import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** currency.js */
  Currency: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** Custom scalar type for precise decimal values using decimal.js */
  Decimal: { input: any; output: any; }
  /** Duration scalar unit */
  Duration: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** Length scalar unit */
  Length: { input: any; output: any; }
  /** Weight/Mass scalar unit */
  Mass: { input: any; output: any; }
  /** Percentage scalar unit */
  Percent: { input: any; output: any; }
  /** Volume scalar unit */
  Volume: { input: any; output: any; }
};

export type AblyTokenOutput = {
  __typename?: 'AblyTokenOutput';
  token?: Maybe<Scalars['String']['output']>;
};

export type AcceptCustomerPortalOrderInput = {
  orderUuid: Scalars['String']['input'];
};

export type AcceptCustomerPortalOrderOutput = AcceptCustomerPortalOrderSuccessOutput | MutationErrorOutput;

export type AcceptCustomerPortalOrderSuccessOutput = {
  __typename?: 'AcceptCustomerPortalOrderSuccessOutput';
  acceptedAt: Scalars['DateTime']['output'];
  orderUuid: Scalars['String']['output'];
};

export type AcceptEdiOrApiOrderInput = {
  uuid: Scalars['String']['input'];
};

export type AcceptEdiOrApiOrderOutput = {
  __typename?: 'AcceptEdiOrApiOrderOutput';
  uuid: Scalars['String']['output'];
};

export type AcceptOrderDelegationInput = {
  uuid: Scalars['String']['input'];
};

export type AcceptOrganizationPeerInput = {
  peerUuid: Scalars['String']['input'];
};

export enum AccessLevel {
  Read = 'READ',
  Write = 'WRITE'
}

export type AccessorialChargeDetailsEntity = {
  __typename?: 'AccessorialChargeDetailsEntity';
  accessorialName: Scalars['String']['output'];
  accessorialUuid: Scalars['String']['output'];
  chargeDetailsByContact: Array<ContactAccessorialChargeDetailsEntity>;
  chargeDetailsByTerminal: Array<TerminalAccessorialChargeDetailsEntity>;
};

export type AccessorialChargeDetailsReportArgs = {
  /** If not specified, returns report for all company-only accessorials. */
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  includeContactsWithNoShipments: Scalars['Boolean']['input'];
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceStatuses: Array<InvoiceStatus>;
  /** If specified, only returns shipments on orders with this controlling terminal */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type AccessorialCreateInput = {
  attemptsAccessorialCreateInput?: InputMaybe<AttemptsAccessorialCreateInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  ediCode?: InputMaybe<Scalars['String']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  invoiceDisplayName?: InputMaybe<Scalars['String']['input']>;
  isAuthoCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultGlobalSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  matchingGlobalAccessorial?: InputMaybe<Scalars['String']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  percentageAccessorialCreateInput?: InputMaybe<PercentageAccessorialCreateInput>;
  qboItemId?: InputMaybe<Scalars['String']['input']>;
  skidBasedAccessorialCreateInput?: InputMaybe<SkidBasedAccessorialCreateInput>;
  specialAccessorialCreateInput?: InputMaybe<SpecialAccessorialCreateInput>;
  standardAccessorialCreateInput?: InputMaybe<StandardAccessorialCreateInput>;
  storageDaysAccessorialCreateInput?: InputMaybe<StorageDaysAccessorialCreateInput>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  unitBasedAccessorialCreateInput?: InputMaybe<UnitBasedAccessorialCreateInput>;
  waitTimeAccessorialCreateInput?: InputMaybe<WaitTimeAccessorialCreateInput>;
  weightBasedAccessorialCreateInput?: InputMaybe<WeightBasedAccessorialCreateInput>;
  zoneBasedAccessorialCreateInput?: InputMaybe<ZoneBasedAccessorialCreateInput>;
};

export type AccessorialDateRangeConfigEntity = {
  __typename?: 'AccessorialDateRangeConfigEntity';
  accessorialRanges: Array<AccessorialRangeEntity>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fuelProfile?: Maybe<FuelProfileEntity>;
  /** @deprecated Use the fuel surcharge rate from the fuel profile instead. */
  fuelSurchargePercentageRate?: Maybe<Scalars['Float']['output']>;
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  specialChargeGroups: Array<SpecialAccessorialChargeGroupEntity>;
  specialMatrixItems: Array<SpecialAccessorialMatrixItemEntity>;
  startDate: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type AccessorialGroupEntity = {
  __typename?: 'AccessorialGroupEntity';
  accessorials: Array<AccessorialUnion>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AccessorialInterface = {
  code?: Maybe<Scalars['String']['output']>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  uuid: Scalars['String']['output'];
};

export enum AccessorialPercentageBasis {
  AllCharges = 'ALL_CHARGES',
  Freight = 'FREIGHT',
  FreightAndFuel = 'FREIGHT_AND_FUEL'
}

export type AccessorialRangeCreateInput = {
  lessThanOrEqualToValue: Scalars['Int']['input'];
  rateUsdCents: Scalars['Float']['input'];
};

export type AccessorialRangeEntity = {
  __typename?: 'AccessorialRangeEntity';
  lessThanOrEqualToValue: Scalars['Int']['output'];
  rateUsdCents: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type AccessorialRangeUpdateInput = {
  lessThanOrEqualToValue?: InputMaybe<Scalars['Int']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AccessorialRangeUpdatesInput = {
  accessorialRangeUpdateInputs: Array<AccessorialRangeUpdateInput>;
  accessorialUuid: Scalars['String']['input'];
};

export type AccessorialToMappingInput = {
  desktopMapping?: InputMaybe<Scalars['String']['input']>;
  fileMapping?: InputMaybe<Scalars['String']['input']>;
  qboItemId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type AccessorialToQuickbooksMappingCreateInput = {
  accessorialUuid: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId: Scalars['String']['input'];
};

export type AccessorialToQuickbooksMappingEntity = {
  __typename?: 'AccessorialToQuickbooksMappingEntity';
  accessorial: AccessorialInterface;
  createdAt: Scalars['DateTime']['output'];
  quickbooksId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type AccessorialToQuickbooksMappingUpdateInput = {
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum AccessorialType {
  Attempts = 'ATTEMPTS',
  Percentage = 'PERCENTAGE',
  Skid = 'SKID',
  Special = 'SPECIAL',
  Standard = 'STANDARD',
  StorageDays = 'STORAGE_DAYS',
  Unit = 'UNIT',
  WaitTime = 'WAIT_TIME',
  Weight = 'WEIGHT',
  ZoneBased = 'ZONE_BASED'
}

export type AccessorialUnion = AttemptsAccessorialEntity | PercentageAccessorialEntity | SkidBasedAccessorialEntity | SpecialAccessorialEntity | StandardAccessorialEntity | StorageDaysAccessorialEntity | UnitBasedAccessorialEntity | WaitTimeAccessorialEntity | WeightBasedAccessorialEntity | ZoneBasedAccessorialEntity;

export type AccessorialUpdateInput = {
  attemptsAccessorialUpdateInput?: InputMaybe<AttemptsAccessorialUpdateInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  ediCode?: InputMaybe<Scalars['String']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  invoiceDisplayName?: InputMaybe<Scalars['String']['input']>;
  isAuthoCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultGlobalSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  matchingGlobalAccessorial?: InputMaybe<Scalars['String']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  percentageAccessorialUpdateInput?: InputMaybe<PercentageAccessorialUpdateInput>;
  qboItemId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingChargeName?: InputMaybe<Scalars['String']['input']>;
  skidBasedAccessorialUpdateInput?: InputMaybe<SkidBasedAccessorialUpdateInput>;
  specialAccessorialUpdateInput?: InputMaybe<SpecialAccessorialUpdateInput>;
  standardAccessorialUpdateInput?: InputMaybe<StandardAccessorialUpdateInput>;
  storageDaysAccessorialUpdateInput?: InputMaybe<StorageDaysAccessorialUpdateInput>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  unitBasedAccessorialUpdateInput?: InputMaybe<UnitBasedAccessorialUpdateInput>;
  waitTimeAccessorialUpdateInput?: InputMaybe<WaitTimeAccessorialUpdateInput>;
  weightBasedAccessorialUpdateInput?: InputMaybe<WeightBasedAccessorialUpdateInput>;
  zoneBasedAccessorialUpdateInput?: InputMaybe<ZoneBasedAccessorialUpdateInput>;
};

export type AccountingReportFilterTypesErrorOutput = {
  __typename?: 'AccountingReportFilterTypesErrorOutput';
  errorMessage: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AccountingReportFilterTypesInput = {
  /** The report type to return the list of filters for */
  reportType: AccountingReportTypeV2;
};

export type AccountingReportFilterTypesSuccessOutput = {
  __typename?: 'AccountingReportFilterTypesSuccessOutput';
  /** A list of report filter types that are required for the specified accounting report type in the query input */
  reportFilterTypes: Array<ReportFilterType>;
  success: Scalars['Boolean']['output'];
};

export type AccountingReportFiltersOutput = AccountingReportFilterTypesErrorOutput | AccountingReportFilterTypesSuccessOutput;

export enum AccountingReportType {
  AgingReport = 'AgingReport'
}

export enum AccountingReportTypeV2 {
  AgingReportDetailed = 'AGING_REPORT_DETAILED',
  DunningReport = 'DUNNING_REPORT'
}

export enum AccountsReceivableCustomerFilter {
  All = 'ALL',
  NonzeroBalance = 'NONZERO_BALANCE'
}

export type AccountsReceivableReportArgs = {
  /** If true, calculate customer balance as of the provided end date in dateFilters. If false, calculate overall customer balance with no date filter. */
  calculateBalanceAsOfEndDate: Scalars['Boolean']['input'];
  customerFilter?: InputMaybe<AccountsReceivableCustomerFilter>;
  dateFilter?: InputMaybe<DateFilterStartEnd>;
};

/** Accounts receivable report data for a particular contact */
export type AccountsReceivableReportDataForContactEntity = {
  __typename?: 'AccountsReceivableReportDataForContactEntity';
  /** Overall balance of contact (invoices minus payments), in dollars */
  balance: Scalars['Float']['output'];
  /** Contact reference number (Account ID) */
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  /** Contact display name */
  displayName: Scalars['String']['output'];
  /** Sum of credit (paymentType = CREDIT) amounts that have been applied to this contacts invoices, in dollars */
  totalCredits: Scalars['Float']['output'];
  /** Sum of debit (paymentType = DEBIT) amounts that have been applied to this contacts invoices, in dollars */
  totalDebits: Scalars['Float']['output'];
  /** Sum of posted invoice totals, in dollars */
  totalInvoices: Scalars['Float']['output'];
  /** Sum of payment (paymentType = PAYMENT) amounts that have been applied to this contacts invoices, in dollars */
  totalPayments: Scalars['Float']['output'];
  /** Sum of credit (paymentType = CREDIT) amounts that have not been applied, in dollars */
  unappliedCredits: Scalars['Float']['output'];
  /** Sum of debit (paymentType = DEBIT) amounts that have not been applied, in dollars */
  unappliedDebits: Scalars['Float']['output'];
  /** Sum of payment (paymentType = PAYMENT) amounts that have not been applied, in dollars */
  unappliedPayments: Scalars['Float']['output'];
};

export type AcknowledgeMyStopChangeInput = {
  stopUuid: Scalars['String']['input'];
};

export type AcknowledgeMyStopChangeOutput = AcknowledgeMyStopChangeSuccessOutput | MutationErrorOutput;

export type AcknowledgeMyStopChangeSuccessOutput = {
  __typename?: 'AcknowledgeMyStopChangeSuccessOutput';
  stop: StopEntity;
  /** Whether the stop was updated. This could be false if, for example, the stop had been re-assigned to a different driver. */
  updated: Scalars['Boolean']['output'];
};

export type AcknowledgeQuoteAttentionInput = {
  orderQuoteUuid: Scalars['String']['input'];
};

export type AcknowledgeQuoteAttentionOutput = AcknowledgeQuoteAttentionSuccessOutput | MutationErrorOutput;

export type AcknowledgeQuoteAttentionSuccessOutput = {
  __typename?: 'AcknowledgeQuoteAttentionSuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
  status: OrderQuoteStatus;
};

export type AcknowledgeRouteChangesInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type AddApiUserContactMappingInput = {
  apiUserUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
};

export type AddDriversToRouteInput = {
  driverUuids: Array<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

export type AddLineItemsToSettlementBillsInput = {
  settlementBillCreateInputs?: InputMaybe<Array<NewSettlementBillInput>>;
  settlementBillUpdateInputs?: InputMaybe<Array<ExistingSettlementBillInput>>;
};

export type AddLineItemsToSettlementBillsOutput = AddLineItemsToSettlementBillsSuccessOutput | MutationErrorOutput;

export type AddLineItemsToSettlementBillsSuccessOutput = {
  __typename?: 'AddLineItemsToSettlementBillsSuccessOutput';
  driverSettlementBills: Array<DriverSettlementBillEntity>;
};

export type AddOrdersToExistingInvoiceErrorOutput = {
  __typename?: 'AddOrdersToExistingInvoiceErrorOutput';
  attemptedOrdersToAdd: Array<OrderToAddToInvoice>;
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToExistingInvoiceResult = AddOrdersToExistingInvoiceErrorOutput | AddOrdersToInvoiceSuccessOutput;

export type AddOrdersToInvoiceSuccessOutput = {
  __typename?: 'AddOrdersToInvoiceSuccessOutput';
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  ordersAdded: Array<OrderAddedToInvoice>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToInvoicesForContactErrorOutput = {
  __typename?: 'AddOrdersToInvoicesForContactErrorOutput';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  proposedNewInvoicesToCreate: Array<NewInvoiceToCreate>;
  proposedUpdatesToExistingInvoices: Array<ExistingInvoiceToUpdate>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToInvoicesForContactOutput = AddOrdersToInvoicesForContactErrorOutput | AddOrdersToInvoicesForContactSuccessOutput;

export type AddOrdersToInvoicesForContactSuccessOutput = {
  __typename?: 'AddOrdersToInvoicesForContactSuccessOutput';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingInvoiceAdds: Array<AddOrdersToExistingInvoiceResult>;
  newInvoiceAdds: Array<AddOrdersToNewInvoiceResult>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToInvoicesInput = {
  addToExistingInvoices: Scalars['Boolean']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type AddOrdersToInvoicesOutput = AddOrdersToInvoicesSuccessOutput | MutationErrorOutput;

export type AddOrdersToInvoicesSuccessOutput = {
  __typename?: 'AddOrdersToInvoicesSuccessOutput';
  invoicesAddedToByContact: Array<AddOrdersToInvoicesForContactOutput>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToManifestInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type AddOrdersToManifestOutput = {
  __typename?: 'AddOrdersToManifestOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type AddOrdersToManifestV2Input = {
  /** When true, allows adding orders whose origin terminal does not match the manifest start terminal, provided the order has a single misrouted piece at the manifest start terminal. */
  forceOriginMismatch?: InputMaybe<Scalars['Boolean']['input']>;
  manifestUuid: Scalars['String']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type AddOrdersToManifestV2Output = AddOrdersToManifestV2PreviousManifestErrorOutput | AddOrdersToManifestV2SuccessOutput | MutationErrorOutput;

/** An error that occurs when adding orders to a manifest. */
export type AddOrdersToManifestV2PreviousManifestErrorOutput = {
  __typename?: 'AddOrdersToManifestV2PreviousManifestErrorOutput';
  /** An array of errors that occur when forceOriginMismatch is true but the order does not have a single misrouted piece at the manifest start terminal */
  invalidMisroutedOverrideErrors: Array<InvalidMisroutedOverrideError>;
  /** An array of errors that occur when adding orders to an initial manifest that have a different start terminal from the start terminal of the manifest being added to */
  originTerminalMismatchErrors: Array<OriginTerminalMismatchError>;
  /** An array of errors that occur when adding orders to a manifest that are on a previous manifest with a different end terminal from the start terminal of the manifest being added to */
  previousManifestErrors: Array<PreviousManifestError>;
  /** An array of errors that occur when the manifest departs a terminal on the order's route but arrives at a terminal the order is not routed to */
  routeDestinationMismatchErrors: Array<RouteDestinationMismatchError>;
};

export type AddOrdersToManifestV2SuccessOutput = {
  __typename?: 'AddOrdersToManifestV2SuccessOutput';
  lineHaulManifest: LineHaulManifestEntity;
};

export type AddOrdersToNewInvoiceErrorOutput = {
  __typename?: 'AddOrdersToNewInvoiceErrorOutput';
  attemptedOrdersToAdd: Array<OrderToAddToInvoice>;
  /** this is null when the invoice could not be created. it is not null when we created the invoice but could not add orders to it */
  createdInvoiceName?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToNewInvoiceResult = AddOrdersToInvoiceSuccessOutput | AddOrdersToNewInvoiceErrorOutput;

export type AddPiecesToPieceReceiptInput = {
  /** Client-side ISO-8601 timestamp of when the user actually scanned the piece(s). Used to preserve real scan time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  /** Existing pieces to add, each optionally moved to a new location */
  existingPieces?: InputMaybe<Array<PieceReceiptExistingPieceInput>>;
  /** New pieces to create and attach to the receipt */
  newPieces?: InputMaybe<Array<PieceReceiptNewPieceInput>>;
  /** When set, nest every piece in this request under this existing container piece (must already be a container on the receipt). */
  parentPieceUuid?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the piece receipt to add pieces to */
  pieceReceiptUuid: Scalars['String']['input'];
};

export type AddPiecesToPieceReceiptOutput = {
  __typename?: 'AddPiecesToPieceReceiptOutput';
  /** Number of pieces newly created and attached */
  createdCount: Scalars['Int']['output'];
  /** Number of existing pieces linked */
  linkedCount: Scalars['Int']['output'];
  /** The piece receipt the pieces were added to */
  pieceReceipt: PieceReceiptEntity;
};

export type AddRouteStopInput = {
  address: AddressUpsertInput;
  /** The appointment as typed in an entry zone. Send it instead of appointmentTime and endAppointmentTime, never with them. Requires terminal_local_times. */
  appointmentLocal?: InputMaybe<StopAppointmentLocalInput>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  routeUuid: Scalars['String']['input'];
  serviceTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  stopType: StopType;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type AddServiceToContactInput = {
  contactUuid: Scalars['String']['input'];
  serviceUuid: Scalars['String']['input'];
};

export type AddStopToRouteInput = {
  routeUuid: Scalars['String']['input'];
  stopUuid: Scalars['String']['input'];
};

export type AddTagToLegInput = {
  legUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type AddTagToOrderInput = {
  orderUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type AddTestAccessorialChargeInput = {
  accessorialUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddTestAccessorialChargeOutput = {
  __typename?: 'AddTestAccessorialChargeOutput';
  customChargeUuid: Scalars['String']['output'];
};

export type AddThirdPartyUserToContactInput = {
  contactUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type AddUserToRoleInput = {
  userUuid: Scalars['String']['input'];
  /** The UUID of the role to add the user to */
  uuid: Scalars['String']['input'];
};

export type AddUserToRoleOutput = {
  __typename?: 'AddUserToRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type AdditionalChargesRoutingRule = {
  /** Services to apply this rule to */
  services: Array<Scalars['String']['input']>;
  /** Target for additional charges */
  target: Scalars['String']['input'];
  /** Terminal code for terminal target */
  terminalCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateInput = {
  associatedContactUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  driverInstructions?: InputMaybe<Scalars['String']['input']>;
  geocodeQuality?: InputMaybe<AddressGeocodeQuality>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  preventCoordRecompute?: InputMaybe<Scalars['Boolean']['input']>;
  receivingHoursEnd?: InputMaybe<Scalars['DateTime']['input']>;
  receivingHoursStart?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  type?: InputMaybe<AddressType>;
  zip: Scalars['String']['input'];
};

export type AddressEntity = {
  __typename?: 'AddressEntity';
  associatedContact?: Maybe<ContactPersonEntity>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  driverInstructions?: Maybe<Scalars['String']['output']>;
  formattedAddress: Scalars['String']['output'];
  geocodeQuality?: Maybe<AddressGeocodeQuality>;
  iataCode?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  preventCoordRecompute?: Maybe<Scalars['Boolean']['output']>;
  receivingHoursEnd?: Maybe<Scalars['DateTime']['output']>;
  receivingHoursStart?: Maybe<Scalars['DateTime']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  state: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  timeZoneSource?: Maybe<TimeZoneSource>;
  type: AddressType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressForCachedStop = {
  __typename?: 'AddressForCachedStop';
  city: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  routeName?: Maybe<Scalars['String']['output']>;
  routeNameUuid?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export enum AddressGeocodeQuality {
  Approximate = 'APPROXIMATE',
  Exact = 'EXACT',
  Unresolved = 'UNRESOLVED'
}

export enum AddressType {
  Record = 'RECORD',
  Template = 'TEMPLATE'
}

/** Filter fields for the address type enum field */
export type AddressTypeFilter = {
  /** Filter for records where the address type is equal to the provided address type value */
  eq?: InputMaybe<StandardStopType>;
};

export type AddressUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  driverInstructions?: InputMaybe<Scalars['String']['input']>;
  geocodeQuality?: InputMaybe<AddressGeocodeQuality>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preventCoordRecompute?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use preventCoordRecompute instead */
  recalculateLatLong?: InputMaybe<Scalars['Boolean']['input']>;
  receivingHoursEnd?: InputMaybe<Scalars['DateTime']['input']>;
  receivingHoursStart?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressType>;
  uuid: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpsertInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  driverInstructions?: InputMaybe<Scalars['String']['input']>;
  geocodeQuality?: InputMaybe<AddressGeocodeQuality>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  preventCoordRecompute?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use preventCoordRecompute instead */
  preventCoordRecomputeInBackend?: InputMaybe<Scalars['Boolean']['input']>;
  receivingHoursEnd?: InputMaybe<Scalars['DateTime']['input']>;
  receivingHoursStart?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  state: Scalars['String']['input'];
  type?: InputMaybe<AddressType>;
  uuid: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AdhocApplyPlanBillingPartyEntity = {
  __typename?: 'AdhocApplyPlanBillingPartyEntity';
  contactUuid?: Maybe<Scalars['String']['output']>;
  mechanism: Scalars['String']['output'];
  senderVerdict?: Maybe<Scalars['String']['output']>;
};

export type AdhocApplyPlanDeadlineTypeEntity = {
  __typename?: 'AdhocApplyPlanDeadlineTypeEntity';
  mechanism: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdhocApplyPlanDuplicateEntity = {
  __typename?: 'AdhocApplyPlanDuplicateEntity';
  duplicateOrderUuid?: Maybe<Scalars['String']['output']>;
  isDuplicate: Scalars['Boolean']['output'];
  wouldAdoptOrphanUuid?: Maybe<Scalars['String']['output']>;
};

export type AdhocApplyPlanEntity = {
  __typename?: 'AdhocApplyPlanEntity';
  billingParty: AdhocApplyPlanBillingPartyEntity;
  deadlineType?: Maybe<AdhocApplyPlanDeadlineTypeEntity>;
  duplicate?: Maybe<AdhocApplyPlanDuplicateEntity>;
  service?: Maybe<AdhocApplyPlanServiceEntity>;
};

export type AdhocApplyPlanServiceEntity = {
  __typename?: 'AdhocApplyPlanServiceEntity';
  mechanism: Scalars['String']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
};

export type AdhocEmailSimulationInput = {
  fromAddress: Scalars['String']['input'];
  receivedAt?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type AdhocPreviewBatchEntity = {
  __typename?: 'AdhocPreviewBatchEntity';
  actorEmail: Scalars['String']['output'];
  aggregateCostUsd?: Maybe<Scalars['Float']['output']>;
  aggregateInputTokens?: Maybe<Scalars['Float']['output']>;
  aggregateOutputTokens?: Maybe<Scalars['Float']['output']>;
  companyUuid: Scalars['String']['output'];
  emailSimulation?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<AdhocPreviewBatchMemberEntity>;
  status: Scalars['String']['output'];
};

export type AdhocPreviewBatchMemberEntity = {
  __typename?: 'AdhocPreviewBatchMemberEntity';
  adhocRunId?: Maybe<Scalars['String']['output']>;
  applyPlan?: Maybe<AdhocApplyPlanEntity>;
  dispatchError?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  extractedFields?: Maybe<Scalars['JSON']['output']>;
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  runStatus?: Maybe<Scalars['String']['output']>;
  uploadId: Scalars['String']['output'];
  usage?: Maybe<Scalars['JSON']['output']>;
};

export type AdhocPreviewExemplarEntity = {
  __typename?: 'AdhocPreviewExemplarEntity';
  cosineSimilarity: Scalars['Float']['output'];
  documentId: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  fieldValues: Scalars['JSON']['output'];
  source: Scalars['String']['output'];
};

export type AdhocPreviewResultEntity = {
  __typename?: 'AdhocPreviewResultEntity';
  applyPlan?: Maybe<AdhocApplyPlanEntity>;
  companyUuid: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  exemplars: Array<AdhocPreviewExemplarEntity>;
  extractedFields?: Maybe<Scalars['JSON']['output']>;
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  usage?: Maybe<Scalars['JSON']['output']>;
};

export type AdhocPreviewTriggerEntity = {
  __typename?: 'AdhocPreviewTriggerEntity';
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AdjustmentStopDriverMapCreateInput = {
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revenueFlatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type AdminSyncInvoicesToQuickbooksInput = {
  actingUserUuid: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  options?: InputMaybe<QuickbooksSyncOptionsInput>;
  uuids: Array<Scalars['String']['input']>;
};

export type AdoptDriverSettlementPayTermsInput = {
  stopDriverMapUuids: Array<Scalars['String']['input']>;
};

export type AdoptDriverSettlementPayTermsResult = {
  __typename?: 'AdoptDriverSettlementPayTermsResult';
  adopted: Scalars['Boolean']['output'];
  captureState: SettlementPayTermsCaptureState;
  stopDriverMapUuid: Scalars['String']['output'];
  terms: StopDriverMapPayTermsEntity;
};

/** Runs the next lifecycle step of every selected order, one step per order per call. */
export type AdvanceOutboundBenchOrdersInput = {
  companyActors?: InputMaybe<Array<BenchCompanyActorInput>>;
  /** Required, and must be true, when the backend runs in production. Ignored elsewhere. */
  confirmProductionSend?: InputMaybe<Scalars['Boolean']['input']>;
  /** An active driver of the orders' company. ROUTE_STOP assigns the route it creates to this driver; without one, ROUTE_STOP and START_ROUTE block. */
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  integrationType: BenchIntegrationType;
  /** Report outbound EDI rows created since this instant: the start of the run, so rows sent after a step returned still show. */
  reportEdiSince?: InputMaybe<Scalars['DateTime']['input']>;
  selection: BenchOrderSelectionInput;
  /** Send the 990 ACCEPTED for an order that arrived live. A live order has no draft to approve, so ACCEPT_TENDER sends the 990 itself, once, when the partnership does not auto-accept. Omitted or false leaves live orders without a 990. */
  send990ForLiveOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Steps to leave out of this run. The plan reports them SKIPPED, and the run moves on to the next step. Empty or omitted runs every step. */
  skippedSteps?: InputMaybe<Array<BenchStepSelectorInput>>;
};

export type AgentFieldsEntity = {
  __typename?: 'AgentFieldsEntity';
  activeTerminals: Array<TerminalEntity>;
  defaultDriver: DriverEntity;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** The open invoice value for a contact within the specified day range */
export type AgingReportBucketEntity = {
  __typename?: 'AgingReportBucketEntity';
  /** Include invoices with date greater than this many days before the aging report start date. If null, there is no lower bound */
  greaterThanOrEqualToDays?: Maybe<Scalars['Float']['output']>;
  /** Optional display label for this bucket. When null, consumers derive the label from the day boundaries (legacy behavior). */
  label?: Maybe<Scalars['String']['output']>;
  /** Include invoices with date less than or equal to this many days before the aging report start date. If null, there is no upper bound */
  lessThanOrEqualToDays?: Maybe<Scalars['Float']['output']>;
  /** The total value of open invoices in this bucket in dollars */
  openInvoiceValue: Scalars['Float']['output'];
};

/**
 * The standard output type for an invoice aging report file (generally PDF or CSV)
 *   which has been generated on the backend and uploaded to S3
 */
export type AgingReportFileOutput = {
  __typename?: 'AgingReportFileOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Aging report data for a particular contact that includes the contact invoices and buckets with open invoice values by start and end day ranges */
export type AgingReportForContactEntity = {
  __typename?: 'AgingReportForContactEntity';
  contactAddress?: Maybe<AddressEntity>;
  contactUuid: Scalars['String']['output'];
  /** Contact display name */
  displayName: Scalars['String']['output'];
  invoices: Array<InvoiceForAgingReportEntity>;
  openInvoiceValueBuckets: Array<AgingReportBucketEntity>;
  /** Net total of unapplied payments for this contact in dollars. Informational only and NOT included in openInvoiceValueBuckets[0] (Balance). Credits and payments are negative; debits are positive. */
  unappliedPaymentsTotal: Scalars['Float']['output'];
};

export enum AgingReportType {
  Detailed = 'DETAILED',
  Summary = 'SUMMARY'
}

export type AirportInfoEntity = {
  __typename?: 'AirportInfoEntity';
  address: AddressEntity;
  createdAt: Scalars['DateTime']['output'];
  iataCode?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  terminal: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type AirportInfoUpdateOutput = {
  __typename?: 'AirportInfoUpdateOutput';
  airportInfo: AirportInfoEntity;
};

/** Which of the two moments a wall-clock time means on a fall-back DST night: EARLIER is the first pass (the daylight-time offset), LATER the second (the standard-time offset). */
export enum AmbiguousLocalTime {
  Earlier = 'EARLIER',
  Later = 'LATER'
}

export enum ApiAddressLocationType {
  Commercial = 'COMMERCIAL',
  Residential = 'RESIDENTIAL'
}

export type ApiKeyAdminConnectOrgsInput = {
  apiKeyUuid: Scalars['String']['input'];
  organizationUuids: Array<Scalars['String']['input']>;
};

export type ApiKeyAdminCreateInput = {
  customMapping?: InputMaybe<Scalars['Boolean']['input']>;
  emitAppointmentCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  emitTerminalHandoffEvents?: InputMaybe<Scalars['Boolean']['input']>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<OutboundWebhookEventType>>;
  idFormat?: InputMaybe<ApiUserIdFormat>;
  name: Scalars['String']['input'];
  payloadShapes?: InputMaybe<Array<WebhookPayloadShape>>;
  /** @deprecated Use webhookTimestampMode instead (TC-1130). */
  sendCompanyLocalTimestamps?: InputMaybe<Scalars['Boolean']['input']>;
  webhookAuthHeaderName?: InputMaybe<Scalars['String']['input']>;
  webhookAuthHeaderValue?: InputMaybe<Scalars['String']['input']>;
  webhookTimestampMode?: InputMaybe<WebhookTimestampMode>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum ApiKeyAdminCsvImportKeyOutcome {
  Conflict = 'CONFLICT',
  Create = 'CREATE',
  Merge = 'MERGE'
}

export enum ApiKeyAdminCsvImportOrgOutcome {
  AlreadyLinked = 'ALREADY_LINKED',
  Ambiguous = 'AMBIGUOUS',
  NotFound = 'NOT_FOUND',
  Ok = 'OK',
  Stale = 'STALE'
}

export type ApiKeyAdminCsvImportOrgRow = {
  __typename?: 'ApiKeyAdminCsvImportOrgRow';
  companyName: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  organizationDisplayName: Scalars['String']['output'];
  outcome: ApiKeyAdminCsvImportOrgOutcome;
  rowNumber: Scalars['Int']['output'];
};

export type ApiKeyAdminCsvImportReport = {
  __typename?: 'ApiKeyAdminCsvImportReport';
  apiKey: Scalars['String']['output'];
  applied: Scalars['Boolean']['output'];
  keyMessage?: Maybe<Scalars['String']['output']>;
  keyName: Scalars['String']['output'];
  keyOutcome: ApiKeyAdminCsvImportKeyOutcome;
  orgRows: Array<ApiKeyAdminCsvImportOrgRow>;
  orgsToLink: Scalars['Int']['output'];
};

export type ApiKeyAdminDetailEntity = {
  __typename?: 'ApiKeyAdminDetailEntity';
  apiKey: ApiKeyAdminEntity;
  linkedOrgs: Array<ApiKeyAdminLinkedOrgEntity>;
};

export type ApiKeyAdminDisconnectOrgInput = {
  apiKeyUuid: Scalars['String']['input'];
  organizationUuid: Scalars['String']['input'];
};

export type ApiKeyAdminEntity = {
  __typename?: 'ApiKeyAdminEntity';
  apiKey: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customMapping: Scalars['Boolean']['output'];
  emitAppointmentCancelledEvents: Scalars['Boolean']['output'];
  emitTerminalHandoffEvents: Scalars['Boolean']['output'];
  enableStaging: Scalars['Boolean']['output'];
  eventTypes: Array<OutboundWebhookEventType>;
  idFormat: ApiUserIdFormat;
  name: Scalars['String']['output'];
  orgCount: Scalars['Float']['output'];
  payloadShapes: Array<WebhookPayloadShape>;
  /** @deprecated Use webhookTimestampMode instead (TC-1130). */
  sendCompanyLocalTimestamps: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  webhookAuthHeaderName?: Maybe<Scalars['String']['output']>;
  webhookAuthHeaderValue?: Maybe<Scalars['String']['output']>;
  webhookTimestampMode: WebhookTimestampMode;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type ApiKeyAdminEventTypeCatalogEntryEntity = {
  __typename?: 'ApiKeyAdminEventTypeCatalogEntryEntity';
  deprecated: Scalars['Boolean']['output'];
  eventType: OutboundWebhookEventType;
  requiresAppointmentCancelledOptIn: Scalars['Boolean']['output'];
  requiresTerminalHandoffOptIn: Scalars['Boolean']['output'];
};

export type ApiKeyAdminEventTypeCatalogShapeEntity = {
  __typename?: 'ApiKeyAdminEventTypeCatalogShapeEntity';
  eventTypes: Array<ApiKeyAdminEventTypeCatalogEntryEntity>;
  isStandard: Scalars['Boolean']['output'];
  shape: WebhookPayloadShape;
};

export type ApiKeyAdminImportCsvInput = {
  csvText: Scalars['String']['input'];
  dryRun: Scalars['Boolean']['input'];
};

export type ApiKeyAdminLinkedOrgEntity = {
  __typename?: 'ApiKeyAdminLinkedOrgEntity';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  organizationDisplayName: Scalars['String']['output'];
  organizationUuid: Scalars['String']['output'];
};

export type ApiKeyAdminListInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ApiKeyAdminSortField>;
};

export type ApiKeyAdminListItemEntity = {
  __typename?: 'ApiKeyAdminListItemEntity';
  createdAt: Scalars['DateTime']['output'];
  customMapping: Scalars['Boolean']['output'];
  emitAppointmentCancelledEvents: Scalars['Boolean']['output'];
  emitTerminalHandoffEvents: Scalars['Boolean']['output'];
  enableStaging: Scalars['Boolean']['output'];
  eventTypes: Array<OutboundWebhookEventType>;
  idFormat: ApiUserIdFormat;
  name: Scalars['String']['output'];
  orgCount: Scalars['Int']['output'];
  payloadShapes: Array<WebhookPayloadShape>;
  /** @deprecated Use webhookTimestampMode instead (TC-1130). */
  sendCompanyLocalTimestamps: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  webhookAuthHeaderName?: Maybe<Scalars['String']['output']>;
  webhookTimestampMode: WebhookTimestampMode;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type ApiKeyAdminListResult = {
  __typename?: 'ApiKeyAdminListResult';
  apiKeys: Array<ApiKeyAdminListItemEntity>;
  totalCount: Scalars['Int']['output'];
};

export type ApiKeyAdminOrgSearchInput = {
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyAdminOrgSearchResult = {
  __typename?: 'ApiKeyAdminOrgSearchResult';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  organizationDisplayName: Scalars['String']['output'];
  organizationUuid: Scalars['String']['output'];
};

export type ApiKeyAdminPreviewMappingInput = {
  apiKeyUuid: Scalars['String']['input'];
  examplePayload: Scalars['String']['input'];
  mappingTemplate: Scalars['String']['input'];
  shape: WebhookPayloadShape;
};

export type ApiKeyAdminSetMappingTemplateInput = {
  apiKeyUuid: Scalars['String']['input'];
  mappingTemplate?: InputMaybe<Scalars['String']['input']>;
  shape: WebhookPayloadShape;
};

export type ApiKeyAdminSetStatusMappingsInput = {
  apiKeyUuid: Scalars['String']['input'];
  mappings: Array<ApiKeyAdminStatusMappingInput>;
};

export enum ApiKeyAdminSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  OrgCount = 'ORG_COUNT'
}

export type ApiKeyAdminStatusMappingEntity = {
  __typename?: 'ApiKeyAdminStatusMappingEntity';
  category: StatusMappingCategory;
  externalName: Scalars['String']['output'];
  internalName: Scalars['String']['output'];
};

export type ApiKeyAdminStatusMappingInput = {
  category: StatusMappingCategory;
  externalName: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
};

export type ApiKeyAdminUpdateInput = {
  customMapping?: InputMaybe<Scalars['Boolean']['input']>;
  emitAppointmentCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  emitTerminalHandoffEvents?: InputMaybe<Scalars['Boolean']['input']>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<OutboundWebhookEventType>>;
  idFormat?: InputMaybe<ApiUserIdFormat>;
  name?: InputMaybe<Scalars['String']['input']>;
  payloadShapes?: InputMaybe<Array<WebhookPayloadShape>>;
  /** @deprecated Use webhookTimestampMode instead (TC-1130). */
  sendCompanyLocalTimestamps?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  webhookAuthHeaderName?: InputMaybe<Scalars['String']['input']>;
  webhookAuthHeaderValue?: InputMaybe<Scalars['String']['input']>;
  webhookTimestampMode?: InputMaybe<WebhookTimestampMode>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyAdminWebhookShapeConfigEntity = {
  __typename?: 'ApiKeyAdminWebhookShapeConfigEntity';
  mappingTemplate?: Maybe<Scalars['String']['output']>;
  urlPath?: Maybe<Scalars['String']['output']>;
  webhookShape: WebhookPayloadShape;
};

export type ApiLogConnection = {
  __typename?: 'ApiLogConnection';
  edges: Array<ApiLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApiLogEdge = {
  __typename?: 'ApiLogEdge';
  cursor: Scalars['String']['output'];
  node: ApiLogEntity;
};

export type ApiLogEntity = {
  __typename?: 'ApiLogEntity';
  createdAt: Scalars['DateTime']['output'];
  direction: ApiRequestDirection;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  freightSnapTransaction?: Maybe<FreightSnapTransactionEntity>;
  payload?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<ApiResponseStatus>;
  sourceIpAddress?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ApiRequestDirection {
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export enum ApiResponseStatus {
  Http_200 = 'HTTP_200',
  Http_500 = 'HTTP_500',
  HttpOther = 'HTTP_OTHER'
}

export type ApiUserCreateInput = {
  apiKey: Scalars['String']['input'];
  customMapping?: InputMaybe<Scalars['Boolean']['input']>;
  echoApiReceivedAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  emitTerminalHandoffEvents?: InputMaybe<Scalars['Boolean']['input']>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  idFormat: ApiUserIdFormat;
  name: Scalars['String']['input'];
  payloadShapes?: InputMaybe<Array<WebhookPayloadShape>>;
  sendAddressEnrichedPayload?: InputMaybe<Scalars['Boolean']['input']>;
  webhookAuthHeaderName?: InputMaybe<Scalars['String']['input']>;
  webhookAuthHeaderValue?: InputMaybe<Scalars['String']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ApiUserEntity = {
  __typename?: 'ApiUserEntity';
  apiKey: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customMapping: Scalars['Boolean']['output'];
  echoApiReceivedAddresses: Scalars['Boolean']['output'];
  emitAppointmentCancelledEvents: Scalars['Boolean']['output'];
  emitTerminalHandoffEvents: Scalars['Boolean']['output'];
  enableStaging: Scalars['Boolean']['output'];
  eventTypes: Array<OutboundWebhookEventType>;
  idFormat: ApiUserIdFormat;
  name: Scalars['String']['output'];
  payloadShapes: Array<WebhookPayloadShape>;
  sendAddressEnrichedPayload: Scalars['Boolean']['output'];
  /** @deprecated Use webhookTimestampMode instead (TC-1130). */
  sendCompanyLocalTimestamps: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  webhookAuthHeaderName?: Maybe<Scalars['String']['output']>;
  webhookAuthHeaderValue?: Maybe<Scalars['String']['output']>;
  webhookTimestampMode: WebhookTimestampMode;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export enum ApiUserIdFormat {
  ApiName = 'API_NAME',
  Uuid = 'UUID'
}

export type ApiUserUpdateInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  customMapping?: InputMaybe<Scalars['Boolean']['input']>;
  echoApiReceivedAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  emitTerminalHandoffEvents?: InputMaybe<Scalars['Boolean']['input']>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  idFormat?: InputMaybe<ApiUserIdFormat>;
  name?: InputMaybe<Scalars['String']['input']>;
  payloadShapes?: InputMaybe<Array<WebhookPayloadShape>>;
  sendAddressEnrichedPayload?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  webhookAuthHeaderName?: InputMaybe<Scalars['String']['input']>;
  webhookAuthHeaderValue?: InputMaybe<Scalars['String']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ApplyDebitToPaymentInput = {
  amountInCents: Scalars['Int']['input'];
  sourcePaymentUuid: Scalars['String']['input'];
  targetPaymentUuid: Scalars['String']['input'];
};

export type ApplyDelegationAccessorialProposalInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  expectedQuantity: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ApplyRouteOptimizationInput = {
  proposals: Array<ProposedRouteSequenceInput>;
};

/** Who moved a stop appointment from one status to another. */
export enum AppointmentActor {
  Client = 'CLIENT',
  Company = 'COMPANY',
  System = 'SYSTEM'
}

export enum AppointmentCallStatus {
  Busy = 'BUSY',
  Called = 'CALLED',
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotCalled = 'NOT_CALLED',
  NoAnswer = 'NO_ANSWER',
  Rejected = 'REJECTED'
}

export type AppointmentConfirmationInfoOutput = {
  __typename?: 'AppointmentConfirmationInfoOutput';
  appointmentConfirmed: Scalars['Boolean']['output'];
  /** The date and time of the appointment in a human-readable format, local to the stop */
  appointmentDateTime: Scalars['String']['output'];
  /** @deprecated Use appointmentDateTime instead */
  appointmentInfoString: Scalars['String']['output'];
  /** @deprecated Use appointmentConfirmed and rescheduleRequested instead */
  appointmentTextStatus: AppointmentTextStatus;
  /** @deprecated Legacy API, always true */
  hasAppointment: Scalars['Boolean']['output'];
  /** @deprecated Use stopType instead */
  pickupOrDelivery?: Maybe<PickupOrDelivery>;
  /** Whether the contact person of the stop has requested to reschedule the appointment */
  rescheduleRequested: Scalars['Boolean']['output'];
  stopType?: Maybe<StopType>;
};

export type AppointmentOption = {
  __typename?: 'AppointmentOption';
  date: PlainDate;
  endTime: PlainTime;
  /** The appointment date in a human-readable format, local to the stop timezone */
  humanDate: Scalars['String']['output'];
  startTime: PlainTime;
};

export type AppointmentOptions = {
  __typename?: 'AppointmentOptions';
  /** Whether the appointment has been set either by the contact person or manually, possibly not confirmed */
  appointmentExists: Scalars['Boolean']['output'];
  /** A descriptive user-facing message to display */
  message?: Maybe<Scalars['String']['output']>;
  options: Array<AppointmentOption>;
  /** The number of options the API generates per page (i.e., per query). If the API returns fewer options than specified here, then we have reached the last page of possible options. */
  pageSize: Scalars['Int']['output'];
  /** Whether the contact person of the stop has requested to reschedule the appointment */
  rescheduleRequested: Scalars['Boolean']['output'];
};

export type AppointmentOptionsInput = {
  /** The start date and time from which to query for options */
  from?: InputMaybe<PlainDateTimeInput>;
  stopUuid: Scalars['String']['input'];
};

export enum AppointmentSchedulerModel {
  SchedulingResource = 'SCHEDULING_RESOURCE',
  SchedulingZone = 'SCHEDULING_ZONE'
}

/** The lifecycle state of a stop appointment. Only CANCELLED is stored; the rest are derived from the legacy stop columns. */
export enum AppointmentStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Executed = 'EXECUTED',
  RescheduleRequested = 'RESCHEDULE_REQUESTED',
  Scheduled = 'SCHEDULED'
}

export type AppointmentStatusHistoryConnection = {
  __typename?: 'AppointmentStatusHistoryConnection';
  edges: Array<AppointmentStatusHistoryEdge>;
  pageInfo: PageInfo;
};

export type AppointmentStatusHistoryEdge = {
  __typename?: 'AppointmentStatusHistoryEdge';
  cursor: Scalars['String']['output'];
  node: AppointmentStatusHistoryEntity;
};

export type AppointmentStatusHistoryEntity = {
  __typename?: 'AppointmentStatusHistoryEntity';
  actor: AppointmentActor;
  createdAt: Scalars['DateTime']['output'];
  fromStatus?: Maybe<AppointmentStatus>;
  previousAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  previousCustomerBookingNotes?: Maybe<Scalars['String']['output']>;
  previousEndAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  toStatus: AppointmentStatus;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userUuid?: Maybe<Scalars['String']['output']>;
};

export enum AppointmentTextStatus {
  Confirmed = 'CONFIRMED',
  NotSent = 'NOT_SENT',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

/** A dispatcher action on a stop appointment. */
export enum AppointmentTransitionAction {
  Cancel = 'CANCEL',
  Confirm = 'CONFIRM',
  Reschedule = 'RESCHEDULE'
}

export enum AppointmentWindowType {
  Soft = 'SOFT',
  SoftEnd = 'SOFT_END',
  SoftStart = 'SOFT_START',
  Strict = 'STRICT'
}

export type ApproveQuoteInput = {
  orderUuid: Scalars['String']['input'];
  quoteUuid: Scalars['String']['input'];
};

export type ApproveQuoteReplyInput = {
  draftReplyUuid: Scalars['String']['input'];
  /** The reply text to send in place of the drafted one; approving replaces the stored draft body with it */
  editedBodyText?: InputMaybe<Scalars['String']['input']>;
  orderQuoteUuid: Scalars['String']['input'];
  /** Required when the sender was recovered from a forwarded message */
  recipientConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApproveQuoteReplyOutput = ApproveQuoteReplySuccessOutput | MutationErrorOutput | QuoteReplyRefusedOutput;

export type ApproveQuoteReplySuccessOutput = {
  __typename?: 'ApproveQuoteReplySuccessOutput';
  approvedAt: Scalars['DateTime']['output'];
  draftReplyUuid: Scalars['String']['output'];
  orderQuoteUuid: Scalars['String']['output'];
};

/** This is the graphql input for archiving an organization */
export type ArchiveOrganizationInput = {
  uuid: Scalars['String']['input'];
};

export type ArchiveOrganizationOutput = ArchiveOrganizationSuccessOutput | MutationErrorOutput;

export type ArchiveOrganizationSuccessOutput = {
  __typename?: 'ArchiveOrganizationSuccessOutput';
  /** The archived org */
  organization: OrganizationEntity;
};

export type ArchiveTariffChainInput = {
  id: Scalars['String']['input'];
};

export type ArchiveTariffChainOutput = ArchiveTariffChainSuccessOutput | MutationErrorOutput;

export type ArchiveTariffChainSuccessOutput = {
  __typename?: 'ArchiveTariffChainSuccessOutput';
  /** The tariff chain that was archived */
  tariffChain: TariffChainEntity;
};

export type ArchivedUserExistsOutput = {
  __typename?: 'ArchivedUserExistsOutput';
  archivedUserUuid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ArriveAtStopInput = {
  /** A user entered value for when the driver arrived at the stop> If set to null, the default arrival date is used */
  arrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  stopUuid: Scalars['String']['input'];
};

/** The expected input to mark a set of stops as arrived */
export type ArriveAtStopsInput = {
  arriveAtStopInputs: Array<ArriveAtStopInput>;
};

export type ArriveAtStopsOutput = ArriveAtStopsSuccessOutput | MutationErrorOutput;

export type ArriveAtStopsSuccessOutput = {
  __typename?: 'ArriveAtStopsSuccessOutput';
  /** The list of stop UUIDs that were successfully marked as arrived */
  arrivedStopUuids: Array<Scalars['String']['output']>;
  /** The list of stop UUIDs that were not marked as arrived */
  failedStopUuids: Array<Scalars['String']['output']>;
};

export type AssignDockDoorInput = {
  doorEventAt?: InputMaybe<Scalars['String']['input']>;
  doorPosition?: InputMaybe<Scalars['Int']['input']>;
  isReturnLeg?: InputMaybe<Scalars['Boolean']['input']>;
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid: Scalars['String']['input'];
};

export type AssignInventoryItemsToStorageUnitInput = {
  itemUuid: Scalars['String']['input'];
  /** The number of inventory items to assign to the specified storage unit */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
  /** The UUID of the storage unit to assign the inventory items */
  uuid: Scalars['String']['input'];
};

export type AssignInventoryItemsToStorageUnitOutput = {
  __typename?: 'AssignInventoryItemsToStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export type AssignLineHaulRouteInput = {
  /** Lets the route replace legs that are planned on manifests that have not left yet. Only the line-haul dispatch board Change route sends it, and only companies on line-haul networks honour it; every other caller keeps the refusal of an order that is already partially dispatched. */
  allowRepathDispatched?: InputMaybe<Scalars['Boolean']['input']>;
  legs: Array<LineHaulRouteLegInput>;
  orderUuid: Scalars['String']['input'];
};

export type AssignLineHaulRouteOutput = {
  __typename?: 'AssignLineHaulRouteOutput';
  laneUuid: Scalars['String']['output'];
  legCount: Scalars['Int']['output'];
  orderUuid: Scalars['String']['output'];
};

export type AssignOrderToTrailerInput = {
  manifestUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  trailerEquipmentUuid: Scalars['String']['input'];
};

export type AssignOutboundReferenceNumberToStorageUnitsInput = {
  outboundReferenceNumber: Scalars['String']['input'];
  /** The UUIDs of the storage units to assign the outbound reference number to */
  uuids: Array<Scalars['String']['input']>;
};

export type AssignOutboundReferenceNumberToStorageUnitsOutput = {
  __typename?: 'AssignOutboundReferenceNumberToStorageUnitsOutput';
  success: Scalars['Boolean']['output'];
};

export type AssignPackagesToManifestInput = {
  manifestUuid: Scalars['String']['input'];
  packageUuids: Array<Scalars['String']['input']>;
};

export type AttemptsAccessorialCreateInput = {
  name: Scalars['String']['input'];
};

export type AttemptsAccessorialEntity = AccessorialInterface & {
  __typename?: 'AttemptsAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type AttemptsAccessorialUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  orderEvent: OrderEventEntity;
  snapshotDifference?: Maybe<AuditLogSnapshotDifference>;
};

export type AuditLogSnapshotDifference = {
  __typename?: 'AuditLogSnapshotDifference';
  inboundStopDifferences?: Maybe<SnapshotStopDifferences>;
  orderDifferences?: Maybe<SnapshotOrderDifferences>;
  outboundStopDifferences?: Maybe<SnapshotStopDifferences>;
};

export type AuditReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  daysPastDue?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  reportAggregationPeriod: ReportAggregationPeriod;
  /** IANA zone the report reads its days in; honored only while terminal_local_times is on. When null, insight reports count each order on its stop's local service day, and the audit report uses the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuditReportBucketEntity = {
  __typename?: 'AuditReportBucketEntity';
  assigned: Array<Scalars['String']['output']>;
  attempted: Array<Scalars['String']['output']>;
  billingIssues: Array<Scalars['String']['output']>;
  cancelledFinalized: Array<Scalars['String']['output']>;
  cancelledUnfinalized: Array<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  daysPastDue?: Maybe<Scalars['Float']['output']>;
  endDate: Scalars['DateTime']['output'];
  noAction: Array<Scalars['String']['output']>;
  noChargeFinalized: Array<Scalars['String']['output']>;
  onHand: Array<Scalars['String']['output']>;
  onHold: Array<Scalars['String']['output']>;
  onInvoicePosted: Array<Scalars['String']['output']>;
  onInvoiceUnposted: Array<Scalars['String']['output']>;
  partiallyComplete: Array<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  unfinalized: Array<Scalars['String']['output']>;
};

export type AutoApplyAccessorialConfigAddressEntity = {
  __typename?: 'AutoApplyAccessorialConfigAddressEntity';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AutoApplyAccessorialConfigAddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AutoApplyAccessorialConfigEntity = {
  __typename?: 'AutoApplyAccessorialConfigEntity';
  /** @deprecated Use accessorials instead */
  accessorial: AccessorialUnion;
  accessorials: Array<AccessorialUnion>;
  addresses: Array<AutoApplyAccessorialConfigAddressEntity>;
  contact?: Maybe<ContactEntity>;
  contactsToExcludeFromRule?: Maybe<Array<ContactEntity>>;
  contactsToIncludeWithRule?: Maybe<Array<ContactEntity>>;
  createdAt: Scalars['DateTime']['output'];
  ruleType: AutoApplyAccessorialRuleType;
  service?: Maybe<ServiceEntity>;
  stopType?: Maybe<PickupOrDelivery>;
  tag?: Maybe<TagEntity>;
  tariffZone?: Maybe<TariffZoneEntity>;
  tariffZoneGroup?: Maybe<TariffZoneGroupEntity>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zipCodes: Array<Scalars['String']['output']>;
};

export enum AutoApplyAccessorialRuleType {
  Address = 'ADDRESS',
  Contact = 'CONTACT',
  ContactAndService = 'CONTACT_AND_SERVICE',
  ContactAndServiceAndTag = 'CONTACT_AND_SERVICE_AND_TAG',
  Global = 'GLOBAL',
  IsHazmat = 'IS_HAZMAT',
  IsInBond = 'IS_IN_BOND',
  Residential = 'RESIDENTIAL',
  Service = 'SERVICE',
  ServiceAndTag = 'SERVICE_AND_TAG',
  StopType = 'STOP_TYPE',
  StopTypeAndTerminal = 'STOP_TYPE_AND_TERMINAL',
  TariffZone = 'TARIFF_ZONE',
  TariffZoneGroup = 'TARIFF_ZONE_GROUP',
  ZipCode = 'ZIP_CODE'
}

export type AutoCreateRoutesV2Input = {
  /** Client-generated request UUID. Reuse the same id across retries of a single logical commit so the backend's idempotency cache returns the same summary on every retry. Mint a fresh id for a separate logical action: a new Preview after a Commit, or a fresh commit attempt against a different planning date / criteria override. Only commit submissions ever populate the cache. */
  clientRequestId: Scalars['String']['input'];
  /** Optional per-run criteria override. When null, the persisted RouteAutomationSettings are applied verbatim. */
  criteriaOverride?: InputMaybe<PopulationCriteriaInput>;
  /** When true, runs eligibility + matching + heuristic truck-fit and returns a Preview summary without writing anything. Preview never consults the idempotency cache - every Preview executes fresh against live data, so a Preview submitted after a Commit with the same clientRequestId returns Preview-computed numbers instead of the Commit's cached result. This is intentional so the dispatcher always sees the current eligibility set, not a stale snapshot. The Preview pipeline also skips recurring-order materialization and uses an approximate truck-fit, so Preview totals can diverge from a subsequent Commit; see the AutoRoutingService docstring. */
  dryRun: Scalars['Boolean']['input'];
  /** Calendar day to plan routes for, expressed as an ISO-8601 plain date string (YYYY-MM-DD). Matched against Stop.serviceDateIso8601 or Stop.deadlineTime depending on the settings dueDateSource. */
  planningDate: Scalars['String']['input'];
  /** UUID of the terminal selected on the dispatcher toolbar. Used as the primary terminal for any new Route this call materializes. When null (the dispatcher hasn't picked one) the service falls back to the most common terminal among each route's stops. */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type AutoCreateRoutesV2Output = {
  __typename?: 'AutoCreateRoutesV2Output';
  /** True when the run was a dry-run preview (transaction rolled back). False when the run was committed. */
  dryRun: Scalars['Boolean']['output'];
  /** Total number of stops considered eligible by the criteria filter. */
  eligibleStopCount: Scalars['Int']['output'];
  /** Stops that were placed onto a route during this run. */
  matchedStopCount: Scalars['Int']['output'];
  /** True when the response is a replayed cached summary (idempotency key collision). */
  replayed: Scalars['Boolean']['output'];
  routeSummaries: Array<AutoCreateRoutesV2RouteSummary>;
  /** Number of existing auto-created routes that received new appended slots in this run. */
  routesAppended: Scalars['Int']['output'];
  /** Number of new Route rows materialized in this run. */
  routesCreated: Scalars['Int']['output'];
  /** Stops that were eligible but could not be placed. */
  unmatchedStopCount: Scalars['Int']['output'];
  unmatchedStops: Array<AutoCreateRoutesV2UnmatchedStop>;
};

export type AutoCreateRoutesV2RouteSummary = {
  __typename?: 'AutoCreateRoutesV2RouteSummary';
  /** True when this run created the route; false when an existing unlocked auto-created route was appended to. */
  created: Scalars['Boolean']['output'];
  /** Display name of the auto-assigned Equipment. Null when no fit was found or auto-assign is off. */
  equipmentName?: Maybe<Scalars['String']['output']>;
  /** UUID of the Equipment auto-assigned to this route when `autoAssignTrucks` is on and a fit was found. Null otherwise. */
  equipmentUuid?: Maybe<Scalars['String']['output']>;
  /** Name of the route (mirrors RouteName.name). */
  routeName: Scalars['String']['output'];
  /** UUID of the route the slots map to. Null on dry-run summaries when this would be a freshly created route (no row exists yet); always set on commit summaries and on dry-run summaries for appended routes. */
  routeUuid?: Maybe<Scalars['String']['output']>;
  /** Per-stop detail for every stop attached in this run. Ordered by the slot ordinal used when attaching. */
  stops: Array<AutoCreateRoutesV2StopSummary>;
  /** Number of stops attached to this route during this run (newly appended slots). */
  stopsAttached: Scalars['Int']['output'];
  /** Outcome of truck-assignment for this route. Null when the company has `autoAssignTrucks` off. */
  truckFitNote?: Maybe<TruckFitNote>;
};

export type AutoCreateRoutesV2StopSummary = {
  __typename?: 'AutoCreateRoutesV2StopSummary';
  /** Address one-liner ("123 Main St, Brooklyn, NY 11201"). Null only when the stop has no resolved address. */
  addressOneLine?: Maybe<Scalars['String']['output']>;
  /** Customer / billing-party display name. Null when the parent order is unresolved. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Order display name (HAWB / order number). Null when the stop has no parent Order in any of the four FK roles. */
  orderName?: Maybe<Scalars['String']['output']>;
  /** PICKUP or DELIVERY (null for legacy rows without a type). */
  stopType?: Maybe<StopType>;
  /** UUID of the stop being placed. */
  stopUuid: Scalars['String']['output'];
};

export type AutoCreateRoutesV2UnmatchedStop = {
  __typename?: 'AutoCreateRoutesV2UnmatchedStop';
  /** Address one-liner ("123 Main St, Brooklyn, NY 11201"). Null when the stop has no resolved address. */
  addressOneLine?: Maybe<Scalars['String']['output']>;
  /** Customer / billing-party display name. Null when unresolved. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Human-readable summary of the matching keys tried for this stop (e.g. "ZIP 46201 / City Indianapolis"). Null for reasons that are not location-based (TARGET_ROUTE_LOCKED, STOP_ALREADY_ON_ROUTE). */
  matchAttempt?: Maybe<Scalars['String']['output']>;
  /** Order display name (HAWB / order number) of the stop. Null when the stop has no parent Order in any of the four FK roles. */
  orderName?: Maybe<Scalars['String']['output']>;
  reason: UnmatchedStopReason;
  /** PICKUP or DELIVERY (null for legacy rows without a type). */
  stopType?: Maybe<StopType>;
  /** UUID of the unmatched stop. */
  stopUuid: Scalars['String']['output'];
};

export type AvailablePeerCompanyEntity = {
  __typename?: 'AvailablePeerCompanyEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type AvailablePieceConnection = {
  __typename?: 'AvailablePieceConnection';
  edges: Array<AvailablePieceEdge>;
  pageInfo: PageInfo;
  /** Total count matching the filter; request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AvailablePieceEdge = {
  __typename?: 'AvailablePieceEdge';
  cursor: Scalars['String']['output'];
  node: AvailablePieceEntity;
};

export type AvailablePieceEntity = {
  __typename?: 'AvailablePieceEntity';
  additionalReferenceNumbers: Array<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  damagedNote?: Maybe<Scalars['String']['output']>;
  daysOverDwellThreshold?: Maybe<Scalars['Int']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  departedAt?: Maybe<Scalars['DateTime']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['DateTime']['output']>;
  discardedByName?: Maybe<Scalars['String']['output']>;
  discardedReason?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  dwellStatus?: Maybe<DwellStatus>;
  effectiveDwellThresholdDays?: Maybe<Scalars['Int']['output']>;
  eta?: Maybe<Scalars['DateTime']['output']>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  isUnalertedFreight: Scalars['Boolean']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  mawb?: Maybe<Scalars['String']['output']>;
  measurementUnits?: Maybe<MeasurementUnits>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  packageOrderName?: Maybe<Scalars['String']['output']>;
  packageOrderUuid?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['String']['output']>;
  packedPieceCount: Scalars['Int']['output'];
  podSignedBy?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  status: PieceStatus;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  totalPieces?: Maybe<Scalars['Int']['output']>;
  truckName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PackageType>;
  uuid: Scalars['String']['output'];
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
  warehouseLocationUuid?: Maybe<Scalars['String']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
  warehouseUuid?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<WeightUnits>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type AvailableSchedulingSlotEntity = {
  __typename?: 'AvailableSchedulingSlotEntity';
  /** Last moment this slot may still be taken, already walked back onto an operating day. */
  bookBy: Scalars['DateTime']['output'];
  /** When the slot ends. Later than midnight of the service day when the resource window crosses it. */
  endsAt: Scalars['DateTime']['output'];
  /** Pieces left on the day, or null when unlimited. */
  remainingPieces?: Maybe<Scalars['Int']['output']>;
  /** Stops left on the day across every booking, or null when the resource has no stop limit. Can read negative if a capacity was lowered below what is already booked. */
  remainingStops?: Maybe<Scalars['Int']['output']>;
  /** Weight left on the day, or null when unlimited. */
  remainingWeight?: Maybe<Scalars['Mass']['output']>;
  schedulingResourceId: Scalars['String']['output'];
  /** The resource offering the slot. Internal fleet label: several resources may cover one area on one weekday, and the name is the only thing distinguishing them. */
  schedulingResourceName: Scalars['String']['output'];
  /** The calendar day the resource window OPENS, as YYYY-MM-DD in the resource time zone. This is the day a capacity reservation for this slot must be dated by, and on an overnight resource it is NOT always the wall-clock day of startsAt. */
  serviceDateIso8601: Scalars['String']['output'];
  /** When the slot begins. */
  startsAt: Scalars['DateTime']['output'];
  /** Canonical IANA region zone startsAt and endsAt are meant to be read in. It is the RESOURCE time zone, which is not always the company one. */
  timeZone: Scalars['String']['output'];
};

/** The average days to pay report values for a contact */
export type AverageDaysToPayForContactEntity = {
  __typename?: 'AverageDaysToPayForContactEntity';
  averageDaysToPay90: Scalars['Float']['output'];
  averageDaysToPay180: Scalars['Float']['output'];
  averageDaysToPay270: Scalars['Float']['output'];
  averageDaysToPay360: Scalars['Float']['output'];
  averageDaysToPay720: Scalars['Float']['output'];
  averageDaysToPayAll: Scalars['Float']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

export type BackfillOrderTotalResult = {
  __typename?: 'BackfillOrderTotalResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
};

export type BackfillOrderTotalsOutput = {
  __typename?: 'BackfillOrderTotalsOutput';
  results: Array<BackfillOrderTotalResult>;
};

export type BatchAddShipmentsToInvoicePreview = {
  __typename?: 'BatchAddShipmentsToInvoicePreview';
  billingCycleDuration: BillingCycleDuration;
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingInvoiceAdds: Array<InvoiceAdd>;
  newInvoiceAdds: Array<InvoiceAdd>;
};

export type BatchAddShipmentsToInvoicesInput = {
  addToExistingInvoices: Scalars['Boolean']['input'];
  contactUuid: Scalars['String']['input'];
  /** @deprecated Backend will determine this value */
  invoiceTimePeriodSplit?: InputMaybe<TimePeriod>;
  /** @deprecated Backend will determine this value */
  numberOfOrdersPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  numberOfShipmentsPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  shipmentUuids: Array<Scalars['String']['input']>;
};

export type BatchAddShipmentsToInvoicesInputMultiple = {
  batchAddShipmentsToInvoicesInputs: Array<BatchAddShipmentsToInvoicesInput>;
};

export type BenchCompanyActorInput = {
  companyUuid: Scalars['String']['input'];
  /** A user of that company. Services that record a user of the order's company (markAsReceivedAtOrigin) act as this user. */
  userUuid: Scalars['String']['input'];
};

export type BenchCompanyUserOptionEntity = {
  __typename?: 'BenchCompanyUserOptionEntity';
  /** The name, or the email when unnamed. */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type BenchCreatedOrdersEntity = {
  __typename?: 'BenchCreatedOrdersEntity';
  /** Why the call stopped before creating every order. The call stops at the first tender the inbound handler does not turn into a new order. */
  failure?: Maybe<Scalars['String']['output']>;
  /** The rated order whose shipper and consignee addresses and packages the tenders copied. Null when the bench found none and used its fixed addresses. */
  laneSourceOrderName?: Maybe<Scalars['String']['output']>;
  /** The orders the call created, in the order it created them. */
  orders: Array<BenchOrderOptionEntity>;
  /** The service names the created orders received. The inbound handler prefers a contact or company default service over the picked code. */
  receivedServiceNames: Array<Scalars['String']['output']>;
  /** What creating an order for this company and contact reaches besides Tenedi. Production refuses creation when any is listed. */
  sideEffects: Array<BenchSideEffectEntity>;
  /** Set when no order of the billing contact rated above $0, so the tenders used fixed addresses and may rate at $0, or when the orders got a service other than the picked service level. */
  warning?: Maybe<Scalars['String']['output']>;
};

export type BenchDriverOptionEntity = {
  __typename?: 'BenchDriverOptionEntity';
  /** The name, or the email when unnamed. */
  displayName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type BenchEdiPayloadEntity = {
  __typename?: 'BenchEdiPayloadEntity';
  /** True when the row's message records Tenedi's acceptance. */
  deliveredThroughTenedi: Scalars['Boolean']['output'];
  /** What the two payloads are and what the bench rebuilt. */
  note: Scalars['String']['output'];
  /** The body the TMS posted to Tenedi, rebuilt with the envelope the delivery adds. Null when nothing went out. */
  sentBody?: Maybe<Scalars['String']['output']>;
  /** The Tenedi path the TMS posted to. Null when nothing went out. */
  sentPath?: Maybe<Scalars['String']['output']>;
  /** edi_transactions.payload, pretty-printed: the body before the Tenedi envelope. */
  storedPayload: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type BenchEdiTransactionEntity = {
  __typename?: 'BenchEdiTransactionEntity';
  createdAt: Scalars['DateTime']['output'];
  edi214ShipmentStatus?: Maybe<Edi214ShipmentStatus>;
  edi990ActionCode?: Maybe<Edi990ActionCode>;
  message?: Maybe<Scalars['String']['output']>;
  receiverIsaId: Scalars['String']['output'];
  status: EdiTransactionStatus;
  tenediMessageId?: Maybe<Scalars['String']['output']>;
  tenediRunIds: Array<Scalars['String']['output']>;
  /** 990, 214 or 210. */
  transactionSet: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type BenchFireResultEntity = {
  __typename?: 'BenchFireResultEntity';
  ediTransactions: Array<BenchEdiTransactionEntity>;
  message: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  outcome: BenchStepOutcome;
  sideEffects: Array<BenchSideEffectEntity>;
};

export enum BenchFireTransactionSet {
  Edi_210 = 'EDI_210',
  Edi_214 = 'EDI_214',
  Edi_990 = 'EDI_990'
}

export enum BenchIntegrationType {
  Tenedi = 'TENEDI'
}

export type BenchOrderOptionEntity = {
  __typename?: 'BenchOrderOptionEntity';
  createdAt: Scalars['DateTime']['output'];
  /** standard_order_fields.shipper_bill_of_lading_number. */
  hawb?: Maybe<Scalars['String']['output']>;
  /** standard_order_fields.master_airway_bill_of_lading_number. */
  mawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: OrderStatus;
  uuid: Scalars['String']['output'];
};

export type BenchOrderReportEntity = {
  __typename?: 'BenchOrderReportEntity';
  billingContactName?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  ediTransactions: Array<BenchEdiTransactionEntity>;
  hawb?: Maybe<Scalars['String']['output']>;
  lastResult?: Maybe<BenchStepResultEntity>;
  nextStep?: Maybe<BenchPlannedStepEntity>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  /** Why the bench will not touch this order in any environment. Empty when it may run. */
  refusals: Array<Scalars['String']['output']>;
  steps: Array<BenchPlannedStepEntity>;
};

/** Which orders a run covers. Explicit orderUuids win; otherwise the company and contact filters pick orders whose billing contact has a TENEDI partnership, newest first. */
export type BenchOrderSelectionInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BenchPartnershipOptionEntity = {
  __typename?: 'BenchPartnershipOptionEntity';
  autoAcceptOrders: Scalars['Boolean']['output'];
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  edi214ShipmentStatuses: Array<Edi214ShipmentStatus>;
  receiverIsaId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type BenchPlannedStepEntity = {
  __typename?: 'BenchPlannedStepEntity';
  expected214Statuses: Array<Edi214ShipmentStatus>;
  expects210: Scalars['Boolean']['output'];
  expects990: Scalars['Boolean']['output'];
  kind: BenchStepKind;
  manifestUuid?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  /** True when a side effect with no suppression option makes the bench refuse this step in production. */
  refusedInProduction: Scalars['Boolean']['output'];
  sideEffects: Array<BenchSideEffectEntity>;
  state: BenchStepState;
  stopRole?: Maybe<BenchStopRole>;
  stopUuid?: Maybe<Scalars['String']['output']>;
};

export type BenchRunReportEntity = {
  __typename?: 'BenchRunReportEntity';
  environment: Scalars['String']['output'];
  integrationType: BenchIntegrationType;
  orders: Array<BenchOrderReportEntity>;
  production: Scalars['Boolean']['output'];
};

/** A service level code mapped on the partnership; the only codes the EDI inbound handler resolves to a service. */
export type BenchServiceLevelOptionEntity = {
  __typename?: 'BenchServiceLevelOptionEntity';
  code: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
};

export type BenchSideEffectEntity = {
  __typename?: 'BenchSideEffectEntity';
  detail: Scalars['String']['output'];
  kind: BenchSideEffectKind;
  /** The service option the bench passes in production to stop it. */
  suppressedBy?: Maybe<Scalars['String']['output']>;
};

export enum BenchSideEffectKind {
  ApiUserWebhook = 'API_USER_WEBHOOK',
  ContactEmail = 'CONTACT_EMAIL',
  EfmStatus = 'EFM_STATUS',
  ExpeditorsStatus = 'EXPEDITORS_STATUS',
  OrderDelegation = 'ORDER_DELEGATION',
  OrderEventNotification = 'ORDER_EVENT_NOTIFICATION',
  OrderMirror = 'ORDER_MIRROR',
  OrderPostCreationHook = 'ORDER_POST_CREATION_HOOK',
  SettlementLines = 'SETTLEMENT_LINES',
  SftpPodUpload = 'SFTP_POD_UPLOAD',
  ShipmentSubscriberMessage = 'SHIPMENT_SUBSCRIBER_MESSAGE',
  UnverifiedSideEffects = 'UNVERIFIED_SIDE_EFFECTS'
}

export enum BenchStepKind {
  AcceptTender = 'ACCEPT_TENDER',
  AddToInvoice = 'ADD_TO_INVOICE',
  ArriveAtStop = 'ARRIVE_AT_STOP',
  CompleteStop = 'COMPLETE_STOP',
  ConfirmAppointment = 'CONFIRM_APPOINTMENT',
  DispatchStop = 'DISPATCH_STOP',
  FinalizeOrder = 'FINALIZE_ORDER',
  LineHaulArrive = 'LINE_HAUL_ARRIVE',
  LineHaulDepart = 'LINE_HAUL_DEPART',
  MarkOnHand = 'MARK_ON_HAND',
  PostInvoice = 'POST_INVOICE',
  ReceivedAtOrigin = 'RECEIVED_AT_ORIGIN',
  RouteStop = 'ROUTE_STOP',
  Send_210 = 'SEND_210',
  StartRoute = 'START_ROUTE'
}

export enum BenchStepOutcome {
  Blocked = 'BLOCKED',
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  LifecycleComplete = 'LIFECYCLE_COMPLETE',
  Refused = 'REFUSED',
  Waiting = 'WAITING'
}

export type BenchStepResultEntity = {
  __typename?: 'BenchStepResultEntity';
  kind?: Maybe<BenchStepKind>;
  message: Scalars['String']['output'];
  outcome: BenchStepOutcome;
  startedAt: Scalars['DateTime']['output'];
  stopRole?: Maybe<BenchStopRole>;
};

/** One lifecycle step: its kind, and the stop role for a stop step. Leave the role empty for an order-level step. */
export type BenchStepSelectorInput = {
  kind: BenchStepKind;
  stopRole?: InputMaybe<BenchStopRole>;
};

export enum BenchStepState {
  Blocked = 'BLOCKED',
  Done = 'DONE',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export enum BenchStopRole {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export enum BenchTenderShape {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  PickupAndDelivery = 'PICKUP_AND_DELIVERY'
}

export enum BillingCycleDuration {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Other = 'OTHER',
  Weekly = 'WEEKLY'
}

export enum BillingCycleType {
  AdHoc = 'AD_HOC',
  EveryFriday = 'EVERY_FRIDAY',
  EveryMonday = 'EVERY_MONDAY',
  EverySaturday = 'EVERY_SATURDAY',
  EverySunday = 'EVERY_SUNDAY',
  EveryThursday = 'EVERY_THURSDAY',
  EveryTuesday = 'EVERY_TUESDAY',
  EveryWednesday = 'EVERY_WEDNESDAY',
  EveryXDays = 'EVERY_X_DAYS'
}

export enum BillingShipmentStatus {
  Finalized = 'FINALIZED',
  HasIssue = 'HAS_ISSUE',
  Invoiced = 'INVOICED',
  Paid = 'PAID'
}

export type BlacklistStatsOutput = {
  __typename?: 'BlacklistStatsOutput';
  activeBlacklisted: Scalars['Int']['output'];
  expiredButNotCleaned: Scalars['Int']['output'];
  totalBlacklisted: Scalars['Int']['output'];
  userRevocations: Scalars['Int']['output'];
};

export type BlockCompanySchedulingDayInput = {
  /** Closes the day even though unreleased capacity claims sit on it. Without it, a day carrying claims writes NOTHING and answers with CompanySchedulingDayLiveClaimsOutput naming the resources and the claim total, so a client can show what is about to be closed over before asking again. A day carrying no claims is closed without it. Closing never cancels those claims either way: they stay on the day and still need releasing or rescheduling. Ignored on a day that is already closed, since re-stating a closure changes nothing about the freight on it. */
  confirmLiveClaims?: InputMaybe<Scalars['Boolean']['input']>;
  /** Calendar day to close for the whole company, as an ISO-8601 plain date (YYYY-MM-DD). Read in each resource own time zone, so a company closed on a date is closed on the day each of its resources calls that date. */
  dateIso8601: Scalars['String']['input'];
  /** Why the company is closed. Closing a day that is already closed replaces this and keeps the exemptions already granted. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type BlockSchedulingResourceDayInput = {
  /** Blocks the day even though unreleased capacity claims sit on it. Without it, a day carrying claims is refused with SchedulingResourceLiveClaimsOutput naming how many, so a client can show what is being closed over before asking again. Blocking never cancels those claims either way. Ignored on a day that is already blocked, since re-stating a block changes nothing about the freight on it. */
  confirmLiveClaims?: InputMaybe<Scalars['Boolean']['input']>;
  /** Calendar day to block, as an ISO-8601 plain date (YYYY-MM-DD). */
  dateIso8601: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  schedulingResourceId: Scalars['String']['input'];
};

export type BookCustomerAppointmentInput = {
  /** Access instructions for the driver -- gate codes, dock numbers, where to ring. Plain text, at most 500 characters. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The service day of the chosen window, as YYYY-MM-DD, exactly as the slot reported it. */
  serviceDateIso8601: Scalars['String']['input'];
  /** Start of the chosen window, exactly as the slot reported it. Matched against the live offer rather than trusted: a start that is no longer offered is refused, whatever the client sends. */
  startsAt: Scalars['DateTime']['input'];
  token: Scalars['String']['input'];
};

export type BookCustomerAppointmentOutput = BookCustomerAppointmentRefusedOutput | BookCustomerAppointmentSuccessOutput | MutationErrorOutput;

/** Why a customer booking or reschedule was refused. */
export enum BookCustomerAppointmentRefusalReason {
  AlreadyRouted = 'ALREADY_ROUTED',
  AlreadyScheduled = 'ALREADY_SCHEDULED',
  AwaitingOnHand = 'AWAITING_ON_HAND',
  NotBookable = 'NOT_BOOKABLE',
  PastChangeCutoff = 'PAST_CHANGE_CUTOFF',
  RescheduleLimitReached = 'RESCHEDULE_LIMIT_REACHED',
  SlotUnavailable = 'SLOT_UNAVAILABLE'
}

export type BookCustomerAppointmentRefusedOutput = {
  __typename?: 'BookCustomerAppointmentRefusedOutput';
  alternativeSlots: Array<CustomerAppointmentSlotEntity>;
  message: Scalars['String']['output'];
  reason: BookCustomerAppointmentRefusalReason;
};

export type BookCustomerAppointmentSuccessOutput = {
  __typename?: 'BookCustomerAppointmentSuccessOutput';
  bookedAppointment: CustomerBookedAppointmentEntity;
  /** Whether the customer may still move this appointment themselves. False once the single self-service reschedule is spent. */
  canReschedule: Scalars['Boolean']['output'];
  /** Confirmation copy to show the customer. */
  message: Scalars['String']['output'];
};

/** How the booked-stops view decided which resource a stop is on. */
export enum BookedStopAttribution {
  /** No claim; more than one resource could serve the stop. candidateResources lists them. */
  Ambiguous = 'AMBIGUOUS',
  /** The stop holds a live capacity claim, and the claimed resource decides. */
  Booking = 'BOOKING',
  /** No claim; exactly one resource covers the address, accepts the order and runs during the appointment. */
  Matched = 'MATCHED',
  /** No claim, and no resource could serve the stop. */
  None = 'NONE'
}

export type BookedStopEntity = {
  __typename?: 'BookedStopEntity';
  addressLine1: Scalars['String']['output'];
  appointmentTime: Scalars['DateTime']['output'];
  attribution: BookedStopAttribution;
  /** Every resource that could serve the stop, when attribution is AMBIGUOUS. Empty otherwise. */
  candidateResources: Array<BookedStopResourceEntity>;
  city: Scalars['String']['output'];
  /** The billing party. */
  customerName: Scalars['String']['output'];
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  houseAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the stop is already on a route. */
  isRouted: Scalars['Boolean']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  routeName?: Maybe<Scalars['String']['output']>;
  routeUuid?: Maybe<Scalars['String']['output']>;
  stopUuid: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type BookedStopGroupEntity = {
  __typename?: 'BookedStopGroupEntity';
  /** Every stop in the group. */
  bookedCount: Scalars['Int']['output'];
  /** Stops placed by a live ledger claim on the day (attribution BOOKING), which is what a customer booking leaves. Always 0 for AMBIGUOUS and NO_RESOURCE. */
  customerBookedCount: Scalars['Int']['output'];
  /** The resource's day uses more than its capacity on some axis, counting live booking claims and the appointments dispatchers set by hand that are attributed to this resource alone. Company-wide, whatever terminal the view is narrowed to. A live claim left on this day by a stop since moved to another day still counts here, even though the stop is listed under its new day. Always false for AMBIGUOUS and NO_RESOURCE. */
  isOverCapacity: Scalars['Boolean']['output'];
  kind: BookedStopGroupKind;
  routedCount: Scalars['Int']['output'];
  /** The resource, for a RESOURCE group. Null for the other two. */
  schedulingResource?: Maybe<BookedStopResourceEntity>;
  stops: Array<BookedStopEntity>;
};

/** What a booked-stops group collects. */
export enum BookedStopGroupKind {
  Ambiguous = 'AMBIGUOUS',
  NoResource = 'NO_RESOURCE',
  Resource = 'RESOURCE'
}

export type BookedStopResourceEntity = {
  __typename?: 'BookedStopResourceEntity';
  /** When the resource window closes, read in timeZone. Earlier than start when the window crosses midnight. */
  end: PlainTime;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** When the resource window opens, read in timeZone. */
  start: PlainTime;
  timeZone: Scalars['String']['output'];
};

export type BookedStopsByResourceOutput = {
  __typename?: 'BookedStopsByResourceOutput';
  /** One group per resource with stops on the day, ordered by when its window opens, then AMBIGUOUS, then NO_RESOURCE. Empty groups are omitted. */
  groups: Array<BookedStopGroupEntity>;
  /** More resources run on this weekday than attribution weighs, so a stop under AMBIGUOUS or NO_RESOURCE may belong to one that was not read. */
  isResourceSetTruncated: Scalars['Boolean']['output'];
  /** The day holds more appointment stops than the view reads, so some are missing from every group. */
  isTruncated: Scalars['Boolean']['output'];
  serviceDateIso8601: Scalars['String']['output'];
};

/** Represents the difference between 2 versions of a boolean field. Used in audit log entries */
export type BooleanFieldDifference = {
  __typename?: 'BooleanFieldDifference';
  newValue?: Maybe<Scalars['Boolean']['output']>;
  oldValue?: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanFilter = {
  filterOperator?: InputMaybe<FilterOperator>;
  value: Scalars['Boolean']['input'];
};

/** A filter object that is used to filter a boolean field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type BooleanFilterV2 = {
  /** Filters for records where the relevant boolean field is equal to the provided boolean value */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant boolean field is not equal to the provided boolean value */
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkAccessorialUpdateInput = {
  accessorialToMappingInputs: Array<AccessorialToMappingInput>;
};

export type BulkActionEntityResults = {
  __typename?: 'BulkActionEntityResults';
  /** Number of entities that were eligible for the action */
  eligible: Scalars['Int']['output'];
  /** UUIDs of entities that are eligible for the action */
  eligibleItems: Array<Scalars['String']['output']>;
  /** Number of entities that failed during processing */
  failed: Scalars['Int']['output'];
  /** Details of failed items with error messages */
  failedItems: Array<BulkActionItemResult>;
  /** Number of entities that were ineligible for the action */
  ineligible: Scalars['Int']['output'];
  /** Details of ineligible items with reasons */
  ineligibleItems: Array<BulkActionItemResult>;
  /** Number of entities that were successfully processed */
  succeeded: Scalars['Int']['output'];
  /** Total number of entities submitted for the action */
  total: Scalars['Int']['output'];
};

export type BulkActionItemResult = {
  __typename?: 'BulkActionItemResult';
  reason: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type BulkChangeCallStatusArgs = {
  callStatus: AppointmentCallStatus;
  uuids: Array<Scalars['String']['input']>;
};

export type BulkConfirmAppointmentsArgs = {
  uuids: Array<Scalars['String']['input']>;
};

export type BulkCsvRouteNameInput = {
  csvRouteNameInputs: Array<CsvRouteNameInput>;
};

export type BulkDelegateOrdersInput = {
  /** Free-text note to the executing company, at most 500 chars. */
  offerNote?: InputMaybe<Scalars['String']['input']>;
  /** Orders to delegate in full to the peer, at most 400. */
  orderUuids: Array<Scalars['String']['input']>;
  /** Organization peer (originator-side row) to delegate to. */
  peerUuid: Scalars['String']['input'];
};

export type BulkDelegationBatchEntity = {
  __typename?: 'BulkDelegationBatchEntity';
  failed: Scalars['Int']['output'];
  /** True once no order is pending. */
  isComplete: Scalars['Boolean']['output'];
  /** In the order the user selected the orders. */
  items: Array<BulkDelegationItemEntity>;
  offered: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type BulkDelegationItemEntity = {
  __typename?: 'BulkDelegationItemEntity';
  orderUuid: Scalars['String']['output'];
  /** Why the order was not offered; set only when FAILED. */
  reason?: Maybe<Scalars['String']['output']>;
  status: BulkDelegationItemStatus;
};

/** Where one order of a bulk delegation stands: offered to the partner, still queued or retrying, or refused. */
export enum BulkDelegationItemStatus {
  Failed = 'FAILED',
  Offered = 'OFFERED',
  Pending = 'PENDING'
}

export type BulkDeletePiecesInput = {
  pieceUuids: Array<Scalars['String']['input']>;
};

export type BulkDiscardPiecesInput = {
  pieceUuids: Array<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type BulkEditOrdersInput = {
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** appointmentTime as the same wall clock at each stop in its own zone (terminal_local_times). */
  appointmentTimeEachStop?: InputMaybe<StopWallClockInput>;
  /** appointmentTime as one moment typed in an entry zone (terminal_local_times). Send one of appointmentTime, appointmentTimeLocal or appointmentTimeEachStop. */
  appointmentTimeLocal?: InputMaybe<LocalDateTimeInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** completedAt as the same wall clock at each stop in its own zone (terminal_local_times). */
  completedAtEachStop?: InputMaybe<StopWallClockInput>;
  /** completedAt as one moment typed in an entry zone (terminal_local_times). Send one of completedAt, completedAtLocal or completedAtEachStop. */
  completedAtLocal?: InputMaybe<LocalDateTimeInput>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  /** Array of documents to upload. Each document will be attached to all eligible orders. Supports uploading multiple documents with different document types in a single bulk operation. */
  documents?: InputMaybe<Array<BulkUploadDocumentInput>>;
  /** Driver UUID for ASSIGN_TO_DRIVER action */
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  /** Multiple order actions to execute */
  orderActions?: InputMaybe<Array<OrderAction>>;
  orderUuids: Array<Scalars['String']['input']>;
  orderUuidsForAction: Array<Scalars['String']['input']>;
  osdReason?: InputMaybe<Scalars['String']['input']>;
  piecesOnHand?: InputMaybe<Scalars['Float']['input']>;
  podName?: InputMaybe<Scalars['String']['input']>;
  referenceNumbersToAdd?: InputMaybe<Array<Scalars['String']['input']>>;
  refusedBy?: InputMaybe<Scalars['String']['input']>;
  /** Why the consignee refused the orders, for MARK_AS_REFUSED */
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  /** The structured refusal reason for MARK_AS_REFUSED, for outbound EDI */
  refusedReasonCode?: InputMaybe<OrderRefusalReason>;
  secondaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 format. This is used to update the service date for the orders. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  shipmentUuids: Array<Scalars['String']['input']>;
  /** Multiple stop actions to execute */
  stopActions?: InputMaybe<Array<StopAction>>;
  /** @deprecated Not used in the backend. Only used in the frontend to derive the stop uuids to update. */
  stopTypes?: InputMaybe<Array<PickupOrDelivery>>;
  stopUuidsForAction: Array<Scalars['String']['input']>;
  stopUuidsForServiceDate?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type BulkEditOrdersResponse = {
  __typename?: 'BulkEditOrdersResponse';
  /** Results for deadline date field updates */
  deadlineDateUpdate?: Maybe<BulkActionEntityResults>;
  /** Results for deadline type field updates */
  deadlineTypeUpdate?: Maybe<BulkActionEntityResults>;
  /** Results for Master Airway Bill (MAWB) field updates */
  mawbUpdate?: Maybe<BulkActionEntityResults>;
  /** Per-action results for order state actions */
  orderStateActions?: Maybe<Array<OrderActionResult>>;
  /** Results for secondary reference number field updates */
  secondaryRefNumberUpdate?: Maybe<BulkActionEntityResults>;
  /** Results for service date field updates */
  serviceDateUpdate?: Maybe<BulkActionEntityResults>;
  /** Per-action results for stop state actions */
  stopStateActions?: Maybe<Array<StopActionResult>>;
  /** Whether the overall operation completed without errors */
  success: Scalars['Boolean']['output'];
  /** Results for warehouse field updates */
  warehouseUpdate?: Maybe<BulkActionEntityResults>;
};

export type BulkInventoryCountResultOutput = {
  __typename?: 'BulkInventoryCountResultOutput';
  /** Number of confirmations that failed. */
  failureCount: Scalars['Int']['output'];
  /** Per-piece failure details (UUID + reason). Empty when the whole batch succeeded. */
  failures: Array<BulkActionItemResult>;
  /** Number of confirmations applied successfully. */
  successCount: Scalars['Int']['output'];
};

export type BulkPiecesActionOutput = {
  __typename?: 'BulkPiecesActionOutput';
  /** Number of pieces the action failed on. */
  failureCount: Scalars['Int']['output'];
  /** Per-piece failure details (UUID + reason). Empty when the whole batch succeeded. */
  failures: Array<BulkActionItemResult>;
  /** Number of pieces the action completed successfully. */
  successCount: Scalars['Int']['output'];
};

export type BulkRestorePiecesInput = {
  pieceUuids: Array<Scalars['String']['input']>;
};

export type BulkUnconfirmAppointmentsArgs = {
  uuids: Array<Scalars['String']['input']>;
};

export type BulkUpdateContactMapping = {
  /** The column name in the CSV file that corresponds to the field name in the import contact schema */
  columnName: Scalars['String']['input'];
  /** The field in the import contact schema that corresponds to the column name in the CSV file */
  field: ImportContactField;
};

export type BulkUploadDocumentInput = {
  /** The document type classification */
  documentType: DocumentType;
  /** The original file name */
  fileName: Scalars['String']['input'];
  /** The MIME type of the file */
  fileType: Scalars['String']['input'];
  /** The S3 key for the uploaded document */
  s3Key: Scalars['String']['input'];
};

export type BusinessDivisionEntity = {
  __typename?: 'BusinessDivisionEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type BusinessKpiSetEntity = {
  __typename?: 'BusinessKpiSetEntity';
  avgDaysToInvoice?: Maybe<Scalars['Float']['output']>;
  avgDaysToPayment?: Maybe<Scalars['Float']['output']>;
  driverCount?: Maybe<Scalars['Int']['output']>;
  invoicedOrderCount?: Maybe<Scalars['Int']['output']>;
  orderCount?: Maybe<Scalars['Int']['output']>;
  ordersPerDriver?: Maybe<Scalars['Float']['output']>;
  paidInvoiceCount?: Maybe<Scalars['Int']['output']>;
  revenueCents?: Maybe<Scalars['Float']['output']>;
  unassignedLineHaulCents?: Maybe<Scalars['Float']['output']>;
  unassignedNoTerminalCents?: Maybe<Scalars['Float']['output']>;
};

export type BusinessKpisEntity = {
  __typename?: 'BusinessKpisEntity';
  current: BusinessKpiSetEntity;
  lastYear: BusinessKpiSetEntity;
};

export type CachedStopBaseEntity = {
  __typename?: 'CachedStopBaseEntity';
  address?: Maybe<AddressForCachedStop>;
  appointmentDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** The appointment as a day and window in the stop's zone. Null while terminal_local_times is off or without an appointment. */
  appointmentLocal?: Maybe<StopAppointmentLocalEntity>;
  appointmentRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the appointment has been confirmed either by the contact person or manually */
  appointmentScheduled?: Maybe<Scalars['Boolean']['output']>;
  /** The latest time the contact person was called with a prompt to select an appointment time */
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The latest time the contact person was texted with a prompt to select an appointment time */
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadlineDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  hasPreviousAttempt?: Maybe<Scalars['Boolean']['output']>;
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  serviceUuid?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  status: StopStatus;
  stopIntention?: Maybe<StopIntention>;
  stopType?: Maybe<StopType>;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  /** The stop's IANA zone from the location zone chain (address zone, US ZIP, stop or route terminal, company) while terminal local times are on for the session company; null otherwise. */
  timeZone?: Maybe<Scalars['String']['output']>;
  totalCharge?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type CachedStopConnection = {
  __typename?: 'CachedStopConnection';
  edges: Array<CachedStopEdge>;
  /** The requested page of group rows when `groupBy` asks for a level that is not yet expanded; null otherwise. */
  groupRows?: Maybe<Array<StopTableGroupRowEntity>>;
  /** Whether the level holds more group rows after this page. Null unless `groupRows` is set. */
  groupRowsHasMore?: Maybe<Scalars['Boolean']['output']>;
  pageInfo: PageInfo;
  /** If includeRecurringRunHeaders is true, this is set to the number of recurring runs present among the filtered stops before applying the limit. */
  recurringRunsCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of stops and, if includeRecurringRunHeaders is true, also the number of recurring runs. Not cheap to calculate, request with prudence. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CachedStopEdge = {
  __typename?: 'CachedStopEdge';
  cursor: Scalars['String']['output'];
  node: StopsListElement;
};

export type CachedStopEntity = {
  __typename?: 'CachedStopEntity';
  linkedEndStop?: Maybe<CachedStopBaseEntity>;
  order?: Maybe<OrderForCachedStop>;
  otherStop?: Maybe<CachedStopBaseEntity>;
  recurringRunUuid?: Maybe<Scalars['String']['output']>;
  stop: CachedStopBaseEntity;
  stopDetails?: Maybe<StopDetailsOutput>;
};

export type CallStopsInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type CalmCrossdockInstructionEntity = {
  __typename?: 'CalmCrossdockInstructionEntity';
  instruction: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
};

export type CalmFreightElsewhereEntity = {
  __typename?: 'CalmFreightElsewhereEntity';
  departed: Scalars['Int']['output'];
  loaded: Scalars['Int']['output'];
  onHand: Scalars['Int']['output'];
  terminalCode: Scalars['String']['output'];
};

export type CalmHawbSearchResultEntity = {
  __typename?: 'CalmHawbSearchResultEntity';
  hasMore: Scalars['Boolean']['output'];
  matches: Array<CalmOrderHawbMatchEntity>;
};

/** Where a shipment on a departing run comes from: originates here, rides through on the same truck, or cross-docks in from another truck. */
export enum CalmInboundSource {
  Origin = 'ORIGIN',
  Through = 'THROUGH',
  Xdock = 'XDOCK'
}

export type CalmLiveRunEntity = {
  __typename?: 'CalmLiveRunEntity';
  departedAt?: Maybe<Scalars['String']['output']>;
  dest: Scalars['String']['output'];
  driverName: Scalars['String']['output'];
  orig: Scalars['String']['output'];
  ref: Scalars['String']['output'];
  ships: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type CalmLoadOrdersInput = {
  manifestUuid: Scalars['String']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type CalmLoadPackageEntity = {
  __typename?: 'CalmLoadPackageEntity';
  awaitingInboundRef?: Maybe<Scalars['String']['output']>;
  cubeFt3: Scalars['Float']['output'];
  customer?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  destCode?: Maybe<Scalars['String']['output']>;
  elsewhere?: Maybe<CalmFreightElsewhereEntity>;
  expectedOnHandAt?: Maybe<Scalars['String']['output']>;
  floorSpaceSqFt: Scalars['Float']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  hazmat: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  inboundServiceDate?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  manifestUuid: Scalars['String']['output'];
  mawb?: Maybe<Scalars['String']['output']>;
  movement?: Maybe<StopType>;
  onHand: Scalars['Boolean']['output'];
  orderName: Scalars['String']['output'];
  orderUuid?: Maybe<Scalars['String']['output']>;
  originCode?: Maybe<Scalars['String']['output']>;
  outboundServiceDate?: Maybe<Scalars['String']['output']>;
  packageUuid: Scalars['String']['output'];
  pieces: Scalars['Int']['output'];
  piecesAtDestination: Scalars['Int']['output'];
  piecesDeparted: Scalars['Int']['output'];
  piecesLoaded: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  unitDimensions: Array<CalmUnitDimensionsEntity>;
  unitsWithoutFootprint: Scalars['Int']['output'];
  warehouse?: Maybe<Scalars['String']['output']>;
  warehouseLocation?: Maybe<Scalars['String']['output']>;
  weightLbs?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type CalmLoadPlacementEntity = {
  __typename?: 'CalmLoadPlacementEntity';
  h: Scalars['Float']['output'];
  l: Scalars['Float']['output'];
  manifestUuid: Scalars['String']['output'];
  packageUuid: Scalars['String']['output'];
  pieceUuid?: Maybe<Scalars['String']['output']>;
  rotated: Scalars['Boolean']['output'];
  trailerEquipmentUuid?: Maybe<Scalars['String']['output']>;
  unitIndex: Scalars['Int']['output'];
  w: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

export type CalmManifestReadinessEntity = {
  __typename?: 'CalmManifestReadinessEntity';
  cubeOnHand: Scalars['Float']['output'];
  cubeTotal: Scalars['Float']['output'];
  floorSpaceSqFt: Scalars['Float']['output'];
  manifestUuid: Scalars['String']['output'];
  orders: Scalars['Int']['output'];
  ordersNotOnHand: Scalars['Int']['output'];
  piecesAtDestination: Scalars['Int']['output'];
  piecesDeparted: Scalars['Int']['output'];
  piecesLoaded: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  piecesTotal: Scalars['Int']['output'];
  unitsWithoutFootprint: Scalars['Int']['output'];
  weightOnHand: Scalars['Float']['output'];
  weightTotal: Scalars['Float']['output'];
};

export type CalmManifestSearchResultEntity = {
  __typename?: 'CalmManifestSearchResultEntity';
  departDate: Scalars['String']['output'];
  dest: Scalars['String']['output'];
  /** The run operating day at its origin as YYYY-MM-DD, the day the board jumps to; null on a row written before it was stored. */
  operatingDay?: Maybe<Scalars['String']['output']>;
  orig: Scalars['String']['output'];
  ref: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CalmOnHandPieceEntity = {
  __typename?: 'CalmOnHandPieceEntity';
  customer?: Maybe<Scalars['String']['output']>;
  destCode?: Maybe<Scalars['String']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  inboundServiceDate?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationUuid?: Maybe<Scalars['String']['output']>;
  markedOnHandAt?: Maybe<Scalars['String']['output']>;
  orderRef?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  outboundServiceDate?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['String']['output']>;
  pieceRef?: Maybe<Scalars['String']['output']>;
  pieceUuid: Scalars['String']['output'];
  warehouseName?: Maybe<Scalars['String']['output']>;
  warehouseUuid?: Maybe<Scalars['String']['output']>;
  weightLbs?: Maybe<Scalars['Float']['output']>;
};

/** Whether a shipment stays on the truck, cross-docks, holds, or delivers at the terminal. */
export enum CalmOnwardDisposition {
  Crossdock = 'CROSSDOCK',
  Deliver = 'DELIVER',
  Hold = 'HOLD',
  Stay = 'STAY'
}

export type CalmOrderCommitEntity = {
  __typename?: 'CalmOrderCommitEntity';
  commitBy?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
};

export type CalmOrderCubeEntity = {
  __typename?: 'CalmOrderCubeEntity';
  cubeFt3: Scalars['Float']['output'];
  floorSpaceSqFt: Scalars['Float']['output'];
  orderUuid: Scalars['String']['output'];
  unitsWithoutFootprint: Scalars['Int']['output'];
  weightLbs: Scalars['Float']['output'];
};

export type CalmOrderHawbMatchEntity = {
  __typename?: 'CalmOrderHawbMatchEntity';
  hawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  status: OrderStatus;
};

export type CalmOrderLegEntity = {
  __typename?: 'CalmOrderLegEntity';
  assigned: Scalars['Boolean']['output'];
  departDate?: Maybe<Scalars['String']['output']>;
  endCode: Scalars['String']['output'];
  endUuid: Scalars['String']['output'];
  manifestRef?: Maybe<Scalars['String']['output']>;
  manifestUuid?: Maybe<Scalars['String']['output']>;
  ordinal: Scalars['Int']['output'];
  startCode: Scalars['String']['output'];
  startUuid: Scalars['String']['output'];
};

export type CalmOrderPackageEntity = {
  __typename?: 'CalmOrderPackageEntity';
  assignments: Array<CalmPackageAssignmentEntity>;
  commitBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  hazmat: Scalars['Boolean']['output'];
  onHand: Scalars['Boolean']['output'];
  pieces: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CalmOrderPackagesEntity = {
  __typename?: 'CalmOrderPackagesEntity';
  orderUuid: Scalars['String']['output'];
  packages: Array<CalmOrderPackageEntity>;
};

export type CalmOrderPieceEntity = {
  __typename?: 'CalmOrderPieceEntity';
  label?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['String']['output']>;
  status: PieceStatus;
  terminalCode?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<Scalars['String']['output']>;
};

export type CalmOrderSplitManifestEntity = {
  __typename?: 'CalmOrderSplitManifestEntity';
  departDate: Scalars['String']['output'];
  manifestRef: Scalars['String']['output'];
  manifestUuid: Scalars['String']['output'];
  units: Scalars['Int']['output'];
};

export type CalmOrderSplitSummaryEntity = {
  __typename?: 'CalmOrderSplitSummaryEntity';
  manifests: Array<CalmOrderSplitManifestEntity>;
  orderUuid: Scalars['String']['output'];
  totalUnits: Scalars['Int']['output'];
};

export type CalmOrderTagEntity = {
  __typename?: 'CalmOrderTagEntity';
  color?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type CalmOrderTagsEntity = {
  __typename?: 'CalmOrderTagsEntity';
  orderUuid: Scalars['String']['output'];
  tags: Array<CalmOrderTagEntity>;
};

export type CalmPackageAssignmentEntity = {
  __typename?: 'CalmPackageAssignmentEntity';
  departDate: Scalars['String']['output'];
  departed: Scalars['Boolean']['output'];
  leg: Scalars['String']['output'];
  manifestRef: Scalars['String']['output'];
  manifestUuid: Scalars['String']['output'];
};

export type CalmPlanOrderEntity = {
  __typename?: 'CalmPlanOrderEntity';
  destCode: Scalars['String']['output'];
  destUuid: Scalars['String']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  hazmat: Scalars['Boolean']['output'];
  inboundServiceDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  originCode: Scalars['String']['output'];
  originUuid: Scalars['String']['output'];
  outboundServiceDate?: Maybe<Scalars['String']['output']>;
  packages: Scalars['Int']['output'];
  packagesOnHand: Scalars['Int']['output'];
  pieces: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  ready: Scalars['Boolean']['output'];
  serviceDate?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type CalmPlanOrdersInput = {
  /** Inclusive service-date window start (ISO). With terminal_local_times on, only its YYYY-MM-DD part is read, as the day name matched against each endpoint stop local service day, so send UTC midnight of the day (2026-10-14T00:00:00.000Z), never a zoned instant whose UTC date can fall on the next day. */
  fromDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Inclusive service-date window end (ISO), read like fromDate: UTC midnight of the last day. */
  toDate: Scalars['String']['input'];
};

export type CalmPndRouteEntity = {
  __typename?: 'CalmPndRouteEntity';
  deliveries: Scalars['Int']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  driverUuid?: Maybe<Scalars['String']['output']>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orderUuids: Array<Scalars['String']['output']>;
  pickups: Scalars['Int']['output'];
  routeUuid: Scalars['String']['output'];
  startAt?: Maybe<Scalars['String']['output']>;
  started: Scalars['Boolean']['output'];
  stops: Scalars['Int']['output'];
};

export type CalmPndRouteLoadEntity = {
  __typename?: 'CalmPndRouteLoadEntity';
  floorLengthIn?: Maybe<Scalars['Float']['output']>;
  floorWidthIn?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  packages: Array<CalmLoadPackageEntity>;
  routeUuid: Scalars['String']['output'];
  vehicleName?: Maybe<Scalars['String']['output']>;
  weightCapacity?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type CalmReroutePreviewEntity = {
  __typename?: 'CalmReroutePreviewEntity';
  freightAtTerminalCode?: Maybe<Scalars['String']['output']>;
  freightAtTerminalUuid?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  refusal?: Maybe<Scalars['String']['output']>;
  runsToLeave: Array<CalmRerouteRunToLeaveEntity>;
  travelledLegs: Array<CalmRerouteTravelledLegEntity>;
};

export type CalmRerouteRunToLeaveEntity = {
  __typename?: 'CalmRerouteRunToLeaveEntity';
  referenceNumber: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CalmRerouteTravelledLegEntity = {
  __typename?: 'CalmRerouteTravelledLegEntity';
  arrived: Scalars['Boolean']['output'];
  endCode: Scalars['String']['output'];
  runReference: Scalars['String']['output'];
  startCode: Scalars['String']['output'];
};

export type CalmReschedulableEntity = {
  __typename?: 'CalmReschedulableEntity';
  commitBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  packageUuid: Scalars['String']['output'];
  pieces: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
};

export type CalmRunInboundOrderEntity = {
  __typename?: 'CalmRunInboundOrderEntity';
  fromManifestRef?: Maybe<Scalars['String']['output']>;
  fromManifestUuid?: Maybe<Scalars['String']['output']>;
  fromTerminalCode?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  source: CalmInboundSource;
};

export type CalmRunInboundPlanEntity = {
  __typename?: 'CalmRunInboundPlanEntity';
  manifestUuid: Scalars['String']['output'];
  orders: Array<CalmRunInboundOrderEntity>;
};

export type CalmRunOnwardOrderEntity = {
  __typename?: 'CalmRunOnwardOrderEntity';
  disposition: CalmOnwardDisposition;
  nextTerminalCode?: Maybe<Scalars['String']['output']>;
  onwardManifestRef?: Maybe<Scalars['String']['output']>;
  onwardManifestUuid?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
};

export type CalmRunOnwardPlanEntity = {
  __typename?: 'CalmRunOnwardPlanEntity';
  manifestUuid: Scalars['String']['output'];
  orders: Array<CalmRunOnwardOrderEntity>;
};

export type CalmSavePlacementsResultEntity = {
  __typename?: 'CalmSavePlacementsResultEntity';
  dropped: Scalars['Int']['output'];
  placements: Array<CalmLoadPlacementEntity>;
  saved: Scalars['Int']['output'];
};

export type CalmUnitDimensionsEntity = {
  __typename?: 'CalmUnitDimensionsEntity';
  height: Scalars['Float']['output'];
  length: Scalars['Float']['output'];
  pieceUuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type CancelPackingPendencyInput = {
  uuid: Scalars['String']['input'];
};

export type CancelPackingPendencyOutput = {
  __typename?: 'CancelPackingPendencyOutput';
  /** The packing pendency that was cancelled */
  packingPendency: PackingPendencyEntity;
};

export type ChargeBreakdownReportInput = {
  /** This filters by the order billing party contact. */
  billingPartyContactUuid: Scalars['String']['input'];
  /** This filters by the order invoice date */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  /** The zone serviceDateFilter is read in. Empty: each order on its own local service day while terminal_local_times is on, else the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  /** This filters by the order service date */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
};

export type ChargeBreakdownReportPdfInput = {
  billingPartyContactUuid: Scalars['String']['input'];
  completedAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
};

export type ChargeBreakdownReportPdfOutput = {
  __typename?: 'ChargeBreakdownReportPdfOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** The accessorial columns of the EXCEL_CHARGE_MATRIX invoice layout, in sheet order. */
export enum ChargeMatrixColumn {
  Debris = 'DEBRIS',
  Hospital = 'HOSPITAL',
  Inside = 'INSIDE',
  Lg = 'LG',
  Unpack = 'UNPACK'
}

export type ChargesUnion = CustomChargeEntity | FreightChargeEntity;

export type CheckConsistencyOfInvoicesInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type ChooseAppointmentOptionInput = {
  date: PlainDateInput;
  endTime: PlainTimeInput;
  startTime: PlainTimeInput;
  stopUuid: Scalars['String']['input'];
};

export type ChooseAppointmentOptionOutput = ChooseAppointmentOptionSuccessOutput | MutationErrorOutput;

export type ChooseAppointmentOptionSuccessOutput = {
  __typename?: 'ChooseAppointmentOptionSuccessOutput';
  /** The date and time of the appointment in a human-readable format */
  appointmentDateTime?: Maybe<Scalars['String']['output']>;
};

export type CityAndStateOptionEntity = {
  __typename?: 'CityAndStateOptionEntity';
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export enum ClassifiedDocumentType {
  AirWaybill = 'AIR_WAYBILL',
  BillOfLading = 'BILL_OF_LADING',
  CommercialInvoice = 'COMMERCIAL_INVOICE',
  CustomsEntry = 'CUSTOMS_ENTRY',
  DeliveryOrder = 'DELIVERY_ORDER',
  PackingList = 'PACKING_LIST',
  PickupAlert = 'PICKUP_ALERT',
  ProofOfDelivery = 'PROOF_OF_DELIVERY',
  Quote = 'QUOTE',
  RateConfirmation = 'RATE_CONFIRMATION'
}

export type ClearCompanyContactsInput = {
  companyUuid: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ClearCompanyContactsOutput = {
  __typename?: 'ClearCompanyContactsOutput';
  status: Scalars['String']['output'];
};

export type ClearCompanyInput = {
  companyUuid: Scalars['String']['input'];
  /** If true, delete company documents that are not attached to any surviving entity. Does not remove the underlying S3 objects. */
  deleteDocuments?: Scalars['Boolean']['input'];
  /** If true, delete empty driver settlement bills with no stop driver maps or settlement bill line items */
  deleteDriverSettlementBills: Scalars['Boolean']['input'];
  /** If true, delete empty invoices with no orders */
  deleteInvoices: Scalars['Boolean']['input'];
  /** If true, allow deleting orders on invoices */
  deleteOrdersOnInvoices: Scalars['Boolean']['input'];
  /** If true, delete payments that are not applied to any orders */
  deletePayments: Scalars['Boolean']['input'];
  /** If true, delete the pieces attached to the deleted orders. Pieces have no company_id, so a piece whose only order links are deleted becomes unattributable — this deletes them up front instead of leaving them behind with a null orderId. Pieces that also link to an order outside the deletion set are kept. */
  deletePieces?: Scalars['Boolean']['input'];
  /** If true, delete legacy quotes and quote-agent quote records (order_quotes) that have no order */
  deleteQuotes: Scalars['Boolean']['input'];
  /** If true, delete empty routes with no stops */
  deleteRoutes: Scalars['Boolean']['input'];
  /** If true, delete scanned order results (and their documents and pages) that never produced an order and are not attached to an order as a POD. */
  deleteScannedOrderResults?: Scalars['Boolean']['input'];
  /** This keeps any orders with the provided HAWB aka shipperBillOfLadingNumber. */
  orderHawbsToKeep: Array<Scalars['String']['input']>;
  /** This filters by the order service date. If null or empty, will delete all orders across all service dates */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** This filters by the order source. If null or empty, will not delete any orders. */
  orderSourcesToDelete: Array<OrderSource>;
};

export type ClearDriverSettlementPayBoundInput = {
  driverUuid: Scalars['String']['input'];
  payType: DriverPayType;
};

export type ClearOrderExecutedByInput = {
  orderUuid: Scalars['String']['input'];
  parts: Array<OrderDelegationPart>;
};

export type ClientChallengeEntity = {
  __typename?: 'ClientChallengeEntity';
  name: Scalars['String']['output'];
  squareLogoUrl?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type CloneSavedFilterViewInput = {
  displayName: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type CloseInventoryCountInput = {
  inventoryCountUuid: Scalars['String']['input'];
};

export type CloseInventoryCountOutput = InventoryCountEntity | MutationErrorOutput;

export enum CompanyAccountType {
  Customer = 'CUSTOMER',
  Demo = 'DEMO',
  Internal = 'INTERNAL',
  Test = 'TEST'
}

export type CompanyConfigurationChangeActorEntity = {
  __typename?: 'CompanyConfigurationChangeActorEntity';
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type CompanyConfigurationChangeConnection = {
  __typename?: 'CompanyConfigurationChangeConnection';
  edges: Array<CompanyConfigurationChangeEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CompanyConfigurationChangeEdge = {
  __typename?: 'CompanyConfigurationChangeEdge';
  cursor: Scalars['String']['output'];
  node: CompanyConfigurationChangeEntity;
};

export type CompanyConfigurationChangeEntity = {
  __typename?: 'CompanyConfigurationChangeEntity';
  changedBy?: Maybe<CompanyConfigurationChangeActorEntity>;
  createdAt: Scalars['DateTime']['output'];
  /** The setting key as the registry names it. A `Company.configs` key, or a `Company` column name for settings written through `updateCompany`. */
  key: Scalars['String']['output'];
  /** The setting's label from the registry, or the key itself when the setting no longer exists. */
  label: Scalars['String']['output'];
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
  uuid: Scalars['String']['output'];
};

export type CompanyConfigurationEntity = {
  __typename?: 'CompanyConfigurationEntity';
  addOrdersToOpenInvoices: Scalars['Boolean']['output'];
  allCapsInOrderPage: Scalars['Boolean']['output'];
  allowDriverToSelectNextStop?: Maybe<Scalars['Boolean']['output']>;
  appointmentChangeCutoffHours: Scalars['Int']['output'];
  /** Which scheduling model owns this company appointment capacity. Null means undecided; nothing reads it yet. */
  appointmentSchedulerModel?: Maybe<AppointmentSchedulerModel>;
  appointmentSchedulingCutoffDays: Scalars['Int']['output'];
  appointmentSchedulingLeadingBufferHours: Scalars['Int']['output'];
  appointmentSchedulingSlotHours: Scalars['Int']['output'];
  /** How many times a customer may move their own appointment from the public booking link. Zero means they book once and anything further needs a human. */
  appointmentSelfRescheduleLimit: Scalars['Int']['output'];
  autoApplyWaitTimeMinutes: Scalars['Boolean']['output'];
  autoGroupStops: Scalars['Boolean']['output'];
  autoMatchEodDocumentsToOrders: Scalars['Boolean']['output'];
  company: CompanyEntity;
  companyOrdinalStart?: Maybe<Scalars['Int']['output']>;
  createRecurringOrdersInAdvanceHours: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customDriverSignableForms: Array<DriverSignableFormTemplateEntity>;
  defaultDimFactor?: Maybe<Scalars['Int']['output']>;
  defaultFuelSettlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  defaultFuelSurcharge?: Maybe<Scalars['Float']['output']>;
  defaultFuelSurchargeBillingMethod: FuelBillingMethod;
  defaultGenerateAppointmentDurationInMinutes: Scalars['Int']['output'];
  defaultGenerateAppointmentEarlyCushionInMinutes: Scalars['Int']['output'];
  defaultInvoiceDocumentsRequired: Array<DocumentType>;
  defaultPalletHeight?: Maybe<Scalars['Int']['output']>;
  defaultPalletLength?: Maybe<Scalars['Int']['output']>;
  defaultPalletWidth?: Maybe<Scalars['Int']['output']>;
  defaultRouteLoadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  defaultRouteStartTime?: Maybe<Scalars['DateTime']['output']>;
  defaultRouteUnloadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  defaultStandardStopType: StandardStopType;
  defaultToAccessorial: Scalars['Boolean']['output'];
  draftOrderCleanupDays: Scalars['Int']['output'];
  draftOrderCleanupSources: Array<OrderSource>;
  /** How many days before its expiry date a driver compliance item reads as EXPIRING. */
  driverComplianceExpiringSoonDays: Scalars['Int']['output'];
  driversShouldMarkFreightAsLoaded: Scalars['Boolean']['output'];
  duplicateOrderMergeWindowHours: Scalars['Int']['output'];
  enableConsolidatedOrders: Scalars['Boolean']['output'];
  enableDigitalSignatureFlow: Scalars['Boolean']['output'];
  enablePaymentMethod: Scalars['Boolean']['output'];
  /** External rating providers the company has enabled; drives which freight billing methods can be chosen. */
  enabledExternalRatingProviders: Array<ExternalRatingProvider>;
  fulfillmentTypeEnabled: Scalars['Boolean']['output'];
  getDriverLocationDataFromMobile: Scalars['Boolean']['output'];
  includeHyphensInInvoiceName: Scalars['Boolean']['output'];
  includeINVInInvoiceName: Scalars['Boolean']['output'];
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This setting no longer affects invoices and will be removed. */
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfLogoUrl?: Maybe<Scalars['String']['output']>;
  lineHaulBuildAheadDays: Scalars['Int']['output'];
  lineHaulEnabled: Scalars['Boolean']['output'];
  lineHaulMobileFutureWindowHours: Scalars['Int']['output'];
  lineHaulMobilePastWindowHours: Scalars['Int']['output'];
  lineHaulPlanningEnabled: Scalars['Boolean']['output'];
  logisticsSectionEnabled: Scalars['Boolean']['output'];
  markOnHandUponPickup: Scalars['Boolean']['output'];
  minDigitsInCompanyOrdinalOrderName?: Maybe<Scalars['Int']['output']>;
  mobilePollingIntervalInSeconds?: Maybe<Scalars['Float']['output']>;
  notificationsEnabled: Scalars['Boolean']['output'];
  orderIdentifierForCoverSheet: OrderIdentifier;
  orderLevelOsdEnabled: Scalars['Boolean']['output'];
  orderNamingScheme: OrderNamingScheme;
  packageWarehouseLocationsEnabled: Scalars['Boolean']['output'];
  pieceTransferableStatuses: Array<PieceStatus>;
  pointToPointTariffsEnabled: Scalars['Boolean']['output'];
  quoteAgentAutoSendMaxCents?: Maybe<Scalars['Int']['output']>;
  quoteAgentDailyModelBudgetCents: Scalars['Int']['output'];
  quoteAgentDefaultMode: QuoteAgentPolicyMode;
  quoteAgentEnabled: Scalars['Boolean']['output'];
  quoteAgentMinConfidence: Scalars['Int']['output'];
  quoteAgentValidityHours: Scalars['Int']['output'];
  /** The quote contribution ratio from which a quote shows as Marginal rather than Not profitable. */
  quoteContributionMarginalFromRatio: Scalars['Float']['output'];
  /** The quote contribution ratio from which a quote shows as Profitable. */
  quoteContributionProfitableFromRatio: Scalars['Float']['output'];
  recoveryTariffsEnabled: Scalars['Boolean']['output'];
  requireDimsToFinalizeCharges: Scalars['Boolean']['output'];
  requireDriverSignature: Scalars['Boolean']['output'];
  requireDriverToAcknowledgeRouteChange: Scalars['Boolean']['output'];
  requireDriverToConfirmStopCompletedAtTime: Scalars['Boolean']['output'];
  /** When true, a delivery cannot be self-scheduled until its order is marked on hand: every slot query answers empty for it, and the customer booking page says the shipment has not arrived yet. Pickups are not affected. */
  requireOnHandBeforeSelfScheduling: Scalars['Boolean']['output'];
  requirePODPhotoAndName: Scalars['Boolean']['output'];
  requirePODPhotoAndNameForPickups: Scalars['Boolean']['output'];
  requirePODPhotoForDeliveries: Scalars['Boolean']['output'];
  requirePODPhotoForPickups: Scalars['Boolean']['output'];
  requireReviewForEdiOrderCreation: Scalars['Boolean']['output'];
  requireSignedPodToCompleteStop: Scalars['Boolean']['output'];
  requireSigneeNameForDeliveries: Scalars['Boolean']['output'];
  requireSigneeNameForPickups: Scalars['Boolean']['output'];
  restrictEditingOrderName: Scalars['Boolean']['output'];
  reviewUrl?: Maybe<Scalars['String']['output']>;
  sameDayDispatchCellHeader: SameDayDispatchCellHeader;
  sendSignedPodEmailAfterLateSignature: Scalars['Boolean']['output'];
  sendSummaryEmailWithIncompleteRoutes: Scalars['Boolean']['output'];
  serviceLevelOptional: Scalars['Boolean']['output'];
  showAccessorialsToDrivers: Scalars['Boolean']['output'];
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showCompanyNameOnBillOfLadingDoc: Scalars['Boolean']['output'];
  showDriverSettlementInBilling: Scalars['Boolean']['output'];
  showHelpersColumnInDispatch?: Maybe<Scalars['Boolean']['output']>;
  showKilogramsAndCentimeters: Scalars['Boolean']['output'];
  showManuallyConfirmedByDefault?: Maybe<Scalars['Boolean']['output']>;
  showVehicleInDailyDispatch?: Maybe<Scalars['Boolean']['output']>;
  stampMobilePhotosWithTimeAndLocation: Scalars['Boolean']['output'];
  startingInvoiceOrdinalNumber?: Maybe<Scalars['Float']['output']>;
  t2tDelegationEnabled: Scalars['Boolean']['output'];
  t2tSyncEnabled: Scalars['Boolean']['output'];
  /** @deprecated Terminals are always enabled. */
  terminalsEnabled: Scalars['Boolean']['output'];
  textNextCustomerForAppointments: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  useDriverNumberForDispatch: Scalars['Boolean']['output'];
  useHawbForLotLabelBarcode: Scalars['Boolean']['output'];
  useJournalNumberForInvoice: Scalars['Boolean']['output'];
  useSeparateDigitalSignatureStep: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  wmsAutoMarkOnHand: Scalars['Boolean']['output'];
  /** @deprecated No longer in use. Present for backwards compatibility, will be removed in the future. */
  wmsBarcodeScannerEnabled: Scalars['Boolean']['output'];
  wmsEnabled: Scalars['Boolean']['output'];
  wmsShortTermStorageEnabled: Scalars['Boolean']['output'];
  wmsStorageOrdersEnabled: Scalars['Boolean']['output'];
};

export type CompanyEntity = {
  __typename?: 'CompanyEntity';
  accessorials: Array<AccessorialUnion>;
  /** What kind of tenant this is. Tenet broadcasts reach CUSTOMER and INTERNAL companies only. */
  accountType: CompanyAccountType;
  addresses: Array<AddressEntity>;
  airportInfos: Array<AirportInfoEntity>;
  alternateIsaId?: Maybe<Scalars['String']['output']>;
  alternateStandardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  blockSendingZeroDollarInvoices: Scalars['Boolean']['output'];
  companyLandscapeLogoUrl?: Maybe<Scalars['String']['output']>;
  companySquareLogoUrl?: Maybe<Scalars['String']['output']>;
  companyStatistics?: Maybe<CompanyStatsEntity>;
  configuration?: Maybe<CompanyConfigurationEntity>;
  createdAt: Scalars['DateTime']['output'];
  customDunningReportFooter?: Maybe<Scalars['String']['output']>;
  customDunningReportHeader?: Maybe<Scalars['String']['output']>;
  customerContacts: Array<CustomerContactEntity>;
  customerPortalConfiguration?: Maybe<CustomerPortalConfigurationEntity>;
  defaultAddress?: Maybe<AddressEntity>;
  defaultInboundEdiService?: Maybe<ServiceEntity>;
  defaultInboundOutboundEdiService?: Maybe<ServiceEntity>;
  defaultInvoiceEmailSubject?: Maybe<Scalars['String']['output']>;
  defaultLineHaulSettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultLineHaulTariffChain?: Maybe<TariffChainEntity>;
  defaultMeasurementUnits: MeasurementUnits;
  defaultNonCompanyDriverSettlementMode: SettlementMode;
  defaultOrdinarySettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultOrdinaryTariffChain?: Maybe<TariffChainEntity>;
  defaultOutboundEdiService?: Maybe<ServiceEntity>;
  defaultPointToPointSettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultPointToPointTariffChain?: Maybe<TariffChainEntity>;
  defaultRecoverySettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultRecoveryTariffChain?: Maybe<TariffChainEntity>;
  defaultTransferSettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultTransferTariffChain?: Maybe<TariffChainEntity>;
  defaultWeightUnits: WeightUnits;
  drivers: Array<DriverEntity>;
  fourthAlternateIsaId?: Maybe<Scalars['String']['output']>;
  fourthAlternateScac?: Maybe<Scalars['String']['output']>;
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  freightSnapId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  invoiceEmail?: Maybe<Scalars['String']['output']>;
  isCourier?: Maybe<Scalars['Boolean']['output']>;
  isaId?: Maybe<Scalars['String']['output']>;
  lineHaulLanes: Array<LineHaulLaneEntity>;
  /** Clock linehaul depart times and cutoffs are entered in: ORIGIN (the origin terminal) when the company is on the origin clock (the default for new companies, or after the per-company switch) and terminal local times are on for it, else COMPANY. */
  lineHaulScheduleInputTimeZoneMode: ScheduleTimeZoneMode;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderFormFields: OrderFormFieldsEntity;
  orderImportConfiguration?: Maybe<OrderImportConfigurationEntity>;
  orderNameOrdinal?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  productionCompany?: Maybe<ProductionCompany>;
  purchasedProductOfferings: Array<PalletProductOffering>;
  qbInvoiceNumberStart?: Maybe<Scalars['Float']['output']>;
  qboDefaultClassId?: Maybe<Scalars['String']['output']>;
  qboDefaultIncomeAccountId?: Maybe<Scalars['String']['output']>;
  qboDefaultTaxCodeId?: Maybe<Scalars['String']['output']>;
  qboFreightItemId?: Maybe<Scalars['String']['output']>;
  qboFuelItemId?: Maybe<Scalars['String']['output']>;
  qboLineHaulItemId?: Maybe<Scalars['String']['output']>;
  quickbooksAccessToken?: Maybe<QuickbooksOauthTokenEntity>;
  quickbooksCompanyId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopCompanyId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopDeliveryId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopFuelChargeId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopLineHaulId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopOrderChargeId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopPickupId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopRecoveryId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopTransferId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingAccessorialChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  secondAlternateIsaId?: Maybe<Scalars['String']['output']>;
  secondAlternateScac?: Maybe<Scalars['String']['output']>;
  segment: Segment;
  sendgridSenderId?: Maybe<Scalars['String']['output']>;
  services: Array<ServiceEntity>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  tags: Array<TagEntity>;
  terminals?: Maybe<Array<TerminalEntity>>;
  thirdAlternateIsaId?: Maybe<Scalars['String']['output']>;
  thirdAlternateScac?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  useSageBusinessWorks: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  warehouses?: Maybe<Array<WarehouseEntity>>;
};

export type CompanyPackageTypeConfigEntity = {
  __typename?: 'CompanyPackageTypeConfigEntity';
  id: Scalars['String']['output'];
  isSingleHandlingUnit: Scalars['Boolean']['output'];
  packageType: PackageType;
};

export type CompanySchedulingBlockedDayOutput = CompanySchedulingBlockedDaySuccessOutput | CompanySchedulingDayExemptionsAtRiskOutput | CompanySchedulingDayLiveClaimsOutput | MutationErrorOutput;

export type CompanySchedulingBlockedDaySuccessOutput = {
  __typename?: 'CompanySchedulingBlockedDaySuccessOutput';
  /** How many resources the closure lands on altogether. Exact and uncapped, unlike the list above, so a fleet larger than one page is still reported truthfully. */
  affectedSchedulingResourceCount: Scalars['Int']['output'];
  /** Live, non-exempt resources running on that weekday, soonest by name. A resource carrying a blocked day of its own is still listed: the company closure covers it too. CAPPED, so compare its length against affectedSchedulingResourceCount before reading it as the whole fleet. Empty after a day is reopened. */
  affectedSchedulingResources: Array<CompanySchedulingDayAffectedResourceOutput>;
  /** Total unreleased capacity claims on that day. Counts CLAIMS rather than resources, covers EVERY affected resource rather than only the ones named above, and is read after the write commits, so a reservation still in flight can be missing from it. */
  liveClaimCount: Scalars['Int']['output'];
  /** The closed day, or null when the day was just reopened. Reopening also drops the day exemptions, because they were opt-outs from a closure that no longer exists. */
  schedulingBlockedDay?: Maybe<SchedulingBlockedDayEntity>;
};

export type CompanySchedulingDayAffectedResourceOutput = {
  __typename?: 'CompanySchedulingDayAffectedResourceOutput';
  id: Scalars['String']['output'];
  /** Unreleased capacity claims this resource holds on the closed day. The claims are NOT cancelled by the closure: they stay on the day and keep consuming capacity, so they still need releasing or rescheduling. */
  liveClaimCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CompanySchedulingDayExemptionInput = {
  /** The closed company day, as an ISO-8601 plain date (YYYY-MM-DD). Must already be blocked for the company. */
  dateIso8601: Scalars['String']['input'];
  schedulingResourceId: Scalars['String']['input'];
};

export type CompanySchedulingDayExemptionsAtRiskOutput = {
  __typename?: 'CompanySchedulingDayExemptionsAtRiskOutput';
  /** How many scheduling resources would lose their exemption. Exact and uncapped, unlike the exemptSchedulingResourceIds a blocked day reports, which is one page. Always greater than zero: a day with no exemptions is reopened on the first call and never produces this arm. */
  exemptSchedulingResourceCount: Scalars['Int']['output'];
  /** Operator-facing explanation of what reopening the day would discard, and how to proceed. Safe to render verbatim. */
  message: Scalars['String']['output'];
};

export type CompanySchedulingDayLiveClaimsOutput = {
  __typename?: 'CompanySchedulingDayLiveClaimsOutput';
  /** How many resources the closure would land on altogether. Exact and uncapped, unlike the list above. */
  affectedSchedulingResourceCount: Scalars['Int']['output'];
  /** Live, non-exempt resources running on that weekday, by name. CAPPED, so compare its length against affectedSchedulingResourceCount before reading it as the whole fleet. */
  affectedSchedulingResources: Array<CompanySchedulingDayAffectedResourceOutput>;
  /** Total unreleased capacity claims that would be closed over. Counts CLAIMS rather than resources, and covers EVERY affected resource rather than only the ones named above. Always greater than zero: a day with no claims is closed on the first call and never produces this arm. */
  liveClaimCount: Scalars['Int']['output'];
  /** Operator-facing explanation of what closing the day would land on, and how to proceed. Safe to render verbatim. */
  message: Scalars['String']['output'];
};

export type CompanyStatsEntity = {
  __typename?: 'CompanyStatsEntity';
  numberOfOrdersDueInFuture: Scalars['Float']['output'];
  numberOfOrdersOneToThirty: Scalars['Float']['output'];
  numberOfOrdersPastNinetyOne: Scalars['Float']['output'];
  numberOfOrdersSixtyOneToNinety: Scalars['Float']['output'];
  numberOfOrdersThirtyOneToSixty: Scalars['Float']['output'];
  numberOfUninvoicedOrdersDueInFuture: Scalars['Float']['output'];
  numberOfUninvoicedOrdersOneToThirty: Scalars['Float']['output'];
  numberOfUninvoicedOrdersPastNinetyOne: Scalars['Float']['output'];
  numberOfUninvoicedOrdersSixtyOneToNinety: Scalars['Float']['output'];
  numberOfUninvoicedOrdersThirtyOneToSixty: Scalars['Float']['output'];
};

export type CompleteRebillInput = {
  newContactUuid: Scalars['String']['input'];
  originalInvoiceUuid: Scalars['String']['input'];
  originalOrderUuid: Scalars['String']['input'];
  rebillOrderUuid: Scalars['String']['input'];
};

export type CompleteRebillOutput = {
  __typename?: 'CompleteRebillOutput';
  invoiceForRebill: InvoiceEntity;
};

export type CompleteStopBulkInput = {
  /** Pass this in to save this at the same time as completing the stop */
  completeStopInputs?: InputMaybe<Array<CompleteStopInput>>;
};

export type CompleteStopEntity = {
  __typename?: 'CompleteStopEntity';
  appointmentCallStatus?: Maybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed: Scalars['Boolean']['output'];
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentTextStatus?: Maybe<AppointmentTextStatus>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  courierReadyOrDueDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerBookingNotes?: Maybe<Scalars['String']['output']>;
  deadlineTime?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  driverCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  etaFinishTime?: Maybe<Scalars['DateTime']['output']>;
  etaLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  expectedOutboundDate?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Float']['output']>;
  inboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  incomingCarrier?: Maybe<Scalars['String']['output']>;
  lastAppointmentTextTime?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundCarrier?: Maybe<Scalars['String']['output']>;
  outboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  paperworkMarkedComplete?: Maybe<Scalars['Boolean']['output']>;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeChangeAcknowledged: Scalars['Boolean']['output'];
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  showDriverModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  status: StopStatus;
  stopType: StopType;
  textResponses?: Maybe<Scalars['String']['output']>;
  twilioCallSid?: Maybe<Scalars['String']['output']>;
  twilioTextSid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type CompleteStopInput = {
  /** The date the stop was completed */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** completedAt typed as a wall clock in an entry zone (terminal_local_times). Send this or completedAt, not both. */
  completedAtLocal?: InputMaybe<LocalDateTimeInput>;
  /** If set to true, forces completion of the associated order regardless of any condition that may prevent that. */
  forceComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isFromWebApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the person who signed the delivery */
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  sentFromDriverMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pass this in to save this at the same time as completing the stop */
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  stopUuid: Scalars['String']['input'];
  /** UUID of the driver truck warehouse. On pickup completion, unscanned pieces receive this warehouseId. On delivery completion, warehouseId is cleared. */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteStopInvalidInputException = {
  __typename?: 'CompleteStopInvalidInputException';
  message: Scalars['String']['output'];
};

export type CompleteStopOutput = CompleteStopEntity | CompleteStopInvalidInputException;

export type CompleteWorkOrderLoadingInput = {
  /** The scanning mode the operator was working in. Used to drop pieces another device already scanned for this mode from `shortagePieceUuids`, so a concurrent scan is not recorded as a shortage. Omitting it keeps only the terminal-status filter. */
  mode?: InputMaybe<FreightScanningV2ScanMode>;
  /** Pieces the operator finished without scanning, flagged as shortages. UUIDs that are not on this work order, or that the server already shows as scanned for `mode`, are dropped. A malformed UUID rejects the whole mutation rather than being dropped, so a client bug fails loudly instead of silently under-recording shortages. */
  shortagePieceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  workOrderType: WorkOrderType;
  /** The UUID of the route or line haul manifest */
  workOrderUuid: Scalars['String']['input'];
};

export type CompleteWorkOrderLoadingOutput = {
  __typename?: 'CompleteWorkOrderLoadingOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CompletedAtSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type CompletionToPaymentDuration = {
  __typename?: 'CompletionToPaymentDuration';
  backwardOrders: Scalars['Int']['output'];
  countedOrders: Scalars['Int']['output'];
  meanSeconds?: Maybe<Scalars['Float']['output']>;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
  prior: CompletionToPaymentPriorDuration;
};

export type CompletionToPaymentFilterArgs = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  flag?: InputMaybe<CompletionToPaymentFlag>;
  runsBackward?: InputMaybe<CompletionToPaymentMeasure>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  waitingIn?: InputMaybe<CompletionToPaymentStage>;
};

export enum CompletionToPaymentFlag {
  OnHold = 'ON_HOLD',
  RatingErrors = 'RATING_ERRORS'
}

export type CompletionToPaymentFlags = {
  __typename?: 'CompletionToPaymentFlags';
  onHold: Scalars['Int']['output'];
  ratingErrors: Scalars['Int']['output'];
  ratingErrorsUnpaid: Scalars['Int']['output'];
};

export type CompletionToPaymentGroup = {
  __typename?: 'CompletionToPaymentGroup';
  name: Scalars['String']['output'];
  orders: Scalars['Int']['output'];
  postedOrders: Scalars['Int']['output'];
  postedToPaidCountedOrders: Scalars['Int']['output'];
  postedToPaidMedianSeconds?: Maybe<Scalars['Float']['output']>;
  settledOrders: Scalars['Int']['output'];
  toPostedCountedOrders: Scalars['Int']['output'];
  toPostedMedianSeconds?: Maybe<Scalars['Float']['output']>;
  unpaidOver30Days: Scalars['Int']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export enum CompletionToPaymentInterval {
  CompleteToFinalized = 'COMPLETE_TO_FINALIZED',
  FinalizedToOnInvoice = 'FINALIZED_TO_ON_INVOICE',
  OnInvoiceToPosted = 'ON_INVOICE_TO_POSTED',
  PostedToPaid = 'POSTED_TO_PAID'
}

export type CompletionToPaymentIntervalDuration = {
  __typename?: 'CompletionToPaymentIntervalDuration';
  backwardOrders: Scalars['Int']['output'];
  countedOrders: Scalars['Int']['output'];
  key: CompletionToPaymentInterval;
  meanSeconds?: Maybe<Scalars['Float']['output']>;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
  prior: CompletionToPaymentPriorDuration;
};

export type CompletionToPaymentLongestInterval = {
  __typename?: 'CompletionToPaymentLongestInterval';
  key: CompletionToPaymentInterval;
  seconds: Scalars['Float']['output'];
};

export enum CompletionToPaymentMeasure {
  CompleteToFinalized = 'COMPLETE_TO_FINALIZED',
  CompleteToPaid = 'COMPLETE_TO_PAID',
  CompleteToPosted = 'COMPLETE_TO_POSTED',
  FinalizedToOnInvoice = 'FINALIZED_TO_ON_INVOICE',
  OnInvoiceToPosted = 'ON_INVOICE_TO_POSTED',
  PostedToPaid = 'POSTED_TO_PAID'
}

export type CompletionToPaymentOutlierOrder = {
  __typename?: 'CompletionToPaymentOutlierOrder';
  customerName: Scalars['String']['output'];
  fromAt: Scalars['DateTime']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  seconds: Scalars['Float']['output'];
  toAt: Scalars['DateTime']['output'];
};

export type CompletionToPaymentOutliers = {
  __typename?: 'CompletionToPaymentOutliers';
  measure: CompletionToPaymentMeasure;
  orders: Array<CompletionToPaymentOutlierOrder>;
};

export type CompletionToPaymentPageArgs = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  flag?: InputMaybe<CompletionToPaymentFlag>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  runsBackward?: InputMaybe<CompletionToPaymentMeasure>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  waitingIn?: InputMaybe<CompletionToPaymentStage>;
};

export type CompletionToPaymentPriorDuration = {
  __typename?: 'CompletionToPaymentPriorDuration';
  countedOrders: Scalars['Int']['output'];
  medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type CompletionToPaymentReport = {
  __typename?: 'CompletionToPaymentReport';
  rows: Array<CompletionToPaymentRow>;
  timezone: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CompletionToPaymentRow = {
  __typename?: 'CompletionToPaymentRow';
  accountId?: Maybe<Scalars['String']['output']>;
  chargesFinalizedAt?: Maybe<Scalars['DateTime']['output']>;
  completeToFinalizedSeconds?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  customerName: Scalars['String']['output'];
  finalizedToOnInvoiceSeconds?: Maybe<Scalars['Float']['output']>;
  hasRatingErrors: Scalars['Boolean']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  invoicePaidAt?: Maybe<Scalars['DateTime']['output']>;
  invoicePostedAt?: Maybe<Scalars['DateTime']['output']>;
  onHold: Scalars['Boolean']['output'];
  onInvoiceAt?: Maybe<Scalars['DateTime']['output']>;
  onInvoiceToPostedSeconds?: Maybe<Scalars['Float']['output']>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  postedToPaidSeconds?: Maybe<Scalars['Float']['output']>;
};

export type CompletionToPaymentSlowOrder = {
  __typename?: 'CompletionToPaymentSlowOrder';
  customerName: Scalars['String']['output'];
  longestInterval?: Maybe<CompletionToPaymentLongestInterval>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  secondsToPosted: Scalars['Float']['output'];
  terminalCode?: Maybe<Scalars['String']['output']>;
};

export enum CompletionToPaymentStage {
  CompleteNotFinalized = 'COMPLETE_NOT_FINALIZED',
  FinalizedNotPosted = 'FINALIZED_NOT_POSTED',
  NotComplete = 'NOT_COMPLETE',
  PostedNotPaid = 'POSTED_NOT_PAID'
}

export type CompletionToPaymentSummary = {
  __typename?: 'CompletionToPaymentSummary';
  byCustomer: Array<CompletionToPaymentGroup>;
  byTerminal: Array<CompletionToPaymentGroup>;
  completeToPaid: CompletionToPaymentDuration;
  completeToPosted: CompletionToPaymentDuration;
  flags: CompletionToPaymentFlags;
  intervals: Array<CompletionToPaymentIntervalDuration>;
  oldestUnpaid: Array<CompletionToPaymentUnpaidOrder>;
  orders: Scalars['Int']['output'];
  outliers: Array<CompletionToPaymentOutliers>;
  postedOrders: Scalars['Int']['output'];
  settledOrders: Scalars['Int']['output'];
  slowestToBill: Array<CompletionToPaymentSlowOrder>;
  timezone: Scalars['String']['output'];
  trend: CompletionToPaymentTrend;
  waiting: Array<CompletionToPaymentWaitingStage>;
};

export type CompletionToPaymentTrend = {
  __typename?: 'CompletionToPaymentTrend';
  points: Array<CompletionToPaymentTrendPoint>;
  unit: KpiTrendBucketUnit;
};

export type CompletionToPaymentTrendPoint = {
  __typename?: 'CompletionToPaymentTrendPoint';
  bucketDate: Scalars['String']['output'];
  completedOrders: Scalars['Int']['output'];
  countedOrders: Scalars['Int']['output'];
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
};

export type CompletionToPaymentUnpaidOrder = {
  __typename?: 'CompletionToPaymentUnpaidOrder';
  ageSeconds: Scalars['Float']['output'];
  customerName: Scalars['String']['output'];
  invoiceName: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  postedAt: Scalars['DateTime']['output'];
};

export type CompletionToPaymentWaitingStage = {
  __typename?: 'CompletionToPaymentWaitingStage';
  medianAgeSeconds?: Maybe<Scalars['Float']['output']>;
  orders: Scalars['Int']['output'];
  over30Days: Scalars['Int']['output'];
  over60Days: Scalars['Int']['output'];
  stage: CompletionToPaymentStage;
};

export type ConditionalServiceExplainEntity = {
  __typename?: 'ConditionalServiceExplainEntity';
  serviceId?: Maybe<Scalars['String']['output']>;
  share?: Maybe<Scalars['Float']['output']>;
  support?: Maybe<Scalars['Int']['output']>;
  verdict: Scalars['String']['output'];
};

/** Named bundles of company configuration that can be migrated. */
export enum ConfigMigrationFeatureGroup {
  Accessorials = 'ACCESSORIALS',
  ApiUsers = 'API_USERS',
  CompanySettings = 'COMPANY_SETTINGS',
  Integrations = 'INTEGRATIONS',
  Tariffs = 'TARIFFS',
  WarehousesTerminals = 'WAREHOUSES_TERMINALS'
}

export type ConfigMigrationReportObject = {
  __typename?: 'ConfigMigrationReportObject';
  allMatch: Scalars['Boolean']['output'];
  companyUuid: Scalars['String']['output'];
  dryRun: Scalars['Boolean']['output'];
  preImageBundleKey?: Maybe<Scalars['String']['output']>;
  source: MigrationEnv;
  sourceBundleKey: Scalars['String']['output'];
  tables: Array<ConfigMigrationTableReportObject>;
  target: MigrationEnv;
};

export type ConfigMigrationStatusObject = {
  __typename?: 'ConfigMigrationStatusObject';
  jobId: Scalars['String']['output'];
  report?: Maybe<ConfigMigrationReportObject>;
  state: Scalars['String']['output'];
};

export type ConfigMigrationTableReportObject = {
  __typename?: 'ConfigMigrationTableReportObject';
  insertedUuids: Array<Scalars['String']['output']>;
  matches: Scalars['Boolean']['output'];
  skipReason?: Maybe<Scalars['String']['output']>;
  sourceCount: Scalars['Int']['output'];
  tableName: Scalars['String']['output'];
  targetCount: Scalars['Int']['output'];
  updatedUuids: Array<Scalars['String']['output']>;
};

export type ConfirmInventoryCountLinesInput = {
  confirmations: Array<InventoryCountConfirmationInput>;
  inventoryCountUuid: Scalars['String']['input'];
};

export type ConfirmInventoryCountLinesOutput = BulkInventoryCountResultOutput | InventoryCountClosedOutput | MutationErrorOutput;

export type ConfirmQuoteAcceptanceInput = {
  /** The current draft amount the operator accepts in place of the quoted one after a price mismatch hold */
  acknowledgedCurrentAmountCents?: InputMaybe<Scalars['Int']['input']>;
  orderQuoteUuid: Scalars['String']['input'];
};

export type ConfirmQuoteAcceptanceOutput = ConfirmQuoteAcceptanceSuccessOutput | MutationErrorOutput | QuoteAcceptanceHeldOutput;

export type ConfirmQuoteAcceptanceSuccessOutput = {
  __typename?: 'ConfirmQuoteAcceptanceSuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
  orderUuid?: Maybe<Scalars['String']['output']>;
  status: OrderQuoteStatus;
};

export type ConsigneePortalOrderEntity = {
  __typename?: 'ConsigneePortalOrderEntity';
  companyTimezone?: Maybe<Scalars['String']['output']>;
  detailedStatus?: Maybe<OrderDetailedStatus>;
  isRefused: Scalars['Boolean']['output'];
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  packages?: Maybe<Array<PackageEntity>>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  shipments: Array<ConsigneePortalShipmentEntity>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  uuid: Scalars['String']['output'];
};

export type ConsigneePortalShipmentEntity = {
  __typename?: 'ConsigneePortalShipmentEntity';
  address?: Maybe<AddressEntity>;
  addressUuid?: Maybe<Scalars['String']['output']>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAtLocal?: Maybe<PlainDateTime>;
  /** If completedAtLocal is set, this field provides the time zone that was used to determine the local date and time. */
  completedAtLocalTimeZone?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  driverPlaceInRoute?: Maybe<Scalars['Float']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  /** @deprecated Use stopType instead */
  pickupOrDelivery?: Maybe<PickupOrDelivery>;
  placeInRoute?: Maybe<Scalars['Float']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeIsToday?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<StopStatus>;
  stopType?: Maybe<StopType>;
  /** The time zone the stop's times are shown in: the stop's own zone while terminal_local_times is on, else the zone of its ZIP code, else the company time zone. */
  timeZone?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ConsolidatableOrdersOutput = {
  __typename?: 'ConsolidatableOrdersOutput';
  error?: Maybe<FindConsolidatableOrdersError>;
  orders: Array<OrderEntity>;
  /** Only returned for orders with multiple addresses (more than one pickup/delivery) */
  shipments?: Maybe<Array<ShipmentEntity>>;
};

export type ConsolidatedOrderCreateInput = {
  shipmentUuid: Scalars['String']['input'];
};

export type ContactAccessorialChargeDetailsEntity = {
  __typename?: 'ContactAccessorialChargeDetailsEntity';
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  shipmentsWithAccessorialCount: Scalars['Float']['output'];
  totalAccessorialCharge: Scalars['Float']['output'];
};

export type ContactAndServicesCombination = {
  contactUuid: Scalars['String']['input'];
  serviceUuids: Array<Scalars['String']['input']>;
};

export type ContactChargeMatrixColumnMappingEntity = {
  __typename?: 'ContactChargeMatrixColumnMappingEntity';
  accessorial: AccessorialInterface;
  column: ChargeMatrixColumn;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactChargeMatrixColumnMappingInput = {
  accessorialUuid: Scalars['String']['input'];
  column: ChargeMatrixColumn;
};

export type ContactCommentEntity = {
  __typename?: 'ContactCommentEntity';
  authorName: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactCommunicationConfigCreateInput = {
  active: Scalars['Boolean']['input'];
  contactUuid: Scalars['String']['input'];
  sendAtHours: Scalars['Int']['input'];
  sendAtMinutes: Scalars['Int']['input'];
  type: ContactCommunicationType;
};

export type ContactCommunicationConfigEntity = {
  __typename?: 'ContactCommunicationConfigEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  sendAtHours: Scalars['Int']['output'];
  sendAtMinutes: Scalars['Int']['output'];
  type: ContactCommunicationType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactCommunicationConfigUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sendAtHours?: InputMaybe<Scalars['Int']['input']>;
  sendAtMinutes?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ContactCommunicationType>;
  uuid: Scalars['String']['input'];
};

export enum ContactCommunicationType {
  DailyOrdersCompleted = 'DAILY_ORDERS_COMPLETED',
  DailyOrdersNotOnHand = 'DAILY_ORDERS_NOT_ON_HAND',
  DailyOrdersOnHand = 'DAILY_ORDERS_ON_HAND',
  DailyOrdersScheduled = 'DAILY_ORDERS_SCHEDULED',
  PerAppointmentDateChanged = 'PER_APPOINTMENT_DATE_CHANGED',
  PerOrderCompleted = 'PER_ORDER_COMPLETED',
  PerOrderDriverOnSite = 'PER_ORDER_DRIVER_ON_SITE',
  PerOrderOutForDelivery = 'PER_ORDER_OUT_FOR_DELIVERY',
  PerOrderScheduled = 'PER_ORDER_SCHEDULED'
}

export type ContactConnection = {
  __typename?: 'ContactConnection';
  edges: Array<ContactEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ContactEdge = {
  __typename?: 'ContactEdge';
  cursor: Scalars['String']['output'];
  node: ContactEntity;
};

export type ContactEmailCreateInput = {
  contactUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
  type: ContactEmailType;
};

export type ContactEmailEntity = {
  __typename?: 'ContactEmailEntity';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  type: ContactEmailType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ContactEmailType {
  Invoice = 'INVOICE',
  OrderUpdate = 'ORDER_UPDATE'
}

export type ContactEntity = {
  accessorialGroupId?: Maybe<Scalars['String']['output']>;
  addresses: Array<AddressEntity>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment: Scalars['Boolean']['output'];
  apiName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay90: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay180: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay270: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay360: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay720: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPayAll: Scalars['Float']['output'];
  /** The customer balance for the contact in dollars */
  balance: Scalars['Float']['output'];
  billingContactEmail?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: Maybe<Scalars['Float']['output']>;
  billingPeriodDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  billingRunStart: Scalars['DateTime']['output'];
  businessDivision?: Maybe<BusinessDivisionEntity>;
  calculateInboundFreightCharges: Scalars['Boolean']['output'];
  calculateLineHaulFreightCharges: Scalars['Boolean']['output'];
  calculateOutboundFreightCharges: Scalars['Boolean']['output'];
  chargeMatrixColumnMappings: Array<ContactChargeMatrixColumnMappingEntity>;
  company: CompanyEntity;
  /** Returns at most 100 most-recent contact comments. Callers needing full enumeration must use a paginated query (TODO: expose contactCommentsConnection). */
  contactComments: Array<ContactCommentEntity>;
  contactOpenInvoiceValue: Scalars['Float']['output'];
  contactOpenInvoiceValue0to30d: Scalars['Float']['output'];
  contactOpenInvoiceValue31to38d: Scalars['Float']['output'];
  contactOpenInvoiceValue39to45d: Scalars['Float']['output'];
  contactOpenInvoiceValue46to60d: Scalars['Float']['output'];
  contactOpenInvoiceValue61to75d: Scalars['Float']['output'];
  contactOpenInvoiceValueOver75d: Scalars['Float']['output'];
  contactPersons: Array<ContactPersonEntity>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactStations: Array<ContactStationEntity>;
  contactStatistics: ContactStatsEntity;
  creditsAppliedToContactInvoices: Scalars['Float']['output'];
  customDunningReportFooter?: Maybe<Scalars['String']['output']>;
  customerAccessorials: Array<AccessorialUnion>;
  customerTariffs: Array<TariffEntity>;
  debitsAppliedToContactInvoices: Scalars['Float']['output'];
  defaultAddress?: Maybe<AddressEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  defaultEfmHandlingStation?: Maybe<Scalars['String']['output']>;
  defaultInvoiceTerms?: Maybe<InvoiceTermEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['output'];
  dimFactor: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  ediPartnership?: Maybe<EdiPartnershipEntity>;
  ediPartnerships: Array<EdiPartnershipEntity>;
  /** The tariff chain rating uses for each tariff type, in the order Ordinary, Line haul, Transfer, Recovery, Point to point: the contact's own chain, else the company default. A type with neither has no entry, and Recovery has none while the company has recovery tariffs off. */
  effectiveTariffChains: Array<EffectiveTariffChainEntity>;
  /** The contact's addresses on a SendGrid suppression list (bounce, invalid email or spam report). Emails to them are skipped. */
  emailSuppressions: Array<EmailSuppressionEntity>;
  emitPieceLevelWebhooks: Scalars['Boolean']['output'];
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This field no longer affects invoices and will be removed. */
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfColumns: Array<PdfColumnEntity>;
  invoiceTimePeriodSplit?: Maybe<TimePeriod>;
  invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName;
  isActive: Scalars['Boolean']['output'];
  isEfm?: Maybe<Scalars['Boolean']['output']>;
  isOverCreditLimit: Scalars['Boolean']['output'];
  isPrepaidOnly: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<DocumentEntity>;
  logoType?: Maybe<DocumentEntity>;
  masterAccount?: Maybe<MasterAccountEntity>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  /** Dollars of the contact credit memos taken up by debit memo offsets */
  offsetCredits: Scalars['Float']['output'];
  /** Dollars of the contact debit memos used to offset payments or credit memos */
  offsetDebits: Scalars['Float']['output'];
  /** Dollars of the contact payments taken up by debit memo offsets */
  offsetPayments: Scalars['Float']['output'];
  /** Returns at most 100 most-recent orders where this contact is the billing party. Callers needing full enumeration must use the paginated orders query (TODO: expose ordersConnection). */
  orders: Array<OrderEntity>;
  overdueInvoices: Array<InvoiceEntity>;
  paymentsAppliedToContactInvoices: Scalars['Float']['output'];
  /** Total closed balance across all posted invoices */
  postedInvoicesTotalClosedBalance: Scalars['Float']['output'];
  /** Total open balance across all posted invoices */
  postedInvoicesTotalOpenBalance: Scalars['Float']['output'];
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopContactId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId?: Maybe<Scalars['String']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['output'];
  requireScanToAdvancePieceStatusAtStops: Scalars['Boolean']['output'];
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  services: Array<ServiceEntity>;
  shortCode?: Maybe<Scalars['String']['output']>;
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  skipFuelCharge?: Maybe<Scalars['Boolean']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  tariffZones: Array<TariffZoneEntity>;
  /** @deprecated placeholder since the column was dropped from the table */
  thirdPartyContactType?: Maybe<ThirdPartyContactType>;
  totalCredits: Scalars['Float']['output'];
  totalDebits: Scalars['Float']['output'];
  totalInvoicesAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPostedInvoicesAmount: Scalars['Float']['output'];
  /** @deprecated Contact type is deprecated. The column has been dropped from the db */
  type: ContactType;
  unappliedCredits?: Maybe<Scalars['Float']['output']>;
  unappliedDebits: Scalars['Float']['output'];
  unappliedPayments: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};


export type ContactEntityContactOpenInvoiceValueArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue0to30dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue31to38dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue39to45dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue46to60dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue61to75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValueOver75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};

export type ContactForContactReport = {
  __typename?: 'ContactForContactReport';
  active: Scalars['Boolean']['output'];
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<Scalars['String']['output']>;
  businessDivision?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  creditLimit?: Maybe<Scalars['Float']['output']>;
  defaultInvoiceTransmissionMethod?: Maybe<Scalars['String']['output']>;
  defaultInvoiceType: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enableCreditHold: Scalars['Boolean']['output'];
  invoiceTimePeriodSplit?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  shortcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ContactPersonCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPersonEntity = {
  __typename?: 'ContactPersonEntity';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactPersonUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ContactPersonUpsertInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ContactStationCreateInput = {
  contactUuid: Scalars['String']['input'];
  isArchived: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ContactStationCreateOutput = ContactStationCreateSuccessOutput | MutationErrorOutput;

export type ContactStationCreateSuccessOutput = {
  __typename?: 'ContactStationCreateSuccessOutput';
  contactStation: ContactStationEntity;
};

export type ContactStationEntity = {
  __typename?: 'ContactStationEntity';
  defaultPerson?: Maybe<PersonEntity>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ContactStationUpdateInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPersonId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type ContactStationUpdateOutput = ContactStationUpdateSuccessOutput | MutationErrorOutput;

export type ContactStationUpdateSuccessOutput = {
  __typename?: 'ContactStationUpdateSuccessOutput';
  contactStation: ContactStationEntity;
};

export type ContactStatsEntity = {
  __typename?: 'ContactStatsEntity';
  numberOfFinalizedOrders: Scalars['Float']['output'];
  numberOfOrdersWithIssues: Scalars['Float']['output'];
  numberOfTotalOrders?: Maybe<Scalars['Float']['output']>;
  numberOfUnfinalizedOrders: Scalars['Float']['output'];
};

export type ContactToServicesTariffGroupMappingEntity = {
  __typename?: 'ContactToServicesTariffGroupMappingEntity';
  contact: ContactEntity;
  services: Array<ServiceEntity>;
  uuid: Scalars['String']['output'];
};

export enum ContactType {
  Customer = 'CUSTOMER',
  ThirdParty = 'THIRD_PARTY'
}

export type CoordinatesForAddressEntity = {
  __typename?: 'CoordinatesForAddressEntity';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  quality: GeocodeQuality;
};

export enum CostBasis {
  Benchmark = 'BENCHMARK',
  CostInputs = 'COST_INPUTS',
  NotSetUp = 'NOT_SET_UP'
}

/** Origin of the cost rates used for a cost center statement row. */
export enum CostCenterProfileSource {
  Benchmark = 'BENCHMARK',
  CostInputs = 'COST_INPUTS'
}

export type CostCenterStatementArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CostCenterStatementReportEntity = {
  __typename?: 'CostCenterStatementReportEntity';
  billingCollectingCostUsd: Scalars['Float']['output'];
  breakevenRevenueUsd?: Maybe<Scalars['Float']['output']>;
  breakevenShipmentCount?: Maybe<Scalars['Int']['output']>;
  contributionDollarsUsd: Scalars['Float']['output'];
  contributionMarginPct?: Maybe<Scalars['Float']['output']>;
  contributionPerDayUsd?: Maybe<Scalars['Float']['output']>;
  contributionPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  costBasis: CostBasis;
  dockCostUsd: Scalars['Float']['output'];
  dockLaborCostUsd?: Maybe<Scalars['Float']['output']>;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  fixedCostPerDayUsd?: Maybe<Scalars['Float']['output']>;
  fixedOverheadCostUsd: Scalars['Float']['output'];
  incomeAfterNonFreightUsd?: Maybe<Scalars['Float']['output']>;
  insuranceClaimsCostUsd: Scalars['Float']['output'];
  linehaulCostUsd: Scalars['Float']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  netRevenuePerDayUsd?: Maybe<Scalars['Float']['output']>;
  netRevenueUsd?: Maybe<Scalars['Float']['output']>;
  nonFreightCostUsd?: Maybe<Scalars['Float']['output']>;
  operatingIncomeUsd: Scalars['Float']['output'];
  operatingRatio?: Maybe<Scalars['Float']['output']>;
  outsideCarriersCostUsd?: Maybe<Scalars['Float']['output']>;
  pdLaborCostUsd?: Maybe<Scalars['Float']['output']>;
  percentOfBreakeven?: Maybe<Scalars['Float']['output']>;
  pickupDeliveryCostUsd: Scalars['Float']['output'];
  revenuePerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  revenueSharedWithAgentsUsd?: Maybe<Scalars['Float']['output']>;
  revenueUsd: Scalars['Float']['output'];
  shipmentCount: Scalars['Int']['output'];
  status?: Maybe<CostCenterStatementStatus>;
  terminals: Array<CostCenterStatementRowEntity>;
  totalVariableCostUsd: Scalars['Float']['output'];
  truckCostUsd?: Maybe<Scalars['Float']['output']>;
  usesBenchmarkDefaults: Scalars['Boolean']['output'];
  variableCostPctOfRevenue?: Maybe<Scalars['Float']['output']>;
  variableCostPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  workdays?: Maybe<Scalars['Float']['output']>;
};

export type CostCenterStatementRowEntity = {
  __typename?: 'CostCenterStatementRowEntity';
  billingCollectingCostUsd: Scalars['Float']['output'];
  breakevenRevenueUsd?: Maybe<Scalars['Float']['output']>;
  contributionDollarsUsd: Scalars['Float']['output'];
  contributionMarginPct?: Maybe<Scalars['Float']['output']>;
  contributionPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  dockCostUsd: Scalars['Float']['output'];
  fixedOverheadCostUsd: Scalars['Float']['output'];
  insuranceClaimsCostUsd: Scalars['Float']['output'];
  linehaulCostUsd: Scalars['Float']['output'];
  operatingIncomeUsd: Scalars['Float']['output'];
  operatingRatio?: Maybe<Scalars['Float']['output']>;
  percentOfBreakeven?: Maybe<Scalars['Float']['output']>;
  pickupDeliveryCostUsd: Scalars['Float']['output'];
  profileSource: CostCenterProfileSource;
  revenuePerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  revenueUsd: Scalars['Float']['output'];
  shipmentCount: Scalars['Int']['output'];
  status?: Maybe<CostCenterStatementStatus>;
  terminalCode?: Maybe<Scalars['String']['output']>;
  terminalName: Scalars['String']['output'];
  terminalUuid?: Maybe<Scalars['String']['output']>;
  totalVariableCostUsd: Scalars['Float']['output'];
  variableCostPctOfRevenue?: Maybe<Scalars['Float']['output']>;
  variableCostPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
};

/** Where a terminal or the company sits relative to its breakeven revenue. */
export enum CostCenterStatementStatus {
  AboveBreakeven = 'ABOVE_BREAKEVEN',
  BelowBreakeven = 'BELOW_BREAKEVEN',
  NearBreakeven = 'NEAR_BREAKEVEN'
}

export enum CostInputCadence {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

export type CostInputDefinitionEntity = {
  __typename?: 'CostInputDefinitionEntity';
  cadence: CostInputCadence;
  field: CostInputField;
  group: CostInputGroup;
  howToFill: Scalars['String']['output'];
  label: Scalars['String']['output'];
  quickbooksMappable: Scalars['Boolean']['output'];
  sources: Array<CostInputSource>;
  unit: CostInputUnit;
  whereToFind: Scalars['String']['output'];
};

export type CostInputEntryInput = {
  field: CostInputField;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type CostInputEstimatedMonthEntity = {
  __typename?: 'CostInputEstimatedMonthEntity';
  items: Array<Scalars['String']['output']>;
  month: Scalars['String']['output'];
};

/** One cost of the Intelligence Board cost inputs. Labels, units and sources live in the cost inputs catalogue. */
export enum CostInputField {
  BreakdownsTowingAccidents = 'BREAKDOWNS_TOWING_ACCIDENTS',
  CargoInsurance = 'CARGO_INSURANCE',
  CombinedWages = 'COMBINED_WAGES',
  DamageClaimsPaid = 'DAMAGE_CLAIMS_PAID',
  Depreciation = 'DEPRECIATION',
  DockPaidHours = 'DOCK_PAID_HOURS',
  DockWages = 'DOCK_WAGES',
  DockWarehouseExpenses = 'DOCK_WAREHOUSE_EXPENSES',
  DriverMeetingHours = 'DRIVER_MEETING_HOURS',
  DrugScreensHiring = 'DRUG_SCREENS_HIRING',
  EmployerPayrollTaxes = 'EMPLOYER_PAYROLL_TAXES',
  Forklifts = 'FORKLIFTS',
  Fuel = 'FUEL',
  FuelTaxesIfta = 'FUEL_TAXES_IFTA',
  GeneralLiabilityInsurance = 'GENERAL_LIABILITY_INSURANCE',
  HealthInsurance = 'HEALTH_INSURANCE',
  HelperWages = 'HELPER_WAGES',
  LinehaulCarriers = 'LINEHAUL_CARRIERS',
  LocalCarriersAgents = 'LOCAL_CARRIERS_AGENTS',
  OfficeWages = 'OFFICE_WAGES',
  OtherOfficeAdmin = 'OTHER_OFFICE_ADMIN',
  PdDriverHoursOnDock = 'PD_DRIVER_HOURS_ON_DOCK',
  PdDriverHoursOnLinehaul = 'PD_DRIVER_HOURS_ON_LINEHAUL',
  PdDriverPaidHours = 'PD_DRIVER_PAID_HOURS',
  PdDriverWages = 'PD_DRIVER_WAGES',
  RegistrationsPermits = 'REGISTRATIONS_PERMITS',
  Rent = 'RENT',
  RepairsMaintenance = 'REPAIRS_MAINTENANCE',
  RetirementMatch = 'RETIREMENT_MATCH',
  RevenueSharedWithAgents = 'REVENUE_SHARED_WITH_AGENTS',
  ServiceFailureRefunds = 'SERVICE_FAILURE_REFUNDS',
  TelematicsSoftware = 'TELEMATICS_SOFTWARE',
  TempLabor = 'TEMP_LABOR',
  Tires = 'TIRES',
  Tolls = 'TOLLS',
  TotalMiles = 'TOTAL_MILES',
  TrailerLeaseRental = 'TRAILER_LEASE_RENTAL',
  TruckInsurance = 'TRUCK_INSURANCE',
  TruckLeaseRental = 'TRUCK_LEASE_RENTAL',
  Utilities = 'UTILITIES',
  Workdays = 'WORKDAYS',
  WorkersComp = 'WORKERS_COMP'
}

export enum CostInputGroup {
  Building = 'BUILDING',
  Calendar = 'CALENDAR',
  Carriers = 'CARRIERS',
  Insurance = 'INSURANCE',
  Labor = 'LABOR',
  NonFreight = 'NON_FREIGHT',
  Trucks = 'TRUCKS'
}

export type CostInputMonthArgs = {
  includeReports?: InputMaybe<Scalars['Boolean']['input']>;
  month: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CostInputMonthEntity = {
  __typename?: 'CostInputMonthEntity';
  isOpenMonth: Scalars['Boolean']['output'];
  month: Scalars['String']['output'];
  rates?: Maybe<CostInputRatesEntity>;
  reports: Array<CostInputReportReadinessEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  values: Array<CostInputValueEntity>;
};

export type CostInputQuickbooksAccountEntity = {
  __typename?: 'CostInputQuickbooksAccountEntity';
  accountName: Scalars['String']['output'];
  field?: Maybe<CostInputField>;
  isMapped: Scalars['Boolean']['output'];
  isParentAccount: Scalars['Boolean']['output'];
  quickbooksAccountId: Scalars['String']['output'];
  recentTotalUsd: Scalars['Float']['output'];
  sectionPath: Scalars['String']['output'];
};

export type CostInputQuickbooksMappingInput = {
  field?: InputMaybe<CostInputField>;
  quickbooksAccountId: Scalars['String']['input'];
};

export type CostInputRatesEntity = {
  __typename?: 'CostInputRatesEntity';
  breakevenContributionRatio?: Maybe<Scalars['Float']['output']>;
  dockCostPerHourUsd?: Maybe<Scalars['Float']['output']>;
  dockLaborUsd: Scalars['Float']['output'];
  fixedCostPerDayUsd?: Maybe<Scalars['Float']['output']>;
  fixedCostUsd: Scalars['Float']['output'];
  insuranceClaimsUsd: Scalars['Float']['output'];
  nonFreightCostUsd: Scalars['Float']['output'];
  operationsBenefitsSharePct?: Maybe<Scalars['Float']['output']>;
  outsideCarriersUsd: Scalars['Float']['output'];
  pdCostPerHourUsd?: Maybe<Scalars['Float']['output']>;
  pdLaborUsd: Scalars['Float']['output'];
  truckCostPerMileUsd?: Maybe<Scalars['Float']['output']>;
  truckCostUsd: Scalars['Float']['output'];
  variableCostPerDayUsd?: Maybe<Scalars['Float']['output']>;
  variableCostUsd: Scalars['Float']['output'];
};

export type CostInputReportReadinessEntity = {
  __typename?: 'CostInputReportReadinessEntity';
  hasCosts: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  missing: Array<Scalars['String']['output']>;
};

export enum CostInputSource {
  Quickbooks = 'QUICKBOOKS',
  Samsara = 'SAMSARA',
  Tenet = 'TENET',
  Typed = 'TYPED'
}

export type CostInputStatusEntity = {
  __typename?: 'CostInputStatusEntity';
  driverWageSplitPct?: Maybe<Scalars['Float']['output']>;
  quickbooksConnected: Scalars['Boolean']['output'];
  quickbooksLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  quickbooksMatchedAccountCount: Scalars['Int']['output'];
  quickbooksUnmatchedAccountCount: Scalars['Int']['output'];
  truckLeasePerMilePct?: Maybe<Scalars['Float']['output']>;
};

export enum CostInputUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Miles = 'MILES',
  Usd = 'USD'
}

export type CostInputValueEntity = {
  __typename?: 'CostInputValueEntity';
  field: CostInputField;
  quickbooksValue?: Maybe<Scalars['Float']['output']>;
  samsaraValue?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<CostInputSource>;
  tenetValue?: Maybe<Scalars['Float']['output']>;
  typedAt?: Maybe<Scalars['DateTime']['output']>;
  typedByName?: Maybe<Scalars['String']['output']>;
  typedValue?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CoverSheetDocumentTypeSequenceCreateInput = {
  documentTypes: Array<DocumentType>;
  name: Scalars['String']['input'];
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  type: CoverSheetDocumentTypeSequenceType;
};

export type CoverSheetDocumentTypeSequenceEntity = {
  __typename?: 'CoverSheetDocumentTypeSequenceEntity';
  documentTypes: Array<DocumentType>;
  name: Scalars['String']['output'];
  type: CoverSheetDocumentTypeSequenceType;
  uuid: Scalars['String']['output'];
};

export enum CoverSheetDocumentTypeSequenceType {
  Record = 'RECORD',
  Template = 'TEMPLATE'
}

export type CoverSheetDocumentTypeSequenceUpdateInput = {
  documentTypes?: InputMaybe<Array<DocumentType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<CoverSheetDocumentTypeSequenceType>;
  uuid: Scalars['String']['input'];
};

export type CreateAccessorialContactInput = {
  accessorialUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
};

export type CreateAccessorialContactOutput = {
  __typename?: 'CreateAccessorialContactOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateAccessorialDateRangeConfigInput = {
  accessorialDateRangeConfigToCopyUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialRangeCreateInputs?: InputMaybe<Array<AccessorialRangeCreateInput>>;
  accessorialUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  /** Accepts rate as a $ float with two decimal places */
  rateUsd?: InputMaybe<Scalars['Float']['input']>;
  specialChargeGroupCreateInputs?: InputMaybe<Array<SpecialAccessorialChargeGroupCreateInput>>;
  specialMatrixItemsCreateInputs?: InputMaybe<Array<SpecialAccessorialMatrixItemCreateInput>>;
  startDate: Scalars['DateTime']['input'];
};

export type CreateAccessorialDateRangeConfigOutput = {
  __typename?: 'CreateAccessorialDateRangeConfigOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateAccessorialGroupInput = {
  /** UUIDs of the accessorials that make up this group. */
  accessorialUuids: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAccessorialInput = {
  accessorialCreateInput: AccessorialCreateInput;
};

export type CreateAccountingReportDocumentOutput = {
  __typename?: 'CreateAccountingReportDocumentOutput';
  document: DocumentEntity;
};

export type CreateAddressInput = {
  addressCreateInput: AddressCreateInput;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAirportInfoInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  iataCode?: InputMaybe<Scalars['String']['input']>;
  terminal: Scalars['String']['input'];
};

export type CreateApiUserInput = {
  apiUserCreateInput: ApiUserCreateInput;
};

export type CreateAutoApplyAccessorialConfigInput = {
  /** @deprecated Use accessorialUuids instead */
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  addresses?: InputMaybe<Array<AutoApplyAccessorialConfigAddressInput>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactsToExcludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactsToIncludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleType: AutoApplyAccessorialRuleType;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopType?: InputMaybe<PickupOrDelivery>;
  tagUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateBasicDocumentInput = {
  companyUuid: Scalars['String']['input'];
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBusinessDivisionInput = {
  name: Scalars['String']['input'];
};

export type CreateBusinessDivisionOutput = {
  __typename?: 'CreateBusinessDivisionOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateCompanyInput = {
  alternateIsaId?: InputMaybe<Scalars['String']['input']>;
  alternateStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  blockSendingZeroDollarInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  companyLandscapeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  companySquareLogoUrl?: InputMaybe<Scalars['String']['input']>;
  /** A JSON object that represents the set of configurations for the company */
  configs?: InputMaybe<Scalars['String']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customDunningReportHeader?: InputMaybe<Scalars['String']['input']>;
  defaultAddressCreateInput: AddressCreateInput;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultMeasurementUnits: MeasurementUnits;
  defaultNonCompanyDriverSettlementMode: SettlementMode;
  defaultOrdinarySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoverySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultWeightUnits: WeightUnits;
  ediPodFilenamePrefix?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateScac?: InputMaybe<Scalars['String']['input']>;
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  freightSnapId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  isCourier?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderNameOrdinal?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  purchasedProductOfferings?: InputMaybe<Array<PalletProductOffering>>;
  qbInvoiceNumberStart?: InputMaybe<Scalars['Float']['input']>;
  qboDefaultClassId?: InputMaybe<Scalars['String']['input']>;
  qboDefaultIncomeAccountId?: InputMaybe<Scalars['String']['input']>;
  qboDefaultTaxCodeId?: InputMaybe<Scalars['String']['input']>;
  qboFreightItemId?: InputMaybe<Scalars['String']['input']>;
  qboFuelItemId?: InputMaybe<Scalars['String']['input']>;
  qboLineHaulItemId?: InputMaybe<Scalars['String']['input']>;
  quickbooksCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccessorialId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopDeliveryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopFuelChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopLineHaulId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopOrderChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopPickupId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopRecoveryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopTransferId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingAccessorialChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  secondAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateScac?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This field is being removed. Setting this will have no effect. */
  segment?: InputMaybe<Segment>;
  sendgridSenderId?: InputMaybe<Scalars['String']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateScac?: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
  useSageBusinessWorks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateConsolidatedOrderFromOrderInput = {
  orderUuid: Scalars['String']['input'];
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConsolidatedOrderInput = {
  consolidatedOrderCreateInput: ConsolidatedOrderCreateInput;
};

export type CreateContactCommentInput = {
  comment: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

export type CreateContactCommunicationConfigInput = {
  contactCommunicationConfigCreateInput: ContactCommunicationConfigCreateInput;
};

export type CreateContactDocumentInput = {
  contactUuid: Scalars['String']['input'];
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactEmailInput = {
  contactEmailCreateInput: ContactEmailCreateInput;
};

export type CreateContactPersonInput = {
  contactPersonCreateInput: ContactPersonCreateInput;
  contactUuid: Scalars['String']['input'];
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactToServicesMappingInput = {
  contactUuid: Scalars['String']['input'];
  serviceUuids: Array<Scalars['String']['input']>;
};

export type CreateCsvOrderFieldMappingInput = {
  csvOrderMappingUuid: Scalars['String']['input'];
  sourceColumnName: Scalars['String']['input'];
  targetFieldType: CsvOrderMappingTargetFieldType;
};

export type CreateCsvOrderImportTransactionInput = {
  bucket: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  key: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  /** The raw, comma-separated string contents of the CSV row */
  row: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  status: CsvOrderImportTransactionStatus;
};

export type CreateCsvOrderMappingInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  csvOrderFieldMappingCreateInputs?: InputMaybe<Array<CreateCsvOrderFieldMappingInput>>;
  deadlineDateDefaultValue?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTypeDefaultValue?: InputMaybe<DeadlineType>;
  enableDynamicInboundOrOutboundStop: Scalars['Boolean']['input'];
  enableInboundStop: Scalars['Boolean']['input'];
  enableOutboundStop: Scalars['Boolean']['input'];
  freightBillingMethodDefaultValue?: InputMaybe<FreightBillingMethod>;
  name: Scalars['String']['input'];
  pickupOrDeliveryDefaultValue?: InputMaybe<PickupOrDelivery>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopImportType: StopImportType;
  stopTypeDefaultValue?: InputMaybe<StandardStopType>;
};

export type CreateCsvOrdersOrderInput = {
  billingPartyContactUuid: Scalars['String']['input'];
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  freightChargeRate?: InputMaybe<Scalars['Float']['input']>;
  freightChargeType?: InputMaybe<FreightBillingMethod>;
  fuelChargeType?: InputMaybe<FuelBillingMethod>;
  fuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  inboundStop?: InputMaybe<ParsedCsvOrderStopInput>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundStop?: InputMaybe<ParsedCsvOrderStopInput>;
  packages: Array<CreateCsvOrdersPackageInput>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** A package that is either parsed from a CSV file or from an order part of an order that was detected in a parsed CSV file */
export type CreateCsvOrdersPackageInput = {
  class?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  freightClass?: InputMaybe<FreightClass>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** A flag that is set to true if the parsed package is one that needs to be appended to the order packages */
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  packageSpecId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  type?: InputMaybe<PackageType>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCustomerContactInput = {
  customerContactCreateInput: CustomerContactCreateInput;
};

export type CreateCustomerContactsInput = {
  customerContactCreateInputs: Array<CustomerContactCreateInput>;
};

export type CreateCustomerContactsOutput = {
  __typename?: 'CreateCustomerContactsOutput';
  customerContacts: Array<CustomerContactEntity>;
};

export type CreateDocExtractionEvalRunInput = {
  config: Scalars['JSON']['input'];
  evalSetId: Scalars['String']['input'];
  executionMode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDocExtractionEvalSetInput = {
  config: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
};

export type CreateDocumentInput = {
  documentCreateInput: DocumentCreateInput;
};

export type CreateDriverCredentialTypeInput = {
  kind: DriverCredentialKind;
  name: Scalars['String']['input'];
};

export type CreateDriverInput = {
  driverCreateInput: DriverCreateInput;
};

export type CreateDriverInsurancePolicyInput = {
  carrierName?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  /** YYYY-MM-DD */
  effectiveOn: Scalars['String']['input'];
  /** YYYY-MM-DD */
  expiresOn: Scalars['String']['input'];
  insuranceType: Scalars['String']['input'];
  insuredAmountUsd?: InputMaybe<Scalars['Float']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDriverSettlementBillInput = {
  driverSettlementBillCreateInput: DriverSettlementBillCreateInput;
};

export type CreateDriverSignableFormTemplateInput = {
  formText: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateDriverTrainingRecordInput = {
  /** YYYY-MM-DD */
  completedOn?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  /** YYYY-MM-DD */
  expiresOn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** A TRAINING credential type. */
  typeUuid: Scalars['String']['input'];
};

export type CreateDriversInput = {
  driverCreateInputs: Array<DriverCreateInput>;
};

export type CreateDriversOutput = {
  __typename?: 'CreateDriversOutput';
  drivers: Array<DriverEntity>;
};

export type CreateDuplicateOrderForRebillInput = {
  newContactUuid: Scalars['String']['input'];
  originalOrderUuid: Scalars['String']['input'];
};

export type CreateDuplicateOrderForRebillOutput = {
  __typename?: 'CreateDuplicateOrderForRebillOutput';
  duplicatedOrder: OrderEntity;
};

export type CreateDwellTimeAlertConfigInput = {
  /** Customer (contact) this override applies to. Null = all customers. */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Whether the config participates in alerting. Defaults to true. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The dwell-time limit, in calendar days, beyond which on-dock freight is flagged. */
  thresholdDays: Scalars['Int']['input'];
  /** Warehouse this override applies to. Null = all warehouses. */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEdiPartnershipInput = {
  allowEditingShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  alternateStediPartnerId?: InputMaybe<Scalars['String']['input']>;
  autoAcceptOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canCreateMultipleStops?: InputMaybe<Scalars['Boolean']['input']>;
  companyStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  edi214ShipmentStatuses?: InputMaybe<Array<Edi214ShipmentStatus>>;
  ediOutboundPayloadDestination?: InputMaybe<EdiOutboundPayloadDestination>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  excludeZeroChargeInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreCancellations?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreNonEdiOutbound?: InputMaybe<Scalars['Boolean']['input']>;
  includeItemizedChargesIn210?: InputMaybe<Scalars['Boolean']['input']>;
  includeOutboundFilenameReceiverIsaId?: InputMaybe<Scalars['Boolean']['input']>;
  mergeLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFilenameScacPrefix?: InputMaybe<Scalars['Boolean']['input']>;
  removeSpacesFrom214Bol?: InputMaybe<Scalars['Boolean']['input']>;
  requireGenerateEdi210Ids?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo204?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo211?: InputMaybe<Scalars['Boolean']['input']>;
  sendBackupDocs?: InputMaybe<Scalars['Boolean']['input']>;
  stedi210MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi210TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi214MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi214TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi990MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi990TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stediPartnershipId?: InputMaybe<Scalars['String']['input']>;
  tiffPodUpload?: InputMaybe<Scalars['Boolean']['input']>;
  timeOfPodUpload?: InputMaybe<TimeOfPodUpload>;
  useStediGenerateEdiFunction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEdiPartnershipServiceMappingsInput = {
  ediPartnershipServiceMappingCreateInputs: Array<EdiPartnershipServiceMappingCreateInput>;
  ediPartnershipUuid: Scalars['String']['input'];
};

export type CreateEdiPartnershipServiceMappingsOutput = {
  __typename?: 'CreateEdiPartnershipServiceMappingsOutput';
  ediPartnershipServiceMappings: Array<EdiPartnershipServiceMappingEntity>;
  /** Service names in the input that match no service the partnership customer can use; those mappings were not written. */
  unmatchedServiceNames: Array<Scalars['String']['output']>;
};

export type CreateEdiTransactionInput = {
  code: EdiTransactionCode;
  edi210NetAmountDueCents?: InputMaybe<Scalars['Int']['input']>;
  edi214ShipmentStatus?: InputMaybe<Edi214ShipmentStatus>;
  edi990ActionCode?: InputMaybe<Edi990ActionCode>;
  ediPayloadId?: InputMaybe<Scalars['String']['input']>;
  hawb?: InputMaybe<Scalars['String']['input']>;
  ignoreInAudit?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
  purposeCode?: InputMaybe<EdiTransactionPurposeCode>;
  receiverIsaId: Scalars['String']['input'];
  senderIsaId: Scalars['String']['input'];
};

export type CreateEdiTransactionOutput = {
  __typename?: 'CreateEdiTransactionOutput';
  ediTransaction: EdiTransactionEntity;
};

export type CreateEmailTransactionInput = {
  contactUuid: Scalars['String']['input'];
  documentUuid: Scalars['String']['input'];
  emailResponse?: InputMaybe<Scalars['String']['input']>;
  emailResponseStatus?: InputMaybe<Scalars['Int']['input']>;
  emails: Array<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  sendgridMessageId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmailTransactionOutput = {
  __typename?: 'CreateEmailTransactionOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateEndOfDayDocumentProcessingJobInput = {
  companyUuid: Scalars['String']['input'];
  dateUploadedFor: Scalars['DateTime']['input'];
  status: EndOfDayDocumentsProcessingJobStatus;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadedFileName: Scalars['String']['input'];
};

export type CreateEodDocumentsInput = {
  /** A flag that determines whether the EOD documents should be automatched to the orders */
  autoMatchingEnabled: Scalars['Boolean']['input'];
  documentCreateInputs: Array<EodDocumentCreateInput>;
  /** The UUID of the job associated with the original EOD document that was uploaded. */
  endOfDayDocumentsProcessingJobUuid: Scalars['String']['input'];
};

export type CreateEquipmentInput = {
  /** Contains equipment details */
  equipmentCreateInput: EquipmentCreateInput;
};

export type CreateEquipmentLicenseInput = {
  equipmentLicenseCreateInput: EquipmentLicenseCreateInput;
  /** UUID of the equipment this license will be associated with */
  equipmentUuid: Scalars['String']['input'];
};

export type CreateEquipmentsInput = {
  equipmentCreateInputs: Array<EquipmentCreateInput>;
};

export type CreateEquipmentsOutput = {
  __typename?: 'CreateEquipmentsOutput';
  equipments: Array<EquipmentEntity>;
};

export type CreateFeatureFlagCompanyOverrideInput = {
  active: Scalars['Boolean']['input'];
  companyUuid: Scalars['String']['input'];
  featureFlagUuid: Scalars['String']['input'];
};

export type CreateFeatureFlagInput = {
  featureFlagCreateInput: FeatureFlagCreateInput;
};

export type CreateFeatureFlagUserOverrideInput = {
  active: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  featureFlagUuid: Scalars['String']['input'];
};

export type CreateFreightChargeInput = {
  freightChargeCreateInput: FreightChargeCreateInput;
  shipmentUuid: Scalars['String']['input'];
};

export type CreateFuelProfileDateRangeInput = {
  expirationDate: Scalars['DateTime']['input'];
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  fuelProfileUuid: Scalars['String']['input'];
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  startDate: Scalars['DateTime']['input'];
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateFuelProfileDateRangeOutput = {
  __typename?: 'CreateFuelProfileDateRangeOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateFuelProfileInput = {
  billingType: FuelBillingMethod;
  expirationDate: Scalars['DateTime']['input'];
  flatRateUsdCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  surchargeRate: Scalars['Float']['input'];
  type: FuelProfileType;
};

export type CreateGeneralLedgerCodeOutput = CreateGeneralLedgerCodeSuccessOutput | MutationErrorOutput;

export type CreateGeneralLedgerCodeSuccessOutput = {
  __typename?: 'CreateGeneralLedgerCodeSuccessOutput';
  generalLedgerCode: GeneralLedgerCodeEntity;
};

export type CreateIngestionTestUploadInput = {
  companyUuid: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
};

export type CreateInventoryItemsInput = {
  itemUuid: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  /** Dictates if a new storage unit should be created. if a storageUnitUuid is supplied it will take priority */
  shouldCreateStorageUnit?: InputMaybe<Scalars['Boolean']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  /** The storage unit to associate the inventory items with, if provided */
  storageUnitUuid?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure: UnitOfMeasure;
};

export type CreateInventoryItemsOutput = {
  __typename?: 'CreateInventoryItemsOutput';
  /** The number of inventory items that were created */
  quantity: Scalars['Int']['output'];
  /** The storage unit that the items were added to, if any */
  storageUnit?: Maybe<StorageUnitEntity>;
};

export type CreateInventoryPrimaryUnitOfMeasureInput = {
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInventorySecondaryUnitOfMeasureInput = {
  primaryUnitsPerSecondaryUOM?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  invoiceUuid: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceDocumentsInput = {
  createInvoiceDocumentInputs: Array<CreateInvoiceDocumentInput>;
};

export type CreateInvoiceInput = {
  invoiceCreateInput: InvoiceCreateInput;
};

export type CreateInvoiceTermsForAllInput = {
  terms: Array<Scalars['String']['input']>;
};

export type CreateItemInput = {
  contactUuid: Scalars['String']['input'];
  createInventoryPrimaryUnitOfMeasureInput: CreateInventoryPrimaryUnitOfMeasureInput;
  createInventorySecondaryUnitOfMeasureInput?: InputMaybe<CreateInventorySecondaryUnitOfMeasureInput>;
  createItemStorageUnitConfigInput?: InputMaybe<CreateItemStorageUnitConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  productCost?: InputMaybe<Scalars['Float']['input']>;
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
  sku: Scalars['String']['input'];
  status: ItemStatus;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateItemLocationInput = {
  name: Scalars['String']['input'];
};

export type CreateItemLocationOutput = {
  __typename?: 'CreateItemLocationOutput';
  /** The item location that was created. It is null in the case a location with a duplicate name w.r.t to the company is passed in */
  itemLocation?: Maybe<ItemLocationEntity>;
};

export type CreateItemOutput = {
  __typename?: 'CreateItemOutput';
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<ItemEntity>;
};

export type CreateItemStorageUnitConfigInput = {
  consolidationUnitUOM: UnitOfMeasure;
  dimensionsUOM: WarehouseMeasurementUnits;
  height: Scalars['Float']['input'];
  high: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  primaryUnitsPerConsolidationUnit: Scalars['Float']['input'];
  tie: Scalars['Float']['input'];
  type: MeasurementUnits;
  weight: Scalars['Float']['input'];
  weightUOM: WarehouseMeasurementUnits;
  width: Scalars['Float']['input'];
};

export type CreateLegDriverMapInput = {
  legDriverMapCreateInput: LegDriverMapCreateInput;
};

export type CreateLegInput = {
  legCreateInput: LegCreateInput;
  /** The order of this leg relative to other legs in the same shipment */
  ordinal: Scalars['Int']['input'];
  shipmentUuid: Scalars['String']['input'];
};

export type CreateLineHaulLaneInput = {
  lineHaulLaneCreateInput: LineHaulLaneCreateInput;
};

export type CreateLineHaulLaneOutput = {
  __typename?: 'CreateLineHaulLaneOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
};

export type CreateLineHaulManifestInput = {
  lineHaulManifestCreateInput: LineHaulManifestCreateInput;
};

export type CreateLineHaulManifestsInput = {
  /** The service day as a bare YYYY-MM-DD (its noon-UTC marker is also accepted). Not an arbitrary instant - a value carrying another time of day is read on its UTC date and will land on the wrong day for companies behind UTC. */
  departDate: Scalars['String']['input'];
  lanes: Array<CreateLineHaulManifestsLaneInput>;
};

export type CreateLineHaulManifestsLaneInput = {
  count: Scalars['Int']['input'];
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type CreateLineHaulManifestsOutput = CreateLineHaulManifestsSuccessOutput | MutationErrorOutput;

export type CreateLineHaulManifestsSuccessOutput = {
  __typename?: 'CreateLineHaulManifestsSuccessOutput';
  lineHaulManifests: Array<LineHaulManifestEntity>;
};

export type CreateLineHaulSegmentInput = {
  lineHaulSegmentCreateInput: LineHaulSegmentCreateInput;
};

export type CreateLineHaulSegmentOutput = {
  __typename?: 'CreateLineHaulSegmentOutput';
  segment: LineHaulSegmentEntity;
};

export type CreateMasterAccountInput = {
  name: Scalars['String']['input'];
};

export type CreateMasterAccountOutput = {
  __typename?: 'CreateMasterAccountOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateMirrorTargetInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique environment name, e.g. "staging", "release", "dev". */
  name: Scalars['String']['input'];
  subscribesToAllCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Base URL of the target backend, e.g. https://api.staging.example.com */
  url: Scalars['String']['input'];
};

export type CreateNotificationInput = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverMarkedAttemptedDriverUuid?: InputMaybe<Scalars['String']['input']>;
  driverMarkedAttemptedStopUuid?: InputMaybe<Scalars['String']['input']>;
  emailTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  sourceDriverUuid?: InputMaybe<Scalars['String']['input']>;
  targetAccessorialUuid?: InputMaybe<Scalars['String']['input']>;
  targetStopUuid?: InputMaybe<Scalars['String']['input']>;
  type: NotificationType;
};

export type CreateOptimizationRunDto = {
  optimizationType?: InputMaybe<Scalars['String']['input']>;
  pinnedSlotUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
  /** @deprecated infers start address from routeUuid now */
  startAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateCsvOrdersInput = {
  /** The parsed CSV orders that have to be created */
  createOrders: Array<CreateCsvOrdersOrderInput>;
  /** The parsed CSV orders that have to be updated with new packages */
  updateOrders: Array<UpdateCsvOrdersOrderInput>;
};

export type CreateOrUpdateCsvOrdersOutput = CreateOrUpdateCsvOrdersSuccessOutput | MutationErrorOutput;

export type CreateOrUpdateCsvOrdersSuccessOutput = {
  __typename?: 'CreateOrUpdateCsvOrdersSuccessOutput';
  /** The orders that were either created or updated by the CSV file */
  orders: Array<OrderEntity>;
};

/** This is the graphql input for creating or updating a customer */
export type CreateOrUpdateCustomerInput = {
  accessorialGroupId?: InputMaybe<Scalars['String']['input']>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment?: InputMaybe<Scalars['Boolean']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  calculateInboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateLineHaulFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateOutboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  customerPortalChargesVisibleFrom?: InputMaybe<CustomerPortalChargesVisibility>;
  defaultAddressUuid?: InputMaybe<Scalars['String']['input']>;
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  defaultFreightBillingMethod?: InputMaybe<FreightBillingMethod>;
  defaultFreightClass?: InputMaybe<FreightClass>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultUseTariff: Scalars['Boolean']['input'];
  displayChargesInCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  duplicateOrderMergeWindowHours?: InputMaybe<Scalars['Int']['input']>;
  enableCustomerPortalInventory?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomerPortalOrderEntry: Scalars['Boolean']['input'];
  includeInExpeditorsScorecard?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceOrOrderIdentifier: Scalars['String']['input'];
  isPrepaidOnly: Scalars['Boolean']['input'];
  referenceNumberLabels: Array<Scalars['String']['input']>;
  serviceGroupId?: InputMaybe<Scalars['String']['input']>;
  serviceUuids: Array<Scalars['String']['input']>;
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['input'];
  useCustomVehicleTypes: Scalars['Boolean']['input'];
  vehicleTypeUuids: Array<Scalars['String']['input']>;
};

export type CreateOrUpdateSettlementAdjustmentOutput = CreateOrUpdateSettlementAdjustmentSuccessOutput | MutationErrorOutput;

export type CreateOrUpdateSettlementAdjustmentSuccessOutput = {
  __typename?: 'CreateOrUpdateSettlementAdjustmentSuccessOutput';
  settlementAdjustment: SettlementAdjustmentEntity;
};

export type CreateOrderCommentInput = {
  comment: Scalars['String']['input'];
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  showOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOrderDelegationRuleInput = {
  customerOrganizationUuid?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  offerWindowMinutes?: InputMaybe<Scalars['Int']['input']>;
  orderSources?: InputMaybe<Array<OrderSource>>;
  peerUuid: Scalars['String']['input'];
  pickupHandling?: InputMaybe<DelegatedPickupHandling>;
  priority: Scalars['Int']['input'];
  scope: OrderDelegationScope;
  shareEndCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  timing: OrderDelegationRuleTiming;
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateOrderDocumentDocumentInput = {
  companyUuid: Scalars['String']['input'];
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderDocumentDocumentOutput = {
  __typename?: 'CreateOrderDocumentDocumentOutput';
  document: DocumentEntity;
};

export type CreateOrderDocumentInput = {
  customDocumentName?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The expected input for generating a report from the orders table. */
export type CreateOrderTableReportInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filters?: InputMaybe<FindOrdersFiltersInput>;
  /** Filters for orders holding SMC3 freight that needs a rate. Currently only implemented for the flat orders view. */
  freightNeedsRateFilter?: InputMaybe<BooleanFilterV2>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the invoice name on the order table field (used when useJournalNumberForInvoice is false) */
  invoiceNameFilter?: InputMaybe<StringFilterV2>;
  /** An integer filter for the invoice journal number (used when useJournalNumberForInvoice is true) */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID filter for the line haul leg destination terminal. Matches orders that have a segment whose end terminal matches. */
  lineHaulLegDestinationTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg (segment). Matches orders assigned to the specified segment via OrderLineHaulSegment. */
  lineHaulLegFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg origin terminal. Matches orders that have a segment whose start terminal matches. */
  lineHaulLegOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A filter for the order's line-haul origin terminal (the order-level origin set for "out of inventory" orders, else the on-hand terminal derivation). Used by the line-haul Outbound tab so out-of-inventory orders are discoverable under their origin terminal. */
  lineHaulOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** The list of order table fields to fetch values for */
  orderTableFields: Array<OrderTableField>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  /** A UUID filter for terminals derived from piece warehouse locations on the order. Semantics across operators: `eq` / `in` match an order when at least one piece is in a warehouse location whose warehouse belongs to one of the requested terminals. `neq` / `nin` exclude an order when ANY piece is in a warehouse location whose warehouse belongs to one of the requested terminals, so a split order with pieces at multiple terminals is excluded if any of its terminals is in the list. `isBlank` matches orders with no piece-terminal assignment at all; `isNotBlank` matches orders with at least one piece-terminal assignment. */
  pieceTerminalFilter?: InputMaybe<UuidFilterV2>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** Restrict the report to these checked orders ("Export selected orders"), intersected with any view-scoping uuids. At most 500 entries; omit to export every order matching the filters. */
  selectedOrderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** True if ascending, False if descending, undefined if no sort */
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  /** A string filter for the email of the user who created the order. */
  sourceUserEmailFilter?: InputMaybe<StringFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). Used only to read which calendar day a picked date filter value means; day boundaries are computed in the company time zone, the zone the order list displays dates in. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version ID for the request */
  versionId?: InputMaybe<Scalars['Float']['input']>;
  /** A UUID filter for the warehouse derived from piece locations on the order. This filters by Warehouse UUID (not WarehouseLocation/bin). The warehouse is determined by the unanimous piece-level warehouseId across the order. */
  warehouseLocationFilter?: InputMaybe<UuidFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

export type CreateOrderTableReportOutput = MutationErrorOutput | OrderTableReportDownloadOutput | OrderTableReportEmailToUserOutput;

/** This is the graphql input for creating an organization */
export type CreateOrganizationInput = {
  customerFields?: InputMaybe<CreateOrUpdateCustomerInput>;
  defaultContactPersonUuid?: InputMaybe<Scalars['String']['input']>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isaId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  peerCompanyUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  types: Array<OrganizationType>;
};

export type CreateOrganizationMessageInput = {
  audience: OrganizationMessageAudienceInput;
  body?: Scalars['String']['input'];
  /** When the message stops showing. Omitted uses the severity default (INFO 14 days, WARNING 3 days, CRITICAL never); null means never. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  link?: InputMaybe<OrganizationMessageLinkInput>;
  severity: OrganizationMessageSeverity;
  /** Optional; most messages need only the body. */
  title?: Scalars['String']['input'];
};

export type CreateOrganizationOutput = CreateOrganizationSuccessOutput | MutationErrorOutput;

export type CreateOrganizationPeerInput = {
  organizationUuid?: InputMaybe<Scalars['String']['input']>;
  peerCompanyUuid: Scalars['String']['input'];
};

export type CreateOrganizationSuccessOutput = {
  __typename?: 'CreateOrganizationSuccessOutput';
  /** The created organization */
  organization: OrganizationEntity;
};

/** Creates new orders for one TENEDI partnership by sending generated 204 tenders through the EDI inbound handler. In production it needs confirmProductionSend and confirmProductionOrderCreation, and refuses a company and contact whose new orders would reach anyone besides Tenedi. */
export type CreateOutboundBenchOrdersInput = {
  /** The second production opt-in, for creating orders. Required, and must be true, together with confirmProductionSend when the backend runs in production. Ignored elsewhere. */
  confirmProductionOrderCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** The bench production opt-in. Required, and must be true, together with confirmProductionOrderCreation when the backend runs in production. Ignored elsewhere. */
  confirmProductionSend?: InputMaybe<Scalars['Boolean']['input']>;
  /** 1 to 10. */
  count: Scalars['Int']['input'];
  /** HHmm, 24-hour, in the stop ZIP code time zone. The EDI inbound handler places the time on the day it processes the tender, not on the date above. */
  deliveryAppointmentEnd?: InputMaybe<Scalars['String']['input']>;
  /** HHmm, 24-hour, in the stop ZIP code time zone. The EDI inbound handler places the time on the day it processes the tender, not on the date above. */
  deliveryAppointmentStart?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD. The delivery service and appointment date. */
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  ediPartnershipUuid: Scalars['String']['input'];
  /** HHmm, 24-hour, in the stop ZIP code time zone. The EDI inbound handler places the time on the day it processes the tender, not on the date above. */
  pickupAppointmentEnd?: InputMaybe<Scalars['String']['input']>;
  /** HHmm, 24-hour, in the stop ZIP code time zone. The EDI inbound handler places the time on the day it processes the tender, not on the date above. */
  pickupAppointmentStart?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD. The pickup service and appointment date. */
  pickupDate?: InputMaybe<Scalars['String']['input']>;
  /** A service level code mapped on the partnership (outboundBenchServiceLevels). The tender's order.serviceLevel. */
  serviceLevelCode?: InputMaybe<Scalars['String']['input']>;
  /** Which stops each order gets. Defaults to PICKUP_AND_DELIVERY. */
  shape?: InputMaybe<BenchTenderShape>;
};

export type CreatePackageInput = {
  orderUuid: Scalars['String']['input'];
  packageCreateInput: PackageCreateInput;
  shipmentUuid: Scalars['String']['input'];
};

export type CreatePackageSpecInput = {
  freightClass?: InputMaybe<FreightClass>;
  height?: InputMaybe<Scalars['Length']['input']>;
  length?: InputMaybe<Scalars['Length']['input']>;
  name: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type CreatePackageSpecOutput = {
  __typename?: 'CreatePackageSpecOutput';
  packageSpec: PackageSpecEntity;
};

export type CreatePackingPendencyInput = {
  assignedWarehouseEmployeeUuid?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  kind: PackingPendencyKind;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  note?: InputMaybe<Scalars['String']['input']>;
  pieceUuids: Array<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePackingPendencyOutput = {
  __typename?: 'CreatePackingPendencyOutput';
  /** The packing pendency that was created */
  packingPendency: PackingPendencyEntity;
};

export type CreatePaymentInput = {
  amountInCents: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  contactUuid: Scalars['String']['input'];
  createPaymentToOrderMappingInputs: Array<CreatePaymentToOrderMappingInput>;
  creditTypeUuid?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  glTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  paymentRail?: InputMaybe<PaymentRail>;
  paymentType: PaymentType;
  referenceNumber: Scalars['String']['input'];
};

export type CreatePaymentToOrderMappingInput = {
  amountInCents: Scalars['Int']['input'];
  orderUuid: Scalars['String']['input'];
};

export type CreatePdfColumnInput = {
  contactUuid: Scalars['String']['input'];
  pdfColumnCreateInput: PdfColumnCreateInput;
};

export type CreatePermissionInput = {
  accessLevel: AccessLevel;
  permissionResource: PermissionResource;
  roleUuid: Scalars['String']['input'];
};

export type CreatePermissionOutput = {
  __typename?: 'CreatePermissionOutput';
  success: Scalars['Boolean']['output'];
};

export type CreatePersonInput = {
  contactStationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid: Scalars['String']['input'];
  defaultDeliveryAddress?: InputMaybe<AddressUpsertInput>;
  defaultPickupAddress?: InputMaybe<AddressUpsertInput>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultVehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePersonOutput = {
  __typename?: 'CreatePersonOutput';
  person: PersonEntity;
};

export type CreatePicklistInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** List of item groups with quantities to be added to picklist */
  itemGroups: Array<UpsertPickListItemGroup>;
  outboundReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePieceDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pieceUuid: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePieceInput = {
  additionalReferenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isMisrouted?: InputMaybe<Scalars['Boolean']['input']>;
  isOverage?: InputMaybe<Scalars['Boolean']['input']>;
  isShortage?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  orderUuid: Scalars['String']['input'];
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePieceReceiptInput = {
  /** Date the shipment arrived. Required. */
  arrivedAt: Scalars['DateTime']['input'];
  billOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the contact (customer) the receipt is created for */
  contactUuid: Scalars['String']['input'];
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  /** Set by the mobile app so the receipt is stamped with source MOBILE. Absent or false stamps WEB. */
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  supplierCompanyName?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trailerNumber?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the warehouse. When omitted, the company default warehouse is used. */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePieceReceiptOutput = {
  __typename?: 'CreatePieceReceiptOutput';
  /** The piece receipt that was created */
  pieceReceipt: PieceReceiptEntity;
};

export type CreatePieceWithoutOrderInput = {
  barcode: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  pieces?: InputMaybe<Array<OrphanPieceSpecInput>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  terminalUuid: Scalars['String']['input'];
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePlaceInput = {
  placeCreateInput: PlaceCreateInput;
};

export type CreatePodReportDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePodReportDocumentOutput = {
  __typename?: 'CreatePodReportDocumentOutput';
  document: DocumentEntity;
};

export type CreateProratedConsolidatedOrderInput = {
  shipmentUuids: Array<Scalars['String']['input']>;
};

export type CreateProratedConsolidatedOrderOutput = {
  __typename?: 'CreateProratedConsolidatedOrderOutput';
  consolidatedOrderUuid?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderEntity>;
};

export type CreateQuickbooksHeaderFileMappingInput = {
  quickbooksHeaderFileMappingCreateInput: QuickbooksHeaderFileMappingCreateInput;
};

export type CreateQuoteAgentForwardingAddressOutput = CreateQuoteAgentForwardingAddressSuccessOutput | MutationErrorOutput;

export type CreateQuoteAgentForwardingAddressSuccessOutput = {
  __typename?: 'CreateQuoteAgentForwardingAddressSuccessOutput';
  connection: QuoteAgentConnection;
};

export type CreateQuoteInput = {
  quoteCreateInput: QuoteCreateInput;
};

export type CreateRecurringLineHaulManifestTemplateInput = {
  autoGenerate?: InputMaybe<Scalars['Boolean']['input']>;
  createAheadDays?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use createAheadDays. This field no longer affects generation. */
  createInAdvanceHours?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek: Array<DayOfWeekAll>;
  defaultDriverUuid?: InputMaybe<Scalars['String']['input']>;
  defaultEquipmentUuid?: InputMaybe<Scalars['String']['input']>;
  departTimeMinutes: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  manifestsPerOccurrence?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated No longer affects generation. Off-weeks are expressed as skipDates. */
  repeatFrequencyUnit?: InputMaybe<RepeatFrequencyUnit>;
  /** @deprecated No longer affects generation. Off-weeks are expressed as skipDates. */
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
  skipDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startDate: Scalars['DateTime']['input'];
  startTerminalUuid: Scalars['String']['input'];
  transitMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRecurringOrderFrequencyInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek: Array<DayOfWeekAll>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  repeatFrequencyUnit?: InputMaybe<RepeatFrequencyUnit>;
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use repeatInterval instead */
  repeatIntervalWeeks?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type CreateRecurringTemplateTruckInput = {
  cutoffTime?: InputMaybe<Scalars['String']['input']>;
  daysOfWeek?: InputMaybe<Array<DayOfWeekAll>>;
  label: Scalars['String']['input'];
  powerUnitEquipmentUuid?: InputMaybe<Scalars['String']['input']>;
  recurringTemplateUuid: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  trailers: Array<RecurringTemplateTruckTrailerInput>;
};

export type CreateReverseOrderInput = {
  orderUuid: Scalars['String']['input'];
  pieceUuids: Array<Scalars['String']['input']>;
};

export type CreateRoleInput = {
  isInternalRole: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateRoleOutput = {
  __typename?: 'CreateRoleOutput';
  role: RoleEntity;
};

export type CreateRouteDriverInput = {
  routeDriverCreateInput: RouteDriverCreateInput;
};

export type CreateRouteFromRouteTemplateInput = {
  /** The date for which to create the route and its orders, defaults to the current date */
  date?: InputMaybe<PlainDateInput>;
  /** The UUID of a run (to be renamed to route template) */
  routeTemplateUuid: Scalars['String']['input'];
};

export type CreateRouteFromRouteTemplateOutput = CreateRouteFromRouteTemplateSuccessOutput | MutationErrorOutput;

export type CreateRouteFromRouteTemplateSuccessOutput = {
  __typename?: 'CreateRouteFromRouteTemplateSuccessOutput';
  /** The orders that were created and added to the route */
  orders: Array<OrderEntity>;
  /** The newly created route or an existing route that was updated */
  route: RouteEntity;
};

export type CreateRouteInput = {
  routeCreateInput: RouteCreateInput;
};

export type CreateRouteNameInput = {
  routeNameCreateInput: RouteNameCreateInput;
};

export type CreateRouteNameLocationInput = {
  routeNameLocationCreateInput: RouteNameLocationCreateInput;
  routeNameUuid: Scalars['String']['input'];
};

export type CreateRouteOptimizationInput = {
  routeOptimizationCreateInput: RouteOptimizationCreateInput;
};

export type CreateRouteSlotInput = {
  routeSlotCreateInput: RouteSlotCreateInput;
  routeUuid: Scalars['String']['input'];
};

export type CreateRoutesInput = {
  routeCreateInputs: Array<RouteCreateInput>;
};

export type CreateRunInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRunOutput = {
  __typename?: 'CreateRunOutput';
  run: RunEntity;
};

export type CreateSameDayDispatchConfigInput = {
  deliveryAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  deliveryWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
  isNextInRouteColorCode?: InputMaybe<Scalars['String']['input']>;
  isPastDeadlineColorCode?: InputMaybe<Scalars['String']['input']>;
  isSpecialColorCode?: InputMaybe<Scalars['String']['input']>;
  pickupAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  pickupWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSamsaraOauthTokenInput = {
  accessToken: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
  refreshToken: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  tokenType: Scalars['String']['input'];
};

export type CreateSandboxRouteForDriverInput = {
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateSavedFilterViewInput = {
  /** The page's default tab the view is based on (e.g. a Billing Review tab). Null means the page's base tab. */
  baseTab?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  displayName: Scalars['String']['input'];
  filterModelJson: Scalars['String']['input'];
  filterModelJsonV2?: InputMaybe<Scalars['JSON']['input']>;
  /** Ordered list of OrderTableField values the orders grid groups by, outermost first. Omit or pass null for an ungrouped view. */
  groupModelJson?: InputMaybe<Scalars['JSON']['input']>;
  /** The line-haul dispatch board filters to restore with the view. Only accepted on LINE_HAUL_ORDERS views; null on update clears them. */
  lineHaulDispatchFilters?: InputMaybe<SavedLineHaulDispatchFiltersInput>;
  orderTableFields: Array<OrderTableField>;
  savedViewPageType: FilterViewPage;
  sortModelJson?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type CreateScannedOrdersFromAdminInput = {
  scannedOrderCreateInputs: Array<ScannedOrderFromAdminCreateInput>;
};

export type CreateScannedOrdersInput = {
  scannedOrderCreateInputs: Array<ScannedOrderCreateInput>;
};

export type CreateSchedulingRegionInput = {
  dailyCapacityPieces?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityStops?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityWeight?: InputMaybe<Scalars['Mass']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSchedulingRegionOutput = CreateSchedulingRegionSuccessOutput | MutationErrorOutput;

export type CreateSchedulingRegionSuccessOutput = {
  __typename?: 'CreateSchedulingRegionSuccessOutput';
  schedulingRegion: SchedulingRegionEntity;
};

export type CreateSchedulingResourceInput = {
  /** Null means the resource has no piece limit. */
  capacityPieces?: InputMaybe<Scalars['Int']['input']>;
  /** Null means the resource has no stop limit. */
  capacityStops?: InputMaybe<Scalars['Int']['input']>;
  /** Null means the resource has no weight limit. */
  capacityWeight?: InputMaybe<Scalars['Mass']['input']>;
  dayOfWeek: DayOfWeekAll;
  /** Earlier than start is accepted and means the window crosses midnight: the end then belongs to the calendar day after dayOfWeek, read in this resource timeZone. Nothing else has to be sent to say so. Equal to start is rejected, so a 24-hour window is not representable: express it as 00:00 to 23:59. Both fields are required and the columns behind them are NOT NULL, so a resource with no window at all is not representable either. */
  end: PlainTimeInput;
  name: Scalars['String']['input'];
  /** UUIDs of the route names this resource covers. At least one is required. The capacity below is the total across all of them, not a per-route-name allowance. */
  routeNameUuids: Array<Scalars['String']['input']>;
  start: PlainTimeInput;
  /** Canonical IANA region time zone the start and end times are read in, for example America/New_York. Fixed offsets, abbreviations and Etc/* zones are rejected because they are blind to daylight saving. Defaults to the company time zone. */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSchedulingZoneInput = {
  availabilities?: InputMaybe<Array<SchedulingZoneAvailabilityUpsertInput>>;
  locations?: InputMaybe<Array<SchedulingZoneLocationUpsertInput>>;
  name: Scalars['String']['input'];
  schedulingRegionId: Scalars['String']['input'];
};

export type CreateSchedulingZoneOutput = CreateSchedulingZoneSuccessOutput | MutationErrorOutput;

export type CreateSchedulingZoneSuccessOutput = {
  __typename?: 'CreateSchedulingZoneSuccessOutput';
  schedulingZone: SchedulingZoneEntity;
};

export type CreateSchemaCompanyMappingInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSchemaDocumentInput = {
  schemaCompanyMappingUuid?: InputMaybe<Scalars['String']['input']>;
  schemaDocument: SchemaDocumentInput;
  schemaUuid: Scalars['String']['input'];
};

export type CreateSchemaInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  schema: SchemaInput;
};

export type CreateSchemaTestSnapshotInput = {
  uuid: Scalars['String']['input'];
};

export type CreateServiceGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** UUIDs of the services that make up this group. */
  serviceUuids: Array<Scalars['String']['input']>;
};

export type CreateServiceInput = {
  serviceCreateInput: ServiceCreateInput;
};

/** An object describing the service regions to create */
export type CreateServiceRegionsInput = {
  serviceRegions: Array<CreateServiceRegionsRegionInput>;
};

export type CreateServiceRegionsOutput = CreateServiceRegionsSuccessOutput | MutationErrorOutput;

/** An object describing the region operated in by a company or agent */
export type CreateServiceRegionsRegionInput = {
  name: Scalars['String']['input'];
};

export type CreateServiceRegionsSuccessOutput = {
  __typename?: 'CreateServiceRegionsSuccessOutput';
  /** All of the company's service regions, including the ones created  */
  serviceRegions: Array<ServiceRegionEntity>;
};

export type CreateSftpCredentialsInput = {
  bundleShipmentPhotosWithPod?: InputMaybe<Scalars['Boolean']['input']>;
  ediPartnershipUuid?: InputMaybe<Scalars['String']['input']>;
  host: Scalars['String']['input'];
  invoicePath?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  path: Scalars['String']['input'];
  podNamingConvention: PodNamingConvention;
  port: Scalars['Int']['input'];
  username: Scalars['String']['input'];
};

export type CreateSftpCredentialsOutput = {
  __typename?: 'CreateSftpCredentialsOutput';
  sftpCredentials: SftpCredentialsEntity;
};

export type CreateShipmentDocumentInput = {
  customDocumentName?: InputMaybe<Scalars['String']['input']>;
  documentType: DocumentType;
  driverFormTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  isNewlyCreatedShipment?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  shipmentUuid: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStandardOrderFieldsInput = {
  standardOrderFieldsCreateInput: StandardOrderFieldsCreateInput;
};

export type CreateStandardOrderInput = {
  orderCreateInput: StandardOrderCreateInput;
  timingData?: InputMaybe<CreateStandardOrderTimingData>;
};

export type CreateStandardOrderTimingData = {
  durationMs: Scalars['Float']['input'];
  endTimeUnix: Scalars['Float']['input'];
  startTimeUnix: Scalars['Float']['input'];
};

export type CreateStandardShipmentFieldInput = {
  standardShipmentFieldsCreateInput: StandardShipmentFieldsCreateInput;
};

export type CreateStorageOrderDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStorageOrderDocumentOutput = {
  __typename?: 'CreateStorageOrderDocumentOutput';
  document: DocumentEntity;
};

export type CreateStorageOrderInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the contact for whom the storage order is being created */
  contactUuid: Scalars['String']['input'];
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  supplierCompanyName?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trailerNumber?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStorageOrderOutput = {
  __typename?: 'CreateStorageOrderOutput';
  /** The storage order that was created */
  storageOrder: StorageOrderEntity;
};

export type CreateStorageUnitInput = {
  height?: InputMaybe<Scalars['Length']['input']>;
  length?: InputMaybe<Scalars['Length']['input']>;
  /** If a name is not passed in, it is autogenerated */
  name?: InputMaybe<Scalars['String']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  /** If a unit of measure is not passed in, the default contact unit of measure will be used */
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type CreateStorageUnitOutput = {
  __typename?: 'CreateStorageUnitOutput';
  storageUnit: StorageUnitEntity;
};

export type CreateStorageUnitWithInventoryItemsInput = {
  /** The UoM of the inventory items */
  itemUnitOfMeasure: UnitOfMeasure;
  /** The UUID of the item to create the inventory items for */
  itemUuid: Scalars['String']['input'];
  /** The name of the storage unit. If not supplied, will generate one based on contact reference ID */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The number of inventory items to create and associate with the storage unit */
  quantity: Scalars['Int']['input'];
  /** The UUID of the storage order to create the storage unit for */
  storageOrderUuid: Scalars['String']['input'];
  /** The UoM of the storage unit */
  unitOfMeasure: UnitOfMeasure;
};

export type CreateStorageUnitWithInventoryItemsOutput = {
  __typename?: 'CreateStorageUnitWithInventoryItemsOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateTagInput = {
  tagCreateInput: TagCreateInput;
};

export type CreateTariffChainInput = {
  name: Scalars['String']['input'];
  tariffGroupType: TariffGroupType;
  tariffGroupUuids: Array<Scalars['String']['input']>;
};

export type CreateTariffChainOutput = CreateTariffChainSuccessOutput | MutationErrorOutput;

export type CreateTariffChainSuccessOutput = {
  __typename?: 'CreateTariffChainSuccessOutput';
  /** The tariff chain that was created */
  tariffChain: TariffChainEntity;
};

export type CreateTariffGroupInput = {
  contactToServicesMappings: Array<CreateContactToServicesMappingInput>;
  contactUuids: Array<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentTariffGroupUuid?: InputMaybe<Scalars['String']['input']>;
  rateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  rateType: RateType;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tariffCreateInputs: Array<TariffCreateInput>;
  tariffGroupScope?: InputMaybe<TariffGroupScope>;
  tariffGroupType: TariffGroupType;
  tariffOverageRateCreates?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  tariffType: TariffType;
  tariffZoneCreateInputs: Array<TariffZoneCreateInput>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUpdateInputs: Array<TariffZoneUpdateInput>;
  terminalUuids: Array<Scalars['String']['input']>;
  useActualWeightInCalculation: Scalars['Boolean']['input'];
  useDeficitBilling?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneType: TariffZoneType;
};

export type CreateTariffInput = {
  /** Tariff Create Input */
  tariffCreateInput: TariffCreateInput;
  tariffGroupUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTariffLocationInput = {
  tariffLocationCreateInput: TariffLocationCreateInput;
  tariffZoneUuid: Scalars['String']['input'];
};

export type CreateTariffLocationOutput = {
  __typename?: 'CreateTariffLocationOutput';
  tariffLocation: TariffLocationEntity;
};

export type CreateTariffOutput = {
  __typename?: 'CreateTariffOutput';
  tariff: TariffEntity;
};

export type CreateTerminalInput = {
  terminalCreateInput: TerminalCreateInput;
};

/** An object describing the lanes to create between terminals. Each lane is a direct connection between two terminals. Specifying a start/end terminal combination that already exists has no effect. */
export type CreateTerminalLanesInput = {
  terminalLanes: Array<CreateTerminalLanesLaneInput>;
};

/** An object representing a lane between two terminals, meaning orders can be moved directly from the start to the end terminal. */
export type CreateTerminalLanesLaneInput = {
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type CreateTerminalLanesOutput = CreateTerminalLanesSuccessOutput | MutationErrorOutput;

export type CreateTerminalLanesSuccessOutput = {
  __typename?: 'CreateTerminalLanesSuccessOutput';
  /** All of the company’s terminal lanes, including the ones created */
  terminalLanes: Array<TerminalLaneEntity>;
};

export type CreateTerminalOutput = {
  __typename?: 'CreateTerminalOutput';
  terminal: TerminalEntity;
};

export type CreateTerminalServiceAreaInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  terminalUuid: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CreateTerminalServiceAreaOutput = {
  __typename?: 'CreateTerminalServiceAreaOutput';
  city?: Maybe<Scalars['String']['output']>;
  createdServiceAreaUuid?: Maybe<Scalars['String']['output']>;
  nameOfTerminalContainingThisZipcode?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type CreateTerminalServiceAreaV2Output = {
  __typename?: 'CreateTerminalServiceAreaV2Output';
  createdCount?: Maybe<Scalars['Int']['output']>;
};

export type CreateTerminalSuccessOutput = {
  __typename?: 'CreateTerminalSuccessOutput';
  /** The created terminal */
  terminal: TerminalEntity;
};

export type CreateTerminalV2Output = CreateTerminalSuccessOutput | MutationErrorOutput;

export type CreateTerminalsInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the terminals downloaded from Crown */
  terminalsUrl: Scalars['String']['input'];
};

export type CreateTestAbstainedScannedOrderInput = {
  candidateCount?: InputMaybe<Scalars['Int']['input']>;
  companyUuid: Scalars['String']['input'];
  snapshotCorrelationId?: InputMaybe<Scalars['String']['input']>;
  withoutUploader?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTestAbstainedScannedOrderOutput = {
  __typename?: 'CreateTestAbstainedScannedOrderOutput';
  candidateContactNames: Array<Scalars['String']['output']>;
  candidateContactUuids: Array<Scalars['String']['output']>;
  scannedOrderResultUuid: Scalars['String']['output'];
  scannedOrderUuid: Scalars['String']['output'];
};

export type CreateTestAccessorialInput = {
  companyUuid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** Flat rate in US cents per unit. */
  rateUsdCents: Scalars['Int']['input'];
};

export type CreateTestAccessorialOutput = {
  __typename?: 'CreateTestAccessorialOutput';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CreateTestApiOrderInput = {
  billingContactUuid: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  destination?: InputMaybe<TestApiOrderDestinationStopInput>;
  emergencyResponseNumber?: InputMaybe<Scalars['String']['input']>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  hazmatClass?: InputMaybe<HazmatClass>;
  hazmatDescription?: InputMaybe<Scalars['String']['input']>;
  houseAirwayBillNumber: Scalars['String']['input'];
  isLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<TestApiOrderOriginStopInput>;
  packageGroup?: InputMaybe<PackageGroup>;
  packages: Array<TestApiOrderPackageInput>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  requiresPlacard?: InputMaybe<Scalars['Boolean']['input']>;
  serviceLevelUuid?: InputMaybe<Scalars['String']['input']>;
  unNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTestCompanyInput = {
  /** If set, overrides the default dim factor of 250 for the company */
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  /** If set to true, line haul configs are enabled */
  isLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, the logistics section (In Bond / Hazmat / Door to door) is enabled on the order form */
  logisticsSectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, requires POD photo and name */
  requirePODPhotoAndName?: InputMaybe<Scalars['Boolean']['input']>;
  segment: Segment;
  /** If set to true, enables the T2T master delegation gate (t2tDelegationEnabled) for this company */
  t2tDelegationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, enables the T2T sync sub-gate (t2tSyncEnabled) for this company. Has no effect unless t2tDelegationEnabled is also true. */
  t2tSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTestCompanyOutput = {
  __typename?: 'CreateTestCompanyOutput';
  company: CompanyEntity;
  inboundTerminal: TerminalEntity;
  outboundTerminal: TerminalEntity;
  users: Array<UserEntity>;
};

export type CreateTestContactInput = {
  companyUuid: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTestContactOutput = {
  __typename?: 'CreateTestContactOutput';
  contact: ContactEntity;
};

export type CreateTestDelegatableOrderInput = {
  companyUuid: Scalars['String']['input'];
};

export type CreateTestDelegatableOrderOutput = {
  __typename?: 'CreateTestDelegatableOrderOutput';
  uuid: Scalars['String']['output'];
};

export type CreateTestEdiOrderInput = {
  payload: Scalars['JSON']['input'];
};

export type CreateTestOrderCustomChargeInput = {
  customChargeUuid: Scalars['String']['input'];
  testOrderUuid: Scalars['String']['input'];
  total: Scalars['Float']['input'];
};

export type CreateTestOrderCustomChargeOutput = {
  __typename?: 'CreateTestOrderCustomChargeOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateTestOrderDelegationInput = {
  autoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  orderUuid: Scalars['String']['input'];
  originatorCompanyUuid: Scalars['String']['input'];
  parts: Array<OrderDelegationPart>;
  peerCompanyUuid: Scalars['String']['input'];
  pickupHandling?: InputMaybe<DelegatedPickupHandling>;
  shareEndCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTestOrderDelegationOutput = {
  __typename?: 'CreateTestOrderDelegationOutput';
  delegationUuid: Scalars['String']['output'];
  duplicateOrderUuid?: Maybe<Scalars['String']['output']>;
};

export type CreateTestOrderDeliveryAppointmentInput = {
  /** Overrides the delivery stop's city, to place it in a route name's service area. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Delivery day, YYYY-MM-DD. The appointment runs 09:00 to 11:00 in the company time zone. */
  serviceDateIso8601: Scalars['String']['input'];
  /** Overrides the delivery stop's zipcode. */
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTestOrderInput = {
  /** The delivery date and appointment window for the delivery stop. Only supported with stopType DELIVERY, and not together with deliveryAppointment. */
  appointment?: InputMaybe<TestOrderAppointmentInput>;
  companyUuid: Scalars['String']['input'];
  /** If set to true, it creates a freight charge and fuel charge for the inbound stop */
  createInboundStopFreightChargeAndFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, it creates a freight charge and fuel charge for the line haul */
  createLineHaulFreightChargeAndFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, it creates a freight charge and fuel charge for the outbound stop */
  createOutboundStopFreightChargeAndFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Creates the order with status DELIVERED, so billing review lists it as unfinalized. Stops keep their seeded status. */
  delivered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gives the delivery stop a delivery date and an appointment. Only valid with stopType DELIVERY, and not together with appointment. */
  deliveryAppointment?: InputMaybe<CreateTestOrderDeliveryAppointmentInput>;
  ratingErrorCode?: InputMaybe<ExternalRatingErrorCode>;
  /** Moves every freight charge the order creates to SMC3 billing. NEEDS_RATE stores it not yet rated; RATED stores a rated total with no SMC3 exchange behind it. */
  smc3FreightState?: InputMaybe<TestSmc3FreightState>;
  /** Gives every pickup or delivery stop a real US address and its terminal, the terminals US addresses, the order a line haul lane, and the order one 500 lb class 70 pallet, so SMC3 can rate the freight. */
  smc3RatableDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** The combination of inbound and outbound stops to create for the order */
  stopType: TestOrderStopType;
  /** If set to true, the order gets the company's first service and default dim factor, which the order form needs before it will rate the order */
  withRatingDefaults?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTestOrderOutput = {
  __typename?: 'CreateTestOrderOutput';
  order: OrderEntity;
};

export type CreateTestOrderQuoteInput = {
  attentionReasons?: InputMaybe<Array<QuoteAttentionReason>>;
  chargeTotalCents?: InputMaybe<Scalars['Int']['input']>;
  companyUuid: Scalars['String']['input'];
  draftReplyApproved?: InputMaybe<Scalars['Boolean']['input']>;
  draftReplyBody?: InputMaybe<Scalars['String']['input']>;
  draftReplyKind?: InputMaybe<QuoteDraftReplyKind>;
  earlierReplyBody?: InputMaybe<Scalars['String']['input']>;
  needsAttention?: InputMaybe<Scalars['Boolean']['input']>;
  quotedAmountCents?: InputMaybe<Scalars['Int']['input']>;
  senderAddress: Scalars['String']['input'];
  senderRecoveredFromForward?: InputMaybe<Scalars['Boolean']['input']>;
  status: OrderQuoteStatus;
  subject?: InputMaybe<Scalars['String']['input']>;
  withDraftOrder: Scalars['Boolean']['input'];
};

export type CreateTestOrderQuoteOutput = {
  __typename?: 'CreateTestOrderQuoteOutput';
  contactUuid?: Maybe<Scalars['String']['output']>;
  draftReplyUuid?: Maybe<Scalars['String']['output']>;
  orderQuoteUuid: Scalars['String']['output'];
  orderUuid?: Maybe<Scalars['String']['output']>;
};

export type CreateTestOrderRequest = {
  orderUuid: Scalars['String']['input'];
  totalCharge: Scalars['Float']['input'];
  totalFreightCharge: Scalars['Float']['input'];
  totalFuelCharge: Scalars['Float']['input'];
};

export type CreateTestOrderResponse = {
  __typename?: 'CreateTestOrderResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateTestOrganizationPeerInput = {
  companyUuid: Scalars['String']['input'];
  peerCompanyUuid: Scalars['String']['input'];
};

export type CreateTestOrganizationPeerOutput = {
  __typename?: 'CreateTestOrganizationPeerOutput';
  companyUuid: Scalars['String']['output'];
  peerCompanyUuid: Scalars['String']['output'];
  peerUuid: Scalars['String']['output'];
  reciprocalPeerUuid: Scalars['String']['output'];
};

export type CreateTestPiecesOnOrderInput = {
  count: Scalars['Int']['input'];
  linkToPackage?: InputMaybe<Scalars['Boolean']['input']>;
  orderUuid: Scalars['String']['input'];
  referenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  status: PieceStatus;
};

export type CreateTestPiecesOutput = {
  __typename?: 'CreateTestPiecesOutput';
  pieces: Array<TestPieceOutput>;
};

export type CreateTestReviewOrderInput = {
  companyUuid: Scalars['String']['input'];
  isDraftOrder: Scalars['Boolean']['input'];
  requireReviewForEdiOrderCreation?: InputMaybe<Scalars['Boolean']['input']>;
  source: OrderSource;
};

export type CreateTestReviewOrderOutput = {
  __typename?: 'CreateTestReviewOrderOutput';
  contactUuid: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
};

export type CreateTestTerminalLaneInput = {
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type CreateTestThirdPartyUserInput = {
  companyUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CreateTestThirdPartyUserOutput = {
  __typename?: 'CreateTestThirdPartyUserOutput';
  contactUuid: Scalars['String']['output'];
  email: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CreateTruckRunsInput = {
  date: Scalars['String']['input'];
  recurringTemplateTruckUuids: Array<Scalars['String']['input']>;
};

export type CreateUserInput = {
  arrangeStopsAndRoutesVertically?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, the user is assigned an internal role that provides them with the master permission resource */
  assignInternalRole?: InputMaybe<Scalars['Boolean']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dispatchTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  email: Scalars['String']['input'];
  invoicesTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  lineHaulOrderTableFields?: InputMaybe<Array<OrderTableField>>;
  linehaulDispatchTableFields?: InputMaybe<Array<LinehaulDispatchTableField>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfStops?: InputMaybe<Scalars['Float']['input']>;
  orderTableFields?: InputMaybe<Array<OrderTableField>>;
  ordersTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The list of roles to assign to a user */
  roleUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardWidth?: InputMaybe<Scalars['Float']['input']>;
  sendAllInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  sendSummaryEmailWithIncompleteRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUserOutput = ArchivedUserExistsOutput | CreateUserSuccessOutput | MutationErrorOutput;

export type CreateUserSuccessOutput = {
  __typename?: 'CreateUserSuccessOutput';
  user: UserEntity;
};

export type CreateWarehouseEmployeeInput = {
  active: Scalars['Boolean']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateWarehouseEmployeeOutput = {
  __typename?: 'CreateWarehouseEmployeeOutput';
  /** The created warehouse employee. It is null if there is a duplicate phone number being used or a server-side error occurs. */
  warehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
};

export type CreateWarehouseInput = {
  addressCreateInput: AddressCreateInput;
  name: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWarehouseLocationInput = {
  location1?: InputMaybe<Scalars['String']['input']>;
  location2?: InputMaybe<Scalars['String']['input']>;
  location3?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWarehouseLocationOutput = {
  __typename?: 'CreateWarehouseLocationOutput';
  /** An array of error messages. This is null if there are no errors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The warehouse location that was created. This is null if there is a warehouse location with a duplicate name passed in or  */
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type CreditTypeCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreditTypeEntity = {
  __typename?: 'CreditTypeEntity';
  color?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  name: Scalars['String']['output'];
  systemKey?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type CreditTypeUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type CsvOrderFieldMappingEntity = {
  __typename?: 'CsvOrderFieldMappingEntity';
  createdAt: Scalars['DateTime']['output'];
  sourceColumnName: Scalars['String']['output'];
  targetFieldType: CsvOrderMappingTargetFieldType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum CsvOrderImportStatus {
  Accepted = 'ACCEPTED',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED'
}

export type CsvOrderImportTransactionEntity = {
  __typename?: 'CsvOrderImportTransactionEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  /** The raw, comma-separated string contents of the CSV row */
  row: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  status: CsvOrderImportTransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum CsvOrderImportTransactionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type CsvOrderMappingEntity = {
  __typename?: 'CsvOrderMappingEntity';
  contact?: Maybe<ContactEntity>;
  createdAt: Scalars['DateTime']['output'];
  csvOrderFieldMappings: Array<CsvOrderFieldMappingEntity>;
  deadlineDateDefaultValue?: Maybe<Scalars['DateTime']['output']>;
  deadlineTypeDefaultValue?: Maybe<DeadlineType>;
  enableDynamicInboundOrOutboundStop: Scalars['Boolean']['output'];
  enableInboundStop: Scalars['Boolean']['output'];
  enableOutboundStop: Scalars['Boolean']['output'];
  freightBillingMethodDefaultValue?: Maybe<FreightBillingMethod>;
  name: Scalars['String']['output'];
  pickupOrDeliveryDefaultValue?: Maybe<PickupOrDelivery>;
  serviceLevelDefaultValue?: Maybe<ServiceEntity>;
  stopTypeDefaultValue?: Maybe<StandardStopType>;
  /** A flag that, if set, ensures that any imports with this mapping treats rows with duplicate HAWBs as updates to existing orders rather than duplicate entries to be skipped. */
  updateOrderOnDuplicateBolNumber?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type CsvOrderMappingQueryInput = {
  uuid: Scalars['String']['input'];
};

export enum CsvOrderMappingTargetFieldType {
  AddressCity = 'ADDRESS_CITY',
  AddressLine_1 = 'ADDRESS_LINE_1',
  AddressLine_2 = 'ADDRESS_LINE_2',
  AddressName = 'ADDRESS_NAME',
  AddressState = 'ADDRESS_STATE',
  AddressZip = 'ADDRESS_ZIP',
  AppointmentEndTime = 'APPOINTMENT_END_TIME',
  AppointmentRequired = 'APPOINTMENT_REQUIRED',
  AppointmentStartTime = 'APPOINTMENT_START_TIME',
  Contact = 'CONTACT',
  ContactPersonEmail = 'CONTACT_PERSON_EMAIL',
  ContactPersonFirstName = 'CONTACT_PERSON_FIRST_NAME',
  ContactPersonLastName = 'CONTACT_PERSON_LAST_NAME',
  ContactPersonPhone = 'CONTACT_PERSON_PHONE',
  CustomerReferenceNumber = 'CUSTOMER_REFERENCE_NUMBER',
  DeadlineDate = 'DEADLINE_DATE',
  DeadlineType = 'DEADLINE_TYPE',
  DriverName = 'DRIVER_NAME',
  DriverReferenceNumber = 'DRIVER_REFERENCE_NUMBER',
  FreightChargeRate = 'FREIGHT_CHARGE_RATE',
  Hawb = 'HAWB',
  InboundAddressCity = 'INBOUND_ADDRESS_CITY',
  InboundAddressLine_1 = 'INBOUND_ADDRESS_LINE_1',
  InboundAddressLine_2 = 'INBOUND_ADDRESS_LINE_2',
  InboundAddressName = 'INBOUND_ADDRESS_NAME',
  InboundAddressState = 'INBOUND_ADDRESS_STATE',
  InboundAddressZip = 'INBOUND_ADDRESS_ZIP',
  InboundAppointmentEndTime = 'INBOUND_APPOINTMENT_END_TIME',
  InboundAppointmentRequired = 'INBOUND_APPOINTMENT_REQUIRED',
  InboundAppointmentStartTime = 'INBOUND_APPOINTMENT_START_TIME',
  InboundContactPersonEmail = 'INBOUND_CONTACT_PERSON_EMAIL',
  InboundContactPersonFirstName = 'INBOUND_CONTACT_PERSON_FIRST_NAME',
  InboundContactPersonLastName = 'INBOUND_CONTACT_PERSON_LAST_NAME',
  InboundContactPersonName = 'INBOUND_CONTACT_PERSON_NAME',
  InboundContactPersonPhone = 'INBOUND_CONTACT_PERSON_PHONE',
  InboundDeadlineDate = 'INBOUND_DEADLINE_DATE',
  InboundDeadlineType = 'INBOUND_DEADLINE_TYPE',
  InboundDriverName = 'INBOUND_DRIVER_NAME',
  InboundDriverReferenceNumber = 'INBOUND_DRIVER_REFERENCE_NUMBER',
  InboundSpecialInstructions = 'INBOUND_SPECIAL_INSTRUCTIONS',
  InboundTerminalName = 'INBOUND_TERMINAL_NAME',
  Mawb = 'MAWB',
  Notes = 'NOTES',
  OutboundAddressCity = 'OUTBOUND_ADDRESS_CITY',
  OutboundAddressLine_1 = 'OUTBOUND_ADDRESS_LINE_1',
  OutboundAddressLine_2 = 'OUTBOUND_ADDRESS_LINE_2',
  OutboundAddressName = 'OUTBOUND_ADDRESS_NAME',
  OutboundAddressState = 'OUTBOUND_ADDRESS_STATE',
  OutboundAddressZip = 'OUTBOUND_ADDRESS_ZIP',
  OutboundAppointmentEndTime = 'OUTBOUND_APPOINTMENT_END_TIME',
  OutboundAppointmentRequired = 'OUTBOUND_APPOINTMENT_REQUIRED',
  OutboundAppointmentStartTime = 'OUTBOUND_APPOINTMENT_START_TIME',
  OutboundContactPersonEmail = 'OUTBOUND_CONTACT_PERSON_EMAIL',
  OutboundContactPersonFirstName = 'OUTBOUND_CONTACT_PERSON_FIRST_NAME',
  OutboundContactPersonLastName = 'OUTBOUND_CONTACT_PERSON_LAST_NAME',
  OutboundContactPersonName = 'OUTBOUND_CONTACT_PERSON_NAME',
  OutboundContactPersonPhone = 'OUTBOUND_CONTACT_PERSON_PHONE',
  OutboundDeadlineDate = 'OUTBOUND_DEADLINE_DATE',
  OutboundDeadlineType = 'OUTBOUND_DEADLINE_TYPE',
  OutboundDriverName = 'OUTBOUND_DRIVER_NAME',
  OutboundDriverReferenceNumber = 'OUTBOUND_DRIVER_REFERENCE_NUMBER',
  OutboundSpecialInstructions = 'OUTBOUND_SPECIAL_INSTRUCTIONS',
  OutboundTerminalName = 'OUTBOUND_TERMINAL_NAME',
  PackageClass = 'PACKAGE_CLASS',
  PackageDescription = 'PACKAGE_DESCRIPTION',
  PackageHeight = 'PACKAGE_HEIGHT',
  PackageLength = 'PACKAGE_LENGTH',
  PackageNmfc = 'PACKAGE_NMFC',
  PackageQuantity = 'PACKAGE_QUANTITY',
  PackageWeight = 'PACKAGE_WEIGHT',
  PackageWidth = 'PACKAGE_WIDTH',
  PickupOrDelivery = 'PICKUP_OR_DELIVERY',
  ReferenceNumber = 'REFERENCE_NUMBER',
  ServiceLevel = 'SERVICE_LEVEL',
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  StopType = 'STOP_TYPE',
  TerminalName = 'TERMINAL_NAME'
}

export type CsvOrderPreSignedPutUrlEntity = {
  __typename?: 'CsvOrderPreSignedPutUrlEntity';
  bucket: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filetype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CsvRouteNameInput = {
  city: Scalars['String']['input'];
  routeName: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CustomChargeArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  customChargeCreateInput?: InputMaybe<CustomChargeCreateInput>;
  /** Pass this field in to update an array item */
  customChargeUpdateInput?: InputMaybe<CustomChargeUpdateInput>;
  /** Pass this field in to upsert an array item */
  customChargeUpsertInput?: InputMaybe<CustomChargeUpsertInput>;
};

export enum CustomChargeBillingMethod {
  Accessorial = 'ACCESSORIAL',
  AdHoc = 'AD_HOC'
}

export type CustomChargeCreateInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  isAutoApplied?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomChargeEntity = {
  __typename?: 'CustomChargeEntity';
  accessorialRange?: Maybe<AccessorialRangeEntity>;
  accessorialTemplate?: Maybe<AccessorialInterface>;
  authoCode?: Maybe<Scalars['String']['output']>;
  billingMethod: CustomChargeBillingMethod;
  description?: Maybe<Scalars['String']['output']>;
  /** This is saved as a percentage in the range [0, 1]. */
  fuelSurchargeRate?: Maybe<Scalars['Float']['output']>;
  isAutoApplied: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  /** This is a percentage out of 100 */
  postedFuelSurchargeRate?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  /** returns rate a double in a string for presentation */
  rate: Scalars['Float']['output'];
  settlementFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment?: Maybe<ShipmentEntity>;
  specialAccessorialChargeGroupUuid?: Maybe<Scalars['String']['output']>;
  specialAccessorialMatrixItem?: Maybe<SpecialAccessorialMatrixItemEntity>;
  specialAccessorialTariffZoneUuid?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  zoneBasedAccessorialChargeGroupUuid?: Maybe<Scalars['String']['output']>;
  zoneBasedAccessorialMatrixItem?: Maybe<ZoneBasedAccessorialMatrixItemEntity>;
  zoneBasedAccessorialZoneUuid?: Maybe<Scalars['String']['output']>;
};

export enum CustomChargeRatingWarning {
  PercentageZeroBase = 'PERCENTAGE_ZERO_BASE'
}

export type CustomChargeUpdateInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description: Scalars['String']['input'];
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  isAutoApplied?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomChargeUpsertInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  isAutoApplied?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomCostEntity = {
  __typename?: 'CustomCostEntity';
  accessorialRange?: Maybe<AccessorialRangeEntity>;
  accessorialTemplate?: Maybe<AccessorialInterface>;
  billingMethod?: Maybe<CustomChargeBillingMethod>;
  dependentSettlementBillingMethod?: Maybe<DependentSettlementBillingMethod>;
  description?: Maybe<Scalars['String']['output']>;
  /** The flat rate of the custom cost in dollars, if it exists */
  flatRateUsdDollars?: Maybe<Scalars['Float']['output']>;
  /** The fuel surcharge rate for the custom cost expressed as a percentage out of 100, if it exists */
  fuelSurchargeRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The percentage rate for the custom cost as a percentage out of 100 if it exists */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  quantity: Scalars['Float']['output'];
  /** The rate of the custom cost in dollars, if it exists */
  rateUsdDollars?: Maybe<Scalars['Float']['output']>;
  specialAccessorialMatrixItem?: Maybe<SpecialAccessorialMatrixItemEntity>;
  totalAmountUsdCents: Scalars['Float']['output'];
  /** The total cost for the custom cost in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars?: Maybe<Scalars['Float']['output']>;
  zoneBasedAccessorialMatrixItem?: Maybe<ZoneBasedAccessorialMatrixItemEntity>;
};

export type CustomDocumentNameEntity = {
  __typename?: 'CustomDocumentNameEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CustomerAppointmentAcknowledgementOutput = {
  __typename?: 'CustomerAppointmentAcknowledgementOutput';
  /** Copy confirming what was done and what happens next. */
  message: Scalars['String']['output'];
};

export type CustomerAppointmentAcknowledgementResult = CustomerAppointmentAcknowledgementOutput | MutationErrorOutput;

export type CustomerAppointmentInvitationEntity = {
  __typename?: 'CustomerAppointmentInvitationEntity';
  /** The appointment already booked, when there is one. */
  bookedAppointment?: Maybe<CustomerBookedAppointmentEntity>;
  /** Whether to offer the "send me a new link" button. True only for EXPIRED: a link is never reissued automatically, and a live link does not need replacing. */
  canRequestNewLink: Scalars['Boolean']['output'];
  /** The company the customer is dealing with, so every state of the page names the party handling the shipment. Null when the token named nothing, or when the company has no name recorded. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** A phone number for that company, so no state of the page is a dead end. Null when the token named nothing, or when no number is configured. */
  companyPhone?: Maybe<Scalars['String']['output']>;
  /** Copy to show the customer. Always present when the status is not BOOKABLE, and always ends with a way to reach a human, so no state of this page is ever a dead end. */
  message?: Maybe<Scalars['String']['output']>;
  /** Access notes the customer previously supplied, so a reschedule can prefill rather than silently discard them. PLAIN TEXT, never HTML. */
  notes?: Maybe<Scalars['String']['output']>;
  /** How many self-service changes are left on this invitation under the company allowance, so the page can name the number instead of hedging. An ALLOWANCE, not a permission: `status` is what says whether a change is possible right now. Null when the token named nothing. */
  selfReschedulesRemaining?: Maybe<Scalars['Int']['output']>;
  /** The address being serviced, on one line, so the customer can confirm the link is about the shipment they think it is. */
  serviceAddress?: Maybe<Scalars['String']['output']>;
  /** Bookable windows, read LIVE at request time rather than snapshotted when the link was sent. Empty is an ordinary answer, and means no time is currently offerable -- the customer is pointed at the exceptions path instead. */
  slots: Array<CustomerAppointmentSlotEntity>;
  status: CustomerAppointmentInvitationStatus;
  /** PICKUP or DELIVERY, for wording the page. Null when the stop has no type recorded. */
  stopType?: Maybe<Scalars['String']['output']>;
};

/** What a customer scheduling link currently permits. */
export enum CustomerAppointmentInvitationStatus {
  AwaitingOnHand = 'AWAITING_ON_HAND',
  Bookable = 'BOOKABLE',
  BookedFinal = 'BOOKED_FINAL',
  BookedReschedulable = 'BOOKED_RESCHEDULABLE',
  Expired = 'EXPIRED',
  NotBookable = 'NOT_BOOKABLE',
  NotFound = 'NOT_FOUND',
  Revoked = 'REVOKED'
}

export type CustomerAppointmentSlotEntity = {
  __typename?: 'CustomerAppointmentSlotEntity';
  /** When the appointment window ends. */
  endsAt: Scalars['DateTime']['output'];
  /** The service day this window belongs to, as YYYY-MM-DD. On an overnight window this is the day the window OPENS, which is not always the calendar day of startsAt. */
  serviceDateIso8601: Scalars['String']['output'];
  /** When the appointment window begins. */
  startsAt: Scalars['DateTime']['output'];
  /** IANA time zone the window should be displayed in. This is the SERVICING location time zone, which is not always the company one, and is what the customer expects to read their delivery window in. */
  timeZone: Scalars['String']['output'];
};

export type CustomerAppointmentTokenInput = {
  /** The opaque token from the scheduling link. Possession of it is the whole of the authorization on this surface. A token that is malformed, unknown, expired or revoked is answered identically, and never as a validation error. */
  token: Scalars['String']['input'];
};

export type CustomerBookedAppointmentEntity = {
  __typename?: 'CustomerBookedAppointmentEntity';
  endsAt: Scalars['DateTime']['output'];
  /** The booked service day, as YYYY-MM-DD. */
  serviceDateIso8601: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  /** IANA time zone the window should be displayed in. */
  timeZone: Scalars['String']['output'];
};

export type CustomerContactCreateInput = {
  /** Accessorial group assigned to this customer. Members are unioned with the customer accessorial allow-list; customer-specific accessorials are never filtered by it. */
  accessorialGroupId?: InputMaybe<Scalars['String']['input']>;
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment?: InputMaybe<Scalars['Boolean']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  billingContactEmail: Scalars['String']['input'];
  billingCycle?: InputMaybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: InputMaybe<Scalars['Float']['input']>;
  billingRunStart: Scalars['DateTime']['input'];
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  calculateInboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateLineHaulFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateOutboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmailCreateInputs?: InputMaybe<Array<ContactEmailCreateInput>>;
  contactPersonCreateInputs?: InputMaybe<Array<ContactPersonCreateInput>>;
  contactReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customerPortalChargesVisibleFrom?: InputMaybe<CustomerPortalChargesVisibility>;
  defaultAddressCreateInput?: InputMaybe<AddressCreateInput>;
  defaultContactPersonCreateInput?: InputMaybe<ContactPersonCreateInput>;
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  defaultFreightBillingMethod?: InputMaybe<FreightBillingMethod>;
  defaultFreightClass?: InputMaybe<FreightClass>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceTransmissionMethod?: InputMaybe<InvoiceTransmissionMethod>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['input'];
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultUseTariff?: InputMaybe<Scalars['Boolean']['input']>;
  dimensionalWeightFactorCreateInputs?: InputMaybe<Array<DimensionalWeightCreateInput>>;
  displayChargesInCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  displayName: Scalars['String']['input'];
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  enableCustomerPortalInventory?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomerPortalOrderEntry: Scalars['Boolean']['input'];
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  includeInExpeditorsScorecard?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This field no longer affects invoices and will be removed. */
  invoiceNotes?: InputMaybe<Scalars['String']['input']>;
  invoiceTimePeriodSplit?: InputMaybe<TimePeriod>;
  isActive: Scalars['Boolean']['input'];
  isPrepaidOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  numberOfOrdersPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  packageSpecIds?: InputMaybe<Array<Scalars['String']['input']>>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopContactId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingCustomerName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  referenceNumberLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['input'];
  /** Service group assigned to this customer. Its members are unioned with serviceUuids at read time; null resolves exactly as before groups existed. */
  serviceGroupId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated ServiceLevel is deprecated and unused. */
  serviceLevels?: InputMaybe<Array<ServiceLevel>>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated 12/03/24: Field is now deprecated, should be removed */
  shortCode?: InputMaybe<Scalars['String']['input']>;
  showEdiReferenceNumbersOnOrderPage?: InputMaybe<Scalars['Boolean']['input']>;
  skipFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  useCustomPackageSpecs?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomVehicleTypes?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerContactEntity = ContactEntity & {
  __typename?: 'CustomerContactEntity';
  accessorialGroupId?: Maybe<Scalars['String']['output']>;
  addresses: Array<AddressEntity>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment: Scalars['Boolean']['output'];
  apiName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay90: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay180: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay270: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay360: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay720: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPayAll: Scalars['Float']['output'];
  /** The customer balance for the contact in dollars */
  balance: Scalars['Float']['output'];
  billingContactEmail?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: Maybe<Scalars['Float']['output']>;
  billingPeriodDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  billingRunStart: Scalars['DateTime']['output'];
  businessDivision?: Maybe<BusinessDivisionEntity>;
  calculateInboundFreightCharges: Scalars['Boolean']['output'];
  calculateLineHaulFreightCharges: Scalars['Boolean']['output'];
  calculateOutboundFreightCharges: Scalars['Boolean']['output'];
  chargeMatrixColumnMappings: Array<ContactChargeMatrixColumnMappingEntity>;
  company: CompanyEntity;
  /** Returns at most 100 most-recent contact comments. Callers needing full enumeration must use a paginated query (TODO: expose contactCommentsConnection). */
  contactComments: Array<ContactCommentEntity>;
  contactOpenInvoiceValue: Scalars['Float']['output'];
  contactOpenInvoiceValue0to30d: Scalars['Float']['output'];
  contactOpenInvoiceValue31to38d: Scalars['Float']['output'];
  contactOpenInvoiceValue39to45d: Scalars['Float']['output'];
  contactOpenInvoiceValue46to60d: Scalars['Float']['output'];
  contactOpenInvoiceValue61to75d: Scalars['Float']['output'];
  contactOpenInvoiceValueOver75d: Scalars['Float']['output'];
  contactPersons: Array<ContactPersonEntity>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactStations: Array<ContactStationEntity>;
  contactStatistics: ContactStatsEntity;
  creditHoldLimitInCents?: Maybe<Scalars['Float']['output']>;
  creditsAppliedToContactInvoices: Scalars['Float']['output'];
  customDunningReportFooter?: Maybe<Scalars['String']['output']>;
  customerAccessorials: Array<AccessorialUnion>;
  customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility;
  customerTariffs: Array<TariffEntity>;
  debitsAppliedToContactInvoices: Scalars['Float']['output'];
  defaultAddress?: Maybe<AddressEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  defaultDimFactor?: Maybe<Scalars['Float']['output']>;
  defaultEfmHandlingStation?: Maybe<Scalars['String']['output']>;
  defaultFreightBillingMethod?: Maybe<FreightBillingMethod>;
  defaultFreightClass?: Maybe<FreightClass>;
  defaultFuelSurcharge?: Maybe<Scalars['Float']['output']>;
  defaultInboundEdiService?: Maybe<ServiceEntity>;
  defaultInboundOutboundEdiService?: Maybe<ServiceEntity>;
  defaultInvoiceDocumentsRequired: Array<DocumentType>;
  defaultInvoiceDownloadDocuments: Array<DocumentType>;
  defaultInvoiceEmailSubject?: Maybe<Scalars['String']['output']>;
  defaultInvoiceTerms?: Maybe<InvoiceTermEntity>;
  defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod;
  defaultInvoiceType: InvoiceType;
  defaultLineHaulTariffChain?: Maybe<TariffChainEntity>;
  defaultOrdinaryTariffChain?: Maybe<TariffChainEntity>;
  defaultOutboundEdiService?: Maybe<ServiceEntity>;
  defaultPointToPointTariffChain?: Maybe<TariffChainEntity>;
  defaultRecoveryTariffChain?: Maybe<TariffChainEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['output'];
  defaultTransferTariffChain?: Maybe<TariffChainEntity>;
  defaultUseTariff?: Maybe<Scalars['Boolean']['output']>;
  defaultVehicleType?: Maybe<VehicleTypeEntity>;
  /** The delivery discount rate as a percentage out of 100 if it exists */
  deliveryDiscountRate?: Maybe<Scalars['Percent']['output']>;
  dimFactor: Scalars['Int']['output'];
  displayChargesInCustomerPortal: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  ediPartnership?: Maybe<EdiPartnershipEntity>;
  ediPartnerships: Array<EdiPartnershipEntity>;
  /** The tariff chain rating uses for each tariff type, in the order Ordinary, Line haul, Transfer, Recovery, Point to point: the contact's own chain, else the company default. A type with neither has no entry, and Recovery has none while the company has recovery tariffs off. */
  effectiveTariffChains: Array<EffectiveTariffChainEntity>;
  /** The contact's addresses on a SendGrid suppression list (bounce, invalid email or spam report). Emails to them are skipped. */
  emailSuppressions: Array<EmailSuppressionEntity>;
  emitPieceLevelWebhooks: Scalars['Boolean']['output'];
  enableCreditHold?: Maybe<Scalars['Boolean']['output']>;
  enableCustomerPortalInventory: Scalars['Boolean']['output'];
  enableCustomerPortalOrderEntry: Scalars['Boolean']['output'];
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  includeInExpeditorsScorecard: Scalars['Boolean']['output'];
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This field no longer affects invoices and will be removed. */
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfColumns: Array<PdfColumnEntity>;
  invoiceTimePeriodSplit?: Maybe<TimePeriod>;
  invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName;
  isActive: Scalars['Boolean']['output'];
  isEfm?: Maybe<Scalars['Boolean']['output']>;
  isOverCreditLimit: Scalars['Boolean']['output'];
  isPrepaidOnly: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  /** The line haul discount rate as a percentage out of 100 if it exists */
  lineHaulDiscountRate?: Maybe<Scalars['Percent']['output']>;
  logo?: Maybe<DocumentEntity>;
  logoType?: Maybe<DocumentEntity>;
  masterAccount?: Maybe<MasterAccountEntity>;
  maxDaysOutstanding?: Maybe<Scalars['Float']['output']>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  /** Dollars of the contact credit memos taken up by debit memo offsets */
  offsetCredits: Scalars['Float']['output'];
  /** Dollars of the contact debit memos used to offset payments or credit memos */
  offsetDebits: Scalars['Float']['output'];
  /** Dollars of the contact payments taken up by debit memo offsets */
  offsetPayments: Scalars['Float']['output'];
  /** Returns at most 100 most-recent orders where this contact is the billing party. Callers needing full enumeration must use the paginated orders query (TODO: expose ordersConnection). */
  orders: Array<OrderEntity>;
  overdueInvoices: Array<InvoiceEntity>;
  packageSpecs: Array<PackageSpecEntity>;
  paymentsAppliedToContactInvoices: Scalars['Float']['output'];
  /** The pickup discount rate as a percentage out of 100 if it exists */
  pickupDiscountRate?: Maybe<Scalars['Percent']['output']>;
  /** Total closed balance across all posted invoices */
  postedInvoicesTotalClosedBalance: Scalars['Float']['output'];
  /** Total open balance across all posted invoices */
  postedInvoicesTotalOpenBalance: Scalars['Float']['output'];
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopContactId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId?: Maybe<Scalars['String']['output']>;
  /** The recovery discount rate as a percentage out of 100 if it exists */
  recoveryDiscountRate?: Maybe<Scalars['Percent']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['output'];
  requireScanToAdvancePieceStatusAtStops: Scalars['Boolean']['output'];
  /** Billing method new freight charges for this customer default to: the stored method, else the legacy tariff flag, else FLAT_RATE. */
  resolvedFreightBillingMethod: FreightBillingMethod;
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  services: Array<ServiceEntity>;
  shortCode?: Maybe<Scalars['String']['output']>;
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  skipFuelCharge?: Maybe<Scalars['Boolean']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  tariffZones: Array<TariffZoneEntity>;
  /** @deprecated placeholder since the column was dropped from the table */
  thirdPartyContactType?: Maybe<ThirdPartyContactType>;
  totalCredits: Scalars['Float']['output'];
  totalDebits: Scalars['Float']['output'];
  totalInvoicesAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPostedInvoicesAmount: Scalars['Float']['output'];
  /** The transfer discount rate as a percentage out of 100 if it exists */
  transferDiscountRate?: Maybe<Scalars['Percent']['output']>;
  /** @deprecated Contact type is deprecated. The column has been dropped from the db */
  type: ContactType;
  unappliedCredits?: Maybe<Scalars['Float']['output']>;
  unappliedDebits: Scalars['Float']['output'];
  unappliedPayments: Scalars['Float']['output'];
  /** Invoices QuickBooks has not accepted yet that bill to this contact. Changing the contact mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  useCustomPackageSpecs: Scalars['Boolean']['output'];
  useCustomVehicleTypes: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  vehicleTypes: Array<VehicleTypeEntity>;
};


export type CustomerContactEntityContactOpenInvoiceValueArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue0to30dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue31to38dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue39to45dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue46to60dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue61to75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValueOver75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};

export type CustomerContactUpdateInput = {
  /** Accessorial group assigned to this customer. Members are unioned with the customer accessorial allow-list; customer-specific accessorials are never filtered by it. */
  accessorialGroupId?: InputMaybe<Scalars['String']['input']>;
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment?: InputMaybe<Scalars['Boolean']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  billingContactEmail?: InputMaybe<Scalars['String']['input']>;
  billingCycle?: InputMaybe<BillingCycleType>;
  billingCycleDuration?: InputMaybe<BillingCycleDuration>;
  billingPeriod?: InputMaybe<Scalars['Float']['input']>;
  billingRunStart?: InputMaybe<Scalars['DateTime']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  calculateInboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateLineHaulFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateOutboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  contactReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  creditHoldLimitInCents?: InputMaybe<Scalars['Float']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customerPortalChargesVisibleFrom?: InputMaybe<CustomerPortalChargesVisibility>;
  defaultAddressUuid?: InputMaybe<Scalars['String']['input']>;
  defaultContactPersonUuid?: InputMaybe<Scalars['String']['input']>;
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  defaultFreightBillingMethod?: InputMaybe<FreightBillingMethod>;
  defaultFreightClass?: InputMaybe<FreightClass>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceDocumentsRequired?: InputMaybe<Array<DocumentType>>;
  defaultInvoiceDownloadDocuments?: InputMaybe<Array<DocumentType>>;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceTermUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceTransmissionMethod?: InputMaybe<InvoiceTransmissionMethod>;
  defaultInvoiceType?: InputMaybe<InvoiceType>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultServicePickupsDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultUseTariff?: InputMaybe<Scalars['Boolean']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for delivery stop types. Note that this is a percentage out of 100 */
  deliveryDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  displayChargesInCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  enableCreditHold?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomerPortalInventory?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomerPortalOrderEntry?: InputMaybe<Scalars['Boolean']['input']>;
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  includeInExpeditorsScorecard?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This field no longer affects invoices and will be removed. */
  invoiceNotes?: InputMaybe<Scalars['String']['input']>;
  invoiceTimePeriodSplit?: InputMaybe<TimePeriod>;
  invoiceVendorDisplayName?: InputMaybe<OrganizationInvoiceVendorDisplayName>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPrepaidOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for line-haul. Note that this is a percentage out of 100 */
  lineHaulDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  logoDocumentUuid?: InputMaybe<Scalars['String']['input']>;
  logoTypeDocumentUuid?: InputMaybe<Scalars['String']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  maxDaysOutstanding?: InputMaybe<Scalars['Float']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  numberOfOrdersPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  packageSpecIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount rate to apply to non-flat rate freight charges for pickup stop types. Note that this is a percentage out of 100 */
  pickupDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopContactId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingCustomerName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for recovery stop types. Note that this is a percentage out of 100 */
  recoveryDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  referenceNumberLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  requireDriverToCheckOffPackagesAtStop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Service group assigned to this customer. Its members are unioned with serviceUuids at read time; null resolves exactly as before groups existed. */
  serviceGroupId?: InputMaybe<Scalars['String']['input']>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated 12/03/24: Field is now deprecated, should be removed */
  shortCode?: InputMaybe<Scalars['String']['input']>;
  showChargesOnCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  showEdiReferenceNumbersOnOrderPage?: InputMaybe<Scalars['Boolean']['input']>;
  skipFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for transfer stop types. Note that this is a percentage out of 100 */
  transferDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  /** @deprecated 12/27/24: Field is now deprecated because the column is being dropped, should be removed */
  type?: InputMaybe<ContactType>;
  useCustomPackageSpecs?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomVehicleTypes?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerFieldsEntity = {
  __typename?: 'CustomerFieldsEntity';
  accessorialGroupId?: Maybe<Scalars['String']['output']>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment: Scalars['Boolean']['output'];
  businessDivisionUuid?: Maybe<Scalars['String']['output']>;
  calculateInboundFreightCharges: Scalars['Boolean']['output'];
  calculateLineHaulFreightCharges: Scalars['Boolean']['output'];
  calculateOutboundFreightCharges: Scalars['Boolean']['output'];
  customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility;
  /** equivalent to the ContactVehicleType table */
  customerVehicleTypes: Array<CustomerVehicleTypeEntity>;
  defaultAddressUuid?: Maybe<Scalars['String']['output']>;
  defaultDimFactor?: Maybe<Scalars['Float']['output']>;
  defaultFreightBillingMethod?: Maybe<FreightBillingMethod>;
  defaultFreightClass?: Maybe<FreightClass>;
  defaultFuelSurcharge?: Maybe<Scalars['Float']['output']>;
  defaultInboundEdiServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultInboundOutboundEdiServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultLineHaulTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultOrdinaryTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultOutboundEdiServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultPointToPointTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultRecoveryTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultTransferTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultUseTariff: Scalars['Boolean']['output'];
  displayChargesInCustomerPortal: Scalars['Boolean']['output'];
  duplicateOrderMergeWindowHours?: Maybe<Scalars['Int']['output']>;
  emitPieceLevelWebhooks: Scalars['Boolean']['output'];
  enableCustomerPortalInventory: Scalars['Boolean']['output'];
  enableCustomerPortalOrderEntry: Scalars['Boolean']['output'];
  includeInExpeditorsScorecard: Scalars['Boolean']['output'];
  invoiceOrOrderIdentifier?: Maybe<Scalars['String']['output']>;
  isPrepaidOnly: Scalars['Boolean']['output'];
  referenceNumberLabels: Array<CustomerReferenceNumberLabelEntity>;
  resolvedFreightBillingMethod: FreightBillingMethod;
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  services: Array<CustomerServiceEntity>;
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  useCustomVehicleTypes: Scalars['Boolean']['output'];
};

export enum CustomerFilterMode {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export type CustomerNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** From which point in an order's life the customer portal shows its charges (TMS-2339). */
export enum CustomerPortalChargesVisibility {
  AfterCompletion = 'AFTER_COMPLETION',
  AfterFinalization = 'AFTER_FINALIZATION',
  AfterInvoicing = 'AFTER_INVOICING',
  Always = 'ALWAYS'
}

export type CustomerPortalConfigurationEntity = {
  __typename?: 'CustomerPortalConfigurationEntity';
  defaultDimFactor?: Maybe<Scalars['Int']['output']>;
  logisticsSectionEnabled: Scalars['Boolean']['output'];
  /** @deprecated Terminals are always enabled. */
  terminalsEnabled: Scalars['Boolean']['output'];
};

/** Review status of an order in the customer portal */
export enum CustomerPortalOrderReviewStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** A filter object that is used to filter the customer portal order review status. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type CustomerPortalOrderReviewStatusFilter = {
  /** Filters for records where the order review status matches the provided value */
  eq?: InputMaybe<CustomerPortalOrderReviewStatus>;
  /** Filters for records where the order review status is in the provided values */
  in?: InputMaybe<Array<CustomerPortalOrderReviewStatus>>;
  /** Filters for records where the order review status does not match the provided value */
  neq?: InputMaybe<CustomerPortalOrderReviewStatus>;
  /** Filters for records where the order review status is not in the provided values */
  nin?: InputMaybe<Array<CustomerPortalOrderReviewStatus>>;
};

export type CustomerPortalOrderStatusBucketInput = {
  /** The order is dispatched (assigned to a route dated today) */
  dispatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order has one or more failed/attempted stops */
  hasFailures?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order is planned (assigned to a future-dated route) */
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order status must be one of these values */
  statusIn?: InputMaybe<Array<OrderStatus>>;
};

export type CustomerPortalPiecesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the company whose portal is being viewed. */
  companyUuid: Scalars['String']['input'];
  /** Narrow to a single customer the caller is linked to. Intersected with the caller's contacts server-side. */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Case-insensitive search across piece reference number, order name, customer (billing party) display name, and the linked order HAWB (house bill or shipper BOL) / MAWB. */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Sort order; first element has highest priority */
  sorts?: InputMaybe<Array<FindPiecesSort>>;
};

export type CustomerProfitabilityArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerProfitabilityBucketEntity = {
  __typename?: 'CustomerProfitabilityBucketEntity';
  actualContributionRatio?: Maybe<Scalars['Float']['output']>;
  customerName: Scalars['String']['output'];
  customerUuid: Scalars['String']['output'];
  revenueUsd: Scalars['Float']['output'];
  shipmentCount: Scalars['Int']['output'];
  status?: Maybe<ProfitabilityStatus>;
  totalMiles: Scalars['Float']['output'];
  totalWeightLbs: Scalars['Float']['output'];
  variableCostUsd?: Maybe<Scalars['Float']['output']>;
};

export type CustomerProfitabilityReportEntity = {
  __typename?: 'CustomerProfitabilityReportEntity';
  appliedRates?: Maybe<ProfitabilityCostAssumptionEntity>;
  breakevenContributionRatio?: Maybe<Scalars['Float']['output']>;
  costBasis: CostBasis;
  customers: Array<CustomerProfitabilityBucketEntity>;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  hasCostAssumptions: Scalars['Boolean']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  operatingRatio?: Maybe<Scalars['Float']['output']>;
  proratedFixedCostUsd?: Maybe<Scalars['Float']['output']>;
  proratedOverheadCostUsd?: Maybe<Scalars['Float']['output']>;
  totalRevenueUsd: Scalars['Float']['output'];
  totalVariableCostUsd?: Maybe<Scalars['Float']['output']>;
};

export type CustomerReferenceNumberLabelEntity = {
  __typename?: 'CustomerReferenceNumberLabelEntity';
  name: Scalars['String']['output'];
};

export type CustomerReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  /** IANA zone the report reads its days in; honored only while terminal_local_times is on. When null, insight reports count each order on its stop's local service day, and the audit report uses the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerReportBucketEntity = {
  __typename?: 'CustomerReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type CustomerServiceEntity = {
  __typename?: 'CustomerServiceEntity';
  uuid: Scalars['String']['output'];
};

export type CustomerVehicleTypeEntity = {
  __typename?: 'CustomerVehicleTypeEntity';
  id: Scalars['String']['output'];
  vehicleTypeUuid: Scalars['String']['output'];
};

export type DateFilter = {
  filterOperator?: InputMaybe<FilterOperator>;
  filterType: DateFilterType;
  value: Scalars['DateTime']['input'];
};

/** Enum of predefined options including static dates and relative options(today, tomorrow, yesterday, before today). */
export enum DateFilterOptionV2 {
  BeforeToday = 'BEFORE_TODAY',
  LastXDays = 'LAST_X_DAYS',
  Static = 'STATIC',
  Today = 'TODAY',
  Tomorrow = 'TOMORROW',
  Yesterday = 'YESTERDAY'
}

export type DateFilterStartEnd = {
  endFilterValue?: InputMaybe<Scalars['DateTime']['input']>;
  filterOperator?: InputMaybe<FilterOperator>;
  startFilterValue?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DateFilterType {
  IsAfter = 'IS_AFTER',
  IsBefore = 'IS_BEFORE'
}

/** A filter object that is used to filter a date field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type DateFilterV2 = {
  /** Filters for records where the relevant date field is between the provided date range */
  between?: InputMaybe<DateRangeFilterInput>;
  /**
   * Filters for records where the relevant date field is equal to the provided date value. Deprecated: Use eqV2 instead.
   * @deprecated Use eqV2 for more flexible date filtering
   */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is equal to a relative date value. eqV2 is to allow for smooth transition from only string dates to the new FilterDateInput system */
  eqV2?: InputMaybe<DateFilterValueInput>;
  /** Filters for records where the relevant date field is greater than the provided date value */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is greater than or equal to the provided date value */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is in the provided date values */
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** Filters for records where the relevant date field is blank */
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant date field is not blank */
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant date field is less than the provided date value */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is less than or equal to the provided date value */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is not equal to the provided date value */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is not in the provided date values */
  nin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Date filter fields for the findLineHaulManifestsV2 query */
export type DateFilterV2Simple = {
  /** Filters for records where the relevant date field is equal to the provided date value. Deprecated: Use eqV2 instead. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Object that represents the filtering input for either a static date option or a relative date option. Static dates are literal dates stored (e.g., "2024-03-15"). Relative dates are those stored as something akin to "today" or "yesterday". */
export type DateFilterValueInput = {
  /** Date value for STATIC options, null otherwise */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Enum of predefined options including static dates and relative options(today, tomorrow, yesterday, before today) */
  dateFilterOption?: InputMaybe<DateFilterOptionV2>;
  /** Number of days to offset the date. Only used for LAST_X_DAYS. */
  offsetDays: Scalars['Int']['input'];
};

export type DateMarkedOnHandSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** Object that represents the filtering input for a date range that is inclusive on both ends */
export type DateRangeFilterInput = {
  /** The end date of the inclusive date range */
  gte: Scalars['DateTime']['input'];
  /** The start date of the inclusive date range */
  lte: Scalars['DateTime']['input'];
};

export enum DayOfWeekAll {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeactivateTestTerminalInput = {
  terminalUuid: Scalars['String']['input'];
};

export enum DeadlineDateFilter {
  Overdue = 'OVERDUE',
  Today = 'TODAY',
  Tomorrow = 'TOMORROW'
}

export enum DeadlineType {
  DueBy = 'DUE_BY',
  DueOn = 'DUE_ON'
}

export type DeclineOrderDelegationInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DeclineQuoteInput = {
  orderQuoteUuid: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type DeclineQuoteOutput = DeclineQuoteSuccessOutput | MutationErrorOutput;

export type DeclineQuoteSuccessOutput = {
  __typename?: 'DeclineQuoteSuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
  status: OrderQuoteStatus;
};

export type DefaultAppointmentTextOutput = {
  __typename?: 'DefaultAppointmentTextOutput';
  appointmentUuid: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type DelegatedOrderInboxItemConnection = {
  __typename?: 'DelegatedOrderInboxItemConnection';
  edges: Array<DelegatedOrderInboxItemEdge>;
  pageInfo: PageInfo;
};

export type DelegatedOrderInboxItemEdge = {
  __typename?: 'DelegatedOrderInboxItemEdge';
  cursor: Scalars['String']['output'];
  node: DelegatedOrderInboxItemEntity;
};

export type DelegatedOrderInboxItemEntity = {
  __typename?: 'DelegatedOrderInboxItemEntity';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  duplicateOrderUuid?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  offerSummary?: Maybe<DelegationOfferSummaryEntity>;
  originatorCompanyName: Scalars['String']['output'];
  originatorCompanyUuid: Scalars['String']['output'];
  pickupHandling?: Maybe<DelegatedPickupHandling>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  scope: OrderDelegationScope;
  status: OrderDelegationStatus;
  uuid: Scalars['String']['output'];
};

export type DelegatedOrdersInboxFilterInput = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
  originatorCompanyUuid?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<OrderDelegationScope>;
  status?: InputMaybe<OrderDelegationStatus>;
};

export type DelegatedOrdersOutboxFilterInput = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  executingCompanyUuid?: InputMaybe<Scalars['String']['input']>;
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<OrderDelegationScope>;
  status?: InputMaybe<OrderDelegationStatus>;
};

/** How the non-delegated leg of a partial delegation is handled. Only valid when scope is INBOUND_ONLY or OUTBOUND_ONLY (one part supplied). CARRIER_DROP_OFF: a carrier drops freight at the executor terminal. FROM_INVENTORY: freight is already in the executor's possession. RECOVERY: the executor performs a recovery to obtain the freight. PICKUP: the executor picks up the freight at the delegator's warehouse. */
export enum DelegatedPickupHandling {
  CarrierDropOff = 'CARRIER_DROP_OFF',
  FromInventory = 'FROM_INVENTORY',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY'
}

export type DelegationAccessorialProposalEntity = {
  __typename?: 'DelegationAccessorialProposalEntity';
  appliedCustomChargeUuid?: Maybe<Scalars['String']['output']>;
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  delegationUuid: Scalars['String']['output'];
  executingCompanyName: Scalars['String']['output'];
  mappedAccessorialName?: Maybe<Scalars['String']['output']>;
  mappedAccessorialType?: Maybe<AccessorialType>;
  mappedAccessorialUuid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalChargesFinalized: Scalars['Boolean']['output'];
  quantity: Scalars['Int']['output'];
  status: DelegationAccessorialProposalStatus;
  suggestedZoneBasedMatrixItemUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** Where a partner accessorial proposal stands: waiting for the owner, applied to the original order, dismissed, or withdrawn because the partner removed it. */
export enum DelegationAccessorialProposalStatus {
  Applied = 'APPLIED',
  Dismissed = 'DISMISSED',
  Pending = 'PENDING',
  Withdrawn = 'WITHDRAWN'
}

export type DelegationEndCustomer = {
  __typename?: 'DelegationEndCustomer';
  address?: Maybe<DelegationEndCustomerAddress>;
  addressBook: Array<DelegationEndCustomerAddress>;
  addressBookTotalCount: Scalars['Int']['output'];
  billingEmails: Array<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  executorOrganization?: Maybe<DelegationEndCustomerExecutorOrganization>;
  name: Scalars['String']['output'];
  people: Array<DelegationEndCustomerPerson>;
  peopleTotalCount: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type DelegationEndCustomerAddress = {
  __typename?: 'DelegationEndCustomerAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type DelegationEndCustomerExecutorOrganization = {
  __typename?: 'DelegationEndCustomerExecutorOrganization';
  displayName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DelegationEndCustomerMatchInput = {
  orderUuid: Scalars['String']['input'];
  peerUuid: Scalars['String']['input'];
};

export type DelegationEndCustomerPerson = {
  __typename?: 'DelegationEndCustomerPerson';
  emails: Array<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type DelegationOfferSummaryEntity = {
  __typename?: 'DelegationOfferSummaryEntity';
  deliveryLocation?: Maybe<OfferLocationEntity>;
  earliestServiceDate?: Maybe<Scalars['String']['output']>;
  hazmat: Scalars['Boolean']['output'];
  inBond: Scalars['Boolean']['output'];
  offerNote?: Maybe<Scalars['String']['output']>;
  packageCount: Scalars['Int']['output'];
  pickupLocation?: Maybe<OfferLocationEntity>;
  refNumbers: Array<Scalars['String']['output']>;
  scope: OrderDelegationScope;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  version: Scalars['Int']['output'];
  weightUnits?: Maybe<Scalars['String']['output']>;
};

export type DeleteAccessorialDateRangeConfigInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteContactCommentInput = {
  /** The UUID of the contact comment to be deleted */
  uuid: Scalars['String']['input'];
};

export type DeleteContactCommentOutput = DeleteContactCommentSuccessOutput | MutationErrorOutput;

export type DeleteContactCommentSuccessOutput = {
  __typename?: 'DeleteContactCommentSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteContactEmailInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteDriverCredentialTypeInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteEdiPartnershipServiceMappingsInput = {
  ediPartnershipUuid: Scalars['String']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type DeleteEdiPartnershipServiceMappingsOutput = {
  __typename?: 'DeleteEdiPartnershipServiceMappingsOutput';
  deletedUuids: Array<Scalars['String']['output']>;
};

export type DeleteEdiTypedReferenceMappingsInput = {
  ediPartnershipUuid: Scalars['String']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type DeleteEdiTypedReferenceMappingsOutput = {
  __typename?: 'DeleteEdiTypedReferenceMappingsOutput';
  deletedUuids: Array<Scalars['String']['output']>;
};

export type DeleteFeatureFlagCompanyOverrideInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteFeatureFlagUserOverrideInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteFuelProfileDateRangeInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteFuelProfileDateRangeOutput = {
  __typename?: 'DeleteFuelProfileDateRangeOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteGeneralLedgerCodeOutput = DeleteGeneralLedgerCodeSuccessOutput | MutationErrorOutput;

export type DeleteGeneralLedgerCodeSuccessOutput = {
  __typename?: 'DeleteGeneralLedgerCodeSuccessOutput';
  id: Scalars['String']['output'];
};

export type DeleteInventoryCountInput = {
  inventoryCountUuid: Scalars['String']['input'];
};

export type DeleteInventoryCountOutput = DeletedInventoryCountOutput | MutationErrorOutput;

export type DeleteInventoryItemsInput = {
  itemUuid: Scalars['String']['input'];
  /** The number of inventory items to be deleted for the specified storage order */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
};

export type DeleteInventoryItemsOutput = {
  __typename?: 'DeleteInventoryItemsOutput';
  /** The number of inventory items that were deleted */
  quantity: Scalars['Int']['output'];
};

export type DeleteOrderCommentInput = {
  /** The UUID of the order comment to be deleted */
  uuid: Scalars['String']['input'];
};

export type DeleteOrderCommentOutput = DeleteOrderCommentSuccessOutput | MutationErrorOutput;

export type DeleteOrderCommentSuccessOutput = {
  __typename?: 'DeleteOrderCommentSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteOrderDelegationRuleInput = {
  ruleUuid: Scalars['String']['input'];
};

export type DeletePermissionInput = {
  uuid: Scalars['String']['input'];
};

export type DeletePermissionOutput = {
  __typename?: 'DeletePermissionOutput';
  success: Scalars['Boolean']['output'];
};

export type DeletePieceReceiptInput = {
  /** UUID of the piece receipt to delete */
  uuid: Scalars['String']['input'];
};

export type DeletePieceReceiptOutput = {
  __typename?: 'DeletePieceReceiptOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteRoleInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteRoleOutput = {
  __typename?: 'DeleteRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteSchemaRunInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteSlotsFromRouteInput = {
  emitMultiplayerEvent?: InputMaybe<Scalars['Boolean']['input']>;
  routeSlotUuids: Array<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

/** The expected input for deleting a stop attempt */
export type DeleteStopAttemptInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteStopAttemptOutput = DeleteStopAttemptSuccessOutput | MutationErrorOutput;

/** The output of a successful stop attempt deletion */
export type DeleteStopAttemptSuccessOutput = {
  __typename?: 'DeleteStopAttemptSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteStorageOrderInput = {
  /** The UUID of the storage order to delete */
  uuid: Scalars['String']['input'];
};

export type DeleteStorageOrderOutput = {
  __typename?: 'DeleteStorageOrderOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteStorageOrdersInput = {
  /** The UUIDs of the storage order to delete */
  uuids: Array<Scalars['String']['input']>;
};

export type DeleteStorageOrdersOutput = {
  __typename?: 'DeleteStorageOrdersOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteStorageUnitInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteStorageUnitOutput = {
  __typename?: 'DeleteStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteTariffLocationInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteTariffLocationOutput = {
  __typename?: 'DeleteTariffLocationOutput';
  tariffLocation: TariffLocationEntity;
};

export type DeleteTerminalLanesInput = {
  /** The IDs of the TerminalLaneEntities to delete. */
  terminalLaneIds: Array<Scalars['String']['input']>;
};

export type DeleteTerminalLanesOutput = DeleteTerminalLanesSuccessOutput | MutationErrorOutput;

export type DeleteTerminalLanesSuccessOutput = {
  __typename?: 'DeleteTerminalLanesSuccessOutput';
  /** All of the company’s terminal lanes after deleting */
  terminalLanes: Array<TerminalLaneEntity>;
};

export type DeleteUserInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteWarehouseLocationImpact = {
  __typename?: 'DeleteWarehouseLocationImpact';
  inventoryItemsCount: Scalars['Int']['output'];
  itemGroupsCount: Scalars['Int']['output'];
  packagesCount: Scalars['Int']['output'];
  piecesCount: Scalars['Int']['output'];
  storageUnitsCount: Scalars['Int']['output'];
};

export type DeleteWarehouseLocationInput = {
  /** When true, confirms you understand deleting the location will clear any assigned locations from related entities. */
  confirmRemoveLocations?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the warehouse location to be deleted */
  uuid: Scalars['String']['input'];
};

export type DeleteWarehouseLocationOutput = {
  __typename?: 'DeleteWarehouseLocationOutput';
  /** Counts of entities currently referencing this location. These references will have their locations cleared on delete. */
  impact: DeleteWarehouseLocationImpact;
  /** True when the location cannot be deleted yet because a second confirmation is required. */
  requiresSecondConfirmation: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeletedInventoryCountOutput = {
  __typename?: 'DeletedInventoryCountOutput';
  uuid: Scalars['String']['output'];
};

export type DeletedPackageInput = {
  /** The top-level pieces the form loaded on this package. */
  loadedPieceUuids: Array<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DeliveryFailureGroupRowEntity = {
  __typename?: 'DeliveryFailureGroupRowEntity';
  failedStops: Scalars['Int']['output'];
  failurePct?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  settledStops: Scalars['Int']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type DeliveryFailureKpiEntity = {
  __typename?: 'DeliveryFailureKpiEntity';
  bucketUnit: KpiTrendBucketUnit;
  customers: Array<DeliveryFailureGroupRowEntity>;
  deliveredLateDayStops: Scalars['Int']['output'];
  deliveredStops: Scalars['Int']['output'];
  drivers: Array<DeliveryFailureGroupRowEntity>;
  failedStops: Scalars['Int']['output'];
  failurePct?: Maybe<Scalars['Float']['output']>;
  forceMarkedCompleteStops: Scalars['Int']['output'];
  neverDeliveredStops: Scalars['Int']['output'];
  pendingStops: Scalars['Int']['output'];
  scheduledStops: Scalars['Int']['output'];
  settledStops: Scalars['Int']['output'];
  stops: Array<DeliveryFailureStopRowEntity>;
  terminals: Array<DeliveryFailureGroupRowEntity>;
  trend: Array<DeliveryFailureTrendBucketEntity>;
};

export type DeliveryFailureStopRowEntity = {
  __typename?: 'DeliveryFailureStopRowEntity';
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  customerName: Scalars['String']['output'];
  daysLate: Scalars['Int']['output'];
  driverNames: Array<Scalars['String']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  fileNo?: Maybe<Scalars['String']['output']>;
  fromDeadline: Scalars['Boolean']['output'];
  orderUuid: Scalars['String']['output'];
  outcome: KpiFailedDeliveryOutcome;
  promisedDate: Scalars['String']['output'];
  stopStatus: Scalars['String']['output'];
  stopTimeZone: Scalars['String']['output'];
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type DeliveryFailureStopsEntity = {
  __typename?: 'DeliveryFailureStopsEntity';
  facets: KpiRecordFacetsEntity;
  stops: Array<DeliveryFailureStopRowEntity>;
  totalStops: Scalars['Int']['output'];
};

export type DeliveryFailureTrendBucketEntity = {
  __typename?: 'DeliveryFailureTrendBucketEntity';
  bucketDate: Scalars['String']['output'];
  failedStops: Scalars['Int']['output'];
  failurePct?: Maybe<Scalars['Float']['output']>;
  settledStops: Scalars['Int']['output'];
};

export enum DependentSettlementBillingMethod {
  AutoCalculate = 'AUTO_CALCULATE',
  FlatRate = 'FLAT_RATE',
  Percentage = 'PERCENTAGE'
}

export type DestinationDetailsSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum DestinationStopType {
  Delivery = 'DELIVERY',
  PartnerPickup = 'PARTNER_PICKUP',
  Transfer = 'TRANSFER'
}

export type DestinationTerminalSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type DetachDocumentsFromShipmentsInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type DimWeightSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type DimensionalWeightCreateInput = {
  factor: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  type: DimensionalWeightFactorType;
};

export enum DimensionalWeightFactorType {
  CompanyLevel = 'COMPANY_LEVEL',
  ContactSpecific = 'CONTACT_SPECIFIC'
}

export type DismissDelegationAccessorialProposalInput = {
  uuid: Scalars['String']['input'];
};

export type DismissQuoteInput = {
  orderQuoteUuid: Scalars['String']['input'];
};

export type DismissQuoteOutput = DismissQuoteSuccessOutput | MutationErrorOutput;

export type DismissQuoteSuccessOutput = {
  __typename?: 'DismissQuoteSuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
  status: OrderQuoteStatus;
};

export type DispatchApplySuggestedManifestsInput = {
  targets: Array<DispatchSuggestedManifestTargetInput>;
};

export type DispatchApplySuggestedManifestsOutput = {
  __typename?: 'DispatchApplySuggestedManifestsOutput';
  results: Array<DispatchSuggestedManifestResult>;
};

export type DispatchAppointmentConnection = {
  __typename?: 'DispatchAppointmentConnection';
  edges: Array<DispatchAppointmentEdge>;
  pageInfo: PageInfo;
  /** Total rows matching the filters. Not cheap to calculate, request with prudence via includeCount. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum DispatchAppointmentContactChannel {
  HasContact = 'HAS_CONTACT',
  NoContact = 'NO_CONTACT'
}

export type DispatchAppointmentEdge = {
  __typename?: 'DispatchAppointmentEdge';
  cursor: Scalars['String']['output'];
  node: DispatchAppointmentEntity;
};

export type DispatchAppointmentEntity = {
  __typename?: 'DispatchAppointmentEntity';
  addressLine?: Maybe<Scalars['String']['output']>;
  appointmentOffRouteDay: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  committedWindowEnd?: Maybe<Scalars['DateTime']['output']>;
  committedWindowStart?: Maybe<Scalars['DateTime']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  customerBookingLinkOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  customerBookingLinkSentAt?: Maybe<Scalars['DateTime']['output']>;
  customerName: Scalars['String']['output'];
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  onRoute: Scalars['Boolean']['output'];
  orderName: Scalars['String']['output'];
  orderUuid?: Maybe<Scalars['String']['output']>;
  projectedArrival?: Maybe<Scalars['DateTime']['output']>;
  status: DispatchAppointmentStatus;
  stopType?: Maybe<StopType>;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  /** The stop's IANA zone the committed window is shown in while terminal_local_times is on; null while it is off. */
  timeZone?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export enum DispatchAppointmentPreset {
  All = 'ALL',
  AwaitingCustomerBooking = 'AWAITING_CUSTOMER_BOOKING',
  NoContact = 'NO_CONTACT',
  Oncoming = 'ONCOMING',
  Unconfirmed = 'UNCONFIRMED'
}

export enum DispatchAppointmentSortField {
  DeliveryDate = 'DELIVERY_DATE',
  OrderName = 'ORDER_NAME',
  ProjectedArrival = 'PROJECTED_ARRIVAL'
}

/** Appointment state shown on the board. CANCELLED is stored; the rest are derived from the legacy stop columns. DELAYED is absent on purpose: nothing records it. */
export enum DispatchAppointmentStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Executed = 'EXECUTED',
  RescheduleRequested = 'RESCHEDULE_REQUESTED',
  Scheduled = 'SCHEDULED'
}

export type DispatchAppointmentSummaryEntity = {
  __typename?: 'DispatchAppointmentSummaryEntity';
  all: Scalars['Int']['output'];
  awaitingCustomerBooking: Scalars['Int']['output'];
  noContact: Scalars['Int']['output'];
  oncoming: Scalars['Int']['output'];
  unconfirmed: Scalars['Int']['output'];
};

export type DispatchFormattedFieldValue = {
  __typename?: 'DispatchFormattedFieldValue';
  field: OrderTableField;
  value?: Maybe<Scalars['String']['output']>;
};

/** A dispatch-board column that leaf rows can be sorted by. Only columns whose displayed value is reproducible in SQL are offered. */
export enum DispatchLeafSortField {
  CurrentLocation = 'CURRENT_LOCATION',
  CustomerName = 'CUSTOMER_NAME',
  DimWeight = 'DIM_WEIGHT',
  FinalDestinationTerminal = 'FINAL_DESTINATION_TERMINAL',
  Hawb = 'HAWB',
  ManifestReference = 'MANIFEST_REFERENCE',
  Mawb = 'MAWB',
  NextLegTerminal = 'NEXT_LEG_TERMINAL',
  OrderName = 'ORDER_NAME',
  OriginTerminal = 'ORIGIN_TERMINAL',
  PieceCount = 'PIECE_COUNT',
  RoutingStatus = 'ROUTING_STATUS',
  ServiceDate = 'SERVICE_DATE',
  Weight = 'WEIGHT'
}

/** How far along the plan for one leg is, as the dispatch board's Routing status column reports it. */
export enum DispatchLegState {
  Arrived = 'ARRIVED',
  Departed = 'DEPARTED',
  DoorsClosed = 'DOORS_CLOSED',
  OnManifest = 'ON_MANIFEST',
  Proposed = 'PROPOSED',
  Routed = 'ROUTED'
}

export type DispatchLineHaulManifest = {
  __typename?: 'DispatchLineHaulManifest';
  completedAt?: Maybe<Scalars['String']['output']>;
  departDate?: Maybe<Scalars['String']['output']>;
  /** IANA zone of the end terminal, or the company zone when the terminal has none. */
  destinationTimeZone: Scalars['String']['output'];
  endTerminalCode: Scalars['String']['output'];
  estimatedArrival?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  startTerminalCode: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DispatchOrderRow = {
  __typename?: 'DispatchOrderRow';
  /** Alternative network paths, present only on a proposed row whose corridor has more than one viable route. */
  alternativeRoutes?: Maybe<Array<DispatchProposedRoute>>;
  billOfLadingNumber?: Maybe<Scalars['String']['output']>;
  /** Where the order's freight currently sits: the terminal its pieces are standing at (arrived, or loaded on a trailer that has not departed), else the last completed manifest's end terminal, else the inbound terminal once received at origin. */
  currentLocationCode?: Maybe<Scalars['String']['output']>;
  /** Whether currentLocationCode came from the freight itself rather than from a manifest-shaped fallback. Decides whether the Location cell reads "at" or "from"; see currentLocationIsLiveSql. */
  currentLocationIsLive: Scalars['Boolean']['output'];
  /** How many countable units are at currentLocationCode. Meaningful only when currentLocationIsLive; 0 otherwise. */
  currentLocationPieceCount: Scalars['Int']['output'];
  currentManifestDepartDate?: Maybe<Scalars['String']['output']>;
  currentManifestReferenceNumber?: Maybe<Scalars['String']['output']>;
  currentManifestStatus?: Maybe<Scalars['String']['output']>;
  currentManifestUuid?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  /** This segment's destination terminal (the lane's end / next stop). */
  destinationTerminalCode?: Maybe<Scalars['String']['output']>;
  dimWeight?: Maybe<Scalars['Float']['output']>;
  /** The order's final destination terminal (its outbound delivery terminal), which may differ from this segment's destination on a multi-leg order. */
  finalDestinationTerminalCode?: Maybe<Scalars['String']['output']>;
  /** The order's final destination terminal uuid, the same terminal finalDestinationTerminalCode names. A re-route has to end here. */
  finalDestinationTerminalUuid?: Maybe<Scalars['String']['output']>;
  formattedValues: Array<DispatchFormattedFieldValue>;
  /** True when the order's travelled legs already reach its final destination, so no part of its route is left to change. */
  isPathLocked: Scalars['Boolean']['output'];
  /** True when the leg is proposed (computed from the network) rather than committed to a segment. */
  isProposed: Scalars['Boolean']['output'];
  isSpecial: Scalars['Boolean']['output'];
  /** Lane this row belongs to (matches OrderLaneGroup.laneKey). */
  laneKey: Scalars['String']['output'];
  lineHaulManifests: Array<DispatchLineHaulManifest>;
  mawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The ORDER's line-haul origin terminal, the same on every leg of a multi-leg order. Order-level lineHaulOriginTerminal first, then the inbound stop's terminal; null when neither answers. */
  orderOriginTerminalCode?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  /** This segment's origin terminal (the lane's start). Differs from orderOriginTerminalCode on every leg after the first of a multi-leg order. */
  originTerminalCode?: Maybe<Scalars['String']['output']>;
  outboundServiceDate?: Maybe<Scalars['String']['output']>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  pieceStatusLocations?: Maybe<Array<PieceStatusTerminalCount>>;
  pieceTerminalLocations?: Maybe<Scalars['String']['output']>;
  piecesAwayFromRunOrigin?: Maybe<PiecesAwayFromRunOrigin>;
  /** The terminal a re-route of this order has to start from: where its travelled legs end, or its origin while none has left the dock. */
  rerouteFromTerminalCode?: Maybe<Scalars['String']['output']>;
  /** The uuid of the terminal rerouteFromTerminalCode names, for the route mutation. */
  rerouteFromTerminalUuid?: Maybe<Scalars['String']['output']>;
  /** The legs the order is routed over, in chain order. Unlike consecutive pairs of routeNodeCodes, these are never invented across a gap in a broken route. Empty means fall back to the row's own lane. */
  routeLegs: Array<DispatchRouteLeg>;
  /** True when the order's committed route does not end at its current final destination. False when the order has no committed route. */
  routeMissesDestination: Scalars['Boolean']['output'];
  /** True when the order's committed route does not start at its current origin and none of the route has travelled yet. False when the order has no committed route. */
  routeMissesOrigin: Scalars['Boolean']['output'];
  /** The leg's full route chain in terminal codes, e.g. ATL > MIA > GSP. */
  routeNodeCodes: Array<Scalars['String']['output']>;
  /** The same chain as routeNodeCodes, in terminal uuids, index-aligned with it. Consecutive pairs are the route legs only when the route has no break; see routeLegs. */
  routeNodeTerminalUuids: Array<Scalars['String']['output']>;
  segmentEndTerminalUuid?: Maybe<Scalars['String']['output']>;
  segmentStartTerminalUuid?: Maybe<Scalars['String']['output']>;
  /** Row identity, and the AG Grid getRowId value. The OrderLineHaulSegment uuid on a committed leg; on a proposed leg (isProposed) there is no segment, so it is the synthetic id `proposed:<orderUuid>:<START>><END>` and must never be passed to a mutation that expects a segment uuid. */
  segmentUuid: Scalars['String']['output'];
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  /** How many countable units the order has in total, including any at no terminal. The denominator of the Location cell's fraction. */
  totalCountablePieceCount: Scalars['Int']['output'];
  weightLbs?: Maybe<Scalars['Float']['output']>;
};

export type DispatchProposedRoute = {
  __typename?: 'DispatchProposedRoute';
  /** Ordered terminal codes, e.g. ["ATL","MIA","GSP"]. */
  nodeCodes: Array<Scalars['String']['output']>;
  /** The same chain as terminal uuids; consecutive pairs are the route legs. */
  nodeTerminalUuids: Array<Scalars['String']['output']>;
};

export type DispatchRouteLeg = {
  __typename?: 'DispatchRouteLeg';
  endTerminalCode: Scalars['String']['output'];
  startTerminalCode: Scalars['String']['output'];
};

export type DispatchSuggestedManifestFailedOrder = {
  __typename?: 'DispatchSuggestedManifestFailedOrder';
  orderName: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export enum DispatchSuggestedManifestOutcome {
  Failed = 'FAILED',
  Loaded = 'LOADED'
}

export type DispatchSuggestedManifestResult = {
  __typename?: 'DispatchSuggestedManifestResult';
  created: Scalars['Boolean']['output'];
  failedOrders: Array<DispatchSuggestedManifestFailedOrder>;
  manifestReferenceNumber?: Maybe<Scalars['String']['output']>;
  manifestUuid?: Maybe<Scalars['String']['output']>;
  orderUuids: Array<Scalars['String']['output']>;
  outcome: DispatchSuggestedManifestOutcome;
  reason?: Maybe<Scalars['String']['output']>;
};

export type DispatchSuggestedManifestTargetInput = {
  departDate?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuids: Array<Scalars['String']['input']>;
  releaseFromBlockingManifest?: InputMaybe<Scalars['Boolean']['input']>;
  startTerminalUuid: Scalars['String']['input'];
};

export type DispatchTableColorEntity = {
  __typename?: 'DispatchTableColorEntity';
  active: Scalars['Boolean']['output'];
  appointmentEndWithinMinutes?: Maybe<Scalars['Int']['output']>;
  appointmentStartWithinMinutes?: Maybe<Scalars['Int']['output']>;
  color: Scalars['String']['output'];
  deadlineDateFilter?: Maybe<DeadlineDateFilter>;
  dispatchViewId?: Maybe<Scalars['String']['output']>;
  fields: Array<DispatchTableColorField>;
  hasAppointmentDate?: Maybe<Scalars['Boolean']['output']>;
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  service?: Maybe<ServiceEntity>;
  uuid: Scalars['String']['output'];
};

export enum DispatchTableColorField {
  AppointmentEndWithin = 'APPOINTMENT_END_WITHIN',
  AppointmentPassed = 'APPOINTMENT_PASSED',
  AppointmentStartWithin = 'APPOINTMENT_START_WITHIN',
  DeadlinePassed = 'DEADLINE_PASSED',
  DeadlineToday = 'DEADLINE_TODAY',
  DeadlineTomorrow = 'DEADLINE_TOMORROW',
  HasAppointmentDate = 'HAS_APPOINTMENT_DATE',
  IsSpecial = 'IS_SPECIAL',
  Service = 'SERVICE'
}

export type DispatchTableColorUpsertInput = {
  active: Scalars['Boolean']['input'];
  /** The number of minutes within the end of the appointment for the rule to apply */
  appointmentEndWithinMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The number of minutes within the start of the appointment for the rule to apply */
  appointmentStartWithinMinutes?: InputMaybe<Scalars['Int']['input']>;
  color: Scalars['String']['input'];
  /** @deprecated Use fields instead */
  deadlineDateFilter?: InputMaybe<DeadlineDateFilter>;
  dispatchViewId?: InputMaybe<Scalars['String']['input']>;
  /** The fields that are included in the rule, all joined in a conjunction (AND operator) when determining if a rule applies to a stop */
  fields?: InputMaybe<Array<DispatchTableColorField>>;
  hasAppointmentDate?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum DispatchTableField {
  Address = 'ADDRESS',
  AddressType = 'ADDRESS_TYPE',
  Appointment = 'APPOINTMENT',
  AppointmentDate = 'APPOINTMENT_DATE',
  AppointmentOptionsProposed = 'APPOINTMENT_OPTIONS_PROPOSED',
  AppointmentRequired = 'APPOINTMENT_REQUIRED',
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  AppointmentTime = 'APPOINTMENT_TIME',
  BusinessDivision = 'BUSINESS_DIVISION',
  CanDispatch = 'CAN_DISPATCH',
  City = 'CITY',
  Consignee = 'CONSIGNEE',
  Customer = 'CUSTOMER',
  Dims = 'DIMS',
  DueDate = 'DUE_DATE',
  Eta = 'ETA',
  HasAppointment = 'HAS_APPOINTMENT',
  InboundCity = 'INBOUND_CITY',
  InboundMethod = 'INBOUND_METHOD',
  InboundName = 'INBOUND_NAME',
  InboundPaperwork = 'INBOUND_PAPERWORK',
  InboundTerminal = 'INBOUND_TERMINAL',
  InboundZip = 'INBOUND_ZIP',
  Mawb = 'MAWB',
  OnHand = 'ON_HAND',
  OrderName = 'ORDER_NAME',
  OrderNotes = 'ORDER_NOTES',
  OrderNumber = 'ORDER_NUMBER',
  OrderStatus = 'ORDER_STATUS',
  OutboundCity = 'OUTBOUND_CITY',
  OutboundMethod = 'OUTBOUND_METHOD',
  OutboundName = 'OUTBOUND_NAME',
  OutboundPaperwork = 'OUTBOUND_PAPERWORK',
  OutboundTerminal = 'OUTBOUND_TERMINAL',
  OutboundZip = 'OUTBOUND_ZIP',
  PieceCount = 'PIECE_COUNT',
  PrimaryConsignee = 'PRIMARY_CONSIGNEE',
  Refused = 'REFUSED',
  RefNumber = 'REF_NUMBER',
  RouteName = 'ROUTE_NAME',
  ServiceDate = 'SERVICE_DATE',
  ServiceLevel = 'SERVICE_LEVEL',
  ServiceTime = 'SERVICE_TIME',
  Special = 'SPECIAL',
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  State = 'STATE',
  StopType = 'STOP_TYPE',
  Tags = 'TAGS',
  Terminal = 'TERMINAL',
  TotalCharges = 'TOTAL_CHARGES',
  VehicleTypeName = 'VEHICLE_TYPE_NAME',
  Weight = 'WEIGHT',
  ZipCode = 'ZIP_CODE'
}

export type DispatchTextDriverOutput = {
  __typename?: 'DispatchTextDriverOutput';
  driver: DriverEntity;
  textNotSentReason?: Maybe<Scalars['String']['output']>;
  textSent: Scalars['Boolean']['output'];
};

export type DispatchUnreachableCorridor = {
  __typename?: 'DispatchUnreachableCorridor';
  /** Terminal code of the corridor destination (the outbound terminal). */
  destinationTerminalCode: Scalars['String']['output'];
  /** Uuid of the destination terminal. */
  destinationTerminalUuid: Scalars['String']['output'];
  /** How many candidate orders move along this corridor and are therefore absent from the board. Never capped: it is the whole count, which the list below may not be. */
  orderCount: Scalars['Int']['output'];
  /** The stranded orders themselves, so the board can list them and open each one. Capped per corridor, and always a prefix of the corridor's orders in scan order, so orderCount minus this length is how many the cap dropped. A tenant with a healthy network reports no corridors at all, so this costs a normal board read nothing. */
  orders: Array<DispatchUnreachableOrder>;
  /** Terminal code of the corridor origin (the inbound terminal). */
  originTerminalCode: Scalars['String']['output'];
  /** Uuid of the origin terminal. This is the terminal whose outbound terminal lanes are missing, so it is the one to open to configure them. */
  originTerminalUuid: Scalars['String']['output'];
};

export type DispatchUnreachableOrder = {
  __typename?: 'DispatchUnreachableOrder';
  /** Terminal code the order is currently on hand at, when it is on hand anywhere. Null otherwise. */
  onHandTerminalCode?: Maybe<Scalars['String']['output']>;
  /** The order's display identifier (the same value the board's order rows show). */
  orderName: Scalars['String']['output'];
  /** Uuid of the stranded order. Opens the order form; it is not a segment uuid and addresses no row on the board, because this order produces no row. */
  orderUuid: Scalars['String']['output'];
  pieceCount?: Maybe<Scalars['Int']['output']>;
  weightLbs?: Maybe<Scalars['Float']['output']>;
};

export type DispatchViewCreateInput = {
  dispatchViewLayoutPositions?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  numberOfStops?: InputMaybe<Scalars['Int']['input']>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardStopTableFields?: InputMaybe<Array<DispatchTableField>>;
  routeCardWidth?: InputMaybe<Scalars['Int']['input']>;
  showCompleteStops?: InputMaybe<Scalars['Boolean']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchViewCreateOutput = DispatchViewCreateSuccessOutput | MutationErrorOutput;

export type DispatchViewCreateSuccessOutput = {
  __typename?: 'DispatchViewCreateSuccessOutput';
  dispatchView: DispatchViewEntity;
};

export type DispatchViewEntity = {
  __typename?: 'DispatchViewEntity';
  dispatchTableColors: Array<DispatchTableColorEntity>;
  dispatchViewLayoutPositions: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfStops: Scalars['Int']['output'];
  routeCardStopTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  routeCardStopTableFields: Array<DispatchTableField>;
  routeCardWidth: Scalars['Int']['output'];
  showCompleteStops: Scalars['Boolean']['output'];
  tabIndex: Scalars['Int']['output'];
  useMinimizedAppointmentTime: Scalars['Boolean']['output'];
};

export type DispatchViewUpdateInput = {
  dispatchViewLayoutPositions?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfStops?: InputMaybe<Scalars['Int']['input']>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardStopTableFields?: InputMaybe<Array<DispatchTableField>>;
  routeCardWidth?: InputMaybe<Scalars['Int']['input']>;
  showCompleteStops?: InputMaybe<Scalars['Boolean']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchViewUpdateOutput = DispatchViewUpdateSuccessOutput | MutationErrorOutput;

export type DispatchViewUpdateSuccessOutput = {
  __typename?: 'DispatchViewUpdateSuccessOutput';
  dispatchView: DispatchViewEntity;
};

export type DispatchableAgentEntity = {
  __typename?: 'DispatchableAgentEntity';
  /** The default driver for this agent */
  defaultDriver: DriverEntity;
  name: Scalars['String']['output'];
  /** Non-default drivers that are dispatchable for this agent */
  nonDefaultDrivers: Array<DriverEntity>;
  uuid: Scalars['String']['output'];
};

export type DocExtractionCancelEvalRunResultEntity = {
  __typename?: 'DocExtractionCancelEvalRunResultEntity';
  cancelRequested: Scalars['Boolean']['output'];
  evalRunId: Scalars['String']['output'];
};

export type DocExtractionCreatedEvalSetEntity = {
  __typename?: 'DocExtractionCreatedEvalSetEntity';
  documentCount: Scalars['Int']['output'];
  evalSetId: Scalars['String']['output'];
  strata: Scalars['JSON']['output'];
};

export type DocExtractionEvalDocumentWordBoxesEntity = {
  __typename?: 'DocExtractionEvalDocumentWordBoxesEntity';
  pages: Array<DocExtractionEvalWordBoxPageEntity>;
};

export type DocExtractionEvalRunCostEstimateEntity = {
  __typename?: 'DocExtractionEvalRunCostEstimateEntity';
  inputTokens: Scalars['Float']['output'];
  outputTokens: Scalars['Float']['output'];
  pricingSource: Scalars['String']['output'];
  tokenProfileSource: Scalars['String']['output'];
  totalTokens: Scalars['Float']['output'];
  usd?: Maybe<Scalars['Float']['output']>;
};

export type DocExtractionEvalRunDocumentEntity = {
  __typename?: 'DocExtractionEvalRunDocumentEntity';
  companyUuid: Scalars['String']['output'];
  costUsd?: Maybe<Scalars['Float']['output']>;
  docScore?: Maybe<Scalars['JSON']['output']>;
  documentId: Scalars['String']['output'];
  errorDetail?: Maybe<Scalars['String']['output']>;
  errorKind?: Maybe<Scalars['String']['output']>;
  evalRunId: Scalars['String']['output'];
  extractedFields?: Maybe<Scalars['JSON']['output']>;
  inputTokens?: Maybe<Scalars['Float']['output']>;
  latencyMs?: Maybe<Scalars['Int']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  runMeta?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  verdicts?: Maybe<Scalars['JSON']['output']>;
};

export type DocExtractionEvalRunDocumentsPageEntity = {
  __typename?: 'DocExtractionEvalRunDocumentsPageEntity';
  documents: Array<DocExtractionEvalRunDocumentEntity>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type DocExtractionEvalRunEntity = {
  __typename?: 'DocExtractionEvalRunEntity';
  actualCostUsd?: Maybe<Scalars['Float']['output']>;
  actualInputTokens?: Maybe<Scalars['Float']['output']>;
  actualOutputTokens?: Maybe<Scalars['Float']['output']>;
  aggregates?: Maybe<Scalars['JSON']['output']>;
  bundleHash: Scalars['String']['output'];
  cancelRequestedAt?: Maybe<Scalars['String']['output']>;
  completedCount: Scalars['Int']['output'];
  config: Scalars['JSON']['output'];
  costEstimate?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  documentCount: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  evalSetId: Scalars['String']['output'];
  executionMode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerBatchId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type DocExtractionEvalSetEntity = {
  __typename?: 'DocExtractionEvalSetEntity';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  documentCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  seed: Scalars['String']['output'];
  selectionConfig: Scalars['JSON']['output'];
  strataSummary: Scalars['JSON']['output'];
};

export type DocExtractionEvalSetPreviewEntity = {
  __typename?: 'DocExtractionEvalSetPreviewEntity';
  poolCutoffAt?: Maybe<Scalars['String']['output']>;
  sampleDocumentIds: Array<Scalars['String']['output']>;
  selectedCount: Scalars['Int']['output'];
  strata: Scalars['JSON']['output'];
  totalCandidates: Scalars['Int']['output'];
};

export type DocExtractionEvalWordBoxEntity = {
  __typename?: 'DocExtractionEvalWordBoxEntity';
  confidence: Scalars['Float']['output'];
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type DocExtractionEvalWordBoxPageEntity = {
  __typename?: 'DocExtractionEvalWordBoxPageEntity';
  pageNumber: Scalars['Int']['output'];
  textSource: Scalars['String']['output'];
  words: Array<DocExtractionEvalWordBoxEntity>;
};

export type DocExtractionLaunchEvalRunResultEntity = {
  __typename?: 'DocExtractionLaunchEvalRunResultEntity';
  bundleHash: Scalars['String']['output'];
  documentCount: Scalars['Int']['output'];
  evalRunId: Scalars['String']['output'];
};

export type DocScanVolumeByPipelineBucketEntity = {
  __typename?: 'DocScanVolumeByPipelineBucketEntity';
  endDate: Scalars['DateTime']['output'];
  pipeline: DocumentIngestionPipeline;
  startDate: Scalars['DateTime']['output'];
  totalCount: Scalars['Float']['output'];
};

export type DocScanVolumeByPipelineInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  period: ReportAggregationPeriod;
  startDate: Scalars['DateTime']['input'];
};

export type DockDoorAssignmentEntity = {
  __typename?: 'DockDoorAssignmentEntity';
  doorEventAt?: Maybe<Scalars['String']['output']>;
  doorPosition?: Maybe<Scalars['Int']['output']>;
  isReturnLeg: Scalars['Boolean']['output'];
  manifestUuid?: Maybe<Scalars['String']['output']>;
  routeUuid?: Maybe<Scalars['String']['output']>;
};

export type DockDoorAssignmentsInput = {
  manifestUuids: Array<Scalars['String']['input']>;
  routeUuids: Array<Scalars['String']['input']>;
  terminalUuid: Scalars['String']['input'];
};

export enum DockDoorDirection {
  Both = 'BOTH',
  In = 'IN',
  Out = 'OUT'
}

export type DockDoorEntity = {
  __typename?: 'DockDoorEntity';
  direction: DockDoorDirection;
  position: Scalars['Int']['output'];
  terminalUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type DockDoorInput = {
  direction: DockDoorDirection;
  position: Scalars['Int']['input'];
};

export type DockProductivityArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DockProductivityReportEntity = {
  __typename?: 'DockProductivityReportEntity';
  actualHoursAreProxy: Scalars['Boolean']['output'];
  appliedDockCostPerHourUsd?: Maybe<Scalars['Float']['output']>;
  costBasis: CostBasis;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  hasTimeAllowances: Scalars['Boolean']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  overallLaborEfficiencyPct?: Maybe<Scalars['Float']['output']>;
  terminals: Array<DockProductivityTerminalEntity>;
  timeAllowances: DockTimeAllowanceEntity;
  totalActualHours: Scalars['Float']['output'];
  totalAllowedHours: Scalars['Float']['output'];
  totalSavedCostUsd?: Maybe<Scalars['Float']['output']>;
  totalSavedHours: Scalars['Float']['output'];
};

/** Terminal dock standing relative to the labor-efficiency thresholds used by the Intelligence Board. */
export enum DockProductivityStatus {
  Efficient = 'EFFICIENT',
  Inefficient = 'INEFFICIENT',
  Moderate = 'MODERATE'
}

export type DockProductivityTerminalEntity = {
  __typename?: 'DockProductivityTerminalEntity';
  actualHours: Scalars['Float']['output'];
  allowedHours: Scalars['Float']['output'];
  inboundPieces: Scalars['Int']['output'];
  laborEfficiencyPct?: Maybe<Scalars['Float']['output']>;
  outboundPieces: Scalars['Int']['output'];
  savedCostUsd?: Maybe<Scalars['Float']['output']>;
  savedHours: Scalars['Float']['output'];
  status?: Maybe<DockProductivityStatus>;
  terminalCode: Scalars['String']['output'];
  terminalName: Scalars['String']['output'];
  terminalUuid: Scalars['String']['output'];
  totalWeightLbs: Scalars['Float']['output'];
};

export type DockReceivedKpiEntity = {
  __typename?: 'DockReceivedKpiEntity';
  arrivalScanCount: Scalars['Int']['output'];
  bucketUnit: KpiTrendBucketUnit;
  ordersReceivedCount: Scalars['Int']['output'];
  piecesReceivedCount: Scalars['Int']['output'];
  terminals: Array<DockReceivedTerminalRowEntity>;
  trend: Array<DockReceivedTrendBucketEntity>;
  unlinkedScanCount: Scalars['Int']['output'];
};

export type DockReceivedTerminalRowEntity = {
  __typename?: 'DockReceivedTerminalRowEntity';
  name?: Maybe<Scalars['String']['output']>;
  ordersReceivedCount: Scalars['Int']['output'];
  piecesReceivedCount: Scalars['Int']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type DockReceivedTrendBucketEntity = {
  __typename?: 'DockReceivedTrendBucketEntity';
  bucketDate: Scalars['String']['output'];
  piecesReceivedCount: Scalars['Int']['output'];
};

export type DockRunTimeEntity = {
  __typename?: 'DockRunTimeEntity';
  actualArriveAt?: Maybe<Scalars['String']['output']>;
  actualDepartAt?: Maybe<Scalars['String']['output']>;
  arriveAt?: Maybe<Scalars['String']['output']>;
  departAt?: Maybe<Scalars['String']['output']>;
  manifestUuid: Scalars['String']['output'];
};

export type DockRunTimesInput = {
  manifestUuids: Array<Scalars['String']['input']>;
};

export type DockScanReportInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use endDay, read in the report time zone */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Last calendar day of the report (YYYY-MM-DD), inclusive through 11:59:59 PM in the report time zone. Takes precedence over endDate. */
  endDay?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use startDay, read in the report time zone */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** First calendar day of the report (YYYY-MM-DD), starting at midnight in the report time zone. Takes precedence over startDate. */
  startDay?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DockScanReportOutput = {
  __typename?: 'DockScanReportOutput';
  rows: Array<DockScanReportRow>;
  /** IANA zone the date window was read in and times should be shown in: the terminal's ZIP zone when a terminal is filtered and its ZIP resolves, otherwise the company zone. */
  timeZone: Scalars['String']['output'];
};

export type DockScanReportRow = {
  __typename?: 'DockScanReportRow';
  barcode: Scalars['String']['output'];
  consigneeName?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  osdReason?: Maybe<Scalars['String']['output']>;
  packagesExpected: Scalars['Int']['output'];
  pieceMarkedOnHandOrdinal?: Maybe<Scalars['Int']['output']>;
  pieceName?: Maybe<Scalars['String']['output']>;
  piecesExpected: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  /** @deprecated Use scan.barcode instead */
  rawBarcode?: Maybe<Scalars['String']['output']>;
  /** When the server recorded the scan, the same clock the order audit log uses. */
  receivedAt: Scalars['DateTime']['output'];
  scan: ScanEntity;
  scanType: ScanType;
  scanUuid: Scalars['String']['output'];
  /** When the device reports the scan happened. */
  scannedAt: Scalars['DateTime']['output'];
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  terminalCode?: Maybe<Scalars['String']['output']>;
};

export type DockTimeAllowanceEntity = {
  __typename?: 'DockTimeAllowanceEntity';
  minutesPerHundredweight: Scalars['Float']['output'];
  minutesPerInboundPiece: Scalars['Float']['output'];
  minutesPerOutboundPiece: Scalars['Float']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type DocumentConnectInput = {
  uuid: Scalars['String']['input'];
};

export type DocumentCreateInput = {
  bucket: Scalars['String']['input'];
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  driverFormTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  freightSnapTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  shipmentUuid?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the storage order to attach the document to */
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
  /** A combination of the order billing party and ordinal separated by a hyphen. Used in the EOD flow */
  uniqueOrderIdentifier?: InputMaybe<Scalars['String']['input']>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentEntity = {
  __typename?: 'DocumentEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customDocumentName?: Maybe<Scalars['String']['output']>;
  dateUploadedFor?: Maybe<Scalars['DateTime']['output']>;
  driverFormTemplate?: Maybe<DriverSignableFormTemplateEntity>;
  expeditorsUploadFailedAt?: Maybe<Scalars['DateTime']['output']>;
  expeditorsUploadFailureReason?: Maybe<Scalars['String']['output']>;
  expeditorsUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  invoice?: Maybe<InvoiceEntity>;
  isDeleted: Scalars['Boolean']['output'];
  isPropagatedReference: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  preSignedGetUrl: Scalars['String']['output'];
  region: Scalars['String']['output'];
  shipment?: Maybe<OrderEntity>;
  signerName?: Maybe<Scalars['String']['output']>;
  thumbnailKey?: Maybe<Scalars['String']['output']>;
  type: DocumentType;
  updatedAt: Scalars['DateTime']['output'];
  uploadOrdinal?: Maybe<Scalars['Int']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type DocumentExtractionStatus = {
  __typename?: 'DocumentExtractionStatus';
  estimatedResumeAt?: Maybe<Scalars['DateTime']['output']>;
  parkedCount: Scalars['Int']['output'];
  paused: Scalars['Boolean']['output'];
  statusUnavailable: Scalars['Boolean']['output'];
};

export type DocumentForSigningInput = {
  documentUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  signatureParty?: InputMaybe<SignatureParty>;
};

export type DocumentForSigningOutput = {
  __typename?: 'DocumentForSigningOutput';
  /** The document to download and stamp the signature onto. On a re-sign this is the root original, NOT the proof currently on the order, so a new signature is applied to unsigned bytes. Do NOT send this uuid back as attachMobileSignedDocumentToOrderAndReplaceOriginal.input.originalDocumentUuid -- that field takes the uuid of the document as it appears on the order. Sending this one names an already-superseded document, which the attach cannot tell apart from a retry: it answers with the copy already attached, so the signature just taken is lost. */
  document?: Maybe<DocumentEntity>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  pageDimensions: Array<DocumentPageDimensionsEntity>;
  /** Presigned GET for the PDF rendering to download and stamp when the original is an image. Null when the original is itself a PDF -- use document.preSignedGetUrl -- and null when signingUnavailableReason is set. Check this field BEFORE falling back to document.preSignedGetUrl: an image document's own bytes are not signable. */
  signablePdfPreSignedGetUrl?: Maybe<Scalars['String']['output']>;
  signingUnavailableReason?: Maybe<SigningUnavailableReason>;
  suggestedPlacement?: Maybe<SignaturePlacementSuggestionEntity>;
};

export enum DocumentIngestionPipeline {
  DocumentExtraction = 'DOCUMENT_EXTRACTION',
  Legacy = 'LEGACY'
}

export enum DocumentIngestionPipelineFilter {
  All = 'ALL',
  DocumentExtraction = 'DOCUMENT_EXTRACTION',
  Legacy = 'LEGACY'
}

export type DocumentPageDimensionsEntity = {
  __typename?: 'DocumentPageDimensionsEntity';
  heightPoints: Scalars['Float']['output'];
  pageNumber: Scalars['Int']['output'];
  widthPoints: Scalars['Float']['output'];
};

export type DocumentProvenanceEntity = {
  __typename?: 'DocumentProvenanceEntity';
  companyUuid: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  extractionRunId?: Maybe<Scalars['String']['output']>;
  fields: Array<ProvenanceFieldEntity>;
  modelVersion?: Maybe<Scalars['String']['output']>;
  taxonomyVersion?: Maybe<Scalars['String']['output']>;
};

export enum DocumentType {
  AbiNotes = 'ABI_NOTES',
  AccountingReport = 'ACCOUNTING_REPORT',
  Ace = 'ACE',
  ArrivalNotice = 'ARRIVAL_NOTICE',
  BackupEmail = 'BACKUP_EMAIL',
  BillOfLading = 'BILL_OF_LADING',
  CheckCopy = 'CHECK_COPY',
  CommercialInvoice = 'COMMERCIAL_INVOICE',
  CoverPage = 'COVER_PAGE',
  CustomsRelease = 'CUSTOMS_RELEASE',
  CustomDriverFormSignature = 'CUSTOM_DRIVER_FORM_SIGNATURE',
  DamageReport = 'DAMAGE_REPORT',
  DeliveryAlert = 'DELIVERY_ALERT',
  DeliveryOrder = 'DELIVERY_ORDER',
  DeliveryReceipt = 'DELIVERY_RECEIPT',
  DeliverySignature = 'DELIVERY_SIGNATURE',
  DigitalProofOfDelivery = 'DIGITAL_PROOF_OF_DELIVERY',
  DigitalProofOfPickup = 'DIGITAL_PROOF_OF_PICKUP',
  Document_7512 = 'DOCUMENT_7512',
  EndOfDayDocument = 'END_OF_DAY_DOCUMENT',
  Hawb = 'HAWB',
  Hazmat = 'HAZMAT',
  ItemizedTransportDocument = 'ITEMIZED_TRANSPORT_DOCUMENT',
  Labels = 'LABELS',
  Manifest = 'MANIFEST',
  Mawb = 'MAWB',
  OrderDocument = 'ORDER_DOCUMENT',
  OsdPhoto = 'OSD_PHOTO',
  Other = 'OTHER',
  OvernightSlip = 'OVERNIGHT_SLIP',
  PartnerDocument = 'PARTNER_DOCUMENT',
  PickupAlert = 'PICKUP_ALERT',
  PickupOrder = 'PICKUP_ORDER',
  PickupReceiptForEsign = 'PICKUP_RECEIPT_FOR_ESIGN',
  PickupSignature = 'PICKUP_SIGNATURE',
  PodBundle = 'POD_BUNDLE',
  PodReport = 'POD_REPORT',
  PrepaidReceipt = 'PREPAID_RECEIPT',
  ProofOfDelivery = 'PROOF_OF_DELIVERY',
  ProofOfDeliveryScanned = 'PROOF_OF_DELIVERY_SCANNED',
  RecoveryDocument = 'RECOVERY_DOCUMENT',
  Rejection = 'REJECTION',
  ShipmentPhoto = 'SHIPMENT_PHOTO',
  StorageUnitPhoto = 'STORAGE_UNIT_PHOTO',
  TransferManifest = 'TRANSFER_MANIFEST',
  TransportApprovalCertificate = 'TRANSPORT_APPROVAL_CERTIFICATE',
  VoidedCheck = 'VOIDED_CHECK'
}

export type DocumentUpdateInput = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  customDocumentName?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  freightSnapTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  shipmentUuid?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DocumentType>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentUpsertInput = {
  bucket: Scalars['String']['input'];
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  signerName?: InputMaybe<Scalars['String']['input']>;
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type DocumentationItemCreateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  html: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  topicUuid: Scalars['String']['input'];
};

export type DocumentationItemEntity = {
  __typename?: 'DocumentationItemEntity';
  code?: Maybe<Scalars['String']['output']>;
  html: Scalars['String']['output'];
  htmlSizeBytes: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  status: DocumentationItemStatus;
  title: Scalars['String']['output'];
  topicUuid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum DocumentationItemStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type DocumentationItemSummaryEntity = {
  __typename?: 'DocumentationItemSummaryEntity';
  code?: Maybe<Scalars['String']['output']>;
  htmlSizeBytes: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  status: DocumentationItemStatus;
  title: Scalars['String']['output'];
  topicUuid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type DocumentationItemUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentationItemStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DocumentationReorderInput = {
  topicUuid?: InputMaybe<Scalars['String']['input']>;
  uuids: Array<Scalars['String']['input']>;
};

export type DocumentationSearchInput = {
  query: Scalars['String']['input'];
};

export type DocumentationSearchResultEntity = {
  __typename?: 'DocumentationSearchResultEntity';
  code?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  snippet: Scalars['String']['output'];
  title: Scalars['String']['output'];
  topicTitle: Scalars['String']['output'];
  topicUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DocumentationTopicCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type DocumentationTopicEntity = {
  __typename?: 'DocumentationTopicEntity';
  description?: Maybe<Scalars['String']['output']>;
  items: Array<DocumentationItemSummaryEntity>;
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DocumentationTopicUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DownloadInvoicesInput = {
  invoicesToDownload: Array<InvoiceToSend>;
};

export type DownloadInvoicesOutput = {
  __typename?: 'DownloadInvoicesOutput';
  combinedDocument?: Maybe<DocumentEntity>;
  documents: Array<DocumentEntity>;
  zipDocument?: Maybe<DocumentEntity>;
};

/** The address and terminal of a stop being entered, before it is saved */
export type DraftStopTimeZoneInput = {
  country: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state: Scalars['String']['input'];
  /** The stop's terminal; must belong to the session company */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type DriverCompletedStopsEntity = {
  __typename?: 'DriverCompletedStopsEntity';
  /** @deprecated Use arrivedAt in stopDriverMaps */
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use completedAt in stopDriverMaps */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use driver in stopDriverMaps */
  driverFirstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use driver in stopDriverMaps */
  driverLastName?: Maybe<Scalars['String']['output']>;
  stopDriverMaps: Array<StopDriverMapForCompletedStopsEntity>;
  /** @deprecated Use stopUuid in stopDriverMaps */
  stopUuid?: Maybe<Scalars['String']['output']>;
};

export type DriverComplianceDateInput = {
  /** YYYY-MM-DD */
  expiresOn?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** A COMPLIANCE credential type. */
  typeUuid: Scalars['String']['input'];
};

export type DriverComplianceDriverInput = {
  driverUuid: Scalars['String']['input'];
};

export type DriverComplianceEntity = {
  __typename?: 'DriverComplianceEntity';
  /** Compliance items (at most one per COMPLIANCE type, seeded types in Crown order), then training records grouped by type, oldest first. */
  credentials: Array<DriverCredentialEntity>;
  driverUuid: Scalars['String']['output'];
  /** Ordered by expiry date, soonest first. */
  insurancePolicies: Array<DriverInsurancePolicyEntity>;
  /** Always present; every field is empty for a driver whose profile was never saved. */
  profile: DriverComplianceProfileEntity;
};

export type DriverComplianceItemInput = {
  uuid: Scalars['String']['input'];
};

export type DriverComplianceProfileEntity = {
  __typename?: 'DriverComplianceProfileEntity';
  dateOfBirth?: Maybe<PlainDate>;
  hireDate?: Maybe<PlainDate>;
  /** Set by terminateDriver and cleared by rehireDriver. A terminated driver is always archived. */
  isTerminated: Scalars['Boolean']['output'];
  licenseClass?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  securityId?: Maybe<Scalars['String']['output']>;
  terminationComments?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<PlainDate>;
};

/** A driver compliance report file, returned in the response rather than stored: it holds license and policy numbers, and the documents bucket is publicly readable. */
export type DriverComplianceReportFileOutput = {
  __typename?: 'DriverComplianceReportFileOutput';
  /** The file contents, base64-encoded. */
  contentBase64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type DriverComplianceReportInput = {
  /** Only credentials of these types. Null means every active type; an empty list means no credentials, so insurance can be reported alone. */
  credentialTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only these drivers. Null or empty means every driver. */
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Include archived and terminated drivers. Terminating a driver archives them, so the two cannot be told apart by this filter. */
  includeInactiveDrivers?: Scalars['Boolean']['input'];
  includeInsurancePolicies?: Scalars['Boolean']['input'];
  /** Only drivers assigned to these terminals. Null or empty means every driver, including those with no terminal. */
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Null lists every current item on file, whatever its expiry. A number lists only expired items and items expiring within that many days of the company's local day. Statuses always follow the company's expiring-soon setting, as on the status chips. */
  withinDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Expiry status in the company's local day. EXPIRING means within the company's expiring-soon window of the expiry date (`driverComplianceExpiringSoonDays`, 30 days by default); NOT_TRACKED means no expiry date is recorded. */
export enum DriverComplianceStatus {
  Current = 'CURRENT',
  Expired = 'EXPIRED',
  Expiring = 'EXPIRING',
  NotTracked = 'NOT_TRACKED'
}

export type DriverCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressUpsertInput>;
  defaultAccessorialSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  driverPayType?: InputMaybe<DriverPayType>;
  /** The IDs of the DriverQualifications the driver will have. This will replace any existing DriverQualifications. */
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  driverReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  driverType?: InputMaybe<DriverType>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  fuelCardNumber: Scalars['String']['input'];
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  lastName: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  perMileRate?: InputMaybe<Scalars['Float']['input']>;
  percentGrossRevenueRate?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber: Scalars['String']['input'];
  sendRouteUpdateEmails?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DriverCredentialEntity = {
  __typename?: 'DriverCredentialEntity';
  completedOn?: Maybe<PlainDate>;
  expiresOn?: Maybe<PlainDate>;
  notes?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: DriverComplianceStatus;
  type: DriverCredentialTypeEntity;
  uuid: Scalars['String']['output'];
};

export enum DriverCredentialKind {
  Compliance = 'COMPLIANCE',
  Training = 'TRAINING'
}

export enum DriverCredentialSystemKey {
  License = 'LICENSE',
  Mvr = 'MVR',
  Physical = 'PHYSICAL',
  Sta = 'STA',
  TsaTest = 'TSA_TEST',
  Violations = 'VIOLATIONS'
}

export type DriverCredentialTypeEntity = {
  __typename?: 'DriverCredentialTypeEntity';
  active: Scalars['Boolean']['output'];
  /** Whether any driver record uses the type. A type in use can be deactivated but not deleted. */
  inUse: Scalars['Boolean']['output'];
  kind: DriverCredentialKind;
  name: Scalars['String']['output'];
  /** Set on the six compliance types every company is seeded with. Stays fixed when the type is renamed. */
  systemKey?: Maybe<DriverCredentialSystemKey>;
  uuid: Scalars['String']['output'];
};

export type DriverDailyLogReportPdfInput = {
  completedStopsOnly: Scalars['Boolean']['input'];
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeLinehaulStops?: InputMaybe<Scalars['Boolean']['input']>;
  onlyEligibleForSettlement: Scalars['Boolean']['input'];
  /** The zone the service days are read in. Empty: each stop on its own local service day and each run on its operating day while terminal_local_times is on. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  serviceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  serviceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DriverEntity = {
  __typename?: 'DriverEntity';
  active: Scalars['Boolean']['output'];
  address?: Maybe<AddressEntity>;
  agent?: Maybe<AgentFieldsEntity>;
  agentId?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  /** The driver's worst compliance status, for badges: EXPIRED or EXPIRING when any tracked item is, NOT_TRACKED when nothing has an expiry date. Carries no dates or numbers, so unlike `driverCompliance` it needs no COMPANY_DRIVER_COMPLIANCE permission. Null only when the status could not be computed. */
  complianceStatus?: Maybe<DriverComplianceStatus>;
  currentLeg?: Maybe<LegEntity>;
  defaultAccessorialSettlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  defaultFuelSettlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  defaultLineHaulTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultOrdinaryTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultPointToPointTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultRecoveryTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultTransferTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultVehicle?: Maybe<EquipmentEntity>;
  driverPayType?: Maybe<DriverPayType>;
  driverReferenceNumber?: Maybe<Scalars['String']['output']>;
  driverType?: Maybe<DriverType>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  expoPushTokens?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use user.name instead. For backwards compatibility, returns the first space-separated word of the user.name field. */
  firstName: Scalars['String']['output'];
  flatRate?: Maybe<Scalars['Float']['output']>;
  fuelCardNumber: Scalars['String']['output'];
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  lastCompletedLeg?: Maybe<LegEntity>;
  /** @deprecated Use user.name instead. For backwards compatibility, returns everything after the first space-separated word of the user.name field. */
  lastName: Scalars['String']['output'];
  legs: Array<LegEntity>;
  mobileCoordsLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  mobilePhoneLatitude?: Maybe<Scalars['Float']['output']>;
  mobilePhoneLongitude?: Maybe<Scalars['Float']['output']>;
  notes: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  perMileRate?: Maybe<Scalars['Float']['output']>;
  percentGrossRevenueRate?: Maybe<Scalars['Float']['output']>;
  phoneNumber: Scalars['String']['output'];
  qualifications: Array<DriverQualificationEntity>;
  route?: Maybe<RouteEntity>;
  sendRouteUpdateEmails: Scalars['Boolean']['output'];
  status: DriverStatus;
  terminal?: Maybe<TerminalEntity>;
  /** The identity of the user associated with the driver. All drivers have a user, which holds the driver's name and email. */
  user: UserActorEntity;
  uuid: Scalars['String']['output'];
};


export type DriverEntityLastCompletedLegArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type DriverEntityLegsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type DriverEntityRouteArgs = {
  date: Scalars['DateTime']['input'];
};

export type DriverEquipmentConstraintInput = {
  driverUuid: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  maxPieces?: InputMaybe<Scalars['Int']['input']>;
  maxVolume?: InputMaybe<Scalars['Volume']['input']>;
  maxWeight?: InputMaybe<Scalars['Mass']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DriverInsurancePolicyEntity = {
  __typename?: 'DriverInsurancePolicyEntity';
  carrierName?: Maybe<Scalars['String']['output']>;
  effectiveOn: PlainDate;
  expiresOn: PlainDate;
  insuranceType: Scalars['String']['output'];
  insuredAmountUsd?: Maybe<Scalars['Float']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  status: DriverComplianceStatus;
  uuid: Scalars['String']['output'];
};

export enum DriverLocationUpdateSource {
  MobileBackground = 'MOBILE_BACKGROUND',
  MobileForeground = 'MOBILE_FOREGROUND'
}

export type DriverOnRouteEntity = {
  __typename?: 'DriverOnRouteEntity';
  type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DriverOrdersInput = {
  driverUuid: Scalars['String']['input'];
  /** The route date to filter driver orders on */
  routeDate: Scalars['DateTime']['input'];
};

export type DriverOrdersOutput = {
  __typename?: 'DriverOrdersOutput';
  orders: Array<OrderEntity>;
};

export type DriverPayRateChangeActorEntity = {
  __typename?: 'DriverPayRateChangeActorEntity';
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type DriverPayRateChangeEventConnection = {
  __typename?: 'DriverPayRateChangeEventConnection';
  edges: Array<DriverPayRateChangeEventEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DriverPayRateChangeEventEdge = {
  __typename?: 'DriverPayRateChangeEventEdge';
  cursor: Scalars['String']['output'];
  node: DriverPayRateChangeEventEntity;
};

export type DriverPayRateChangeEventEntity = {
  __typename?: 'DriverPayRateChangeEventEntity';
  actor?: Maybe<DriverPayRateChangeActorEntity>;
  /** Null when no session made the change: an activation capture, an import, or another system write. */
  actorUserUuid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  driverSettlementBillUuid?: Maybe<Scalars['String']['output']>;
  driverUuid: Scalars['String']['output'];
  id: Scalars['String']['output'];
  next: Scalars['JSON']['output'];
  /** Null for DRIVER_DEFAULT_RATE, where the pay type is itself part of what can change and so appears inside previous/next. */
  payType?: Maybe<DriverPayType>;
  /** The value at this scope immediately before the change. Null when there was none, which is not the same as the first event ever: a pay bound that is deleted and later recreated records a null previous again. */
  previous?: Maybe<Scalars['JSON']['output']>;
  scope: DriverPayRateChangeScope;
  stopDriverMapPayTermsId?: Maybe<Scalars['String']['output']>;
  /** Null when the event is not about one unit of work, or when that work has since been deleted. */
  stopDriverMapUuid?: Maybe<Scalars['String']['output']>;
};

/** Which of a driver's three rate levels a history entry describes: the driver's own default configuration, a per-pay-type bound, or the terms frozen against one unit of work. */
export enum DriverPayRateChangeScope {
  DriverDefaultRate = 'DRIVER_DEFAULT_RATE',
  DriverPayBound = 'DRIVER_PAY_BOUND',
  StopDriverMapPayTerms = 'STOP_DRIVER_MAP_PAY_TERMS'
}

export enum DriverPayType {
  PercentGrossRevenue = 'PERCENT_GROSS_REVENUE',
  PerMile = 'PER_MILE'
}

export type DriverPhoneNumberAvailabilityOutput = {
  __typename?: 'DriverPhoneNumberAvailabilityOutput';
  available: Scalars['Boolean']['output'];
  sameCompanyDriverName?: Maybe<Scalars['String']['output']>;
  sameCompanyDriverUuid?: Maybe<Scalars['String']['output']>;
};

export type DriverPlannerArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DriverPlannerAssumptionEntity = {
  __typename?: 'DriverPlannerAssumptionEntity';
  standardShiftHours: Scalars['Float']['output'];
  targetMgt: Scalars['Float']['output'];
  targetUtilizationPct: Scalars['Float']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type DriverPlannerReportEntity = {
  __typename?: 'DriverPlannerReportEntity';
  actualUtilizationPct?: Maybe<Scalars['Float']['output']>;
  assumptions: DriverPlannerAssumptionEntity;
  avgNetHoursPerTrip?: Maybe<Scalars['Float']['output']>;
  avgProductiveHoursPerTrip?: Maybe<Scalars['Float']['output']>;
  costBasis: CostBasis;
  driverWageFringePerHourUsd?: Maybe<Scalars['Float']['output']>;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  excessCapacityLaborCostUsd?: Maybe<Scalars['Float']['output']>;
  excessCapacityPct?: Maybe<Scalars['Float']['output']>;
  excessTrips?: Maybe<Scalars['Float']['output']>;
  hasAssumptions: Scalars['Boolean']['output'];
  hasTimeAllowances: Scalars['Boolean']['output'];
  mgt?: Maybe<Scalars['Float']['output']>;
  missingCostInputs: Array<Scalars['String']['output']>;
  netHours: Scalars['Float']['output'];
  netHoursAreProxy: Scalars['Boolean']['output'];
  productiveHours: Scalars['Float']['output'];
  requiredTrips?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<DriverPlannerStatus>;
  targetProductiveHoursPerTrip: Scalars['Float']['output'];
  terminals: Array<DriverPlannerRowEntity>;
  tripsRun: Scalars['Int']['output'];
};

export type DriverPlannerRowEntity = {
  __typename?: 'DriverPlannerRowEntity';
  actualUtilizationPct?: Maybe<Scalars['Float']['output']>;
  avgNetHoursPerTrip?: Maybe<Scalars['Float']['output']>;
  avgProductiveHoursPerTrip?: Maybe<Scalars['Float']['output']>;
  excessCapacityLaborCostUsd?: Maybe<Scalars['Float']['output']>;
  excessCapacityPct?: Maybe<Scalars['Float']['output']>;
  excessTrips?: Maybe<Scalars['Float']['output']>;
  mgt?: Maybe<Scalars['Float']['output']>;
  netHours: Scalars['Float']['output'];
  productiveHours: Scalars['Float']['output'];
  requiredTrips?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<DriverPlannerStatus>;
  terminalCode: Scalars['String']['output'];
  terminalName: Scalars['String']['output'];
  terminalUuid: Scalars['String']['output'];
  tripsRun: Scalars['Int']['output'];
};

/** Terminal P&D capacity standing relative to the target MGT number used by the Intelligence Board. */
export enum DriverPlannerStatus {
  Balanced = 'BALANCED',
  ExcessCapacity = 'EXCESS_CAPACITY',
  UnderCapacity = 'UNDER_CAPACITY'
}

export type DriverQualificationEntity = {
  __typename?: 'DriverQualificationEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DriverReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  /** IANA zone the report reads its days in; honored only while terminal_local_times is on. When null, insight reports count each order on its stop's local service day, and the audit report uses the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DriverReportBucketEntity = {
  __typename?: 'DriverReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  driverType?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lastName: Scalars['String']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type DriverSettlementBillConnection = {
  __typename?: 'DriverSettlementBillConnection';
  edges: Array<DriverSettlementBillEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DriverSettlementBillCreateInput = {
  billEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  billStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid: Scalars['String']['input'];
  finalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settlementDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  stopDriverMapUuidAdds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DriverSettlementBillEdge = {
  __typename?: 'DriverSettlementBillEdge';
  cursor: Scalars['String']['output'];
  node: DriverSettlementBillEntity;
};

export type DriverSettlementBillEntity = {
  __typename?: 'DriverSettlementBillEntity';
  billEndDate?: Maybe<Scalars['DateTime']['output']>;
  billStartDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  driver: DriverEntity;
  finalizedDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Use this for display instead of billStartDate and billEndDate */
  payPeriod: Scalars['String']['output'];
  paymentInformation: DriverSettlementPaymentEntity;
  settlementAdjustments: Array<SettlementAdjustmentEntity>;
  settlementBillLineItems: Array<SettlementBillLineItemEntity>;
  settlementDate?: Maybe<Scalars['DateTime']['output']>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductions: Array<SettlementDeductionEntity>;
  /** If valid settlement bill snapshot exists, returns snapshot JSON */
  snapshot?: Maybe<Scalars['JSON']['output']>;
  /** If valid settlement bill snapshot exists, returns true. Use this if you just need to verify snapshot existence to avoid fetching the entire snapshot. */
  snapshotExists: Scalars['Boolean']['output'];
  /** calculated by finding oldest completed stop in bill */
  totalDriverPayoutPreDeduction?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type DriverSettlementBillExportPdfInput = {
  /** The UUIDs of the driver settlement bills to include in the export. */
  driverSettlementBillUuids: Array<Scalars['String']['input']>;
  /** Whether to display the bill headers, including bill and company information. */
  includeHeaders: Scalars['Boolean']['input'];
  /** If true, return a detailed version of the bill. Otherwise, return a basic version. */
  includeLineItemDetails: Scalars['Boolean']['input'];
  /** Whether to display the line item totals aka driver pay. */
  includeLineItemTotals: Scalars['Boolean']['input'];
};

export type DriverSettlementBillForDownloadEntity = {
  __typename?: 'DriverSettlementBillForDownloadEntity';
  billEndDate?: Maybe<Scalars['DateTime']['output']>;
  billName?: Maybe<Scalars['String']['output']>;
  billStartDate?: Maybe<Scalars['DateTime']['output']>;
  billUuid: Scalars['String']['output'];
  driverFirstName?: Maybe<Scalars['String']['output']>;
  driverLastName?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverStationCode?: Maybe<Scalars['String']['output']>;
  finalizedDate?: Maybe<Scalars['DateTime']['output']>;
  settlementDate?: Maybe<Scalars['DateTime']['output']>;
  settlementDeductions?: Maybe<Array<SettlementDeductionForDownloadEntity>>;
  stopDriverMaps: Array<StopDriverMapForDownloadEntity>;
};

export type DriverSettlementBillUpdateInput = {
  /** @deprecated DO NOT USE, this is a field purely derived on the backend */
  billEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated DO NOT USE, this is a field purely derived on the backend */
  billStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  /** The date the bill was finalized. Only pass this in if bill is not finalized yet -- if it is already finalized, pass in undefined. */
  finalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settlementDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  stopDriverMapUuidAdds?: InputMaybe<Array<Scalars['String']['input']>>;
  stopDriverMapUuidDeletes?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type DriverSettlementPayBoundEntity = {
  __typename?: 'DriverSettlementPayBoundEntity';
  maxPayUsdCents?: Maybe<Scalars['Int']['output']>;
  minPayUsdCents?: Maybe<Scalars['Int']['output']>;
  payType: DriverPayType;
};

export type DriverSettlementPayBoundInput = {
  maxPayUsdCents?: InputMaybe<Scalars['Int']['input']>;
  minPayUsdCents?: InputMaybe<Scalars['Int']['input']>;
  payType: DriverPayType;
};

export type DriverSettlementPaymentEntity = {
  __typename?: 'DriverSettlementPaymentEntity';
  eligiblePay: Scalars['Currency']['output'];
  finalPay: Scalars['Currency']['output'];
  netAdjustments: Scalars['Currency']['output'];
  /** @deprecated During Robust Settlement Project. Use `netAdjustments` instead */
  totalDeductions?: Maybe<Scalars['Currency']['output']>;
};

export type DriverSettlementTotalAmountsOutput = {
  __typename?: 'DriverSettlementTotalAmountsOutput';
  payBasis: SettlementPayBasisOutput;
  totalChargesForSettlement: Scalars['Float']['output'];
  totalDriverPayout: Scalars['Float']['output'];
  totalEligibleAmountForStop: Scalars['Float']['output'];
};

export type DriverSignableFormTemplateEntity = {
  __typename?: 'DriverSignableFormTemplateEntity';
  createdAt: Scalars['DateTime']['output'];
  formText: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum DriverStatus {
  Assigned = 'ASSIGNED',
  Available = 'AVAILABLE'
}

export enum DriverType {
  CompanyDriver = 'COMPANY_DRIVER',
  Contractor = 'CONTRACTOR',
  OwnerOperator = 'OWNER_OPERATOR'
}

export type DriverUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressUpsertInput>;
  defaultAccessorialSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  driverPayType?: InputMaybe<DriverPayType>;
  /** The IDs of the DriverQualifications the driver will have. This will replace any existing DriverQualifications. */
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  driverReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  driverType?: InputMaybe<DriverType>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  fuelCardNumber?: InputMaybe<Scalars['String']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  perMileRate?: InputMaybe<Scalars['Float']['input']>;
  percentGrossRevenueRate?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sendRouteUpdateEmails?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DunningReportInput = {
  contactUuid: Scalars['String']['input'];
  /** Optional free-text message rendered in the dunning report PDF above the footer. Applied to every recipient when sending in a batch. */
  customMessage?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateEdiPartnershipsInput = {
  destinationContactUuid: Scalars['String']['input'];
  replaceEdiPartnerships?: InputMaybe<Scalars['Boolean']['input']>;
  sourceContactUuid: Scalars['String']['input'];
};

export type DuplicateEdiPartnershipsOutput = {
  __typename?: 'DuplicateEdiPartnershipsOutput';
  contact?: Maybe<ContactEntity>;
  status: Scalars['String']['output'];
};

export type DuplicateTariffGroupInput = {
  uuid: Scalars['String']['input'];
};

export type DuplicateTariffGroupOutput = {
  __typename?: 'DuplicateTariffGroupOutput';
  tariffGroup: TariffGroupEntity;
};

export type DwellAlertFilterInput = {
  /** Dwell bands to include. Defaults to APPROACHING + OVER when omitted; including OK returns all on-dock freight. */
  statuses?: InputMaybe<Array<DwellStatus>>;
};

/** Dwell-time banding for on-dock freight relative to its effective threshold. */
export enum DwellStatus {
  Approaching = 'APPROACHING',
  Ok = 'OK',
  Over = 'OVER'
}

export type DwellTimeAlertConfigEntity = {
  __typename?: 'DwellTimeAlertConfigEntity';
  contact?: Maybe<ContactEntity>;
  createdAt: Scalars['DateTime']['output'];
  /** Whether this configuration row participates in alerting. */
  enabled: Scalars['Boolean']['output'];
  /** The dwell-time limit, in calendar days, beyond which on-dock freight is flagged. */
  thresholdDays: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse?: Maybe<WarehouseEntity>;
};

export enum Edi214Status {
  Af = 'AF',
  Av = 'AV',
  D1 = 'D1',
  I1 = 'I1',
  P1 = 'P1',
  X1 = 'X1',
  X3 = 'X3',
  X4 = 'X4',
  X6 = 'X6',
  X7 = 'X7'
}

export enum EdiTransactionCode {
  FunctionalAcknowledgement = 'FUNCTIONAL_ACKNOWLEDGEMENT',
  MotorCarrierBillOfLading = 'MOTOR_CARRIER_BILL_OF_LADING',
  MotorCarrierFreightDetailsAndInvoice = 'MOTOR_CARRIER_FREIGHT_DETAILS_AND_INVOICE',
  MotorCarrierLoadTender = 'MOTOR_CARRIER_LOAD_TENDER',
  ResponseToALoadTender = 'RESPONSE_TO_A_LOAD_TENDER',
  TransportationCarrierShipmentStatusMessage = 'TRANSPORTATION_CARRIER_SHIPMENT_STATUS_MESSAGE'
}

export enum EdiTransactionStatus {
  Failed = 'FAILED',
  Ignored = 'IGNORED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export enum EfmOutboundRequestStatusCode {
  Apt = 'APT',
  Arr = 'ARR',
  Atd = 'ATD',
  Cxl = 'CXL',
  Del = 'DEL',
  Dmg = 'DMG',
  Dsh = 'DSH',
  Lm = 'LM',
  Lm3 = 'LM3',
  Ofd = 'OFD',
  Osd = 'OSD',
  Pre = 'PRE',
  R2E = 'R2E',
  Rcd = 'RCD',
  Ref = 'REF'
}

export enum EfmOutboundRequestType {
  SubmitPodByShipperRefNo = 'SubmitPODByShipperRefNo',
  SubmitStatusByShipperRefNo = 'SubmitStatusByShipperRefNo',
  UpdateStatusByByShipperRefNo = 'UpdateStatusByByShipperRefNo',
  UploadPodDocumentByShipperRefNo = 'UploadPODDocumentByShipperRefNo'
}

export enum Edge {
  Bottom = 'BOTTOM',
  Left = 'LEFT',
  Right = 'RIGHT',
  Top = 'TOP'
}

export type EdgeAnchorEntity = {
  __typename?: 'EdgeAnchorEntity';
  blockId?: Maybe<Scalars['String']['output']>;
  edge: Edge;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type EdgeAnchorInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  edge: Edge;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  text: Scalars['String']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export enum Edi214ShipmentStatus {
  ContactAttempted = 'CONTACT_ATTEMPTED',
  DeliveryAppointmentCancelled = 'DELIVERY_APPOINTMENT_CANCELLED',
  DeliveryAppointmentConfirmed = 'DELIVERY_APPOINTMENT_CONFIRMED',
  DeliveryAppointmentRescheduled = 'DELIVERY_APPOINTMENT_RESCHEDULED',
  DeliveryArrived = 'DELIVERY_ARRIVED',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryDispatched = 'DELIVERY_DISPATCHED',
  DeliveryOnHand = 'DELIVERY_ON_HAND',
  DeliveryRefused = 'DELIVERY_REFUSED',
  LineHaulArrivedAtDestination = 'LINE_HAUL_ARRIVED_AT_DESTINATION',
  LineHaulDeparted = 'LINE_HAUL_DEPARTED',
  LineHaulDepartedOrigin = 'LINE_HAUL_DEPARTED_ORIGIN',
  LineHaulReceived = 'LINE_HAUL_RECEIVED',
  OrderReceivedAtOrigin = 'ORDER_RECEIVED_AT_ORIGIN',
  PickupAppointmentCancelled = 'PICKUP_APPOINTMENT_CANCELLED',
  PickupAppointmentConfirmed = 'PICKUP_APPOINTMENT_CONFIRMED',
  PickupAppointmentRescheduled = 'PICKUP_APPOINTMENT_RESCHEDULED',
  PickupArrived = 'PICKUP_ARRIVED',
  PickupCompleted = 'PICKUP_COMPLETED',
  PickupDispatched = 'PICKUP_DISPATCHED',
  PickupRefused = 'PICKUP_REFUSED',
  PickupTransferred = 'PICKUP_TRANSFERRED',
  RecoveryCompleted = 'RECOVERY_COMPLETED'
}

export enum Edi990ActionCode {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED'
}

export enum EdiAndApiOrdersForReviewSortField {
  CreatedAt = 'CreatedAt',
  ShipperBillOfLadingNumber = 'ShipperBillOfLadingNumber'
}

export type EdiAndApiOrdersForReviewSortInput = {
  sortBy: EdiAndApiOrdersForReviewSortField;
  sortDirection: SortDirection;
};

export enum EdiOutboundPayloadDestination {
  Boomi = 'BOOMI',
  Stedi = 'STEDI',
  Tenedi = 'TENEDI'
}

export type EdiPartnershipEntity = {
  __typename?: 'EdiPartnershipEntity';
  allowEditingShipperBillOfLadingNumber: Scalars['Boolean']['output'];
  alternateStediPartnerId?: Maybe<Scalars['String']['output']>;
  autoAcceptOrders: Scalars['Boolean']['output'];
  canCreateMultipleStops: Scalars['Boolean']['output'];
  companyStandardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  edi214ShipmentStatuses: Array<Edi214ShipmentStatus>;
  ediOutboundPayloadDestination: EdiOutboundPayloadDestination;
  enableStaging: Scalars['Boolean']['output'];
  enabled214Statuses: Array<Edi214Status>;
  excludeZeroChargeInvoices: Scalars['Boolean']['output'];
  ignoreCancellations: Scalars['Boolean']['output'];
  ignoreNonEdiOutbound: Scalars['Boolean']['output'];
  includeItemizedChargesIn210: Scalars['Boolean']['output'];
  includeOutboundFilenameReceiverIsaId: Scalars['Boolean']['output'];
  mergeLineHaul: Scalars['Boolean']['output'];
  outboundFilenameScacPrefix: Scalars['Boolean']['output'];
  removeSpacesFrom214Bol: Scalars['Boolean']['output'];
  requireGenerateEdi210Ids: Scalars['Boolean']['output'];
  send990InResponseTo204: Scalars['Boolean']['output'];
  send990InResponseTo211: Scalars['Boolean']['output'];
  sendBackupDocs: Scalars['Boolean']['output'];
  stedi210MappingId?: Maybe<Scalars['String']['output']>;
  stedi210TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stedi214MappingId?: Maybe<Scalars['String']['output']>;
  stedi214TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stedi990MappingId?: Maybe<Scalars['String']['output']>;
  stedi990TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stediPartnershipId?: Maybe<Scalars['String']['output']>;
  tiffPodUpload: Scalars['Boolean']['output'];
  timeOfPodUpload: TimeOfPodUpload;
  updatedAt: Scalars['DateTime']['output'];
  useStediGenerateEdiFunction: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type EdiPartnershipReferenceMappingEntity = {
  __typename?: 'EdiPartnershipReferenceMappingEntity';
  createdAt: Scalars['DateTime']['output'];
  label?: Maybe<Scalars['String']['output']>;
  qualifier: Scalars['String']['output'];
  target: EdiReferenceTarget;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type EdiPartnershipReferenceMappingUpsertInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  qualifier: Scalars['String']['input'];
  target: EdiReferenceTarget;
};

export type EdiPartnershipServiceMappingCreateInput = {
  ediValue: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
};

export type EdiPartnershipServiceMappingEntity = {
  __typename?: 'EdiPartnershipServiceMappingEntity';
  createdAt: Scalars['DateTime']['output'];
  ediValue: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  serviceUuid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type EdiReferenceEntity = {
  __typename?: 'EdiReferenceEntity';
  /** Display label from the partnership's reference mapping */
  label?: Maybe<Scalars['String']['output']>;
  /** X12 reference qualifier as received, e.g. BM, MB, ZZ */
  qualifier: Scalars['String']['output'];
  source: Scalars['String']['output'];
  /** Order field this reference filled; null when it filled none (unmapped, display-only, or lost to a dedicated value) */
  target?: Maybe<EdiReferenceTarget>;
  value: Scalars['String']['output'];
};

export enum EdiReferenceTarget {
  DisplayOnly = 'DISPLAY_ONLY',
  Hawb = 'HAWB',
  Mawb = 'MAWB',
  Po = 'PO',
  Quaternary = 'QUATERNARY',
  Quinary = 'QUINARY',
  RefNumbers = 'REF_NUMBERS',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export type EdiTransactionConnection = {
  __typename?: 'EdiTransactionConnection';
  edges: Array<EdiTransactionEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EdiTransactionEdge = {
  __typename?: 'EdiTransactionEdge';
  cursor: Scalars['String']['output'];
  node: EdiTransactionEntity;
};

export type EdiTransactionEntity = {
  __typename?: 'EdiTransactionEntity';
  code: EdiTransactionCode;
  createdAt: Scalars['DateTime']['output'];
  edi210NetAmountDueCents?: Maybe<Scalars['Int']['output']>;
  edi214ShipmentStatus?: Maybe<Edi214ShipmentStatus>;
  edi990ActionCode?: Maybe<Edi990ActionCode>;
  ediPayloadId?: Maybe<Scalars['String']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  ignoreInAudit: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  payload: Scalars['String']['output'];
  purposeCode?: Maybe<EdiTransactionPurposeCode>;
  receiverIsaId: Scalars['String']['output'];
  senderIsaId: Scalars['String']['output'];
  status: EdiTransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum EdiTransactionPurposeCode {
  Cancellation = 'CANCELLATION',
  Change = 'CHANGE',
  Original = 'ORIGINAL'
}

export type EditContactsInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL with the contacts data to update */
  csvUrl: Scalars['String']['input'];
  /** The mappings between the CSV columns and the contact import fields. Should provide ContactIdentifier mapping. */
  mappings: Array<BulkUpdateContactMapping>;
};

export type EditContactsOutput = {
  __typename?: 'EditContactsOutput';
  failedContacts: Array<Scalars['String']['output']>;
  successfulContacts: Array<Scalars['String']['output']>;
};

export type EffectiveOrganizationQuotePolicy = {
  __typename?: 'EffectiveOrganizationQuotePolicy';
  /** False unless the override allows it: the company has no hazmat setting to inherit. */
  allowHazmatAuto: Scalars['Boolean']['output'];
  autoSendMaxCents?: Maybe<Scalars['Int']['output']>;
  minConfidence: Scalars['Float']['output'];
  mode: QuoteAgentPolicyMode;
};

export type EffectivePackageTypeConfigEntity = {
  __typename?: 'EffectivePackageTypeConfigEntity';
  isSingleHandlingUnit: Scalars['Boolean']['output'];
  packageType: PackageType;
};

export type EffectiveTariffChainEntity = {
  __typename?: 'EffectiveTariffChainEntity';
  source: TariffChainSource;
  tariffChain: TariffChainEntity;
  tariffGroupType: TariffGroupType;
};

export type EfmOutboundRequestEventEntity = {
  __typename?: 'EfmOutboundRequestEventEntity';
  clockworkStatusQueueId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  httpStatusCode?: Maybe<Scalars['Int']['output']>;
  requestType: EfmOutboundRequestType;
  statusCode?: Maybe<EfmOutboundRequestStatusCode>;
  uuid: Scalars['String']['output'];
};

export type EmailAccountingReportInput = {
  accountingReportDocumentUuid: Scalars['String']['input'];
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmail: Scalars['String']['input'];
  reportType: AccountingReportType;
  senderEmail?: InputMaybe<Scalars['String']['input']>;
};

export type EmailAccountingReportOutput = {
  __typename?: 'EmailAccountingReportOutput';
  status: EmailAccountingReportStatus;
};

export enum EmailAccountingReportStatus {
  NoAccountingReportUrl = 'NO_ACCOUNTING_REPORT_URL',
  NoRecipientEmail = 'NO_RECIPIENT_EMAIL',
  Other = 'OTHER',
  Success = 'SUCCESS'
}

export type EmailIngestionExcludedCustomerEntity = {
  __typename?: 'EmailIngestionExcludedCustomerEntity';
  displayName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type EmailIngestionExclusionsEntity = {
  __typename?: 'EmailIngestionExclusionsEntity';
  excludedCustomers: Array<EmailIngestionExcludedCustomerEntity>;
  excludedDocumentTypes: Array<ClassifiedDocumentType>;
};

export type EmailOrderDocumentInput = {
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  isQuote: Scalars['Boolean']['input'];
  orderDocumentDocumentUuid: Scalars['String']['input'];
  orderDocumentType: OrderDocumentType;
  orderIdentifier: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  senderEmail?: InputMaybe<Scalars['String']['input']>;
};

export type EmailOrderDocumentOutput = {
  __typename?: 'EmailOrderDocumentOutput';
  status: EmailOrderDocumentStatus;
};

export enum EmailOrderDocumentStatus {
  NoOrderDocumentUrl = 'NO_ORDER_DOCUMENT_URL',
  NoRecipientEmail = 'NO_RECIPIENT_EMAIL',
  Other = 'OTHER',
  Success = 'SUCCESS'
}

export enum EmailSendStatus {
  Failed = 'FAILED',
  NotSent = 'NOT_SENT',
  PartiallySent = 'PARTIALLY_SENT',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type EmailSuppressionEntity = {
  __typename?: 'EmailSuppressionEntity';
  /** The address, lowercased. */
  email: Scalars['String']['output'];
  type: EmailSuppressionType;
};

export enum EmailSuppressionType {
  Bounce = 'BOUNCE',
  InvalidEmail = 'INVALID_EMAIL',
  SpamReport = 'SPAM_REPORT'
}

export type EmailTransactionConnection = {
  __typename?: 'EmailTransactionConnection';
  edges: Array<EmailTransactionEdge>;
  pageInfo: PageInfo;
};

export type EmailTransactionEdge = {
  __typename?: 'EmailTransactionEdge';
  cursor: Scalars['String']['output'];
  node: EmailTransactionEntity;
};

export type EmailTransactionEntity = {
  __typename?: 'EmailTransactionEntity';
  company: CompanyEntity;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  document: DocumentEntity;
  emailResponse?: Maybe<Scalars['String']['output']>;
  emailResponseStatus?: Maybe<Scalars['Int']['output']>;
  emailTransactionLogs: Array<EmailTransactionLogEntity>;
  emailTransactionStatus: EmailTransactionStatus;
  emails: Array<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<InvoiceEntity>;
  pdfNotAttached: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type EmailTransactionLogCreateInput = {
  email: Scalars['String']['input'];
  emailTransactionUuid: Scalars['String']['input'];
  lastStatus?: InputMaybe<EmailTransactionLogStatus>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTransactionLogEntity = {
  __typename?: 'EmailTransactionLogEntity';
  email: Scalars['String']['output'];
  lastStatus?: Maybe<EmailTransactionLogStatus>;
  reason?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export enum EmailTransactionLogStatus {
  Blocked = 'BLOCKED',
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  Processed = 'PROCESSED'
}

export type EmailTransactionLogUpdateInput = {
  email: Scalars['String']['input'];
  emailTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  lastStatus?: InputMaybe<EmailTransactionLogStatus>;
  reason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum EmailTransactionStatus {
  Failed = 'FAILED',
  PartiallySent = 'PARTIALLY_SENT',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type EndOfDayDocumentProcessingJobEntity = {
  __typename?: 'EndOfDayDocumentProcessingJobEntity';
  createdAt: Scalars['DateTime']['output'];
  dateUploadedFor: Scalars['DateTime']['output'];
  status: EndOfDayDocumentsProcessingJobStatus;
  updatedAt: Scalars['DateTime']['output'];
  uploadedFileName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum EndOfDayDocumentsProcessingJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type EodDocumentCreateInput = {
  bucket: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  signerName?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EquipmentCreateInput = {
  /** capacity of equipment */
  capacity?: InputMaybe<Scalars['Float']['input']>;
  /** equipment licenses to be created for this equipment */
  equipmentLicenseCreateInputs: Array<EquipmentLicenseCreateInput>;
  /** height of equipment */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** length of equipment */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** measurement system used for equipment data */
  measurementSystem: MeasurementSystem;
  /** name of equipment */
  name: Scalars['String']['input'];
  /** notes for equipment */
  notes?: InputMaybe<Scalars['String']['input']>;
  samsaraIsDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** special operating rules for equipment */
  specialRules?: InputMaybe<Scalars['String']['input']>;
  type: EquipmentType;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  /** weight of equipment */
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** width of equipment */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type EquipmentEntity = {
  __typename?: 'EquipmentEntity';
  capacity?: Maybe<Scalars['Float']['output']>;
  equipmentLicenses: Array<EquipmentLicenseEntity>;
  height?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  /** Measurement system used. Defaults to Imperial */
  measurementSystem: MeasurementSystem;
  motiveIsDeactivated?: Maybe<Scalars['Boolean']['output']>;
  motiveVehicleId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  samsaraIsDeactivated?: Maybe<Scalars['Boolean']['output']>;
  samsaraVehicleId?: Maybe<Scalars['String']['output']>;
  specialRules?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  type: EquipmentType;
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type EquipmentLicenseArrayUpdateInput = {
  equipmentLicenseCreateInput?: InputMaybe<EquipmentLicenseCreateInput>;
  equipmentLicenseUpdateInput?: InputMaybe<EquipmentLicenseUpdateInput>;
};

export type EquipmentLicenseCreateInput = {
  /** Expiry date of the license */
  expiryDate: Scalars['DateTime']['input'];
  /** Issue date of the license */
  issueDate: Scalars['DateTime']['input'];
  /** Equipment license type */
  licenseType: Scalars['String']['input'];
  /** Licensing body which provided the license */
  licensingBody: Scalars['String']['input'];
  /** Equipment license Number (e.g. plate number) */
  number: Scalars['String']['input'];
};

export type EquipmentLicenseEntity = {
  __typename?: 'EquipmentLicenseEntity';
  /** Expiry date of the license */
  expiryDate: Scalars['DateTime']['output'];
  /** Issue date of the license */
  issueDate: Scalars['DateTime']['output'];
  /** Equipment license type */
  licenseType: Scalars['String']['output'];
  /** Licensing body which provided the license */
  licensingBody: Scalars['String']['output'];
  /** Equipment license Number (e.g. plate number) */
  number: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type EquipmentLicenseUpdateInput = {
  /** New expiry date */
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** New issue date */
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** New license type */
  licenseType?: InputMaybe<Scalars['String']['input']>;
  /** New licensing body */
  licensingBody?: InputMaybe<Scalars['String']['input']>;
  /** New license number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** uuid of equipment license to update */
  uuid: Scalars['String']['input'];
};

export enum EquipmentType {
  Chassis = 'CHASSIS',
  Trailer = 'TRAILER',
  Vehicle = 'VEHICLE'
}

export type EquipmentUpdateInput = {
  /** capacity of equipment */
  capacity?: InputMaybe<Scalars['Float']['input']>;
  /** update objects (union type) for equipment licenses */
  equipmentLicenseArrayUpdateInputs?: InputMaybe<Array<EquipmentLicenseArrayUpdateInput>>;
  /** height of equipment */
  height?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** length of equipment */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** measurement system used for equipment data */
  measurementSystem?: InputMaybe<MeasurementSystem>;
  /** name of equipment */
  name?: InputMaybe<Scalars['String']['input']>;
  /** notes for equipment */
  notes?: InputMaybe<Scalars['String']['input']>;
  samsaraIsDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** special operating rules for equipment */
  specialRules?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EquipmentType>;
  /** uuid of the equipment to be updated */
  uuid: Scalars['String']['input'];
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  /** weight of equipment */
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** width of equipment */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type EstimateDocExtractionEvalRunInput = {
  config: Scalars['JSON']['input'];
  evalSetId: Scalars['String']['input'];
  executionMode?: InputMaybe<Scalars['String']['input']>;
};

export type EtaEntity = {
  __typename?: 'EtaEntity';
  arrivalTime: Scalars['DateTime']['output'];
  finishTime: Scalars['DateTime']['output'];
};

export type ExecutePackingPendencyInput = {
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  pendencyUuid: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PieceStatus>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type ExecutePackingPendencyOutput = {
  __typename?: 'ExecutePackingPendencyOutput';
  packingPendency: PackingPendencyEntity;
  piece?: Maybe<PieceEntity>;
  restoredPieceCount?: Maybe<Scalars['Int']['output']>;
  unpackedParentCount?: Maybe<Scalars['Int']['output']>;
};

export type ExistingInvoiceToUpdate = {
  __typename?: 'ExistingInvoiceToUpdate';
  invoiceUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ordersToAdd: Array<OrderToAddToInvoice>;
};

export type ExistingSettlementBillInput = {
  driverSettlementBillUuid: Scalars['String']['input'];
  settlementBillLineItemIds: Array<Scalars['String']['input']>;
};

export type ExpeditorsApiStatusEntity = {
  __typename?: 'ExpeditorsApiStatusEntity';
  connection: ExpeditorsConnectionHealth;
  generatedAt: Scalars['DateTime']['output'];
  timezone: Scalars['String']['output'];
  transmissions: Array<ExpeditorsTransmissionRow>;
  transmissionsTotal: Scalars['Int']['output'];
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
};

export type ExpeditorsConnectionHealth = {
  __typename?: 'ExpeditorsConnectionHealth';
  avgAttempts?: Maybe<Scalars['Float']['output']>;
  degraded: Scalars['Boolean']['output'];
  failingSendsCount: Scalars['Int']['output'];
  heldCount: Scalars['Int']['output'];
  longestWaitMinutes?: Maybe<Scalars['Int']['output']>;
};

export type ExpeditorsOutboundRequestEventEntity = {
  __typename?: 'ExpeditorsOutboundRequestEventEntity';
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  httpStatusCode?: Maybe<Scalars['Int']['output']>;
  requestType: ExpeditorsOutboundRequestType;
  uuid: Scalars['String']['output'];
  workOrderNumber?: Maybe<Scalars['String']['output']>;
};

export enum ExpeditorsOutboundRequestType {
  AcceptWorkOrder = 'ACCEPT_WORK_ORDER',
  DownloadDocuments = 'DOWNLOAD_DOCUMENTS',
  GetAllWorkOrderByStatus = 'GET_ALL_WORK_ORDER_BY_STATUS',
  GetAvailableWorkOrders = 'GET_AVAILABLE_WORK_ORDERS',
  GetFreightDetails = 'GET_FREIGHT_DETAILS',
  GetWorkOrder = 'GET_WORK_ORDER',
  RejectWorkOrder = 'REJECT_WORK_ORDER',
  UpdateStatus = 'UPDATE_STATUS',
  UploadDocument = 'UPLOAD_DOCUMENT'
}

/** What one outbound call carried to Expeditors. */
export enum ExpeditorsTransmissionKind {
  Accepted = 'ACCEPTED',
  Arrived = 'ARRIVED',
  ArrivedPickup = 'ARRIVED_PICKUP',
  Delivered = 'DELIVERED',
  DeliveredWithPodImage = 'DELIVERED_WITH_POD_IMAGE',
  Other = 'OTHER',
  OtherDocument = 'OTHER_DOCUMENT',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  PickedUp = 'PICKED_UP',
  PickupAppointment = 'PICKUP_APPOINTMENT',
  PodImage = 'POD_IMAGE',
  Rejected = 'REJECTED'
}

/** Where a transmission to Expeditors ended up. */
export enum ExpeditorsTransmissionResult {
  AlreadyApplied = 'ALREADY_APPLIED',
  ConnectionError = 'CONNECTION_ERROR',
  Received = 'RECEIVED',
  RejectedByForwarder = 'REJECTED_BY_FORWARDER'
}

export type ExpeditorsTransmissionRow = {
  __typename?: 'ExpeditorsTransmissionRow';
  consigneeCity?: Maybe<Scalars['String']['output']>;
  consigneeName?: Maybe<Scalars['String']['output']>;
  consigneeState?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventUuid: Scalars['String']['output'];
  kind: ExpeditorsTransmissionKind;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  result: ExpeditorsTransmissionResult;
  retriedLater: Scalars['Boolean']['output'];
  transmittedAt: Scalars['DateTime']['output'];
};

export type ExpireQuoteAgentPreviousForwardingTokenOutput = ExpireQuoteAgentPreviousForwardingTokenSuccessOutput | MutationErrorOutput;

export type ExpireQuoteAgentPreviousForwardingTokenSuccessOutput = {
  __typename?: 'ExpireQuoteAgentPreviousForwardingTokenSuccessOutput';
  forwardingAddress: Scalars['String']['output'];
  /** False when no replaced address was still working, so nothing changed. */
  previousExpired: Scalars['Boolean']['output'];
};

export type ExpiredTariffGroupEntity = {
  __typename?: 'ExpiredTariffGroupEntity';
  /** Other tariff groups that also expired and would have rated this shipment, so a "+N more" affordance can name them. */
  additional: Array<ExpiredTariffGroupSummaryEntity>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tariffGroupScope?: Maybe<TariffGroupScope>;
  tariffGroupType?: Maybe<TariffGroupType>;
};

export type ExpiredTariffGroupSummaryEntity = {
  __typename?: 'ExpiredTariffGroupSummaryEntity';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ExportInvoicesToQuickbooksInput = {
  invoiceUuids: Array<Scalars['String']['input']>;
};

export type ExportQuickbooksResult = {
  __typename?: 'ExportQuickbooksResult';
  conductorUserFacingErrors: Array<Scalars['String']['output']>;
  duplicateInvoiceError?: Maybe<Scalars['String']['output']>;
  failedInvoiceUuid: Scalars['String']['output'];
  invoice: QuickbooksDesktopInvoiceEntity;
  missingAccessorialMappings: Array<Scalars['String']['output']>;
  missingCustomerName?: Maybe<Scalars['String']['output']>;
  missingCustomerUuid?: Maybe<Scalars['String']['output']>;
  missingFreightChargeMappings: Array<Scalars['String']['output']>;
  missingFuelChargeMappings: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ExternalFreightRatingStatus {
  NeedsRate = 'NEEDS_RATE',
  Rated = 'RATED',
  Stored = 'STORED'
}

export type ExternalRateQuoteDownloadEntity = {
  __typename?: 'ExternalRateQuoteDownloadEntity';
  attemptCount: Scalars['Int']['output'];
  attemptedAt: Scalars['DateTime']['output'];
  cacheHit: Scalars['Boolean']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  errorCode?: Maybe<ExternalRatingErrorCode>;
  /** 0, or 1 for the fallback after SMC3 code 32. */
  exchangeOrdinal: Scalars['Int']['output'];
  /** The reference ID shown with a rating error. */
  operationId: Scalars['String']['output'];
  provider: ExternalRatingProvider;
  providerCode?: Maybe<Scalars['String']['output']>;
  providerEnvironment: Scalars['String']['output'];
  providerFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  request: Scalars['JSON']['output'];
  /** Null when no answer arrived. */
  response?: Maybe<Scalars['JSON']['output']>;
  status: ExternalRateQuoteStatus;
  uuid: Scalars['String']['output'];
  wireRequest: Scalars['JSON']['output'];
};

export type ExternalRateQuoteEntity = {
  __typename?: 'ExternalRateQuoteEntity';
  billedWeightLbs?: Maybe<Scalars['Int']['output']>;
  deficitWeightLbs?: Maybe<Scalars['Int']['output']>;
  errorCode?: Maybe<ExternalRatingErrorCode>;
  finalCents?: Maybe<Scalars['Int']['output']>;
  grossTotalCents?: Maybe<Scalars['Int']['output']>;
  lines: Array<ExternalRatingLine>;
  minimumChargeCents?: Maybe<Scalars['Int']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  providerFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  ratingDate: PlainDate;
  ratingDateSource: RatingDateSource;
  status: ExternalRateQuoteStatus;
  tariffEffectiveDate: PlainDate;
  tariffName: Scalars['String']['output'];
  tariffResolutionReason: TariffResolutionReason;
  uuid: Scalars['String']['output'];
};

export enum ExternalRateQuoteStatus {
  ProviderError = 'PROVIDER_ERROR',
  Rated = 'RATED',
  RejectedResponse = 'REJECTED_RESPONSE',
  TransportError = 'TRANSPORT_ERROR'
}

export enum ExternalRatingErrorCode {
  AmountOutOfRange = 'AMOUNT_OUT_OF_RANGE',
  AuthFailed = 'AUTH_FAILED',
  InvalidPostalCode = 'INVALID_POSTAL_CODE',
  InvalidWeight = 'INVALID_WEIGHT',
  LicenseExpired = 'LICENSE_EXPIRED',
  MalformedResponse = 'MALFORMED_RESPONSE',
  MissingClass = 'MISSING_CLASS',
  MissingPackages = 'MISSING_PACKAGES',
  MissingTerminalAddress = 'MISSING_TERMINAL_ADDRESS',
  MissingWeight = 'MISSING_WEIGHT',
  NotYetRated = 'NOT_YET_RATED',
  NoTariffConfigured = 'NO_TARIFF_CONFIGURED',
  NoTariffVersion = 'NO_TARIFF_VERSION',
  PinnedVersionUnavailable = 'PINNED_VERSION_UNAVAILABLE',
  PointNotInTariff = 'POINT_NOT_IN_TARIFF',
  PointUnresolved = 'POINT_UNRESOLVED',
  PostalCodeRejected = 'POSTAL_CODE_REJECTED',
  ProviderErrorOther = 'PROVIDER_ERROR_OTHER',
  ProviderNotEnabled = 'PROVIDER_NOT_ENABLED',
  ProviderPaused = 'PROVIDER_PAUSED',
  ProviderRateLimited = 'PROVIDER_RATE_LIMITED',
  ProviderRequestRejected = 'PROVIDER_REQUEST_REJECTED',
  ProviderServerError = 'PROVIDER_SERVER_ERROR',
  ProviderTimeout = 'PROVIDER_TIMEOUT',
  ProviderUnreachable = 'PROVIDER_UNREACHABLE',
  TariffListUnavailable = 'TARIFF_LIST_UNAVAILABLE',
  TariffProblem = 'TARIFF_PROBLEM',
  TransactionLimit = 'TRANSACTION_LIMIT',
  UnreconciledResponse = 'UNRECONCILED_RESPONSE',
  UnsupportedCountry = 'UNSUPPORTED_COUNTRY',
  UnsupportedCurrency = 'UNSUPPORTED_CURRENCY',
  WeightOutOfRange = 'WEIGHT_OUT_OF_RANGE'
}

export type ExternalRatingFailure = {
  __typename?: 'ExternalRatingFailure';
  code: ExternalRatingErrorCode;
  message: Scalars['String']['output'];
  packageIndex?: Maybe<Scalars['Int']['output']>;
  /** The operation ID support searches in logs and exchanges */
  referenceId?: Maybe<Scalars['String']['output']>;
  retryAfter?: Maybe<Scalars['DateTime']['output']>;
  retryable: Scalars['Boolean']['output'];
};

export type ExternalRatingLine = {
  __typename?: 'ExternalRatingLine';
  amountCents: Scalars['Int']['output'];
  freightClass?: Maybe<Scalars['String']['output']>;
  isMinimumAdjustment: Scalars['Boolean']['output'];
  weightLbs?: Maybe<Scalars['Int']['output']>;
};

export enum ExternalRatingProvider {
  Smc3 = 'SMC3'
}

export type ExternalRatingResult = ExternalRatingFailure | ExternalRatingSuccess;

export type ExternalRatingSuccess = {
  __typename?: 'ExternalRatingSuccess';
  deficitWeightLbs: Scalars['Int']['output'];
  finalCents: Scalars['Int']['output'];
  lines: Array<ExternalRatingLine>;
  minimumAdjustmentCents: Scalars['Int']['output'];
  /** ISO date, YYYY-MM-DD */
  tariffEffectiveDate: Scalars['String']['output'];
  tariffName: Scalars['String']['output'];
};

export type ExtractedFieldEntity = {
  __typename?: 'ExtractedFieldEntity';
  field: FieldMapping;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ExtractedFieldInput = {
  field?: InputMaybe<FieldMapping>;
  value: Scalars['String']['input'];
};

export enum ExtractionType {
  Contact = 'CONTACT',
  Noop = 'NOOP',
  Regex = 'REGEX',
  SelectAll = 'SELECT_ALL',
  TrimLeft = 'TRIM_LEFT',
  TrimRight = 'TRIM_RIGHT'
}

export type FeatureFlagCompanyOverrideArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  featureFlagCompanyOverrideCreateInput?: InputMaybe<FeatureFlagCompanyOverrideCreateInput>;
  /** Pass this field in to update an array item */
  featureFlagCompanyOverrideUpdateInput?: InputMaybe<FeatureFlagCompanyOverrideUpdateInput>;
};

export type FeatureFlagCompanyOverrideCreateInput = {
  active: Scalars['Boolean']['input'];
  companyUuid: Scalars['String']['input'];
};

export type FeatureFlagCompanyOverrideEntity = {
  __typename?: 'FeatureFlagCompanyOverrideEntity';
  active: Scalars['Boolean']['output'];
  /** Convenience field for retool */
  companyName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FeatureFlagCompanyOverrideUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type FeatureFlagCreateInput = {
  active: Scalars['Boolean']['input'];
  featureFlagCompanyOverrideCreateInput?: InputMaybe<Array<FeatureFlagCompanyOverrideCreateInput>>;
  name: Scalars['String']['input'];
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagEntity = {
  __typename?: 'FeatureFlagEntity';
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  versionId?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagInput = {
  name: Scalars['String']['input'];
};

export type FeatureFlagRemoveInput = {
  uuid: Scalars['String']['input'];
};

export type FeatureFlagUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  featureFlagCompanyOverrideArrayUpdateInput?: InputMaybe<Array<FeatureFlagCompanyOverrideArrayUpdateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagUserOverrideEntity = {
  __typename?: 'FeatureFlagUserOverrideEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  featureFlagUuid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserActorEntity;
  /** Convenience field for retool  */
  userEmail: Scalars['String']['output'];
  userUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FieldExtractorEntity = {
  __typename?: 'FieldExtractorEntity';
  mapping: FieldMapping;
  type: ExtractionType;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FieldExtractorInput = {
  mapping: FieldMapping;
  type: ExtractionType;
  value: Scalars['String']['input'];
};

export enum FieldMapping {
  BillOfLadingNumber = 'BILL_OF_LADING_NUMBER',
  CodAmount = 'COD_AMOUNT',
  CodCurrency = 'COD_CURRENCY',
  ConsigneeAddressAll = 'CONSIGNEE_ADDRESS_ALL',
  ConsigneeAddressCity = 'CONSIGNEE_ADDRESS_CITY',
  ConsigneeAddressCountry = 'CONSIGNEE_ADDRESS_COUNTRY',
  ConsigneeAddressLine_1 = 'CONSIGNEE_ADDRESS_LINE_1',
  ConsigneeAddressLine_2 = 'CONSIGNEE_ADDRESS_LINE_2',
  ConsigneeAddressState = 'CONSIGNEE_ADDRESS_STATE',
  ConsigneeAddressZip = 'CONSIGNEE_ADDRESS_ZIP',
  ConsigneeContactFirstName = 'CONSIGNEE_CONTACT_FIRST_NAME',
  ConsigneeContactLastName = 'CONSIGNEE_CONTACT_LAST_NAME',
  ConsigneeName = 'CONSIGNEE_NAME',
  ConsigneePhone = 'CONSIGNEE_PHONE',
  Contact = 'CONTACT',
  CurrentPage = 'CURRENT_PAGE',
  DeadlineDate = 'DEADLINE_DATE',
  DeadlineDateStated = 'DEADLINE_DATE_STATED',
  DeadlineType = 'DEADLINE_TYPE',
  DeclaredValueAmount = 'DECLARED_VALUE_AMOUNT',
  DeclaredValueCurrency = 'DECLARED_VALUE_CURRENCY',
  Delivery = 'DELIVERY',
  DeliveryOrderNumber = 'DELIVERY_ORDER_NUMBER',
  DocumentDate = 'DOCUMENT_DATE',
  FreightChargeAmount = 'FREIGHT_CHARGE_AMOUNT',
  FreightChargeCurrency = 'FREIGHT_CHARGE_CURRENCY',
  HazmatClass = 'HAZMAT_CLASS',
  HazmatProperShippingName = 'HAZMAT_PROPER_SHIPPING_NAME',
  HazmatUnNumber = 'HAZMAT_UN_NUMBER',
  MasterAirwayBill = 'MASTER_AIRWAY_BILL',
  OrderNumber = 'ORDER_NUMBER',
  Package_0Description = 'PACKAGE_0_DESCRIPTION',
  Package_0DimensionUnit = 'PACKAGE_0_DIMENSION_UNIT',
  Package_0Height = 'PACKAGE_0_HEIGHT',
  Package_0Length = 'PACKAGE_0_LENGTH',
  Package_0Quantity = 'PACKAGE_0_QUANTITY',
  Package_0Weight = 'PACKAGE_0_WEIGHT',
  Package_0WeightUnit = 'PACKAGE_0_WEIGHT_UNIT',
  Package_0Width = 'PACKAGE_0_WIDTH',
  Package_1Description = 'PACKAGE_1_DESCRIPTION',
  Package_1DimensionUnit = 'PACKAGE_1_DIMENSION_UNIT',
  Package_1Height = 'PACKAGE_1_HEIGHT',
  Package_1Length = 'PACKAGE_1_LENGTH',
  Package_1Quantity = 'PACKAGE_1_QUANTITY',
  Package_1Weight = 'PACKAGE_1_WEIGHT',
  Package_1WeightUnit = 'PACKAGE_1_WEIGHT_UNIT',
  Package_1Width = 'PACKAGE_1_WIDTH',
  Package_2Description = 'PACKAGE_2_DESCRIPTION',
  Package_2DimensionUnit = 'PACKAGE_2_DIMENSION_UNIT',
  Package_2Height = 'PACKAGE_2_HEIGHT',
  Package_2Length = 'PACKAGE_2_LENGTH',
  Package_2Quantity = 'PACKAGE_2_QUANTITY',
  Package_2Weight = 'PACKAGE_2_WEIGHT',
  Package_2WeightUnit = 'PACKAGE_2_WEIGHT_UNIT',
  Package_2Width = 'PACKAGE_2_WIDTH',
  Package_3Description = 'PACKAGE_3_DESCRIPTION',
  Package_3DimensionUnit = 'PACKAGE_3_DIMENSION_UNIT',
  Package_3Height = 'PACKAGE_3_HEIGHT',
  Package_3Length = 'PACKAGE_3_LENGTH',
  Package_3Quantity = 'PACKAGE_3_QUANTITY',
  Package_3Weight = 'PACKAGE_3_WEIGHT',
  Package_3WeightUnit = 'PACKAGE_3_WEIGHT_UNIT',
  Package_3Width = 'PACKAGE_3_WIDTH',
  Package_4Description = 'PACKAGE_4_DESCRIPTION',
  Package_4DimensionUnit = 'PACKAGE_4_DIMENSION_UNIT',
  Package_4Height = 'PACKAGE_4_HEIGHT',
  Package_4Length = 'PACKAGE_4_LENGTH',
  Package_4Quantity = 'PACKAGE_4_QUANTITY',
  Package_4Weight = 'PACKAGE_4_WEIGHT',
  Package_4WeightUnit = 'PACKAGE_4_WEIGHT_UNIT',
  Package_4Width = 'PACKAGE_4_WIDTH',
  Package_5Description = 'PACKAGE_5_DESCRIPTION',
  Package_5DimensionUnit = 'PACKAGE_5_DIMENSION_UNIT',
  Package_5Height = 'PACKAGE_5_HEIGHT',
  Package_5Length = 'PACKAGE_5_LENGTH',
  Package_5Quantity = 'PACKAGE_5_QUANTITY',
  Package_5Weight = 'PACKAGE_5_WEIGHT',
  Package_5WeightUnit = 'PACKAGE_5_WEIGHT_UNIT',
  Package_5Width = 'PACKAGE_5_WIDTH',
  Package_6Description = 'PACKAGE_6_DESCRIPTION',
  Package_6DimensionUnit = 'PACKAGE_6_DIMENSION_UNIT',
  Package_6Height = 'PACKAGE_6_HEIGHT',
  Package_6Length = 'PACKAGE_6_LENGTH',
  Package_6Quantity = 'PACKAGE_6_QUANTITY',
  Package_6Weight = 'PACKAGE_6_WEIGHT',
  Package_6WeightUnit = 'PACKAGE_6_WEIGHT_UNIT',
  Package_6Width = 'PACKAGE_6_WIDTH',
  Package_7Description = 'PACKAGE_7_DESCRIPTION',
  Package_7DimensionUnit = 'PACKAGE_7_DIMENSION_UNIT',
  Package_7Height = 'PACKAGE_7_HEIGHT',
  Package_7Length = 'PACKAGE_7_LENGTH',
  Package_7Quantity = 'PACKAGE_7_QUANTITY',
  Package_7Weight = 'PACKAGE_7_WEIGHT',
  Package_7WeightUnit = 'PACKAGE_7_WEIGHT_UNIT',
  Package_7Width = 'PACKAGE_7_WIDTH',
  Package_8Description = 'PACKAGE_8_DESCRIPTION',
  Package_8DimensionUnit = 'PACKAGE_8_DIMENSION_UNIT',
  Package_8Height = 'PACKAGE_8_HEIGHT',
  Package_8Length = 'PACKAGE_8_LENGTH',
  Package_8Quantity = 'PACKAGE_8_QUANTITY',
  Package_8Weight = 'PACKAGE_8_WEIGHT',
  Package_8WeightUnit = 'PACKAGE_8_WEIGHT_UNIT',
  Package_8Width = 'PACKAGE_8_WIDTH',
  Package_9Description = 'PACKAGE_9_DESCRIPTION',
  Package_9DimensionUnit = 'PACKAGE_9_DIMENSION_UNIT',
  Package_9Height = 'PACKAGE_9_HEIGHT',
  Package_9Length = 'PACKAGE_9_LENGTH',
  Package_9Quantity = 'PACKAGE_9_QUANTITY',
  Package_9Weight = 'PACKAGE_9_WEIGHT',
  Package_9WeightUnit = 'PACKAGE_9_WEIGHT_UNIT',
  Package_9Width = 'PACKAGE_9_WIDTH',
  Package_10Description = 'PACKAGE_10_DESCRIPTION',
  Package_10DimensionUnit = 'PACKAGE_10_DIMENSION_UNIT',
  Package_10Height = 'PACKAGE_10_HEIGHT',
  Package_10Length = 'PACKAGE_10_LENGTH',
  Package_10Quantity = 'PACKAGE_10_QUANTITY',
  Package_10Weight = 'PACKAGE_10_WEIGHT',
  Package_10WeightUnit = 'PACKAGE_10_WEIGHT_UNIT',
  Package_10Width = 'PACKAGE_10_WIDTH',
  Pickup = 'PICKUP',
  PickupLocationAddressAll = 'PICKUP_LOCATION_ADDRESS_ALL',
  PickupLocationName = 'PICKUP_LOCATION_NAME',
  PickupNumber = 'PICKUP_NUMBER',
  PickupWindowEnd = 'PICKUP_WINDOW_END',
  PickupWindowStart = 'PICKUP_WINDOW_START',
  ProNumber = 'PRO_NUMBER',
  PurchaseOrderNumber = 'PURCHASE_ORDER_NUMBER',
  SecondaryReferenceNumber = 'SECONDARY_REFERENCE_NUMBER',
  ServiceLevel = 'SERVICE_LEVEL',
  ShipperAddressAll = 'SHIPPER_ADDRESS_ALL',
  ShipperAddressCity = 'SHIPPER_ADDRESS_CITY',
  ShipperAddressCountry = 'SHIPPER_ADDRESS_COUNTRY',
  ShipperAddressLine_1 = 'SHIPPER_ADDRESS_LINE_1',
  ShipperAddressLine_2 = 'SHIPPER_ADDRESS_LINE_2',
  ShipperAddressState = 'SHIPPER_ADDRESS_STATE',
  ShipperAddressZip = 'SHIPPER_ADDRESS_ZIP',
  ShipperContactFirstName = 'SHIPPER_CONTACT_FIRST_NAME',
  ShipperContactLastName = 'SHIPPER_CONTACT_LAST_NAME',
  ShipperName = 'SHIPPER_NAME',
  ShipperPhone = 'SHIPPER_PHONE',
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  TertiaryReferenceNumber = 'TERTIARY_REFERENCE_NUMBER',
  TotalChargesAmount = 'TOTAL_CHARGES_AMOUNT',
  TotalChargesCurrency = 'TOTAL_CHARGES_CURRENCY',
  TotalPages = 'TOTAL_PAGES',
  TotalWeight = 'TOTAL_WEIGHT',
  TotalWeightUnit = 'TOTAL_WEIGHT_UNIT',
  WarehouseReceiptNumber = 'WAREHOUSE_RECEIPT_NUMBER'
}

export type FieldMatcherEntity = {
  __typename?: 'FieldMatcherEntity';
  type: MatcherType;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FieldMatcherInput = {
  type: MatcherType;
  value: Scalars['String']['input'];
};

/** Filter fields for the findLineHaulManifestsV2 query */
export type Fields = {
  departDate?: InputMaybe<DateFilterV2Simple>;
  driverUuidFilter?: InputMaybe<UuidFilterV2Simple>;
  endTerminalUuidFilter?: InputMaybe<UuidFilterV2Simple>;
  startTerminalUuidFilter?: InputMaybe<UuidFilterV2Simple>;
  statusFilter?: InputMaybe<LineHaulManifestStatusFilter>;
};

export enum FilterOperator {
  And = 'AND',
  Or = 'OR'
}

export enum FilterViewPage {
  Appointments = 'APPOINTMENTS',
  CustomerPortalOrders = 'CUSTOMER_PORTAL_ORDERS',
  Dispatch = 'DISPATCH',
  Invoices = 'INVOICES',
  LineHaulOrders = 'LINE_HAUL_ORDERS',
  Orders = 'ORDERS',
  OrdersAudit = 'ORDERS_AUDIT',
  Quotes = 'QUOTES',
  StorageOrders = 'STORAGE_ORDERS',
  StorageUnits = 'STORAGE_UNITS'
}

export type FinalizeInvoicesInput = {
  /** The invoice date to assign all included invoices */
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids: Array<Scalars['String']['input']>;
};

export type FinalizeInvoicesOutput = {
  __typename?: 'FinalizeInvoicesOutput';
  count: Scalars['Int']['output'];
};

export type FinalizeOrdersInput = {
  /** The UUIDs of the orders to be finalized */
  uuids: Array<Scalars['String']['input']>;
};

export type FinalizeOrdersOutput = FinalizeOrdersSuccessOutput | MutationErrorOutput;

export type FinalizeOrdersSuccessOutput = {
  __typename?: 'FinalizeOrdersSuccessOutput';
  /** The list of order UUIDs that were not finalized */
  failedOrderUuids: Array<Scalars['String']['output']>;
  /** The list of order UUIDs that were successfully finalized */
  finalizedOrderUuids: Array<Scalars['String']['output']>;
};

export type FinalizeSettlementBillResult = {
  __typename?: 'FinalizeSettlementBillResult';
  bill: DriverSettlementBillEntity;
  /** User-facing error message if bill failed to finalize. Otherwise null. */
  error?: Maybe<Scalars['String']['output']>;
};

export type FinalizeSettlementBillsInput = {
  /** The UUIDs of the driver settlement bills to finalize */
  billUuids: Array<Scalars['String']['input']>;
};

export type FinalizeSettlementBillsOutput = FinalizeSettlementBillsSuccessOutput | MutationErrorOutput;

export type FinalizeSettlementBillsSuccessOutput = {
  __typename?: 'FinalizeSettlementBillsSuccessOutput';
  results: Array<FinalizeSettlementBillResult>;
};

export type FindAccessorialDateRangeConfigsInput = {
  /** The UUID of the accessorial to retrieve the date range configs for */
  accessorialUuid: Scalars['String']['input'];
};

export type FindAccessorialDateRangeConfigsOutput = {
  __typename?: 'FindAccessorialDateRangeConfigsOutput';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
};

export type FindAvailablePiecesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filter to pieces matching this customer on either of two branches: the directly linked order's billing-party contact, or the customer named at receipt for freight that arrived without an order. A piece owned only through a package is NOT matched, even though the grid displays that package's order billing party as its customer. */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by piece height */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Search across every terminal instead of defaulting to the order's current terminal. Ignored when terminalUuid is set. */
  includeAllTerminals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to pieces that arrived as unalerted freight (no linked order at scan time) */
  isUnalertedFreight?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by piece length */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** The UUID of the order to link pieces to */
  orderUuid: Scalars['String']['input'];
  /** Reference numbers for auto-suggest matching */
  referenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search text to match against referenceNumber and additionalReferenceNumbers */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Filter by piece status (any of). When omitted, defaults to ARRIVED if the company's configuration allows linking ARRIVED pieces; otherwise defaults to every status the configuration allows linking. */
  statuses?: InputMaybe<Array<PieceStatus>>;
  /** Filter to pieces at this terminal. When set, replaces the default scope derived from the order's current terminal and takes precedence over includeAllTerminals. */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter to pieces in this warehouse location */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter to pieces in this warehouse */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter by piece width */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type FindAvailableSchedulingSlotsInput = {
  /** Most slots to return, between 1 and 50. Outside that range is a validation error rather than a clamp. Defaults to 50. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Earliest service day to consider, as YYYY-MM-DD. Defaults to today in the company time zone, and is never read as earlier than that. It moves the window, and is not a cursor: it cannot resume part-way through a service day whose slots were cut off by the result cap. */
  fromDateIso8601?: InputMaybe<Scalars['String']['input']>;
  /** The order the slots are being offered for. */
  orderUuid: Scalars['String']['input'];
  /** Latest service day to consider, as YYYY-MM-DD. Defaults to the company booking horizon, and is never read as later than it. */
  toDateIso8601?: InputMaybe<Scalars['String']['input']>;
};

export type FindBookedStopsByResourceInput = {
  /** The day to read, as YYYY-MM-DD in the company time zone, matched against each shipment's delivery date. */
  serviceDateIso8601: Scalars['String']['input'];
  /** Only stops at this terminal, plus stops with no terminal, as the dispatch stops grid narrows by the page's terminal selector. A terminal of another company matches nothing beyond those terminal-less stops. Omitted means every terminal. */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindBusinessDivisionsOutput = {
  __typename?: 'FindBusinessDivisionsOutput';
  businessDivisions: Array<BusinessDivisionEntity>;
};

export type FindClientQuotesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FindQuoteFiltersInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export enum FindCompanyDocumentStatusFilter {
  All = 'All',
  Matched = 'Matched',
  Processing = 'Processing',
  Unmatched = 'Unmatched'
}

export type FindCompanyOrdersInDateRangeInput = {
  companyUuid: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  excludeOrdersOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  requireOrderToBeOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
  statuses: Array<OrderStatus>;
};

export type FindCompanyOrdersInDateRangeOutput = {
  __typename?: 'FindCompanyOrdersInDateRangeOutput';
  orders: Array<OrderEntity>;
};

export type FindCompanyPackageTypeConfigsOutput = {
  __typename?: 'FindCompanyPackageTypeConfigsOutput';
  companyPackageTypeConfigs: Array<CompanyPackageTypeConfigEntity>;
};

export type FindCompanySchedulingBlockedDaysInput = {
  /** Earliest day to read, as an ISO-8601 plain date (YYYY-MM-DD). Defaults to today in the company time zone, so a company closed every Christmas does not drag its whole history into a list view. */
  fromDateIso8601?: InputMaybe<Scalars['String']['input']>;
  /** Latest day to read, as an ISO-8601 plain date (YYYY-MM-DD). Defaults to one year from the lower bound, because the read is capped in rows and an open window would silently return only a prefix of the closures. */
  toDateIso8601?: InputMaybe<Scalars['String']['input']>;
};

export enum FindConsolidatableOrdersError {
  AlreadyConsolidated = 'ALREADY_CONSOLIDATED',
  MultipleAddresses = 'MULTIPLE_ADDRESSES'
}

export type FindContactItemsInput = {
  /** The UUID of the contact to retrieve all the items for */
  contactUuid: Scalars['String']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindContactItemsOutput = {
  __typename?: 'FindContactItemsOutput';
  items: Array<ItemEntity>;
};

export type FindCustomerPortalQuotesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filters for the customerPortalQuotes query. The source filter is ignored and always set to CUSTOMER_PORTAL. */
  filters?: InputMaybe<FindQuoteFiltersInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type FindEffectiveOrganizationPackageTypeConfigsOutput = {
  __typename?: 'FindEffectiveOrganizationPackageTypeConfigsOutput';
  effectivePackageTypeConfigs: Array<EffectivePackageTypeConfigEntity>;
};

export type FindEmailTransactionsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindEmailTransactionsOutput = {
  __typename?: 'FindEmailTransactionsOutput';
  /** A connection that represents paginated email transactions */
  emailTransactionConnection: EmailTransactionConnection;
};

export type FindFuelProfileDateRangesInput = {
  fuelProfileUuid: Scalars['String']['input'];
};

export type FindFuelProfileDateRangesOutput = {
  __typename?: 'FindFuelProfileDateRangesOutput';
  fuelProfileDateRanges: Array<FuelProfileDateRangeEntity>;
};

export type FindFuelProfileInput = {
  uuid: Scalars['String']['input'];
};

export type FindFuelProfileOutput = {
  __typename?: 'FindFuelProfileOutput';
  fuelProfile: FuelProfileEntity;
};

export type FindIngestedOutlookEmailAttachmentsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<IngestedOutlookEmailAttachmentProcessingStatus>;
};

export type FindIngestedOutlookEmailsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Search term for matching against messageId, subject, sender, or body */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindInventoryCountInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Restrict the line connection to a single state. */
  state?: InputMaybe<InventoryCountLineState>;
  uuid: Scalars['String']['input'];
};

export type FindInventoryCountOutput = {
  __typename?: 'FindInventoryCountOutput';
  inventoryCount: InventoryCountEntity;
  lineConnection: InventoryCountLineConnection;
};

export type FindInventoryCountsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to counts started on or before this date. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Restrict to closed (true) or open (false) counts. Omitted returns both. */
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to counts started on or after this date. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). Used only to read which calendar day a picked date means; day boundaries are computed in the company time zone. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindInventoryCountsOutput = {
  __typename?: 'FindInventoryCountsOutput';
  inventoryCountConnection: InventoryCountConnection;
};

export type FindInvoiceEdiTransactionsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the invoice to retrieve the EDI transactions for */
  invoiceUuid: Scalars['String']['input'];
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FindInvoiceEdiTransactionsOutput = {
  __typename?: 'FindInvoiceEdiTransactionsOutput';
  /** The paginated EDI transactions associated with the invoice. Currently, only 210 transaction sets are associated with invoices. */
  ediTransactionConnection: EdiTransactionConnection;
};

export type FindInvoiceEmailsApiLogsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  isFailedEmailTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  isSuccessfulEmailTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Ignored. The page size is always capped at 1000.
   * @deprecated Ignored; the page size is always capped at 1000.
   */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindInvoiceEmailsApiLogsOutput = {
  __typename?: 'FindInvoiceEmailsApiLogsOutput';
  apiLogConnection: ApiLogConnection;
};

export type FindInvoicesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  /** Should not be used outside of internal tooling and audits. */
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Should not be used outside of internal tooling and audits. */
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the list to the invoices under one group of the grouped invoice list: one entry per grouping level, outermost first, each carrying the group key the `invoiceGroups` query returned. Every other filter still applies. */
  groupPath?: InputMaybe<Array<InvoiceTableGroupPathEntryInput>>;
  /** If true, only return invoices whose last QuickBooks sync failed. If false, only return invoices with no recorded sync failure. If null, do not apply the filter. */
  hasQuickbooksSyncFailure?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return closed invoices with a zero non-null balanceCents. If false, only return open invoices with a non-zero non-null balanceCents. If null, do not apply any balance filter. Note that only posted invoices have a non-null balanceCents. */
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters by invoice number, matching either the per-contact ordinal or the company journal number. Combined with searchText via AND when both are present. in/nin accept at most 1000 values. */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return invoices with a non-null lastSyncedToQuickbooksAt. */
  isSyncedToQuickbooks?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return invoices with a non-sync syncedToQuickbooksDesktopAt. */
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restricts the result to invoices whose last QuickBooks sync failed with one of these failure codes. Combined with hasQuickbooksSyncFailure via AND when both are present. */
  quickbooksSyncFailureCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  removeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindInvoicesSort = {
  sortBy: FindInvoicesSortFields;
  sortDirection: SortDirection;
};

export enum FindInvoicesSortFields {
  CreatedAt = 'CreatedAt',
  Date = 'Date',
  DueDate = 'DueDate',
  InvoiceNameOrJournalNumber = 'InvoiceNameOrJournalNumber'
}

export type FindItemGroupsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billedFilter?: InputMaybe<BooleanFilter>;
  companyUuidFilter?: InputMaybe<StringFilter>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  markedOnHandAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  markedOsdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  pickedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  quantityFilter?: InputMaybe<ItemGroupQuantityFilter>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). Used only to read which calendar day a picked date filter value means; day boundaries are computed in the company time zone. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  warehouseLocationUuidFilter?: InputMaybe<StringFilter>;
  warehouseUuidFilter?: InputMaybe<StringFilter>;
};

export type FindLaneFromOriginAndDestinationTerminalInput = {
  destinationTerminalUuid: Scalars['String']['input'];
  originTerminalUuid: Scalars['String']['input'];
};

export type FindLaneFromOriginAndDestinationTerminalOutput = {
  __typename?: 'FindLaneFromOriginAndDestinationTerminalOutput';
  lane?: Maybe<LineHaulLaneEntity>;
};

export type FindLineHaulManifestsOutput = {
  __typename?: 'FindLineHaulManifestsOutput';
  lineHaulManifests: Array<LineHaulManifestEntity>;
  unmanifestedSegments: Array<LineHaulSegmentEntity>;
};

/** Filters for the findLineHaulManifestsV2 query. Use either "and" or "or" filters, but not both simultaneously. Using both in the same query may lead to unexpected results. */
export type FindLineHaulManifestsV2FiltersInput = {
  and?: InputMaybe<Array<LineHaulManifestFilters>>;
  or?: InputMaybe<Array<LineHaulManifestFilters>>;
};

export type FindMasterAccountsOutput = {
  __typename?: 'FindMasterAccountsOutput';
  masterAccounts: Array<MasterAccountEntity>;
};

export type FindOpenInvoicesArgs = {
  hideCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FindOrderByShipperBillOfLadingNumberInput = {
  companyUuid: Scalars['String']['input'];
  shipperBillOfLadingNumber: Scalars['String']['input'];
};

export type FindOrderByShipperBillOfLadingNumberOutput = {
  __typename?: 'FindOrderByShipperBillOfLadingNumberOutput';
  /** The most recent order that has the specified shipper bill of lading number */
  order?: Maybe<OrderEntity>;
};

/** The filters, tab and search of an orders table view, for fetching the uuids of the orders in it. Sorting, paging and counting do not apply. */
export type FindOrderUuidsInViewInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filters?: InputMaybe<FindOrdersFiltersInput>;
  /** Filters for orders holding SMC3 freight that needs a rate. Currently only implemented for the flat orders view. */
  freightNeedsRateFilter?: InputMaybe<BooleanFilterV2>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the invoice name on the order table field (used when useJournalNumberForInvoice is false) */
  invoiceNameFilter?: InputMaybe<StringFilterV2>;
  /** An integer filter for the invoice journal number (used when useJournalNumberForInvoice is true) */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** At most this many uuids are returned; `hasMore` says whether the view holds more. */
  limit: Scalars['Int']['input'];
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID filter for the line haul leg destination terminal. Matches orders that have a segment whose end terminal matches. */
  lineHaulLegDestinationTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg (segment). Matches orders assigned to the specified segment via OrderLineHaulSegment. */
  lineHaulLegFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg origin terminal. Matches orders that have a segment whose start terminal matches. */
  lineHaulLegOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A filter for the order's line-haul origin terminal (the order-level origin set for "out of inventory" orders, else the on-hand terminal derivation). Used by the line-haul Outbound tab so out-of-inventory orders are discoverable under their origin terminal. */
  lineHaulOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  /** A UUID filter for terminals derived from piece warehouse locations on the order. Semantics across operators: `eq` / `in` match an order when at least one piece is in a warehouse location whose warehouse belongs to one of the requested terminals. `neq` / `nin` exclude an order when ANY piece is in a warehouse location whose warehouse belongs to one of the requested terminals, so a split order with pieces at multiple terminals is excluded if any of its terminals is in the list. `isBlank` matches orders with no piece-terminal assignment at all; `isNotBlank` matches orders with at least one piece-terminal assignment. */
  pieceTerminalFilter?: InputMaybe<UuidFilterV2>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter for the email of the user who created the order. */
  sourceUserEmailFilter?: InputMaybe<StringFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** Serve the uuids from the SQE (flat_orders.switchover), as the orders table does when its new-search toggle is on, so the selection matches the rows on screen. Requires FF_SQE_ORDERLIST_ENABLED for the company. */
  useSqeBackend?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). Used only to read which calendar day a picked date filter value means; day boundaries are computed in the company time zone, the zone the order list displays dates in. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version ID for the request */
  versionId?: InputMaybe<Scalars['Float']['input']>;
  /** A UUID filter for the warehouse derived from piece locations on the order. This filters by Warehouse UUID (not WarehouseLocation/bin). The warehouse is determined by the unanimous piece-level warehouseId across the order. */
  warehouseLocationFilter?: InputMaybe<UuidFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

/** The uuids of the orders in an orders table view, for selecting the whole view. */
export type FindOrderUuidsInViewOutput = {
  __typename?: 'FindOrderUuidsInViewOutput';
  /** True when the view holds more than `limit` orders. */
  hasMore: Scalars['Boolean']['output'];
  /** Up to `limit` order uuids in the view, in no particular order. Incomplete when `hasMore` is true. */
  uuids: Array<Scalars['String']['output']>;
};

export type FindOrdersBaseInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filters?: InputMaybe<FindOrdersFiltersInput>;
  /** Filters for orders holding SMC3 freight that needs a rate. Currently only implemented for the flat orders view. */
  freightNeedsRateFilter?: InputMaybe<BooleanFilterV2>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the invoice name on the order table field (used when useJournalNumberForInvoice is false) */
  invoiceNameFilter?: InputMaybe<StringFilterV2>;
  /** An integer filter for the invoice journal number (used when useJournalNumberForInvoice is true) */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID filter for the line haul leg destination terminal. Matches orders that have a segment whose end terminal matches. */
  lineHaulLegDestinationTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg (segment). Matches orders assigned to the specified segment via OrderLineHaulSegment. */
  lineHaulLegFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg origin terminal. Matches orders that have a segment whose start terminal matches. */
  lineHaulLegOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A filter for the order's line-haul origin terminal (the order-level origin set for "out of inventory" orders, else the on-hand terminal derivation). Used by the line-haul Outbound tab so out-of-inventory orders are discoverable under their origin terminal. */
  lineHaulOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  /** A UUID filter for terminals derived from piece warehouse locations on the order. Semantics across operators: `eq` / `in` match an order when at least one piece is in a warehouse location whose warehouse belongs to one of the requested terminals. `neq` / `nin` exclude an order when ANY piece is in a warehouse location whose warehouse belongs to one of the requested terminals, so a split order with pieces at multiple terminals is excluded if any of its terminals is in the list. `isBlank` matches orders with no piece-terminal assignment at all; `isNotBlank` matches orders with at least one piece-terminal assignment. */
  pieceTerminalFilter?: InputMaybe<UuidFilterV2>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** True if ascending, False if descending, undefined if no sort */
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  /** A string filter for the email of the user who created the order. */
  sourceUserEmailFilter?: InputMaybe<StringFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). Used only to read which calendar day a picked date filter value means; day boundaries are computed in the company time zone, the zone the order list displays dates in. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version ID for the request */
  versionId?: InputMaybe<Scalars['Float']['input']>;
  /** A UUID filter for the warehouse derived from piece locations on the order. This filters by Warehouse UUID (not WarehouseLocation/bin). The warehouse is determined by the unanimous piece-level warehouseId across the order. */
  warehouseLocationFilter?: InputMaybe<UuidFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

/** Input type for the orders query and the order table report that contains all filters. Excludes any pagination or sorting arguments. */
export type FindOrdersFiltersInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer activeTerminalFilter */
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  /** @deprecated Prefer orderCityFilter */
  addressCityFilter?: InputMaybe<StringFilter>;
  /** @deprecated Prefer orderZipFilter */
  addressZipFilter?: InputMaybe<StringFilter>;
  /** Filters to be combined using a logical AND */
  and?: InputMaybe<Array<FindOrdersFiltersInput>>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  /** @deprecated Prefer customerNameFilter */
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  /** @deprecated Use billingPartyContactUuidFilters instead */
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /**
   * Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact.
   * @deprecated Prefer customerUuidFilter
   */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer businessDivisionUuidFilterV2 */
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  /** @deprecated Prefer controllingTerminalUuidFilterV2 */
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  /** @deprecated Use billingPartyContactDisplayNameFilter instead */
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** @deprecated Prefer destinationTerminalUuidFilterV2 */
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer driverUuidFilterV2 */
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /**
   * Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All").
   * @deprecated Prefer driverUuidFilterV2
   */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  /** @deprecated Prefer outboundCityFilter */
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  /** Filters for orders holding SMC3 freight that needs a rate. Currently only implemented for the flat orders view. */
  freightNeedsRateFilter?: InputMaybe<BooleanFilterV2>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer hasFailuresFilter */
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer hasRouteFilter */
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer hideFromBillingFilter */
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer inboundDriverUuidFilter instead */
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  /** @deprecated Use inboundStopMethodFilterV2 instead */
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** @deprecated Prefer inboundNotArrivedFilter */
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the invoice name on the order table field (used when useJournalNumberForInvoice is false) */
  invoiceNameFilter?: InputMaybe<StringFilterV2>;
  /** An integer filter for the invoice journal number (used when useJournalNumberForInvoice is true) */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Prefer isCancelledFilter */
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isCollectOnDeliveryFilter */
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isFinalizedFilter */
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isHazmatFilter */
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isInBondFilter */
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isLineHaulFilter */
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isOsdFilter */
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isPickedFilter */
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isPickupOrDeliveryFilter */
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isRefusedFilter */
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isSpecialFilter */
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID filter for the line haul leg destination terminal. Matches orders that have a segment whose end terminal matches. */
  lineHaulLegDestinationTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg (segment). Matches orders assigned to the specified segment via OrderLineHaulSegment. */
  lineHaulLegFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg origin terminal. Matches orders that have a segment whose start terminal matches. */
  lineHaulLegOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A filter for the order's line-haul origin terminal (the order-level origin set for "out of inventory" orders, else the on-hand terminal derivation). Used by the line-haul Outbound tab so out-of-inventory orders are discoverable under their origin terminal. */
  lineHaulOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Use terminalUuidsFilter instead by passing it an empty array */
  noTerminal?: InputMaybe<BooleanFilter>;
  /** @deprecated Prefer onHandFilter */
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer onInvoiceFilter */
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** Filters to be combined using a logical OR */
  or?: InputMaybe<Array<FindOrdersFiltersInput>>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer orderNameFilterV2 instead */
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** @deprecated Prefer orderSourceFilter instead */
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer originTerminalUuidFilterV2 */
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer outboundDriverUuidFilter instead */
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  /** @deprecated Use outboundStopMethodFilterV2 instead */
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer paperworkCompleteFilter */
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  /** A UUID filter for terminals derived from piece warehouse locations on the order. Semantics across operators: `eq` / `in` match an order when at least one piece is in a warehouse location whose warehouse belongs to one of the requested terminals. `neq` / `nin` exclude an order when ANY piece is in a warehouse location whose warehouse belongs to one of the requested terminals, so a split order with pieces at multiple terminals is excluded if any of its terminals is in the list. `isBlank` matches orders with no piece-terminal assignment at all; `isNotBlank` matches orders with at least one piece-terminal assignment. */
  pieceTerminalFilter?: InputMaybe<UuidFilterV2>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** @deprecated Prefer requiresRecoveryFilter */
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer requiresRoutingFilter */
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  /** @deprecated Prefer serviceDateFilter instead */
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  /** @deprecated Prefer showConsolidatedOrdersFilter */
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter for the email of the user who created the order. */
  sourceUserEmailFilter?: InputMaybe<StringFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  /** @deprecated Prefer inboundCityFilter */
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  /** @deprecated Use tagUuidsFilter instead */
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer terminalUuidFilterV2 */
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /**
   * Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All").
   * @deprecated Prefer terminalUuidFilterV2
   */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  /** @deprecated Prefer transferPendingFilter */
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the warehouse derived from piece locations on the order. This filters by Warehouse UUID (not WarehouseLocation/bin). The warehouse is determined by the unanimous piece-level warehouseId across the order. */
  warehouseLocationFilter?: InputMaybe<UuidFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

export type FindOrdersOnInvoiceSort = {
  sortBy: FindOrdersOnInvoiceSortFields;
  sortDirection: SortDirection;
};

export enum FindOrdersOnInvoiceSortFields {
  Consignee = 'Consignee',
  MasterAirwayBillOfLadingNumber = 'MasterAirwayBillOfLadingNumber',
  ServiceDate = 'ServiceDate',
  ShipperBillOfLadingNumber = 'ShipperBillOfLadingNumber'
}

export type FindOrganizationInput = {
  uuid: Scalars['String']['input'];
};

export type FindOrganizationNotesInput = {
  organizationUuid: Scalars['String']['input'];
};

export type FindOrganizationPackageTypeConfigsOutput = {
  __typename?: 'FindOrganizationPackageTypeConfigsOutput';
  organizationPackageTypeConfigs: Array<OrganizationPackageTypeConfigEntity>;
};

export type FindOrphanPiecesByBarcodeOutput = {
  __typename?: 'FindOrphanPiecesByBarcodeOutput';
  hasMore: Scalars['Boolean']['output'];
  pieces: Array<PieceEntity>;
};

export type FindPackageSpecsOutput = {
  __typename?: 'FindPackageSpecsOutput';
  packageSpecs: Array<PackageSpecEntity>;
};

export type FindPackingPendenciesInput = {
  afterUuid?: InputMaybe<Scalars['String']['input']>;
  /** Page size. Defaults to and is capped at 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<PackingPendencyStatus>>;
  warehouseUuid: Scalars['String']['input'];
};

export type FindPackingPendenciesOutput = {
  __typename?: 'FindPackingPendenciesOutput';
  packingPendencies: Array<PackingPendencyEntity>;
};

export type FindPaginatedOrganizationPeersInput = {
  /** Forward pagination cursor; provide on subsequent queries. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Backward pagination cursor. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Forward pagination count; provide on initial query. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Backward pagination count. */
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrganizationPeerStatus>;
};

export type FindPaginatedOrganizationsInput = {
  /** forwards pagination cursor, provide this on subsequent queries */
  after?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination cursor, provide this on subsequent queries */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** filter by active organizations. If not provided or undefined it returns all */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** forwards pagination cursor, provide this on subsequent queries */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** search on organization name and reference number */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type FindPaymentsV2Args = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  creditTypeUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** With contactUuid: also return payments received from every customer sharing this customer's master account, in the same company. Defaults to false (payments received from this customer only). */
  includeMasterAccountFamily?: InputMaybe<Scalars['Boolean']['input']>;
  /** With contactUuid: also return payments received from other customers that were applied to this customer's invoices. Defaults to false (payments received from this customer only). */
  includePaymentsAppliedToContactInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return payments where amountInCents = appliedAmountCents. If false, only return payments where amountInCents != appliedAmountCents. If null, return all payments. */
  isFullyApplied?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  paymentDateFilters?: InputMaybe<DateFilterStartEnd>;
  paymentRails?: InputMaybe<Array<PaymentRail>>;
  /** @deprecated Use paymentTypes instead */
  paymentType?: InputMaybe<PaymentType>;
  paymentTypes?: InputMaybe<Array<PaymentType>>;
  /** Filter on the payment reference number only (unlike searchText, which also matches comment, applied-order refs, and amount). String operator values must be at least 3 characters. */
  referenceNumber?: InputMaybe<StringFilterV2>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<PaymentSort>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter to payments with these uuids (company-scoped). An empty array matches nothing. */
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindPersonsOutput = {
  __typename?: 'FindPersonsOutput';
  persons: Array<PersonEntity>;
  totalCount: Scalars['Float']['output'];
};

export type FindPieceReceiptInput = {
  /** UUID of the piece receipt to retrieve */
  uuid: Scalars['String']['input'];
};

export type FindPieceReceiptOutput = {
  __typename?: 'FindPieceReceiptOutput';
  pieceReceipt: PieceReceiptEntity;
};

export type FindPieceReceiptsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  arrivedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  expectedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Restricts results to receipts created from this client. */
  sourceFilter?: InputMaybe<PieceReceiptSource>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuidFilter?: InputMaybe<StringFilter>;
};

export type FindPieceReceiptsOutput = {
  __typename?: 'FindPieceReceiptsOutput';
  /** A connection that represents paginated piece receipts */
  pieceReceiptConnection: PieceReceiptConnection;
};

export type FindPiecesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Lifecycle bucket the client is rendering. Gates the inclusion of bucket-specific relations in the response. */
  bucket?: InputMaybe<PieceBucketKey>;
  /**
   * Filter by customer UUID (the linked order's billing-party contact).
   * @deprecated Use contactUuids instead
   */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter by customer UUIDs (the linked order's billing-party contact, any of). Applied in addition to `contactUuid` if both are provided. */
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict to pieces whose createdAt falls in this range. */
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Restrict to on-dock pieces in the given dwell bands (overdue filter). */
  dwellAlertFilter?: InputMaybe<DwellAlertFilterInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** When true, restrict to parent pieces (those that have at least one child piece), regardless of package type. */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Disable maximum page size limit */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by order UUID */
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive search across piece reference number, order name, customer (billing party) display name, and the linked order HAWB (house bill or shipper BOL) / MAWB. */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Sort order; first element has highest priority */
  sorts?: InputMaybe<Array<FindPiecesSort>>;
  /** Filter by piece status */
  status?: InputMaybe<PieceStatus>;
  /** Filter by piece status (any of). Applied in addition to `status` if both are provided. */
  statuses?: InputMaybe<Array<PieceStatus>>;
  /** Filter by terminal UUID */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter by piece (container) type */
  type?: InputMaybe<PackageType>;
  /** Restrict to pieces not associated to any order (orderId IS NULL). */
  unassociatedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by warehouse location UUID */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter by warehouse UUID */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindPiecesSort = {
  sortBy: FindPiecesSortFields;
  sortDirection: SortDirection;
};

export enum FindPiecesSortFields {
  CreatedAt = 'CreatedAt',
  Hawb = 'Hawb',
  MarkedOnHandAt = 'MarkedOnHandAt',
  Mawb = 'Mawb',
  OrderName = 'OrderName',
  ReferenceNumber = 'ReferenceNumber',
  Status = 'Status',
  TerminalName = 'TerminalName',
  WarehouseLocationName = 'WarehouseLocationName'
}

/** Input type for the quotesV2 query that contains all filters. Excludes any pagination or sorting arguments. */
export type FindQuoteFiltersInput = {
  contactUuidFilter?: InputMaybe<UuidFilterV2>;
  sourceFilter?: InputMaybe<QuoteSourceFilter>;
  statusFilter?: InputMaybe<QuoteStatusFilter>;
};

export enum FindReportSendJobBatchesFields {
  CreatedAtDate = 'CreatedAtDate'
}

export type FindReportSendJobBatchesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<Array<FindReportSendJobBatchesSort>>;
};

export type FindReportSendJobBatchesOutput = {
  __typename?: 'FindReportSendJobBatchesOutput';
  reportSendJobBatchConnection: ReportSendJobBatchConnection;
};

export type FindReportSendJobBatchesSort = {
  sortBy: FindReportSendJobBatchesFields;
  sortDirection: SortDirection;
};

export type FindReportSendJobsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  reportSendJobBatchId: Scalars['String']['input'];
  reportSendJobStatus?: InputMaybe<ReportSendJobStatus>;
};

export type FindReportSendJobsOutput = {
  __typename?: 'FindReportSendJobsOutput';
  reportSendJobConnection: ReportSendJobConnection;
};

export type FindRoleInput = {
  uuid: Scalars['String']['input'];
};

export type FindRoleOutput = {
  __typename?: 'FindRoleOutput';
  role: RoleEntity;
};

export type FindRolesInput = {
  includeInternalRoles: Scalars['Boolean']['input'];
};

export type FindRolesOutput = {
  __typename?: 'FindRolesOutput';
  roles: Array<RoleEntity>;
};

export type FindScannedOrdersInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FindSchedulingRegionsOutput = {
  __typename?: 'FindSchedulingRegionsOutput';
  schedulingRegions: Array<SchedulingRegionEntity>;
};

export type FindSchedulingResourcesByRouteNameInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query. Between 1 and 100; omitting both this and last reads the first 100 */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Include archived resources. Defaults to false. */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count. Between 1 and 100 */
  last?: InputMaybe<Scalars['Int']['input']>;
  routeNameUuid: Scalars['String']['input'];
};

export type FindSchedulingResourcesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query. Between 1 and 100; omitting both this and last reads the first 100 */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Include archived resources. Defaults to false. */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count. Between 1 and 100 */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FindSchedulingResourcesOutput = {
  __typename?: 'FindSchedulingResourcesOutput';
  /** A connection that represents paginated scheduling resources */
  schedulingResourceConnection: SchedulingResourceConnection;
};

export type FindSegmentedLineHaulOrdersInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  sorts?: InputMaybe<Array<LineHaulOrderSort>>;
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindSegmentedLineHaulOrdersInputV2 = {
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Calculate and return the total count. Can be expensive, so use prudently */
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  sorts?: InputMaybe<Array<LineHaulOrderSort>>;
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindServicesForCustomerConfigurationInput = {
  organizationUuid: Scalars['String']['input'];
};

export type FindServicesForCustomerConfigurationOutput = FindServicesForCustomerConfigurationSuccessOutput | QueryErrorOutput;

export type FindServicesForCustomerConfigurationSuccessOutput = {
  __typename?: 'FindServicesForCustomerConfigurationSuccessOutput';
  /** The services available for customer configuration */
  services: Array<ServiceEntity>;
};

export type FindServicesForOrderInput = {
  organizationUuid: Scalars['String']['input'];
  /** The UUID of the currently selected service for the order, if one exists */
  selectedServiceUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindServicesForOrderOutput = FindServicesForOrderSuccessOutput | QueryErrorOutput;

export type FindServicesForOrderSuccessOutput = {
  __typename?: 'FindServicesForOrderSuccessOutput';
  /** The services available for order */
  services: Array<ServiceEntity>;
};

export type FindServicesForThirdPartyUserInput = {
  companyUuid: Scalars['String']['input'];
};

export type FindSettlementBillLineItemsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** The completed at date for the relevant stop that is tied to the settlement bill line item */
  completedDateFilter?: InputMaybe<DateFilterV2>;
  driverSettlementBillUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** We currently do not have a use case for showing line items on finalized driver settlement bills specifically. */
  driverSettlementFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onDriverSettlementBill?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  settlementDateFilter?: InputMaybe<DateFilterV2>;
};

export type FindSftpUploadsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SftpUploadStatus>;
  type?: InputMaybe<SftpUploadType>;
};

export type FindStopsFiltersInput = {
  addressType?: InputMaybe<StandardStopType>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  canDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Control whether all filters need to be satisfied or at least one. Default is AND. */
  filterOperator?: InputMaybe<FilterOperator>;
  /** Filter by whether a stop has either a start or end appointment time set */
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether a stop has an appointment date set */
  hasAppointmentDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** This is equivalent to checking if either appointmentSchedulingOptionsCalledAt or appointmentSchedulingOptionsTextedAt is non-null */
  hasAppointmentOptionsProposed?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, stops with a null serviceDate (unscheduled) are retained alongside the serviceDateFilters range instead of being excluded by it. Used by the dispatch board so windowing the default view never hides unscheduled work. */
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindStorageOrderInput = {
  /** The UUID of the storage order to retrieve */
  uuid: Scalars['String']['input'];
};

export type FindStorageOrderOutput = {
  __typename?: 'FindStorageOrderOutput';
  storageOrder: StorageOrderEntity;
};

export type FindStorageOrderStorageUnitsInput = {
  storageOrderUuid: Scalars['String']['input'];
};

export type FindStorageOrderStorageUnitsOutput = {
  __typename?: 'FindStorageOrderStorageUnitsOutput';
  storageUnits: Array<StorageUnitEntity>;
};

export type FindStorageOrdersInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  arrivedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  expectedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). Used only to read which calendar day a picked date filter value means; day boundaries are computed in the company time zone. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  warehouseUuidFilter?: InputMaybe<StringFilter>;
};

export type FindStorageOrdersOutput = {
  __typename?: 'FindStorageOrdersOutput';
  /** A connection that represents paginated storage orders */
  storageOrderConnection: StorageOrderConnection;
};

export type FindStorageUnitInput = {
  uuid: Scalars['String']['input'];
};

export type FindStorageUnitOutput = {
  __typename?: 'FindStorageUnitOutput';
  storageUnit: StorageUnitEntity;
};

export type FindStorageUnitsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billedFilter?: InputMaybe<BooleanFilter>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  markedOnHandAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  markedOsdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  pickedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). Used only to read which calendar day a picked date filter value means; day boundaries are computed in the company time zone. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  warehouseLocationUuidFilter?: InputMaybe<StringFilter>;
};

export type FindStorageUnitsOutput = {
  __typename?: 'FindStorageUnitsOutput';
  /** A connection that represents paginated storage units */
  storageUnitConnection: StorageUnitConnection;
};

export type FindTariffChainsInput = {
  isArchived: Scalars['Boolean']['input'];
};

export type FindTariffGroupsWithContactAndServicesCombinationOutput = {
  __typename?: 'FindTariffGroupsWithContactAndServicesCombinationOutput';
  /** the contact in that group that has a match */
  contactUuid: Scalars['String']['output'];
  /** the services in that group that has a match */
  matchingTariffGroups: Array<MatchingGroupsAlongWithMatchingServices>;
};

export type FindTariffZoneGroupsInput = {
  isArchived: Scalars['Boolean']['input'];
};

export type FindTerminalForAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type FindTerminalForAddressOutput = {
  __typename?: 'FindTerminalForAddressOutput';
  terminal?: Maybe<TerminalEntity>;
};

export type FindTerminalsForAddressOutput = {
  __typename?: 'FindTerminalsForAddressOutput';
  terminals?: Maybe<Array<TerminalEntity>>;
};

export type FindTerminalsForThirdPartyUserInput = {
  companyUuid: Scalars['String']['input'];
  /** Optionally filter by isActive, defaults to including all terminals */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindTestOrderInput = {
  uuid: Scalars['String']['input'];
};

export type FindTestOrderOutput = {
  __typename?: 'FindTestOrderOutput';
  testOrder: TestOrderEntity;
};

export type FindTestOrdersOutput = {
  __typename?: 'FindTestOrdersOutput';
  testOrders: Array<TestOrderEntity>;
};

export type FindWarehouseEmployeesOutput = {
  __typename?: 'FindWarehouseEmployeesOutput';
  warehouseEmployees: Array<WarehouseEmployeeEntity>;
};

export type FindWarehouseLocationsOutput = {
  __typename?: 'FindWarehouseLocationsOutput';
  warehouseLocations: Array<WarehouseLocationEntity>;
};

export type FingerprintAnchorEntity = {
  __typename?: 'FingerprintAnchorEntity';
  blockId?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  required: Scalars['Boolean']['output'];
  substring?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type FingerprintAnchorInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  required: Scalars['Boolean']['input'];
  substring?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type FingerprintAnchorMatchEntity = {
  __typename?: 'FingerprintAnchorMatchEntity';
  substring?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FingerprintAnchorMatchInput = {
  substring?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type FireOutboundBenchTransactionInput = {
  /** The 990 action. Defaults to ACCEPTED. */
  action990?: InputMaybe<Edi990ActionCode>;
  /** Sends the 214 even when the order already has a successful 214 with that status. */
  allowDuplicate214?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required, and must be true, when the backend runs in production. Ignored elsewhere. */
  confirmProductionSend?: InputMaybe<Scalars['Boolean']['input']>;
  integrationType: BenchIntegrationType;
  orderUuid: Scalars['String']['input'];
  /** Required for a 214. Must be one of the partnership's edi214ShipmentStatuses. */
  status214?: InputMaybe<Edi214ShipmentStatus>;
  /** For CONTACT_ATTEMPTED only: which stop the contact attempt was for. Defaults to the delivery stop, or the pickup when the order has no delivery. */
  stopRole214?: InputMaybe<BenchStopRole>;
  transactionSet: BenchFireTransactionSet;
};

/** A filter object that is used to filter a float field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type FloatFilterV2 = {
  /** Filters for records where the relevant float field is equal to the provided float value */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is greater than the provided float value */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is greater than or equal to the provided float value */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is in the provided float values */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Filters for records where the relevant float field is less than the provided float value */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is less than or equal to the provided float value */
  lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is not equal to the provided float value */
  neq?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is not in the provided float values */
  nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FormatCsvResEntity = {
  __typename?: 'FormatCsvResEntity';
  csvItems: Array<Array<Scalars['String']['output']>>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  missingAccessorialMappings: Array<Scalars['String']['output']>;
  missingCustomerMappings: Array<Scalars['String']['output']>;
  missingFreightChargeMappings: Array<Scalars['String']['output']>;
  missingFuelChargeMappings: Array<Scalars['String']['output']>;
};

/** Encapsulates the paginated list of formatted orders, statistics, and metadata used in the output of order table field values retrieval queries. */
export type FormattedOrderConnection = {
  __typename?: 'FormattedOrderConnection';
  edges: Array<FormattedOrderEdge>;
  /** Not cheap to calculate, request with prudence.  Group UUID = invoice UUID */
  groupedCountsByInvoice?: Maybe<Array<GroupedCounts>>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Version ID for the response */
  versionId?: Maybe<Scalars['Float']['output']>;
};

export type FormattedOrderEdge = {
  __typename?: 'FormattedOrderEdge';
  cursor: Scalars['String']['output'];
  node: FormattedOrderEntity;
};

/** Represents a formatted order that is returned as part of an orders query */
export type FormattedOrderEntity = {
  __typename?: 'FormattedOrderEntity';
  /** The UUID of the organization associated with the order */
  contactUuid: Scalars['String']['output'];
  /** The list of formatted fields for the order. The fields whose values are returned are based on which order table fields are passed into the query input */
  formattedOrderFields: Array<FormattedOrderFieldEntity>;
  freightNeedsRate: Scalars['Boolean']['output'];
  /** Custom output for the "Total Charges with Itemized" column in the orders table. Null if the value is not requested in the query input */
  itemizedChargesField?: Maybe<OrderTableItemizedChargesFieldEntity>;
  /** Custom output for the "Line Haul Manifests" column in the orders table. Null if the value is not requested in the query input */
  lineHaulManifestsField?: Maybe<OrderTableLineHaulManifestsFieldEntity>;
  /** Custom output for the "Dims" column */
  packagesField?: Maybe<OrderTablePackagesFieldEntity>;
  /** Custom output for the "Paperwork Complete" column in the orders table. Null if the value is not requested in the query input */
  paperworkField?: Maybe<OrderTablePaperworkFieldEntity>;
  /** Custom output for the "Photos" column in the orders table. Null if the value is not requested in the query input */
  photosField?: Maybe<OrderTablePhotosFieldEntity>;
  pieceTerminalLocationsDisplay?: Maybe<Scalars['String']['output']>;
  /** Custom output for the "Primary Service" column in the orders table. Null if the value is not requested in the query input */
  serviceField?: Maybe<OrderTableServiceFieldEntity>;
  /** Custom output for the "Tags" column in the orders table. Null if the value is not requested in the query input */
  tagsField?: Maybe<OrderTableTagsFieldEntity>;
  /** The UUID of the corresponding order */
  uuid: Scalars['String']['output'];
};


/** Represents a formatted order that is returned as part of an orders query */
export type FormattedOrderEntityPieceTerminalLocationsDisplayArgs = {
  activeTerminalUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type FormattedOrderFieldEntity = {
  __typename?: 'FormattedOrderFieldEntity';
  orderTableField: OrderTableField;
  value: Scalars['String']['output'];
};

export type ForwarderBoardAcceptanceMissRow = {
  __typename?: 'ForwarderBoardAcceptanceMissRow';
  acceptanceLagMinutes?: Maybe<Scalars['Int']['output']>;
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  orderUuid: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderBoardAcceptanceQueueRow = {
  __typename?: 'ForwarderBoardAcceptanceQueueRow';
  orderUuid: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  waitingMinutes: Scalars['Int']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderBoardAgingQueueRow = {
  __typename?: 'ForwarderBoardAgingQueueRow';
  ageDays: Scalars['Int']['output'];
  orderUuid: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderBoardArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  forwarder: ForwarderBoardForwarder;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  window: ForwarderBoardWindow;
};

export type ForwarderBoardConnectionStats = {
  __typename?: 'ForwarderBoardConnectionStats';
  avgAttempts?: Maybe<Scalars['Float']['output']>;
  heldCount: Scalars['Int']['output'];
  longestWaitMinutes?: Maybe<Scalars['Int']['output']>;
};

export type ForwarderBoardEntity = {
  __typename?: 'ForwarderBoardEntity';
  acceptanceMisses: Array<ForwarderBoardAcceptanceMissRow>;
  acceptanceMissesTotal: Scalars['Int']['output'];
  acceptedWithin12h: ForwarderBoardRateTile;
  awaitingAcceptance: Array<ForwarderBoardAcceptanceQueueRow>;
  awaitingAcceptanceTotal: Scalars['Int']['output'];
  awaitingPod: Array<ForwarderBoardPodQueueRow>;
  awaitingPodTotal: Scalars['Int']['output'];
  completedWithin30OfArrival: ForwarderBoardRateTile;
  connection: ForwarderBoardConnectionStats;
  deliveryEventWithin30: ForwarderBoardRateTile;
  driverEntered: ForwarderBoardRateTile;
  electronicDispatchShare: ForwarderBoardRateTile;
  lateDeliveries: Array<ForwarderBoardLateDeliveryRow>;
  lateDeliveriesTotal: Scalars['Int']['output'];
  manualOrders: Array<ForwarderBoardManualOrderRow>;
  manualOrdersTotal: Scalars['Int']['output'];
  missingPods: Scalars['Int']['output'];
  podWithin30: ForwarderBoardRateTile;
  timezone: Scalars['String']['output'];
  undelivered: Array<ForwarderBoardAgingQueueRow>;
  undeliveredTotal: Scalars['Int']['output'];
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
};

/** The forwarder a Forwarder Board describes. */
export enum ForwarderBoardForwarder {
  Expeditors = 'EXPEDITORS'
}

export type ForwarderBoardLateDeliveryRow = {
  __typename?: 'ForwarderBoardLateDeliveryRow';
  arrivalToCompletionMinutes?: Maybe<Scalars['Int']['output']>;
  deliveredAt: Scalars['DateTime']['output'];
  deliveryEventLagMinutes?: Maybe<Scalars['Int']['output']>;
  driverEntered: Scalars['Boolean']['output'];
  firstUploadAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  orderUuid: Scalars['String']['output'];
  podLagMinutes?: Maybe<Scalars['Int']['output']>;
  reachedForwarder: Scalars['Boolean']['output'];
  uploadAttempts: Scalars['Int']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderBoardManualOrderRow = {
  __typename?: 'ForwarderBoardManualOrderRow';
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
};

/** Why a delivered shipment has no POD with the forwarder yet. */
export enum ForwarderBoardPodCause {
  ConnectionError = 'CONNECTION_ERROR',
  Failed = 'FAILED',
  HeldByForwarder = 'HELD_BY_FORWARDER',
  NoPhoto = 'NO_PHOTO',
  OfficeEntered = 'OFFICE_ENTERED',
  Sending = 'SENDING'
}

export type ForwarderBoardPodQueueRow = {
  __typename?: 'ForwarderBoardPodQueueRow';
  cause: ForwarderBoardPodCause;
  deliveredAt: Scalars['DateTime']['output'];
  firstUploadAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  orderUuid: Scalars['String']['output'];
  uploadAttempts: Scalars['Int']['output'];
  waitingMinutes: Scalars['Int']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderBoardRateTile = {
  __typename?: 'ForwarderBoardRateTile';
  of: Scalars['Int']['output'];
  onTime: Scalars['Int']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Forwarder Board reporting window: the live partial day, 7/30 complete days ending yesterday, or a custom date range. */
export enum ForwarderBoardWindow {
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  TodayLive = 'TODAY_LIVE'
}

export type ForwarderScorecardArgs = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  forwarder: ForwarderBoardForwarder;
  reportDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ForwarderScorecardCustomer = {
  __typename?: 'ForwarderScorecardCustomer';
  displayName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type ForwarderScorecardCustomerNotIncluded = {
  __typename?: 'ForwarderScorecardCustomerNotIncluded';
  apiOrders: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type ForwarderScorecardDeliveryExceptionRow = {
  __typename?: 'ForwarderScorecardDeliveryExceptionRow';
  arrivedSentAt?: Maybe<Scalars['DateTime']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  consigneeCity: Scalars['String']['output'];
  consigneeName: Scalars['String']['output'];
  consigneeState: Scalars['String']['output'];
  deliveredAt: Scalars['DateTime']['output'];
  dlvLagMinutes?: Maybe<Scalars['Int']['output']>;
  dlvOperator: Scalars['String']['output'];
  dlvReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  ediDispatch: Scalars['Boolean']['output'];
  orderUuid: Scalars['String']['output'];
  outForDeliverySentAt?: Maybe<Scalars['DateTime']['output']>;
  pickedUpSentAt?: Maybe<Scalars['DateTime']['output']>;
  podLagMinutes?: Maybe<Scalars['Int']['output']>;
  podReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderScorecardDeliverySummaryRow = {
  __typename?: 'ForwarderScorecardDeliverySummaryRow';
  arrivedCount: Scalars['Int']['output'];
  dlvWithin30Pct?: Maybe<Scalars['Float']['output']>;
  endDate: Scalars['DateTime']['output'];
  freightPickedUp: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  missingPodCount: Scalars['Int']['output'];
  outForDelivery: Scalars['Int']['output'];
  podWithin30Pct?: Maybe<Scalars['Float']['output']>;
  shipmentsDispatched: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type ForwarderScorecardDeliveryTrendPoint = {
  __typename?: 'ForwarderScorecardDeliveryTrendPoint';
  day: Scalars['String']['output'];
  dlvPct?: Maybe<Scalars['Float']['output']>;
  podPct?: Maybe<Scalars['Float']['output']>;
};

export type ForwarderScorecardDispatchExceptionRow = {
  __typename?: 'ForwarderScorecardDispatchExceptionRow';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  consigneeCity: Scalars['String']['output'];
  consigneeName: Scalars['String']['output'];
  consigneeState: Scalars['String']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  minutesLate?: Maybe<Scalars['Int']['output']>;
  orderUuid: Scalars['String']['output'];
  receiptAt: Scalars['DateTime']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderScorecardDispatchSummaryRow = {
  __typename?: 'ForwarderScorecardDispatchSummaryRow';
  acceptedPct?: Maybe<Scalars['Float']['output']>;
  connectivityPct?: Maybe<Scalars['Float']['output']>;
  endDate: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  shipmentsDispatched: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type ForwarderScorecardDispatchTrendPoint = {
  __typename?: 'ForwarderScorecardDispatchTrendPoint';
  acceptedPct?: Maybe<Scalars['Float']['output']>;
  connectivityPct?: Maybe<Scalars['Float']['output']>;
  day: Scalars['String']['output'];
};

export type ForwarderScorecardEntity = {
  __typename?: 'ForwarderScorecardEntity';
  companyName: Scalars['String']['output'];
  customers: Array<ForwarderScorecardCustomer>;
  customersNotIncluded: Array<ForwarderScorecardCustomerNotIncluded>;
  dayRowLabel: Scalars['String']['output'];
  deliveryExceptions: Array<ForwarderScorecardDeliveryExceptionRow>;
  deliveryExceptionsTotal: Scalars['Int']['output'];
  deliverySummary: Array<ForwarderScorecardDeliverySummaryRow>;
  deliveryTrend: Array<ForwarderScorecardDeliveryTrendPoint>;
  dispatchExceptions: Array<ForwarderScorecardDispatchExceptionRow>;
  dispatchExceptionsTotal: Scalars['Int']['output'];
  dispatchSummary: Array<ForwarderScorecardDispatchSummaryRow>;
  dispatchTrend: Array<ForwarderScorecardDispatchTrendPoint>;
  generatedAt: Scalars['DateTime']['output'];
  reportDay: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  undelivered: Array<ForwarderScorecardUndeliveredRow>;
  undeliveredTotal: Scalars['Int']['output'];
};

export type ForwarderScorecardUndeliveredRow = {
  __typename?: 'ForwarderScorecardUndeliveredRow';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  consigneeCity: Scalars['String']['output'];
  consigneeName: Scalars['String']['output'];
  consigneeState: Scalars['String']['output'];
  dispatchedElectronically: Scalars['Boolean']['output'];
  dispatchedReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  dispatchedSentAt?: Maybe<Scalars['DateTime']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  freightAvailableAt?: Maybe<Scalars['DateTime']['output']>;
  orderUuid: Scalars['String']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export enum FreightBillingMethod {
  FlatRate = 'FLAT_RATE',
  PerMile = 'PER_MILE',
  PerPiece = 'PER_PIECE',
  Smc3 = 'SMC3',
  Tariff = 'TARIFF',
  Weight = 'WEIGHT'
}

export type FreightChargeCreateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to be applied to the freight charge total. Note that this is a percentage out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  fuelChargeCreateInput?: InputMaybe<FuelChargeCreateInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate: Scalars['Float']['input'];
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
};

export type FreightChargeEntity = {
  __typename?: 'FreightChargeEntity';
  authoCode?: Maybe<Scalars['String']['output']>;
  billingMethod: FreightBillingMethod;
  description?: Maybe<Scalars['String']['output']>;
  /** The discount rate for the freight charge as a percentage out of 100 if it exists */
  discountRate?: Maybe<Scalars['Percent']['output']>;
  externalRateQuote?: Maybe<ExternalRateQuoteEntity>;
  externalRatingLines?: Maybe<Array<ExternalRatingLine>>;
  fuelCharge?: Maybe<FuelChargeEntity>;
  ignoreQuantityRegression: Scalars['Boolean']['output'];
  lastRatedExternalRateQuote?: Maybe<ExternalRateQuoteEntity>;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
  rate: Scalars['Float']['output'];
  ratingErrorCode?: Maybe<ExternalRatingErrorCode>;
  ratingFailure?: Maybe<ExternalRatingFailure>;
  settlementFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment: ShipmentEntity;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  tariff?: Maybe<TariffEntity>;
  total: Scalars['Float']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

/** the freight charge amount after prorating */
export type FreightChargeForProrating = {
  __typename?: 'FreightChargeForProrating';
  totalCents: Scalars['Float']['output'];
};

export type FreightChargeRerateResult = {
  __typename?: 'FreightChargeRerateResult';
  externalRating?: Maybe<ExternalRatingResult>;
  freightChargeUuid: Scalars['String']['output'];
  status: ExternalFreightRatingStatus;
};

export type FreightChargeUpdateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod?: InputMaybe<FreightBillingMethod>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to be applied to the freight charge total. Note that this is a percentage out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  fuelChargeUpdateInput?: InputMaybe<FuelChargeUpdateInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type FreightChargeUpsertInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to be applied to the freight charge total. Note that this is a percentage out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  fuelChargeUpsertInput?: InputMaybe<FuelChargeUpsertInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate: Scalars['Float']['input'];
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export enum FreightClass {
  Class_50 = 'CLASS_50',
  Class_55 = 'CLASS_55',
  Class_60 = 'CLASS_60',
  Class_65 = 'CLASS_65',
  Class_70 = 'CLASS_70',
  Class_77_5 = 'CLASS_77_5',
  Class_85 = 'CLASS_85',
  Class_92_5 = 'CLASS_92_5',
  Class_100 = 'CLASS_100',
  Class_110 = 'CLASS_110',
  Class_125 = 'CLASS_125',
  Class_150 = 'CLASS_150',
  Class_175 = 'CLASS_175',
  Class_200 = 'CLASS_200',
  Class_250 = 'CLASS_250',
  Class_300 = 'CLASS_300',
  Class_400 = 'CLASS_400',
  Class_500 = 'CLASS_500'
}

export type FreightCostEntity = {
  __typename?: 'FreightCostEntity';
  billingMethod?: Maybe<FreightBillingMethod>;
  dependentSettlementBillingMethod?: Maybe<DependentSettlementBillingMethod>;
  description?: Maybe<Scalars['String']['output']>;
  /** The discount rate for the freight cost as a percentage out of 100 if it exists */
  discountRate?: Maybe<Scalars['Percent']['output']>;
  /** The flat rate of the freight cost in dollars, if it exists */
  flatRateUsdDollars?: Maybe<Scalars['Float']['output']>;
  fuelCost?: Maybe<FuelCostEntity>;
  id: Scalars['String']['output'];
  /** The percentage rate for the freight cost as a percentage out of 100 if it exists */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The rate of the freight cost in dollars, if it exists */
  rateUsdDollars?: Maybe<Scalars['Float']['output']>;
  ratedMiles?: Maybe<Scalars['Float']['output']>;
  tariff?: Maybe<TariffEntity>;
  /** @deprecated Use totalAmountUsdDollars instead. This field will be removed in a future release. */
  totalAmountUsdCents: Scalars['Float']['output'];
  /** The total cost for the freight cost in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars?: Maybe<Scalars['Float']['output']>;
};

export enum FreightRatingWarning {
  ExpiredTariffAvailable = 'EXPIRED_TARIFF_AVAILABLE',
  MilesUnavailable = 'MILES_UNAVAILABLE'
}

export type FreightScanningV2AddressInfo = {
  __typename?: 'FreightScanningV2AddressInfo';
  city?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type FreightScanningV2BulkProcessPiecesInput = {
  /** Client-side ISO-8601 timestamp of when the user actually scanned the barcode. Used to preserve real scan time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  /** Optional manifest UUID. When present, the mutation rejects the entire batch with NOT_ON_MANIFEST if any piece belongs to an order not on the manifest, before any piece state mutates. */
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  mode: FreightScanningV2ScanMode;
  pieceUuids: Array<Scalars['String']['input']>;
  /** Optional stop UUID for DELIVERY and PICKUP modes. Used to associate the scan with a specific stop. */
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional warehouse UUID for warehouse-scoped modes (INBOUND, OUTBOUND). */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2BulkProcessPiecesOutput = {
  __typename?: 'FreightScanningV2BulkProcessPiecesOutput';
  processedCount: Scalars['Int']['output'];
  results: Array<FreightScanningV2ResponseSuccessOutput>;
  success: Scalars['Boolean']['output'];
};

export type FreightScanningV2CommitWorkOrderScanErrorOutput = {
  __typename?: 'FreightScanningV2CommitWorkOrderScanErrorOutput';
  code: FreightScanningV2ScanErrorCode;
  message: Scalars['String']['output'];
};

export type FreightScanningV2CommitWorkOrderScanInput = {
  /** Client-side ISO-8601 timestamp of when the user actually scanned the barcode. Used to preserve real scan time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  /** INBOUND (-> ARRIVED) or OUTBOUND (-> LOADED) only. MOVE/DELIVERY/PICKUP are rejected. */
  mode: FreightScanningV2ScanMode;
  pieceUuid: Scalars['String']['input'];
  /** Active warehouse the operator is scanning at. Resolves the terminal stamped on the piece + the ON_HAND/LOADED terminal event. Should mirror the terminal the work-order list was queried with so the scanned piece counts as complete on the screen. */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  /** Whether workOrderUuid is a ROUTE or a LINE_HAUL manifest. Selects which membership relation the piece is verified against. */
  workOrderType: WorkOrderType;
  /** UUID of the work order the piece is being scanned under. Resolves to a route (workOrderType=ROUTE) or line-haul manifest (workOrderType=LINE_HAUL). Used to scope the piece lookup so a piece from another work order is rejected. */
  workOrderUuid: Scalars['String']['input'];
};

export type FreightScanningV2CommitWorkOrderScanOutput = FreightScanningV2CommitWorkOrderScanErrorOutput | FreightScanningV2CommitWorkOrderScanSuccessOutput | MutationErrorOutput;

export type FreightScanningV2CommitWorkOrderScanPiece = {
  __typename?: 'FreightScanningV2CommitWorkOrderScanPiece';
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2CommitWorkOrderScanSuccessOutput = {
  __typename?: 'FreightScanningV2CommitWorkOrderScanSuccessOutput';
  piece: FreightScanningV2CommitWorkOrderScanPiece;
  success: Scalars['Boolean']['output'];
  wasRescan: Scalars['Boolean']['output'];
};

export type FreightScanningV2DestinationTerminalInfo = {
  __typename?: 'FreightScanningV2DestinationTerminalInfo';
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2DocumentInfo = {
  __typename?: 'FreightScanningV2DocumentInfo';
  bucket: Scalars['String']['output'];
  fileType?: Maybe<Scalars['String']['output']>;
  preSignedGetUrl?: Maybe<Scalars['String']['output']>;
  thumbnailKey?: Maybe<Scalars['String']['output']>;
  type: DocumentType;
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2LeanOrderHeader = {
  __typename?: 'FreightScanningV2LeanOrderHeader';
  billingPartyContactDisplayName?: Maybe<Scalars['String']['output']>;
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  expectedPieceCount: Scalars['Int']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  mawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scannedPieceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2LeanPieceInfo = {
  __typename?: 'FreightScanningV2LeanPieceInfo';
  contactDisplayName?: Maybe<Scalars['String']['output']>;
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isPieceCompletedForMode: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2LeanScanError = {
  __typename?: 'FreightScanningV2LeanScanError';
  code: FreightScanningV2ScanErrorCode;
  message: Scalars['String']['output'];
};

export type FreightScanningV2LineHaulLaneInfo = {
  __typename?: 'FreightScanningV2LineHaulLaneInfo';
  destinationTerminal: FreightScanningV2DestinationTerminalInfo;
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2MatchingPiece = {
  __typename?: 'FreightScanningV2MatchingPiece';
  packageUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2MoveWarehouseLocationInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** Client-side ISO-8601 timestamp of when the user actually scanned the barcode. Used to preserve real scan time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  pieceUuids: Array<Scalars['String']['input']>;
  setStatusToArrived?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2MoveWarehouseLocationOutput = FreightScanningV2MoveWarehouseLocationSuccessOutput | MutationErrorOutput;

export type FreightScanningV2MoveWarehouseLocationSuccessOutput = {
  __typename?: 'FreightScanningV2MoveWarehouseLocationSuccessOutput';
  pieces: Array<FreightScanningV2PieceInfo>;
  terminalCode?: Maybe<Scalars['String']['output']>;
  warehouseLocation: FreightScanningV2WarehouseLocationInfo;
  warehouseName?: Maybe<Scalars['String']['output']>;
};

export type FreightScanningV2MutationOutput = FreightScanningV2ResponseSuccessOutput | MutationErrorOutput;

export type FreightScanningV2OrderInfo = {
  __typename?: 'FreightScanningV2OrderInfo';
  billingPartyContactDisplayName?: Maybe<Scalars['String']['output']>;
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  documents: Array<FreightScanningV2DocumentInfo>;
  finalDestinationAddress?: Maybe<FreightScanningV2AddressInfo>;
  hasMultipleWarehouseLocations: Scalars['Boolean']['output'];
  hasShortage: Scalars['Boolean']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  isLineHaul: Scalars['Boolean']['output'];
  lineHaulLane?: Maybe<FreightScanningV2LineHaulLaneInfo>;
  mawb?: Maybe<Scalars['String']['output']>;
  measurementUnits?: Maybe<MeasurementUnits>;
  name: Scalars['String']['output'];
  osAndD?: Maybe<Scalars['Boolean']['output']>;
  osdReason?: Maybe<Scalars['String']['output']>;
  packages: Array<FreightScanningV2PackageOption>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  pieceCountFromPackages: Scalars['Int']['output'];
  piecesDelivered: FreightScanningV2PiecesDeliveredInfo;
  piecesPickedUp: FreightScanningV2PiecesPickedUpInfo;
  scanProgress?: Maybe<FreightScanningV2ScanProgress>;
  tags: Array<FreightScanningV2TagInfo>;
  uuid: Scalars['String']['output'];
  weightUnits?: Maybe<WeightUnits>;
};

export type FreightScanningV2OrderInfoInput = {
  mode: FreightScanningV2ScanMode;
  orderUuid: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2OrderOption = {
  __typename?: 'FreightScanningV2OrderOption';
  destination?: Maybe<Scalars['String']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  matchingPiece?: Maybe<FreightScanningV2MatchingPiece>;
  mawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  packageCount: Scalars['Int']['output'];
  packages: Array<FreightScanningV2PackageSummary>;
  totalPieces: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2PackageOption = {
  __typename?: 'FreightScanningV2PackageOption';
  description: Scalars['String']['output'];
  dimensions?: Maybe<Scalars['String']['output']>;
  onHand: Scalars['Int']['output'];
  pieces: Array<FreightScanningV2PieceInfo>;
  quantity: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  type?: Maybe<PackageType>;
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type FreightScanningV2PackageSummary = {
  __typename?: 'FreightScanningV2PackageSummary';
  description?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2PieceInfo = {
  __typename?: 'FreightScanningV2PieceInfo';
  contactDisplayName?: Maybe<Scalars['String']['output']>;
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  damagedNote?: Maybe<Scalars['String']['output']>;
  documents: Array<FreightScanningV2DocumentInfo>;
  height?: Maybe<Scalars['Float']['output']>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isPieceCompletedForMode: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  measurementUnits?: Maybe<MeasurementUnits>;
  name: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  terminal?: Maybe<FreightScanningV2TerminalInfo>;
  uuid?: Maybe<Scalars['String']['output']>;
  warehouse?: Maybe<FreightScanningV2WarehouseInfo>;
  warehouseLocation?: Maybe<FreightScanningV2WarehouseLocationInfo>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<WeightUnits>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type FreightScanningV2PieceInfoInput = {
  mode: FreightScanningV2ScanMode;
  pieceUuid: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2PiecesDeliveredInfo = {
  __typename?: 'FreightScanningV2PiecesDeliveredInfo';
  deliveryScansCount: Scalars['Int']['output'];
};

export type FreightScanningV2PiecesPickedUpInfo = {
  __typename?: 'FreightScanningV2PiecesPickedUpInfo';
  pickupScansCount: Scalars['Int']['output'];
};

export type FreightScanningV2ProcessBarcodeInput = {
  /** When true and the barcode resolves as a serialized lot label (pieceName is set), skip the NEEDS_PACKAGE_SELECTION gate and FIFO-assign + scan in one call. Use only from flows that have no post-NeedsPackageSelection FIFO-assign of their own (e.g. inbound scan-log). Other flows (useOrderPieceListScanning, useScannedOrderDetailsFlow) manage FIFO-assign themselves and must NOT set this flag. */
  autoAssignSerializedPiece?: InputMaybe<Scalars['Boolean']['input']>;
  barcode: Scalars['String']['input'];
  /** Client-side ISO-8601 timestamp of when the user actually scanned the barcode. Used to preserve real scan time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  mode: FreightScanningV2ScanMode;
  /** If provided, skips barcode lookup and resolves this specific order directly. Used after the user selects an order from the multi-order picker. */
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional stop UUID for DELIVERY and PICKUP modes. Used to associate the scan with a specific stop. */
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2ProcessBarcodeLeanOutput = FreightScanningV2ProcessBarcodeLeanSuccessOutput | MutationErrorOutput;

export type FreightScanningV2ProcessBarcodeLeanSuccessOutput = {
  __typename?: 'FreightScanningV2ProcessBarcodeLeanSuccessOutput';
  error?: Maybe<FreightScanningV2LeanScanError>;
  fuzzyMatchHints: Array<OrderFuzzyMatchHint>;
  fuzzyMatchedField?: Maybe<ScanMatchedField>;
  isFuzzyMatch: Scalars['Boolean']['output'];
  isSerializedBarcode?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<FreightScanningV2LeanOrderHeader>;
  orders?: Maybe<Array<FreightScanningV2OrderOption>>;
  orphanPieces?: Maybe<Array<FreightScanningV2PieceInfo>>;
  packages?: Maybe<Array<FreightScanningV2PackageOption>>;
  piece?: Maybe<FreightScanningV2LeanPieceInfo>;
  piecesCreated?: Maybe<Scalars['Int']['output']>;
  scanJobUuid?: Maybe<Scalars['String']['output']>;
  selectedPackageUuid?: Maybe<Scalars['String']['output']>;
  state: FreightScanningV2ScanSessionState;
  wasRescan?: Maybe<Scalars['Boolean']['output']>;
};

export type FreightScanningV2ResponseSuccessOutput = {
  __typename?: 'FreightScanningV2ResponseSuccessOutput';
  error?: Maybe<FreightScanningV2ScanError>;
  fuzzyMatchHints: Array<OrderFuzzyMatchHint>;
  fuzzyMatchedField?: Maybe<ScanMatchedField>;
  isFuzzyMatch: Scalars['Boolean']['output'];
  isSerializedBarcode?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<FreightScanningV2OrderInfo>;
  orders?: Maybe<Array<FreightScanningV2OrderOption>>;
  orphanPieces?: Maybe<Array<FreightScanningV2PieceInfo>>;
  piece?: Maybe<FreightScanningV2PieceInfo>;
  piecesCreated?: Maybe<Scalars['Int']['output']>;
  selectedPackageUuid?: Maybe<Scalars['String']['output']>;
  state: FreightScanningV2ScanSessionState;
  wasRescan?: Maybe<Scalars['Boolean']['output']>;
};

export type FreightScanningV2ScanError = {
  __typename?: 'FreightScanningV2ScanError';
  code: FreightScanningV2ScanErrorCode;
  message: Scalars['String']['output'];
  order?: Maybe<FreightScanningV2OrderInfo>;
};

/** Error codes for scanning operations */
export enum FreightScanningV2ScanErrorCode {
  BarcodeAmbiguous = 'BARCODE_AMBIGUOUS',
  BarcodeNotFound = 'BARCODE_NOT_FOUND',
  NotOnManifest = 'NOT_ON_MANIFEST',
  NotOnStop = 'NOT_ON_STOP',
  PackPending = 'PACK_PENDING'
}

/** Lifecycle status of a deferred scan post-processing job (derived from BullMQ job state). */
export enum FreightScanningV2ScanJobState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type FreightScanningV2ScanJobStatus = {
  __typename?: 'FreightScanningV2ScanJobStatus';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: FreightScanningV2ScanJobState;
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2ScanJobStatusesInput = {
  uuids: Array<Scalars['String']['input']>;
};

/** The mode of the scanning operation */
export enum FreightScanningV2ScanMode {
  Delivery = 'DELIVERY',
  Inbound = 'INBOUND',
  Move = 'MOVE',
  Outbound = 'OUTBOUND',
  Pickup = 'PICKUP'
}

export type FreightScanningV2ScanProgress = {
  __typename?: 'FreightScanningV2ScanProgress';
  isFirstTerminal?: Maybe<Scalars['Boolean']['output']>;
  isLastTerminal?: Maybe<Scalars['Boolean']['output']>;
  manifestReferenceNumber?: Maybe<Scalars['String']['output']>;
  manifestUuid?: Maybe<Scalars['String']['output']>;
  scannedPieceCount: Scalars['Int']['output'];
};

/** The current state of the scanning session */
export enum FreightScanningV2ScanSessionState {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  NeedsFuzzyMatchConfirmation = 'NEEDS_FUZZY_MATCH_CONFIRMATION',
  NeedsOrderlessInboundConfirmation = 'NEEDS_ORDERLESS_INBOUND_CONFIRMATION',
  NeedsOrderSelection = 'NEEDS_ORDER_SELECTION',
  NeedsOrphanPieceSelection = 'NEEDS_ORPHAN_PIECE_SELECTION',
  NeedsPackageSelection = 'NEEDS_PACKAGE_SELECTION',
  NoAssignablePiece = 'NO_ASSIGNABLE_PIECE',
  OrderResolved = 'ORDER_RESOLVED',
  OrphanPieceResolved = 'ORPHAN_PIECE_RESOLVED'
}

export type FreightScanningV2SelectPackageInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createNewPiece?: InputMaybe<Scalars['Boolean']['input']>;
  isSerializedBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional manifest UUID. When present, the mutation rejects scans whose order is not on the manifest with a NOT_ON_MANIFEST error before any piece state mutates. */
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  mode: FreightScanningV2ScanMode;
  orderUuid: Scalars['String']['input'];
  packageUuid: Scalars['String']['input'];
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional stop UUID for DELIVERY and PICKUP modes. Used to associate the scan with a specific stop. */
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse location UUID for staging mode */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2TagInfo = {
  __typename?: 'FreightScanningV2TagInfo';
  color?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FreightScanningV2TerminalInfo = {
  __typename?: 'FreightScanningV2TerminalInfo';
  code: Scalars['String']['output'];
};

export type FreightScanningV2WarehouseInfo = {
  __typename?: 'FreightScanningV2WarehouseInfo';
  name: Scalars['String']['output'];
};

export type FreightScanningV2WarehouseLocationInfo = {
  __typename?: 'FreightScanningV2WarehouseLocationInfo';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightSnapCreateInput = {
  freightSnapTransactionUuid: Scalars['String']['input'];
  proNum?: InputMaybe<Scalars['String']['input']>;
};

export enum FreightSnapFailureReason {
  EmptyFreightSnapDimensions = 'EMPTY_FREIGHT_SNAP_DIMENSIONS',
  NoMatch = 'NO_MATCH',
  NoShipmentsFoundForOrder = 'NO_SHIPMENTS_FOUND_FOR_ORDER',
  Unknown = 'UNKNOWN'
}

export type FreightSnapTransactionEntity = {
  __typename?: 'FreightSnapTransactionEntity';
  createdAt: Scalars['DateTime']['output'];
  ehdim?: Maybe<Scalars['String']['output']>;
  eldim?: Maybe<Scalars['String']['output']>;
  ewdim?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<FreightSnapFailureReason>;
  imgs: Array<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  proNum?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FreightSnapTransactionStatus>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['String']['output']>;
};

export enum FreightSnapTransactionStatus {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export enum FuelBillingMethod {
  AutoCalculate = 'AUTO_CALCULATE',
  FlatRate = 'FLAT_RATE',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export type FuelChargeCreateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  autoCalculate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  surchargeRate: Scalars['Float']['input'];
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  type: FuelBillingMethod;
};

export type FuelChargeEntity = {
  __typename?: 'FuelChargeEntity';
  authoCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the AUTO_CALCULATE FuelBillingMethod value instead */
  autoCalculate: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  flatRate: Scalars['Float']['output'];
  freightCharge: FreightChargeEntity;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  settlementFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  surchargeRate: Scalars['Float']['output'];
  /** @deprecated this value is wrong!! use shipmentCharges.totalFuelCharge on shipment instead */
  total: Scalars['Float']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  type: FuelBillingMethod;
  uuid: Scalars['String']['output'];
};

/** the fuel charge amount after prorating */
export type FuelChargeForProrating = {
  __typename?: 'FuelChargeForProrating';
  totalCents: Scalars['Float']['output'];
};

export type FuelChargeFuelProfileDateRangeInput = {
  /** The appointment date for the fuel charge's stop */
  appointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactUuid: Scalars['String']['input'];
  /** The service date for the fuel charge's stop */
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date the fuel charge's stop was completed */
  stopCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the fuel profile attached to the tariff selected for the stop */
  tariffGroupFuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FuelChargeFuelProfileDateRangeOutput = {
  __typename?: 'FuelChargeFuelProfileDateRangeOutput';
  fuelProfileDateRange?: Maybe<FuelProfileDateRangeEntity>;
};

export type FuelChargeUpdateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  autoCalculate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<FuelBillingMethod>;
  uuid: Scalars['String']['input'];
};

export type FuelChargeUpsertInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  autoCalculate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  surchargeRate: Scalars['Float']['input'];
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  type: FuelBillingMethod;
  uuid: Scalars['String']['input'];
};

export type FuelCostEntity = {
  __typename?: 'FuelCostEntity';
  billingMethod?: Maybe<FuelBillingMethod>;
  dependentSettlementBillingMethod?: Maybe<DependentSettlementBillingMethod>;
  /** The flat rate of the fuel cost in dollars, if it exists */
  flatRateUsdDollars?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  /** The percentage rate for the fuel cost as a percentage out of 100 if it exists */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  /** The surcharge rate for the fuel cost as a percentage out of 100 if it exists */
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use totalAmountUsdDollars instead. This field will be removed in a future release. */
  totalAmountUsdCents: Scalars['Float']['output'];
  /** The total cost for the fuel cost in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars?: Maybe<Scalars['Float']['output']>;
};

export type FuelProfileDateRangeEntity = {
  __typename?: 'FuelProfileDateRangeEntity';
  createdAt: Scalars['DateTime']['output'];
  expirationDate: Scalars['DateTime']['output'];
  flatRateUsdCents?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['DateTime']['output'];
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type FuelProfileEntity = {
  __typename?: 'FuelProfileEntity';
  billingType: FuelBillingMethod;
  company: CompanyEntity;
  contacts?: Maybe<Array<ContactEntity>>;
  createdAt: Scalars['DateTime']['output'];
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  flatRateUsdCents?: Maybe<Scalars['Int']['output']>;
  fuelProfileDateRanges: Array<FuelProfileDateRangeEntity>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  surchargeRate: Scalars['Float']['output'];
  tariffGroups: Array<TariffGroupEntity>;
  type: FuelProfileType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum FuelProfileType {
  ContactSpecific = 'CONTACT_SPECIFIC',
  Global = 'GLOBAL'
}

export enum FuelRatingWarning {
  NoValidFuelProfile = 'NO_VALID_FUEL_PROFILE',
  UsedCurrentDateFallback = 'USED_CURRENT_DATE_FALLBACK'
}

export type FuelRatingWarningDetailsEntity = {
  __typename?: 'FuelRatingWarningDetailsEntity';
  /** True when the fuel profile has at least one date range and every range expired before the rating date. False when it has no ranges, or a range starts later or leaves a gap at that date. */
  fuelProfileExpired: Scalars['Boolean']['output'];
  fuelProfileName?: Maybe<Scalars['String']['output']>;
  /** Name of the tariff group the fuel profile is attached to. */
  tariffName?: Maybe<Scalars['String']['output']>;
};

export enum FulfillmentType {
  Dedicated = 'DEDICATED',
  MultiTrip = 'MULTI_TRIP'
}

export type FuzzySearchItemsBySkuNameInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};

export type FuzzySearchItemsBySkuNameOutput = {
  __typename?: 'FuzzySearchItemsBySkuNameOutput';
  /** The item whose SKU most closely matches the specified SKU */
  item?: Maybe<ItemEntity>;
};

export type FuzzySearchOrdersByShipperBillOfLadingNumberInput = {
  shipperBillOfLadingNumber: Scalars['String']['input'];
};

export type FuzzySearchOrdersByShipperBillOfLadingNumberOutput = {
  __typename?: 'FuzzySearchOrdersByShipperBillOfLadingNumberOutput';
  /** The candidate orders whose shipper BOLs meet the similarity threshold for the specified BOL */
  orders: Array<OrderEntity>;
};

export type FuzzySearchStorageOrdersInput = {
  searchText: Scalars['String']['input'];
};

export type FuzzySearchStorageOrdersOutput = {
  __typename?: 'FuzzySearchStorageOrdersOutput';
  storageOrders: Array<StorageOrderEntity>;
};

export type FuzzySearchStorageUnitsInput = {
  searchText: Scalars['String']['input'];
};

export type FuzzySearchStorageUnitsOutput = {
  __typename?: 'FuzzySearchStorageUnitsOutput';
  storageUnits: Array<StorageUnitEntity>;
};

export type GlCodeReportPdfInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralLedgerCodeCreateInput = {
  code: Scalars['String']['input'];
  configurationId: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type GeneralLedgerCodeDeleteInput = {
  id: Scalars['String']['input'];
};

export type GeneralLedgerCodeEntity = {
  __typename?: 'GeneralLedgerCodeEntity';
  accessorials: Array<AccessorialUnion>;
  code: Scalars['String']['output'];
  creditTypes: Array<CreditTypeEntity>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type GeneralLedgerCodeUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  configurationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type GeneralLedgerConfigurationEntity = {
  __typename?: 'GeneralLedgerConfigurationEntity';
  accessorialFallbackCodeId?: Maybe<Scalars['String']['output']>;
  deliveryChargeCodeId?: Maybe<Scalars['String']['output']>;
  fuelChargeCodeId?: Maybe<Scalars['String']['output']>;
  generalLedgerCodes: Array<GeneralLedgerCodeEntity>;
  id: Scalars['String']['output'];
  lineHaulChargeCodeId?: Maybe<Scalars['String']['output']>;
  orderChargeCodeId?: Maybe<Scalars['String']['output']>;
  pickupChargeCodeId?: Maybe<Scalars['String']['output']>;
  recoveryChargeCodeId?: Maybe<Scalars['String']['output']>;
  transferChargeCodeId?: Maybe<Scalars['String']['output']>;
};

export type GeneralLedgerConfigurationUpdateInput = {
  accessorialFallbackCodeId?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lineHaulChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  orderChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  pickupChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  recoveryChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  transferChargeCodeId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateAccountingReportPreSignedPutUrlInput = {
  companyUuid: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type GenerateClearCompanyContactsTokenInput = {
  companyUuid: Scalars['String']['input'];
};

export type GenerateClearCompanyContactsTokenOutput = {
  __typename?: 'GenerateClearCompanyContactsTokenOutput';
  token: Scalars['String']['output'];
};

export type GenerateContactPreSignedPutUrlInput = {
  contactUuid: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type GenerateCsvOrderPresignedPutUrlInput = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
};

export type GenerateCsvPresignedPutUrlForMappingPreviewInput = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
};

export type GenerateCsvPresignedPutUrlForMappingPreviewOutput = {
  __typename?: 'GenerateCsvPresignedPutUrlForMappingPreviewOutput';
  bucket: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filetype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GenerateDefaultAppointmentTextsArgs = {
  appointmentUuids: Array<Scalars['String']['input']>;
};

export type GenerateHistoricalInvoicesCsvInput = {
  companyUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenerateHistoricalInvoicesCsvOutput = {
  __typename?: 'GenerateHistoricalInvoicesCsvOutput';
  s3Url?: Maybe<Scalars['String']['output']>;
};

export type GenerateInvoicePreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  invoiceUuid: Scalars['String']['input'];
};

export type GenerateInvoicePreSignedPutUrlOutput = {
  __typename?: 'GenerateInvoicePreSignedPutUrlOutput';
  invoiceUuid: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GenerateInvoicePreSignedPutUrlsInput = {
  generateInvoicePreSignedPutUrlInputs: Array<GenerateInvoicePreSignedPutUrlInput>;
};

export type GenerateLabelInput = {
  /** The ZPL data to be used to generate the label */
  zplData: Scalars['String']['input'];
};

export type GenerateLineHaulRunsInput = {
  fromDate: Scalars['String']['input'];
  recurringTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  toDate: Scalars['String']['input'];
};

export type GenerateLineHaulRunsOutput = {
  __typename?: 'GenerateLineHaulRunsOutput';
  created: Scalars['Int']['output'];
  serviceDays: Scalars['Int']['output'];
};

export type GenerateOrderDocumentPreSignedPutUrlInput = {
  /** @deprecated Use CurrentUser instead */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type GenerateOrderPreSignedGetAndPutUrlsInput = {
  /** The company the upload is for. Defaults to the session's company. */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
};

export type GenerateOrderPreSignedGetAndPutUrlsOutput = {
  __typename?: 'GenerateOrderPreSignedGetAndPutUrlsOutput';
  getUrl: Scalars['String']['output'];
  putUrl: Scalars['String']['output'];
};

export type GenerateOrderPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type GeneratePiecePreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};

export type GeneratePodReportPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type GeneratePreSignedPutUrlOutput = {
  __typename?: 'GeneratePreSignedPutUrlOutput';
  url: Scalars['String']['output'];
};

export type GenerateResetCompanyTokenInput = {
  companyUuid: Scalars['String']['input'];
};

export type GenerateResetCompanyTokenOutput = {
  __typename?: 'GenerateResetCompanyTokenOutput';
  token: Scalars['String']['output'];
};

export type GenerateRoutesInput = {
  appointmentWindowType: AppointmentWindowType;
  driverEquipmentConstraints: Array<DriverEquipmentConstraintInput>;
  stopUuids: Array<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateRoutesOutput = {
  __typename?: 'GenerateRoutesOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  routes?: Maybe<Array<RouteGenerationPreviewEntity>>;
  unassignedStopUuids?: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerateShipmentPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  shipmentUuid: Scalars['String']['input'];
};

export type GenerateStorageOrderPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  storageOrderUuid: Scalars['String']['input'];
};

export type GenerateStorageOrderPreSignedPutUrlOutput = {
  __typename?: 'GenerateStorageOrderPreSignedPutUrlOutput';
  preSignedPutUrl: Scalars['String']['output'];
};

export enum GeocodeQuality {
  Approximate = 'APPROXIMATE',
  Exact = 'EXACT',
  Unavailable = 'UNAVAILABLE',
  Unresolved = 'UNRESOLVED'
}

export type GetCityAndStateOptionsFromZipcodeInput = {
  zipcode: Scalars['String']['input'];
};

export type GetCityAndStateOptionsFromZipcodeOutput = {
  __typename?: 'GetCityAndStateOptionsFromZipcodeOutput';
  /** A list of city and state options that the zipcode could apply to */
  citiesAndStates: Array<CityAndStateOptionEntity>;
  /** The zipcode that was used to retrieve city and state options */
  zipcode: Scalars['String']['output'];
};

export type GetDispatchableDriversInput = {
  /** If provided, we will return all drivers that are assigned to this terminal or to an agent terminal in the same service region as that terminal */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetDispatchableDriversOutput = {
  __typename?: 'GetDispatchableDriversOutput';
  /** Agents under the company that have drivers that are dispatchable given some inputs */
  agents: Array<DispatchableAgentEntity>;
  /** Non-agent drivers under the company that are dispatchable given some inputs */
  companyDrivers: Array<DriverEntity>;
};

export type GetDriverCredentialTypesInput = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetDriverSettlementPayBoundsInput = {
  driverUuid: Scalars['String']['input'];
};

export type GetFeatureFlagCompanyOverridesInput = {
  featureFlagUuid: Scalars['String']['input'];
};

export type GetFeatureFlagUserOverridesInput = {
  featureFlagUuid: Scalars['String']['input'];
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetInvoiceCsvsInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type GetLineHaulProgressInput = {
  uuid: Scalars['String']['input'];
};

export type GetLineHaulProgressOutput = {
  __typename?: 'GetLineHaulProgressOutput';
  /** each terminal's status in the line haul */
  terminalStatuses: Array<LineHaulStatusByTerminal>;
};

export type GetOrderAuditLogEntriesInput = {
  orderUuid: Scalars['String']['input'];
};

export type GetOrderAuditLogEntriesOutput = {
  __typename?: 'GetOrderAuditLogEntriesOutput';
  auditLogEntries: Array<AuditLogEntry>;
};

export type GetOrderTableFieldHeadersOutput = {
  __typename?: 'GetOrderTableFieldHeadersOutput';
  /** The list of table headers for all order table fields */
  orderTableFieldHeaders: Array<OrderTableFieldHeaderEntity>;
};

export type GetOrderTableFieldValuesInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filters?: InputMaybe<FindOrdersFiltersInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for orders holding SMC3 freight that needs a rate. Currently only implemented for the flat orders view. */
  freightNeedsRateFilter?: InputMaybe<BooleanFilterV2>;
  /** When set, the orders table is grouped. See OrderTableGroupByInput for how `fields` and `keys` decide whether group rows or orders come back. */
  groupBy?: InputMaybe<OrderTableGroupByInput>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** If set to true, includes the formatted orders with the requested field values as part of the output */
  includeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the invoice name on the order table field (used when useJournalNumberForInvoice is false) */
  invoiceNameFilter?: InputMaybe<StringFilterV2>;
  /** An integer filter for the invoice journal number (used when useJournalNumberForInvoice is true) */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID filter for the line haul leg destination terminal. Matches orders that have a segment whose end terminal matches. */
  lineHaulLegDestinationTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg (segment). Matches orders assigned to the specified segment via OrderLineHaulSegment. */
  lineHaulLegFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg origin terminal. Matches orders that have a segment whose start terminal matches. */
  lineHaulLegOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A filter for the order's line-haul origin terminal (the order-level origin set for "out of inventory" orders, else the on-hand terminal derivation). Used by the line-haul Outbound tab so out-of-inventory orders are discoverable under their origin terminal. */
  lineHaulOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** The list of order table fields to fetch values for */
  orderTableFields: Array<OrderTableField>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  /** A UUID filter for terminals derived from piece warehouse locations on the order. Semantics across operators: `eq` / `in` match an order when at least one piece is in a warehouse location whose warehouse belongs to one of the requested terminals. `neq` / `nin` exclude an order when ANY piece is in a warehouse location whose warehouse belongs to one of the requested terminals, so a split order with pieces at multiple terminals is excluded if any of its terminals is in the list. `isBlank` matches orders with no piece-terminal assignment at all; `isNotBlank` matches orders with at least one piece-terminal assignment. */
  pieceTerminalFilter?: InputMaybe<UuidFilterV2>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** True if ascending, False if descending, undefined if no sort */
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  /** A string filter for the email of the user who created the order. */
  sourceUserEmailFilter?: InputMaybe<StringFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useFlatOrdersView?: InputMaybe<Scalars['Boolean']['input']>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spike toggle: when true, the orders-table query is served by the SQE (flat_orders.switchover) instead of Prisma's `flat_orders` view. Per-request flag; the frontend flips it from the orders-table toolbar. */
  useSqeBackend?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). Used only to read which calendar day a picked date filter value means; day boundaries are computed in the company time zone, the zone the order list displays dates in. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version ID for the request */
  versionId?: InputMaybe<Scalars['Float']['input']>;
  /** A UUID filter for the warehouse derived from piece locations on the order. This filters by Warehouse UUID (not WarehouseLocation/bin). The warehouse is determined by the unanimous piece-level warehouseId across the order. */
  warehouseLocationFilter?: InputMaybe<UuidFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

/** The output of the query to retrieve the order table field values for a set of orders. */
export type GetOrderTableFieldValuesOutput = {
  __typename?: 'GetOrderTableFieldValuesOutput';
  /** The paginated list of formatted orders with the values for the order table fields specified in the input */
  formattedOrderConnection: FormattedOrderConnection;
  /** The group rows of the requested level when the input carries a `groupBy` whose `keys` are shorter than its `fields`. Null otherwise, including for the orders under a fully expanded group path, which arrive in `formattedOrderConnection`. */
  groupRows?: Maybe<Array<OrderTableGroupRowEntity>>;
  /** Whether more group rows exist past `groupRows` at the requested level. Null when `groupRows` is null. */
  groupRowsHasMore?: Maybe<Scalars['Boolean']['output']>;
  /** The list of table headers for the order table fields requested as part of the order retrieval query */
  orderTableFieldHeaders: Array<OrderTableFieldHeaderEntity>;
};

export type GetOutlookIntegrationsForInternalInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetScannedOrderResultsForAdminArgs = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  failed?: InputMaybe<Scalars['Boolean']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  scannedOrderSource?: InputMaybe<ScannedOrderSource>;
  scannedOrderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetSchemaMatchDetailsInput = {
  bucket: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type GetServiceRegionsInput = {
  /** Filter for either archived or not archived service regions. Defaults to all. */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetServiceRegionsOutput = {
  __typename?: 'GetServiceRegionsOutput';
  /** All off the company's service regions. */
  serviceRegions: Array<ServiceRegionEntity>;
};

export type GetShipmentsInput = {
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetTerminalsInput = {
  /** @deprecated Use isActive = false instead */
  excludeNotActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally filter by isActive, defaults to including all terminals */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetTerminalsInternalInput = {
  companyUuid: Scalars['String']['input'];
  excludeNotActive: Scalars['Boolean']['input'];
};

export type GetUsersInput = {
  includeNotActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetXyTransformInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export type GetZipcodeOptionsFromCityAndStateInput = {
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type GetZipcodeOptionsFromCityAndStateOutput = {
  __typename?: 'GetZipcodeOptionsFromCityAndStateOutput';
  /** The city that was used to retrieve zipcode options */
  city: Scalars['String']['output'];
  /** The state that was used to retrieve zipcode options */
  state: Scalars['String']['output'];
  /** A list of zipcode options that the city and state could apply to */
  zipcodes: Array<ZipcodeOptionEntity>;
};

export enum GranteeType {
  Terminal = 'TERMINAL',
  User = 'USER'
}

export type GroupByStopEntity = {
  __typename?: 'GroupByStopEntity';
  ADDRESS: Scalars['String']['output'];
  ADDRESS_TYPE?: Maybe<Scalars['String']['output']>;
  APPOINTMENT?: Maybe<Scalars['DateTime']['output']>;
  APPOINTMENT_DATE?: Maybe<Scalars['DateTime']['output']>;
  APPOINTMENT_REQUIRED?: Maybe<Scalars['Boolean']['output']>;
  APPOINTMENT_SCHEDULED?: Maybe<Scalars['Boolean']['output']>;
  APPOINTMENT_TIME?: Maybe<Scalars['DateTime']['output']>;
  BUSINESS_DIVISION?: Maybe<Scalars['String']['output']>;
  CITY?: Maybe<Scalars['String']['output']>;
  CONSIGNEE?: Maybe<Scalars['String']['output']>;
  CUSTOMER?: Maybe<Scalars['String']['output']>;
  DIMS?: Maybe<Scalars['String']['output']>;
  DUE_DATE?: Maybe<Scalars['DateTime']['output']>;
  INBOUND_CITY?: Maybe<Scalars['String']['output']>;
  INBOUND_METHOD?: Maybe<InboundMethod>;
  INBOUND_NAME?: Maybe<Scalars['String']['output']>;
  INBOUND_TERMINAL?: Maybe<Scalars['String']['output']>;
  INBOUND_ZIP?: Maybe<Scalars['String']['output']>;
  MAWB?: Maybe<Scalars['String']['output']>;
  ORDER_NAME?: Maybe<Scalars['String']['output']>;
  ORDER_NOTES?: Maybe<Scalars['String']['output']>;
  ORDER_NUMBER: Scalars['String']['output'];
  ORDER_STATUS?: Maybe<Scalars['String']['output']>;
  OUTBOUND_CITY?: Maybe<Scalars['String']['output']>;
  OUTBOUND_METHOD?: Maybe<OutboundMethod>;
  OUTBOUND_NAME?: Maybe<Scalars['String']['output']>;
  OUTBOUND_TERMINAL?: Maybe<Scalars['String']['output']>;
  OUTBOUND_ZIP?: Maybe<Scalars['String']['output']>;
  PIECE_COUNT?: Maybe<Scalars['Float']['output']>;
  REF_NUMBER?: Maybe<Array<Scalars['String']['output']>>;
  ROUTE_NAME?: Maybe<Scalars['String']['output']>;
  SERVICE_DATE?: Maybe<Scalars['DateTime']['output']>;
  SERVICE_LEVEL?: Maybe<Scalars['String']['output']>;
  SERVICE_TIME?: Maybe<Scalars['DateTime']['output']>;
  SPECIAL?: Maybe<Scalars['Boolean']['output']>;
  SPECIAL_INSTRUCTIONS?: Maybe<Scalars['String']['output']>;
  STOP_TYPE?: Maybe<Scalars['String']['output']>;
  TAGS?: Maybe<Array<Scalars['String']['output']>>;
  TERMINAL?: Maybe<Scalars['String']['output']>;
  TOTAL_CHARGES?: Maybe<Scalars['Float']['output']>;
  VEHICLE_TYPE_NAME?: Maybe<Scalars['String']['output']>;
  WEIGHT?: Maybe<Scalars['Float']['output']>;
  ZIP_CODE?: Maybe<Scalars['String']['output']>;
  orderNumberCellColor?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  stopDetails?: Maybe<StopDetailsOutput>;
  /** The stop's zone (stop zone chain) while terminal_local_times is on, for reading its times at the stop; null while it is off. */
  timeZone?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type GroupByStopRowUnion = GroupsOutput | StopOutput;

export enum GroupByStopsEnum {
  City = 'CITY',
  RouteName = 'ROUTE_NAME',
  ServiceLevel = 'SERVICE_LEVEL'
}

/** Filters with fields for the groupByStops query. Use either "and" or "or" or "filters", but not all simultaneously. Using all in the same query may lead to unexpected results. */
export type GroupByStopsFilters = {
  and?: InputMaybe<Array<GroupByStopsFilters>>;
  fields?: InputMaybe<GroupByStopsFiltersFields>;
  or?: InputMaybe<Array<GroupByStopsFilters>>;
};

/** Filter fields for the groupByStops query */
export type GroupByStopsFiltersFields = {
  /** The stop's full formatted address. */
  ADDRESS?: InputMaybe<StringFilterV2>;
  ADDRESS_TYPE?: InputMaybe<AddressTypeFilter>;
  /** The stop's appointment date, in the company's timezone. */
  APPOINTMENT_DATE?: InputMaybe<DateFilterV2>;
  APPOINTMENT_OPTIONS_PROPOSED?: InputMaybe<BooleanFilterV2>;
  APPOINTMENT_REQUIRED?: InputMaybe<BooleanFilterV2>;
  APPOINTMENT_SCHEDULED?: InputMaybe<BooleanFilterV2>;
  /** The order's business division name. */
  BUSINESS_DIVISION?: InputMaybe<StringFilterV2>;
  CAN_DISPATCH?: InputMaybe<BooleanFilterV2>;
  CITY?: InputMaybe<StringFilterV2>;
  /** The order's billing party (customer) organization uuid. */
  CUSTOMER?: InputMaybe<UuidFilterV2>;
  /** The stop's deadline date, in the company's timezone. */
  DUE_DATE?: InputMaybe<DateFilterV2>;
  HAS_APPOINTMENT?: InputMaybe<BooleanFilterV2>;
  /** The order's MAWB. */
  MAWB?: InputMaybe<StringFilterV2>;
  ON_HAND?: InputMaybe<BooleanFilterV2>;
  /** The order's HAWB (shipper bill of lading number). */
  ORDER_NAME?: InputMaybe<StringFilterV2>;
  /** The order's name. */
  ORDER_NUMBER?: InputMaybe<StringFilterV2>;
  /** The order's status. */
  ORDER_STATUS?: InputMaybe<OrderStatusFilter>;
  /** The order's piece count. */
  PIECE_COUNT?: InputMaybe<IntegerFilterV2>;
  REFUSED?: InputMaybe<BooleanFilterV2>;
  /** The stop address's route name uuid. */
  ROUTE_NAME?: InputMaybe<UuidFilterV2>;
  /** The order's service level uuid. */
  SERVICE_LEVEL?: InputMaybe<UuidFilterV2>;
  SPECIAL?: InputMaybe<BooleanFilterV2>;
  /** The stop address's state. */
  STATE?: InputMaybe<StringFilterV2>;
  STOP_TYPE?: InputMaybe<StopTypeFilter>;
  /** The order's tag uuids. */
  TAGS?: InputMaybe<UuidListFilter>;
  /** The stop's terminal uuid. */
  TERMINAL?: InputMaybe<UuidFilterV2>;
  /** The order's total package weight. */
  WEIGHT?: InputMaybe<FloatFilterV2>;
  /** The stop address's zip code. */
  ZIP_CODE?: InputMaybe<StringFilterV2>;
};

/** Filters for the groupByStops query. Use either "and" or "or" filters, but not both simultaneously. Using both in the same query may lead to unexpected results. */
export type GroupByStopsFiltersInput = {
  and?: InputMaybe<Array<GroupByStopsFilters>>;
  or?: InputMaybe<Array<GroupByStopsFilters>>;
};

/** Input for grouping stops */
export type GroupByStopsInput = {
  filters?: InputMaybe<GroupByStopsFiltersInput>;
  groupByFields: Array<GroupByStopsEnum>;
  groupByValues: Array<InputMaybe<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Top-level service date filter */
  serviceDate?: InputMaybe<DateFilterV2>;
  sort?: InputMaybe<Array<GroupByStopsSort>>;
  /** If provided, filter stops by terminal uuid. If null, return stops with NO terminal. If undefined, do not apply a terminal filter at all. */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GroupByStopsOutput = {
  __typename?: 'GroupByStopsOutput';
  count?: Maybe<Scalars['Int']['output']>;
  rows: GroupByStopRowUnion;
};

export type GroupByStopsSort = {
  direction: GroupByStopsSortDirection;
  field: DispatchTableField;
};

export enum GroupByStopsSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Filters specific to the line-haul dispatch board */
export type GroupOrdersBoardFiltersInput = {
  /** Restricts rows to orders whose Status column reads as one of these. Empty or omitted applies no constraint. A refused order matches none of them -- its Status column reads 'Refused'; use baseFilters.isRefusedFilter for that. */
  detailedStatuses?: InputMaybe<Array<OrderDetailedStatus>>;
  /** Restricts rows to these leg plan states (the board's Routing status column). Empty or omitted applies no constraint. */
  legStates?: InputMaybe<Array<DispatchLegState>>;
  /** Restricts rows to orders holding at least one countable piece in these statuses. Empty or omitted applies no constraint. */
  pieceStatuses?: InputMaybe<Array<PieceStatus>>;
};

export enum GroupOrdersField {
  Lane = 'Lane',
  None = 'None'
}

export enum GroupOrdersForPaymentsBy {
  Hawb = 'HAWB',
  Invoice = 'INVOICE',
  Order = 'ORDER'
}

/** Input for the groupOrders query */
export type GroupOrdersInput = {
  /** Keyset pagination cursor for leaf rows: the segmentUuid of the last row of the previous page. Two forms are accepted, matching the two kinds of leaf row: a segment uuid, which resumes the committed half after that segment; or a proposed row id (`proposed:<orderUuid>:<START>><END>`), which means the lane's proposed half is behind us and the committed half starts at the beginning of the lane. Omit for the first page. Ignored when fetching group keys. */
  afterSegmentUuid?: InputMaybe<Scalars['String']['input']>;
  /** Same filter contract as the standard orders query. Saved views from the linehaul page apply as-is. */
  baseFilters: FindOrdersBaseInput;
  /** The dispatch board's own filters (leg plan state, piece status). ANDed with baseFilters and applied to the lane aggregates as well as to the rows, so a lane's count agrees with what drilling into it returns. Dispatch-board only. */
  boardFilters?: InputMaybe<GroupOrdersBoardFiltersInput>;
  /** The columns to group by. Exactly one entry is supported today. Pass [NONE] for an ungrouped list of leaf rows across every lane. */
  groupByFields: Array<GroupOrdersField>;
  /** The group-key path at the current tree level. Empty array requests the distinct group keys (root level); a single string drills into that group and returns its leaf segment rows. Must be empty when groupByFields is [NONE]. */
  groupByValues: Array<InputMaybe<Scalars['String']['input']>>;
  /** When true, each leaf row carries pieceStatusLocations: the order's countable pieces grouped by terminal and piece status, for the board's per-leg piece-status column. Rides on the same per-terminal piece query as includePiecesAwayFromRunOrigin rather than costing a second one, so it is free when either is already on. A request argument rather than an orderTableFields entry because the selection is board-local (localStorage) and is never persisted in a user preference or a saved view. */
  includePieceStatusLocations?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, each leaf row carries piecesAwayFromRunOrigin: how much of the freight on that order is not at the origin terminal of the run carrying this lane leg. Costs the per-terminal piece query, so it is opt-in and off by default. A request argument rather than an orderTableFields entry because the selection is board-local (localStorage) and is never persisted in a user preference or a saved view. */
  includePiecesAwayFromRunOrigin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional lane-scoped (segment-level) filter. Restricts which lanes appear and recomputes per-lane counts; ANDs with baseFilters. Dispatch-board only. */
  laneFilter?: InputMaybe<GroupOrdersLaneFilterInput>;
  /** How to order a lane's leaf rows. Omit for the default order (segment id ascending), which is what the keyset cursor pages by. Supplying it switches the leaf read to offset paging -- see the offset field. Only columns whose displayed value is reproducible in SQL can be sorted; see DispatchLeafSortField. Ignored when fetching group keys. */
  leafSort?: InputMaybe<GroupOrdersLeafSortInput>;
  /** Pagination limit for leaf rows. Ignored when fetching group keys. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Count of leaf rows already loaded before this page. With no leafSort it does NOT skip rows server-side (keyset paging via afterSegmentUuid does that) and is used only to compute the page-based totalCount. WITH a leafSort it becomes the paging mechanism (a keyset on the segment id cannot resume another ordering), and must then count only the COMMITTED rows already loaded for the lane -- the proposed block leads the first page and is not part of the scan it offsets into. Ignored when fetching group keys. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Order table fields to compute on each formatted leaf order. Mirrors the existing getOrderTableFieldValues input. */
  orderTableFields: Array<OrderTableField>;
};

/** Lane-scoped (segment-level) filter for the dispatch board. */
export type GroupOrdersLaneFilterInput = {
  /** Terminal uuids matched at EITHER end: keep lanes whose origin OR destination terminal is in this set (terminal-centric view). */
  anyEndTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Lane END terminal uuids: keep lanes whose destination terminal is in this set. */
  destinationTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exact lane keys to keep, each in the `START>END` terminal-code form (e.g. `DFW>LFT`). */
  laneKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Lane START terminal uuids: keep lanes whose origin terminal is in this set. */
  originTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GroupOrdersLeafSortInput = {
  direction: SortDirection;
  field: DispatchLeafSortField;
};

export type GroupOrdersOutput = {
  __typename?: 'GroupOrdersOutput';
  rows: GroupOrdersRowsUnion;
};

export type GroupOrdersRowsUnion = OrderLaneGroupsOutput | OrderSegmentLeavesOutput;

/** Used to track grouped counts (e.g. number of orders per invoice) */
export type GroupedCounts = {
  __typename?: 'GroupedCounts';
  /** Count of items in group */
  count: Scalars['Int']['output'];
  /** Unique group identifier / uuid */
  groupUuid: Scalars['String']['output'];
};

export type GroupsOutput = {
  __typename?: 'GroupsOutput';
  groupValues: Array<Maybe<Scalars['String']['output']>>;
};

export type HandleMultiple210OutboundInput = {
  invoiceUuids: Array<Scalars['String']['input']>;
};

export enum HazmatClass {
  Class1 = 'Class1',
  Class1_1 = 'Class1_1',
  Class1_2 = 'Class1_2',
  Class1_3 = 'Class1_3',
  Class1_4 = 'Class1_4',
  Class1_5 = 'Class1_5',
  Class1_6 = 'Class1_6',
  Class2 = 'Class2',
  Class2_1 = 'Class2_1',
  Class2_2 = 'Class2_2',
  Class2_3 = 'Class2_3',
  Class3 = 'Class3',
  Class4 = 'Class4',
  Class4_1 = 'Class4_1',
  Class4_2 = 'Class4_2',
  Class4_3 = 'Class4_3',
  Class5 = 'Class5',
  Class5_1 = 'Class5_1',
  Class5_2 = 'Class5_2',
  Class6 = 'Class6',
  Class6_1 = 'Class6_1',
  Class6_2 = 'Class6_2',
  Class7 = 'Class7',
  Class8 = 'Class8',
  Class9 = 'Class9'
}

export enum HeaderFileMappingType {
  CustomerName = 'CUSTOMER_NAME',
  InvoiceDate = 'INVOICE_DATE',
  InvoiceDueDate = 'INVOICE_DUE_DATE',
  InvoiceItemAmount = 'INVOICE_ITEM_AMOUNT',
  InvoiceItemName = 'INVOICE_ITEM_NAME',
  InvoiceItemQuantity = 'INVOICE_ITEM_QUANTITY',
  InvoiceItemRate = 'INVOICE_ITEM_RATE',
  InvoiceItemServiceDate = 'INVOICE_ITEM_SERVICE_DATE',
  InvoiceName = 'INVOICE_NAME',
  InvoiceTerms = 'INVOICE_TERMS',
  OneColumn = 'ONE_COLUMN',
  OrderReferenceNumber = 'ORDER_REFERENCE_NUMBER'
}

export type HoldReasonCreateInput = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type HoldReasonEntity = {
  __typename?: 'HoldReasonEntity';
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type HoldReasonUpdateInput = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Valid field names in the import contact schema */
export enum ImportContactField {
  AccountsReceivableId = 'AccountsReceivableId',
  Action = 'Action',
  Active = 'Active',
  BillingContactEmail = 'BillingContactEmail',
  BillingContactPhone = 'BillingContactPhone',
  BillingCycleDuration = 'BillingCycleDuration',
  BillingFax = 'BillingFax',
  BusinessDivision = 'BusinessDivision',
  ContactIdentifier = 'ContactIdentifier',
  ContactReferenceNumber = 'ContactReferenceNumber',
  Country = 'Country',
  CreditHoldLimitInCents = 'CreditHoldLimitInCents',
  DefaultAddressCity = 'DefaultAddressCity',
  DefaultAddressDriverInstructions = 'DefaultAddressDriverInstructions',
  DefaultAddressLine1 = 'DefaultAddressLine1',
  DefaultAddressLine2 = 'DefaultAddressLine2',
  DefaultAddressState = 'DefaultAddressState',
  DefaultAddressZip = 'DefaultAddressZip',
  DefaultContactPersonName = 'DefaultContactPersonName',
  DefaultInvoiceTerms = 'DefaultInvoiceTerms',
  DefaultInvoiceTransmissionMethod = 'DefaultInvoiceTransmissionMethod',
  DefaultInvoiceType = 'DefaultInvoiceType',
  DefaultLineHaulTariffChain = 'DefaultLineHaulTariffChain',
  DefaultOrdinaryTariffChain = 'DefaultOrdinaryTariffChain',
  DefaultPointToPointTariffChain = 'DefaultPointToPointTariffChain',
  DefaultService = 'DefaultService',
  DefaultTransferTariffChain = 'DefaultTransferTariffChain',
  DimFactor = 'DimFactor',
  DisplayName = 'DisplayName',
  DocumentsInInvoice = 'DocumentsInInvoice',
  EnableCreditHold = 'EnableCreditHold',
  Inactive = 'Inactive',
  InvoiceTimePeriodSplit = 'InvoiceTimePeriodSplit',
  MasterAccount = 'MasterAccount',
  MaxDaysOutstanding = 'MaxDaysOutstanding',
  NumberOfOrdersPerInvoice = 'NumberOfOrdersPerInvoice',
  Prepaid = 'Prepaid',
  QuickbooksFileMappingCustomerName = 'QuickbooksFileMappingCustomerName',
  RequiredDocuments = 'RequiredDocuments',
  ServiceContactEmail = 'ServiceContactEmail',
  ServiceContactName = 'ServiceContactName',
  ServiceContactPhone = 'ServiceContactPhone',
  ServiceFax = 'ServiceFax',
  ShortCode = 'ShortCode'
}

export type ImportCrownAccessorialInput = {
  accessorialUrl: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  fuelSurchargePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  isZoneBased?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialType?: InputMaybe<SpecialAccessorialType>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use tariffZoneGroupId instead */
  useContactTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportCrownAccessorialOutput = {
  __typename?: 'ImportCrownAccessorialOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportCrownDriversInput = {
  driversUrl: Scalars['String']['input'];
};

export type ImportCrownDriversOutput = {
  __typename?: 'ImportCrownDriversOutput';
  error?: Maybe<Scalars['String']['output']>;
  failedDriverPhoneNumbers: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  successfulDriverPhoneNumbers: Array<Scalars['String']['output']>;
};

export type ImportCrownInvoicesInput = {
  /** The Pallet admin email for this company */
  adminEmail: Scalars['String']['input'];
  /** A publicly accessible URL of the charges breakdown report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  chargeBreakdownUrl: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the open invoices report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  openInvoicesUrl: Scalars['String']['input'];
  skipExisting?: Scalars['Boolean']['input'];
  skipImportCharges?: Scalars['Boolean']['input'];
};

export type ImportCrownInvoicesOutput = {
  __typename?: 'ImportCrownInvoicesOutput';
  chargesFailedCrownIDs: Array<Scalars['String']['output']>;
  chargesImportedCrownIDs: Array<Scalars['String']['output']>;
  chargesSkippedCrownIDs: Array<Scalars['String']['output']>;
  invoicesFailedJournalNumbers: Array<Scalars['String']['output']>;
  invoicesImportedJournalNumbers: Array<Scalars['String']['output']>;
  invoicesSkippedJournalNumbers: Array<Scalars['String']['output']>;
  numberOfCharges: Scalars['Int']['output'];
  numberOfInvoices: Scalars['Int']['output'];
  numberOfShipments: Scalars['Int']['output'];
  shipmentsFailedCrownIDs: Array<Scalars['String']['output']>;
  shipmentsImportedCrownIDs: Array<Scalars['String']['output']>;
  shipmentsSkippedCrownIDs: Array<Scalars['String']['output']>;
};

export type ImportCrownLanesInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the lanes downloaded from Crown */
  lanesUrl: Scalars['String']['input'];
};

export type ImportCrownLanesOutput = {
  __typename?: 'ImportCrownLanesOutput';
  success: Scalars['Boolean']['output'];
};

export type ImportCrownOrdersInput = {
  /** The UUID of the company whose orders are being imported. Must be the session company. */
  companyUuid: Scalars['String']['input'];
  /** Automatically finalize all imported orders */
  finalizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not apply any charges to imported orders */
  noCharges?: InputMaybe<Scalars['Boolean']['input']>;
  /** A publicly accessible URL of the orders for this company */
  ordersUrl: Scalars['String']['input'];
  /** Only include the provided ShipIDs */
  shipIDFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  skipExisting?: Scalars['Boolean']['input'];
  /**
   * Ignored. The imported orders are attributed to the session user.
   * @deprecated Ignored; the imported orders are attributed to the session user.
   */
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ImportCrownOrdersOutput = {
  __typename?: 'ImportCrownOrdersOutput';
  failedCrownIDs: Array<Scalars['String']['output']>;
  importedCrownIDs: Array<Scalars['String']['output']>;
  numberOfOrders: Scalars['Int']['output'];
  skippedCrownIDs: Array<Scalars['String']['output']>;
};

export type ImportCrownPaymentsInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the payment application report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  paymentApplicationUrl: Scalars['String']['input'];
  /** A publicly accessible URL of the unapplied payments report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  unappliedPaymentsUrl: Scalars['String']['input'];
};

export type ImportCrownPaymentsOutput = {
  __typename?: 'ImportCrownPaymentsOutput';
  failedPaymentIDs: Array<Scalars['String']['output']>;
  importedPaymentIDs: Array<Scalars['String']['output']>;
  numberOfPayments: Scalars['Int']['output'];
};

export type ImportCrownTariffInput = {
  autoSelectAllServices: Scalars['Boolean']['input'];
  autoSelectAllVehicleTypes: Scalars['Boolean']['input'];
  /** @deprecated Ignored unless it matches the session company; the session is authoritative. */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use contactUuids instead */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When true, runs the import inside a transaction and rolls back, returning a preview of what would be created instead of committing. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rateType: RateType;
  /** Used to import a (global or contact) tariff for specific service levels. */
  serviceUuids: Array<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tariffGroupType: TariffGroupType;
  tariffType: TariffType;
  tariffUrl: Scalars['String']['input'];
  /** Zone group to use for zone-based tariffs. */
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneType: TariffZoneType;
  useActualWeight: Scalars['Boolean']['input'];
  /** Used to import a tariff for specific vehicle types. Only used when tariff chains are enabled for the given company. */
  vehicleTypeUuids: Array<Scalars['String']['input']>;
};

export type ImportCrownTariffOutput = {
  __typename?: 'ImportCrownTariffOutput';
  /** True when the result came from a dry-run (rolled back). */
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** Number of tariff ranges the import created (or would create). */
  rangesToCreate?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  /** Number of tariffs the import created (or would create). */
  tariffsToCreate?: Maybe<Scalars['Int']['output']>;
};

export type ImportCrownUsersInput = {
  usersUrl: Scalars['String']['input'];
};

export type ImportCrownUsersOutput = {
  __typename?: 'ImportCrownUsersOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportRecoveryTerminalInput = {
  companyUuid: Scalars['String']['input'];
  recoveryTerminalsUrl: Scalars['String']['input'];
};

export type ImportRecoveryTerminalOutput = {
  __typename?: 'ImportRecoveryTerminalOutput';
  success: Scalars['Boolean']['output'];
};

export type ImportStorageOrdersFromCsvInput = {
  contactUuid: Scalars['String']['input'];
  /**
   * CSV text of the import
   * @deprecated Deprecated. Pass the S3 URL instead.
   */
  csvText?: InputMaybe<Scalars['String']['input']>;
  /** S3 URL of the import */
  fileUrl: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ImportStorageOrdersFromCsvOutput = {
  __typename?: 'ImportStorageOrdersFromCsvOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  storageOrders: Array<StorageOrderEntity>;
};

export type ImportTerminalServiceAreasInput = {
  companyUuid: Scalars['String']['input'];
  csvDocumentUrl: Scalars['String']['input'];
  deleteExisting: Scalars['Boolean']['input'];
};

export type ImportTestSnapshotInput = {
  testSnapshot: TestSnapshotInput;
};

export type ImportWarehouseLocationsFromCsvInput = {
  csvText: Scalars['String']['input'];
};

export type ImportedOrderTypeMappingCreateInput = {
  defaultToInbound: Scalars['Boolean']['input'];
  defaultToOutbound: Scalars['Boolean']['input'];
  inboundStopType: StopType;
  lineHaul: Scalars['Boolean']['input'];
  moveType?: InputMaybe<Scalars['String']['input']>;
  orderImportConfigurationUuid: Scalars['String']['input'];
  outboundStopType: StopType;
  serviceLevel?: InputMaybe<Scalars['String']['input']>;
};

export type ImportedOrderTypeMappingEntity = {
  __typename?: 'ImportedOrderTypeMappingEntity';
  defaultToInbound: Scalars['Boolean']['output'];
  defaultToOutbound: Scalars['Boolean']['output'];
  inboundStopType: StopType;
  lineHaul: Scalars['Boolean']['output'];
  moveType?: Maybe<Scalars['String']['output']>;
  outboundStopType: StopType;
  serviceLevel?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ImportedOrderTypeMappingUpdateInput = {
  defaultToInbound: Scalars['Boolean']['input'];
  defaultToOutbound: Scalars['Boolean']['input'];
  inboundStopType: StopType;
  lineHaul: Scalars['Boolean']['input'];
  moveType?: InputMaybe<Scalars['String']['input']>;
  orderImportConfigurationUuid?: InputMaybe<Scalars['String']['input']>;
  outboundStopType: StopType;
  serviceLevel?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type InAppNotificationConnection = {
  __typename?: 'InAppNotificationConnection';
  edges: Array<InAppNotificationEdge>;
  pageInfo: PageInfo;
};

export type InAppNotificationEdge = {
  __typename?: 'InAppNotificationEdge';
  cursor: Scalars['String']['output'];
  node: InAppNotificationEntity;
};

export type InAppNotificationEntity = {
  __typename?: 'InAppNotificationEntity';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  eventType: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  subjectType?: Maybe<NotificationSubjectType>;
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type InAppNotificationPreferenceEntity = {
  __typename?: 'InAppNotificationPreferenceEntity';
  enabled: Scalars['Boolean']['output'];
  eventType: NotificationEventType;
  /** Required for every user: always enabled and cannot be changed. */
  mandatory: Scalars['Boolean']['output'];
};

export type InAppNotificationPreferenceInput = {
  enabled: Scalars['Boolean']['input'];
  eventType: NotificationEventType;
};

export type InBondSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundAddressNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundAddressSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundCityNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundCompletedDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** SCALAR stages one control; GROUP moves as one unit, because adopting half of an address or a package list produces something the rest of the system cannot use. */
export enum InboundConflictKind {
  Group = 'GROUP',
  Scalar = 'SCALAR'
}

export type InboundDriverNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum InboundFieldSurface {
  Addresses = 'ADDRESSES',
  Charges = 'CHARGES',
  Header = 'HEADER',
  Packages = 'PACKAGES'
}

/** How the stored text turns back into a value a control can hold. DATE means the text is ISO-8601, JSON a structure written as one unit, TEXT a value no control will ever take. */
export enum InboundFieldValueType {
  Date = 'DATE',
  Json = 'JSON',
  Number = 'NUMBER',
  String = 'STRING',
  Text = 'TEXT'
}

export type InboundMessageConflictEntity = {
  __typename?: 'InboundMessageConflictEntity';
  /** True only where a control on the order form is wrapped in StagedField. The form demotes this further when the control is disabled, locked or not rendered. */
  adoptable: Scalars['Boolean']['output'];
  /** react-hook-form path on the order form. May contain the `%STOP%` token, which the form resolves against the stop that actually renders the control. */
  fieldPath: Scalars['String']['output'];
  /** The value the message carried, as text. */
  incomingValue: Scalars['String']['output'];
  /** What the order held when the message landed. Null when it held nothing. */
  keptValue?: Maybe<Scalars['String']['output']>;
  /** Stable id, unique within its message, and the key a decision is recorded against. The field path on its own for order- and stop-level fields; the path plus the package concerned when one message disagrees about several packages at once. */
  key: Scalars['String']['output'];
  kind: InboundConflictKind;
  label: Scalars['String']['output'];
  /** Why the value cannot be applied. Set whenever adoptable is false. */
  note?: Maybe<Scalars['String']['output']>;
  /** What the operator decided, once they have reviewed and saved. Null while the difference is still outstanding. */
  resolvedChoice?: Maybe<InboundReviewChoice>;
  /** Which part of the order form shows this field. Drives the per-tab markers, so the count on a tab and the count on the chip come from one list rather than two. */
  surface: InboundFieldSurface;
  /** The uuid of the package this difference is about, for the `packages.%PKG%.*` paths. The order form resolves the token to that package's current index — an index cannot be sent, because the list is reordered by every add and delete. Null for order- and stop-level fields, and for a package the order does not hold. */
  targetUuid?: Maybe<Scalars['String']['output']>;
  valueType: InboundFieldValueType;
};

export type InboundMessageEntity = {
  __typename?: 'InboundMessageEntity';
  /** When the message was merged. Null unless state is APPLIED. */
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  conflicts: Array<InboundMessageConflictEntity>;
  receivedAt: Scalars['DateTime']['output'];
  senderName?: Maybe<Scalars['String']['output']>;
  source: OrderSource;
  state: InboundMessageState;
  /** Identifies the message. This is the uuid of the order the merge absorbed, which is unique and outlives the row it named. */
  uuid: Scalars['String']['output'];
};

export enum InboundMessageState {
  Applied = 'APPLIED',
  Awaiting = 'AWAITING',
  Unmatched = 'UNMATCHED'
}

export type InboundMessagesForOrderInput = {
  /** The order whose inbound messages are being read. */
  orderUuid: Scalars['String']['input'];
};

export type InboundMessagesForOrderOutput = {
  __typename?: 'InboundMessagesForOrderOutput';
  messages: Array<InboundMessageEntity>;
};

export enum InboundMethod {
  InboundDelivery = 'INBOUND_DELIVERY',
  Other = 'OTHER',
  Recovery = 'RECOVERY'
}

/** What an operator chose for one field: ADOPTED took the message's value, KEPT left the order's own in place. */
export enum InboundReviewChoice {
  Adopted = 'ADOPTED',
  Kept = 'KEPT'
}

export type InboundReviewDecisionInput = {
  choice: InboundReviewChoice;
  /** The `key` of the difference this decision is about, as returned by `inboundMessagesForOrder`. Paired with `messageUuid` to address exactly one persisted difference. Omitted by clients that only want the audit-log entry. */
  differenceKey?: InputMaybe<Scalars['String']['input']>;
  /** The field as the operator saw it named on the form. */
  fieldLabel: Scalars['String']['input'];
  /** The value the inbound message carried, as it was shown. */
  incomingValue?: InputMaybe<Scalars['String']['input']>;
  /** The message this decision is about, as returned by `inboundMessagesForOrder`. Required to mark the persisted difference resolved; omitted by clients that only want the audit-log entry. */
  messageUuid?: InputMaybe<Scalars['String']['input']>;
  /** The value the order held before the review. */
  previousValue?: InputMaybe<Scalars['String']['input']>;
};

export type InboundRouteDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundRouteNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundServiceDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundZipcodeSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type IncomeAnalysisReportArgs = {
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  includeContactsWithNoShipments: Scalars['Boolean']['input'];
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceStatuses: Array<InvoiceStatus>;
  /** The zone serviceDateFilter is read in. Empty: each order on its own local service day while terminal_local_times is on, else the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IncomeAnalysisReportOutput = {
  __typename?: 'IncomeAnalysisReportOutput';
  customers: Array<CustomerReportBucketEntity>;
  terminals: Array<IncomeAnalysisTerminalBucketEntity>;
};

export type IncomeAnalysisTerminalBucketEntity = {
  __typename?: 'IncomeAnalysisTerminalBucketEntity';
  kind: IncomeAnalysisTerminalBucketKind;
  label: Scalars['String']['output'];
  numberOfShipments: Scalars['Float']['output'];
  terminalUuid?: Maybe<Scalars['String']['output']>;
  totalRevenue: Scalars['Float']['output'];
};

export enum IncomeAnalysisTerminalBucketKind {
  LineHaul = 'LINE_HAUL',
  OrderCharges = 'ORDER_CHARGES',
  StopWithoutTerminal = 'STOP_WITHOUT_TERMINAL',
  Terminal = 'TERMINAL'
}

export type IncomingPeerAccessorialMappingEntity = {
  __typename?: 'IncomingPeerAccessorialMappingEntity';
  executorAccessorialName: Scalars['String']['output'];
  originatorAccessorialUuid?: Maybe<Scalars['String']['output']>;
  suggestedAccessorialUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type IncomingPeerServiceMappingEntity = {
  __typename?: 'IncomingPeerServiceMappingEntity';
  executorServiceUuid?: Maybe<Scalars['String']['output']>;
  originatorServiceName: Scalars['String']['output'];
  suggestedServiceUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type IndependentCustomCostCreateInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents: Scalars['Decimal']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IndependentCustomCostUpsertInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IndependentFreightCostCreateInput = {
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Percent out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  independentFuelCostCreateInput?: InputMaybe<IndependentFuelCostCreateInput>;
  /** Is null when billing method is per mile or flat rate */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents: Scalars['Decimal']['input'];
};

export type IndependentFreightCostUpsertInput = {
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Percent out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  independentFuelCostUpsertInput?: InputMaybe<IndependentFuelCostUpsertInput>;
  /** Is null when billing method is per mile or flat rate */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
};

export type IndependentFuelCostCreateInput = {
  billingMethod: FuelBillingMethod;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  /** Percent in the range [0, 100] */
  surchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  totalAmountUsdCents: Scalars['Decimal']['input'];
};

export type IndependentFuelCostUpsertInput = {
  billingMethod: FuelBillingMethod;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  /** Percent in the range [0, 100] */
  surchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
};

export type IndependentSettlementBillLineItemCreateInput = {
  /** @deprecated No longer used. Agent settlement is implemented via drivers. */
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  independentCustomCostCreateInputs?: InputMaybe<Array<IndependentCustomCostCreateInput>>;
  independentFreightCostCreateInput?: InputMaybe<IndependentFreightCostCreateInput>;
  settlementMode: SettlementMode;
  totalAmountUsdCents: Scalars['Decimal']['input'];
};

export type IndependentSettlementBillLineItemUpsertInput = {
  /** @deprecated No longer used. Agent settlement is implemented via drivers. */
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  id: Scalars['String']['input'];
  independentCustomCostUpsertInputs?: InputMaybe<Array<IndependentCustomCostUpsertInput>>;
  independentFreightCostUpsertInput?: InputMaybe<IndependentFreightCostUpsertInput>;
  settlementMode: SettlementMode;
  /** The total amount of the settlement bill line item in USD. If undefined for an existing settlement bill line item, then the existing total amount will be kept. If undefined for a new settlement bill line item, then the total amount will be 0. */
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
};

export type IngestedEmailDetailsEntity = {
  __typename?: 'IngestedEmailDetailsEntity';
  attachmentUuid?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  bodyPreview?: Maybe<Scalars['String']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  outlookIntegrationTerminal?: Maybe<TerminalEntity>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type IngestedOutlookEmailAttachmentConnection = {
  __typename?: 'IngestedOutlookEmailAttachmentConnection';
  edges: Array<IngestedOutlookEmailAttachmentEdge>;
  pageInfo: PageInfo;
};

export type IngestedOutlookEmailAttachmentEdge = {
  __typename?: 'IngestedOutlookEmailAttachmentEdge';
  cursor: Scalars['String']['output'];
  node: IngestedOutlookEmailAttachmentEntity;
};

export type IngestedOutlookEmailAttachmentEntity = {
  __typename?: 'IngestedOutlookEmailAttachmentEntity';
  attachmentFilename?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  ingestedEmailDetails: IngestedEmailDetailsEntity;
  outlookAttachmentId: Scalars['String']['output'];
  processingStatus: IngestedOutlookEmailAttachmentProcessingStatus;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  scannedOrder?: Maybe<ScannedOrderEntity>;
  uuid: Scalars['String']['output'];
};

export enum IngestedOutlookEmailAttachmentProcessingStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type IngestedOutlookEmailConnection = {
  __typename?: 'IngestedOutlookEmailConnection';
  edges: Array<IngestedOutlookEmailEdge>;
  pageInfo: PageInfo;
};

export type IngestedOutlookEmailEdge = {
  __typename?: 'IngestedOutlookEmailEdge';
  cursor: Scalars['String']['output'];
  node: IngestedOutlookEmailEntity;
};

export type IngestedOutlookEmailEntity = {
  __typename?: 'IngestedOutlookEmailEntity';
  attachments: Array<IngestedOutlookEmailAttachmentEntity>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  effectiveSenderAddress: Scalars['String']['output'];
  fromAddress?: Maybe<Scalars['String']['output']>;
  outlookMessageId: Scalars['String']['output'];
  outlookReceivedDateTime: Scalars['DateTime']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type IngestionTestRunAppliedResultEntity = {
  __typename?: 'IngestionTestRunAppliedResultEntity';
  applyPlan?: Maybe<Scalars['JSON']['output']>;
  duplicateOfOrderUuid?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  pageEnd: Scalars['Int']['output'];
  pageStart: Scalars['Int']['output'];
  resultUuid: Scalars['String']['output'];
  status: ScannedOrderResultStatus;
};

export type IngestionTestRunEntity = {
  __typename?: 'IngestionTestRunEntity';
  actorEmail: Scalars['String']['output'];
  appliedResults: Array<IngestionTestRunAppliedResultEntity>;
  applyPlan?: Maybe<Scalars['JSON']['output']>;
  companyUuid: Scalars['String']['output'];
  correlationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailContext?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  exemplarMarker?: Maybe<Scalars['JSON']['output']>;
  extractedFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  mode: IngestionTestRunMode;
  state: IngestionTestRunState;
  updatedAt: Scalars['DateTime']['output'];
  usage?: Maybe<Scalars['JSON']['output']>;
};

/** The e2e test-run completion path: PREVIEW_E2E (side-effect-free, no order) or FULL_APPLY (authoritative apply, creates a real order). */
export enum IngestionTestRunMode {
  FullApply = 'FULL_APPLY',
  PreviewE2E = 'PREVIEW_E2E'
}

/** The e2e test-run lifecycle state, from UPLOADED through DISPATCHED/EXTRACTING to a terminal COMPLETED/FAILED (and CLEANED once purged). */
export enum IngestionTestRunState {
  Cleaned = 'CLEANED',
  Completed = 'COMPLETED',
  Dispatched = 'DISPATCHED',
  Extracting = 'EXTRACTING',
  Failed = 'FAILED',
  Uploaded = 'UPLOADED'
}

export type IngestionTestUploadEntity = {
  __typename?: 'IngestionTestUploadEntity';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type InitiateDelegatedOrderReviewInput = {
  delegationUuid: Scalars['String']['input'];
};

export type InitiateDelegatedOrderReviewOutput = {
  __typename?: 'InitiateDelegatedOrderReviewOutput';
  draftOrderUuid: Scalars['String']['output'];
};

/** A filter object that is used to filter a integer field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type IntegerFilterV2 = {
  /** Filters for records where the relevant integer field is equal to the provided integer value */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is greater than the provided integer value */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is greater than or equal to the provided integer value */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is in the provided integer values */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters for records where the relevant integer field is less than the provided integer value */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is less than or equal to the provided integer value */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is not equal to the provided integer value */
  neq?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is not in the provided integer values */
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** An error when forceOriginMismatch is true but the order does not have a single misrouted piece at the manifest start terminal. */
export type InvalidMisroutedOverrideError = {
  __typename?: 'InvalidMisroutedOverrideError';
  order: OrderEntity;
};

export type InventoryCountClosedOutput = {
  __typename?: 'InventoryCountClosedOutput';
  message: Scalars['String']['output'];
};

export type InventoryCountConfirmationInput = {
  /** Client-side ISO-8601 timestamp of when the operator actually scanned the piece. Used to preserve real scan time across offline replays. Outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  pieceUuid: Scalars['String']['input'];
  scannedBarcode?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountConnection = {
  __typename?: 'InventoryCountConnection';
  edges: Array<InventoryCountEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InventoryCountEdge = {
  __typename?: 'InventoryCountEdge';
  cursor: Scalars['String']['output'];
  node: InventoryCountEntity;
};

export type InventoryCountEntity = {
  __typename?: 'InventoryCountEntity';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closedByUser?: Maybe<UserActorEntity>;
  closedByWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  confirmedCount: Scalars['Int']['output'];
  contact?: Maybe<ContactEntity>;
  departedCount: Scalars['Int']['output'];
  expectedCount: Scalars['Int']['output'];
  isClosed: Scalars['Boolean']['output'];
  noLocationOnly: Scalars['Boolean']['output'];
  overdueOnly: Scalars['Boolean']['output'];
  pendingCount: Scalars['Int']['output'];
  searchText?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  startedByUser?: Maybe<UserActorEntity>;
  startedByWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  statuses: Array<PieceStatus>;
  terminal?: Maybe<TerminalEntity>;
  unassociatedOnly: Scalars['Boolean']['output'];
  unexpectedCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  warehouse?: Maybe<WarehouseEntity>;
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type InventoryCountLineConnection = {
  __typename?: 'InventoryCountLineConnection';
  edges: Array<InventoryCountLineEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InventoryCountLineEdge = {
  __typename?: 'InventoryCountLineEdge';
  cursor: Scalars['String']['output'];
  node: InventoryCountLineEntity;
};

export type InventoryCountLineEntity = {
  __typename?: 'InventoryCountLineEntity';
  additionalReferenceNumbers: Array<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  orderHawb?: Maybe<Scalars['String']['output']>;
  orderName?: Maybe<Scalars['String']['output']>;
  pieceStatus?: Maybe<PieceStatus>;
  pieceStatusAtClose?: Maybe<PieceStatus>;
  pieceUuid?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  scannedAt?: Maybe<Scalars['DateTime']['output']>;
  scannedBarcode?: Maybe<Scalars['String']['output']>;
  scannedByUser?: Maybe<UserActorEntity>;
  scannedByWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  state: InventoryCountLineState;
  uuid: Scalars['String']['output'];
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
};

export enum InventoryCountLineState {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Unexpected = 'UNEXPECTED'
}

export type InventoryCountScopeTooLargeOutput = {
  __typename?: 'InventoryCountScopeTooLargeOutput';
  cap: Scalars['Int']['output'];
  pieceCount: Scalars['Int']['output'];
};

/** Deprecated, use ItemGroupEntity instead */
export type InventoryItemEntity = {
  __typename?: 'InventoryItemEntity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  item: ItemEntity;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  markedOsdAt?: Maybe<Scalars['DateTime']['output']>;
  pickedAt?: Maybe<Scalars['DateTime']['output']>;
  storageUnit?: Maybe<StorageUnitEntity>;
  unitOfMeasure: UnitOfMeasure;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type InventoryPrimaryUnitOfMeasureEntity = {
  __typename?: 'InventoryPrimaryUnitOfMeasureEntity';
  createdAt: Scalars['DateTime']['output'];
  unitOfMeasure: UnitOfMeasure;
  upcCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type InventorySecondaryUnitOfMeasureEntity = {
  __typename?: 'InventorySecondaryUnitOfMeasureEntity';
  createdAt: Scalars['DateTime']['output'];
  primaryUnitsPerSecondaryUOM?: Maybe<Scalars['Float']['output']>;
  unitOfMeasure: UnitOfMeasure;
  upcCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceAdd = {
  __typename?: 'InvoiceAdd';
  name?: Maybe<Scalars['String']['output']>;
  shipmentUuids: Array<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAgingReportArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * If set to true, excludes any invoices that are closed
   * @deprecated Unused, need to deprecate after removing from frontend
   */
  hideCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of aging report to generate. SUMMARY shows one row per customer, DETAILED shows individual invoices. Defaults to DETAILED. */
  reportType?: InputMaybe<AgingReportType>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** If set to true, calculate aging from the invoice due date instead of the invoice date */
  useInvoiceDueDate?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InvoiceBillingSummaryDetailType {
  Aggregate = 'AGGREGATE',
  Detailed = 'DETAILED'
}

export enum InvoiceBillingSummaryGroupByType {
  Contact = 'CONTACT',
  Terminal = 'TERMINAL'
}

export type InvoiceBillingSummaryLineItemEntity = {
  __typename?: 'InvoiceBillingSummaryLineItemEntity';
  contactDisplayName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  inboundAddressName?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceName: Scalars['String']['output'];
  invoiceStatus: Scalars['String']['output'];
  orderLineHaulLane?: Maybe<OrderLineHaulLaneEntity>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  outboundAddressName?: Maybe<Scalars['String']['output']>;
  /** Sum of all package quantities on order */
  pieces: Scalars['Int']['output'];
  refNumbers?: Maybe<Array<Scalars['String']['output']>>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the line item as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  serviceLevel: Scalars['String']['output'];
  serviceName?: Maybe<Scalars['String']['output']>;
  shipmentsIncludedInLineItemRevenue: Array<ShipmentIncludedInRevenueEntity>;
  shipperBillOfLadingNumber: Scalars['String']['output'];
  totalCharge: Scalars['Float']['output'];
  /** Sum of all package weights on order */
  weight: Scalars['Float']['output'];
};

export type InvoiceBillingSummaryV2Group = {
  __typename?: 'InvoiceBillingSummaryV2Group';
  groupLabel: Scalars['String']['output'];
  groupTotal: Scalars['Float']['output'];
  specialGroupType?: Maybe<InvoiceBillingSummaryV2SpecialGroupType>;
  subgroups: Array<InvoiceBillingSummaryV2Subgroup>;
  totalLineItems: Scalars['Float']['output'];
};

export type InvoiceBillingSummaryV2Input = {
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated We don't support this option anymore and this field is not respected in the backend. */
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  onlyLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  reportDetailType?: InputMaybe<InvoiceBillingSummaryDetailType>;
  reportGroupByType: InvoiceBillingSummaryGroupByType;
  /** The zone serviceDateFilter is read in. Empty: each order on its own local service day while terminal_local_times is on, else the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  /** Filters the order records based on whether the "order service date" meets the filter conditions */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceBillingSummaryV2Output = {
  __typename?: 'InvoiceBillingSummaryV2Output';
  groups: Array<InvoiceBillingSummaryV2Group>;
  total: Scalars['Float']['output'];
};

export type InvoiceBillingSummaryV2PdfOutput = {
  __typename?: 'InvoiceBillingSummaryV2PdfOutput';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum InvoiceBillingSummaryV2SpecialGroupType {
  LineHaul = 'LINE_HAUL',
  NoTerminal = 'NO_TERMINAL'
}

export type InvoiceBillingSummaryV2Subgroup = {
  __typename?: 'InvoiceBillingSummaryV2Subgroup';
  lineItems: Array<InvoiceBillingSummaryLineItemEntity>;
  subgroupLabel?: Maybe<Scalars['String']['output']>;
  subgroupTotal: Scalars['Float']['output'];
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceCreateInput = {
  associatedShipmentUuids: Array<Scalars['String']['input']>;
  billToAddressCreateInput?: InputMaybe<AddressCreateInput>;
  billToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  billToContactUuid: Scalars['String']['input'];
  customChargeCreateInputs: Array<CustomChargeCreateInput>;
  customJournalNumber?: InputMaybe<Scalars['Float']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  customOrdinal?: InputMaybe<Scalars['Float']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceTermsUuid?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  remitToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InvoiceSource>;
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceEntity;
};

export type InvoiceEntity = {
  __typename?: 'InvoiceEntity';
  age: Scalars['Int']['output'];
  balanceCents?: Maybe<Scalars['Float']['output']>;
  balanceInCents: Scalars['Int']['output'];
  balanceInDollars: Scalars['Float']['output'];
  billTo?: Maybe<AddressEntity>;
  billToContact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  documents: Array<DocumentEntity>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  emailOptions: Array<Scalars['String']['output']>;
  emailSendStatus: EmailSendStatus;
  firstShipment?: Maybe<ShipmentEntity>;
  hasAppliedPayments: Scalars['Boolean']['output'];
  inConsolidatedInvoice: Scalars['Boolean']['output'];
  invoiceTerms?: Maybe<InvoiceTermEntity>;
  /** The invoice total charge in dollars as a string */
  invoiceTotal: Scalars['String']['output'];
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  journalNumber: Scalars['Float']['output'];
  lastSyncedFromQuickbooksAt?: Maybe<Scalars['DateTime']['output']>;
  lastSyncedToQuickbooksAt?: Maybe<Scalars['DateTime']['output']>;
  latest210EdiStatus?: Maybe<Latest210EdiStatusEntity>;
  latestEmailTransaction?: Maybe<EmailTransactionEntity>;
  manuallySyncedToQuickbooksDesktopAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderEntity>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  qbInvoiceNumber?: Maybe<Scalars['Float']['output']>;
  quickbooksInvoiceId?: Maybe<Scalars['String']['output']>;
  quickbooksLastSyncAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  quickbooksNextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  quickbooksSyncFailureCode?: Maybe<Scalars['String']['output']>;
  quickbooksSyncFailureDetail?: Maybe<Scalars['String']['output']>;
  quickbooksSyncFailureElement?: Maybe<Scalars['String']['output']>;
  quickbooksSyncFailureRemediation?: Maybe<Scalars['String']['output']>;
  quickbooksSyncFailureTitle?: Maybe<Scalars['String']['output']>;
  quickbooksSyncFaultCode?: Maybe<Scalars['String']['output']>;
  quickbooksSyncRequestId?: Maybe<Scalars['String']['output']>;
  quickbooksSyncToken?: Maybe<Scalars['String']['output']>;
  remitTo?: Maybe<AddressEntity>;
  shipments: Array<ShipmentEntity>;
  source: InvoiceSource;
  status: InvoiceStatus;
  syncedToQuickbooksDesktopAt?: Maybe<Scalars['DateTime']['output']>;
  totalNumber: Scalars['Float']['output'];
  totalOpenAmount: Scalars['Float']['output'];
  transmissionSendStatus: EmailSendStatus;
  uuid: Scalars['String']['output'];
};

export type InvoiceExcelCustomChargeAmount = {
  __typename?: 'InvoiceExcelCustomChargeAmount';
  total: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceExcelExportDataOutput = {
  __typename?: 'InvoiceExcelExportDataOutput';
  invoiceUuid: Scalars['String']['output'];
  shipments: Array<InvoiceExcelShipmentAmounts>;
};

export type InvoiceExcelShipmentAmounts = {
  __typename?: 'InvoiceExcelShipmentAmounts';
  customCharges: Array<InvoiceExcelCustomChargeAmount>;
  smc3FreightText?: Maybe<Scalars['String']['output']>;
  totalCharge: Scalars['Float']['output'];
  totalFreightCharge: Scalars['Float']['output'];
  totalFuelCharge: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

/** An invoice or unapplied payment and its fields returned as part of an invoice aging report */
export type InvoiceForAgingReportEntity = {
  __typename?: 'InvoiceForAgingReportEntity';
  age: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  journalNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  totalOpenAmount: Scalars['Float']['output'];
};

/** An invoice and its fields returned as part of an open invoice report */
export type InvoiceForOpenInvoiceReportEntity = {
  __typename?: 'InvoiceForOpenInvoiceReportEntity';
  billingPartyContactDisplayName: Scalars['String']['output'];
  billingPartyContactReferenceNumber?: Maybe<Scalars['String']['output']>;
  billingPartyContactUuid: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceBalanceCents: Scalars['Float']['output'];
  invoiceTotalCents: Scalars['Float']['output'];
  journalNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orders: Array<OrderForOpenInvoiceReportEntity>;
  status: InvoiceStatus;
  uuid: Scalars['String']['output'];
};

export type InvoiceNoteRuleConnection = {
  __typename?: 'InvoiceNoteRuleConnection';
  edges: Array<InvoiceNoteRuleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceNoteRuleEdge = {
  __typename?: 'InvoiceNoteRuleEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceNoteRuleEntity;
};

export type InvoiceNoteRuleEntity = {
  __typename?: 'InvoiceNoteRuleEntity';
  contactDisplayName?: Maybe<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Also print the company-wide rule's note after this rule's note. */
  includeCompanyNote: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  /** true: at least one order on the invoice is a rebill. false: none are. null: either. */
  rebilled?: Maybe<Scalars['Boolean']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceUuid?: Maybe<Scalars['String']['output']>;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceNoteRuleInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Also print the company-wide rule's note after this rule's note. Not allowed on the company-wide rule itself. */
  includeCompanyNote?: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  rebilled?: InputMaybe<Scalars['Boolean']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceRegisterReportInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * The upper bound for the date of invoices which will be included in the report.
   *     If not included, the report will include all invoices after invoiceStartDate.
   */
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The lower bound for the date of invoices which will be included in the report.
   *       If not included, the report will include all invoices before invoiceEndDate.
   */
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  statusFilter: InvoiceStatusFilter;
};

export type InvoiceSendJobBatchConnection = {
  __typename?: 'InvoiceSendJobBatchConnection';
  edges: Array<InvoiceSendJobBatchEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceSendJobBatchDocumentsEntity = {
  __typename?: 'InvoiceSendJobBatchDocumentsEntity';
  invoicesBackupDocument?: Maybe<DocumentEntity>;
  invoicesCombinedDocument?: Maybe<DocumentEntity>;
  invoicesZipDocument?: Maybe<DocumentEntity>;
};

export type InvoiceSendJobBatchEdge = {
  __typename?: 'InvoiceSendJobBatchEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceSendJobBatchEntity;
};

export type InvoiceSendJobBatchEntity = {
  __typename?: 'InvoiceSendJobBatchEntity';
  createdAt: Scalars['DateTime']['output'];
  invoiceBatchDocuments: InvoiceSendJobBatchDocumentsEntity;
  invoiceSendJobBatchDocumentCount: Scalars['Float']['output'];
  invoiceSendJobBatchProgress: InvoiceSendJobBatchProgressEntity;
  type: InvoiceSendJobBatchType;
  uuid: Scalars['String']['output'];
};

export type InvoiceSendJobBatchProgressEntity = {
  __typename?: 'InvoiceSendJobBatchProgressEntity';
  failCount: Scalars['Float']['output'];
  successCount: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export enum InvoiceSendJobBatchType {
  Download = 'DOWNLOAD',
  PostAndSend = 'POST_AND_SEND',
  Send = 'SEND'
}

export type InvoiceSendJobConnection = {
  __typename?: 'InvoiceSendJobConnection';
  edges: Array<InvoiceSendJobEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceSendJobEdge = {
  __typename?: 'InvoiceSendJobEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceSendJobEntity;
};

export type InvoiceSendJobEntity = {
  __typename?: 'InvoiceSendJobEntity';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<DocumentEntity>;
  documentGenerationFailed?: Maybe<Scalars['Boolean']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  invoice: InvoiceEntity;
  invoiceAttachmentDocumentTypes: Array<DocumentType>;
  /** A base64-encoded string that represents the list of shipments and their charges sent on the PDF invoice */
  invoiceChargesObject?: Maybe<Scalars['String']['output']>;
  invoiceSendJobError?: Maybe<InvoiceSendJobError>;
  invoiceTransmissionMethod: InvoiceTransmissionMethod;
  note?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export enum InvoiceSendJobError {
  AllRecipientsOnSuppressionList = 'ALL_RECIPIENTS_ON_SUPPRESSION_LIST',
  DocumentGenerationFailed = 'DOCUMENT_GENERATION_FAILED',
  InvoiceHasNoShipments = 'INVOICE_HAS_NO_SHIPMENTS',
  InvoiceMissingSomeShipments = 'INVOICE_MISSING_SOME_SHIPMENTS',
  InvoiceRecentlySent = 'INVOICE_RECENTLY_SENT',
  InvoiceTotalIsZero = 'INVOICE_TOTAL_IS_ZERO'
}

export enum InvoiceSendJobStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type InvoiceShipmentUpdate = {
  customChargeArrayUpdateInputs?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  freightChargeArrayUpdateInputs?: InputMaybe<Array<FreightChargeCreateInput>>;
  shipmentUuid: Scalars['String']['input'];
};

export enum InvoiceSource {
  ManuallyCreated = 'MANUALLY_CREATED',
  Migrated = 'MIGRATED'
}

export enum InvoiceStatus {
  Invoiced = 'INVOICED',
  NotFinalized = 'NOT_FINALIZED',
  Paid = 'PAID',
  ReadyToInvoice = 'READY_TO_INVOICE',
  Void = 'VOID'
}

export enum InvoiceStatusFilter {
  All = 'ALL',
  NotPosted = 'NOT_POSTED',
  Posted = 'POSTED'
}

/** Groups the invoice list by one or more columns. `fields` is the ordered list of grouping levels; `keys` holds the group value for each level the client has already expanded, outermost first, and must be shorter than `fields`: the query answers with the group rows of the next level. The invoices under a fully expanded path come from the `invoices` query with a `groupPath`. */
export type InvoiceTableGroupByInput = {
  /** Order of the group rows by their value; ascending when omitted. */
  direction?: InputMaybe<SortDirection>;
  /** Grouping levels, outermost first. */
  fields: Array<InvoiceTableGroupField>;
  /** Group value for each expanded level, outermost first. Shorter than `fields`. */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  /** Most group rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Group rows to skip within the requested level. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Invoice list columns the client may group by. */
export enum InvoiceTableGroupField {
  Customer = 'CUSTOMER',
  SendStatus = 'SEND_STATUS',
  Status = 'STATUS'
}

/** One expanded level of a grouped invoice list: the grouping field and the group key the client was given for it. A null key selects the invoices whose value is blank. */
export type InvoiceTableGroupPathEntryInput = {
  field: InvoiceTableGroupField;
  key?: InputMaybe<Scalars['String']['input']>;
};

/** One group of the invoice list at the level the request asked for: the value shared by its invoices, the text to show for it, and how many invoices it holds. */
export type InvoiceTableGroupRowEntity = {
  __typename?: 'InvoiceTableGroupRowEntity';
  /** Number of invoices in the group under the active filters. */
  count: Scalars['Int']['output'];
  /** The group value as the client must send it back in `groupBy.keys` or `groupPath` to expand this group. Null for the invoices whose value is blank. */
  key?: Maybe<Scalars['String']['output']>;
  /** Display text for the group. Null when the value is blank, so the client can render its own placeholder. */
  label?: Maybe<Scalars['String']['output']>;
};

/** One level of the grouped invoice list: the group rows at that level, and whether more follow the requested page. */
export type InvoiceTableGroupsOutput = {
  __typename?: 'InvoiceTableGroupsOutput';
  groupRows: Array<InvoiceTableGroupRowEntity>;
  /** Whether more group rows exist beyond `offset + limit`. */
  hasMore: Scalars['Boolean']['output'];
};

export type InvoiceTermEntity = {
  __typename?: 'InvoiceTermEntity';
  terms: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceToSend = {
  attachments: Array<DocumentType>;
  /** The email subject. If not provided, a subject will be generated */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceTransmissionMethod: InvoiceTransmissionMethod;
  invoiceType: InvoiceType;
  note?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum InvoiceTransmissionMethod {
  Download = 'DOWNLOAD',
  Edi = 'EDI',
  Email = 'EMAIL',
  EmailAndDownload = 'EMAIL_AND_DOWNLOAD',
  None = 'NONE'
}

export enum InvoiceType {
  ExcelChargeMatrix = 'EXCEL_CHARGE_MATRIX',
  ExcelItemized = 'EXCEL_ITEMIZED',
  ExcelSummarized = 'EXCEL_SUMMARIZED',
  PdfItemized = 'PDF_ITEMIZED',
  PdfSummarized = 'PDF_SUMMARIZED'
}

export type InvoiceUpdateInput = {
  associatedShipmentUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  billToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  billToContactUuid?: InputMaybe<Scalars['String']['input']>;
  customChargeArrayUpdate?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  documentUpsertInputs?: InputMaybe<Array<DocumentUpsertInput>>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  invoiceShipmentUpdate?: InputMaybe<InvoiceShipmentUpdate>;
  invoiceTermsUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newBillToAddress?: InputMaybe<AddressCreateInput>;
  newRemitToAddress?: InputMaybe<AddressCreateInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quickbooksInvoiceId?: InputMaybe<Scalars['String']['input']>;
  remitToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  uuid: Scalars['String']['input'];
};

export type InvoiceUpdateLimitedInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceTermsUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type IsReweighedSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type ItemConnection = {
  __typename?: 'ItemConnection';
  edges: Array<ItemEdge>;
  pageInfo: PageInfo;
};

export type ItemEdge = {
  __typename?: 'ItemEdge';
  cursor: Scalars['String']['output'];
  node: ItemEntity;
};

export type ItemEntity = {
  __typename?: 'ItemEntity';
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  inventoryItems: Array<InventoryItemEntity>;
  itemStorageUnitConfig?: Maybe<ItemStorageUnitConfigEntity>;
  primaryUOM: InventoryPrimaryUnitOfMeasureEntity;
  productCost?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  secondaryUOM?: Maybe<InventorySecondaryUnitOfMeasureEntity>;
  sellPrice?: Maybe<Scalars['Float']['output']>;
  sku: Scalars['String']['output'];
  status: ItemStatus;
  storageOrders: Array<StorageOrderEntity>;
  storageUnitsCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};

export type ItemForStorageOrder = {
  __typename?: 'ItemForStorageOrder';
  item: ItemEntity;
  /** The total count of inventory items of this item type */
  totalQuantity: Scalars['Int']['output'];
  /** The count of inventory items not assigned to a storage order */
  unassignedQuantity: Scalars['Int']['output'];
};

export type ItemForStorageUnit = {
  __typename?: 'ItemForStorageUnit';
  /** The count of inventory items of this item type assigned to this storage unit */
  assignedQuantity: Scalars['Int']['output'];
  item: ItemEntity;
};

export type ItemGroupConnection = {
  __typename?: 'ItemGroupConnection';
  edges: Array<ItemGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ItemGroupEdge = {
  __typename?: 'ItemGroupEdge';
  cursor: Scalars['String']['output'];
  node: ItemGroupEntity;
};

export type ItemGroupEntity = {
  __typename?: 'ItemGroupEntity';
  createdAt: Scalars['DateTime']['output'];
  item: ItemEntity;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  markedOsdAt?: Maybe<Scalars['DateTime']['output']>;
  pickedAt?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  storageOrder: StorageOrderEntity;
  storageUnit?: Maybe<StorageUnitEntity>;
  unitOfMeasure: UnitOfMeasure;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ItemGroupQuantityFilter = {
  /** UUIDs of itemGroups to query regardless of the filter type. Used to display picked itemGroups when editing a picklist */
  overrideUUIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  type: ItemGroupQuantityFilterType;
};

export enum ItemGroupQuantityFilterType {
  All = 'ALL',
  NotZero = 'NOT_ZERO',
  OnlyZero = 'ONLY_ZERO'
}

export type ItemLocationEntity = {
  __typename?: 'ItemLocationEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ItemStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ItemStorageUnitConfigEntity = {
  __typename?: 'ItemStorageUnitConfigEntity';
  consolidationUnitUOM: UnitOfMeasure;
  createdAt: Scalars['DateTime']['output'];
  dimensionsUOM: WarehouseMeasurementUnits;
  height: Scalars['Float']['output'];
  high: Scalars['Float']['output'];
  length: Scalars['Float']['output'];
  primaryUnitsPerConsolidationUnit: Scalars['Float']['output'];
  tie: Scalars['Float']['output'];
  type: MeasurementUnits;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
  weightUOM: WarehouseMeasurementUnits;
  width: Scalars['Float']['output'];
};

export type KpiComparisonSetEntity = {
  __typename?: 'KpiComparisonSetEntity';
  lastMonth: KpiReferenceValueEntity;
  priorPeriod: KpiReferenceValueEntity;
};

export type KpiComparisonsEntity = {
  __typename?: 'KpiComparisonsEntity';
  delivery?: Maybe<KpiComparisonSetEntity>;
  deliveryFailure?: Maybe<KpiComparisonSetEntity>;
  pickup?: Maybe<KpiComparisonSetEntity>;
  scan?: Maybe<KpiComparisonSetEntity>;
};

export type KpiDataStartEntity = {
  __typename?: 'KpiDataStartEntity';
  firstServiceDate?: Maybe<PlainDate>;
};

export type KpiDockReceiptRecordEntity = {
  __typename?: 'KpiDockReceiptRecordEntity';
  customerName?: Maybe<Scalars['String']['output']>;
  fileNo?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  pieceName: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type KpiDockReceiptRecordsEntity = {
  __typename?: 'KpiDockReceiptRecordsEntity';
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiDockReceiptRecordEntity>;
  totalRecords: Scalars['Int']['output'];
};

export type KpiDriverOrdersRecordEntity = {
  __typename?: 'KpiDriverOrdersRecordEntity';
  driverName?: Maybe<Scalars['String']['output']>;
  driverUuid: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  share?: Maybe<Scalars['Float']['output']>;
};

export type KpiDriverOrdersRecordsEntity = {
  __typename?: 'KpiDriverOrdersRecordsEntity';
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiDriverOrdersRecordEntity>;
  totalRecords: Scalars['Int']['output'];
};

/** How a delivery missed the day it was promised for. */
export enum KpiFailedDeliveryOutcome {
  DeliveredLateDay = 'DELIVERED_LATE_DAY',
  NotDelivered = 'NOT_DELIVERED'
}

export type KpiInvoicedOrderRecordEntity = {
  __typename?: 'KpiInvoicedOrderRecordEntity';
  createdAt: Scalars['DateTime']['output'];
  customerName: Scalars['String']['output'];
  days: Scalars['Float']['output'];
  fileNo?: Maybe<Scalars['String']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  invoicedAt: Scalars['DateTime']['output'];
  orderUuid: Scalars['String']['output'];
};

export type KpiInvoicedOrderRecordsEntity = {
  __typename?: 'KpiInvoicedOrderRecordsEntity';
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiInvoicedOrderRecordEntity>;
  totalRecords: Scalars['Int']['output'];
};

export type KpiLayoutEntity = {
  __typename?: 'KpiLayoutEntity';
  availableTiles: Array<KpiTileEntity>;
  customized: Scalars['Boolean']['output'];
  defaultTiles: Array<KpiTileEntity>;
  tiles: Array<KpiTileEntity>;
};

export type KpiOrderRecordEntity = {
  __typename?: 'KpiOrderRecordEntity';
  customerName: Scalars['String']['output'];
  driverNames: Array<Scalars['String']['output']>;
  fileNo?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  revenueCents?: Maybe<Scalars['Float']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type KpiOrderRecordsEntity = {
  __typename?: 'KpiOrderRecordsEntity';
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiOrderRecordEntity>;
  revenueVisible: Scalars['Boolean']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type KpiPaidInvoiceRecordEntity = {
  __typename?: 'KpiPaidInvoiceRecordEntity';
  amountCents?: Maybe<Scalars['Float']['output']>;
  customerName: Scalars['String']['output'];
  days: Scalars['Float']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  paidAt: Scalars['DateTime']['output'];
};

export type KpiPaidInvoiceRecordsEntity = {
  __typename?: 'KpiPaidInvoiceRecordsEntity';
  amountVisible: Scalars['Boolean']['output'];
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiPaidInvoiceRecordEntity>;
  totalRecords: Scalars['Int']['output'];
};

export type KpiPieceRecordEntity = {
  __typename?: 'KpiPieceRecordEntity';
  customerName: Scalars['String']['output'];
  fileNo?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  pieceName: Scalars['String']['output'];
  scanned: Scalars['Boolean']['output'];
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  terminalName?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<Scalars['String']['output']>;
};

export type KpiPieceRecordsEntity = {
  __typename?: 'KpiPieceRecordsEntity';
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiPieceRecordEntity>;
  totalRecords: Scalars['Int']['output'];
};

/** Whether a delivered piece carried a delivery scan. */
export enum KpiPieceScanState {
  NotScanned = 'NOT_SCANNED',
  Scanned = 'SCANNED'
}

/** A column of an Owner's Breakfast record table. */
export enum KpiRecordColumn {
  Amount = 'AMOUNT',
  Created = 'CREATED',
  Customer = 'CUSTOMER',
  Days = 'DAYS',
  Driver = 'DRIVER',
  Invoice = 'INVOICE',
  Invoiced = 'INVOICED',
  InvoiceDate = 'INVOICE_DATE',
  Judged = 'JUDGED',
  Order = 'ORDER',
  Orders = 'ORDERS',
  Outcome = 'OUTCOME',
  Paid = 'PAID',
  Piece = 'PIECE',
  Promised = 'PROMISED',
  Received = 'RECEIVED',
  Revenue = 'REVENUE',
  Scan = 'SCAN',
  ServiceDate = 'SERVICE_DATE',
  Share = 'SHARE',
  Terminal = 'TERMINAL',
  Weight = 'WEIGHT'
}

export type KpiRecordDateRangeInput = {
  column: KpiRecordColumn;
  /** YYYY-MM-DD, inclusive */
  from: Scalars['String']['input'];
  /** YYYY-MM-DD, inclusive */
  to: Scalars['String']['input'];
};

/** The file a record table is downloaded as. */
export enum KpiRecordDownloadFormat {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type KpiRecordFacetOptionEntity = {
  __typename?: 'KpiRecordFacetOptionEntity';
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type KpiRecordFacetsEntity = {
  __typename?: 'KpiRecordFacetsEntity';
  customers: Array<KpiRecordFacetOptionEntity>;
  drivers: Array<KpiRecordFacetOptionEntity>;
  terminals: Array<KpiRecordFacetOptionEntity>;
};

export type KpiRecordFiltersInput = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRanges?: InputMaybe<Array<KpiRecordDateRangeInput>>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  outcomes?: InputMaybe<Array<KpiFailedDeliveryOutcome>>;
  referenceText?: InputMaybe<Scalars['String']['input']>;
  scanStates?: InputMaybe<Array<KpiPieceScanState>>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KpiRecordPageInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type KpiRecordSortInput = {
  column: KpiRecordColumn;
  direction: SortDirection;
};

/** An Owner's Breakfast record table. */
export enum KpiRecordTable {
  DockReceipts = 'DOCK_RECEIPTS',
  DriverOrders = 'DRIVER_ORDERS',
  FailedDeliveries = 'FAILED_DELIVERIES',
  InvoicedOrders = 'INVOICED_ORDERS',
  OnTimeStops = 'ON_TIME_STOPS',
  Orders = 'ORDERS',
  PaidInvoices = 'PAID_INVOICES',
  Pieces = 'PIECES'
}

export type KpiRecordTableArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<KpiRecordFiltersInput>;
  metrics?: InputMaybe<Array<KpiTileMetric>>;
  page?: InputMaybe<KpiRecordPageInput>;
  sort?: InputMaybe<KpiRecordSortInput>;
  startDate: Scalars['DateTime']['input'];
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KpiRecordTableDownloadArgs = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<KpiRecordFiltersInput>;
  format: KpiRecordDownloadFormat;
  metrics?: InputMaybe<Array<KpiTileMetric>>;
  sort?: InputMaybe<KpiRecordSortInput>;
  startDate: Scalars['DateTime']['input'];
  stopFilter?: InputMaybe<OnTimeStopFilter>;
  stopKind?: InputMaybe<KpiStopKind>;
  table: KpiRecordTable;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A record table built while the user waited, behind a presigned link that expires like every report link. */
export type KpiRecordTableDownloadFileOutput = {
  __typename?: 'KpiRecordTableDownloadFileOutput';
  fileName: Scalars['String']['output'];
  reportGenerationStatus: ReportGenerationStatus;
  url: Scalars['String']['output'];
};

export type KpiRecordTableDownloadOutput = KpiRecordTableDownloadFileOutput | KpiRecordTableEmailToUserOutput;

/** A record-table CSV with more rows than are built while the user waits: a background job builds it and emails a link. */
export type KpiRecordTableEmailToUserOutput = {
  __typename?: 'KpiRecordTableEmailToUserOutput';
  emailedTo: Scalars['String']['output'];
  reportGenerationStatus: ReportGenerationStatus;
  rowCount: Scalars['Int']['output'];
};

export type KpiReferenceValueEntity = {
  __typename?: 'KpiReferenceValueEntity';
  denominator: Scalars['Int']['output'];
  numerator: Scalars['Int']['output'];
  pct?: Maybe<Scalars['Float']['output']>;
};

export type KpiReportArgs = {
  endDate: Scalars['DateTime']['input'];
  metrics?: InputMaybe<Array<KpiTileMetric>>;
  startDate: Scalars['DateTime']['input'];
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Which side of the order an on-time KPI describes. */
export enum KpiStopKind {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type KpiTileEntity = {
  __typename?: 'KpiTileEntity';
  format: KpiTileFormat;
  metric: KpiTileMetric;
};

/** How an Owner's Breakfast Dashboard tile shows its metric. */
export enum KpiTileFormat {
  Breakdown = 'BREAKDOWN',
  Card = 'CARD',
  Commitment = 'COMMITMENT',
  FailureList = 'FAILURE_LIST',
  Trend = 'TREND'
}

export type KpiTileInput = {
  format: KpiTileFormat;
  metric: KpiTileMetric;
};

/** A figure the Owner's Breakfast Dashboard can show. */
export enum KpiTileMetric {
  DaysToInvoice = 'DAYS_TO_INVOICE',
  DaysToPayment = 'DAYS_TO_PAYMENT',
  DeliveryFailure = 'DELIVERY_FAILURE',
  DockReceived = 'DOCK_RECEIVED',
  OnTimeDelivery = 'ON_TIME_DELIVERY',
  OnTimePickup = 'ON_TIME_PICKUP',
  OrdersPerDriver = 'ORDERS_PER_DRIVER',
  OrderCount = 'ORDER_COUNT',
  PieceScan = 'PIECE_SCAN',
  Revenue = 'REVENUE'
}

/** Grain of a KPI dashboard trend series. */
export enum KpiTrendBucketUnit {
  Day = 'DAY',
  Week = 'WEEK'
}

export type LaneDefaultDoorEntity = {
  __typename?: 'LaneDefaultDoorEntity';
  destDoorPosition?: Maybe<Scalars['Int']['output']>;
  endTerminalUuid: Scalars['String']['output'];
  originDoorPosition?: Maybe<Scalars['Int']['output']>;
  startTerminalUuid: Scalars['String']['output'];
};

export type LateStop = {
  __typename?: 'LateStop';
  minutesLate: Scalars['Int']['output'];
  serviceStartsAt: Scalars['String']['output'];
  stopUuid: Scalars['String']['output'];
  windowEndsAt: Scalars['String']['output'];
};

export type Latest210EdiStatusEntity = {
  __typename?: 'Latest210EdiStatusEntity';
  errorSummary?: Maybe<Scalars['String']['output']>;
  status: EdiTransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type LegCreateInput = {
  endStopCreateInput: StopCreateInput;
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** Manually initialize a leg's status */
  status?: InputMaybe<LegStatus>;
};

export type LegDriverMapCreateInput = {
  driverUuid: Scalars['String']['input'];
  legUuid: Scalars['String']['input'];
};

export type LegDriverMapEntity = {
  __typename?: 'LegDriverMapEntity';
  driver?: Maybe<DriverEntity>;
  uuid: Scalars['String']['output'];
};

export type LegDriverMapUpdateInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  legUuid?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type LegEntity = {
  __typename?: 'LegEntity';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  drivers: Array<DriverEntity>;
  endStop: StopEntity;
  flatRate?: Maybe<Scalars['Float']['output']>;
  legDriverMaps: Array<LegDriverMapEntity>;
  miles?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  previousStopAttempts: Array<StopEntity>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  shipment: ShipmentEntity;
  status: LegStatus;
  tags: Array<TagEntity>;
  uuid: Scalars['String']['output'];
};

export enum LegPdfColumnMapping {
  Miles = 'MILES'
}

export enum LegStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS'
}

export type LegUpdateInput = {
  endStopUpdateInput?: InputMaybe<StopUpdateInput>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** Manually update a leg's status. Only recommended if setting to COMPLETED */
  status?: InputMaybe<LegStatus>;
  uuid: Scalars['String']['input'];
};

export type LegUpsertInput = {
  endStopUpsertInput: StopUpsertInput;
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** Manually initialize a leg's status */
  status?: InputMaybe<LegStatus>;
  uuid: Scalars['String']['input'];
};

export type LineHaulDriverConflictInput = {
  driverUuid: Scalars['String']['input'];
  manifestUuid: Scalars['String']['input'];
};

export type LineHaulDriverConflictOutput = {
  __typename?: 'LineHaulDriverConflictOutput';
  conflictWarning?: Maybe<Scalars['String']['output']>;
};

export type LineHaulFuelChargeFuelProfileDateRangeInput = {
  contactUuid: Scalars['String']['input'];
  /** The date the line haul was completed. To be used to select the fuel profile date range selection if it exists */
  lineHaulCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the fuel profile attached to the tariff selected for the stop */
  tariffGroupFuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
};

export type LineHaulFuelChargeFuelProfileDateRangeOutput = {
  __typename?: 'LineHaulFuelChargeFuelProfileDateRangeOutput';
  fuelProfileDateRange?: Maybe<FuelProfileDateRangeEntity>;
};

export type LineHaulLaneCreateInput = {
  destinationTerminalUuid: Scalars['String']['input'];
  intermediateTerminalUuids: Array<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  originTerminalUuid: Scalars['String']['input'];
};

export type LineHaulLaneEntity = {
  __typename?: 'LineHaulLaneEntity';
  destinationTerminal: TerminalEntity;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  originTerminal: TerminalEntity;
  segments: Array<LineHaulSegmentEntity>;
  uuid: Scalars['String']['output'];
};

export type LineHaulLaneUpdateInput = {
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  intermediateTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type LineHaulManifestCreateInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departDate: Scalars['DateTime']['input'];
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LineHaulManifestEntity = {
  __typename?: 'LineHaulManifestEntity';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedByAgentAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  departDate: Scalars['DateTime']['output'];
  departTimeMinutes?: Maybe<Scalars['Int']['output']>;
  /** IANA zone of the end terminal, or the company zone when the terminal has none or terminal local times are off for the company. */
  destinationTimeZone: Scalars['String']['output'];
  doorsClosedAt?: Maybe<Scalars['DateTime']['output']>;
  driver?: Maybe<DriverEntity>;
  endTerminal: TerminalEntity;
  equipment?: Maybe<EquipmentEntity>;
  estimatedArrival?: Maybe<Scalars['DateTime']['output']>;
  estimatedDeparture?: Maybe<Scalars['DateTime']['output']>;
  hasFreightArrivedWhileUndeparted: Scalars['Boolean']['output'];
  isRecurringGenerated: Scalars['Boolean']['output'];
  loadPosition?: Maybe<LoadPosition>;
  /** The run operating day at its origin terminal as YYYY-MM-DD, or null on a row written before it was stored. */
  operatingDay?: Maybe<Scalars['String']['output']>;
  orderSegments: Array<OrderLineHaulSegmentEntity>;
  orders: Array<OrderEntity>;
  ordersOnManifest: Array<OrderOnLineHaulManifestEntity>;
  /** IANA zone of the start terminal, or the company zone when the terminal has none or terminal local times are off for the company. */
  originTimeZone: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  sentToAgentAt?: Maybe<Scalars['DateTime']['output']>;
  startTerminal: TerminalEntity;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: LineHaulManifestStatus;
  uuid: Scalars['String']['output'];
};

/** Filters with fields for the findLineHaulManifestsV2 query. Use either "and" or "or" or "filters", but not all simultaneously. Using all in the same query may lead to unexpected results. */
export type LineHaulManifestFilters = {
  and?: InputMaybe<Array<LineHaulManifestFilters>>;
  fields?: InputMaybe<Fields>;
  or?: InputMaybe<Array<LineHaulManifestFilters>>;
};

/** The status of the line haul manifest */
export enum LineHaulManifestStatus {
  Arrived = 'ARRIVED',
  Departed = 'DEPARTED',
  DoorsClosed = 'DOORS_CLOSED',
  Planning = 'PLANNING'
}

export type LineHaulManifestStatusFilter = {
  /** Filters for records where the relevant status field is equal to the provided status value */
  eq?: InputMaybe<LineHaulManifestStatus>;
  /** Filters for records where the relevant status field is in the provided status values */
  in?: InputMaybe<Array<LineHaulManifestStatus>>;
  /** Filters for records where the relevant status field is not equal to the provided status value */
  neq?: InputMaybe<LineHaulManifestStatus>;
  /** Filters for records where the relevant status field is not in the provided status values */
  nin?: InputMaybe<Array<LineHaulManifestStatus>>;
};

export type LineHaulManifestUpdateInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departDate: Scalars['DateTime']['input'];
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type LineHaulManifestsCategoryGroupsOutput = {
  __typename?: 'LineHaulManifestsCategoryGroupsOutput';
  category: LineHaulManifestsGroupBy;
  groups: Array<ManifestGroup>;
};

/** Categories available for grouping line haul manifests */
export enum LineHaulManifestsGroupBy {
  Lane = 'LANE'
}

export type LineHaulManifestsGroupsInput = {
  filters?: InputMaybe<FindLineHaulManifestsV2FiltersInput>;
  groupBy: LineHaulManifestsGroupBy;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type LineHaulOrderSort = {
  sortBy: OrderLineHaulSegmentSortFields;
  sortDirection: SortDirection;
};

export type LineHaulRevenueReportInput = {
  /** End date for the report (filters order_events.created_at) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Output format for the report. ALLOCATION = current multi-sheet breakdown, SUMMARY = SSF-style 4-sheet summary. */
  outputFormat?: InputMaybe<RevenueReportOutputFormat>;
  /** Report rules for the report */
  rules?: InputMaybe<ReportRules>;
  /** Start date for the report (filters order_events.created_at) */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LineHaulRevenueReportOutput = {
  __typename?: 'LineHaulRevenueReportOutput';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LineHaulRouteLegInput = {
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type LineHaulRunCargoUnitEntity = {
  __typename?: 'LineHaulRunCargoUnitEntity';
  equipmentUuid: Scalars['String']['output'];
  floorLengthIn?: Maybe<Scalars['Float']['output']>;
  floorWidthIn?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export type LineHaulRunConfigEntity = {
  __typename?: 'LineHaulRunConfigEntity';
  cubeCapacity?: Maybe<Scalars['Float']['output']>;
  cutoffTime?: Maybe<Scalars['String']['output']>;
  /** IANA zone cutoffTime is read in: the run origin terminal zone once the cutoff is in origin time, else the company zone. */
  cutoffTimeZone: Scalars['String']['output'];
  manifestUuid: Scalars['String']['output'];
  powerUnitDetails?: Maybe<LineHaulRunCargoUnitEntity>;
  powerUnitName?: Maybe<Scalars['String']['output']>;
  recurringTemplateTruckUuid?: Maybe<Scalars['String']['output']>;
  trailerDetails: Array<RecurringTemplateTruckTrailerEntity>;
  trailers: Array<Scalars['String']['output']>;
  truckLabel?: Maybe<Scalars['String']['output']>;
  weightCapacity?: Maybe<Scalars['Float']['output']>;
};

export type LineHaulSegmentCreateInput = {
  endTerminalUuid: Scalars['String']['input'];
  laneUuid: Scalars['String']['input'];
  ordinal: Scalars['Float']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type LineHaulSegmentEntity = {
  __typename?: 'LineHaulSegmentEntity';
  cutoffTime?: Maybe<Scalars['String']['output']>;
  endTerminal: TerminalEntity;
  ordinal: Scalars['Float']['output'];
  startTerminal: TerminalEntity;
  transitDays?: Maybe<Scalars['Int']['output']>;
  transitMinutes?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

export type LineHaulSegmentTimingEntity = {
  __typename?: 'LineHaulSegmentTimingEntity';
  cutoffTime?: Maybe<Scalars['String']['output']>;
  /** IANA zone cutoffTime is read in: the start terminal zone once the cutoff is in origin time, else the company zone. */
  cutoffTimeZone: Scalars['String']['output'];
  endTerminalCode: Scalars['String']['output'];
  endTerminalUuid: Scalars['String']['output'];
  startTerminalCode: Scalars['String']['output'];
  /** IANA zone of the start terminal itself, where its doors close; null when the terminal has no zone. */
  startTerminalTimeZone?: Maybe<Scalars['String']['output']>;
  startTerminalUuid: Scalars['String']['output'];
  transitDays?: Maybe<Scalars['Int']['output']>;
  transitMinutes?: Maybe<Scalars['Int']['output']>;
};

export type LineHaulSegmentUpdateInput = {
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  laneUuid?: InputMaybe<Scalars['String']['input']>;
  ordinal: Scalars['Float']['input'];
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type LineHaulStatusByTerminal = {
  __typename?: 'LineHaulStatusByTerminal';
  arrivalScans: Array<ScanEntity>;
  departureScans: Array<ScanEntity>;
  manifestDepartingFromThisTerminal?: Maybe<LineHaulManifestEntity>;
  markedArrivedAt?: Maybe<Scalars['DateTime']['output']>;
  terminal: TerminalEntity;
};

export type LineHaulTrailerAssignmentEntity = {
  __typename?: 'LineHaulTrailerAssignmentEntity';
  cubeFt3: Scalars['Float']['output'];
  manifestUuid: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  trailerEquipmentUuid: Scalars['String']['output'];
  weightLbs: Scalars['Float']['output'];
};

export type LineHaulUtilizationArgs = {
  endDate: Scalars['DateTime']['input'];
  grain: LineHaulUtilizationGrain;
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type LineHaulUtilizationAssumptionEntity = {
  __typename?: 'LineHaulUtilizationAssumptionEntity';
  defaultTrailerCubeCapacityCubicFeet: Scalars['Float']['output'];
  defaultTrailerWeightCapacityLbs: Scalars['Float']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Grouping grain for the Intelligence Board linehaul utilization report. */
export enum LineHaulUtilizationGrain {
  Lane = 'LANE',
  Manifest = 'MANIFEST',
  Terminal = 'TERMINAL'
}

export type LineHaulUtilizationReportEntity = {
  __typename?: 'LineHaulUtilizationReportEntity';
  assumptions: LineHaulUtilizationAssumptionEntity;
  grain: LineHaulUtilizationGrain;
  hasAssumptions: Scalars['Boolean']['output'];
  overallWeightUtilizationPct?: Maybe<Scalars['Float']['output']>;
  rows: Array<LineHaulUtilizationRowEntity>;
  totalEquivalentEmptyTrailers: Scalars['Float']['output'];
  totalLoadedWeightLbs: Scalars['Float']['output'];
  totalManifests: Scalars['Int']['output'];
  totalTrailers: Scalars['Int']['output'];
  totalWeightCapacityLbs: Scalars['Float']['output'];
  usedDefaultCapacity: Scalars['Boolean']['output'];
};

export type LineHaulUtilizationRowEntity = {
  __typename?: 'LineHaulUtilizationRowEntity';
  cubeCapacityCubicFeet: Scalars['Float']['output'];
  cubeUtilizationPct?: Maybe<Scalars['Float']['output']>;
  equivalentEmptyTrailers: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  laneBalancePct?: Maybe<Scalars['Float']['output']>;
  loadedCubeCubicFeet: Scalars['Float']['output'];
  loadedWeightLbs: Scalars['Float']['output'];
  manifestCount: Scalars['Int']['output'];
  reverseLoadedWeightLbs?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<LineHaulUtilizationStatus>;
  trailerCount: Scalars['Int']['output'];
  utilizationPct?: Maybe<Scalars['Float']['output']>;
  weightCapacityLbs: Scalars['Float']['output'];
  weightUtilizationPct?: Maybe<Scalars['Float']['output']>;
};

/** Trailer utilization standing used by the Intelligence Board linehaul report. */
export enum LineHaulUtilizationStatus {
  PoorlyUtilized = 'POORLY_UTILIZED',
  Underutilized = 'UNDERUTILIZED',
  WellUtilized = 'WELL_UTILIZED'
}

export enum LinehaulDispatchTableField {
  CustomerName = 'CUSTOMER_NAME',
  DeadlineDate = 'DEADLINE_DATE',
  DimWeight = 'DIM_WEIGHT',
  Hawb = 'HAWB',
  InboundAddressName = 'INBOUND_ADDRESS_NAME',
  IsHazmat = 'IS_HAZMAT',
  IsSpecial = 'IS_SPECIAL',
  Lane = 'LANE',
  Mawb = 'MAWB',
  Name = 'NAME',
  NextSegment = 'NEXT_SEGMENT',
  OutboundAddressName = 'OUTBOUND_ADDRESS_NAME',
  PieceCount = 'PIECE_COUNT',
  Segment = 'SEGMENT',
  Service = 'SERVICE',
  ServiceDate = 'SERVICE_DATE',
  Tags = 'TAGS',
  Weight = 'WEIGHT'
}

export type LinkPieceError = {
  __typename?: 'LinkPieceError';
  pieceUuid: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type LinkPieceToOrderInput = {
  orderUuid: Scalars['String']['input'];
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid: Scalars['String']['input'];
};

export type LinkPieceToPackageInput = {
  packageUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};

export type LinkPiecesToPackageInput = {
  packageUuid: Scalars['String']['input'];
  pieceUuids: Array<Scalars['String']['input']>;
};

export type LinkPiecesToPackageOutput = {
  __typename?: 'LinkPiecesToPackageOutput';
  errors: Array<LinkPieceError>;
  linkedPieces: Array<PieceEntity>;
  success: Scalars['Boolean']['output'];
};

export type LoadPlacementInput = {
  h: Scalars['Float']['input'];
  l: Scalars['Float']['input'];
  packageUuid: Scalars['String']['input'];
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  rotated: Scalars['Boolean']['input'];
  trailerEquipmentUuid?: InputMaybe<Scalars['String']['input']>;
  unitIndex?: InputMaybe<Scalars['Int']['input']>;
  w: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

export enum LoadPosition {
  Nose = 'NOSE',
  Tail = 'TAIL'
}

/** A time typed as a wall clock on day in entryTimeZone (D-05). The server converts it, refusing a time skipped by a DST change and asking which pass on a repeated one. Requires terminal_local_times. */
export type LocalDateTimeInput = {
  /** YYYY-MM-DD in entryTimeZone. */
  day: Scalars['String']['input'];
  /** Required when the time happens twice (fall-back night). */
  disambiguation?: InputMaybe<AmbiguousLocalTime>;
  entryTimeZone: Scalars['String']['input'];
  /** HH:mm in entryTimeZone. */
  time: Scalars['String']['input'];
};

export type LocationSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type LogUnassignedScanInput = {
  barcode: Scalars['String']['input'];
  scanType?: InputMaybe<ScanType>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type LoginInput = {
  clientUuid?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginOutput = {
  __typename?: 'LoginOutput';
  clientChallenge?: Maybe<Array<ClientChallengeEntity>>;
  driver?: Maybe<DriverEntity>;
  /** @deprecated Use kind to disambiguate instead */
  fullAccessUser?: Maybe<UserEntity>;
  kind?: Maybe<Scalars['String']['output']>;
  status: LoginStatus;
  /** @deprecated Use kind to disambiguate instead */
  thirdPartyUser?: Maybe<ThirdPartyUserEntity>;
};

export type LoginPhoneInput = {
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type LoginPhoneJwtInput = {
  jwt: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type LoginPhoneOutput = {
  __typename?: 'LoginPhoneOutput';
  driver?: Maybe<DriverEntity>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  status: LoginStatus;
  warehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
};

export enum LoginStatus {
  ClientChallenge = 'CLIENT_CHALLENGE',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  Success = 'SUCCESS',
  ThirdPartyUserNoOrganization = 'THIRD_PARTY_USER_NO_ORGANIZATION',
  Unauthorized = 'UNAUTHORIZED'
}

export type MakeAppointmentConfirmationDecisionInput = {
  accepted: Scalars['Boolean']['input'];
  stopUuid: Scalars['String']['input'];
};

export type MakeAppointmentConfirmationDecisionOutput = AppointmentConfirmationInfoOutput | MutationErrorOutput;

export type ManifestGroup = {
  __typename?: 'ManifestGroup';
  category: LineHaulManifestsGroupBy;
  manifests: Array<LineHaulManifestEntity>;
};

export type ManifestUuidsInput = {
  manifestUuids: Array<Scalars['String']['input']>;
};

export type ManualStandardStopTypeForAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type MapPeerAccessorialInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  mappingUuid: Scalars['String']['input'];
};

export type MapPeerServiceInput = {
  mappingUuid: Scalars['String']['input'];
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
};

export type MarkAsNotOnHandInput = {
  /** The UUID of the order to mark not on hand */
  uuid: Scalars['String']['input'];
};

export type MarkAsNotReceivedAtOriginInput = {
  /** The UUID of the order to mark not received at origin terminal */
  uuid: Scalars['String']['input'];
};

export type MarkAsOnHandInput = {
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkAsOnHoldInput = {
  holdReasonUuid?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkAsReceivedAtOriginInput = {
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkConsolidatableOrdersAsBilledIndividuallyInput = {
  orderUuid: Scalars['String']['input'];
};

export type MarkManifestAsArrivedInput = {
  /** Client-side ISO-8601 timestamp of when the driver actually arrived. Used to preserve the real time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is more than 48 hours in the past or more than 5 minutes in the future (or absent), the server records its own time instead. The stored arrival is never earlier than the departure time of the manifest. */
  clientArrivedAt?: InputMaybe<Scalars['String']['input']>;
  /** Set when the caller has confirmed arriving a run that never departed. Without it the mutation refuses, as it always has; the board sets it only after the dispatcher has been shown how much of the run was loaded and has accepted. */
  confirmedWithoutDeparture?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the manifest arrival is being marked from the line haul dispatch screen. Used as part of the business logic to determine if the manifest should be marked as on hand. */
  fromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsArrivedOutput = {
  __typename?: 'MarkManifestAsArrivedOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkManifestAsDepartedInput = {
  /** Client-side ISO-8601 timestamp of when the driver actually departed. Used to preserve the real time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is more than 48 hours in the past or more than 5 minutes in the future (or absent), the server records its own time instead. The stored departure is never earlier than the latest time the loaded pieces of the manifest were loaded. */
  clientDepartedAt?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsDepartedOutput = {
  __typename?: 'MarkManifestAsDepartedOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkManifestAsDoorsClosedInput = {
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsDoorsClosedOutput = {
  __typename?: 'MarkManifestAsDoorsClosedOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkManifestAsPlanningInput = {
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsPlanningOutput = {
  __typename?: 'MarkManifestAsPlanningOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkNotOsdInput = {
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkNotificationReadInput = {
  uuid: Scalars['String']['input'];
};

export type MarkOrderAsCompleteForceInput = {
  refuseOrderInput?: InputMaybe<RefuseOrderInput>;
  uuid: Scalars['String']['input'];
};

export type MarkOrderAsPickedInput = {
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

/** The expected input to the mutation that marks an order as refused, records who it was refused by, and when it was refused */
export type MarkOrderAsRefusedInput = {
  /** The person that the order was refused by */
  refusedBy: Scalars['String']['input'];
  /** The date and time when the order was marked as refused */
  refusedDate: Scalars['DateTime']['input'];
  /** refusedDate typed as a wall clock in an entry zone (terminal_local_times). Replaces refusedDate when sent. */
  refusedDateLocal?: InputMaybe<LocalDateTimeInput>;
  /** Why the consignee refused it, in the driver's words */
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  /** The structured reason the consignee refused it, for outbound EDI. The free-text refusedReason carries the detail. */
  refusedReasonCode?: InputMaybe<OrderRefusalReason>;
  /** The UUID of the order to mark as refused */
  uuid: Scalars['String']['input'];
};

export type MarkOrderAsRefusedOutput = MarkOrderAsRefusedSuccessOutput | MutationErrorOutput;

export type MarkOrderAsRefusedSuccessOutput = {
  __typename?: 'MarkOrderAsRefusedSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkOsdInput = {
  /** @deprecated Use `osdReason` instead */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Include any notes provided on why the order was OSD */
  osdReason?: InputMaybe<Scalars['String']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkPieceDamagedInput = {
  osdReason?: InputMaybe<Scalars['String']['input']>;
  pieceUuid: Scalars['String']['input'];
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarkQuoteSentInput = {
  orderQuoteUuid: Scalars['String']['input'];
};

export type MarkQuoteSentOutput = MarkQuoteSentSuccessOutput | MutationErrorOutput;

export type MarkQuoteSentSuccessOutput = {
  __typename?: 'MarkQuoteSentSuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
  /** The charge-row sum pinned at send */
  quotedAmountCents: Scalars['Int']['output'];
  sentAt: Scalars['DateTime']['output'];
  status: OrderQuoteStatus;
  validUntil: Scalars['DateTime']['output'];
};

export type MarkStopAsFailedV2Input = {
  attemptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitAsBilledInput = {
  /** The UUID of the storage unit to mark as billed */
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitAsBilledOutput = {
  __typename?: 'MarkStorageUnitAsBilledOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkStorageUnitAsOsdInput = {
  osdReason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitAsOsdOutput = {
  __typename?: 'MarkStorageUnitAsOsdOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkStorageUnitOnHandInput = {
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitOnHandOutput = {
  __typename?: 'MarkStorageUnitOnHandOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkTestOrderForEdiReviewInput = {
  orderUuid: Scalars['String']['input'];
};

export type MasterAccountEntity = {
  __typename?: 'MasterAccountEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum MatcherType {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  NotContains = 'NOT_CONTAINS',
  NotEndsWith = 'NOT_ENDS_WITH',
  NotStartsWith = 'NOT_STARTS_WITH',
  Regex = 'REGEX',
  RegexNoMatch = 'REGEX_NO_MATCH',
  StartsWith = 'STARTS_WITH'
}

export type MatchingGroupsAlongWithMatchingServices = {
  __typename?: 'MatchingGroupsAlongWithMatchingServices';
  /** the services in that group that has a match */
  serviceUuids: Array<Scalars['String']['output']>;
  /** the tariff group that has this combination */
  tariffGroupName?: Maybe<Scalars['String']['output']>;
  /** the tariff group uuid that has this combination */
  tariffGroupUuid: Scalars['String']['output'];
};

export type MawbSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum MeasurementSystem {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC'
}

export enum MeasurementUnits {
  Centimeters = 'CENTIMETERS',
  Inches = 'INCHES'
}

export type MergeEdiOrderInput = {
  existingOrderUuid: Scalars['String']['input'];
  incomingEdiOrderUuid: Scalars['String']['input'];
};

export type MergeEdiOrderOutput = {
  __typename?: 'MergeEdiOrderOutput';
  uuid: Scalars['String']['output'];
};

export type MergeScannedOrderResultIntoPossibleDuplicateInput = {
  scannedOrderResultUuid: Scalars['String']['input'];
};

export type MetricTagInput = {
  tag: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum MetricType {
  Count = 'COUNT',
  Distribution = 'DISTRIBUTION',
  Gauge = 'GAUGE'
}

export type MigratableCompanyObject = {
  __typename?: 'MigratableCompanyObject';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** Environments the config-migration tool can read from or write to. */
export enum MigrationEnv {
  Demo = 'DEMO',
  Development = 'DEVELOPMENT',
  Localdev = 'LOCALDEV',
  Production = 'PRODUCTION',
  Release = 'RELEASE',
  Staging = 'STAGING'
}

export type MirrorSyncRequestEntity = {
  __typename?: 'MirrorSyncRequestEntity';
  companyUuids: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Orders the target newly created, out of those sent. */
  createdCount?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** Orders the target already had (idempotent re-sync skips). */
  existedCount?: Maybe<Scalars['Int']['output']>;
  fromDateTime: Scalars['DateTime']['output'];
  /** Orders sent to the target (attempted). */
  matchedCount?: Maybe<Scalars['Int']['output']>;
  scope: Scalars['String']['output'];
  status: Scalars['String']['output'];
  toDateTime: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type MirrorSyncableCompanyEntity = {
  __typename?: 'MirrorSyncableCompanyEntity';
  companyUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MirrorTargetCompanyEntity = {
  __typename?: 'MirrorTargetCompanyEntity';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type MirrorTargetEntity = {
  __typename?: 'MirrorTargetEntity';
  batchSize: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  /** Number of companies this target mirrors via the live cron. */
  mirroredCompanyCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subscribesToAllCompanies: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type MissingOrderForInvoiceMoveEntity = {
  __typename?: 'MissingOrderForInvoiceMoveEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum MobileRole {
  Driver = 'DRIVER',
  WarehouseEmployee = 'WAREHOUSE_EMPLOYEE'
}

export type MotiveIntegrationEntity = {
  __typename?: 'MotiveIntegrationEntity';
  /** Whether the company has a stored Motive API key. */
  connected: Scalars['Boolean']['output'];
};

export type MoveBetweenRunsInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  packageUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceManifestUuid: Scalars['String']['input'];
  targetManifestUuid: Scalars['String']['input'];
};

export type MoveShipmentsBetweenInvoicesIncompleteOperationOutput = {
  __typename?: 'MoveShipmentsBetweenInvoicesIncompleteOperationOutput';
  /** The list of shipment UUIDs that need to also be moved for the operation to be completed successfully. For example we want to move all shipments of a consolidated order even though we only specified some in the input. */
  additionalShipmentUuidsToMove: Array<Scalars['String']['output']>;
  /** The list of shipment UUIDs that were specified in the input. */
  inputShipmentUuids: Array<Scalars['String']['output']>;
  /** The list of orders that are missing for the operation to be completed successfully. For example we want to move all shipments of a consolidated order even though we only specified some in the input. */
  missingOrders: Array<MissingOrderForInvoiceMoveEntity>;
};

/** The input to move shipments to a new invoice */
export type MoveShipmentsBetweenInvoicesInput = {
  /** The uuid of the invoice that we want to move the shipments from. */
  invoiceMovingFromUuid: Scalars['String']['input'];
  /** The uuid of the new invoice that we want to move the shipments to. If null, the shipments will be moved to a newly created invoice. */
  invoiceMovingToUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentUuids: Array<Scalars['String']['input']>;
};

export type MoveShipmentsBetweenInvoicesOutput = MoveShipmentsBetweenInvoicesIncompleteOperationOutput | MoveShipmentsBetweenInvoicesSuccessOutput | MutationErrorOutput;

export type MoveShipmentsBetweenInvoicesSuccessOutput = {
  __typename?: 'MoveShipmentsBetweenInvoicesSuccessOutput';
  /** The list of shipment UUIDs that were successfully moved to the new invoice */
  movedShipmentUuids: Array<Scalars['String']['output']>;
  /** The uuid of the new invoice that we moved the shipments to */
  newInvoiceUuid: Scalars['String']['output'];
};

export type MoveShipmentsToInvoiceInput = {
  invoiceUuid: Scalars['String']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type MoveShipmentsToInvoiceOutput = {
  __typename?: 'MoveShipmentsToInvoiceOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * UUID of target invoice
   * @deprecated Added for backwards compatibility
   */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptCustomerPortalOrder: AcceptCustomerPortalOrderOutput;
  acceptEdiOrApiOrder: AcceptEdiOrApiOrderOutput;
  /** Accept an Expeditors work order and notify their API */
  acceptExpeditorsWorkOrder: Scalars['Boolean']['output'];
  acceptOrderDelegation: DelegatedOrderInboxItemEntity;
  acceptOrganizationPeer: OrganizationPeerEntity;
  acknowledgeFailedInvoiceSendJobs: InvoiceSendJobBatchEntity;
  /** Acknowledge changes to all stops for the current driver */
  acknowledgeMyRouteChanges: Scalars['Int']['output'];
  /** Acknowledge changes to a specific stop for the current driver */
  acknowledgeMyStopChange: AcknowledgeMyStopChangeOutput;
  acknowledgeNotification: NotificationEntity;
  acknowledgeNotifications: Array<NotificationEntity>;
  acknowledgeQuoteAttention: AcknowledgeQuoteAttentionOutput;
  addApiUserContactMapping: ApiUserEntity;
  addDriverExpoPushToken?: Maybe<DriverEntity>;
  addDriversToRoute: Array<RouteDriverEntity>;
  /** Given lists of settlement bill line items, will create new settlement bill line items and update existing ones */
  addLineItemsToSettlementBills: AddLineItemsToSettlementBillsOutput;
  addNextRouteSlotForRoute: RouteEntity;
  addOrdersToInvoices: AddOrdersToInvoicesOutput;
  addOrdersToManifest: AddOrdersToManifestOutput;
  addOrdersToManifestV2: AddOrdersToManifestV2Output;
  /** Adds pieces to a receipt by creating new pieces and/or linking existing ones. Used by both web and mobile. */
  addPiecesToPieceReceipt: AddPiecesToPieceReceiptOutput;
  addQuickbooksDesktopCustomer: QuickbooksDesktopResultEntity;
  addQuickbooksDesktopCustomers: Array<QuickbooksDesktopResultEntity>;
  addQuickbooksDesktopItem: QuickbooksDesktopResultEntity;
  addRouteStop: StopEntity;
  addServiceToContact: ServiceEntity;
  /** Finds existing contact-to-services mappings and adds the specified services */
  addServicesToTariffGroupMappings: Array<ContactToServicesTariffGroupMappingEntity>;
  addTagToLeg: TagEntity;
  addTagToOrder: TagEntity;
  addTestAccessorialCharge: AddTestAccessorialChargeOutput;
  addThirdPartyUserToContact: ThirdPartyUserEntity;
  addUserToRole: AddUserToRoleOutput;
  adminSyncInvoicesToQuickbooks: SyncInvoicesToQuickbooksOutput;
  adoptDriverSettlementPayTerms: Array<AdoptDriverSettlementPayTermsResult>;
  advanceOutboundBenchOrders: BenchRunReportEntity;
  apiKeyAdminConnectOrgs: ApiKeyAdminDetailEntity;
  apiKeyAdminCreate: ApiKeyAdminEntity;
  apiKeyAdminDelete: Scalars['Boolean']['output'];
  apiKeyAdminDisconnectOrg: ApiKeyAdminDetailEntity;
  apiKeyAdminImportCsv: ApiKeyAdminCsvImportReport;
  apiKeyAdminSetMappingTemplate: ApiKeyAdminWebhookShapeConfigEntity;
  apiKeyAdminSetStatusMappings: Array<ApiKeyAdminStatusMappingEntity>;
  apiKeyAdminUpdate: ApiKeyAdminEntity;
  applyDebitToPayment: PaymentToPaymentMappingEntity;
  applyDelegationAccessorialProposal: DelegationAccessorialProposalEntity;
  applyRouteOptimization: Scalars['Int']['output'];
  approveQuote: QuoteEntity;
  approveQuoteReply: ApproveQuoteReplyOutput;
  archiveAirportInfo: AirportInfoUpdateOutput;
  archiveContactStation: ContactStationUpdateOutput;
  archiveDriver: UpdateDriverOutput;
  archiveOrganization: ArchiveOrganizationOutput;
  archivePackageSpec: UpdatePackageSpecOutput;
  archivePerson: UpdatePersonOutput;
  archiveSchedulingRegion: UpdateSchedulingRegionOutput;
  archiveSchedulingResource: SchedulingResourceOutput;
  archiveTariffChain: ArchiveTariffChainOutput;
  archiveTariffZoneGroup: TariffZoneGroupArchiveOutput;
  archiveVehicleType: VehicleTypeUpdateOutput;
  /** Archive a warehouse employee (TMS-1562): the employee can no longer log in and their phone number is released for reuse by a new employee. Their existing mobile sessions are revoked. */
  archiveWarehouseEmployee: UpdateWarehouseEmployeeOutput;
  arriveAtStop: StopEntity;
  arriveAtStops: ArriveAtStopsOutput;
  assignDockDoor: Array<DockDoorEntity>;
  assignHelperToRoute: Array<DriverOnRouteEntity>;
  assignInventoryItemsToStorageUnit: AssignInventoryItemsToStorageUnitOutput;
  assignOrderToLineHaulTrailer: Scalars['Boolean']['output'];
  assignOutboundReferenceNumbersToStorageUnits: AssignOutboundReferenceNumberToStorageUnitsOutput;
  attachMobileSignedDocumentToOrderAndReplaceOriginal: UploadMobileSignedDocumentOutput;
  /** Runs the v2 auto-routing pipeline for the calling company. dryRun controls whether the transaction commits. */
  autoCreateRoutesV2: AutoCreateRoutesV2Output;
  backfillContactCommunicationConfigs: Scalars['String']['output'];
  backfillFuelProfileDateRangeRates?: Maybe<Scalars['Float']['output']>;
  backfillItemGroups: Scalars['Boolean']['output'];
  /** Backfill order totals for orders that do not have a total amount stored. */
  backfillOrderTotals: BackfillOrderTotalsOutput;
  backfillSettlementDate: Scalars['Float']['output'];
  backfillTariffZoneGroups: Scalars['String']['output'];
  backfillTariffZoneGroupsForCompany: Scalars['String']['output'];
  batchAddShipmentsToInvoicesMultiple: Array<InvoiceEntity>;
  /** Closes one calendar day for every scheduling resource in the company except those exempted from it. TWO-PHASE when the day carries booked capacity: without confirmLiveClaims the call writes NOTHING and returns CompanySchedulingDayLiveClaimsOutput naming what would be closed over, and sending the same input again with confirmLiveClaims applies it. A day carrying no claims is closed on the first call. The claims are neither cancelled nor moved either way. Closing a day that is already closed replaces its reason, keeps the exemptions already granted, and needs no confirmation. */
  blockCompanySchedulingDay: CompanySchedulingBlockedDayOutput;
  blockSchedulingResourceDay: SchedulingResourceOutput;
  /** Book the chosen appointment window, or move an existing booking onto it. Idempotent under double submission. A window that filled while the customer was choosing is refused with a fresh list of alternatives rather than an error. */
  bookCustomerAppointment: BookCustomerAppointmentOutput;
  bulkChangeCallStatus: Scalars['Float']['output'];
  bulkConfirmAppointments: Scalars['Float']['output'];
  /** Queues one full delegation offer per order to a partner and returns the batch to poll with bulkDelegationBatch. */
  bulkDelegateOrders: BulkDelegationBatchEntity;
  bulkDeletePieces: BulkPiecesActionOutput;
  bulkDiscardPieces: BulkPiecesActionOutput;
  bulkEditOrders: BulkEditOrdersResponse;
  bulkRestorePieces: BulkPiecesActionOutput;
  bulkUnconfirmAppointments: Scalars['Int']['output'];
  bulkUpdateAccessorialMappings: Array<AccessorialUnion>;
  bulkUpdateContactQuickbooksIds: Array<CustomerContactEntity>;
  bulkUploadRouteNames: Array<RouteNameEntity>;
  calculateRouteEtas: Array<EtaEntity>;
  callStops: Array<StopEntity>;
  calmAddStopToRoute: Scalars['Boolean']['output'];
  calmAssignLineHaulRoute: AssignLineHaulRouteOutput;
  calmAssignPackagesToManifest: Scalars['Boolean']['output'];
  calmLoadOrdersOnManifest: Scalars['Boolean']['output'];
  calmMoveOrderBetweenRuns: Scalars['Boolean']['output'];
  calmRemovePackagesFromManifest: Scalars['Boolean']['output'];
  calmRepointOrderFreight: RepointOrderFreightEntity;
  calmSaveManifestPlacements: CalmSavePlacementsResultEntity;
  calmSetCrossdockInstruction: Scalars['Boolean']['output'];
  calmSetPndRouteDriver: Scalars['Boolean']['output'];
  cancelDocExtractionEvalRun: DocExtractionCancelEvalRunResultEntity;
  cancelPackingPendency: CancelPackingPendencyOutput;
  chooseAppointmentOption: ChooseAppointmentOptionOutput;
  /** Clears a company. Only intended to be called via this Relay Workflow: https://run.relay.app/workflows/cm2dz61pm03eo0qlx5tb43i1q/edit. Accordingly, returns early to avoid Relay timing out. */
  clearCompany: Scalars['Int']['output'];
  clearCompanyContacts: ClearCompanyContactsOutput;
  clearDriverSettlementPayBound: Array<DriverSettlementPayBoundEntity>;
  clearOrderExecutedBy: Scalars['Boolean']['output'];
  clearOrderMirrorOutbox: Scalars['Int']['output'];
  cloneSavedFilterView: SavedFilterViewEntity;
  closeInventoryCount: CloseInventoryCountOutput;
  completeRebill: CompleteRebillOutput;
  completeStopBulk: Array<StopEntity>;
  completeStopV2: CompleteStopOutput;
  completeWorkOrderLoading: CompleteWorkOrderLoadingOutput;
  confirmInventoryCountLines: ConfirmInventoryCountLinesOutput;
  confirmQuoteAcceptance: ConfirmQuoteAcceptanceOutput;
  connectToQuickbooksDesktop: Scalars['String']['output'];
  createAccessorial: AccessorialUnion;
  createAccessorialContact: CreateAccessorialContactOutput;
  createAccessorialDateRangeConfig: CreateAccessorialDateRangeConfigOutput;
  createAccessorialGroup: AccessorialGroupEntity;
  createAccessorialToQuickbooksMapping: AccessorialToQuickbooksMappingEntity;
  createAccountingReportDocument: CreateAccountingReportDocumentOutput;
  createAddress: AddressEntity;
  createAdjustmentStopDriverMap?: Maybe<StopDriverMapEntity>;
  createAirportInfo: AirportInfoEntity;
  createApiUser: ApiUserEntity;
  createAppointmentsForRoute: RouteEntity;
  createAutoApplyAccessorialConfig: AutoApplyAccessorialConfigEntity;
  createBusinessDivision: CreateBusinessDivisionOutput;
  createCompany: CompanyEntity;
  createConsolidatedOrder: OrderEntity;
  createConsolidatedOrderFromOrder: OrderEntity;
  createContactComment: ContactCommentEntity;
  /** @deprecated Use updateContactEmails instead. */
  createContactCommunicationConfig: ContactCommunicationConfigEntity;
  createContactDocument: DocumentEntity;
  /** @deprecated Should be used only for invoice subscriptions. Use updateContactEmails for order update subscriptions. */
  createContactEmail?: Maybe<ContactEmailEntity>;
  createContactPerson: ContactPersonEntity;
  createContactStation: ContactStationCreateOutput;
  createCoverSheetDocumentTypeSequence: CoverSheetDocumentTypeSequenceEntity;
  createCreditType: CreditTypeEntity;
  createCsvOrderFieldMapping: CsvOrderFieldMappingEntity;
  createCsvOrderImportTransaction: CsvOrderImportTransactionEntity;
  createCsvOrderMapping: CsvOrderMappingEntity;
  createCustomerContact: CustomerContactEntity;
  createCustomerContacts: CreateCustomerContactsOutput;
  createDispatchView: DispatchViewCreateOutput;
  createDocExtractionEvalRun: DocExtractionLaunchEvalRunResultEntity;
  createDocExtractionEvalSet: DocExtractionCreatedEvalSetEntity;
  createDocument: DocumentEntity;
  createDriver?: Maybe<DriverEntity>;
  createDriverCredentialType: DriverCredentialTypeEntity;
  createDriverInsurancePolicy: DriverComplianceEntity;
  createDriverSettlementBill: DriverSettlementBillEntity;
  createDriverSignableFormTemplate: DriverSignableFormTemplateEntity;
  createDriverTrainingRecord: DriverComplianceEntity;
  createDrivers: CreateDriversOutput;
  createDuplicateOrderForRebill: CreateDuplicateOrderForRebillOutput;
  createDwellTimeAlertConfig: DwellTimeAlertConfigEntity;
  createEODDocuments: Array<DocumentEntity>;
  createEdiPartnership: EdiPartnershipEntity;
  createEdiPartnershipServiceMappings: CreateEdiPartnershipServiceMappingsOutput;
  /** Use sparingly, not meant for regular use */
  createEdiTransaction: CreateEdiTransactionOutput;
  createEmailTransaction: CreateEmailTransactionOutput;
  createEmailTransactionLog: EmailTransactionLogEntity;
  createEndOfDayDocumentProcessingJob: EndOfDayDocumentProcessingJobEntity;
  createEquipment: EquipmentEntity;
  createEquipmentLicense: EquipmentLicenseEntity;
  createEquipments: CreateEquipmentsOutput;
  createFeatureFlag: FeatureFlagEntity;
  createFeatureFlagCompanyOverride: FeatureFlagCompanyOverrideEntity;
  createFeatureFlagUserOverride?: Maybe<FeatureFlagUserOverrideEntity>;
  createFreightCharge: FreightChargeEntity;
  createFuelProfile?: Maybe<FuelProfileEntity>;
  createFuelProfileDateRange: CreateFuelProfileDateRangeOutput;
  createGeneralLedgerCode: CreateGeneralLedgerCodeOutput;
  createGeneralLedgerConfiguration: GeneralLedgerConfigurationEntity;
  createHoldReason: HoldReasonEntity;
  createImportedOrderTypeMapping: ImportedOrderTypeMappingEntity;
  createImportedOrderTypeMappings: Array<ImportedOrderTypeMappingEntity>;
  createIngestionTestUpload: IngestionTestUploadEntity;
  /** @deprecated Deprecated. Use upsertItemGroup instead */
  createInventoryItems: CreateInventoryItemsOutput;
  createInventoryPrimaryUnitOfMeasure: InventoryPrimaryUnitOfMeasureEntity;
  createInventorySecondaryUnitOfMeasure: InventorySecondaryUnitOfMeasureEntity;
  createInvoice: InvoiceEntity;
  createInvoiceDocument: DocumentEntity;
  createInvoiceDocuments: Array<DocumentEntity>;
  createInvoiceNoteRule: InvoiceNoteRuleEntity;
  createInvoiceTerms: InvoiceTermEntity;
  createInvoiceTermsForAll: Scalars['Boolean']['output'];
  createItem: CreateItemOutput;
  createItemLocation: CreateItemLocationOutput;
  createLeg: LegEntity;
  /** This is probably not the method you want to use */
  createLegDriverMap: LegDriverMapEntity;
  createLineHaulLane: CreateLineHaulLaneOutput;
  createLineHaulManifest: LineHaulManifestEntity;
  createLineHaulManifests: CreateLineHaulManifestsOutput;
  createLineHaulSegment: CreateLineHaulSegmentOutput;
  createLineHaulTruckRuns: Scalars['Int']['output'];
  createManyReferenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  createMasterAccount: CreateMasterAccountOutput;
  createMirrorTarget: MirrorTargetEntity;
  createNotification: NotificationEntity;
  createOrUpdateCsvOrders: CreateOrUpdateCsvOrdersOutput;
  createOrderComment: OrderCommentEntity;
  createOrderDelegationRule: OrderDelegationRuleEntity;
  createOrderDocument: DocumentEntity;
  createOrderDocumentDocument: CreateOrderDocumentDocumentOutput;
  createOrderImportConfiguration: OrderImportConfigurationEntity;
  createOrderLineHaulSegment: OrderLineHaulSegmentEntity;
  createOrderSnapshot?: Maybe<OrderEventEntity>;
  createOrderTableReport: CreateOrderTableReportOutput;
  createOrdersFromRecurringTemplates: Array<OrderEntity>;
  createOrganization: CreateOrganizationOutput;
  createOrganizationMessage: OrganizationMessageEntity;
  createOrganizationPeer: OrganizationPeerEntity;
  createOutboundBenchOrders: BenchCreatedOrdersEntity;
  createOutlookIntegration: OutlookIntegrationEntity;
  createPODReportDocument: CreatePodReportDocumentOutput;
  /** @deprecated Do not create packages directly */
  createPackage: PackageEntity;
  createPackageSpec: CreatePackageSpecOutput;
  createPackingPendency: CreatePackingPendencyOutput;
  createPayment: PaymentEntity;
  createPdfColumn: PdfColumnEntity;
  createPermission: CreatePermissionOutput;
  createPerson: CreatePersonOutput;
  /** @deprecated Use upsertPicklist instead */
  createPicklist: UpsertPicklistOutput;
  createPiece: PieceEntity;
  createPieceDocument: DocumentEntity;
  createPieceReceipt: CreatePieceReceiptOutput;
  /** Creates one or more orphan pieces (no parent order) under the same barcode. Returns the created pieces in order. */
  createPieceWithoutOrder: Array<PieceEntity>;
  createPlace: PlaceEntity;
  createProratedConsolidatedOrder: CreateProratedConsolidatedOrderOutput;
  createQuickbooksHeaderFileMapping: QuickbooksHeaderFileMappingEntity;
  createQuote: QuoteEntity;
  createQuoteAgentForwardingAddress: CreateQuoteAgentForwardingAddressOutput;
  createRecurringLineHaulManifestTemplate: RecurringLineHaulManifestTemplateEntity;
  createRecurringOrderFrequency: RecurringOrderFrequencyEntity;
  createRecurringOrdersFromTemplates: Scalars['Boolean']['output'];
  createRecurringTemplateTruck: RecurringTemplateTruckEntity;
  createReportGroupConfiguration: ReportGroupConfigurationEntity;
  createReverseOrder: OrderEntity;
  createRole: CreateRoleOutput;
  createRoute: RouteEntity;
  /** This is probably not the API you want to use */
  createRouteDriver: RouteDriverEntity;
  createRouteFromRouteTemplate: CreateRouteFromRouteTemplateOutput;
  createRouteName: RouteNameEntity;
  createRouteNameLocation: RouteNameLocationEntity;
  createRouteOptimization: RouteOptimizationEntity;
  createRoutePaths: Array<Maybe<RoutePathEntity>>;
  createRouteSlot: Array<Maybe<RouteSlotEntity>>;
  createRoutes: Array<RouteEntity>;
  createRun: CreateRunOutput;
  createSameDayDispatchConfig: SameDayDispatchConfigEntity;
  createSamsaraOauthToken: SamsaraOauthTokenEntity;
  /** Development-only route for creating sandbox routes for a driver */
  createSandboxRouteForDriver?: Maybe<Scalars['Boolean']['output']>;
  createSavedFilterView: SavedFilterViewEntity;
  createScannedOrders: Array<Scalars['String']['output']>;
  createScannedOrdersFromAdmin: Array<ScannedOrderFromAdminCreateOutput>;
  createSchedulingRegion: CreateSchedulingRegionOutput;
  createSchedulingResource: SchedulingResourceOutput;
  createSchedulingZone: CreateSchedulingZoneOutput;
  createSchema: Scalars['String']['output'];
  createSchemaCompanyMapping: Scalars['String']['output'];
  createSchemaDocument: SchemaDocumentEntity;
  createSchemaTestSnapshot: Scalars['String']['output'];
  createService: ServiceEntity;
  createServiceGroup: ServiceGroupEntity;
  /** Creates new service regions for the current company. Automatically removes duplicate regions with the same name from the input. Existing regions remain unchanged. */
  createServiceRegions: CreateServiceRegionsOutput;
  createSettlementAdjustment: CreateOrUpdateSettlementAdjustmentOutput;
  /** @deprecated Deprecated during Robust Settlement Project. Use `createSettlementAdjustment` instead */
  createSettlementDeduction: SettlementDeductionEntity;
  createSettlementDeductionType: SettlementDeductionTypeEntity;
  createSftpCredentials: CreateSftpCredentialsOutput;
  createShipmentDocument: DocumentEntity;
  createStandardOrder: StandardOrderEntity;
  createStandardOrderFields: StandardOrderFieldsEntity;
  createStandardOrderWithDuplicateResolution: StandardOrderEntity;
  createStandardShipmentFields: StandardShipmentFieldsEntity;
  createStorageOrder: CreateStorageOrderOutput;
  createStorageOrderDocument: CreateStorageOrderDocumentOutput;
  createStorageUnit: CreateStorageUnitOutput;
  /** @deprecated Deprecated. Use createStorageUnit instead */
  createStorageUnitWithInventoryItems: CreateStorageUnitWithInventoryItemsOutput;
  createTag: TagEntity;
  createTariff: CreateTariffOutput;
  createTariffChain: CreateTariffChainOutput;
  createTariffGroup: TariffGroupEntity;
  createTariffLocation: CreateTariffLocationOutput;
  createTariffZone: TariffZoneEntity;
  createTariffZoneGroup: TariffZoneGroupCreateOutput;
  /** @deprecated Use createTerminalV2 instead */
  createTerminal: CreateTerminalOutput;
  createTerminalLanes: CreateTerminalLanesOutput;
  /** @deprecated Deprecating because we are removing zip+city uniqueness constraint and this is not used by the frontend. Use createTerminalServiceAreasV2 instead */
  createTerminalServiceArea: TerminalServiceAreaEntity;
  /** @deprecated Deprecating because we are removing zip+city uniqueness constraint. Use createTerminalServiceAreasV2 instead */
  createTerminalServiceAreas: Array<CreateTerminalServiceAreaOutput>;
  createTerminalServiceAreasV2: CreateTerminalServiceAreaV2Output;
  createTerminalV2: CreateTerminalV2Output;
  createTerminals: Scalars['Int']['output'];
  createTestAbstainedScannedOrder: CreateTestAbstainedScannedOrderOutput;
  createTestAccessorial: CreateTestAccessorialOutput;
  createTestApiOrder: TestApiOrderResult;
  createTestCompany: CreateTestCompanyOutput;
  createTestContact: CreateTestContactOutput;
  createTestDelegatableOrder: CreateTestDelegatableOrderOutput;
  createTestEdiOrder: TestEdiOrderResult;
  createTestOrder: CreateTestOrderOutput;
  createTestOrderCustomCharge: CreateTestOrderCustomChargeOutput;
  createTestOrderDelegation: CreateTestOrderDelegationOutput;
  createTestOrderQuote: CreateTestOrderQuoteOutput;
  createTestOrderV2: CreateTestOrderResponse;
  createTestOrganizationPeer: CreateTestOrganizationPeerOutput;
  createTestPiecesOnOrder: CreateTestPiecesOutput;
  createTestReviewOrder: CreateTestReviewOrderOutput;
  createTestTerminalLane: Scalars['Boolean']['output'];
  createTestThirdPartyUser: CreateTestThirdPartyUserOutput;
  createTestUser?: Maybe<UserEntity>;
  createThirdPartyBroker: ThirdPartyBrokerEntity;
  createUser?: Maybe<UserEntity>;
  createUserV2: CreateUserOutput;
  createVehicleType: VehicleTypeEntity;
  createWarehouse: WarehouseEntity;
  createWarehouseEmployee: CreateWarehouseEmployeeOutput;
  createWarehouseLocation: CreateWarehouseLocationOutput;
  deactivateTestTerminal: Scalars['Boolean']['output'];
  /** Tell the carrier that none of the offered times work, which hands the shipment to the scheduling team. When an appointment was already booked through this link, this cancels it: the capacity is released and the access notes are cleared. */
  declineCustomerAppointmentOptions: CustomerAppointmentAcknowledgementResult;
  declineOrderDelegation: DelegatedOrderInboxItemEntity;
  declineQuote: DeclineQuoteOutput;
  delete: CsvOrderImportTransactionEntity;
  deleteAccessorialDateRangeConfig: AccessorialDateRangeConfigEntity;
  deleteAccessorialGroup: Scalars['Boolean']['output'];
  deleteAccessorialRange: AccessorialRangeEntity;
  deleteAutoApplyAccessorialConfig: Scalars['Boolean']['output'];
  deleteContactComment: DeleteContactCommentOutput;
  deleteContactEmail: ContactEmailEntity;
  deleteCsvOrderFieldMapping: CsvOrderFieldMappingEntity;
  deleteCustomDocumentName: CustomDocumentNameEntity;
  deleteDocument?: Maybe<DocumentEntity>;
  deleteDrayageShipmentFields: StandardShipmentFieldsEntity;
  /** Deletes a custom type no driver record uses. Built-in types cannot be deleted, and a type in use can only be deactivated. */
  deleteDriverCredentialType: Scalars['Boolean']['output'];
  deleteDriverInsurancePolicy: DriverComplianceEntity;
  deleteDriverSignableFormTemplate: DriverSignableFormTemplateEntity;
  deleteDriverTrainingRecord: DriverComplianceEntity;
  deleteDwellTimeAlertConfig: Scalars['Boolean']['output'];
  deleteEdiPartnershipReferenceMappings: DeleteEdiTypedReferenceMappingsOutput;
  deleteEdiPartnershipServiceMappings: DeleteEdiPartnershipServiceMappingsOutput;
  deleteEquipment: EquipmentEntity;
  deleteFeatureFlagCompanyOverride: FeatureFlagCompanyOverrideEntity;
  deleteFeatureFlagUserOverride: FeatureFlagUserOverrideEntity;
  deleteFreightCharge: FreightChargeEntity;
  deleteFuelProfileDateRange: DeleteFuelProfileDateRangeOutput;
  deleteGeneralLedgerCode: DeleteGeneralLedgerCodeOutput;
  deleteInventoryCount: DeleteInventoryCountOutput;
  /** @deprecated Deprecated. Use upsertItemGroup instead */
  deleteInventoryItems: DeleteInventoryItemsOutput;
  deleteInvoiceNoteRule: InvoiceNoteRuleEntity;
  /** This is probably not the method you want to use */
  deleteLegDriverMap: LegDriverMapEntity;
  deleteMirrorTarget: Scalars['Boolean']['output'];
  deleteOrder?: Maybe<OrderEntity>;
  deleteOrderComment: DeleteOrderCommentOutput;
  deleteOrderDelegationRule: Scalars['Boolean']['output'];
  deleteOrphanPiece: PieceEntity;
  deletePackage: PackageEntity;
  deletePayment: PaymentEntity;
  deletePermission: DeletePermissionOutput;
  deletePieceReceipt: DeletePieceReceiptOutput;
  deleteQuickbooksHeaderFileMapping: QuickbooksHeaderFileMappingEntity;
  deleteQuote?: Maybe<QuoteEntity>;
  deleteRecurringLineHaulManifestTemplate: Scalars['String']['output'];
  deleteRecurringTemplateTruck: Scalars['String']['output'];
  deleteReportGroupConfiguration: ReportGroupConfigurationEntity;
  deleteRole: DeleteRoleOutput;
  deleteRouteNameLocation: RouteNameLocationEntity;
  deleteSameDayDispatchConfig: SameDayDispatchConfigEntity;
  deleteSavedFilterView: SavedFilterViewEntity;
  deleteSchema?: Maybe<Scalars['String']['output']>;
  deleteSchemaCompanyMapping: Scalars['String']['output'];
  deleteSchemaDocument?: Maybe<Scalars['String']['output']>;
  deleteSchemaRun: Scalars['String']['output'];
  deleteServiceGroup: Scalars['Boolean']['output'];
  deleteSlotsFromRoute?: Maybe<Scalars['Int']['output']>;
  deleteStandardOrder?: Maybe<StandardOrderEntity>;
  deleteStandardOrderFields: StandardOrderFieldsEntity;
  deleteStopAttempt: DeleteStopAttemptOutput;
  deleteStopDriverMap: StopDriverMapEntity;
  deleteStorageOrder: DeleteStorageOrderOutput;
  /** Deletes storage orders and all associated entities such as audit log entries, storage units, and pick ticket items */
  deleteStorageOrders: DeleteStorageOrdersOutput;
  deleteStorageUnit: DeleteStorageUnitOutput;
  deleteStuckSendingEmailTransactions?: Maybe<Scalars['Float']['output']>;
  deleteTag: TagEntity;
  deleteTariff: TariffEntity;
  deleteTariffGroup: TariffGroupEntity;
  deleteTariffLocation: DeleteTariffLocationOutput;
  deleteTariffRange: TariffRangeEntity;
  deleteTariffZone: TariffZoneEntity;
  deleteTariffZones: Scalars['String']['output'];
  deleteTariffs: Array<TariffEntity>;
  deleteTerminalLanes: DeleteTerminalLanesOutput;
  /** Deletes all warehouse locations for a company that are not associated with a storage unit, inventory item, package, piece, or item group. */
  deleteUnusedWarehouseLocations: Scalars['Int']['output'];
  deleteUser?: Maybe<UserEntity>;
  deleteWarehouse: WarehouseEntity;
  deleteWarehouseLocation: DeleteWarehouseLocationOutput;
  deselectRole?: Maybe<LoginPhoneOutput>;
  detachDocumentFromShipment: DocumentEntity;
  detachDocumentsFromShipments: Array<DocumentEntity>;
  disconnectQuickbooks: Scalars['Boolean']['output'];
  dismissCompletedScannedOrderResults: Scalars['Int']['output'];
  dismissDelegationAccessorialProposal: DelegationAccessorialProposalEntity;
  dismissOrganizationMessage: Scalars['Boolean']['output'];
  dismissQuote: DismissQuoteOutput;
  dismissScannedOrderResult: ScannedOrderResultEntity;
  dispatchApplySuggestedManifests: DispatchApplySuggestedManifestsOutput;
  dispatchTextDriver: DispatchTextDriverOutput;
  documentationAdminCreateItem: DocumentationItemEntity;
  documentationAdminCreateTopic: DocumentationTopicEntity;
  documentationAdminDeleteItem: Scalars['Boolean']['output'];
  documentationAdminDeleteTopic: Scalars['Boolean']['output'];
  documentationAdminReorder: Scalars['Boolean']['output'];
  documentationAdminUpdateItem: DocumentationItemEntity;
  documentationAdminUpdateTopic: DocumentationTopicEntity;
  downloadInvoices: DownloadInvoicesOutput;
  driverSettlementBillExportPdf: ReportFileOutput;
  driverSettlementBillExportZip: ReportFileOutput;
  duplicateEdiPartnerships: DuplicateEdiPartnershipsOutput;
  duplicateTariffGroup: DuplicateTariffGroupOutput;
  editContacts: EditContactsOutput;
  emailAccountingReport: EmailAccountingReportOutput;
  emailOrderDocument: EmailOrderDocumentOutput;
  estimateDocExtractionEvalRun: DocExtractionEvalRunCostEstimateEntity;
  /** Executes an OPEN packing pendency by packing or unpacking its covered pieces (via packPieces / unpackPieces). Allowed when the pendency is unassigned or assigned to the acting warehouse employee. `warehouseUuid` must match the pendency's warehouse, but it is a consistency check on the caller's context rather than an authorization boundary: warehouse employees have no warehouse membership relation, so any employee in the tenant can satisfy it. */
  executePackingPendency: ExecutePackingPendencyOutput;
  /** Lets one scheduling resource keep running on a day the company is closed. Waives the COMPANY closure only: a resource that also carries a blocked day of its own for that date stays closed. Refused when the company has not blocked the day. */
  exemptSchedulingResourceFromCompanyBlockedDay: CompanySchedulingBlockedDayOutput;
  expireQuoteAgentPreviousForwardingToken: ExpireQuoteAgentPreviousForwardingTokenOutput;
  exportInvoicesToQuickbooksDesktop: Array<ExportQuickbooksResult>;
  /** Do not use for FF_ROBUST_SETTLEMENT. Use finalizeSettlementBills instead. */
  finalizeDriverSettlementBills: Scalars['Float']['output'];
  finalizeInvoices: FinalizeInvoicesOutput;
  finalizeOrder: OrderEntity;
  finalizeOrders: FinalizeOrdersOutput;
  /** If FF_ROBUST_SETTLEMENT is enabled, will create a snapshot for each bill and finalize the bill. */
  finalizeSettlementBills: FinalizeSettlementBillsOutput;
  fireOutboundBenchTransaction: BenchFireResultEntity;
  flipIsArchived: AccessorialUnion;
  generateAccountingReportPreSignedPutUrl: Scalars['String']['output'];
  generateClearCompanyContactsToken: GenerateClearCompanyContactsTokenOutput;
  generateContactPreSignedPutUrl: GeneratePreSignedPutUrlOutput;
  generateHistoricalInvoicesCsv: GenerateHistoricalInvoicesCsvOutput;
  generateInvoicePreSignedPutUrl: Scalars['String']['output'];
  generateInvoicePreSignedPutUrls: Array<GenerateInvoicePreSignedPutUrlOutput>;
  generateLabel: Scalars['String']['output'];
  generateLineHaulRuns: GenerateLineHaulRunsOutput;
  generateMobileSignedDocumentPreSignedPutUrl: Scalars['String']['output'];
  generateOrderDocumentPreSignedPutUrl: Scalars['String']['output'];
  generateOrderPreSignedGetAndPutUrls: GenerateOrderPreSignedGetAndPutUrlsOutput;
  generateOrderPreSignedPutUrl: Scalars['String']['output'];
  generatePiecePreSignedPutUrl: Scalars['String']['output'];
  generatePodReportPreSignedPutUrl: Scalars['String']['output'];
  generatePreSignedPutUrl: Scalars['String']['output'];
  generateReferenceIds: Array<Scalars['String']['output']>;
  generateResetCompanyToken: GenerateResetCompanyTokenOutput;
  generateShipmentPreSignedPutUrl: Scalars['String']['output'];
  generateStorageOrderPreSignedPutUrl: GenerateStorageOrderPreSignedPutUrlOutput;
  handleMultipleInvoices210Outbound: Scalars['Boolean']['output'];
  importCrownAccessorial: ImportCrownAccessorialOutput;
  /** Calls importCrownContactsV3 */
  importCrownContactsV2: Array<Scalars['String']['output']>;
  importCrownDrivers: ImportCrownDriversOutput;
  importCrownInvoices: ImportCrownInvoicesOutput;
  importCrownLanes: ImportCrownLanesOutput;
  importCrownOrders: ImportCrownOrdersOutput;
  importCrownPayments: ImportCrownPaymentsOutput;
  importCrownTariff: ImportCrownTariffOutput;
  importCrownUsers: ImportCrownUsersOutput;
  importCustomerDefaultAddresses: Array<Scalars['String']['output']>;
  importQuickbooksDesktopMappings: Array<Scalars['String']['output']>;
  importRecoveryTerminal: ImportRecoveryTerminalOutput;
  importStorageOrdersFromCSV: ImportStorageOrdersFromCsvOutput;
  importTerminalServiceAreas: Scalars['Int']['output'];
  importTestSnapshot: Scalars['String']['output'];
  importThirdPartyPortalAccountEmails: Array<Scalars['String']['output']>;
  importWarehouseLocationsFromCsv: Scalars['Int']['output'];
  initiateDelegatedOrderReview: InitiateDelegatedOrderReviewOutput;
  kpiRecordTableDownload: KpiRecordTableDownloadOutput;
  /** @deprecated Use linkPieceToOrderWithRole instead */
  linkPieceToOrder: PieceEntity;
  linkPieceToOrderWithRole: PieceEntity;
  linkPieceToPackage: PackageHasPieceEntity;
  linkPiecesToPackage: LinkPiecesToPackageOutput;
  logUnassignedScan: ScanEntity;
  login?: Maybe<LoginOutput>;
  loginInternal?: Maybe<LoginOutput>;
  loginPhone?: Maybe<LoginPhoneOutput>;
  /** @deprecated use loginPhoneJwtV2 instead */
  loginPhoneJwt?: Maybe<LoginPhoneOutput>;
  loginPhoneJwtV2?: Maybe<LoginPhoneOutput>;
  loginPhoneV2?: Maybe<LoginPhoneOutput>;
  logout: Scalars['Boolean']['output'];
  /** Make a decision to confirm an appointment or to request it to be rescheduled */
  makeAppointmentConfirmationDecision: MakeAppointmentConfirmationDecisionOutput;
  manuallySetInvoicesQbSyncStatus: Scalars['Boolean']['output'];
  mapPeerAccessorial: IncomingPeerAccessorialMappingEntity;
  mapPeerService: IncomingPeerServiceMappingEntity;
  markAllInAppNotificationsRead: Scalars['Int']['output'];
  markAsCancelled: OrderEntity;
  markAsOnHold: OrderEntity;
  /** Mark an attempted stop as complete */
  markAttemptedStopAsComplete: StopEntity;
  markConsolidatableOrdersAsBilledIndividually: Array<OrderEntity>;
  markManifestAsArrived: MarkManifestAsArrivedOutput;
  markManifestAsDeparted: MarkManifestAsDepartedOutput;
  markManifestAsDoorsClosed: MarkManifestAsDoorsClosedOutput;
  markManifestAsPlanning: MarkManifestAsPlanningOutput;
  /** @deprecated Deprecated. Use piece-level damage and automatic issue flags instead. */
  markNotOsd: OrderEntity;
  markNotificationRead: Scalars['Boolean']['output'];
  markOrderAsCompleteForce: OrderEntity;
  markOrderAsHasBillingIssue: OrderEntity;
  markOrderAsNotComplete: OrderEntity;
  markOrderAsNotOnHand: OrderEntity;
  markOrderAsNotReadyToInvoice: OrderEntity;
  markOrderAsNotReceivedAtOrigin: OrderEntity;
  markOrderAsOnHand: OrderEntity;
  markOrderAsPicked: OrderEntity;
  markOrderAsReadyToInvoice: OrderEntity;
  /** @deprecated This marks an order as complete, not finalized. Use markOrderAsCompleteForce instead */
  markOrderAsReadyToInvoiceForce: OrderEntity;
  markOrderAsReceivedAtOrigin: OrderEntity;
  markOrderAsRefused: MarkOrderAsRefusedOutput;
  /** @deprecated Deprecated. Use piece-level damage and automatic issue flags instead. */
  markOsd: OrderEntity;
  markPieceDamaged: PieceEntity;
  markQuoteSent: MarkQuoteSentOutput;
  markStopAsFailed: StopEntity;
  markStopAsFailedV2: StopEntity;
  markStopAsIncomplete: StopEntity;
  markStorageUnitAsBilled: MarkStorageUnitAsBilledOutput;
  markStorageUnitAsOsd: MarkStorageUnitAsOsdOutput;
  markStorageUnitOnHand: MarkStorageUnitOnHandOutput;
  markTestOrderForEdiReview: Scalars['Boolean']['output'];
  markTutorialSeen: Array<TutorialId>;
  markWarehouseAsDefault: WarehouseEntity;
  matchFreightSnap?: Maybe<FreightSnapTransactionEntity>;
  matchSignedPODs: Scalars['Boolean']['output'];
  mergeEdiOrder: MergeEdiOrderOutput;
  mergeScannedOrderResultIntoPossibleDuplicate: ScannedOrderResultEntity;
  migrateToAccessorialContacts: Scalars['Boolean']['output'];
  moveShipmentsBetweenInvoices: MoveShipmentsBetweenInvoicesOutput;
  moveShipmentsToInvoice: MoveShipmentsToInvoiceOutput;
  normalizeDocument: Scalars['String']['output'];
  offboardCompanyFromQuoteAgent: OffboardCompanyFromQuoteAgentOutput;
  openMessageInOutlook: OpenMessageInOutlookOutput;
  optimizeRouteSequence: OptimizeRouteSequenceResult;
  optimizeRoutesTogether: OptimizationPending;
  /** Nests the selected pieces under a newly created parent piece of the given type (pack/unpack v2). All selected pieces must belong to the same order or all be orderless. */
  packPieces: PieceEntity;
  parseCsvOrders: ParseCsvOrdersOutput;
  pickQuoteCustomer: PickQuoteCustomerOutput;
  pickStorageUnit: PickStorageUnitOutput;
  previewDocExtractionEvalSet: DocExtractionEvalSetPreviewEntity;
  prorateOrders: ProrateOrdersOutput;
  publishOrganizationMessage: OrganizationMessageEntity;
  queueAppointmentSchedulingProposals: QueueAppointmentSchedulingProposalsOutput;
  /** Queue appointment texts for all stops according to the UUIDs provided */
  queueAppointmentTexts: QueueAppointmentTextsOutput;
  reactivateUser: UserEntity;
  reanalyzePage: Scalars['Boolean']['output'];
  reanalyzeSchemaFile: Scalars['Boolean']['output'];
  reassignRouteSlot?: Maybe<Array<RouteEntity>>;
  reconfigureDriverSettlementPayTerms: ReconfigureDriverSettlementPayTermsOutput;
  recordContactAttempted: Scalars['Int']['output'];
  recordInboundReviewDecisions: Scalars['Boolean']['output'];
  recordInventoryCountUnexpected: RecordInventoryCountUnexpectedOutput;
  recreateScannedOrderForEmailAttachment: Scalars['Boolean']['output'];
  refreshAuthToken: RefreshAuthTokenOutput;
  refreshEtasForRoute: Array<EtaEntity>;
  /** Restores a terminated driver, clears the termination and sets the new hire date. */
  rehireDriver: DriverComplianceEntity;
  rejectCustomerPortalOrder: RejectCustomerPortalOrderOutput;
  rejectDelegationEndCustomerLink: OrderDelegationEntity;
  rejectEdiOrder: RejectEdiOrderOutput;
  rejectEdiOrders: RejectEdiOrdersOutput;
  /** Reject an Expeditors work order and notify their API */
  rejectExpeditorsWorkOrder: Scalars['Boolean']['output'];
  rejectQuoteReply: RejectQuoteReplyOutput;
  removeAccessorial: AccessorialUnion;
  removeAddress: AddressEntity;
  removeApiUserContactMapping: ApiUserEntity;
  removeBusinessDivision: BusinessDivisionEntity;
  removeCompany: CompanyEntity;
  removeContact?: Maybe<ContactEntity>;
  removeContactPerson: ContactPersonEntity;
  removeContacts: RemoveContactsOutput;
  removeCoverSheetDocumentTypeSequence: CoverSheetDocumentTypeSequenceEntity;
  removeCreditType: CreditTypeEntity;
  removeDispatchView: DispatchViewEntity;
  removeDriver: DriverEntity;
  removeDriverSettlementBill: DriverSettlementBillEntity;
  removeDriversFromRoute: Scalars['Int']['output'];
  removeEmailTransactionLog: EmailTransactionLogEntity;
  removeFeatureFlag: FeatureFlagEntity;
  removeFuelProfile: FuelProfileEntity;
  removeGeneralLedgerCode: GeneralLedgerCodeEntity;
  removeGeneralLedgerConfiguration: GeneralLedgerConfigurationEntity;
  removeHelperFromRoute: Scalars['String']['output'];
  removeHoldReason: HoldReasonEntity;
  removeImportedOrderTypeMapping: ImportedOrderTypeMappingEntity;
  removeInvoice: InvoiceEntity;
  removeInvoiceTerms: InvoiceTermEntity;
  removeLineHaulLane: LineHaulLaneEntity;
  removeLineHaulManifest: Scalars['String']['output'];
  removeLineHaulSegment: LineHaulSegmentEntity;
  /** Given lists of settlement bill line items, will disconnect them from the bills they are associated with and trigger any side effects */
  removeLineItemsFromSettlementBill: RemoveLineItemsFromSettlementBillOutput;
  removeMasterAccount: MasterAccountEntity;
  /** Removes the stored company Motive API key. */
  removeMotiveApiKey: MotiveIntegrationEntity;
  removeOrderHold: OrderEntity;
  removeOrderLineHaulSegment: OrderLineHaulSegmentEntity;
  /** @deprecated Use removeOrdersFromManifestV2 instead */
  removeOrdersFromManifest: AddOrdersToManifestOutput;
  removeOrdersFromManifestV2: RemoveOrdersFromManifestV2Output;
  removePaymentOffset: PaymentToPaymentMappingEntity;
  removePiecesFromPieceReceipt: RemovePiecesFromPieceReceiptOutput;
  removeRoute: RouteEntity;
  /** This is probably not the API you want to use */
  removeRouteDriver: RouteDriverEntity;
  /** Puts an exempted scheduling resource back under a company closure, which CLOSES that day for it again. Removing an exemption that was never granted succeeds and changes nothing. */
  removeSchedulingResourceCompanyBlockedDayExemption: CompanySchedulingBlockedDayOutput;
  removeService: ServiceEntity;
  removeServiceToContact: ServiceEntity;
  removeSettlementAdjustment: SettlementAdjustmentEntity;
  /** @deprecated Deprecated during Robust Settlement Project. Use `removeSettlementAdjustment` instead */
  removeSettlementDeduction: SettlementDeductionEntity;
  removeSettlementDeductionType: SettlementDeductionTypeEntity;
  removeShipmentsFromInvoice: Array<Maybe<ShipmentEntity>>;
  removeSpecialAccessorial: AccessorialUnion;
  removeStopsFromRoutes: Array<Scalars['String']['output']>;
  removeStorageUnitOnHand: RemoveStorageUnitOnHandOutput;
  removeStorageUnitOsd: RemoveStorageUnitOsdOutput;
  removeSubscriberFromShipment: ShipmentSubscriberEntity;
  removeTagFromLeg: TagEntity;
  removeTagFromOrder: TagEntity;
  removeTerminal: TerminalEntity;
  removeTerminalServiceArea: TerminalServiceAreaEntity;
  removeThirdPartyBroker: ThirdPartyBrokerEntity;
  removeThirdPartyUserFromContact: ThirdPartyUserEntity;
  removeUserFromRole: RemoveUserFromRoleOutput;
  /** @deprecated Use archive/restore instead of deleting */
  removeVehicleType: VehicleTypeEntity;
  removeZoneBasedAccessorial: AccessorialUnion;
  replayOutboundEdi: Scalars['Boolean']['output'];
  reportADocScanIssue: ReportADocScanIssueOutput;
  /** Send a fresh scheduling link to the phone number on file, for a link that has expired. The new token is NOT returned here: it is delivered out of band, so holding an expired link is not enough to keep renewing it. */
  requestCustomerAppointmentLink: CustomerAppointmentAcknowledgementResult;
  requestOrderMirrorSync: RequestOrderMirrorSyncOutput;
  requestQuoteReprice: RequestQuoteRepriceOutput;
  requoteQuoteAtCurrentPrice: RequoteQuoteAtCurrentPriceOutput;
  rerateOrderFreight: RerateOrderFreightOutput;
  rerateQuoteFreight: RerateQuoteFreightOutput;
  rescheduleOrganizationMessage: OrganizationMessageEntity;
  resendExternalTransmission: Scalars['Boolean']['output'];
  resendQuoteAgentCatalogSnapshot: Scalars['Boolean']['output'];
  resetCompany: ResetCompanyOutput;
  resolveOrganizationMessage: OrganizationMessageEntity;
  resolveQuoteReplySend: ResolveQuoteReplySendOutput;
  resolveScannedOrderBillingParty: ScannedOrderResultEntity;
  restoreAirportInfo: AirportInfoUpdateOutput;
  restoreContactStation: ContactStationUpdateOutput;
  restoreDriver: UpdateDriverOutput;
  restoreOrganization: RestoreOrganizationOutput;
  restorePackageSpec: UpdatePackageSpecOutput;
  /** Restore a person to the active status (un-archive) */
  restorePerson: UpdatePersonOutput;
  restoreSchedulingRegion: RestoreSchedulingRegionOutput;
  restoreSchedulingResource: SchedulingResourceOutput;
  restoreSchedulingZone: RestoreSchedulingZoneOutput;
  restoreTariffChain: RestoreTariffChainOutput;
  restoreTariffZoneGroup: TariffZoneGroupRestoreOutput;
  restoreVehicleType: VehicleTypeUpdateOutput;
  /** Restore an archived warehouse employee to the active status (un-archive). Fails with a conflict when the phone number has been reused by another live employee. */
  restoreWarehouseEmployee: UpdateWarehouseEmployeeOutput;
  retryAllFailedInvoice210OutboundsForCompany: RetryInvoice210OutboundResult;
  retryFailedInvoice210Outbound: RetryInvoice210OutboundResult;
  retryInvoiceSendJobBatches: InvoiceSendJobBatchEntity;
  retrySftpUploads: RetrySftpUploadsOutput;
  reuploadPods: Scalars['Boolean']['output'];
  revokeOrganizationPeer: OrganizationPeerEntity;
  rotateDocument: Scalars['String']['output'];
  rotateQuoteAgentForwardingToken: RotateQuoteAgentForwardingTokenOutput;
  runOptimization: RouteOptimizationEntity;
  runTestAccessorialDetection: Scalars['Boolean']['output'];
  samsaraDiscoveryRemoveToken: SamsaraDiscoveryStatusEntity;
  samsaraDiscoveryRunImport: SamsaraDiscoveryStatusEntity;
  /** Validates the token with Samsara, stores it encrypted and starts an import. */
  samsaraDiscoverySetToken: SamsaraDiscoveryStatusEntity;
  saveCostInputQuickbooksMappings: Array<CostInputQuickbooksAccountEntity>;
  saveCostInputSetup: CostInputStatusEntity;
  saveCostInputs: CostInputMonthEntity;
  savePointToPointLanes: SavePointToPointLanesOutput;
  /** Saves the SMC3 connection after SMC3 accepts it; a refusal saves nothing. */
  saveSmc3Settings: Smc3SettingsSaveResultEntity;
  saveTenediPartnership: TenediPartnershipSaveResultEntity;
  /** Used when the uuid of an order is known */
  scanOrder: OrderEntity;
  /** Scan an order barcode. If one result is found, will perform scan logic on the order. If multiple results are found, will return the results. If no results are found, will log an unassigned scan. */
  scanOrderBarcode: ScanOrderBarcodeOutput;
  /** @deprecated Use scanOrderBarcode or scanOrder */
  scanPiece: PieceEntity;
  scanWarehouseLocation: ScanWarehouseLocationOutput;
  /** Bulk-process pieces through the same scan path as selectPackage. Skips already-processed pieces (idempotent). */
  scanningV2__bulkProcessPieces: FreightScanningV2BulkProcessPiecesOutput;
  /** Slim piece-targeted commit for bounded work-order scanning (Inbound -> ARRIVED, Loading -> LOADED). Verifies work-order membership + transitions the piece + writes the Scan row synchronously, then defers the order/manifest/on-hand rollup to a background job. Idempotent (rescan / already-terminal no-ops). Rejects MOVE/DELIVERY/PICKUP. */
  scanningV2__commitWorkOrderScan: FreightScanningV2CommitWorkOrderScanOutput;
  /** Move multiple pieces to a warehouse location. Used after ORDER_RESOLVED state in MOVE mode. */
  scanningV2__moveWarehouseLocation: FreightScanningV2MoveWarehouseLocationOutput;
  /** Process a barcode scan. Returns order/package selection options or completes the scan. */
  scanningV2__processBarcode: FreightScanningV2MutationOutput;
  /** Lean barcode scan: records the scan synchronously and defers order rollup to a background job. Returns a scanJobUuid to poll via scanningV2__scanJobStatuses. */
  scanningV2__processBarcodeLean: FreightScanningV2ProcessBarcodeLeanOutput;
  /** Select a package and optionally specify piece count. Completes the scan. */
  scanningV2__selectPackage: FreightScanningV2MutationOutput;
  scheduleOrganizationMessage: OrganizationMessageEntity;
  selectRole?: Maybe<LoginPhoneOutput>;
  sendAccountingReports: SendAccountingReportsOutput;
  sendDeliveryCompleted: Scalars['Boolean']['output'];
  sendInvoices: InvoiceSendJobBatchEntity;
  sendMetric: Scalars['Boolean']['output'];
  sendRouteToAgent: SendRouteToAgentOutput;
  sendStopToAgent: SendStopToAgentOutput;
  setAccessorialQboItemMapping: AccessorialUnion;
  setCompanyAccountType: CompanyEntity;
  /** Replaces every charge matrix column assignment of the contact with the given set. */
  setContactChargeMatrixColumnMappings: Array<ContactChargeMatrixColumnMappingEntity>;
  setDockDoors: Array<DockDoorEntity>;
  setDriverComplianceDates: DriverComplianceEntity;
  setDriverSettlementPayBounds: Array<DriverSettlementPayBoundEntity>;
  setLaneDefaultDoor: Array<LaneDefaultDoorEntity>;
  setLineHaulManifestDepartTime: LineHaulManifestEntity;
  setLineHaulManifestLoadPosition: SetLineHaulManifestLoadPositionOutput;
  setLineHaulManifestOrderLoadPosition: SetLineHaulManifestLoadPositionOutput;
  setLineHaulManifestOriginTerminal: LineHaulManifestEntity;
  setLineHaulManifestTrailers: SetManifestTrailersOutput;
  setLineHaulManifestTruck: SetManifestTruckOutput;
  setLineHaulSegmentTiming: SetLineHaulSegmentTimingOutput;
  setMirrorTargetCompanies: Scalars['Boolean']['output'];
  /** Validates and stores the company Motive API key. */
  setMotiveApiKey: MotiveIntegrationEntity;
  setNotificationCutoverMode: NotificationCutoverConfigEntity;
  setOrderExecutedBy: OrderDelegationEntity;
  setOrderMirrorCaptureConfig: OrderMirrorCaptureConfigEntity;
  setOrganizationEmitPieceLevelWebhooks: OrganizationEntity;
  setOrganizationRequireScanToAdvancePieceStatusAtStops: OrganizationEntity;
  setPeerAccessorialShares: Array<Scalars['String']['output']>;
  setPeerServiceShares: Array<PeerServiceShareEntity>;
  /** Replaces the supplied dimensions of a scheduling resource eligibility rule set, and returns the resource so the new rules can be selected back in the same request. Every subject is named by UUID and must belong to the calling company; an unknown subject and one belonging to another company are reported identically. */
  setSchedulingResourceEligibilityRules: SchedulingResourceOutput;
  setStorageOrderItemQuantity: StorageOrderEntity;
  setTerminalTimeZone: UpdateTerminalV2Output;
  shareSavedFilterView: SavedFilterViewEntity;
  signUpForThirdPartyUserAccount: SignUpForThirdPartyUserAccountOutput;
  splitAndProcessOrderDocuments: Scalars['Boolean']['output'];
  startConfigMigration: Scalars['String']['output'];
  startInventoryCount: StartInventoryCountOutput;
  startPieceBackfillRun: PieceBackfillRunView;
  startRoute: RouteEntity;
  syncFinancialSnapshots: Scalars['Boolean']['output'];
  syncInvoiceStatusWithQuickbooks: InvoiceEntity;
  syncInvoicesToQuickbooks: SyncInvoicesToQuickbooksOutput;
  syncVehiclesWithSamsara: Array<EquipmentEntity>;
  /** Archives the driver and records the termination. Reverse it with rehireDriver. */
  terminateDriver: DriverComplianceEntity;
  testAllSnapshots: Scalars['String']['output'];
  testOneSnapshot: Scalars['String']['output'];
  testSchema?: Maybe<Scalars['String']['output']>;
  /** Checks the stored SMC3 connection, enabled or not. */
  testSmc3Connection: Smc3ConnectionTestResultEntity;
  /** Rates one class and weight with the stored SMC3 connection. */
  testSmc3Rate: Smc3TestRateResultEntity;
  testSubmitPODByShipperRefNo: Scalars['String']['output'];
  testSubmitStatusByShipperRefNo: Scalars['String']['output'];
  testUpdateStatusByShipperRefNo: Scalars['String']['output'];
  /** @deprecated Use dispatchTextDriver, which also reports whether the text went out. */
  textDriver: DriverEntity;
  textractSchemaFile: Scalars['Boolean']['output'];
  textractSchemaTestFile: Scalars['Boolean']['output'];
  throwGraphQLError: Scalars['String']['output'];
  throwPrismaError: Scalars['String']['output'];
  transferPieceToOrder: PieceEntity;
  transferPieceToOutboundOrder: PieceEntity;
  /** Confirm, reschedule or cancel one stop appointment, recording the transition in its status history. */
  transitionAppointment: TransitionAppointmentOutput;
  triggerAdhocPreview: AdhocPreviewTriggerEntity;
  triggerAdhocPreviewBatch: AdhocPreviewBatchEntity;
  triggerIngestionTestRun: IngestionTestRunEntity;
  unassignInventoryItems: UnassignInventoryItemsOutput;
  unassignLegFromDriver: LegEntity;
  unassignOrderFromLineHaulTrailer: Scalars['Boolean']['output'];
  /** Reopens a calendar day the whole company was closed on. DROPS the day exemptions with it, because they were opt-outs from a closure that no longer exists: closing the same day again starts from nobody exempt. TWO-PHASE for that reason: without confirmDiscardsExemptions a day carrying exemptions writes NOTHING and returns CompanySchedulingDayExemptionsAtRiskOutput naming how many resources would lose theirs, and sending the same input again with confirmDiscardsExemptions applies it. A day carrying no exemptions is reopened on the first call. Each resource own blocked days are untouched. */
  unblockCompanySchedulingDay: CompanySchedulingBlockedDayOutput;
  unblockSchedulingResourceDay: SchedulingResourceOutput;
  uncancelOrder: OrderEntity;
  unconsolidateOrder: Array<ShipmentEntity>;
  unfinalizeOrder: OrderEntity;
  unfinalizeOrders: UnfinalizeOrdersOutput;
  unlinkPieceFromOrder: PieceEntity;
  unlinkPieceFromPackage: Scalars['Boolean']['output'];
  unmarkPieceDamaged: PieceEntity;
  /** Unpacks the selected child pieces from their bundles (partial unpack): each is restored to a top-level piece; a parent whose last child is removed is deleted, otherwise it keeps its remaining children. */
  unpackPieces: UnpackPiecesOutput;
  unpickOrder: OrderEntity;
  unpickStorageUnit: UnpickStorageUnitOutput;
  unpostInvoice: UnpostInvoiceOutput;
  unpostInvoices: UnpostInvoicesOutput;
  update: EquipmentLicenseEntity;
  updateAccessorial: AccessorialUnion;
  updateAccessorialContact: UpdateAccessorialContactOutput;
  updateAccessorialDateRangeConfig: UpdateAccessorialDateRangeConfigOutput;
  updateAccessorialGroup: AccessorialGroupEntity;
  updateAccessorialRangesForAccessorial: Array<AccessorialRangeEntity>;
  updateAccessorialToQuickbooksMapping: AccessorialToQuickbooksMappingEntity;
  updateAddress: AddressEntity;
  updateAirportInfo: AirportInfoEntity;
  updateApiUser: ApiUserEntity;
  updateAutoApplyAccessorialConfig: AutoApplyAccessorialConfigEntity;
  updateBusinessDivision: UpdateBusinessDivisionOutput;
  updateCompany: CompanyEntity;
  updateCompanyConfiguration: CompanyConfigurationEntity;
  updateContactComment: UpdateContactCommentOutput;
  /** @deprecated Use updateContactEmails instead. */
  updateContactCommunicationConfig: ContactCommunicationConfigEntity;
  /** Update all ContactEmailEntities and ContactCommunicationConfigEntities that have to do with orders for a contact */
  updateContactEmails: UpdateContactEmailsOutput;
  updateContactPerson: ContactPersonEntity;
  updateContactStation: ContactStationUpdateOutput;
  updateContactToServicesTariffGroupMappings: Array<ContactToServicesTariffGroupMappingEntity>;
  updateCoverSheetDocumentTypeSequence: CoverSheetDocumentTypeSequenceEntity;
  updateCreditType: CreditTypeEntity;
  updateCsvOrderFieldMapping: CsvOrderFieldMappingEntity;
  updateCsvOrderImportTransaction: CsvOrderImportTransactionEntity;
  updateCsvOrderMapping: CsvOrderMappingEntity;
  updateCustomerContact: CustomerContactEntity;
  updateCustomerContactPackageSpecs: UpdateCustomerContactOutput;
  updateCustomerContactVehicleTypes: UpdateCustomerContactOutput;
  updateDefaultTariffChainsForCompany: UpdateDefaultTariffChainsForCompany;
  updateDispatchTableColors: UpdateDispatchTableColorsOutput;
  updateDispatchView: DispatchViewUpdateOutput;
  updateDocument: DocumentEntity;
  updateDocuments: Array<DocumentEntity>;
  updateDriver: DriverEntity;
  updateDriverComplianceProfile: DriverComplianceEntity;
  updateDriverCredentialType: DriverCredentialTypeEntity;
  updateDriverInsurancePolicy: DriverComplianceEntity;
  updateDriverLocation?: Maybe<DriverEntity>;
  updateDriverQualifications: UpdateDriverQualificationsOutput;
  updateDriverSettlementBill: DriverSettlementBillEntity;
  updateDriverSignableFormTemplate: DriverSignableFormTemplateEntity;
  updateDriverTrainingRecord: DriverComplianceEntity;
  updateDwellTimeAlertConfig: DwellTimeAlertConfigEntity;
  updateEdiPartnership: UpdateEdiPartnershipOutput;
  updateEmailIngestionExclusions: EmailIngestionExclusionsEntity;
  updateEmailTransaction: UpdateEmailTransactionOutput;
  updateEmailTransactionLog: EmailTransactionLogEntity;
  updateEndOfDayDocumentProcessingJob: EndOfDayDocumentProcessingJobEntity;
  updateEquipment: EquipmentEntity;
  updateFeatureFlag?: Maybe<FeatureFlagEntity>;
  updateFeatureFlagCompanyOverride: FeatureFlagCompanyOverrideEntity;
  updateFeatureFlagUserOverride: FeatureFlagUserOverrideEntity;
  updateFreightCharge: FreightChargeEntity;
  updateFuelProfile?: Maybe<FuelProfileEntity>;
  updateFuelProfileDateRange: UpdateFuelProfileDateRangeOutput;
  updateGeneralLedgerCode: UpdateGeneralLedgerCodeOutput;
  updateGeneralLedgerConfiguration: UpdateGeneralLedgerConfigurationOutput;
  updateHoldReason: HoldReasonEntity;
  updateImportedOrderTypeMapping: ImportedOrderTypeMappingEntity;
  /** Upserts the given in-app notification opt-in choices for the current user; event types omitted from the payload are left unchanged. */
  updateInAppNotificationPreferences: Array<InAppNotificationPreferenceEntity>;
  /** @deprecated Deprecated. Use upsertItemGroup instead */
  updateInventoryItems: UpdateInventoryItemsOutput;
  /** @deprecated Use updateInvoiceLimited instead */
  updateInvoice: InvoiceEntity;
  updateInvoiceEmail: CompanyEntity;
  /** Updates the date, name, and terms of an invoice. Think carefully before adding more fields for this mutation to update */
  updateInvoiceLimited: InvoiceEntity;
  /** Replaces the rule's criteria and note. */
  updateInvoiceNoteRule: InvoiceNoteRuleEntity;
  updateItem: ItemEntity;
  updateItemLocation: UpdateItemLocationOutput;
  updateKpiDashboardLayout: KpiLayoutEntity;
  /** This is probably not the method you want to use */
  updateLegDriverMap: LegDriverMapEntity;
  updateLineHaulLane: UpdateLineHaulLaneOutput;
  updateLineHaulManifest: LineHaulManifestEntity;
  updateLineHaulSegment: LineHaulSegmentEntity;
  updateManifestDriver: LineHaulManifestEntity;
  updateManifestVehicle: LineHaulManifestEntity;
  updateManifestsStatus: UpdateManifestsStatusOutput;
  updateMasterAccount: UpdateMasterAccountOutput;
  updateMirrorTarget: MirrorTargetEntity;
  /** Record notes or the proof-of-delivery signee on a stop of the current driver */
  updateMyStop: StopEntity;
  updateOrderComment: OrderCommentEntity;
  updateOrderDelegationRule: OrderDelegationRuleEntity;
  /** Update (replacing) all subscriptions for a contact */
  updateOrderEventNotificationSubscriptions: UpdateOrderEventNotificationSubscriptionsOutput;
  updateOrderFormFields: OrderFormFieldsEntity;
  updateOrderImportConfiguration: OrderImportConfigurationEntity;
  updateOrderLineHaulSegment: OrderLineHaulSegmentEntity;
  updateOrderLoadedStatus: OrderEntity;
  updateOrganization: UpdateOrganizationOutput;
  updateOrganizationMessage: OrganizationMessageEntity;
  updateOrganizationPeersSettings: Array<OrganizationPeerEntity>;
  updateOutlookIntegration: OutlookIntegrationEntity;
  updatePackage: PackageEntity;
  updatePackageArray: Array<PackageEntity>;
  updatePackageSpec: UpdatePackageSpecOutput;
  updatePackageWarehouseLocation: UpdatePackageWarehouseLocationOutput;
  updatePaperworkCompletedForStops: Array<StopEntity>;
  updatePayment: PaymentEntity;
  updatePaymentOffset: PaymentToPaymentMappingEntity;
  updatePermission: UpdatePermissionOutput;
  updatePermissionAccessLevel: UpdatePermissionAccessLevelOutput;
  updatePerson: UpdatePersonOutput;
  updatePiece: PieceEntity;
  updatePieceCount: OrderEntity;
  updatePieceDimensions: PieceEntity;
  updatePieceReceipt: UpdatePieceReceiptOutput;
  /** Edits an attached piece's dimensions, weight, container type, and location. markedOnHandAt is read-only. */
  updatePieceReceiptPiece: UpdatePieceReceiptPieceOutput;
  updatePiecesPicked: OrderEntity;
  updatePlace: PlaceEntity;
  updateQuickAddAccessorials: UpdateQuickAddAccessorialsOutput;
  updateQuickbooksHeaderFileMapping: QuickbooksHeaderFileMappingEntity;
  updateQuote: QuoteEntity;
  updateQuoteAgentStaffSettings: CompanyConfigurationEntity;
  updateRecurringLineHaulManifestTemplate: RecurringLineHaulManifestTemplateEntity;
  updateRecurringOrderFrequency: RecurringOrderFrequencyEntity;
  updateRecurringTemplateTruck: RecurringTemplateTruckEntity;
  updateReportGroupConfiguration: ReportGroupConfigurationEntity;
  updateReportsEmail: UserEntity;
  updateRole: UpdateRoleOutput;
  updateRoute: RouteEntity;
  updateRouteDrivers: RouteEntity;
  updateRouteNameLocation: RouteNameLocationEntity;
  updateRouteOptimization: RouteOptimizationEntity;
  updateRouteSlot: RouteSlotEntity;
  updateRouteSlots?: Maybe<RouteEntity>;
  updateRun: UpdateRunOutput;
  updateSameDayDispatchConfig: SameDayDispatchConfigEntity;
  updateSavedFilterView: SavedFilterViewEntity;
  /** Send the update of an ingested order scan. This will create an order on success. Not used for general CRUD updates  */
  updateScannedOrder: Scalars['String']['output'];
  updateScannedOrderResultStatus: ScannedOrderResultEntity;
  updateSchedulingRegion: UpdateSchedulingRegionOutput;
  updateSchedulingResource: SchedulingResourceOutput;
  updateSchedulingZone: UpdateSchedulingZoneOutput;
  updateSchema: Scalars['String']['output'];
  updateSchemaCompanyMapping: Scalars['String']['output'];
  updateSchemaDocument: SchemaDocumentEntity;
  updateService: ServiceEntity;
  updateServiceDateForAssignedStops: Array<RouteEntity>;
  updateServiceGroup: ServiceGroupEntity;
  /** Updates a service region by id. Returns the updated service region. The update will fail if attempting to update a service region as archived that has terminals associated with it that are active. */
  updateServiceRegion: UpdateServiceRegionOutput;
  updateSettlementAdjustment: CreateOrUpdateSettlementAdjustmentOutput;
  /** @deprecated Deprecated during Robust Settlement Project. Use `updateSettlementAdjustment` instead */
  updateSettlementDeduction: SettlementDeductionEntity;
  updateSettlementDeductionType: SettlementDeductionTypeEntity;
  updateSftpCredentials: CreateSftpCredentialsOutput;
  updateShipment: ShipmentEntity;
  updateShipmentStandardAccessorials: ShipmentEntity;
  /** Send the update of an ingested signed pod scan. This will create an document on success attached to the existing order shipment. Not used for general CRUD updates  */
  updateSignedPOD: ScannedOrderEntity;
  updateStandaloneStop: StopEntity;
  updateStandardOrder: StandardOrderEntity;
  updateStandardShipmentFields: StandardShipmentFieldsEntity;
  updateStop: StopEntity;
  updateStopDriverMap: StopDriverMapEntity;
  updateStops: Array<StopEntity>;
  updateStorageOrder: UpdateStorageOrderOutput;
  updateStorageUnit: UpdateStorageUnitOutput;
  updateTag: TagEntity;
  updateTariffChain: UpdateTariffChainOutput;
  updateTariffGroup: TariffGroupEntity;
  updateTariffRangesForTariff: Array<TariffRangeEntity>;
  updateTariffZone: TariffZoneEntity;
  updateTariffZoneGroup: TariffZoneGroupUpdateOutput;
  updateTemplateAndRecordAddresses: Array<AddressEntity>;
  updateTenediCarrierIdentity: TenediCarrierIdentitySaveResultEntity;
  updateTenediCustomerIdentity: TenediCustomerIdentitySaveResultEntity;
  /** @deprecated Use updateTerminalV2 instead */
  updateTerminal: UpdateTerminalOutput;
  updateTerminalServiceArea: TerminalServiceAreaEntity;
  updateTerminalV2: UpdateTerminalV2Output;
  updateTestOrder: UpdateTestOrderOutput;
  updateTestPieceStatus: Scalars['Boolean']['output'];
  updateThirdPartyBroker: ThirdPartyBrokerEntity;
  updateUser: UserEntity;
  updateVehicleForRoute: RouteEntity;
  updateVehicleType: VehicleTypeEntity;
  updateWarehouse: WarehouseEntity;
  updateWarehouseEmployee: UpdateWarehouseEmployeeOutput;
  updateWarehouseLocation: UpdateWarehouseLocationOutput;
  /** Upload a POD document to Expeditors for an Expeditors work order */
  uploadDocumentToExpeditors: Scalars['Boolean']['output'];
  upsertAddress: AddressEntity;
  upsertCompanyPackageTypeConfig: UpsertCompanyPackageTypeConfigOutput;
  upsertContactPerson: ContactPersonEntity;
  upsertDockTimeAllowances: DockTimeAllowanceEntity;
  upsertDriverPlannerAssumptions: DriverPlannerAssumptionEntity;
  upsertEdiPartnershipReferenceMappings: Array<EdiPartnershipReferenceMappingEntity>;
  upsertFreightCharge: FreightChargeEntity;
  upsertItemGroup?: Maybe<ItemGroupEntity>;
  upsertLineHaulUtilizationAssumptions: LineHaulUtilizationAssumptionEntity;
  upsertOrganizationPackageTypeConfig: UpsertOrganizationPackageTypeConfigOutput;
  upsertOrganizationQuotePolicy: OrganizationQuotePolicy;
  upsertPackage: PackageEntity;
  upsertPicklist: UpsertPicklistOutput;
  upsertProductivityTimeAllowances: ProductivityTimeAllowanceEntity;
  /** Persists the calling company's v2 route-automation settings. Validates that referenced services / tags belong to the company. */
  upsertRouteAutomationSettings: RouteAutomationSettingsEntity;
  upsertSamsaraOauthToken: SamsaraOauthTokenEntity;
  /** Internal resolver to upsert a shipment subscriber. Directly calls the upsert service function. */
  upsertShipmentSubscriber: ShipmentSubscriberEntity;
  /** Public endpoint to allow any viewer to make a phone number a subscriber to shipment updates, given that they provide the correct company UUID and the correct shipment UUID */
  upsertShipmentSubscriberForCompany: ShipmentSubscriberEntity;
  upsertStructuredExtractionSchemaOverride: StructuredExtractionSchemaOverrideEntity;
  upsertUserContactNotificationSubscription: UserContactNotificationSubscriptionEntity;
  userSessionsAdminRevokeSessions: RevokeCompanyUserSessionsResult;
  validateCrownChargesFromCSV: ValidateCrownChargesOutput;
  validateCrownChargesFromPDF: ValidateCrownChargesOutput;
  validateImportedCrownInvoices: ValidateImportedCrownInvoicesOutput;
  verifyInventoryForStorageUnit: VerifyInventoryForStorageUnitOutput;
  withdrawOrganizationMessage: OrganizationMessageEntity;
};


export type MutationAcceptCustomerPortalOrderArgs = {
  acceptCustomerPortalOrderInput: AcceptCustomerPortalOrderInput;
};


export type MutationAcceptEdiOrApiOrderArgs = {
  acceptEdiOrApiOrderInput: AcceptEdiOrApiOrderInput;
};


export type MutationAcceptExpeditorsWorkOrderArgs = {
  orderUuid: Scalars['String']['input'];
};


export type MutationAcceptOrderDelegationArgs = {
  input: AcceptOrderDelegationInput;
};


export type MutationAcceptOrganizationPeerArgs = {
  input: AcceptOrganizationPeerInput;
};


export type MutationAcknowledgeFailedInvoiceSendJobsArgs = {
  invoiceSendJobBatchUuid: Scalars['String']['input'];
};


export type MutationAcknowledgeMyRouteChangesArgs = {
  acknowledgeRouteChangesInput: AcknowledgeRouteChangesInput;
};


export type MutationAcknowledgeMyStopChangeArgs = {
  input: AcknowledgeMyStopChangeInput;
};


export type MutationAcknowledgeNotificationArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationAcknowledgeNotificationsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationAcknowledgeQuoteAttentionArgs = {
  acknowledgeQuoteAttentionInput: AcknowledgeQuoteAttentionInput;
};


export type MutationAddApiUserContactMappingArgs = {
  addApiUserContactMappingInput: AddApiUserContactMappingInput;
};


export type MutationAddDriverExpoPushTokenArgs = {
  newExpoPushToken: Scalars['String']['input'];
};


export type MutationAddDriversToRouteArgs = {
  addDriversToRouteInput: AddDriversToRouteInput;
};


export type MutationAddLineItemsToSettlementBillsArgs = {
  addLineItemsToSettlementBillsInput: AddLineItemsToSettlementBillsInput;
};


export type MutationAddNextRouteSlotForRouteArgs = {
  nextRouteSlotUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};


export type MutationAddOrdersToInvoicesArgs = {
  input: AddOrdersToInvoicesInput;
};


export type MutationAddOrdersToManifestArgs = {
  addOrdersToManifestInput: AddOrdersToManifestInput;
};


export type MutationAddOrdersToManifestV2Args = {
  input: AddOrdersToManifestV2Input;
};


export type MutationAddPiecesToPieceReceiptArgs = {
  addPiecesToPieceReceiptInput: AddPiecesToPieceReceiptInput;
};


export type MutationAddQuickbooksDesktopCustomerArgs = {
  contactUuid: Scalars['String']['input'];
};


export type MutationAddQuickbooksDesktopCustomersArgs = {
  contactUuids: Array<Scalars['String']['input']>;
};


export type MutationAddQuickbooksDesktopItemArgs = {
  accountRefName: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
};


export type MutationAddRouteStopArgs = {
  addRouteStopInput: AddRouteStopInput;
};


export type MutationAddServiceToContactArgs = {
  addServiceToContactInput: AddServiceToContactInput;
};


export type MutationAddServicesToTariffGroupMappingsArgs = {
  serviceUuids: Array<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationAddTagToLegArgs = {
  addTagToLegInput: AddTagToLegInput;
};


export type MutationAddTagToOrderArgs = {
  addTagToOrderInput: AddTagToOrderInput;
};


export type MutationAddTestAccessorialChargeArgs = {
  addTestAccessorialChargeInput: AddTestAccessorialChargeInput;
};


export type MutationAddThirdPartyUserToContactArgs = {
  addThirdPartyUserToContactInput: AddThirdPartyUserToContactInput;
};


export type MutationAddUserToRoleArgs = {
  addUserToRoleInput: AddUserToRoleInput;
};


export type MutationAdminSyncInvoicesToQuickbooksArgs = {
  input: AdminSyncInvoicesToQuickbooksInput;
};


export type MutationAdoptDriverSettlementPayTermsArgs = {
  input: AdoptDriverSettlementPayTermsInput;
};


export type MutationAdvanceOutboundBenchOrdersArgs = {
  input: AdvanceOutboundBenchOrdersInput;
};


export type MutationApiKeyAdminConnectOrgsArgs = {
  input: ApiKeyAdminConnectOrgsInput;
};


export type MutationApiKeyAdminCreateArgs = {
  input: ApiKeyAdminCreateInput;
};


export type MutationApiKeyAdminDeleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationApiKeyAdminDisconnectOrgArgs = {
  input: ApiKeyAdminDisconnectOrgInput;
};


export type MutationApiKeyAdminImportCsvArgs = {
  input: ApiKeyAdminImportCsvInput;
};


export type MutationApiKeyAdminSetMappingTemplateArgs = {
  input: ApiKeyAdminSetMappingTemplateInput;
};


export type MutationApiKeyAdminSetStatusMappingsArgs = {
  input: ApiKeyAdminSetStatusMappingsInput;
};


export type MutationApiKeyAdminUpdateArgs = {
  input: ApiKeyAdminUpdateInput;
};


export type MutationApplyDebitToPaymentArgs = {
  input: ApplyDebitToPaymentInput;
};


export type MutationApplyDelegationAccessorialProposalArgs = {
  input: ApplyDelegationAccessorialProposalInput;
};


export type MutationApplyRouteOptimizationArgs = {
  input: ApplyRouteOptimizationInput;
};


export type MutationApproveQuoteArgs = {
  approveQuoteInput: ApproveQuoteInput;
};


export type MutationApproveQuoteReplyArgs = {
  approveQuoteReplyInput: ApproveQuoteReplyInput;
};


export type MutationArchiveAirportInfoArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationArchiveContactStationArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationArchiveOrganizationArgs = {
  input: ArchiveOrganizationInput;
};


export type MutationArchivePackageSpecArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchivePersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveSchedulingRegionArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveSchedulingResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveTariffChainArgs = {
  archiveTariffChainInput: ArchiveTariffChainInput;
};


export type MutationArchiveTariffZoneGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationArchiveWarehouseEmployeeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationArriveAtStopArgs = {
  arriveAtStopInput: ArriveAtStopInput;
};


export type MutationArriveAtStopsArgs = {
  arriveAtStopsInput: ArriveAtStopsInput;
};


export type MutationAssignDockDoorArgs = {
  input: AssignDockDoorInput;
};


export type MutationAssignHelperToRouteArgs = {
  helperUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};


export type MutationAssignInventoryItemsToStorageUnitArgs = {
  assignInventoryItemsToStorageUnitInput: AssignInventoryItemsToStorageUnitInput;
};


export type MutationAssignOrderToLineHaulTrailerArgs = {
  input: AssignOrderToTrailerInput;
};


export type MutationAssignOutboundReferenceNumbersToStorageUnitsArgs = {
  assignOutboundReferenceNumbersToStorageUnitsInput: AssignOutboundReferenceNumberToStorageUnitsInput;
};


export type MutationAttachMobileSignedDocumentToOrderAndReplaceOriginalArgs = {
  input: UploadMobileSignedDocumentInput;
  placement?: InputMaybe<SignaturePlacementInput>;
};


export type MutationAutoCreateRoutesV2Args = {
  input: AutoCreateRoutesV2Input;
};


export type MutationBackfillOrderTotalsArgs = {
  pageSize: Scalars['Float']['input'];
};


export type MutationBackfillTariffZoneGroupsForCompanyArgs = {
  companyUuid: Scalars['String']['input'];
};


export type MutationBatchAddShipmentsToInvoicesMultipleArgs = {
  batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple;
};


export type MutationBlockCompanySchedulingDayArgs = {
  input: BlockCompanySchedulingDayInput;
};


export type MutationBlockSchedulingResourceDayArgs = {
  input: BlockSchedulingResourceDayInput;
};


export type MutationBookCustomerAppointmentArgs = {
  input: BookCustomerAppointmentInput;
};


export type MutationBulkChangeCallStatusArgs = {
  changeCallStatusArgs: BulkChangeCallStatusArgs;
};


export type MutationBulkConfirmAppointmentsArgs = {
  bulkConfirmAppointmentsArgs: BulkConfirmAppointmentsArgs;
};


export type MutationBulkDelegateOrdersArgs = {
  input: BulkDelegateOrdersInput;
};


export type MutationBulkDeletePiecesArgs = {
  input: BulkDeletePiecesInput;
};


export type MutationBulkDiscardPiecesArgs = {
  input: BulkDiscardPiecesInput;
};


export type MutationBulkEditOrdersArgs = {
  bulkEditOrdersInput: BulkEditOrdersInput;
};


export type MutationBulkRestorePiecesArgs = {
  input: BulkRestorePiecesInput;
};


export type MutationBulkUnconfirmAppointmentsArgs = {
  bulkUnconfirmAppointmentsArgs: BulkUnconfirmAppointmentsArgs;
};


export type MutationBulkUpdateAccessorialMappingsArgs = {
  bulkAccessorialUpdateInput: BulkAccessorialUpdateInput;
};


export type MutationBulkUpdateContactQuickbooksIdsArgs = {
  bulkUpdateContactQuickbooksId: UpdateContactQuickbooksIdsInput;
};


export type MutationBulkUploadRouteNamesArgs = {
  bulkCsvRouteNameInput: BulkCsvRouteNameInput;
};


export type MutationCalculateRouteEtasArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationCallStopsArgs = {
  callStopsInput: CallStopsInput;
};


export type MutationCalmAddStopToRouteArgs = {
  input: AddStopToRouteInput;
};


export type MutationCalmAssignLineHaulRouteArgs = {
  input: AssignLineHaulRouteInput;
};


export type MutationCalmAssignPackagesToManifestArgs = {
  input: AssignPackagesToManifestInput;
};


export type MutationCalmLoadOrdersOnManifestArgs = {
  input: CalmLoadOrdersInput;
};


export type MutationCalmMoveOrderBetweenRunsArgs = {
  input: MoveBetweenRunsInput;
};


export type MutationCalmRemovePackagesFromManifestArgs = {
  input: AssignPackagesToManifestInput;
};


export type MutationCalmRepointOrderFreightArgs = {
  input: RepointOrderFreightInput;
};


export type MutationCalmSaveManifestPlacementsArgs = {
  input: SaveManifestPlacementsInput;
};


export type MutationCalmSetCrossdockInstructionArgs = {
  input: SetCrossdockInstructionInput;
};


export type MutationCalmSetPndRouteDriverArgs = {
  input: SetPndRouteDriverInput;
};


export type MutationCancelDocExtractionEvalRunArgs = {
  runId: Scalars['String']['input'];
};


export type MutationCancelPackingPendencyArgs = {
  input: CancelPackingPendencyInput;
};


export type MutationChooseAppointmentOptionArgs = {
  input: ChooseAppointmentOptionInput;
};


export type MutationClearCompanyArgs = {
  input: ClearCompanyInput;
};


export type MutationClearCompanyContactsArgs = {
  clearCompanyContactsInput: ClearCompanyContactsInput;
};


export type MutationClearDriverSettlementPayBoundArgs = {
  input: ClearDriverSettlementPayBoundInput;
};


export type MutationClearOrderExecutedByArgs = {
  input: ClearOrderExecutedByInput;
};


export type MutationCloneSavedFilterViewArgs = {
  cloneSavedFilterViewInput: CloneSavedFilterViewInput;
};


export type MutationCloseInventoryCountArgs = {
  closeInventoryCountInput: CloseInventoryCountInput;
};


export type MutationCompleteRebillArgs = {
  completeRebillInput: CompleteRebillInput;
};


export type MutationCompleteStopBulkArgs = {
  completeStopBulkInput: CompleteStopBulkInput;
};


export type MutationCompleteStopV2Args = {
  completeStopInput: CompleteStopInput;
};


export type MutationCompleteWorkOrderLoadingArgs = {
  input: CompleteWorkOrderLoadingInput;
};


export type MutationConfirmInventoryCountLinesArgs = {
  confirmInventoryCountLinesInput: ConfirmInventoryCountLinesInput;
};


export type MutationConfirmQuoteAcceptanceArgs = {
  confirmQuoteAcceptanceInput: ConfirmQuoteAcceptanceInput;
};


export type MutationConnectToQuickbooksDesktopArgs = {
  qbUserEmail: Scalars['String']['input'];
};


export type MutationCreateAccessorialArgs = {
  createAccessorialInput: CreateAccessorialInput;
};


export type MutationCreateAccessorialContactArgs = {
  accessorialContactCreateInput: CreateAccessorialContactInput;
};


export type MutationCreateAccessorialDateRangeConfigArgs = {
  createAccessorialDateRangeConfigInput: CreateAccessorialDateRangeConfigInput;
};


export type MutationCreateAccessorialGroupArgs = {
  input: CreateAccessorialGroupInput;
};


export type MutationCreateAccessorialToQuickbooksMappingArgs = {
  accessorialToQuickbooksMappingCreateInput: AccessorialToQuickbooksMappingCreateInput;
};


export type MutationCreateAccountingReportDocumentArgs = {
  createAccountingReportDocumentInput: CreateBasicDocumentInput;
};


export type MutationCreateAddressArgs = {
  createAddressInput: CreateAddressInput;
};


export type MutationCreateAdjustmentStopDriverMapArgs = {
  adjustmentStopDriverMapCreateInput: AdjustmentStopDriverMapCreateInput;
};


export type MutationCreateAirportInfoArgs = {
  createAirportInfoInput: CreateAirportInfoInput;
};


export type MutationCreateApiUserArgs = {
  createApiUserInput: CreateApiUserInput;
};


export type MutationCreateAppointmentsForRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationCreateAutoApplyAccessorialConfigArgs = {
  createAutoApplyAccessorialConfigInput: CreateAutoApplyAccessorialConfigInput;
};


export type MutationCreateBusinessDivisionArgs = {
  createBusinessDivisionInput: CreateBusinessDivisionInput;
};


export type MutationCreateCompanyArgs = {
  createCompanyInput: CreateCompanyInput;
};


export type MutationCreateConsolidatedOrderArgs = {
  createConsolidatedOrderInput: CreateConsolidatedOrderInput;
};


export type MutationCreateConsolidatedOrderFromOrderArgs = {
  createConsolidatedOrderFromOrderInput: CreateConsolidatedOrderFromOrderInput;
};


export type MutationCreateContactCommentArgs = {
  createContactCommentInput: CreateContactCommentInput;
};


export type MutationCreateContactCommunicationConfigArgs = {
  createContactCommunicationConfigInput: CreateContactCommunicationConfigInput;
};


export type MutationCreateContactDocumentArgs = {
  createContactDocumentInput: CreateContactDocumentInput;
};


export type MutationCreateContactEmailArgs = {
  createContactEmailInput: CreateContactEmailInput;
};


export type MutationCreateContactPersonArgs = {
  createContactPersonInput: CreateContactPersonInput;
};


export type MutationCreateContactStationArgs = {
  contactStationCreateInput: ContactStationCreateInput;
};


export type MutationCreateCoverSheetDocumentTypeSequenceArgs = {
  coverSheetDocumentTypeSequenceCreateInput: CoverSheetDocumentTypeSequenceCreateInput;
};


export type MutationCreateCreditTypeArgs = {
  creditTypeCreateInput: CreditTypeCreateInput;
};


export type MutationCreateCsvOrderFieldMappingArgs = {
  createCsvOrderFieldMappingInput: CreateCsvOrderFieldMappingInput;
};


export type MutationCreateCsvOrderImportTransactionArgs = {
  createCsvOrderImportTransactionInput: CreateCsvOrderImportTransactionInput;
};


export type MutationCreateCsvOrderMappingArgs = {
  createCsvOrderMappingInput: CreateCsvOrderMappingInput;
};


export type MutationCreateCustomerContactArgs = {
  createCustomerContactInput: CreateCustomerContactInput;
};


export type MutationCreateCustomerContactsArgs = {
  createCustomerContactsInput: CreateCustomerContactsInput;
};


export type MutationCreateDispatchViewArgs = {
  dispatchViewCreateInput: DispatchViewCreateInput;
};


export type MutationCreateDocExtractionEvalRunArgs = {
  input: CreateDocExtractionEvalRunInput;
};


export type MutationCreateDocExtractionEvalSetArgs = {
  input: CreateDocExtractionEvalSetInput;
};


export type MutationCreateDocumentArgs = {
  createDocumentInput: CreateDocumentInput;
};


export type MutationCreateDriverArgs = {
  createDriverInput: CreateDriverInput;
};


export type MutationCreateDriverCredentialTypeArgs = {
  input: CreateDriverCredentialTypeInput;
};


export type MutationCreateDriverInsurancePolicyArgs = {
  input: CreateDriverInsurancePolicyInput;
};


export type MutationCreateDriverSettlementBillArgs = {
  createDriverSettlementBillInput: CreateDriverSettlementBillInput;
};


export type MutationCreateDriverSignableFormTemplateArgs = {
  createDriverSignableFormTemplateInput: CreateDriverSignableFormTemplateInput;
};


export type MutationCreateDriverTrainingRecordArgs = {
  input: CreateDriverTrainingRecordInput;
};


export type MutationCreateDriversArgs = {
  createDriversInput: CreateDriversInput;
};


export type MutationCreateDuplicateOrderForRebillArgs = {
  createDuplicateOrderForRebillInput: CreateDuplicateOrderForRebillInput;
};


export type MutationCreateDwellTimeAlertConfigArgs = {
  createDwellTimeAlertConfigInput: CreateDwellTimeAlertConfigInput;
};


export type MutationCreateEodDocumentsArgs = {
  createEodDocumentsInput: CreateEodDocumentsInput;
};


export type MutationCreateEdiPartnershipArgs = {
  createEdiPartnershipInput: CreateEdiPartnershipInput;
};


export type MutationCreateEdiPartnershipServiceMappingsArgs = {
  createEdiPartnershipServiceMappingsInput: CreateEdiPartnershipServiceMappingsInput;
};


export type MutationCreateEdiTransactionArgs = {
  createEdiTransactionInput: CreateEdiTransactionInput;
};


export type MutationCreateEmailTransactionArgs = {
  createEmailTransactionInput: CreateEmailTransactionInput;
};


export type MutationCreateEmailTransactionLogArgs = {
  emailTransactionLogCreateInput: EmailTransactionLogCreateInput;
};


export type MutationCreateEndOfDayDocumentProcessingJobArgs = {
  createEndOfDayDocumentProcessingJobInput: CreateEndOfDayDocumentProcessingJobInput;
};


export type MutationCreateEquipmentArgs = {
  createEquipmentInput: CreateEquipmentInput;
};


export type MutationCreateEquipmentLicenseArgs = {
  createEquipmentLicenseInput: CreateEquipmentLicenseInput;
};


export type MutationCreateEquipmentsArgs = {
  createEquipmentsInput: CreateEquipmentsInput;
};


export type MutationCreateFeatureFlagArgs = {
  createFeatureFlagInput: CreateFeatureFlagInput;
};


export type MutationCreateFeatureFlagCompanyOverrideArgs = {
  createFeatureFlagCompanyOverrideInput: CreateFeatureFlagCompanyOverrideInput;
};


export type MutationCreateFeatureFlagUserOverrideArgs = {
  createFeatureFlagUserOverrideInput: CreateFeatureFlagUserOverrideInput;
};


export type MutationCreateFreightChargeArgs = {
  createFreightChargeInput: CreateFreightChargeInput;
};


export type MutationCreateFuelProfileArgs = {
  createFuelProfileInput: CreateFuelProfileInput;
};


export type MutationCreateFuelProfileDateRangeArgs = {
  createFuelProfileDateRangeInput: CreateFuelProfileDateRangeInput;
};


export type MutationCreateGeneralLedgerCodeArgs = {
  input: GeneralLedgerCodeCreateInput;
};


export type MutationCreateHoldReasonArgs = {
  holdReasonCreateInput: HoldReasonCreateInput;
};


export type MutationCreateImportedOrderTypeMappingArgs = {
  importedOrderTypeMappingCreateInput: ImportedOrderTypeMappingCreateInput;
};


export type MutationCreateImportedOrderTypeMappingsArgs = {
  importedOrderTypeMappingCreateInputs: Array<ImportedOrderTypeMappingCreateInput>;
};


export type MutationCreateIngestionTestUploadArgs = {
  input: CreateIngestionTestUploadInput;
};


export type MutationCreateInventoryItemsArgs = {
  createInventoryItemsInput: CreateInventoryItemsInput;
};


export type MutationCreateInventoryPrimaryUnitOfMeasureArgs = {
  createInventoryPrimaryUnitOfMeasureInput: CreateInventoryPrimaryUnitOfMeasureInput;
};


export type MutationCreateInventorySecondaryUnitOfMeasureArgs = {
  createInventorySecondaryUnitOfMeasureInput: CreateInventorySecondaryUnitOfMeasureInput;
};


export type MutationCreateInvoiceArgs = {
  createInvoiceInput: CreateInvoiceInput;
};


export type MutationCreateInvoiceDocumentArgs = {
  createInvoiceDocumentInput: CreateInvoiceDocumentInput;
};


export type MutationCreateInvoiceDocumentsArgs = {
  createInvoiceDocumentsInput: CreateInvoiceDocumentsInput;
};


export type MutationCreateInvoiceNoteRuleArgs = {
  invoiceNoteRuleInput: InvoiceNoteRuleInput;
};


export type MutationCreateInvoiceTermsArgs = {
  terms: Scalars['String']['input'];
};


export type MutationCreateInvoiceTermsForAllArgs = {
  createInvoiceTermsForAllInput: CreateInvoiceTermsForAllInput;
};


export type MutationCreateItemArgs = {
  createItemInput: CreateItemInput;
};


export type MutationCreateItemLocationArgs = {
  createItemLocationInput: CreateItemLocationInput;
};


export type MutationCreateLegArgs = {
  createLegInput: CreateLegInput;
};


export type MutationCreateLegDriverMapArgs = {
  createLegDriverMapInput: CreateLegDriverMapInput;
};


export type MutationCreateLineHaulLaneArgs = {
  createLineHaulLaneInput: CreateLineHaulLaneInput;
};


export type MutationCreateLineHaulManifestArgs = {
  createLineHaulManifestInput: CreateLineHaulManifestInput;
};


export type MutationCreateLineHaulManifestsArgs = {
  input: CreateLineHaulManifestsInput;
};


export type MutationCreateLineHaulSegmentArgs = {
  createLineHaulSegmentInput: CreateLineHaulSegmentInput;
};


export type MutationCreateLineHaulTruckRunsArgs = {
  input: CreateTruckRunsInput;
};


export type MutationCreateManyReferenceNumberLabelsArgs = {
  referenceNumberLabels: Array<Scalars['String']['input']>;
};


export type MutationCreateMasterAccountArgs = {
  createMasterAccountInput: CreateMasterAccountInput;
};


export type MutationCreateMirrorTargetArgs = {
  input: CreateMirrorTargetInput;
};


export type MutationCreateNotificationArgs = {
  createNotificationInput: CreateNotificationInput;
};


export type MutationCreateOrUpdateCsvOrdersArgs = {
  createOrUpdateCsvOrdersInput: CreateOrUpdateCsvOrdersInput;
};


export type MutationCreateOrderCommentArgs = {
  createOrderCommentInput: CreateOrderCommentInput;
};


export type MutationCreateOrderDelegationRuleArgs = {
  input: CreateOrderDelegationRuleInput;
};


export type MutationCreateOrderDocumentArgs = {
  createOrderDocumentInput: CreateOrderDocumentInput;
};


export type MutationCreateOrderDocumentDocumentArgs = {
  createOrderDocumentDocumentInput: CreateOrderDocumentDocumentInput;
};


export type MutationCreateOrderImportConfigurationArgs = {
  orderImportConfigurationCreateInput: OrderImportConfigurationCreateInput;
};


export type MutationCreateOrderLineHaulSegmentArgs = {
  orderLineHaulSegmentCreateInput: OrderLineHaulSegmentCreateInput;
};


export type MutationCreateOrderSnapshotArgs = {
  orderEventSnapshotCreateInput: OrderEventSnapshotCreateInput;
};


export type MutationCreateOrderTableReportArgs = {
  createOrderTableReportInput: CreateOrderTableReportInput;
};


export type MutationCreateOrdersFromRecurringTemplatesArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationMessageArgs = {
  input: CreateOrganizationMessageInput;
};


export type MutationCreateOrganizationPeerArgs = {
  input: CreateOrganizationPeerInput;
};


export type MutationCreateOutboundBenchOrdersArgs = {
  input: CreateOutboundBenchOrdersInput;
};


export type MutationCreateOutlookIntegrationArgs = {
  outlookIntegrationCreateInput: OutlookIntegrationCreateInput;
};


export type MutationCreatePodReportDocumentArgs = {
  createPodReportDocumentInput: CreatePodReportDocumentInput;
};


export type MutationCreatePackageArgs = {
  createPackageInput: CreatePackageInput;
};


export type MutationCreatePackageSpecArgs = {
  createPackageSpecInput: CreatePackageSpecInput;
};


export type MutationCreatePackingPendencyArgs = {
  input: CreatePackingPendencyInput;
};


export type MutationCreatePaymentArgs = {
  createPaymentInput: CreatePaymentInput;
};


export type MutationCreatePdfColumnArgs = {
  createPdfColumnInput: CreatePdfColumnInput;
};


export type MutationCreatePermissionArgs = {
  createPermissionInput: CreatePermissionInput;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreatePicklistArgs = {
  createPicklistInput: CreatePicklistInput;
};


export type MutationCreatePieceArgs = {
  createPieceInput: CreatePieceInput;
};


export type MutationCreatePieceDocumentArgs = {
  createPieceDocumentInput: CreatePieceDocumentInput;
};


export type MutationCreatePieceReceiptArgs = {
  createPieceReceiptInput: CreatePieceReceiptInput;
};


export type MutationCreatePieceWithoutOrderArgs = {
  input: CreatePieceWithoutOrderInput;
};


export type MutationCreatePlaceArgs = {
  createPlaceInput: CreatePlaceInput;
};


export type MutationCreateProratedConsolidatedOrderArgs = {
  createProratedConsolidatedOrderInput: CreateProratedConsolidatedOrderInput;
};


export type MutationCreateQuickbooksHeaderFileMappingArgs = {
  createQuickbooksHeaderFileMappingInput: CreateQuickbooksHeaderFileMappingInput;
};


export type MutationCreateQuoteArgs = {
  createQuoteInput: CreateQuoteInput;
};


export type MutationCreateRecurringLineHaulManifestTemplateArgs = {
  input: CreateRecurringLineHaulManifestTemplateInput;
};


export type MutationCreateRecurringOrderFrequencyArgs = {
  createRecurringOrderFrequencyInput: CreateRecurringOrderFrequencyInput;
};


export type MutationCreateRecurringTemplateTruckArgs = {
  input: CreateRecurringTemplateTruckInput;
};


export type MutationCreateReportGroupConfigurationArgs = {
  createReportGroupConfigurationInput: ReportGroupConfigurationCreateInput;
};


export type MutationCreateReverseOrderArgs = {
  createReverseOrderInput: CreateReverseOrderInput;
};


export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};


export type MutationCreateRouteArgs = {
  createRouteInput: CreateRouteInput;
};


export type MutationCreateRouteDriverArgs = {
  createRouteDriverInput: CreateRouteDriverInput;
};


export type MutationCreateRouteFromRouteTemplateArgs = {
  input: CreateRouteFromRouteTemplateInput;
};


export type MutationCreateRouteNameArgs = {
  createRouteNameInput: CreateRouteNameInput;
};


export type MutationCreateRouteNameLocationArgs = {
  createRouteNameLocationInput: CreateRouteNameLocationInput;
  routeNameUuid: Scalars['String']['input'];
};


export type MutationCreateRouteOptimizationArgs = {
  createRouteOptimizationInput: CreateRouteOptimizationInput;
};


export type MutationCreateRoutePathsArgs = {
  routePathsCreateInput: RoutePathsCreateInput;
};


export type MutationCreateRouteSlotArgs = {
  createRouteSlotInput: CreateRouteSlotInput;
};


export type MutationCreateRoutesArgs = {
  createRoutesInput: CreateRoutesInput;
};


export type MutationCreateRunArgs = {
  createRunInput: CreateRunInput;
};


export type MutationCreateSameDayDispatchConfigArgs = {
  createSameDayDispatchConfigInput: CreateSameDayDispatchConfigInput;
};


export type MutationCreateSamsaraOauthTokenArgs = {
  createSamsaraOauthTokenInput: CreateSamsaraOauthTokenInput;
};


export type MutationCreateSandboxRouteForDriverArgs = {
  createSandboxRouteForDriverInput: CreateSandboxRouteForDriverInput;
};


export type MutationCreateSavedFilterViewArgs = {
  createSavedFilterViewInput: CreateSavedFilterViewInput;
};


export type MutationCreateScannedOrdersArgs = {
  createScannedOrdersInput: CreateScannedOrdersInput;
};


export type MutationCreateScannedOrdersFromAdminArgs = {
  createScannedOrdersFromAdminInput: CreateScannedOrdersFromAdminInput;
};


export type MutationCreateSchedulingRegionArgs = {
  input: CreateSchedulingRegionInput;
};


export type MutationCreateSchedulingResourceArgs = {
  input: CreateSchedulingResourceInput;
};


export type MutationCreateSchedulingZoneArgs = {
  input: CreateSchedulingZoneInput;
};


export type MutationCreateSchemaArgs = {
  createSchemaInput: CreateSchemaInput;
};


export type MutationCreateSchemaCompanyMappingArgs = {
  createSchemaCompanyMappingInput: CreateSchemaCompanyMappingInput;
};


export type MutationCreateSchemaDocumentArgs = {
  createSchemaDocumentInput: CreateSchemaDocumentInput;
};


export type MutationCreateSchemaTestSnapshotArgs = {
  createSchemaTestSnapshotInput: CreateSchemaTestSnapshotInput;
};


export type MutationCreateServiceArgs = {
  createServiceInput: CreateServiceInput;
};


export type MutationCreateServiceGroupArgs = {
  input: CreateServiceGroupInput;
};


export type MutationCreateServiceRegionsArgs = {
  input: CreateServiceRegionsInput;
};


export type MutationCreateSettlementAdjustmentArgs = {
  settlementAdjustmentCreateInput: SettlementAdjustmentCreateInput;
};


export type MutationCreateSettlementDeductionArgs = {
  settlementDeductionCreateInput: SettlementDeductionCreateInput;
};


export type MutationCreateSettlementDeductionTypeArgs = {
  settlementDeductionTypeCreateInput: SettlementDeductionTypeCreateInput;
};


export type MutationCreateSftpCredentialsArgs = {
  createSftpCredentialsInput: CreateSftpCredentialsInput;
};


export type MutationCreateShipmentDocumentArgs = {
  createShipmentDocumentInput: CreateShipmentDocumentInput;
};


export type MutationCreateStandardOrderArgs = {
  createStandardOrderInput: CreateStandardOrderInput;
};


export type MutationCreateStandardOrderFieldsArgs = {
  createStandardOrderFieldsInput: CreateStandardOrderFieldsInput;
};


export type MutationCreateStandardOrderWithDuplicateResolutionArgs = {
  createStandardOrderInput: CreateStandardOrderInput;
};


export type MutationCreateStandardShipmentFieldsArgs = {
  createStandardShipmentFieldsInput: CreateStandardShipmentFieldInput;
};


export type MutationCreateStorageOrderArgs = {
  createStorageOrderInput: CreateStorageOrderInput;
};


export type MutationCreateStorageOrderDocumentArgs = {
  createStorageOrderDocumentInput: CreateStorageOrderDocumentInput;
};


export type MutationCreateStorageUnitArgs = {
  createStorageUnitInput: CreateStorageUnitInput;
};


export type MutationCreateStorageUnitWithInventoryItemsArgs = {
  createStorageUnitWithInventoryItemsInput: CreateStorageUnitWithInventoryItemsInput;
};


export type MutationCreateTagArgs = {
  createTagInput: CreateTagInput;
};


export type MutationCreateTariffArgs = {
  createTariffInput: CreateTariffInput;
};


export type MutationCreateTariffChainArgs = {
  createTariffChainInput: CreateTariffChainInput;
};


export type MutationCreateTariffGroupArgs = {
  createTariffGroupInput: CreateTariffGroupInput;
};


export type MutationCreateTariffLocationArgs = {
  createTariffLocationInput: CreateTariffLocationInput;
};


export type MutationCreateTariffZoneArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneCreateInput: TariffZoneCreateInput;
};


export type MutationCreateTariffZoneGroupArgs = {
  tariffZoneGroupCreateInput: TariffZoneGroupCreateInput;
};


export type MutationCreateTerminalArgs = {
  createTerminalInput: CreateTerminalInput;
};


export type MutationCreateTerminalLanesArgs = {
  input: CreateTerminalLanesInput;
};


export type MutationCreateTerminalServiceAreaArgs = {
  createTerminalServiceAreaInput: CreateTerminalServiceAreaInput;
};


export type MutationCreateTerminalServiceAreasArgs = {
  createTerminalServiceAreaInputs: Array<CreateTerminalServiceAreaInput>;
};


export type MutationCreateTerminalServiceAreasV2Args = {
  createTerminalServiceAreaInputs: Array<CreateTerminalServiceAreaInput>;
};


export type MutationCreateTerminalV2Args = {
  input: TerminalCreateInput;
};


export type MutationCreateTerminalsArgs = {
  createTerminalsInput: CreateTerminalsInput;
};


export type MutationCreateTestAbstainedScannedOrderArgs = {
  createTestAbstainedScannedOrderInput: CreateTestAbstainedScannedOrderInput;
};


export type MutationCreateTestAccessorialArgs = {
  createTestAccessorialInput: CreateTestAccessorialInput;
};


export type MutationCreateTestApiOrderArgs = {
  input: CreateTestApiOrderInput;
};


export type MutationCreateTestCompanyArgs = {
  createTestCompanyInput: CreateTestCompanyInput;
};


export type MutationCreateTestContactArgs = {
  createTestContactInput: CreateTestContactInput;
};


export type MutationCreateTestDelegatableOrderArgs = {
  createTestDelegatableOrderInput: CreateTestDelegatableOrderInput;
};


export type MutationCreateTestEdiOrderArgs = {
  input: CreateTestEdiOrderInput;
};


export type MutationCreateTestOrderArgs = {
  createTestOrderInput: CreateTestOrderInput;
};


export type MutationCreateTestOrderCustomChargeArgs = {
  createTestOrderCustomChargeInput: CreateTestOrderCustomChargeInput;
};


export type MutationCreateTestOrderDelegationArgs = {
  createTestOrderDelegationInput: CreateTestOrderDelegationInput;
};


export type MutationCreateTestOrderQuoteArgs = {
  createTestOrderQuoteInput: CreateTestOrderQuoteInput;
};


export type MutationCreateTestOrderV2Args = {
  createTestOrderRequest: CreateTestOrderRequest;
};


export type MutationCreateTestOrganizationPeerArgs = {
  createTestOrganizationPeerInput: CreateTestOrganizationPeerInput;
};


export type MutationCreateTestPiecesOnOrderArgs = {
  input: CreateTestPiecesOnOrderInput;
};


export type MutationCreateTestReviewOrderArgs = {
  createTestReviewOrderInput: CreateTestReviewOrderInput;
};


export type MutationCreateTestTerminalLaneArgs = {
  input: CreateTestTerminalLaneInput;
};


export type MutationCreateTestThirdPartyUserArgs = {
  input: CreateTestThirdPartyUserInput;
};


export type MutationCreateTestUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateThirdPartyBrokerArgs = {
  thirdPartyBrokerCreateInput: ThirdPartyBrokerCreateInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateUserV2Args = {
  createUserInput: CreateUserInput;
};


export type MutationCreateVehicleTypeArgs = {
  vehicleTypeCreateInput: VehicleTypeCreateInput;
};


export type MutationCreateWarehouseArgs = {
  createWarehouseInput: CreateWarehouseInput;
};


export type MutationCreateWarehouseEmployeeArgs = {
  createWarehouseEmployeeInput: CreateWarehouseEmployeeInput;
};


export type MutationCreateWarehouseLocationArgs = {
  createWarehouseLocationInput: CreateWarehouseLocationInput;
};


export type MutationDeactivateTestTerminalArgs = {
  input: DeactivateTestTerminalInput;
};


export type MutationDeclineCustomerAppointmentOptionsArgs = {
  input: CustomerAppointmentTokenInput;
};


export type MutationDeclineOrderDelegationArgs = {
  input: DeclineOrderDelegationInput;
};


export type MutationDeclineQuoteArgs = {
  declineQuoteInput: DeclineQuoteInput;
};


export type MutationDeleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteAccessorialDateRangeConfigArgs = {
  deleteAccessorialDateRangeConfigInput: DeleteAccessorialDateRangeConfigInput;
};


export type MutationDeleteAccessorialGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAccessorialRangeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteAutoApplyAccessorialConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteContactCommentArgs = {
  deleteContactCommentInput: DeleteContactCommentInput;
};


export type MutationDeleteContactEmailArgs = {
  deleteContactEmailInput: DeleteContactEmailInput;
};


export type MutationDeleteCsvOrderFieldMappingArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteCustomDocumentNameArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDrayageShipmentFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDriverCredentialTypeArgs = {
  input: DeleteDriverCredentialTypeInput;
};


export type MutationDeleteDriverInsurancePolicyArgs = {
  input: DriverComplianceItemInput;
};


export type MutationDeleteDriverSignableFormTemplateArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDriverTrainingRecordArgs = {
  input: DriverComplianceItemInput;
};


export type MutationDeleteDwellTimeAlertConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteEdiPartnershipReferenceMappingsArgs = {
  deleteEdiPartnershipReferenceMappingsInput: DeleteEdiTypedReferenceMappingsInput;
};


export type MutationDeleteEdiPartnershipServiceMappingsArgs = {
  deleteEdiPartnershipServiceMappingsInput: DeleteEdiPartnershipServiceMappingsInput;
};


export type MutationDeleteEquipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteFeatureFlagCompanyOverrideArgs = {
  deleteFeatureFlagCompanyOverrideInput: DeleteFeatureFlagCompanyOverrideInput;
};


export type MutationDeleteFeatureFlagUserOverrideArgs = {
  deleteFeatureFlagUserOverrideInput: DeleteFeatureFlagUserOverrideInput;
};


export type MutationDeleteFreightChargeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteFuelProfileDateRangeArgs = {
  deleteFuelProfileDateRangeInput: DeleteFuelProfileDateRangeInput;
};


export type MutationDeleteGeneralLedgerCodeArgs = {
  input: GeneralLedgerCodeDeleteInput;
};


export type MutationDeleteInventoryCountArgs = {
  deleteInventoryCountInput: DeleteInventoryCountInput;
};


export type MutationDeleteInventoryItemsArgs = {
  deleteInventoryItemsInput: DeleteInventoryItemsInput;
};


export type MutationDeleteInvoiceNoteRuleArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteLegDriverMapArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteMirrorTargetArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteOrderCommentArgs = {
  deleteOrderCommentInput: DeleteOrderCommentInput;
};


export type MutationDeleteOrderDelegationRuleArgs = {
  input: DeleteOrderDelegationRuleInput;
};


export type MutationDeleteOrphanPieceArgs = {
  pieceUuid: Scalars['String']['input'];
};


export type MutationDeletePackageArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeletePaymentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeletePermissionArgs = {
  deletePermissionInput: DeletePermissionInput;
};


export type MutationDeletePieceReceiptArgs = {
  deletePieceReceiptInput: DeletePieceReceiptInput;
};


export type MutationDeleteQuickbooksHeaderFileMappingArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteQuoteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteRecurringLineHaulManifestTemplateArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteRecurringTemplateTruckArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteReportGroupConfigurationArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteRoleArgs = {
  deleteRoleInput: DeleteRoleInput;
};


export type MutationDeleteRouteNameLocationArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSameDayDispatchConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSavedFilterViewArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSchemaArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSchemaCompanyMappingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSchemaDocumentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSchemaRunArgs = {
  deleteSchemaRunInput: DeleteSchemaRunInput;
};


export type MutationDeleteServiceGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSlotsFromRouteArgs = {
  deleteSlotsFromRouteInput: DeleteSlotsFromRouteInput;
};


export type MutationDeleteStandardOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteStandardOrderFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteStopAttemptArgs = {
  deleteStopAttemptInput: DeleteStopAttemptInput;
};


export type MutationDeleteStopDriverMapArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteStorageOrderArgs = {
  deleteStorageOrderInput: DeleteStorageOrderInput;
};


export type MutationDeleteStorageOrdersArgs = {
  deleteStorageOrdersInput: DeleteStorageOrdersInput;
};


export type MutationDeleteStorageUnitArgs = {
  deleteStorageUnitInput: DeleteStorageUnitInput;
};


export type MutationDeleteTagArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffGroupArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffLocationArgs = {
  deleteTariffLocationInput: DeleteTariffLocationInput;
};


export type MutationDeleteTariffRangeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffZoneArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffZonesArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationDeleteTariffsArgs = {
  tariffsDeleteInput: TariffsDeleteInput;
};


export type MutationDeleteTerminalLanesArgs = {
  input: DeleteTerminalLanesInput;
};


export type MutationDeleteUserArgs = {
  deleteUserInput: DeleteUserInput;
};


export type MutationDeleteWarehouseArgs = {
  warehouseUuid: Scalars['String']['input'];
};


export type MutationDeleteWarehouseLocationArgs = {
  deleteWarehouseLocationInput: DeleteWarehouseLocationInput;
};


export type MutationDetachDocumentFromShipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDetachDocumentsFromShipmentsArgs = {
  detachDocumentsFromShipmentsInput: DetachDocumentsFromShipmentsInput;
};


export type MutationDismissDelegationAccessorialProposalArgs = {
  input: DismissDelegationAccessorialProposalInput;
};


export type MutationDismissOrganizationMessageArgs = {
  input: OrganizationMessageUuidInput;
};


export type MutationDismissQuoteArgs = {
  dismissQuoteInput: DismissQuoteInput;
};


export type MutationDismissScannedOrderResultArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDispatchApplySuggestedManifestsArgs = {
  input: DispatchApplySuggestedManifestsInput;
};


export type MutationDispatchTextDriverArgs = {
  textDriverInput: TextDriverInput;
};


export type MutationDocumentationAdminCreateItemArgs = {
  input: DocumentationItemCreateInput;
};


export type MutationDocumentationAdminCreateTopicArgs = {
  input: DocumentationTopicCreateInput;
};


export type MutationDocumentationAdminDeleteItemArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDocumentationAdminDeleteTopicArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDocumentationAdminReorderArgs = {
  input: DocumentationReorderInput;
};


export type MutationDocumentationAdminUpdateItemArgs = {
  input: DocumentationItemUpdateInput;
};


export type MutationDocumentationAdminUpdateTopicArgs = {
  input: DocumentationTopicUpdateInput;
};


export type MutationDownloadInvoicesArgs = {
  downloadInvoicesInput: DownloadInvoicesInput;
};


export type MutationDriverSettlementBillExportPdfArgs = {
  driverSettlementBillExportPdfInput: DriverSettlementBillExportPdfInput;
};


export type MutationDriverSettlementBillExportZipArgs = {
  input: DriverSettlementBillExportPdfInput;
};


export type MutationDuplicateEdiPartnershipsArgs = {
  duplicateEdiPartnershipsInput: DuplicateEdiPartnershipsInput;
};


export type MutationDuplicateTariffGroupArgs = {
  duplicateTariffGroupInput: DuplicateTariffGroupInput;
};


export type MutationEditContactsArgs = {
  editContactsInput: EditContactsInput;
};


export type MutationEmailAccountingReportArgs = {
  emailAccountingReportInput: EmailAccountingReportInput;
};


export type MutationEmailOrderDocumentArgs = {
  emailOrderDocumentInput: EmailOrderDocumentInput;
};


export type MutationEstimateDocExtractionEvalRunArgs = {
  input: EstimateDocExtractionEvalRunInput;
};


export type MutationExecutePackingPendencyArgs = {
  input: ExecutePackingPendencyInput;
};


export type MutationExemptSchedulingResourceFromCompanyBlockedDayArgs = {
  input: CompanySchedulingDayExemptionInput;
};


export type MutationExportInvoicesToQuickbooksDesktopArgs = {
  exportInvoicesToQuickbooksInput: ExportInvoicesToQuickbooksInput;
};


export type MutationFinalizeDriverSettlementBillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationFinalizeInvoicesArgs = {
  finalizeInvoicesInput: FinalizeInvoicesInput;
};


export type MutationFinalizeOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationFinalizeOrdersArgs = {
  finalizeOrdersInput: FinalizeOrdersInput;
};


export type MutationFinalizeSettlementBillsArgs = {
  finalizeSettlementBillsInput: FinalizeSettlementBillsInput;
};


export type MutationFireOutboundBenchTransactionArgs = {
  input: FireOutboundBenchTransactionInput;
};


export type MutationFlipIsArchivedArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationGenerateAccountingReportPreSignedPutUrlArgs = {
  generateAccountingReportPreSignedPutUrlInput: GenerateAccountingReportPreSignedPutUrlInput;
};


export type MutationGenerateClearCompanyContactsTokenArgs = {
  generateClearCompanyContactsTokenInput: GenerateClearCompanyContactsTokenInput;
};


export type MutationGenerateContactPreSignedPutUrlArgs = {
  generateContactPreSignedPutUrlInput: GenerateContactPreSignedPutUrlInput;
};


export type MutationGenerateHistoricalInvoicesCsvArgs = {
  generateHistoricalInvoicesCsvInput: GenerateHistoricalInvoicesCsvInput;
};


export type MutationGenerateInvoicePreSignedPutUrlArgs = {
  generateInvoicePreSignedPutUrlInput: GenerateInvoicePreSignedPutUrlInput;
};


export type MutationGenerateInvoicePreSignedPutUrlsArgs = {
  generateInvoicePreSignedPutUrlsInput: GenerateInvoicePreSignedPutUrlsInput;
};


export type MutationGenerateLabelArgs = {
  generateLabelInput: GenerateLabelInput;
};


export type MutationGenerateLineHaulRunsArgs = {
  input: GenerateLineHaulRunsInput;
};


export type MutationGenerateMobileSignedDocumentPreSignedPutUrlArgs = {
  input: UploadMobileSignedDocumentInput;
};


export type MutationGenerateOrderDocumentPreSignedPutUrlArgs = {
  generateOrderDocumentPreSignedPutUrlInput: GenerateOrderDocumentPreSignedPutUrlInput;
};


export type MutationGenerateOrderPreSignedGetAndPutUrlsArgs = {
  generateOrderPreSignedGetAndPutUrlsInput: GenerateOrderPreSignedGetAndPutUrlsInput;
};


export type MutationGenerateOrderPreSignedPutUrlArgs = {
  generateOrderPreSignedPutUrlInput: GenerateOrderPreSignedPutUrlInput;
};


export type MutationGeneratePiecePreSignedPutUrlArgs = {
  generatePiecePreSignedPutUrlInput: GeneratePiecePreSignedPutUrlInput;
};


export type MutationGeneratePodReportPreSignedPutUrlArgs = {
  generatePodReportPreSignedPutUrlInput: GeneratePodReportPreSignedPutUrlInput;
};


export type MutationGeneratePreSignedPutUrlArgs = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};


export type MutationGenerateResetCompanyTokenArgs = {
  generateResetCompanyTokenInput: GenerateResetCompanyTokenInput;
};


export type MutationGenerateShipmentPreSignedPutUrlArgs = {
  generateShipmentPreSignedPutUrlInput: GenerateShipmentPreSignedPutUrlInput;
};


export type MutationGenerateStorageOrderPreSignedPutUrlArgs = {
  generateStorageOrderPreSignedPutUrlInput: GenerateStorageOrderPreSignedPutUrlInput;
};


export type MutationHandleMultipleInvoices210OutboundArgs = {
  handleMultiple210OutboundInput: HandleMultiple210OutboundInput;
};


export type MutationImportCrownAccessorialArgs = {
  importCrownAccessorialInput: ImportCrownAccessorialInput;
};


export type MutationImportCrownContactsV2Args = {
  companyUuid: Scalars['String']['input'];
  csvUrl: Scalars['String']['input'];
  useNewImporter?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportCrownDriversArgs = {
  importCrownDriversInput: ImportCrownDriversInput;
};


export type MutationImportCrownInvoicesArgs = {
  importCrownInvoicesInput: ImportCrownInvoicesInput;
};


export type MutationImportCrownLanesArgs = {
  importCrownLanesInput: ImportCrownLanesInput;
};


export type MutationImportCrownOrdersArgs = {
  importCrownOrdersInput: ImportCrownOrdersInput;
};


export type MutationImportCrownPaymentsArgs = {
  importCrownPaymentsInput: ImportCrownPaymentsInput;
};


export type MutationImportCrownTariffArgs = {
  importCrownTariffInput: ImportCrownTariffInput;
};


export type MutationImportCrownUsersArgs = {
  importCrownUsersInput: ImportCrownUsersInput;
};


export type MutationImportCustomerDefaultAddressesArgs = {
  companyUuid: Scalars['String']['input'];
  csvUrl: Scalars['String']['input'];
};


export type MutationImportQuickbooksDesktopMappingsArgs = {
  companyUuid: Scalars['String']['input'];
  qbDesktopMappingsUrl: Scalars['String']['input'];
};


export type MutationImportRecoveryTerminalArgs = {
  importRecoveryTerminalInput: ImportRecoveryTerminalInput;
};


export type MutationImportStorageOrdersFromCsvArgs = {
  importStorageOrdersFromCsvInput: ImportStorageOrdersFromCsvInput;
};


export type MutationImportTerminalServiceAreasArgs = {
  importTerminalServiceAreasInput: ImportTerminalServiceAreasInput;
};


export type MutationImportTestSnapshotArgs = {
  importTestSnapshotInput: ImportTestSnapshotInput;
};


export type MutationImportThirdPartyPortalAccountEmailsArgs = {
  companyUuid: Scalars['String']['input'];
  csvUrl: Scalars['String']['input'];
};


export type MutationImportWarehouseLocationsFromCsvArgs = {
  importWarehouseLocationsFromCsvInput: ImportWarehouseLocationsFromCsvInput;
};


export type MutationInitiateDelegatedOrderReviewArgs = {
  input: InitiateDelegatedOrderReviewInput;
};


export type MutationKpiRecordTableDownloadArgs = {
  args: KpiRecordTableDownloadArgs;
};


export type MutationLinkPieceToOrderArgs = {
  orderUuid: Scalars['String']['input'];
  packageUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};


export type MutationLinkPieceToOrderWithRoleArgs = {
  input: LinkPieceToOrderInput;
};


export type MutationLinkPieceToPackageArgs = {
  linkPieceToPackageInput: LinkPieceToPackageInput;
};


export type MutationLinkPiecesToPackageArgs = {
  linkPiecesToPackageInput: LinkPiecesToPackageInput;
};


export type MutationLogUnassignedScanArgs = {
  logUnassignedScanInput: LogUnassignedScanInput;
};


export type MutationLoginArgs = {
  loginInputData: LoginInput;
};


export type MutationLoginInternalArgs = {
  loginInputData: LoginInput;
};


export type MutationLoginPhoneArgs = {
  loginPhoneInput: LoginPhoneInput;
};


export type MutationLoginPhoneJwtArgs = {
  loginPhoneJwtInput: LoginPhoneJwtInput;
};


export type MutationLoginPhoneJwtV2Args = {
  loginPhoneJwtInput: LoginPhoneJwtInput;
};


export type MutationLoginPhoneV2Args = {
  loginPhoneInput: LoginPhoneInput;
};


export type MutationMakeAppointmentConfirmationDecisionArgs = {
  input: MakeAppointmentConfirmationDecisionInput;
};


export type MutationManuallySetInvoicesQbSyncStatusArgs = {
  invoiceUuids: Array<Scalars['String']['input']>;
  synced: Scalars['Boolean']['input'];
};


export type MutationMapPeerAccessorialArgs = {
  input: MapPeerAccessorialInput;
};


export type MutationMapPeerServiceArgs = {
  input: MapPeerServiceInput;
};


export type MutationMarkAsCancelledArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkAsOnHoldArgs = {
  markAsOnHoldInput: MarkAsOnHoldInput;
};


export type MutationMarkAttemptedStopAsCompleteArgs = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  stopUuid: Scalars['String']['input'];
};


export type MutationMarkConsolidatableOrdersAsBilledIndividuallyArgs = {
  markConsolidatableOrdersAsBilledIndividuallyInput: MarkConsolidatableOrdersAsBilledIndividuallyInput;
};


export type MutationMarkManifestAsArrivedArgs = {
  markManifestAsArrivedInput: MarkManifestAsArrivedInput;
};


export type MutationMarkManifestAsDepartedArgs = {
  markManifestAsDepartedInput: MarkManifestAsDepartedInput;
};


export type MutationMarkManifestAsDoorsClosedArgs = {
  markManifestAsDoorsClosedInput: MarkManifestAsDoorsClosedInput;
};


export type MutationMarkManifestAsPlanningArgs = {
  markManifestAsPlanningInput: MarkManifestAsPlanningInput;
};


export type MutationMarkNotOsdArgs = {
  markAsNotOsd: MarkNotOsdInput;
};


export type MutationMarkNotificationReadArgs = {
  input: MarkNotificationReadInput;
};


export type MutationMarkOrderAsCompleteForceArgs = {
  markOrderAsCompleteForceInput: MarkOrderAsCompleteForceInput;
};


export type MutationMarkOrderAsHasBillingIssueArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsNotCompleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsNotOnHandArgs = {
  markAsNotOnHandInput: MarkAsNotOnHandInput;
};


export type MutationMarkOrderAsNotReadyToInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsNotReceivedAtOriginArgs = {
  markAsNotReceivedAtOriginInput: MarkAsNotReceivedAtOriginInput;
};


export type MutationMarkOrderAsOnHandArgs = {
  markAsOnHandInput: MarkAsOnHandInput;
};


export type MutationMarkOrderAsPickedArgs = {
  markOrderAsPickedInput: MarkOrderAsPickedInput;
};


export type MutationMarkOrderAsReadyToInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsReadyToInvoiceForceArgs = {
  refuseOrderInput?: InputMaybe<RefuseOrderInput>;
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsReceivedAtOriginArgs = {
  markAsReceivedAtOriginInput: MarkAsReceivedAtOriginInput;
};


export type MutationMarkOrderAsRefusedArgs = {
  markOrderAsRefusedInput: MarkOrderAsRefusedInput;
};


export type MutationMarkOsdArgs = {
  markOsdInput: MarkOsdInput;
};


export type MutationMarkPieceDamagedArgs = {
  markPieceDamagedInput: MarkPieceDamagedInput;
};


export type MutationMarkQuoteSentArgs = {
  markQuoteSentInput: MarkQuoteSentInput;
};


export type MutationMarkStopAsFailedArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkStopAsFailedV2Args = {
  markStopAsFailedV2Input: MarkStopAsFailedV2Input;
};


export type MutationMarkStopAsIncompleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkStorageUnitAsBilledArgs = {
  markStorageUnitAsBilledInput: MarkStorageUnitAsBilledInput;
};


export type MutationMarkStorageUnitAsOsdArgs = {
  markStorageUnitAsOsdInput: MarkStorageUnitAsOsdInput;
};


export type MutationMarkStorageUnitOnHandArgs = {
  markStorageUnitOnHandInput: MarkStorageUnitOnHandInput;
};


export type MutationMarkTestOrderForEdiReviewArgs = {
  markTestOrderForEdiReviewInput: MarkTestOrderForEdiReviewInput;
};


export type MutationMarkTutorialSeenArgs = {
  tutorialId: TutorialId;
};


export type MutationMarkWarehouseAsDefaultArgs = {
  warehouseUuid: Scalars['String']['input'];
};


export type MutationMatchFreightSnapArgs = {
  freightSnapCreateInput: FreightSnapCreateInput;
};


export type MutationMatchSignedPoDsArgs = {
  matchSignedPODsInput: CreateScannedOrdersInput;
};


export type MutationMergeEdiOrderArgs = {
  mergeEdiOrderInput: MergeEdiOrderInput;
};


export type MutationMergeScannedOrderResultIntoPossibleDuplicateArgs = {
  input: MergeScannedOrderResultIntoPossibleDuplicateInput;
};


export type MutationMoveShipmentsBetweenInvoicesArgs = {
  moveShipmentsBetweenInvoicesInput: MoveShipmentsBetweenInvoicesInput;
};


export type MutationMoveShipmentsToInvoiceArgs = {
  moveShipmentsToInvoiceInput: MoveShipmentsToInvoiceInput;
};


export type MutationNormalizeDocumentArgs = {
  normalizeDocumentInput: NormalizeDocumentInput;
};


export type MutationOffboardCompanyFromQuoteAgentArgs = {
  input: OffboardCompanyFromQuoteAgentInput;
};


export type MutationOpenMessageInOutlookArgs = {
  openMessageInOutlookInput: OpenMessageInOutlookInput;
};


export type MutationOptimizeRouteSequenceArgs = {
  input: OptimizeRouteSequenceInput;
};


export type MutationOptimizeRoutesTogetherArgs = {
  input: OptimizeRoutesTogetherInput;
};


export type MutationPackPiecesArgs = {
  input: PackPiecesInput;
};


export type MutationParseCsvOrdersArgs = {
  input: ParseCsvOrdersInput;
};


export type MutationPickQuoteCustomerArgs = {
  pickQuoteCustomerInput: PickQuoteCustomerInput;
};


export type MutationPickStorageUnitArgs = {
  pickStorageUnitInput: PickStorageUnitInput;
};


export type MutationPreviewDocExtractionEvalSetArgs = {
  config: Scalars['JSON']['input'];
};


export type MutationProrateOrdersArgs = {
  prorateOrdersInput: ProrateOrdersInput;
};


export type MutationPublishOrganizationMessageArgs = {
  input: PublishOrganizationMessageInput;
};


export type MutationQueueAppointmentSchedulingProposalsArgs = {
  input: QueueAppointmentSchedulingProposalsInput;
};


export type MutationQueueAppointmentTextsArgs = {
  queueAppointmentTextsArgs: QueueAppointmentTextsArgs;
};


export type MutationReactivateUserArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationReanalyzePageArgs = {
  reanalyzePageInput: ReanalyzePageInput;
};


export type MutationReanalyzeSchemaFileArgs = {
  reanalyzeSchemaFileInput: ReanalyzeSchemaFileInput;
};


export type MutationReassignRouteSlotArgs = {
  routeSlotReassignInput: RouteSlotReassignInput;
};


export type MutationReconfigureDriverSettlementPayTermsArgs = {
  input: ReconfigureDriverSettlementPayTermsInput;
};


export type MutationRecordContactAttemptedArgs = {
  recordContactAttemptedArgs: RecordContactAttemptedArgs;
};


export type MutationRecordInboundReviewDecisionsArgs = {
  input: RecordInboundReviewDecisionsInput;
};


export type MutationRecordInventoryCountUnexpectedArgs = {
  recordInventoryCountUnexpectedInput: RecordInventoryCountUnexpectedInput;
};


export type MutationRecreateScannedOrderForEmailAttachmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRefreshAuthTokenArgs = {
  refreshAuthTokenInput: RefreshAuthTokenInput;
};


export type MutationRefreshEtasForRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRehireDriverArgs = {
  input: RehireDriverInput;
};


export type MutationRejectCustomerPortalOrderArgs = {
  rejectCustomerPortalOrderInput: RejectCustomerPortalOrderInput;
};


export type MutationRejectDelegationEndCustomerLinkArgs = {
  input: RejectDelegationEndCustomerLinkInput;
};


export type MutationRejectEdiOrderArgs = {
  rejectEdiOrderInput: RejectEdiOrderInput;
};


export type MutationRejectEdiOrdersArgs = {
  rejectEdiOrdersInput: RejectEdiOrdersInput;
};


export type MutationRejectExpeditorsWorkOrderArgs = {
  orderUuid: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectQuoteReplyArgs = {
  rejectQuoteReplyInput: RejectQuoteReplyInput;
};


export type MutationRemoveAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveAddressArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveApiUserContactMappingArgs = {
  removeApiUserContactMappingInput: RemoveApiUserContactMappingInput;
};


export type MutationRemoveBusinessDivisionArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveContactArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveContactPersonArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveContactsArgs = {
  removeContactsInput: RemoveContactsInput;
};


export type MutationRemoveCoverSheetDocumentTypeSequenceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveCreditTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveDispatchViewArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveDriverSettlementBillArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveDriversFromRouteArgs = {
  removeDriversFromRouteInput: RemoveDriversFromRouteInput;
};


export type MutationRemoveEmailTransactionLogArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveFeatureFlagArgs = {
  removeFeatureFlagInput: FeatureFlagRemoveInput;
};


export type MutationRemoveFuelProfileArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveGeneralLedgerCodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveGeneralLedgerConfigurationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveHelperFromRouteArgs = {
  helperUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};


export type MutationRemoveHoldReasonArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveImportedOrderTypeMappingArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveInvoiceTermsArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineHaulLaneArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineHaulManifestArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineHaulSegmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineItemsFromSettlementBillArgs = {
  removeLineItemsFromSettlementBillInput: RemoveLineItemsFromSettlementBillInput;
};


export type MutationRemoveMasterAccountArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveOrderHoldArgs = {
  removeOrderHoldInput: RemoveOrderHoldInput;
};


export type MutationRemoveOrderLineHaulSegmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveOrdersFromManifestArgs = {
  removeOrdersFromManifestInput: RemoveOrdersFromManifestInput;
};


export type MutationRemoveOrdersFromManifestV2Args = {
  input: RemoveOrdersFromManifestV2Input;
};


export type MutationRemovePaymentOffsetArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemovePiecesFromPieceReceiptArgs = {
  removePiecesFromPieceReceiptInput: RemovePiecesFromPieceReceiptInput;
};


export type MutationRemoveRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveRouteDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveSchedulingResourceCompanyBlockedDayExemptionArgs = {
  input: CompanySchedulingDayExemptionInput;
};


export type MutationRemoveServiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveServiceToContactArgs = {
  removeServiceFromContactInput: RemoveServiceFromContactInput;
};


export type MutationRemoveSettlementAdjustmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveSettlementDeductionArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveSettlementDeductionTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveShipmentsFromInvoiceArgs = {
  removeShipmentsFromInvoiceInput: RemoveShipmentsFromInvoiceInput;
};


export type MutationRemoveSpecialAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveStopsFromRoutesArgs = {
  removeStopsFromRoutesInput: RemoveStopsFromRoutesInputType;
};


export type MutationRemoveStorageUnitOnHandArgs = {
  removeStorageUnitOnHandInput: RemoveStorageUnitOnHandInput;
};


export type MutationRemoveStorageUnitOsdArgs = {
  removeStorageUnitOsdInput: RemoveStorageUnitOsdInput;
};


export type MutationRemoveSubscriberFromShipmentArgs = {
  removeSubscriberInput: RemoveSubscriberInput;
};


export type MutationRemoveTagFromLegArgs = {
  removeTagFromLegInput: RemoveTagFromLegInput;
};


export type MutationRemoveTagFromOrderArgs = {
  removeTagFromOrderInput: RemoveTagFromOrderInput;
};


export type MutationRemoveTerminalArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveTerminalServiceAreaArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveThirdPartyBrokerArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveThirdPartyUserFromContactArgs = {
  removeThirdPartyUserFromContactInput: RemoveThirdPartyUserFromContactInput;
};


export type MutationRemoveUserFromRoleArgs = {
  removeUserFromRoleInput: RemoveUserFromRoleInput;
};


export type MutationRemoveVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveZoneBasedAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationReplayOutboundEdiArgs = {
  replayOutboundEdiInput: ReplayOutboundEdiInput;
};


export type MutationReportADocScanIssueArgs = {
  reportADocScanIssueInput: ReportADocScanIssueInput;
};


export type MutationRequestCustomerAppointmentLinkArgs = {
  input: CustomerAppointmentTokenInput;
};


export type MutationRequestOrderMirrorSyncArgs = {
  input: RequestOrderMirrorSyncInput;
};


export type MutationRequestQuoteRepriceArgs = {
  requestQuoteRepriceInput: RequestQuoteRepriceInput;
};


export type MutationRequoteQuoteAtCurrentPriceArgs = {
  requoteQuoteAtCurrentPriceInput: RequoteQuoteAtCurrentPriceInput;
};


export type MutationRerateOrderFreightArgs = {
  orderUuid: Scalars['String']['input'];
};


export type MutationRerateQuoteFreightArgs = {
  quoteUuid: Scalars['String']['input'];
};


export type MutationRescheduleOrganizationMessageArgs = {
  input: ScheduleOrganizationMessageInput;
};


export type MutationResendExternalTransmissionArgs = {
  input: ResendExternalTransmissionInput;
};


export type MutationResetCompanyArgs = {
  resetCompanyInput: ResetCompanyInput;
};


export type MutationResolveOrganizationMessageArgs = {
  input: ResolveOrganizationMessageInput;
};


export type MutationResolveQuoteReplySendArgs = {
  resolveQuoteReplySendInput: ResolveQuoteReplySendInput;
};


export type MutationResolveScannedOrderBillingPartyArgs = {
  resolveScannedOrderBillingPartyInput: ResolveScannedOrderBillingPartyInput;
};


export type MutationRestoreAirportInfoArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRestoreContactStationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRestoreOrganizationArgs = {
  input: RestoreOrganizationInput;
};


export type MutationRestorePackageSpecArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestorePersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreSchedulingRegionArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreSchedulingResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreSchedulingZoneArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreTariffChainArgs = {
  restoreTariffChainInput: RestoreTariffChainInput;
};


export type MutationRestoreTariffZoneGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRestoreWarehouseEmployeeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRetryFailedInvoice210OutboundArgs = {
  invoiceUuid: Scalars['String']['input'];
};


export type MutationRetryInvoiceSendJobBatchesArgs = {
  invoiceSendJobBatchUuids: Array<Scalars['String']['input']>;
  skipFailures: Scalars['Boolean']['input'];
};


export type MutationRetrySftpUploadsArgs = {
  retrySftpUploadsInput: RetrySftpUploadsInput;
};


export type MutationReuploadPodsArgs = {
  reuploadPodsInput: ReuploadPodsInput;
};


export type MutationRevokeOrganizationPeerArgs = {
  input: RevokeOrganizationPeerInput;
};


export type MutationRotateDocumentArgs = {
  rotateDocumentInput: RotateDocumentInput;
};


export type MutationRotateQuoteAgentForwardingTokenArgs = {
  connectionUuid: Scalars['String']['input'];
};


export type MutationRunOptimizationArgs = {
  createOptimizationRunInput: CreateOptimizationRunDto;
};


export type MutationRunTestAccessorialDetectionArgs = {
  runTestAccessorialDetectionInput: RunTestAccessorialDetectionInput;
};


export type MutationSamsaraDiscoverySetTokenArgs = {
  input: SamsaraDiscoverySetTokenInput;
};


export type MutationSaveCostInputQuickbooksMappingsArgs = {
  input: SaveCostInputQuickbooksMappingsInput;
};


export type MutationSaveCostInputSetupArgs = {
  input: SaveCostInputSetupInput;
};


export type MutationSaveCostInputsArgs = {
  input: SaveCostInputsInput;
};


export type MutationSavePointToPointLanesArgs = {
  input: SavePointToPointLanesInput;
};


export type MutationSaveSmc3SettingsArgs = {
  input: SaveSmc3SettingsInput;
};


export type MutationSaveTenediPartnershipArgs = {
  input: SaveTenediPartnershipInput;
};


export type MutationScanOrderArgs = {
  scanOrderInput: ScanOrderInput;
};


export type MutationScanOrderBarcodeArgs = {
  scanOrderBarcodeInput: ScanOrderBarcodeInput;
};


export type MutationScanPieceArgs = {
  scanPieceInput: ScanPieceInput;
};


export type MutationScanWarehouseLocationArgs = {
  scanWarehouseLocationInput: ScanWarehouseLocationInput;
};


export type MutationScanningV2__BulkProcessPiecesArgs = {
  input: FreightScanningV2BulkProcessPiecesInput;
};


export type MutationScanningV2__CommitWorkOrderScanArgs = {
  input: FreightScanningV2CommitWorkOrderScanInput;
};


export type MutationScanningV2__MoveWarehouseLocationArgs = {
  input: FreightScanningV2MoveWarehouseLocationInput;
};


export type MutationScanningV2__ProcessBarcodeArgs = {
  input: FreightScanningV2ProcessBarcodeInput;
};


export type MutationScanningV2__ProcessBarcodeLeanArgs = {
  input: FreightScanningV2ProcessBarcodeInput;
};


export type MutationScanningV2__SelectPackageArgs = {
  input: FreightScanningV2SelectPackageInput;
};


export type MutationScheduleOrganizationMessageArgs = {
  input: ScheduleOrganizationMessageInput;
};


export type MutationSelectRoleArgs = {
  selectRoleInput: SelectRoleInput;
};


export type MutationSendAccountingReportsArgs = {
  sendAccountingReportsInput: SendAccountingReportsInput;
};


export type MutationSendDeliveryCompletedArgs = {
  sendDeliveryCompletedInput: SendDeliveryCompletedInput;
};


export type MutationSendInvoicesArgs = {
  sendInvoicesInput: SendInvoicesInput;
};


export type MutationSendMetricArgs = {
  sendMetricInput: SendMetricInput;
};


export type MutationSendRouteToAgentArgs = {
  input: SendRouteToAgentInput;
};


export type MutationSendStopToAgentArgs = {
  input: SendStopToAgentInput;
};


export type MutationSetAccessorialQboItemMappingArgs = {
  input: SetAccessorialQboItemMappingInput;
};


export type MutationSetCompanyAccountTypeArgs = {
  input: SetCompanyAccountTypeInput;
};


export type MutationSetContactChargeMatrixColumnMappingsArgs = {
  setContactChargeMatrixColumnMappingsInput: SetContactChargeMatrixColumnMappingsInput;
};


export type MutationSetDockDoorsArgs = {
  input: SetDockDoorsInput;
};


export type MutationSetDriverComplianceDatesArgs = {
  input: SetDriverComplianceDatesInput;
};


export type MutationSetDriverSettlementPayBoundsArgs = {
  input: SetDriverSettlementPayBoundsInput;
};


export type MutationSetLaneDefaultDoorArgs = {
  input: SetLaneDefaultDoorInput;
};


export type MutationSetLineHaulManifestDepartTimeArgs = {
  input: SetManifestDepartTimeInput;
};


export type MutationSetLineHaulManifestLoadPositionArgs = {
  input: SetLineHaulManifestLoadPositionInput;
};


export type MutationSetLineHaulManifestOrderLoadPositionArgs = {
  input: SetLineHaulManifestOrderLoadPositionInput;
};


export type MutationSetLineHaulManifestOriginTerminalArgs = {
  input: SetManifestOriginTerminalInput;
};


export type MutationSetLineHaulManifestTrailersArgs = {
  input: SetManifestTrailersInput;
};


export type MutationSetLineHaulManifestTruckArgs = {
  input: SetManifestTruckInput;
};


export type MutationSetLineHaulSegmentTimingArgs = {
  input: SetLineHaulSegmentTimingInput;
};


export type MutationSetMirrorTargetCompaniesArgs = {
  input: SetMirrorTargetCompaniesInput;
};


export type MutationSetMotiveApiKeyArgs = {
  input: SetMotiveApiKeyInput;
};


export type MutationSetNotificationCutoverModeArgs = {
  input: SetNotificationCutoverModeInput;
};


export type MutationSetOrderExecutedByArgs = {
  input: SetOrderExecutedByInput;
};


export type MutationSetOrderMirrorCaptureConfigArgs = {
  input: SetOrderMirrorCaptureConfigInput;
};


export type MutationSetOrganizationEmitPieceLevelWebhooksArgs = {
  enabled: Scalars['Boolean']['input'];
  organizationUuid: Scalars['String']['input'];
};


export type MutationSetOrganizationRequireScanToAdvancePieceStatusAtStopsArgs = {
  enabled: Scalars['Boolean']['input'];
  organizationUuid: Scalars['String']['input'];
};


export type MutationSetPeerAccessorialSharesArgs = {
  input: SetPeerAccessorialSharesInput;
};


export type MutationSetPeerServiceSharesArgs = {
  input: SetPeerServiceSharesInput;
};


export type MutationSetSchedulingResourceEligibilityRulesArgs = {
  input: SetSchedulingResourceEligibilityRulesInput;
};


export type MutationSetStorageOrderItemQuantityArgs = {
  setStorageOrderItemQuantityInput: SetStorageOrderItemQuantityInput;
};


export type MutationSetTerminalTimeZoneArgs = {
  input: SetTerminalTimeZoneInput;
};


export type MutationShareSavedFilterViewArgs = {
  shareSavedFilterViewInput: ShareSavedFilterViewInput;
};


export type MutationSignUpForThirdPartyUserAccountArgs = {
  signUpForThirdPartyUserAccountInput: SignUpForThirdPartyUserAccountInput;
};


export type MutationSplitAndProcessOrderDocumentsArgs = {
  splitAndProcessOrderDocumentsInput: SplitAndProcessOrderDocumentsInput;
};


export type MutationStartConfigMigrationArgs = {
  input: StartConfigMigrationInput;
};


export type MutationStartInventoryCountArgs = {
  startInventoryCountInput: StartInventoryCountInput;
};


export type MutationStartPieceBackfillRunArgs = {
  input: StartPieceBackfillRunInput;
};


export type MutationStartRouteArgs = {
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationSyncInvoiceStatusWithQuickbooksArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationSyncInvoicesToQuickbooksArgs = {
  options?: InputMaybe<QuickbooksSyncOptionsInput>;
  uuids: Array<Scalars['String']['input']>;
};


export type MutationTerminateDriverArgs = {
  input: TerminateDriverInput;
};


export type MutationTestOneSnapshotArgs = {
  testOneSnapshotInput: TestOneSnapshotInput;
};


export type MutationTestSchemaArgs = {
  testSchemaInput: TestSchemaInput;
};


export type MutationTestSmc3RateArgs = {
  input: TestSmc3RateInput;
};


export type MutationTextDriverArgs = {
  textDriverInput: TextDriverInput;
};


export type MutationTextractSchemaFileArgs = {
  textractSchemaFileInput: TextractSchemaFileInput;
};


export type MutationTextractSchemaTestFileArgs = {
  textractSchemaTestFileInput: TextractSchemaTestFileInput;
};


export type MutationTransferPieceToOrderArgs = {
  input: TransferPieceToOrderInput;
};


export type MutationTransferPieceToOutboundOrderArgs = {
  input: TransferPieceToOutboundOrderInput;
};


export type MutationTransitionAppointmentArgs = {
  transitionAppointmentInput: TransitionAppointmentInput;
};


export type MutationTriggerAdhocPreviewArgs = {
  input: TriggerAdhocPreviewInput;
};


export type MutationTriggerAdhocPreviewBatchArgs = {
  input: TriggerAdhocPreviewBatchInput;
};


export type MutationTriggerIngestionTestRunArgs = {
  input: TriggerIngestionTestRunInput;
};


export type MutationUnassignInventoryItemsArgs = {
  unassignInventoryItemsInput: UnassignInventoryItemsInput;
};


export type MutationUnassignLegFromDriverArgs = {
  unassignLegFromDriver: UnassignLegFromDriverInput;
};


export type MutationUnassignOrderFromLineHaulTrailerArgs = {
  input: UnassignOrderFromTrailerInput;
};


export type MutationUnblockCompanySchedulingDayArgs = {
  input: UnblockCompanySchedulingDayInput;
};


export type MutationUnblockSchedulingResourceDayArgs = {
  input: UnblockSchedulingResourceDayInput;
};


export type MutationUncancelOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationUnconsolidateOrderArgs = {
  unconsolidateOrderInput: UnconsolidateOrderInput;
};


export type MutationUnfinalizeOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationUnfinalizeOrdersArgs = {
  unfinalizeOrdersInput: UnfinalizeOrdersInput;
};


export type MutationUnlinkPieceFromOrderArgs = {
  input: UnlinkPieceFromOrderInput;
};


export type MutationUnlinkPieceFromPackageArgs = {
  unlinkPieceFromPackageInput: UnlinkPieceFromPackageInput;
};


export type MutationUnmarkPieceDamagedArgs = {
  pieceUuid: Scalars['String']['input'];
};


export type MutationUnpackPiecesArgs = {
  input: UnpackPiecesInput;
};


export type MutationUnpickOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationUnpickStorageUnitArgs = {
  unpickStorageUnitInput: UnpickStorageUnitInput;
};


export type MutationUnpostInvoiceArgs = {
  unpostInvoiceInput: UnpostInvoiceInput;
};


export type MutationUnpostInvoicesArgs = {
  unpostInvoicesInput: UnpostInvoicesInput;
};


export type MutationUpdateArgs = {
  updateEquipmentLicenseInput: UpdateEquipmentLicenseInput;
};


export type MutationUpdateAccessorialArgs = {
  updateAccessorialInput: UpdateAccessorialInput;
};


export type MutationUpdateAccessorialContactArgs = {
  accessorialContactInput: UpdateAccessorialContactInput;
};


export type MutationUpdateAccessorialDateRangeConfigArgs = {
  updateAccessorialDateRangeConfigInput: UpdateAccessorialDateRangeConfigInput;
};


export type MutationUpdateAccessorialGroupArgs = {
  input: UpdateAccessorialGroupInput;
};


export type MutationUpdateAccessorialRangesForAccessorialArgs = {
  accessorialRangeUpdatesInput: AccessorialRangeUpdatesInput;
};


export type MutationUpdateAccessorialToQuickbooksMappingArgs = {
  accessorialToQuickbooksMappingUpdateInput: AccessorialToQuickbooksMappingUpdateInput;
};


export type MutationUpdateAddressArgs = {
  updateAddressInput: UpdateAddressInput;
};


export type MutationUpdateAirportInfoArgs = {
  updateAirportInfoInput: UpdateAirportInfoInput;
};


export type MutationUpdateApiUserArgs = {
  updateApiUserInput: UpdateApiUserInput;
};


export type MutationUpdateAutoApplyAccessorialConfigArgs = {
  updateAutoApplyAccessorialConfigInput: UpdateAutoApplyAccessorialConfigInput;
};


export type MutationUpdateBusinessDivisionArgs = {
  updateBusinessDivisionInput: UpdateBusinessDivisionInput;
};


export type MutationUpdateCompanyArgs = {
  updateCompanyInput: UpdateCompanyInput;
};


export type MutationUpdateCompanyConfigurationArgs = {
  updateCompanyConfigurationInput: UpdateCompanyConfigurationInput;
};


export type MutationUpdateContactCommentArgs = {
  updateContactCommentInput: UpdateContactCommentInput;
};


export type MutationUpdateContactCommunicationConfigArgs = {
  updateContactCommunicationConfigInput: UpdateContactCommunicationConfigInput;
};


export type MutationUpdateContactEmailsArgs = {
  input: UpdateContactEmailsInput;
};


export type MutationUpdateContactPersonArgs = {
  updateContactPersonInput: UpdateContactPersonInput;
};


export type MutationUpdateContactStationArgs = {
  contactStationUpdateInput: ContactStationUpdateInput;
};


export type MutationUpdateContactToServicesTariffGroupMappingsArgs = {
  contactToServicesMappings: Array<CreateContactToServicesMappingInput>;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateCoverSheetDocumentTypeSequenceArgs = {
  coverSheetDocumentTypeSequenceUpdateInput: CoverSheetDocumentTypeSequenceUpdateInput;
};


export type MutationUpdateCreditTypeArgs = {
  creditTypeUpdateInput: CreditTypeUpdateInput;
};


export type MutationUpdateCsvOrderFieldMappingArgs = {
  updateCsvOrderFieldMappingInput: UpdateCsvOrderFieldMappingInput;
};


export type MutationUpdateCsvOrderImportTransactionArgs = {
  updateCsvOrderImportTransactionInput: UpdateCsvOrderImportTransactionInput;
};


export type MutationUpdateCsvOrderMappingArgs = {
  updateCsvOrderMappingInput: UpdateCsvOrderMappingInput;
};


export type MutationUpdateCustomerContactArgs = {
  updateCustomerContactInput: UpdateCustomerContactInput;
};


export type MutationUpdateCustomerContactPackageSpecsArgs = {
  input: UpdateCustomerContactPackageSpecsInput;
};


export type MutationUpdateCustomerContactVehicleTypesArgs = {
  input: UpdateCustomerContactVehicleTypesInput;
};


export type MutationUpdateDefaultTariffChainsForCompanyArgs = {
  updateDefaultTariffChainsForCompanyInput: UpdateDefaultTariffChainsForCompanyInput;
};


export type MutationUpdateDispatchTableColorsArgs = {
  input: UpdateDispatchTableColorsInput;
};


export type MutationUpdateDispatchViewArgs = {
  dispatchViewUpdateInput: DispatchViewUpdateInput;
};


export type MutationUpdateDocumentArgs = {
  updateDocumentInput: UpdateDocumentInput;
};


export type MutationUpdateDocumentsArgs = {
  updateDocumentsInput: UpdateDocumentsInput;
};


export type MutationUpdateDriverArgs = {
  updateDriverInput: UpdateDriverInput;
};


export type MutationUpdateDriverComplianceProfileArgs = {
  input: UpdateDriverComplianceProfileInput;
};


export type MutationUpdateDriverCredentialTypeArgs = {
  input: UpdateDriverCredentialTypeInput;
};


export type MutationUpdateDriverInsurancePolicyArgs = {
  input: UpdateDriverInsurancePolicyInput;
};


export type MutationUpdateDriverLocationArgs = {
  updateDriverLocationInput: UpdateDriverLocationInput;
};


export type MutationUpdateDriverQualificationsArgs = {
  input: UpdateDriverQualificationsInput;
};


export type MutationUpdateDriverSettlementBillArgs = {
  updateDriverSettlementBillInput: UpdateDriverSettlementBillInput;
};


export type MutationUpdateDriverSignableFormTemplateArgs = {
  updateDriverSignableFormTemplateInput: UpdateDriverSignableFormTemplateInput;
};


export type MutationUpdateDriverTrainingRecordArgs = {
  input: UpdateDriverTrainingRecordInput;
};


export type MutationUpdateDwellTimeAlertConfigArgs = {
  updateDwellTimeAlertConfigInput: UpdateDwellTimeAlertConfigInput;
};


export type MutationUpdateEdiPartnershipArgs = {
  updateEdiPartnershipInput: UpdateEdiPartnershipInput;
};


export type MutationUpdateEmailIngestionExclusionsArgs = {
  updateEmailIngestionExclusionsInput: UpdateEmailIngestionExclusionsInput;
};


export type MutationUpdateEmailTransactionArgs = {
  updateEmailTransactionInput: UpdateEmailTransactionInput;
};


export type MutationUpdateEmailTransactionLogArgs = {
  emailTransactionLogInput: EmailTransactionLogUpdateInput;
};


export type MutationUpdateEndOfDayDocumentProcessingJobArgs = {
  updateEndOfDayDocumentProcessingJobInput: UpdateEndOfDayDocumentProcessingJobInput;
};


export type MutationUpdateEquipmentArgs = {
  updateEquipmentInput: UpdateEquipmentInput;
};


export type MutationUpdateFeatureFlagArgs = {
  updateFeatureFlagInput: UpdateFeatureFlagInput;
};


export type MutationUpdateFeatureFlagCompanyOverrideArgs = {
  updateFeatureFlagCompanyOverrideInput: UpdateFeatureFlagCompanyOverrideInput;
};


export type MutationUpdateFeatureFlagUserOverrideArgs = {
  updateFeatureFlagUserOverrideInput: UpdateFeatureFlagUserOverrideInput;
};


export type MutationUpdateFreightChargeArgs = {
  updateFreightChargeInput: UpdateFreightChargeInput;
};


export type MutationUpdateFuelProfileArgs = {
  updateFuelProfileInput: UpdateFuelProfileInput;
};


export type MutationUpdateFuelProfileDateRangeArgs = {
  updateFuelProfileDateRangeInput: UpdateFuelProfileDateRangeInput;
};


export type MutationUpdateGeneralLedgerCodeArgs = {
  input: GeneralLedgerCodeUpdateInput;
};


export type MutationUpdateGeneralLedgerConfigurationArgs = {
  input: GeneralLedgerConfigurationUpdateInput;
};


export type MutationUpdateHoldReasonArgs = {
  holdReasonUpdateInput: HoldReasonUpdateInput;
};


export type MutationUpdateImportedOrderTypeMappingArgs = {
  importedOrderTypeMappingInput: ImportedOrderTypeMappingUpdateInput;
};


export type MutationUpdateInAppNotificationPreferencesArgs = {
  input: UpdateInAppNotificationPreferencesInput;
};


export type MutationUpdateInventoryItemsArgs = {
  updateInventoryItemsInput: UpdateInventoryItemsInput;
};


export type MutationUpdateInvoiceArgs = {
  updateInvoiceInput: UpdateInvoiceInput;
};


export type MutationUpdateInvoiceEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateInvoiceLimitedArgs = {
  updateInvoiceLimitedInput: InvoiceUpdateLimitedInput;
};


export type MutationUpdateInvoiceNoteRuleArgs = {
  updateInvoiceNoteRuleInput: UpdateInvoiceNoteRuleInput;
};


export type MutationUpdateItemArgs = {
  updateItemInput: UpdateItemInput;
};


export type MutationUpdateItemLocationArgs = {
  updateItemLocationInput: UpdateItemLocationInput;
};


export type MutationUpdateKpiDashboardLayoutArgs = {
  input: UpdateKpiLayoutInput;
};


export type MutationUpdateLegDriverMapArgs = {
  updateLegDriverMapInput: UpdateLegDriverMapInput;
};


export type MutationUpdateLineHaulLaneArgs = {
  updateLineHaulLaneInput: UpdateLineHaulLaneInput;
};


export type MutationUpdateLineHaulManifestArgs = {
  updateLineHaulManifestInput: UpdateLineHaulManifestInput;
};


export type MutationUpdateLineHaulSegmentArgs = {
  updateLineHaulSegmentInput: UpdateLineHaulSegmentInput;
};


export type MutationUpdateManifestDriverArgs = {
  updateManifestDriverInput: UpdateManifestDriverInput;
};


export type MutationUpdateManifestVehicleArgs = {
  updateManifestVehicleInput: UpdateManifestVehicleInput;
};


export type MutationUpdateManifestsStatusArgs = {
  input: UpdateManifestsStatusInput;
};


export type MutationUpdateMasterAccountArgs = {
  updateMasterAccountInput: UpdateMasterAccountInput;
};


export type MutationUpdateMirrorTargetArgs = {
  input: UpdateMirrorTargetInput;
};


export type MutationUpdateMyStopArgs = {
  input: UpdateMyStopInput;
};


export type MutationUpdateOrderCommentArgs = {
  updateOrderCommentInput: UpdateOrderCommentInput;
};


export type MutationUpdateOrderDelegationRuleArgs = {
  input: UpdateOrderDelegationRuleInput;
};


export type MutationUpdateOrderEventNotificationSubscriptionsArgs = {
  input: UpdateOrderEventNotificationSubscriptionsInput;
};


export type MutationUpdateOrderFormFieldsArgs = {
  updateOrderFormFieldsInput: UpdateOrderFormFieldsInput;
};


export type MutationUpdateOrderImportConfigurationArgs = {
  orderImportConfigurationUpdateInput: OrderImportConfigurationUpdateInput;
};


export type MutationUpdateOrderLineHaulSegmentArgs = {
  orderLineHaulSegmentInput: OrderLineHaulSegmentUpdateInput;
};


export type MutationUpdateOrderLoadedStatusArgs = {
  updateOrderLoadedStatusInput: UpdateOrderLoadedStatusInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationMessageArgs = {
  input: UpdateOrganizationMessageInput;
};


export type MutationUpdateOrganizationPeersSettingsArgs = {
  input: UpdateOrganizationPeersSettingsInput;
};


export type MutationUpdateOutlookIntegrationArgs = {
  outlookIntegrationUpdateInput: OutlookIntegrationUpdateInput;
};


export type MutationUpdatePackageArgs = {
  updatePackageInput: UpdatePackageInput;
};


export type MutationUpdatePackageArrayArgs = {
  updatePackageArrayInput: UpdatePackageArrayInput;
};


export type MutationUpdatePackageSpecArgs = {
  updatePackageSpecInput: UpdatePackageSpecInput;
};


export type MutationUpdatePackageWarehouseLocationArgs = {
  updatePackageWarehouseLocationInput: UpdatePackageWarehouseLocationInput;
};


export type MutationUpdatePaperworkCompletedForStopsArgs = {
  updatePaperworkCompleteInput: UpdatePaperworkCompleteInput;
};


export type MutationUpdatePaymentArgs = {
  updatePaymentInput: UpdatePaymentInput;
};


export type MutationUpdatePaymentOffsetArgs = {
  input: UpdatePaymentOffsetInput;
};


export type MutationUpdatePermissionArgs = {
  updatePermissionInput: UpdatePermissionInput;
};


export type MutationUpdatePermissionAccessLevelArgs = {
  updatePermissionAccessLevelInput: UpdatePermissionAccessLevelInput;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdatePieceArgs = {
  updatePieceInput: UpdatePieceInput;
};


export type MutationUpdatePieceCountArgs = {
  updatePieceCountInput: UpdatePieceCountInput;
};


export type MutationUpdatePieceDimensionsArgs = {
  input: UpdatePieceDimensionsInput;
};


export type MutationUpdatePieceReceiptArgs = {
  updatePieceReceiptInput: UpdatePieceReceiptInput;
};


export type MutationUpdatePieceReceiptPieceArgs = {
  updatePieceReceiptPieceInput: UpdatePieceReceiptPieceInput;
};


export type MutationUpdatePiecesPickedArgs = {
  updatePiecesPickedInput: UpdatePiecesPickedInput;
};


export type MutationUpdatePlaceArgs = {
  updatePlaceInput: UpdatePlaceInput;
};


export type MutationUpdateQuickAddAccessorialsArgs = {
  input: UpdateQuickAddAccessorialsInput;
};


export type MutationUpdateQuickbooksHeaderFileMappingArgs = {
  updateQuickbooksHeaderFileMappingInput: UpdateQuickbooksHeaderFileMappingInput;
};


export type MutationUpdateQuoteArgs = {
  updateQuoteInput: UpdateQuoteInput;
};


export type MutationUpdateQuoteAgentStaffSettingsArgs = {
  input: UpdateQuoteAgentStaffSettingsInput;
};


export type MutationUpdateRecurringLineHaulManifestTemplateArgs = {
  input: UpdateRecurringLineHaulManifestTemplateInput;
};


export type MutationUpdateRecurringOrderFrequencyArgs = {
  updateRecurringOrderFrequencyInput: UpdateRecurringOrderFrequencyInput;
};


export type MutationUpdateRecurringTemplateTruckArgs = {
  input: UpdateRecurringTemplateTruckInput;
};


export type MutationUpdateReportGroupConfigurationArgs = {
  updateReportGroupConfigurationInput: ReportGroupConfigurationUpdateInput;
};


export type MutationUpdateReportsEmailArgs = {
  email: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};


export type MutationUpdateRoleArgs = {
  updateRoleInput: UpdateRoleInput;
};


export type MutationUpdateRouteArgs = {
  updateRouteInput: UpdateRouteInput;
};


export type MutationUpdateRouteDriversArgs = {
  updateRouteDriversInput: UpdateRouteDriversInput;
};


export type MutationUpdateRouteNameLocationArgs = {
  updateRouteNameLocationInput: UpdateRouteNameLocationInput;
};


export type MutationUpdateRouteOptimizationArgs = {
  updateRouteOptimizationInput: UpdateRouteOptimizationInput;
};


export type MutationUpdateRouteSlotArgs = {
  updateRouteSlotInput: UpdateRouteSlotInput;
};


export type MutationUpdateRouteSlotsArgs = {
  updateRouteSlotsInput: UpdateRouteSlotsInput;
};


export type MutationUpdateRunArgs = {
  updateRunInput: UpdateRunInput;
};


export type MutationUpdateSameDayDispatchConfigArgs = {
  updateSameDayDispatchConfigInput: UpdateSameDayDispatchConfigInput;
};


export type MutationUpdateSavedFilterViewArgs = {
  updateSavedFilterViewInput: UpdateSavedFilterViewInput;
};


export type MutationUpdateScannedOrderArgs = {
  updateScannedOrderInput: UpdateScannedOrderInput;
};


export type MutationUpdateScannedOrderResultStatusArgs = {
  updateScannedOrderResultStatusInput: UpdateScannedOrderResultStatusInput;
};


export type MutationUpdateSchedulingRegionArgs = {
  input: UpdateSchedulingRegionInput;
};


export type MutationUpdateSchedulingResourceArgs = {
  input: UpdateSchedulingResourceInput;
};


export type MutationUpdateSchedulingZoneArgs = {
  input: UpdateSchedulingZoneInput;
};


export type MutationUpdateSchemaArgs = {
  updateSchemaInput: UpdateSchemaInput;
};


export type MutationUpdateSchemaCompanyMappingArgs = {
  updateSchemaCompanyMappingInput: UpdateSchemaCompanyMappingInput;
};


export type MutationUpdateSchemaDocumentArgs = {
  updateSchemaDocumentInput: UpdateSchemaDocumentInput;
};


export type MutationUpdateServiceArgs = {
  updateServiceInput: UpdateServiceInput;
};


export type MutationUpdateServiceDateForAssignedStopsArgs = {
  updateServiceDateForAssignedStopsInput: UpdateServiceDateForAssignedStopsInput;
};


export type MutationUpdateServiceGroupArgs = {
  input: UpdateServiceGroupInput;
};


export type MutationUpdateServiceRegionArgs = {
  input: UpdateServiceRegionInput;
};


export type MutationUpdateSettlementAdjustmentArgs = {
  settlementAdjustmentUpdateInput: SettlementAdjustmentUpdateInput;
};


export type MutationUpdateSettlementDeductionArgs = {
  settlementDeductionUpdateInput: SettlementDeductionUpdateInput;
};


export type MutationUpdateSettlementDeductionTypeArgs = {
  settlementDeductionTypeInput: SettlementDeductionTypeUpdateInput;
};


export type MutationUpdateSftpCredentialsArgs = {
  updateSftpCredentialsInput: UpdateSftpCredentialsInput;
};


export type MutationUpdateShipmentArgs = {
  updateShipmentInput: UpdateShipmentInput;
};


export type MutationUpdateShipmentStandardAccessorialsArgs = {
  updateShipmentStandardAccessorialsInput: UpdateShipmentStandardAccessorialsInput;
};


export type MutationUpdateSignedPodArgs = {
  updateSignedPODInput: UpdateScannedOrderInput;
};


export type MutationUpdateStandaloneStopArgs = {
  updateStandaloneStopInput: UpdateStandaloneStopInput;
};


export type MutationUpdateStandardOrderArgs = {
  updateStandardOrderInput: UpdateStandardOrderInput;
};


export type MutationUpdateStandardShipmentFieldsArgs = {
  updateStandardShipmentFieldsInput: UpdateStandardShipmentFieldInput;
};


export type MutationUpdateStopArgs = {
  updateStopInput: UpdateStopInput;
};


export type MutationUpdateStopDriverMapArgs = {
  updateStopDriverMapInput: UpdateStopDriverMapInput;
};


export type MutationUpdateStopsArgs = {
  updateStopsInput: UpdateStopsInput;
};


export type MutationUpdateStorageOrderArgs = {
  updateStorageOrderInput: UpdateStorageOrderInput;
};


export type MutationUpdateStorageUnitArgs = {
  updateStorageUnitInput: UpdateStorageUnitInput;
};


export type MutationUpdateTagArgs = {
  updateTagInput: UpdateTagInput;
};


export type MutationUpdateTariffChainArgs = {
  updateTariffChainInput: UpdateTariffChainInput;
};


export type MutationUpdateTariffGroupArgs = {
  updateTariffGroupInput: UpdateTariffGroupInput;
};


export type MutationUpdateTariffRangesForTariffArgs = {
  tariffRangeUpdatesInput: TariffRangeUpdatesInput;
};


export type MutationUpdateTariffZoneArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUpdateInput: TariffZoneUpdateInput;
};


export type MutationUpdateTariffZoneGroupArgs = {
  tariffZoneGroupUpdateInput: TariffZoneGroupUpdateInput;
};


export type MutationUpdateTemplateAndRecordAddressesArgs = {
  updateAddressInput: UpdateAddressInput;
};


export type MutationUpdateTenediCarrierIdentityArgs = {
  input: UpdateTenediCarrierIdentityInput;
};


export type MutationUpdateTenediCustomerIdentityArgs = {
  input: UpdateTenediCustomerIdentityInput;
};


export type MutationUpdateTerminalArgs = {
  updateTerminalInput: UpdateTerminalInput;
};


export type MutationUpdateTerminalServiceAreaArgs = {
  terminalServiceAreaInput: TerminalServiceAreaUpdateInput;
};


export type MutationUpdateTerminalV2Args = {
  input: TerminalUpdateInput;
};


export type MutationUpdateTestOrderArgs = {
  updateTestOrderInput: UpdateTestOrderInput;
};


export type MutationUpdateTestPieceStatusArgs = {
  input: UpdateTestPieceStatusInput;
};


export type MutationUpdateThirdPartyBrokerArgs = {
  thirdPartyBrokerUpdateInput: ThirdPartyBrokerUpdateInput;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateVehicleForRouteArgs = {
  routeUuid: Scalars['String']['input'];
  vehicleUuid: Scalars['String']['input'];
};


export type MutationUpdateVehicleTypeArgs = {
  vehicleTypeUpdateInput: VehicleTypeUpdateInput;
};


export type MutationUpdateWarehouseArgs = {
  updateWarehouseInput: UpdateWarehouseInput;
};


export type MutationUpdateWarehouseEmployeeArgs = {
  updateWarehouseEmployeeInput: UpdateWarehouseEmployeeInput;
};


export type MutationUpdateWarehouseLocationArgs = {
  updateWarehouseLocationInput: UpdateWarehouseLocationInput;
};


export type MutationUploadDocumentToExpeditorsArgs = {
  documentUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};


export type MutationUpsertAddressArgs = {
  upsertAddressInput: UpsertAddressInput;
};


export type MutationUpsertCompanyPackageTypeConfigArgs = {
  input: UpsertCompanyPackageTypeConfigInput;
};


export type MutationUpsertContactPersonArgs = {
  upsertContactPersonInput: UpsertContactPersonInput;
};


export type MutationUpsertDockTimeAllowancesArgs = {
  input: UpsertDockTimeAllowanceInput;
};


export type MutationUpsertDriverPlannerAssumptionsArgs = {
  input: UpsertDriverPlannerAssumptionsInput;
};


export type MutationUpsertEdiPartnershipReferenceMappingsArgs = {
  upsertEdiPartnershipReferenceMappingsInput: UpsertEdiPartnershipReferenceMappingsInput;
};


export type MutationUpsertFreightChargeArgs = {
  upsertFreightChargeInput: UpsertFreightChargeInput;
};


export type MutationUpsertItemGroupArgs = {
  upsertItemGroupInput: UpsertItemGroupInput;
};


export type MutationUpsertLineHaulUtilizationAssumptionsArgs = {
  input: UpsertLineHaulUtilizationAssumptionInput;
};


export type MutationUpsertOrganizationPackageTypeConfigArgs = {
  input: UpsertOrganizationPackageTypeConfigInput;
};


export type MutationUpsertOrganizationQuotePolicyArgs = {
  input: UpsertOrganizationQuotePolicyInput;
};


export type MutationUpsertPackageArgs = {
  upsertPackageInput: UpsertPackageInput;
};


export type MutationUpsertPicklistArgs = {
  upsertPicklistInput: UpsertPicklistInput;
};


export type MutationUpsertProductivityTimeAllowancesArgs = {
  input: UpsertTimeAllowanceInput;
};


export type MutationUpsertRouteAutomationSettingsArgs = {
  input: RouteAutomationSettingsInput;
};


export type MutationUpsertSamsaraOauthTokenArgs = {
  upsertSamsaraOauthTokenInput: UpsertSamsaraOauthTokenInput;
};


export type MutationUpsertShipmentSubscriberArgs = {
  upsertShipmentSubscriberInput: UpsertShipmentSubscriberInput;
};


export type MutationUpsertShipmentSubscriberForCompanyArgs = {
  companyUuid: Scalars['String']['input'];
  upsertShipmentSubscriberInput: UpsertShipmentSubscriberInput;
};


export type MutationUpsertStructuredExtractionSchemaOverrideArgs = {
  upsertStructuredExtractionSchemaOverrideInput: StructuredExtractionSchemaOverrideInput;
};


export type MutationUpsertUserContactNotificationSubscriptionArgs = {
  userContactNotificationSubscriptionUpsertInput: UserContactNotificationSubscriptionUpsertInput;
};


export type MutationUserSessionsAdminRevokeSessionsArgs = {
  input: RevokeCompanyUserSessionsInput;
};


export type MutationValidateCrownChargesFromCsvArgs = {
  validateCrownChargesInput: ValidateCrownChargesInput;
};


export type MutationValidateCrownChargesFromPdfArgs = {
  validateCrownChargesInput: ValidateCrownChargesInput;
};


export type MutationValidateImportedCrownInvoicesArgs = {
  validateImportedCrownInvoicesInput: ValidateImportedCrownInvoicesInput;
};


export type MutationVerifyInventoryForStorageUnitArgs = {
  verifyInventoryForStorageUnitInput: VerifyInventoryForStorageUnitInput;
};


export type MutationWithdrawOrganizationMessageArgs = {
  input: OrganizationMessageUuidInput;
};

export type MutationErrorOutput = {
  __typename?: 'MutationErrorOutput';
  message: Scalars['String']['output'];
};

export type NameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type NetSalesSummaryReportInput = {
  /** The UUIDs of the customers (contacts) to include in the report. If not included, the report will include net sales data for all customers. */
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type NetSalesSummaryReportOutput = {
  __typename?: 'NetSalesSummaryReportOutput';
  contactRows: Array<NetSalesSummaryReportOutputRow>;
  reportTotal: NetSalesSummaryReportOutputRow;
};

export type NetSalesSummaryReportOutputRow = {
  __typename?: 'NetSalesSummaryReportOutputRow';
  /** Total of credits and debits on open invoices */
  adjustmentsInCents: Scalars['Float']['output'];
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  dimWeight: Scalars['Float']['output'];
  /** openInvoiesTotal - adjustments */
  netSalesInCents: Scalars['Float']['output'];
  openInvoiesTotalInCents: Scalars['Float']['output'];
  pieces: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
};

export type NewInvoiceToCreate = {
  __typename?: 'NewInvoiceToCreate';
  name?: Maybe<Scalars['String']['output']>;
  ordersToAdd: Array<OrderToAddToInvoice>;
};

export type NewSettlementBillInput = {
  driverUuid: Scalars['String']['input'];
  settlementBillLineItemIds: Array<Scalars['String']['input']>;
};

export type NormalizeDocumentInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export enum NotificationChannel {
  Edi = 'EDI',
  Email = 'EMAIL',
  InApp = 'IN_APP',
  OutboundApi = 'OUTBOUND_API',
  Push = 'PUSH',
  TextMessage = 'TEXT_MESSAGE'
}

export type NotificationCutoverConfigEntity = {
  __typename?: 'NotificationCutoverConfigEntity';
  /** The channels of this event a shadow run cannot compare, even when the event is comparable on another channel. */
  engineOnlyChannels: Array<NotificationChannel>;
  /** The notification event type this row controls. */
  eventType: NotificationEventType;
  /** The ticket blocking FULL, or null when FULL is available. The write path names this same ticket when it refuses a FULL. */
  fullBlockedBy?: Maybe<Scalars['String']['output']>;
  /** Whether a configured FULL is honoured for this event type. When false, FULL is downgraded to SHADOW at resolve time (the engine runs in parallel instead of delivering), so a row can report mode FULL while no cutover is in effect. Render the two together so an operator is not left believing a cutover happened. */
  fullEligible: Scalars['Boolean']['output'];
  /** Why FULL is safe for this event, or null when FULL is not available. */
  fullEligibleBecause?: Maybe<Scalars['String']['output']>;
  /** The static description of what this event is and who it reaches. */
  metadata: NotificationEventMetadataEntity;
  /** The cutover mode currently configured for the event type. */
  mode: NotificationEngineMode;
  /** The event that must already be FULL before this one may go FULL, or null when it stands alone. Setting a raised notification to FULL without the event that clears it leaves notifications that never go away. */
  requiredPartnerEvent?: Maybe<NotificationEventType>;
  /** Whether a SHADOW run can be compared against a legacy send on any channel this event delivers on. False when every deliverable channel is engine-only, so the event can never earn FULL by observation. Read it with engineOnlyChannels, which names the channels that cannot be compared. */
  shadowComparable: Scalars['Boolean']['output'];
  /** The business domain the event comes from. */
  source: Scalars['String']['output'];
};

/** Whether an event results in a real delivery today: DELIVERING (a legacy path is sending, whatever this row says), DORMANT_UNTIL_FULL (the engine is the only sender and would send the moment this row is set to Full), REACHES_NOBODY (nothing lands even at Full). */
export enum NotificationDeliveryState {
  Delivering = 'DELIVERING',
  DormantUntilFull = 'DORMANT_UNTIL_FULL',
  ReachesNobody = 'REACHES_NOBODY'
}

/** Cutover mode for a notification event: OFF (legacy path only), SHADOW (engine computes without sending, for comparison), FULL (engine delivers). */
export enum NotificationEngineMode {
  Full = 'FULL',
  Off = 'OFF',
  Shadow = 'SHADOW'
}

export type NotificationEntity = {
  __typename?: 'NotificationEntity';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  driverMarkedAttemptedDriver?: Maybe<DriverEntity>;
  driverMarkedAttemptedStop?: Maybe<StopEntity>;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  order?: Maybe<OrderEntity>;
  partnerCompanyName?: Maybe<Scalars['String']['output']>;
  sourceDriver?: Maybe<DriverEntity>;
  targetAccessorial?: Maybe<AccessorialUnion>;
  targetStop?: Maybe<StopEntity>;
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type NotificationEventConfigurationPointEntity = {
  __typename?: 'NotificationEventConfigurationPointEntity';
  /** Where a human clicks to change it. Null when the setting has no screen at all and is only reachable through an API mutation or SQL. */
  clickPath?: Maybe<Scalars['String']['output']>;
  /** The setting, named as it exists in the system. */
  setting: Scalars['String']['output'];
};

export type NotificationEventMetadataEntity = {
  __typename?: 'NotificationEventMetadataEntity';
  /** The channels the engine's recipient resolvers can emit for this event. Static capability, not observed traffic: a channel here means a resolver would produce a target on it, not that a message went out on it. */
  channels: Array<NotificationChannel>;
  /** Every switch governing whether this event actually sends, including the cutover mode itself. */
  configuredIn: Array<NotificationEventConfigurationPointEntity>;
  /** Whether a real delivery happens today, independent of this row. DELIVERING with mode OFF is the normal state of a not-yet-migrated event, where the legacy path is sending. */
  deliveryState: NotificationDeliveryState;
  /** Why that delivery state holds. */
  deliveryStateReason: Scalars['String']['output'];
  /** What the event means, in plain sentences. */
  description: Scalars['String']['output'];
  /** The service class that raises this event, or null when no call site raises it anywhere yet. Derived from a source scan in a spec, so it cannot outlive the emitter landing. */
  emittedBy?: Maybe<Scalars['String']['output']>;
  /** Who the engine resolves for this event: the audience a Full flip on this row starts delivering to. */
  engineTargets: Array<NotificationEventTargetEntity>;
  /** Who a legacy imperative path reaches for the same business moment today, whatever this row's mode is. Empty when no legacy path exists. Not an audience this row controls. */
  legacyTargets: Array<NotificationEventTargetEntity>;
  /** The domain moment that fires the event. Says nothing about whether a call site exists; emittedBy carries that. */
  trigger: Scalars['String']['output'];
};

export type NotificationEventTargetEntity = {
  __typename?: 'NotificationEventTargetEntity';
  /** Plain-language definition of the audience. */
  definition: Scalars['String']['output'];
  /** The NotificationRecipientKind a dispatch job for this audience carries, as stamped on every job. Null when no dispatch job ever carries it: the audience notifies nobody, or only a legacy imperative path reaches it. */
  recipientKind?: Maybe<Scalars['String']['output']>;
  /** The audience this event is addressed to. */
  target: NotificationTarget;
};

/** A domain event the notification engine can handle. */
export enum NotificationEventType {
  AppointmentCancelled = 'APPOINTMENT_CANCELLED',
  AppointmentConfirmed = 'APPOINTMENT_CONFIRMED',
  AppointmentDateChanged = 'APPOINTMENT_DATE_CHANGED',
  ContactAttempted = 'CONTACT_ATTEMPTED',
  DeliveryDispatched = 'DELIVERY_DISPATCHED',
  LoadedOnTruck = 'LOADED_ON_TRUCK',
  OrderOnHand = 'ORDER_ON_HAND',
  OrderRefused = 'ORDER_REFUSED',
  OrganizationMessagePublished = 'ORGANIZATION_MESSAGE_PUBLISHED',
  QuoteHeldForReview = 'QUOTE_HELD_FOR_REVIEW',
  SchedulingExceptionCleared = 'SCHEDULING_EXCEPTION_CLEARED',
  SchedulingExceptionRaised = 'SCHEDULING_EXCEPTION_RAISED',
  SchedulingInvitationSent = 'SCHEDULING_INVITATION_SENT',
  SchedulingSlotBooked = 'SCHEDULING_SLOT_BOOKED',
  SchedulingSlotRescheduled = 'SCHEDULING_SLOT_RESCHEDULED'
}

export type NotificationShadowComparisonEntity = {
  __typename?: 'NotificationShadowComparisonEntity';
  /** The delivery channel this comparison is for. */
  channel: NotificationChannel;
  /** The owning company UUID. */
  companyUuid: Scalars['String']['output'];
  /** When the row was first created. */
  createdAt: Scalars['DateTime']['output'];
  /** The notification event type this comparison is for. */
  eventType: Scalars['String']['output'];
  /** Whether the engine recorded content for this delivery. */
  hasEngineContent: Scalars['Boolean']['output'];
  /** Whether the legacy path recorded content for this delivery. */
  hasLegacyContent: Scalars['Boolean']['output'];
  /** Names of the semantic fields that diverged (set on MISMATCH; empty otherwise). */
  mismatchedFields: Array<Scalars['String']['output']>;
  /** The aggregate reference (e.g. a stop UUID) the event is about. */
  sourceRef: Scalars['String']['output'];
  /** The comparison row resolution status. */
  status: NotificationShadowStatus;
  /** When the row was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The comparison row UUID. */
  uuid: Scalars['String']['output'];
};

export type NotificationShadowComparisonFilterInput = {
  /** Restrict to rows delivered over this channel. */
  channel?: InputMaybe<NotificationChannel>;
  /** Restrict to rows belonging to this company. */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to rows for this notification event type. */
  eventType?: InputMaybe<NotificationEventType>;
  /** Maximum rows to return from the list query (default 200, max 500). Ignored by the summary query. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Restrict to rows with this resolution status. */
  status?: InputMaybe<NotificationShadowStatus>;
};

export type NotificationShadowComparisonStatusCountEntity = {
  __typename?: 'NotificationShadowComparisonStatusCountEntity';
  count: Scalars['Int']['output'];
  status: NotificationShadowStatus;
};

/** Resolution state of a shadow-mode comparison row (TMS-1660/1661). A MATCH is never persisted as a status: matching rows self-prune (deleted, only a metric is kept), so only PENDING, MISMATCH, and ORPHAN rows are ever stored. */
export enum NotificationShadowStatus {
  Mismatch = 'MISMATCH',
  Orphan = 'ORPHAN',
  Pending = 'PENDING'
}

export enum NotificationSubjectType {
  OrganizationMessage = 'ORGANIZATION_MESSAGE'
}

export enum NotificationSubscriberType {
  DynamicOrderContact = 'DYNAMIC_ORDER_CONTACT',
  DynamicOrderInboundContact = 'DYNAMIC_ORDER_INBOUND_CONTACT',
  DynamicOrderOutboundContact = 'DYNAMIC_ORDER_OUTBOUND_CONTACT'
}

/** Who a notification event is addressed to, in customer-facing words. Refines NotificationRecipientKind: several targets share one kind (three distinct human contacts are all external contacts), which the dispatch job does not need to tell apart but an operator does. NONE means the event notifies nobody. */
export enum NotificationTarget {
  DeliveryContact = 'DELIVERY_CONTACT',
  EdiPartner = 'EDI_PARTNER',
  EfmAgentPortal = 'EFM_AGENT_PORTAL',
  InternalUser = 'INTERNAL_USER',
  None = 'NONE',
  OrderContact = 'ORDER_CONTACT',
  OrderSubscribers = 'ORDER_SUBSCRIBERS',
  PickupContact = 'PICKUP_CONTACT',
  StopContact = 'STOP_CONTACT',
  WebhookSubscriber = 'WEBHOOK_SUBSCRIBER'
}

export enum NotificationType {
  ContactCreditLimitReached = 'CONTACT_CREDIT_LIMIT_REACHED',
  DriverAddedAccessorialToStop = 'DRIVER_ADDED_ACCESSORIAL_TO_STOP',
  DriverMarkedStopAsAttempted = 'DRIVER_MARKED_STOP_AS_ATTEMPTED',
  EmailingInvoice = 'EMAILING_INVOICE',
  OrderAwaitingApproval = 'ORDER_AWAITING_APPROVAL',
  PartnershipRevoked = 'PARTNERSHIP_REVOKED'
}

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

/** Represents the difference between 2 versions of a numerical field. Used in audit log entries */
export type NumberFieldDifference = {
  __typename?: 'NumberFieldDifference';
  newValue?: Maybe<Scalars['Float']['output']>;
  oldValue?: Maybe<Scalars['Float']['output']>;
};

export enum NumberOfConsignees {
  Multiple = 'MULTIPLE',
  One = 'ONE'
}

export enum NumberOfShippers {
  Multiple = 'MULTIPLE',
  One = 'ONE'
}

export type OffboardCompanyFromQuoteAgentInput = {
  companyUuid: Scalars['String']['input'];
};

export type OffboardCompanyFromQuoteAgentOutput = {
  __typename?: 'OffboardCompanyFromQuoteAgentOutput';
  companyUuid: Scalars['String']['output'];
  status: QuoteAgentOffboardingRequestStatus;
};

export type OfferLocationEntity = {
  __typename?: 'OfferLocationEntity';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OnTimeCommitmentSplitEntity = {
  __typename?: 'OnTimeCommitmentSplitEntity';
  measurableStops: Scalars['Int']['output'];
  onTimePct?: Maybe<Scalars['Float']['output']>;
  onTimeStops: Scalars['Int']['output'];
};

export type OnTimeCustomerRowEntity = {
  __typename?: 'OnTimeCustomerRowEntity';
  customerName: Scalars['String']['output'];
  customerUuid: Scalars['String']['output'];
  lateStops: Scalars['Int']['output'];
  measurableStops: Scalars['Int']['output'];
  onTimePct?: Maybe<Scalars['Float']['output']>;
};

export type OnTimeGroupRowEntity = {
  __typename?: 'OnTimeGroupRowEntity';
  lateStops: Scalars['Int']['output'];
  measurableStops: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  onTimePct?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type OnTimeKpiArgs = {
  endDate: Scalars['DateTime']['input'];
  metrics?: InputMaybe<Array<KpiTileMetric>>;
  startDate: Scalars['DateTime']['input'];
  stopKind: KpiStopKind;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OnTimeKpiEntity = {
  __typename?: 'OnTimeKpiEntity';
  bucketUnit: KpiTrendBucketUnit;
  completedStops: Scalars['Int']['output'];
  customerAppointment: OnTimeCommitmentSplitEntity;
  customers: Array<OnTimeCustomerRowEntity>;
  drivers: Array<OnTimeGroupRowEntity>;
  excludedNoPromiseStops: Scalars['Int']['output'];
  fallbackJudgedStops: Scalars['Int']['output'];
  forwarderDate: OnTimeCommitmentSplitEntity;
  lateStops: Scalars['Int']['output'];
  measurableStops: Scalars['Int']['output'];
  onTimePct?: Maybe<Scalars['Float']['output']>;
  onTimeStops: Scalars['Int']['output'];
  terminals: Array<OnTimeGroupRowEntity>;
  trend: Array<OnTimeTrendBucketEntity>;
};

export type OnTimeKpiStopsArgs = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  filter: OnTimeStopFilter;
  filters?: InputMaybe<KpiRecordFiltersInput>;
  metrics?: InputMaybe<Array<KpiTileMetric>>;
  page?: InputMaybe<KpiRecordPageInput>;
  sort?: InputMaybe<KpiRecordSortInput>;
  startDate: Scalars['DateTime']['input'];
  stopKind: KpiStopKind;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OnTimeKpiStopsEntity = {
  __typename?: 'OnTimeKpiStopsEntity';
  facets: KpiRecordFacetsEntity;
  stops: Array<OnTimeStopRowEntity>;
  totalStops: Scalars['Int']['output'];
};

export enum OnTimePerformanceReportDetailType {
  Aggregate = 'AGGREGATE',
  Detailed = 'DETAILED'
}

export type OnTimePerformanceReportInput = {
  /** The UUIDs of the business divisions to include in the report. If not included, the report will include stops for all business divisions. */
  businessDivisionUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The UUIDs of the customers to include in the report. If not included, the report will include stops for all customers. */
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  reportDetailType?: InputMaybe<OnTimePerformanceReportDetailType>;
  /** IANA zone every stop is read in. Without it, each stop is read on its own location day and clock while terminal_local_times is on, and in the company zone otherwise. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  /** The UUIDs of the services to include in the report. If not included, the report will include stops for all services. */
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The upper bound for the date of stops which will be included in the report.
   *     If not included, the report will include all stops after stopStartDate.
   */
  stopEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The lower bound for the date of stops which will be included in the report.
   *     If not included, the report will include all stops before stopEndDate.
   */
  stopStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUIDs of the terminals to include in the report. If not included, the report will include stops for all terminals. */
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Which stops behind an on-time number to list. */
export enum OnTimeStopFilter {
  Excluded = 'EXCLUDED',
  FallbackJudged = 'FALLBACK_JUDGED',
  Late = 'LATE',
  OnTime = 'ON_TIME'
}

export type OnTimeStopRowEntity = {
  __typename?: 'OnTimeStopRowEntity';
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  customerName: Scalars['String']['output'];
  driverNames: Array<Scalars['String']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  fileNo?: Maybe<Scalars['String']['output']>;
  judgedAt?: Maybe<Scalars['DateTime']['output']>;
  judgedEvent?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  promiseSource?: Maybe<Scalars['String']['output']>;
  promisedAt?: Maybe<Scalars['DateTime']['output']>;
  stopTimeZone: Scalars['String']['output'];
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type OnTimeTrendBucketEntity = {
  __typename?: 'OnTimeTrendBucketEntity';
  bucketDate: Scalars['String']['output'];
  measurableStops: Scalars['Int']['output'];
  onTimePct?: Maybe<Scalars['Float']['output']>;
  onTimeStops: Scalars['Int']['output'];
};

export type OpenInvoiceReportArgs = {
  findInvoicesArgs: FindInvoicesInput;
};

export type OpenMessageInOutlookInput = {
  orderUuid: Scalars['String']['input'];
};

export type OpenMessageInOutlookOutput = {
  __typename?: 'OpenMessageInOutlookOutput';
  linkToOpen: Scalars['String']['output'];
};

export type OperationalEfficiencyArgs = {
  dimension: OperationalEfficiencyDimension;
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Grouping dimension for the Intelligence Board operational efficiency report. */
export enum OperationalEfficiencyDimension {
  AssetType = 'ASSET_TYPE',
  Service = 'SERVICE'
}

export type OperationalEfficiencyReportEntity = {
  __typename?: 'OperationalEfficiencyReportEntity';
  avgShipmentPriceUsd?: Maybe<Scalars['Float']['output']>;
  dimension: OperationalEfficiencyDimension;
  milesCoveragePct: Scalars['Float']['output'];
  revenuePerMileUsd?: Maybe<Scalars['Float']['output']>;
  rows: Array<OperationalEfficiencyRowEntity>;
  shipmentsWithMiles: Scalars['Int']['output'];
  totalMiles: Scalars['Float']['output'];
  totalRevenueUsd: Scalars['Float']['output'];
  totalShipments: Scalars['Int']['output'];
};

export type OperationalEfficiencyRowEntity = {
  __typename?: 'OperationalEfficiencyRowEntity';
  avgShipmentPriceUsd: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  milesCoveragePct: Scalars['Float']['output'];
  revenuePerMileUsd?: Maybe<Scalars['Float']['output']>;
  revenueUsd: Scalars['Float']['output'];
  shipmentCount: Scalars['Int']['output'];
  shipmentsWithMiles: Scalars['Int']['output'];
  status: OperationalEfficiencyStatus;
  totalMiles: Scalars['Float']['output'];
};

/** Coverage band for a row of the operational efficiency report: how much of the group's mileage is recorded, not how it performed. */
export enum OperationalEfficiencyStatus {
  Measured = 'MEASURED',
  NotMeasured = 'NOT_MEASURED',
  PartiallyMeasured = 'PARTIALLY_MEASURED'
}

export type OperationsPerformanceDuration = {
  __typename?: 'OperationsPerformanceDuration';
  backwardOrders: Scalars['Int']['output'];
  countedOrders: Scalars['Int']['output'];
  meanSeconds?: Maybe<Scalars['Float']['output']>;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
  prior: OperationsPerformancePriorDuration;
};

export type OperationsPerformanceFilterArgs = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  runsBackward?: InputMaybe<OperationsPerformanceMeasure>;
  sortBy?: InputMaybe<OperationsPerformanceInterval>;
  sortDirection?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OperationsPerformanceGroup = {
  __typename?: 'OperationsPerformanceGroup';
  deliveredOrders: Scalars['Int']['output'];
  intervals: Array<OperationsPerformanceGroupInterval>;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  orders: Scalars['Int']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type OperationsPerformanceGroupInterval = {
  __typename?: 'OperationsPerformanceGroupInterval';
  countedOrders: Scalars['Int']['output'];
  key: OperationsPerformanceInterval;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export enum OperationsPerformanceInterval {
  CreatedToInboundDispatch = 'CREATED_TO_INBOUND_DISPATCH',
  InboundCompletionToOutboundDispatch = 'INBOUND_COMPLETION_TO_OUTBOUND_DISPATCH',
  InboundDispatchToCompletion = 'INBOUND_DISPATCH_TO_COMPLETION',
  OutboundDispatchToCompletion = 'OUTBOUND_DISPATCH_TO_COMPLETION'
}

export type OperationsPerformanceIntervalDuration = {
  __typename?: 'OperationsPerformanceIntervalDuration';
  backwardOrders: Scalars['Int']['output'];
  countedOrders: Scalars['Int']['output'];
  key: OperationsPerformanceInterval;
  meanSeconds?: Maybe<Scalars['Float']['output']>;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
  prior: OperationsPerformancePriorDuration;
};

export type OperationsPerformanceLongestInterval = {
  __typename?: 'OperationsPerformanceLongestInterval';
  key: OperationsPerformanceInterval;
  seconds: Scalars['Float']['output'];
};

export enum OperationsPerformanceMeasure {
  CreatedToInboundDispatch = 'CREATED_TO_INBOUND_DISPATCH',
  InboundCompletionToOutboundDispatch = 'INBOUND_COMPLETION_TO_OUTBOUND_DISPATCH',
  InboundDispatchToCompletion = 'INBOUND_DISPATCH_TO_COMPLETION',
  OrderToDelivered = 'ORDER_TO_DELIVERED',
  OutboundDispatchToCompletion = 'OUTBOUND_DISPATCH_TO_COMPLETION'
}

export type OperationsPerformanceOutlierOrder = {
  __typename?: 'OperationsPerformanceOutlierOrder';
  customerName: Scalars['String']['output'];
  fromAt: Scalars['DateTime']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  seconds: Scalars['Float']['output'];
  toAt: Scalars['DateTime']['output'];
};

export type OperationsPerformanceOutliers = {
  __typename?: 'OperationsPerformanceOutliers';
  measure: OperationsPerformanceMeasure;
  orders: Array<OperationsPerformanceOutlierOrder>;
};

export type OperationsPerformancePageArgs = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  runsBackward?: InputMaybe<OperationsPerformanceMeasure>;
  sortBy?: InputMaybe<OperationsPerformanceInterval>;
  sortDirection?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OperationsPerformancePriorDuration = {
  __typename?: 'OperationsPerformancePriorDuration';
  countedOrders: Scalars['Int']['output'];
  medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type OperationsPerformanceReport = {
  __typename?: 'OperationsPerformanceReport';
  rows: Array<OperationsPerformanceRow>;
  timezone: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type OperationsPerformanceRow = {
  __typename?: 'OperationsPerformanceRow';
  accountId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdToInboundDispatchSeconds?: Maybe<Scalars['Float']['output']>;
  customerName: Scalars['String']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  inboundCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  inboundCompletionToOutboundDispatchSeconds?: Maybe<Scalars['Float']['output']>;
  inboundDispatchToCompletionSeconds?: Maybe<Scalars['Float']['output']>;
  inboundDispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  inboundName?: Maybe<Scalars['String']['output']>;
  inboundScannedPieceCount?: Maybe<Scalars['Int']['output']>;
  lastCustomerUpdateAt?: Maybe<Scalars['DateTime']['output']>;
  lastCustomerUpdateMethod?: Maybe<OperationsPerformanceUpdateMethod>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  outboundCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  outboundDispatchToCompletionSeconds?: Maybe<Scalars['Float']['output']>;
  outboundDispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  outboundName?: Maybe<Scalars['String']['output']>;
  outboundScannedPieceCount?: Maybe<Scalars['Int']['output']>;
  pieceCount: Scalars['Int']['output'];
  source: OrderSource;
  sourceIsEmail: Scalars['Boolean']['output'];
};

export type OperationsPerformanceSignals = {
  __typename?: 'OperationsPerformanceSignals';
  byMethod: Array<OperationsPerformanceUpdateMethodCount>;
  inboundPieces: Scalars['Int']['output'];
  inboundScannedPieces: Scalars['Int']['output'];
  outboundPieces: Scalars['Int']['output'];
  outboundScannedPieces: Scalars['Int']['output'];
  updatedOrders: Scalars['Int']['output'];
};

export type OperationsPerformanceSlowOrder = {
  __typename?: 'OperationsPerformanceSlowOrder';
  customerName: Scalars['String']['output'];
  longestInterval?: Maybe<OperationsPerformanceLongestInterval>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  terminalCode?: Maybe<Scalars['String']['output']>;
  totalSeconds: Scalars['Float']['output'];
};

export type OperationsPerformanceSummary = {
  __typename?: 'OperationsPerformanceSummary';
  byCustomer: Array<OperationsPerformanceGroup>;
  byTerminal: Array<OperationsPerformanceGroup>;
  intervals: Array<OperationsPerformanceIntervalDuration>;
  orderToDelivered: OperationsPerformanceDuration;
  orders: Scalars['Int']['output'];
  outliers: Array<OperationsPerformanceOutliers>;
  signals: OperationsPerformanceSignals;
  slowestOrders: Array<OperationsPerformanceSlowOrder>;
  timezone: Scalars['String']['output'];
  trend: OperationsPerformanceTrend;
};

export type OperationsPerformanceTrend = {
  __typename?: 'OperationsPerformanceTrend';
  points: Array<OperationsPerformanceTrendPoint>;
  unit: KpiTrendBucketUnit;
};

export type OperationsPerformanceTrendPoint = {
  __typename?: 'OperationsPerformanceTrendPoint';
  backwardOrders: Scalars['Int']['output'];
  bucketDate: Scalars['String']['output'];
  countedOrders: Scalars['Int']['output'];
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
};

export enum OperationsPerformanceUpdateMethod {
  Api = 'API',
  Edi_214 = 'EDI_214',
  Email = 'EMAIL',
  Sftp = 'SFTP',
  Text = 'TEXT'
}

export type OperationsPerformanceUpdateMethodCount = {
  __typename?: 'OperationsPerformanceUpdateMethodCount';
  method: OperationsPerformanceUpdateMethod;
  orders: Scalars['Int']['output'];
};

export type OptimizationCompleted = {
  __typename?: 'OptimizationCompleted';
  proposedRoutes: Array<ProposedRouteSequence>;
  summary: RouteOptimizationSummary;
  unplacedStopCount?: Maybe<Scalars['Int']['output']>;
};

export type OptimizationFailed = {
  __typename?: 'OptimizationFailed';
  message: Scalars['String']['output'];
};

export type OptimizationPending = {
  __typename?: 'OptimizationPending';
  jobUuid: Scalars['String']['output'];
};

export type OptimizationResultsOutput = {
  __typename?: 'OptimizationResultsOutput';
  error?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Array<Scalars['String']['output']>>;
};

export type OptimizationStatusResult = OptimizationCompleted | OptimizationFailed | OptimizationPending;

/** Endpoint-pinning strategy for route sequence optimization. PINNED_BOTH (default) keeps current first/last stops. PINNED_START frees the final stop. ROUND_TRIP optimizes a loop. FREE lets the solver pick both endpoints (approximate). RETURN_TO_TERMINAL starts and ends at the route terminal (or the company's default warehouse). */
export enum OptimizeEndpointMode {
  Free = 'FREE',
  PinnedBoth = 'PINNED_BOTH',
  PinnedStart = 'PINNED_START',
  ReturnToTerminal = 'RETURN_TO_TERMINAL',
  RoundTrip = 'ROUND_TRIP'
}

export type OptimizeRouteSequenceConstraintsInput = {
  respectDriverCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  respectTimeWindows?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptimizeRouteSequenceInput = {
  constraints?: InputMaybe<OptimizeRouteSequenceConstraintsInput>;
  endpointMode?: InputMaybe<OptimizeEndpointMode>;
  profile?: InputMaybe<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
  rules?: InputMaybe<Array<OptimizeSequencingRuleInput>>;
};

export type OptimizeRouteSequenceResult = OptimizationCompleted | OptimizationPending;

export type OptimizeRoutesTogetherInput = {
  constraints?: InputMaybe<OptimizeRouteSequenceConstraintsInput>;
  endpointMode?: InputMaybe<OptimizeEndpointMode>;
  routeUuids: Array<Scalars['String']['input']>;
  rules?: InputMaybe<Array<OptimizeSequencingRuleInput>>;
};

export type OptimizeSequencingRuleInput = {
  deliveryUuid?: InputMaybe<Scalars['String']['input']>;
  kind: OptimizeSequencingRuleKind;
  otherStopUuid?: InputMaybe<Scalars['String']['input']>;
  pickupUuid?: InputMaybe<Scalars['String']['input']>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Constraint kind applied during route sequence optimization. Single-stop kinds (FIRST/LAST) use `stopUuid`. Pairwise kinds (BEFORE/AFTER) use `stopUuid` plus `otherStopUuid`. Pickup/delivery kinds use `pickupUuid` plus `deliveryUuid`. */
export enum OptimizeSequencingRuleKind {
  After = 'AFTER',
  Before = 'BEFORE',
  First = 'FIRST',
  Last = 'LAST',
  PickupBeforeDelivery = 'PICKUP_BEFORE_DELIVERY'
}

export enum OrderAction {
  AddReferenceNumbers = 'ADD_REFERENCE_NUMBERS',
  Delete = 'DELETE',
  MarkAllPiecesPicked = 'MARK_ALL_PIECES_PICKED',
  MarkAsCancelled = 'MARK_AS_CANCELLED',
  MarkAsOnHand = 'MARK_AS_ON_HAND',
  MarkAsOnHold = 'MARK_AS_ON_HOLD',
  MarkAsRefused = 'MARK_AS_REFUSED',
  MarkNotOnHand = 'MARK_NOT_ON_HAND',
  MarkOsd = 'MARK_OSD',
  RemoveHold = 'REMOVE_HOLD',
  Uncancel = 'UNCANCEL',
  UpdatePiecesOnHand = 'UPDATE_PIECES_ON_HAND',
  UploadDocuments = 'UPLOAD_DOCUMENTS'
}

export type OrderActionResult = {
  __typename?: 'OrderActionResult';
  action: OrderAction;
  results: BulkActionEntityResults;
};

export type OrderAddedToInvoice = {
  __typename?: 'OrderAddedToInvoice';
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
};

export enum OrderBillingStatus {
  HasIssues = 'HAS_ISSUES',
  NotReadyToInvoice = 'NOT_READY_TO_INVOICE',
  ReadyToInvoice = 'READY_TO_INVOICE'
}

export type OrderCommentEntity = {
  __typename?: 'OrderCommentEntity';
  authorName: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  piece?: Maybe<PieceEntity>;
  showOnInvoice?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserActorEntity>;
  uuid: Scalars['String']['output'];
};

export type OrderCommentForCachedStop = {
  __typename?: 'OrderCommentForCachedStop';
  comment: Scalars['String']['output'];
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  edges: Array<OrderEdge>;
  /** Not cheap to calculate, request with prudence. groupUuid = invoice UUID when groupOrdersBy=INVOICE, HAWB (shipperBillOfLadingNumber) when groupOrdersBy=HAWB. */
  groupedCountsByInvoice?: Maybe<Array<GroupedCounts>>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Version ID for the response */
  versionId?: Maybe<Scalars['Float']['output']>;
};

export type OrderConsigneeSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** Methods for order consolidation */
export enum OrderConsolidationMethod {
  BaseOrder = 'BASE_ORDER',
  ByWeight = 'BY_WEIGHT',
  EvenDistribution = 'EVEN_DISTRIBUTION'
}

export enum OrderConsolidationType {
  Consolidated = 'CONSOLIDATED',
  Standard = 'STANDARD'
}

export type OrderDelegationConnection = {
  __typename?: 'OrderDelegationConnection';
  edges: Array<OrderDelegationEdge>;
  pageInfo: PageInfo;
};

export type OrderDelegationEdge = {
  __typename?: 'OrderDelegationEdge';
  cursor: Scalars['String']['output'];
  node: OrderDelegationEntity;
};

export type OrderDelegationEntity = {
  __typename?: 'OrderDelegationEntity';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  duplicateOrderUuid?: Maybe<Scalars['String']['output']>;
  endCustomer?: Maybe<DelegationEndCustomer>;
  executingCompanyName: Scalars['String']['output'];
  executingCompanyUuid: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  organizationPeerUuid: Scalars['String']['output'];
  originalOrderName?: Maybe<Scalars['String']['output']>;
  originalOrderUuid: Scalars['String']['output'];
  originatorCompanyName: Scalars['String']['output'];
  originatorCompanyUuid: Scalars['String']['output'];
  originatorProgressStatus?: Maybe<OrderDetailedStatus>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  scope: OrderDelegationScope;
  sharesEndCustomer: Scalars['Boolean']['output'];
  status: OrderDelegationStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** The part of an order to delegate. Supply both INBOUND and OUTBOUND with the same peer in one call to create a single FULL delegation. */
export enum OrderDelegationPart {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type OrderDelegationRuleEntity = {
  __typename?: 'OrderDelegationRuleEntity';
  createdAt: Scalars['DateTime']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  customerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  offerWindowMinutes?: Maybe<Scalars['Int']['output']>;
  orderSources: Array<OrderSource>;
  organizationPeerUuid: Scalars['String']['output'];
  peerCompanyName: Scalars['String']['output'];
  pickupHandling?: Maybe<DelegatedPickupHandling>;
  priority: Scalars['Int']['output'];
  scope: OrderDelegationScope;
  shareEndCustomer: Scalars['Boolean']['output'];
  terminals: Array<OrderDelegationRuleTerminalEntity>;
  timing: OrderDelegationRuleTiming;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zipCodes: Array<Scalars['String']['output']>;
};

export type OrderDelegationRuleTerminalEntity = {
  __typename?: 'OrderDelegationRuleTerminalEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** When a rule evaluates an order. ON_RECEIPT: as soon as the order is created, draft or live. WHEN_LIVE: when the order leaves draft. */
export enum OrderDelegationRuleTiming {
  OnReceipt = 'ON_RECEIPT',
  WhenLive = 'WHEN_LIVE'
}

/** The scope of work delegated: inbound only, outbound only, or the full order. */
export enum OrderDelegationScope {
  Full = 'FULL',
  InboundOnly = 'INBOUND_ONLY',
  OutboundOnly = 'OUTBOUND_ONLY'
}

/** Lifecycle state of an OrderDelegation row. */
export enum OrderDelegationStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  PendingAck = 'PENDING_ACK',
  Revoked = 'REVOKED'
}

export enum OrderDetailedStatus {
  Arrived = 'ARRIVED',
  Attempted = 'ATTEMPTED',
  BillingIssues = 'BILLING_ISSUES',
  Cancelled = 'CANCELLED',
  ChargesFinalized = 'CHARGES_FINALIZED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Creating = 'CREATING',
  Delivered = 'DELIVERED',
  DeliveryScheduled = 'DELIVERY_SCHEDULED',
  InvoicePosted = 'INVOICE_POSTED',
  InProgress = 'IN_PROGRESS',
  InTransit = 'IN_TRANSIT',
  Loaded = 'LOADED',
  OnHand = 'ON_HAND',
  OnHold = 'ON_HOLD',
  OnInvoice = 'ON_INVOICE',
  Osd = 'OSD',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  OutForPickup = 'OUT_FOR_PICKUP',
  OutForRecovery = 'OUT_FOR_RECOVERY',
  OutForTransfer = 'OUT_FOR_TRANSFER',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  PartiallyInTransit = 'PARTIALLY_IN_TRANSIT',
  PartiallyLoaded = 'PARTIALLY_LOADED',
  PartiallyOnHand = 'PARTIALLY_ON_HAND',
  PartiallyOutForDelivery = 'PARTIALLY_OUT_FOR_DELIVERY',
  PartiallyPicked = 'PARTIALLY_PICKED',
  PartiallyPlanned = 'PARTIALLY_PLANNED',
  Picked = 'PICKED',
  PickupScheduled = 'PICKUP_SCHEDULED',
  Planned = 'PLANNED',
  Received = 'RECEIVED',
  ReceivedAtOrigin = 'RECEIVED_AT_ORIGIN',
  RecoveryScheduled = 'RECOVERY_SCHEDULED',
  TransferScheduled = 'TRANSFER_SCHEDULED'
}

export type OrderDocumentInput = {
  bucket: Scalars['String']['input'];
  endOfDayDocumentsProcessingJobUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OrderDocumentType {
  AirWaybill = 'AirWaybill',
  ArrivalNotice = 'ArrivalNotice',
  AuthoSheet = 'AuthoSheet',
  PodReport = 'PodReport'
}

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['String']['output'];
  node: OrderEntity;
};

export type OrderEntity = {
  appliedAmount: Scalars['Float']['output'];
  balanceInCents: Scalars['Int']['output'];
  billingPartyContact: CustomerContactEntity;
  billingPartyContactStation?: Maybe<ContactStationEntity>;
  /** @deprecated Use personName */
  callerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: Maybe<Scalars['String']['output']>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  /** The chargeable weight is an optional weight value (measured in cubic meters) that can be used in billing calculations for the order. */
  chargeableWeightCubicMeters?: Maybe<Scalars['Volume']['output']>;
  codCheckAmountCents?: Maybe<Scalars['Int']['output']>;
  codCheckNumber?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consolidatableOrders: ConsolidatableOrdersOutput;
  consolidatedOrders?: Maybe<Array<OrderEntity>>;
  consolidatedShipmentString?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  coverSheetDocumentTypeSequence?: Maybe<CoverSheetDocumentTypeSequenceEntity>;
  createdAt: Scalars['DateTime']['output'];
  createdFromOrderTemplate?: Maybe<OrderEntity>;
  csvOrderImportStatus?: Maybe<CsvOrderImportStatus>;
  /** Total custom charge (accessorial charge) for the order in dollars */
  customChargeRevenue: Scalars['Float']['output'];
  /** Each custom charge (accessorial charge) itemized */
  customCharges: Array<CustomChargeEntity>;
  customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility;
  customerPortalChargesVisibleFromOverride?: Maybe<CustomerPortalChargesVisibility>;
  dateMarkedLoaded?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedReceivedAtOrigin?: Maybe<Scalars['DateTime']['output']>;
  delegationAsDuplicate?: Maybe<OrderDelegationEntity>;
  delegations: Array<OrderDelegationEntity>;
  deletedAutoAppliedAccessorials: Array<AccessorialUnion>;
  detailedStatus?: Maybe<Scalars['String']['output']>;
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  dimWeight: Scalars['Float']['output'];
  displayChargesInCustomerPortalOverride?: Maybe<Scalars['Boolean']['output']>;
  documents: Array<DocumentEntity>;
  driverQualifications: Array<DriverQualificationEntity>;
  driverSettlementTotal: Scalars['Float']['output'];
  ediReceivedScac?: Maybe<Scalars['String']['output']>;
  ediReferences?: Maybe<Array<EdiReferenceEntity>>;
  ediServiceLevelCode?: Maybe<Scalars['String']['output']>;
  ediTransactions: Array<EdiTransactionEntity>;
  emergencyResponseNumber?: Maybe<Scalars['String']['output']>;
  enableLineHaul: Scalars['Boolean']['output'];
  endStop?: Maybe<StopEntity>;
  externalNotes?: Maybe<Scalars['String']['output']>;
  fields: StandardOrderFieldsEntity;
  /** Total freight charge for the order in dollars */
  freightChargeRevenue: Scalars['Float']['output'];
  freightNeedsRate: Scalars['Boolean']['output'];
  /** Total fuel charge for the order in dollars */
  fuelChargeRevenue: Scalars['Float']['output'];
  fulfillmentType?: Maybe<FulfillmentType>;
  hasDamage: Scalars['Boolean']['output'];
  hasDriverPod: Scalars['Boolean']['output'];
  hasDriverUploadedDocument: Scalars['Boolean']['output'];
  hasEdiCancellation: Scalars['Boolean']['output'];
  hasIssues: Scalars['Boolean']['output'];
  hasNoneOrCompletedInboundStop: Scalars['Boolean']['output'];
  hasShortage: Scalars['Boolean']['output'];
  hasUncollectedInboundStop: Scalars['Boolean']['output'];
  hazmat: Scalars['Boolean']['output'];
  hazmatClass?: Maybe<HazmatClass>;
  hazmatDescription?: Maybe<Scalars['String']['output']>;
  holdReason?: Maybe<HoldReasonEntity>;
  inBond: Scalars['Boolean']['output'];
  inboundPaperwork: OrderPaperworkEntity;
  inboundShipment?: Maybe<ShipmentEntity>;
  inboundStopIntention?: Maybe<StopIntention>;
  invoice?: Maybe<InvoiceEntity>;
  isCollectOnDelivery: Scalars['Boolean']['output'];
  isCrossDock?: Maybe<Scalars['Boolean']['output']>;
  isDoorToDoor?: Maybe<Scalars['Boolean']['output']>;
  /** Filters out draft and template orders */
  isDraftOrder: Scalars['Boolean']['output'];
  isOnHand: Scalars['Boolean']['output'];
  isOverdue: Scalars['Boolean']['output'];
  isReturnOrder: Scalars['Boolean']['output'];
  isReverse: Scalars['Boolean']['output'];
  isReweighed: Scalars['Boolean']['output'];
  issueReason?: Maybe<Scalars['String']['output']>;
  itTeIssueDate?: Maybe<Scalars['DateTime']['output']>;
  itTeNumber?: Maybe<Scalars['String']['output']>;
  lastCompletedLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  lastUpdatedByUser?: Maybe<UserActorEntity>;
  lineHaulCompletedDate: Scalars['DateTime']['output'];
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  lineHaulOriginTerminal?: Maybe<TerminalEntity>;
  lineHaulServiceDisplayString: Scalars['String']['output'];
  lineHaulShipment?: Maybe<ShipmentEntity>;
  /** The line haul events associated with an order, such as every stop at a terminal. This is the order’s own timeline, not an audit log of user actions or changes. */
  lineHaulTimeline: Array<OrderLineHaulTimelineEventEntity>;
  lockSecondaryRefNumber: Scalars['Boolean']['output'];
  /** @deprecated Use paperwork.missingDocuments instead */
  missingDocuments: Array<DocumentType>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  numPackagesOnHand: Scalars['Float']['output'];
  onHand?: Maybe<Scalars['Boolean']['output']>;
  onHold: Scalars['Boolean']['output'];
  orderChargesShipment?: Maybe<ShipmentEntity>;
  orderComments: Array<OrderCommentEntity>;
  orderConsolidationType: OrderConsolidationType;
  orderEvents: Array<OrderEventEntity>;
  orderInvoiceByDate?: Maybe<Scalars['DateTime']['output']>;
  orderPaymentMappings: Array<PaymentToOrderMappingEntity>;
  orderSegmentType: OrderSegmentType;
  /** Orders that were prorated with (but not including) this order */
  ordersProratedWith?: Maybe<Array<OrderEntity>>;
  ordersWithSameBillOfLadingNumber: Array<OrderEntity>;
  ordersWithSameBillOfLadingNumberForReviewOrders?: Maybe<Array<StandardOrderEntity>>;
  ordinal: Scalars['Int']['output'];
  /** Packaging as received on this order's original transmission, captured when the order is created and never rewritten. Empty for orders created before the snapshot existed, and for orders created without packages. */
  originalTransmissionPackages: Array<PackageEntity>;
  /** @deprecated Deprecated. Use hasIssues and hasDamage instead. */
  osAndD: Scalars['Boolean']['output'];
  osd?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated. Use hasIssues and hasDamage instead. */
  osdReason?: Maybe<Scalars['String']['output']>;
  outboundPaperwork: OrderPaperworkEntity;
  /** The scans out of the last terminal (if multi-terminal and line haul), or simply departure scans corresponding to outbound delivery */
  outboundScans: Array<ScanEntity>;
  outboundShipment?: Maybe<ShipmentEntity>;
  outboundStopIntention?: Maybe<StopIntention>;
  packageCount: Scalars['Float']['output'];
  packageGroup?: Maybe<PackageGroup>;
  packages: Array<PackageEntity>;
  paperwork: OrderPaperworkEntity;
  paymentMethod?: Maybe<PaymentMethod>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhoneNumber?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  pieceCountFromPackages: Scalars['Float']['output'];
  pieces: Array<PieceEntity>;
  piecesDelivered: PiecesDeliveredEntity;
  piecesLoaded?: Maybe<Scalars['Int']['output']>;
  piecesPicked?: Maybe<Scalars['Int']['output']>;
  piecesPickedUp: PiecesPickedUpEntity;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  quaternaryRefNumber?: Maybe<Scalars['String']['output']>;
  quinaryRefNumber?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<QuoteEntity>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  recurringOrderFrequency?: Maybe<RecurringOrderFrequencyEntity>;
  refNumbers: Array<Scalars['String']['output']>;
  refusedBy?: Maybe<Scalars['String']['output']>;
  refusedDate?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  refusedReasonCode?: Maybe<OrderRefusalReason>;
  requiresPlacard?: Maybe<Scalars['Boolean']['output']>;
  reversalCounterpart?: Maybe<ReversalCounterpartOrder>;
  run?: Maybe<RunEntity>;
  scannedOrderResult?: Maybe<ScannedOrderResultEntity>;
  /** A field that represents a concatenation of all fields on the order that we want to search by. */
  searchText?: Maybe<Scalars['String']['output']>;
  secondaryRefNumber?: Maybe<Scalars['String']['output']>;
  service?: Maybe<ServiceEntity>;
  shipments: Array<ShipmentEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  shouldDisplayChargesInCustomerPortal: Scalars['Boolean']['output'];
  source: OrderSource;
  standardOrderFields: StandardOrderFieldsEntity;
  startStop?: Maybe<StopEntity>;
  status: OrderStatus;
  tags: Array<TagEntity>;
  tertiaryRefNumber?: Maybe<Scalars['String']['output']>;
  thirdPartyBrokers: Array<ThirdPartyBrokerEntity>;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the order in dollars */
  totalCharge: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  totalSkids?: Maybe<Scalars['Int']['output']>;
  unNumber?: Maybe<Scalars['String']['output']>;
  upcomingLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
  warehouse?: Maybe<WarehouseEntity>;
  weight: Scalars['Float']['output'];
};

export type OrderEventEntity = {
  __typename?: 'OrderEventEntity';
  createdAt: Scalars['DateTime']['output'];
  eventType: OrderEventType;
  ignoreSnapshot: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  mirroredFromPartner: Scalars['Boolean']['output'];
  order?: Maybe<OrderEntity>;
  snapshot?: Maybe<Scalars['String']['output']>;
  sourceDriver?: Maybe<DriverEntity>;
  sourceEdiTransaction?: Maybe<EdiTransactionEntity>;
  sourceEfmOutboundRequestEvent?: Maybe<EfmOutboundRequestEventEntity>;
  sourceExpeditorsOutboundRequestEvent?: Maybe<ExpeditorsOutboundRequestEventEntity>;
  sourceOutboundWebhookEvent?: Maybe<OutboundWebhookEventEntity>;
  sourcePicklist?: Maybe<PicklistEntity>;
  sourceSftpUpload?: Maybe<SftpUploadEntity>;
  sourceType: OrderEventSourceType;
  sourceUser?: Maybe<UserActorEntity>;
  sourceWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  targetContactPerson?: Maybe<ContactPersonEntity>;
  targetDocument?: Maybe<DocumentEntity>;
  targetDriver?: Maybe<DriverEntity>;
  targetEmail?: Maybe<Scalars['String']['output']>;
  targetInvoice?: Maybe<InvoiceEntity>;
  targetOrderTotalAfterConsolidation?: Maybe<Scalars['Float']['output']>;
  targetOrderTotalBeforeConsolidation?: Maybe<Scalars['Float']['output']>;
  targetPhoneNumber?: Maybe<Scalars['String']['output']>;
  targetPiece?: Maybe<PieceEntity>;
  targetRoute?: Maybe<RouteEntity>;
  targetSettlementBill?: Maybe<DriverSettlementBillEntity>;
  targetShipment?: Maybe<ShipmentEntity>;
  targetShipmentSubscriber?: Maybe<ShipmentSubscriberEntity>;
  targetStop?: Maybe<StopEntity>;
  targetType: OrderEventTargetType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type OrderEventNotificationSubscriptionEntity = {
  __typename?: 'OrderEventNotificationSubscriptionEntity';
  channel: NotificationChannel;
  eventType: OrderEventNotificationType;
  id: Scalars['String']['output'];
  subscriberType: NotificationSubscriberType;
};

export type OrderEventNotificationSubscriptionInput = {
  channel: NotificationChannel;
  eventType: OrderEventNotificationType;
  subscriberType: NotificationSubscriberType;
};

export enum OrderEventNotificationType {
  AppointmentCancelled = 'APPOINTMENT_CANCELLED',
  AppointmentConfirmed = 'APPOINTMENT_CONFIRMED',
  AppointmentDateChanged = 'APPOINTMENT_DATE_CHANGED',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryNextStop = 'DELIVERY_NEXT_STOP',
  LoadedOnTruck = 'LOADED_ON_TRUCK',
  OnHand = 'ON_HAND',
  OrderCreated = 'ORDER_CREATED',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  PickupCompleted = 'PICKUP_COMPLETED',
  PickupNextStop = 'PICKUP_NEXT_STOP',
  SchedulingInvitationSent = 'SCHEDULING_INVITATION_SENT',
  SchedulingSlotBooked = 'SCHEDULING_SLOT_BOOKED',
  SchedulingSlotRescheduled = 'SCHEDULING_SLOT_RESCHEDULED'
}

export type OrderEventSnapshotCreateInput = {
  orderUuid: Scalars['String']['input'];
  previousSnapshot?: InputMaybe<Scalars['String']['input']>;
  snapshot: Scalars['String']['input'];
};

export enum OrderEventSourceType {
  Api = 'API',
  Driver = 'DRIVER',
  EdiTransaction = 'EDI_TRANSACTION',
  Picklist = 'PICKLIST',
  SftpUpload = 'SFTP_UPLOAD',
  System = 'SYSTEM',
  ThirdPartyUser = 'THIRD_PARTY_USER',
  User = 'USER',
  WarehouseEmployee = 'WAREHOUSE_EMPLOYEE'
}

export enum OrderEventTargetType {
  ContactPerson = 'CONTACT_PERSON',
  CustomerContact = 'CUSTOMER_CONTACT',
  Document = 'DOCUMENT',
  Driver = 'DRIVER',
  Invoice = 'INVOICE',
  Order = 'ORDER',
  Piece = 'PIECE',
  PieceReceipt = 'PIECE_RECEIPT',
  ShipmentAndInvoice = 'SHIPMENT_AND_INVOICE',
  ShipmentSubscriber = 'SHIPMENT_SUBSCRIBER',
  Stop = 'STOP',
  StopAndRoute = 'STOP_AND_ROUTE',
  StorageOrder = 'STORAGE_ORDER'
}

export enum OrderEventType {
  ApiOrderApproved = 'API_ORDER_APPROVED',
  Call = 'CALL',
  CustomerPortalOrderApproved = 'CUSTOMER_PORTAL_ORDER_APPROVED',
  CustomerPortalOrderRejected = 'CUSTOMER_PORTAL_ORDER_REJECTED',
  DelegatedDocumentPropagated = 'DELEGATED_DOCUMENT_PROPAGATED',
  DelegatedDocumentPropagationRevoked = 'DELEGATED_DOCUMENT_PROPAGATION_REVOKED',
  DocumentScanningOrderApproved = 'DOCUMENT_SCANNING_ORDER_APPROVED',
  DocumentScanningOrderRejected = 'DOCUMENT_SCANNING_ORDER_REJECTED',
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  Edi = 'EDI',
  EdiOrderApproved = 'EDI_ORDER_APPROVED',
  ExternalApiTransmission = 'EXTERNAL_API_TRANSMISSION',
  NextStopPendingNotificationEmail = 'NEXT_STOP_PENDING_NOTIFICATION_EMAIL',
  NextStopPendingNotificationText = 'NEXT_STOP_PENDING_NOTIFICATION_TEXT',
  OrderCancelled = 'ORDER_CANCELLED',
  OrderCompleted = 'ORDER_COMPLETED',
  OrderConsolidated = 'ORDER_CONSOLIDATED',
  OrderCreated = 'ORDER_CREATED',
  OrderCreatedNotificationEmail = 'ORDER_CREATED_NOTIFICATION_EMAIL',
  OrderCreatedNotificationText = 'ORDER_CREATED_NOTIFICATION_TEXT',
  OrderDelegationAccepted = 'ORDER_DELEGATION_ACCEPTED',
  OrderDelegationCompleted = 'ORDER_DELEGATION_COMPLETED',
  OrderDelegationDeclined = 'ORDER_DELEGATION_DECLINED',
  OrderDelegationExpired = 'ORDER_DELEGATION_EXPIRED',
  OrderDelegationFieldsChangedByExecutor = 'ORDER_DELEGATION_FIELDS_CHANGED_BY_EXECUTOR',
  OrderDelegationOffered = 'ORDER_DELEGATION_OFFERED',
  OrderDelegationRevoked = 'ORDER_DELEGATION_REVOKED',
  OrderDuplicateDiscarded = 'ORDER_DUPLICATE_DISCARDED',
  OrderFinalized = 'ORDER_FINALIZED',
  OrderHasIssue = 'ORDER_HAS_ISSUE',
  OrderHasShortage = 'ORDER_HAS_SHORTAGE',
  OrderHoldRemoved = 'ORDER_HOLD_REMOVED',
  OrderInboundReviewDecided = 'ORDER_INBOUND_REVIEW_DECIDED',
  OrderLineHaulManifestRepointed = 'ORDER_LINE_HAUL_MANIFEST_REPOINTED',
  OrderLoaded = 'ORDER_LOADED',
  OrderMarkedNotCompleted = 'ORDER_MARKED_NOT_COMPLETED',
  OrderMarkedNotOnHand = 'ORDER_MARKED_NOT_ON_HAND',
  OrderMarkedNotOsd = 'ORDER_MARKED_NOT_OSD',
  OrderMarkedNotReceivedAtOrigin = 'ORDER_MARKED_NOT_RECEIVED_AT_ORIGIN',
  OrderMarkedOnHold = 'ORDER_MARKED_ON_HOLD',
  OrderMarkedOsd = 'ORDER_MARKED_OSD',
  OrderMatchedInboundDocument = 'ORDER_MATCHED_INBOUND_DOCUMENT',
  OrderMergedFromInbound = 'ORDER_MERGED_FROM_INBOUND',
  OrderNotReadyToInvoice = 'ORDER_NOT_READY_TO_INVOICE',
  OrderOnHand = 'ORDER_ON_HAND',
  OrderPicked = 'ORDER_PICKED',
  OrderPiecesLoadedUpdated = 'ORDER_PIECES_LOADED_UPDATED',
  OrderPiecesPickedUpdated = 'ORDER_PIECES_PICKED_UPDATED',
  OrderPieceCountUpdated = 'ORDER_PIECE_COUNT_UPDATED',
  OrderReceivedAtOrigin = 'ORDER_RECEIVED_AT_ORIGIN',
  OrderRefused = 'ORDER_REFUSED',
  OrderScanned = 'ORDER_SCANNED',
  OrderSnapshot = 'ORDER_SNAPSHOT',
  OrderUncancelled = 'ORDER_UNCANCELLED',
  OrderUnloaded = 'ORDER_UNLOADED',
  OrderUpdated = 'ORDER_UPDATED',
  OrderUpdateEmailSent = 'ORDER_UPDATE_EMAIL_SENT',
  PartnerDeliveryPodPending = 'PARTNER_DELIVERY_POD_PENDING',
  PartnerDeliverySent = 'PARTNER_DELIVERY_SENT',
  PieceCreated = 'PIECE_CREATED',
  PieceDamaged = 'PIECE_DAMAGED',
  PieceDamageCleared = 'PIECE_DAMAGE_CLEARED',
  PieceDeleted = 'PIECE_DELETED',
  PieceLinkedToPackage = 'PIECE_LINKED_TO_PACKAGE',
  PieceLocationChanged = 'PIECE_LOCATION_CHANGED',
  PieceMarkedMisrouted = 'PIECE_MARKED_MISROUTED',
  PieceMarkedOverage = 'PIECE_MARKED_OVERAGE',
  PieceMarkedShortage = 'PIECE_MARKED_SHORTAGE',
  PieceMisroutedCleared = 'PIECE_MISROUTED_CLEARED',
  PieceOnHandEventRemoved = 'PIECE_ON_HAND_EVENT_REMOVED',
  PieceOverageCleared = 'PIECE_OVERAGE_CLEARED',
  PieceReceiptCreated = 'PIECE_RECEIPT_CREATED',
  PieceReceiptPiecesAdded = 'PIECE_RECEIPT_PIECES_ADDED',
  PieceReceiptPiecesRemoved = 'PIECE_RECEIPT_PIECES_REMOVED',
  PieceReceiptPieceUpdated = 'PIECE_RECEIPT_PIECE_UPDATED',
  PieceRefused = 'PIECE_REFUSED',
  PieceScanned = 'PIECE_SCANNED',
  PieceShortageCleared = 'PIECE_SHORTAGE_CLEARED',
  PieceStatusChanged = 'PIECE_STATUS_CHANGED',
  PieceUnlinkedFromPackage = 'PIECE_UNLINKED_FROM_PACKAGE',
  PieceUpdated = 'PIECE_UPDATED',
  QuoteApproved = 'QUOTE_APPROVED',
  QuoteAutoSent = 'QUOTE_AUTO_SENT',
  QuoteCustomerAccepted = 'QUOTE_CUSTOMER_ACCEPTED',
  QuoteDeclined = 'QUOTE_DECLINED',
  QuoteExpired = 'QUOTE_EXPIRED',
  QuoteSent = 'QUOTE_SENT',
  ReceiptCreated = 'RECEIPT_CREATED',
  SettlementBillFinalized = 'SETTLEMENT_BILL_FINALIZED',
  SettlementBillLineItemAdded = 'SETTLEMENT_BILL_LINE_ITEM_ADDED',
  SettlementBillLineItemAddedToBill = 'SETTLEMENT_BILL_LINE_ITEM_ADDED_TO_BILL',
  SettlementBillLineItemRemoved = 'SETTLEMENT_BILL_LINE_ITEM_REMOVED',
  SettlementBillLineItemRemovedFromBill = 'SETTLEMENT_BILL_LINE_ITEM_REMOVED_FROM_BILL',
  SettlementBillUnfinalized = 'SETTLEMENT_BILL_UNFINALIZED',
  SetPackageLocation = 'SET_PACKAGE_LOCATION',
  SftpDocumentUploaded = 'SFTP_DOCUMENT_UPLOADED',
  ShipmentAddedToInvoice = 'SHIPMENT_ADDED_TO_INVOICE',
  SignedPodEmailSent = 'SIGNED_POD_EMAIL_SENT',
  StopAddedToRoute = 'STOP_ADDED_TO_ROUTE',
  StopAppointmentConfirmed = 'STOP_APPOINTMENT_CONFIRMED',
  StopAppointmentRescheduled = 'STOP_APPOINTMENT_RESCHEDULED',
  StopAppointmentSchedulingOptionsCall = 'STOP_APPOINTMENT_SCHEDULING_OPTIONS_CALL',
  StopAppointmentSchedulingOptionsTextMessage = 'STOP_APPOINTMENT_SCHEDULING_OPTIONS_TEXT_MESSAGE',
  StopAppointmentUnconfirmed = 'STOP_APPOINTMENT_UNCONFIRMED',
  StopArrived = 'STOP_ARRIVED',
  StopAttempted = 'STOP_ATTEMPTED',
  StopAttemptRemoved = 'STOP_ATTEMPT_REMOVED',
  StopCompleted = 'STOP_COMPLETED',
  StopCompletedNotificationEmail = 'STOP_COMPLETED_NOTIFICATION_EMAIL',
  StopCompletedNotificationText = 'STOP_COMPLETED_NOTIFICATION_TEXT',
  StopPaperworkMarkedComplete = 'STOP_PAPERWORK_MARKED_COMPLETE',
  StopPaperworkMarkedIncomplete = 'STOP_PAPERWORK_MARKED_INCOMPLETE',
  StopProofOfDeliverySigneeChanged = 'STOP_PROOF_OF_DELIVERY_SIGNEE_CHANGED',
  StopRemovedFromRoute = 'STOP_REMOVED_FROM_ROUTE',
  StorageOrderInventoryDeduction = 'STORAGE_ORDER_INVENTORY_DEDUCTION',
  TextMessage = 'TEXT_MESSAGE'
}

export type OrderForCachedStop = {
  __typename?: 'OrderForCachedStop';
  businessDivisionName?: Maybe<Scalars['String']['output']>;
  businessDivisionUuid?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personName */
  callerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: Maybe<Scalars['String']['output']>;
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  fulfillmentType?: Maybe<FulfillmentType>;
  inboundCity?: Maybe<Scalars['String']['output']>;
  inboundName?: Maybe<Scalars['String']['output']>;
  /** Contains inbound documents grouped by type */
  inboundPaperwork?: Maybe<OrderPaperworkEntity>;
  inboundStopType?: Maybe<PickupOrDelivery>;
  inboundZip?: Maybe<Scalars['String']['output']>;
  isDoorToDoor?: Maybe<Scalars['Boolean']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderComments: Array<OrderCommentForCachedStop>;
  orderSegmentType: OrderSegmentType;
  outboundCity?: Maybe<Scalars['String']['output']>;
  outboundName?: Maybe<Scalars['String']['output']>;
  /** Contains outbound documents grouped by type */
  outboundPaperwork?: Maybe<OrderPaperworkEntity>;
  outboundStopType?: Maybe<PickupOrDelivery>;
  outboundZip?: Maybe<Scalars['String']['output']>;
  packages: Array<PackageForCachedStop>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhoneNumber?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  refNumbers: Array<Scalars['String']['output']>;
  refusedBy?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceUuid?: Maybe<Scalars['String']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  tags: Array<TagEntity>;
  uuid: Scalars['String']['output'];
  vehicleTypeName?: Maybe<Scalars['String']['output']>;
  warehouseUuid?: Maybe<Scalars['String']['output']>;
};

/** An order and its fields returned as part of an invoice in the open invoice report */
export type OrderForOpenInvoiceReportEntity = {
  __typename?: 'OrderForOpenInvoiceReportEntity';
  addressName?: Maybe<Scalars['String']['output']>;
  destinationTerminalCode?: Maybe<Scalars['String']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  orderBalanceCents: Scalars['Float']['output'];
  orderName: Scalars['String']['output'];
  orderTotalCents: Scalars['Float']['output'];
  orderUuid: Scalars['String']['output'];
  originTerminalCode?: Maybe<Scalars['String']['output']>;
  pieces: Scalars['Float']['output'];
  refNumbers?: Maybe<Array<Scalars['String']['output']>>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  serviceDateV2?: Maybe<PlainDate>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type OrderForPaymentApplicationReportEntity = {
  __typename?: 'OrderForPaymentApplicationReportEntity';
  /** The amount applied to this order by this payment in dollars */
  appliedAmount: Scalars['Float']['output'];
  inboundAddressName?: Maybe<Scalars['String']['output']>;
  /** The invoice total in cents */
  invoiceBalance?: Maybe<Scalars['Float']['output']>;
  invoiceContactDisplayName?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceJournalNumber?: Maybe<Scalars['Float']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  /** The invoice total in dollars */
  invoiceTotal?: Maybe<Scalars['Float']['output']>;
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  orderBalance: Scalars['Float']['output'];
  orderName: Scalars['String']['output'];
  orderTotal: Scalars['Float']['output'];
  orderUuid: Scalars['String']['output'];
  outboundAddressName?: Maybe<Scalars['String']['output']>;
  pieces: Scalars['Float']['output'];
  refNumbers?: Maybe<Array<Scalars['String']['output']>>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type OrderForPaymentJournalReportEntity = {
  __typename?: 'OrderForPaymentJournalReportEntity';
  /** The amount applied to this order by this payment in dollars */
  appliedAmountDollars: Scalars['Float']['output'];
  invoiceCustomerName?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceJournalNumber?: Maybe<Scalars['Float']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderFormFieldsEntity = {
  __typename?: 'OrderFormFieldsEntity';
  onePackageRequired: Scalars['Boolean']['output'];
  onePackageWeightRequired: Scalars['Boolean']['output'];
  packagePiecesRequired: Scalars['Boolean']['output'];
  packageWeightRequired: Scalars['Boolean']['output'];
};

export type OrderFuzzyMatchHint = {
  __typename?: 'OrderFuzzyMatchHint';
  matchedField: ScanMatchedField;
  orderUuid: Scalars['String']['output'];
};

export enum OrderIdentifier {
  OrderName = 'ORDER_NAME',
  ShipperBillOfLadingNumber = 'SHIPPER_BILL_OF_LADING_NUMBER'
}

export type OrderImportConfigurationCreateInput = {
  alwaysCreateDummyOrderCharge: Scalars['Boolean']['input'];
};

export type OrderImportConfigurationEntity = {
  __typename?: 'OrderImportConfigurationEntity';
  alwaysCreateDummyOrderCharge: Scalars['Boolean']['output'];
  importedOrderTypeMappings: Array<ImportedOrderTypeMappingEntity>;
  uuid: Scalars['String']['output'];
};

export type OrderImportConfigurationUpdateInput = {
  alwaysCreateDummyOrderCharge: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type OrderLaneGroup = {
  __typename?: 'OrderLaneGroup';
  endTerminalCode: Scalars['String']['output'];
  laneKey: Scalars['String']['output'];
  /** Total piece count of orders that traverse this lane. */
  pieceCount: Scalars['Int']['output'];
  /** Number of OrderLineHaulSegment rows in this lane after filters are applied. */
  segmentCount: Scalars['Int']['output'];
  startTerminalCode: Scalars['String']['output'];
  /** Total weight in pounds of orders that traverse this lane. */
  weightLbs?: Maybe<Scalars['Float']['output']>;
};

export type OrderLaneGroupsOutput = {
  __typename?: 'OrderLaneGroupsOutput';
  groups: Array<OrderLaneGroup>;
  /** How many further unreachable corridors exist beyond the ones listed above, dropped by the report cap. 0 when the list is complete, which is the normal case. */
  omittedUnreachableCorridorCount: Scalars['Int']['output'];
  /** Total distinct lanes matching the filter set. */
  totalCount: Scalars['Int']['output'];
  /** Corridors on which orders exist but no terminal-lane path connects the endpoints, so those orders produce no row in any lane group above. A lane-configuration gap, reported here because it is otherwise invisible. Capped: see omittedUnreachableCorridorCount. Empty for companies without line-haul networks. Root branch only: a drilled-in lane has no use for it. */
  unreachableCorridors?: Maybe<Array<DispatchUnreachableCorridor>>;
};

export type OrderLineHaulLaneEntity = {
  __typename?: 'OrderLineHaulLaneEntity';
  destinationTerminalCode: Scalars['String']['output'];
  laneUuid?: Maybe<Scalars['String']['output']>;
  originTerminalCode: Scalars['String']['output'];
};

export type OrderLineHaulSegmentConnection = {
  __typename?: 'OrderLineHaulSegmentConnection';
  edges: Array<OrderLineHaulSegmentEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderLineHaulSegmentCreateInput = {
  lineHaulSegmentUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type OrderLineHaulSegmentEdge = {
  __typename?: 'OrderLineHaulSegmentEdge';
  cursor: Scalars['String']['output'];
  node: OrderLineHaulSegmentEntity;
};

export type OrderLineHaulSegmentEntity = {
  __typename?: 'OrderLineHaulSegmentEntity';
  arrivalScans: Array<ScanEntity>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  departureScans: Array<ScanEntity>;
  order: OrderEntity;
  priorOrderLineHaulSegment?: Maybe<OrderLineHaulSegmentEntity>;
  segment: LineHaulSegmentEntity;
  uuid: Scalars['String']['output'];
};

export type OrderLineHaulSegmentOutput = {
  __typename?: 'OrderLineHaulSegmentOutput';
  edges: Array<OrderLineHaulSegmentEntity>;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum OrderLineHaulSegmentSortFields {
  CustomerName = 'CUSTOMER_NAME',
  ServiceDate = 'SERVICE_DATE'
}

export type OrderLineHaulSegmentUpdateInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lineHaulSegmentUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** An event in the line haul timeline of an order. */
export type OrderLineHaulTimelineEventEntity = {
  __typename?: 'OrderLineHaulTimelineEventEntity';
  arrivalScans: Array<ScanEntity>;
  departingManifest?: Maybe<LineHaulManifestEntity>;
  departureScans: Array<ScanEntity>;
  markedArrivedAt?: Maybe<Scalars['DateTime']['output']>;
  terminal: TerminalEntity;
};

export type OrderMirrorCaptureCompanyEntity = {
  __typename?: 'OrderMirrorCaptureCompanyEntity';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
};

export type OrderMirrorCaptureConfigEntity = {
  __typename?: 'OrderMirrorCaptureConfigEntity';
  companies: Array<OrderMirrorCaptureCompanyEntity>;
  /** 'NONE', 'ALL', or 'COMPANIES'. */
  mode: Scalars['String']['output'];
};

export enum OrderNamingScheme {
  CompanyOrdinal = 'COMPANY_ORDINAL',
  ContactOrdinal = 'CONTACT_ORDINAL'
}

export type OrderOnLineHaulManifestEntity = {
  __typename?: 'OrderOnLineHaulManifestEntity';
  loadPosition?: Maybe<LoadPosition>;
  orderUuid: Scalars['String']['output'];
  ordinal?: Maybe<Scalars['Int']['output']>;
  piecesAwayFromRunOrigin?: Maybe<PiecesAwayFromRunOrigin>;
};

export enum OrderPdfColumnMapping {
  ClientReferenceNumber = 'CLIENT_REFERENCE_NUMBER'
}

/** Data about an order's paperwork, e.g. whether all required documents are attached */
export type OrderPaperworkEntity = {
  __typename?: 'OrderPaperworkEntity';
  alerts?: Maybe<Array<DocumentType>>;
  /** All documents uploaded to the order */
  attachedDocuments?: Maybe<Array<DocumentType>>;
  /** Document types missing from the order, required by the company's or contact's defaultInvoiceDocumentsRequired */
  missingDocuments?: Maybe<Array<DocumentType>>;
  other?: Maybe<Array<DocumentType>>;
  /**
   * Whether all documents required for a contact are attached.
   *       Can be manually overridden (see paperworkMarkedCompleteOverride).
   *       If no documents are required, this is false until overridden.
   */
  paperworkComplete: Scalars['Boolean']['output'];
  /** Whether this order's paperwork has been manually marked complete/incomplete. Null if not overridden */
  paperworkMarkedCompleteOverride?: Maybe<Scalars['Boolean']['output']>;
  photos?: Maybe<Array<DocumentType>>;
  proofOfDeliveryOrPickupReadyToSign?: Maybe<Array<DocumentType>>;
  proofOfDeliveryOrPickupSigned?: Maybe<Array<DocumentType>>;
};

/** One version of a quote the quote agent prepared from an inbound email, as the review list shows it */
export type OrderQuote = {
  __typename?: 'OrderQuote';
  attentionReasons: Array<QuoteAttentionReason>;
  conversationUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<OrderQuoteCustomer>;
  customerCandidates: Array<OrderQuoteCustomerCandidate>;
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  draftReplyApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  draftReplyBody?: Maybe<Scalars['String']['output']>;
  draftReplyKind?: Maybe<QuoteDraftReplyKind>;
  draftReplyUuid?: Maybe<Scalars['String']['output']>;
  /** What the agent read from the email: null when the extraction outcome is anything other than EXTRACTED (model refused, skipped for budget or rate limit, or pipeline failed) or on a row returned degraded because its stored snapshot is unreadable; orderQuoteForOrder and the pickQuoteCustomer and requestQuoteReprice results error on an unreadable snapshot instead */
  extractedRequest?: Maybe<OrderQuoteExtractedRequest>;
  /** This quote's uuid, or for a superseded version the uuid of the version that replaced it last */
  latestVersionUuid: Scalars['String']['output'];
  /** Fields the request left out that the draft order still lacks; every field the request left out when there is no draft order yet */
  missingFields: Array<Scalars['String']['output']>;
  needsAttentionAt?: Maybe<Scalars['DateTime']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderQuoteOrderSummary>;
  /** PRICED, UNPRICEABLE or NOT_ATTEMPTED */
  pricingState: Scalars['String']['output'];
  queueGroup: OrderQuoteQueueGroup;
  quotedAmountCents?: Maybe<Scalars['Int']['output']>;
  senderAddress: Scalars['String']['output'];
  senderDisplayName?: Maybe<Scalars['String']['output']>;
  senderRecoveredFromForward: Scalars['Boolean']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: OrderQuoteStatus;
  /** The email subject of the request this quote answers; null for quotes stored before it was recorded */
  subject?: Maybe<Scalars['String']['output']>;
  turnSeq: Scalars['Int']['output'];
  unpriceableReasons: Array<Scalars['String']['output']>;
  /** The approved reply of an earlier version whose send is unconfirmed, while this version carries the earlier-send flag */
  unsettledEarlierReply?: Maybe<OrderQuoteEarlierReply>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['Int']['output'];
};

export type OrderQuoteConnection = {
  __typename?: 'OrderQuoteConnection';
  edges: Array<OrderQuoteEdge>;
  /** Rows in the Needs you group; set only with scope OPEN and includeCount */
  needsYouCount?: Maybe<Scalars['Int']['output']>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrderQuoteCustomer = {
  __typename?: 'OrderQuoteCustomer';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type OrderQuoteCustomerCandidate = {
  __typename?: 'OrderQuoteCustomerCandidate';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  /** How the candidate was found: LEARNED_MAPPING, ADDRESS_BOOK, SENDER_HISTORY or DOMAIN */
  matchedBy?: Maybe<Scalars['String']['output']>;
};

/** An approved reply drafted for an earlier version of the quote whose send is not confirmed */
export type OrderQuoteEarlierReply = {
  __typename?: 'OrderQuoteEarlierReply';
  draftReplyApprovedAt: Scalars['DateTime']['output'];
  draftReplyBody: Scalars['String']['output'];
  draftReplyKind: QuoteDraftReplyKind;
  draftReplyUuid: Scalars['String']['output'];
  orderQuoteUuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type OrderQuoteEdge = {
  __typename?: 'OrderQuoteEdge';
  cursor: Scalars['String']['output'];
  node: OrderQuote;
};

export type OrderQuoteExtractedPackage = {
  __typename?: 'OrderQuoteExtractedPackage';
  /** The goods description */
  commodity?: Maybe<Scalars['String']['output']>;
  /** PER_UNIT, PER_SET or UNKNOWN */
  dimensionBasis: Scalars['String']['output'];
  /** IN, CM or UNKNOWN */
  dimensionUnit: Scalars['String']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  /** PALLET, SKID, BOX, PIECE or UNKNOWN */
  packaging: Scalars['String']['output'];
  piecesPerUnit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  /** EACH, TOTAL or UNKNOWN */
  weightBasis: Scalars['String']['output'];
  /** LB, KG or UNKNOWN */
  weightUnit: Scalars['String']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export type OrderQuoteExtractedParty = {
  __typename?: 'OrderQuoteExtractedParty';
  contact?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** What the quote agent read from the email, as the sender wrote it */
export type OrderQuoteExtractedRequest = {
  __typename?: 'OrderQuoteExtractedRequest';
  /** The sender's wording */
  accessorials: Array<Scalars['String']['output']>;
  consignee: OrderQuoteExtractedParty;
  /** The agent's outbound stop */
  delivery: OrderQuoteExtractedStop;
  /** YES, NO or UNKNOWN */
  hazmat: Scalars['String']['output'];
  packages: Array<OrderQuoteExtractedPackage>;
  /** The agent's inbound stop */
  pickup: OrderQuoteExtractedStop;
  readyTime?: Maybe<Scalars['String']['output']>;
  serviceWording?: Maybe<Scalars['String']['output']>;
  shipDate?: Maybe<Scalars['String']['output']>;
  shipper: OrderQuoteExtractedParty;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  /** What the agent dropped past its caps: packages, accessorial_picks, references, clarification_needed, stops.inbound.airlines, stops.outbound.airlines */
  truncatedFields: Array<Scalars['String']['output']>;
};

export type OrderQuoteExtractedStop = {
  __typename?: 'OrderQuoteExtractedStop';
  airlines: Array<Scalars['String']['output']>;
  airportCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** ADDRESS, AIRPORT, TERMINAL, ZIP_ONLY, CARRIER_FACILITY or UNKNOWN */
  kind: Scalars['String']['output'];
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  readyWindow?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OrderQuoteOrderSummary = {
  __typename?: 'OrderQuoteOrderSummary';
  name: Scalars['String']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

/** Where a quote sits in the queue: NEEDS_YOU (an operator must act or it is flagged), WAITING_ON_CUSTOMER (sent, nothing flagged) or CLOSED */
export enum OrderQuoteQueueGroup {
  Closed = 'CLOSED',
  NeedsYou = 'NEEDS_YOU',
  WaitingOnCustomer = 'WAITING_ON_CUSTOMER'
}

/** OPEN lists the quotes that need an operator, then the quotes waiting on the customer. CLOSED lists accepted, declined, expired and dismissed quotes that are not flagged. */
export enum OrderQuoteQueueScope {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

/** The status of a quote prepared by the quote agent */
export enum OrderQuoteStatus {
  Accepted = 'ACCEPTED',
  CustomerAccepted = 'CUSTOMER_ACCEPTED',
  CustomerReplied = 'CUSTOMER_REPLIED',
  Declined = 'DECLINED',
  Dismissed = 'DISMISSED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Requested = 'REQUESTED',
  Sent = 'SENT',
  Superseded = 'SUPERSEDED',
  Unpriceable = 'UNPRICEABLE'
}

/** A filter object that is used to filter the order quote status enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type OrderQuoteStatusFilter = {
  /** Filters for records where the relevant order quote status field is equal to the provided order quote status value */
  eq?: InputMaybe<OrderQuoteStatus>;
  /** Filters for records where the relevant order quote status field is in the provided order quote status values */
  in?: InputMaybe<Array<OrderQuoteStatus>>;
  /** Filters for records where the relevant order quote status field is not equal to the provided order quote status value */
  neq?: InputMaybe<OrderQuoteStatus>;
  /** Filters for records where the relevant order quote status field is not in the provided order quote status values */
  nin?: InputMaybe<Array<OrderQuoteStatus>>;
};

export enum OrderRefusalReason {
  ConsigneeClosed = 'CONSIGNEE_CLOSED',
  Damaged = 'DAMAGED',
  NotOrdered = 'NOT_ORDERED',
  NoSpace = 'NO_SPACE',
  Other = 'OTHER',
  WrongItem = 'WRONG_ITEM'
}

export type OrderReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportAggregationPeriod: ReportAggregationPeriod;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  /** IANA zone the report reads its days in; honored only while terminal_local_times is on. When null, insight reports count each order on its stop's local service day, and the audit report uses the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OrderReportBucketEntity = {
  __typename?: 'OrderReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
};

export type OrderRevenueReportInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  isLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyCompletedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** The zone serviceDateFilter is read in. Empty: each order on its own local service day while terminal_local_times is on, else the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  /** @deprecated Deprecated. Use serviceDateFilter instead */
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSegmentLeavesOutput = {
  __typename?: 'OrderSegmentLeavesOutput';
  rows: Array<DispatchOrderRow>;
  /** Total segment-level rows in the lane matching the filter set. */
  totalCount: Scalars['Int']['output'];
};

export enum OrderSegmentType {
  Cartage = 'CARTAGE',
  Courier = 'COURIER'
}

export type OrderServiceDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OrderSort = {
  sortBy: OrderTableField;
  sortDirection: OrderSortDirection;
};

export enum OrderSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrderSortV2 = {
  completedAtSortInput?: InputMaybe<CompletedAtSortInput>;
  customerNameSortInput?: InputMaybe<CustomerNameSortInput>;
  dateMarkedOnHandSortInput?: InputMaybe<DateMarkedOnHandSortInput>;
  destinationDetailsSortInput?: InputMaybe<DestinationDetailsSortInput>;
  destinationTerminalSortInput?: InputMaybe<DestinationTerminalSortInput>;
  dimWeightSortInput?: InputMaybe<DimWeightSortInput>;
  fieldName: OrderTableField;
  inBondSortInput?: InputMaybe<InBondSortInput>;
  inboundAddressNameSortInput?: InputMaybe<InboundAddressNameSortInput>;
  inboundAddressSortInput?: InputMaybe<InboundAddressSortInput>;
  inboundCityNameSortInput?: InputMaybe<InboundCityNameSortInput>;
  inboundCompletedDateSortInput?: InputMaybe<InboundCompletedDateSortInput>;
  inboundDriverNameSortInput?: InputMaybe<InboundDriverNameSortInput>;
  inboundRouteDateSortInput?: InputMaybe<InboundRouteDateSortInput>;
  inboundRouteNameSortInput?: InputMaybe<InboundRouteNameSortInput>;
  inboundServiceDateSortInput?: InputMaybe<InboundServiceDateSortInput>;
  inboundZipcodeSortInput?: InputMaybe<InboundZipcodeSortInput>;
  isReweighedSortInput?: InputMaybe<IsReweighedSortInput>;
  locationSortInput?: InputMaybe<LocationSortInput>;
  mawbSortInput?: InputMaybe<MawbSortInput>;
  nameSortInput?: InputMaybe<NameSortInput>;
  orderConsigneeSortInput?: InputMaybe<OrderConsigneeSortInput>;
  orderServiceDateSortInput?: InputMaybe<OrderServiceDateSortInput>;
  orderSourceSortInput?: InputMaybe<OrderSourceSortInput>;
  originTerminalSortInput?: InputMaybe<OriginTerminalSortInput>;
  outboundAddressNameSortInput?: InputMaybe<OutboundAddressNameSortInput>;
  outboundAddressSortInput?: InputMaybe<OutboundAddressSortInput>;
  outboundCityNameSortInput?: InputMaybe<OutboundCityNameSortInput>;
  outboundCompletedDateSortInput?: InputMaybe<OutboundCompletedDateSortInput>;
  outboundDriverNameSortInput?: InputMaybe<OutboundDriverNameSortInput>;
  outboundMethodSortInput?: InputMaybe<OutboundMethodSortInput>;
  outboundRouteDateSortInput?: InputMaybe<OutboundRouteDateSortInput>;
  outboundRouteNameSortInput?: InputMaybe<OutboundRouteNameSortInput>;
  outboundServiceDateSortInput?: InputMaybe<OutboundServiceDateSortInput>;
  outboundZipcodeSortInput?: InputMaybe<OutboundZipcodeSortInput>;
  pieceCountSortInput?: InputMaybe<PieceCountSortInput>;
  secondaryRefNumberSortInput?: InputMaybe<SecondaryRefNumberSortInput>;
  shipperBillOfLadingNumberSortInput?: InputMaybe<ShipperBillOfLadingNumberSortInput>;
  totalPackageWeightSortInput?: InputMaybe<TotalPackageWeightSortInput>;
  totalSkidsSortInput?: InputMaybe<TotalSkidsSortInput>;
};

export enum OrderSource {
  Api = 'API',
  Consolidation = 'CONSOLIDATION',
  CsvImport = 'CSV_IMPORT',
  Cuda = 'CUDA',
  CustomerPortal = 'CUSTOMER_PORTAL',
  Delegated = 'DELEGATED',
  DocumentScanning = 'DOCUMENT_SCANNING',
  Edi = 'EDI',
  EmailQuote = 'EMAIL_QUOTE',
  Expeditors = 'EXPEDITORS',
  FiveString = 'FIVE_STRING',
  FromTemplate = 'FROM_TEMPLATE',
  IsTemplate = 'IS_TEMPLATE',
  ManuallyEntered = 'MANUALLY_ENTERED',
  Migrated = 'MIGRATED',
  Mirror = 'MIRROR',
  Quote = 'QUOTE',
  Rebilled = 'REBILLED'
}

/** A filter object that is used to filter the order source enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type OrderSourceFilter = {
  /** Filters for records where the relevant order source field is equal to the provided order source value */
  eq?: InputMaybe<OrderSource>;
  /** Filters for records where the relevant order source field is in the provided order source values */
  in?: InputMaybe<Array<OrderSource>>;
  /** Filters for records where the relevant order source field is not equal to the provided order source value */
  neq?: InputMaybe<OrderSource>;
  /** Filters for records where the relevant order source field is not in the provided order source values */
  nin?: InputMaybe<Array<OrderSource>>;
};

export type OrderSourceSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OrderSplitSummaryInput = {
  orderUuids: Array<Scalars['String']['input']>;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Finalized = 'FINALIZED',
  HasIssue = 'HAS_ISSUE',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  OnHold = 'ON_HOLD'
}

/** A filter object that is used to filter the order status enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type OrderStatusFilter = {
  /** Filters for records where the relevant order status field is equal to the provided order status value */
  eq?: InputMaybe<OrderStatus>;
  /** Filters for records where the relevant order status field is in the provided order status values */
  in?: InputMaybe<Array<OrderStatus>>;
  /** Filters for records where the relevant order status field is not equal to the provided order status value */
  neq?: InputMaybe<OrderStatus>;
  /** Filters for records where the relevant order status field is not in the provided order status values */
  nin?: InputMaybe<Array<OrderStatus>>;
};

export enum OrderStatusFilterType {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export type OrderTableCustomChargeFieldEntity = {
  __typename?: 'OrderTableCustomChargeFieldEntity';
  /** The billing method of the custom charge. */
  billingMethod: CustomChargeBillingMethod;
  /** The name of the custom charge. */
  name: Scalars['String']['output'];
  /** The total for the custom charge in dollars */
  total: Scalars['Float']['output'];
};

export enum OrderTableField {
  AdditionalCharges = 'ADDITIONAL_CHARGES',
  Attempted = 'ATTEMPTED',
  BillingReviewStatus = 'BILLING_REVIEW_STATUS',
  BillOfLadingNumber = 'BILL_OF_LADING_NUMBER',
  BusinessDivision = 'BUSINESS_DIVISION',
  Charges = 'CHARGES',
  CityName = 'CITY_NAME',
  Company = 'COMPANY',
  CompletedAt = 'COMPLETED_AT',
  ContactInformation = 'CONTACT_INFORMATION',
  ContactName = 'CONTACT_NAME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CustomerName = 'CUSTOMER_NAME',
  DestinationDetails = 'DESTINATION_DETAILS',
  DestinationTerminal = 'DESTINATION_TERMINAL',
  Dims = 'DIMS',
  DimWeight = 'DIM_WEIGHT',
  DriverName = 'DRIVER_NAME',
  DriverSettlement = 'DRIVER_SETTLEMENT',
  ExternalNotes = 'EXTERNAL_NOTES',
  HasDriverPod = 'HAS_DRIVER_POD',
  HoldReason = 'HOLD_REASON',
  InboundAddress = 'INBOUND_ADDRESS',
  InboundAddressName = 'INBOUND_ADDRESS_NAME',
  InboundAddressType = 'INBOUND_ADDRESS_TYPE',
  InboundAppointment = 'INBOUND_APPOINTMENT',
  InboundAppointmentConfirmed = 'INBOUND_APPOINTMENT_CONFIRMED',
  InboundAppointmentDate = 'INBOUND_APPOINTMENT_DATE',
  InboundAppointmentTime = 'INBOUND_APPOINTMENT_TIME',
  InboundCharges = 'INBOUND_CHARGES',
  InboundCityName = 'INBOUND_CITY_NAME',
  InboundCompletedDate = 'INBOUND_COMPLETED_DATE',
  InboundContactName = 'INBOUND_CONTACT_NAME',
  InboundDriverName = 'INBOUND_DRIVER_NAME',
  InboundMethod = 'INBOUND_METHOD',
  InboundOnTimePerformanceStatus = 'INBOUND_ON_TIME_PERFORMANCE_STATUS',
  InboundPaperwork = 'INBOUND_PAPERWORK',
  InboundRouteDate = 'INBOUND_ROUTE_DATE',
  InboundRouteName = 'INBOUND_ROUTE_NAME',
  InboundRouting = 'INBOUND_ROUTING',
  InboundServiceDate = 'INBOUND_SERVICE_DATE',
  InboundStopTotalTime = 'INBOUND_STOP_TOTAL_TIME',
  InboundStopType = 'INBOUND_STOP_TYPE',
  InboundStopWaitTime = 'INBOUND_STOP_WAIT_TIME',
  InboundZipcode = 'INBOUND_ZIPCODE',
  InvoiceName = 'INVOICE_NAME',
  InBond = 'IN_BOND',
  IsLinehaul = 'IS_LINEHAUL',
  IsReweighed = 'IS_REWEIGHED',
  ItTeNumber = 'IT_TE_NUMBER',
  LineHaulCharges = 'LINE_HAUL_CHARGES',
  LineHaulManifests = 'LINE_HAUL_MANIFESTS',
  Location = 'LOCATION',
  Mawb = 'MAWB',
  Name = 'NAME',
  NextAddress = 'NEXT_ADDRESS',
  NextAppointment = 'NEXT_APPOINTMENT',
  NextConsignee = 'NEXT_CONSIGNEE',
  NextDeadline = 'NEXT_DEADLINE',
  Notes = 'NOTES',
  OnHold = 'ON_HOLD',
  OrderConsignee = 'ORDER_CONSIGNEE',
  OrderLevelIssues = 'ORDER_LEVEL_ISSUES',
  OrderServiceDate = 'ORDER_SERVICE_DATE',
  OrderType = 'ORDER_TYPE',
  OriginTerminal = 'ORIGIN_TERMINAL',
  OsdReason = 'OSD_REASON',
  OutboundAddress = 'OUTBOUND_ADDRESS',
  OutboundAddressName = 'OUTBOUND_ADDRESS_NAME',
  OutboundAddressType = 'OUTBOUND_ADDRESS_TYPE',
  OutboundAppointment = 'OUTBOUND_APPOINTMENT',
  OutboundAppointmentConfirmed = 'OUTBOUND_APPOINTMENT_CONFIRMED',
  OutboundAppointmentDate = 'OUTBOUND_APPOINTMENT_DATE',
  OutboundAppointmentTime = 'OUTBOUND_APPOINTMENT_TIME',
  OutboundCharges = 'OUTBOUND_CHARGES',
  OutboundCityName = 'OUTBOUND_CITY_NAME',
  OutboundCompletedDate = 'OUTBOUND_COMPLETED_DATE',
  OutboundContactName = 'OUTBOUND_CONTACT_NAME',
  OutboundDriverName = 'OUTBOUND_DRIVER_NAME',
  OutboundMethod = 'OUTBOUND_METHOD',
  OutboundOnTimePerformanceStatus = 'OUTBOUND_ON_TIME_PERFORMANCE_STATUS',
  OutboundPaperwork = 'OUTBOUND_PAPERWORK',
  OutboundRouteDate = 'OUTBOUND_ROUTE_DATE',
  OutboundRouteName = 'OUTBOUND_ROUTE_NAME',
  OutboundRouting = 'OUTBOUND_ROUTING',
  OutboundServiceDate = 'OUTBOUND_SERVICE_DATE',
  OutboundStopTotalTime = 'OUTBOUND_STOP_TOTAL_TIME',
  OutboundStopType = 'OUTBOUND_STOP_TYPE',
  OutboundStopWaitTime = 'OUTBOUND_STOP_WAIT_TIME',
  OutboundZipcode = 'OUTBOUND_ZIPCODE',
  PaperworkComplete = 'PAPERWORK_COMPLETE',
  Photos = 'PHOTOS',
  PieceCount = 'PIECE_COUNT',
  PieceTerminalLocations = 'PIECE_TERMINAL_LOCATIONS',
  PodName = 'POD_NAME',
  PrimaryAddress = 'PRIMARY_ADDRESS',
  PrimaryAddressType = 'PRIMARY_ADDRESS_TYPE',
  PrimaryAppointment = 'PRIMARY_APPOINTMENT',
  PrimaryConsignee = 'PRIMARY_CONSIGNEE',
  PrimaryContactName = 'PRIMARY_CONTACT_NAME',
  PrimaryDeadline = 'PRIMARY_DEADLINE',
  PrimaryServiceDate = 'PRIMARY_SERVICE_DATE',
  PrimaryServiceLevel = 'PRIMARY_SERVICE_LEVEL',
  ReceivedAt = 'RECEIVED_AT',
  RouteName = 'ROUTE_NAME',
  RoutingLocation = 'ROUTING_LOCATION',
  SecondaryRefNumber = 'SECONDARY_REF_NUMBER',
  ShipmentType = 'SHIPMENT_TYPE',
  Source = 'SOURCE',
  Special = 'SPECIAL',
  Status = 'STATUS',
  StopTypes = 'STOP_TYPES',
  Tags = 'TAGS',
  TotalChargesWithItemized = 'TOTAL_CHARGES_WITH_ITEMIZED',
  TotalSkids = 'TOTAL_SKIDS',
  UnNumber = 'UN_NUMBER',
  Weight = 'WEIGHT',
  Zipcode = 'ZIPCODE'
}

/** Represents a table or column header for an order table field that is requested as part of an order retrieval for the orders table */
export type OrderTableFieldHeaderEntity = {
  __typename?: 'OrderTableFieldHeaderEntity';
  header: Scalars['String']['output'];
  /** Whether the orders table can be grouped by this field. Decided server-side from the columns the flat orders view carries, so the client never offers a grouping the query would refuse. */
  isGroupable: Scalars['Boolean']['output'];
  /** Whether the orders table can be grouped by this field while the new search serves it. A subset of isGroupable: only fields whose groups on the new search match the classic ones. */
  isGroupableOnNewSearch: Scalars['Boolean']['output'];
  orderTableField: OrderTableField;
};

/** Groups the orders table by one or more columns. `fields` is the ordered list of grouping levels; `keys` holds the group value for each level the client has already expanded, outermost first. When `keys` is shorter than `fields` the query answers with the group rows of the next level; when the two are the same length it answers with the orders under that path. A null key selects the orders whose value is blank. */
export type OrderTableGroupByInput = {
  /** Order of the group rows by their value; ascending when omitted. A blank value sorts as the largest, so it comes last ascending and first descending. */
  direction?: InputMaybe<SortDirection>;
  /** Grouping levels, outermost first. */
  fields: Array<OrderTableField>;
  /** Group value for each expanded level, outermost first. Never longer than `fields`. */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  /** Most group rows to return. Ignored for a fully expanded path, where `first` bounds the orders page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Rows to skip within the requested level, for group rows and for the orders under a fully expanded path alike. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** One group of the orders table at the level the request asked for: the value shared by its orders, the text to show for it, and how many orders it holds. */
export type OrderTableGroupRowEntity = {
  __typename?: 'OrderTableGroupRowEntity';
  /** Number of orders in the group under the active filters. */
  count: Scalars['Int']['output'];
  /** The group value as the client must send it back in `groupBy.keys` to expand this group. Null for the orders whose value is blank. */
  key?: Maybe<Scalars['String']['output']>;
  /** Display text for the group. Null when the value is blank, so the client can render its own placeholder. */
  label?: Maybe<Scalars['String']['output']>;
};

export type OrderTableItemizedChargesFieldEntity = {
  __typename?: 'OrderTableItemizedChargesFieldEntity';
  /** @deprecated Now uses charges for more granular viewing */
  customCharges: Array<OrderTableCustomChargeFieldEntity>;
  /** @deprecated Now uses charges for more granular viewing */
  freightChargeTotal: Scalars['Float']['output'];
  /** @deprecated Now uses charges for more granular viewing */
  fuelChargeTotal: Scalars['Float']['output'];
  orderTableField: OrderTableField;
  /** The result of rating the order. If null, order rating was skipped as part of retrieving the itemized charges field */
  rateOrderOutput?: Maybe<RateOrderOutput>;
  shipmentCharges: Array<OrderTableItemizedChargesFieldShipmentEntity>;
};

export type OrderTableItemizedChargesFieldShipmentEntity = {
  __typename?: 'OrderTableItemizedChargesFieldShipmentEntity';
  customCharges: Array<OrderTableCustomChargeFieldEntity>;
  freightBillingMethod?: Maybe<FreightBillingMethod>;
  freightQuantity?: Maybe<Scalars['Float']['output']>;
  freightRate?: Maybe<Scalars['Currency']['output']>;
  freightTotalAmount?: Maybe<Scalars['Currency']['output']>;
  fuelBillingMethod?: Maybe<FuelBillingMethod>;
  fuelFlatRate?: Maybe<Scalars['Currency']['output']>;
  fuelSurchargeRate?: Maybe<Scalars['Percent']['output']>;
  fuelTotalAmount?: Maybe<Scalars['Currency']['output']>;
  /** @deprecated Use stopType instead */
  pickupOrDelivery?: Maybe<PickupOrDelivery>;
  shipmentType: ShipmentType;
  stopType?: Maybe<StopType>;
  tariff?: Maybe<TariffEntity>;
};

/** Represents a single line haul manifest that an order is on. Returned as part of a formatted line haul manifests order table field */
export type OrderTableLineHaulManifestEntity = {
  __typename?: 'OrderTableLineHaulManifestEntity';
  endTerminal: TerminalEntity;
  startTerminal: TerminalEntity;
  status: LineHaulManifestStatus;
};

export type OrderTableLineHaulManifestsFieldEntity = {
  __typename?: 'OrderTableLineHaulManifestsFieldEntity';
  /** The current terminal that the order is in. Null if the order is not on a line haul manifest */
  currentTerminal?: Maybe<TerminalEntity>;
  /** The end terminal of the order. */
  endTerminal: TerminalEntity;
  lineHaulManifests: Array<OrderTableLineHaulManifestEntity>;
  orderTableField: OrderTableField;
  /** The start terminal of the order. */
  startTerminal: TerminalEntity;
};

export type OrderTablePackageEntity = {
  __typename?: 'OrderTablePackageEntity';
  height?: Maybe<Scalars['Length']['output']>;
  length?: Maybe<Scalars['Length']['output']>;
  quantity: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Mass']['output']>;
  width?: Maybe<Scalars['Length']['output']>;
};

/** Represents the custom value for the "Dims" order table field that is returned as part of a retrieval query */
export type OrderTablePackagesFieldEntity = {
  __typename?: 'OrderTablePackagesFieldEntity';
  orderTableField: OrderTableField;
  orderTablePackages: Array<OrderTablePackageEntity>;
};

export type OrderTablePaperworkFieldEntity = {
  __typename?: 'OrderTablePaperworkFieldEntity';
  /** Contains inbound documents grouped by type */
  inboundPaperwork?: Maybe<OrderPaperworkEntity>;
  orderTableField: OrderTableField;
  /** Contains outbound documents grouped by type */
  outboundPaperwork?: Maybe<OrderPaperworkEntity>;
  paperwork: OrderPaperworkEntity;
};

export type OrderTablePhotoEntity = {
  __typename?: 'OrderTablePhotoEntity';
  fileName: Scalars['String']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  shipmentPickupOrDelivery: PickupOrDelivery;
  shipmentUuid: Scalars['String']['output'];
  stopType: StopType;
  type: DocumentType;
};

export type OrderTablePhotosFieldEntity = {
  __typename?: 'OrderTablePhotosFieldEntity';
  orderTableField: OrderTableField;
  orderTablePhotos: Array<OrderTablePhotoEntity>;
};

/** The output shape of the order table report when the number of orders is below the threshold and is generated and downloaded synchronously */
export type OrderTableReportDownloadOutput = {
  __typename?: 'OrderTableReportDownloadOutput';
  reportGenerationStatus: ReportGenerationStatus;
  reportUrl: Scalars['String']['output'];
};

/** The output shape of the order table report when the number of orders is above the threshold and is generated asynchronously and is emailed to the user */
export type OrderTableReportEmailToUserOutput = {
  __typename?: 'OrderTableReportEmailToUserOutput';
  reportGenerationStatus: ReportGenerationStatus;
};

export type OrderTableServiceEntity = {
  __typename?: 'OrderTableServiceEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type OrderTableServiceFieldEntity = {
  __typename?: 'OrderTableServiceFieldEntity';
  orderTableField: OrderTableField;
  service?: Maybe<OrderTableServiceEntity>;
};

export type OrderTableTagEntity = {
  __typename?: 'OrderTableTagEntity';
  color?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type OrderTableTagsFieldEntity = {
  __typename?: 'OrderTableTagsFieldEntity';
  orderTableField: OrderTableField;
  orderTableTags: Array<OrderTableTagEntity>;
};

export type OrderToAddToInvoice = {
  __typename?: 'OrderToAddToInvoice';
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  shipmentUuids: Array<Scalars['String']['output']>;
};

export type OrderToChargeEntity = {
  __typename?: 'OrderToChargeEntity';
  /** Amount to apply to this order */
  amountInCents: Scalars['Int']['output'];
  billToContactDisplayName?: Maybe<Scalars['String']['output']>;
  /** UUID of the customer the order is invoiced to (the invoice bill-to), so the client can total a payment by customer when it spans several. */
  billToContactUuid?: Maybe<Scalars['String']['output']>;
  /** Current order balance (before applying new payment) */
  currentBalanceInCents: Scalars['Int']['output'];
  /** Order's HAWB (shipperBillOfLadingNumber), or null when the order has none. Lets the client group/count preview rows by HAWB without re-fetching from the paginated order list. */
  hawb?: Maybe<Scalars['String']['output']>;
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  /** New order balance after applying specified amountInCents */
  lineBalanceInCents: Scalars['Int']['output'];
  /** Order total charge */
  orderTotalInCents: Scalars['Int']['output'];
  orderUuid: Scalars['String']['output'];
};

export type OrderUuidsInput = {
  orderUuids: Array<Scalars['String']['input']>;
};

export type OrderVolumeByCompanyInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeByContactInput = {
  companyUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeByDateRangeInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  period: ReportAggregationPeriod;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  startDate: Scalars['DateTime']['input'];
};

export type OrderVolumeBySchemaInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeByUserInput = {
  companyUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeCompanyBucketEntity = {
  __typename?: 'OrderVolumeCompanyBucketEntity';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
};

export type OrderVolumeContactBucketEntity = {
  __typename?: 'OrderVolumeContactBucketEntity';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
};

/** The open invoice value for a contact within the specified day range */
export type OrderVolumeDateRangeBucketEntity = {
  __typename?: 'OrderVolumeDateRangeBucketEntity';
  contactUuid?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
  startDate: Scalars['DateTime']['output'];
};

export type OrderVolumeSchemaBucketEntity = {
  __typename?: 'OrderVolumeSchemaBucketEntity';
  schemaName: Scalars['String']['output'];
  schemaUuid?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
};

export type OrderVolumeSourceBucketEntity = {
  __typename?: 'OrderVolumeSourceBucketEntity';
  scannedOrderSource?: Maybe<ScannedOrderSource>;
  source: OrderSource;
  totalCount: Scalars['Float']['output'];
};

export type OrderVolumeUserBucketEntity = {
  __typename?: 'OrderVolumeUserBucketEntity';
  name?: Maybe<Scalars['String']['output']>;
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
  userEmail: Scalars['String']['output'];
  userTerminalName?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['String']['output'];
};

export type OrderWithPieceNameEntity = {
  __typename?: 'OrderWithPieceNameEntity';
  order: OrderEntity;
  /** The unique piece ID associated with this scanned order */
  pieceName?: Maybe<Scalars['String']['output']>;
};

export type OrdersByHawbInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
  hawb: Scalars['String']['input'];
};

export type OrdersForPaymentsSort = {
  sortBy: OrdersForPaymentsSortField;
  sortDirection: SortDirection;
};

export enum OrdersForPaymentsSortField {
  Customer = 'Customer',
  /** The posted invoice balance; unposted invoices sort last in both directions */
  InvoiceBalance = 'InvoiceBalance',
  /** The invoice journal number when the company uses journal numbers for invoices, otherwise the invoice name */
  InvoiceName = 'InvoiceName',
  /** The posted invoice amount; unposted invoices sort last in both directions */
  InvoiceTotal = 'InvoiceTotal',
  MasterAirwayBillOfLadingNumber = 'MasterAirwayBillOfLadingNumber',
  /** The order total minus the payments applied to it */
  OrderBalance = 'OrderBalance',
  OrderName = 'OrderName',
  /** The posted order amount, falling back to the order total */
  OrderTotal = 'OrderTotal',
  SecondaryRefNumber = 'SecondaryRefNumber',
  ShipperBillOfLadingNumber = 'ShipperBillOfLadingNumber'
}

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationEntity;
};

/** This entity represents the fields that an organization will always have regardless of the type */
export type OrganizationEntity = {
  __typename?: 'OrganizationEntity';
  addresses: Array<AddressEntity>;
  agentFields?: Maybe<AgentFieldsEntity>;
  contactPersons: Array<ContactPersonEntity>;
  createdAt: Scalars['DateTime']['output'];
  customerFields?: Maybe<CustomerFieldsEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  types: Array<OrganizationType>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum OrganizationInvoiceVendorDisplayName {
  BusinessDivisionName = 'BUSINESS_DIVISION_NAME',
  CompanyName = 'COMPANY_NAME',
  CompanyNameAndBusinessDivisionName = 'COMPANY_NAME_AND_BUSINESS_DIVISION_NAME'
}

export type OrganizationMessageAudienceInput = {
  /** Every company that receives broadcasts (CUSTOMER and INTERNAL). `companyUuids` must then be empty. */
  allCompanies: Scalars['Boolean']['input'];
  companyUuids?: Array<Scalars['String']['input']>;
};

export type OrganizationMessageBannerEntity = {
  __typename?: 'OrganizationMessageBannerEntity';
  body: Scalars['String']['output'];
  /** Whether dismissing is saved for the user (WARNING). A CRITICAL banner can only be hidden on screen and returns on reload. */
  dismissible: Scalars['Boolean']['output'];
  linkLabel?: Maybe<Scalars['String']['output']>;
  linkTarget?: Maybe<Scalars['String']['output']>;
  linkType?: Maybe<OrganizationMessageLinkType>;
  severity: OrganizationMessageSeverity;
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type OrganizationMessageBannersEntity = {
  __typename?: 'OrganizationMessageBannersEntity';
  /** CRITICAL first, then WARNING, newest first. */
  banners: Array<OrganizationMessageBannerEntity>;
  /** The next time this set changes on its own (an expiry or a scheduled start); refetch then. */
  nextChangeAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationMessageCompanyEntity = {
  __typename?: 'OrganizationMessageCompanyEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type OrganizationMessageConnection = {
  __typename?: 'OrganizationMessageConnection';
  edges: Array<OrganizationMessageEdge>;
  pageInfo: PageInfo;
};

export type OrganizationMessageContentInput = {
  body?: Scalars['String']['input'];
  /** When the message stops showing. Omitted uses the severity default (INFO 14 days, WARNING 3 days, CRITICAL never); null means never. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  link?: InputMaybe<OrganizationMessageLinkInput>;
  severity: OrganizationMessageSeverity;
  /** Optional; most messages need only the body. */
  title?: Scalars['String']['input'];
};

export type OrganizationMessageCountsEntity = {
  __typename?: 'OrganizationMessageCountsEntity';
  drafts: Scalars['Int']['output'];
  ended: Scalars['Int']['output'];
  live: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
};

export type OrganizationMessageEdge = {
  __typename?: 'OrganizationMessageEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationMessageEntity;
};

export type OrganizationMessageEntity = {
  __typename?: 'OrganizationMessageEntity';
  /** Sent to every company that receives broadcasts; otherwise to `companies`. */
  allCompanies: Scalars['Boolean']['output'];
  body: Scalars['String']['output'];
  /** The addressed companies by name; empty when sent to all. */
  companies: Array<OrganizationMessageCompanyEntity>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserUuid: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  followsMessageUuid?: Maybe<Scalars['String']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  linkTarget?: Maybe<Scalars['String']['output']>;
  linkType?: Maybe<OrganizationMessageLinkType>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  severity: OrganizationMessageSeverity;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: OrganizationMessageStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The expiry is the severity default, counted from when the message starts showing. */
  usesDefaultExpiry: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrganizationMessageEventAction {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Edited = 'EDITED',
  Published = 'PUBLISHED',
  Rescheduled = 'RESCHEDULED',
  Resolved = 'RESOLVED',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED',
  Withdrawn = 'WITHDRAWN'
}

export type OrganizationMessageEventEntity = {
  __typename?: 'OrganizationMessageEventEntity';
  action: OrganizationMessageEventAction;
  /** The staff member who acted; null when the user is gone. */
  actorName?: Maybe<Scalars['String']['output']>;
  actorUserUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The message as it stood after the action. */
  snapshot: Scalars['JSON']['output'];
};

export type OrganizationMessageLinkInput = {
  label: Scalars['String']['input'];
  /** A published documentation slug, an internal app path starting with "/", or an https URL, matching `type`. */
  target: Scalars['String']['input'];
  type: OrganizationMessageLinkType;
};

export enum OrganizationMessageLinkType {
  Documentation = 'DOCUMENTATION',
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type OrganizationMessageReachEntity = {
  __typename?: 'OrganizationMessageReachEntity';
  /** Companies with the engine notification bell enabled. Banners show everywhere; the bell entry only here. */
  bellEnabledCompanyCount: Scalars['Int']['output'];
  companyCount: Scalars['Int']['output'];
  /** Active internal users of those companies. */
  userCount: Scalars['Int']['output'];
};

export enum OrganizationMessageSeverity {
  Critical = 'CRITICAL',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type OrganizationMessageStatsEntity = {
  __typename?: 'OrganizationMessageStatsEntity';
  asOf: Scalars['DateTime']['output'];
  /** Companies the message was sent to. */
  companyCount: Scalars['Int']['output'];
  /** Bell rows written. */
  deliveredCount: Scalars['Int']['output'];
  dismissedCount: Scalars['Int']['output'];
  /** Companies whose delivery failed for good. */
  failedCompanyCount: Scalars['Int']['output'];
  /** Companies whose delivery has not run yet. */
  pendingCompanyCount: Scalars['Int']['output'];
  readCount: Scalars['Int']['output'];
};

export enum OrganizationMessageStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Resolved = 'RESOLVED',
  Scheduled = 'SCHEDULED',
  Withdrawn = 'WITHDRAWN'
}

export type OrganizationMessageUuidInput = {
  uuid: Scalars['String']['input'];
};

export enum OrganizationMessageView {
  Drafts = 'DRAFTS',
  Ended = 'ENDED',
  Live = 'LIVE',
  Scheduled = 'SCHEDULED'
}

export type OrganizationPackageTypeConfigEntity = {
  __typename?: 'OrganizationPackageTypeConfigEntity';
  id: Scalars['String']['output'];
  isSingleHandlingUnit: Scalars['Boolean']['output'];
  packageType: PackageType;
};

export type OrganizationPeerConnection = {
  __typename?: 'OrganizationPeerConnection';
  edges: Array<OrganizationPeerEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationPeerEdge = {
  __typename?: 'OrganizationPeerEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationPeerEntity;
};

export type OrganizationPeerEntity = {
  __typename?: 'OrganizationPeerEntity';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  autoAcceptOffers: Scalars['Boolean']['output'];
  autoApplyPeerAccessorials: Scalars['Boolean']['output'];
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  organizationUuid?: Maybe<Scalars['String']['output']>;
  peerCompanyName: Scalars['String']['output'];
  peerCompanyUuid: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  shareProgressWithPeer: Scalars['Boolean']['output'];
  status: OrganizationPeerStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type OrganizationPeerSettingsChangeInput = {
  autoAcceptOffers?: InputMaybe<Scalars['Boolean']['input']>;
  autoApplyPeerAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  peerCompanyUuid: Scalars['String']['input'];
  shareProgressWithPeer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Lifecycle state of a directed organization-to-organization peer relationship. */
export enum OrganizationPeerStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type OrganizationQuotePolicy = {
  __typename?: 'OrganizationQuotePolicy';
  effective: EffectiveOrganizationQuotePolicy;
  organizationUuid: Scalars['String']['output'];
  override?: Maybe<OrganizationQuotePolicyOverride>;
  tenantDefault: OrganizationQuotePolicyTenantDefault;
};

export type OrganizationQuotePolicyOverride = {
  __typename?: 'OrganizationQuotePolicyOverride';
  allowHazmatAuto?: Maybe<Scalars['Boolean']['output']>;
  autoSendMaxCents?: Maybe<Scalars['Int']['output']>;
  minConfidence?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<QuoteAgentPolicyMode>;
  updatedAt: Scalars['DateTime']['output'];
  updatedByUserUuid?: Maybe<Scalars['String']['output']>;
};

export type OrganizationQuotePolicyTenantDefault = {
  __typename?: 'OrganizationQuotePolicyTenantDefault';
  autoSendMaxCents?: Maybe<Scalars['Int']['output']>;
  /** A fraction between 0 and 1, the unit of the override. */
  minConfidence: Scalars['Float']['output'];
  mode: QuoteAgentPolicyMode;
};

/** The type of organization */
export enum OrganizationType {
  Agent = 'AGENT',
  Customer = 'CUSTOMER'
}

export enum OriginStopType {
  PartnerDropoff = 'PARTNER_DROPOFF',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY'
}

export type OriginTerminalMismatchError = {
  __typename?: 'OriginTerminalMismatchError';
  order: OrderEntity;
};

export type OriginTerminalSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OrphanPieceSpecInput = {
  damagedNote?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isDamaged?: InputMaybe<Scalars['Boolean']['input']>;
  isMisrouted?: InputMaybe<Scalars['Boolean']['input']>;
  isOverage?: InputMaybe<Scalars['Boolean']['input']>;
  isShortage?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  note?: InputMaybe<Scalars['String']['input']>;
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type OutboundAddressNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundAddressSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** Searches one TENEDI partnership's orders for the page's order picker, newest first. */
export type OutboundBenchOrderSearchInput = {
  ediPartnershipUuid: Scalars['String']['input'];
  /** 1 to 25. Defaults to 25. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  /** Matched, ignoring case, against the order name, HAWB and MAWB. Leave it empty for the newest orders. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundCityNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundCompletedDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundDriverNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum OutboundMethod {
  AirportTransfer = 'AIRPORT_TRANSFER',
  LocalDelivery = 'LOCAL_DELIVERY',
  Other = 'OTHER'
}

export type OutboundMethodSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundRouteDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundRouteNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundServiceDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundWebhookEventEntity = {
  __typename?: 'OutboundWebhookEventEntity';
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  httpStatusCode?: Maybe<Scalars['Int']['output']>;
  type: OutboundWebhookEventType;
  uuid: Scalars['String']['output'];
};

export enum OutboundWebhookEventType {
  DeliveryAppointmentCancelled = 'DELIVERY_APPOINTMENT_CANCELLED',
  DeliveryAppointmentConfirmed = 'DELIVERY_APPOINTMENT_CONFIRMED',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  InvoicePosted = 'INVOICE_POSTED',
  MasterOrderAllFulfilled = 'MASTER_ORDER_ALL_FULFILLED',
  OrderOnHand = 'ORDER_ON_HAND',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  OutForPickup = 'OUT_FOR_PICKUP',
  PickupAppointmentCancelled = 'PICKUP_APPOINTMENT_CANCELLED',
  PickupAppointmentConfirmed = 'PICKUP_APPOINTMENT_CONFIRMED',
  PickupCompleted = 'PICKUP_COMPLETED',
  PieceStatusChanged = 'PIECE_STATUS_CHANGED',
  PodDocumentAvailable = 'POD_DOCUMENT_AVAILABLE',
  RecoveryCompleted = 'RECOVERY_COMPLETED',
  StopAppointmentScheduled = 'STOP_APPOINTMENT_SCHEDULED',
  StopAttempted = 'STOP_ATTEMPTED',
  StopCompleted = 'STOP_COMPLETED',
  StopOutForDelivery = 'STOP_OUT_FOR_DELIVERY',
  TransferCompleted = 'TRANSFER_COMPLETED'
}

export type OutboundZipcodeSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutlookIntegrationCreateInput = {
  companyUuid: Scalars['String']['input'];
  emailCreatedAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  entraTenantId: Scalars['String']['input'];
  entraUserId: Scalars['String']['input'];
  outboundEmailDomains: Array<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OutlookIntegrationEntity = {
  __typename?: 'OutlookIntegrationEntity';
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  emailCreatedAtStartDate?: Maybe<Scalars['DateTime']['output']>;
  entraTenantId: Scalars['String']['output'];
  entraUserId: Scalars['String']['output'];
  outboundEmailDomains: Array<Scalars['String']['output']>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserActorEntity;
  uuid: Scalars['String']['output'];
};

export type OutlookIntegrationUpdateInput = {
  emailCreatedAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundEmailDomains: Array<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type PackPiecesInput = {
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  pieceUuids: Array<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PieceStatus>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type: PackageType;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageArrayUpdateInput = {
  packageUpsertInput: PackageUpsertInput;
};

export type PackageCreateInput = {
  class?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  freightClass?: InputMaybe<FreightClass>;
  freightSnapTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  packageSpecId?: InputMaybe<Scalars['String']['input']>;
  /** UUIDs of existing pieces to link to this package via the PackageHasPiece join table. */
  pieceUuidsToLink?: InputMaybe<Array<Scalars['String']['input']>>;
  pieces?: InputMaybe<Array<PackagePieceCreateInput>>;
  quantity: Scalars['Int']['input'];
  quantityCompletedAtStop?: InputMaybe<Scalars['Int']['input']>;
  reasonUncompletedAtStop?: InputMaybe<Scalars['String']['input']>;
  skuNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  /** Represents the warehouse location assigned to the package if it is turned on for the customer */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageEntity = {
  __typename?: 'PackageEntity';
  class?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  freightClass?: Maybe<FreightClass>;
  hazmat?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  nmfc?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  /** All PackageHasPiece links for the package. */
  packageHasPieces?: Maybe<Array<PackageHasPieceEntity>>;
  packageSpec?: Maybe<PackageSpecEntity>;
  /**
   * The first piece associated with the package
   * @deprecated Use pieces instead as packages now have multiple pieces
   */
  piece?: Maybe<PieceEntity>;
  /** All pieces associated with the package */
  pieces?: Maybe<Array<PieceEntity>>;
  quantity: Scalars['Int']['output'];
  quantityCompletedAtStop?: Maybe<Scalars['Int']['output']>;
  reasonUncompletedAtStop?: Maybe<Scalars['String']['output']>;
  skuNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PackageType>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum PackageField {
  Description = 'DESCRIPTION',
  Height = 'HEIGHT',
  Length = 'LENGTH',
  Quantity = 'QUANTITY',
  Weight = 'WEIGHT',
  Width = 'WIDTH'
}

export type PackageForCachedStop = {
  __typename?: 'PackageForCachedStop';
  description?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum PackageGroup {
  I = 'I',
  Ii = 'II',
  Iii = 'III'
}

export type PackageHasPieceEntity = {
  __typename?: 'PackageHasPieceEntity';
  createdAt: Scalars['DateTime']['output'];
  package: PackageEntity;
  piece: PieceEntity;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PackagePieceCreateInput = {
  additionalReferenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Where the form loaded this piece. Present for a piece the form read from the server, absent for a new one. */
  baseline?: InputMaybe<PieceBaselineInput>;
  children?: InputMaybe<Array<PackagePieceCreateInput>>;
  damagedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Fields of this piece the form filled in for the user: each is written only while the stored column is still empty, and a save carrying nothing else for the piece does not count as an edit of it. */
  fillIfEmptyFields?: InputMaybe<Array<PieceFillIfEmptyField>>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isMisrouted?: InputMaybe<Scalars['Boolean']['input']>;
  isOverage?: InputMaybe<Scalars['Boolean']['input']>;
  isShortage?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  refusedAt?: InputMaybe<Scalars['DateTime']['input']>;
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PieceStatus>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  uuid: Scalars['String']['input'];
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageSpecEntity = {
  __typename?: 'PackageSpecEntity';
  freightClass?: Maybe<FreightClass>;
  height?: Maybe<Scalars['Length']['output']>;
  id: Scalars['String']['output'];
  length?: Maybe<Scalars['Length']['output']>;
  name: Scalars['String']['output'];
  status: PackageSpecStatus;
  weight?: Maybe<Scalars['Mass']['output']>;
  width?: Maybe<Scalars['Length']['output']>;
};

export enum PackageSpecStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type PackageTableColumnEntity = {
  __typename?: 'PackageTableColumnEntity';
  columnIndex: Scalars['Int']['output'];
  header: Scalars['String']['output'];
  packageField?: Maybe<PackageField>;
  required: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type PackageTableColumnInput = {
  columnIndex: Scalars['Int']['input'];
  header: Scalars['String']['input'];
  packageField?: InputMaybe<PackageField>;
  required: Scalars['Boolean']['input'];
};

export type PackageTableEntity = {
  __typename?: 'PackageTableEntity';
  blockId: Scalars['String']['output'];
  headerRowIndex: Scalars['Int']['output'];
  packageTableColumns: Array<PackageTableColumnEntity>;
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type PackageTableInput = {
  blockId: Scalars['String']['input'];
  headerRowIndex: Scalars['Int']['input'];
  packageTableColumns: Array<PackageTableColumnInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PackageType {
  Box = 'BOX',
  Bundle = 'BUNDLE',
  Container = 'CONTAINER',
  Crate = 'CRATE',
  Other = 'OTHER',
  Pallet = 'PALLET',
  Piece = 'PIECE',
  Skid = 'SKID'
}

export type PackageUpdateInput = {
  class?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  freightClass?: InputMaybe<FreightClass>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityCompletedAtStop?: InputMaybe<Scalars['Int']['input']>;
  reasonUncompletedAtStop?: InputMaybe<Scalars['String']['input']>;
  skuNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  uuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageUpsertInput = {
  /** The stored quantity the form loaded; quantity is then applied as a change on the stored value. */
  baselineQuantity?: InputMaybe<Scalars['Int']['input']>;
  class?: InputMaybe<Scalars['Float']['input']>;
  /** Omitted or null leaves the stored description alone; required to create a package. */
  description?: InputMaybe<Scalars['String']['input']>;
  freightClass?: InputMaybe<FreightClass>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  packageSpecId?: InputMaybe<Scalars['String']['input']>;
  /** UUIDs of existing pieces to link to this package via the PackageHasPiece join table. */
  pieceUuidsToLink?: InputMaybe<Array<Scalars['String']['input']>>;
  pieces?: InputMaybe<Array<PackagePieceCreateInput>>;
  quantity: Scalars['Int']['input'];
  quantityCompletedAtStop?: InputMaybe<Scalars['Int']['input']>;
  reasonUncompletedAtStop?: InputMaybe<Scalars['String']['input']>;
  /** Sending this list puts the package in delta mode: the loaded top-level pieces the user deleted from the order. */
  removedPieceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  skuNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  uuid: Scalars['String']['input'];
  /** Represents the warehouse location assigned to the package if it is turned on for the customer */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackingPendencyEntity = {
  __typename?: 'PackingPendencyEntity';
  /** Null when the pendency is open to any operator on its warehouse. */
  assignedWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  /** When an operator claimed this pendency. Set while IN_PROGRESS, retained after DONE. */
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executedByWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  height?: Maybe<Scalars['Float']['output']>;
  kind: PackingPendencyKind;
  length?: Maybe<Scalars['Float']['output']>;
  measurementUnits?: Maybe<MeasurementUnits>;
  note?: Maybe<Scalars['String']['output']>;
  /** The shared order of the covered pieces, when they have one. Powers the "N pieces · ORDER" secondary label. */
  order?: Maybe<PackingPendencyOrderEntity>;
  pieces: Array<PieceEntity>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  resultingPiece?: Maybe<PieceEntity>;
  status: PackingPendencyStatus;
  type?: Maybe<PackageType>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
  /** Where the sender staged the packed bundle. Null when left to the floor; used as the default the operator confirms. */
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<WeightUnits>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum PackingPendencyKind {
  Pack = 'PACK',
  Unpack = 'UNPACK'
}

export type PackingPendencyOrderEntity = {
  __typename?: 'PackingPendencyOrderEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum PackingPendencyStatus {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

export type PackingPieceByBarcodeInput = {
  barcode: Scalars['String']['input'];
  preferOrderUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PackingPiecesInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PackingPiecesOutput = {
  __typename?: 'PackingPiecesOutput';
  hasMorePackages: Scalars['Boolean']['output'];
  pieces: Array<PieceListEntity>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PalletProductOffering {
  EmailIngestion = 'EMAIL_INGESTION',
  Tms = 'TMS',
  Wms = 'WMS'
}

export type ParseCsvOrderRowErrorEntity = {
  __typename?: 'ParseCsvOrderRowErrorEntity';
  message: Scalars['String']['output'];
  /** The row where the error occurred. Note that this is NOT 0-indexed */
  row: Scalars['Int']['output'];
};

export type ParseCsvOrdersInput = {
  bucket: Scalars['String']['input'];
  csvOrderMappingUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type ParseCsvOrdersOutput = MutationErrorOutput | ParseCsvOrdersSuccessOutput;

export type ParseCsvOrdersSuccessOutput = {
  __typename?: 'ParseCsvOrdersSuccessOutput';
  enableInboundStop: Scalars['Boolean']['output'];
  enableOutboundStop: Scalars['Boolean']['output'];
  errors: Array<ParseCsvOrderRowErrorEntity>;
  parsedOrderUpdates: Array<ParsedCsvOrderUpdateEntity>;
  parsedOrders: Array<ParsedCsvOrderEntity>;
};

export type ParsedCsvOrderEntity = {
  __typename?: 'ParsedCsvOrderEntity';
  billingPartyContact: ContactEntity;
  customerReferenceNumber?: Maybe<Scalars['String']['output']>;
  dimFactor?: Maybe<Scalars['Int']['output']>;
  freightChargeRate?: Maybe<Scalars['Float']['output']>;
  freightChargeType?: Maybe<FreightBillingMethod>;
  fuelChargeType?: Maybe<FuelBillingMethod>;
  fuelSurcharge?: Maybe<Scalars['Float']['output']>;
  inboundStop?: Maybe<ParsedCsvOrderStopEntity>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundStop?: Maybe<ParsedCsvOrderStopEntity>;
  packages: Array<ParsedCsvOrderPackageEntity>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  serviceLevel?: Maybe<ServiceEntity>;
  shipperBillOfLadingNumber: Scalars['String']['output'];
};

/** A package that is either parsed from a CSV file or from an order part of an order that was detected in a parsed CSV file */
export type ParsedCsvOrderPackageEntity = {
  __typename?: 'ParsedCsvOrderPackageEntity';
  class?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  freightClass?: Maybe<FreightClass>;
  height?: Maybe<Scalars['Float']['output']>;
  /** A flag that is set to true if the parsed package is one that needs to be appended to the order packages */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  nmfc?: Maybe<Scalars['String']['output']>;
  packageSpec?: Maybe<PackageSpecEntity>;
  quantity: Scalars['Int']['output'];
  type?: Maybe<PackageType>;
  /** Either the UUID of an existing package, or a new UUID for the new package */
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ParsedCsvOrderStopEntity = {
  __typename?: 'ParsedCsvOrderStopEntity';
  addressCity: Scalars['String']['output'];
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressName: Scalars['String']['output'];
  addressState: Scalars['String']['output'];
  addressZip: Scalars['String']['output'];
  appointmentEndTime?: Maybe<PlainTime>;
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentStartTime?: Maybe<PlainTime>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonFirstName?: Maybe<Scalars['String']['output']>;
  contactPersonLastName?: Maybe<Scalars['String']['output']>;
  contactPersonPhone?: Maybe<Scalars['String']['output']>;
  deadlineDate?: Maybe<Scalars['DateTime']['output']>;
  deadlineType?: Maybe<DeadlineType>;
  driver?: Maybe<DriverEntity>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverReferenceNumber?: Maybe<Scalars['String']['output']>;
  pickupOrDelivery: PickupOrDelivery;
  serviceDate: Scalars['DateTime']['output'];
  /** The service date of the parsed stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2: PlainDate;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<TerminalEntity>;
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type ParsedCsvOrderStopInput = {
  addressCity: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressName: Scalars['String']['input'];
  addressState: Scalars['String']['input'];
  addressZip: Scalars['String']['input'];
  appointmentEndTime?: InputMaybe<PlainTimeInput>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentStartTime?: InputMaybe<PlainTimeInput>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonFirstName?: InputMaybe<Scalars['String']['input']>;
  contactPersonLastName?: InputMaybe<Scalars['String']['input']>;
  contactPersonPhone?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  pickupOrDelivery: PickupOrDelivery;
  serviceDate: Scalars['DateTime']['input'];
  /** The service date, in ISO 8601 date format. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ParsedCsvOrderUpdateEntity = {
  __typename?: 'ParsedCsvOrderUpdateEntity';
  billingPartyContact: ContactEntity;
  packages: Array<ParsedCsvOrderPackageEntity>;
  shipperBillOfLadingNumber: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  edges: Array<PaymentEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Version ID for the response */
  versionId?: Maybe<Scalars['Float']['output']>;
};

export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  cursor: Scalars['String']['output'];
  node: PaymentEntity;
};

export type PaymentEntity = {
  __typename?: 'PaymentEntity';
  amountInCents: Scalars['Int']['output'];
  appliedAmountInCents: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  creditNumber?: Maybe<Scalars['Float']['output']>;
  creditType?: Maybe<CreditTypeEntity>;
  date: Scalars['DateTime']['output'];
  glTerminal?: Maybe<TerminalEntity>;
  invoicesAppliedTo: Array<InvoiceEntity>;
  offsetAmountInCents: Scalars['Int']['output'];
  paymentOffsets: Array<PaymentToPaymentMappingEntity>;
  paymentRail?: Maybe<PaymentRail>;
  paymentToOrderMappings: Array<PaymentToOrderMappingEntity>;
  paymentType: PaymentType;
  quickbooksPaymentId?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  unappliedAmountInCents: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type PaymentForCheckRegisterReportEntity = {
  __typename?: 'PaymentForCheckRegisterReportEntity';
  amountInCents?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  contactDisplayName?: Maybe<Scalars['String']['output']>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentUuid: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  terminalCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type PaymentForPaymentApplicationReportEntity = {
  __typename?: 'PaymentForPaymentApplicationReportEntity';
  comment?: Maybe<Scalars['String']['output']>;
  contactDisplayName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  masterAccountName?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderForPaymentApplicationReportEntity>;
  paymentDate: Scalars['DateTime']['output'];
  paymentRail?: Maybe<PaymentRail>;
  paymentType: PaymentType;
  paymentUuid: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  /** The total amount of the payment in dollars */
  totalAmount: Scalars['Float']['output'];
  /** The amount not applied yet in dollars */
  unappliedAmount: Scalars['Float']['output'];
};

export type PaymentForPaymentJournalReportEntity = {
  __typename?: 'PaymentForPaymentJournalReportEntity';
  comment?: Maybe<Scalars['String']['output']>;
  contactDisplayName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  creditNumber?: Maybe<Scalars['Float']['output']>;
  creditTypeName?: Maybe<Scalars['String']['output']>;
  glTerminalName?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderForPaymentJournalReportEntity>;
  paymentDate: Scalars['DateTime']['output'];
  paymentRail?: Maybe<PaymentRail>;
  paymentType: PaymentType;
  paymentUuid: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  /** The total amount of the payment in dollars */
  totalAmount: Scalars['Float']['output'];
  /** The amount not applied yet in dollars */
  unappliedAmountDollars: Scalars['Float']['output'];
};

export enum PaymentMethod {
  Collect = 'COLLECT',
  PrepaidBySeller = 'PREPAID_BY_SELLER',
  ServiceFreightNoCharges = 'SERVICE_FREIGHT_NO_CHARGES',
  ThirdPartyPay = 'THIRD_PARTY_PAY'
}

export enum PaymentRail {
  Ach = 'ACH',
  Check = 'CHECK'
}

export type PaymentSort = {
  sortBy: PaymentTableField;
  sortDirection: SortDirection;
};

export enum PaymentTableField {
  Amount = 'amount',
  Date = 'date'
}

export type PaymentToOrderMappingEntity = {
  __typename?: 'PaymentToOrderMappingEntity';
  amountInCents: Scalars['Int']['output'];
  order: OrderEntity;
  payment: PaymentEntity;
  uuid: Scalars['String']['output'];
};

export type PaymentToPaymentMappingEntity = {
  __typename?: 'PaymentToPaymentMappingEntity';
  amountInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  sourcePayment: PaymentEntity;
  targetPayment: PaymentEntity;
  uuid: Scalars['String']['output'];
};

export enum PaymentType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Payment = 'PAYMENT'
}

export type PdProductivityArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PdProductivityDriverEntity = {
  __typename?: 'PdProductivityDriverEntity';
  actualHours: Scalars['Float']['output'];
  allowedHours: Scalars['Float']['output'];
  driverName: Scalars['String']['output'];
  driverUuid: Scalars['String']['output'];
  inefficiencyCostUsd?: Maybe<Scalars['Float']['output']>;
  inefficiencyHours: Scalars['Float']['output'];
  pieceCount: Scalars['Int']['output'];
  productivityRatio?: Maybe<Scalars['Float']['output']>;
  routeCount: Scalars['Int']['output'];
  status?: Maybe<ProductivityStatus>;
  stopCount: Scalars['Int']['output'];
  totalMiles: Scalars['Float']['output'];
  totalWeightLbs: Scalars['Float']['output'];
};

export type PdProductivityReportEntity = {
  __typename?: 'PdProductivityReportEntity';
  appliedDriverCostPerHourUsd?: Maybe<Scalars['Float']['output']>;
  costBasis: CostBasis;
  costPerStopUsd?: Maybe<Scalars['Float']['output']>;
  drivers: Array<PdProductivityDriverEntity>;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  hasTimeAllowances: Scalars['Boolean']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  overallProductivityRatio?: Maybe<Scalars['Float']['output']>;
  pdCostUsd?: Maybe<Scalars['Float']['output']>;
  routesMissingTimestamps: Scalars['Int']['output'];
  timeAllowances: ProductivityTimeAllowanceEntity;
  totalActualHours: Scalars['Float']['output'];
  totalAllowedHours: Scalars['Float']['output'];
  totalInefficiencyCostUsd?: Maybe<Scalars['Float']['output']>;
  totalInefficiencyHours: Scalars['Float']['output'];
  truckCostPerMileUsd?: Maybe<Scalars['Float']['output']>;
};

export type PdfColumnCreateInput = {
  legPDFColumnMapping?: InputMaybe<LegPdfColumnMapping>;
  orderColumnMapping?: InputMaybe<OrderPdfColumnMapping>;
  shipmentPDFColumnMapping?: InputMaybe<ShipmentPdfColumnMapping>;
  stopPDFColumnMapping?: InputMaybe<StopPdfColumnMapping>;
};

export type PdfColumnEntity = {
  __typename?: 'PdfColumnEntity';
  createdAt: Scalars['DateTime']['output'];
  legPDFColumnMapping?: Maybe<LegPdfColumnMapping>;
  orderColumnMapping?: Maybe<OrderPdfColumnMapping>;
  shipmentPDFColumnMapping?: Maybe<ShipmentPdfColumnMapping>;
  stopPDFColumnMapping?: Maybe<StopPdfColumnMapping>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PeerServiceShareEntity = {
  __typename?: 'PeerServiceShareEntity';
  isActive: Scalars['Boolean']['output'];
  serviceName: Scalars['String']['output'];
  serviceUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PercentageAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageBasis: AccessorialPercentageBasis;
  /** Percentage rate out of 100, e.g. 1.75 means 1.75% */
  rate: Scalars['Float']['input'];
};

export type PercentageAccessorialEntity = AccessorialInterface & {
  __typename?: 'PercentageAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  percentageBasis?: Maybe<AccessorialPercentageBasis>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  /** Percentage rate out of 100 */
  rate: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type PercentageAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentageBasis?: InputMaybe<AccessorialPercentageBasis>;
  /** Percentage rate out of 100, e.g. 1.75 means 1.75% */
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type PermissionEntity = {
  __typename?: 'PermissionEntity';
  accessLevel: AccessLevel;
  permissionResource: PermissionResource;
  uuid: Scalars['String']['output'];
};

export enum PermissionResource {
  AccountingReports = 'ACCOUNTING_REPORTS',
  Appointments = 'APPOINTMENTS',
  BillingReview = 'BILLING_REVIEW',
  CompanyAccessorials = 'COMPANY_ACCESSORIALS',
  CompanyBilling = 'COMPANY_BILLING',
  CompanyBusinessDivisions = 'COMPANY_BUSINESS_DIVISIONS',
  CompanyCustomForms = 'COMPANY_CUSTOM_FORMS',
  CompanyDrivers = 'COMPANY_DRIVERS',
  CompanyDriverCompliance = 'COMPANY_DRIVER_COMPLIANCE',
  CompanyEquipment = 'COMPANY_EQUIPMENT',
  CompanyFuelProfiles = 'COMPANY_FUEL_PROFILES',
  CompanyHoldReasons = 'COMPANY_HOLD_REASONS',
  CompanyLineHaul = 'COMPANY_LINE_HAUL',
  CompanyRecoveryTerminals = 'COMPANY_RECOVERY_TERMINALS',
  CompanyRecurringOrders = 'COMPANY_RECURRING_ORDERS',
  CompanyRouteNames = 'COMPANY_ROUTE_NAMES',
  CompanyScheduling = 'COMPANY_SCHEDULING',
  CompanyServices = 'COMPANY_SERVICES',
  CompanyTariffs = 'COMPANY_TARIFFS',
  CompanyTerminals = 'COMPANY_TERMINALS',
  CompanyThirdPartyBrokers = 'COMPANY_THIRD_PARTY_BROKERS',
  CompanyUsers = 'COMPANY_USERS',
  CompanyWarehouseEmployees = 'COMPANY_WAREHOUSE_EMPLOYEES',
  Contacts = 'CONTACTS',
  Customers = 'CUSTOMERS',
  CustomerPortalOrders = 'CUSTOMER_PORTAL_ORDERS',
  DailyControlCenter = 'DAILY_CONTROL_CENTER',
  DelegatedOrders = 'DELEGATED_ORDERS',
  DelegatedOrdersAccept = 'DELEGATED_ORDERS_ACCEPT',
  DeleteOrders = 'DELETE_ORDERS',
  DeletePieces = 'DELETE_PIECES',
  DriverSettlements = 'DRIVER_SETTLEMENTS',
  EdiApiOrders = 'EDI_API_ORDERS',
  EmailOrders = 'EMAIL_ORDERS',
  EmailQuotes = 'EMAIL_QUOTES',
  EndOfDay = 'END_OF_DAY',
  ExpeditorsApiStatus = 'EXPEDITORS_API_STATUS',
  FinalizeChargesOrders = 'FINALIZE_CHARGES_ORDERS',
  FinalizeChargesOrdersPaperworkIncomplete = 'FINALIZE_CHARGES_ORDERS_PAPERWORK_INCOMPLETE',
  ForwarderBoard = 'FORWARDER_BOARD',
  IntelligenceBoard = 'INTELLIGENCE_BOARD',
  InternalTools = 'INTERNAL_TOOLS',
  Invoices = 'INVOICES',
  LineHaulDispatch = 'LINE_HAUL_DISPATCH',
  Master = 'MASTER',
  MobileDriverApp = 'MOBILE_DRIVER_APP',
  MobileWarehouseScanning = 'MOBILE_WAREHOUSE_SCANNING',
  Orders = 'ORDERS',
  OrderDelegationGrant = 'ORDER_DELEGATION_GRANT',
  OwnersBreakfastDashboard = 'OWNERS_BREAKFAST_DASHBOARD',
  OwnersBreakfastDaysToInvoice = 'OWNERS_BREAKFAST_DAYS_TO_INVOICE',
  OwnersBreakfastDaysToPayment = 'OWNERS_BREAKFAST_DAYS_TO_PAYMENT',
  OwnersBreakfastDeliveryFailure = 'OWNERS_BREAKFAST_DELIVERY_FAILURE',
  OwnersBreakfastDockReceived = 'OWNERS_BREAKFAST_DOCK_RECEIVED',
  OwnersBreakfastOnTimeDelivery = 'OWNERS_BREAKFAST_ON_TIME_DELIVERY',
  OwnersBreakfastOnTimePickup = 'OWNERS_BREAKFAST_ON_TIME_PICKUP',
  OwnersBreakfastOrdersPerDriver = 'OWNERS_BREAKFAST_ORDERS_PER_DRIVER',
  OwnersBreakfastOrderCount = 'OWNERS_BREAKFAST_ORDER_COUNT',
  OwnersBreakfastPieceScan = 'OWNERS_BREAKFAST_PIECE_SCAN',
  OwnersBreakfastRevenue = 'OWNERS_BREAKFAST_REVENUE',
  Quote = 'QUOTE',
  Reports = 'REPORTS',
  Routes = 'ROUTES',
  SavedViews = 'SAVED_VIEWS',
  ScannedOrders = 'SCANNED_ORDERS',
  SendFinalizedToBilling = 'SEND_FINALIZED_TO_BILLING',
  SettingsAutoApplyAccessorialRules = 'SETTINGS_AUTO_APPLY_ACCESSORIAL_RULES',
  SettingsDispatch = 'SETTINGS_DISPATCH',
  SettingsGeneral = 'SETTINGS_GENERAL',
  SettingsMotive = 'SETTINGS_MOTIVE',
  SettingsOrders = 'SETTINGS_ORDERS',
  SettingsQuickbooks = 'SETTINGS_QUICKBOOKS',
  SettingsQuickbooksDesktop = 'SETTINGS_QUICKBOOKS_DESKTOP',
  SettingsQuickbooksOnline = 'SETTINGS_QUICKBOOKS_ONLINE',
  SettingsRoles = 'SETTINGS_ROLES',
  SettingsSamsara = 'SETTINGS_SAMSARA',
  SettingsSmc3 = 'SETTINGS_SMC3',
  SettingsTags = 'SETTINGS_TAGS',
  T2TPeerCompanies = 'T2T_PEER_COMPANIES',
  UnpostInvoices = 'UNPOST_INVOICES',
  ViewAllScannedDocuments = 'VIEW_ALL_SCANNED_DOCUMENTS',
  Warehouses = 'WAREHOUSES'
}

export type PersonEntity = {
  __typename?: 'PersonEntity';
  defaultDeliveryAddress?: Maybe<AddressEntity>;
  defaultForContactStations?: Maybe<Array<ContactStationEntity>>;
  defaultPickupAddress?: Maybe<AddressEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultVehicleType?: Maybe<VehicleTypeEntity>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  status: PersonStatus;
};

export enum PersonStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type PickQuoteCustomerInput = {
  contactUuid: Scalars['String']['input'];
  orderQuoteUuid: Scalars['String']['input'];
};

export type PickQuoteCustomerOutput = MutationErrorOutput | PickQuoteCustomerSuccessOutput;

export type PickQuoteCustomerSuccessOutput = {
  __typename?: 'PickQuoteCustomerSuccessOutput';
  /** The quote after the draft was created and priced */
  orderQuote: OrderQuote;
};

export type PickStorageUnitInput = {
  /** The number of inventory items to pick in that storage unit  */
  quantity: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type PickStorageUnitOutput = {
  __typename?: 'PickStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export enum PickedStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type PicklistConnection = {
  __typename?: 'PicklistConnection';
  edges: Array<PicklistEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PicklistEdge = {
  __typename?: 'PicklistEdge';
  cursor: Scalars['String']['output'];
  node: PicklistEntity;
};

export type PicklistEntity = {
  __typename?: 'PicklistEntity';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  outboundReferenceNumber?: Maybe<Scalars['String']['output']>;
  picklistItemGroups: Array<PicklistItemGroupEntity>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PicklistEntityPicklistItemGroupsArgs = {
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Mapping that specifies which ItemGroups are on a Picklist */
export type PicklistItemGroupEntity = {
  __typename?: 'PicklistItemGroupEntity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  itemGroup: ItemGroupEntity;
  pickedQuantity: Scalars['Int']['output'];
  pickedStatus: PickedStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PicklistsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** UUID of company to filter by */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  /** UUID of contact to filter by */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** UUID of warehouse to filter by */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum PickupOrDelivery {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY',
  Transfer = 'TRANSFER'
}

/** DRY_RUN plans the backfill without writing; EXECUTE plans and applies it. */
export enum PieceBackfillRunMode {
  DryRun = 'DRY_RUN',
  Execute = 'EXECUTE'
}

/** Lifecycle of a backfill run: PENDING once enqueued, RUNNING while the worker holds it, then COMPLETED or FAILED. */
export enum PieceBackfillRunStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type PieceBackfillRunView = {
  __typename?: 'PieceBackfillRunView';
  companyUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  joinsCreated: Scalars['Int']['output'];
  mode: PieceBackfillRunMode;
  packagesProcessed: Scalars['Int']['output'];
  packagesSkipped: Scalars['Int']['output'];
  packagesTotal: Scalars['Int']['output'];
  params: Scalars['JSON']['output'];
  piecesCreated: Scalars['Int']['output'];
  piecesUpdated: Scalars['Int']['output'];
  report?: Maybe<Scalars['JSON']['output']>;
  requestedByEmail: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: PieceBackfillRunStatus;
  uuid: Scalars['String']['output'];
};

export type PieceBackfillRunsInput = {
  companyUuid: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PieceBackfillSurvey = {
  __typename?: 'PieceBackfillSurvey';
  billingParties: Array<PieceBackfillSurveyRow>;
  companyUuid: Scalars['String']['output'];
  cutoffDate: Scalars['DateTime']['output'];
  totalExistingPieceCount: Scalars['Int']['output'];
  totalMissingPieceCount: Scalars['Int']['output'];
  totalPackageCount: Scalars['Int']['output'];
  totalPackageQuantity: Scalars['Int']['output'];
};

export type PieceBackfillSurveyInput = {
  companyUuid: Scalars['String']['input'];
  cutoffDate: Scalars['DateTime']['input'];
};

export type PieceBackfillSurveyRow = {
  __typename?: 'PieceBackfillSurveyRow';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingPieceCount: Scalars['Int']['output'];
  missingPieceCount: Scalars['Int']['output'];
  packageCount: Scalars['Int']['output'];
  totalPackageQuantity: Scalars['Int']['output'];
};

export type PieceBaselineInput = {
  /** The package the form loaded this piece on, as a top-level piece. */
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  /** The bundle the form loaded this piece in, as a child. */
  parentPieceUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum PieceBucketKey {
  Delivered = 'DELIVERED',
  Discarded = 'DISCARDED',
  Inbound = 'INBOUND',
  Inventory = 'INVENTORY',
  InTransit = 'IN_TRANSIT'
}

export type PieceBucketMetric = {
  __typename?: 'PieceBucketMetric';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  unit: PieceBucketMetricUnit;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum PieceBucketMetricUnit {
  Count = 'COUNT',
  DurationDays = 'DURATION_DAYS',
  Percent = 'PERCENT',
  Weight = 'WEIGHT'
}

export type PieceBucketMetricsInput = {
  bucket: PieceBucketKey;
  searchText?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PieceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PieceBucketMetricsOutput = {
  __typename?: 'PieceBucketMetricsOutput';
  metrics: Array<PieceBucketMetric>;
};

export type PieceConnection = {
  __typename?: 'PieceConnection';
  edges: Array<PieceEdge>;
  pageInfo: PageInfo;
  /** Total count matching the filter; request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PieceCountSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum PieceDimsSyncAction {
  SplitToNewPackage = 'SPLIT_TO_NEW_PACKAGE',
  UpdateAllPieces = 'UPDATE_ALL_PIECES',
  UpdatePackageOnly = 'UPDATE_PACKAGE_ONLY'
}

export type PieceEdge = {
  __typename?: 'PieceEdge';
  cursor: Scalars['String']['output'];
  node: PieceListEntity;
};

export type PieceEntity = {
  __typename?: 'PieceEntity';
  additionalReferenceNumbers: Array<Scalars['String']['output']>;
  children: Array<PieceEntity>;
  /** Customer named when the piece was received without an order, kept as the arrival record even after the piece is linked. This is not the effective customer: once the piece has an order, that order's billing party is. Null when the piece did not arrive through orderless inbound, or arrived with no customer identified. */
  contact?: Maybe<ContactEntity>;
  createdAt: Scalars['DateTime']['output'];
  /** The customer the piece is shown under: the billing party of the order that owns it, or, for freight received without an order, the customer named at receipt. Null when neither is known — the case the pieces grid flags as "Unknown customer". */
  customer?: Maybe<ContactEntity>;
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  damagedNote?: Maybe<Scalars['String']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  dimWeight?: Maybe<Scalars['Float']['output']>;
  discardedAt?: Maybe<Scalars['DateTime']['output']>;
  discardedReason?: Maybe<Scalars['String']['output']>;
  documents: Array<DocumentEntity>;
  firstOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  /** HAWB of the order that owns the piece (its direct order, else the order owning its package): the house air waybill number when set, otherwise the shipper BOL (the order form's HAWB field). Null when the piece has no order or both are blank. */
  hawb?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  isUnalertedFreight: Scalars['Boolean']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  measurementUnits?: Maybe<MeasurementUnits>;
  name: Scalars['String']['output'];
  /** @deprecated Use packageHasPieces to resolve orders for a piece */
  order?: Maybe<OrderEntity>;
  package?: Maybe<PackageEntity>;
  /** All PackageHasPiece links for the piece. */
  packageHasPieces?: Maybe<Array<PackageHasPieceEntity>>;
  packedPieceCount: Scalars['Int']['output'];
  pickedUpAt?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  status: PieceStatus;
  terminal?: Maybe<TerminalEntity>;
  type?: Maybe<PackageType>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse?: Maybe<WarehouseEntity>;
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<WeightUnits>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum PieceFillIfEmptyField {
  Height = 'HEIGHT',
  Length = 'LENGTH',
  MeasurementUnits = 'MEASUREMENT_UNITS',
  Type = 'TYPE',
  Weight = 'WEIGHT',
  WeightUnits = 'WEIGHT_UNITS',
  Width = 'WIDTH'
}

export type PieceGroupEntity = {
  __typename?: 'PieceGroupEntity';
  pieceCount: Scalars['Int']['output'];
  pieces: Array<PieceEntity>;
  status: PieceStatus;
  /** Terminal where the pieces are located. This field is only populated when all pieces have arrived or departed from a terminal on a line haul lane. It is null if the status is awaiting or delivered, or if the order is not on a line haul lane. */
  terminal?: Maybe<TerminalEntity>;
};

export type PieceListEntity = {
  __typename?: 'PieceListEntity';
  carrier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  damagedNote?: Maybe<Scalars['String']['output']>;
  daysOverDwellThreshold?: Maybe<Scalars['Int']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  departedAt?: Maybe<Scalars['DateTime']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['DateTime']['output']>;
  discardedByName?: Maybe<Scalars['String']['output']>;
  discardedReason?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  dwellStatus?: Maybe<DwellStatus>;
  effectiveDwellThresholdDays?: Maybe<Scalars['Int']['output']>;
  eta?: Maybe<Scalars['DateTime']['output']>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  isUnalertedFreight: Scalars['Boolean']['output'];
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  mawb?: Maybe<Scalars['String']['output']>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  packageOrderName?: Maybe<Scalars['String']['output']>;
  packageOrderUuid?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['String']['output']>;
  packedPieceCount: Scalars['Int']['output'];
  podSignedBy?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  status: PieceStatus;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  totalPieces?: Maybe<Scalars['Int']['output']>;
  truckName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
  warehouseLocationUuid?: Maybe<Scalars['String']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
  warehouseUuid?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<WeightUnits>;
};

export type PieceReceiptConnection = {
  __typename?: 'PieceReceiptConnection';
  edges: Array<PieceReceiptEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PieceReceiptEdge = {
  __typename?: 'PieceReceiptEdge';
  cursor: Scalars['String']['output'];
  node: PieceReceiptEntity;
};

export type PieceReceiptEntity = {
  __typename?: 'PieceReceiptEntity';
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  billOfLadingNumber?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consigneeName?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  expectedAt?: Maybe<Scalars['DateTime']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pickupDate?: Maybe<Scalars['DateTime']['output']>;
  pieces: Array<PieceEntity>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  sealNumber?: Maybe<Scalars['String']['output']>;
  source: PieceReceiptSource;
  supplierCompanyName?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trailerNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};

export type PieceReceiptExistingPieceInput = {
  /** UUID of the existing piece to add to the receipt */
  pieceUuid: Scalars['String']['input'];
  /** Optional warehouse location to move the piece to */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PieceReceiptNewPieceInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  /** Number of identical pieces to create. Defaults to 1. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Reference number / barcode for the new piece(s) */
  referenceNumber: Scalars['String']['input'];
  /** Package kind for the piece (box, pallet, etc.). Optional and independent of whether the piece holds nested children. */
  type?: InputMaybe<PackageType>;
  /** Client-minted piece UUID used as an idempotency key; honored only when quantity is 1. */
  uuid?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the warehouse location the piece(s) are received into. Optional; a piece may be received without a location set. */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export enum PieceReceiptSource {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type PieceScanCustomerRowEntity = {
  __typename?: 'PieceScanCustomerRowEntity';
  customerName: Scalars['String']['output'];
  customerUuid: Scalars['String']['output'];
  piecesDeliveredCount: Scalars['Int']['output'];
  piecesUnscannedCount: Scalars['Int']['output'];
  scanRatePct?: Maybe<Scalars['Float']['output']>;
};

export type PieceScanGroupRowEntity = {
  __typename?: 'PieceScanGroupRowEntity';
  name?: Maybe<Scalars['String']['output']>;
  piecesDeliveredCount: Scalars['Int']['output'];
  piecesUnscannedCount: Scalars['Int']['output'];
  scanRatePct?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type PieceScanKpiEntity = {
  __typename?: 'PieceScanKpiEntity';
  bucketUnit: KpiTrendBucketUnit;
  customers: Array<PieceScanCustomerRowEntity>;
  drivers: Array<PieceScanGroupRowEntity>;
  piecesDeliveredCount: Scalars['Int']['output'];
  piecesDeliveredWithScanCount: Scalars['Int']['output'];
  piecesUnscannedCount: Scalars['Int']['output'];
  scanRatePct?: Maybe<Scalars['Float']['output']>;
  terminals: Array<PieceScanGroupRowEntity>;
  trend: Array<PieceScanTrendBucketEntity>;
};

export type PieceScanTrendBucketEntity = {
  __typename?: 'PieceScanTrendBucketEntity';
  bucketDate: Scalars['String']['output'];
  piecesDeliveredCount: Scalars['Int']['output'];
  piecesDeliveredWithScanCount: Scalars['Int']['output'];
  scanRatePct?: Maybe<Scalars['Float']['output']>;
};

export enum PieceStatus {
  Arrived = 'ARRIVED',
  ArrivedAtDestination = 'ARRIVED_AT_DESTINATION',
  Awaiting = 'AWAITING',
  Delivered = 'DELIVERED',
  Departed = 'DEPARTED',
  Loaded = 'LOADED',
  PickedUp = 'PICKED_UP',
  Planned = 'PLANNED'
}

export type PieceStatusTerminalCount = {
  __typename?: 'PieceStatusTerminalCount';
  pieceCount: Scalars['Int']['output'];
  status: PieceStatus;
  terminalCode: Scalars['String']['output'];
};

export type PiecesAwayFromRunOrigin = {
  __typename?: 'PiecesAwayFromRunOrigin';
  awayFromOriginPieceCount: Scalars['Int']['output'];
  runOriginTerminalCode: Scalars['String']['output'];
  terminalCounts: Array<TerminalPieceCount>;
  totalPieceCount: Scalars['Int']['output'];
  unaccountedPieceCount: Scalars['Int']['output'];
};

export type PiecesDeliveredEntity = {
  __typename?: 'PiecesDeliveredEntity';
  deliveryScansCount: Scalars['Int']['output'];
};

export type PiecesGroupedByStatusInput = {
  orderUuid: Scalars['String']['input'];
};

export type PiecesGroupedByStatusOutput = {
  __typename?: 'PiecesGroupedByStatusOutput';
  pieceGroups: Array<PieceGroupEntity>;
};

export type PiecesPickedUpEntity = {
  __typename?: 'PiecesPickedUpEntity';
  pickupScansCount: Scalars['Int']['output'];
};

export type PlaceCreateInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes: Scalars['String']['input'];
};

export type PlaceEntity = {
  __typename?: 'PlaceEntity';
  address: AddressEntity;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  notes: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PlaceUpdateInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** A calendar date without a time zone. See https://tc39.es/proposal-temporal/docs/plaindate.html */
export type PlainDate = {
  __typename?: 'PlainDate';
  /** A day of the month, from 1 through 31. */
  day: Scalars['Int']['output'];
  /** The plain date in ISO 8601 format. */
  iso8601: Scalars['String']['output'];
  /** A month number, from 1 through 12. 1 is January. */
  month: Scalars['Int']['output'];
  /** The year of the date */
  year: Scalars['Int']['output'];
};

export type PlainDateInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type PlainDateTime = {
  __typename?: 'PlainDateTime';
  date: PlainDate;
  time: PlainTime;
};

export type PlainDateTimeInput = {
  date: PlainDateInput;
  time: PlainTimeInput;
};

export type PlainTime = {
  __typename?: 'PlainTime';
  /** A 24-hour clock hour, from 0 through 23 */
  hour: Scalars['Int']['output'];
  /** A minute, from 0 through 59 */
  minute: Scalars['Int']['output'];
};

export type PlainTimeInput = {
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
};

export type PlanOutboundBenchRunInput = {
  companyActors?: InputMaybe<Array<BenchCompanyActorInput>>;
  /** An active driver of the orders' company. ROUTE_STOP assigns the route it creates to this driver; without one, ROUTE_STOP and START_ROUTE block. */
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  integrationType: BenchIntegrationType;
  selection: BenchOrderSelectionInput;
  /** Send the 990 ACCEPTED for an order that arrived live. A live order has no draft to approve, so ACCEPT_TENDER sends the 990 itself, once, when the partnership does not auto-accept. Omitted or false leaves live orders without a 990. */
  send990ForLiveOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Steps to leave out of this run. The plan reports them SKIPPED, and the run moves on to the next step. Empty or omitted runs every step. */
  skippedSteps?: InputMaybe<Array<BenchStepSelectorInput>>;
};

export enum PodNamingConvention {
  Blume = 'BLUME',
  Btx = 'BTX',
  Data_2Logistics = 'DATA_2_LOGISTICS',
  Flexport = 'FLEXPORT',
  ForwardAirTiff = 'FORWARD_AIR_TIFF',
  SimpleTiff = 'SIMPLE_TIFF',
  SimpleTiffMawb = 'SIMPLE_TIFF_MAWB',
  Stg = 'STG'
}

/** One band of a point-to-point lane: a range row of the lane tariff. A lane may hold fewer bands than its group, so match bands to group ceilings by lessThanOrEqualToValue. */
export type PointToPointLaneBand = {
  __typename?: 'PointToPointLaneBand';
  /** Same as TariffRangeEntity */
  lessThanOrEqualToValue: Scalars['Int']['output'];
  /** Rate in USD cents, same unit as TariffRangeEntity.rateUsdCents. The editor saves a blank cell as 0. */
  rateUsdCents: Scalars['Float']['output'];
};

export type PointToPointLaneBandInput = {
  /** Same as TariffRangeEntity */
  lessThanOrEqualToValue: Scalars['Int']['input'];
  /** Rate in USD cents, same unit as TariffRangeEntity */
  rateUsdCents: Scalars['Float']['input'];
};

export type PointToPointLaneConnection = {
  __typename?: 'PointToPointLaneConnection';
  edges: Array<PointToPointLaneEdge>;
  pageInfo: PageInfo;
  /** Lanes in the group across all pages */
  totalCount: Scalars['Int']['output'];
};

export type PointToPointLaneEdge = {
  __typename?: 'PointToPointLaneEdge';
  cursor: Scalars['String']['output'];
  node: PointToPointLaneEntity;
};

/** One lane of a point-to-point tariff group, flattened for the lane editor. Units match TariffEntity and TariffRangeEntity. */
export type PointToPointLaneEntity = {
  __typename?: 'PointToPointLaneEntity';
  /** The lane range rows, in ascending ceiling order */
  bands: Array<PointToPointLaneBand>;
  /** Origin zone. Null for a legacy lane whose zone is not a zone pair. */
  inboundZoneUuid?: Maybe<Scalars['String']['output']>;
  /** False when the lane is disabled: it keeps its rates, rating never selects it, and the order falls through to the next tariff group in the chain. */
  isActive: Scalars['Boolean']['output'];
  /** Maximum amount assessed, in USD cents */
  maximumUsdCents?: Maybe<Scalars['Int']['output']>;
  /** Minimum amount assessed, in USD cents */
  minimumUsdCents?: Maybe<Scalars['Int']['output']>;
  /** Destination zone. Null for a legacy lane whose zone is not a zone pair. */
  outboundZoneUuid?: Maybe<Scalars['String']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  tariffOverageRates: Array<TariffOverageRateEntity>;
  tariffUuid: Scalars['String']['output'];
  /** The tariff's updatedAt. A lane save sends it back so the server can refuse a write over a newer change. */
  version: Scalars['DateTime']['output'];
};

export type PointToPointLaneInput = {
  /** The lane's bands, lowest ceiling first. Replaces every stored band. */
  bands: Array<PointToPointLaneBandInput>;
  /** Origin zone, a zone group member */
  inboundZoneUuid: Scalars['String']['input'];
  /** False disables the lane: it keeps its rates and never rates */
  isActive: Scalars['Boolean']['input'];
  /** USD cents */
  maximumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  /** USD cents */
  minimumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  /** Destination zone, a zone group member */
  outboundZoneUuid: Scalars['String']['input'];
  /** Replaces the lane overage rates. Omit or send null to keep the stored ones; a new lane then gets none. */
  overageRates?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The saved lane tariff, from pointToPointLanes. Omit, with version, for a lane the group does not price yet. */
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The version pointToPointLanes returned for tariffUuid. The save refuses the lane when the tariff changed since. */
  version?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PointToPointLaneRemovalInput = {
  tariffUuid: Scalars['String']['input'];
  /** The version pointToPointLanes returned for tariffUuid */
  version: Scalars['DateTime']['input'];
};

export type PopulationCriteriaInput = {
  dueDateSource?: InputMaybe<RouteAutomationDueDateSource>;
  /** Override list of Tag uuids a stop must NOT carry. Empty array means "no exclude filter". */
  excludeTagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Override list of Tag uuids a stop must carry. Empty array means "no include filter". */
  includeTagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupOrDelivery?: InputMaybe<RouteAutomationDirection>;
  /** Override list of Service uuids that qualify. Empty array means "match all services" for this run. */
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PostalResultEntity = {
  __typename?: 'PostalResultEntity';
  component: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Represents an order with a discrepancy between posted and current amounts */
export type PostedVsActualDiscrepancyEntity = {
  __typename?: 'PostedVsActualDiscrepancyEntity';
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  currentAmountCents?: Maybe<Scalars['Float']['output']>;
  customerName: Scalars['String']['output'];
  customerReferenceNumber?: Maybe<Scalars['String']['output']>;
  discrepancyCents: Scalars['Float']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceJournalNumber?: Maybe<Scalars['Float']['output']>;
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  postedAmountCents?: Maybe<Scalars['Float']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PreSignedPutUrlEntity = {
  __typename?: 'PreSignedPutUrlEntity';
  bucket: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filetype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PreSignedUrlRequestInput = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
};

export type PrefillBillingPartyCandidateEntity = {
  __typename?: 'PrefillBillingPartyCandidateEntity';
  displayName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PrefillInspectionEntity = {
  __typename?: 'PrefillInspectionEntity';
  candidates: Array<PrefillBillingPartyCandidateEntity>;
  conditionalService?: Maybe<ConditionalServiceExplainEntity>;
  senderBillingParty?: Maybe<SenderBillingPartyExplainEntity>;
};

export type PrefillInspectionOutput = PrefillInspectionEntity | QueryErrorOutput;

export type PreviewAddOrdersToInvoicesForContactOutput = {
  __typename?: 'PreviewAddOrdersToInvoicesForContactOutput';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingInvoicesToUpdate: Array<ExistingInvoiceToUpdate>;
  newInvoicesToCreate: Array<NewInvoiceToCreate>;
};

export type PreviewAddOrdersToInvoicesInput = {
  addToExistingInvoices: Scalars['Boolean']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type PreviewAddOrdersToInvoicesOutput = {
  __typename?: 'PreviewAddOrdersToInvoicesOutput';
  invoicesToAddToByContact: Array<PreviewAddOrdersToInvoicesForContactOutput>;
};

export type PreviewInventoryCountScopeInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to on-hand pieces with a warehouse but no warehouse location assigned. */
  noLocationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to on-dock pieces flagged overdue by dwell time. */
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Piece statuses in scope. Defaults to the web Inventory bucket (ARRIVED, PLANNED) when omitted. */
  statuses?: InputMaybe<Array<PieceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to pieces not associated to any order. */
  unassociatedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PreviewInventoryCountScopeOutput = {
  __typename?: 'PreviewInventoryCountScopeOutput';
  cap: Scalars['Int']['output'];
  isOverCap: Scalars['Boolean']['output'];
  pieceCount: Scalars['Int']['output'];
};

export type PreviewLineHaulReroutesInput = {
  routes: Array<AssignLineHaulRouteInput>;
};

export type PreviewParseCsvOrdersInput = {
  bucket: Scalars['String']['input'];
  csvOrderMappingUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type PreviewParseCsvOrdersOutput = PreviewParseCsvOrdersSuccessOutput | QueryErrorOutput;

export type PreviewParseCsvOrdersSuccessOutput = {
  __typename?: 'PreviewParseCsvOrdersSuccessOutput';
  errors: Array<ParseCsvOrderRowErrorEntity>;
  parsedOrders: Array<ParsedCsvOrderEntity>;
};

export type PreviewProratedConsolidationInput = {
  shipmentUuids: Array<Scalars['String']['input']>;
};

/** the output of the API is a list of orders along with information about charges after prorating */
export type PreviewProratedConsolidationOutput = {
  __typename?: 'PreviewProratedConsolidationOutput';
  proratedOrders: Array<ProratedOrderInformation>;
};

export type PreviewProratedConsolidationV2Input = {
  consolidationMethod?: InputMaybe<OrderConsolidationMethod>;
  ordersToConsolidateWithUuids: Array<Scalars['String']['input']>;
  primaryOrderUuid: Scalars['String']['input'];
  shouldProrateInbound: Scalars['Boolean']['input'];
  shouldProrateOutbound: Scalars['Boolean']['input'];
};

export type PreviewProratedConsolidationV2Output = PreviewProratedConsolidationV2SuccessOutput | QueryErrorOutput;

export type PreviewProratedConsolidationV2SuccessOutput = {
  __typename?: 'PreviewProratedConsolidationV2SuccessOutput';
  consolidationMethod: OrderConsolidationMethod;
  proratedOrders: Array<ProratedOrder>;
  proratedOverview: ProratedOverview;
  totalAfterProrating: Scalars['Float']['output'];
  /** The sum of the weights of the orders that were consolidated */
  totalWeightConsolidated: Scalars['Float']['output'];
};

export type PreviousManifestError = {
  __typename?: 'PreviousManifestError';
  manifest: LineHaulManifestEntity;
  order: OrderEntity;
};

export enum ProductionCompany {
  Intellifreight = 'INTELLIFREIGHT',
  WiseChoice = 'WISE_CHOICE'
}

/** Driver standing relative to the P&D time-allowance thresholds used by the Intelligence Board. */
export enum ProductivityStatus {
  Efficient = 'EFFICIENT',
  Inefficient = 'INEFFICIENT',
  Moderate = 'MODERATE'
}

export type ProductivityTimeAllowanceEntity = {
  __typename?: 'ProductivityTimeAllowanceEntity';
  minutesPerHundredweight: Scalars['Float']['output'];
  minutesPerMile: Scalars['Float']['output'];
  minutesPerPiece: Scalars['Float']['output'];
  minutesPerStop: Scalars['Float']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ProfitabilityCostAssumptionEntity = {
  __typename?: 'ProfitabilityCostAssumptionEntity';
  monthlyFixedCostUsd: Scalars['Float']['output'];
  monthlyOverheadCostUsd: Scalars['Float']['output'];
  variableCostPerHundredweightUsd: Scalars['Float']['output'];
  variableCostPerMileUsd: Scalars['Float']['output'];
  variableCostPerShipmentUsd: Scalars['Float']['output'];
};

/** Customer standing relative to the contribution-ratio thresholds used by the Intelligence Board. */
export enum ProfitabilityStatus {
  BelowVariableCost = 'BELOW_VARIABLE_COST',
  Contributing = 'CONTRIBUTING',
  Profitable = 'PROFITABLE'
}

export type ProposedRouteSequence = {
  __typename?: 'ProposedRouteSequence';
  lateStops?: Maybe<Array<LateStop>>;
  routeUuid: Scalars['String']['output'];
  stopOrder: Array<Scalars['String']['output']>;
};

export type ProposedRouteSequenceInput = {
  routeUuid: Scalars['String']['input'];
  stopOrder: Array<Scalars['String']['input']>;
};

export type ProrateOrdersInput = {
  consolidationMethod?: InputMaybe<OrderConsolidationMethod>;
  ordersToConsolidateWithUuids: Array<Scalars['String']['input']>;
  primaryOrderUuid: Scalars['String']['input'];
  shouldProrateInbound: Scalars['Boolean']['input'];
  shouldProrateOutbound: Scalars['Boolean']['input'];
};

export type ProrateOrdersOutput = MutationErrorOutput | ProrateOrdersSuccessOutput;

export type ProrateOrdersSuccessOutput = {
  __typename?: 'ProrateOrdersSuccessOutput';
  orderUuids: Array<Scalars['String']['output']>;
};

/** the custom charge amount before and after prorating along with which orders the custom charge was present in before prorating (since after prorating it is split across orders) */
export type ProratedCustomCharge = {
  __typename?: 'ProratedCustomCharge';
  accessorialUuid?: Maybe<Scalars['String']['output']>;
  /** before prorating, which orders was this custom charge in. This helps us tell whether it was split or combined and split. */
  initialOrderUuidsPresentIn: Array<Scalars['String']['output']>;
  initialTotalCents?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  proratedTotalCents: Scalars['Float']['output'];
};

/** the custom charge amount before and after prorating along with which orders the custom charge was present in before prorating (since after prorating it is split across orders) */
export type ProratedCustomChargeV2 = {
  __typename?: 'ProratedCustomChargeV2';
  /** the total of the custom charge before prorating. It is null if this custom charge was not on this order before. */
  initialTotal?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  proratedTotal: Scalars['Float']['output'];
};

export type ProratedOrder = {
  __typename?: 'ProratedOrder';
  hawb?: Maybe<Scalars['String']['output']>;
  inboundShipment?: Maybe<ProratedShipment>;
  /** The initial line haul charges before prorating. It can just be a number because we are not prorating line haul yet */
  lineHaulInitialTotal?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** The initial order charges before prorating. It can just be a number because we are not prorating order charges yet */
  orderChargesInitialTotal?: Maybe<Scalars['Float']['output']>;
  outboundShipment?: Maybe<ProratedShipment>;
  proportionForConsolidation?: Maybe<Scalars['Float']['output']>;
  /** @deprecated This field is deprecated as we are introducing proportions for consolidation besides weight. Use proportionForConsolidation instead.  */
  proportionOfTotalWeight: Scalars['Float']['output'];
  /** The total after prorating including shipments that were not prorated */
  totalAfterProrating: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  /** The weight of the order */
  weight: Scalars['Float']['output'];
};

export type ProratedOrderInformation = {
  __typename?: 'ProratedOrderInformation';
  inboundShipment?: Maybe<ProratedShipmentInformation>;
  order: OrderEntity;
  outboundShipment?: Maybe<ProratedShipmentInformation>;
};

export type ProratedOverview = {
  __typename?: 'ProratedOverview';
  customCharges?: Maybe<Array<SimpleCustomCharge>>;
  inboundFreightCharge?: Maybe<SimpleFreightCharge>;
  inboundFuelCharge?: Maybe<SimpleFuelCharge>;
  outboundFreightCharge?: Maybe<SimpleFreightCharge>;
  outboundFuelCharge?: Maybe<SimpleFuelCharge>;
};

export type ProratedShipment = {
  __typename?: 'ProratedShipment';
  customCharges: Array<ProratedCustomChargeV2>;
  /** The total of the freight charge in dollars before prorating. If it is null, the shipment did not have a freight charge */
  initialFreightChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The total of the fuel charge in dollars before prorating. If it is null, the shipment did not have a fuel charge */
  initialFuelChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The total of the freight charge in dollars after prorating. If the shipment is not prorated this will equal the initial total */
  proratedFreightChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The total of the fuel charge in dollars after prorating. If the shipment is not prorated this will equal the initial total */
  proratedFuelChargeTotal?: Maybe<Scalars['Float']['output']>;
};

export type ProratedShipmentInformation = {
  __typename?: 'ProratedShipmentInformation';
  customCharges: Array<ProratedCustomCharge>;
  freightAndFuelProrateMultiplier: Scalars['Float']['output'];
  initialFreightCharge?: Maybe<FreightChargeForProrating>;
  initialFuelCharge?: Maybe<FuelChargeForProrating>;
  isProrated: Scalars['Boolean']['output'];
  proratedFreightCharge?: Maybe<FreightChargeForProrating>;
  proratedFuelCharge?: Maybe<FuelChargeForProrating>;
  shipment: ShipmentEntity;
};

export type ProvenanceBboxEntity = {
  __typename?: 'ProvenanceBboxEntity';
  h: Scalars['Float']['output'];
  l: Scalars['Float']['output'];
  t: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
};

export type ProvenanceFieldEntity = {
  __typename?: 'ProvenanceFieldEntity';
  confidence?: Maybe<Scalars['Float']['output']>;
  contributingNeighbors: Array<Scalars['String']['output']>;
  contributingNotes: Array<Scalars['String']['output']>;
  derivationTag?: Maybe<Scalars['String']['output']>;
  fieldKey: Scalars['String']['output'];
  fieldStatus: Scalars['String']['output'];
  pageHash?: Maybe<Scalars['String']['output']>;
  sourceBboxes: Array<ProvenanceBboxEntity>;
  sourceKind?: Maybe<Scalars['String']['output']>;
  sourcePage?: Maybe<Scalars['Int']['output']>;
  sourceS3Key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProvenanceNeighborEntity = {
  __typename?: 'ProvenanceNeighborEntity';
  companyUuid: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  extractionRunId?: Maybe<Scalars['String']['output']>;
  fields: Array<ProvenanceFieldEntity>;
  modelVersion?: Maybe<Scalars['String']['output']>;
  taxonomyVersion?: Maybe<Scalars['String']['output']>;
};

export type PublishOrganizationMessageInput = {
  /** Required as "SEND" when the message addresses every company. */
  confirmation?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum QboSyncElement {
  Account = 'ACCOUNT',
  Connection = 'CONNECTION',
  Currency = 'CURRENCY',
  Customer = 'CUSTOMER',
  Invoice = 'INVOICE',
  Item = 'ITEM',
  Tax = 'TAX',
  Terms = 'TERMS'
}

export enum QboSyncFixLocation {
  Either = 'EITHER',
  NoneRetry = 'NONE_RETRY',
  Quickbooks = 'QUICKBOOKS',
  Support = 'SUPPORT',
  Tenet = 'TENET'
}

export enum QboSyncNoticeKind {
  BillWithParent = 'BILL_WITH_PARENT',
  CreatedCustomer = 'CREATED_CUSTOMER',
  CreatedItem = 'CREATED_ITEM',
  MatchedByNormalizedName = 'MATCHED_BY_NORMALIZED_NAME',
  NearDuplicateCustomer = 'NEAR_DUPLICATE_CUSTOMER',
  RelinkedCustomer = 'RELINKED_CUSTOMER',
  UpdatedExistingInvoice = 'UPDATED_EXISTING_INVOICE'
}

export type Query = {
  __typename?: 'Query';
  ablyToken: AblyTokenOutput;
  accessorial: AccessorialUnion;
  accessorialChargeDetailsReport: Array<AccessorialChargeDetailsEntity>;
  accessorialDateRangeConfigByUuid: AccessorialDateRangeConfigEntity;
  accessorialDateRangeConfigs: FindAccessorialDateRangeConfigsOutput;
  accessorialGroup: AccessorialGroupEntity;
  accessorialGroups: Array<AccessorialGroupEntity>;
  accessorialToQuickbooksMappingByContact: Array<AccessorialToQuickbooksMappingEntity>;
  accessorials: Array<AccessorialUnion>;
  accessorialsByBillingContact: Array<AccessorialUnion>;
  accountingReportFilters: AccountingReportFiltersOutput;
  accountsReceivableReport: Array<AccountsReceivableReportDataForContactEntity>;
  activeAgents: Array<AgentFieldsEntity>;
  activeOrganizationMessageBanners: OrganizationMessageBannersEntity;
  adhocPreviewBatch: AdhocPreviewBatchEntity;
  adhocPreviewResult: AdhocPreviewResultEntity;
  adhocPreviewWordBoxes: DocExtractionEvalDocumentWordBoxesEntity;
  agingReport: Array<AgingReportForContactEntity>;
  agingReportPdf: AgingReportFileOutput;
  airportInfo: AirportInfoEntity;
  airportInfos: Array<AirportInfoEntity>;
  allScannedDocuments: Array<Scalars['String']['output']>;
  apiKeyAdminEventTypeCatalog: Array<ApiKeyAdminEventTypeCatalogShapeEntity>;
  apiKeyAdminExamplePayload: Scalars['String']['output'];
  apiKeyAdminExportCsv: Scalars['String']['output'];
  apiKeyAdminGet: ApiKeyAdminDetailEntity;
  apiKeyAdminList: ApiKeyAdminListResult;
  apiKeyAdminPreviewMapping: Scalars['String']['output'];
  apiKeyAdminSearchOrganizations: Array<ApiKeyAdminOrgSearchResult>;
  apiKeyAdminStatusMappings: Array<ApiKeyAdminStatusMappingEntity>;
  apiKeyAdminWebhookShapeConfig?: Maybe<ApiKeyAdminWebhookShapeConfigEntity>;
  apiLog: ApiLogEntity;
  apiLogs: ApiLogConnection;
  /** Public resolver to get appointment confirmation info for this stop */
  appointmentConfirmationInfo: AppointmentConfirmationInfoOutput;
  appointmentOptions: AppointmentOptions;
  /** One page of a stop appointment's status transitions, newest first. */
  appointmentStatusHistory: AppointmentStatusHistoryConnection;
  /** get stops, filtered by appointment time, for the appointment scheduling page */
  appointments: Array<StopEntity>;
  auditQuickbooksDesktopInvoiceTotals: Array<Scalars['String']['output']>;
  auditReport: Array<AuditReportBucketEntity>;
  auditShipmentOnInvoiceButOtherShipmentsNot?: Maybe<Scalars['String']['output']>;
  autoApplyAccessorialConfig?: Maybe<AutoApplyAccessorialConfigEntity>;
  autoApplyAccessorialConfigs?: Maybe<Array<AutoApplyAccessorialConfigEntity>>;
  availablePeerCompanies: Array<AvailablePeerCompanyEntity>;
  availablePiecesForLinking: AvailablePieceConnection;
  /** Bookable slots for an order, earliest first, capped at 50. An empty list is an ordinary answer, and is also what a delivery held until its order is marked on hand (requireOnHandBeforeSelfScheduling) returns. NOT PAGINATED: the date bounds move the window rather than resume one, so a service day the cap cut off part-way cannot be continued, only re-read with a larger first. */
  availableSchedulingSlotsForOrder: Array<AvailableSchedulingSlotEntity>;
  averageDaysToPayReport: Array<AverageDaysToPayForContactEntity>;
  billOfLadingPdfUrl?: Maybe<Scalars['String']['output']>;
  /** Appointment stops for one delivery day, grouped by the scheduling resource each belongs to. A live booking claim decides the resource; otherwise it is computed from area, eligibility, weekday and appointment hours. Read only: nothing is assigned to a route. */
  bookedStopsByResource: BookedStopsByResourceOutput;
  /** Progress of a bulk delegation batch of the caller company. */
  bulkDelegationBatch: BulkDelegationBatchEntity;
  businessDivisions: FindBusinessDivisionsOutput;
  businessKpiInvoicedOrders: KpiInvoicedOrderRecordsEntity;
  businessKpiOrders: KpiOrderRecordsEntity;
  businessKpiOrdersPerDriver: KpiDriverOrdersRecordsEntity;
  businessKpiPaidInvoices: KpiPaidInvoiceRecordsEntity;
  businessKpis: BusinessKpisEntity;
  calmCommitDatesByOrderUuids: Array<CalmOrderCommitEntity>;
  calmCrossdockInstructions: Array<CalmCrossdockInstructionEntity>;
  calmLineHaulOrdersToPlan: Array<CalmPlanOrderEntity>;
  calmLiveRuns: Array<CalmLiveRunEntity>;
  calmManifestLoadPackages: Array<CalmLoadPackageEntity>;
  calmManifestPlacements: Array<CalmLoadPlacementEntity>;
  calmManifestReadiness: Array<CalmManifestReadinessEntity>;
  calmManifestReschedulables: Array<CalmReschedulableEntity>;
  calmManifestSearch: Array<CalmManifestSearchResultEntity>;
  calmOrderCubeByOrderUuids: Array<CalmOrderCubeEntity>;
  calmOrderLineHaulRoute: Array<CalmOrderLegEntity>;
  calmOrderPackages: Array<CalmOrderPackageEntity>;
  calmOrderPackagesByOrderUuids: Array<CalmOrderPackagesEntity>;
  calmOrderPieces: Array<CalmOrderPieceEntity>;
  calmOrderSplitSummary: Array<CalmOrderSplitSummaryEntity>;
  calmOrderTags: Array<CalmOrderTagsEntity>;
  calmOrdersByHawb: CalmHawbSearchResultEntity;
  calmPndRouteLoad: CalmPndRouteLoadEntity;
  calmPreviewLineHaulReroutes: Array<CalmReroutePreviewEntity>;
  calmRunInboundPlan: Array<CalmRunInboundPlanEntity>;
  calmRunOnwardPlan: Array<CalmRunOnwardPlanEntity>;
  calmTerminalOnHand: Array<CalmOnHandPieceEntity>;
  calmTerminalPnd: Array<CalmPndRouteEntity>;
  chargeBreakdownReportCsv: ReportFileOutput;
  chargeBreakdownReportPdf: ChargeBreakdownReportPdfOutput;
  checkConsistencyOfInvoices: Array<Scalars['Boolean']['output']>;
  checkRegisterReport: Array<PaymentForCheckRegisterReportEntity>;
  /** Returns quotes for a client that belong to the specified company and meet the specified filter conditions. Used in the Pallet TMS quotes page. */
  clientQuotes: QuoteConnection;
  closestWarehouseToAddress?: Maybe<WarehouseEntity>;
  companies: Array<CompanyEntity>;
  company: CompanyEntity;
  companyByUuid?: Maybe<CompanyEntity>;
  companyConfiguration?: Maybe<CompanyConfigurationEntity>;
  companyConfigurationByCompanyUuid?: Maybe<CompanyConfigurationEntity>;
  companyConfigurationChanges: CompanyConfigurationChangeConnection;
  companyContacts: Array<ContactEntity>;
  companyDockDoors: Array<DockDoorEntity>;
  companyDocuments: Array<DocumentEntity>;
  companyPackageTypeConfigs: FindCompanyPackageTypeConfigsOutput;
  /** Calendar days the whole company is closed for scheduling, soonest first. Defaults to today onward, read in the company time zone. A day listed here closes every resource that runs on that weekday except the ones named in its exemptions, and composes with each resource own blocked days rather than replacing them. */
  companySchedulingBlockedDays: Array<SchedulingBlockedDayEntity>;
  companySchemas: Array<SchemaWithAnchorsEntity>;
  completedStopsNotOnRoutes: Array<StopEntity>;
  completionToPaymentReport: CompletionToPaymentReport;
  completionToPaymentReportCsv: ReportFileOutput;
  completionToPaymentSummary: CompletionToPaymentSummary;
  configMigrationCompanies: Array<MigratableCompanyObject>;
  configMigrationFeatureGroups: Array<ConfigMigrationFeatureGroup>;
  configMigrationStatus?: Maybe<ConfigMigrationStatusObject>;
  consigneePortalOrder: ConsigneePortalOrderEntity;
  contact: ContactEntity;
  contactChargeMatrixColumnMappings: Array<ContactChargeMatrixColumnMappingEntity>;
  contactCommunicationConfigs?: Maybe<Array<ContactCommunicationConfigEntity>>;
  contactEmails?: Maybe<Array<ContactEmailEntity>>;
  /** An unpaginated query for all items belonging to a contact. */
  contactItems: FindContactItemsOutput;
  contactOrderStatisticsForDateRange: ContactStatsEntity;
  contactPersons: Array<ContactPersonEntity>;
  contactServices: Array<ServiceEntity>;
  /** Get all stations for a specific contact */
  contactStations: Array<ContactStationEntity>;
  contacts: Array<ContactEntity>;
  contactsByUuids: Array<ContactEntity>;
  contactsReport: Array<ContactForContactReport>;
  coordinatesForAddress: CoordinatesForAddressEntity;
  costCenterStatementReport: CostCenterStatementReportEntity;
  costInputCatalogue: Array<CostInputDefinitionEntity>;
  costInputMonth: CostInputMonthEntity;
  costInputQuickbooksAccounts: Array<CostInputQuickbooksAccountEntity>;
  costInputStatus: CostInputStatusEntity;
  coverSheetDocumentTypeSequences: Array<CoverSheetDocumentTypeSequenceEntity>;
  creditTypes: Array<CreditTypeEntity>;
  csvOrderImportTransactions: CsvOrderImportTransactionEntity;
  csvOrderMapping: CsvOrderMappingEntity;
  csvOrderMappings: Array<CsvOrderMappingEntity>;
  currentBillingPeriodInvoice: Array<InvoiceEntity>;
  customDocumentNames: Array<CustomDocumentNameEntity>;
  customDriverForm?: Maybe<DriverSignableFormTemplateEntity>;
  customDriverForms?: Maybe<Array<DriverSignableFormTemplateEntity>>;
  /** What a customer scheduling link currently permits, plus the appointment windows available RIGHT NOW. Slots are read live on every call, never snapshotted when the link was sent. A token that is unknown, expired or revoked is an ordinary answer with a status, not an error. */
  customerAppointmentInvitation: CustomerAppointmentInvitationEntity;
  customerPortalOrders: OrderConnection;
  /** Paginated inventory list for a customer-portal (third-party) user. Restricted to pieces billed to one of the caller's own linked contacts with the portal Inventory tab enabled, within the requested company, resolved through any of the order paths a piece can be owned by (direct order link, package link, or legacy direct package link). The lifecycle bucket and piece statuses are forced server-side, and a client-supplied contactUuid is intersected with the caller's contacts, so no input can widen the visible set. Returns an empty connection for a caller that is not a portal user. */
  customerPortalPieces: PieceConnection;
  /** Returns quotes for a customer portal that the third party user has access to and meet the specified filter conditions. Used in the Pallet Customer Portal. */
  customerPortalQuotes: QuoteConnection;
  customerProfitabilityReport: CustomerProfitabilityReportEntity;
  customerReport: Array<CustomerReportBucketEntity>;
  defaultGlobalSpecialAccessorials: Array<AccessorialUnion>;
  delegatedOrdersInbox: DelegatedOrderInboxItemConnection;
  delegatedOrdersOutbox: OrderDelegationConnection;
  delegationAccessorialProposals: Array<DelegationAccessorialProposalEntity>;
  delegationEndCustomerMatch: Scalars['Boolean']['output'];
  deliveryFailureKpi: DeliveryFailureKpiEntity;
  deliveryFailureStops: DeliveryFailureStopsEntity;
  digitallySignableDocuments: Array<DocumentEntity>;
  /** Preset-tab counts for the Dispatch appointments board, scoped by tenant and delivery-date range only. */
  dispatchAppointmentSummary: DispatchAppointmentSummaryEntity;
  /** Paginated appointments for the Dispatch appointments board. The date axis is the shipment deliveryDate, not Stop.appointmentTime. */
  dispatchAppointments: DispatchAppointmentConnection;
  /** All DispatchTableColorEntities sorted ascending by position */
  dispatchTableColors: Array<DispatchTableColorEntity>;
  dispatchViews: Array<DispatchViewEntity>;
  dispatchableDrivers: GetDispatchableDriversOutput;
  docExtractionEvalDocumentWordBoxes: DocExtractionEvalDocumentWordBoxesEntity;
  docExtractionEvalRun: DocExtractionEvalRunEntity;
  docExtractionEvalRunDocuments: DocExtractionEvalRunDocumentsPageEntity;
  docExtractionEvalRuns: Array<DocExtractionEvalRunEntity>;
  docExtractionEvalSet: DocExtractionEvalSetEntity;
  docExtractionEvalSets: Array<DocExtractionEvalSetEntity>;
  docScanVolumeByPipelineReport: Array<DocScanVolumeByPipelineBucketEntity>;
  dockDoorAssignments: Array<DockDoorAssignmentEntity>;
  dockDoors: Array<DockDoorEntity>;
  dockProductivityReport: DockProductivityReportEntity;
  dockReceivedKpi: DockReceivedKpiEntity;
  dockReceivedKpiReceipts: KpiDockReceiptRecordsEntity;
  dockRunTimes: Array<DockRunTimeEntity>;
  dockScanReport: DockScanReportOutput;
  dockTimeAllowances: DockTimeAllowanceEntity;
  document: DocumentEntity;
  documentExtractionStatus: DocumentExtractionStatus;
  documentForSigning: DocumentForSigningOutput;
  documentationAdminItem: DocumentationItemEntity;
  documentationAdminTopics: Array<DocumentationTopicEntity>;
  documentationItem: DocumentationItemEntity;
  documentationSearch: Array<DocumentationSearchResultEntity>;
  documentationTopics: Array<DocumentationTopicEntity>;
  documents: Array<DocumentEntity>;
  /** One stored SMC3 exchange with its request, body sent and redacted response. */
  downloadExternalRateQuote: ExternalRateQuoteDownloadEntity;
  downloadFinancialSnapshotsCsv: Array<Array<Scalars['String']['output']>>;
  /** IANA zone of a stop that is not saved yet: the address zone, else its US ZIP, else the terminal's zone, else the company zone. The company zone while terminal local times are off. */
  draftStopTimeZone: Scalars['String']['output'];
  driver: DriverEntity;
  driverCompletedStopsLog: DriverCompletedStopsEntity;
  driverCompliance: DriverComplianceEntity;
  driverComplianceReportCsv: DriverComplianceReportFileOutput;
  driverComplianceReportPdf: DriverComplianceReportFileOutput;
  driverCredentialTypes: Array<DriverCredentialTypeEntity>;
  driverDailyLogReportCsv: ReportFileOutput;
  driverDailyLogReportPdf: ReportPdfOutput;
  driverOrders: DriverOrdersOutput;
  driverPayRateChangeEvents: DriverPayRateChangeEventConnection;
  driverPhoneNumberAvailability: DriverPhoneNumberAvailabilityOutput;
  driverPlannerAssumptions: DriverPlannerAssumptionEntity;
  driverPlannerReport: DriverPlannerReportEntity;
  driverQualifications: Array<DriverQualificationEntity>;
  driverReport: Array<DriverReportBucketEntity>;
  driverSettlementBill: DriverSettlementBillEntity;
  /** Recomputes one finalized bill against its current inputs and reports whether the frozen calculation still matches. Records a DRIFT_DETECTED flag when it does not. Expensive: it re-rates the whole bill, so call it for a single bill on demand, never per row of a list. */
  driverSettlementBillDrift: SettlementBillDriftEntity;
  driverSettlementBills: DriverSettlementBillConnection;
  driverSettlementBillsCountForCompany: Scalars['Float']['output'];
  driverSettlementBillsForDownload: Array<DriverSettlementBillForDownloadEntity>;
  driverSettlementPayBounds: Array<DriverSettlementPayBoundEntity>;
  drivers: Array<DriverEntity>;
  dummyQuery: Scalars['String']['output'];
  dunningReportPdf: ReportPdfOutput;
  duplicateMergeCandidates: Array<OrderEntity>;
  dwellTimeAlertConfigs: Array<DwellTimeAlertConfigEntity>;
  ediAndApiOrdersForReview: OrderConnection;
  ediPartnershipReferenceMappings: Array<EdiPartnershipReferenceMappingEntity>;
  ediPartnershipServiceMappings: Array<EdiPartnershipServiceMappingEntity>;
  ediTransactionPayloadByUuid: Scalars['String']['output'];
  ediTransactions: EdiTransactionConnection;
  ediTransactionsByCompany: EdiTransactionConnection;
  emailIngestionExclusions: EmailIngestionExclusionsEntity;
  emailTransactions: FindEmailTransactionsOutput;
  endOfDayDocumentProcessingJobs: Array<EndOfDayDocumentProcessingJobEntity>;
  equipment: EquipmentEntity;
  equipmentLicenses: Array<EquipmentLicenseEntity>;
  equipments: Array<EquipmentEntity>;
  etaForCustomerPortal?: Maybe<EtaEntity>;
  expeditorsApiStatus: ExpeditorsApiStatusEntity;
  externalApiTransmissionPayloadByOrderEventUuid: Scalars['String']['output'];
  featureFlag?: Maybe<FeatureFlagEntity>;
  featureFlagCompanyOverrides: Array<FeatureFlagCompanyOverrideEntity>;
  featureFlagUserOverrides: Array<FeatureFlagUserOverrideEntity>;
  featureFlags: Array<FeatureFlagEntity>;
  featureFlagsForCompanyGivenUuid: Array<FeatureFlagEntity>;
  findByOrderUuid: EdiTransactionEntity;
  findCompanyOrdersInDateRange: FindCompanyOrdersInDateRangeOutput;
  findDefaultRecoveryTariffGroupForCompany?: Maybe<TariffGroupEntity>;
  findDefaultTariffGroupForCompany?: Maybe<TariffGroupEntity>;
  findDefaultTransferTariffGroupForCompany?: Maybe<TariffGroupEntity>;
  /** Returns orphan pieces whose reference numbers match any reference number on the given order. */
  findMatchingOrphanPiecesForOrder: Array<PieceEntity>;
  findOrderByShipperBillOfLadingNumber: FindOrderByShipperBillOfLadingNumberOutput;
  /** Returns orphan pieces (no parent order) matching the given barcode within the current company. Optionally filter by terminal. `pieces` is capped at 50 rows; `hasMore` is true when additional matches exist beyond the cap, so clients can display "at least N" instead of a misleading exact count. */
  findOrphanPiecesByBarcode: FindOrphanPiecesByBarcodeOutput;
  findOutboundRequest: Scalars['String']['output'];
  findServicesForCustomerConfiguration: FindServicesForCustomerConfigurationOutput;
  findTariffGroups: Array<ContactToServicesTariffGroupMappingEntity>;
  findTariffGroupsWithContactAndServiceCombination: Array<FindTariffGroupsWithContactAndServicesCombinationOutput>;
  findTariffZoneByUuid: TariffZoneEntity;
  findTariffZoneByUuidOrThrow: TariffZoneEntity;
  firstScannedOrderResultInReview?: Maybe<ScannedOrderResultEntity>;
  forwarderBoard: ForwarderBoardEntity;
  forwarderScorecard: ForwarderScorecardEntity;
  freightCost: FreightCostEntity;
  /** Tries to find a fuel profile date range for the fuel charge that the specified date to use falls within. */
  fuelChargeFuelProfileDateRange: FuelChargeFuelProfileDateRangeOutput;
  fuelCost: FuelCostEntity;
  fuelProfile: FindFuelProfileOutput;
  fuelProfileDateRanges: FindFuelProfileDateRangesOutput;
  fuelProfiles: Array<FuelProfileEntity>;
  fuzzySearchItemsBySkuName: FuzzySearchItemsBySkuNameOutput;
  /** Returns the most recently created order that meets the required similarity threshold */
  fuzzySearchOrdersByShippingBillOfLadingNumber: FuzzySearchOrdersByShipperBillOfLadingNumberOutput;
  fuzzySearchStorageOrders: FuzzySearchStorageOrdersOutput;
  fuzzySearchStorageUnits: FuzzySearchStorageUnitsOutput;
  generalLedgerCodes: Array<GeneralLedgerCodeEntity>;
  generalLedgerConfiguration?: Maybe<GeneralLedgerConfigurationEntity>;
  generateCsvOrderPreSignedPutUrls: Array<CsvOrderPreSignedPutUrlEntity>;
  generateCsvPresignedPutUrlForMappingPreview: GenerateCsvPresignedPutUrlForMappingPreviewOutput;
  generateDefaultAppointmentTexts: Array<DefaultAppointmentTextOutput>;
  generateRoutes: GenerateRoutesOutput;
  generateScannedOrderPreSignedPutUrls: Array<PreSignedPutUrlEntity>;
  getBlacklistStats: BlacklistStatsOutput;
  /** Given a zipcode, returns the city and state options it denotes. More than one is returned when a zipcode legitimately serves several places, so the caller can ask rather than guess; an empty list means the zipcode is not in the reference data. */
  getCityAndStateOptionsFromZipcode: GetCityAndStateOptionsFromZipcodeOutput;
  getFreightCharge: FreightChargeEntity;
  getInvoiceCsvs?: Maybe<FormatCsvResEntity>;
  getJsonSchemaWithOverride: Scalars['String']['output'];
  /** This is probably not the method you want to use */
  getLegDriverMap: LegDriverMapEntity;
  getLineHaulProgress: GetLineHaulProgressOutput;
  getNexusShipments: Scalars['String']['output'];
  getOptimizationResults?: Maybe<OptimizationResultsOutput>;
  getOrderTableFieldValues: GetOrderTableFieldValuesOutput;
  getPackage: PackageEntity;
  getQuickbooksConnectionStatus?: Maybe<QuickbooksOauthTokenEntity>;
  getSavedFilterViews: Array<SavedFilterViewEntity>;
  getSchemaMatchDetails: Scalars['String']['output'];
  getSftpCredentials?: Maybe<SftpCredentialsEntity>;
  getStandardOrderFields: StandardOrderFieldsEntity;
  getStandardShipmentFields: StandardShipmentFieldsEntity;
  getStructuredExtractionSchemaOverride?: Maybe<StructuredExtractionSchemaOverrideEntity>;
  getTag: TagEntity;
  getTags: Array<TagEntity>;
  getXYTransform: XyTransformEntity;
  /** Given a city and state, invokes the Smarty US Zipcode API and returns a list of possible zipcodes for that city and state */
  getZipcodeOptionsFromCityAndState: GetZipcodeOptionsFromCityAndStateOutput;
  glCodeReportPdf: ReportPdfOutput;
  groupByStops: GroupByStopsOutput;
  groupOrders: GroupOrdersOutput;
  /** The dispatch table fields the stops grid can group by (`stops(groupBy:)`), so the grid never offers a field the query refuses. */
  groupableDispatchTableFields: Array<DispatchTableField>;
  holdReasons: Array<HoldReasonEntity>;
  /** The notification event types deliverable to the in-app bell and configurable on the in-app preferences screen, sorted. Internal users only. */
  inAppEligibleNotificationEventTypes: Array<NotificationEventType>;
  inAppNotifications: InAppNotificationConnection;
  inboundMessagesForOrder: InboundMessagesForOrderOutput;
  /** @deprecated Use incomeAnalysisReportV2, which adds terminal totals */
  incomeAnalysisReport: Array<CustomerReportBucketEntity>;
  incomeAnalysisReportV2: IncomeAnalysisReportOutput;
  incomingOrganizationPeers: OrganizationPeerConnection;
  incomingPeerAccessorialMappings: Array<IncomingPeerAccessorialMappingEntity>;
  incomingPeerServiceMappings: Array<IncomingPeerServiceMappingEntity>;
  incompleteLegsWithAttempts: Array<LegEntity>;
  ingestedOutlookEmail: IngestedOutlookEmailEntity;
  ingestedOutlookEmailAttachments: IngestedOutlookEmailAttachmentConnection;
  ingestedOutlookEmails: IngestedOutlookEmailConnection;
  ingestionTestRun: IngestionTestRunEntity;
  internalOnly_featureFlagsGlobal: Array<FeatureFlagEntity>;
  inventoryCount: FindInventoryCountOutput;
  inventoryCounts: FindInventoryCountsOutput;
  invoice?: Maybe<InvoiceEntity>;
  invoiceBillingSummaryReportV2: InvoiceBillingSummaryV2Output;
  invoiceBillingSummaryReportV2Pdf: InvoiceBillingSummaryV2PdfOutput;
  invoiceBillingSummaryReportV2PdfUrl: Scalars['String']['output'];
  invoiceDocuments: Array<DocumentEntity>;
  /** Given an invoice, retrieves all the EDI transactions associated with that invoice */
  invoiceEdiTransactions: FindInvoiceEdiTransactionsOutput;
  invoiceEmailsApiLogs: FindInvoiceEmailsApiLogsOutput;
  invoiceExcelExportData: Array<InvoiceExcelExportDataOutput>;
  invoiceGroups: InvoiceTableGroupsOutput;
  invoiceNoteRules: InvoiceNoteRuleConnection;
  invoiceRegisterReportCsv: ReportFileOutput;
  invoiceRegisterReportPdf: ReportPdfOutput;
  invoiceSendJobBatches: InvoiceSendJobBatchConnection;
  invoiceSendJobs: InvoiceSendJobConnection;
  invoiceTerms: Array<InvoiceTermEntity>;
  invoices: InvoiceConnection;
  invoicesByUuids: Array<InvoiceEntity>;
  item: ItemEntity;
  itemGroups: ItemGroupConnection;
  itemLocations: Array<ItemLocationEntity>;
  items: ItemConnection;
  itemsBySkuName: Array<ItemEntity>;
  kpiComparisons: KpiComparisonsEntity;
  kpiDashboardLayout: KpiLayoutEntity;
  kpiDataStart: KpiDataStartEntity;
  laneDefaultDoors: Array<LaneDefaultDoorEntity>;
  laneFromOriginAndDestinationTerminal: FindLaneFromOriginAndDestinationTerminalOutput;
  leg?: Maybe<LegEntity>;
  legs: Array<LegEntity>;
  lineHaulDriverConflict: LineHaulDriverConflictOutput;
  /** Tries to find a line haul fuel profile date range for the fuel charge that the specified date to use falls within. */
  lineHaulFuelChargeFuelProfileDateRange: LineHaulFuelChargeFuelProfileDateRangeOutput;
  lineHaulLane: LineHaulLaneEntity;
  lineHaulLanes: Array<LineHaulLaneEntity>;
  lineHaulLanesForTerminals: Array<LineHaulLaneEntity>;
  lineHaulManifest: LineHaulManifestEntity;
  lineHaulManifests: FindLineHaulManifestsOutput;
  lineHaulManifestsGroups: LineHaulManifestsCategoryGroupsOutput;
  lineHaulRunConfigs: Array<LineHaulRunConfigEntity>;
  lineHaulSegment: LineHaulSegmentEntity;
  lineHaulSegmentTimings: Array<LineHaulSegmentTimingEntity>;
  lineHaulSegments: Array<LineHaulSegmentEntity>;
  lineHaulTrailerAssignments: Array<LineHaulTrailerAssignmentEntity>;
  lineHaulUtilizationAssumptions: LineHaulUtilizationAssumptionEntity;
  lineHaulUtilizationReport: LineHaulUtilizationReportEntity;
  linehaulRevenueReport: LineHaulRevenueReportOutput;
  /** The Business/Residence most recently picked by hand for this street address in the caller company, or null when nobody has picked one */
  manualStandardStopTypeForAddress?: Maybe<StandardStopType>;
  mapboxDirections: Scalars['Boolean']['output'];
  mapboxMatrix: Scalars['Boolean']['output'];
  masterAccounts: FindMasterAccountsOutput;
  me?: Maybe<UserEntity>;
  meAsThirdPartyUser?: Maybe<ThirdPartyUserEntity>;
  meDriver: DriverEntity;
  mirrorTargetCompanies: Array<MirrorTargetCompanyEntity>;
  mirrorTargets: Array<MirrorTargetEntity>;
  mobileFeatureFlag?: Maybe<FeatureFlagEntity>;
  mobileForceUpdateRequired: Scalars['Boolean']['output'];
  /** Returns the calling company's Motive connection state. */
  motiveIntegration: MotiveIntegrationEntity;
  myGroupedStopUuids: Array<Array<Scalars['String']['output']>>;
  /** The current user's effective in-app notification preferences: one entry per in-app-eligible event type with its resolved enabled state (the user's explicit choice, or the type's default). */
  myInAppNotificationPreferences: Array<InAppNotificationPreferenceEntity>;
  myLineHaulManifest?: Maybe<LineHaulManifestEntity>;
  myLineHaulManifests: Array<LineHaulManifestEntity>;
  /** Return today's stops for the current driver */
  myRoute?: Maybe<RouteEntity>;
  /** Return routes for the current driver */
  myRoutes?: Maybe<RouteConnection>;
  /** Return today's stops for the current driver */
  myStops: Array<StopEntity>;
  /** Return stops for the current driver by the UUIDs */
  myStopsByUuids: Array<StopEntity>;
  netSalesSummaryReport: NetSalesSummaryReportOutput;
  notificationCutoverConfigs: Array<NotificationCutoverConfigEntity>;
  notificationShadowComparisonSummary: Array<NotificationShadowComparisonStatusCountEntity>;
  notificationShadowComparisons: Array<NotificationShadowComparisonEntity>;
  notifications: Array<NotificationEntity>;
  numberOfEdiAndApiOrdersForReviewForCurrentCompany: Scalars['Int']['output'];
  /** @deprecated Prefer orderTableFieldValues with totalCount set to true instead */
  numberOfOrders: Scalars['Float']['output'];
  numberOfScannedOrderResultDuplicates: Scalars['Int']['output'];
  numberOfScannedOrderResultsApproved: Scalars['Int']['output'];
  numberOfScannedOrderResultsFailed: Scalars['Int']['output'];
  numberOfScannedOrderResultsInProgress: Scalars['Int']['output'];
  numberOfScannedOrderResultsInReview: Scalars['Int']['output'];
  numberOfScannedOrderResultsRejected: Scalars['Int']['output'];
  numberOfStops: Scalars['Float']['output'];
  onTimeKpi: OnTimeKpiEntity;
  onTimeKpiStops: OnTimeKpiStopsEntity;
  onTimePerformanceReportCsv: ReportFileOutput;
  onTimePerformanceReportPdf: ReportFileOutput;
  openInvoiceReport: Array<InvoiceForOpenInvoiceReportEntity>;
  operationalEfficiencyReport: OperationalEfficiencyReportEntity;
  operationsPerformanceReport: OperationsPerformanceReport;
  operationsPerformanceReportCsv: ReportFileOutput;
  operationsPerformanceSummary: OperationsPerformanceSummary;
  optimizationStatus: OptimizationStatusResult;
  order?: Maybe<OrderEntity>;
  /** Given a payment amount and a HAWB, preview applying payment to all orders sharing that HAWB for the customer (or every customer when contactUuid is omitted). Returns amount applied and new+current balances. */
  orderAmountsToPayForHawb: Array<OrderToChargeEntity>;
  /** Given a payment amount and invoices, preview applying payment to orders across invoices. Return amount applied and new+current balances. */
  orderAmountsToPayForInvoice: Array<OrderToChargeEntity>;
  orderAuditLogEntries?: Maybe<GetOrderAuditLogEntriesOutput>;
  /** Comments for an order or a specific piece */
  orderComments: Array<OrderCommentEntity>;
  orderDelegationRules: Array<OrderDelegationRuleEntity>;
  orderEventNotificationSubscriptions: Array<OrderEventNotificationSubscriptionEntity>;
  orderEvents?: Maybe<Array<OrderEventEntity>>;
  orderFormFields: OrderFormFieldsEntity;
  orderImportConfiguration: OrderImportConfigurationEntity;
  orderMirrorCaptureConfig: OrderMirrorCaptureConfigEntity;
  orderMirrorOutboxCount: Scalars['Int']['output'];
  orderMirrorSyncRequests: Array<MirrorSyncRequestEntity>;
  orderMirrorSyncableCompanies: Array<MirrorSyncableCompanyEntity>;
  orderName: Scalars['String']['output'];
  orderQuote?: Maybe<OrderQuote>;
  orderQuoteForOrder?: Maybe<OrderQuote>;
  orderQuotes: OrderQuoteConnection;
  orderQuotesNeedingActionCount: Scalars['Int']['output'];
  orderReport: Array<OrderReportBucketEntity>;
  orderReportByReportGroup: Array<OrderReportBucketEntity>;
  orderRevenueReport: RevenueReportOrderConnection;
  orderTableFieldHeaders: GetOrderTableFieldHeadersOutput;
  /** The uuids of the orders in an orders table view, up to a limit, for selecting the whole view. Requires ORDERS read access. */
  orderUuidsInView: FindOrderUuidsInViewOutput;
  orderVolumeByCompanyReport: Array<OrderVolumeCompanyBucketEntity>;
  orderVolumeByContactReport: Array<OrderVolumeContactBucketEntity>;
  orderVolumeByDateRangeReport: Array<OrderVolumeDateRangeBucketEntity>;
  orderVolumeBySchemaReport: Array<OrderVolumeSchemaBucketEntity>;
  orderVolumeByUserReport: Array<OrderVolumeUserBucketEntity>;
  orders: OrderConnection;
  ordersByMasterAirwayBillOfLadingNumber: Array<OrderEntity>;
  ordersBySecondaryRefNumber: Array<OrderEntity>;
  ordersByShipperBillOfLadingNumber: Array<OrderEntity>;
  ordersByUuids: Array<OrderEntity>;
  ordersForPayments: OrderConnection;
  organization: OrganizationEntity;
  organizationEffectivePackageTypeConfigs: FindEffectiveOrganizationPackageTypeConfigsOutput;
  organizationMessage: OrganizationMessageEntity;
  organizationMessageCounts: OrganizationMessageCountsEntity;
  organizationMessageHistory: Array<OrganizationMessageEventEntity>;
  organizationMessageReach: OrganizationMessageReachEntity;
  organizationMessageStats: OrganizationMessageStatsEntity;
  organizationMessages: OrganizationMessageConnection;
  organizationNotes: Array<ContactCommentEntity>;
  organizationPackageTypeConfigs: FindOrganizationPackageTypeConfigsOutput;
  organizationPeers: OrganizationPeerConnection;
  organizationQuotePolicy: OrganizationQuotePolicy;
  organizations: Array<OrganizationEntity>;
  outboundBenchCompanyUsers: Array<BenchCompanyUserOptionEntity>;
  outboundBenchDrivers: Array<BenchDriverOptionEntity>;
  outboundBenchEdiPayload: BenchEdiPayloadEntity;
  outboundBenchOrders: Array<BenchOrderOptionEntity>;
  outboundBenchPartnerships: Array<BenchPartnershipOptionEntity>;
  outboundBenchServiceLevels: Array<BenchServiceLevelOptionEntity>;
  outlookIntegrations: Array<OutlookIntegrationEntity>;
  outlookIntegrationsForInternal: Array<OutlookIntegrationEntity>;
  outstandingInvoicesForCustomer?: Maybe<Array<InvoiceEntity>>;
  outstandingOrdersForReview: OrderConnection;
  outstandingShipments: ShipmentConnection;
  overdueInvoices: Array<InvoiceEntity>;
  packageHasPiece: PackageHasPieceEntity;
  packageSpec: PackageSpecEntity;
  packageSpecs: FindPackageSpecsOutput;
  packingPendencies: FindPackingPendenciesOutput;
  /** Resolves one scanned barcode to a packable piece for the mobile packing screen. Matches the piece reference number and its alternates, exactly as freight scanning does. The open order and the scanning facility rank the matches rather than filter them, so a piece with no assigned facility still resolves. Returns null when no packable piece matches. */
  packingPieceByBarcode?: Maybe<PieceListEntity>;
  /** Lists pieces for the warehouse packing page, paginated by package so whole packages are returned (never split at a piece boundary). */
  packingPieces: PackingPiecesOutput;
  paginatedContacts: ContactConnection;
  paginatedOrdersByInvoice: OrderConnection;
  paginatedOrganizations: OrganizationConnection;
  paginatedRoutes: RouteConnection;
  parseAddress: Array<PostalResultEntity>;
  paymentApplicationReport: Array<PaymentForPaymentApplicationReportEntity>;
  paymentByUuid?: Maybe<PaymentEntity>;
  /** Uuids of the customers the payment dialog lists when filtered on this customer: the customer and every customer sharing its master account, inactive ones included. */
  paymentCustomerScope: Array<Scalars['String']['output']>;
  paymentJournalReport: Array<PaymentForPaymentJournalReportEntity>;
  paymentsByInvoiceUuid: Array<PaymentEntity>;
  paymentsV2: PaymentConnection;
  pdProductivityReport: PdProductivityReportEntity;
  pdfColumn: PdfColumnEntity;
  peerAccessorialShares: Array<Scalars['String']['output']>;
  peerServiceShares: Array<PeerServiceShareEntity>;
  pendingOrderDelegationsCount: Scalars['Int']['output'];
  person: PersonEntity;
  /** Find all persons for the specified contact. Returns an empty result when contactUuid is omitted. */
  persons: FindPersonsOutput;
  picklists: PicklistConnection;
  piece: PieceEntity;
  pieceBackfillRun: PieceBackfillRunView;
  pieceBackfillRuns: Array<PieceBackfillRunView>;
  pieceBackfillSurvey: PieceBackfillSurvey;
  pieceBucketMetrics: PieceBucketMetricsOutput;
  pieceReceipt: FindPieceReceiptOutput;
  /** Fetch a single piece for the receipt detail panel. Receipt-scoped: resolves only when the piece is attached to the given receipt (which is tenant-checked first). */
  pieceReceiptPiece: PieceEntity;
  pieceReceipts: FindPieceReceiptsOutput;
  pieceScanKpi: PieceScanKpiEntity;
  pieceScanKpiPieces: KpiPieceRecordsEntity;
  /** Paginated list of pieces for the current company. */
  pieces: PieceConnection;
  /** Fetch multiple pieces by UUID, scoped to the current company. */
  piecesByUuids: Array<PieceEntity>;
  piecesGroupedByStatus: PiecesGroupedByStatusOutput;
  ping: Scalars['String']['output'];
  place: PlaceEntity;
  planOutboundBenchRun: BenchRunReportEntity;
  planQuickbooksSync: QuickbooksSyncPlan;
  pointToPointLanes: PointToPointLaneConnection;
  postedVsActualReport: Array<PostedVsActualDiscrepancyEntity>;
  prefillInspection: PrefillInspectionOutput;
  previewAddOrdersToInvoices: PreviewAddOrdersToInvoicesOutput;
  previewBatchAddShipmentsToInvoices: BatchAddShipmentsToInvoicePreview;
  previewBatchAddShipmentsToInvoicesMultiple: Array<BatchAddShipmentsToInvoicePreview>;
  previewInventoryCountScope: PreviewInventoryCountScopeOutput;
  previewParseCsvOrders: PreviewParseCsvOrdersOutput;
  previewProratedConsolidation: PreviewProratedConsolidationOutput;
  previewProratedConsolidationV2: PreviewProratedConsolidationV2Output;
  productivityTimeAllowances: ProductivityTimeAllowanceEntity;
  queryQuickbooksDesktopAccounts: QuickbooksDesktopResultEntity;
  queryQuickbooksDesktopCustomers: QuickbooksDesktopResultEntity;
  queryQuickbooksDesktopInvoices: Array<QuickbooksDesktopInvoiceEntity>;
  queryQuickbooksDesktopItems: QuickbooksDesktopResultEntity;
  quickbooksClasses?: Maybe<Array<QuickbooksClassEntity>>;
  quickbooksCustomers?: Maybe<Array<QuickbooksCustomerEntity>>;
  quickbooksHeaderFileMappings: Array<QuickbooksHeaderFileMappingEntity>;
  quickbooksIncomeAccounts?: Maybe<Array<QuickbooksAccountEntity>>;
  quickbooksItems?: Maybe<Array<QuickbooksItemEntity>>;
  quickbooksOAuthUrl: Scalars['String']['output'];
  quickbooksTaxCodes?: Maybe<Array<QuickbooksTaxCodeEntity>>;
  quote: QuoteEntity;
  quoteAgentConnections: QuoteAgentConnectionsResult;
  quoteAgentInboundRejections: QuoteAgentInboundRejectionsResult;
  quoteContributionRatio?: Maybe<QuoteContributionRatioEntity>;
  quoteConversation?: Maybe<QuoteConversationEntity>;
  quoteName: Scalars['String']['output'];
  quotes: QuoteConnection;
  rateAutoAppliedAccessorials: RateAutoAppliedAccessorialsOutput;
  rateOrderByUuid: RateOrderOutput;
  rateOrderContents: RateOrderOutput;
  receiptItemStorageUnits: Array<StorageUnitEntity>;
  recurringLineHaulManifestTemplate: RecurringLineHaulManifestTemplateEntity;
  recurringLineHaulManifestTemplates: Array<RecurringLineHaulManifestTemplateEntity>;
  recurringOrderFrequency: RecurringOrderFrequencyEntity;
  recurringOrderTemplates: Array<OrderEntity>;
  recurringRuns: Array<RunEntity>;
  recurringTemplateTrucks: Array<RecurringTemplateTruckEntity>;
  referenceNumberFormatConfigs?: Maybe<Array<ReferenceNumberFormatConfigEntity>>;
  remainingAmountOfInvoices: Scalars['Float']['output'];
  renderServices: Array<RenderServiceWithDeploysEntity>;
  reportGroupConfigurations: Array<ReportGroupConfigurationEntity>;
  reportSendJobBatches: FindReportSendJobBatchesOutput;
  reportSendJobs: FindReportSendJobsOutput;
  reportsEmailSenderIsVerified?: Maybe<Scalars['Boolean']['output']>;
  resolveProvenanceNeighbor?: Maybe<ProvenanceNeighborEntity>;
  role: FindRoleOutput;
  roles: FindRolesOutput;
  route: RouteEntity;
  /** Returns the calling company's v2 route-automation settings. Creates a default row on first read. */
  routeAutomationSettings: RouteAutomationSettingsEntity;
  routeName?: Maybe<RouteNameEntity>;
  routeNames: Array<RouteNameEntity>;
  routes: Array<RouteEntity>;
  routesSamsaraVehicleLocations: RoutesSamsaraVehicleLocationsOutput;
  sageBusinessWorksInvoiceExportCsv: ReportFileOutput;
  salesVarianceReportCsv: ReportFileOutput;
  /** Get the Samsara OAuth authorize URL */
  samaraOAuthAuthorizeUrl: Scalars['String']['output'];
  sameDayDispatchConfig?: Maybe<SameDayDispatchConfigEntity>;
  samsaraDiscoveryCatalogue: SamsaraDiscoveryCatalogueEntity;
  /** The filtered dataset as CSV or JSON text. */
  samsaraDiscoveryExport: Scalars['String']['output'];
  samsaraDiscoveryMonthlyOverview: Array<SamsaraDiscoveryMonthEntity>;
  samsaraDiscoveryRows: SamsaraDiscoveryRowsPageEntity;
  samsaraDiscoveryStatus: SamsaraDiscoveryStatusEntity;
  samsaraDriverVehicleAssignments?: Maybe<Scalars['String']['output']>;
  samsaraDrivers?: Maybe<SamsaraDriversEntity>;
  samsaraOAuthToken?: Maybe<SamsaraOauthTokenEntity>;
  samsaraVehicleStatsFeed?: Maybe<SamsaraVehicleStatsFeedEntity>;
  samsaraVehicles?: Maybe<SamsaraVehiclesEntity>;
  scannedOrder?: Maybe<ScannedOrderEntity>;
  scannedOrderProvenance?: Maybe<DocumentProvenanceEntity>;
  scannedOrderResult?: Maybe<ScannedOrderResultEntity>;
  scannedOrderResultByOrderUuid?: Maybe<ScannedOrderResultEntity>;
  scannedOrderResultForAdmin?: Maybe<ScannedOrderResultEntity>;
  scannedOrderResults: ScannedOrderResultConnection;
  scannedOrderResultsForAdmin: ScannedOrderResultConnection;
  scannedOrders: ScannedOrderConnection;
  scannedOrdersByUuids: Array<ScannedOrderEntity>;
  /** On-demand full order info for the lean scan flow drill-in. Loads the heavy order graph only when the operator opens an order. */
  scanningV2__orderInfo?: Maybe<FreightScanningV2OrderInfo>;
  /** On-demand single-piece info for the lean scan flow drill-in. Loads an orderless (orphan) piece that cannot be resolved via scanningV2__orderInfo. */
  scanningV2__pieceInfo?: Maybe<FreightScanningV2PieceInfo>;
  /** Batched status lookup for deferred scan post-processing jobs. Powers the client polling loop. Reads BullMQ job state directly (jobId = scanUuid); no database row is involved. Tenant-scoped by the session company. */
  scanningV2__scanJobStatuses: Array<FreightScanningV2ScanJobStatus>;
  schedulingRegion: SchedulingRegionEntity;
  schedulingRegions: FindSchedulingRegionsOutput;
  schedulingResource: SchedulingResourceEntity;
  schedulingResources: FindSchedulingResourcesOutput;
  schedulingResourcesByRouteName: FindSchedulingResourcesOutput;
  schemaCompanyMappings: Array<SchemaCompanyMappingEntity>;
  schemaDocumentsBySchemaCompanyMapping: Array<SchemaDocumentEntity>;
  schemaFilePutUrl: Scalars['String']['output'];
  schemaRun?: Maybe<SchemaRunEntity>;
  schemaRunTestList: SchemaRunTestListEntity;
  schemaRunTestSnapshots: Array<SchemaRunEntity>;
  schemaTestFilePutUrl: Scalars['String']['output'];
  schemas: Array<SchemaWithAnchorsEntity>;
  searchSchemas: Array<SchemaEntity>;
  segmentedLineHaulOrders: OrderLineHaulSegmentConnection;
  segmentedLineHaulOrdersV2: OrderLineHaulSegmentOutput;
  selectSpecialAccessorial: SelectSpecialAccessorialOutput;
  senderIsVerified?: Maybe<Scalars['String']['output']>;
  serviceGroup: ServiceGroupEntity;
  serviceGroups: Array<ServiceGroupEntity>;
  serviceLevelReport: Array<ServiceLevelReportBucketEntity>;
  serviceRegion: ServiceRegionEntity;
  serviceRegions: GetServiceRegionsOutput;
  services: Array<ServiceEntity>;
  servicesForOrder: FindServicesForOrderOutput;
  servicesForThirdPartyUser: Array<ServiceEntity>;
  /** Changes recorded against one bill whose pay calculation is already frozen, newest first. */
  settlementBillChangeFlags: Array<SettlementBillChangeFlagEntity>;
  settlementBillLineItem: SettlementBillLineItemEntity;
  /** Pulls line items that are settled or settle-able (aka associated with completed stops) */
  settlementBillLineItems: SettlementBillLineItemConnection;
  settlementDeductionTypes: Array<SettlementDeductionTypeEntity>;
  sftpUploads: SftpUploadConnection;
  shipment: ShipmentEntity;
  shipmentV2?: Maybe<ShipmentEntity>;
  shipments: Array<ShipmentEntity>;
  shipmentsByContactUuid?: Maybe<Array<ShipmentEntity>>;
  shipmentsByPhoneOrReferenceNumber: Array<ShipmentEntity>;
  /** The tariffs and effective dates SMC3 lists for the company. */
  smc3AvailableTariffs: Smc3AvailableTariffsResultEntity;
  /** The calling company's SMC3 connection, without secrets. */
  smc3Settings: Smc3SettingsEntity;
  smsConsentAdminList: SmsConsentAdminConnection;
  standardAccessorials: Array<StandardAccessorialEntity>;
  standardOrder: StandardOrderEntity;
  standardOrderForReview?: Maybe<StandardOrderEntity>;
  stationReport: Array<StationReportBucketEntity>;
  stop: StopEntity;
  stopDriverMaps: StopDriverMapConnection;
  /** The uuids of the stops in one group of the grouped dispatch stops grid, under the same filters as `stops`, for assigning the whole group to a route. `groupBy.keys` names the group, at any depth. */
  stopUuidsInGroup: StopUuidsInGroupOutput;
  /** Get stops for a company. Recurring run headers are included only when there are stops loaded in the cache. */
  stops: CachedStopConnection;
  stopsBySearchText: Array<StopEntity>;
  stopsOnRoutesBySearchText: Array<StopEntity>;
  storageOrder: FindStorageOrderOutput;
  storageOrderStorageUnits: FindStorageOrderStorageUnitsOutput;
  storageOrders: FindStorageOrdersOutput;
  storageUnit: FindStorageUnitOutput;
  storageUnitByName?: Maybe<StorageUnitEntity>;
  storageUnits: FindStorageUnitsOutput;
  structuredExtractionRunByScannedOrder?: Maybe<StructuredExtractionRunEntity>;
  tableFields?: Maybe<TableFieldsEntity>;
  tariff: TariffEntity;
  tariffChains: Array<TariffChainEntity>;
  tariffGroup: TariffGroupEntity;
  tariffGroups: Array<TariffGroupEntity>;
  tariffGroupsPaginated: TariffGroupConnection;
  tariffZoneGroup: TariffZoneGroupEntity;
  tariffZoneGroups: Array<TariffZoneGroupEntity>;
  tariffZones: Array<TariffZoneEntity>;
  tariffsByContact: Array<TariffEntity>;
  templateAddresses: Array<AddressEntity>;
  tenediConnection: TenediConnectionEntity;
  tenediConnectionCustomers: Array<TenediConnectionCustomerOptionEntity>;
  terminal: TerminalEntity;
  terminalEfficiencyReport: TerminalEfficiencyReportEntity;
  terminalForAddress: FindTerminalForAddressOutput;
  terminalReport: Array<TerminalReportBucketEntity>;
  /** What saving the terminal form would do to departures leaving it when its zone changes; null when the zone stays or terminal local times are off. */
  terminalTimeZoneChangePreview?: Maybe<TerminalTimeZoneChangePreviewEntity>;
  terminals: Array<TerminalEntity>;
  terminalsForAddress: FindTerminalsForAddressOutput;
  terminalsForInternal: Array<TerminalEntity>;
  terminalsForThirdPartyUser: Array<TerminalEntity>;
  testJsonSchemaOnDocumentsForSchema: TestJsonSchemaOnDocumentsForSchemaOutput;
  testOrder: FindTestOrderOutput;
  testOrders: FindTestOrdersOutput;
  thirdPartyBrokers: Array<ThirdPartyBrokerEntity>;
  thirdPartyUser?: Maybe<ThirdPartyUserEntity>;
  thirdPartyUserByUuid?: Maybe<ThirdPartyUserEntity>;
  thirdPartyUsersByContact: Array<ThirdPartyUserEntity>;
  throwError: Scalars['Boolean']['output'];
  unappliedPaymentReportCsv: ReportFileOutput;
  /** @deprecated Use individual unified queries instead */
  unifiedSearch: UnifiedSearchEntity;
  unifiedSearchInvoices: InvoiceConnection;
  unifiedSearchOrders: OrderConnection;
  unifiedSearchQuotes: QuoteConnection;
  unifiedSearchUnacceptedEdiAndApiOrders: OrderConnection;
  unifiedSearchUnacceptedEmailOrders: ScannedOrderResultConnection;
  unreadInAppNotificationsCount: Scalars['Int']['output'];
  userContactNotificationSubscription?: Maybe<UserContactNotificationSubscriptionEntity>;
  userOptions: Array<UserOptionEntity>;
  userRoles: Array<RoleEntity>;
  userSessionsAdminCompanyUsers: UserSessionsAdminCompanyUsersResult;
  userSessionsAdminSearchCompanies: Array<UserSessionsAdminCompanyEntity>;
  users: Array<UserEntity>;
  usersEditingOrder?: Maybe<Array<UserActorEntity>>;
  /** Validates bulk edit input and returns affected counts without executing actions */
  validateBulkEditOrders: BulkEditOrdersResponse;
  vehicleType: VehicleTypeEntity;
  vehicleTypes: Array<VehicleTypeEntity>;
  verifySchemaDocumentMatchesForCompany: Scalars['String']['output'];
  warehouse?: Maybe<WarehouseEntity>;
  /** @deprecated Changing naming to more accurately represent purpose of api, see startingAddressForRoute */
  warehouseAddressOfFirstRouteSlot?: Maybe<AddressEntity>;
  warehouseEmployees: FindWarehouseEmployeesOutput;
  warehouseLocations: FindWarehouseLocationsOutput;
  warehouses?: Maybe<Array<WarehouseEntity>>;
  weightBreakReport: WeightBreakReportEntity;
  whiteLabelCompany?: Maybe<WhiteLabelCompanyEntity>;
  /** returns all contacts with storage orders associated with them to enable ease of filtering by WMS contacts. If called by the customer portal, only returns contacts that the user has access to */
  wmsContacts: Array<ContactEntity>;
  workOrderCount: Scalars['Int']['output'];
  workOrders: Array<WorkOrderListItem>;
};


export type QueryAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAccessorialChargeDetailsReportArgs = {
  args: AccessorialChargeDetailsReportArgs;
};


export type QueryAccessorialDateRangeConfigByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAccessorialDateRangeConfigsArgs = {
  findAccessorialDateRangeConfigsInput: FindAccessorialDateRangeConfigsInput;
};


export type QueryAccessorialGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccessorialToQuickbooksMappingByContactArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryAccessorialsArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAccessorialsByBillingContactArgs = {
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAccountingReportFiltersArgs = {
  accountingReportFiltersInput: AccountingReportFilterTypesInput;
};


export type QueryAccountsReceivableReportArgs = {
  args: AccountsReceivableReportArgs;
};


export type QueryAdhocPreviewBatchArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdhocPreviewResultArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdhocPreviewWordBoxesArgs = {
  id: Scalars['String']['input'];
};


export type QueryAgingReportArgs = {
  args: InvoiceAgingReportArgs;
};


export type QueryAgingReportPdfArgs = {
  args: InvoiceAgingReportArgs;
};


export type QueryAirportInfoArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryApiKeyAdminExamplePayloadArgs = {
  sendCompanyLocalTimestamps?: Scalars['Boolean']['input'];
  shape: WebhookPayloadShape;
};


export type QueryApiKeyAdminExportCsvArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryApiKeyAdminGetArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryApiKeyAdminListArgs = {
  input: ApiKeyAdminListInput;
};


export type QueryApiKeyAdminPreviewMappingArgs = {
  input: ApiKeyAdminPreviewMappingInput;
};


export type QueryApiKeyAdminSearchOrganizationsArgs = {
  input: ApiKeyAdminOrgSearchInput;
};


export type QueryApiKeyAdminStatusMappingsArgs = {
  apiKeyUuid: Scalars['String']['input'];
};


export type QueryApiKeyAdminWebhookShapeConfigArgs = {
  apiKeyUuid: Scalars['String']['input'];
  shape: WebhookPayloadShape;
};


export type QueryApiLogArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryApiLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter>>;
  emailTransactionStatus?: InputMaybe<EmailTransactionStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freightSnapFailureReason?: InputMaybe<FreightSnapFailureReason>;
  freightSnapTransactionStatus?: InputMaybe<FreightSnapTransactionStatus>;
  invoiceFailed?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isFreightSnap?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoiceEmails?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAppointmentConfirmationInfoArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAppointmentOptionsArgs = {
  input: AppointmentOptionsInput;
};


export type QueryAppointmentStatusHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stopUuid: Scalars['String']['input'];
};


export type QueryAppointmentsArgs = {
  deliveryDate: Scalars['DateTime']['input'];
};


export type QueryAuditQuickbooksDesktopInvoiceTotalsArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryAuditReportArgs = {
  args: AuditReportArgs;
};


export type QueryAuditShipmentOnInvoiceButOtherShipmentsNotArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryAutoApplyAccessorialConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAvailablePiecesForLinkingArgs = {
  findAvailablePiecesInput: FindAvailablePiecesInput;
};


export type QueryAvailableSchedulingSlotsForOrderArgs = {
  input: FindAvailableSchedulingSlotsInput;
};


export type QueryBillOfLadingPdfUrlArgs = {
  orderUuid: Scalars['ID']['input'];
};


export type QueryBookedStopsByResourceArgs = {
  input: FindBookedStopsByResourceInput;
};


export type QueryBulkDelegationBatchArgs = {
  batchUuid: Scalars['String']['input'];
};


export type QueryBusinessKpiInvoicedOrdersArgs = {
  args: KpiRecordTableArgs;
};


export type QueryBusinessKpiOrdersArgs = {
  args: KpiRecordTableArgs;
};


export type QueryBusinessKpiOrdersPerDriverArgs = {
  args: KpiRecordTableArgs;
};


export type QueryBusinessKpiPaidInvoicesArgs = {
  args: KpiRecordTableArgs;
};


export type QueryBusinessKpisArgs = {
  args: KpiReportArgs;
};


export type QueryCalmCommitDatesByOrderUuidsArgs = {
  input: OrderUuidsInput;
};


export type QueryCalmCrossdockInstructionsArgs = {
  terminalUuid: Scalars['String']['input'];
};


export type QueryCalmLineHaulOrdersToPlanArgs = {
  input: CalmPlanOrdersInput;
};


export type QueryCalmLiveRunsArgs = {
  date: Scalars['String']['input'];
};


export type QueryCalmManifestLoadPackagesArgs = {
  input: ManifestUuidsInput;
};


export type QueryCalmManifestPlacementsArgs = {
  input: ManifestUuidsInput;
};


export type QueryCalmManifestReadinessArgs = {
  input: ManifestUuidsInput;
};


export type QueryCalmManifestReschedulablesArgs = {
  manifestUuid: Scalars['String']['input'];
};


export type QueryCalmManifestSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryCalmOrderCubeByOrderUuidsArgs = {
  input: OrderUuidsInput;
};


export type QueryCalmOrderLineHaulRouteArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryCalmOrderPackagesArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryCalmOrderPackagesByOrderUuidsArgs = {
  input: OrderUuidsInput;
};


export type QueryCalmOrderPiecesArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryCalmOrderSplitSummaryArgs = {
  input: OrderSplitSummaryInput;
};


export type QueryCalmOrderTagsArgs = {
  input: OrderUuidsInput;
};


export type QueryCalmOrdersByHawbArgs = {
  input: OrdersByHawbInput;
};


export type QueryCalmPndRouteLoadArgs = {
  routeUuid: Scalars['String']['input'];
};


export type QueryCalmPreviewLineHaulReroutesArgs = {
  input: PreviewLineHaulReroutesInput;
};


export type QueryCalmRunInboundPlanArgs = {
  input: ManifestUuidsInput;
};


export type QueryCalmRunOnwardPlanArgs = {
  input: ManifestUuidsInput;
};


export type QueryCalmTerminalOnHandArgs = {
  terminalUuid: Scalars['String']['input'];
};


export type QueryCalmTerminalPndArgs = {
  date: Scalars['String']['input'];
  terminalUuid: Scalars['String']['input'];
};


export type QueryChargeBreakdownReportCsvArgs = {
  chargeBreakdownReportInput?: InputMaybe<ChargeBreakdownReportPdfInput>;
  input?: InputMaybe<ChargeBreakdownReportInput>;
};


export type QueryChargeBreakdownReportPdfArgs = {
  chargeBreakdownReportPdfInput?: InputMaybe<ChargeBreakdownReportPdfInput>;
  input?: InputMaybe<ChargeBreakdownReportInput>;
};


export type QueryCheckConsistencyOfInvoicesArgs = {
  checkConsistencyOfInvoicesInput: CheckConsistencyOfInvoicesInput;
};


export type QueryCheckRegisterReportArgs = {
  args: FindPaymentsV2Args;
};


export type QueryClientQuotesArgs = {
  findClientQuotesInput: FindClientQuotesInput;
};


export type QueryClosestWarehouseToAddressArgs = {
  addressLatitude: Scalars['Float']['input'];
  addressLongitude: Scalars['Float']['input'];
};


export type QueryCompanyByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCompanyConfigurationByCompanyUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCompanyConfigurationChangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyContactsArgs = {
  companyUuid: Scalars['String']['input'];
  excludeNonActiveContacts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanyDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  date: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  statusFilter: FindCompanyDocumentStatusFilter;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanySchedulingBlockedDaysArgs = {
  input?: InputMaybe<FindCompanySchedulingBlockedDaysInput>;
};


export type QueryCompletedStopsNotOnRoutesArgs = {
  date: Scalars['DateTime']['input'];
};


export type QueryCompletionToPaymentReportArgs = {
  args: CompletionToPaymentPageArgs;
};


export type QueryCompletionToPaymentReportCsvArgs = {
  args: CompletionToPaymentFilterArgs;
};


export type QueryCompletionToPaymentSummaryArgs = {
  args: CompletionToPaymentFilterArgs;
};


export type QueryConfigMigrationCompaniesArgs = {
  env: MigrationEnv;
};


export type QueryConfigMigrationStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryConsigneePortalOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryContactArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryContactChargeMatrixColumnMappingsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactCommunicationConfigsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactEmailsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactItemsArgs = {
  findContactItemsInput: FindContactItemsInput;
};


export type QueryContactOrderStatisticsForDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type QueryContactServicesArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactStationsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  checkHasTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  checkHasTariffs?: InputMaybe<Scalars['Boolean']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByContactName?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberDescending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContactsByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryCoordinatesForAddressArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCostCenterStatementReportArgs = {
  args: CostCenterStatementArgs;
};


export type QueryCostInputMonthArgs = {
  args: CostInputMonthArgs;
};


export type QueryCsvOrderImportTransactionsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryCsvOrderMappingArgs = {
  input: CsvOrderMappingQueryInput;
};


export type QueryCurrentBillingPeriodInvoiceArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryCustomDriverFormArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCustomerAppointmentInvitationArgs = {
  input: CustomerAppointmentTokenInput;
};


export type QueryCustomerPortalOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyFilter?: InputMaybe<Scalars['String']['input']>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  contactFilter?: InputMaybe<Scalars['String']['input']>;
  contactsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  dispatched?: InputMaybe<BooleanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ofdOfp?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  orderStatusBuckets?: InputMaybe<Array<CustomerPortalOrderStatusBucketInput>>;
  plannedDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  thirdPartyUserUuid?: InputMaybe<Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerPortalPiecesArgs = {
  customerPortalPiecesInput: CustomerPortalPiecesInput;
};


export type QueryCustomerPortalQuotesArgs = {
  findCustomerPortalQuotesInput: FindCustomerPortalQuotesInput;
};


export type QueryCustomerProfitabilityReportArgs = {
  args: CustomerProfitabilityArgs;
};


export type QueryCustomerReportArgs = {
  args: CustomerReportArgs;
};


export type QueryDelegatedOrdersInboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DelegatedOrdersInboxFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDelegatedOrdersOutboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DelegatedOrdersOutboxFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDelegationAccessorialProposalsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryDelegationEndCustomerMatchArgs = {
  input: DelegationEndCustomerMatchInput;
};


export type QueryDeliveryFailureKpiArgs = {
  args: KpiReportArgs;
};


export type QueryDeliveryFailureStopsArgs = {
  args: KpiRecordTableArgs;
};


export type QueryDigitallySignableDocumentsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryDispatchAppointmentSummaryArgs = {
  deliveryDateFilter?: InputMaybe<DateFilterStartEnd>;
  oncomingWindow?: InputMaybe<DateFilterStartEnd>;
};


export type QueryDispatchAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  contactChannel?: InputMaybe<DispatchAppointmentContactChannel>;
  deliveryDateFilter?: InputMaybe<DateFilterStartEnd>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  oncomingWindow?: InputMaybe<DateFilterStartEnd>;
  preset?: InputMaybe<DispatchAppointmentPreset>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DispatchAppointmentSortField>;
  sortDirection?: InputMaybe<SortDirection>;
  statuses?: InputMaybe<Array<DispatchAppointmentStatus>>;
  stopTypes?: InputMaybe<Array<StopType>>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDispatchableDriversArgs = {
  getDispatchableDriversInput: GetDispatchableDriversInput;
};


export type QueryDocExtractionEvalDocumentWordBoxesArgs = {
  documentId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};


export type QueryDocExtractionEvalRunArgs = {
  id: Scalars['String']['input'];
};


export type QueryDocExtractionEvalRunDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  runId: Scalars['String']['input'];
};


export type QueryDocExtractionEvalRunsArgs = {
  evalSetId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocExtractionEvalSetArgs = {
  id: Scalars['String']['input'];
};


export type QueryDocExtractionEvalSetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocScanVolumeByPipelineReportArgs = {
  docScanVolumeByPipelineInput: DocScanVolumeByPipelineInput;
};


export type QueryDockDoorAssignmentsArgs = {
  input: DockDoorAssignmentsInput;
};


export type QueryDockDoorsArgs = {
  terminalUuid: Scalars['String']['input'];
};


export type QueryDockProductivityReportArgs = {
  args: DockProductivityArgs;
};


export type QueryDockReceivedKpiArgs = {
  args: KpiReportArgs;
};


export type QueryDockReceivedKpiReceiptsArgs = {
  args: KpiRecordTableArgs;
};


export type QueryDockRunTimesArgs = {
  input: DockRunTimesInput;
};


export type QueryDockScanReportArgs = {
  dockScanReportInput: DockScanReportInput;
};


export type QueryDocumentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDocumentForSigningArgs = {
  documentForSigningInput: DocumentForSigningInput;
};


export type QueryDocumentationAdminItemArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDocumentationItemArgs = {
  slug: Scalars['String']['input'];
};


export type QueryDocumentationSearchArgs = {
  input: DocumentationSearchInput;
};


export type QueryDocumentsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryDownloadExternalRateQuoteArgs = {
  quoteUuid: Scalars['String']['input'];
};


export type QueryDraftStopTimeZoneArgs = {
  input: DraftStopTimeZoneInput;
};


export type QueryDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDriverCompletedStopsLogArgs = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryDriverComplianceArgs = {
  input: DriverComplianceDriverInput;
};


export type QueryDriverComplianceReportCsvArgs = {
  driverComplianceReportInput: DriverComplianceReportInput;
};


export type QueryDriverComplianceReportPdfArgs = {
  driverComplianceReportInput: DriverComplianceReportInput;
};


export type QueryDriverCredentialTypesArgs = {
  input?: InputMaybe<GetDriverCredentialTypesInput>;
};


export type QueryDriverDailyLogReportCsvArgs = {
  driverDailyLogReportCsvInput: DriverDailyLogReportPdfInput;
};


export type QueryDriverDailyLogReportPdfArgs = {
  driverDailyLogReportPdfInput: DriverDailyLogReportPdfInput;
};


export type QueryDriverOrdersArgs = {
  driverOrdersInput: DriverOrdersInput;
};


export type QueryDriverPayRateChangeEventsArgs = {
  actorUserUuid?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateRangeFilterInput>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scopes?: InputMaybe<Array<DriverPayRateChangeScope>>;
  stopDriverMapUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDriverPhoneNumberAvailabilityArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryDriverPlannerReportArgs = {
  args: DriverPlannerArgs;
};


export type QueryDriverReportArgs = {
  args: DriverReportArgs;
};


export type QueryDriverSettlementBillArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDriverSettlementBillDriftArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDriverSettlementBillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDriverSettlementBillsForDownloadArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDriverSettlementPayBoundsArgs = {
  input: GetDriverSettlementPayBoundsInput;
};


export type QueryDriversArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDunningReportPdfArgs = {
  dunningReportInput: DunningReportInput;
};


export type QueryDuplicateMergeCandidatesArgs = {
  billingPartyContactUuid: Scalars['String']['input'];
  excludeOrderUuid?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber: Scalars['String']['input'];
};


export type QueryEdiAndApiOrdersForReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<EdiAndApiOrdersForReviewSortInput>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEdiPartnershipReferenceMappingsArgs = {
  ediPartnershipUuid: Scalars['String']['input'];
};


export type QueryEdiPartnershipServiceMappingsArgs = {
  ediPartnershipUuid: Scalars['String']['input'];
};


export type QueryEdiTransactionPayloadByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryEdiTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryEdiTransactionsByCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailTransactionsArgs = {
  findEmailTransactionsInput: FindEmailTransactionsInput;
};


export type QueryEndOfDayDocumentProcessingJobsArgs = {
  companyUuid: Scalars['String']['input'];
  dateUploadedFor: Scalars['DateTime']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEquipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryEquipmentLicensesArgs = {
  equipmentUuid: Scalars['String']['input'];
};


export type QueryEquipmentsArgs = {
  includeNotActive?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<EquipmentType>>;
};


export type QueryEtaForCustomerPortalArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryExternalApiTransmissionPayloadByOrderEventUuidArgs = {
  orderEventUuid: Scalars['String']['input'];
};


export type QueryFeatureFlagArgs = {
  featureFlagInput: FeatureFlagInput;
};


export type QueryFeatureFlagCompanyOverridesArgs = {
  getFeatureFlagCompanyOverridesInput: GetFeatureFlagCompanyOverridesInput;
};


export type QueryFeatureFlagUserOverridesArgs = {
  getFeatureFlagUserOverridesInput: GetFeatureFlagUserOverridesInput;
};


export type QueryFeatureFlagsForCompanyGivenUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFindByOrderUuidArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryFindCompanyOrdersInDateRangeArgs = {
  findCompanyOrdersInDateRangeInput: FindCompanyOrdersInDateRangeInput;
};


export type QueryFindMatchingOrphanPiecesForOrderArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryFindOrderByShipperBillOfLadingNumberArgs = {
  findOrderByShipperBillOfLadingNumberInput: FindOrderByShipperBillOfLadingNumberInput;
};


export type QueryFindOrphanPiecesByBarcodeArgs = {
  barcode: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindServicesForCustomerConfigurationArgs = {
  findServicesForCustomerConfigurationInput: FindServicesForCustomerConfigurationInput;
};


export type QueryFindTariffGroupsWithContactAndServiceCombinationArgs = {
  mappingsList: Array<ContactAndServicesCombination>;
};


export type QueryFindTariffZoneByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFindTariffZoneByUuidOrThrowArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFirstScannedOrderResultInReviewArgs = {
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryForwarderBoardArgs = {
  args: ForwarderBoardArgs;
};


export type QueryForwarderScorecardArgs = {
  args: ForwarderScorecardArgs;
};


export type QueryFreightCostArgs = {
  id: Scalars['String']['input'];
};


export type QueryFuelChargeFuelProfileDateRangeArgs = {
  fuelChargeFuelProfileDateRangeInput: FuelChargeFuelProfileDateRangeInput;
};


export type QueryFuelCostArgs = {
  id: Scalars['String']['input'];
};


export type QueryFuelProfileArgs = {
  findFuelProfileInput: FindFuelProfileInput;
};


export type QueryFuelProfileDateRangesArgs = {
  findFuelProfileDateRangesInput: FindFuelProfileDateRangesInput;
};


export type QueryFuelProfilesArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  excludeContactUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FuelProfileType>;
};


export type QueryFuzzySearchItemsBySkuNameArgs = {
  fuzzySearchItemsBySkuNameInput: FuzzySearchItemsBySkuNameInput;
};


export type QueryFuzzySearchOrdersByShippingBillOfLadingNumberArgs = {
  fuzzySearchOrdersByShipperBillOfLadingNumberInput: FuzzySearchOrdersByShipperBillOfLadingNumberInput;
};


export type QueryFuzzySearchStorageOrdersArgs = {
  fuzzySearchStorageOrdersInput: FuzzySearchStorageOrdersInput;
};


export type QueryFuzzySearchStorageUnitsArgs = {
  fuzzySearchStorageUnitsInput: FuzzySearchStorageUnitsInput;
};


export type QueryGenerateCsvOrderPreSignedPutUrlsArgs = {
  generateCsvOrderPresignedPutUrlInputs: Array<GenerateCsvOrderPresignedPutUrlInput>;
};


export type QueryGenerateCsvPresignedPutUrlForMappingPreviewArgs = {
  input: GenerateCsvPresignedPutUrlForMappingPreviewInput;
};


export type QueryGenerateDefaultAppointmentTextsArgs = {
  generateDefaultAppointmentTextsArgs: GenerateDefaultAppointmentTextsArgs;
};


export type QueryGenerateRoutesArgs = {
  generateRoutesInput: GenerateRoutesInput;
};


export type QueryGenerateScannedOrderPreSignedPutUrlsArgs = {
  preSignedUrlRequests: Array<PreSignedUrlRequestInput>;
};


export type QueryGetCityAndStateOptionsFromZipcodeArgs = {
  getCityAndStateOptionsFromZipcodeInput: GetCityAndStateOptionsFromZipcodeInput;
};


export type QueryGetFreightChargeArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetInvoiceCsvsArgs = {
  getInvoiceCsvsInput: GetInvoiceCsvsInput;
};


export type QueryGetJsonSchemaWithOverrideArgs = {
  schemaUuid: Scalars['String']['input'];
};


export type QueryGetLegDriverMapArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetLineHaulProgressArgs = {
  getLineHaulProgressInput: GetLineHaulProgressInput;
};


export type QueryGetOptimizationResultsArgs = {
  routeOptimizationUuid: Scalars['String']['input'];
};


export type QueryGetOrderTableFieldValuesArgs = {
  getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput;
};


export type QueryGetPackageArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetSavedFilterViewsArgs = {
  pageType: Scalars['String']['input'];
};


export type QueryGetSchemaMatchDetailsArgs = {
  getSchemaMatchDetailsInput: GetSchemaMatchDetailsInput;
};


export type QueryGetSftpCredentialsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetStandardOrderFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetStandardShipmentFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetStructuredExtractionSchemaOverrideArgs = {
  schemaUuid: Scalars['String']['input'];
};


export type QueryGetTagArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetXyTransformArgs = {
  getXyTransformInput: GetXyTransformInput;
};


export type QueryGetZipcodeOptionsFromCityAndStateArgs = {
  getZipcodeOptionsFromCityAndStateInput: GetZipcodeOptionsFromCityAndStateInput;
};


export type QueryGlCodeReportPdfArgs = {
  glCodeReportPdfInput: GlCodeReportPdfInput;
};


export type QueryGroupByStopsArgs = {
  groupByStopsInput: GroupByStopsInput;
};


export type QueryGroupOrdersArgs = {
  input: GroupOrdersInput;
};


export type QueryHoldReasonsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInAppNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInboundMessagesForOrderArgs = {
  input: InboundMessagesForOrderInput;
};


export type QueryIncomeAnalysisReportArgs = {
  args: IncomeAnalysisReportArgs;
};


export type QueryIncomeAnalysisReportV2Args = {
  args: IncomeAnalysisReportArgs;
};


export type QueryIncomingOrganizationPeersArgs = {
  input: FindPaginatedOrganizationPeersInput;
};


export type QueryIncomingPeerAccessorialMappingsArgs = {
  peerUuid: Scalars['String']['input'];
};


export type QueryIncomingPeerServiceMappingsArgs = {
  peerUuid: Scalars['String']['input'];
};


export type QueryIngestedOutlookEmailArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryIngestedOutlookEmailAttachmentsArgs = {
  findIngestedOutlookEmailAttachmentsInput: FindIngestedOutlookEmailAttachmentsInput;
};


export type QueryIngestedOutlookEmailsArgs = {
  findIngestedOutlookEmailsInput: FindIngestedOutlookEmailsInput;
};


export type QueryIngestionTestRunArgs = {
  id: Scalars['String']['input'];
};


export type QueryInventoryCountArgs = {
  findInventoryCountInput: FindInventoryCountInput;
};


export type QueryInventoryCountsArgs = {
  findInventoryCountsInput: FindInventoryCountsInput;
};


export type QueryInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryInvoiceBillingSummaryReportV2Args = {
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
};


export type QueryInvoiceBillingSummaryReportV2PdfArgs = {
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
};


export type QueryInvoiceBillingSummaryReportV2PdfUrlArgs = {
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
};


export type QueryInvoiceDocumentsArgs = {
  invoiceUuid: Scalars['String']['input'];
};


export type QueryInvoiceEdiTransactionsArgs = {
  findInvoiceEdiTransactionsInput: FindInvoiceEdiTransactionsInput;
};


export type QueryInvoiceEmailsApiLogsArgs = {
  findInvoiceEmailsApiLogsInput: FindInvoiceEmailsApiLogsInput;
};


export type QueryInvoiceExcelExportDataArgs = {
  invoiceUuids: Array<Scalars['String']['input']>;
};


export type QueryInvoiceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy: InvoiceTableGroupByInput;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  groupPath?: InputMaybe<Array<InvoiceTableGroupPathEntryInput>>;
  hasQuickbooksSyncFailure?: InputMaybe<Scalars['Boolean']['input']>;
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooks?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  quickbooksSyncFailureCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  removeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoiceNoteRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvoiceRegisterReportCsvArgs = {
  invoiceRegisterReportInput: InvoiceRegisterReportInput;
};


export type QueryInvoiceRegisterReportPdfArgs = {
  invoiceRegisterReportInput: InvoiceRegisterReportInput;
};


export type QueryInvoiceSendJobBatchesArgs = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFailures?: InputMaybe<Scalars['Boolean']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<InvoiceSendJobBatchType>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoiceSendJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceSendJobBatchUuid: Scalars['String']['input'];
  invoiceSendJobStatus?: InputMaybe<InvoiceSendJobStatus>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  groupPath?: InputMaybe<Array<InvoiceTableGroupPathEntryInput>>;
  hasQuickbooksSyncFailure?: InputMaybe<Scalars['Boolean']['input']>;
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooks?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  quickbooksSyncFailureCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  removeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoicesByUuidsArgs = {
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  uuids: Array<Scalars['String']['input']>;
};


export type QueryItemArgs = {
  itemUuid: Scalars['String']['input'];
};


export type QueryItemGroupsArgs = {
  findItemGroupsInput: FindItemGroupsInput;
};


export type QueryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryItemsBySkuNameArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};


export type QueryKpiComparisonsArgs = {
  args: KpiReportArgs;
};


export type QueryLaneFromOriginAndDestinationTerminalArgs = {
  findLaneFromOriginAndDestinationTerminalInput: FindLaneFromOriginAndDestinationTerminalInput;
};


export type QueryLegArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLegsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxOneUnassignedPerShipment?: InputMaybe<Scalars['Boolean']['input']>;
  shipHasArrived?: InputMaybe<Scalars['Boolean']['input']>;
  showUnscheduled?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<LegStatus>>;
};


export type QueryLineHaulDriverConflictArgs = {
  input: LineHaulDriverConflictInput;
};


export type QueryLineHaulFuelChargeFuelProfileDateRangeArgs = {
  lineHaulFuelChargeFuelProfileDateRangeInput: LineHaulFuelChargeFuelProfileDateRangeInput;
};


export type QueryLineHaulLaneArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLineHaulManifestArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLineHaulManifestsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryLineHaulManifestsGroupsArgs = {
  input: LineHaulManifestsGroupsInput;
};


export type QueryLineHaulRunConfigsArgs = {
  manifestUuids: Array<Scalars['String']['input']>;
};


export type QueryLineHaulSegmentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLineHaulTrailerAssignmentsArgs = {
  manifestUuids: Array<Scalars['String']['input']>;
};


export type QueryLineHaulUtilizationReportArgs = {
  args: LineHaulUtilizationArgs;
};


export type QueryLinehaulRevenueReportArgs = {
  LineHaulRevenueReportInput: LineHaulRevenueReportInput;
};


export type QueryManualStandardStopTypeForAddressArgs = {
  input: ManualStandardStopTypeForAddressInput;
};


export type QueryMirrorTargetCompaniesArgs = {
  targetUuid: Scalars['String']['input'];
};


export type QueryMobileFeatureFlagArgs = {
  featureFlagInput: FeatureFlagInput;
};


export type QueryMyGroupedStopUuidsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyLineHaulManifestArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryMyRouteArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maximumTake?: InputMaybe<Scalars['Int']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyStopsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyStopsByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryNetSalesSummaryReportArgs = {
  netSalesSummaryReportInput: NetSalesSummaryReportInput;
};


export type QueryNotificationShadowComparisonSummaryArgs = {
  filter?: InputMaybe<NotificationShadowComparisonFilterInput>;
};


export type QueryNotificationShadowComparisonsArgs = {
  filter?: InputMaybe<NotificationShadowComparisonFilterInput>;
};


export type QueryNumberOfOrdersArgs = {
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  customerFilter?: InputMaybe<StringFilter>;
  customerNameFilter?: InputMaybe<StringFilterV2>;
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filterOutOldFlowConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  includeOrdersPartOfV2ConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  itNumberFilter?: InputMaybe<StringFilterV2>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  orderCityFilter?: InputMaybe<StringFilterV2>;
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  versionId?: InputMaybe<Scalars['Float']['input']>;
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};


export type QueryNumberOfScannedOrderResultDuplicatesArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfScannedOrderResultsApprovedArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfScannedOrderResultsFailedArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfScannedOrderResultsInProgressArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfScannedOrderResultsInReviewArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfScannedOrderResultsRejectedArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfStopsArgs = {
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput>>;
  groupFilters?: InputMaybe<GroupByStopsFiltersInput>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  standardStopTypes?: InputMaybe<Array<StandardStopType>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOnTimeKpiArgs = {
  args: OnTimeKpiArgs;
};


export type QueryOnTimeKpiStopsArgs = {
  args: OnTimeKpiStopsArgs;
};


export type QueryOnTimePerformanceReportCsvArgs = {
  onTimePerformanceReportInput: OnTimePerformanceReportInput;
};


export type QueryOnTimePerformanceReportPdfArgs = {
  onTimePerformanceReportInput: OnTimePerformanceReportInput;
};


export type QueryOpenInvoiceReportArgs = {
  openInvoiceReportArgs: OpenInvoiceReportArgs;
};


export type QueryOperationalEfficiencyReportArgs = {
  args: OperationalEfficiencyArgs;
};


export type QueryOperationsPerformanceReportArgs = {
  args: OperationsPerformancePageArgs;
};


export type QueryOperationsPerformanceReportCsvArgs = {
  args: OperationsPerformanceFilterArgs;
};


export type QueryOperationsPerformanceSummaryArgs = {
  args: OperationsPerformanceFilterArgs;
};


export type QueryOptimizationStatusArgs = {
  jobUuid: Scalars['String']['input'];
};


export type QueryOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrderAmountsToPayForHawbArgs = {
  amountInCents: Scalars['Float']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  hawb: Scalars['String']['input'];
};


export type QueryOrderAmountsToPayForInvoiceArgs = {
  amountInCents: Scalars['Float']['input'];
  invoiceUuids: Array<Scalars['String']['input']>;
};


export type QueryOrderAuditLogEntriesArgs = {
  getOrderAuditLogEntriesInput: GetOrderAuditLogEntriesInput;
};


export type QueryOrderCommentsArgs = {
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderEventNotificationSubscriptionsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryOrderEventsArgs = {
  eventType?: InputMaybe<OrderEventType>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pieceReceiptUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderNameArgs = {
  billingPartyContactUuid: Scalars['String']['input'];
};


export type QueryOrderQuoteArgs = {
  orderQuoteUuid: Scalars['String']['input'];
};


export type QueryOrderQuoteForOrderArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryOrderQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFilter?: InputMaybe<DateFilterV2>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  needsActionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  needsAttentionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<OrderQuoteQueueScope>;
  statusFilter?: InputMaybe<OrderQuoteStatusFilter>;
};


export type QueryOrderReportArgs = {
  args: OrderReportArgs;
};


export type QueryOrderReportByReportGroupArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrderRevenueReportArgs = {
  orderRevenueReportInput: OrderRevenueReportInput;
};


export type QueryOrderUuidsInViewArgs = {
  findOrderUuidsInViewInput: FindOrderUuidsInViewInput;
};


export type QueryOrderVolumeByCompanyReportArgs = {
  orderVolumeByCompanyInput: OrderVolumeByCompanyInput;
};


export type QueryOrderVolumeByContactReportArgs = {
  orderVolumeByContactInput: OrderVolumeByContactInput;
};


export type QueryOrderVolumeByDateRangeReportArgs = {
  orderVolumeByDateRangeInput: OrderVolumeByDateRangeInput;
};


export type QueryOrderVolumeBySchemaReportArgs = {
  orderVolumeBySchemaInput: OrderVolumeBySchemaInput;
};


export type QueryOrderVolumeByUserReportArgs = {
  orderVolumeByUserInput: OrderVolumeByUserInput;
};


export type QueryOrdersArgs = {
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  customerFilter?: InputMaybe<StringFilter>;
  customerNameFilter?: InputMaybe<StringFilterV2>;
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filterOutOldFlowConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  includeOrdersPartOfV2ConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  itNumberFilter?: InputMaybe<StringFilterV2>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  orderCityFilter?: InputMaybe<StringFilterV2>;
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  versionId?: InputMaybe<Scalars['Float']['input']>;
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};


export type QueryOrdersByMasterAirwayBillOfLadingNumberArgs = {
  masterAirwayBillOfLadingNumber: Scalars['String']['input'];
};


export type QueryOrdersBySecondaryRefNumberArgs = {
  secondaryRefNumber: Scalars['String']['input'];
};


export type QueryOrdersByShipperBillOfLadingNumberArgs = {
  includeInReviewEdiOrders?: InputMaybe<Scalars['Boolean']['input']>;
  includeInReviewScannedOrdersFromEmail?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateOrders?: InputMaybe<Scalars['Boolean']['input']>;
  shipperBillOfLadingNumber: Scalars['String']['input'];
};


export type QueryOrdersByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryOrdersForPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  currentPaymentUuid?: InputMaybe<Scalars['String']['input']>;
  filterOutZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupOrdersBy?: GroupOrdersForPaymentsBy;
  includeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeTotalCountsByInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<OrdersForPaymentsSort>>;
};


export type QueryOrganizationArgs = {
  input: FindOrganizationInput;
};


export type QueryOrganizationEffectivePackageTypeConfigsArgs = {
  organizationUuid: Scalars['String']['input'];
};


export type QueryOrganizationMessageArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrganizationMessageHistoryArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrganizationMessageReachArgs = {
  audience: OrganizationMessageAudienceInput;
};


export type QueryOrganizationMessageStatsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrganizationMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  view?: InputMaybe<OrganizationMessageView>;
};


export type QueryOrganizationNotesArgs = {
  findOrganizationNotesInput: FindOrganizationNotesInput;
};


export type QueryOrganizationPackageTypeConfigsArgs = {
  organizationUuid: Scalars['String']['input'];
};


export type QueryOrganizationPeersArgs = {
  input: FindPaginatedOrganizationPeersInput;
};


export type QueryOrganizationQuotePolicyArgs = {
  organizationUuid: Scalars['String']['input'];
};


export type QueryOutboundBenchCompanyUsersArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryOutboundBenchDriversArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryOutboundBenchEdiPayloadArgs = {
  ediTransactionUuid: Scalars['String']['input'];
};


export type QueryOutboundBenchOrdersArgs = {
  input: OutboundBenchOrderSearchInput;
};


export type QueryOutboundBenchServiceLevelsArgs = {
  partnershipUuid: Scalars['String']['input'];
};


export type QueryOutlookIntegrationsForInternalArgs = {
  getOutlookIntegrationsForInternalInput: GetOutlookIntegrationsForInternalInput;
};


export type QueryOutstandingInvoicesForCustomerArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryOutstandingOrdersForReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  includeUuids?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isUnfinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  orderCompletionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompletionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids: Array<Scalars['String']['input']>;
};


export type QueryOutstandingShipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayName?: InputMaybe<StringFilter>;
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isUnfinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  orderUuids: Array<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopCompletionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopCompletionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryOverdueInvoicesArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryPackageHasPieceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPackageSpecArgs = {
  id: Scalars['String']['input'];
};


export type QueryPackingPendenciesArgs = {
  input: FindPackingPendenciesInput;
};


export type QueryPackingPieceByBarcodeArgs = {
  input: PackingPieceByBarcodeInput;
};


export type QueryPackingPiecesArgs = {
  input: PackingPiecesInput;
};


export type QueryPaginatedContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  checkHasTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  checkHasTariffs?: InputMaybe<Scalars['Boolean']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByContactName?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberDescending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaginatedOrdersByInvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceUuid: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByShipperBillOfLadingNumberAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindOrdersOnInvoiceSort>>;
};


export type QueryPaginatedOrganizationsArgs = {
  findPaginatedOrganizationsInput: FindPaginatedOrganizationsInput;
};


export type QueryPaginatedRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maximumTake?: InputMaybe<Scalars['Int']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryParseAddressArgs = {
  address: Scalars['String']['input'];
};


export type QueryPaymentApplicationReportArgs = {
  args: FindPaymentsV2Args;
};


export type QueryPaymentByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPaymentCustomerScopeArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryPaymentJournalReportArgs = {
  args: FindPaymentsV2Args;
};


export type QueryPaymentsByInvoiceUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPaymentsV2Args = {
  args: FindPaymentsV2Args;
};


export type QueryPdProductivityReportArgs = {
  args: PdProductivityArgs;
};


export type QueryPdfColumnArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPeerAccessorialSharesArgs = {
  peerUuid: Scalars['String']['input'];
};


export type QueryPeerServiceSharesArgs = {
  peerUuid: Scalars['String']['input'];
};


export type QueryPersonArgs = {
  id: Scalars['String']['input'];
};


export type QueryPersonsArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPicklistsArgs = {
  picklistsInput: PicklistsInput;
};


export type QueryPieceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPieceBackfillRunArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPieceBackfillRunsArgs = {
  input: PieceBackfillRunsInput;
};


export type QueryPieceBackfillSurveyArgs = {
  input: PieceBackfillSurveyInput;
};


export type QueryPieceBucketMetricsArgs = {
  input: PieceBucketMetricsInput;
};


export type QueryPieceReceiptArgs = {
  findPieceReceiptInput: FindPieceReceiptInput;
};


export type QueryPieceReceiptPieceArgs = {
  pieceReceiptUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};


export type QueryPieceReceiptsArgs = {
  findPieceReceiptsInput: FindPieceReceiptsInput;
};


export type QueryPieceScanKpiArgs = {
  args: KpiReportArgs;
};


export type QueryPieceScanKpiPiecesArgs = {
  args: KpiRecordTableArgs;
};


export type QueryPiecesArgs = {
  findPiecesInput: FindPiecesInput;
};


export type QueryPiecesByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryPiecesGroupedByStatusArgs = {
  piecesGroupedByStatusInput: PiecesGroupedByStatusInput;
};


export type QueryPlaceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPlanOutboundBenchRunArgs = {
  input: PlanOutboundBenchRunInput;
};


export type QueryPlanQuickbooksSyncArgs = {
  options?: InputMaybe<QuickbooksSyncOptionsInput>;
  uuids: Array<Scalars['String']['input']>;
};


export type QueryPointToPointLanesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  tariffGroupUuid: Scalars['String']['input'];
};


export type QueryPrefillInspectionArgs = {
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  senderAddress?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewAddOrdersToInvoicesArgs = {
  previewAddOrdersToInvoicesInput: PreviewAddOrdersToInvoicesInput;
};


export type QueryPreviewBatchAddShipmentsToInvoicesArgs = {
  batchAddShipmentsToInvoicesInput: BatchAddShipmentsToInvoicesInput;
};


export type QueryPreviewBatchAddShipmentsToInvoicesMultipleArgs = {
  batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple;
};


export type QueryPreviewInventoryCountScopeArgs = {
  previewInventoryCountScopeInput: PreviewInventoryCountScopeInput;
};


export type QueryPreviewParseCsvOrdersArgs = {
  input: PreviewParseCsvOrdersInput;
};


export type QueryPreviewProratedConsolidationArgs = {
  previewProratedConsolidationInput: PreviewProratedConsolidationInput;
};


export type QueryPreviewProratedConsolidationV2Args = {
  previewProratedConsolidationV2Input: PreviewProratedConsolidationV2Input;
};


export type QueryQuoteArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryQuoteContributionRatioArgs = {
  input: QuoteContributionRatioInput;
  rateOrderInput: RateOrderInput;
};


export type QueryQuoteConversationArgs = {
  orderQuoteUuid: Scalars['String']['input'];
};


export type QueryQuoteNameArgs = {
  billingPartyContactUuid: Scalars['String']['input'];
};


export type QueryQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  quoteStatus?: InputMaybe<QuoteStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRateAutoAppliedAccessorialsArgs = {
  rateAutoAppliedAccessorialsInput: RateAutoAppliedAccessorialsInput;
};


export type QueryRateOrderByUuidArgs = {
  persist: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
  withholdExpiredTariffFallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRateOrderContentsArgs = {
  rateOrderInput: RateOrderInput;
  withholdExpiredTariffFallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryReceiptItemStorageUnitsArgs = {
  itemUuid: Scalars['String']['input'];
  receiptUuid: Scalars['String']['input'];
};


export type QueryRecurringLineHaulManifestTemplateArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRecurringOrderFrequencyArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRecurringOrderTemplatesArgs = {
  runUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecurringTemplateTrucksArgs = {
  recurringTemplateUuid: Scalars['String']['input'];
};


export type QueryReferenceNumberFormatConfigsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryRemainingAmountOfInvoicesArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryReportSendJobBatchesArgs = {
  findReportSendJobBatchesInput: FindReportSendJobBatchesInput;
};


export type QueryReportSendJobsArgs = {
  findReportSendJobsInput: FindReportSendJobsInput;
};


export type QueryReportsEmailSenderIsVerifiedArgs = {
  userUuid: Scalars['String']['input'];
};


export type QueryResolveProvenanceNeighborArgs = {
  neighborUuid: Scalars['String']['input'];
  scannedOrderUuid: Scalars['String']['input'];
};


export type QueryRoleArgs = {
  findRoleInput: FindRoleInput;
};


export type QueryRolesArgs = {
  findRolesInput?: InputMaybe<FindRolesInput>;
};


export type QueryRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRouteNameArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maximumTake?: InputMaybe<Scalars['Int']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoutesSamsaraVehicleLocationsArgs = {
  routeUuids: Array<Scalars['String']['input']>;
};


export type QuerySageBusinessWorksInvoiceExportCsvArgs = {
  invoiceUuids: Array<Scalars['String']['input']>;
};


export type QuerySalesVarianceReportCsvArgs = {
  salesVarianceReportInput: SalesVarianceReportInput;
};


export type QuerySamsaraDiscoveryExportArgs = {
  input: SamsaraDiscoveryExportInput;
};


export type QuerySamsaraDiscoveryMonthlyOverviewArgs = {
  input: SamsaraDiscoveryMonthlyOverviewInput;
};


export type QuerySamsaraDiscoveryRowsArgs = {
  input: SamsaraDiscoveryRowsInput;
};


export type QuerySamsaraDriversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySamsaraVehicleStatsFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  samsaraVehicleIds: Array<Scalars['String']['input']>;
};


export type QuerySamsaraVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScannedOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderProvenanceArgs = {
  scannedOrderUuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultByOrderUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultForAdminArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  failureReasonFilter?: InputMaybe<ScannedOrderFailureReason>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  rejectedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  signedPodMatchStatuses?: InputMaybe<Array<SignedPodMatchStatus>>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  status?: InputMaybe<ScannedOrderResultStatus>;
  statuses?: InputMaybe<Array<ScannedOrderResultStatus>>;
  type: ScannedOrderResultType;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScannedOrderResultsForAdminArgs = {
  args: GetScannedOrderResultsForAdminArgs;
};


export type QueryScannedOrdersArgs = {
  findScannedOrdersInput: FindScannedOrdersInput;
};


export type QueryScannedOrdersByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryScanningV2__OrderInfoArgs = {
  input: FreightScanningV2OrderInfoInput;
};


export type QueryScanningV2__PieceInfoArgs = {
  input: FreightScanningV2PieceInfoInput;
};


export type QueryScanningV2__ScanJobStatusesArgs = {
  input: FreightScanningV2ScanJobStatusesInput;
};


export type QuerySchedulingRegionArgs = {
  id: Scalars['String']['input'];
};


export type QuerySchedulingResourceArgs = {
  id: Scalars['String']['input'];
};


export type QuerySchedulingResourcesArgs = {
  input?: InputMaybe<FindSchedulingResourcesInput>;
};


export type QuerySchedulingResourcesByRouteNameArgs = {
  input: FindSchedulingResourcesByRouteNameInput;
};


export type QuerySchemaCompanyMappingsArgs = {
  schemaUuid: Scalars['String']['input'];
};


export type QuerySchemaDocumentsBySchemaCompanyMappingArgs = {
  schemaCompanyMappingId: Scalars['String']['input'];
};


export type QuerySchemaFilePutUrlArgs = {
  schemaFilePutUrlInput: SchemaFilePutUrlInput;
};


export type QuerySchemaRunArgs = {
  uuid: Scalars['String']['input'];
};


export type QuerySchemaRunTestListArgs = {
  schemaRunTestListInput: SchemaRunTestListInput;
};


export type QuerySchemaTestFilePutUrlArgs = {
  schemaTestFilePutUrlInput: SchemaTestFilePutUrlInput;
};


export type QuerySearchSchemasArgs = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySegmentedLineHaulOrdersArgs = {
  findSegmentedLineHaulOrdersInput: FindSegmentedLineHaulOrdersInput;
};


export type QuerySegmentedLineHaulOrdersV2Args = {
  findSegmentedLineHaulOrdersInputV2: FindSegmentedLineHaulOrdersInputV2;
};


export type QuerySelectSpecialAccessorialArgs = {
  selectSpecialAccessorialInput: SelectSpecialAccessorialInput;
};


export type QueryServiceGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceLevelReportArgs = {
  args: ServiceLevelReportArgs;
};


export type QueryServiceRegionArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceRegionsArgs = {
  input: GetServiceRegionsInput;
};


export type QueryServicesForOrderArgs = {
  findServicesForOrderInput: FindServicesForOrderInput;
};


export type QueryServicesForThirdPartyUserArgs = {
  findServicesForThirdPartyUserInput: FindServicesForThirdPartyUserInput;
};


export type QuerySettlementBillChangeFlagsArgs = {
  uuid: Scalars['String']['input'];
};


export type QuerySettlementBillLineItemArgs = {
  id: Scalars['String']['input'];
};


export type QuerySettlementBillLineItemsArgs = {
  findSettlementBillLineItemInput: FindSettlementBillLineItemsInput;
};


export type QuerySftpUploadsArgs = {
  findSftpUploadsInput: FindSftpUploadsInput;
};


export type QueryShipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryShipmentV2Args = {
  uuid: Scalars['String']['input'];
};


export type QueryShipmentsArgs = {
  getShipmentsInput?: InputMaybe<GetShipmentsInput>;
};


export type QueryShipmentsByContactUuidArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  endCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  startCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryShipmentsByPhoneOrReferenceNumberArgs = {
  companyUuid: Scalars['String']['input'];
  searchText: Scalars['String']['input'];
};


export type QuerySmsConsentAdminListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SmsConsentAdminFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStandardOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryStandardOrderForReviewArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryStationReportArgs = {
  args: StationReportArgs;
};


export type QueryStopArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryStopDriverMapsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chargesFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  completedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  completionStatus?: InputMaybe<StopCompletionStatus>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverSettlementFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  excludeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceStatuses?: InputMaybe<Array<InvoiceStatus>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onDriverSettlementBill?: InputMaybe<Scalars['Boolean']['input']>;
  onInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  settlementEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortByCompletedDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  stopTypes?: InputMaybe<Array<StopType>>;
};


export type QueryStopUuidsInGroupArgs = {
  addressType?: InputMaybe<StandardStopType>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  cacheStartIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<StopTableGroupByInput>;
  groupFilters?: InputMaybe<GroupByStopsFiltersInput>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeRecurringRunHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<StopSort>;
  sorts?: InputMaybe<Array<StopSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStopsArgs = {
  addressType?: InputMaybe<StandardStopType>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  cacheStartIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<StopTableGroupByInput>;
  groupFilters?: InputMaybe<GroupByStopsFiltersInput>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeRecurringRunHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<StopSort>;
  sorts?: InputMaybe<Array<StopSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStopsBySearchTextArgs = {
  searchText: Scalars['String']['input'];
};


export type QueryStopsOnRoutesBySearchTextArgs = {
  searchText: Scalars['String']['input'];
};


export type QueryStorageOrderArgs = {
  findStorageOrderInput: FindStorageOrderInput;
};


export type QueryStorageOrderStorageUnitsArgs = {
  findStorageOrderStorageUnitsInput: FindStorageOrderStorageUnitsInput;
};


export type QueryStorageOrdersArgs = {
  findStorageOrdersInput: FindStorageOrdersInput;
};


export type QueryStorageUnitArgs = {
  findStorageUnitInput: FindStorageUnitInput;
};


export type QueryStorageUnitByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryStorageUnitsArgs = {
  findStorageUnitsInput: FindStorageUnitsInput;
};


export type QueryStructuredExtractionRunByScannedOrderArgs = {
  scannedOrderUuid: Scalars['String']['input'];
};


export type QueryTariffArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTariffChainsArgs = {
  findTariffChainsInput: FindTariffChainsInput;
};


export type QueryTariffGroupArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTariffGroupsArgs = {
  excludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTariffGroupsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  excludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  tariffGroupType?: InputMaybe<TariffGroupType>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTariffZoneGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryTariffZoneGroupsArgs = {
  findTariffZoneGroupsInput: FindTariffZoneGroupsInput;
};


export type QueryTariffZonesArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  defaultToGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  excludeLineHaulTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  excludeMileBasedTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  tariffZoneType?: InputMaybe<TariffZoneType>;
};


export type QueryTariffsByContactArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryTemplateAddressesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenediConnectionArgs = {
  input: TenediConnectionInput;
};


export type QueryTenediConnectionCustomersArgs = {
  input: TenediConnectionCustomersInput;
};


export type QueryTerminalArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTerminalEfficiencyReportArgs = {
  args: TerminalEfficiencyArgs;
};


export type QueryTerminalForAddressArgs = {
  findTerminalForAddressInput: FindTerminalForAddressInput;
};


export type QueryTerminalReportArgs = {
  args: TerminalReportArgs;
};


export type QueryTerminalTimeZoneChangePreviewArgs = {
  input: TerminalTimeZoneChangePreviewInput;
};


export type QueryTerminalsArgs = {
  getTerminalsInput?: InputMaybe<GetTerminalsInput>;
};


export type QueryTerminalsForAddressArgs = {
  findTerminalForAddressInput: FindTerminalForAddressInput;
};


export type QueryTerminalsForInternalArgs = {
  getTerminalsInternalInput: GetTerminalsInternalInput;
};


export type QueryTerminalsForThirdPartyUserArgs = {
  findTerminalsForThirdPartyUserInput: FindTerminalsForThirdPartyUserInput;
};


export type QueryTestJsonSchemaOnDocumentsForSchemaArgs = {
  testJsonSchemaOnDocumentsForSchemaInput: TestJsonSchemaOnDocumentsForSchemaInput;
};


export type QueryTestOrderArgs = {
  findTestOrderInput: FindTestOrderInput;
};


export type QueryThirdPartyUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryThirdPartyUserByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryThirdPartyUsersByContactArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryUnappliedPaymentReportCsvArgs = {
  unappliedPaymentReportCsvInput: UnappliedPaymentReportCsvInput;
};


export type QueryUnifiedSearchArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchInvoicesArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchOrdersArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchQuotesArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchUnacceptedEdiAndApiOrdersArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchUnacceptedEmailOrdersArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUserContactNotificationSubscriptionArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryUserOptionsArgs = {
  getUsersInput?: InputMaybe<GetUsersInput>;
};


export type QueryUserSessionsAdminCompanyUsersArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryUserSessionsAdminSearchCompaniesArgs = {
  input: UserSessionsAdminCompanySearchInput;
};


export type QueryUsersArgs = {
  getUsersInput?: InputMaybe<GetUsersInput>;
};


export type QueryUsersEditingOrderArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryValidateBulkEditOrdersArgs = {
  bulkEditOrdersInput: BulkEditOrdersInput;
};


export type QueryVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryVerifySchemaDocumentMatchesForCompanyArgs = {
  companyUuid: Scalars['String']['input'];
  schemaDocumentUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWarehouseArgs = {
  warehouseUuid: Scalars['String']['input'];
};


export type QueryWarehouseAddressOfFirstRouteSlotArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryWarehouseLocationsArgs = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWarehousesArgs = {
  warehousesInput?: InputMaybe<WarehousesInput>;
};


export type QueryWeightBreakReportArgs = {
  args: WeightBreakArgs;
};


export type QueryWhiteLabelCompanyArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryWmsContactsArgs = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkOrderCountArgs = {
  input: WorkOrderListInput;
};


export type QueryWorkOrdersArgs = {
  input: WorkOrderListInput;
};

export type QueryErrorOutput = {
  __typename?: 'QueryErrorOutput';
  message: Scalars['String']['output'];
};

export type QueueAppointmentSchedulingProposalsInput = {
  enableCall: Scalars['Boolean']['input'];
  enableText: Scalars['Boolean']['input'];
  stopUuids: Array<Scalars['String']['input']>;
};

export type QueueAppointmentSchedulingProposalsOutput = MutationErrorOutput | QueueAppointmentSchedulingProposalsSuccessOutput;

export type QueueAppointmentSchedulingProposalsSuccessOutput = {
  __typename?: 'QueueAppointmentSchedulingProposalsSuccessOutput';
  /** User-facing messages for errors encountered processing stops */
  errorMessages: Array<Scalars['String']['output']>;
  /** The UUIDs of the stops for which proposals were enqueued */
  stopUuids: Array<Scalars['String']['output']>;
};

export type QueueAppointmentTextsArgs = {
  appointmentUuids: Array<Scalars['String']['input']>;
};

export type QueueAppointmentTextsOutput = {
  __typename?: 'QueueAppointmentTextsOutput';
  /** Stops where a message was attempted but Twilio did not accept it */
  failedCount: Scalars['Int']['output'];
  /** Stops whose text was accepted by Twilio and recorded as sent */
  sentCount: Scalars['Int']['output'];
  /** Stops passed over because the contact number cannot receive a text: a landline (per Twilio Lookup), a toll-free number, a number outside the 50 US states and Canada, or a number whose texts have repeatedly failed to deliver. The field keeps its original name for compatibility. Twilio was not asked to send these. */
  skippedLandlineCount: Scalars['Int']['output'];
  /** Stops passed over because they have no order or no appointment date or time to compose a message from. No message was attempted for these. */
  skippedMissingDetailsCount: Scalars['Int']['output'];
  /** Stops passed over because they have no contact person, or a contact person with no phone number. No message was attempted for these. */
  skippedNoContactCount: Scalars['Int']['output'];
  /** Stops whose text the notification delivery guard held back on purpose, as it does outside production. Twilio was not called for these. */
  suppressedCount: Scalars['Int']['output'];
};

export type QuickbooksAccountEntity = {
  __typename?: 'QuickbooksAccountEntity';
  accountType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum QuickbooksAuthStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export type QuickbooksClassEntity = {
  __typename?: 'QuickbooksClassEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksCustomerEntity = {
  __typename?: 'QuickbooksCustomerEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quickbooksBillToId?: Maybe<Scalars['String']['output']>;
  quickbooksRemitToId?: Maybe<Scalars['String']['output']>;
};

export type QuickbooksDesktopInvoiceEntity = {
  __typename?: 'QuickbooksDesktopInvoiceEntity';
  amount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksDesktopObjectEntity = {
  __typename?: 'QuickbooksDesktopObjectEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksDesktopResultEntity = {
  __typename?: 'QuickbooksDesktopResultEntity';
  error?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopObjects?: Maybe<Array<QuickbooksDesktopObjectEntity>>;
};

export type QuickbooksHeaderFileMappingCreateInput = {
  cellNumber: Scalars['Float']['input'];
  headerType: HeaderFileMappingType;
  name: Scalars['String']['input'];
};

export type QuickbooksHeaderFileMappingEntity = {
  __typename?: 'QuickbooksHeaderFileMappingEntity';
  cellNumber: Scalars['Float']['output'];
  headerType: HeaderFileMappingType;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type QuickbooksHeaderFileMappingUpdateInput = {
  cellNumber?: InputMaybe<Scalars['Float']['input']>;
  headerType?: InputMaybe<HeaderFileMappingType>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type QuickbooksItemEntity = {
  __typename?: 'QuickbooksItemEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksOauthTokenEntity = {
  __typename?: 'QuickbooksOauthTokenEntity';
  authStatus: QuickbooksAuthStatus;
  expiresAt: Scalars['DateTime']['output'];
  lastAuthError?: Maybe<Scalars['DateTime']['output']>;
  refreshTokenExpiresAt: Scalars['DateTime']['output'];
  tokenType: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type QuickbooksSyncInvoicePlan = {
  __typename?: 'QuickbooksSyncInvoicePlan';
  billToContactName: Scalars['String']['output'];
  billToContactUuid: Scalars['String']['output'];
  failures: Array<SyncInvoiceToQuickbooksFailure>;
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  notices: Array<SyncInvoiceToQuickbooksNotice>;
  plannedCreates: Array<QuickbooksSyncPlannedCreate>;
  status: QuickbooksSyncPlanStatus;
  warnings: Array<SyncInvoiceToQuickbooksFailure>;
};

export type QuickbooksSyncOptionsInput = {
  allowAutoCreate?: Scalars['Boolean']['input'];
  allowRelink?: Scalars['Boolean']['input'];
};

export type QuickbooksSyncPlan = {
  __typename?: 'QuickbooksSyncPlan';
  blocked: Array<QuickbooksSyncInvoicePlan>;
  clean: Array<QuickbooksSyncInvoicePlan>;
  connection: QuickbooksSyncPlanConnection;
  needsReview: Array<QuickbooksSyncInvoicePlan>;
  notFoundUuids: Array<Scalars['String']['output']>;
  plannedCreates: Array<QuickbooksSyncPlannedCreate>;
  plannedInvoiceCount: Scalars['Int']['output'];
};

export type QuickbooksSyncPlanConnection = {
  __typename?: 'QuickbooksSyncPlanConnection';
  automatedSalesTaxEnabled: Scalars['Boolean']['output'];
  bookCloseDate?: Maybe<Scalars['String']['output']>;
  connected: Scalars['Boolean']['output'];
  element: QboSyncElement;
  quickbooksCompanyName?: Maybe<Scalars['String']['output']>;
  realmId?: Maybe<Scalars['String']['output']>;
};

export enum QuickbooksSyncPlanStatus {
  Blocked = 'BLOCKED',
  Clean = 'CLEAN',
  NeedsReview = 'NEEDS_REVIEW'
}

export type QuickbooksSyncPlannedCreate = {
  __typename?: 'QuickbooksSyncPlannedCreate';
  kind: QuickbooksSyncPlannedCreateKind;
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  tenetRecordName?: Maybe<Scalars['String']['output']>;
  tenetRecordUuid?: Maybe<Scalars['String']['output']>;
  tenetUrl?: Maybe<Scalars['String']['output']>;
};

export enum QuickbooksSyncPlannedCreateKind {
  Customer = 'CUSTOMER',
  Item = 'ITEM'
}

export type QuickbooksTaxCodeEntity = {
  __typename?: 'QuickbooksTaxCodeEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuoteAcceptanceHeldOutput = {
  __typename?: 'QuoteAcceptanceHeldOutput';
  /** The draft charge-row sum; null when the draft is not completely priced */
  currentAmountCents?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  orderQuoteUuid: Scalars['String']['output'];
  quotedAmountCents?: Maybe<Scalars['Int']['output']>;
  reason: QuoteAcceptanceHoldReason;
};

/** Why a quote acceptance was held instead of creating the order */
export enum QuoteAcceptanceHoldReason {
  Expired = 'EXPIRED',
  NotPriced = 'NOT_PRICED',
  PriceMismatch = 'PRICE_MISMATCH',
  SupersededVersion = 'SUPERSEDED_VERSION'
}

export type QuoteAgentConnection = {
  __typename?: 'QuoteAgentConnection';
  address: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  kind: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type QuoteAgentConnectionsResult = {
  __typename?: 'QuoteAgentConnectionsResult';
  /** False when the quote agent is off for the company, unconfigured or unreachable; connections is then empty. */
  available: Scalars['Boolean']['output'];
  connections: Array<QuoteAgentConnection>;
};

export type QuoteAgentInboundRejection = {
  __typename?: 'QuoteAgentInboundRejection';
  fromAddress?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  receiptUuid: Scalars['String']['output'];
  rejectedAt: Scalars['DateTime']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type QuoteAgentInboundRejectionsResult = {
  __typename?: 'QuoteAgentInboundRejectionsResult';
  /** False when the quote agent is off for the company, unconfigured or unreachable; rejections is then empty. */
  available: Scalars['Boolean']['output'];
  rejections: Array<QuoteAgentInboundRejection>;
};

/** ALREADY_QUEUED: an offboarding job for the company is still waiting, delayed or running, so no second one was added. */
export enum QuoteAgentOffboardingRequestStatus {
  AlreadyQueued = 'ALREADY_QUEUED',
  Queued = 'QUEUED'
}

export enum QuoteAgentPolicyMode {
  AutoSend = 'AUTO_SEND',
  AutoSendBelow = 'AUTO_SEND_BELOW',
  ReviewAll = 'REVIEW_ALL'
}

/** Why a quote prepared by the quote agent needs an operator */
export enum QuoteAttentionReason {
  AmountAboveAutoSendMax = 'AMOUNT_ABOVE_AUTO_SEND_MAX',
  AmountCheckFailed = 'AMOUNT_CHECK_FAILED',
  ConfidenceBelowMin = 'CONFIDENCE_BELOW_MIN',
  CustomerAccepted = 'CUSTOMER_ACCEPTED',
  CustomerChanged = 'CUSTOMER_CHANGED',
  CustomerDeclined = 'CUSTOMER_DECLINED',
  CustomerQuestion = 'CUSTOMER_QUESTION',
  CustomerReplyUnclear = 'CUSTOMER_REPLY_UNCLEAR',
  EarlierReplySendUncertain = 'EARLIER_REPLY_SEND_UNCERTAIN',
  ExtractionModelRefused = 'EXTRACTION_MODEL_REFUSED',
  ExtractionPipelineFailed = 'EXTRACTION_PIPELINE_FAILED',
  ExtractionSkippedBudget = 'EXTRACTION_SKIPPED_BUDGET',
  ExtractionSkippedRateLimited = 'EXTRACTION_SKIPPED_RATE_LIMITED',
  Hazmat = 'HAZMAT',
  IncompleteRequest = 'INCOMPLETE_REQUEST',
  ModelBudgetExceeded = 'MODEL_BUDGET_EXCEEDED',
  NeedsOperator = 'NEEDS_OPERATOR',
  NewRequestInThread = 'NEW_REQUEST_IN_THREAD',
  NoCustomer = 'NO_CUSTOMER',
  PolicyReviewAll = 'POLICY_REVIEW_ALL',
  PrecisionBelowMin = 'PRECISION_BELOW_MIN',
  PrecisionUnknown = 'PRECISION_UNKNOWN',
  PriceMismatch = 'PRICE_MISMATCH',
  ReplyNotFromCustomer = 'REPLY_NOT_FROM_CUSTOMER',
  ReplyRejected = 'REPLY_REJECTED',
  ReplySendFailed = 'REPLY_SEND_FAILED',
  ReplySendUncertain = 'REPLY_SEND_UNCERTAIN',
  ReplyToExpiredQuote = 'REPLY_TO_EXPIRED_QUOTE',
  ReplyToSupersededVersion = 'REPLY_TO_SUPERSEDED_VERSION',
  ReplyVersionInferred = 'REPLY_VERSION_INFERRED',
  SenderDailyCap = 'SENDER_DAILY_CAP',
  SenderRecoveredFromForward = 'SENDER_RECOVERED_FROM_FORWARD',
  Unpriced = 'UNPRICED'
}

export type QuoteConnection = {
  __typename?: 'QuoteConnection';
  edges: Array<QuoteEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum QuoteContributionBenchmarkLeg {
  Inbound = 'INBOUND',
  LineHaul = 'LINE_HAUL',
  OrderCharges = 'ORDER_CHARGES',
  Outbound = 'OUTBOUND'
}

export type QuoteContributionBenchmarkLegEntity = {
  __typename?: 'QuoteContributionBenchmarkLegEntity';
  hasTariff: Scalars['Boolean']['output'];
  leg: QuoteContributionBenchmarkLeg;
  tariffGroupName?: Maybe<Scalars['String']['output']>;
  totalUsd: Scalars['Float']['output'];
};

export type QuoteContributionRatioEntity = {
  __typename?: 'QuoteContributionRatioEntity';
  actualWeightLb: Scalars['Float']['output'];
  benchmarkLegs: Array<QuoteContributionBenchmarkLegEntity>;
  benchmarkUsd?: Maybe<Scalars['Float']['output']>;
  contributionUsd?: Maybe<Scalars['Float']['output']>;
  driverSettlementUsd?: Maybe<Scalars['Float']['output']>;
  marginalFromRatio: Scalars['Float']['output'];
  profitableFromRatio: Scalars['Float']['output'];
  ratio?: Maybe<Scalars['Float']['output']>;
  revenueUsd: Scalars['Float']['output'];
  status: QuoteContributionStatus;
  storedDriverSettlementUsdCents?: Maybe<Scalars['Int']['output']>;
};

export type QuoteContributionRatioInput = {
  driverSettlementUsdCents?: InputMaybe<Scalars['Int']['input']>;
  quoteUuid?: InputMaybe<Scalars['String']['input']>;
  revenueUsdCents: Scalars['Int']['input'];
};

/** Where a quote's contribution ratio falls against the company's two cutoffs, or why it has none: no tariff prices the quote, or the driver pay has not been entered. */
export enum QuoteContributionStatus {
  DriverPayRequired = 'DRIVER_PAY_REQUIRED',
  Loss = 'LOSS',
  Marginal = 'MARGINAL',
  NotProfitable = 'NOT_PROFITABLE',
  Profitable = 'PROFITABLE',
  Unavailable = 'UNAVAILABLE'
}

export type QuoteConversationAttachmentEntity = {
  __typename?: 'QuoteConversationAttachmentEntity';
  contentType?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type QuoteConversationEntity = {
  __typename?: 'QuoteConversationEntity';
  createdAt: Scalars['DateTime']['output'];
  lastInboundAt?: Maybe<Scalars['DateTime']['output']>;
  lastOutboundAt?: Maybe<Scalars['DateTime']['output']>;
  messageCount: Scalars['Int']['output'];
  messages: Array<QuoteConversationMessageEntity>;
  messagesTruncated: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type QuoteConversationMessageEntity = {
  __typename?: 'QuoteConversationMessageEntity';
  attachments: Array<QuoteConversationAttachmentEntity>;
  bodyState: Scalars['String']['output'];
  bodyText?: Maybe<Scalars['String']['output']>;
  bodyTruncated: Scalars['Boolean']['output'];
  cc: Array<Scalars['String']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  from: QuoteConversationPartyEntity;
  originalSender?: Maybe<QuoteConversationPartyEntity>;
  receivedAt: Scalars['DateTime']['output'];
  senderRecoveredFromForward: Scalars['Boolean']['output'];
  subject: Scalars['String']['output'];
  to: Array<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type QuoteConversationPartyEntity = {
  __typename?: 'QuoteConversationPartyEntity';
  address: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type QuoteCreateInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid: Scalars['String']['input'];
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  dimFactor?: InputMaybe<Scalars['Float']['input']>;
  driverSettlementUsdCents?: InputMaybe<Scalars['Int']['input']>;
  enableLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulOriginTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  number: Scalars['String']['input'];
  packageCreateInputs: Array<PackageCreateInput>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentCreateInputs: Array<ShipmentCreateInput>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
};

/** Whether a drafted reply answers the request or asks a question */
export enum QuoteDraftReplyKind {
  Clarification = 'CLARIFICATION',
  Reply = 'REPLY'
}

export type QuoteEdge = {
  __typename?: 'QuoteEdge';
  cursor: Scalars['String']['output'];
  node: QuoteEntity;
};

export type QuoteEntity = {
  __typename?: 'QuoteEntity';
  billingPartyContact: ContactEntity;
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  deletedAutoAppliedAccessorials: Array<AccessorialUnion>;
  dimFactor?: Maybe<Scalars['Float']['output']>;
  enableLineHaul: Scalars['Boolean']['output'];
  freightNeedsRate: Scalars['Boolean']['output'];
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  lineHaulOriginTerminal?: Maybe<TerminalEntity>;
  measurementUnits?: Maybe<MeasurementUnits>;
  number: Scalars['String']['output'];
  order?: Maybe<OrderEntity>;
  packages: Array<PackageEntity>;
  service?: Maybe<ServiceEntity>;
  shipments: Array<ShipmentEntity>;
  source: QuoteSource;
  status: QuoteStatus;
  totalCharge: Scalars['Currency']['output'];
  totalSkids?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  weightUnits?: Maybe<WeightUnits>;
};

/** Why an operator action on a drafted quote reply was refused */
export enum QuoteReplyRefusalReason {
  AlreadyApproved = 'ALREADY_APPROVED',
  NotReviewable = 'NOT_REVIEWABLE',
  PriceChanged = 'PRICE_CHANGED',
  RecipientNotConfirmed = 'RECIPIENT_NOT_CONFIRMED',
  ReplySendPending = 'REPLY_SEND_PENDING',
  SendNotUncertain = 'SEND_NOT_UNCERTAIN',
  SendUncertainUnresolved = 'SEND_UNCERTAIN_UNRESOLVED',
  StaleDraft = 'STALE_DRAFT'
}

export type QuoteReplyRefusedOutput = {
  __typename?: 'QuoteReplyRefusedOutput';
  /** The draft charge-row sum; null when the draft is not completely priced */
  currentAmountCents?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  orderQuoteUuid: Scalars['String']['output'];
  quotedAmountCents?: Maybe<Scalars['Int']['output']>;
  reason: QuoteReplyRefusalReason;
};

/** What the operator decided about a reply whose send the agent could not confirm */
export enum QuoteReplySendOutcome {
  Discard = 'DISCARD',
  MarkSent = 'MARK_SENT',
  Resend = 'RESEND'
}

/** The source of a quote */
export enum QuoteSource {
  Api = 'API',
  CustomerPortal = 'CUSTOMER_PORTAL',
  ManuallyCreated = 'MANUALLY_CREATED'
}

/** A filter object that is used to filter the quote source enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type QuoteSourceFilter = {
  /** Filters for records where the relevant quote source field is equal to the provided quote source value */
  eq?: InputMaybe<QuoteSource>;
  /** Filters for records where the relevant quote source field is in the provided quote source values */
  in?: InputMaybe<Array<QuoteSource>>;
  /** Filters for records where the relevant quote source field is not equal to the provided quote source value */
  neq?: InputMaybe<QuoteSource>;
  /** Filters for records where the relevant quote source field is not in the provided quote source values */
  nin?: InputMaybe<Array<QuoteSource>>;
};

/** The status of a quote */
export enum QuoteStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  PendingContactApproval = 'PENDING_CONTACT_APPROVAL',
  Rejected = 'REJECTED'
}

/** A filter object that is used to filter the quote status enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type QuoteStatusFilter = {
  /** Filters for records where the relevant quote status field is equal to the provided quote status value */
  eq?: InputMaybe<QuoteStatus>;
  /** Filters for records where the relevant quote status field is in the provided quote status values */
  in?: InputMaybe<Array<QuoteStatus>>;
  /** Filters for records where the relevant quote status field is not equal to the provided quote status value */
  neq?: InputMaybe<QuoteStatus>;
  /** Filters for records where the relevant quote status field is not in the provided quote status values */
  nin?: InputMaybe<Array<QuoteStatus>>;
};

export type QuoteUpdateInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  dimFactor?: InputMaybe<Scalars['Float']['input']>;
  driverSettlementUsdCents?: InputMaybe<Scalars['Int']['input']>;
  enableLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulOriginTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  number?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentArrayUpdateInputs?: InputMaybe<Array<ShipmentArrayUpdateInput>>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
};

/** Custom charge for the rate auto applied accessorials query */
export type RateAutoAppliedAccessorialsCustomChargeInput = {
  /** This is required - filter out custom charges that arent based on an accessorial */
  accessorialUuid: Scalars['String']['input'];
  isAutoApplied: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type RateAutoAppliedAccessorialsCustomChargeToAddOutput = {
  __typename?: 'RateAutoAppliedAccessorialsCustomChargeToAddOutput';
  accessorialUuid: Scalars['String']['output'];
  chargeGroupUuid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rate: Scalars['Currency']['output'];
  zoneUuid?: Maybe<Scalars['String']['output']>;
};

export type RateAutoAppliedAccessorialsInput = {
  contactUuid: Scalars['String']['input'];
  inboundShipment?: InputMaybe<RateAutoAppliedAccessorialsShipmentInput>;
  isHazmat: Scalars['Boolean']['input'];
  isInBond: Scalars['Boolean']['input'];
  orderChargesShipment?: InputMaybe<RateAutoAppliedAccessorialsOrderChargesShipmentInput>;
  outboundShipment?: InputMaybe<RateAutoAppliedAccessorialsShipmentInput>;
  serviceUuid: Scalars['String']['input'];
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The order charges shipment for the rate auto applied accessorials query */
export type RateAutoAppliedAccessorialsOrderChargesShipmentInput = {
  customCharges: Array<RateAutoAppliedAccessorialsCustomChargeInput>;
};

export type RateAutoAppliedAccessorialsOutput = {
  __typename?: 'RateAutoAppliedAccessorialsOutput';
  /** The set of auto applied accessorials to add to / remove from the inbound shipment */
  inboundShipment?: Maybe<RateAutoAppliedAccessorialsShipmentOutput>;
  /** The set of auto applied accessorials to add to / remove from the inbound shipment */
  orderChargesShipment?: Maybe<RateAutoAppliedAccessorialsShipmentOutput>;
  /** The set of auto applied accessorials to add to / remove from the inbound shipment */
  outboundShipment?: Maybe<RateAutoAppliedAccessorialsShipmentOutput>;
};

/** Inbound or outbound shipment input for the rate auto applied accessorials query */
export type RateAutoAppliedAccessorialsShipmentInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  customCharges: Array<RateAutoAppliedAccessorialsCustomChargeInput>;
  standardStopType: StandardStopType;
  stopType: StopType;
  terminalUuid: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type RateAutoAppliedAccessorialsShipmentOutput = {
  __typename?: 'RateAutoAppliedAccessorialsShipmentOutput';
  /** The set of accessorials to auto-apply */
  customChargesToAdd: Array<RateAutoAppliedAccessorialsCustomChargeToAddOutput>;
  /** The set of custom charges to remove. These represent auto-applied accessorials that should no longer be auto-applied */
  customChargesToRemove: Array<Scalars['String']['output']>;
};

export type RateCustomChargeOutput = {
  __typename?: 'RateCustomChargeOutput';
  errorMessage?: Maybe<Scalars['Float']['output']>;
  existingCustomChargeUuid?: Maybe<Scalars['String']['output']>;
  fuelSurchargePercentageRate?: Maybe<Scalars['Float']['output']>;
  rateDollars?: Maybe<Scalars['Currency']['output']>;
  settlementFlatRate?: Maybe<Scalars['Currency']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  totalDollars?: Maybe<Scalars['Currency']['output']>;
  warning?: Maybe<CustomChargeRatingWarning>;
};

export type RateCustomCostOutput = {
  __typename?: 'RateCustomCostOutput';
  errorMessage?: Maybe<Scalars['Float']['output']>;
  existingCustomCostId?: Maybe<Scalars['String']['output']>;
  fuelSurchargePercentageRate?: Maybe<Scalars['Float']['output']>;
  rateDollars?: Maybe<Scalars['Currency']['output']>;
  totalDollars?: Maybe<Scalars['Currency']['output']>;
};

export type RateDependentFreightCostSuccessOutput = {
  __typename?: 'RateDependentFreightCostSuccessOutput';
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateDependentFuelCostSuccessOutput = {
  __typename?: 'RateDependentFuelCostSuccessOutput';
  /** The flat rate for the fuel cost. Null if the dependent billing method is not FLAT_RATE */
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  /** The percentage rate for the fuel cost. Null if the dependent billing method is not PERCENTAGE or AUTO-CALCULATE */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateDependentSettlementBillLineItemSuccessOutput = {
  __typename?: 'RateDependentSettlementBillLineItemSuccessOutput';
  customCostTotal: Scalars['Currency']['output'];
  customCosts: Array<RateCustomCostOutput>;
  freightCost?: Maybe<RateDependentFreightCostSuccessOutput>;
  fuelCost?: Maybe<RateDependentFuelCostSuccessOutput>;
  success: Scalars['Boolean']['output'];
  total: Scalars['Currency']['output'];
};

export type RateFreightChargeSuccessOutput = {
  __typename?: 'RateFreightChargeSuccessOutput';
  discountRate?: Maybe<Scalars['Percent']['output']>;
  /** Which expired tariff an EXPIRED_TARIFF_AVAILABLE warning is about, so the user knows what to renew. Null for every other warning and whenever tariffWarning is null. */
  expiredTariffGroup?: Maybe<ExpiredTariffGroupEntity>;
  miles?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  /** The rate of the freight charge. $ / lb, $ / mi, or total $ in the flat rate case */
  rateDollars: Scalars['Currency']['output'];
  settlementFlatRate?: Maybe<Scalars['Currency']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  tariffUuid?: Maybe<Scalars['String']['output']>;
  /** Why tariff rating produced a $0 freight charge, when the cause is actionable: no tariff was selected (EXPIRED_TARIFF_AVAILABLE) or a per-mile tariff had no distance to bill on (MILES_UNAVAILABLE). Null otherwise, including when nothing was configured at all. */
  tariffWarning?: Maybe<FreightRatingWarning>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateFuelChargeSuccessOutput = {
  __typename?: 'RateFuelChargeSuccessOutput';
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  fuelProfileName?: Maybe<Scalars['String']['output']>;
  settlementFlatRate?: Maybe<Scalars['Currency']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  /** The surcharge rate for the fuel charge. Null if the fuel charge billing method is not PERCENTAGE (or isn't set to auto-calculate. */
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  surchargeRatePercentage?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
  /** Warning surfaced when fuel profile selection fell back to current date or found no profile at all. */
  warning?: Maybe<FuelRatingWarning>;
  /** Which tariff fuel profile a NO_VALID_FUEL_PROFILE warning is about. Null for every other warning, and when the rated tariff has no fuel profile. */
  warningDetails?: Maybe<FuelRatingWarningDetailsEntity>;
};

export type RateIndependentFreightCostSuccessOutput = {
  __typename?: 'RateIndependentFreightCostSuccessOutput';
  /** Percentage out of 100 */
  discountRate?: Maybe<Scalars['Percent']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  /** The rate of the freight charge. $ / lb, $ / mi, or total $ in the flat rate case */
  rateDollars: Scalars['Currency']['output'];
  tariffUuid?: Maybe<Scalars['String']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateIndependentFuelCostSuccessOutput = {
  __typename?: 'RateIndependentFuelCostSuccessOutput';
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  /** The surcharge rate for the fuel cost. Null if the fuel cost billing method is not PERCENTAGE (or isn't set to auto-calculate. */
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  surchargeRatePercentage?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
  /** Warning surfaced when fuel profile selection fell back to current date or found no profile at all. */
  warning?: Maybe<FuelRatingWarning>;
  /** Which tariff fuel profile a NO_VALID_FUEL_PROFILE warning is about. Null for every other warning, and when the rated tariff has no fuel profile. */
  warningDetails?: Maybe<FuelRatingWarningDetailsEntity>;
};

export type RateIndependentSettlementBillLineItemSuccessOutput = {
  __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput';
  customCostTotal: Scalars['Currency']['output'];
  customCosts: Array<RateCustomCostOutput>;
  freightCost?: Maybe<RateIndependentFreightCostSuccessOutput>;
  fuelCost?: Maybe<RateIndependentFuelCostSuccessOutput>;
  success: Scalars['Boolean']['output'];
  /** The total amount of the line item in USD */
  total: Scalars['Currency']['output'];
};

export type RateOrderAddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type RateOrderChargesInput = {
  customCharges: Array<RateOrderCustomChargeInput>;
  freightCharge?: InputMaybe<RateOrderFreightChargeInput>;
  fuelCharge?: InputMaybe<RateOrderFuelChargeInput>;
};

export type RateOrderCustomChargeInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  existingCustomChargeUuid?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  rateUsdDecimalCents?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialChargeGroupUuid?: InputMaybe<Scalars['String']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  useAccessorialRate: Scalars['Boolean']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderDependentCustomCostInput = {
  customCharge: RateOrderCustomChargeInput;
  dependentSettlementBillingMethod: DependentSettlementBillingMethod;
  existingCustomCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  percentageRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RateOrderDependentFreightCostInput = {
  dependentSettlementBillingMethod: DependentSettlementBillingMethod;
  existingFreightCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  freightCharge: RateOrderFreightChargeInput;
  percentageRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RateOrderDependentFuelCostInput = {
  dependentSettlementBillingMethod: DependentSettlementBillingMethod;
  existingCustomCostId?: InputMaybe<Scalars['String']['input']>;
  existingFuelCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  fuelCharge: RateOrderFuelChargeInput;
  percentageRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RateOrderDependentSettlementBillLineItemInput = {
  /** @deprecated No longer used. Agent settlement is implemented via drivers. */
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  customCosts: Array<RateOrderDependentCustomCostInput>;
  driverUuid: Scalars['String']['input'];
  /** The id of the settlement bill line item that is being rated. Set the id to null if the order is currently being created */
  existingId?: InputMaybe<Scalars['String']['input']>;
  freightCost?: InputMaybe<RateOrderDependentFreightCostInput>;
  fuelCost?: InputMaybe<RateOrderDependentFuelCostInput>;
  settlementBillFinalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  settlementMode: SettlementMode;
};

export type RateOrderErrorOutput = {
  __typename?: 'RateOrderErrorOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RateOrderFreightChargeInput = {
  billingMethod: FreightBillingMethod;
  existingFreightChargeUuid?: InputMaybe<Scalars['String']['input']>;
  quantityInHundreds?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use `rateUsdDecimalCents` instead. */
  rateUsdCents?: InputMaybe<Scalars['Int']['input']>;
  /** Represents the freight charge rate in cents. Currently only implemented on the API layer and not stored in the database. */
  rateUsdDecimalCents?: InputMaybe<Scalars['Decimal']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderFuelChargeInput = {
  existingFuelChargeUuid?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  /** The percentage rate from [0,1] of the fuel charge. Will be zero if fuel billing method is FLAT_RATE */
  surchargeRate: Scalars['Float']['input'];
  type: FuelBillingMethod;
};

export type RateOrderIndependentCustomCostInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  existingCustomCostId?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  quantity: Scalars['Float']['input'];
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  specialAccessorialChargeGroupUuid?: InputMaybe<Scalars['String']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  useAccessorialRate: Scalars['Boolean']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderIndependentFreightCostInput = {
  billingMethod?: InputMaybe<FreightBillingMethod>;
  existingFreightCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderIndependentFuelCostInput = {
  billingMethod: FuelBillingMethod;
  existingFuelCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  /** The percentage rate from [0,1] of the fuel cost */
  surchargeRate: Scalars['Decimal']['input'];
};

export type RateOrderIndependentSettlementBillLineItemInput = {
  /** @deprecated No longer used. Agent settlement is implemented via drivers. */
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  customCosts: Array<RateOrderIndependentCustomCostInput>;
  driverUuid: Scalars['String']['input'];
  /** The id of the settlement bill line item that is being rated. Set the id to null if the order is currently being created */
  existingId?: InputMaybe<Scalars['String']['input']>;
  freightCost?: InputMaybe<RateOrderIndependentFreightCostInput>;
  fuelCost?: InputMaybe<RateOrderIndependentFuelCostInput>;
  settlementBillFinalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  settlementMode: SettlementMode;
};

export type RateOrderInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  detailedStatus: OrderDetailedStatus;
  dimFactor: Scalars['Float']['input'];
  existingOrderUuid?: InputMaybe<Scalars['String']['input']>;
  inboundShipment?: InputMaybe<RateOrderRegularShipmentAndChargesInput>;
  lineHaul?: InputMaybe<RateOrderLineHaulShipmentAndChargesInput>;
  orderCharges?: InputMaybe<RateOrderOrderChargesShipmentAndChargesInput>;
  outboundShipment?: InputMaybe<RateOrderRegularShipmentAndChargesInput>;
  packages: Array<RateOrderPackageInput>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountCents?: InputMaybe<Scalars['Float']['input']>;
  totalSkids?: InputMaybe<Scalars['Float']['input']>;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderLineHaulShipmentAndChargesInput = {
  charges: RateOrderChargesInput;
  /** Currently nullable so older clients don't break */
  dependentSettlementBillLineItems?: InputMaybe<Array<RateOrderDependentSettlementBillLineItemInput>>;
  /** Currently nullable so older clients don't break */
  independentSettlementBillLineItems?: InputMaybe<Array<RateOrderIndependentSettlementBillLineItemInput>>;
  shipmentDetails: RateOrderLineHaulShipmentInput;
};

export type RateOrderLineHaulShipmentInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the shipment that is being rated. Set the UUID to null if the order is currently being created */
  existingShipmentUuid?: InputMaybe<Scalars['String']['input']>;
  laneUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated service date, as an ISO 8601 formatted date string. If not provided, this field will not be updated. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  shipmentType: ShipmentType;
};

export type RateOrderOrderChargesShipmentAndChargesInput = {
  charges: RateOrderChargesInput;
  /** Currently nullable so older clients don't break */
  dependentSettlementBillLineItems?: InputMaybe<Array<RateOrderDependentSettlementBillLineItemInput>>;
  /** Currently nullable so older clients don't break */
  independentSettlementBillLineItems?: InputMaybe<Array<RateOrderIndependentSettlementBillLineItemInput>>;
  shipmentDetails: RateOrderOrderChargesShipmentInput;
};

export type RateOrderOrderChargesShipmentInput = {
  /** The UUID of the shipment that is being rated. Set the UUID to null if the order is currently being created */
  existingShipmentUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentType: ShipmentType;
};

export type RateOrderOutput = RateOrderErrorOutput | RateOrderSuccessOutput;

export type RateOrderPackageInput = {
  freightClass?: InputMaybe<FreightClass>;
  /** height in inches */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** length in inches */
  length?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** weight in pounds */
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** width in inches */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type RateOrderRegularShipmentAndChargesInput = {
  charges: RateOrderChargesInput;
  /** Currently nullable so older clients don't break */
  dependentSettlementBillLineItems?: InputMaybe<Array<RateOrderDependentSettlementBillLineItemInput>>;
  /** Currently nullable so older clients don't break */
  independentSettlementBillLineItems?: InputMaybe<Array<RateOrderIndependentSettlementBillLineItemInput>>;
  shipmentDetails: RateOrderRegularShipmentInput;
};

export type RateOrderRegularShipmentInput = {
  /** The UUID of the shipment that is being rated. Set the UUID to null if the order is currently being created */
  existingShipmentUuid?: InputMaybe<Scalars['String']['input']>;
  overridePackageWeight: Scalars['Boolean']['input'];
  shipmentType: ShipmentType;
  stop: RateOrderStopInput;
};

export type RateOrderStopInput = {
  /** The stop's address to use for tariff selection if applicable. Null if the stop address does not exist */
  address?: InputMaybe<RateOrderAddressInput>;
  appointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  miles?: InputMaybe<Scalars['Float']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The stop's service date in ISO 8601 format. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  stopType: StopType;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderSuccessOutput = {
  __typename?: 'RateOrderSuccessOutput';
  inboundShipmentCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  lineHaulCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  orderCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  outboundShipmentCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  success: Scalars['Boolean']['output'];
  totalDollars?: Maybe<Scalars['Currency']['output']>;
};

export type RateShipmentForOrderSuccessOutput = {
  __typename?: 'RateShipmentForOrderSuccessOutput';
  customChargeTotal: Scalars['Currency']['output'];
  customCharges: Array<RateCustomChargeOutput>;
  dependentSettlementBillLineItems: Array<RateDependentSettlementBillLineItemSuccessOutput>;
  externalRating?: Maybe<ExternalRatingResult>;
  freightCharge?: Maybe<RateFreightChargeSuccessOutput>;
  fuelCharge?: Maybe<RateFuelChargeSuccessOutput>;
  independentSettlementBillLineItems: Array<RateIndependentSettlementBillLineItemSuccessOutput>;
  success: Scalars['Boolean']['output'];
  total: Scalars['Currency']['output'];
};

export enum RateType {
  Flat = 'FLAT',
  QuantityBased = 'QUANTITY_BASED'
}

export enum RatingDateSource {
  CompanyToday = 'COMPANY_TODAY',
  ServiceDate = 'SERVICE_DATE'
}

export type ReanalyzePageInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export type ReanalyzeSchemaFileInput = {
  pngFilename: Scalars['String']['input'];
  textractType: TextractType;
};

export type ReconfigureDriverSettlementPayTermsInput = {
  expectedRevision: Scalars['Float']['input'];
  rate: ReconfigureSettlementPayRateInput;
  stopDriverMapUuid: Scalars['String']['input'];
};

export type ReconfigureDriverSettlementPayTermsOutput = {
  __typename?: 'ReconfigureDriverSettlementPayTermsOutput';
  created: Scalars['Boolean']['output'];
  terms: StopDriverMapPayTermsEntity;
};

export type ReconfigureSettlementPayRateInput = {
  flatPayUsdCents?: InputMaybe<Scalars['Float']['input']>;
  percentageOutOf100?: InputMaybe<Scalars['Float']['input']>;
  source: SettlementPayRateSource;
};

export type RecordContactAttemptedArgs = {
  /** Report an attempt the dispatcher made by hand, even though this stop’s automated call was already reported. */
  reportAdditionalAttempt?: Scalars['Boolean']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type RecordInboundReviewDecisionsInput = {
  decisions: Array<InboundReviewDecisionInput>;
  orderUuid: Scalars['String']['input'];
  /** Who sent the inbound message the operator was reviewing. Omitted when the message cannot be identified. */
  senderLabel?: InputMaybe<Scalars['String']['input']>;
};

export type RecordInventoryCountUnexpectedInput = {
  barcode: Scalars['String']['input'];
  /** Client-side ISO-8601 timestamp of when the operator actually scanned the barcode. Used to preserve real scan time across offline replays. Outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  inventoryCountUuid: Scalars['String']['input'];
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RecordInventoryCountUnexpectedOutput = InventoryCountLineEntity | MutationErrorOutput;

export type RecurringLineHaulManifestTemplateEntity = {
  __typename?: 'RecurringLineHaulManifestTemplateEntity';
  autoGenerate: Scalars['Boolean']['output'];
  createAheadDays?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use createAheadDays. This field no longer affects generation. */
  createInAdvanceHours: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  daysOfWeek: Array<DayOfWeekAll>;
  defaultDriverUuid?: Maybe<Scalars['String']['output']>;
  defaultEquipmentUuid?: Maybe<Scalars['String']['output']>;
  departTimeMinutes: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endTerminalUuid: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastProcessedAt?: Maybe<Scalars['DateTime']['output']>;
  manifestsPerOccurrence: Scalars['Int']['output'];
  /** @deprecated No longer affects generation. Off-weeks are expressed as skipDates. */
  repeatFrequencyUnit: RepeatFrequencyUnit;
  /** @deprecated No longer affects generation. Off-weeks are expressed as skipDates. */
  repeatInterval: Scalars['Int']['output'];
  /** Clock the stored departTimeMinutes is in: ORIGIN (the start terminal) or COMPANY. */
  scheduleTimeZoneMode: ScheduleTimeZoneMode;
  skipDates: Array<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
  startTerminalUuid: Scalars['String']['output'];
  transitMinutes: Scalars['Int']['output'];
  truckCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type RecurringOrderFrequencyEntity = {
  __typename?: 'RecurringOrderFrequencyEntity';
  daysOfMonth: Array<Scalars['Int']['output']>;
  daysOfWeek: Array<DayOfWeekAll>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  repeatFrequencyUnit: RepeatFrequencyUnit;
  repeatInterval: Scalars['Int']['output'];
  /** @deprecated Use repeatInterval instead */
  repeatIntervalWeeks?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type RecurringRunHeaderEntity = {
  __typename?: 'RecurringRunHeaderEntity';
  createdAt: Scalars['DateTime']['output'];
  driver?: Maybe<DriverEntity>;
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  recurringOrderTemplates: Array<OrderEntity>;
  tags: Array<TagEntity>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
};

export type RecurringTemplateTruckEntity = {
  __typename?: 'RecurringTemplateTruckEntity';
  cutoffTime?: Maybe<Scalars['String']['output']>;
  daysOfWeek: Array<DayOfWeekAll>;
  label: Scalars['String']['output'];
  powerUnitEquipmentUuid?: Maybe<Scalars['String']['output']>;
  powerUnitName?: Maybe<Scalars['String']['output']>;
  recurringTemplateUuid: Scalars['String']['output'];
  /** Clock the stored cutoffTime is in: ORIGIN (the template start terminal) or COMPANY. */
  scheduleTimeZoneMode: ScheduleTimeZoneMode;
  trailers: Array<RecurringTemplateTruckTrailerEntity>;
  uuid: Scalars['String']['output'];
};

export type RecurringTemplateTruckTrailerEntity = {
  __typename?: 'RecurringTemplateTruckTrailerEntity';
  capacity?: Maybe<Scalars['Float']['output']>;
  equipmentUuid: Scalars['String']['output'];
  floorLengthIn?: Maybe<Scalars['Float']['output']>;
  floorWidthIn?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type RecurringTemplateTruckTrailerInput = {
  trailerEquipmentUuid: Scalars['String']['input'];
};

export type ReferenceNumberFormatCheckEntity = {
  __typename?: 'ReferenceNumberFormatCheckEntity';
  createdAt: Scalars['DateTime']['output'];
  lengthOperand?: Maybe<Scalars['Int']['output']>;
  operator?: Maybe<ReferenceNumberFormatCheckOperator>;
  startsWithOperands: Array<Scalars['String']['output']>;
  type: ReferenceNumberFormatCheckType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ReferenceNumberFormatCheckOperator {
  And = 'AND',
  Or = 'OR'
}

export enum ReferenceNumberFormatCheckType {
  Length = 'LENGTH',
  StartsWith = 'STARTS_WITH'
}

export type ReferenceNumberFormatConfigEntity = {
  __typename?: 'ReferenceNumberFormatConfigEntity';
  checks: Array<ReferenceNumberFormatCheckEntity>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ReferenceNumberLabelEntity = {
  __typename?: 'ReferenceNumberLabelEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RefreshAuthTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type RefreshAuthTokenOutput = {
  __typename?: 'RefreshAuthTokenOutput';
  expiresAt: Scalars['DateTime']['output'];
  jwt: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type RefuseOrderInput = {
  refusedBy: Scalars['String']['input'];
  refusedDate: Scalars['DateTime']['input'];
  /** refusedDate typed as a wall clock in an entry zone (terminal_local_times). Replaces refusedDate when sent. */
  refusedDateLocal?: InputMaybe<LocalDateTimeInput>;
  /** Why the consignee refused it */
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  /** The structured reason the consignee refused it, for outbound EDI. The free-text refusedReason carries the detail. */
  refusedReasonCode?: InputMaybe<OrderRefusalReason>;
  uuid: Scalars['String']['input'];
};

export type RehireDriverInput = {
  driverUuid: Scalars['String']['input'];
  /** YYYY-MM-DD */
  hireDate: Scalars['String']['input'];
};

export type RejectCustomerPortalOrderInput = {
  orderUuid: Scalars['String']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
};

export type RejectCustomerPortalOrderOutput = MutationErrorOutput | RejectCustomerPortalOrderSuccessOutput;

export type RejectCustomerPortalOrderSuccessOutput = {
  __typename?: 'RejectCustomerPortalOrderSuccessOutput';
  orderUuid: Scalars['String']['output'];
  rejectedAt: Scalars['DateTime']['output'];
};

export type RejectDelegationEndCustomerLinkInput = {
  delegationUuid: Scalars['String']['input'];
};

export type RejectEdiOrderInput = {
  uuid: Scalars['String']['input'];
};

export type RejectEdiOrderOutput = {
  __typename?: 'RejectEdiOrderOutput';
  uuid: Scalars['String']['output'];
};

export type RejectEdiOrdersInput = {
  orderUuids: Array<Scalars['String']['input']>;
};

export type RejectEdiOrdersOutput = MutationErrorOutput | RejectEdiOrdersSuccess;

export type RejectEdiOrdersSuccess = {
  __typename?: 'RejectEdiOrdersSuccess';
  successfulOrderUuids: Array<Scalars['String']['output']>;
};

export type RejectQuoteReplyInput = {
  draftReplyUuid: Scalars['String']['input'];
  orderQuoteUuid: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RejectQuoteReplyOutput = MutationErrorOutput | QuoteReplyRefusedOutput | RejectQuoteReplySuccessOutput;

export type RejectQuoteReplySuccessOutput = {
  __typename?: 'RejectQuoteReplySuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
};

export type RemoveApiUserContactMappingInput = {
  apiUserUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
};

export type RemoveContactsInput = {
  deleteOrders: Scalars['Boolean']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type RemoveContactsOutput = {
  __typename?: 'RemoveContactsOutput';
  uuids: Array<Scalars['String']['output']>;
};

export type RemoveDriversFromRouteInput = {
  driverUuids: Array<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

export type RemoveLineItemsFromSettlementBillInput = {
  /** The IDs of the settlement bill line items to disconnect from the driver settlement bill. Will validate that these are all on the provided bill. */
  settlementBillLineItemIds: Array<Scalars['String']['input']>;
  /** The UUID of the driver settlement bill to remove line items from */
  settlementBillUuid: Scalars['String']['input'];
};

export type RemoveLineItemsFromSettlementBillOutput = MutationErrorOutput | RemoveLineItemsFromSettlementBillSuccessOutput;

export type RemoveLineItemsFromSettlementBillSuccessOutput = {
  __typename?: 'RemoveLineItemsFromSettlementBillSuccessOutput';
  settlementBillLineItemsCount: Scalars['Float']['output'];
};

export type RemoveOrderHoldInput = {
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type RemoveOrdersFromManifestInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type RemoveOrdersFromManifestV2Input = {
  manifestUuid: Scalars['String']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type RemoveOrdersFromManifestV2Output = MutationErrorOutput | RemoveOrdersFromManifestV2SuccessOutput;

/** The output of removing orders from a line haul manifest successfully */
export type RemoveOrdersFromManifestV2SuccessOutput = {
  __typename?: 'RemoveOrdersFromManifestV2SuccessOutput';
  /** The updated line haul manifest */
  lineHaulManifest: LineHaulManifestEntity;
};

export type RemovePiecesFromPieceReceiptInput = {
  /** UUID of the piece receipt to remove pieces from */
  pieceReceiptUuid: Scalars['String']['input'];
  /** UUIDs of the pieces to detach from the receipt */
  pieceUuids: Array<Scalars['String']['input']>;
};

export type RemovePiecesFromPieceReceiptOutput = {
  __typename?: 'RemovePiecesFromPieceReceiptOutput';
  /** The piece receipt the pieces were removed from */
  pieceReceipt: PieceReceiptEntity;
  /** Number of pieces detached from the receipt */
  removedCount: Scalars['Int']['output'];
};

export type RemoveServiceFromContactInput = {
  contactUuid: Scalars['String']['input'];
  serviceUuid: Scalars['String']['input'];
};

export type RemoveShipmentsFromInvoiceInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type RemoveStopsFromRoutesInputType = {
  uuids: Array<Scalars['String']['input']>;
};

export type RemoveStorageUnitOnHandInput = {
  uuid: Scalars['String']['input'];
};

export type RemoveStorageUnitOnHandOutput = {
  __typename?: 'RemoveStorageUnitOnHandOutput';
  success: Scalars['Boolean']['output'];
};

export type RemoveStorageUnitOsdInput = {
  uuid: Scalars['String']['input'];
};

export type RemoveStorageUnitOsdOutput = {
  __typename?: 'RemoveStorageUnitOsdOutput';
  success: Scalars['Boolean']['output'];
};

export type RemoveSubscriberInput = {
  shipmentUuid: Scalars['String']['input'];
  subscriberUuid: Scalars['String']['input'];
};

export type RemoveTagFromLegInput = {
  legUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type RemoveTagFromOrderInput = {
  orderUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type RemoveThirdPartyUserFromContactInput = {
  contactUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

export type RemoveUserFromRoleInput = {
  userUuid: Scalars['String']['input'];
  /** The UUID of the role to remove the user from */
  uuid: Scalars['String']['input'];
};

export type RemoveUserFromRoleOutput = {
  __typename?: 'RemoveUserFromRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type RenderDeployEntity = {
  __typename?: 'RenderDeployEntity';
  commitHash: Scalars['String']['output'];
  commitMessage: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['Float']['output']>;
};

export type RenderServiceWithDeploysEntity = {
  __typename?: 'RenderServiceWithDeploysEntity';
  branch: Scalars['String']['output'];
  deploys: Array<RenderDeployEntity>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
};

export enum RepeatFrequencyUnit {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ReplayOutboundEdiInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  replay214s?: InputMaybe<Scalars['Boolean']['input']>;
  replay990s?: InputMaybe<Scalars['Boolean']['input']>;
  replayPods?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RepointOrderFreightEntity = {
  __typename?: 'RepointOrderFreightEntity';
  packagesLeftPartiallyShort: Scalars['Int']['output'];
  unitsLeftBehind: Scalars['Int']['output'];
  unitsMarkedShort: Scalars['Int']['output'];
  unitsMoved: Scalars['Int']['output'];
};

export type RepointOrderFreightInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
  reason: RepointReason;
  sourceManifestUuid: Scalars['String']['input'];
  targetManifestUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Why a shipment was moved off a line-haul run. */
export enum RepointReason {
  LoadedInError = 'LOADED_IN_ERROR',
  Misrouted = 'MISROUTED',
  Other = 'OTHER',
  PaperworkOnly = 'PAPERWORK_ONLY',
  RolledToNextRun = 'ROLLED_TO_NEXT_RUN',
  ShortShipped = 'SHORT_SHIPPED'
}

export type ReportADocScanIssueInput = {
  message: Scalars['String']['input'];
  orderStateJsonBlob?: InputMaybe<Scalars['String']['input']>;
  scannedOrderResultUuid: Scalars['String']['input'];
};

export type ReportADocScanIssueOutput = {
  __typename?: 'ReportADocScanIssueOutput';
  success: Scalars['Boolean']['output'];
};

export enum ReportAggregationPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/**
 * The standard output type for a report file (generally PDF or CSV)
 *   which has been generated on the backend and uploaded to S3. This type can be
 *   returned directly from reports or extended to add
 *   additional report-specific fields.
 */
export type ReportFileOutput = {
  __typename?: 'ReportFileOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ReportFilterType {
  ContactUuidFilter = 'CONTACT_UUID_FILTER',
  InvoiceDateFilter = 'INVOICE_DATE_FILTER',
  InvoiceIsClosedFilter = 'INVOICE_IS_CLOSED_FILTER',
  InvoiceSourcesFilter = 'INVOICE_SOURCES_FILTER'
}

/** An input object that represents a superset of all possible filters that can be used for report generation */
export type ReportFiltersInput = {
  /** When present, filters the report by billing party UUID. Otherwise, no filtering of billing party contact occurs. */
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A date range filter that is used for the 'date' field on the invoice */
  invoiceDateFilter?: InputMaybe<DateFilterStartEnd>;
  /** A date range filter that is used for the 'dueDate' field on the invoice */
  invoiceDueDateFilter?: InputMaybe<DateFilterStartEnd>;
  /** A boolean filter that is used for the 'isClosed' field on the invoice */
  invoiceIsClosedFilter?: InputMaybe<BooleanFilter>;
  /** An enum list filter that is used for the 'source' field on the invoice */
  invoiceSourcesFilter?: InputMaybe<Array<InvoiceSource>>;
};

export enum ReportGenerationStatus {
  Available = 'AVAILABLE',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  NotStarted = 'NOT_STARTED',
  Uploading = 'UPLOADING'
}

export type ReportGroupConfigurationCreateInput = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultReportType: ReportType;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderStatuses: Array<OrderStatus>;
  reportAggregationPeriod: ReportAggregationPeriod;
  reportRevenueType: ReportRevenueType;
  reportStatistics: Array<ReportStatistic>;
  /** IANA zone the report reads its days in; honored only while terminal_local_times is on. When null, insight reports count each order on its stop's local service day, and the audit report uses the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ReportGroupConfigurationEntity = {
  __typename?: 'ReportGroupConfigurationEntity';
  businessDivision?: Maybe<BusinessDivisionEntity>;
  contact?: Maybe<ContactEntity>;
  contacts?: Maybe<Array<ContactEntity>>;
  createdAt: Scalars['DateTime']['output'];
  defaultReportType: ReportType;
  driver?: Maybe<DriverEntity>;
  drivers?: Maybe<Array<DriverEntity>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  lastNumberOfDays?: Maybe<Scalars['Int']['output']>;
  lastNumberOfMonths?: Maybe<Scalars['Int']['output']>;
  lastNumberOfWeeks?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  orderStatuses: Array<OrderStatus>;
  reportAggregationPeriod: ReportAggregationPeriod;
  reportRevenueType: ReportRevenueType;
  reportStatistics: Array<ReportStatistic>;
  /** IANA zone the report reads its days in; honored only while terminal_local_times is on. When null, insight reports count each order on its stop's local service day, and the audit report uses the company zone. */
  reportTimeZone?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stopTypes: Array<PickupOrDelivery>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ReportGroupConfigurationUpdateInput = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultReportType?: InputMaybe<ReportType>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  reportAggregationPeriod?: InputMaybe<ReportAggregationPeriod>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics?: InputMaybe<Array<ReportStatistic>>;
  /** IANA zone the report reads its days in; honored only while terminal_local_times is on. When null, insight reports count each order on its stop's local service day, and the audit report uses the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes?: InputMaybe<Array<PickupOrDelivery>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ReportPdfOutput = {
  __typename?: 'ReportPdfOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ReportRevenueType {
  Earned = 'EARNED',
  Projected = 'PROJECTED'
}

export type ReportRules = {
  /** How to route additional charges */
  additionalChargesRouting: Array<AdditionalChargesRoutingRule>;
  /** Fallback for empty customer names */
  emptyCustomerFallback: Scalars['String']['input'];
  /** Default terminal for linehaul charges. Empty = attribute to inbound terminal */
  linehaulDefaultTerminal: Scalars['String']['input'];
  /** Terminal overrides for linehaul */
  linehaulTerminalOverrides: Array<Scalars['String']['input']>;
  /** Swap to posted values when total ≠ sum-of-charges */
  usePostedWhenMismatch: Scalars['Boolean']['input'];
};

export type ReportSendJobBatchConnection = {
  __typename?: 'ReportSendJobBatchConnection';
  edges: Array<ReportSendJobBatchEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReportSendJobBatchEdge = {
  __typename?: 'ReportSendJobBatchEdge';
  cursor: Scalars['String']['output'];
  node: ReportSendJobBatchEntity;
};

export type ReportSendJobBatchEntity = {
  __typename?: 'ReportSendJobBatchEntity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  reportSendJobBatchProgress: ReportSendJobBatchProgressEntity;
  reportSendJobs: Array<ReportSendJobEntity>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReportSendJobBatchProgressEntity = {
  __typename?: 'ReportSendJobBatchProgressEntity';
  failCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ReportSendJobConnection = {
  __typename?: 'ReportSendJobConnection';
  edges: Array<ReportSendJobEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReportSendJobEdge = {
  __typename?: 'ReportSendJobEdge';
  cursor: Scalars['String']['output'];
  node: ReportSendJobEntity;
};

export type ReportSendJobEntity = {
  __typename?: 'ReportSendJobEntity';
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<DocumentEntity>;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  id: Scalars['String']['output'];
  reportSendJobBatch: ReportSendJobBatchEntity;
  reportSendJobBatchId: Scalars['String']['output'];
  reportSendJobError?: Maybe<ReportSendJobError>;
  reportType: AccountingReportTypeV2;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ReportSendJobError {
  DocumentGenerationFailed = 'DOCUMENT_GENERATION_FAILED'
}

export enum ReportSendJobStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export enum ReportStatistic {
  CustomChargeRevenue = 'CUSTOM_CHARGE_REVENUE',
  DeliveryRevenue = 'DELIVERY_REVENUE',
  FreightRevenue = 'FREIGHT_REVENUE',
  FuelRevenue = 'FUEL_REVENUE',
  NumberOfOrders = 'NUMBER_OF_ORDERS',
  NumberOfPackages = 'NUMBER_OF_PACKAGES',
  PickupRevenue = 'PICKUP_REVENUE',
  RecoveryRevenue = 'RECOVERY_REVENUE',
  TotalRevenue = 'TOTAL_REVENUE',
  TotalWeight = 'TOTAL_WEIGHT',
  TransferRevenue = 'TRANSFER_REVENUE'
}

export enum ReportType {
  Customer = 'CUSTOMER',
  Driver = 'DRIVER',
  Order = 'ORDER',
  ServiceLevel = 'SERVICE_LEVEL',
  Station = 'STATION',
  Terminal = 'TERMINAL'
}

export type RequestOrderMirrorSyncInput = {
  companyUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Window start (ISO 8601 datetime). */
  fromDateTime: Scalars['String']['input'];
  /** 'ALL' or 'COMPANIES'. */
  scope: Scalars['String']['input'];
  /** Window end (ISO 8601 datetime). */
  toDateTime: Scalars['String']['input'];
};

export type RequestOrderMirrorSyncOutput = {
  __typename?: 'RequestOrderMirrorSyncOutput';
  requestUuid: Scalars['String']['output'];
};

export type RequestQuoteRepriceInput = {
  orderQuoteUuid: Scalars['String']['input'];
};

export type RequestQuoteRepriceOutput = MutationErrorOutput | RequestQuoteRepriceSuccessOutput;

export type RequestQuoteRepriceSuccessOutput = {
  __typename?: 'RequestQuoteRepriceSuccessOutput';
  /** The quote after its draft was priced again */
  orderQuote: OrderQuote;
};

export type RequoteQuoteAtCurrentPriceInput = {
  orderQuoteUuid: Scalars['String']['input'];
};

export type RequoteQuoteAtCurrentPriceOutput = MutationErrorOutput | QuoteReplyRefusedOutput | RequoteQuoteAtCurrentPriceSuccessOutput;

export type RequoteQuoteAtCurrentPriceSuccessOutput = {
  __typename?: 'RequoteQuoteAtCurrentPriceSuccessOutput';
  /** The new version */
  orderQuoteUuid: Scalars['String']['output'];
  supersededOrderQuoteUuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type RerateOrderFreightOutput = {
  __typename?: 'RerateOrderFreightOutput';
  externalRatings: Array<FreightChargeRerateResult>;
  order: OrderEntity;
};

export type RerateQuoteFreightOutput = {
  __typename?: 'RerateQuoteFreightOutput';
  externalRatings: Array<FreightChargeRerateResult>;
  quote: QuoteEntity;
};

export type ResendExternalTransmissionInput = {
  orderEventUuid: Scalars['String']['input'];
};

export type ResetCompanyInput = {
  companyUuid: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResetCompanyOutput = {
  __typename?: 'ResetCompanyOutput';
  status: Scalars['String']['output'];
};

export type ResolveOrganizationMessageInput = {
  /** Required as "SEND" when a follow-up goes to every company. */
  confirmation?: InputMaybe<Scalars['String']['input']>;
  /** A follow-up message published to the same audience as the resolved one, in the same step. */
  followUp?: InputMaybe<OrganizationMessageContentInput>;
  uuid: Scalars['String']['input'];
};

export type ResolveQuoteReplySendInput = {
  draftReplyUuid: Scalars['String']['input'];
  orderQuoteUuid: Scalars['String']['input'];
  outcome: QuoteReplySendOutcome;
};

export type ResolveQuoteReplySendOutput = MutationErrorOutput | QuoteReplyRefusedOutput | ResolveQuoteReplySendSuccessOutput;

export type ResolveQuoteReplySendSuccessOutput = {
  __typename?: 'ResolveQuoteReplySendSuccessOutput';
  draftReplyUuid: Scalars['String']['output'];
  orderQuoteUuid: Scalars['String']['output'];
  outcome: QuoteReplySendOutcome;
};

export type ResolveScannedOrderBillingPartyInput = {
  contactUuid: Scalars['String']['input'];
  scannedOrderResultUuid: Scalars['String']['input'];
};

/** This is the graphql input for restoring an organization */
export type RestoreOrganizationInput = {
  uuid: Scalars['String']['input'];
};

export type RestoreOrganizationOutput = MutationErrorOutput | RestoreOrganizationSuccessOutput;

export type RestoreOrganizationSuccessOutput = {
  __typename?: 'RestoreOrganizationSuccessOutput';
  /** The restored org */
  organization: OrganizationEntity;
};

export type RestoreSchedulingRegionNameConflictOutput = {
  __typename?: 'RestoreSchedulingRegionNameConflictOutput';
  conflictingSchedulingRegionId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type RestoreSchedulingRegionOutput = MutationErrorOutput | RestoreSchedulingRegionNameConflictOutput | UpdateSchedulingRegionSuccessOutput;

export type RestoreSchedulingZoneNameConflictOutput = {
  __typename?: 'RestoreSchedulingZoneNameConflictOutput';
  conflictingSchedulingZoneId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type RestoreSchedulingZoneOutput = MutationErrorOutput | RestoreSchedulingZoneNameConflictOutput | UpdateSchedulingZoneSuccessOutput;

export type RestoreTariffChainInput = {
  id: Scalars['String']['input'];
};

export type RestoreTariffChainOutput = MutationErrorOutput | RestoreTariffChainSuccessOutput;

export type RestoreTariffChainSuccessOutput = {
  __typename?: 'RestoreTariffChainSuccessOutput';
  /** The tariff chain that was restored */
  tariffChain: TariffChainEntity;
};

export type RetryInvoice210OutboundResult = {
  __typename?: 'RetryInvoice210OutboundResult';
  queuedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type RetrySftpUploadsInput = {
  sftpUploadUuid: Scalars['String']['input'];
};

export type RetrySftpUploadsOutput = {
  __typename?: 'RetrySftpUploadsOutput';
  sftpUpload?: Maybe<SftpUploadEntity>;
};

export type ReuploadPodsInput = {
  contactUuids: Array<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type RevenueReportOrderConnection = {
  __typename?: 'RevenueReportOrderConnection';
  edges: Array<RevenueReportOrderEdge>;
  pageInfo: PageInfo;
};

export type RevenueReportOrderEdge = {
  __typename?: 'RevenueReportOrderEdge';
  cursor: Scalars['String']['output'];
  node: RevenueReportOrderEntity;
};

export type RevenueReportOrderEntity = {
  __typename?: 'RevenueReportOrderEntity';
  contactName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  controllingTerminalCode?: Maybe<Scalars['String']['output']>;
  deliveryRevenue: Scalars['Float']['output'];
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  inboundAddressString?: Maybe<Scalars['String']['output']>;
  inboundStopType?: Maybe<OriginStopType>;
  lineHaulRevenue: Scalars['Float']['output'];
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  outboundAddressString?: Maybe<Scalars['String']['output']>;
  outboundStopType?: Maybe<DestinationStopType>;
  packageQuantity: Scalars['Float']['output'];
  packageWeight: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  podUploaded: Scalars['Boolean']['output'];
  /** Single service date for the order from the order's endStop */
  serviceDates: Array<Scalars['DateTime']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  stopTypes: Array<StopType>;
  totalCharge: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export enum RevenueReportOutputFormat {
  Allocation = 'ALLOCATION',
  Summary = 'SUMMARY'
}

export type ReversalCounterpartOrder = {
  __typename?: 'ReversalCounterpartOrder';
  isReturnOrder: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type RevokeCompanyUserSessionsInput = {
  archiveUsers: Scalars['Boolean']['input'];
  companyUuid: Scalars['String']['input'];
  userUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RevokeCompanyUserSessionsResult = {
  __typename?: 'RevokeCompanyUserSessionsResult';
  archivedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  revokedCount: Scalars['Int']['output'];
  skippedNoEmailCount: Scalars['Int']['output'];
  targetedUsers: Array<UserSessionsAdminUserEntity>;
};

export type RevokeOrganizationPeerInput = {
  peerUuid: Scalars['String']['input'];
};

export type RoleEntity = {
  __typename?: 'RoleEntity';
  isInternalRole: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<PermissionEntity>;
  users: Array<UserEntity>;
  uuid: Scalars['String']['output'];
};

export type RotateDocumentInput = {
  degrees: Scalars['Float']['input'];
  documentName: Scalars['String']['input'];
  textractType: TextractType;
};

export type RotateQuoteAgentForwardingTokenOutput = MutationErrorOutput | RotateQuoteAgentForwardingTokenSuccessOutput;

export type RotateQuoteAgentForwardingTokenSuccessOutput = {
  __typename?: 'RotateQuoteAgentForwardingTokenSuccessOutput';
  connectionUuid: Scalars['String']['output'];
  forwardingAddress: Scalars['String']['output'];
  /** When the replaced address stops receiving mail. */
  previousValidUntil: Scalars['DateTime']['output'];
};

/** Direction filter applied during auto-route eligibility evaluation. BOTH includes pickups and deliveries; PICKUP / DELIVERY restrict by Stop.stopType. */
export enum RouteAutomationDirection {
  Both = 'BOTH',
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

/** Which date field auto-routing uses to decide a stop is "due" on a given planning date. SERVICE_DATE filters by Stop.serviceDateIso8601; DUE_BY filters by Stop.deadlineTime. */
export enum RouteAutomationDueDateSource {
  DueBy = 'DUE_BY',
  ServiceDate = 'SERVICE_DATE'
}

export type RouteAutomationSettingsEntity = {
  __typename?: 'RouteAutomationSettingsEntity';
  /** When true, auto-populate also picks a fitting Equipment per route. Vehicle-fit logic itself ships in TMS-1460 PR5. */
  autoAssignTrucks: Scalars['Boolean']['output'];
  /** Master switch. When false, the v2 toolbar button is hidden and `autoCreateRoutesV2` rejects calls with BadRequestException. */
  autoCreateRoutes: Scalars['Boolean']['output'];
  /** When true, auto-create also fills routes with eligible open stops. Has no effect when autoCreateRoutes is false. */
  autoPopulateRoutes: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  dueDateSource: RouteAutomationDueDateSource;
  excludeTagIds: Array<Scalars['String']['output']>;
  excludeTagUuids: Array<Scalars['String']['output']>;
  includeTagIds: Array<Scalars['String']['output']>;
  includeTagUuids: Array<Scalars['String']['output']>;
  pickupOrDelivery: RouteAutomationDirection;
  serviceIds: Array<Scalars['String']['output']>;
  serviceUuids: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Stable UUID for the settings row (unique per company). */
  uuid: Scalars['String']['output'];
};

export type RouteAutomationSettingsInput = {
  autoAssignTrucks: Scalars['Boolean']['input'];
  autoCreateRoutes: Scalars['Boolean']['input'];
  autoPopulateRoutes: Scalars['Boolean']['input'];
  dueDateSource: RouteAutomationDueDateSource;
  /** Tag uuids a stop must NOT carry. Empty array = no exclude filter. */
  excludeTagUuids: Array<Scalars['String']['input']>;
  /** Tag uuids a stop must carry to qualify. Empty array = no include filter. */
  includeTagUuids: Array<Scalars['String']['input']>;
  pickupOrDelivery: RouteAutomationDirection;
  /** Service uuids that qualify. Empty array = match all services. */
  serviceUuids: Array<Scalars['String']['input']>;
};

export type RouteConnection = {
  __typename?: 'RouteConnection';
  edges: Array<RouteEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  versionId?: Maybe<Scalars['String']['output']>;
};

export type RouteCoordinatesEntity = {
  __typename?: 'RouteCoordinatesEntity';
  /** Direction of travel in degrees clockwise from north. Only vehicle trackers report it. */
  headingDegrees?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  /** The vehicle tracker's place description, e.g. 'San Jose, CA'. */
  placeLabel?: Maybe<Scalars['String']['output']>;
  routeUuid: Scalars['String']['output'];
  /** Speed in miles per hour. Only vehicle trackers report it. */
  speedMph?: Maybe<Scalars['Float']['output']>;
  /** When this position was recorded: the driver app's last update, or the vehicle tracker's GPS time. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RouteCreateInput = {
  date: Scalars['DateTime']['input'];
  defaultStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** defaultStartTime typed as a wall clock in an entry zone (terminal_local_times). Replaces defaultStartTime when sent. */
  defaultStartTimeLocal?: InputMaybe<LocalDateTimeInput>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  loadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  stopUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  unloadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
};

/** An error when the run departs a terminal the order is routed through but arrives somewhere the order is not routed to. */
export type RouteDestinationMismatchError = {
  __typename?: 'RouteDestinationMismatchError';
  manifest: LineHaulManifestEntity;
  order: OrderEntity;
};

export type RouteDriverCreateInput = {
  driverUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};

export type RouteDriverEntity = {
  __typename?: 'RouteDriverEntity';
  uuid: Scalars['String']['output'];
};

export type RouteEdge = {
  __typename?: 'RouteEdge';
  cursor: Scalars['String']['output'];
  node: RouteEntity;
};

export type RouteEntity = {
  __typename?: 'RouteEntity';
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  currentDriverMobilePhoneLocation?: Maybe<RouteCoordinatesEntity>;
  date: Scalars['DateTime']['output'];
  defaultStartTime?: Maybe<Scalars['DateTime']['output']>;
  driver?: Maybe<DriverEntity>;
  /** @deprecated Use driver instead. There can never be more than one driver per route */
  drivers: Array<DriverEntity>;
  endLoadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  equipments: Array<EquipmentEntity>;
  etas: Array<EtaEntity>;
  /** Return stops on this route grouped by address, status and customer. Two stops at one address for different customers are not grouped. Slightly expensive to calculate, use with care */
  groupedStopUuids: Array<Array<Scalars['String']['output']>>;
  helpers: Array<DriverEntity>;
  lastDispatched?: Maybe<Scalars['DateTime']['output']>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameManuallyChanged: Scalars['Boolean']['output'];
  nextRouteSlot?: Maybe<RouteSlotEntity>;
  numberOfRescheduled?: Maybe<Scalars['Float']['output']>;
  productivity?: Maybe<RouteProductivityEntity>;
  routeInfo: RouteInfo;
  routePath?: Maybe<RoutePathEntity>;
  routePathUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  routeSlotsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  slots: Array<RouteSlotEntity>;
  startLoadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  tags: Array<TagEntity>;
  terminal?: Maybe<TerminalEntity>;
  /** IANA zone the route's day and start time are read in: its terminal's zone, or the company zone when the route has no terminal, the terminal has no zone, or terminal local times are off for the company. */
  timeZone: Scalars['String']['output'];
  totalDistanceInMeters?: Maybe<Scalars['Float']['output']>;
  totalTimeInSeconds?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type RouteGenerationPreviewEntity = {
  __typename?: 'RouteGenerationPreviewEntity';
  driver: DriverEntity;
  equipment?: Maybe<EquipmentEntity>;
  stops: Array<StopPreviewForRouteGenerationEntity>;
};

export type RouteInfo = {
  __typename?: 'RouteInfo';
  pieceCount: Scalars['Float']['output'];
  status: RouteStatus;
  totalOrdersRefused: Scalars['Float']['output'];
  totalStops: Scalars['Float']['output'];
  totalStopsArrived: Scalars['Float']['output'];
  totalStopsCancelled: Scalars['Float']['output'];
  totalStopsCompleted: Scalars['Float']['output'];
  totalStopsConfirmedByAgent: Scalars['Float']['output'];
  totalStopsFailed: Scalars['Float']['output'];
  totalStopsNotArrived: Scalars['Float']['output'];
  totalStopsSentToAgent: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
};

export type RouteNameCreateInput = {
  name: Scalars['String']['input'];
  routeNameLocationCreateInputs: Array<RouteNameLocationCreateInput>;
};

export type RouteNameEntity = {
  __typename?: 'RouteNameEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  routeNameLocations: Array<RouteNameLocationEntity>;
  uuid: Scalars['String']['output'];
};

export type RouteNameLocationCreateInput = {
  city: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type RouteNameLocationEntity = {
  __typename?: 'RouteNameLocationEntity';
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type RouteNameLocationUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type RouteOptimizationCreateInput = {
  mapboxId: Scalars['String']['input'];
  pinnedSlotUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

export type RouteOptimizationEntity = {
  __typename?: 'RouteOptimizationEntity';
  createdAt: Scalars['DateTime']['output'];
  excludedStopUuids?: Maybe<Array<Scalars['String']['output']>>;
  mapboxId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type RouteOptimizationSummary = {
  __typename?: 'RouteOptimizationSummary';
  currentDistanceMiles: Scalars['Float']['output'];
  currentDurationSeconds: Scalars['Float']['output'];
  deltaDistanceMiles: Scalars['Float']['output'];
  deltaDurationSeconds: Scalars['Float']['output'];
  proposedDistanceMiles: Scalars['Float']['output'];
  proposedDurationSeconds: Scalars['Float']['output'];
};

export type RouteOptimizationUpdateInput = {
  mapboxId?: InputMaybe<Scalars['String']['input']>;
  pinnedSlotUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RoutePathEntity = {
  __typename?: 'RoutePathEntity';
  coordinates?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  inputCoordinates?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  route: RouteEntity;
  uuid: Scalars['String']['output'];
};

export type RoutePathsCreateInput = {
  routeUuids: Array<Scalars['String']['input']>;
};

export type RouteProductivityEntity = {
  __typename?: 'RouteProductivityEntity';
  actualHours?: Maybe<Scalars['Float']['output']>;
  actualHoursAreProxy: Scalars['Boolean']['output'];
  allowedHours?: Maybe<Scalars['Float']['output']>;
  hasTimeAllowances: Scalars['Boolean']['output'];
  productivityRatio?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<ProductivityStatus>;
};

export type RouteSlotArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  routeSlotCreateInput?: InputMaybe<RouteSlotCreateInput>;
  /** Pass this field in to update an array item */
  routeSlotUpdateInput?: InputMaybe<RouteSlotUpdateInput>;
};

export type RouteSlotCreateInput = {
  /** The uuids of the stops to add to create route slots from. No relation to anything drayage */
  drayageStopUuids: Array<Scalars['String']['input']>;
  emitMultiplayerEvent?: InputMaybe<Scalars['Boolean']['input']>;
  groupBy?: InputMaybe<GroupByStopsInput>;
  placeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RouteSlotEntity = {
  __typename?: 'RouteSlotEntity';
  ordinal: Scalars['Int']['output'];
  places: Array<PlaceEntity>;
  previousSlotDistanceMeters?: Maybe<Scalars['Float']['output']>;
  previousSlotDurationSeconds?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<RouteEntity>;
  stops: Array<StopEntity>;
  uuid: Scalars['String']['output'];
};

export type RouteSlotReassignInput = {
  endIndex?: InputMaybe<Scalars['Float']['input']>;
  routeUuid: Scalars['String']['input'];
  slotUuid: Scalars['String']['input'];
};

export type RouteSlotUpdateInput = {
  drayageStopUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  placeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type RouteSort = {
  sortBy: RouteSortBy;
  sortDirection: SortDirection;
};

export enum RouteSortBy {
  CreatedTime = 'CREATED_TIME',
  Driver = 'DRIVER',
  Name = 'NAME',
  NumberStopsComplete = 'NUMBER_STOPS_COMPLETE',
  NumberStopsIncomplete = 'NUMBER_STOPS_INCOMPLETE',
  RouteDate = 'ROUTE_DATE',
  Status = 'STATUS'
}

export enum RouteStatus {
  AwaitingAgentConfirmation = 'AWAITING_AGENT_CONFIRMATION',
  AwaitingSendToAgent = 'AWAITING_SEND_TO_AGENT',
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type RouteUpdateInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  defaultStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** defaultStartTime typed as a wall clock in an entry zone (terminal_local_times). Replaces defaultStartTime when sent. */
  defaultStartTimeLocal?: InputMaybe<LocalDateTimeInput>;
  endLoadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  equipmentUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  lastDispatched?: InputMaybe<Scalars['DateTime']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameManuallyChanged?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfRescheduled?: InputMaybe<Scalars['Float']['input']>;
  routeSlotsUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startLoadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type RoutesSamsaraVehicleLocationsOutput = {
  __typename?: 'RoutesSamsaraVehicleLocationsOutput';
  routeCoordinates: Array<RouteCoordinatesEntity>;
};

export type RunEntity = {
  __typename?: 'RunEntity';
  createdAt: Scalars['DateTime']['output'];
  driver?: Maybe<DriverEntity>;
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  recurringOrderTemplates: Array<OrderEntity>;
  tags: Array<TagEntity>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
};

export type RunTestAccessorialDetectionInput = {
  delegationUuid: Scalars['String']['input'];
};

export type SalesVarianceReportInput = {
  /** List of customer uuids to include in the report. If not provided, all customers will be included. */
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The zone the service-date periods are read in. Empty: each order on its own local service day while terminal_local_times is on, else the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  /** Order service date filter for the first sales period that is being compared */
  serviceDateFilterPeriod1: DateFilterV2;
  /** Order service date filter for the second sales period that is being compared */
  serviceDateFilterPeriod2: DateFilterV2;
};

export enum SameDayDispatchCellHeader {
  BillOfLadingNumber = 'BILL_OF_LADING_NUMBER',
  ServiceLevel = 'SERVICE_LEVEL'
}

export type SameDayDispatchConfigEntity = {
  __typename?: 'SameDayDispatchConfigEntity';
  createdAt: Scalars['DateTime']['output'];
  deliveryAppointmentTimeThreshold: Scalars['Int']['output'];
  deliveryWithinTimeWindowColorCode: Scalars['String']['output'];
  isNextInRouteColorCode: Scalars['String']['output'];
  isPastDeadlineColorCode: Scalars['String']['output'];
  isSpecialColorCode: Scalars['String']['output'];
  pickupAppointmentTimeThreshold: Scalars['Int']['output'];
  pickupWithinTimeWindowColorCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum SamsaraDatasetGroup {
  Activity = 'ACTIVITY',
  Costs = 'COSTS',
  Fleet = 'FLEET',
  Other = 'OTHER'
}

export type SamsaraDiscoveryAbsentEndpointEntity = {
  __typename?: 'SamsaraDiscoveryAbsentEndpointEntity';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type SamsaraDiscoveryCatalogueEntity = {
  __typename?: 'SamsaraDiscoveryCatalogueEntity';
  absentEndpoints: Array<SamsaraDiscoveryAbsentEndpointEntity>;
  datasets: Array<SamsaraDiscoveryDatasetEntity>;
};

export type SamsaraDiscoveryDatasetEntity = {
  __typename?: 'SamsaraDiscoveryDatasetEntity';
  dated: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  group: SamsaraDatasetGroup;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  rowCount: Scalars['Int']['output'];
};

export enum SamsaraDiscoveryExportFormat {
  Csv = 'CSV',
  Json = 'JSON'
}

export type SamsaraDiscoveryExportInput = {
  /** When true, every field the API returned as a flattened column instead of the curated columns. */
  allFields?: Scalars['Boolean']['input'];
  /** A dataset key from the catalogue. */
  dataset: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  format: SamsaraDiscoveryExportFormat;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SamsaraDiscoveryMonthEntity = {
  __typename?: 'SamsaraDiscoveryMonthEntity';
  driveHours?: Maybe<Scalars['Float']['output']>;
  estFuelUsd?: Maybe<Scalars['Float']['output']>;
  gallons?: Maybe<Scalars['Float']['output']>;
  idleHours?: Maybe<Scalars['Float']['output']>;
  iftaGallonsBought?: Maybe<Scalars['Float']['output']>;
  iftaMiles?: Maybe<Scalars['Float']['output']>;
  laborUsd?: Maybe<Scalars['Float']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
  /** YYYY-MM */
  month: Scalars['String']['output'];
  onDutyHours?: Maybe<Scalars['Float']['output']>;
  partLinesUsd?: Maybe<Scalars['Float']['output']>;
  taskPartsCostUsd?: Maybe<Scalars['Float']['output']>;
  vehicles?: Maybe<Scalars['Int']['output']>;
  workOrdersCompleted?: Maybe<Scalars['Int']['output']>;
};

export type SamsaraDiscoveryMonthlyOverviewInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type SamsaraDiscoveryRowsInput = {
  /** When true, every field the API returned as a flattened column instead of the curated columns. */
  allFields?: Scalars['Boolean']['input'];
  /** A dataset key from the catalogue. */
  dataset: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Zero-based page index. */
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SamsaraDiscoveryRowsPageEntity = {
  __typename?: 'SamsaraDiscoveryRowsPageEntity';
  headers: Array<Scalars['String']['output']>;
  rows: Array<Array<Scalars['String']['output']>>;
  /** Rows matching the filter across all pages. */
  total: Scalars['Int']['output'];
};

export type SamsaraDiscoveryRunEntity = {
  __typename?: 'SamsaraDiscoveryRunEntity';
  currentDatasetLabel?: Maybe<Scalars['String']['output']>;
  /** Datasets finished so far in this run. */
  datasetsDone: Scalars['Int']['output'];
  datasetsTotal: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  fromDate?: Maybe<Scalars['DateTime']['output']>;
  /** Rows written by this run so far. */
  rowsWritten: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: SamsaraImportRunStatus;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type SamsaraDiscoverySetTokenInput = {
  /** The read-only Samsara API token. */
  apiToken: Scalars['String']['input'];
};

export type SamsaraDiscoveryStatusEntity = {
  __typename?: 'SamsaraDiscoveryStatusEntity';
  connected: Scalars['Boolean']['output'];
  hasData: Scalars['Boolean']['output'];
  latestRun?: Maybe<SamsaraDiscoveryRunEntity>;
  samsaraOrgName?: Maybe<Scalars['String']['output']>;
  /** Rows stored for the company across all datasets. While an import is queued or running this is the rows that run has written so far, which keeps polling cheap. */
  totalRows: Scalars['Int']['output'];
};

export type SamsaraDriverEntity = {
  __typename?: 'SamsaraDriverEntity';
  createdAtTime: Scalars['String']['output'];
  driverActivationStatus: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAtTime: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SamsaraDriversEntity = {
  __typename?: 'SamsaraDriversEntity';
  data: Array<SamsaraDriverEntity>;
  pagination: SamsaraPaginationEntity;
};

export type SamsaraGpsPingEntity = {
  __typename?: 'SamsaraGpsPingEntity';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  time: Scalars['String']['output'];
};

export enum SamsaraImportRunStatus {
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export type SamsaraOauthTokenEntity = {
  __typename?: 'SamsaraOauthTokenEntity';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  scope: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SamsaraPaginationEntity = {
  __typename?: 'SamsaraPaginationEntity';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
};

export type SamsaraVehicleEntity = {
  __typename?: 'SamsaraVehicleEntity';
  createdAtTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  updatedAtTime: Scalars['String']['output'];
  vin: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type SamsaraVehicleStatsEntity = {
  __typename?: 'SamsaraVehicleStatsEntity';
  gps?: Maybe<Array<SamsaraGpsPingEntity>>;
  /** Vehicle ID */
  id: Scalars['String']['output'];
};

export type SamsaraVehicleStatsFeedEntity = {
  __typename?: 'SamsaraVehicleStatsFeedEntity';
  data: Array<SamsaraVehicleStatsEntity>;
  pagination: SamsaraPaginationEntity;
};

export type SamsaraVehiclesEntity = {
  __typename?: 'SamsaraVehiclesEntity';
  data: Array<SamsaraVehicleEntity>;
  pagination: SamsaraPaginationEntity;
};

export type SaveCostInputQuickbooksMappingsInput = {
  mappings: Array<CostInputQuickbooksMappingInput>;
};

export type SaveCostInputSetupInput = {
  driverWageSplitPct?: InputMaybe<Scalars['Float']['input']>;
  truckLeasePerMilePct?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveCostInputsInput = {
  entries: Array<CostInputEntryInput>;
  month: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type SaveManifestPlacementsInput = {
  manifestUuid: Scalars['String']['input'];
  placements: Array<LoadPlacementInput>;
};

/** Changed lanes of one point-to-point group. Group-level fields stay on updateTariffGroup; tariffType, rateType and maximumIncludesFuel apply to every lane this save writes, and useActualWeightInCalculation comes from the group row. Each request commits whole or not at all; a client splits a large book across requests and sends upserts before removals. */
export type SavePointToPointLanesInput = {
  /** Saved lanes to take off the group, at most 1000. The tariff stays, because freight charges point at it. */
  laneRemovals: Array<PointToPointLaneRemovalInput>;
  /** Lanes to create or update, at most 1000 */
  laneUpserts: Array<PointToPointLaneInput>;
  /** Same as TariffUpsertInput.maximumIncludesFuel */
  maximumIncludesFuel: Scalars['Boolean']['input'];
  rateType: RateType;
  tariffGroupUuid: Scalars['String']['input'];
  tariffType: TariffType;
};

export type SavePointToPointLanesOutput = {
  __typename?: 'SavePointToPointLanesOutput';
  /** Every upserted lane, in request order */
  lanes: Array<SavedPointToPointLane>;
};

export type SaveSmc3SettingsInput = {
  defaultTariffName?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Smc3Environment>;
  expectedVersion?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  licenseKey?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pinnedTariffEffectiveDate?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Creates a partnership between a carrier and one of its customers, or, with partnershipUuid, updates that partnership. Every setting is required, so a save always states the whole partnership. */
export type SaveTenediPartnershipInput = {
  allowEditingShipperBillOfLadingNumber: Scalars['Boolean']['input'];
  alternateStediPartnerId?: InputMaybe<Scalars['String']['input']>;
  autoAcceptOrders: Scalars['Boolean']['input'];
  canCreateMultipleStops: Scalars['Boolean']['input'];
  /** One of the carrier's SCACs. */
  companyStandardCarrierAlphaCode: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  /** Required as true to change an existing partnership's destination. The change takes effect on the next message. */
  confirmCutover?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required as true when the backend runs in production. The page sends it only after the operator types prod. */
  confirmProduction?: InputMaybe<Scalars['Boolean']['input']>;
  edi214ShipmentStatuses: Array<Edi214ShipmentStatus>;
  ediOutboundPayloadDestination: EdiOutboundPayloadDestination;
  enableStaging: Scalars['Boolean']['input'];
  excludeZeroChargeInvoices: Scalars['Boolean']['input'];
  ignoreCancellations: Scalars['Boolean']['input'];
  ignoreNonEdiOutbound: Scalars['Boolean']['input'];
  organizationUuid: Scalars['String']['input'];
  /** Omit to create a partnership. */
  partnershipUuid?: InputMaybe<Scalars['String']['input']>;
  removeSpacesFrom214Bol: Scalars['Boolean']['input'];
  send990InResponseTo204: Scalars['Boolean']['input'];
  send990InResponseTo211: Scalars['Boolean']['input'];
  sendBackupDocs: Scalars['Boolean']['input'];
  useStediGenerateEdiFunction: Scalars['Boolean']['input'];
};

export type SavedFilterViewEntity = {
  __typename?: 'SavedFilterViewEntity';
  baseTab?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dispatchTableFields: Array<DispatchTableField>;
  displayName: Scalars['String']['output'];
  filterModelJson: Scalars['String']['output'];
  filterModelJsonV2?: Maybe<Scalars['JSON']['output']>;
  grants: Array<SavedFilterViewGrantEntity>;
  /** Ordered list of OrderTableField values the orders grid groups by, outermost first. Null or empty means the view is ungrouped. */
  groupModelJson?: Maybe<Scalars['JSON']['output']>;
  isPublicToCompany: Scalars['Boolean']['output'];
  isShared: Scalars['Boolean']['output'];
  lineHaulDispatchFilters?: Maybe<SavedLineHaulDispatchFiltersEntity>;
  myPermission: ViewPermission;
  orderTableFields: Array<OrderTableField>;
  savedViewPageType: FilterViewPage;
  sortModelJson?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserActorEntity;
  uuid: Scalars['String']['output'];
};

export type SavedFilterViewGrantEntity = {
  __typename?: 'SavedFilterViewGrantEntity';
  createdAt: Scalars['DateTime']['output'];
  granteeName: Scalars['String']['output'];
  granteeType: GranteeType;
  granteeUuid: Scalars['String']['output'];
  permission: ViewPermission;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SavedFilterViewGrantInput = {
  granteeType: GranteeType;
  granteeUuid: Scalars['String']['input'];
  permission: ViewPermission;
};

export type SavedLineHaulDispatchBoardFiltersEntity = {
  __typename?: 'SavedLineHaulDispatchBoardFiltersEntity';
  detailedStatuses: Array<OrderDetailedStatus>;
  legStates: Array<DispatchLegState>;
  pieceStatuses: Array<PieceStatus>;
};

/** The line-haul dispatch board filters a saved view restores. An empty array applies no constraint on that dimension. */
export type SavedLineHaulDispatchFiltersEntity = {
  __typename?: 'SavedLineHaulDispatchFiltersEntity';
  boardFilters: SavedLineHaulDispatchBoardFiltersEntity;
  laneFilter: SavedLineHaulDispatchLaneFilterEntity;
};

/** The line-haul dispatch board filters a saved view restores. Only accepted on LINE_HAUL_ORDERS views. */
export type SavedLineHaulDispatchFiltersInput = {
  boardFilters: GroupOrdersBoardFiltersInput;
  laneFilter: SavedLineHaulDispatchLaneFilterInput;
};

export type SavedLineHaulDispatchLaneFilterEntity = {
  __typename?: 'SavedLineHaulDispatchLaneFilterEntity';
  destinationTerminalUuids: Array<Scalars['String']['output']>;
  originTerminalUuids: Array<Scalars['String']['output']>;
};

/** The lane filter a line-haul dispatch saved view restores: origin and destination terminal uuids. */
export type SavedLineHaulDispatchLaneFilterInput = {
  /** Lane END terminal uuids. Empty applies no constraint. Terminals outside the company are dropped. */
  destinationTerminalUuids: Array<Scalars['String']['input']>;
  /** Lane START terminal uuids. Empty applies no constraint. Terminals outside the company are dropped. */
  originTerminalUuids: Array<Scalars['String']['input']>;
};

/** One lane a savePointToPointLanes request wrote. The next save of the lane sends tariffUuid and version back. */
export type SavedPointToPointLane = {
  __typename?: 'SavedPointToPointLane';
  inboundZoneUuid: Scalars['String']['output'];
  outboundZoneUuid: Scalars['String']['output'];
  tariffUuid: Scalars['String']['output'];
  version: Scalars['DateTime']['output'];
};

export type ScanEntity = {
  __typename?: 'ScanEntity';
  barcode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  isNewPiece: Scalars['Boolean']['output'];
  order?: Maybe<OrderEntity>;
  orderLineHaulSegmentArrival?: Maybe<OrderLineHaulSegmentEntity>;
  orderLineHaulSegmentDeparture?: Maybe<OrderLineHaulSegmentEntity>;
  orderMarkedOnHandByScan: Scalars['Boolean']['output'];
  orderMarkedReceivedAtOriginByScan: Scalars['Boolean']['output'];
  piece?: Maybe<PieceEntity>;
  /** @deprecated Deprecated in favor of Piece.barcode. Needed for backwards compatibility */
  rawBarcode: Scalars['String']['output'];
  scanType: ScanType;
  scannedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** Which field produced a contains-match hit in the scan fallback. */
export enum ScanMatchedField {
  HouseAirwayBillOfLadingNumber = 'HOUSE_AIRWAY_BILL_OF_LADING_NUMBER',
  MasterAirwayBillOfLadingNumber = 'MASTER_AIRWAY_BILL_OF_LADING_NUMBER',
  OrderName = 'ORDER_NAME',
  OrderRefNumbers = 'ORDER_REF_NUMBERS',
  PieceReferenceNumber = 'PIECE_REFERENCE_NUMBER',
  ShipperBillOfLadingNumber = 'SHIPPER_BILL_OF_LADING_NUMBER'
}

export type ScanOrderBarcodeInput = {
  barcode: Scalars['String']['input'];
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  scanType?: InputMaybe<ScanType>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ScanOrderBarcodeOrderResultEntity = {
  __typename?: 'ScanOrderBarcodeOrderResultEntity';
  order: OrderEntity;
  /** Whether the piece was parsed from a serialized barcode. This will always be true if piece is not null, but may also be true if a recognized serialzed barcode format was scanned */
  parsedFromSerializedBarcode: Scalars['Boolean']['output'];
  piece?: Maybe<PieceEntity>;
  /**
   * The unique piece ID associated with this scanned order
   * @deprecated Use parsedFromSerializedBarcode instead to determine if piece was parsed from a serialized barcode because some piece-specific barcodes may not have a distinct pieceName
   */
  pieceName?: Maybe<Scalars['String']['output']>;
};

export type ScanOrderBarcodeOutput = {
  __typename?: 'ScanOrderBarcodeOutput';
  /** The orders and associated info found by the barcode scan. If one result is found, scan logic will be performed on the order. If multiple results are found, the results will be returned. If no results are found, an unassigned scan will be logged. */
  orderResults: Array<ScanOrderBarcodeOrderResultEntity>;
  /**
   * The orders matching a barcode scan. If only one match is found, scan logic will be performed on the order.
   * @deprecated Use orderResults instead
   */
  orders: Array<OrderEntity>;
  /**
   * The orders matching a barcode scan and the piece names associated with each result. If only one match is found, scan logic will be performed on the order.
   * @deprecated Use orderResults instead
   */
  ordersWithPieceNames: Array<OrderWithPieceNameEntity>;
  /** The scan event if one or zero orders are found */
  scan?: Maybe<ScanEntity>;
  /** The result of the barcode scan */
  scanBarcodeResultType?: Maybe<ScanOrderBarcodeResultType>;
};

export enum ScanOrderBarcodeResultType {
  Error = 'ERROR',
  MoreThanOneValidOrder = 'MORE_THAN_ONE_VALID_ORDER',
  NotOnManifest = 'NOT_ON_MANIFEST',
  NotOnStop = 'NOT_ON_STOP',
  PieceAlreadyScanned = 'PIECE_ALREADY_SCANNED',
  Success = 'SUCCESS'
}

export type ScanOrderInput = {
  barcode: Scalars['String']['input'];
  /** Indicates if the barcode is a serialized barcode. This should be true if pieceUuid is provided, or if the barcode is unique to a piece */
  isSerializedBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Deprecated. Mark on hand logic is determined by backend logic */
  markOnHand?: InputMaybe<Scalars['Boolean']['input']>;
  orderUuid: Scalars['String']['input'];
  /** @deprecated Use isSerializedBarcode (and pieceUuid if the piece is known) instead to indicate if a piece-specific barcode is being scanned */
  pieceName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of a scanned piece if we already know what it is */
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Previously used for client-side parsing. Deprecated in favor of barcode */
  rawBarcode?: InputMaybe<Scalars['String']['input']>;
  scanType?: InputMaybe<ScanType>;
  /** The UUID of the stop the driver is currently at */
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ScanPieceInput = {
  markOnHand?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export enum ScanType {
  Arrival = 'ARRIVAL',
  Delivery = 'DELIVERY',
  Departure = 'DEPARTURE'
}

export type ScanWarehouseLocationInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ScanWarehouseLocationOutput = {
  __typename?: 'ScanWarehouseLocationOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<OrderEntity>;
  package?: Maybe<PackageEntity>;
  piece?: Maybe<PieceEntity>;
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export enum ScannedDocumentType {
  DeliveryAlert = 'DELIVERY_ALERT',
  DeliveryReceipt = 'DELIVERY_RECEIPT',
  None = 'NONE',
  PickupAlert = 'PICKUP_ALERT'
}

export type ScannedOrderConnection = {
  __typename?: 'ScannedOrderConnection';
  edges: Array<ScannedOrderEdge>;
  pageInfo: PageInfo;
};

export type ScannedOrderCreateInput = {
  bucket: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
  signedPodMatchStatus?: InputMaybe<SignedPodMatchStatus>;
};

export type ScannedOrderEdge = {
  __typename?: 'ScannedOrderEdge';
  cursor: Scalars['String']['output'];
  node: ScannedOrderEntity;
};

export type ScannedOrderEntity = {
  __typename?: 'ScannedOrderEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentIngestionPipeline: DocumentIngestionPipeline;
  failureReason?: Maybe<ScannedOrderFailureReason>;
  filename: Scalars['String']['output'];
  ingestedOutlookEmailDetails: IngestedEmailDetailsEntity;
  key: Scalars['String']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
  s3Url: Scalars['String']['output'];
  scannedOrderResults: Array<ScannedOrderResultEntity>;
  source: ScannedOrderSource;
  status: ScannedOrderStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ScannedOrderFailureReason {
  CustomerExcluded = 'CUSTOMER_EXCLUDED',
  DocumentTypeExcluded = 'DOCUMENT_TYPE_EXCLUDED',
  EmptyExtraction = 'EMPTY_EXTRACTION',
  InvalidFiletype = 'INVALID_FILETYPE',
  InvalidPageSize = 'INVALID_PAGE_SIZE',
  InvalidPageSizeA0 = 'INVALID_PAGE_SIZE_A0',
  InvalidPageSizeA1 = 'INVALID_PAGE_SIZE_A1',
  InvalidPageSizeA2 = 'INVALID_PAGE_SIZE_A2',
  InvalidPageSizeA3 = 'INVALID_PAGE_SIZE_A3',
  InvalidPageSizeA4 = 'INVALID_PAGE_SIZE_A4',
  InvalidPageSizeA5 = 'INVALID_PAGE_SIZE_A5',
  InvalidPageSizeA6 = 'INVALID_PAGE_SIZE_A6',
  InvalidPageSizeA7 = 'INVALID_PAGE_SIZE_A7',
  InvalidPageSizeA8 = 'INVALID_PAGE_SIZE_A8',
  InvalidPageSizeA9 = 'INVALID_PAGE_SIZE_A9',
  InvalidPageSizeA10 = 'INVALID_PAGE_SIZE_A10',
  InvalidPageSizeB0 = 'INVALID_PAGE_SIZE_B0',
  InvalidPageSizeB1 = 'INVALID_PAGE_SIZE_B1',
  InvalidPageSizeB2 = 'INVALID_PAGE_SIZE_B2',
  InvalidPageSizeB3 = 'INVALID_PAGE_SIZE_B3',
  InvalidPageSizeB4 = 'INVALID_PAGE_SIZE_B4',
  InvalidPageSizeB5 = 'INVALID_PAGE_SIZE_B5',
  InvalidPageSizeB6 = 'INVALID_PAGE_SIZE_B6',
  InvalidPageSizeB7 = 'INVALID_PAGE_SIZE_B7',
  InvalidPageSizeB8 = 'INVALID_PAGE_SIZE_B8',
  InvalidPageSizeB9 = 'INVALID_PAGE_SIZE_B9',
  InvalidPageSizeB10 = 'INVALID_PAGE_SIZE_B10',
  InvalidPageSizeC0 = 'INVALID_PAGE_SIZE_C0',
  InvalidPageSizeC1 = 'INVALID_PAGE_SIZE_C1',
  InvalidPageSizeC2 = 'INVALID_PAGE_SIZE_C2',
  InvalidPageSizeC3 = 'INVALID_PAGE_SIZE_C3',
  InvalidPageSizeC4 = 'INVALID_PAGE_SIZE_C4',
  InvalidPageSizeC5 = 'INVALID_PAGE_SIZE_C5',
  InvalidPageSizeC6 = 'INVALID_PAGE_SIZE_C6',
  InvalidPageSizeC7 = 'INVALID_PAGE_SIZE_C7',
  InvalidPageSizeC8 = 'INVALID_PAGE_SIZE_C8',
  InvalidPageSizeC9 = 'INVALID_PAGE_SIZE_C9',
  InvalidPageSizeC10 = 'INVALID_PAGE_SIZE_C10',
  InvalidPageSizeJuniorLegal = 'INVALID_PAGE_SIZE_JUNIOR_LEGAL',
  InvalidPageSizeLegal = 'INVALID_PAGE_SIZE_LEGAL',
  InvalidPageSizeLetter = 'INVALID_PAGE_SIZE_LETTER',
  InvalidPageSizeTabloid = 'INVALID_PAGE_SIZE_TABLOID',
  LlmProviderError = 'LLM_PROVIDER_ERROR',
  LowDocumentQuality = 'LOW_DOCUMENT_QUALITY',
  NeedsManualSplit = 'NEEDS_MANUAL_SPLIT',
  NonOrderDocument = 'NON_ORDER_DOCUMENT',
  NoBillingParty = 'NO_BILLING_PARTY',
  NoHawbExtracted = 'NO_HAWB_EXTRACTED',
  TooManyPages = 'TOO_MANY_PAGES',
  Unknown = 'UNKNOWN',
  UnrecognizedDocument = 'UNRECOGNIZED_DOCUMENT'
}

export type ScannedOrderFromAdminCreateInput = {
  bucket: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type ScannedOrderFromAdminCreateOutput = {
  __typename?: 'ScannedOrderFromAdminCreateOutput';
  error?: Maybe<Scalars['String']['output']>;
  scannedOrderEntity?: Maybe<ScannedOrderEntity>;
};

export type ScannedOrderResultBillingPartyCandidate = {
  __typename?: 'ScannedOrderResultBillingPartyCandidate';
  contactName?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  share?: Maybe<Scalars['Float']['output']>;
  votes?: Maybe<Scalars['Int']['output']>;
};

export type ScannedOrderResultConnection = {
  __typename?: 'ScannedOrderResultConnection';
  edges: Array<ScannedOrderResultEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Float']['output']>;
};

export type ScannedOrderResultCreateInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  documentCreateInput: DocumentCreateInput;
  extractedFields: Array<ExtractedFieldInput>;
  failureReason?: InputMaybe<ScannedOrderFailureReason>;
  pageEnd: Scalars['Int']['input'];
  pageStart: Scalars['Int']['input'];
  scannedDocumentType: ScannedDocumentType;
  scannedOrderResultPageInputs: Array<ScannedOrderResultPageInput>;
  schemaUuid?: InputMaybe<Scalars['String']['input']>;
  signedPodMatchStatus?: InputMaybe<SignedPodMatchStatus>;
  status: ScannedOrderResultStatus;
};

export type ScannedOrderResultDocumentEntity = {
  __typename?: 'ScannedOrderResultDocumentEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  scannedDocumentType: ScannedDocumentType;
  scannedOrderResultDocumentPages: Array<ScannedOrderResultDocumentPageEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScannedOrderResultDocumentPageEntity = {
  __typename?: 'ScannedOrderResultDocumentPageEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScannedOrderResultEdge = {
  __typename?: 'ScannedOrderResultEdge';
  cursor: Scalars['String']['output'];
  node: ScannedOrderResultEntity;
};

export type ScannedOrderResultEntity = {
  __typename?: 'ScannedOrderResultEntity';
  applyPlan?: Maybe<AdhocApplyPlanEntity>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  billingPartyCandidates?: Maybe<Array<ScannedOrderResultBillingPartyCandidate>>;
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  dismissed: Scalars['Boolean']['output'];
  duplicateOrder?: Maybe<OrderEntity>;
  duplicateScannedOrderResultOrder?: Maybe<OrderEntity>;
  exemplars: Array<ScannedOrderResultExemplar>;
  extractionDetail?: Maybe<ScannedOrderResultExtractionDetail>;
  failureReason?: Maybe<ScannedOrderFailureReason>;
  filename: Scalars['String']['output'];
  mergedAwayOrder?: Maybe<OrderEntity>;
  /** Return the next youngest scanned order result to review. Scanned order results are processed in descending order by creation date */
  nextScannedOrderResultInReview?: Maybe<ScannedOrderResultEntity>;
  order?: Maybe<OrderEntity>;
  pageEnd: Scalars['Int']['output'];
  pageStart: Scalars['Int']['output'];
  podOrder?: Maybe<OrderEntity>;
  possibleDuplicateOrder?: Maybe<OrderEntity>;
  preSignedGetUrl?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  scannedOrder: ScannedOrderEntity;
  scannedOrderResultDocuments: Array<ScannedOrderResultDocumentEntity>;
  scannedOrderResultPages: Array<ScannedOrderResultPageEntity>;
  schemaUuid?: Maybe<Scalars['String']['output']>;
  serviceSelection?: Maybe<ScannedOrderResultServiceSelection>;
  signedPodMatchStatus?: Maybe<SignedPodMatchStatus>;
  status: ScannedOrderResultStatus;
  type: ScannedOrderResultType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};


export type ScannedOrderResultEntityNextScannedOrderResultInReviewArgs = {
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScannedOrderResultExemplar = {
  __typename?: 'ScannedOrderResultExemplar';
  cosineSimilarity: Scalars['Float']['output'];
  documentId: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  preSignedGetUrl?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export type ScannedOrderResultExtractionDetail = {
  __typename?: 'ScannedOrderResultExtractionDetail';
  correlationId?: Maybe<Scalars['String']['output']>;
  exemplarMarker?: Maybe<Scalars['JSON']['output']>;
  extractedFields?: Maybe<Scalars['JSON']['output']>;
  pipelineVersion?: Maybe<Scalars['String']['output']>;
  taxonomyVersion?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['JSON']['output']>;
};

export type ScannedOrderResultPageEntity = {
  __typename?: 'ScannedOrderResultPageEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScannedOrderResultPageInput = {
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};

export type ScannedOrderResultServiceSelection = {
  __typename?: 'ScannedOrderResultServiceSelection';
  extractedText?: Maybe<Scalars['String']['output']>;
  source?: Maybe<ScannedOrderResultServiceSource>;
  suggestedServiceSource?: Maybe<ScannedOrderResultServiceSource>;
  suggestedServiceUuid?: Maybe<Scalars['String']['output']>;
};

/** Where the auto-apply took the pre-filled service from: the extracted service level (exact name or learned mapping), the billing party default, or past orders on the same lane or billing party. */
export enum ScannedOrderResultServiceSource {
  ContactDefault = 'CONTACT_DEFAULT',
  ExtractedExact = 'EXTRACTED_EXACT',
  ExtractedLearned = 'EXTRACTED_LEARNED',
  LocalityHistory = 'LOCALITY_HISTORY'
}

export enum ScannedOrderResultSourceFilter {
  All = 'ALL',
  EmailIntegration = 'EMAIL_INTEGRATION',
  UploadedPdf = 'UPLOADED_PDF'
}

export enum ScannedOrderResultStatus {
  Approved = 'APPROVED',
  Attached = 'ATTACHED',
  Duplicate = 'DUPLICATE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  ManuallyEntered = 'MANUALLY_ENTERED',
  Rejected = 'REJECTED'
}

export enum ScannedOrderResultType {
  Order = 'ORDER',
  SignedPod = 'SIGNED_POD'
}

export enum ScannedOrderSource {
  EmailIntegration = 'EMAIL_INTEGRATION',
  UploadedDocument = 'UPLOADED_DOCUMENT'
}

export enum ScannedOrderStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  Queued = 'QUEUED',
  Rejected = 'REJECTED'
}

export type ScannedOrderUpdateInput = {
  companyUuid: Scalars['String']['input'];
  /** Included if the entire scanned order request failed */
  failureReason?: InputMaybe<ScannedOrderFailureReason>;
  outlookIntegrationUuid?: InputMaybe<Scalars['String']['input']>;
  outlookMessageId?: InputMaybe<Scalars['String']['input']>;
  scannedOrderResults: Array<ScannedOrderResultCreateInput>;
  source?: InputMaybe<ScannedOrderSource>;
  status: ScannedOrderStatus;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ScheduleOrganizationMessageInput = {
  /** Required as "SEND" when scheduling a message to every company. */
  confirmation?: InputMaybe<Scalars['String']['input']>;
  /** When delivery starts. Must be in the future. */
  startsAt: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export enum ScheduleTimeZoneMode {
  Company = 'COMPANY',
  Origin = 'ORIGIN'
}

export type SchedulingBlockedDayEntity = {
  __typename?: 'SchedulingBlockedDayEntity';
  date: PlainDate;
  /** Scheduling resources that still run on this day. An exemption waives THIS company closure only: a resource that also carries a blocked day of its own for the date stays closed. Capped per day, in id order. */
  exemptSchedulingResourceIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type SchedulingRegionEntity = {
  __typename?: 'SchedulingRegionEntity';
  dailyCapacityPieces?: Maybe<Scalars['Int']['output']>;
  dailyCapacityStops?: Maybe<Scalars['Int']['output']>;
  dailyCapacityWeight?: Maybe<Scalars['Mass']['output']>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  zones: Array<SchedulingZoneEntity>;
};

export type SchedulingResourceBlockedDayEntity = {
  __typename?: 'SchedulingResourceBlockedDayEntity';
  date: PlainDate;
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type SchedulingResourceConnection = {
  __typename?: 'SchedulingResourceConnection';
  edges: Array<SchedulingResourceEdge>;
  pageInfo: PageInfo;
};

export type SchedulingResourceCustomerEligibilityRulesInput = {
  /** Customer ids, ANY ONE of which an order's billing party may be. One party per order, so this list widens the resource as it grows, like the service levels above and unlike the tags. The customer is the order's billing party specifically, never the consignee on a stop. Master accounts do NOT cascade and cannot be named here at all: a rule names one organization and reaches that organization alone, so covering a master account means naming each of its organizations, and one onboarded later is covered when someone adds it. */
  allow: Array<Scalars['String']['input']>;
  /** Customer ids that refuse an order whose billing party is ANY ONE of them. Deny wins over allow. Master accounts do not cascade here either: banning an organization does not ban its siblings under the same master account. */
  deny: Array<Scalars['String']['input']>;
};

export type SchedulingResourceCustomerEligibilityRulesOutput = {
  __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput';
  /** Customer ids, ANY ONE of which an order's billing party may be. One party per order, so this list widens the resource as it grows. The billing party specifically, never the consignee on a stop. Master accounts do not cascade and cannot be named: each organization is named on its own. */
  allow: Array<Scalars['String']['output']>;
  /** Customer ids that refuse an order whose billing party is ANY ONE of them. Deny wins over allow, and banning an organization does not ban its siblings under the same master account. */
  deny: Array<Scalars['String']['output']>;
  /** DERIVED and READ-ONLY. True when the last write to the customer dimension left a non-empty allow list, and it is not settable: no input field maps to it. It exists to tell "this dimension was never configured" from "it was configured and everything it named has since been deleted", which are the same zero rows in the database and opposite states in the business. True with an EMPTY allow list is the damaged state a cascading subject delete leaves behind: the resource then matches nothing and refuses every order, rather than silently reopening to all of them. A UI should explain that state and offer to clear the dimension, which is what sending two empty lists does. */
  restricted: Scalars['Boolean']['output'];
};

export type SchedulingResourceEdge = {
  __typename?: 'SchedulingResourceEdge';
  cursor: Scalars['String']['output'];
  node: SchedulingResourceEntity;
};

/** The eligibility rules configured on a scheduling resource: which orders may book it. An order must clear ALL THREE dimensions. The three do NOT match the same way, so read each field: a tag allow list means an order must carry ALL of those tags, while the service level and customer allow lists mean ANY ONE of them. Within a dimension the deny list wins, and an empty allow list means unrestricted unless that dimension reports restricted. */
export type SchedulingResourceEligibilityRulesOutput = {
  __typename?: 'SchedulingResourceEligibilityRulesOutput';
  customers: SchedulingResourceCustomerEligibilityRulesOutput;
  services: SchedulingResourceServiceEligibilityRulesOutput;
  tags: SchedulingResourceTagEligibilityRulesOutput;
};

export type SchedulingResourceEntity = {
  __typename?: 'SchedulingResourceEntity';
  /** Blocked days in the requested window, soonest first, capped at 100 per resource. Defaults to today onward, read in the resource time zone. Narrow the window to reach days past the cap. */
  blockedDays: Array<SchedulingResourceBlockedDayEntity>;
  /** Number of blocked days in the requested window. Defaults to today onward, read in the resource time zone. Exact, unlike the length of blockedDays, which is capped per resource. */
  blockedDaysCount: Scalars['Int']['output'];
  /** Null means the resource has no piece limit. */
  capacityPieces?: Maybe<Scalars['Int']['output']>;
  /** Null means the resource has no stop limit. */
  capacityStops?: Maybe<Scalars['Int']['output']>;
  capacityWeight?: Maybe<Scalars['Mass']['output']>;
  dayOfWeek: DayOfWeekAll;
  /** Which orders may book this resource. An order must clear all three dimensions, and the three do not match the same way: read the field descriptions rather than assuming the lists behave alike. A resource nobody has configured reports three empty, unrestricted dimensions. NULL means the rules for this one resource could not be read, because it stopped being visible to this session between the read of the resource and the read of its rules; it never means the resource has no rules, and must not be shown as unrestricted. The accompanying GraphQL error names the field. */
  eligibilityRules?: Maybe<SchedulingResourceEligibilityRulesOutput>;
  end: PlainTime;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  routeNames: Array<RouteNameEntity>;
  start: PlainTime;
  /** Canonical IANA region time zone the start and end wall-clock times are read in. Blocked-day dates are read in it too. */
  timeZone: Scalars['String']['output'];
};


export type SchedulingResourceEntityBlockedDaysArgs = {
  fromDateIso8601?: InputMaybe<Scalars['String']['input']>;
  toDateIso8601?: InputMaybe<Scalars['String']['input']>;
};


export type SchedulingResourceEntityBlockedDaysCountArgs = {
  fromDateIso8601?: InputMaybe<Scalars['String']['input']>;
  toDateIso8601?: InputMaybe<Scalars['String']['input']>;
};

export type SchedulingResourceLiveClaimsOutput = {
  __typename?: 'SchedulingResourceLiveClaimsOutput';
  /** How many unreleased capacity claims block the edit. Exact, and counts CLAIMS rather than days: several claims may sit on one day. */
  liveClaimCount: Scalars['Int']['output'];
  /** The distinct days carrying those claims, as YYYY-MM-DD read in the time zone of the resource, earliest first. Capped for a refused weekday move, so it can be shorter than the claim count implies even after de-duplication; liveClaimCount is the complete figure. A refused block reports the single day it was closing. */
  liveClaimDatesIso8601: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SchedulingResourceNameConflictOutput = {
  __typename?: 'SchedulingResourceNameConflictOutput';
  /** Id of the live resource already holding this name. It is NOT the resource the request named: rename this one, then retry. */
  conflictingSchedulingResourceId: Scalars['String']['output'];
  /** Name both resources hold, already trimmed. Equal to the requested name by construction, and repeated here so a client can render the conflict without a second read. */
  conflictingSchedulingResourceName: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type SchedulingResourceOutput = MutationErrorOutput | SchedulingResourceLiveClaimsOutput | SchedulingResourceNameConflictOutput | SchedulingResourceSuccessOutput;

export type SchedulingResourceServiceEligibilityRulesInput = {
  /** Service level ids, ANY ONE of which an order may hold to book this resource. An order holds at most one service level, so this list widens the resource as it grows, the opposite of the tag allow list above. An order holding NO service level at all is refused by any service restriction, this list and the deny list alike: an order that cannot state its service level cannot prove it belongs on a restricted resource. */
  allow: Array<Scalars['String']['input']>;
  /** Service level ids that refuse an order holding ANY ONE of them. Deny wins over allow. A deny list alone still refuses an order with no service level at all. */
  deny: Array<Scalars['String']['input']>;
};

export type SchedulingResourceServiceEligibilityRulesOutput = {
  __typename?: 'SchedulingResourceServiceEligibilityRulesOutput';
  /** Service level ids, ANY ONE of which an order may hold. An order holds at most one, so this list widens the resource as it grows, unlike the tag allow list. An order with NO service level is refused by any service restriction, this list and the deny list alike. */
  allow: Array<Scalars['String']['output']>;
  /** Service level ids that refuse an order holding ANY ONE of them. Deny wins over allow, and a deny list alone still refuses an order with no service level at all. */
  deny: Array<Scalars['String']['output']>;
  /** DERIVED and READ-ONLY. True when the last write to the service level dimension left a non-empty allow list, and it is not settable: no input field maps to it. It exists to tell "this dimension was never configured" from "it was configured and everything it named has since been deleted", which are the same zero rows in the database and opposite states in the business. True with an EMPTY allow list is the damaged state a cascading subject delete leaves behind: the resource then matches nothing and refuses every order, rather than silently reopening to all of them. A UI should explain that state and offer to clear the dimension, which is what sending two empty lists does. */
  restricted: Scalars['Boolean']['output'];
};

export type SchedulingResourceSuccessOutput = {
  __typename?: 'SchedulingResourceSuccessOutput';
  schedulingResource: SchedulingResourceEntity;
};

export type SchedulingResourceTagEligibilityRulesInput = {
  /** Tag ids an order must carry ALL of. This is a DEDICATION rule, not a capability rule: [LIFTGATE] means the resource takes ONLY liftgate freight, so an order carrying no tags is refused rather than accepted. Every tag added narrows what the resource accepts; none of them widens it. Two tags mean an order must carry both, never either. Label this in a UI as "orders must carry all of these", never as capabilities or equipment, which reads exactly backwards. */
  allow: Array<Scalars['String']['input']>;
  /** Tag ids that refuse an order carrying ANY ONE of them. Deny wins over allow, so a tag on both lists refuses. */
  deny: Array<Scalars['String']['input']>;
};

export type SchedulingResourceTagEligibilityRulesOutput = {
  __typename?: 'SchedulingResourceTagEligibilityRulesOutput';
  /** Tag ids an order must carry ALL of. A DEDICATION rule, not a capability rule: [LIFTGATE] means the resource takes ONLY liftgate freight, so an untagged order is refused. Every tag listed narrows what the resource accepts; none widens it. */
  allow: Array<Scalars['String']['output']>;
  /** Tag ids that refuse an order carrying ANY ONE of them. Deny wins over allow. */
  deny: Array<Scalars['String']['output']>;
  /** DERIVED and READ-ONLY. True when the last write to the tag dimension left a non-empty allow list, and it is not settable: no input field maps to it. It exists to tell "this dimension was never configured" from "it was configured and everything it named has since been deleted", which are the same zero rows in the database and opposite states in the business. True with an EMPTY allow list is the damaged state a cascading subject delete leaves behind: the resource then matches nothing and refuses every order, rather than silently reopening to all of them. A UI should explain that state and offer to clear the dimension, which is what sending two empty lists does. */
  restricted: Scalars['Boolean']['output'];
};

export type SchedulingZoneAvailabilityEntity = {
  __typename?: 'SchedulingZoneAvailabilityEntity';
  dayOfWeek: DayOfWeekAll;
  end: PlainTime;
  id: Scalars['String']['output'];
  start: PlainTime;
};

export type SchedulingZoneAvailabilityUpsertInput = {
  dayOfWeek: DayOfWeekAll;
  end: PlainTimeInput;
  id: Scalars['String']['input'];
  start: PlainTimeInput;
};

export type SchedulingZoneEntity = {
  __typename?: 'SchedulingZoneEntity';
  availabilities: Array<SchedulingZoneAvailabilityEntity>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  locations: Array<SchedulingZoneLocationEntity>;
  name: Scalars['String']['output'];
};

export type SchedulingZoneLocationEntity = {
  __typename?: 'SchedulingZoneLocationEntity';
  city: Scalars['String']['output'];
  id: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type SchedulingZoneLocationUpsertInput = {
  city: Scalars['String']['input'];
  id: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type SchemaCompanyMappingEntity = {
  __typename?: 'SchemaCompanyMappingEntity';
  companyUuid: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  schemaDocuments: Array<SchemaDocumentEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
};

export type SchemaDocumentEntity = {
  __typename?: 'SchemaDocumentEntity';
  bucket: Scalars['String']['output'];
  company?: Maybe<CompanyEntity>;
  companyUuid?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  labelledValues?: Maybe<Scalars['String']['output']>;
  preSignedGetUrl: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SchemaDocumentInput = {
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
  labelledValues?: InputMaybe<Scalars['String']['input']>;
};

export type SchemaEntity = {
  __typename?: 'SchemaEntity';
  companyMappingsCount: Scalars['Float']['output'];
  companyUuid?: Maybe<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  firstTestSchemaDocument?: Maybe<SchemaDocumentEntity>;
  isActive: Scalars['Boolean']['output'];
  isMultiPage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  scannedDocumentType: ScannedDocumentType;
  testDocumentCount?: Maybe<Scalars['Float']['output']>;
  textractType: TextractType;
  updatedAt: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SchemaFieldEntity = {
  __typename?: 'SchemaFieldEntity';
  bottomEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  concatenateX: Scalars['Boolean']['output'];
  fieldExtractors: Array<FieldExtractorEntity>;
  fieldMatchers: Array<FieldMatcherEntity>;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  leftEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  rightEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  top: Scalars['Float']['output'];
  topEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type SchemaFieldInput = {
  bottomEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  concatenateX: Scalars['Boolean']['input'];
  fieldExtractors: Array<FieldExtractorInput>;
  fieldMatchers: Array<FieldMatcherInput>;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  leftEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  rightEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  top: Scalars['Float']['input'];
  topEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  width: Scalars['Float']['input'];
};

export type SchemaFilePutUrlInput = {
  filename: Scalars['String']['input'];
};

export type SchemaInput = {
  fingerprintAnchors: Array<FingerprintAnchorInput>;
  isMultiPage: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
  packageTables: Array<PackageTableInput>;
  scannedDocumentType: ScannedDocumentType;
  schemaFields: Array<SchemaFieldInput>;
  textractType: TextractType;
  transformAnchors: Array<TransformAnchorInput>;
};

export type SchemaRunEntity = {
  __typename?: 'SchemaRunEntity';
  bucket: Scalars['String']['output'];
  extractedFields: Array<ExtractedFieldEntity>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchEntity>;
  key: Scalars['String']['output'];
  schema: SchemaWithAnchorsEntity;
  schemaRunPages: Array<SchemaRunPageEntity>;
  schemaRunTestSnapshot?: Maybe<SchemaRunEntity>;
  schemaRunTestStatus?: Maybe<SchemaRunTestStatus>;
  transformAnchorMatches: Array<TransformAnchorMatchEntity>;
  type: SchemaRunType;
  uuid: Scalars['String']['output'];
};

export type SchemaRunPageEntity = {
  __typename?: 'SchemaRunPageEntity';
  bucket: Scalars['String']['output'];
  extractedFields: Array<ExtractedFieldEntity>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchEntity>;
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  transformAnchorMatches: Array<TransformAnchorMatchEntity>;
  uuid: Scalars['String']['output'];
};

export type SchemaRunPageInput = {
  bucket: Scalars['String']['input'];
  extractedFields: Array<ExtractedFieldInput>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchInput>;
  key: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  transformAnchorMatches: Array<TransformAnchorMatchInput>;
};

export type SchemaRunTestListEntity = {
  __typename?: 'SchemaRunTestListEntity';
  createdAt: Scalars['DateTime']['output'];
  schemaRunTestStatus: SchemaRunTestStatus;
  schemaRuns: Array<SchemaRunEntity>;
  uuid: Scalars['String']['output'];
};

export type SchemaRunTestListInput = {
  schemaRunTestListUuid: Scalars['String']['input'];
};

export enum SchemaRunTestStatus {
  Error = 'ERROR',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Passed = 'PASSED'
}

export enum SchemaRunType {
  ManualRun = 'MANUAL_RUN',
  TestRun = 'TEST_RUN',
  TestSnapshot = 'TEST_SNAPSHOT'
}

export type SchemaTestFilePutUrlInput = {
  filename: Scalars['String']['input'];
};

export type SchemaWithAnchorsEntity = {
  __typename?: 'SchemaWithAnchorsEntity';
  companyUuid?: Maybe<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  fingerprintAnchors: Array<FingerprintAnchorEntity>;
  isActive: Scalars['Boolean']['output'];
  isMultiPage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  packageTables: Array<PackageTableEntity>;
  scannedDocumentType: ScannedDocumentType;
  schemaDocuments: Array<SchemaDocumentEntity>;
  schemaFields: Array<SchemaFieldEntity>;
  structuredExtractionSchemaOverride?: Maybe<StructuredExtractionSchemaOverrideEntity>;
  textractType: TextractType;
  transformAnchors: Array<TransformAnchorEntity>;
  uuid: Scalars['String']['output'];
};

export type SecondaryRefNumberSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum Segment {
  Cartage = 'CARTAGE',
  Standard = 'STANDARD'
}

export type SelectRoleInput = {
  role: MobileRole;
};

export type SelectSpecialAccessorialInput = {
  accessorialForContactUuid?: InputMaybe<Scalars['String']['input']>;
  /** City of the stop address */
  city?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated We no longer use contactUuid */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Country of the stop address */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The end appointment time that is set for the stop */
  endAppointment: Scalars['DateTime']['input'];
  /** Latitude of the stop address, used for the stop's zone when the stop does not exist yet. */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Street name/house number of the stop address */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** Longitude of the stop address, used for the stop's zone when the stop does not exist yet. */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** The distance to be traveled in miles for the stop */
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** The stop's service date */
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The selected service level for the order */
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  /** The start appointment time that is set for the stop */
  startAppointment: Scalars['DateTime']['input'];
  /** State of the stop address */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The stop, when it exists: with terminal_local_times on, day and time rules are evaluated in the stop's zone. */
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  /** The selected terminal for the stop, when one has been chosen */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** ZIP of the stop address */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type SelectSpecialAccessorialOutput = {
  __typename?: 'SelectSpecialAccessorialOutput';
  /** The selected special accessorial name based on the provided parameters. The value is null when there is no special accessorial found that matches the provided parameters */
  accessorialName?: Maybe<Scalars['String']['output']>;
  /** The selected special accessorial UUID based on the provided parameters. The value is null when there is no special accessorial found that matches the provided parameters */
  accessorialUuid?: Maybe<Scalars['String']['output']>;
  /** The selected charge group based on the provided parameters. The value is null when there is no charge group found that matches the provided parameters */
  chargeGroupUuid?: Maybe<Scalars['String']['output']>;
  /** The selected matrix item based on the provided parameters. The value is null when there is no matrix item found that matches the provided parameters */
  matrixItemUuid?: Maybe<Scalars['String']['output']>;
  /** The selected tariff zone based on the provided parameters. The value is null when there is no tariff zone found that matches the provided parameters */
  tariffZoneUuid?: Maybe<Scalars['String']['output']>;
};

export type SendAccountingReportsInput = {
  /** The UUIDs of the contacts to which we email the report. If an empty list is provided, we will email the report to all contacts for the company. For the dunning report, if the user chooses to send to all, we will only send the report to contacts with outstanding invoices */
  contactUuids: Array<Scalars['String']['input']>;
  /** Optional free-text message applied to every recipient of this batch. For the dunning report it is rendered in the PDF (above the footer) and the email body. */
  customMessage?: InputMaybe<Scalars['String']['input']>;
  /** The list of report filters used to generate the accounting report */
  reportFilters: ReportFiltersInput;
  /** The type of accounting report to be generated and emailed */
  reportType: AccountingReportTypeV2;
};

export type SendAccountingReportsOutput = MutationErrorOutput | SendAccountingReportsSuccessOutput;

export type SendAccountingReportsSuccessOutput = {
  __typename?: 'SendAccountingReportsSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type SendDeliveryCompletedInput = {
  hawbs?: InputMaybe<Array<Scalars['String']['input']>>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SendInvoicesInput = {
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceSendJobBatchType: InvoiceSendJobBatchType;
  invoicesToSend: Array<InvoiceToSend>;
  /** @deprecated Invoice backups are now always created */
  shouldPrintBackups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendMetricInput = {
  metricName: Scalars['String']['input'];
  tags: Array<MetricTagInput>;
  type: MetricType;
  value: Scalars['Int']['input'];
};

export type SendRouteToAgentInput = {
  agentId: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};

export type SendRouteToAgentOutput = MutationErrorOutput | SendRouteToAgentSuccessOutput;

export type SendRouteToAgentSuccessOutput = {
  __typename?: 'SendRouteToAgentSuccessOutput';
  route: RouteEntity;
};

export type SendStopToAgentInput = {
  agentId: Scalars['String']['input'];
  stopUuid: Scalars['String']['input'];
};

export type SendStopToAgentOutput = MutationErrorOutput | SendStopToAgentSuccessOutput;

export type SendStopToAgentSuccessOutput = {
  __typename?: 'SendStopToAgentSuccessOutput';
  stop: StopEntity;
};

export type SenderBillingPartyExplainEntity = {
  __typename?: 'SenderBillingPartyExplainEntity';
  contactUuid?: Maybe<Scalars['String']['output']>;
  distinctParties?: Maybe<Scalars['Int']['output']>;
  support?: Maybe<Scalars['Int']['output']>;
  verdict: Scalars['String']['output'];
};

export type ServiceAvailabilityDateEntity = {
  __typename?: 'ServiceAvailabilityDateEntity';
  /** @deprecated Use end instead */
  availableEndTime: Scalars['DateTime']['output'];
  /** @deprecated Use start instead */
  availableStartTime: Scalars['DateTime']['output'];
  dayCategory: SpecialDayOfWeek;
  enabled: Scalars['Boolean']['output'];
  end: PlainTime;
  id: Scalars['String']['output'];
  start: PlainTime;
};

export type ServiceCreateInput = {
  calculateInboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateLineHaulFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateOutboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAppointmentEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultAppointmentStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultDeliveryPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultFulfillmentType?: InputMaybe<FulfillmentType>;
  defaultInboundStopType?: InputMaybe<StopType>;
  defaultIsLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  defaultOutboundStopType?: InputMaybe<StopType>;
  defaultPickupPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultStartNow?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTotalDuration?: InputMaybe<Scalars['Duration']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isExposedToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  markOrdersAsSpecial: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  serviceAvailabilityDates?: InputMaybe<Array<UpsertServiceAvailabilityDateInput>>;
  timeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  useApptInRouteOptimization: Scalars['Boolean']['input'];
};

export type ServiceEntity = {
  __typename?: 'ServiceEntity';
  calculateInboundFreightCharges: Scalars['Boolean']['output'];
  calculateLineHaulFreightCharges: Scalars['Boolean']['output'];
  calculateOutboundFreightCharges: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultAppointmentEndTime?: Maybe<Scalars['DateTime']['output']>;
  defaultAppointmentStartTime?: Maybe<Scalars['DateTime']['output']>;
  defaultDeliveryPadding?: Maybe<Scalars['Duration']['output']>;
  defaultFulfillmentType?: Maybe<FulfillmentType>;
  defaultInboundStopType?: Maybe<StopType>;
  defaultIsLineHaul: Scalars['Boolean']['output'];
  defaultOutboundStopType?: Maybe<StopType>;
  defaultPickupPadding?: Maybe<Scalars['Duration']['output']>;
  defaultStartNow: Scalars['Boolean']['output'];
  defaultTotalDuration?: Maybe<Scalars['Duration']['output']>;
  isActive: Scalars['Boolean']['output'];
  isExposedToCustomers: Scalars['Boolean']['output'];
  markOrdersAsSpecial: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serviceAvailabilityDates: Array<ServiceAvailabilityDateEntity>;
  timeInMinutes?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  useApptInRouteOptimization: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type ServiceGroupEntity = {
  __typename?: 'ServiceGroupEntity';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  services: Array<ServiceEntity>;
};

export enum ServiceLevel {
  AirDrop = 'AIR_DROP',
  AmazonLockerCore = 'AMAZON_LOCKER_CORE',
  AmazonLockerPremiere = 'AMAZON_LOCKER_PREMIERE',
  Amerigas = 'AMERIGAS',
  AtmInstall = 'ATM_INSTALL',
  AtmSwap = 'ATM_SWAP',
  BasicDelivery = 'BASIC_DELIVERY',
  BasicPickup = 'BASIC_PICKUP',
  Coinstar = 'COINSTAR',
  CostcoTruckManifest = 'COSTCO_TRUCK_MANIFEST',
  Ct = 'CT',
  CustomerPickup = 'CUSTOMER_PICKUP',
  DebrisRemoval = 'DEBRIS_REMOVAL',
  DeliveryExpedited = 'DELIVERY_EXPEDITED',
  DicksDropTrailer = 'DICKS_DROP_TRAILER',
  Dock = 'DOCK',
  Drop = 'DROP',
  DumpRun = 'DUMP_RUN',
  Expedited = 'EXPEDITED',
  ExpeditedPickup = 'EXPEDITED_PICKUP',
  Fn = 'FN',
  FourManDelivery = 'FOUR_MAN_DELIVERY',
  Freeosk = 'FREEOSK',
  Fs = 'FS',
  Ge_2Man = 'GE_2_MAN',
  Ge_3Man = 'GE_3_MAN',
  Ge_4Man = 'GE_4_MAN',
  Ge_5Man = 'GE_5_MAN',
  Hiseq = 'HISEQ',
  HotShot = 'HOT_SHOT',
  Inbound = 'INBOUND',
  Iscan = 'ISCAN',
  Keyme = 'KEYME',
  L2IdLs = 'L2_ID_LS',
  LiftgateCurbside = 'LIFTGATE_CURBSIDE',
  LiftgateInside = 'LIFTGATE_INSIDE',
  LinehaulTruck = 'LINEHAUL_TRUCK',
  LocalNextDay = 'LOCAL_NEXT_DAY',
  LocalSameDay = 'LOCAL_SAME_DAY',
  MedicalDevice = 'MEDICAL_DEVICE',
  Miseq = 'MISEQ',
  NextseqNovaseq = 'NEXTSEQ_NOVASEQ',
  NextDay = 'NEXT_DAY',
  OneManPlus = 'ONE_MAN_PLUS',
  OneManWg = 'ONE_MAN_WG',
  PlWd = 'PL_WD',
  RackAssist = 'RACK_ASSIST',
  RackAssist_2Man = 'RACK_ASSIST_2_MAN',
  Recovery = 'RECOVERY',
  RecoverySameDay = 'RECOVERY_SAME_DAY',
  RecoverySameDayExpedited = 'RECOVERY_SAME_DAY_EXPEDITED',
  Redbox = 'REDBOX',
  RoomOfChoice = 'ROOM_OF_CHOICE',
  Rtn = 'RTN',
  SameDay = 'SAME_DAY',
  SamsClubReturnCenter = 'SAMS_CLUB_RETURN_CENTER',
  SignatureDelivery = 'SIGNATURE_DELIVERY',
  SiteSurvey = 'SITE_SURVEY',
  SpecialProducts = 'SPECIAL_PRODUCTS',
  Standard = 'STANDARD',
  Storage = 'STORAGE',
  SvRc = 'SV_RC',
  Tcr = 'TCR',
  Td = 'TD',
  Threshold = 'THRESHOLD',
  ThresholdPlus = 'THRESHOLD_PLUS',
  Transfer = 'TRANSFER',
  TwoManDelivery = 'TWO_MAN_DELIVERY',
  TwoManPickup = 'TWO_MAN_PICKUP',
  TwoManPlus = 'TWO_MAN_PLUS',
  TwoManWg = 'TWO_MAN_WG',
  WaWga = 'WA_WGA',
  WhiteGlove = 'WHITE_GLOVE'
}

export type ServiceLevelReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  /** IANA zone the report reads its days in; honored only while terminal_local_times is on. When null, insight reports count each order on its stop's local service day, and the audit report uses the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLevelReportBucketEntity = {
  __typename?: 'ServiceLevelReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

/** An object describing the region and terminals operated in by a service company */
export type ServiceRegionEntity = {
  __typename?: 'ServiceRegionEntity';
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The terminals that are part of this service region */
  terminals: Array<TerminalEntity>;
};

export type ServiceUpdateInput = {
  calculateInboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateLineHaulFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateOutboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAppointmentEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultAppointmentStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultDeliveryPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultFulfillmentType?: InputMaybe<FulfillmentType>;
  defaultInboundStopType?: InputMaybe<StopType>;
  defaultIsLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  defaultOutboundStopType?: InputMaybe<StopType>;
  defaultPickupPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultStartNow?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTotalDuration?: InputMaybe<Scalars['Duration']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isExposedToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  markOrdersAsSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  serviceAvailabilityDates?: InputMaybe<Array<UpsertServiceAvailabilityDateInput>>;
  timeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  useApptInRouteOptimization?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type SetAccessorialQboItemMappingInput = {
  qboItemId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type SetCompanyAccountTypeInput = {
  accountType: CompanyAccountType;
  companyUuid: Scalars['String']['input'];
};

export type SetContactChargeMatrixColumnMappingsInput = {
  contactUuid: Scalars['String']['input'];
  mappings: Array<ContactChargeMatrixColumnMappingInput>;
};

export type SetCrossdockInstructionInput = {
  instruction: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  terminalUuid: Scalars['String']['input'];
};

export type SetDockDoorsInput = {
  doors: Array<DockDoorInput>;
  terminalUuid: Scalars['String']['input'];
};

export type SetDriverComplianceDatesInput = {
  driverUuid: Scalars['String']['input'];
  items: Array<DriverComplianceDateInput>;
};

export type SetDriverSettlementPayBoundsInput = {
  bounds: Array<DriverSettlementPayBoundInput>;
  driverUuid: Scalars['String']['input'];
};

export type SetLaneDefaultDoorInput = {
  destDoorPosition?: InputMaybe<Scalars['Int']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  originDoorPosition?: InputMaybe<Scalars['Int']['input']>;
  startTerminalUuid: Scalars['String']['input'];
};

export type SetLineHaulManifestLoadPositionInput = {
  loadPosition?: InputMaybe<LoadPosition>;
  uuid: Scalars['String']['input'];
};

export type SetLineHaulManifestLoadPositionOutput = MutationErrorOutput | SetLineHaulManifestLoadPositionSuccessOutput;

export type SetLineHaulManifestLoadPositionSuccessOutput = {
  __typename?: 'SetLineHaulManifestLoadPositionSuccessOutput';
  lineHaulManifest: LineHaulManifestEntity;
};

export type SetLineHaulManifestOrderLoadPositionInput = {
  lineHaulManifestUuid: Scalars['String']['input'];
  loadPosition?: InputMaybe<LoadPosition>;
  orderUuid: Scalars['String']['input'];
};

export type SetLineHaulSegmentTimingInput = {
  cutoffTime?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
  transitDays?: InputMaybe<Scalars['Int']['input']>;
  transitMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type SetLineHaulSegmentTimingOutput = {
  __typename?: 'SetLineHaulSegmentTimingOutput';
  timing?: Maybe<LineHaulSegmentTimingEntity>;
  updatedCount: Scalars['Int']['output'];
};

export type SetManifestDepartTimeInput = {
  /** Minutes after midnight of the run operating day at which it departs, up to 2879; a time before the origin terminal day start is stored as that time plus 1440. Null goes back to following the template. */
  departTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The clock departTimeMinutes is in. ORIGIN is the run origin terminal's local time, accepted only while terminal local times are on; a terminal without a zone reads it in the company zone. Omitted: the company's schedule input clock. */
  departTimeZoneMode?: InputMaybe<ScheduleTimeZoneMode>;
  manifestUuid: Scalars['String']['input'];
};

export type SetManifestOriginTerminalInput = {
  /** Keep the local clock time at the new origin instead of the departure moment. Defaults to keeping the moment. */
  keepWallClock?: InputMaybe<Scalars['Boolean']['input']>;
  manifestUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type SetManifestTrailersInput = {
  manifestUuid: Scalars['String']['input'];
  /** The trailer equipment UUIDs this run should carry, in load order. Empty clears the run to no trailers. */
  trailerEquipmentUuids: Array<Scalars['String']['input']>;
};

export type SetManifestTrailersOutput = {
  __typename?: 'SetManifestTrailersOutput';
  conflictWarning?: Maybe<Scalars['String']['output']>;
};

export type SetManifestTruckInput = {
  manifestUuid: Scalars['String']['input'];
  recurringTemplateTruckUuid?: InputMaybe<Scalars['String']['input']>;
};

export type SetManifestTruckOutput = {
  __typename?: 'SetManifestTruckOutput';
  conflictWarning?: Maybe<Scalars['String']['output']>;
};

export type SetMirrorTargetCompaniesInput = {
  /** Producer-side company UUIDs this target mirrors via the cron. */
  companyUuids: Array<Scalars['String']['input']>;
  targetUuid: Scalars['String']['input'];
};

export type SetMotiveApiKeyInput = {
  /** The Motive API key to store. */
  apiKey: Scalars['String']['input'];
};

export type SetNotificationCutoverModeInput = {
  /** The event type to configure. */
  eventType: NotificationEventType;
  /** The mode to set for the event type. */
  mode: NotificationEngineMode;
};

export type SetOrderExecutedByInput = {
  offerNote?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
  parts: Array<OrderDelegationPart>;
  peerUuid: Scalars['String']['input'];
  pickupHandling?: InputMaybe<DelegatedPickupHandling>;
  shareEndCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetOrderMirrorCaptureConfigInput = {
  /** Company UUIDs to capture. Required (non-empty) when mode=COMPANIES; ignored otherwise. */
  companyUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 'NONE', 'ALL', or 'COMPANIES'. */
  mode: Scalars['String']['input'];
};

export type SetPeerAccessorialSharesInput = {
  accessorialUuids: Array<Scalars['String']['input']>;
  peerUuid: Scalars['String']['input'];
};

export type SetPeerServiceSharesInput = {
  peerUuid: Scalars['String']['input'];
  serviceUuids: Array<Scalars['String']['input']>;
};

export type SetPndRouteDriverInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

/** Replaces the supplied dimensions of one scheduling resource eligibility rule set. A dimension omitted, or sent as null, keeps its stored rules; the two are identical. A dimension supplied replaces BOTH of its lists, so a request changing only a deny list still sends the allow list it wants to keep; supplying both empty clears that dimension and makes it unrestricted, which is refused without confirmRestrictionRemoval when that dimension restricts the resource today. The three dimensions do not match the same way: read each list field. */
export type SetSchedulingResourceEligibilityRulesInput = {
  /** Write-time confirmation that emptying an allow list currently in force was meant, and the only way one request may lift a restriction. It is validated and discarded, never stored: the stored rules already say what the resource accepts. Needed only when a SUPPLIED dimension whose stored allow list names at least one subject arrives with an empty allow list, because the restriction marker is derived as allow.length > 0, so such a write turns a dedicated resource into one that takes all freight. A dimension whose stored allow list is ALREADY empty needs no confirmation even when its marker is set: that resource refuses every order today, and emptying its allow list is the documented repair. Never inferred, so an unconfirmed removal is refused rather than guessed at. Defaults to false. */
  confirmRestrictionRemoval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Omit this field, or send null, to leave the customer rules exactly as they are; the two mean the same thing. Supplying it replaces BOTH of its lists, and two empty lists clear the dimension. */
  customers?: InputMaybe<SchedulingResourceCustomerEligibilityRulesInput>;
  schedulingResourceId: Scalars['String']['input'];
  /** Omit this field, or send null, to leave the service level rules exactly as they are; the two mean the same thing. Supplying it replaces BOTH of its lists, and two empty lists clear the dimension. */
  services?: InputMaybe<SchedulingResourceServiceEligibilityRulesInput>;
  /** Omit this field, or send null, to leave the tag rules exactly as they are; the two mean the same thing. Supplying it replaces BOTH of its lists, and two empty lists clear the dimension. */
  tags?: InputMaybe<SchedulingResourceTagEligibilityRulesInput>;
};

export type SetStorageOrderItemQuantityInput = {
  itemUuid: Scalars['String']['input'];
  /** The updated total quantity for the specified item. */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
};

export type SetTerminalTimeZoneInput = {
  terminalUuid: Scalars['String']['input'];
  /** IANA zone to pin as a manual override; null clears the override and resolves the zone from the terminal address again */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type SettlementAdjustmentCreateInput = {
  adjustmentType: SettlementAdjustmentType;
  driverSettlementBillUuid: Scalars['String']['input'];
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SettlementAdjustmentEntity = {
  __typename?: 'SettlementAdjustmentEntity';
  adjustmentType: SettlementAdjustmentType;
  flatRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentageDecimalRate?: Maybe<Scalars['Float']['output']>;
  totalDollars: Scalars['Currency']['output'];
  uuid: Scalars['String']['output'];
};

/** Type of Adjustment for Settlements. Deductions are negative. Adjustments are positive. */
export enum SettlementAdjustmentType {
  Adjustment = 'ADJUSTMENT',
  Deduction = 'DEDUCTION'
}

export type SettlementAdjustmentUpdateInput = {
  adjustmentType?: InputMaybe<SettlementAdjustmentType>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type SettlementBillChangeFlagEntity = {
  __typename?: 'SettlementBillChangeFlagEntity';
  actorUserUuid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['JSON']['output'];
  /** The frozen snapshot's final cents. Populated by DRIFT_DETECTED only. */
  frozenCents?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  /** The cents a recomputation against current inputs produced. Populated by DRIFT_DETECTED only. */
  observedCents?: Maybe<Scalars['Float']['output']>;
  resolutionNote?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedByUserUuid?: Maybe<Scalars['String']['output']>;
  settlementBillLineItemId?: Maybe<Scalars['String']['output']>;
  shipmentUuid?: Maybe<Scalars['String']['output']>;
  source: SettlementBillChangeFlagSource;
};

/** Why a finalized settlement bill was flagged. Each value names the write that reached a bill whose pay calculation is already frozen. */
export enum SettlementBillChangeFlagSource {
  DriftDetected = 'DRIFT_DETECTED',
  LegacyUnfinalizeAttempt = 'LEGACY_UNFINALIZE_ATTEMPT',
  LineItemReplacement = 'LINE_ITEM_REPLACEMENT',
  MapDelete = 'MAP_DELETE',
  MapMembershipWrite = 'MAP_MEMBERSHIP_WRITE',
  PayTermsWrite = 'PAY_TERMS_WRITE'
}

export type SettlementBillDriftEntity = {
  __typename?: 'SettlementBillDriftEntity';
  /** True when recomputing the bill against its current inputs produces a different total than the frozen calculation. */
  drifted: Scalars['Boolean']['output'];
  driverSettlementBillUuid: Scalars['String']['output'];
  /** Final cents recorded by the frozen calculation. */
  frozenCents?: Maybe<Scalars['Float']['output']>;
  /** False when the bill has never been finalized, in which case there is nothing frozen to drift from. */
  hasFrozenCalculation: Scalars['Boolean']['output'];
  /** Final cents a recomputation against the bill's current inputs produces. */
  observedCents?: Maybe<Scalars['Float']['output']>;
};

export type SettlementBillLineItemConnection = {
  __typename?: 'SettlementBillLineItemConnection';
  edges: Array<SettlementBillLineItemEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SettlementBillLineItemEdge = {
  __typename?: 'SettlementBillLineItemEdge';
  cursor: Scalars['String']['output'];
  node: SettlementBillLineItemEntity;
};

/** A line item on a settlement bill. Used to track costs associated with a shipment and driver. */
export type SettlementBillLineItemEntity = {
  __typename?: 'SettlementBillLineItemEntity';
  customCosts: Array<CustomCostEntity>;
  driver: DriverEntity;
  driverSettlementBill?: Maybe<DriverSettlementBillEntity>;
  freightCost?: Maybe<FreightCostEntity>;
  id: Scalars['String']['output'];
  /** The the revenue flat rate in dollars if it exists. Meant for presentation */
  revenueFlatRate?: Maybe<Scalars['Float']['output']>;
  /** The percentage rate as a percentage out of 100, if it exists */
  revenuePercentageRate?: Maybe<Scalars['Percent']['output']>;
  settlementMode: SettlementMode;
  shipment: ShipmentEntity;
  /** The total cost for the settlement bill line item in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars: Scalars['Float']['output'];
};

export type SettlementChargeBreakdownLineOutput = {
  __typename?: 'SettlementChargeBreakdownLineOutput';
  eligibleAmount: Scalars['Float']['output'];
  flatRate?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  lineType: SettlementChargeBreakdownLineType;
  percentageRate?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export enum SettlementChargeBreakdownLineType {
  Accessorial = 'ACCESSORIAL',
  AccessorialAdjustment = 'ACCESSORIAL_ADJUSTMENT',
  Deduction = 'DEDUCTION',
  Freight = 'FREIGHT',
  Fuel = 'FUEL'
}

export type SettlementDeductionCreateInput = {
  driverSettlementBillUuid: Scalars['String']['input'];
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SettlementDeductionEntity = {
  __typename?: 'SettlementDeductionEntity';
  adjustmentType?: Maybe<SettlementAdjustmentType>;
  flatRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentageDecimalRate?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type SettlementDeductionForDownloadEntity = {
  __typename?: 'SettlementDeductionForDownloadEntity';
  flatRate?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentageDecimalRate?: Maybe<Scalars['Float']['output']>;
};

export type SettlementDeductionTypeCreateInput = {
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SettlementDeductionTypeEntity = {
  __typename?: 'SettlementDeductionTypeEntity';
  flatRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentageRate?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type SettlementDeductionTypeUpdateInput = {
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type SettlementDeductionUpdateInput = {
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export enum SettlementMode {
  Dependent = 'DEPENDENT',
  Independent = 'INDEPENDENT'
}

export type SettlementPayBasisOutput = {
  __typename?: 'SettlementPayBasisOutput';
  basisType: SettlementPayBasisType;
  flatAmount?: Maybe<Scalars['Float']['output']>;
  isBounded: Scalars['Boolean']['output'];
  maxPay?: Maybe<Scalars['Float']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
  minPay?: Maybe<Scalars['Float']['output']>;
  perMileRate?: Maybe<Scalars['Float']['output']>;
  percentageOutOf100?: Maybe<Scalars['Float']['output']>;
};

export enum SettlementPayBasisType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE',
  PerMile = 'PER_MILE'
}

export enum SettlementPayCaptureReason {
  DraftAdoption = 'DRAFT_ADOPTION',
  ExplicitReconfiguration = 'EXPLICIT_RECONFIGURATION',
  PayableActivation = 'PAYABLE_ACTIVATION'
}

export enum SettlementPayRateSource {
  DriverDefault = 'DRIVER_DEFAULT',
  MapFlatOverride = 'MAP_FLAT_OVERRIDE',
  MapPercentageOverride = 'MAP_PERCENTAGE_OVERRIDE'
}

export enum SettlementPayTermsCaptureState {
  Captured = 'CAPTURED',
  LegacyUnknown = 'LEGACY_UNKNOWN',
  Uncaptured = 'UNCAPTURED'
}

export type SettlementStopChargeBreakdownOutput = {
  __typename?: 'SettlementStopChargeBreakdownOutput';
  driverPayout: Scalars['Float']['output'];
  lines: Array<SettlementChargeBreakdownLineOutput>;
  payBasis: SettlementPayBasisOutput;
  totalEligibleAmount: Scalars['Float']['output'];
};

export type SftpCredentialsEntity = {
  __typename?: 'SftpCredentialsEntity';
  bundleShipmentPhotosWithPod: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  host: Scalars['String']['output'];
  invoicePath?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  podNamingConvention?: Maybe<PodNamingConvention>;
  port: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SftpUploadConnection = {
  __typename?: 'SftpUploadConnection';
  edges: Array<SftpUploadEdge>;
  pageInfo: PageInfo;
};

export type SftpUploadEdge = {
  __typename?: 'SftpUploadEdge';
  cursor: Scalars['String']['output'];
  node: SftpUploadEntity;
};

export type SftpUploadEntity = {
  __typename?: 'SftpUploadEntity';
  company: CompanyEntity;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<OrderEntity>;
  order?: Maybe<OrderEntity>;
  path?: Maybe<Scalars['String']['output']>;
  status: SftpUploadStatus;
  type: SftpUploadType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum SftpUploadStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Retried = 'RETRIED'
}

export enum SftpUploadType {
  Invoice = 'INVOICE',
  KuehneNagelXml = 'KUEHNE_NAGEL_XML',
  Pod = 'POD'
}

export type ShareSavedFilterViewInput = {
  grants: Array<SavedFilterViewGrantInput>;
  isPublicToCompany: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type ShipmentArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  shipmentCreateInput?: InputMaybe<ShipmentCreateInput>;
  /** Pass this field in to update an array item */
  shipmentUpdateInput?: InputMaybe<ShipmentUpdateInput>;
};

export type ShipmentChargeEntity = {
  __typename?: 'ShipmentChargeEntity';
  totalCharge: Scalars['Float']['output'];
  totalCustomCharge: Scalars['Float']['output'];
  totalFreightCharge: Scalars['Float']['output'];
  totalFuelCharge: Scalars['Float']['output'];
};

export type ShipmentConnection = {
  __typename?: 'ShipmentConnection';
  edges: Array<ShipmentEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ShipmentConsolidationType {
  ConsolidatedIn = 'CONSOLIDATED_IN',
  Standard = 'STANDARD'
}

export type ShipmentCreateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customChargeCreateInputs?: InputMaybe<Array<CustomChargeCreateInput>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  documentConnectInputs?: InputMaybe<Array<DocumentConnectInput>>;
  documentCreateInputs?: InputMaybe<Array<DocumentCreateInput>>;
  freightChargeCreateInput?: InputMaybe<FreightChargeCreateInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemCreateInputs?: InputMaybe<Array<IndependentSettlementBillLineItemCreateInput>>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  legCreateInputs?: InputMaybe<Array<LegCreateInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageCreateInputs?: InputMaybe<Array<PackageCreateInput>>;
  shipmentSubscriberUpsertInputs?: InputMaybe<Array<ShipmentSubscriberUpsertInput>>;
  shipmentType?: InputMaybe<ShipmentType>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsCreateInput?: InputMaybe<StandardShipmentFieldsCreateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type ShipmentEdge = {
  __typename?: 'ShipmentEdge';
  cursor: Scalars['String']['output'];
  node: ShipmentEntity;
};

export type ShipmentEntity = {
  airline?: Maybe<Scalars['String']['output']>;
  airportInfo?: Maybe<AirportInfoEntity>;
  billingShipmentStatus?: Maybe<BillingShipmentStatus>;
  charges: Array<ChargesUnion>;
  consigneeAddress?: Maybe<AddressEntity>;
  consolidatableShipment?: Maybe<ShipmentEntity>;
  consolidatableShipments?: Maybe<Array<ShipmentEntity>>;
  customCharges: Array<CustomChargeEntity>;
  dateAddedToInvoice?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedFinalized?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOfd?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  documents: Array<DocumentEntity>;
  failureCount: Scalars['Float']['output'];
  fields?: Maybe<StandardShipmentFieldsEntity>;
  freightCharge?: Maybe<FreightChargeEntity>;
  freightNeedsRate: Scalars['Boolean']['output'];
  hasBillingIssues?: Maybe<Scalars['DateTime']['output']>;
  hasFailedStop: Scalars['Boolean']['output'];
  hasSignedPOD: Scalars['Boolean']['output'];
  hideFromBilling: Scalars['Boolean']['output'];
  independentSettlementBillLineItems: Array<SettlementBillLineItemEntity>;
  inputForConsolidatedOrder?: Maybe<OrderEntity>;
  invoice?: Maybe<InvoiceEntity>;
  legs: Array<LegEntity>;
  name: Scalars['String']['output'];
  order?: Maybe<OrderEntity>;
  ordinal: Scalars['Float']['output'];
  overridePackageWeight: Scalars['Boolean']['output'];
  packages: Array<PackageEntity>;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  settlementBillLineItems: Array<SettlementBillLineItemEntity>;
  /** The shipment total charge, freight charge total, fuel charge total, and custom charge total in dollars */
  shipmentCharges: ShipmentChargeEntity;
  shipmentConsolidationType: ShipmentConsolidationType;
  shipmentSubscribers: Array<ShipmentSubscriberEntity>;
  shipmentType: ShipmentType;
  shipperAddress?: Maybe<AddressEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  shouldUseDimWeight: Scalars['Boolean']['output'];
  standardShipmentFields?: Maybe<StandardShipmentFieldsEntity>;
  status: ShipmentStatus;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the shipment in dollars */
  totalChargesAmount: Scalars['Float']['output'];
  totalChargesForDriverSettlement: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type ShipmentIncludedInRevenueEntity = {
  __typename?: 'ShipmentIncludedInRevenueEntity';
  shipmentTypeForCharge: ShipmentTypeForCharge;
  shipmentUuid: Scalars['String']['output'];
  terminalCode?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
};

export enum ShipmentPdfColumnMapping {
  DeliveryDate = 'DELIVERY_DATE',
  PickupOrDelivery = 'PICKUP_OR_DELIVERY',
  ServiceLevel = 'SERVICE_LEVEL',
  TotalChargeAmount = 'TOTAL_CHARGE_AMOUNT'
}

export enum ShipmentStatus {
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Finalized = 'FINALIZED',
  HasIssue = 'HAS_ISSUE',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Paid = 'PAID'
}

export type ShipmentStatusFilter = {
  filterType: ShipmentStatusFilterType;
  status: ShipmentStatus;
};

export enum ShipmentStatusFilterType {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export enum ShipmentStatusWithoutBilling {
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  InProgress = 'IN_PROGRESS',
  OutForDelivery = 'OUT_FOR_DELIVERY'
}

export type ShipmentSubscriberEntity = {
  __typename?: 'ShipmentSubscriberEntity';
  email?: Maybe<Scalars['String']['output']>;
  /** Subscriber phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Subscriber uuid */
  uuid: Scalars['String']['output'];
};

export type ShipmentSubscriberUpsertInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** Subscriber phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Subscriber uuid */
  uuid: Scalars['String']['input'];
};

export enum ShipmentType {
  LineHaul = 'LINE_HAUL',
  OrderCharges = 'ORDER_CHARGES',
  Regular = 'REGULAR'
}

export enum ShipmentTypeForCharge {
  Delivery = 'DELIVERY',
  LineHaul = 'LINE_HAUL',
  OrderCharge = 'ORDER_CHARGE',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY',
  Transfer = 'TRANSFER'
}

export type ShipmentUpdateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  customChargeArrayUpdateInputs?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  /** When sent, the custom charge save stops replacing the whole set and deletes only the charges listed here. Only updateStandardOrder accepts it; other operations refuse a non-null list. */
  deletedCustomChargeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  freightChargeUpsertInput?: InputMaybe<FreightChargeUpsertInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemUpsertInputs?: InputMaybe<Array<IndependentSettlementBillLineItemUpsertInput>>;
  legUpdateInput?: InputMaybe<LegUpdateInput>;
  /** @deprecated Prefer legUpdateInput - array update with upserts is problematic */
  legUpsertInputs?: InputMaybe<Array<LegUpsertInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsUpdateInput?: InputMaybe<StandardShipmentFieldsUpdateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type ShipperBillOfLadingNumberSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type SignUpForThirdPartyUserAccountInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignUpForThirdPartyUserAccountOutput = {
  __typename?: 'SignUpForThirdPartyUserAccountOutput';
  status: SignUpForThirdPartyUserAccountStatus;
  thirdPartyUser?: Maybe<ThirdPartyUserEntity>;
};

export enum SignUpForThirdPartyUserAccountStatus {
  EmailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  Success = 'SUCCESS'
}

/** Which party's signature a placement belongs to. */
export enum SignatureParty {
  Consignee = 'CONSIGNEE',
  Driver = 'DRIVER',
  Shipper = 'SHIPPER'
}

export type SignaturePlacementInput = {
  party?: InputMaybe<SignatureParty>;
  rect?: InputMaybe<SignaturePlacementRectInput>;
  suggestedRect?: InputMaybe<SignaturePlacementRectInput>;
  suggestedSource?: InputMaybe<SignaturePlacementSource>;
  suggestedTargetPage?: InputMaybe<Scalars['Int']['input']>;
  targetPage: Scalars['Int']['input'];
};

export type SignaturePlacementRectInput = {
  h: Scalars['Float']['input'];
  l: Scalars['Float']['input'];
  t: Scalars['Float']['input'];
  w: Scalars['Float']['input'];
};

export enum SignaturePlacementSource {
  AnchorDetected = 'ANCHOR_DETECTED',
  Ml = 'ML',
  Operator = 'OPERATOR'
}

export type SignaturePlacementSuggestionEntity = {
  __typename?: 'SignaturePlacementSuggestionEntity';
  pageImageUrl?: Maybe<Scalars['String']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  rect?: Maybe<SignatureRectEntity>;
  source: SignaturePlacementSource;
  targetPage: Scalars['Int']['output'];
};

export type SignatureRectEntity = {
  __typename?: 'SignatureRectEntity';
  h: Scalars['Float']['output'];
  l: Scalars['Float']['output'];
  t: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
};

export enum SignedPodMatchStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Matched = 'MATCHED',
  Unmatched = 'UNMATCHED'
}

/** Why a document cannot currently be offered for e-signature. */
export enum SigningUnavailableReason {
  ConversionFailed = 'CONVERSION_FAILED',
  UnsupportedFileType = 'UNSUPPORTED_FILE_TYPE'
}

export type SimpleCustomCharge = {
  __typename?: 'SimpleCustomCharge';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type SimpleFreightCharge = {
  __typename?: 'SimpleFreightCharge';
  amount: Scalars['Float']['output'];
  billingMethod: FreightBillingMethod;
  quantity: Scalars['Float']['output'];
  rate: Scalars['String']['output'];
};

export type SimpleFuelCharge = {
  __typename?: 'SimpleFuelCharge';
  amount: Scalars['Float']['output'];
  billingMethod: FuelBillingMethod;
  quantity: Scalars['Float']['output'];
};

export type SkidBasedAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ratePerSkid: Scalars['Float']['input'];
};

export type SkidBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'SkidBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  ratePerSkid: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type SkidBasedAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratePerSkid?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type Smc3AvailableTariffsResultEntity = {
  __typename?: 'Smc3AvailableTariffsResultEntity';
  failure?: Maybe<Smc3ConnectionFailureEntity>;
  tariffs: Array<Smc3TariffEntity>;
};

export type Smc3ConnectionFailureEntity = {
  __typename?: 'Smc3ConnectionFailureEntity';
  code: ExternalRatingErrorCode;
  providerCode?: Maybe<Scalars['String']['output']>;
  providerMessage?: Maybe<Scalars['String']['output']>;
  retryAfter?: Maybe<Scalars['DateTime']['output']>;
  retryable: Scalars['Boolean']['output'];
};

export type Smc3ConnectionTestResultEntity = {
  __typename?: 'Smc3ConnectionTestResultEntity';
  connected: Scalars['Boolean']['output'];
  failure?: Maybe<Smc3ConnectionFailureEntity>;
};

export type Smc3DiagnosticsEntity = {
  __typename?: 'Smc3DiagnosticsEntity';
  lastErrorAt?: Maybe<Scalars['DateTime']['output']>;
  lastErrorCode?: Maybe<ExternalRatingErrorCode>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum Smc3Environment {
  Production = 'PRODUCTION',
  Trial = 'TRIAL'
}

export type Smc3SettingsEntity = {
  __typename?: 'Smc3SettingsEntity';
  defaultTariffName?: Maybe<Scalars['String']['output']>;
  /** Null when the diagnostics store cannot be read. */
  diagnostics?: Maybe<Smc3DiagnosticsEntity>;
  environment?: Maybe<Smc3Environment>;
  hasCredentials: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  pinnedTariffEffectiveDate?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Smc3SettingsSaveResultEntity = {
  __typename?: 'Smc3SettingsSaveResultEntity';
  /** Set when SMC3 refused the connection; nothing was saved. */
  failure?: Maybe<Smc3ConnectionFailureEntity>;
  settings: Smc3SettingsEntity;
};

export type Smc3TariffEntity = {
  __typename?: 'Smc3TariffEntity';
  /** Listed effective dates, newest first. */
  effectiveDates: Array<Scalars['String']['output']>;
  tariffName: Scalars['String']['output'];
};

export type Smc3TestRateResultEntity = {
  __typename?: 'Smc3TestRateResultEntity';
  failure?: Maybe<Smc3ConnectionFailureEntity>;
  finalCents?: Maybe<Scalars['Int']['output']>;
  tariffEffectiveDate?: Maybe<Scalars['String']['output']>;
  tariffName?: Maybe<Scalars['String']['output']>;
};

export type SmsConsentAdminConnection = {
  __typename?: 'SmsConsentAdminConnection';
  edges: Array<SmsConsentAdminEdge>;
  pageInfo: PageInfo;
};

export type SmsConsentAdminEdge = {
  __typename?: 'SmsConsentAdminEdge';
  cursor: Scalars['String']['output'];
  node: SmsConsentAdminEntity;
};

export type SmsConsentAdminEntity = {
  __typename?: 'SmsConsentAdminEntity';
  basis: SmsConsentBasis;
  consecutiveFailures: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  events: Array<SmsConsentAdminEventEntity>;
  historyTruncated: Scalars['Boolean']['output'];
  landline?: Maybe<Scalars['Boolean']['output']>;
  lastFailureAt?: Maybe<Scalars['DateTime']['output']>;
  lastFailureCode?: Maybe<Scalars['Int']['output']>;
  lineTypeCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  maskedPhoneNumber: Scalars['String']['output'];
  optedInAt?: Maybe<Scalars['DateTime']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  status: SmsConsentStatus;
  undeliverableUntil?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type SmsConsentAdminEventEntity = {
  __typename?: 'SmsConsentAdminEventEntity';
  action: SmsConsentEventAction;
  occurredAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SmsConsentAdminFilterInput = {
  landline?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SmsConsentStatus>;
};

/** How the number reached us: CARRIER_PROVIDED on a delivery order, or WEB_FORM on the public opt-in page. */
export enum SmsConsentBasis {
  CarrierProvided = 'CARRIER_PROVIDED',
  WebForm = 'WEB_FORM'
}

/** One recorded change to a consent row. */
export enum SmsConsentEventAction {
  CarrierGranted = 'CARRIER_GRANTED',
  Confirmed = 'CONFIRMED',
  Requested = 'REQUESTED',
  Resumed = 'RESUMED',
  Revoked = 'REVOKED'
}

/** PENDING is a web-form request not yet confirmed from the handset; GRANTED may be texted; REVOKED has opted out. */
export enum SmsConsentStatus {
  Granted = 'GRANTED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

/** Represents the difference between 2 versions of an address. Used in audit log entries */
export type SnapshotAddressDifferences = {
  __typename?: 'SnapshotAddressDifferences';
  city?: Maybe<StringFieldDifference>;
  line1?: Maybe<StringFieldDifference>;
  name?: Maybe<StringFieldDifference>;
  state?: Maybe<StringFieldDifference>;
  zip?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of a custom charge. Used in audit log entries */
export type SnapshotCustomChargeDifferences = {
  __typename?: 'SnapshotCustomChargeDifferences';
  name?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

/** Represents the difference between 2 versions of a custom cost */
export type SnapshotCustomCostDifferences = {
  __typename?: 'SnapshotCustomCostDifferences';
  name?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

/** Represents the difference between 2 versions of a freight charge. Used in audit log entries */
export type SnapshotFreightChargeDifferences = {
  __typename?: 'SnapshotFreightChargeDifferences';
  billingMethod?: Maybe<StringFieldDifference>;
  externalRating?: Maybe<StringFieldDifference>;
  fuelCharge?: Maybe<SnapshotFuelChargeDifferences>;
  tariff?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
};

/** Represents the difference between 2 versions of a freight cost */
export type SnapshotFreightCostDifferences = {
  __typename?: 'SnapshotFreightCostDifferences';
  billingMethod?: Maybe<StringFieldDifference>;
  fuelCost?: Maybe<SnapshotFuelCostDifferences>;
  tariff?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
};

/** Represents the difference between 2 versions of a fuel charge. Used in audit log entries */
export type SnapshotFuelChargeDifferences = {
  __typename?: 'SnapshotFuelChargeDifferences';
  surchargeRate?: Maybe<NumberFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  type?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of a fuel cost */
export type SnapshotFuelCostDifferences = {
  __typename?: 'SnapshotFuelCostDifferences';
  billingMethod?: Maybe<StringFieldDifference>;
  surchargeRate?: Maybe<NumberFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  type?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of an independent settlement bill line item */
export type SnapshotIndependentSettlementBillLineItemDifferences = {
  __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences';
  customCosts?: Maybe<Array<SnapshotCustomCostDifferences>>;
  driverName?: Maybe<StringFieldDifference>;
  freightCost?: Maybe<SnapshotFreightCostDifferences>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

/** Represents the difference between 2 versions of an order. Used in audit log entries */
export type SnapshotOrderDifferences = {
  __typename?: 'SnapshotOrderDifferences';
  billingPartyName?: Maybe<StringFieldDifference>;
  hawb?: Maybe<StringFieldDifference>;
  mawb?: Maybe<StringFieldDifference>;
  packages?: Maybe<Array<SnapshotPackageDifferences>>;
  refNumbers?: Maybe<StringArrayFieldDifference>;
  serviceLevel?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  vehicleType?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of a package. Used in audit log entries */
export type SnapshotPackageDifferences = {
  __typename?: 'SnapshotPackageDifferences';
  description?: Maybe<StringFieldDifference>;
  height?: Maybe<NumberFieldDifference>;
  length?: Maybe<NumberFieldDifference>;
  quantity?: Maybe<NumberFieldDifference>;
  type?: Maybe<StringFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
  weight?: Maybe<NumberFieldDifference>;
  width?: Maybe<NumberFieldDifference>;
};

/** Represents the difference between 2 versions of a stop. Used in audit log entries */
export type SnapshotStopDifferences = {
  __typename?: 'SnapshotStopDifferences';
  address?: Maybe<SnapshotAddressDifferences>;
  appointmentManuallyConfirmed?: Maybe<BooleanFieldDifference>;
  appointmentRequired?: Maybe<BooleanFieldDifference>;
  customCharges?: Maybe<Array<SnapshotCustomChargeDifferences>>;
  driverName?: Maybe<StringFieldDifference>;
  freightCharge?: Maybe<SnapshotFreightChargeDifferences>;
  independentSettlementBillLineItems?: Maybe<Array<SnapshotIndependentSettlementBillLineItemDifferences>>;
  isSpecial?: Maybe<BooleanFieldDifference>;
  serviceDate?: Maybe<StringFieldDifference>;
  serviceDateIso8601?: Maybe<StringFieldDifference>;
  stopType?: Maybe<StringFieldDifference>;
  terminal?: Maybe<StringFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpecialAccessorialChargeGroupArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  specialAccessorialChargeGroupCreateInput?: InputMaybe<SpecialAccessorialChargeGroupCreateInput>;
  /** Pass this field in to update an array item */
  specialAccessorialChargeGroupUpdateInput?: InputMaybe<SpecialAccessorialChargeGroupUpdateInput>;
};

export type SpecialAccessorialChargeGroupCreateInput = {
  dayOfWeek: SpecialDayOfWeek;
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type SpecialAccessorialChargeGroupEntity = {
  __typename?: 'SpecialAccessorialChargeGroupEntity';
  dayOfWeek: SpecialDayOfWeek;
  endTime: Scalars['DateTime']['output'];
  startTime: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SpecialAccessorialChargeGroupUpdateInput = {
  dayOfWeek?: InputMaybe<SpecialDayOfWeek>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type SpecialAccessorialCreateInput = {
  name: Scalars['String']['input'];
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  specialAccessorialType?: InputMaybe<SpecialAccessorialType>;
  specialChargeGroups: Array<SpecialAccessorialChargeGroupCreateInput>;
  specialMatrixItems: Array<SpecialAccessorialMatrixItemCreateInput>;
  specialMileRanges?: InputMaybe<Array<SpecialAccessorialMileRangeCreateInput>>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialAccessorialEntity = AccessorialInterface & {
  __typename?: 'SpecialAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  chargeGroups: Array<SpecialAccessorialChargeGroupEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  /** @deprecated Prefer the isSpecial field on the accessorial charge's corresponding stop */
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  matrixItems: Array<SpecialAccessorialMatrixItemEntity>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  serviceLevel?: Maybe<ServiceEntity>;
  specialAccessorialType?: Maybe<SpecialAccessorialType>;
  tariffZoneGroup?: Maybe<TariffZoneGroupEntity>;
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  zones: Array<TariffZoneEntity>;
};


export type SpecialAccessorialEntityChargeGroupsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SpecialAccessorialEntityMatrixItemsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SpecialAccessorialMatrixItemArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  matrixItemCreateInput?: InputMaybe<SpecialAccessorialMatrixItemCreateInput>;
  /** Pass this field in to update an array item */
  matrixItemUpdateInput?: InputMaybe<SpecialAccessorialMatrixItemUpdateInput>;
};

export type SpecialAccessorialMatrixItemCreateInput = {
  chargeGroupDayOfWeek: SpecialDayOfWeek;
  chargeGroupEndTime: Scalars['DateTime']['input'];
  chargeGroupStartTime: Scalars['DateTime']['input'];
  chargeGroupUuid?: InputMaybe<Scalars['String']['input']>;
  /** Accepts rate as a $ float with two decimal places */
  rate: Scalars['Float']['input'];
  tariffZoneUuid: Scalars['String']['input'];
};

export type SpecialAccessorialMatrixItemEntity = {
  __typename?: 'SpecialAccessorialMatrixItemEntity';
  chargeGroupUuid: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  tariffZone: TariffZoneEntity;
  uuid: Scalars['String']['output'];
  zoneUuid: Scalars['String']['output'];
};

export type SpecialAccessorialMatrixItemUpdateInput = {
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type SpecialAccessorialMileRangeCreateInput = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
  /** UUIDs are generated on the frontend so that we can link matrix items to mile ranges on the frontend without first creating the mile ranges */
  uuid: Scalars['String']['input'];
};

export enum SpecialAccessorialType {
  MileageBased = 'MILEAGE_BASED',
  ZoneBased = 'ZONE_BASED'
}

export type SpecialAccessorialUpdateInput = {
  chargeGroupUpdates?: InputMaybe<Array<SpecialAccessorialChargeGroupArrayUpdateInput>>;
  matrixItemsArrayUpdateInput?: InputMaybe<Array<SpecialAccessorialMatrixItemArrayUpdateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum SpecialDayOfWeek {
  Holiday = 'HOLIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Weekday = 'WEEKDAY'
}

export type SplitAndProcessOrderDocumentsInput = {
  /** A flag that determines whether the EOD documents should be automatched to the orders */
  autoMatchingEnabled: Scalars['Boolean']['input'];
  /** The UUID of the company the EOD documents are being matched for */
  companyUuid: Scalars['String']['input'];
  /** The day the EOD documents are being matched for */
  currentDate: Scalars['DateTime']['input'];
  orderDocuments: Array<OrderDocumentInput>;
};

export type StandardAccessorialCreateInput = {
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** Accepts rate as a $ float with two decimal places */
  rate: Scalars['Float']['input'];
};

export type StandardAccessorialEntity = AccessorialInterface & {
  __typename?: 'StandardAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type StandardAccessorialUpdateInput = {
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  /** Rate in $, will be truncated to two decimal places */
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type StandardOrderCreateInput = {
  apiReceivedReference?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactStationId?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid: Scalars['String']['input'];
  callerName?: InputMaybe<Scalars['String']['input']>;
  callerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  chargeableWeightCubicMeters?: InputMaybe<Scalars['Volume']['input']>;
  codCheckAmountCents?: InputMaybe<Scalars['Int']['input']>;
  codCheckNumber?: InputMaybe<Scalars['String']['input']>;
  createdFromOrderTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  csvOrderImportStatus?: InputMaybe<CsvOrderImportStatus>;
  customerPortalChargesVisibleFromOverride?: InputMaybe<CustomerPortalChargesVisibility>;
  dateMarkedOnHand?: InputMaybe<Scalars['DateTime']['input']>;
  dateMarkedReceivedAtOrigin?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  displayChargesInCustomerPortalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  documentCreateInputs?: InputMaybe<Array<DocumentCreateInput>>;
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ediConsigneeAddressCreateInput?: InputMaybe<AddressCreateInput>;
  ediConsigneeContactPersonCreateInput?: InputMaybe<ContactPersonCreateInput>;
  ediEquipmentType?: InputMaybe<Scalars['String']['input']>;
  ediReceivedScac?: InputMaybe<Scalars['String']['input']>;
  ediShipperAddressCreateInput?: InputMaybe<AddressCreateInput>;
  ediShipperContactPersonCreateInput?: InputMaybe<ContactPersonCreateInput>;
  efmServiceLevelCode?: InputMaybe<Scalars['String']['input']>;
  emergencyResponseNumber?: InputMaybe<Scalars['String']['input']>;
  enableLinehaul?: InputMaybe<Scalars['Boolean']['input']>;
  externalNotes?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  hazmatClass?: InputMaybe<HazmatClass>;
  hazmatDescription?: InputMaybe<Scalars['String']['input']>;
  holdReasonUuid?: InputMaybe<Scalars['String']['input']>;
  inBond?: InputMaybe<Scalars['Boolean']['input']>;
  inboundShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  inboundStopIntention?: InputMaybe<StopIntention>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  isDoorToDoor?: InputMaybe<Scalars['Boolean']['input']>;
  isDraftOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isReweighed?: InputMaybe<Scalars['Boolean']['input']>;
  issueReason?: InputMaybe<Scalars['String']['input']>;
  itTeIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  itTeNumber?: InputMaybe<Scalars['String']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulOriginTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  lockSecondaryRefNumber?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHold?: InputMaybe<Scalars['DateTime']['input']>;
  orderChargesShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  orderCommentCreateInputs?: InputMaybe<Array<CreateOrderCommentInput>>;
  orderConsolidationType?: InputMaybe<OrderConsolidationType>;
  orderSegmentType?: InputMaybe<OrderSegmentType>;
  outboundShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  outboundStopIntention?: InputMaybe<StopIntention>;
  packageCreateInputs?: InputMaybe<Array<PackageCreateInput>>;
  packageGroup?: InputMaybe<PackageGroup>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  personEmail?: InputMaybe<Scalars['String']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  personPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickedDate?: InputMaybe<Scalars['DateTime']['input']>;
  pieceCount?: InputMaybe<Scalars['Float']['input']>;
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  quaternaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  quinaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  /** If false, the charges for the order will not be recalculated. This should only be used on manual order creation when client-side order rating has already been done. */
  recalculateCharges?: InputMaybe<Scalars['Boolean']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  recurringOrderFrequencyCreateInput?: InputMaybe<CreateRecurringOrderFrequencyInput>;
  refNumbers: Array<Scalars['String']['input']>;
  refusedBy?: InputMaybe<Scalars['String']['input']>;
  requiresPlacard?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentCreateInputs?: InputMaybe<Array<StandardShipmentCreateInput>>;
  source: OrderSource;
  standardOrderFieldsCreateInput?: InputMaybe<StandardOrderFieldsCreateInput>;
  status?: InputMaybe<OrderStatus>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tertiaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  thirdPartyBrokerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  /** Defaults to the order piece count (the sum of package quantities) when omitted. */
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  unNumber?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StandardOrderEntity = OrderEntity & {
  __typename?: 'StandardOrderEntity';
  appliedAmount: Scalars['Float']['output'];
  balanceInCents: Scalars['Int']['output'];
  billingPartyContact: CustomerContactEntity;
  billingPartyContactStation?: Maybe<ContactStationEntity>;
  /** @deprecated Use personName */
  callerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: Maybe<Scalars['String']['output']>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  /** The chargeable weight is an optional weight value (measured in cubic meters) that can be used in billing calculations for the order. */
  chargeableWeightCubicMeters?: Maybe<Scalars['Volume']['output']>;
  codCheckAmountCents?: Maybe<Scalars['Int']['output']>;
  codCheckNumber?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consolidatableOrders: ConsolidatableOrdersOutput;
  consolidatedOrders?: Maybe<Array<OrderEntity>>;
  consolidatedShipmentString?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  coverSheetDocumentTypeSequence?: Maybe<CoverSheetDocumentTypeSequenceEntity>;
  createdAt: Scalars['DateTime']['output'];
  createdFromOrderTemplate?: Maybe<OrderEntity>;
  csvOrderImportStatus?: Maybe<CsvOrderImportStatus>;
  /** Total custom charge (accessorial charge) for the order in dollars */
  customChargeRevenue: Scalars['Float']['output'];
  /** Each custom charge (accessorial charge) itemized */
  customCharges: Array<CustomChargeEntity>;
  customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility;
  customerPortalChargesVisibleFromOverride?: Maybe<CustomerPortalChargesVisibility>;
  dateMarkedLoaded?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedReceivedAtOrigin?: Maybe<Scalars['DateTime']['output']>;
  delegationAsDuplicate?: Maybe<OrderDelegationEntity>;
  delegations: Array<OrderDelegationEntity>;
  deletedAutoAppliedAccessorials: Array<AccessorialUnion>;
  detailedStatus?: Maybe<Scalars['String']['output']>;
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  dimWeight: Scalars['Float']['output'];
  displayChargesInCustomerPortalOverride?: Maybe<Scalars['Boolean']['output']>;
  documents: Array<DocumentEntity>;
  driverQualifications: Array<DriverQualificationEntity>;
  driverSettlementTotal: Scalars['Float']['output'];
  ediReceivedScac?: Maybe<Scalars['String']['output']>;
  ediReferences?: Maybe<Array<EdiReferenceEntity>>;
  ediServiceLevelCode?: Maybe<Scalars['String']['output']>;
  ediTransactions: Array<EdiTransactionEntity>;
  emergencyResponseNumber?: Maybe<Scalars['String']['output']>;
  enableLineHaul: Scalars['Boolean']['output'];
  endStop?: Maybe<StopEntity>;
  externalNotes?: Maybe<Scalars['String']['output']>;
  fields: StandardOrderFieldsEntity;
  /** Total freight charge for the order in dollars */
  freightChargeRevenue: Scalars['Float']['output'];
  freightNeedsRate: Scalars['Boolean']['output'];
  /** Total fuel charge for the order in dollars */
  fuelChargeRevenue: Scalars['Float']['output'];
  fulfillmentType?: Maybe<FulfillmentType>;
  hasDamage: Scalars['Boolean']['output'];
  hasDriverPod: Scalars['Boolean']['output'];
  hasDriverUploadedDocument: Scalars['Boolean']['output'];
  hasEdiCancellation: Scalars['Boolean']['output'];
  hasIssues: Scalars['Boolean']['output'];
  hasNoneOrCompletedInboundStop: Scalars['Boolean']['output'];
  hasShortage: Scalars['Boolean']['output'];
  hasUncollectedInboundStop: Scalars['Boolean']['output'];
  hazmat: Scalars['Boolean']['output'];
  hazmatClass?: Maybe<HazmatClass>;
  hazmatDescription?: Maybe<Scalars['String']['output']>;
  holdReason?: Maybe<HoldReasonEntity>;
  inBond: Scalars['Boolean']['output'];
  inboundPaperwork: OrderPaperworkEntity;
  inboundShipment?: Maybe<ShipmentEntity>;
  inboundStopIntention?: Maybe<StopIntention>;
  invoice?: Maybe<InvoiceEntity>;
  isCollectOnDelivery: Scalars['Boolean']['output'];
  isCrossDock?: Maybe<Scalars['Boolean']['output']>;
  isDoorToDoor?: Maybe<Scalars['Boolean']['output']>;
  /** Filters out draft and template orders */
  isDraftOrder: Scalars['Boolean']['output'];
  isOnHand: Scalars['Boolean']['output'];
  isOverdue: Scalars['Boolean']['output'];
  isReturnOrder: Scalars['Boolean']['output'];
  isReverse: Scalars['Boolean']['output'];
  isReweighed: Scalars['Boolean']['output'];
  issueReason?: Maybe<Scalars['String']['output']>;
  itTeIssueDate?: Maybe<Scalars['DateTime']['output']>;
  itTeNumber?: Maybe<Scalars['String']['output']>;
  lastCompletedLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  lastUpdatedByUser?: Maybe<UserActorEntity>;
  lineHaulCompletedDate: Scalars['DateTime']['output'];
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  lineHaulOriginTerminal?: Maybe<TerminalEntity>;
  lineHaulServiceDisplayString: Scalars['String']['output'];
  lineHaulShipment?: Maybe<ShipmentEntity>;
  /** The line haul events associated with an order, such as every stop at a terminal. This is the order’s own timeline, not an audit log of user actions or changes. */
  lineHaulTimeline: Array<OrderLineHaulTimelineEventEntity>;
  lockSecondaryRefNumber: Scalars['Boolean']['output'];
  /** @deprecated Use paperwork.missingDocuments instead */
  missingDocuments: Array<DocumentType>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  numPackagesOnHand: Scalars['Float']['output'];
  onHand?: Maybe<Scalars['Boolean']['output']>;
  onHold: Scalars['Boolean']['output'];
  orderChargesShipment?: Maybe<ShipmentEntity>;
  orderComments: Array<OrderCommentEntity>;
  orderConsolidationType: OrderConsolidationType;
  orderEvents: Array<OrderEventEntity>;
  orderInvoiceByDate?: Maybe<Scalars['DateTime']['output']>;
  orderPaymentMappings: Array<PaymentToOrderMappingEntity>;
  orderSegmentType: OrderSegmentType;
  /** Orders that were prorated with (but not including) this order */
  ordersProratedWith?: Maybe<Array<OrderEntity>>;
  ordersWithSameBillOfLadingNumber: Array<OrderEntity>;
  ordersWithSameBillOfLadingNumberForReviewOrders?: Maybe<Array<StandardOrderEntity>>;
  ordinal: Scalars['Int']['output'];
  /** Packaging as received on this order's original transmission, captured when the order is created and never rewritten. Empty for orders created before the snapshot existed, and for orders created without packages. */
  originalTransmissionPackages: Array<PackageEntity>;
  /** @deprecated Deprecated. Use hasIssues and hasDamage instead. */
  osAndD: Scalars['Boolean']['output'];
  osd?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated. Use hasIssues and hasDamage instead. */
  osdReason?: Maybe<Scalars['String']['output']>;
  outboundPaperwork: OrderPaperworkEntity;
  /** The scans out of the last terminal (if multi-terminal and line haul), or simply departure scans corresponding to outbound delivery */
  outboundScans: Array<ScanEntity>;
  outboundShipment?: Maybe<ShipmentEntity>;
  outboundStopIntention?: Maybe<StopIntention>;
  packageCount: Scalars['Float']['output'];
  packageGroup?: Maybe<PackageGroup>;
  packages: Array<PackageEntity>;
  paperwork: OrderPaperworkEntity;
  paymentMethod?: Maybe<PaymentMethod>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhoneNumber?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  pieceCountFromPackages: Scalars['Float']['output'];
  pieces: Array<PieceEntity>;
  piecesDelivered: PiecesDeliveredEntity;
  piecesLoaded?: Maybe<Scalars['Int']['output']>;
  piecesPicked?: Maybe<Scalars['Int']['output']>;
  piecesPickedUp: PiecesPickedUpEntity;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  quaternaryRefNumber?: Maybe<Scalars['String']['output']>;
  quinaryRefNumber?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<QuoteEntity>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  recurringOrderFrequency?: Maybe<RecurringOrderFrequencyEntity>;
  refNumbers: Array<Scalars['String']['output']>;
  refusedBy?: Maybe<Scalars['String']['output']>;
  refusedDate?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  refusedReasonCode?: Maybe<OrderRefusalReason>;
  requiresPlacard?: Maybe<Scalars['Boolean']['output']>;
  reversalCounterpart?: Maybe<ReversalCounterpartOrder>;
  run?: Maybe<RunEntity>;
  scannedOrderResult?: Maybe<ScannedOrderResultEntity>;
  /** A field that represents a concatenation of all fields on the order that we want to search by. */
  searchText?: Maybe<Scalars['String']['output']>;
  secondaryRefNumber?: Maybe<Scalars['String']['output']>;
  service?: Maybe<ServiceEntity>;
  shipments: Array<ShipmentEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  shouldDisplayChargesInCustomerPortal: Scalars['Boolean']['output'];
  source: OrderSource;
  standardOrderFields: StandardOrderFieldsEntity;
  startStop?: Maybe<StopEntity>;
  status: OrderStatus;
  tags: Array<TagEntity>;
  tertiaryRefNumber?: Maybe<Scalars['String']['output']>;
  thirdPartyBrokers: Array<ThirdPartyBrokerEntity>;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the order in dollars */
  totalCharge: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  totalSkids?: Maybe<Scalars['Int']['output']>;
  unNumber?: Maybe<Scalars['String']['output']>;
  upcomingLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
  warehouse?: Maybe<WarehouseEntity>;
  weight: Scalars['Float']['output'];
};

export type StandardOrderFieldsCreateInput = {
  defaultConsigneeStopCreateInput?: InputMaybe<StopCreateInput>;
  defaultShipperStopCreateInput?: InputMaybe<StopCreateInput>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  driversNeededInVehicle?: InputMaybe<Scalars['Int']['input']>;
  houseAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  lockShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  numberOfConsignees: NumberOfConsignees;
  numberOfShippers: NumberOfShippers;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
};

export type StandardOrderFieldsEntity = {
  __typename?: 'StandardOrderFieldsEntity';
  createdAt: Scalars['DateTime']['output'];
  defaultConsigneeStop?: Maybe<StandardStopEntity>;
  defaultShipperStop?: Maybe<StandardStopEntity>;
  dimFactor?: Maybe<Scalars['Int']['output']>;
  driversNeededInVehicle?: Maybe<Scalars['Int']['output']>;
  /** The HAWB: houseAirwayBillOfLadingNumber when set, otherwise shipperBillOfLadingNumber (the order form's HAWB field). Null when both are blank. */
  hawb?: Maybe<Scalars['String']['output']>;
  houseAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  lockShipperBillOfLadingNumber: Scalars['Boolean']['output'];
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  measurementUnits: MeasurementUnits;
  numberOfConsignees: NumberOfConsignees;
  numberOfShippers: NumberOfShippers;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weightUnits: WeightUnits;
};

export type StandardOrderFieldsUpdateInput = {
  /** @deprecated This field is unused and ignored. */
  defaultConsigneeStopUpsertInput?: InputMaybe<StandardStopUpsertInput>;
  /** @deprecated This field is unused and ignored. */
  defaultShipperStopUpsertInput?: InputMaybe<StandardStopUpsertInput>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  driversNeededInVehicle?: InputMaybe<Scalars['Int']['input']>;
  houseAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  lockShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  numberOfConsignees?: InputMaybe<NumberOfConsignees>;
  numberOfShippers?: InputMaybe<NumberOfShippers>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  weightUnits?: InputMaybe<WeightUnits>;
};

export type StandardOrderUpdateInput = {
  billingPartyContactStationId?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  billingStatus?: InputMaybe<OrderBillingStatus>;
  /** @deprecated Use personName */
  callerName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  chargeableWeightCubicMeters?: InputMaybe<Scalars['Volume']['input']>;
  codCheckAmountCents?: InputMaybe<Scalars['Int']['input']>;
  codCheckNumber?: InputMaybe<Scalars['String']['input']>;
  createdFromOrderTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  customerPortalChargesVisibleFromOverride?: InputMaybe<CustomerPortalChargesVisibility>;
  dateMarkedReceivedAtOrigin?: InputMaybe<Scalars['DateTime']['input']>;
  /** dateMarkedReceivedAtOrigin typed as a wall clock in an entry zone (terminal_local_times). Replaces dateMarkedReceivedAtOrigin when sent. */
  dateMarkedReceivedAtOriginLocal?: InputMaybe<LocalDateTimeInput>;
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Loaded packages the user deleted, with the pieces the form loaded on them. When sent, only these packages are deleted. */
  deletedPackages?: InputMaybe<Array<DeletedPackageInput>>;
  displayChargesInCustomerPortalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  documentUpsertInputs?: InputMaybe<Array<DocumentUpsertInput>>;
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emergencyResponseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Enables line haul features for the order */
  enableLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  externalNotes?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  hasDamage?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  hasShortage?: InputMaybe<Scalars['Boolean']['input']>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  hazmatClass?: InputMaybe<HazmatClass>;
  hazmatDescription?: InputMaybe<Scalars['String']['input']>;
  holdReasonUuid?: InputMaybe<Scalars['String']['input']>;
  inBond?: InputMaybe<Scalars['Boolean']['input']>;
  inboundStopIntention?: InputMaybe<StopIntention>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  isDoorToDoor?: InputMaybe<Scalars['Boolean']['input']>;
  isDraftOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isReweighed?: InputMaybe<Scalars['Boolean']['input']>;
  issueReason?: InputMaybe<Scalars['String']['input']>;
  itTeIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  itTeNumber?: InputMaybe<Scalars['String']['input']>;
  lineHaulChargeSetByOperator?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulOriginTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulRemovedByOperator?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  orderCommentCreateInputs?: InputMaybe<Array<CreateOrderCommentInput>>;
  osd?: InputMaybe<Scalars['Boolean']['input']>;
  outboundStopIntention?: InputMaybe<StopIntention>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  packageGroup?: InputMaybe<PackageGroup>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  personEmail?: InputMaybe<Scalars['String']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  personPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** pickedDate typed as a wall clock in an entry zone (terminal_local_times). Replaces pickedDate when sent. */
  pickedDateLocal?: InputMaybe<LocalDateTimeInput>;
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  recalculateTotals?: InputMaybe<Scalars['Boolean']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** receivedDate typed as a wall clock in an entry zone (terminal_local_times). Replaces receivedDate when sent. */
  receivedDateLocal?: InputMaybe<LocalDateTimeInput>;
  recurringOrderFrequencyUpdateInput?: InputMaybe<UpdateRecurringOrderFrequencyInput>;
  refNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  refusedBy?: InputMaybe<Scalars['String']['input']>;
  refusedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** refusedDate typed as a wall clock in an entry zone (terminal_local_times). Replaces refusedDate when sent. */
  refusedDateLocal?: InputMaybe<LocalDateTimeInput>;
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  requiresPlacard?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentArrayUpdateInputs?: InputMaybe<Array<StandardShipmentArrayUpdateInput>>;
  standardOrderFieldsUpdateInput?: InputMaybe<StandardOrderFieldsUpdateInput>;
  status?: InputMaybe<OrderStatus>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tertiaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  thirdPartyBrokerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  unNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StandardShipmentArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  shipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  /** Pass this field in to update an array item */
  shipmentUpdateInput?: InputMaybe<StandardShipmentUpdateInput>;
};

export type StandardShipmentCreateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customChargeCreateInputs?: InputMaybe<Array<CustomChargeCreateInput>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  documentConnectInputs?: InputMaybe<Array<DocumentConnectInput>>;
  documentCreateInputs?: InputMaybe<Array<DocumentCreateInput>>;
  freightChargeCreateInput?: InputMaybe<FreightChargeCreateInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemCreateInputs?: InputMaybe<Array<IndependentSettlementBillLineItemCreateInput>>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  legCreateInputs?: InputMaybe<Array<LegCreateInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageCreateInputs?: InputMaybe<Array<PackageCreateInput>>;
  shipmentSubscriberUpsertInputs?: InputMaybe<Array<ShipmentSubscriberUpsertInput>>;
  shipmentType?: InputMaybe<ShipmentType>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsCreateInput?: InputMaybe<StandardShipmentFieldsCreateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type StandardShipmentEntity = ShipmentEntity & {
  __typename?: 'StandardShipmentEntity';
  airline?: Maybe<Scalars['String']['output']>;
  airportInfo?: Maybe<AirportInfoEntity>;
  billingShipmentStatus?: Maybe<BillingShipmentStatus>;
  charges: Array<ChargesUnion>;
  consigneeAddress?: Maybe<AddressEntity>;
  consolidatableShipment?: Maybe<ShipmentEntity>;
  consolidatableShipments?: Maybe<Array<ShipmentEntity>>;
  customCharges: Array<CustomChargeEntity>;
  dateAddedToInvoice?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedFinalized?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOfd?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  documents: Array<DocumentEntity>;
  failureCount: Scalars['Float']['output'];
  fields?: Maybe<StandardShipmentFieldsEntity>;
  freightCharge?: Maybe<FreightChargeEntity>;
  freightNeedsRate: Scalars['Boolean']['output'];
  hasBillingIssues?: Maybe<Scalars['DateTime']['output']>;
  hasFailedStop: Scalars['Boolean']['output'];
  hasSignedPOD: Scalars['Boolean']['output'];
  hideFromBilling: Scalars['Boolean']['output'];
  independentSettlementBillLineItems: Array<SettlementBillLineItemEntity>;
  inputForConsolidatedOrder?: Maybe<OrderEntity>;
  invoice?: Maybe<InvoiceEntity>;
  legs: Array<LegEntity>;
  name: Scalars['String']['output'];
  order?: Maybe<OrderEntity>;
  ordinal: Scalars['Float']['output'];
  overridePackageWeight: Scalars['Boolean']['output'];
  packages: Array<PackageEntity>;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  settlementBillLineItems: Array<SettlementBillLineItemEntity>;
  /** The shipment total charge, freight charge total, fuel charge total, and custom charge total in dollars */
  shipmentCharges: ShipmentChargeEntity;
  shipmentConsolidationType: ShipmentConsolidationType;
  shipmentSubscribers: Array<ShipmentSubscriberEntity>;
  shipmentType: ShipmentType;
  shipperAddress?: Maybe<AddressEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  shouldUseDimWeight: Scalars['Boolean']['output'];
  standardShipmentFields: StandardShipmentFieldsEntity;
  status: ShipmentStatus;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the shipment in dollars */
  totalChargesAmount: Scalars['Float']['output'];
  totalChargesForDriverSettlement: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type StandardShipmentFieldsCreateInput = {
  cargoDescription?: InputMaybe<Scalars['String']['input']>;
  cargoPieces?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  pickupOrDelivery: PickupOrDelivery;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  type: StandardShipmentType;
  weightUnits?: InputMaybe<WeightUnits>;
};

export type StandardShipmentFieldsEntity = {
  __typename?: 'StandardShipmentFieldsEntity';
  cargoDescription?: Maybe<Scalars['String']['output']>;
  cargoPieces?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadlineDate?: Maybe<Scalars['DateTime']['output']>;
  deadlineType?: Maybe<DeadlineType>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  dimFactor: Scalars['Int']['output'];
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  measurementUnits: MeasurementUnits;
  outboundMethod?: Maybe<OutboundMethod>;
  pickupOrDelivery: PickupOrDelivery;
  service?: Maybe<ServiceEntity>;
  serviceLevel?: Maybe<ServiceLevel>;
  type: StandardShipmentType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
  weightUnits: WeightUnits;
};

export type StandardShipmentFieldsUpdateInput = {
  cargoDescription?: InputMaybe<Scalars['String']['input']>;
  cargoPieces?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  name?: InputMaybe<Scalars['String']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  standardShipmentFieldsCreateInput?: InputMaybe<StandardShipmentFieldsCreateInput>;
  type?: InputMaybe<StandardShipmentType>;
  uuid: Scalars['String']['input'];
  weightUnits?: InputMaybe<WeightUnits>;
};

export enum StandardShipmentType {
  SingleStop = 'SINGLE_STOP'
}

export type StandardShipmentUpdateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  customChargeArrayUpdateInputs?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  /** When sent, the custom charge save stops replacing the whole set and deletes only the charges listed here. Only updateStandardOrder accepts it; other operations refuse a non-null list. */
  deletedCustomChargeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  freightChargeUpsertInput?: InputMaybe<FreightChargeUpsertInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemUpsertInputs?: InputMaybe<Array<IndependentSettlementBillLineItemUpsertInput>>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  legUpdateInput?: InputMaybe<LegUpdateInput>;
  /** @deprecated Prefer legUpdateInput - array update with upserts is problematic */
  legUpsertInputs?: InputMaybe<Array<LegUpsertInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsUpdateInput?: InputMaybe<StandardShipmentFieldsUpdateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type StandardStopEntity = StopEntity & {
  __typename?: 'StandardStopEntity';
  address: AddressEntity;
  appointmentCallStatus?: Maybe<AppointmentCallStatus>;
  /** The appointment as a day and window in the stop's zone. Null while terminal_local_times is off or without an appointment. */
  appointmentLocal?: Maybe<StopAppointmentLocalEntity>;
  appointmentManuallyConfirmed: Scalars['Boolean']['output'];
  /** Whether the appointment falls on another day at the stop than its route day. False while terminal_local_times is off, off a route, or without a window. */
  appointmentOffRouteDay: Scalars['Boolean']['output'];
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The STORED appointment status. Only CANCELLED is ever stored; null means the status is derived from the confirmation columns, not that there is none. */
  appointmentStatus?: Maybe<AppointmentStatus>;
  appointmentTextStatus?: Maybe<AppointmentTextStatus>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  cachedEta?: Maybe<EtaEntity>;
  canMarkAttemptComplete?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedByAgentAt?: Maybe<Scalars['DateTime']['output']>;
  consigneeAddress?: Maybe<AddressEntity>;
  consigneeContactPerson?: Maybe<ContactPersonEntity>;
  /** True when this stop's current automated call has already been reported as a contact attempt. Reporting it again needs reportAdditionalAttempt. */
  contactAttemptReportedForCurrentCall: Scalars['Boolean']['output'];
  contactPerson?: Maybe<ContactPersonEntity>;
  courierReadyOrDueDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerBookingNotes?: Maybe<Scalars['String']['output']>;
  deadlineTime?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  driverCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  equipment?: Maybe<EquipmentEntity>;
  eta?: Maybe<EtaEntity>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  etaFinishTime?: Maybe<Scalars['DateTime']['output']>;
  etaLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  expectedOutboundDate?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Float']['output']>;
  formattedCallMessage?: Maybe<Scalars['String']['output']>;
  /** returns if a stop has a previous attempt */
  hasPreviousAttempt: Scalars['Boolean']['output'];
  hideFromDispatch?: Maybe<Scalars['Boolean']['output']>;
  inboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  incomingCarrier?: Maybe<Scalars['String']['output']>;
  /** returns if a stop is an attempt */
  isAttempt: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  lastAppointmentTextTime?: Maybe<Scalars['DateTime']['output']>;
  leg?: Maybe<LegEntity>;
  linkedEndStop?: Maybe<StopEntity>;
  /** The local time zone of the stop, based on the address. Defaults to company time zone. */
  localTimeZone?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundCarrier?: Maybe<Scalars['String']['output']>;
  outboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  paperworkMarkedComplete?: Maybe<Scalars['Boolean']['output']>;
  pickupOrDelivery: StopPickupOrDelivery;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeChangeAcknowledged: Scalars['Boolean']['output'];
  routeName?: Maybe<RouteNameEntity>;
  routeSlot?: Maybe<RouteSlotEntity>;
  sentToAgentAt?: Maybe<Scalars['DateTime']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment?: Maybe<ShipmentEntity>;
  /** shipment consignee address- the address for the endStop of the last leg in the shipment that this stop's leg belongs to */
  shipmentConsigneeAddress: AddressEntity;
  /** Total volume of all packages associated with this stop's shipment */
  shipmentTotalVolume: Scalars['Float']['output'];
  /** Total weight of all packages associated with this stop's shipment */
  shipmentTotalWeight: Scalars['Float']['output'];
  shipperAddress?: Maybe<AddressEntity>;
  shipperContactPerson?: Maybe<ContactPersonEntity>;
  showDriverModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  startOrEnd: StartOrEnd;
  status: StopStatus;
  stopDetails?: Maybe<StopDetailsOutput>;
  stopDriverMaps: Array<StopDriverMapEntity>;
  stopIntention?: Maybe<StopIntention>;
  stopType?: Maybe<StopType>;
  terminal?: Maybe<TerminalEntity>;
  textResponses?: Maybe<Scalars['String']['output']>;
  /** The stop's IANA zone: its address zone, then its US ZIP's, then its own terminal's, then its route terminal's, then a terminal address's US ZIP, then the company's. The company zone while terminal_local_times is off. */
  timeZone?: Maybe<Scalars['String']['output']>;
  transferAddress?: Maybe<AddressEntity>;
  twilioCallSid?: Maybe<Scalars['String']['output']>;
  twilioTextSid?: Maybe<Scalars['String']['output']>;
  /** Convenience field, not strongly typed. Recommended for display only, use the other fields if you need to do something programmatically with it */
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum StandardStopType {
  Commercial = 'COMMERCIAL',
  Dummy = 'DUMMY',
  Residential = 'RESIDENTIAL'
}

/** A filter object that is used to filter the standard stop type enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type StandardStopTypeFilter = {
  /** Filters for records where the relevant standard stop type field is equal to the provided standard stop type value */
  eq?: InputMaybe<StandardStopType>;
  /** Filters for records where the relevant standard stop type field is in the provided standard stop type values */
  in?: InputMaybe<Array<StandardStopType>>;
  /** Filters for records where the relevant standard stop type field is not equal to the provided standard stop type value */
  neq?: InputMaybe<StandardStopType>;
  /** Filters for records where the relevant standard stop type field is not in the provided standard stop type values */
  nin?: InputMaybe<Array<StandardStopType>>;
};

export type StandardStopUpsertInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentCallStatus?: InputMaybe<AppointmentCallStatus>;
  /** The appointment as typed in an entry zone. Send it instead of appointmentTime and endAppointmentTime, never with them. Requires terminal_local_times. */
  appointmentLocal?: InputMaybe<StopAppointmentLocalInput>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** arrivedAt typed as a wall clock in an entry zone (terminal_local_times). Send this or arrivedAt, not both. */
  arrivedAtLocal?: InputMaybe<LocalDateTimeInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** completedAt typed as a wall clock in an entry zone (terminal_local_times). Send this or completedAt, not both. */
  completedAtLocal?: InputMaybe<LocalDateTimeInput>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  courierReadyOrDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  lastAppointmentTextTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  removedDriver?: InputMaybe<Scalars['Boolean']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. If null or unspecified, the stop's service date will not be updated. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287?pvs=4. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopIntention?: InputMaybe<StopIntention>;
  stopType?: InputMaybe<StopType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  transferAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  upsertStopDriverMapInputs?: InputMaybe<Array<UpsertStopDriverMapInput>>;
  uuid: Scalars['String']['input'];
};

export type StartConfigMigrationInput = {
  companyUuid: Scalars['String']['input'];
  confirmProductionTarget?: InputMaybe<Scalars['Boolean']['input']>;
  dryRun: Scalars['Boolean']['input'];
  groups: Array<ConfigMigrationFeatureGroup>;
  source: MigrationEnv;
  target: MigrationEnv;
};

export type StartInventoryCountInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to on-hand pieces with a warehouse but no warehouse location assigned. */
  noLocationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to on-dock pieces flagged overdue by dwell time. */
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Piece statuses in scope. Defaults to the web Inventory bucket (ARRIVED, PLANNED) when omitted. */
  statuses?: InputMaybe<Array<PieceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to pieces not associated to any order. */
  unassociatedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StartInventoryCountOutput = InventoryCountEntity | InventoryCountScopeTooLargeOutput;

export enum StartOrEnd {
  End = 'END',
  Start = 'START'
}

export type StartPieceBackfillRunInput = {
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  companyUuid: Scalars['String']['input'];
  confirmExecute?: InputMaybe<Scalars['Boolean']['input']>;
  cutoffDate: Scalars['DateTime']['input'];
  mode: PieceBackfillRunMode;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type StationReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid: Scalars['String']['input'];
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  /** IANA zone the report reads its days in; honored only while terminal_local_times is on. When null, insight reports count each order on its stop's local service day, and the audit report uses the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StationReportBucketEntity = {
  __typename?: 'StationReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  stationId?: Maybe<Scalars['String']['output']>;
  stationName?: Maybe<Scalars['String']['output']>;
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
};

export type StatusFilter = {
  filterType: OrderStatusFilterType;
  status: OrderStatus;
};

export enum StatusMappingCategory {
  OrderStatus = 'ORDER_STATUS',
  OrderStatusDescription = 'ORDER_STATUS_DESCRIPTION',
  PieceStatus = 'PIECE_STATUS'
}

export enum StopAction {
  AssignToDriver = 'ASSIGN_TO_DRIVER',
  MarkArrived = 'MARK_ARRIVED',
  MarkAttempted = 'MARK_ATTEMPTED',
  MarkComplete = 'MARK_COMPLETE',
  MarkIncomplete = 'MARK_INCOMPLETE',
  MarkPaperworkComplete = 'MARK_PAPERWORK_COMPLETE',
  SetAppointmentConfirmed = 'SET_APPOINTMENT_CONFIRMED',
  SetAppointmentRequired = 'SET_APPOINTMENT_REQUIRED',
  SetAppointmentTime = 'SET_APPOINTMENT_TIME',
  UnassignFromRoute = 'UNASSIGN_FROM_ROUTE'
}

export type StopActionResult = {
  __typename?: 'StopActionResult';
  action: StopAction;
  results: BulkActionEntityResults;
};

/** The appointment at the stop: its calendar day and wall-clock window in the stop's zone. */
export type StopAppointmentLocalEntity = {
  __typename?: 'StopAppointmentLocalEntity';
  /** YYYY-MM-DD at the stop. */
  day: Scalars['String']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** HH:mm at the stop; on the next day when before startTime, a zero-width window when equal. */
  endTime?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** HH:mm at the stop. */
  startTime?: Maybe<Scalars['String']['output']>;
  /** The stop's IANA zone. */
  timeZone: Scalars['String']['output'];
};

/** An appointment typed as a wall-clock window on day, start in entryTimeZone and end in endEntryTimeZone (entryTimeZone when absent). The server reads it from day (the end may fall on the next day) and stores it in the stop zone. Requires terminal_local_times. */
export type StopAppointmentLocalInput = {
  /** YYYY-MM-DD the start is read on; in one zone the end too unless its clock is before the start. */
  day: Scalars['String']['input'];
  /** Required when endTime happens twice (fall-back night). */
  endDisambiguation?: InputMaybe<AmbiguousLocalTime>;
  /** Zone endTime is read in when it differs from entryTimeZone (aliases of the same zone count as the same); null reads it in entryTimeZone. Not stored. */
  endEntryTimeZone?: InputMaybe<Scalars['String']['input']>;
  /** HH:mm in endEntryTimeZone (entryTimeZone when absent). In one zone it is on day, or the next day when before startTime, a zero-width window when equal. With a different endEntryTimeZone it is the first time this clock occurs there at or after the start: on the start instant's date in that zone, else the next day. */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** Zone startTime is read in, and endTime too unless endEntryTimeZone is given. */
  entryTimeZone: Scalars['String']['input'];
  /** Required when startTime happens twice (fall-back night). */
  startDisambiguation?: InputMaybe<AmbiguousLocalTime>;
  /** HH:mm in entryTimeZone; null for no start. */
  startTime?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for the stops list by completion state. COMPLETED = completedAt set, UNCOMPLETED = completedAt null, ALL = no constraint. */
export enum StopCompletionStatus {
  All = 'ALL',
  Completed = 'COMPLETED',
  Uncompleted = 'UNCOMPLETED'
}

export type StopCreateInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentCallStatus?: InputMaybe<AppointmentCallStatus>;
  /** The appointment as typed in an entry zone. Send it instead of appointmentTime and endAppointmentTime, never with them. Requires terminal_local_times. */
  appointmentLocal?: InputMaybe<StopAppointmentLocalInput>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  consigneeAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  consigneeContactPersonUpsertInput?: InputMaybe<ContactPersonUpdateInput>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpdateInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  podSignee?: InputMaybe<Scalars['String']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  removedDriver?: InputMaybe<Scalars['Boolean']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. If null or unspecified, the stop's service date will not be updated. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287?pvs=4 for details. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shipperContactPersonUpsertInput?: InputMaybe<ContactPersonUpdateInput>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopIntention?: InputMaybe<StopIntention>;
  stopType?: InputMaybe<StopType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  transferAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  upsertStopDriverMapInputs?: InputMaybe<Array<UpsertStopDriverMapInput>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type StopDetailsOutput = {
  __typename?: 'StopDetailsOutput';
  message?: Maybe<Scalars['String']['output']>;
  stopDetailsStatus: StopDetailsStatus;
};

export enum StopDetailsStatus {
  AwaitingAgentConfirmation = 'AWAITING_AGENT_CONFIRMATION',
  AwaitingSendToAgent = 'AWAITING_SEND_TO_AGENT',
  InboundRequired = 'INBOUND_REQUIRED',
  Loaded = 'LOADED',
  OnHand = 'ON_HAND',
  OnRoute = 'ON_ROUTE',
  PartiallyOnHand = 'PARTIALLY_ON_HAND'
}

export type StopDriverMapAddressForDownloadEntity = {
  __typename?: 'StopDriverMapAddressForDownloadEntity';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type StopDriverMapConnection = {
  __typename?: 'StopDriverMapConnection';
  edges: Array<StopDriverMapEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StopDriverMapEdge = {
  __typename?: 'StopDriverMapEdge';
  cursor: Scalars['String']['output'];
  node: StopDriverMapEntity;
};

export type StopDriverMapEntity = {
  __typename?: 'StopDriverMapEntity';
  driver: DriverEntity;
  driverPayoutFinalized: Scalars['Boolean']['output'];
  driverSettlementBill?: Maybe<DriverSettlementBillEntity>;
  driverSettlementTotalAmounts: DriverSettlementTotalAmountsOutput;
  enableDriverSettlement?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revenueFlatRate?: Maybe<Scalars['Float']['output']>;
  revenuePercentageRate?: Maybe<Scalars['Float']['output']>;
  stop: StopEntity;
  totalChargesForSettlement?: Maybe<Scalars['Float']['output']>;
  totalDriverPayoutForStop?: Maybe<Scalars['Float']['output']>;
  totalEligibleAmountForStop?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type StopDriverMapForCompletedStopsEntity = {
  __typename?: 'StopDriverMapForCompletedStopsEntity';
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  driver: DriverEntity;
  isLineHaul?: Maybe<Scalars['Boolean']['output']>;
  linehaulEndTerminal?: Maybe<TerminalEntity>;
  linehaulStartTerminal?: Maybe<TerminalEntity>;
  order?: Maybe<OrderEntity>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  serviceDateV2?: Maybe<PlainDate>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  stopType?: Maybe<StopType>;
  stopUuid?: Maybe<Scalars['String']['output']>;
};

export type StopDriverMapForDownloadEntity = {
  __typename?: 'StopDriverMapForDownloadEntity';
  address?: Maybe<StopDriverMapAddressForDownloadEntity>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  billingPartyContactName?: Maybe<Scalars['String']['output']>;
  chargeBreakdown: SettlementStopChargeBreakdownOutput;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  driverSettlementTotalAmounts: DriverSettlementTotalAmountsOutput;
  isAttempt: Scalars['Boolean']['output'];
  order?: Maybe<OrderEntity>;
  orderName?: Maybe<Scalars['String']['output']>;
  otherDriversOnStop: Array<StopDriverMapOtherDriverForDownloadEntity>;
  packages: Array<PackageEntity>;
  serviceName?: Maybe<Scalars['String']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  stopType?: Maybe<StopType>;
  stopUuid: Scalars['String']['output'];
  /** The stop's IANA zone (stop zone chain, ending at the company zone), so the settlement PDF and spreadsheet print its completion where it happened. Null while terminal_local_times is off. */
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type StopDriverMapOtherDriverForDownloadEntity = {
  __typename?: 'StopDriverMapOtherDriverForDownloadEntity';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type StopDriverMapPayTermsEntity = {
  __typename?: 'StopDriverMapPayTermsEntity';
  calculationVersion: Scalars['Int']['output'];
  captureReason: SettlementPayCaptureReason;
  driverUuid: Scalars['String']['output'];
  flatPayUsdCents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  maxPayUsdCents?: Maybe<Scalars['Int']['output']>;
  minPayUsdCents?: Maybe<Scalars['Int']['output']>;
  payType: DriverPayType;
  perMileRateUsdMillicents?: Maybe<Scalars['Int']['output']>;
  percentageOutOf100?: Maybe<Scalars['Float']['output']>;
  rateSource: SettlementPayRateSource;
  revision: Scalars['Int']['output'];
  stopUuid: Scalars['String']['output'];
};

export type StopDriverMapUpdateInput = {
  driverPayoutFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  enableDriverSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type StopDriverMapUpsertInput = {
  driverPayoutFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  enableDriverSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revenueFlatRate?: InputMaybe<Scalars['Float']['input']>;
  revenuePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  stopUuid: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type StopEntity = {
  address: AddressEntity;
  appointmentCallStatus?: Maybe<AppointmentCallStatus>;
  /** The appointment as a day and window in the stop's zone. Null while terminal_local_times is off or without an appointment. */
  appointmentLocal?: Maybe<StopAppointmentLocalEntity>;
  appointmentManuallyConfirmed: Scalars['Boolean']['output'];
  /** Whether the appointment falls on another day at the stop than its route day. False while terminal_local_times is off, off a route, or without a window. */
  appointmentOffRouteDay: Scalars['Boolean']['output'];
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The STORED appointment status. Only CANCELLED is ever stored; null means the status is derived from the confirmation columns, not that there is none. */
  appointmentStatus?: Maybe<AppointmentStatus>;
  appointmentTextStatus?: Maybe<AppointmentTextStatus>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  cachedEta?: Maybe<EtaEntity>;
  canMarkAttemptComplete?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedByAgentAt?: Maybe<Scalars['DateTime']['output']>;
  consigneeAddress?: Maybe<AddressEntity>;
  consigneeContactPerson?: Maybe<ContactPersonEntity>;
  /** True when this stop's current automated call has already been reported as a contact attempt. Reporting it again needs reportAdditionalAttempt. */
  contactAttemptReportedForCurrentCall: Scalars['Boolean']['output'];
  contactPerson?: Maybe<ContactPersonEntity>;
  courierReadyOrDueDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerBookingNotes?: Maybe<Scalars['String']['output']>;
  deadlineTime?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  driverCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  equipment?: Maybe<EquipmentEntity>;
  eta?: Maybe<EtaEntity>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  etaFinishTime?: Maybe<Scalars['DateTime']['output']>;
  etaLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  expectedOutboundDate?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Float']['output']>;
  formattedCallMessage?: Maybe<Scalars['String']['output']>;
  /** returns if a stop has a previous attempt */
  hasPreviousAttempt: Scalars['Boolean']['output'];
  hideFromDispatch?: Maybe<Scalars['Boolean']['output']>;
  inboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  incomingCarrier?: Maybe<Scalars['String']['output']>;
  /** returns if a stop is an attempt */
  isAttempt: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  lastAppointmentTextTime?: Maybe<Scalars['DateTime']['output']>;
  leg?: Maybe<LegEntity>;
  linkedEndStop?: Maybe<StopEntity>;
  /** The local time zone of the stop, based on the address. Defaults to company time zone. */
  localTimeZone?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundCarrier?: Maybe<Scalars['String']['output']>;
  outboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  paperworkMarkedComplete?: Maybe<Scalars['Boolean']['output']>;
  pickupOrDelivery: StopPickupOrDelivery;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeChangeAcknowledged: Scalars['Boolean']['output'];
  routeName?: Maybe<RouteNameEntity>;
  routeSlot?: Maybe<RouteSlotEntity>;
  sentToAgentAt?: Maybe<Scalars['DateTime']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment?: Maybe<ShipmentEntity>;
  /** shipment consignee address- the address for the endStop of the last leg in the shipment that this stop's leg belongs to */
  shipmentConsigneeAddress: AddressEntity;
  /** Total volume of all packages associated with this stop's shipment */
  shipmentTotalVolume: Scalars['Float']['output'];
  /** Total weight of all packages associated with this stop's shipment */
  shipmentTotalWeight: Scalars['Float']['output'];
  shipperAddress?: Maybe<AddressEntity>;
  shipperContactPerson?: Maybe<ContactPersonEntity>;
  showDriverModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  startOrEnd: StartOrEnd;
  status: StopStatus;
  stopDetails?: Maybe<StopDetailsOutput>;
  stopDriverMaps: Array<StopDriverMapEntity>;
  stopIntention?: Maybe<StopIntention>;
  stopType?: Maybe<StopType>;
  terminal?: Maybe<TerminalEntity>;
  textResponses?: Maybe<Scalars['String']['output']>;
  /** The stop's IANA zone: its address zone, then its US ZIP's, then its own terminal's, then its route terminal's, then a terminal address's US ZIP, then the company's. The company zone while terminal_local_times is off. */
  timeZone?: Maybe<Scalars['String']['output']>;
  transferAddress?: Maybe<AddressEntity>;
  twilioCallSid?: Maybe<Scalars['String']['output']>;
  twilioTextSid?: Maybe<Scalars['String']['output']>;
  /** Convenience field, not strongly typed. Recommended for display only, use the other fields if you need to do something programmatically with it */
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum StopImportType {
  Both = 'BOTH',
  DynamicInboundOrOutbound = 'DYNAMIC_INBOUND_OR_OUTBOUND',
  InboundOnly = 'INBOUND_ONLY',
  OutboundOnly = 'OUTBOUND_ONLY'
}

export enum StopIntention {
  None = 'NONE',
  Pending = 'PENDING'
}

export type StopOutput = {
  __typename?: 'StopOutput';
  stopValues: Array<Maybe<GroupByStopEntity>>;
};

export enum StopPdfColumnMapping {
  Address = 'ADDRESS',
  CompletedAtDate = 'COMPLETED_AT_DATE'
}

export enum StopPickupOrDelivery {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type StopPreviewForRouteGenerationEntity = {
  __typename?: 'StopPreviewForRouteGenerationEntity';
  eta: Scalars['DateTime']['output'];
  odometer: Scalars['Float']['output'];
  stop: StopEntity;
};

export type StopSort = {
  sortBy: DispatchTableField;
  sortDirection: StopSortDirection;
};

export enum StopSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum StopStatus {
  Arrived = 'ARRIVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NotArrived = 'NOT_ARRIVED'
}

/** Groups the dispatch stops grid by one or more columns. `fields` is the ordered list of grouping levels; `keys` holds the group value for each level the client has already expanded, outermost first. When `keys` is shorter than `fields` the query answers with the group rows of the next level; when the two are the same length it answers with the stops under that path. A null key selects the stops whose value is blank. */
export type StopTableGroupByInput = {
  /** Order of the group rows by their value; ascending when omitted. A blank value sorts as the largest, so it comes last ascending and first descending. */
  direction?: InputMaybe<SortDirection>;
  /** Grouping levels, outermost first. */
  fields: Array<DispatchTableField>;
  /** Group value for each expanded level, outermost first. Never longer than `fields`. */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  /** Most group rows to return. Ignored for a fully expanded path, where `first` bounds the stops page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Rows to skip within the requested level, for group rows and for the stops under a fully expanded path alike. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** One group of the dispatch stops grid at the level the request asked for: the value shared by its stops, the text to show for it, and how many stops it holds. */
export type StopTableGroupRowEntity = {
  __typename?: 'StopTableGroupRowEntity';
  /** Number of stops in the group under the active filters. */
  count: Scalars['Int']['output'];
  /** The group value as the client must send it back in `groupBy.keys` to expand this group. Null for the stops whose value is blank. */
  key?: Maybe<Scalars['String']['output']>;
  /** Display text for the group. Null when the value is blank, so the client can render its own placeholder. */
  label?: Maybe<Scalars['String']['output']>;
};

export enum StopType {
  Delivery = 'DELIVERY',
  None = 'NONE',
  PartnerCarrierDropoff = 'PARTNER_CARRIER_DROPOFF',
  PartnerCarrierPickup = 'PARTNER_CARRIER_PICKUP',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY',
  Standalone = 'STANDALONE',
  Transfer = 'TRANSFER'
}

/** A filter object that is used to filter the stop type enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type StopTypeFilter = {
  /** Filters for records where the relevant stop type field is equal to the provided stop type value */
  eq?: InputMaybe<StopType>;
  /** Filters for records where the relevant stop type field is in the provided stop type values */
  in?: InputMaybe<Array<StopType>>;
  /** Filters for records where the relevant stop type field is not equal to the provided stop type value */
  neq?: InputMaybe<StopType>;
  /** Filters for records where the relevant stop type field is not in the provided stop type values */
  nin?: InputMaybe<Array<StopType>>;
};

export type StopTypesFilter = {
  fieldLevelFilterOperator: FilterOperator;
  filterOperator?: InputMaybe<FilterOperator>;
  stopTypes: Array<PickupOrDelivery>;
};

export type StopTypesV2Filter = {
  filterOperator?: InputMaybe<FilterOperator>;
  stopType?: InputMaybe<StopType>;
};

export type StopUpdateInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  /** The appointment as typed in an entry zone. Send it instead of appointmentTime and endAppointmentTime, never with them. Requires terminal_local_times. */
  appointmentLocal?: InputMaybe<StopAppointmentLocalInput>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** arrivedAt typed as a wall clock in an entry zone (terminal_local_times). Send this or arrivedAt, not both. */
  arrivedAtLocal?: InputMaybe<LocalDateTimeInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** completedAt typed as a wall clock in an entry zone (terminal_local_times). Send this or completedAt, not both. */
  completedAtLocal?: InputMaybe<LocalDateTimeInput>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  courierReadyOrDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  customerBookingNotes?: InputMaybe<Scalars['String']['input']>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  etaArrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  etaFinishTime?: InputMaybe<Scalars['DateTime']['input']>;
  etaLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  lastAppointmentTextTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderAdditionalStopForUuid?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  postedAmountUsdCents?: InputMaybe<Scalars['Int']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  snapshottedAmountUsdCents?: InputMaybe<Scalars['Int']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopIntention?: InputMaybe<StopIntention>;
  stopType?: InputMaybe<StopType>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type StopUpsertInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentCallStatus?: InputMaybe<AppointmentCallStatus>;
  /** The appointment as typed in an entry zone. Send it instead of appointmentTime and endAppointmentTime, never with them. Requires terminal_local_times. */
  appointmentLocal?: InputMaybe<StopAppointmentLocalInput>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** arrivedAt typed as a wall clock in an entry zone (terminal_local_times). Send this or arrivedAt, not both. */
  arrivedAtLocal?: InputMaybe<LocalDateTimeInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** completedAt typed as a wall clock in an entry zone (terminal_local_times). Send this or completedAt, not both. */
  completedAtLocal?: InputMaybe<LocalDateTimeInput>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  courierReadyOrDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  lastAppointmentTextTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  removedDriver?: InputMaybe<Scalars['Boolean']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. If null or unspecified, the stop's service date will not be updated. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287?pvs=4. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopIntention?: InputMaybe<StopIntention>;
  stopType?: InputMaybe<StopType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  transferAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  upsertStopDriverMapInputs?: InputMaybe<Array<UpsertStopDriverMapInput>>;
  uuid: Scalars['String']['input'];
};

/** The stops of one group of the dispatch stops grid, for assigning the whole group to a route. */
export type StopUuidsInGroupOutput = {
  __typename?: 'StopUuidsInGroupOutput';
  /** True when the group holds more stops than one request may assign; `uuids` is then empty. */
  exceedsCap: Scalars['Boolean']['output'];
  /** The uuids of the stops in the group, up to the limit. Empty when the group exceeds it. */
  uuids: Array<Scalars['String']['output']>;
};

/** One wall clock applied at each stop in its own zone (D-06: local time at each stop). A stop whose zone skips the time fails alone. Requires terminal_local_times. */
export type StopWallClockInput = {
  /** YYYY-MM-DD at each stop. */
  day: Scalars['String']['input'];
  /** Which pass a time that happens twice at a stop (fall-back night) means; without it such a stop fails. */
  disambiguation?: InputMaybe<AmbiguousLocalTime>;
  /** HH:mm at each stop. */
  time: Scalars['String']['input'];
};

export type StopsListElement = CachedStopEntity | RecurringRunHeaderEntity;

export type StorageDaysAccessorialCreateInput = {
  /** Pallet-count-based ranges. lessThanOrEqualToValue = pallet count, rate = per-day charge. */
  accessorialRangeCreateInputs: Array<AccessorialRangeCreateInput>;
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  storageDaysExcludeWeekends: Scalars['Boolean']['input'];
  storageDaysFreeDays: Scalars['Int']['input'];
};

export type StorageDaysAccessorialEntity = AccessorialInterface & {
  __typename?: 'StorageDaysAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  accessorialRanges?: Maybe<Array<AccessorialRangeEntity>>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  storageDaysExcludeWeekends?: Maybe<Scalars['Boolean']['output']>;
  storageDaysFreeDays?: Maybe<Scalars['Int']['output']>;
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type StorageDaysAccessorialUpdateInput = {
  accessorialRangeUpdateInputs?: InputMaybe<Array<AccessorialRangeUpdateInput>>;
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  storageDaysExcludeWeekends?: InputMaybe<Scalars['Boolean']['input']>;
  storageDaysFreeDays?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['String']['input'];
};

export type StorageOrderConnection = {
  __typename?: 'StorageOrderConnection';
  edges: Array<StorageOrderEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StorageOrderEdge = {
  __typename?: 'StorageOrderEdge';
  cursor: Scalars['String']['output'];
  node: StorageOrderEntity;
};

export type StorageOrderEntity = {
  __typename?: 'StorageOrderEntity';
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  billOfLadingNumber?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consigneeName?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<DocumentEntity>;
  expectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Deprecated. Use items.item instead */
  inventoryItems: Array<InventoryItemEntity>;
  isOSD: Scalars['Boolean']['output'];
  items: Array<ItemForStorageOrder>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pickupDate?: Maybe<Scalars['DateTime']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  sealNumber?: Maybe<Scalars['String']['output']>;
  storageUnits: Array<StorageUnitEntity>;
  supplierCompanyName?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trailerNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};


export type StorageOrderEntityStorageUnitsArgs = {
  storageUnitsInput?: InputMaybe<StorageUnitsInput>;
};

export type StorageUnitConnection = {
  __typename?: 'StorageUnitConnection';
  edges: Array<StorageUnitEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StorageUnitEdge = {
  __typename?: 'StorageUnitEdge';
  cursor: Scalars['String']['output'];
  node: StorageUnitEntity;
};

export type StorageUnitEntity = {
  __typename?: 'StorageUnitEntity';
  billed?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The number of billable days in the current billing cycle. Assumes that customer is billed everytime inventory is verified */
  currentBillableDays: Scalars['Int']['output'];
  height?: Maybe<Scalars['Length']['output']>;
  /** @deprecated Use items.item instead */
  inventoryItems: Array<InventoryItemEntity>;
  inventoryLastVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Represents the description of the SKU that a storage unit is comprised of. Note that this should only be used for single-SKU storage units */
  itemDescription?: Maybe<Scalars['String']['output']>;
  /** Note that this should only be used for single-SKU storage units */
  itemUOM?: Maybe<UnitOfMeasure>;
  items: Array<ItemForStorageUnit>;
  length?: Maybe<Scalars['Length']['output']>;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  markedOsdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** The number of days the storage unit spent in the warehouse */
  numberOfDaysInStorage: Scalars['Int']['output'];
  /**
   * The number of inventory items currently in the storage unit. An inventory item is in the storage unit if it is on hand and has not been picked yet
   * @deprecated Use items quantities instead
   */
  numberOfInventoryItems: Scalars['Int']['output'];
  osdReason?: Maybe<Scalars['String']['output']>;
  outboundReferenceNumber?: Maybe<Scalars['String']['output']>;
  pickedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Represents the SKU that a storage unit is comprised of. Note that this should only be used for single-SKU storage units */
  sku?: Maybe<Scalars['String']['output']>;
  storageOrder?: Maybe<StorageOrderEntity>;
  /**
   * The number of inventory items associated with the storage unit
   * @deprecated Use items quantities instead
   */
  totalNumberOfInventoryItems: Scalars['Int']['output'];
  unitOfMeasure: UnitOfMeasure;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
  weight?: Maybe<Scalars['Mass']['output']>;
  width?: Maybe<Scalars['Length']['output']>;
};

export type StorageUnitsInput = {
  pickedFilter?: InputMaybe<StorageUnitsPickedFilterType>;
};

export enum StorageUnitsPickedFilterType {
  All = 'ALL',
  Available = 'AVAILABLE',
  Picked = 'PICKED'
}

/** Represents the difference between 2 versions of a string list. Used in audit log entries */
export type StringArrayFieldDifference = {
  __typename?: 'StringArrayFieldDifference';
  newValue?: Maybe<Array<Scalars['String']['output']>>;
  oldValue?: Maybe<Array<Scalars['String']['output']>>;
};

/** Represents the difference between 2 versions of a string field. Used in audit log entries */
export type StringFieldDifference = {
  __typename?: 'StringFieldDifference';
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type StringFilter = {
  filterOperator?: InputMaybe<FilterOperator>;
  filterType: StringFilterType;
  value: Scalars['String']['input'];
};

export type StringFilterNullable = {
  filterOperator?: InputMaybe<FilterOperator>;
  filterType: StringFilterType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum StringFilterType {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  NotContains = 'NOT_CONTAINS',
  StartsWith = 'STARTS_WITH'
}

/** A filter object that is used to filter a string field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type StringFilterV2 = {
  /** Filters for records where the relevant string field contains the provided string value */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field contains (case insensitive) the provided string value */
  containsIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field ends with the provided string value */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field ends with (case insensitive) the provided string value */
  endsWithIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is equal to the provided string value */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is equal to (case insensitive) the provided string value */
  eqIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is in the provided array of string values */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant string field is blank */
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant string field is not blank */
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant string field is not equal to the provided string value */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is not equal to (case insensitive) the provided string value */
  neqIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is not in the provided array of string values */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant string field starts with the provided string value */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field starts with (case insensitive) the provided string value */
  startsWithIgnoreCase?: InputMaybe<Scalars['String']['input']>;
};

export type StringsFilter = {
  /** Operator to apply across the array of values. Only supports equality. */
  fieldLevelFilterOperator: FilterOperator;
  values: Array<Scalars['String']['input']>;
};

export type StructuredExtractionRunEntity = {
  __typename?: 'StructuredExtractionRunEntity';
  createdAt: Scalars['DateTime']['output'];
  hasError?: Maybe<Scalars['Boolean']['output']>;
  rawResult?: Maybe<Scalars['String']['output']>;
  scannedOrderUuid: Scalars['String']['output'];
  schemaName?: Maybe<Scalars['String']['output']>;
  schemaUuid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type StructuredExtractionSchemaOverrideEntity = {
  __typename?: 'StructuredExtractionSchemaOverrideEntity';
  deadlineDateKeys?: Maybe<Array<Scalars['String']['output']>>;
  schemaExclusions?: Maybe<Scalars['String']['output']>;
  schemaOverride?: Maybe<Scalars['String']['output']>;
  specialInstructionsKeys?: Maybe<Array<Scalars['String']['output']>>;
  uuid: Scalars['String']['output'];
};

export type StructuredExtractionSchemaOverrideInput = {
  deadlineDateKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  schemaExclusions?: InputMaybe<Scalars['String']['input']>;
  schemaOverride: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
  specialInstructionsKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SyncInvoiceToQuickbooksFailure = {
  __typename?: 'SyncInvoiceToQuickbooksFailure';
  affectedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  code: SyncInvoiceToQuickbooksFailureCode;
  detail: Scalars['String']['output'];
  element: QboSyncElement;
  fixIn: QboSyncFixLocation;
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  quickbooksCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFaultCode?: Maybe<Scalars['String']['output']>;
  quickbooksItemId?: Maybe<Scalars['String']['output']>;
  quickbooksItemName?: Maybe<Scalars['String']['output']>;
  quickbooksRequestId?: Maybe<Scalars['String']['output']>;
  quickbooksSaid?: Maybe<Scalars['String']['output']>;
  quickbooksUrl?: Maybe<Scalars['String']['output']>;
  remediation: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
  tenetRecordName?: Maybe<Scalars['String']['output']>;
  tenetUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum SyncInvoiceToQuickbooksFailureCode {
  AccessForbidden = 'ACCESS_FORBIDDEN',
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  ClassOrLocationRequired = 'CLASS_OR_LOCATION_REQUIRED',
  ClosedPeriod = 'CLOSED_PERIOD',
  ConfigurationMissing = 'CONFIGURATION_MISSING',
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  CustomerAmbiguous = 'CUSTOMER_AMBIGUOUS',
  CustomerInactiveOrDeleted = 'CUSTOMER_INACTIVE_OR_DELETED',
  CustomerNameDuplicate = 'CUSTOMER_NAME_DUPLICATE',
  CustomerNotResolved = 'CUSTOMER_NOT_RESOLVED',
  DuplicateDocumentNumber = 'DUPLICATE_DOCUMENT_NUMBER',
  DuplicateName = 'DUPLICATE_NAME',
  FieldTooLong = 'FIELD_TOO_LONG',
  IncomeAccountMissing = 'INCOME_ACCOUNT_MISSING',
  InvalidCharacter = 'INVALID_CHARACTER',
  InvalidProperty = 'INVALID_PROPERTY',
  InvalidReference = 'INVALID_REFERENCE',
  InvoiceChangedDuringSync = 'INVOICE_CHANGED_DURING_SYNC',
  ItemAmbiguous = 'ITEM_AMBIGUOUS',
  ItemInactive = 'ITEM_INACTIVE',
  ItemIsCategory = 'ITEM_IS_CATEGORY',
  ItemIsInventory = 'ITEM_IS_INVENTORY',
  ItemNameDuplicate = 'ITEM_NAME_DUPLICATE',
  ItemNotFound = 'ITEM_NOT_FOUND',
  NegativeTotal = 'NEGATIVE_TOTAL',
  NotConnected = 'NOT_CONNECTED',
  NoBillableLines = 'NO_BILLABLE_LINES',
  PaymentApplied = 'PAYMENT_APPLIED',
  QboInvoiceConflict = 'QBO_INVOICE_CONFLICT',
  QboInvoiceDeleted = 'QBO_INVOICE_DELETED',
  QuickbooksUnavailable = 'QUICKBOOKS_UNAVAILABLE',
  RateLimited = 'RATE_LIMITED',
  RealmMismatch = 'REALM_MISMATCH',
  SyncInProgress = 'SYNC_IN_PROGRESS',
  TaxCodeRequired = 'TAX_CODE_REQUIRED',
  TermsNotFound = 'TERMS_NOT_FOUND',
  Unknown = 'UNKNOWN'
}

export type SyncInvoiceToQuickbooksNotice = {
  __typename?: 'SyncInvoiceToQuickbooksNotice';
  detail: Scalars['String']['output'];
  element: QboSyncElement;
  kind: QboSyncNoticeKind;
  quickbooksRecordId?: Maybe<Scalars['String']['output']>;
  quickbooksRecordName?: Maybe<Scalars['String']['output']>;
  quickbooksUrl?: Maybe<Scalars['String']['output']>;
  tenetRecordName?: Maybe<Scalars['String']['output']>;
  tenetUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SyncInvoicesToQuickbooksOutput = {
  __typename?: 'SyncInvoicesToQuickbooksOutput';
  failed: Array<SyncInvoiceToQuickbooksFailure>;
  synced: Array<InvoiceEntity>;
  syncedWithNotices: Array<SyncedInvoiceWithNotices>;
};

export type SyncedInvoiceWithNotices = {
  __typename?: 'SyncedInvoiceWithNotices';
  invoice: InvoiceEntity;
  notices: Array<SyncInvoiceToQuickbooksNotice>;
};

export type TableColumnWidthEntity = {
  __typename?: 'TableColumnWidthEntity';
  colId: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type TableFieldsEntity = {
  __typename?: 'TableFieldsEntity';
  billingReviewOrderTableFields: Array<OrderTableField>;
  dispatchTableColumnWidths?: Maybe<Array<TableColumnWidthEntity>>;
  dispatchTableFields: Array<DispatchTableField>;
  invoicesTableColumnWidths?: Maybe<Array<TableColumnWidthEntity>>;
  lineHaulOrderTableFields: Array<OrderTableField>;
  linehaulDispatchTableFields: Array<LinehaulDispatchTableField>;
  orderTableFields: Array<OrderTableField>;
  ordersTableColumnWidths?: Maybe<Array<TableColumnWidthEntity>>;
  routeCardStopTableColumnWidths?: Maybe<Array<TableColumnWidthEntity>>;
  routeCardStopTableFields: Array<DispatchTableField>;
};

export type TagCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type TagEntity = {
  __typename?: 'TagEntity';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  legs: Array<LegEntity>;
  orders: Array<OrderEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TagUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TariffChainEntity = {
  __typename?: 'TariffChainEntity';
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tariffGroupType: TariffGroupType;
  /** This is an ORDERED list of tariff groups on this tariff chain. */
  tariffGroups: Array<TariffGroupEntity>;
};

/** Where rating found a tariff chain: the contact's own default, or the company default it falls back to. */
export enum TariffChainSource {
  Company = 'COMPANY',
  Contact = 'CONTACT'
}

export type TariffCreateInput = {
  /** UUID of billing party contact for custom tariffs */
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  /** False creates the lane disabled: it keeps its rates and rating skips it. Point-to-point tariff groups only (TMS-2756). Defaults to true. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, reaching the maximum suppresses the fuel charge: the maximum already includes fuel (TMS-1631). Defaults to false. */
  maximumIncludesFuel?: InputMaybe<Scalars['Boolean']['input']>;
  maximumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  minimumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  rateType: RateType;
  serviceLevel?: InputMaybe<ServiceLevel>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  tariffOverageRateCreateInputs?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  /** tariff ranges to be created for this tariff */
  tariffRangeCreateInputs: Array<TariffRangeCreateInput>;
  tariffType: TariffType;
  tariffZoneUuid: Scalars['String']['input'];
  useActualWeightInCalculation: Scalars['Boolean']['input'];
  visibilityLevel?: InputMaybe<TariffVisibilityLevel>;
};

export type TariffEntity = {
  __typename?: 'TariffEntity';
  billingPartyContactUuid?: Maybe<Scalars['String']['output']>;
  /** False when the lane is disabled: it keeps its rates and rating never selects it. With tariff chains on, the order falls through to the next group in the chain; without them it behaves like a blank lane. Only point-to-point tariff groups disable lanes. */
  isActive: Scalars['Boolean']['output'];
  /** When true, the maximum is all-inclusive: reaching it suppresses the fuel charge, because the maximum already accounts for fuel. Inert when no maximum is set. */
  maximumIncludesFuel: Scalars['Boolean']['output'];
  /** Maximum amount assessed, in USD cents */
  maximumUsdCents?: Maybe<Scalars['Int']['output']>;
  /** Minimum amount assessed, in USD cents */
  minimumUsdCents?: Maybe<Scalars['Int']['output']>;
  rateType: RateType;
  service?: Maybe<ServiceEntity>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  tariffGroup?: Maybe<TariffGroupEntity>;
  tariffOverageRates: Array<TariffOverageRateEntity>;
  tariffRanges: Array<TariffRangeEntity>;
  /** Tariff Type */
  tariffType: TariffType;
  tariffZone: TariffZoneEntity;
  useActualWeight?: Maybe<Scalars['Boolean']['output']>;
  useActualWeightInCalculation: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type TariffGroupConnection = {
  __typename?: 'TariffGroupConnection';
  edges: Array<TariffGroupEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TariffGroupCustomerPreviewEntity = {
  __typename?: 'TariffGroupCustomerPreviewEntity';
  displayName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** Customers who rate through a tariff group by way of a tariff chain. */
export type TariffGroupCustomerUsageEntity = {
  __typename?: 'TariffGroupCustomerUsageEntity';
  /** Null when none of the company default chains contains the group. Otherwise the customers with no chain of their own for the type that default chain covers. */
  companyDefaultCustomerCount?: Maybe<Scalars['Int']['output']>;
  /** Up to two customers whose own chain contains the group, ordered by display name. */
  previewCustomers: Array<TariffGroupCustomerPreviewEntity>;
  /** Customers whose own chain of any type contains the group, archived chains included. */
  totalDirectCustomers: Scalars['Int']['output'];
};

export type TariffGroupEdge = {
  __typename?: 'TariffGroupEdge';
  cursor: Scalars['String']['output'];
  node: TariffGroupEntity;
};

export type TariffGroupEntity = {
  __typename?: 'TariffGroupEntity';
  contactToServicesMappings: Array<ContactToServicesTariffGroupMappingEntity>;
  customerUsage: TariffGroupCustomerUsageEntity;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firstTariff?: Maybe<TariffEntity>;
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentTariffGroup?: Maybe<TariffGroupEntity>;
  rateMultiplier?: Maybe<Scalars['Float']['output']>;
  services: Array<ServiceEntity>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tariff chains that contain this group, archived chains included. The group cannot be deleted while this is non-empty. */
  tariffChains: Array<TariffChainEntity>;
  tariffGroupScope?: Maybe<TariffGroupScope>;
  tariffGroupType: TariffGroupType;
  tariffZoneGroup?: Maybe<TariffZoneGroupEntity>;
  tariffs: Array<TariffEntity>;
  terminals: Array<TerminalEntity>;
  totalContactsToServicesMappings: Scalars['Int']['output'];
  useActualWeightInCalculation: Scalars['Boolean']['output'];
  useDeficitBilling?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['String']['output'];
  vehicleTypes: Array<VehicleTypeEntity>;
};


export type TariffGroupEntityContactToServicesMappingsArgs = {
  first?: InputMaybe<Scalars['Float']['input']>;
};

export enum TariffGroupScope {
  Combination = 'COMBINATION',
  Contact = 'CONTACT',
  Default = 'DEFAULT'
}

export enum TariffGroupType {
  LineHaul = 'LINE_HAUL',
  Ordinary = 'ORDINARY',
  PointToPoint = 'POINT_TO_POINT',
  Recovery = 'RECOVERY',
  Transfer = 'TRANSFER'
}

export type TariffLocationCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type TariffLocationEntity = {
  __typename?: 'TariffLocationEntity';
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type TariffOverageRateCreateInput = {
  applicableAboveAmount: Scalars['Float']['input'];
  /** When true, applies the overage rate to the full amount rather than just the overage. Defaults to false for backwards compatibility. */
  applyRateToFullAmount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flat rate in USD cents. Made nullable outside the entity to be backwards compatible with the old frontends. */
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  rateUsdCents: Scalars['Float']['input'];
  type: TariffOverageRateType;
};

export type TariffOverageRateEntity = {
  __typename?: 'TariffOverageRateEntity';
  applicableAboveAmount: Scalars['Float']['output'];
  applyRateToFullAmount: Scalars['Boolean']['output'];
  flatRateUsdCents: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  rateUsdCents: Scalars['Float']['output'];
  type: TariffOverageRateType;
  uuid: Scalars['String']['output'];
};

export enum TariffOverageRateType {
  Miles = 'MILES',
  Pieces = 'PIECES',
  Weight = 'WEIGHT'
}

export type TariffRangeCreateInput = {
  lessThanOrEqualToValue: Scalars['Int']['input'];
  rateUsdCents: Scalars['Float']['input'];
};

export type TariffRangeEntity = {
  __typename?: 'TariffRangeEntity';
  lessThanOrEqualToValue: Scalars['Int']['output'];
  rateUsdCents: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type TariffRangeUpdateInput = {
  lessThanOrEqualToValue: Scalars['Int']['input'];
  rateUsdCents: Scalars['Float']['input'];
  uuid: Scalars['String']['input'];
};

export type TariffRangeUpdatesInput = {
  tariffRangeUpdateInputs: Array<TariffRangeUpdateInput>;
  tariffUuid: Scalars['String']['input'];
};

export enum TariffResolutionReason {
  Code_32Fallback = 'CODE_32_FALLBACK',
  GreatestOnOrBefore = 'GREATEST_ON_OR_BEFORE',
  Pinned = 'PINNED'
}

export enum TariffType {
  NoUnits = 'NO_UNITS',
  PerCubicFoot = 'PER_CUBIC_FOOT',
  PerHundredPounds = 'PER_HUNDRED_POUNDS',
  PerMile = 'PER_MILE',
  PerPiece = 'PER_PIECE'
}

export type TariffUpsertInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  /** False disables the lane: it keeps its rates and rating skips it. Point-to-point tariff groups only (TMS-2756). Omitted on update means keep the current value; a new tariff defaults to true. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, reaching the maximum suppresses the fuel charge: the maximum already includes fuel (TMS-1631). Omitted on update means keep the current value. */
  maximumIncludesFuel?: InputMaybe<Scalars['Boolean']['input']>;
  maximumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  minimumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  rateType?: InputMaybe<RateType>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  tariffOverageRateCreateInputs?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  tariffRangeUpdateInputs?: InputMaybe<Array<TariffRangeUpdateInput>>;
  tariffType: TariffType;
  tariffZoneUuid: Scalars['String']['input'];
  useActualWeightInCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export enum TariffVisibilityLevel {
  Customer = 'CUSTOMER',
  Global = 'GLOBAL'
}

export type TariffZoneCreateInput = {
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  inboundZoneUuid?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<TariffLocationCreateInput>>;
  mileRangeEnd?: InputMaybe<Scalars['Float']['input']>;
  mileRangeStart?: InputMaybe<Scalars['Float']['input']>;
  /** Name of tariff */
  name: Scalars['String']['input'];
  outboundZoneUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type: TariffZoneType;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TariffZoneEntity = {
  __typename?: 'TariffZoneEntity';
  billingPartyContactId?: Maybe<Scalars['Int']['output']>;
  billingPartyContactUuid?: Maybe<Scalars['String']['output']>;
  destinationTerminal?: Maybe<TerminalEntity>;
  inboundZone?: Maybe<TariffZoneEntity>;
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  locations: Array<TariffLocationEntity>;
  mileRangeEnd?: Maybe<Scalars['Float']['output']>;
  mileRangeStart?: Maybe<Scalars['Float']['output']>;
  /** Name of tariff */
  name: Scalars['String']['output'];
  outboundZone?: Maybe<TariffZoneEntity>;
  tariffZoneGroupId?: Maybe<Scalars['String']['output']>;
  tariffZoneLocationType?: Maybe<TariffZoneLocationType>;
  terminal?: Maybe<TerminalEntity>;
  type: TariffZoneType;
  uuid: Scalars['String']['output'];
};

export type TariffZoneGroupArchiveOutput = MutationErrorOutput | TariffZoneGroupArchiveSuccessOutput;

export type TariffZoneGroupArchiveSuccessOutput = {
  __typename?: 'TariffZoneGroupArchiveSuccessOutput';
  /** The archived tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export type TariffZoneGroupCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TariffZoneGroupCreateOutput = MutationErrorOutput | TariffZoneGroupCreateSuccessOutput;

export type TariffZoneGroupCreateSuccessOutput = {
  __typename?: 'TariffZoneGroupCreateSuccessOutput';
  /** The created tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export type TariffZoneGroupEntity = {
  __typename?: 'TariffZoneGroupEntity';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tariffZones: Array<TariffZoneEntity>;
};

export type TariffZoneGroupRestoreOutput = MutationErrorOutput | TariffZoneGroupRestoreSuccessOutput;

export type TariffZoneGroupRestoreSuccessOutput = {
  __typename?: 'TariffZoneGroupRestoreSuccessOutput';
  /** The restored tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export type TariffZoneGroupUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type TariffZoneGroupUpdateOutput = MutationErrorOutput | TariffZoneGroupUpdateSuccessOutput;

export type TariffZoneGroupUpdateSuccessOutput = {
  __typename?: 'TariffZoneGroupUpdateSuccessOutput';
  /** The updated tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export enum TariffZoneLocationType {
  LineHaulLane = 'LINE_HAUL_LANE',
  Terminal = 'TERMINAL',
  Zipcode = 'ZIPCODE'
}

export enum TariffZoneType {
  Location = 'LOCATION',
  Miles = 'MILES',
  Universal = 'UNIVERSAL',
  Zipcode = 'ZIPCODE',
  ZonePair = 'ZONE_PAIR'
}

export type TariffZoneUpdateInput = {
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  inboundZoneUuid?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<TariffLocationCreateInput>>;
  mileRangeEnd?: InputMaybe<Scalars['Float']['input']>;
  mileRangeStart?: InputMaybe<Scalars['Float']['input']>;
  /** Name of tariff */
  name?: InputMaybe<Scalars['String']['input']>;
  outboundZoneUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TariffZoneType>;
  uuid: Scalars['String']['input'];
};

export type TariffsDeleteInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type TenediCarrierIdentityEntity = {
  __typename?: 'TenediCarrierIdentityEntity';
  alternateIsaId?: Maybe<Scalars['String']['output']>;
  alternateStandardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  fourthAlternateIsaId?: Maybe<Scalars['String']['output']>;
  fourthAlternateScac?: Maybe<Scalars['String']['output']>;
  isaId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The carrier's SCACs that are set, primary first. A partnership must use one. */
  scacs: Array<Scalars['String']['output']>;
  secondAlternateIsaId?: Maybe<Scalars['String']['output']>;
  secondAlternateScac?: Maybe<Scalars['String']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  thirdAlternateIsaId?: Maybe<Scalars['String']['output']>;
  thirdAlternateScac?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type TenediCarrierIdentitySaveResultEntity = {
  __typename?: 'TenediCarrierIdentitySaveResultEntity';
  carrier: TenediCarrierIdentityEntity;
  changes: Array<TenediFieldChangeEntity>;
};

/** One of the carrier's customers, for the picker. */
export type TenediConnectionCustomerOptionEntity = {
  __typename?: 'TenediConnectionCustomerOptionEntity';
  displayName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  /** Partnerships between this customer and the carrier. */
  partnershipCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

/** Searches one carrier's customers for the Tenedi connections page, by name or customer EDI ID. */
export type TenediConnectionCustomersInput = {
  companyUuid: Scalars['String']['input'];
  /** 1 to 25. Defaults to 25. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TenediConnectionEntity = {
  __typename?: 'TenediConnectionEntity';
  carrier: TenediCarrierIdentityEntity;
  customer: TenediCustomerIdentityEntity;
  /** The backend's APP_ENV. */
  environment: Scalars['String']['output'];
  partnerships: Array<TenediPartnershipEntity>;
  production: Scalars['Boolean']['output'];
  readiness: Array<TenediReadinessItemEntity>;
  /** True when no readiness item blocks. */
  ready: Scalars['Boolean']['output'];
};

export type TenediConnectionInput = {
  companyUuid: Scalars['String']['input'];
  organizationUuid: Scalars['String']['input'];
};

export type TenediCustomerIdentityEntity = {
  __typename?: 'TenediCustomerIdentityEntity';
  defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod;
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type TenediCustomerIdentitySaveResultEntity = {
  __typename?: 'TenediCustomerIdentitySaveResultEntity';
  changes: Array<TenediFieldChangeEntity>;
  customer: TenediCustomerIdentityEntity;
};

/** One field a save changed, read back from the database. Lists join with ", ". */
export type TenediFieldChangeEntity = {
  __typename?: 'TenediFieldChangeEntity';
  after?: Maybe<Scalars['String']['output']>;
  before?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
};

export type TenediPartnershipEntity = {
  __typename?: 'TenediPartnershipEntity';
  allowEditingShipperBillOfLadingNumber: Scalars['Boolean']['output'];
  alternateStediPartnerId?: Maybe<Scalars['String']['output']>;
  autoAcceptOrders: Scalars['Boolean']['output'];
  canCreateMultipleStops: Scalars['Boolean']['output'];
  companyStandardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  edi214ShipmentStatuses: Array<Edi214ShipmentStatus>;
  ediOutboundPayloadDestination: EdiOutboundPayloadDestination;
  enableStaging: Scalars['Boolean']['output'];
  excludeZeroChargeInvoices: Scalars['Boolean']['output'];
  ignoreCancellations: Scalars['Boolean']['output'];
  ignoreNonEdiOutbound: Scalars['Boolean']['output'];
  removeSpacesFrom214Bol: Scalars['Boolean']['output'];
  send990InResponseTo204: Scalars['Boolean']['output'];
  send990InResponseTo211: Scalars['Boolean']['output'];
  sendBackupDocs: Scalars['Boolean']['output'];
  stedi210MappingId?: Maybe<Scalars['String']['output']>;
  stedi210TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stedi214MappingId?: Maybe<Scalars['String']['output']>;
  stedi214TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stedi990MappingId?: Maybe<Scalars['String']['output']>;
  stedi990TransactionSettingId?: Maybe<Scalars['String']['output']>;
  /** Read only on this page. */
  stediPartnershipId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  useStediGenerateEdiFunction: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type TenediPartnershipSaveResultEntity = {
  __typename?: 'TenediPartnershipSaveResultEntity';
  changes: Array<TenediFieldChangeEntity>;
  created: Scalars['Boolean']['output'];
  partnership: TenediPartnershipEntity;
};

export enum TenediReadinessCheck {
  CarrierIsaId = 'CARRIER_ISA_ID',
  CarrierScac = 'CARRIER_SCAC',
  CarrierStediPartnerId = 'CARRIER_STEDI_PARTNER_ID',
  CustomerInvoiceMethod = 'CUSTOMER_INVOICE_METHOD',
  CustomerIsaId = 'CUSTOMER_ISA_ID',
  CustomerStediPartnerId = 'CUSTOMER_STEDI_PARTNER_ID',
  EdiIdsUpperCase = 'EDI_IDS_UPPER_CASE',
  NoBlankScacPartnership = 'NO_BLANK_SCAC_PARTNERSHIP',
  NoXmlPartnership = 'NO_XML_PARTNERSHIP',
  PartnershipsSendToTenedi = 'PARTNERSHIPS_SEND_TO_TENEDI',
  PartnershipExists = 'PARTNERSHIP_EXISTS',
  Replies_990 = 'REPLIES_990',
  Statuses_214Selected = 'STATUSES_214_SELECTED',
  TenediDeliveryConfigured = 'TENEDI_DELIVERY_CONFIGURED',
  TenediSide = 'TENEDI_SIDE',
  UniqueInboundSender = 'UNIQUE_INBOUND_SENDER',
  WorkerSettings = 'WORKER_SETTINGS'
}

export type TenediReadinessItemEntity = {
  __typename?: 'TenediReadinessItemEntity';
  check: TenediReadinessCheck;
  fixIn: TenediReadinessSection;
  message: Scalars['String']['output'];
  status: TenediReadinessStatus;
};

export enum TenediReadinessSection {
  Carrier = 'CARRIER',
  Customer = 'CUSTOMER',
  Environment = 'ENVIRONMENT',
  Partnership = 'PARTNERSHIP',
  Tenedi = 'TENEDI'
}

export enum TenediReadinessStatus {
  Blocking = 'BLOCKING',
  Info = 'INFO',
  Ready = 'READY',
  Warning = 'WARNING'
}

export type TerminalAccessorialChargeDetailsEntity = {
  __typename?: 'TerminalAccessorialChargeDetailsEntity';
  chargeDetailsByContact: Array<ContactAccessorialChargeDetailsEntity>;
  terminalCode?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
};

export type TerminalCreateInput = {
  addressUuid: Scalars['String']['input'];
  /** Required if the terminal being created is an agent terminal */
  agentId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Required if and only if the line_haul_networks feature flag is enabled */
  serviceRegionId?: InputMaybe<Scalars['String']['input']>;
};

export type TerminalEfficiencyArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type TerminalEfficiencyReportEntity = {
  __typename?: 'TerminalEfficiencyReportEntity';
  actualHoursAreProxy: Scalars['Boolean']['output'];
  costBasis: CostBasis;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  hasDockAllowances: Scalars['Boolean']['output'];
  hasPdAllowances: Scalars['Boolean']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  overallEfficiencyPct?: Maybe<Scalars['Float']['output']>;
  terminals: Array<TerminalEfficiencyRowEntity>;
  totalActualHours: Scalars['Float']['output'];
  totalAllowedHours: Scalars['Float']['output'];
};

export type TerminalEfficiencyRowEntity = {
  __typename?: 'TerminalEfficiencyRowEntity';
  dockActualHours: Scalars['Float']['output'];
  dockAllowedHours: Scalars['Float']['output'];
  efficiencyPct?: Maybe<Scalars['Float']['output']>;
  pdActualHours: Scalars['Float']['output'];
  pdAllowedHours: Scalars['Float']['output'];
  status?: Maybe<TerminalEfficiencyStatus>;
  terminalCode: Scalars['String']['output'];
  terminalName: Scalars['String']['output'];
  terminalUuid: Scalars['String']['output'];
  totalActualHours: Scalars['Float']['output'];
  totalAllowedHours: Scalars['Float']['output'];
};

/** Combined P&D + dock terminal efficiency standing used by the Intelligence Board. */
export enum TerminalEfficiencyStatus {
  Efficient = 'EFFICIENT',
  Inefficient = 'INEFFICIENT',
  Moderate = 'MODERATE'
}

export type TerminalEntity = {
  __typename?: 'TerminalEntity';
  address: AddressEntity;
  agent?: Maybe<AgentFieldsEntity>;
  code: Scalars['String']['output'];
  /** Minutes after local midnight at which the terminal operating day starts. */
  dayStartMinutes: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serviceAreas: Array<TerminalServiceAreaEntity>;
  serviceRegion?: Maybe<ServiceRegionEntity>;
  serviceRegionId?: Maybe<Scalars['String']['output']>;
  startForTerminalLanes: Array<TerminalLaneEntity>;
  timeZone?: Maybe<Scalars['String']['output']>;
  timeZoneSource?: Maybe<TimeZoneSource>;
  uuid: Scalars['String']['output'];
};

/** An object representing a lane between two terminals, meaning orders can be moved directly from the start to the end terminal. */
export type TerminalLaneEntity = {
  __typename?: 'TerminalLaneEntity';
  endTerminal: TerminalEntity;
  id: Scalars['String']['output'];
  startTerminal: TerminalEntity;
};

export type TerminalPieceCount = {
  __typename?: 'TerminalPieceCount';
  pieceCount: Scalars['Int']['output'];
  terminalCode: Scalars['String']['output'];
};

export type TerminalReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  /** IANA zone the report reads its days in; honored only while terminal_local_times is on. When null, insight reports count each order on its stop's local service day, and the audit report uses the company zone. */
  reportTimeZone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
};

export type TerminalReportBucketEntity = {
  __typename?: 'TerminalReportBucketEntity';
  code: Scalars['String']['output'];
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type TerminalServiceAreaEntity = {
  __typename?: 'TerminalServiceAreaEntity';
  city?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type TerminalServiceAreaUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type TerminalTimeZoneChangePreviewEntity = {
  __typename?: 'TerminalTimeZoneChangePreviewEntity';
  /** The zone departures are read in now (the company zone when the terminal has none). */
  currentTimeZone: Scalars['String']['output'];
  /** How far a departure kept at the same local clock moves, in minutes (positive = later). */
  departureShiftMinutes: Scalars['Int']['output'];
  /** The zone after saving; null when it cannot be resolved. */
  newTimeZone?: Maybe<Scalars['String']['output']>;
  /** Runs not yet departed that keep their local clock and move. */
  runCount: Scalars['Int']['output'];
  sampleRunReferences: Array<Scalars['String']['output']>;
  /** Active lane schedules leaving the terminal on its own clock. */
  templateCount: Scalars['Int']['output'];
};

export type TerminalTimeZoneChangePreviewInput = {
  /** The address the form will save, when it differs from the stored one */
  address?: InputMaybe<TerminalZonePreviewAddressInput>;
  /** The manual zone the form will save; null when the zone is to come from the address */
  manualTimeZone?: InputMaybe<Scalars['String']['input']>;
  terminalUuid: Scalars['String']['input'];
};

export type TerminalUpdateInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** All of the UUIDs of the terminals to which there is a lane starting at the terminal being edited, replacing the existing terminal lanes */
  laneEndTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Required if and only if the line_haul_networks feature flag is enabled */
  serviceRegionId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type TerminalZonePreviewAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type TerminateDriverInput = {
  driverUuid: Scalars['String']['input'];
  terminationComments?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  terminationDate: Scalars['String']['input'];
};

export type TestApiOrderAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<ApiAddressLocationType>;
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type TestApiOrderContactPersonInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type TestApiOrderDestinationStopInput = {
  address: TestApiOrderAddressInput;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<TestApiOrderContactPersonInput>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  destinationStopType: DestinationStopType;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  startAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestApiOrderOriginStopInput = {
  address: TestApiOrderAddressInput;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<TestApiOrderContactPersonInput>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  hasTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  originStopType: OriginStopType;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  startAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestApiOrderPackageInput = {
  barcodes?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Int']['input'];
  type?: InputMaybe<PackageType>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type TestApiOrderResult = {
  __typename?: 'TestApiOrderResult';
  inboundApiRequestUuid: Scalars['String']['output'];
  merged: Scalars['Boolean']['output'];
  mergedIntoOrderName?: Maybe<Scalars['String']['output']>;
  mergedIntoOrderUuid?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
};

export type TestEdiOrderResult = {
  __typename?: 'TestEdiOrderResult';
  ediTransactionId?: Maybe<Scalars['String']['output']>;
  merged: Scalars['Boolean']['output'];
  mergedIntoOrderName?: Maybe<Scalars['String']['output']>;
  mergedIntoOrderUuid?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  schemaWarning?: Maybe<Scalars['String']['output']>;
};

export type TestJsonSchemaOnDocumentsForSchemaInput = {
  deadlineDateKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  schemaExclusions?: InputMaybe<Scalars['String']['input']>;
  schemaOverride?: InputMaybe<Scalars['String']['input']>;
  schemaUuid: Scalars['String']['input'];
};

export type TestJsonSchemaOnDocumentsForSchemaOutput = {
  __typename?: 'TestJsonSchemaOnDocumentsForSchemaOutput';
  differencesMap: Scalars['String']['output'];
  normalizedGptResults: Scalars['String']['output'];
  rawGptResults: Scalars['String']['output'];
};

export type TestOneSnapshotInput = {
  schemaRunUuid: Scalars['String']['input'];
};

export type TestOrderAppointmentInput = {
  appointmentTime: Scalars['DateTime']['input'];
  deliveryDate: Scalars['DateTime']['input'];
  endAppointmentTime: Scalars['DateTime']['input'];
};

export type TestOrderCustomChargeEntity = {
  __typename?: 'TestOrderCustomChargeEntity';
  createdAt: Scalars['DateTime']['output'];
  customCharge: CustomChargeEntity;
  total: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type TestOrderEntity = {
  __typename?: 'TestOrderEntity';
  createdAt: Scalars['DateTime']['output'];
  order: StandardOrderEntity;
  testOrderCustomCharges: Array<TestOrderCustomChargeEntity>;
  totalCharge: Scalars['Float']['output'];
  totalFreightCharge: Scalars['Float']['output'];
  totalFuelCharge: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum TestOrderStopType {
  Delivery = 'DELIVERY',
  PartnerCarrierDropoffAndDelivery = 'PARTNER_CARRIER_DROPOFF_AND_DELIVERY',
  PartnerCarrierDropoffLineHaulDelivery = 'PARTNER_CARRIER_DROPOFF_LINE_HAUL_DELIVERY',
  Pickup = 'PICKUP',
  PickupAndDelivery = 'PICKUP_AND_DELIVERY',
  PickupAndTransfer = 'PICKUP_AND_TRANSFER',
  PickupLineHaulDelivery = 'PICKUP_LINE_HAUL_DELIVERY',
  PickupLineHaulTransfer = 'PICKUP_LINE_HAUL_TRANSFER',
  PickupPartnerCarrierLineHaulPickup = 'PICKUP_PARTNER_CARRIER_LINE_HAUL_PICKUP',
  PickupPartnerCarrierPickup = 'PICKUP_PARTNER_CARRIER_PICKUP',
  RecoveryAndDelivery = 'RECOVERY_AND_DELIVERY',
  RecoveryLineHaulDelivery = 'RECOVERY_LINE_HAUL_DELIVERY'
}

export type TestPieceOutput = {
  __typename?: 'TestPieceOutput';
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: PieceStatus;
  uuid: Scalars['String']['output'];
};

export type TestSchemaInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export enum TestSmc3FreightState {
  NeedsRate = 'NEEDS_RATE',
  Rated = 'RATED'
}

export type TestSmc3RateInput = {
  destinationPostalCode: Scalars['String']['input'];
  freightClass: FreightClass;
  originPostalCode: Scalars['String']['input'];
  shipDate?: InputMaybe<Scalars['String']['input']>;
  weightPounds: Scalars['Int']['input'];
};

export type TestSnapshotInput = {
  bucket: Scalars['String']['input'];
  extractedFields: Array<ExtractedFieldInput>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchInput>;
  key: Scalars['String']['input'];
  schemaName: Scalars['String']['input'];
  schemaRunPages: Array<SchemaRunPageInput>;
  transformAnchorMatches: Array<TransformAnchorMatchInput>;
};

export type TextDriverInput = {
  dispatchedDate: Scalars['DateTime']['input'];
  driverUuid: Scalars['String']['input'];
  messageContents: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};

export type TextractSchemaFileInput = {
  filename: Scalars['String']['input'];
  textractType: TextractType;
};

export type TextractSchemaTestFileInput = {
  filename: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export enum TextractType {
  AnalyzeDocument = 'ANALYZE_DOCUMENT',
  DetectDocumentText = 'DETECT_DOCUMENT_TEXT'
}

export type ThirdPartyBrokerCreateInput = {
  name: Scalars['String']['input'];
};

export type ThirdPartyBrokerEntity = {
  __typename?: 'ThirdPartyBrokerEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ThirdPartyBrokerUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ThirdPartyContactEntity = ContactEntity & {
  __typename?: 'ThirdPartyContactEntity';
  accessorialGroupId?: Maybe<Scalars['String']['output']>;
  addresses: Array<AddressEntity>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment: Scalars['Boolean']['output'];
  apiName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay90: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay180: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay270: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay360: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay720: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPayAll: Scalars['Float']['output'];
  /** The customer balance for the contact in dollars */
  balance: Scalars['Float']['output'];
  billingContactEmail?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: Maybe<Scalars['Float']['output']>;
  billingPeriodDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  billingRunStart: Scalars['DateTime']['output'];
  businessDivision?: Maybe<BusinessDivisionEntity>;
  calculateInboundFreightCharges: Scalars['Boolean']['output'];
  calculateLineHaulFreightCharges: Scalars['Boolean']['output'];
  calculateOutboundFreightCharges: Scalars['Boolean']['output'];
  chargeMatrixColumnMappings: Array<ContactChargeMatrixColumnMappingEntity>;
  company: CompanyEntity;
  /** Returns at most 100 most-recent contact comments. Callers needing full enumeration must use a paginated query (TODO: expose contactCommentsConnection). */
  contactComments: Array<ContactCommentEntity>;
  contactOpenInvoiceValue: Scalars['Float']['output'];
  contactOpenInvoiceValue0to30d: Scalars['Float']['output'];
  contactOpenInvoiceValue31to38d: Scalars['Float']['output'];
  contactOpenInvoiceValue39to45d: Scalars['Float']['output'];
  contactOpenInvoiceValue46to60d: Scalars['Float']['output'];
  contactOpenInvoiceValue61to75d: Scalars['Float']['output'];
  contactOpenInvoiceValueOver75d: Scalars['Float']['output'];
  contactPersons: Array<ContactPersonEntity>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactStations: Array<ContactStationEntity>;
  contactStatistics: ContactStatsEntity;
  creditsAppliedToContactInvoices: Scalars['Float']['output'];
  customDunningReportFooter?: Maybe<Scalars['String']['output']>;
  customerAccessorials: Array<AccessorialUnion>;
  customerTariffs: Array<TariffEntity>;
  debitsAppliedToContactInvoices: Scalars['Float']['output'];
  defaultAddress?: Maybe<AddressEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  defaultEfmHandlingStation?: Maybe<Scalars['String']['output']>;
  defaultInvoiceTerms?: Maybe<InvoiceTermEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['output'];
  dimFactor: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  ediPartnership?: Maybe<EdiPartnershipEntity>;
  ediPartnerships: Array<EdiPartnershipEntity>;
  /** The tariff chain rating uses for each tariff type, in the order Ordinary, Line haul, Transfer, Recovery, Point to point: the contact's own chain, else the company default. A type with neither has no entry, and Recovery has none while the company has recovery tariffs off. */
  effectiveTariffChains: Array<EffectiveTariffChainEntity>;
  /** The contact's addresses on a SendGrid suppression list (bounce, invalid email or spam report). Emails to them are skipped. */
  emailSuppressions: Array<EmailSuppressionEntity>;
  emitPieceLevelWebhooks: Scalars['Boolean']['output'];
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This field no longer affects invoices and will be removed. */
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfColumns: Array<PdfColumnEntity>;
  invoiceTimePeriodSplit?: Maybe<TimePeriod>;
  invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName;
  isActive: Scalars['Boolean']['output'];
  isEfm?: Maybe<Scalars['Boolean']['output']>;
  isOverCreditLimit: Scalars['Boolean']['output'];
  isPrepaidOnly: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<DocumentEntity>;
  logoType?: Maybe<DocumentEntity>;
  masterAccount?: Maybe<MasterAccountEntity>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  /** Dollars of the contact credit memos taken up by debit memo offsets */
  offsetCredits: Scalars['Float']['output'];
  /** Dollars of the contact debit memos used to offset payments or credit memos */
  offsetDebits: Scalars['Float']['output'];
  /** Dollars of the contact payments taken up by debit memo offsets */
  offsetPayments: Scalars['Float']['output'];
  /** Returns at most 100 most-recent orders where this contact is the billing party. Callers needing full enumeration must use the paginated orders query (TODO: expose ordersConnection). */
  orders: Array<OrderEntity>;
  overdueInvoices: Array<InvoiceEntity>;
  paymentsAppliedToContactInvoices: Scalars['Float']['output'];
  /** Total closed balance across all posted invoices */
  postedInvoicesTotalClosedBalance: Scalars['Float']['output'];
  /** Total open balance across all posted invoices */
  postedInvoicesTotalOpenBalance: Scalars['Float']['output'];
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopContactId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId?: Maybe<Scalars['String']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['output'];
  requireScanToAdvancePieceStatusAtStops: Scalars['Boolean']['output'];
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  services: Array<ServiceEntity>;
  shortCode?: Maybe<Scalars['String']['output']>;
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  skipFuelCharge?: Maybe<Scalars['Boolean']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  tariffZones: Array<TariffZoneEntity>;
  /** @deprecated this field is a placeholder since the column was dropped from the table */
  thirdPartyContactType: ThirdPartyContactType;
  totalCredits: Scalars['Float']['output'];
  totalDebits: Scalars['Float']['output'];
  totalInvoicesAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPostedInvoicesAmount: Scalars['Float']['output'];
  /** @deprecated Contact type is deprecated. The column has been dropped from the db */
  type: ContactType;
  unappliedCredits?: Maybe<Scalars['Float']['output']>;
  unappliedDebits: Scalars['Float']['output'];
  unappliedPayments: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};


export type ThirdPartyContactEntityContactOpenInvoiceValueArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue0to30dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue31to38dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue39to45dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue46to60dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue61to75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValueOver75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};

export enum ThirdPartyContactType {
  OtherFacility = 'OTHER_FACILITY',
  Receiver = 'RECEIVER',
  Shipper = 'SHIPPER'
}

export type ThirdPartyUserEntity = {
  __typename?: 'ThirdPartyUserEntity';
  contacts: Array<ContactEntity>;
  email: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum TimeOfPodUpload {
  DoNotSend = 'DO_NOT_SEND',
  InvoiceSent = 'INVOICE_SENT',
  StopCompletion = 'STOP_COMPLETION'
}

export enum TimePeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum TimeZoneSource {
  Geo = 'GEO',
  Manual = 'MANUAL',
  Zip = 'ZIP'
}

export type TotalPackageWeightSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type TotalSkidsSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type TransferPieceToOrderInput = {
  newOrderUuid: Scalars['String']['input'];
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid: Scalars['String']['input'];
};

export type TransferPieceToOutboundOrderInput = {
  newOutboundOrderUuid: Scalars['String']['input'];
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid: Scalars['String']['input'];
};

export type TransformAnchorEntity = {
  __typename?: 'TransformAnchorEntity';
  blockId?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type TransformAnchorInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  text: Scalars['String']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type TransformAnchorMatchEntity = {
  __typename?: 'TransformAnchorMatchEntity';
  text: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type TransformAnchorMatchInput = {
  text: Scalars['String']['input'];
};

export type TransitionAppointmentInput = {
  action: AppointmentTransitionAction;
  /** The new window typed as a wall clock in an entry zone (terminal_local_times), in place of appointmentTime and endAppointmentTime. */
  appointmentLocal?: InputMaybe<StopAppointmentLocalInput>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  stopUuid: Scalars['String']['input'];
};

export type TransitionAppointmentOutput = MutationErrorOutput | TransitionAppointmentSuccessOutput;

export type TransitionAppointmentSuccessOutput = {
  __typename?: 'TransitionAppointmentSuccessOutput';
  status: AppointmentStatus;
  stopUuid: Scalars['String']['output'];
};

export type TriggerAdhocPreviewBatchInput = {
  companyUuid: Scalars['String']['input'];
  emailSimulation?: InputMaybe<AdhocEmailSimulationInput>;
  idempotencyKey: Scalars['String']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};

export type TriggerAdhocPreviewInput = {
  companyUuid: Scalars['String']['input'];
  emailSimulation?: InputMaybe<AdhocEmailSimulationInput>;
  idempotencyKey: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};

export type TriggerIngestionTestRunInput = {
  companyUuid: Scalars['String']['input'];
  confirmFullApply?: InputMaybe<Scalars['Boolean']['input']>;
  emailSimulation?: InputMaybe<AdhocEmailSimulationInput>;
  idempotencyKey: Scalars['String']['input'];
  mode: IngestionTestRunMode;
  uploadId: Scalars['String']['input'];
};

/** Outcome of truck-assignment for a route when the company's settings request auto-assign. */
export enum TruckFitNote {
  Assigned = 'ASSIGNED',
  NoTruckFit = 'NO_TRUCK_FIT',
  PreviewTentative = 'PREVIEW_TENTATIVE'
}

export enum TutorialId {
  AccountingDriverSettlement = 'accountingDriverSettlement',
  AccountingInvoices = 'accountingInvoices',
  AccountingSettlement = 'accountingSettlement',
  AllOrders = 'allOrders',
  AppointmentsBoard = 'appointmentsBoard',
  CompanySetup = 'companySetup',
  Customers = 'customers',
  DailyControlCenter = 'dailyControlCenter',
  DelegatedOrders = 'delegatedOrders',
  DeliveryNotifications = 'deliveryNotifications',
  Directory = 'directory',
  DispatchRoutes = 'dispatchRoutes',
  EmailIngestionConfigure = 'emailIngestionConfigure',
  EmailIngestionReview = 'emailIngestionReview',
  EmailOrders = 'emailOrders',
  EndOfDay = 'endOfDay',
  ExpeditorsApiStatus = 'expeditorsApiStatus',
  ExpeditorsScorecard = 'expeditorsScorecard',
  IbCostCenterStatement = 'ibCostCenterStatement',
  IbCostInputs = 'ibCostInputs',
  IbCustomerProfitability = 'ibCustomerProfitability',
  IbDockProductivity = 'ibDockProductivity',
  IbDriverPlanner = 'ibDriverPlanner',
  IbLineHaulUtilization = 'ibLineHaulUtilization',
  IbOperationalEfficiency = 'ibOperationalEfficiency',
  IbPdProductivity = 'ibPdProductivity',
  IbTerminalEfficiency = 'ibTerminalEfficiency',
  IbWeightBreak = 'ibWeightBreak',
  LineHaulDispatch = 'lineHaulDispatch',
  LinehaulCalmBoard = 'linehaulCalmBoard',
  LinehaulSchedule = 'linehaulSchedule',
  LoadPlanning3d = 'loadPlanning3d',
  OrderRequests = 'orderRequests',
  OwnersBreakfastDashboard = 'ownersBreakfastDashboard',
  PieceReceipts = 'pieceReceipts',
  Quotes = 'quotes',
  Reports = 'reports',
  ReservationSystem = 'reservationSystem',
  ScannedOrders = 'scannedOrders',
  Settings = 'settings',
  VirtualDock = 'virtualDock',
  WarehouseInventory = 'warehouseInventory',
  WarehousePacking = 'warehousePacking',
  WarehousePieces = 'warehousePieces',
  WarehouseReceipts = 'warehouseReceipts',
  WarehouseReports = 'warehouseReports',
  WarehouseSettings = 'warehouseSettings'
}

/** A filter object that is used to filter a UUID field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type UuidFilterV2 = {
  /** Filters for records where the relevant UUID is equal to the provided UUID */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is in the provided array of UUIDs */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant UUID field is null */
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant UUID field is not null */
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant UUID is not equal to the provided UUID */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is not in the provided array of UUIDs */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UnappliedPaymentReportCsvInput = {
  /** The list of filters that can be used to generate the unapplied payments report. */
  reportFilters: ReportFiltersInput;
};

export type UnassignInventoryItemsInput = {
  /** The UUID of the item whose inventory items need to be unassigned from the storage unit */
  itemUuid: Scalars['String']['input'];
  /** The UUID of the storage unit to unassign the inventory items from */
  uuid: Scalars['String']['input'];
};

export type UnassignInventoryItemsOutput = {
  __typename?: 'UnassignInventoryItemsOutput';
  success: Scalars['Boolean']['output'];
};

export type UnassignLegFromDriverInput = {
  driverUuid: Scalars['String']['input'];
  legUuid: Scalars['String']['input'];
};

export type UnassignOrderFromTrailerInput = {
  manifestUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type UnblockCompanySchedulingDayInput = {
  /** Reopens the day even though reopening DISCARDS the exemptions granted against it. Without it, a day carrying exemptions writes NOTHING and answers with CompanySchedulingDayExemptionsAtRiskOutput naming how many resources would lose theirs. A day carrying no exemptions is reopened without it. The exemptions cannot be recovered afterwards: closing the same day again starts from nobody exempt. */
  confirmDiscardsExemptions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Calendar day to reopen, as an ISO-8601 plain date (YYYY-MM-DD). */
  dateIso8601: Scalars['String']['input'];
};

export type UnblockSchedulingResourceDayInput = {
  /** Calendar day to unblock, as an ISO-8601 plain date (YYYY-MM-DD). */
  dateIso8601: Scalars['String']['input'];
  schedulingResourceId: Scalars['String']['input'];
};

export type UnconsolidateOrderInput = {
  orderUuid: Scalars['String']['input'];
};

export type UnfinalizeOrdersInput = {
  /** The UUIDs of the orders to be unfinalized */
  uuids: Array<Scalars['String']['input']>;
};

export type UnfinalizeOrdersOutput = MutationErrorOutput | UnfinalizeOrdersSuccessOutput;

export type UnfinalizeOrdersSuccessOutput = {
  __typename?: 'UnfinalizeOrdersSuccessOutput';
  /** The list of order UUIDs that failed to unfinalize */
  failedOrderUuids: Array<Scalars['String']['output']>;
  /** The list of order UUIDs skipped because they are on an invoice — unpost the invoice first */
  skippedOnInvoiceOrderUuids: Array<Scalars['String']['output']>;
  /** The list of order UUIDs that were successfully unfinalized */
  unfinalizedOrderUuids: Array<Scalars['String']['output']>;
};

export type UnifiedSearchConnectionArgsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UnifiedSearchEntity = {
  __typename?: 'UnifiedSearchEntity';
  invoices: InvoiceConnection;
  orders: OrderConnection;
  quotes: QuoteConnection;
  unacceptedEdiAndApiOrders: OrderConnection;
  unacceptedEmailOrders: ScannedOrderResultConnection;
};

export type UnifiedSearchInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  invoicesConnectionArgs?: InputMaybe<UnifiedSearchConnectionArgsInput>;
  ordersConnectionArgs: UnifiedSearchConnectionArgsInput;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  quotesConnectionArgs: UnifiedSearchConnectionArgsInput;
  searchText: Scalars['String']['input'];
  unacceptedEdiAndApiOrdersConnectionArgs: UnifiedSearchConnectionArgsInput;
  unacceptedEmailOrdersConnectionArgs: UnifiedSearchConnectionArgsInput;
};

export type UnitBasedAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ratePerUnit: Scalars['Float']['input'];
};

export type UnitBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'UnitBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  ratePerUnit: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type UnitBasedAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratePerUnit?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export enum UnitOfMeasure {
  Box = 'BOX',
  Carton = 'CARTON',
  Crate = 'CRATE',
  Each = 'EACH',
  Pallet = 'PALLET',
  Skid = 'SKID',
  Unit = 'UNIT'
}

export type UnlinkPieceFromOrderInput = {
  orderUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};

export type UnlinkPieceFromPackageInput = {
  packageUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};

/** Reason a candidate stop did not land on an auto-created route during a given run. */
export enum UnmatchedStopReason {
  AddressMissingLocation = 'ADDRESS_MISSING_LOCATION',
  NoRouteNameMatch = 'NO_ROUTE_NAME_MATCH',
  StopAlreadyOnRoute = 'STOP_ALREADY_ON_ROUTE',
  TargetRouteLocked = 'TARGET_ROUTE_LOCKED'
}

export type UnpackPiecesInput = {
  pieceUuids: Array<Scalars['String']['input']>;
};

export type UnpackPiecesOutput = {
  __typename?: 'UnpackPiecesOutput';
  restoredPieceCount: Scalars['Int']['output'];
  unpackedParentCount: Scalars['Int']['output'];
};

export type UnpickStorageUnitInput = {
  uuid: Scalars['String']['input'];
};

export type UnpickStorageUnitOutput = {
  __typename?: 'UnpickStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export type UnpostInvoiceInput = {
  uuid: Scalars['String']['input'];
};

export type UnpostInvoiceOutput = {
  __typename?: 'UnpostInvoiceOutput';
  success: Scalars['Boolean']['output'];
};

export type UnpostInvoicesInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type UnpostInvoicesOutput = MutationErrorOutput | UnpostInvoicesSuccessOutput;

export type UnpostInvoicesSuccessOutput = {
  __typename?: 'UnpostInvoicesSuccessOutput';
  /** UUIDs of invoices that failed to unpost due to an error */
  failedUuids: Array<Scalars['String']['output']>;
  /** UUIDs of invoices skipped because they have payments applied — remove the payment first */
  skippedWithPaymentsUuids: Array<Scalars['String']['output']>;
  /** UUIDs of invoices that were successfully unposted */
  unpostedUuids: Array<Scalars['String']['output']>;
};

export type UpdateAccessorialContactInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateAccessorialContactOutput = {
  __typename?: 'UpdateAccessorialContactOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateAccessorialDateRangeConfigInput = {
  accessorialDateRangeConfigToCopyUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialRangeCreateInputs?: InputMaybe<Array<AccessorialRangeCreateInput>>;
  accessorialRangeUpdateInputs?: InputMaybe<Array<AccessorialRangeUpdateInput>>;
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  rateUsd?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialChargeGroupUpdateInputs?: InputMaybe<Array<SpecialAccessorialChargeGroupUpdateInput>>;
  specialAccessorialMatrixItemUpdateInputs?: InputMaybe<Array<SpecialAccessorialMatrixItemUpdateInput>>;
  specialChargeGroupCreateInputs?: InputMaybe<Array<SpecialAccessorialChargeGroupCreateInput>>;
  specialMatrixItemsCreateInputs?: InputMaybe<Array<SpecialAccessorialMatrixItemCreateInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateAccessorialDateRangeConfigOutput = {
  __typename?: 'UpdateAccessorialDateRangeConfigOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateAccessorialGroupInput = {
  /** When provided, replaces the group membership wholesale. Omit to leave membership unchanged. */
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccessorialInput = {
  accessorialUpdateInput: AccessorialUpdateInput;
};

export type UpdateAddressInput = {
  addressUpdateInput: AddressUpdateInput;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
};

export type UpdateAirportInfoInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateApiUserInput = {
  apiUserUpdateInput: ApiUserUpdateInput;
};

export type UpdateAutoApplyAccessorialConfigInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  addresses?: InputMaybe<Array<AutoApplyAccessorialConfigAddressInput>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactsToExcludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactsToIncludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleType?: InputMaybe<AutoApplyAccessorialRuleType>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopType?: InputMaybe<PickupOrDelivery>;
  tagUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateBusinessDivisionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateBusinessDivisionOutput = {
  __typename?: 'UpdateBusinessDivisionOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateCompanyConfigurationInput = {
  addOrdersToOpenInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  allCapsInOrderPage?: InputMaybe<Scalars['Boolean']['input']>;
  allowDriverToSelectNextStop?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentChangeCutoffHours?: InputMaybe<Scalars['Int']['input']>;
  /** Which scheduling model owns this company appointment capacity. Nothing reads it yet. */
  appointmentSchedulerModel?: InputMaybe<AppointmentSchedulerModel>;
  appointmentSchedulingCutoffDays?: InputMaybe<Scalars['Int']['input']>;
  appointmentSchedulingLeadingBufferHours?: InputMaybe<Scalars['Int']['input']>;
  appointmentSchedulingSlotHours?: InputMaybe<Scalars['Int']['input']>;
  appointmentSelfRescheduleLimit?: InputMaybe<Scalars['Int']['input']>;
  autoApplyWaitTimeMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  autoGroupStops?: InputMaybe<Scalars['Boolean']['input']>;
  autoMatchEodDocumentsToOrders?: InputMaybe<Scalars['Boolean']['input']>;
  companyOrdinalStart?: InputMaybe<Scalars['Int']['input']>;
  createRecurringOrdersInAdvanceHours?: InputMaybe<Scalars['Int']['input']>;
  debounceAccessorialSearch?: InputMaybe<Scalars['Boolean']['input']>;
  debounceContactSearch?: InputMaybe<Scalars['Boolean']['input']>;
  defaultDimFactor?: InputMaybe<Scalars['Int']['input']>;
  defaultFuelSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSurchargeBillingMethod?: InputMaybe<FuelBillingMethod>;
  defaultGenerateAppointmentDurationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  defaultGenerateAppointmentEarlyCushionInMinutes?: InputMaybe<Scalars['Int']['input']>;
  defaultInvoiceDocumentsRequired?: InputMaybe<Array<DocumentType>>;
  defaultPalletHeight?: InputMaybe<Scalars['Int']['input']>;
  defaultPalletLength?: InputMaybe<Scalars['Int']['input']>;
  defaultPalletWidth?: InputMaybe<Scalars['Int']['input']>;
  defaultRouteLoadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  defaultRouteStartTime?: InputMaybe<Scalars['String']['input']>;
  defaultRouteUnloadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  defaultStandardStopType?: InputMaybe<StandardStopType>;
  defaultToAccessorial?: InputMaybe<Scalars['Boolean']['input']>;
  draftOrderCleanupDays?: InputMaybe<Scalars['Int']['input']>;
  draftOrderCleanupSources?: InputMaybe<Array<OrderSource>>;
  driverComplianceExpiringSoonDays?: InputMaybe<Scalars['Int']['input']>;
  driversShouldMarkFreightAsLoaded?: InputMaybe<Scalars['Boolean']['input']>;
  duplicateOrderMergeWindowHours?: InputMaybe<Scalars['Int']['input']>;
  enableConsolidatedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  enableDigitalSignatureFlow?: InputMaybe<Scalars['Boolean']['input']>;
  enablePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentTypeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  getDriverLocationDataFromMobile?: InputMaybe<Scalars['Boolean']['input']>;
  includeHyphensInInvoiceName?: InputMaybe<Scalars['Boolean']['input']>;
  includeINVInInvoiceName?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This setting no longer affects invoices and will be removed. */
  invoiceNotes?: InputMaybe<Scalars['String']['input']>;
  invoicePdfLogoUrl?: InputMaybe<Scalars['String']['input']>;
  lineHaulBuildAheadDays?: InputMaybe<Scalars['Int']['input']>;
  lineHaulEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulMobileFutureWindowHours?: InputMaybe<Scalars['Int']['input']>;
  lineHaulMobilePastWindowHours?: InputMaybe<Scalars['Int']['input']>;
  lineHaulPlanningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logisticsSectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  markOnHandUponPickup?: InputMaybe<Scalars['Boolean']['input']>;
  minDigitsInCompanyOrdinalOrderName?: InputMaybe<Scalars['Int']['input']>;
  mobilePollingIntervalInSeconds?: InputMaybe<Scalars['Float']['input']>;
  notificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderIdentifierForCoverSheet?: InputMaybe<OrderIdentifier>;
  orderLevelOsdEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderNamingScheme?: InputMaybe<OrderNamingScheme>;
  packageWarehouseLocationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pieceTransferableStatuses?: InputMaybe<Array<PieceStatus>>;
  pointToPointTariffsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  quoteAgentAutoSendMaxCents?: InputMaybe<Scalars['Int']['input']>;
  quoteAgentDailyModelBudgetCents?: InputMaybe<Scalars['Int']['input']>;
  quoteAgentDefaultMode?: InputMaybe<QuoteAgentPolicyMode>;
  quoteAgentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  quoteAgentMinConfidence?: InputMaybe<Scalars['Int']['input']>;
  quoteAgentValidityHours?: InputMaybe<Scalars['Int']['input']>;
  quoteContributionMarginalFromRatio?: InputMaybe<Scalars['Float']['input']>;
  quoteContributionProfitableFromRatio?: InputMaybe<Scalars['Float']['input']>;
  recoveryTariffsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  requireDimsToFinalizeCharges?: InputMaybe<Scalars['Boolean']['input']>;
  requireDriverSignature?: InputMaybe<Scalars['Boolean']['input']>;
  requireDriverToAcknowledgeRouteChange?: InputMaybe<Scalars['Boolean']['input']>;
  requireDriverToConfirmStopCompletedAtTime?: InputMaybe<Scalars['Boolean']['input']>;
  requireOnHandBeforeSelfScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use requirePODPhotoForDeliveries or requireSigneeNameForDeliveries */
  requirePODPhotoAndName?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use requirePODPhotoForPickups or requireSigneeNameForPickups */
  requirePODPhotoAndNameForPickups?: InputMaybe<Scalars['Boolean']['input']>;
  requirePODPhotoForDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  requirePODPhotoForPickups?: InputMaybe<Scalars['Boolean']['input']>;
  requireReviewForEdiOrderCreation?: InputMaybe<Scalars['Boolean']['input']>;
  requireSignedPodToCompleteStop?: InputMaybe<Scalars['Boolean']['input']>;
  requireSigneeNameForDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  requireSigneeNameForPickups?: InputMaybe<Scalars['Boolean']['input']>;
  restrictEditingOrderName?: InputMaybe<Scalars['Boolean']['input']>;
  reviewUrl?: InputMaybe<Scalars['String']['input']>;
  sameDayDispatchCellHeader?: InputMaybe<SameDayDispatchCellHeader>;
  sendSignedPodEmailAfterLateSignature?: InputMaybe<Scalars['Boolean']['input']>;
  sendSummaryEmailWithIncompleteRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  serviceLevelOptional?: InputMaybe<Scalars['Boolean']['input']>;
  showAccessorialsToDrivers?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Not relevant anymore */
  showChargesOnCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  showCompanyNameOnBillOfLadingDoc?: InputMaybe<Scalars['Boolean']['input']>;
  showDriverSettlementInBilling?: InputMaybe<Scalars['Boolean']['input']>;
  showHelpersColumnInDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  showKilogramsAndCentimeters?: InputMaybe<Scalars['Boolean']['input']>;
  showManuallyConfirmedByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  showVehicleInDailyDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  stampMobilePhotosWithTimeAndLocation?: InputMaybe<Scalars['Boolean']['input']>;
  startingInvoiceOrdinalNumber?: InputMaybe<Scalars['Float']['input']>;
  t2tDelegationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  t2tSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Terminals are always enabled. This input is ignored. */
  terminalsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  textNextCustomerForAppointments?: InputMaybe<Scalars['Boolean']['input']>;
  useDriverNumberForDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  useHawbForLotLabelBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  useJournalNumberForInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  useSeparateDigitalSignatureStep?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  wmsAutoMarkOnHand?: InputMaybe<Scalars['Boolean']['input']>;
  wmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wmsShortTermStorageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wmsStorageOrdersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCompanyInput = {
  alternateIsaId?: InputMaybe<Scalars['String']['input']>;
  alternateStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  blockSendingZeroDollarInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  companyLandscapeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  companySquareLogoUrl?: InputMaybe<Scalars['String']['input']>;
  /** A JSON object that represents the set of configurations for the company */
  configs?: InputMaybe<Scalars['String']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customDunningReportHeader?: InputMaybe<Scalars['String']['input']>;
  defaultAddressCreateInput?: InputMaybe<AddressCreateInput>;
  defaultAddressUpdateInput?: InputMaybe<AddressUpdateInput>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultMeasurementUnits?: InputMaybe<MeasurementUnits>;
  defaultNonCompanyDriverSettlementMode?: InputMaybe<SettlementMode>;
  defaultOrdinarySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoverySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultWeightUnits?: InputMaybe<WeightUnits>;
  ediPodFilenamePrefix?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateScac?: InputMaybe<Scalars['String']['input']>;
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  freightSnapId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  isCourier?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderNameOrdinal?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  purchasedProductOfferings?: InputMaybe<Array<PalletProductOffering>>;
  qbInvoiceNumberStart?: InputMaybe<Scalars['Float']['input']>;
  qboDefaultClassId?: InputMaybe<Scalars['String']['input']>;
  qboDefaultIncomeAccountId?: InputMaybe<Scalars['String']['input']>;
  qboDefaultTaxCodeId?: InputMaybe<Scalars['String']['input']>;
  qboFreightItemId?: InputMaybe<Scalars['String']['input']>;
  qboFuelItemId?: InputMaybe<Scalars['String']['input']>;
  qboLineHaulItemId?: InputMaybe<Scalars['String']['input']>;
  quickbooksCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccessorialId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopDeliveryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopFuelChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopLineHaulId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopOrderChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopPickupId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopRecoveryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopTransferId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingAccessorialChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  secondAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateScac?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Segment>;
  sendgridSenderId?: InputMaybe<Scalars['String']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateScac?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  useSageBusinessWorks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContactCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the contact comment to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdateContactCommentOutput = MutationErrorOutput | UpdateContactCommentSuccessOutput;

export type UpdateContactCommentSuccessOutput = {
  __typename?: 'UpdateContactCommentSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateContactCommunicationConfigInput = {
  updateContactCommunicationConfigInput: ContactCommunicationConfigUpdateInput;
};

export type UpdateContactEmailsInput = {
  communicationTypes: Array<ContactCommunicationType>;
  contactUuid: Scalars['String']['input'];
  orderUpdateEmails: Array<Scalars['String']['input']>;
};

export type UpdateContactEmailsOutput = MutationErrorOutput | UpdateContactEmailsSuccessOutput;

export type UpdateContactEmailsSuccessOutput = {
  __typename?: 'UpdateContactEmailsSuccessOutput';
  contactCommunicationConfigs: Array<ContactCommunicationConfigEntity>;
  contactEmails: Array<ContactEmailEntity>;
  contactUuid: Scalars['String']['output'];
};

export type UpdateContactPersonInput = {
  contactPersonUpdateInput: ContactPersonUpdateInput;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactQuickbooksIdInput = {
  quickbooksContactId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateContactQuickbooksIdsInput = {
  updateQuickbooksIdInputs: Array<UpdateContactQuickbooksIdInput>;
};

export type UpdateCsvOrderFieldMappingInput = {
  sourceColumnName?: InputMaybe<Scalars['String']['input']>;
  targetFieldType?: InputMaybe<CsvOrderMappingTargetFieldType>;
  uuid: Scalars['String']['input'];
};

export type UpdateCsvOrderImportTransactionInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  status: CsvOrderImportTransactionStatus;
  uuid: Scalars['String']['input'];
};

export type UpdateCsvOrderMappingInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  csvOrderFieldMappingCreateInputs?: InputMaybe<Array<CreateCsvOrderFieldMappingInput>>;
  deadlineDateDefaultValue?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTypeDefaultValue?: InputMaybe<DeadlineType>;
  enableDynamicInboundOrOutboundStop?: InputMaybe<Scalars['Boolean']['input']>;
  enableInboundStop?: InputMaybe<Scalars['Boolean']['input']>;
  enableOutboundStop?: InputMaybe<Scalars['Boolean']['input']>;
  freightBillingMethodDefaultValue?: InputMaybe<FreightBillingMethod>;
  name?: InputMaybe<Scalars['String']['input']>;
  pickupOrDeliveryDefaultValue?: InputMaybe<PickupOrDelivery>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopImportType?: InputMaybe<StopImportType>;
  stopTypeDefaultValue?: InputMaybe<StandardStopType>;
  uuid: Scalars['String']['input'];
};

export type UpdateCsvOrdersOrderInput = {
  packages: Array<CreateCsvOrdersPackageInput>;
  uuid: Scalars['String']['input'];
};

export type UpdateCustomerContactInput = {
  customerContactUpdateInput: CustomerContactUpdateInput;
};

export type UpdateCustomerContactOutput = {
  __typename?: 'UpdateCustomerContactOutput';
  customerContact: CustomerContactEntity;
};

export type UpdateCustomerContactPackageSpecsInput = {
  packageSpecIds: Array<Scalars['String']['input']>;
  useCustomPackageSpecs: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateCustomerContactVehicleTypesInput = {
  useCustomVehicleTypes: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
  vehicleTypeUuids: Array<Scalars['String']['input']>;
};

export type UpdateDefaultTariffChainsForCompany = MutationErrorOutput | UpdateDefaultTariffChainsForCompanySuccessOutput;

export type UpdateDefaultTariffChainsForCompanyInput = {
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinarySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoverySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultTariffChainsForCompanySuccessOutput = {
  __typename?: 'UpdateDefaultTariffChainsForCompanySuccessOutput';
  company: CompanyEntity;
};

export type UpdateDispatchTableColorsInput = {
  /** The new list of colors with the position in the array determining the precedence for selecting a color on the frontend */
  dispatchTableColors: Array<DispatchTableColorUpsertInput>;
};

export type UpdateDispatchTableColorsOutput = MutationErrorOutput | UpdateDispatchTableColorsSuccessOutput;

export type UpdateDispatchTableColorsSuccessOutput = {
  __typename?: 'UpdateDispatchTableColorsSuccessOutput';
  /** All of the dispatch table colors for the company in the configured order of precedence */
  dispatchTableColors: Array<DispatchTableColorEntity>;
};

export type UpdateDocumentInput = {
  documentUpdateInput: DocumentUpdateInput;
};

export type UpdateDocumentsInput = {
  documentUpdateInputs: Array<DocumentUpdateInput>;
};

export type UpdateDriverComplianceProfileInput = {
  /** YYYY-MM-DD */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  /** YYYY-MM-DD */
  hireDate?: InputMaybe<Scalars['String']['input']>;
  licenseClass?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  licenseState?: InputMaybe<Scalars['String']['input']>;
  securityId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDriverCredentialTypeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateDriverInput = {
  driverUpdateInput: DriverUpdateInput;
};

export type UpdateDriverInsurancePolicyInput = {
  carrierName?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  effectiveOn?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  expiresOn?: InputMaybe<Scalars['String']['input']>;
  insuranceType?: InputMaybe<Scalars['String']['input']>;
  insuredAmountUsd?: InputMaybe<Scalars['Float']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateDriverLocationInput = {
  forceUpdateLocation?: InputMaybe<Scalars['Boolean']['input']>;
  mobilePhoneLatitude: Scalars['Float']['input'];
  mobilePhoneLongitude: Scalars['Float']['input'];
  source?: InputMaybe<DriverLocationUpdateSource>;
};

export type UpdateDriverOutput = {
  __typename?: 'UpdateDriverOutput';
  driver: DriverEntity;
};

export type UpdateDriverQualificationsElementInput = {
  /** The ID of a driver qualification to update, or a new ID to create a new qualification. This must be a UUID. */
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateDriverQualificationsInput = {
  driverQualifications: Array<UpdateDriverQualificationsElementInput>;
};

export type UpdateDriverQualificationsOutput = {
  __typename?: 'UpdateDriverQualificationsOutput';
  driverQualifications: Array<DriverQualificationEntity>;
};

export type UpdateDriverSettlementBillInput = {
  driverSettlementBillUpdateInput: DriverSettlementBillUpdateInput;
};

export type UpdateDriverSignableFormTemplateInput = {
  formText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateDriverTrainingRecordInput = {
  /** YYYY-MM-DD */
  completedOn?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  expiresOn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  typeUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateDwellTimeAlertConfigInput = {
  /** Whether the config participates in alerting. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The dwell-time limit, in calendar days, beyond which on-dock freight is flagged. */
  thresholdDays: Scalars['Int']['input'];
  /** UUID of the config row to update. */
  uuid: Scalars['String']['input'];
};

export type UpdateEdiPartnershipInput = {
  allowEditingShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  alternateStediPartnerId?: InputMaybe<Scalars['String']['input']>;
  autoAcceptOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canCreateMultipleStops?: InputMaybe<Scalars['Boolean']['input']>;
  companyStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  edi214ShipmentStatuses?: InputMaybe<Array<Edi214ShipmentStatus>>;
  ediOutboundPayloadDestination?: InputMaybe<EdiOutboundPayloadDestination>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  excludeZeroChargeInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreCancellations?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreNonEdiOutbound?: InputMaybe<Scalars['Boolean']['input']>;
  includeItemizedChargesIn210?: InputMaybe<Scalars['Boolean']['input']>;
  includeOutboundFilenameReceiverIsaId?: InputMaybe<Scalars['Boolean']['input']>;
  mergeLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFilenameScacPrefix?: InputMaybe<Scalars['Boolean']['input']>;
  removeSpacesFrom214Bol?: InputMaybe<Scalars['Boolean']['input']>;
  requireGenerateEdi210Ids?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo204?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo211?: InputMaybe<Scalars['Boolean']['input']>;
  sendBackupDocs?: InputMaybe<Scalars['Boolean']['input']>;
  stedi210MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi210TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi214MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi214TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi990MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi990TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stediPartnershipId?: InputMaybe<Scalars['String']['input']>;
  tiffPodUpload?: InputMaybe<Scalars['Boolean']['input']>;
  timeOfPodUpload?: InputMaybe<TimeOfPodUpload>;
  useStediGenerateEdiFunction?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateEdiPartnershipOutput = {
  __typename?: 'UpdateEdiPartnershipOutput';
  ediPartnership?: Maybe<EdiPartnershipEntity>;
};

export type UpdateEmailIngestionExclusionsInput = {
  excludedCustomerUuids: Array<Scalars['String']['input']>;
  excludedDocumentTypes: Array<ClassifiedDocumentType>;
};

export type UpdateEmailTransactionInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  documentUuid?: InputMaybe<Scalars['String']['input']>;
  emailResponse?: InputMaybe<Scalars['String']['input']>;
  emailResponseStatus?: InputMaybe<Scalars['Int']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  sendgridMessageId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateEmailTransactionOutput = {
  __typename?: 'UpdateEmailTransactionOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateEndOfDayDocumentProcessingJobInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  status: EndOfDayDocumentsProcessingJobStatus;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadedFileName?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateEquipmentInput = {
  equipmentUpdateInput: EquipmentUpdateInput;
};

export type UpdateEquipmentLicenseInput = {
  equipmentLicenseUpdateInput: EquipmentLicenseUpdateInput;
};

export type UpdateFeatureFlagCompanyOverrideInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateFeatureFlagInput = {
  featureFlagUpdateInput: FeatureFlagUpdateInput;
};

export type UpdateFeatureFlagUserOverrideInput = {
  active: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateFreightChargeInput = {
  freightChargeUpdateInput: FreightChargeUpdateInput;
};

export type UpdateFuelProfileDateRangeInput = {
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateFuelProfileDateRangeOutput = {
  __typename?: 'UpdateFuelProfileDateRangeOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateFuelProfileInput = {
  billingType?: InputMaybe<FuelBillingMethod>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<FuelProfileType>;
  unappliedContactUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateGeneralLedgerCodeOutput = MutationErrorOutput | UpdateGeneralLedgerCodeSuccessOutput;

export type UpdateGeneralLedgerCodeSuccessOutput = {
  __typename?: 'UpdateGeneralLedgerCodeSuccessOutput';
  generalLedgerCode: GeneralLedgerCodeEntity;
};

export type UpdateGeneralLedgerConfigurationOutput = MutationErrorOutput | UpdateGeneralLedgerConfigurationSuccessOutput;

export type UpdateGeneralLedgerConfigurationSuccessOutput = {
  __typename?: 'UpdateGeneralLedgerConfigurationSuccessOutput';
  generalLedgerConfiguration: GeneralLedgerConfigurationEntity;
};

export type UpdateInAppNotificationPreferencesInput = {
  preferences: Array<InAppNotificationPreferenceInput>;
};

export type UpdateInventoryItemsInput = {
  itemUuid: Scalars['String']['input'];
  /** The updated number of inventory items for the specified item and storage order */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
  unitOfMeasure: UnitOfMeasure;
};

export type UpdateInventoryItemsOutput = {
  __typename?: 'UpdateInventoryItemsOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateInvoiceInput = {
  invoiceUpdateInput: InvoiceUpdateInput;
};

export type UpdateInvoiceNoteRuleInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Also print the company-wide rule's note after this rule's note. Not allowed on the company-wide rule itself. */
  includeCompanyNote?: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  rebilled?: InputMaybe<Scalars['Boolean']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  productCost?: InputMaybe<Scalars['Float']['input']>;
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ItemStatus>;
  upsertInventoryPrimaryUnitOfMeasureInput?: InputMaybe<UpsertInventoryPrimaryUnitOfMeasureInput>;
  upsertInventorySecondaryUnitOfMeasureInput?: InputMaybe<UpsertInventorySecondaryUnitOfMeasureInput>;
  upsertItemStorageUnitConfigInput?: InputMaybe<UpsertItemStorageUnitConfigInput>;
  uuid: Scalars['String']['input'];
};

export type UpdateItemLocationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the item location to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdateItemLocationOutput = {
  __typename?: 'UpdateItemLocationOutput';
  /** The item location that was created. It is null in the case a location with a duplicate name w.r.t to the company is passed in */
  itemLocation?: Maybe<ItemLocationEntity>;
};

export type UpdateKpiLayoutInput = {
  tiles?: InputMaybe<Array<KpiTileInput>>;
};

export type UpdateLegDriverMapInput = {
  legDriverMapUpdateInput: LegDriverMapUpdateInput;
};

export type UpdateLineHaulLaneInput = {
  lineHaulLaneUpdateInput: LineHaulLaneUpdateInput;
};

export type UpdateLineHaulLaneOutput = {
  __typename?: 'UpdateLineHaulLaneOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulLane: LineHaulLaneEntity;
};

export type UpdateLineHaulManifestInput = {
  lineHaulManifestUpdateInput: LineHaulManifestUpdateInput;
};

export type UpdateLineHaulSegmentInput = {
  lineHaulSegmentUpdateInput: LineHaulSegmentUpdateInput;
};

export type UpdateManifestDriverInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateManifestVehicleInput = {
  equipmentUuid: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateManifestsStatusInput = {
  manifestUuids: Array<Scalars['String']['input']>;
  status: LineHaulManifestStatus;
};

export type UpdateManifestsStatusOutput = MutationErrorOutput | UpdateManifestsStatusSuccessOutput;

export type UpdateManifestsStatusSuccessOutput = {
  __typename?: 'UpdateManifestsStatusSuccessOutput';
  lineHaulManifests: Array<LineHaulManifestEntity>;
};

export type UpdateMasterAccountInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateMasterAccountOutput = {
  __typename?: 'UpdateMasterAccountOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateMirrorTargetInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subscribesToAllCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateMyStopInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  stopUuid: Scalars['String']['input'];
};

export type UpdateOrderCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  showOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the order comment to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdateOrderDelegationRuleInput = {
  customerOrganizationUuid?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerWindowMinutes?: InputMaybe<Scalars['Int']['input']>;
  orderSources?: InputMaybe<Array<OrderSource>>;
  peerUuid?: InputMaybe<Scalars['String']['input']>;
  pickupHandling?: InputMaybe<DelegatedPickupHandling>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  ruleUuid: Scalars['String']['input'];
  scope?: InputMaybe<OrderDelegationScope>;
  shareEndCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  timing?: InputMaybe<OrderDelegationRuleTiming>;
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateOrderEventNotificationSubscriptionsInput = {
  contactUuid: Scalars['String']['input'];
  subscriptions: Array<OrderEventNotificationSubscriptionInput>;
};

export type UpdateOrderEventNotificationSubscriptionsOutput = MutationErrorOutput | UpdateOrderEventNotificationSubscriptionsSuccessOutput;

export type UpdateOrderEventNotificationSubscriptionsSuccessOutput = {
  __typename?: 'UpdateOrderEventNotificationSubscriptionsSuccessOutput';
  contactUuid: Scalars['String']['output'];
  subscriptions: Array<OrderEventNotificationSubscriptionEntity>;
};

export type UpdateOrderFormFieldsInput = {
  onePackageRequired: Scalars['Boolean']['input'];
  onePackageWeightRequired: Scalars['Boolean']['input'];
  /** @deprecated This field is no longer needed. Will be removed once the frontend stops using it. */
  packagePiecesRequired?: Scalars['Boolean']['input'];
  /** @deprecated This field is no longer needed. Will be removed once the frontend stops using it. */
  packageWeightRequired?: Scalars['Boolean']['input'];
};

export type UpdateOrderLoadedStatusInput = {
  /** Client-side ISO-8601 timestamp of when the driver actually loaded or unloaded the order. Used to preserve the real time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is more than 48 hours in the past or more than 5 minutes in the future (or absent), the server records its own time instead. */
  clientLoadedAt?: InputMaybe<Scalars['String']['input']>;
  loaded: Scalars['Boolean']['input'];
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

/** This is the graphql input for editing an organization. Identical to create input except we pass in uuid */
export type UpdateOrganizationInput = {
  customerFields?: InputMaybe<CreateOrUpdateCustomerInput>;
  defaultContactPersonUuid?: InputMaybe<Scalars['String']['input']>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isaId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  peerCompanyUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  types: Array<OrganizationType>;
  uuid: Scalars['String']['input'];
};

export type UpdateOrganizationMessageInput = {
  /** A new audience. Only a draft can change who it reaches. */
  audience?: InputMaybe<OrganizationMessageAudienceInput>;
  body?: Scalars['String']['input'];
  /** When the message stops showing. Omitted uses the severity default (INFO 14 days, WARNING 3 days, CRITICAL never); null means never. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  link?: InputMaybe<OrganizationMessageLinkInput>;
  severity: OrganizationMessageSeverity;
  /** Optional; most messages need only the body. */
  title?: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateOrganizationOutput = MutationErrorOutput | UpdateOrganizationSuccessOutput;

export type UpdateOrganizationPeersSettingsInput = {
  peers: Array<OrganizationPeerSettingsChangeInput>;
};

export type UpdateOrganizationSuccessOutput = {
  __typename?: 'UpdateOrganizationSuccessOutput';
  /** The updated organization */
  organization: OrganizationEntity;
};

export type UpdatePackageArrayInput = {
  orderUuid: Scalars['String']['input'];
  packageArrayUpdateInputs: Array<PackageArrayUpdateInput>;
  shipmentUuid: Scalars['String']['input'];
};

export type UpdatePackageInput = {
  packageUpdateInput: PackageUpdateInput;
};

export type UpdatePackageSpecInput = {
  freightClass?: InputMaybe<FreightClass>;
  height?: InputMaybe<Scalars['Length']['input']>;
  id: Scalars['String']['input'];
  length?: InputMaybe<Scalars['Length']['input']>;
  name: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type UpdatePackageSpecOutput = {
  __typename?: 'UpdatePackageSpecOutput';
  packageSpec: PackageSpecEntity;
};

export type UpdatePackageWarehouseLocationInput = {
  uuid: Scalars['String']['input'];
  /** The UUID of the new warehouse location that the package is being moved to */
  warehouseLocationUuid: Scalars['String']['input'];
};

export type UpdatePackageWarehouseLocationOutput = {
  __typename?: 'UpdatePackageWarehouseLocationOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdatePaperworkCompleteInput = {
  paperworkCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdatePaymentInput = {
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  creditTypeUuid?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  glTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  paymentRail?: InputMaybe<PaymentRail>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  updatePaymentToOrderMappingInput: Array<UpdatePaymentOrderMappingInput>;
  uuid: Scalars['String']['input'];
};

export type UpdatePaymentOffsetInput = {
  amountInCents: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdatePaymentOrderMappingInput = {
  amountInCents: Scalars['Int']['input'];
  orderUuid: Scalars['String']['input'];
};

export type UpdatePermissionAccessLevelInput = {
  accessLevel: AccessLevel;
  uuid: Scalars['String']['input'];
};

export type UpdatePermissionAccessLevelOutput = {
  __typename?: 'UpdatePermissionAccessLevelOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdatePermissionInput = {
  accessLevel?: InputMaybe<AccessLevel>;
  permissionResource?: InputMaybe<PermissionResource>;
  roleUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdatePermissionOutput = {
  __typename?: 'UpdatePermissionOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdatePersonInput = {
  contactStationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid: Scalars['String']['input'];
  defaultDeliveryAddress?: InputMaybe<AddressUpsertInput>;
  defaultPickupAddress?: InputMaybe<AddressUpsertInput>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultVehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonOutput = {
  __typename?: 'UpdatePersonOutput';
  person: PersonEntity;
};

export type UpdatePieceCountInput = {
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the order whose piece count is to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdatePieceDimensionsInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  /** Client-generated UUID for the package created by SPLIT_TO_NEW_PACKAGE; a repeat call with the same value is a no-op that returns the piece */
  newPackageUuid?: InputMaybe<Scalars['String']['input']>;
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  syncAction?: InputMaybe<PieceDimsSyncAction>;
  uuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePieceInput = {
  additionalReferenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  damagedNote?: InputMaybe<Scalars['String']['input']>;
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isMisrouted?: InputMaybe<Scalars['Boolean']['input']>;
  isOverage?: InputMaybe<Scalars['Boolean']['input']>;
  isShortage?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  refusedAt?: InputMaybe<Scalars['DateTime']['input']>;
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePieceReceiptInput = {
  /** Date the shipment arrived. Required. */
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the contact (customer) the receipt is created for */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  supplierCompanyName?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trailerNumber?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the piece receipt being updated */
  uuid: Scalars['String']['input'];
};

export type UpdatePieceReceiptOutput = {
  __typename?: 'UpdatePieceReceiptOutput';
  /** The piece receipt that was updated */
  pieceReceipt: PieceReceiptEntity;
};

export type UpdatePieceReceiptPieceInput = {
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  /** UUID of the receipt the piece must be attached to */
  pieceReceiptUuid: Scalars['String']['input'];
  /** UUID of the piece to update */
  pieceUuid: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  /** UUID of the warehouse location to move the piece to */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePieceReceiptPieceOutput = {
  __typename?: 'UpdatePieceReceiptPieceOutput';
  /** The updated piece */
  piece: PieceEntity;
};

export type UpdatePiecesPickedInput = {
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the order whose pieces picked is to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdatePlaceInput = {
  placeUpdateInput: PlaceUpdateInput;
};

export type UpdateQuickAddAccessorialsInput = {
  quickAddAccessorialUuids: Array<Scalars['String']['input']>;
};

export type UpdateQuickAddAccessorialsOutput = {
  __typename?: 'UpdateQuickAddAccessorialsOutput';
  quickAddAccessorials: Array<AccessorialUnion>;
};

export type UpdateQuickbooksHeaderFileMappingInput = {
  quickbooksHeaderFileMappingUpdateInput: QuickbooksHeaderFileMappingUpdateInput;
};

export type UpdateQuoteAgentStaffSettingsInput = {
  companyUuid: Scalars['String']['input'];
  quoteAgentDailyModelBudgetCents?: InputMaybe<Scalars['Int']['input']>;
  quoteAgentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateQuoteInput = {
  quoteUpdateInput: QuoteUpdateInput;
  uuid: Scalars['String']['input'];
};

export type UpdateRecurringLineHaulManifestTemplateInput = {
  autoGenerate?: InputMaybe<Scalars['Boolean']['input']>;
  createAheadDays?: InputMaybe<Scalars['Int']['input']>;
  createInAdvanceHours?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek: Array<DayOfWeekAll>;
  defaultDriverUuid?: InputMaybe<Scalars['String']['input']>;
  defaultEquipmentUuid?: InputMaybe<Scalars['String']['input']>;
  departTimeMinutes: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  manifestsPerOccurrence?: InputMaybe<Scalars['Int']['input']>;
  repeatFrequencyUnit?: InputMaybe<RepeatFrequencyUnit>;
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
  skipDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startDate: Scalars['DateTime']['input'];
  startTerminalUuid: Scalars['String']['input'];
  transitMinutes?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRecurringOrderFrequencyInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek?: InputMaybe<Array<DayOfWeekAll>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  repeatFrequencyUnit?: InputMaybe<RepeatFrequencyUnit>;
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
  repeatIntervalWeeks?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRecurringTemplateTruckInput = {
  cutoffTime?: InputMaybe<Scalars['String']['input']>;
  daysOfWeek?: InputMaybe<Array<DayOfWeekAll>>;
  label: Scalars['String']['input'];
  powerUnitEquipmentUuid?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  trailers: Array<RecurringTemplateTruckTrailerInput>;
  uuid: Scalars['String']['input'];
};

export type UpdateRoleInput = {
  isInternalRole?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRoleOutput = {
  __typename?: 'UpdateRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateRouteDriversInput = {
  driverUuids: Array<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRouteInput = {
  routeUpdateInput: RouteUpdateInput;
};

export type UpdateRouteNameLocationInput = {
  routeNameLocationCreateInput?: InputMaybe<RouteNameLocationCreateInput>;
  routeNameLocationUpdateInput: RouteNameLocationUpdateInput;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRouteOptimizationInput = {
  routeOptimizationUpdateInput: RouteOptimizationUpdateInput;
  uuid: Scalars['String']['input'];
};

export type UpdateRouteSlotInput = {
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  routeSlotUpdateInput: RouteSlotUpdateInput;
};

export type UpdateRouteSlotsInput = {
  routeSlotArrayUpdateInputs: Array<RouteSlotArrayUpdateInput>;
  routeSlotsUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRunInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Because name cannot be cleared out, passing in an empty string, null, or undefined will have no effect */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The UUIDs of the orders to be included under the run. Passing in null or undefined value will have no effect. */
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The UUIDs of the tags to be associated with this run. Passing in null or undefined value will have no effect. */
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRunOutput = {
  __typename?: 'UpdateRunOutput';
  run: RunEntity;
};

export type UpdateSameDayDispatchConfigInput = {
  deliveryAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  deliveryWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
  isNextInRouteColorCode?: InputMaybe<Scalars['String']['input']>;
  isPastDeadlineColorCode?: InputMaybe<Scalars['String']['input']>;
  isSpecialColorCode?: InputMaybe<Scalars['String']['input']>;
  pickupAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  pickupWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSavedFilterViewInput = {
  /** The page's default tab the view is based on (e.g. a Billing Review tab). Null means the page's base tab. */
  baseTab?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  filterModelJson?: InputMaybe<Scalars['String']['input']>;
  filterModelJsonV2?: InputMaybe<Scalars['JSON']['input']>;
  /** Ordered list of OrderTableField values the orders grid groups by, outermost first. Omit or pass null for an ungrouped view. */
  groupModelJson?: InputMaybe<Scalars['JSON']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  /** The line-haul dispatch board filters to restore with the view. Only accepted on LINE_HAUL_ORDERS views; null on update clears them. */
  lineHaulDispatchFilters?: InputMaybe<SavedLineHaulDispatchFiltersInput>;
  /** The new set of order columns to display for the saved filter view. If null, then the current set of order columns is maintained for the view */
  orderTableFields?: InputMaybe<Array<OrderTableField>>;
  savedViewPageType?: InputMaybe<FilterViewPage>;
  sortModelJson?: InputMaybe<Array<Scalars['JSON']['input']>>;
  uuid: Scalars['String']['input'];
};

export type UpdateScannedOrderInput = {
  companyUuid: Scalars['String']['input'];
  scannedOrderUpdateInput: ScannedOrderUpdateInput;
};

export type UpdateScannedOrderResultStatusInput = {
  /** Associate the result with this uuid. Used when an order is manually entered */
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  scannedOrderResultUuid: Scalars['String']['input'];
  status: ScannedOrderResultStatus;
};

export type UpdateSchedulingRegionInput = {
  dailyCapacityPieces?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityStops?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityWeight?: InputMaybe<Scalars['Mass']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingRegionOutput = MutationErrorOutput | UpdateSchedulingRegionSuccessOutput;

export type UpdateSchedulingRegionSuccessOutput = {
  __typename?: 'UpdateSchedulingRegionSuccessOutput';
  schedulingRegion: SchedulingRegionEntity;
};

export type UpdateSchedulingResourceInput = {
  /** Null means the resource has no piece limit. */
  capacityPieces?: InputMaybe<Scalars['Int']['input']>;
  /** Null means the resource has no stop limit. */
  capacityStops?: InputMaybe<Scalars['Int']['input']>;
  /** Null means the resource has no weight limit. */
  capacityWeight?: InputMaybe<Scalars['Mass']['input']>;
  dayOfWeek?: InputMaybe<DayOfWeekAll>;
  /** Earlier than start is accepted and means the window crosses midnight: the end then belongs to the calendar day after dayOfWeek, read in this resource timeZone. Nothing else has to be sent to say so. Equal to start is rejected, so a 24-hour window is not representable: express it as 00:00 to 23:59. Both fields are required and the columns behind them are NOT NULL, so a resource with no window at all is not representable either. */
  end?: InputMaybe<PlainTimeInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** UUIDs of the route names this resource covers. At least one is required. The capacity below is the total across all of them, not a per-route-name allowance. */
  routeNameUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  start?: InputMaybe<PlainTimeInput>;
  /** Canonical IANA region time zone the start and end times are read in, for example America/New_York. Fixed offsets, abbreviations and Etc/* zones are rejected because they are blind to daylight saving. Defaults to the company time zone. */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingZoneInput = {
  availabilities?: InputMaybe<Array<SchedulingZoneAvailabilityUpsertInput>>;
  id: Scalars['String']['input'];
  locations?: InputMaybe<Array<SchedulingZoneLocationUpsertInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedulingRegionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingZoneOutput = MutationErrorOutput | UpdateSchedulingZoneSuccessOutput;

export type UpdateSchedulingZoneSuccessOutput = {
  __typename?: 'UpdateSchedulingZoneSuccessOutput';
  schedulingZone: SchedulingZoneEntity;
};

export type UpdateSchemaCompanyMappingInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchemaDocumentInput = {
  schemaDocument: SchemaDocumentInput;
  uuid: Scalars['String']['input'];
};

export type UpdateSchemaInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  schema: SchemaInput;
  uuid: Scalars['String']['input'];
};

export type UpdateServiceDateForAssignedStopsInput = {
  serviceDate: Scalars['DateTime']['input'];
  /** The service date to set the stop sto, as an ISO 8601 formatted date string. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  stopUuids: Array<Scalars['String']['input']>;
};

export type UpdateServiceGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** When provided, replaces the group membership wholesale. Omit to leave membership unchanged. */
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateServiceInput = {
  serviceCreateInput?: InputMaybe<ServiceCreateInput>;
  serviceUpdateInput: ServiceUpdateInput;
};

export type UpdateServiceRegionInput = {
  id: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceRegionOutput = MutationErrorOutput | UpdateServiceRegionSuccessOutput;

export type UpdateServiceRegionSuccessOutput = {
  __typename?: 'UpdateServiceRegionSuccessOutput';
  /** The updated service region */
  serviceRegion: ServiceRegionEntity;
};

export type UpdateSftpCredentialsInput = {
  bundleShipmentPhotosWithPod?: InputMaybe<Scalars['Boolean']['input']>;
  ediPartnershipUuid?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  invoicePath?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  podNamingConvention?: InputMaybe<PodNamingConvention>;
  port?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateShipmentInput = {
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  shipmentUpdateInput: ShipmentUpdateInput;
};

export type UpdateShipmentStandardAccessorialsInput = {
  /** Accessorial uuids to keep. Any uuids excluded are removed */
  accessorialUuids: Array<Scalars['String']['input']>;
  shipmentUuid: Scalars['String']['input'];
};

export type UpdateStandaloneStopInput = {
  address: AddressUpsertInput;
  /** The appointment as typed in an entry zone. Send it instead of appointmentTime and endAppointmentTime, never with them. Requires terminal_local_times. */
  appointmentLocal?: InputMaybe<StopAppointmentLocalInput>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  serviceTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  stopUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStandardOrderInput = {
  orderUpdateInput: StandardOrderUpdateInput;
  /** The last known updatedAt timestamp from the client-side application. Used for validating concurrent updates to ensure data consistency. */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateStandardShipmentFieldInput = {
  standardShipmentFieldsUpdateInput: StandardShipmentFieldsUpdateInput;
};

export type UpdateStopDriverMapInput = {
  stopDriverMapUpdateInput: StopDriverMapUpdateInput;
};

export type UpdateStopInput = {
  stopUpdateInput: StopUpdateInput;
};

export type UpdateStopsInput = {
  stopUpdateInputs: Array<StopUpdateInput>;
};

export type UpdateStorageOrderInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the contact for whom the storage order is being created */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  documentUpsertInputs?: InputMaybe<Array<DocumentUpsertInput>>;
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  supplierCompanyName?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trailerNumber?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the storage order being updated */
  uuid: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStorageOrderOutput = {
  __typename?: 'UpdateStorageOrderOutput';
  /** The storage order that was updated */
  storageOrder: StorageOrderEntity;
};

export type UpdateStorageUnitInput = {
  billed?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Length']['input']>;
  inventoryLastVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  length?: InputMaybe<Scalars['Length']['input']>;
  markedOnHandAt?: InputMaybe<Scalars['DateTime']['input']>;
  markedOsdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  osdReason?: InputMaybe<Scalars['String']['input']>;
  outboundReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  pickedAt?: InputMaybe<Scalars['DateTime']['input']>;
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
  uuid: Scalars['String']['input'];
  /** The UUID of the newly assigned warehouse location for the storage unit. */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type UpdateStorageUnitOutput = {
  __typename?: 'UpdateStorageUnitOutput';
  storageUnit: StorageUnitEntity;
};

export type UpdateTagInput = {
  tagUpdateInput: TagUpdateInput;
};

export type UpdateTariffChainInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tariffGroupUuids: Array<Scalars['String']['input']>;
};

export type UpdateTariffChainOutput = MutationErrorOutput | UpdateTariffChainSuccessOutput;

export type UpdateTariffChainSuccessOutput = {
  __typename?: 'UpdateTariffChainSuccessOutput';
  /** The tariff chain that was updated */
  tariffChain: TariffChainEntity;
};

export type UpdateTariffGroupInput = {
  contactToServicesMappings?: InputMaybe<Array<CreateContactToServicesMappingInput>>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentTariffGroupUuid?: InputMaybe<Scalars['String']['input']>;
  rateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<RateType>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tariffCreateInputs?: InputMaybe<Array<TariffCreateInput>>;
  tariffGroupScope?: InputMaybe<TariffGroupScope>;
  tariffGroupType?: InputMaybe<TariffGroupType>;
  tariffOverageRateCreates?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  tariffType?: InputMaybe<TariffType>;
  /** The tariffs the group keeps. An array, empty included, upserts each one and disconnects every saved tariff it leaves out. Null leaves the tariffs alone; a point-to-point editor then saves lanes through savePointToPointLanes, and zone changes or tariffOverageRateCreates alongside a null list are refused. */
  tariffUpsertInputs?: InputMaybe<Array<TariffUpsertInput>>;
  tariffZoneCreateInputs?: InputMaybe<Array<TariffZoneCreateInput>>;
  tariffZoneDeletes: Array<Scalars['String']['input']>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUpdateInputs?: InputMaybe<Array<TariffZoneUpdateInput>>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  useActualWeightInCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  useDeficitBilling?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneType?: InputMaybe<TariffZoneType>;
};

/** The carrier's EDI identity. Omit a field to keep it; send null or blank to clear it. */
export type UpdateTenediCarrierIdentityInput = {
  alternateIsaId?: InputMaybe<Scalars['String']['input']>;
  alternateStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  /** Required as true when the backend runs in production. The page sends it only after the operator types prod. */
  confirmProduction?: InputMaybe<Scalars['Boolean']['input']>;
  fourthAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateScac?: InputMaybe<Scalars['String']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateScac?: InputMaybe<Scalars['String']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateScac?: InputMaybe<Scalars['String']['input']>;
};

/** The customer's EDI identity. Omit a field to keep it; send null or blank to clear it. */
export type UpdateTenediCustomerIdentityInput = {
  companyUuid: Scalars['String']['input'];
  /** Required as true when the backend runs in production. The page sends it only after the operator types prod. */
  confirmProduction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Omit to keep. Cannot be cleared. */
  defaultInvoiceTransmissionMethod?: InputMaybe<InvoiceTransmissionMethod>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  organizationUuid: Scalars['String']['input'];
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTerminalInput = {
  terminalUpdateInput: TerminalUpdateInput;
};

export type UpdateTerminalOutput = {
  __typename?: 'UpdateTerminalOutput';
  terminal: TerminalEntity;
};

export type UpdateTerminalSuccessOutput = {
  __typename?: 'UpdateTerminalSuccessOutput';
  /** The updated terminal */
  terminal: TerminalEntity;
};

export type UpdateTerminalV2Output = MutationErrorOutput | UpdateTerminalSuccessOutput;

export type UpdateTestOrderInput = {
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  totalFreightCharge?: InputMaybe<Scalars['Float']['input']>;
  totalFuelCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateTestOrderOutput = {
  __typename?: 'UpdateTestOrderOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateTestPieceStatusInput = {
  pieceUuids: Array<Scalars['String']['input']>;
  status: PieceStatus;
};

export type UpdateUserInput = {
  arrangeStopsAndRoutesVertically?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, the user is assigned an internal role that provides them with the master permission resource */
  assignInternalRole?: InputMaybe<Scalars['Boolean']['input']>;
  billingReviewOrderTableFields?: InputMaybe<Array<OrderTableField>>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dispatchTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  email?: InputMaybe<Scalars['String']['input']>;
  invoicesTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulOrderTableFields?: InputMaybe<Array<OrderTableField>>;
  linehaulDispatchTableFields?: InputMaybe<Array<LinehaulDispatchTableField>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfStops?: InputMaybe<Scalars['Float']['input']>;
  orderTableFields?: InputMaybe<Array<OrderTableField>>;
  ordersTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redirectIsAlertedOnFirstSave?: InputMaybe<Scalars['Boolean']['input']>;
  redirectIsAlertedOnOpenOrder?: InputMaybe<Scalars['Boolean']['input']>;
  reportsEmail?: InputMaybe<Scalars['String']['input']>;
  /** The list of roles to assign to a user */
  roleUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardStopTableFields?: InputMaybe<Array<DispatchTableField>>;
  routeCardWidth?: InputMaybe<Scalars['Float']['input']>;
  sendAllInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  sendSummaryEmailWithIncompleteRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateWarehouseEmployeeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateWarehouseEmployeeOutput = {
  __typename?: 'UpdateWarehouseEmployeeOutput';
  /** The affected warehouse employee. Shared by the update, archive, and restore mutations. It is null when the operation could not be applied — for example the employee was not found within the caller's company, the phone number is already used by a live employee, or a server-side error occurred. (Restore surfaces a phone-number conflict as a ConflictException rather than null.) */
  warehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
};

export type UpdateWarehouseInput = {
  addressUpdateInput: AddressUpdateInput;
  name: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateWarehouseLocationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  location1?: InputMaybe<Scalars['String']['input']>;
  location2?: InputMaybe<Scalars['String']['input']>;
  location3?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the warehouse location to be updated */
  uuid: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWarehouseLocationOutput = {
  __typename?: 'UpdateWarehouseLocationOutput';
  /** An array of error messages. This is null if there are no errors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The warehouse location that was updated. This is null if there is a warehouse location with a duplicate name passed in or  */
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type UploadMobileSignedDocumentInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  originalDocumentUuid: Scalars['String']['input'];
  signerName?: InputMaybe<Scalars['String']['input']>;
};

export type UploadMobileSignedDocumentOutput = {
  __typename?: 'UploadMobileSignedDocumentOutput';
  document?: Maybe<DocumentEntity>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type UpsertAddressInput = {
  addressUpsertInput: AddressUpsertInput;
  contactUuid: Scalars['String']['input'];
};

export type UpsertCompanyPackageTypeConfigInput = {
  isSingleHandlingUnit: Scalars['Boolean']['input'];
  packageType: PackageType;
};

export type UpsertCompanyPackageTypeConfigOutput = {
  __typename?: 'UpsertCompanyPackageTypeConfigOutput';
  companyPackageTypeConfig: CompanyPackageTypeConfigEntity;
};

export type UpsertContactPersonInput = {
  contactPersonUpsertInput: ContactPersonUpsertInput;
  contactUuid: Scalars['String']['input'];
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDockTimeAllowanceInput = {
  minutesPerHundredweight: Scalars['Float']['input'];
  minutesPerInboundPiece: Scalars['Float']['input'];
  minutesPerOutboundPiece: Scalars['Float']['input'];
};

export type UpsertDriverPlannerAssumptionsInput = {
  standardShiftHours: Scalars['Float']['input'];
  targetMgt: Scalars['Float']['input'];
  targetUtilizationPct: Scalars['Float']['input'];
};

export type UpsertEdiPartnershipReferenceMappingsInput = {
  ediPartnershipReferenceMappingUpsertInputs: Array<EdiPartnershipReferenceMappingUpsertInput>;
  ediPartnershipUuid: Scalars['String']['input'];
};

export type UpsertFreightChargeInput = {
  freightChargeUpsertInput: FreightChargeUpsertInput;
  shipmentUuid: Scalars['String']['input'];
};

export type UpsertInventoryPrimaryUnitOfMeasureInput = {
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpsertInventorySecondaryUnitOfMeasureInput = {
  primaryUnitsPerSecondaryUOM?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpsertItemGroupInput = {
  /** Increments the quantity of the item group. */
  incrementQuantityBy?: InputMaybe<Scalars['Int']['input']>;
  itemUuid: Scalars['String']['input'];
  /** Sets the quantity of the item group. Takes precedence over incrementQuantityBy. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Dictates if a new storage unit should be created. if a storageUnitUuid is supplied it will take priority */
  shouldCreateStorageUnit?: InputMaybe<Scalars['Boolean']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  storageUnitUuid?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
};

export type UpsertItemStorageUnitConfigInput = {
  consolidationUnitUOM: UnitOfMeasure;
  dimensionsUOM: WarehouseMeasurementUnits;
  height: Scalars['Float']['input'];
  high: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  primaryUnitsPerConsolidationUnit: Scalars['Float']['input'];
  tie: Scalars['Float']['input'];
  type: MeasurementUnits;
  uuid: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
  weightUOM: WarehouseMeasurementUnits;
  width: Scalars['Float']['input'];
};

export type UpsertLineHaulUtilizationAssumptionInput = {
  defaultTrailerCubeCapacityCubicFeet: Scalars['Float']['input'];
  defaultTrailerWeightCapacityLbs: Scalars['Float']['input'];
};

export type UpsertOrganizationPackageTypeConfigInput = {
  isSingleHandlingUnit: Scalars['Boolean']['input'];
  organizationUuid: Scalars['String']['input'];
  packageType: PackageType;
};

export type UpsertOrganizationPackageTypeConfigOutput = {
  __typename?: 'UpsertOrganizationPackageTypeConfigOutput';
  organizationPackageTypeConfig: OrganizationPackageTypeConfigEntity;
};

export type UpsertOrganizationQuotePolicyInput = {
  /** Whether a hazmat quote may auto-send. Null inherits, which is false because the company has no such setting; omitting the field keeps the stored value. */
  allowHazmatAuto?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ceiling in cents for auto-send below an amount. Null inherits the company ceiling; omitting the field keeps the stored value. */
  autoSendMaxCents?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum confidence as a fraction between 0 and 1. Null inherits the company default; omitting the field keeps the stored value. */
  minConfidence?: InputMaybe<Scalars['Float']['input']>;
  /** Null inherits the company default; omitting the field keeps the stored value. */
  mode?: InputMaybe<QuoteAgentPolicyMode>;
  organizationUuid: Scalars['String']['input'];
};

export type UpsertPackageInput = {
  orderUuid: Scalars['String']['input'];
  packageUpsertInput: PackageUpsertInput;
  shipmentUuid: Scalars['String']['input'];
};

export type UpsertPickListItemGroup = {
  itemGroupUuid: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type UpsertPicklistInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** List of item groups with quantities to be added to picklist */
  itemGroups: Array<UpsertPickListItemGroup>;
  outboundReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertPicklistOutput = {
  __typename?: 'UpsertPicklistOutput';
  error?: Maybe<Scalars['String']['output']>;
  picklist?: Maybe<PicklistEntity>;
};

export type UpsertSamsaraOauthTokenInput = {
  accessToken: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
  refreshToken: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  tokenType: Scalars['String']['input'];
};

export type UpsertServiceAvailabilityDateInput = {
  /** @deprecated Use end instead */
  availableEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Use start instead */
  availableStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The category or type of day. This uniquely identifies the ServiceAvailabilityDateEntity for the service. */
  dayCategory: SpecialDayOfWeek;
  enabled: Scalars['Boolean']['input'];
  end?: InputMaybe<PlainTimeInput>;
  start?: InputMaybe<PlainTimeInput>;
};

export type UpsertShipmentSubscriberInput = {
  shipmentSubscriberUpsertInput: ShipmentSubscriberUpsertInput;
  shipmentUuid: Scalars['String']['input'];
};

export type UpsertStopDriverMapInput = {
  stopDriverMapUpsertInput: StopDriverMapUpsertInput;
};

export type UpsertTimeAllowanceInput = {
  minutesPerHundredweight: Scalars['Float']['input'];
  minutesPerMile: Scalars['Float']['input'];
  minutesPerPiece: Scalars['Float']['input'];
  minutesPerStop: Scalars['Float']['input'];
};

export type UserActorEntity = {
  __typename?: 'UserActorEntity';
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type UserContactNotificationSubscriptionEntity = {
  __typename?: 'UserContactNotificationSubscriptionEntity';
  approveOrderNotification?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['String']['output'];
};

export type UserContactNotificationSubscriptionUpsertInput = {
  approveOrderNotification?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type UserEntity = {
  __typename?: 'UserEntity';
  arrangeStopsAndRoutesVertically: Scalars['Boolean']['output'];
  billingReviewOrderTableFields: Array<OrderTableField>;
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  dispatchTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  dispatchTableFields: Array<DispatchTableField>;
  driver?: Maybe<DriverEntity>;
  /** The email address of the user, or an empty string if it is null. The frontend is migrating towards accepting a nullable user.email, but we need this field to return a string until all clients are updated to accept nullable emails */
  email: Scalars['String']['output'];
  holdsPrivilegedRole: Scalars['Boolean']['output'];
  invoicesTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  isActive: Scalars['Boolean']['output'];
  lineHaulOrderTableFields: Array<OrderTableField>;
  linehaulDispatchTableFields: Array<LinehaulDispatchTableField>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfStops: Scalars['Float']['output'];
  orderTableFields: Array<OrderTableField>;
  ordersTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  redirectIsAlertedOnFirstSave?: Maybe<Scalars['Boolean']['output']>;
  redirectIsAlertedOnOpenOrder?: Maybe<Scalars['Boolean']['output']>;
  reportsEmail?: Maybe<Scalars['String']['output']>;
  reportsEmailSendgridSenderId?: Maybe<Scalars['String']['output']>;
  roles: Array<RoleEntity>;
  routeCardStopTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  routeCardStopTableFields: Array<DispatchTableField>;
  routeCardWidth: Scalars['Float']['output'];
  seenTutorials?: Maybe<Array<TutorialId>>;
  sendAllInvoices?: Maybe<Scalars['Boolean']['output']>;
  sendSummaryEmailWithIncompleteRoutes: Scalars['Boolean']['output'];
  terminal?: Maybe<TerminalEntity>;
  useMinimizedAppointmentTime: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type UserOptionEntity = {
  __typename?: 'UserOptionEntity';
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type UserSessionsAdminCompanyEntity = {
  __typename?: 'UserSessionsAdminCompanyEntity';
  activeUserCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type UserSessionsAdminCompanySearchInput = {
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type UserSessionsAdminCompanyUsersResult = {
  __typename?: 'UserSessionsAdminCompanyUsersResult';
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  users: Array<UserSessionsAdminUserEntity>;
};

export type UserSessionsAdminUserEntity = {
  __typename?: 'UserSessionsAdminUserEntity';
  canRevokeSessions: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** UUID filter fields for the findLineHaulManifestsV2 query */
export type UuidFilterV2Simple = {
  /** Filters for records where the relevant UUID is equal to the provided UUID */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is in the provided array of UUIDs */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant UUID is not equal to the provided UUID */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is not in the provided array of UUIDs */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A filter object that is used to filter a UUID list field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operators. */
export type UuidListFilter = {
  /** Filters for records where the relevant list contains the provided UUID */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant list is empty (or null) */
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant list is not empty */
  isNotEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant list does not contain the provided UUID */
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateCrownChargesInput = {
  /** The UUID of the company whose orders are being imported */
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of invoices with charges (CSV) */
  invoicesUrl?: InputMaybe<Scalars['String']['input']>;
  /** A publicly accessible URL of order charges (CSV) */
  ordersUrl: Scalars['String']['input'];
};

export type ValidateCrownChargesOutput = {
  __typename?: 'ValidateCrownChargesOutput';
  correctCrownIDs: Array<Scalars['String']['output']>;
  /** A 2D array of the CSV results of the rate validation */
  csvResults: Array<Array<Scalars['String']['output']>>;
  /** A publicly accessible URL of the rate validation results */
  resultsUrl: Scalars['String']['output'];
  wrongCrownIDs: Array<Scalars['String']['output']>;
};

export type ValidateImportedCrownInvoicesInput = {
  /** A publicly accessible URL of the charges breakdown report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  chargeBreakdownUrl: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the open invoices report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  openInvoicesUrl: Scalars['String']['input'];
};

export type ValidateImportedCrownInvoicesOutput = {
  __typename?: 'ValidateImportedCrownInvoicesOutput';
  correctCrownIDs: Array<Scalars['String']['output']>;
  correctInvoiceIDs: Array<Scalars['String']['output']>;
  /** A 2D array of the CSV results of the invoice import validation */
  invoiceCsvResults: Array<Array<Scalars['String']['output']>>;
  /** A publicly accessible URL of the invoice import validation results */
  invoiceResultsUrl: Scalars['String']['output'];
  /** A 2D array of the CSV results of the invoice order import validation */
  orderCsvResults: Array<Array<Scalars['String']['output']>>;
  /** A publicly accessible URL of the invoice order import validation results */
  orderResultsUrl: Scalars['String']['output'];
  wrongCrownIDs: Array<Scalars['String']['output']>;
  wrongInvoiceIDs: Array<Scalars['String']['output']>;
};

export type VehicleTypeCreateInput = {
  capacityNotes?: InputMaybe<Scalars['String']['input']>;
  doorHeight?: InputMaybe<Scalars['Length']['input']>;
  interiorHeightIn?: InputMaybe<Scalars['Float']['input']>;
  interiorLengthIn?: InputMaybe<Scalars['Float']['input']>;
  interiorWidthIn?: InputMaybe<Scalars['Float']['input']>;
  maxHeight?: InputMaybe<Scalars['Length']['input']>;
  maxLength?: InputMaybe<Scalars['Length']['input']>;
  maxVolume?: InputMaybe<Scalars['Volume']['input']>;
  maxWeight?: InputMaybe<Scalars['Mass']['input']>;
  maxWidth?: InputMaybe<Scalars['Length']['input']>;
  name: Scalars['String']['input'];
  packageSpecs?: InputMaybe<Array<VehicleTypePackageSpecUpsertInput>>;
  specialRules?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleTypeEntity = {
  __typename?: 'VehicleTypeEntity';
  capacityNotes?: Maybe<Scalars['String']['output']>;
  doorHeight?: Maybe<Scalars['Length']['output']>;
  interiorHeightIn?: Maybe<Scalars['Float']['output']>;
  interiorLengthIn?: Maybe<Scalars['Float']['output']>;
  interiorWidthIn?: Maybe<Scalars['Float']['output']>;
  maxHeight?: Maybe<Scalars['Length']['output']>;
  maxLength?: Maybe<Scalars['Length']['output']>;
  maxVolume?: Maybe<Scalars['Volume']['output']>;
  maxWeight?: Maybe<Scalars['Mass']['output']>;
  maxWidth?: Maybe<Scalars['Length']['output']>;
  name: Scalars['String']['output'];
  specialRules?: Maybe<Scalars['String']['output']>;
  status: VehicleTypeStatus;
  uuid: Scalars['String']['output'];
  vehicleTypePackageSpecs: Array<VehicleTypePackageSpecEntity>;
};

export type VehicleTypePackageSpecEntity = {
  __typename?: 'VehicleTypePackageSpecEntity';
  /** The ID of the VehicleTypePackageSpecEntity, not VehicleTypeEntity */
  id: Scalars['String']['output'];
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  packageSpec: PackageSpecEntity;
};

export type VehicleTypePackageSpecUpsertInput = {
  /** The number of packages of this spec that the vehicle can carry */
  maxQuantity?: InputMaybe<Scalars['Int']['input']>;
  packageSpecId: Scalars['String']['input'];
};

export enum VehicleTypeStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type VehicleTypeUpdateInput = {
  capacityNotes?: InputMaybe<Scalars['String']['input']>;
  doorHeight?: InputMaybe<Scalars['Length']['input']>;
  interiorHeightIn?: InputMaybe<Scalars['Float']['input']>;
  interiorLengthIn?: InputMaybe<Scalars['Float']['input']>;
  interiorWidthIn?: InputMaybe<Scalars['Float']['input']>;
  maxHeight?: InputMaybe<Scalars['Length']['input']>;
  maxLength?: InputMaybe<Scalars['Length']['input']>;
  maxVolume?: InputMaybe<Scalars['Volume']['input']>;
  maxWeight?: InputMaybe<Scalars['Mass']['input']>;
  maxWidth?: InputMaybe<Scalars['Length']['input']>;
  name: Scalars['String']['input'];
  packageSpecs?: InputMaybe<Array<VehicleTypePackageSpecUpsertInput>>;
  specialRules?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type VehicleTypeUpdateOutput = {
  __typename?: 'VehicleTypeUpdateOutput';
  vehicleType: VehicleTypeEntity;
};

export type VerifyInventoryForStorageUnitInput = {
  /** The UUID of the storage unit to verify inventory for */
  uuid: Scalars['String']['input'];
};

export type VerifyInventoryForStorageUnitOutput = {
  __typename?: 'VerifyInventoryForStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export enum ViewPermission {
  Admin = 'ADMIN',
  Edit = 'EDIT',
  View = 'VIEW'
}

export type WaitTimeAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  waitTimeChargePeriod: Scalars['Float']['input'];
  waitTimeFreeMinutes: Scalars['Float']['input'];
};

export type WaitTimeAccessorialEntity = AccessorialInterface & {
  __typename?: 'WaitTimeAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  waitTimeChargePeriod?: Maybe<Scalars['Float']['output']>;
  waitTimeFreeMinutes?: Maybe<Scalars['Float']['output']>;
};

export type WaitTimeAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
  waitTimeChargePeriod?: InputMaybe<Scalars['Float']['input']>;
  waitTimeFreeMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type WarehouseEmployeeEntity = {
  __typename?: 'WarehouseEmployeeEntity';
  active: Scalars['Boolean']['output'];
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type WarehouseEntity = {
  __typename?: 'WarehouseEntity';
  address: AddressEntity;
  createdAt: Scalars['DateTime']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type WarehouseLocationEntity = {
  __typename?: 'WarehouseLocationEntity';
  createdAt: Scalars['DateTime']['output'];
  location1?: Maybe<Scalars['String']['output']>;
  location2?: Maybe<Scalars['String']['output']>;
  location3?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};

export enum WarehouseMeasurementUnits {
  Centimeters = 'CENTIMETERS',
  CubicFeet = 'CUBIC_FEET',
  CubicInches = 'CUBIC_INCHES',
  Feet = 'FEET',
  Inches = 'INCHES',
  Kilograms = 'KILOGRAMS',
  Liters = 'LITERS',
  Meters = 'METERS',
  Milliliters = 'MILLILITERS',
  Ounces = 'OUNCES',
  Pounds = 'POUNDS',
  SquareFeet = 'SQUARE_FEET',
  Tonnes = 'TONNES'
}

export type WarehousesInput = {
  companyUuidFilter?: InputMaybe<Scalars['String']['input']>;
};

export enum WebhookPayloadShape {
  Appointment = 'APPOINTMENT',
  InvoicePosted = 'INVOICE_POSTED',
  InvoicePostedPerOrder = 'INVOICE_POSTED_PER_ORDER',
  MasterOrder = 'MASTER_ORDER',
  OrderStatusChange = 'ORDER_STATUS_CHANGE',
  PieceStatus = 'PIECE_STATUS',
  PodDocument = 'POD_DOCUMENT'
}

export enum WebhookTimestampMode {
  EventLocal = 'EVENT_LOCAL',
  StopLocal = 'STOP_LOCAL',
  Utc = 'UTC'
}

export type WeightBasedAccessorialCreateInput = {
  /** accessorial ranges to be created for this accessorial */
  accessorialRangeCreateInputs: Array<AccessorialRangeCreateInput>;
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ratePerHundredWeight: Scalars['Float']['input'];
};

export type WeightBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'WeightBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  accessorialRanges?: Maybe<Array<AccessorialRangeEntity>>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  ratePerHundredWeight: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type WeightBasedAccessorialUpdateInput = {
  accessorialRangeUpdateInputs?: InputMaybe<Array<AccessorialRangeUpdateInput>>;
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  ratePerHundredWeight?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type WeightBreakArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type WeightBreakBracketEntity = {
  __typename?: 'WeightBreakBracketEntity';
  contributionDollarsUsd?: Maybe<Scalars['Float']['output']>;
  contributionPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  contributionRatio?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  maxLbs?: Maybe<Scalars['Int']['output']>;
  minLbs: Scalars['Int']['output'];
  revenuePerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  revenueUsd: Scalars['Float']['output'];
  shipmentCount: Scalars['Int']['output'];
  status?: Maybe<WeightBreakStatus>;
  varCostPctOfRevenue?: Maybe<Scalars['Float']['output']>;
  variableCostPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  variableCostUsd?: Maybe<Scalars['Float']['output']>;
};

export type WeightBreakReportEntity = {
  __typename?: 'WeightBreakReportEntity';
  brackets: Array<WeightBreakBracketEntity>;
  costBasis: CostBasis;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  hasCostAssumptions: Scalars['Boolean']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  overallContributionPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  overallContributionRatio?: Maybe<Scalars['Float']['output']>;
  overallVarCostPctOfRevenue?: Maybe<Scalars['Float']['output']>;
  sweetSpotLabel?: Maybe<Scalars['String']['output']>;
  totalContributionDollarsUsd?: Maybe<Scalars['Float']['output']>;
  totalRevenueUsd: Scalars['Float']['output'];
  totalShipmentCount: Scalars['Int']['output'];
  totalVariableCostUsd?: Maybe<Scalars['Float']['output']>;
  upsideDownFromLabel?: Maybe<Scalars['String']['output']>;
};

/** Weight bracket standing relative to the carrier average variable cost percent used by the Intelligence Board. */
export enum WeightBreakStatus {
  Losing = 'LOSING',
  SweetSpot = 'SWEET_SPOT',
  UpsideDown = 'UPSIDE_DOWN'
}

export enum WeightUnits {
  Kilograms = 'KILOGRAMS',
  Pounds = 'POUNDS'
}

export type WhiteLabelCompanyEntity = {
  __typename?: 'WhiteLabelCompanyEntity';
  companyLandscapeLogoUrl?: Maybe<Scalars['String']['output']>;
  companySquareLogoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type WorkOrderEquipment = {
  __typename?: 'WorkOrderEquipment';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type WorkOrderListInput = {
  date: Scalars['DateTime']['input'];
  mode: FreightScanningV2ScanMode;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). When provided, the backend uses this timezone to compute day boundaries for date filters so that results reflect the calendar date in the user's local time rather than UTC. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type WorkOrderListItem = {
  __typename?: 'WorkOrderListItem';
  doorsClosedAt?: Maybe<Scalars['DateTime']['output']>;
  equipment?: Maybe<WorkOrderEquipment>;
  name: Scalars['String']['output'];
  orders: Array<WorkOrderOrder>;
  progress: WorkOrderProgress;
  runTimes: WorkOrderRunTimes;
  scheduledTime?: Maybe<Scalars['DateTime']['output']>;
  type: WorkOrderType;
  uuid: Scalars['String']['output'];
};

export type WorkOrderOrder = {
  __typename?: 'WorkOrderOrder';
  billingPartyContactDisplayName?: Maybe<Scalars['String']['output']>;
  destinationTerminalCode?: Maybe<Scalars['String']['output']>;
  finalDestinationAddress?: Maybe<FreightScanningV2AddressInfo>;
  hawb?: Maybe<Scalars['String']['output']>;
  loadSequence?: Maybe<Scalars['Int']['output']>;
  mawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originTerminalCode?: Maybe<Scalars['String']['output']>;
  packages: Array<WorkOrderPackage>;
  progress: WorkOrderProgress;
  tags: Array<TagEntity>;
  uuid: Scalars['String']['output'];
};

export type WorkOrderPackage = {
  __typename?: 'WorkOrderPackage';
  description?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Scalars['String']['output']>;
  pieces: Array<WorkOrderPiece>;
  quantity: Scalars['Int']['output'];
  type?: Maybe<PackageType>;
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type WorkOrderPiece = {
  __typename?: 'WorkOrderPiece';
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  damagedNote?: Maybe<Scalars['String']['output']>;
  documents: Array<FreightScanningV2DocumentInfo>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isPieceCompletedForMode: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  scannedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  terminal?: Maybe<FreightScanningV2TerminalInfo>;
  uuid?: Maybe<Scalars['String']['output']>;
  warehouse?: Maybe<FreightScanningV2WarehouseInfo>;
  warehouseLocation?: Maybe<FreightScanningV2WarehouseLocationInfo>;
};

export type WorkOrderProgress = {
  __typename?: 'WorkOrderProgress';
  current: Scalars['Int']['output'];
  expected: Scalars['Int']['output'];
};

export type WorkOrderRunTimes = {
  __typename?: 'WorkOrderRunTimes';
  destinationArrivalActual?: Maybe<Scalars['DateTime']['output']>;
  destinationArrivalEstimated?: Maybe<Scalars['DateTime']['output']>;
  destinationArrivalEstimatedAsOf?: Maybe<Scalars['DateTime']['output']>;
  destinationTimeZone?: Maybe<Scalars['String']['output']>;
  originDepartureActual?: Maybe<Scalars['DateTime']['output']>;
  originDepartureEstimated?: Maybe<Scalars['DateTime']['output']>;
  originDepartureInferred?: Maybe<Scalars['DateTime']['output']>;
  originTimeZone?: Maybe<Scalars['String']['output']>;
};

/** Type of work order - either a delivery route or line haul manifest */
export enum WorkOrderType {
  LineHaul = 'LINE_HAUL',
  Route = 'ROUTE'
}

export type XyTransformEntity = {
  __typename?: 'XyTransformEntity';
  rotation: Scalars['Float']['output'];
  xMin: Scalars['Float']['output'];
  xScale: Scalars['Float']['output'];
  xTranslation: Scalars['Float']['output'];
  yMin: Scalars['Float']['output'];
  yScale: Scalars['Float']['output'];
  yTranslation: Scalars['Float']['output'];
};

export type ZipcodeOptionEntity = {
  __typename?: 'ZipcodeOptionEntity';
  zipcode: Scalars['String']['output'];
};

export type ZoneBasedAccessorialChargeGroupArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  zoneBasedAccessorialChargeGroupCreateInput?: InputMaybe<ZoneBasedAccessorialChargeGroupCreateInput>;
  /** Pass this field in to update an array item */
  zoneBasedAccessorialChargeGroupUpdateInput?: InputMaybe<ZoneBasedAccessorialChargeGroupUpdateInput>;
};

export type ZoneBasedAccessorialChargeGroupCreateInput = {
  name: Scalars['String']['input'];
};

export type ZoneBasedAccessorialChargeGroupEntity = {
  __typename?: 'ZoneBasedAccessorialChargeGroupEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ZoneBasedAccessorialChargeGroupUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ZoneBasedAccessorialCreateInput = {
  name: Scalars['String']['input'];
  zoneBasedChargeGroups: Array<ZoneBasedAccessorialChargeGroupCreateInput>;
  zoneBasedMatrixItems: Array<ZoneBasedAccessorialMatrixItemCreateInput>;
  zones: Array<ZoneBasedAccessorialZoneCreateInput>;
};

export type ZoneBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'ZoneBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  chargeGroups: Array<ZoneBasedAccessorialChargeGroupEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  matrixItems: Array<ZoneBasedAccessorialMatrixItemEntity>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  zones: Array<ZoneBasedAccessorialZoneEntity>;
};

export type ZoneBasedAccessorialMatrixItemArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  matrixItemCreateInput?: InputMaybe<ZoneBasedAccessorialMatrixItemCreateInput>;
  /** Pass this field in to update an array item */
  matrixItemUpdateInput?: InputMaybe<ZoneBasedAccessorialMatrixItemUpdateInput>;
};

export type ZoneBasedAccessorialMatrixItemCreateInput = {
  chargeGroupName: Scalars['String']['input'];
  /** Accepts rate as a $ float with two decimal places */
  rate: Scalars['Float']['input'];
  zoneName: Scalars['String']['input'];
};

export type ZoneBasedAccessorialMatrixItemEntity = {
  __typename?: 'ZoneBasedAccessorialMatrixItemEntity';
  chargeGroupUuid: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  zoneUuid: Scalars['String']['output'];
};

export type ZoneBasedAccessorialMatrixItemUpdateInput = {
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type ZoneBasedAccessorialUpdateInput = {
  chargeGroupUpdates?: InputMaybe<Array<ZoneBasedAccessorialChargeGroupArrayUpdateInput>>;
  matrixItemsArrayUpdateInput?: InputMaybe<Array<ZoneBasedAccessorialMatrixItemArrayUpdateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zoneArrayUpdates?: InputMaybe<Array<ZoneBasedAccessorialZoneArrayUpdateInput>>;
};

export type ZoneBasedAccessorialZoneArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  zoneBasedAccessorialZoneCreateInput?: InputMaybe<ZoneBasedAccessorialZoneCreateInput>;
  /** Pass this field in to update an array item */
  zoneBasedAccessorialZoneUpdateInput?: InputMaybe<ZoneBasedAccessorialZoneUpdateInput>;
};

export type ZoneBasedAccessorialZoneCreateInput = {
  name: Scalars['String']['input'];
};

export type ZoneBasedAccessorialZoneEntity = {
  __typename?: 'ZoneBasedAccessorialZoneEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ZoneBasedAccessorialZoneUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type CompanyAccountTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyAccountTypesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'CompanyEntity', uuid: string, name: string, accountType: CompanyAccountType }> };

export type SetCompanyAccountTypeMutationVariables = Exact<{
  input: SetCompanyAccountTypeInput;
}>;


export type SetCompanyAccountTypeMutation = { __typename?: 'Mutation', setCompanyAccountType: { __typename?: 'CompanyEntity', uuid: string, accountType: CompanyAccountType } };

export type ScannedOrderResultAdminDetailQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ScannedOrderResultAdminDetailQuery = { __typename?: 'Query', scannedOrderResultForAdmin?: { __typename?: 'ScannedOrderResultEntity', uuid: string, createdAt: any, status: ScannedOrderResultStatus, failureReason?: ScannedOrderFailureReason | null, pageStart: number, pageEnd: number, preSignedGetUrl?: string | null, applyPlan?: { __typename?: 'AdhocApplyPlanEntity', billingParty: { __typename?: 'AdhocApplyPlanBillingPartyEntity', mechanism: string, contactUuid?: string | null, senderVerdict?: string | null }, service?: { __typename?: 'AdhocApplyPlanServiceEntity', mechanism: string, serviceId?: string | null } | null, deadlineType?: { __typename?: 'AdhocApplyPlanDeadlineTypeEntity', mechanism: string, value: string } | null, duplicate?: { __typename?: 'AdhocApplyPlanDuplicateEntity', isDuplicate: boolean, duplicateOrderUuid?: string | null, wouldAdoptOrphanUuid?: string | null } | null } | null, extractionDetail?: { __typename?: 'ScannedOrderResultExtractionDetail', extractedFields?: any | null, usage?: any | null, exemplarMarker?: any | null, correlationId?: string | null, pipelineVersion?: string | null, taxonomyVersion?: string | null } | null, exemplars: Array<{ __typename?: 'ScannedOrderResultExemplar', documentId: string, documentType: string, source: string, cosineSimilarity: number, rank: number, preSignedGetUrl?: string | null }>, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, scannedOrder: { __typename?: 'ScannedOrderEntity', createdAt: any, source: ScannedOrderSource, documentIngestionPipeline: DocumentIngestionPipeline, ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', receivedAt?: any | null, subject?: string | null, fromAddress?: string | null } }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null } | null };

export type ScannedOrderResultsForLogsQueryVariables = Exact<{
  args: GetScannedOrderResultsForAdminArgs;
}>;


export type ScannedOrderResultsForLogsQuery = { __typename?: 'Query', scannedOrderResultsForAdmin: { __typename?: 'ScannedOrderResultConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ScannedOrderResultEdge', node: { __typename?: 'ScannedOrderResultEntity', uuid: string, createdAt: any, schemaUuid?: string | null, status: ScannedOrderResultStatus, failureReason?: ScannedOrderFailureReason | null, preSignedGetUrl?: string | null, company: { __typename?: 'CompanyEntity', name: string }, scannedOrder: { __typename?: 'ScannedOrderEntity', source: ScannedOrderSource, documentIngestionPipeline: DocumentIngestionPipeline, ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', receivedAt?: any | null, subject?: string | null, fromAddress?: string | null } }, order?: { __typename?: 'StandardOrderEntity', uuid: string, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateOutlookIntegrationMutationVariables = Exact<{
  outlookIntegrationCreateInput: OutlookIntegrationCreateInput;
}>;


export type CreateOutlookIntegrationMutation = { __typename?: 'Mutation', createOutlookIntegration: { __typename?: 'OutlookIntegrationEntity', uuid: string } };

export type OutlookIntegrationsForInternalQueryVariables = Exact<{
  getOutlookIntegrationsForInternalInput: GetOutlookIntegrationsForInternalInput;
}>;


export type OutlookIntegrationsForInternalQuery = { __typename?: 'Query', outlookIntegrationsForInternal: Array<{ __typename?: 'OutlookIntegrationEntity', uuid: string, createdAt: any, entraTenantId: string, entraUserId: string, emailCreatedAtStartDate?: any | null, outboundEmailDomains: Array<string>, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, user: { __typename?: 'UserActorEntity', uuid: string, name?: string | null } }> };

export type UpdateOutlookIntegrationMutationVariables = Exact<{
  outlookIntegrationUpdateInput: OutlookIntegrationUpdateInput;
}>;


export type UpdateOutlookIntegrationMutation = { __typename?: 'Mutation', updateOutlookIntegration: { __typename?: 'OutlookIntegrationEntity', uuid: string } };

export type CompanyQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CompanyQuery = { __typename?: 'Query', companyByUuid?: { __typename?: 'CompanyEntity', id: number, uuid: string, name: string, createdAt: any, configuration?: { __typename?: 'CompanyConfigurationEntity', invoicePdfLogoUrl?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', city: string, state: string } | null } | null };

export type DocScanVolumeByPipelineReportQueryVariables = Exact<{
  docScanVolumeByPipelineInput: DocScanVolumeByPipelineInput;
}>;


export type DocScanVolumeByPipelineReportQuery = { __typename?: 'Query', docScanVolumeByPipelineReport: Array<{ __typename?: 'DocScanVolumeByPipelineBucketEntity', startDate: any, endDate: any, pipeline: DocumentIngestionPipeline, totalCount: number }> };

export type OrderVolumeByCompanyReportQueryVariables = Exact<{
  orderVolumeByCompanyInput: OrderVolumeByCompanyInput;
}>;


export type OrderVolumeByCompanyReportQuery = { __typename?: 'Query', orderVolumeByCompanyReport: Array<{ __typename?: 'OrderVolumeCompanyBucketEntity', companyUuid: string, companyName: string, sourceAmounts: Array<{ __typename?: 'OrderVolumeSourceBucketEntity', source: OrderSource, scannedOrderSource?: ScannedOrderSource | null, totalCount: number }> }> };

export type OrderVolumeByContactReportQueryVariables = Exact<{
  orderVolumeByContactInput: OrderVolumeByContactInput;
}>;


export type OrderVolumeByContactReportQuery = { __typename?: 'Query', orderVolumeByContactReport: Array<{ __typename?: 'OrderVolumeContactBucketEntity', contactUuid: string, contactName: string, sourceAmounts: Array<{ __typename?: 'OrderVolumeSourceBucketEntity', source: OrderSource, scannedOrderSource?: ScannedOrderSource | null, totalCount: number }> }> };

export type OrderVolumeByDateRangeReportQueryVariables = Exact<{
  orderVolumeByDateRangeInput: OrderVolumeByDateRangeInput;
}>;


export type OrderVolumeByDateRangeReportQuery = { __typename?: 'Query', orderVolumeByDateRangeReport: Array<{ __typename?: 'OrderVolumeDateRangeBucketEntity', startDate: any, endDate: any, sourceAmounts: Array<{ __typename?: 'OrderVolumeSourceBucketEntity', source: OrderSource, scannedOrderSource?: ScannedOrderSource | null, totalCount: number }> }> };

export type OrderVolumeBySchemaReportQueryVariables = Exact<{
  orderVolumeBySchemaInput: OrderVolumeBySchemaInput;
}>;


export type OrderVolumeBySchemaReportQuery = { __typename?: 'Query', orderVolumeBySchemaReport: Array<{ __typename?: 'OrderVolumeSchemaBucketEntity', schemaUuid?: string | null, schemaName: string, total: number }> };

export type OrderVolumeByUserReportQueryVariables = Exact<{
  orderVolumeByUserInput: OrderVolumeByUserInput;
}>;


export type OrderVolumeByUserReportQuery = { __typename?: 'Query', orderVolumeByUserReport: Array<{ __typename?: 'OrderVolumeUserBucketEntity', userUuid: string, name?: string | null, userEmail: string, userTerminalName?: string | null, sourceAmounts: Array<{ __typename?: 'OrderVolumeSourceBucketEntity', source: OrderSource, scannedOrderSource?: ScannedOrderSource | null, totalCount: number }> }> };

export type AddressFragment = { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string };

export type AllScannedDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllScannedDocumentsQuery = { __typename?: 'Query', allScannedDocuments: Array<string> };

export type ApiLogEmailTransactionFragment = { __typename?: 'EmailTransactionEntity', createdAt: any, emails: Array<string>, emailResponse?: string | null, emailResponseStatus?: number | null, company: { __typename?: 'CompanyEntity', uuid: string, name: string, timeZone: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, document: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null };

export type ApiLogFragment = { __typename?: 'ApiLogEntity', uuid: string, createdAt: any, updatedAt: any, responseStatus?: ApiResponseStatus | null, sourceIpAddress?: string | null, direction: ApiRequestDirection, emailTransaction?: { __typename?: 'EmailTransactionEntity', createdAt: any, emails: Array<string>, emailResponse?: string | null, emailResponseStatus?: number | null, company: { __typename?: 'CompanyEntity', uuid: string, name: string, timeZone: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, document: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null } | null };

export type ApiLogsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter> | DateFilter>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  isFreightSnap?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoiceEmails?: InputMaybe<Scalars['Boolean']['input']>;
  freightSnapTransactionStatus?: InputMaybe<FreightSnapTransactionStatus>;
  freightSnapFailureReason?: InputMaybe<FreightSnapFailureReason>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApiLogsQuery = { __typename?: 'Query', apiLogs: { __typename?: 'ApiLogConnection', totalCount: number, edges: Array<{ __typename?: 'ApiLogEdge', node: { __typename?: 'ApiLogEntity', uuid: string, createdAt: any, updatedAt: any, responseStatus?: ApiResponseStatus | null, sourceIpAddress?: string | null, direction: ApiRequestDirection, emailTransaction?: { __typename?: 'EmailTransactionEntity', createdAt: any, emails: Array<string>, emailResponse?: string | null, emailResponseStatus?: number | null, company: { __typename?: 'CompanyEntity', uuid: string, name: string, timeZone: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, document: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type InvoiceEmailsApiLogsQueryVariables = Exact<{
  findInvoiceEmailsApiLogsInput: FindInvoiceEmailsApiLogsInput;
}>;


export type InvoiceEmailsApiLogsQuery = { __typename?: 'Query', invoiceEmailsApiLogs: { __typename?: 'FindInvoiceEmailsApiLogsOutput', apiLogConnection: { __typename?: 'ApiLogConnection', totalCount: number, edges: Array<{ __typename?: 'ApiLogEdge', node: { __typename?: 'ApiLogEntity', uuid: string, createdAt: any, updatedAt: any, responseStatus?: ApiResponseStatus | null, sourceIpAddress?: string | null, direction: ApiRequestDirection, emailTransaction?: { __typename?: 'EmailTransactionEntity', createdAt: any, emails: Array<string>, emailResponse?: string | null, emailResponseStatus?: number | null, company: { __typename?: 'CompanyEntity', uuid: string, name: string, timeZone: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, document: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type CompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'CompanyEntity', uuid: string, name: string }> };

export type CompanyConfigurationByCompanyUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CompanyConfigurationByCompanyUuidQuery = { __typename?: 'Query', companyConfigurationByCompanyUuid?: { __typename?: 'CompanyConfigurationEntity', uuid: string, sameDayDispatchCellHeader: SameDayDispatchCellHeader, sendSummaryEmailWithIncompleteRoutes: boolean, startingInvoiceOrdinalNumber?: number | null, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, showChargesOnCustomerPortal: boolean, textNextCustomerForAppointments: boolean, invoicePdfLogoUrl?: string | null, reviewUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, allowDriverToSelectNextStop?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, requireReviewForEdiOrderCreation: boolean, autoApplyWaitTimeMinutes: boolean, useJournalNumberForInvoice: boolean, getDriverLocationDataFromMobile: boolean, stampMobilePhotosWithTimeAndLocation: boolean, mobilePollingIntervalInSeconds?: number | null, requireDriverToAcknowledgeRouteChange: boolean, useDriverNumberForDispatch: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, restrictEditingOrderName: boolean, showKilogramsAndCentimeters: boolean, showDriverSettlementInBilling: boolean, notificationsEnabled: boolean, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, enableDigitalSignatureFlow: boolean, requireDriverSignature: boolean, useSeparateDigitalSignatureStep: boolean, sendSignedPodEmailAfterLateSignature: boolean, requireSignedPodToCompleteStop: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean, appointmentSchedulerModel?: AppointmentSchedulerModel | null, createRecurringOrdersInAdvanceHours: number, serviceLevelOptional: boolean, addOrdersToOpenInvoices: boolean, invoiceNotes?: string | null, defaultInvoiceDocumentsRequired: Array<DocumentType>, autoMatchEodDocumentsToOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, requireSigneeNameForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, quoteAgentEnabled: boolean, quoteAgentDefaultMode: QuoteAgentPolicyMode, quoteAgentAutoSendMaxCents?: number | null, quoteAgentMinConfidence: number, quoteAgentValidityHours: number, quoteAgentDailyModelBudgetCents: number, draftOrderCleanupDays: number, draftOrderCleanupSources: Array<OrderSource>, duplicateOrderMergeWindowHours: number, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, defaultStandardStopType: StandardStopType, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, showAccessorialsToDrivers: boolean, pieceTransferableStatuses: Array<PieceStatus>, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean } | null };

export type OffboardCompanyFromQuoteAgentMutationVariables = Exact<{
  input: OffboardCompanyFromQuoteAgentInput;
}>;


export type OffboardCompanyFromQuoteAgentMutation = { __typename?: 'Mutation', offboardCompanyFromQuoteAgent: { __typename?: 'OffboardCompanyFromQuoteAgentOutput', companyUuid: string, status: QuoteAgentOffboardingRequestStatus } };

export type SessionCompanyConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionCompanyConfigurationQuery = { __typename?: 'Query', companyConfiguration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, sameDayDispatchCellHeader: SameDayDispatchCellHeader, sendSummaryEmailWithIncompleteRoutes: boolean, startingInvoiceOrdinalNumber?: number | null, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, showChargesOnCustomerPortal: boolean, textNextCustomerForAppointments: boolean, invoicePdfLogoUrl?: string | null, reviewUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, allowDriverToSelectNextStop?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, requireReviewForEdiOrderCreation: boolean, autoApplyWaitTimeMinutes: boolean, useJournalNumberForInvoice: boolean, getDriverLocationDataFromMobile: boolean, stampMobilePhotosWithTimeAndLocation: boolean, mobilePollingIntervalInSeconds?: number | null, requireDriverToAcknowledgeRouteChange: boolean, useDriverNumberForDispatch: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, restrictEditingOrderName: boolean, showKilogramsAndCentimeters: boolean, showDriverSettlementInBilling: boolean, notificationsEnabled: boolean, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, enableDigitalSignatureFlow: boolean, requireDriverSignature: boolean, useSeparateDigitalSignatureStep: boolean, sendSignedPodEmailAfterLateSignature: boolean, requireSignedPodToCompleteStop: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean, appointmentSchedulerModel?: AppointmentSchedulerModel | null, createRecurringOrdersInAdvanceHours: number, serviceLevelOptional: boolean, addOrdersToOpenInvoices: boolean, invoiceNotes?: string | null, defaultInvoiceDocumentsRequired: Array<DocumentType>, autoMatchEodDocumentsToOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, requireSigneeNameForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, quoteAgentEnabled: boolean, quoteAgentDefaultMode: QuoteAgentPolicyMode, quoteAgentAutoSendMaxCents?: number | null, quoteAgentMinConfidence: number, quoteAgentValidityHours: number, quoteAgentDailyModelBudgetCents: number, draftOrderCleanupDays: number, draftOrderCleanupSources: Array<OrderSource>, duplicateOrderMergeWindowHours: number, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, defaultStandardStopType: StandardStopType, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, showAccessorialsToDrivers: boolean, pieceTransferableStatuses: Array<PieceStatus>, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean } | null };

export type UpdateCompanyConfigurationMutationVariables = Exact<{
  updateCompanyConfigurationInput: UpdateCompanyConfigurationInput;
}>;


export type UpdateCompanyConfigurationMutation = { __typename?: 'Mutation', updateCompanyConfiguration: { __typename?: 'CompanyConfigurationEntity', uuid: string, sameDayDispatchCellHeader: SameDayDispatchCellHeader, sendSummaryEmailWithIncompleteRoutes: boolean, startingInvoiceOrdinalNumber?: number | null, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, showChargesOnCustomerPortal: boolean, textNextCustomerForAppointments: boolean, invoicePdfLogoUrl?: string | null, reviewUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, allowDriverToSelectNextStop?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, requireReviewForEdiOrderCreation: boolean, autoApplyWaitTimeMinutes: boolean, useJournalNumberForInvoice: boolean, getDriverLocationDataFromMobile: boolean, stampMobilePhotosWithTimeAndLocation: boolean, mobilePollingIntervalInSeconds?: number | null, requireDriverToAcknowledgeRouteChange: boolean, useDriverNumberForDispatch: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, restrictEditingOrderName: boolean, showKilogramsAndCentimeters: boolean, showDriverSettlementInBilling: boolean, notificationsEnabled: boolean, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, enableDigitalSignatureFlow: boolean, requireDriverSignature: boolean, useSeparateDigitalSignatureStep: boolean, sendSignedPodEmailAfterLateSignature: boolean, requireSignedPodToCompleteStop: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean, appointmentSchedulerModel?: AppointmentSchedulerModel | null, createRecurringOrdersInAdvanceHours: number, serviceLevelOptional: boolean, addOrdersToOpenInvoices: boolean, invoiceNotes?: string | null, defaultInvoiceDocumentsRequired: Array<DocumentType>, autoMatchEodDocumentsToOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, requireSigneeNameForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, quoteAgentEnabled: boolean, quoteAgentDefaultMode: QuoteAgentPolicyMode, quoteAgentAutoSendMaxCents?: number | null, quoteAgentMinConfidence: number, quoteAgentValidityHours: number, quoteAgentDailyModelBudgetCents: number, draftOrderCleanupDays: number, draftOrderCleanupSources: Array<OrderSource>, duplicateOrderMergeWindowHours: number, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, defaultStandardStopType: StandardStopType, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, showAccessorialsToDrivers: boolean, pieceTransferableStatuses: Array<PieceStatus>, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean } };

export type UpdateQuoteAgentStaffSettingsMutationVariables = Exact<{
  input: UpdateQuoteAgentStaffSettingsInput;
}>;


export type UpdateQuoteAgentStaffSettingsMutation = { __typename?: 'Mutation', updateQuoteAgentStaffSettings: { __typename?: 'CompanyConfigurationEntity', uuid: string, sameDayDispatchCellHeader: SameDayDispatchCellHeader, sendSummaryEmailWithIncompleteRoutes: boolean, startingInvoiceOrdinalNumber?: number | null, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, showChargesOnCustomerPortal: boolean, textNextCustomerForAppointments: boolean, invoicePdfLogoUrl?: string | null, reviewUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, allowDriverToSelectNextStop?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, requireReviewForEdiOrderCreation: boolean, autoApplyWaitTimeMinutes: boolean, useJournalNumberForInvoice: boolean, getDriverLocationDataFromMobile: boolean, stampMobilePhotosWithTimeAndLocation: boolean, mobilePollingIntervalInSeconds?: number | null, requireDriverToAcknowledgeRouteChange: boolean, useDriverNumberForDispatch: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, restrictEditingOrderName: boolean, showKilogramsAndCentimeters: boolean, showDriverSettlementInBilling: boolean, notificationsEnabled: boolean, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, enableDigitalSignatureFlow: boolean, requireDriverSignature: boolean, useSeparateDigitalSignatureStep: boolean, sendSignedPodEmailAfterLateSignature: boolean, requireSignedPodToCompleteStop: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean, appointmentSchedulerModel?: AppointmentSchedulerModel | null, createRecurringOrdersInAdvanceHours: number, serviceLevelOptional: boolean, addOrdersToOpenInvoices: boolean, invoiceNotes?: string | null, defaultInvoiceDocumentsRequired: Array<DocumentType>, autoMatchEodDocumentsToOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, requireSigneeNameForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, quoteAgentEnabled: boolean, quoteAgentDefaultMode: QuoteAgentPolicyMode, quoteAgentAutoSendMaxCents?: number | null, quoteAgentMinConfidence: number, quoteAgentValidityHours: number, quoteAgentDailyModelBudgetCents: number, draftOrderCleanupDays: number, draftOrderCleanupSources: Array<OrderSource>, duplicateOrderMergeWindowHours: number, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, defaultStandardStopType: StandardStopType, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, showAccessorialsToDrivers: boolean, pieceTransferableStatuses: Array<PieceStatus>, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean } };

export type ConfigMigrationCompaniesQueryVariables = Exact<{
  env: MigrationEnv;
}>;


export type ConfigMigrationCompaniesQuery = { __typename?: 'Query', configMigrationCompanies: Array<{ __typename?: 'MigratableCompanyObject', uuid: string, name: string }> };

export type ConfigMigrationFeatureGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigMigrationFeatureGroupsQuery = { __typename?: 'Query', configMigrationFeatureGroups: Array<ConfigMigrationFeatureGroup> };

export type ConfigMigrationStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type ConfigMigrationStatusQuery = { __typename?: 'Query', configMigrationStatus?: { __typename?: 'ConfigMigrationStatusObject', jobId: string, state: string, report?: { __typename?: 'ConfigMigrationReportObject', source: MigrationEnv, target: MigrationEnv, companyUuid: string, dryRun: boolean, sourceBundleKey: string, preImageBundleKey?: string | null, allMatch: boolean, tables: Array<{ __typename?: 'ConfigMigrationTableReportObject', tableName: string, sourceCount: number, targetCount: number, matches: boolean, insertedUuids: Array<string>, updatedUuids: Array<string>, skipReason?: string | null }> } | null } | null };

type CompanyContact_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, stediPartnerId?: string | null, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, displayName: string, isActive: boolean, shortCode?: string | null, type: ContactType, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, billingCycleDuration: BillingCycleDuration, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }> };

type CompanyContact_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', displayName: string, isActive: boolean, shortCode?: string | null, type: ContactType, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }> };

export type CompanyContactFragment = CompanyContact_CustomerContactEntity_Fragment | CompanyContact_ThirdPartyContactEntity_Fragment;

export type CompanyContactsQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  excludeNonActiveContacts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompanyContactsQuery = { __typename?: 'Query', companyContacts: Array<{ __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, stediPartnerId?: string | null, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, displayName: string, isActive: boolean, shortCode?: string | null, type: ContactType, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, billingCycleDuration: BillingCycleDuration, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }> } | { __typename?: 'ThirdPartyContactEntity', displayName: string, isActive: boolean, shortCode?: string | null, type: ContactType, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }> }> };

export type ContactQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } };

type ShallowContact_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, stediPartnerId?: string | null, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, isPrepaidOnly: boolean, displayName: string, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, billingCycleDuration: BillingCycleDuration, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }> };

type ShallowContact_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', displayName: string, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }> };

export type ShallowContactFragment = ShallowContact_CustomerContactEntity_Fragment | ShallowContact_ThirdPartyContactEntity_Fragment;

export type ShallowContactsQueryVariables = Exact<{
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ShallowContactsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, stediPartnerId?: string | null, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, isPrepaidOnly: boolean, displayName: string, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, billingCycleDuration: BillingCycleDuration, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }> } | { __typename?: 'ThirdPartyContactEntity', displayName: string, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }> }> };

export type CreateSchemaTestSnapshotMutationVariables = Exact<{
  createSchemaTestSnapshotInput: CreateSchemaTestSnapshotInput;
}>;


export type CreateSchemaTestSnapshotMutation = { __typename?: 'Mutation', createSchemaTestSnapshot: string };

export type CreateSchemaMutationVariables = Exact<{
  createSchemaInput: CreateSchemaInput;
}>;


export type CreateSchemaMutation = { __typename?: 'Mutation', createSchema: string };

export type ImportCrownAccessorialMutationVariables = Exact<{
  importCrownAccessorialInput: ImportCrownAccessorialInput;
}>;


export type ImportCrownAccessorialMutation = { __typename?: 'Mutation', importCrownAccessorial: { __typename?: 'ImportCrownAccessorialOutput', success: boolean, error?: string | null } };

export type ImportCrownContactsV2MutationVariables = Exact<{
  csvUrl: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  useNewImporter: Scalars['Boolean']['input'];
}>;


export type ImportCrownContactsV2Mutation = { __typename?: 'Mutation', importCrownContactsV2: Array<string> };

export type ImportCrownDriversMutationVariables = Exact<{
  importCrownDriversInput: ImportCrownDriversInput;
}>;


export type ImportCrownDriversMutation = { __typename?: 'Mutation', importCrownDrivers: { __typename?: 'ImportCrownDriversOutput', success: boolean, error?: string | null, successfulDriverPhoneNumbers: Array<string>, failedDriverPhoneNumbers: Array<string> } };

export type CreateImportedOrderTypeMappingMutationVariables = Exact<{
  importedOrderTypeMappingCreateInput: ImportedOrderTypeMappingCreateInput;
}>;


export type CreateImportedOrderTypeMappingMutation = { __typename?: 'Mutation', createImportedOrderTypeMapping: { __typename?: 'ImportedOrderTypeMappingEntity', uuid: string } };

export type CreateOrderImportConfigurationMutationVariables = Exact<{
  orderImportConfigurationCreateInput: OrderImportConfigurationCreateInput;
}>;


export type CreateOrderImportConfigurationMutation = { __typename?: 'Mutation', createOrderImportConfiguration: { __typename?: 'OrderImportConfigurationEntity', uuid: string } };

export type ImportCrownOrdersMutationVariables = Exact<{
  importCrownOrdersInput: ImportCrownOrdersInput;
}>;


export type ImportCrownOrdersMutation = { __typename?: 'Mutation', importCrownOrders: { __typename?: 'ImportCrownOrdersOutput', numberOfOrders: number, importedCrownIDs: Array<string>, skippedCrownIDs: Array<string>, failedCrownIDs: Array<string> } };

export type RemoveImportedOrderTypeMappingMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveImportedOrderTypeMappingMutation = { __typename?: 'Mutation', removeImportedOrderTypeMapping: { __typename?: 'ImportedOrderTypeMappingEntity', uuid: string } };

export type UpdateOrderImportConfigurationMutationVariables = Exact<{
  orderImportConfigurationUpdateInput: OrderImportConfigurationUpdateInput;
}>;


export type UpdateOrderImportConfigurationMutation = { __typename?: 'Mutation', updateOrderImportConfiguration: { __typename?: 'OrderImportConfigurationEntity', uuid: string } };

export type ContactServicesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactServicesQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', uuid: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } };

export type FuelProfileFragment = { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null };

export type FuelProfilesQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  excludeContactUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FuelProfileType>;
}>;


export type FuelProfilesQuery = { __typename?: 'Query', fuelProfiles: Array<{ __typename?: 'FuelProfileEntity', uuid: string, name?: string | null }> };

export type ImportCrownTariffMutationVariables = Exact<{
  importCrownTariffInput: ImportCrownTariffInput;
}>;


export type ImportCrownTariffMutation = { __typename?: 'Mutation', importCrownTariff: { __typename?: 'ImportCrownTariffOutput', success: boolean, error?: string | null, dryRun?: boolean | null, tariffsToCreate?: number | null, rangesToCreate?: number | null } };

export type ServiceFragment = { __typename?: 'ServiceEntity', uuid: string, name: string, isActive: boolean };

export type ServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ServicesQuery = { __typename?: 'Query', services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, isActive: boolean }> };

export type TariffZoneGroupFragment = { __typename?: 'TariffZoneGroupEntity', id: string, name: string };

export type TariffZoneGroupsQueryVariables = Exact<{
  findTariffZoneGroupsInput: FindTariffZoneGroupsInput;
}>;


export type TariffZoneGroupsQuery = { __typename?: 'Query', tariffZoneGroups: Array<{ __typename?: 'TariffZoneGroupEntity', id: string, name: string }> };

export type VehicleTypeFragment = { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus };

export type VehicleTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type VehicleTypesQuery = { __typename?: 'Query', vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }> };

export type ImportCrownUsersMutationVariables = Exact<{
  importCrownUsersInput: ImportCrownUsersInput;
}>;


export type ImportCrownUsersMutation = { __typename?: 'Mutation', importCrownUsers: { __typename?: 'ImportCrownUsersOutput', success: boolean, error?: string | null } };

export type DeleteSchemaRunMutationVariables = Exact<{
  deleteSchemaRunInput: DeleteSchemaRunInput;
}>;


export type DeleteSchemaRunMutation = { __typename?: 'Mutation', deleteSchemaRun: string };

export type DeleteSchemaMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteSchemaMutation = { __typename?: 'Mutation', deleteSchema?: string | null };

export type CancelDocExtractionEvalRunMutationVariables = Exact<{
  runId: Scalars['String']['input'];
}>;


export type CancelDocExtractionEvalRunMutation = { __typename?: 'Mutation', cancelDocExtractionEvalRun: { __typename?: 'DocExtractionCancelEvalRunResultEntity', evalRunId: string, cancelRequested: boolean } };

export type CreateDocExtractionEvalRunMutationVariables = Exact<{
  input: CreateDocExtractionEvalRunInput;
}>;


export type CreateDocExtractionEvalRunMutation = { __typename?: 'Mutation', createDocExtractionEvalRun: { __typename?: 'DocExtractionLaunchEvalRunResultEntity', evalRunId: string, documentCount: number, bundleHash: string } };

export type CreateDocExtractionEvalSetMutationVariables = Exact<{
  input: CreateDocExtractionEvalSetInput;
}>;


export type CreateDocExtractionEvalSetMutation = { __typename?: 'Mutation', createDocExtractionEvalSet: { __typename?: 'DocExtractionCreatedEvalSetEntity', evalSetId: string, documentCount: number, strata: any } };

export type EstimateDocExtractionEvalRunMutationVariables = Exact<{
  input: EstimateDocExtractionEvalRunInput;
}>;


export type EstimateDocExtractionEvalRunMutation = { __typename?: 'Mutation', estimateDocExtractionEvalRun: { __typename?: 'DocExtractionEvalRunCostEstimateEntity', inputTokens: number, outputTokens: number, totalTokens: number, usd?: number | null, pricingSource: string, tokenProfileSource: string } };

export type DocExtractionEvalDocumentWordBoxesQueryVariables = Exact<{
  runId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type DocExtractionEvalDocumentWordBoxesQuery = { __typename?: 'Query', docExtractionEvalDocumentWordBoxes: { __typename?: 'DocExtractionEvalDocumentWordBoxesEntity', pages: Array<{ __typename?: 'DocExtractionEvalWordBoxPageEntity', pageNumber: number, textSource: string, words: Array<{ __typename?: 'DocExtractionEvalWordBoxEntity', text: string, confidence: number, left: number, top: number, width: number, height: number }> }> } };

export type EvalRunDocumentFieldsFragment = { __typename?: 'DocExtractionEvalRunDocumentEntity', evalRunId: string, documentId: string, companyUuid: string, status: string, errorKind?: string | null, errorDetail?: string | null, inputTokens?: number | null, outputTokens?: number | null, latencyMs?: number | null, costUsd?: number | null, extractedFields?: any | null, verdicts?: any | null, docScore?: any | null, runMeta?: any | null };

export type DocExtractionEvalRunDocumentsQueryVariables = Exact<{
  runId: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DocExtractionEvalRunDocumentsQuery = { __typename?: 'Query', docExtractionEvalRunDocuments: { __typename?: 'DocExtractionEvalRunDocumentsPageEntity', nextCursor?: string | null, documents: Array<{ __typename?: 'DocExtractionEvalRunDocumentEntity', evalRunId: string, documentId: string, companyUuid: string, status: string, errorKind?: string | null, errorDetail?: string | null, inputTokens?: number | null, outputTokens?: number | null, latencyMs?: number | null, costUsd?: number | null, extractedFields?: any | null, verdicts?: any | null, docScore?: any | null, runMeta?: any | null }> } };

export type EvalRunFieldsFragment = { __typename?: 'DocExtractionEvalRunEntity', id: string, evalSetId: string, name: string, status: string, executionMode: string, providerBatchId?: string | null, documentCount: number, completedCount: number, errorCount: number, bundleHash: string, actualInputTokens?: number | null, actualOutputTokens?: number | null, actualCostUsd?: number | null, cancelRequestedAt?: string | null, createdAt: string, updatedAt: string, config: any, aggregates?: any | null, costEstimate?: any | null };

export type DocExtractionEvalRunQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DocExtractionEvalRunQuery = { __typename?: 'Query', docExtractionEvalRun: { __typename?: 'DocExtractionEvalRunEntity', id: string, evalSetId: string, name: string, status: string, executionMode: string, providerBatchId?: string | null, documentCount: number, completedCount: number, errorCount: number, bundleHash: string, actualInputTokens?: number | null, actualOutputTokens?: number | null, actualCostUsd?: number | null, cancelRequestedAt?: string | null, createdAt: string, updatedAt: string, config: any, aggregates?: any | null, costEstimate?: any | null } };

export type DocExtractionEvalRunsQueryVariables = Exact<{
  evalSetId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DocExtractionEvalRunsQuery = { __typename?: 'Query', docExtractionEvalRuns: Array<{ __typename?: 'DocExtractionEvalRunEntity', id: string, evalSetId: string, name: string, status: string, executionMode: string, providerBatchId?: string | null, documentCount: number, completedCount: number, errorCount: number, bundleHash: string, actualInputTokens?: number | null, actualOutputTokens?: number | null, actualCostUsd?: number | null, cancelRequestedAt?: string | null, createdAt: string, updatedAt: string, config: any, aggregates?: any | null, costEstimate?: any | null }> };

export type EvalSetFieldsFragment = { __typename?: 'DocExtractionEvalSetEntity', id: string, name: string, documentCount: number, seed: string, createdBy: string, createdAt: string, selectionConfig: any, strataSummary: any };

export type DocExtractionEvalSetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DocExtractionEvalSetQuery = { __typename?: 'Query', docExtractionEvalSet: { __typename?: 'DocExtractionEvalSetEntity', id: string, name: string, documentCount: number, seed: string, createdBy: string, createdAt: string, selectionConfig: any, strataSummary: any } };

export type DocExtractionEvalSetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DocExtractionEvalSetsQuery = { __typename?: 'Query', docExtractionEvalSets: Array<{ __typename?: 'DocExtractionEvalSetEntity', id: string, name: string, documentCount: number, seed: string, createdBy: string, createdAt: string, selectionConfig: any, strataSummary: any }> };

export type PreviewDocExtractionEvalSetMutationVariables = Exact<{
  config: Scalars['JSON']['input'];
}>;


export type PreviewDocExtractionEvalSetMutation = { __typename?: 'Mutation', previewDocExtractionEvalSet: { __typename?: 'DocExtractionEvalSetPreviewEntity', totalCandidates: number, selectedCount: number, strata: any, sampleDocumentIds: Array<string>, poolCutoffAt?: string | null } };

export type GeneratePreSignedPutUrlMutationVariables = Exact<{
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
}>;


export type GeneratePreSignedPutUrlMutation = { __typename?: 'Mutation', generatePreSignedPutUrl: string };

export type EdiTransactionFragmentFragment = { __typename?: 'EdiTransactionEntity', uuid: string, updatedAt: any, status: EdiTransactionStatus, code: EdiTransactionCode, message?: string | null, payload: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null };

export type EdiTransactionsByCompanyQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type EdiTransactionsByCompanyQuery = { __typename?: 'Query', ediTransactionsByCompany: { __typename?: 'EdiTransactionConnection', edges: Array<{ __typename?: 'EdiTransactionEdge', node: { __typename?: 'EdiTransactionEntity', uuid: string, updatedAt: any, status: EdiTransactionStatus, code: EdiTransactionCode, message?: string | null, payload: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ExtractedFieldFragment = { __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string };

export type EdgeAnchorFragment = { __typename?: 'EdgeAnchorEntity', uuid: string, blockId?: string | null, edge: Edge, left: number, top: number, height: number, width: number, text: string };

export type FingerprintAnchorMatchFragment = { __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string };

export type FingerprintAnchorFragment = { __typename?: 'FingerprintAnchorEntity', blockId?: string | null, left: number, top: number, height: number, width: number, substring?: string | null, text: string, required: boolean };

export type GetXyTransformQueryVariables = Exact<{
  getXyTransformInput: GetXyTransformInput;
}>;


export type GetXyTransformQuery = { __typename?: 'Query', getXYTransform: { __typename?: 'XyTransformEntity', xMin: number, yMin: number, yTranslation: number, xTranslation: number, yScale: number, xScale: number, rotation: number } };

export type ImportTestSnapshotMutationVariables = Exact<{
  importTestSnapshotInput: ImportTestSnapshotInput;
}>;


export type ImportTestSnapshotMutation = { __typename?: 'Mutation', importTestSnapshot: string };

export type AdhocPreviewBatchQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdhocPreviewBatchQuery = { __typename?: 'Query', adhocPreviewBatch: { __typename?: 'AdhocPreviewBatchEntity', id: string, status: string, companyUuid: string, memberCount: number, aggregateInputTokens?: number | null, aggregateOutputTokens?: number | null, aggregateCostUsd?: number | null, members: Array<{ __typename?: 'AdhocPreviewBatchMemberEntity', position: number, fileName: string, adhocRunId?: string | null, dispatchError?: string | null, runStatus?: string | null, error?: string | null, applyPlan?: { __typename?: 'AdhocApplyPlanEntity', billingParty: { __typename?: 'AdhocApplyPlanBillingPartyEntity', mechanism: string, contactUuid?: string | null, senderVerdict?: string | null }, service?: { __typename?: 'AdhocApplyPlanServiceEntity', mechanism: string, serviceId?: string | null } | null, deadlineType?: { __typename?: 'AdhocApplyPlanDeadlineTypeEntity', mechanism: string, value: string } | null, duplicate?: { __typename?: 'AdhocApplyPlanDuplicateEntity', isDuplicate: boolean, duplicateOrderUuid?: string | null, wouldAdoptOrphanUuid?: string | null } | null } | null }> } };

export type AdhocPreviewResultQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdhocPreviewResultQuery = { __typename?: 'Query', adhocPreviewResult: { __typename?: 'AdhocPreviewResultEntity', runId: string, status: string, error?: string | null, companyUuid: string, extractedFields?: any | null, usage?: any | null, exemplars: Array<{ __typename?: 'AdhocPreviewExemplarEntity', documentId: string, documentType: string, source: string, cosineSimilarity: number, fieldValues: any }>, applyPlan?: { __typename?: 'AdhocApplyPlanEntity', billingParty: { __typename?: 'AdhocApplyPlanBillingPartyEntity', mechanism: string, contactUuid?: string | null, senderVerdict?: string | null }, service?: { __typename?: 'AdhocApplyPlanServiceEntity', mechanism: string, serviceId?: string | null } | null, deadlineType?: { __typename?: 'AdhocApplyPlanDeadlineTypeEntity', mechanism: string, value: string } | null, duplicate?: { __typename?: 'AdhocApplyPlanDuplicateEntity', isDuplicate: boolean, duplicateOrderUuid?: string | null, wouldAdoptOrphanUuid?: string | null } | null } | null } };

export type AdhocPreviewWordBoxesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdhocPreviewWordBoxesQuery = { __typename?: 'Query', adhocPreviewWordBoxes: { __typename?: 'DocExtractionEvalDocumentWordBoxesEntity', pages: Array<{ __typename?: 'DocExtractionEvalWordBoxPageEntity', pageNumber: number, textSource: string, words: Array<{ __typename?: 'DocExtractionEvalWordBoxEntity', text: string, confidence: number, left: number, top: number, width: number, height: number }> }> } };

export type CreateIngestionTestUploadMutationVariables = Exact<{
  input: CreateIngestionTestUploadInput;
}>;


export type CreateIngestionTestUploadMutation = { __typename?: 'Mutation', createIngestionTestUpload: { __typename?: 'IngestionTestUploadEntity', uploadId: string, bucket: string, key: string, uploadUrl: string } };

export type TriggerAdhocPreviewBatchMutationVariables = Exact<{
  input: TriggerAdhocPreviewBatchInput;
}>;


export type TriggerAdhocPreviewBatchMutation = { __typename?: 'Mutation', triggerAdhocPreviewBatch: { __typename?: 'AdhocPreviewBatchEntity', id: string, status: string, memberCount: number } };

export type TriggerAdhocPreviewMutationVariables = Exact<{
  input: TriggerAdhocPreviewInput;
}>;


export type TriggerAdhocPreviewMutation = { __typename?: 'Mutation', triggerAdhocPreview: { __typename?: 'AdhocPreviewTriggerEntity', runId: string, status: string } };

export type IngestionTestRunQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type IngestionTestRunQuery = { __typename?: 'Query', ingestionTestRun: { __typename?: 'IngestionTestRunEntity', id: string, mode: IngestionTestRunMode, state: IngestionTestRunState, companyUuid: string, actorEmail: string, correlationId?: string | null, emailContext?: any | null, extractedFields?: any | null, applyPlan?: any | null, exemplarMarker?: any | null, usage?: any | null, error?: string | null, createdAt: any, updatedAt: any, appliedResults: Array<{ __typename?: 'IngestionTestRunAppliedResultEntity', resultUuid: string, status: ScannedOrderResultStatus, orderUuid?: string | null, duplicateOfOrderUuid?: string | null, applyPlan?: any | null, pageStart: number, pageEnd: number }> } };

export type TriggerIngestionTestRunMutationVariables = Exact<{
  input: TriggerIngestionTestRunInput;
}>;


export type TriggerIngestionTestRunMutation = { __typename?: 'Mutation', triggerIngestionTestRun: { __typename?: 'IngestionTestRunEntity', id: string, mode: IngestionTestRunMode, state: IngestionTestRunState, correlationId?: string | null, createdAt: any, error?: string | null } };

export type LoginInternalMutationVariables = Exact<{
  loginInputData: LoginInput;
}>;


export type LoginInternalMutation = { __typename?: 'Mutation', loginInternal?: { __typename?: 'LoginOutput', status: LoginStatus, fullAccessUser?: { __typename?: 'UserEntity', uuid: string } | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type MeCompanyConfigurationFragment = { __typename?: 'CompanyConfigurationEntity', uuid: string, sameDayDispatchCellHeader: SameDayDispatchCellHeader, sendSummaryEmailWithIncompleteRoutes: boolean, startingInvoiceOrdinalNumber?: number | null, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, showChargesOnCustomerPortal: boolean, textNextCustomerForAppointments: boolean, invoicePdfLogoUrl?: string | null, reviewUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, allowDriverToSelectNextStop?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, requireReviewForEdiOrderCreation: boolean, autoApplyWaitTimeMinutes: boolean, useJournalNumberForInvoice: boolean, getDriverLocationDataFromMobile: boolean, stampMobilePhotosWithTimeAndLocation: boolean, mobilePollingIntervalInSeconds?: number | null, requireDriverToAcknowledgeRouteChange: boolean, useDriverNumberForDispatch: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, restrictEditingOrderName: boolean, showKilogramsAndCentimeters: boolean, showDriverSettlementInBilling: boolean, notificationsEnabled: boolean, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, enableDigitalSignatureFlow: boolean, requireDriverSignature: boolean, useSeparateDigitalSignatureStep: boolean, sendSignedPodEmailAfterLateSignature: boolean, requireSignedPodToCompleteStop: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean, appointmentSchedulerModel?: AppointmentSchedulerModel | null, createRecurringOrdersInAdvanceHours: number, serviceLevelOptional: boolean, addOrdersToOpenInvoices: boolean, invoiceNotes?: string | null, defaultInvoiceDocumentsRequired: Array<DocumentType>, autoMatchEodDocumentsToOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, requireSigneeNameForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, quoteAgentEnabled: boolean, quoteAgentDefaultMode: QuoteAgentPolicyMode, quoteAgentAutoSendMaxCents?: number | null, quoteAgentMinConfidence: number, quoteAgentValidityHours: number, quoteAgentDailyModelBudgetCents: number, draftOrderCleanupDays: number, draftOrderCleanupSources: Array<OrderSource>, duplicateOrderMergeWindowHours: number, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, defaultStandardStopType: StandardStopType, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, showAccessorialsToDrivers: boolean, pieceTransferableStatuses: Array<PieceStatus>, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean };

export type MeCompanyFragment = { __typename?: 'CompanyEntity', uuid: string, segment: Segment, timeZone: string, name: string, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, sameDayDispatchCellHeader: SameDayDispatchCellHeader, sendSummaryEmailWithIncompleteRoutes: boolean, startingInvoiceOrdinalNumber?: number | null, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, showChargesOnCustomerPortal: boolean, textNextCustomerForAppointments: boolean, invoicePdfLogoUrl?: string | null, reviewUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, allowDriverToSelectNextStop?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, requireReviewForEdiOrderCreation: boolean, autoApplyWaitTimeMinutes: boolean, useJournalNumberForInvoice: boolean, getDriverLocationDataFromMobile: boolean, stampMobilePhotosWithTimeAndLocation: boolean, mobilePollingIntervalInSeconds?: number | null, requireDriverToAcknowledgeRouteChange: boolean, useDriverNumberForDispatch: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, restrictEditingOrderName: boolean, showKilogramsAndCentimeters: boolean, showDriverSettlementInBilling: boolean, notificationsEnabled: boolean, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, enableDigitalSignatureFlow: boolean, requireDriverSignature: boolean, useSeparateDigitalSignatureStep: boolean, sendSignedPodEmailAfterLateSignature: boolean, requireSignedPodToCompleteStop: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean, appointmentSchedulerModel?: AppointmentSchedulerModel | null, createRecurringOrdersInAdvanceHours: number, serviceLevelOptional: boolean, addOrdersToOpenInvoices: boolean, invoiceNotes?: string | null, defaultInvoiceDocumentsRequired: Array<DocumentType>, autoMatchEodDocumentsToOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, requireSigneeNameForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, quoteAgentEnabled: boolean, quoteAgentDefaultMode: QuoteAgentPolicyMode, quoteAgentAutoSendMaxCents?: number | null, quoteAgentMinConfidence: number, quoteAgentValidityHours: number, quoteAgentDailyModelBudgetCents: number, draftOrderCleanupDays: number, draftOrderCleanupSources: Array<OrderSource>, duplicateOrderMergeWindowHours: number, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, defaultStandardStopType: StandardStopType, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, showAccessorialsToDrivers: boolean, pieceTransferableStatuses: Array<PieceStatus>, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean } | null, orderImportConfiguration?: { __typename?: 'OrderImportConfigurationEntity', uuid: string, alwaysCreateDummyOrderCharge: boolean, importedOrderTypeMappings: Array<{ __typename?: 'ImportedOrderTypeMappingEntity', uuid: string, moveType?: string | null, serviceLevel?: string | null, inboundStopType: StopType, outboundStopType: StopType, lineHaul: boolean, defaultToInbound: boolean, defaultToOutbound: boolean }> } | null };

export type ImportedOrderTypeMappingFragment = { __typename?: 'ImportedOrderTypeMappingEntity', uuid: string, moveType?: string | null, serviceLevel?: string | null, inboundStopType: StopType, outboundStopType: StopType, lineHaul: boolean, defaultToInbound: boolean, defaultToOutbound: boolean };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', email: string, uuid: string, company: { __typename?: 'CompanyEntity', uuid: string, segment: Segment, timeZone: string, name: string, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, sameDayDispatchCellHeader: SameDayDispatchCellHeader, sendSummaryEmailWithIncompleteRoutes: boolean, startingInvoiceOrdinalNumber?: number | null, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, showChargesOnCustomerPortal: boolean, textNextCustomerForAppointments: boolean, invoicePdfLogoUrl?: string | null, reviewUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, allowDriverToSelectNextStop?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, requireReviewForEdiOrderCreation: boolean, autoApplyWaitTimeMinutes: boolean, useJournalNumberForInvoice: boolean, getDriverLocationDataFromMobile: boolean, stampMobilePhotosWithTimeAndLocation: boolean, mobilePollingIntervalInSeconds?: number | null, requireDriverToAcknowledgeRouteChange: boolean, useDriverNumberForDispatch: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, restrictEditingOrderName: boolean, showKilogramsAndCentimeters: boolean, showDriverSettlementInBilling: boolean, notificationsEnabled: boolean, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, enableDigitalSignatureFlow: boolean, requireDriverSignature: boolean, useSeparateDigitalSignatureStep: boolean, sendSignedPodEmailAfterLateSignature: boolean, requireSignedPodToCompleteStop: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean, appointmentSchedulerModel?: AppointmentSchedulerModel | null, createRecurringOrdersInAdvanceHours: number, serviceLevelOptional: boolean, addOrdersToOpenInvoices: boolean, invoiceNotes?: string | null, defaultInvoiceDocumentsRequired: Array<DocumentType>, autoMatchEodDocumentsToOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, requireSigneeNameForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, quoteAgentEnabled: boolean, quoteAgentDefaultMode: QuoteAgentPolicyMode, quoteAgentAutoSendMaxCents?: number | null, quoteAgentMinConfidence: number, quoteAgentValidityHours: number, quoteAgentDailyModelBudgetCents: number, draftOrderCleanupDays: number, draftOrderCleanupSources: Array<OrderSource>, duplicateOrderMergeWindowHours: number, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, defaultStandardStopType: StandardStopType, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, showAccessorialsToDrivers: boolean, pieceTransferableStatuses: Array<PieceStatus>, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean } | null, orderImportConfiguration?: { __typename?: 'OrderImportConfigurationEntity', uuid: string, alwaysCreateDummyOrderCharge: boolean, importedOrderTypeMappings: Array<{ __typename?: 'ImportedOrderTypeMappingEntity', uuid: string, moveType?: string | null, serviceLevel?: string | null, inboundStopType: StopType, outboundStopType: StopType, lineHaul: boolean, defaultToInbound: boolean, defaultToOutbound: boolean }> } | null } } | null };

export type NormalizeDocumentMutationVariables = Exact<{
  normalizeDocumentInput: NormalizeDocumentInput;
}>;


export type NormalizeDocumentMutation = { __typename?: 'Mutation', normalizeDocument: string };

export type NotificationCutoverConfigFieldsFragment = { __typename?: 'NotificationCutoverConfigEntity', eventType: NotificationEventType, mode: NotificationEngineMode, fullEligible: boolean, fullBlockedBy?: string | null, fullEligibleBecause?: string | null, requiredPartnerEvent?: NotificationEventType | null, shadowComparable: boolean, engineOnlyChannels: Array<NotificationChannel>, source: string, metadata: { __typename?: 'NotificationEventMetadataEntity', description: string, trigger: string, emittedBy?: string | null, channels: Array<NotificationChannel>, deliveryState: NotificationDeliveryState, deliveryStateReason: string, engineTargets: Array<{ __typename?: 'NotificationEventTargetEntity', target: NotificationTarget, definition: string, recipientKind?: string | null }>, legacyTargets: Array<{ __typename?: 'NotificationEventTargetEntity', target: NotificationTarget, definition: string, recipientKind?: string | null }>, configuredIn: Array<{ __typename?: 'NotificationEventConfigurationPointEntity', setting: string, clickPath?: string | null }> } };

export type NotificationCutoverConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationCutoverConfigsQuery = { __typename?: 'Query', notificationCutoverConfigs: Array<{ __typename?: 'NotificationCutoverConfigEntity', eventType: NotificationEventType, mode: NotificationEngineMode, fullEligible: boolean, fullBlockedBy?: string | null, fullEligibleBecause?: string | null, requiredPartnerEvent?: NotificationEventType | null, shadowComparable: boolean, engineOnlyChannels: Array<NotificationChannel>, source: string, metadata: { __typename?: 'NotificationEventMetadataEntity', description: string, trigger: string, emittedBy?: string | null, channels: Array<NotificationChannel>, deliveryState: NotificationDeliveryState, deliveryStateReason: string, engineTargets: Array<{ __typename?: 'NotificationEventTargetEntity', target: NotificationTarget, definition: string, recipientKind?: string | null }>, legacyTargets: Array<{ __typename?: 'NotificationEventTargetEntity', target: NotificationTarget, definition: string, recipientKind?: string | null }>, configuredIn: Array<{ __typename?: 'NotificationEventConfigurationPointEntity', setting: string, clickPath?: string | null }> } }> };

export type SetNotificationCutoverModeMutationVariables = Exact<{
  input: SetNotificationCutoverModeInput;
}>;


export type SetNotificationCutoverModeMutation = { __typename?: 'Mutation', setNotificationCutoverMode: { __typename?: 'NotificationCutoverConfigEntity', eventType: NotificationEventType, mode: NotificationEngineMode, fullEligible: boolean } };

export type NotificationShadowComparisonsQueryVariables = Exact<{
  filter?: InputMaybe<NotificationShadowComparisonFilterInput>;
}>;


export type NotificationShadowComparisonsQuery = { __typename?: 'Query', notificationShadowComparisons: Array<{ __typename?: 'NotificationShadowComparisonEntity', uuid: string, eventType: string, channel: NotificationChannel, status: NotificationShadowStatus, sourceRef: string, mismatchedFields: Array<string>, companyUuid: string, hasLegacyContent: boolean, hasEngineContent: boolean, createdAt: any, updatedAt: any }> };

export type NotificationShadowComparisonSummaryQueryVariables = Exact<{
  filter?: InputMaybe<NotificationShadowComparisonFilterInput>;
}>;


export type NotificationShadowComparisonSummaryQuery = { __typename?: 'Query', notificationShadowComparisonSummary: Array<{ __typename?: 'NotificationShadowComparisonStatusCountEntity', status: NotificationShadowStatus, count: number }> };

export type OrderMirrorCaptureConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderMirrorCaptureConfigQuery = { __typename?: 'Query', orderMirrorCaptureConfig: { __typename?: 'OrderMirrorCaptureConfigEntity', mode: string, companies: Array<{ __typename?: 'OrderMirrorCaptureCompanyEntity', companyUuid: string, companyName: string }> } };

export type ClearOrderMirrorOutboxMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearOrderMirrorOutboxMutation = { __typename?: 'Mutation', clearOrderMirrorOutbox: number };

export type CreateMirrorTargetMutationVariables = Exact<{
  input: CreateMirrorTargetInput;
}>;


export type CreateMirrorTargetMutation = { __typename?: 'Mutation', createMirrorTarget: { __typename?: 'MirrorTargetEntity', uuid: string } };

export type DeleteMirrorTargetMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteMirrorTargetMutation = { __typename?: 'Mutation', deleteMirrorTarget: boolean };

export type MirrorAdminAllCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type MirrorAdminAllCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'CompanyEntity', uuid: string, name: string }> };

export type MirrorTargetCompaniesQueryVariables = Exact<{
  targetUuid: Scalars['String']['input'];
}>;


export type MirrorTargetCompaniesQuery = { __typename?: 'Query', mirrorTargetCompanies: Array<{ __typename?: 'MirrorTargetCompanyEntity', companyUuid: string, companyName: string, enabled: boolean }> };

export type MirrorTargetsQueryVariables = Exact<{ [key: string]: never; }>;


export type MirrorTargetsQuery = { __typename?: 'Query', mirrorTargets: Array<{ __typename?: 'MirrorTargetEntity', uuid: string, name: string, url: string, enabled: boolean, batchSize: number, subscribesToAllCompanies: boolean, mirroredCompanyCount: number, createdAt: any }> };

export type OrderMirrorOutboxCountQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderMirrorOutboxCountQuery = { __typename?: 'Query', orderMirrorOutboxCount: number };

export type OrderMirrorSyncRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderMirrorSyncRequestsQuery = { __typename?: 'Query', orderMirrorSyncRequests: Array<{ __typename?: 'MirrorSyncRequestEntity', uuid: string, scope: string, companyUuids: Array<string>, fromDateTime: any, toDateTime: any, status: string, matchedCount?: number | null, createdCount?: number | null, existedCount?: number | null, error?: string | null, createdAt: any }> };

export type OrderMirrorSyncableCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderMirrorSyncableCompaniesQuery = { __typename?: 'Query', orderMirrorSyncableCompanies: Array<{ __typename?: 'MirrorSyncableCompanyEntity', companyUuid: string, name: string }> };

export type RequestOrderMirrorSyncMutationVariables = Exact<{
  input: RequestOrderMirrorSyncInput;
}>;


export type RequestOrderMirrorSyncMutation = { __typename?: 'Mutation', requestOrderMirrorSync: { __typename?: 'RequestOrderMirrorSyncOutput', requestUuid: string } };

export type SetOrderMirrorCaptureConfigMutationVariables = Exact<{
  input: SetOrderMirrorCaptureConfigInput;
}>;


export type SetOrderMirrorCaptureConfigMutation = { __typename?: 'Mutation', setOrderMirrorCaptureConfig: { __typename?: 'OrderMirrorCaptureConfigEntity', mode: string, companies: Array<{ __typename?: 'OrderMirrorCaptureCompanyEntity', companyUuid: string, companyName: string }> } };

export type SetMirrorTargetCompaniesMutationVariables = Exact<{
  input: SetMirrorTargetCompaniesInput;
}>;


export type SetMirrorTargetCompaniesMutation = { __typename?: 'Mutation', setMirrorTargetCompanies: boolean };

export type UpdateMirrorTargetMutationVariables = Exact<{
  input: UpdateMirrorTargetInput;
}>;


export type UpdateMirrorTargetMutation = { __typename?: 'Mutation', updateMirrorTarget: { __typename?: 'MirrorTargetEntity', uuid: string } };

export type PackageTableColumnFragment = { __typename?: 'PackageTableColumnEntity', uuid: string, columnIndex: number, header: string, packageField?: PackageField | null, required: boolean };

export type PieceBackfillRunFieldsFragment = { __typename?: 'PieceBackfillRunView', uuid: string, companyUuid: string, mode: PieceBackfillRunMode, status: PieceBackfillRunStatus, packagesTotal: number, packagesProcessed: number, packagesSkipped: number, piecesCreated: number, piecesUpdated: number, joinsCreated: number, params: any, report?: any | null, error?: string | null, requestedByEmail: string, createdAt: any, startedAt?: any | null, finishedAt?: any | null };

export type PieceBackfillRunQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type PieceBackfillRunQuery = { __typename?: 'Query', pieceBackfillRun: { __typename?: 'PieceBackfillRunView', uuid: string, companyUuid: string, mode: PieceBackfillRunMode, status: PieceBackfillRunStatus, packagesTotal: number, packagesProcessed: number, packagesSkipped: number, piecesCreated: number, piecesUpdated: number, joinsCreated: number, params: any, report?: any | null, error?: string | null, requestedByEmail: string, createdAt: any, startedAt?: any | null, finishedAt?: any | null } };

export type PieceBackfillRunsQueryVariables = Exact<{
  input: PieceBackfillRunsInput;
}>;


export type PieceBackfillRunsQuery = { __typename?: 'Query', pieceBackfillRuns: Array<{ __typename?: 'PieceBackfillRunView', uuid: string, companyUuid: string, mode: PieceBackfillRunMode, status: PieceBackfillRunStatus, packagesTotal: number, packagesProcessed: number, packagesSkipped: number, piecesCreated: number, piecesUpdated: number, joinsCreated: number, params: any, report?: any | null, error?: string | null, requestedByEmail: string, createdAt: any, startedAt?: any | null, finishedAt?: any | null }> };

export type PieceBackfillSurveyQueryVariables = Exact<{
  input: PieceBackfillSurveyInput;
}>;


export type PieceBackfillSurveyQuery = { __typename?: 'Query', pieceBackfillSurvey: { __typename?: 'PieceBackfillSurvey', companyUuid: string, cutoffDate: any, totalPackageCount: number, totalPackageQuantity: number, totalExistingPieceCount: number, totalMissingPieceCount: number, billingParties: Array<{ __typename?: 'PieceBackfillSurveyRow', contactUuid: string, contactName: string, packageCount: number, totalPackageQuantity: number, existingPieceCount: number, missingPieceCount: number }> } };

export type StartPieceBackfillRunMutationVariables = Exact<{
  input: StartPieceBackfillRunInput;
}>;


export type StartPieceBackfillRunMutation = { __typename?: 'Mutation', startPieceBackfillRun: { __typename?: 'PieceBackfillRunView', uuid: string, companyUuid: string, mode: PieceBackfillRunMode, status: PieceBackfillRunStatus, packagesTotal: number, packagesProcessed: number, packagesSkipped: number, piecesCreated: number, piecesUpdated: number, joinsCreated: number, params: any, report?: any | null, error?: string | null, requestedByEmail: string, createdAt: any, startedAt?: any | null, finishedAt?: any | null } };

export type PrefillInspectionQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  senderAddress?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type PrefillInspectionQuery = { __typename?: 'Query', prefillInspection: { __typename: 'PrefillInspectionEntity', candidates: Array<{ __typename?: 'PrefillBillingPartyCandidateEntity', uuid: string, displayName: string }>, senderBillingParty?: { __typename?: 'SenderBillingPartyExplainEntity', verdict: string, contactUuid?: string | null, support?: number | null, distinctParties?: number | null } | null, conditionalService?: { __typename?: 'ConditionalServiceExplainEntity', verdict: string, serviceId?: string | null, support?: number | null, share?: number | null } | null } | { __typename: 'QueryErrorOutput', message: string } };

export type ReanalyzePageMutationVariables = Exact<{
  reanalyzePageInput: ReanalyzePageInput;
}>;


export type ReanalyzePageMutation = { __typename?: 'Mutation', reanalyzePage: boolean };

export type ReanalyzeSchemaFileMutationVariables = Exact<{
  reanalyzeSchemaFileInput: ReanalyzeSchemaFileInput;
}>;


export type ReanalyzeSchemaFileMutation = { __typename?: 'Mutation', reanalyzeSchemaFile: boolean };

export type RenderServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type RenderServicesQuery = { __typename?: 'Query', renderServices: Array<{ __typename?: 'RenderServiceWithDeploysEntity', id: string, name: string, branch: string, updatedAt: number, deploys: Array<{ __typename?: 'RenderDeployEntity', commitHash: string, commitMessage: string, finishedAt?: number | null }> }> };

export type RetrySftpUploadsMutationVariables = Exact<{
  retrySftpUploadsInput: RetrySftpUploadsInput;
}>;


export type RetrySftpUploadsMutation = { __typename?: 'Mutation', retrySftpUploads: { __typename?: 'RetrySftpUploadsOutput', sftpUpload?: { __typename?: 'SftpUploadEntity', uuid: string, status: SftpUploadStatus, error?: string | null } | null } };

export type RotateDocumentMutationVariables = Exact<{
  rotateDocumentInput: RotateDocumentInput;
}>;


export type RotateDocumentMutation = { __typename?: 'Mutation', rotateDocument: string };

export type CreateScannedOrdersFromAdminMutationVariables = Exact<{
  createScannedOrdersFromAdminInput: CreateScannedOrdersFromAdminInput;
}>;


export type CreateScannedOrdersFromAdminMutation = { __typename?: 'Mutation', createScannedOrdersFromAdmin: Array<{ __typename?: 'ScannedOrderFromAdminCreateOutput', error?: string | null, scannedOrderEntity?: { __typename?: 'ScannedOrderEntity', uuid: string } | null }> };

export type ScannedOrderResultsForAdminQueryVariables = Exact<{
  args: GetScannedOrderResultsForAdminArgs;
}>;


export type ScannedOrderResultsForAdminQuery = { __typename?: 'Query', scannedOrderResultsForAdmin: { __typename?: 'ScannedOrderResultConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ScannedOrderResultEdge', node: { __typename?: 'ScannedOrderResultEntity', uuid: string, createdAt: any, filename: string, status: ScannedOrderResultStatus, failureReason?: ScannedOrderFailureReason | null, preSignedGetUrl?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, documents: Array<{ __typename?: 'DocumentEntity', preSignedGetUrl: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', serviceDate?: any | null, specialInstructions?: string | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', quantity: number, weight?: number | null, width?: number | null, length?: number | null, height?: number | null, description: string }> } | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type StructuredExtractionRunByScannedOrderUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StructuredExtractionRunByScannedOrderUuidQuery = { __typename?: 'Query', structuredExtractionRunByScannedOrder?: { __typename?: 'StructuredExtractionRunEntity', uuid: string, scannedOrderUuid: string, schemaUuid?: string | null, schemaName?: string | null, rawResult?: string | null } | null };

export type StructuredExtractionSchemaOverrideQueryVariables = Exact<{
  schemaUuid: Scalars['String']['input'];
}>;


export type StructuredExtractionSchemaOverrideQuery = { __typename?: 'Query', getStructuredExtractionSchemaOverride?: { __typename?: 'StructuredExtractionSchemaOverrideEntity', uuid: string, schemaOverride?: string | null, schemaExclusions?: string | null, deadlineDateKeys?: Array<string> | null, specialInstructionsKeys?: Array<string> | null } | null };

export type UpsertStructuredExtractionSchemaOverrideMutationVariables = Exact<{
  upsertStructuredExtractionSchemaOverrideInput: StructuredExtractionSchemaOverrideInput;
}>;


export type UpsertStructuredExtractionSchemaOverrideMutation = { __typename?: 'Mutation', upsertStructuredExtractionSchemaOverride: { __typename?: 'StructuredExtractionSchemaOverrideEntity', uuid: string, schemaOverride?: string | null, schemaExclusions?: string | null } };

export type CreateSchemaCompanyMappingMutationVariables = Exact<{
  createSchemaCompanyMappingInput: CreateSchemaCompanyMappingInput;
}>;


export type CreateSchemaCompanyMappingMutation = { __typename?: 'Mutation', createSchemaCompanyMapping: string };

export type CreateSchemaDocumentMutationVariables = Exact<{
  createSchemaDocumentInput: CreateSchemaDocumentInput;
}>;


export type CreateSchemaDocumentMutation = { __typename?: 'Mutation', createSchemaDocument: { __typename?: 'SchemaDocumentEntity', uuid: string } };

export type DeleteSchemaCompanyMappingMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSchemaCompanyMappingMutation = { __typename?: 'Mutation', deleteSchemaCompanyMapping: string };

export type DeleteSchemaDocumentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteSchemaDocumentMutation = { __typename?: 'Mutation', deleteSchemaDocument?: string | null };

export type GenerateScannedOrderPreSignedPutUrlsQueryVariables = Exact<{
  preSignedUrlRequests: Array<PreSignedUrlRequestInput> | PreSignedUrlRequestInput;
}>;


export type GenerateScannedOrderPreSignedPutUrlsQuery = { __typename?: 'Query', generateScannedOrderPreSignedPutUrls: Array<{ __typename?: 'PreSignedPutUrlEntity', url: string, bucket: string, key: string, filename: string, filetype: string }> };

export type SchemaCompanyMappingsQueryVariables = Exact<{
  schemaUuid: Scalars['String']['input'];
}>;


export type SchemaCompanyMappingsQuery = { __typename?: 'Query', schemaCompanyMappings: Array<{ __typename?: 'SchemaCompanyMappingEntity', id: string, contactUuid: string, companyUuid: string, isActive: boolean, terminalUuid?: string | null }> };

export type SchemaDocumentsBySchemaCompanyMappingQueryVariables = Exact<{
  schemaCompanyMappingId: Scalars['String']['input'];
}>;


export type SchemaDocumentsBySchemaCompanyMappingQuery = { __typename?: 'Query', schemaDocumentsBySchemaCompanyMapping: Array<{ __typename?: 'SchemaDocumentEntity', uuid: string, bucket: string, key: string, preSignedGetUrl: string, company?: { __typename?: 'CompanyEntity', uuid: string, name: string } | null }> };

export type SearchSchemasQueryVariables = Exact<{
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchSchemasQuery = { __typename?: 'Query', searchSchemas: Array<{ __typename?: 'SchemaEntity', uuid: string, name: string, createdAt: string, updatedAt: string, companyUuid?: string | null, isActive: boolean, scannedDocumentType: ScannedDocumentType, testDocumentCount?: number | null, companyMappingsCount: number, firstTestSchemaDocument?: { __typename?: 'SchemaDocumentEntity', uuid: string, preSignedGetUrl: string, bucket: string, key: string, company?: { __typename?: 'CompanyEntity', uuid: string, name: string } | null } | null }> };

export type UpdateSchemaCompanyMappingMutationVariables = Exact<{
  updateSchemaCompanyMappingInput: UpdateSchemaCompanyMappingInput;
}>;


export type UpdateSchemaCompanyMappingMutation = { __typename?: 'Mutation', updateSchemaCompanyMapping: string };

export type VerifySchemaDocumentMatchesForCompanyQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  schemaDocumentUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifySchemaDocumentMatchesForCompanyQuery = { __typename?: 'Query', verifySchemaDocumentMatchesForCompany: string };

export type SchemaFilePutUrlQueryVariables = Exact<{
  schemaFilePutUrlInput: SchemaFilePutUrlInput;
}>;


export type SchemaFilePutUrlQuery = { __typename?: 'Query', schemaFilePutUrl: string };

export type SchemaRunTestListQueryVariables = Exact<{
  schemaRunTestListInput: SchemaRunTestListInput;
}>;


export type SchemaRunTestListQuery = { __typename?: 'Query', schemaRunTestList: { __typename?: 'SchemaRunTestListEntity', uuid: string, schemaRunTestStatus: SchemaRunTestStatus, schemaRuns: Array<{ __typename?: 'SchemaRunEntity', uuid: string, bucket: string, key: string, schemaRunTestStatus?: SchemaRunTestStatus | null, type: SchemaRunType, schemaRunTestSnapshot?: { __typename?: 'SchemaRunEntity', uuid: string, bucket: string, key: string, schemaRunTestStatus?: SchemaRunTestStatus | null, type: SchemaRunType, extractedFields: Array<{ __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string }>, fingerprintAnchorMatches: Array<{ __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string }>, transformAnchorMatches: Array<{ __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string }>, schema: { __typename?: 'SchemaWithAnchorsEntity', uuid: string, name: string }, schemaRunPages: Array<{ __typename?: 'SchemaRunPageEntity', bucket: string, key: string, page: number, uuid: string, extractedFields: Array<{ __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string }>, fingerprintAnchorMatches: Array<{ __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string }>, transformAnchorMatches: Array<{ __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string }> }> } | null, extractedFields: Array<{ __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string }>, fingerprintAnchorMatches: Array<{ __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string }>, transformAnchorMatches: Array<{ __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string }>, schema: { __typename?: 'SchemaWithAnchorsEntity', uuid: string, name: string }, schemaRunPages: Array<{ __typename?: 'SchemaRunPageEntity', bucket: string, key: string, page: number, uuid: string, extractedFields: Array<{ __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string }>, fingerprintAnchorMatches: Array<{ __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string }>, transformAnchorMatches: Array<{ __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string }> }> }> } };

export type SchemaRunTestSnapshotsQueryVariables = Exact<{ [key: string]: never; }>;


export type SchemaRunTestSnapshotsQuery = { __typename?: 'Query', schemaRunTestSnapshots: Array<{ __typename?: 'SchemaRunEntity', uuid: string, bucket: string, key: string, schemaRunTestStatus?: SchemaRunTestStatus | null, type: SchemaRunType, extractedFields: Array<{ __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string }>, fingerprintAnchorMatches: Array<{ __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string }>, transformAnchorMatches: Array<{ __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string }>, schema: { __typename?: 'SchemaWithAnchorsEntity', uuid: string, name: string }, schemaRunPages: Array<{ __typename?: 'SchemaRunPageEntity', bucket: string, key: string, page: number, uuid: string, extractedFields: Array<{ __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string }>, fingerprintAnchorMatches: Array<{ __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string }>, transformAnchorMatches: Array<{ __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string }> }> }> };

export type SchemaRunFragment = { __typename?: 'SchemaRunEntity', uuid: string, bucket: string, key: string, schemaRunTestStatus?: SchemaRunTestStatus | null, type: SchemaRunType, extractedFields: Array<{ __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string }>, fingerprintAnchorMatches: Array<{ __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string }>, transformAnchorMatches: Array<{ __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string }>, schema: { __typename?: 'SchemaWithAnchorsEntity', uuid: string, name: string }, schemaRunPages: Array<{ __typename?: 'SchemaRunPageEntity', bucket: string, key: string, page: number, uuid: string, extractedFields: Array<{ __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string }>, fingerprintAnchorMatches: Array<{ __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string }>, transformAnchorMatches: Array<{ __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string }> }> };

export type SchemaRunQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type SchemaRunQuery = { __typename?: 'Query', schemaRun?: { __typename?: 'SchemaRunEntity', uuid: string, bucket: string, key: string, schemaRunTestStatus?: SchemaRunTestStatus | null, type: SchemaRunType, extractedFields: Array<{ __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string }>, fingerprintAnchorMatches: Array<{ __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string }>, transformAnchorMatches: Array<{ __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string }>, schema: { __typename?: 'SchemaWithAnchorsEntity', uuid: string, name: string }, schemaRunPages: Array<{ __typename?: 'SchemaRunPageEntity', bucket: string, key: string, page: number, uuid: string, extractedFields: Array<{ __typename?: 'ExtractedFieldEntity', field: FieldMapping, value: string, uuid: string }>, fingerprintAnchorMatches: Array<{ __typename?: 'FingerprintAnchorMatchEntity', substring?: string | null, text: string, uuid: string }>, transformAnchorMatches: Array<{ __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string }> }> } | null };

export type SchemaTestFilePutUrlQueryVariables = Exact<{
  schemaTestFilePutUrlInput: SchemaTestFilePutUrlInput;
}>;


export type SchemaTestFilePutUrlQuery = { __typename?: 'Query', schemaTestFilePutUrl: string };

export type SchemasQueryVariables = Exact<{ [key: string]: never; }>;


export type SchemasQuery = { __typename?: 'Query', schemas: Array<{ __typename?: 'SchemaWithAnchorsEntity', uuid: string, companyUuid?: string | null, contactUuid?: string | null, isMultiPage: boolean, isActive: boolean, name: string, originalFilename: string, scannedDocumentType: ScannedDocumentType, textractType: TextractType, packageTables: Array<{ __typename?: 'PackageTableEntity', uuid: string, blockId: string, headerRowIndex: number, title?: string | null, packageTableColumns: Array<{ __typename?: 'PackageTableColumnEntity', uuid: string, columnIndex: number, header: string, packageField?: PackageField | null, required: boolean }> }>, schemaFields: Array<{ __typename?: 'SchemaFieldEntity', uuid: string, left: number, top: number, height: number, width: number, concatenateX: boolean, leftEdgeAnchor?: { __typename?: 'EdgeAnchorEntity', uuid: string, blockId?: string | null, edge: Edge, left: number, top: number, height: number, width: number, text: string } | null, rightEdgeAnchor?: { __typename?: 'EdgeAnchorEntity', uuid: string, blockId?: string | null, edge: Edge, left: number, top: number, height: number, width: number, text: string } | null, topEdgeAnchor?: { __typename?: 'EdgeAnchorEntity', uuid: string, blockId?: string | null, edge: Edge, left: number, top: number, height: number, width: number, text: string } | null, bottomEdgeAnchor?: { __typename?: 'EdgeAnchorEntity', uuid: string, blockId?: string | null, edge: Edge, left: number, top: number, height: number, width: number, text: string } | null, fieldExtractors: Array<{ __typename?: 'FieldExtractorEntity', uuid: string, type: ExtractionType, value: string, mapping: FieldMapping }>, fieldMatchers: Array<{ __typename?: 'FieldMatcherEntity', uuid: string, type: MatcherType, value: string }> }>, fingerprintAnchors: Array<{ __typename?: 'FingerprintAnchorEntity', blockId?: string | null, left: number, top: number, height: number, width: number, substring?: string | null, text: string, required: boolean }>, transformAnchors: Array<{ __typename?: 'TransformAnchorEntity', blockId?: string | null, left: number, top: number, height: number, width: number, text: string }> }> };

export type SftpUploadsQueryVariables = Exact<{
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SftpUploadStatus>;
  type?: InputMaybe<SftpUploadType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type SftpUploadsQuery = { __typename?: 'Query', sftpUploads: { __typename?: 'SftpUploadConnection', edges: Array<{ __typename?: 'SftpUploadEdge', node: { __typename?: 'SftpUploadEntity', uuid: string, createdAt: any, type: SftpUploadType, status: SftpUploadStatus, error?: string | null, company: { __typename?: 'CompanyEntity', name: string }, contact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type StartConfigMigrationMutationVariables = Exact<{
  input: StartConfigMigrationInput;
}>;


export type StartConfigMigrationMutation = { __typename?: 'Mutation', startConfigMigration: string };

export type TerminalsForInternalQueryVariables = Exact<{
  getTerminalsInternalInput: GetTerminalsInternalInput;
}>;


export type TerminalsForInternalQuery = { __typename?: 'Query', terminalsForInternal: Array<{ __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string } }> };

export type TerminalsFragment = { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string } };

export type TerminalsQueryVariables = Exact<{
  getTerminalsInput?: InputMaybe<GetTerminalsInput>;
}>;


export type TerminalsQuery = { __typename?: 'Query', terminals: Array<{ __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string } }> };

export type TestAllSnapshotsMutationVariables = Exact<{ [key: string]: never; }>;


export type TestAllSnapshotsMutation = { __typename?: 'Mutation', testAllSnapshots: string };

export type TestOneSnapshotMutationVariables = Exact<{
  testOneSnapshotInput: TestOneSnapshotInput;
}>;


export type TestOneSnapshotMutation = { __typename?: 'Mutation', testOneSnapshot: string };

export type CreateTestOrderCustomChargeMutationVariables = Exact<{
  createTestOrderCustomChargeInput: CreateTestOrderCustomChargeInput;
}>;


export type CreateTestOrderCustomChargeMutation = { __typename?: 'Mutation', createTestOrderCustomCharge: { __typename?: 'CreateTestOrderCustomChargeOutput', success: boolean } };

export type CreateTestOrderV2MutationVariables = Exact<{
  createTestOrderRequest: CreateTestOrderRequest;
}>;


export type CreateTestOrderV2Mutation = { __typename?: 'Mutation', createTestOrderV2: { __typename?: 'CreateTestOrderResponse', success: boolean } };

export type FindTestOrderFragment = { __typename?: 'TestOrderEntity', uuid: string, totalCharge: number, totalFreightCharge: number, totalFuelCharge: number, order: { __typename?: 'StandardOrderEntity', uuid: string, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, billingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', name: string } | { __typename?: 'PercentageAccessorialEntity', name: string } | { __typename?: 'SkidBasedAccessorialEntity', name: string } | { __typename?: 'SpecialAccessorialEntity', name: string } | { __typename?: 'StandardAccessorialEntity', name: string } | { __typename?: 'StorageDaysAccessorialEntity', name: string } | { __typename?: 'UnitBasedAccessorialEntity', name: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string } | null }> }, testOrderCustomCharges: Array<{ __typename?: 'TestOrderCustomChargeEntity', uuid: string, total: number, customCharge: { __typename?: 'CustomChargeEntity', uuid: string, name: string, billingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', name: string } | { __typename?: 'PercentageAccessorialEntity', name: string } | { __typename?: 'SkidBasedAccessorialEntity', name: string } | { __typename?: 'SpecialAccessorialEntity', name: string } | { __typename?: 'StandardAccessorialEntity', name: string } | { __typename?: 'StorageDaysAccessorialEntity', name: string } | { __typename?: 'UnitBasedAccessorialEntity', name: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string } | null } }> };

export type TestOrderQueryVariables = Exact<{
  findTestOrderInput: FindTestOrderInput;
}>;


export type TestOrderQuery = { __typename?: 'Query', testOrder: { __typename?: 'FindTestOrderOutput', testOrder: { __typename?: 'TestOrderEntity', uuid: string, totalCharge: number, totalFreightCharge: number, totalFuelCharge: number, order: { __typename?: 'StandardOrderEntity', uuid: string, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, billingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', name: string } | { __typename?: 'PercentageAccessorialEntity', name: string } | { __typename?: 'SkidBasedAccessorialEntity', name: string } | { __typename?: 'SpecialAccessorialEntity', name: string } | { __typename?: 'StandardAccessorialEntity', name: string } | { __typename?: 'StorageDaysAccessorialEntity', name: string } | { __typename?: 'UnitBasedAccessorialEntity', name: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string } | null }> }, testOrderCustomCharges: Array<{ __typename?: 'TestOrderCustomChargeEntity', uuid: string, total: number, customCharge: { __typename?: 'CustomChargeEntity', uuid: string, name: string, billingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', name: string } | { __typename?: 'PercentageAccessorialEntity', name: string } | { __typename?: 'SkidBasedAccessorialEntity', name: string } | { __typename?: 'SpecialAccessorialEntity', name: string } | { __typename?: 'StandardAccessorialEntity', name: string } | { __typename?: 'StorageDaysAccessorialEntity', name: string } | { __typename?: 'UnitBasedAccessorialEntity', name: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string } | null } }> } } };

export type TestOrderFragment = { __typename?: 'TestOrderEntity', uuid: string, totalCharge: number, totalFreightCharge: number, totalFuelCharge: number, order: { __typename?: 'StandardOrderEntity', uuid: string, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } };

export type TestOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type TestOrdersQuery = { __typename?: 'Query', testOrders: { __typename?: 'FindTestOrdersOutput', testOrders: Array<{ __typename?: 'TestOrderEntity', uuid: string, totalCharge: number, totalFreightCharge: number, totalFuelCharge: number, order: { __typename?: 'StandardOrderEntity', uuid: string, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } }> } };

export type UpdateTestOrderMutationVariables = Exact<{
  updateTestOrderInput: UpdateTestOrderInput;
}>;


export type UpdateTestOrderMutation = { __typename?: 'Mutation', updateTestOrder: { __typename?: 'UpdateTestOrderOutput', success: boolean } };

export type TestSchemaMutationVariables = Exact<{
  testSchemaInput: TestSchemaInput;
}>;


export type TestSchemaMutation = { __typename?: 'Mutation', testSchema?: string | null };

export type TextractSchemaFileMutationVariables = Exact<{
  textractSchemaFileInput: TextractSchemaFileInput;
}>;


export type TextractSchemaFileMutation = { __typename?: 'Mutation', textractSchemaFile: boolean };

export type TextractSchemaTestFileMutationVariables = Exact<{
  textractSchemaTestFileInput: TextractSchemaTestFileInput;
}>;


export type TextractSchemaTestFileMutation = { __typename?: 'Mutation', textractSchemaTestFile: boolean };

export type TransformAnchorMatchFragment = { __typename?: 'TransformAnchorMatchEntity', text: string, uuid: string };

export type TransformAnchorFragment = { __typename?: 'TransformAnchorEntity', blockId?: string | null, left: number, top: number, height: number, width: number, text: string };

export type UpdateSchemaMutationVariables = Exact<{
  updateSchemaInput: UpdateSchemaInput;
}>;


export type UpdateSchemaMutation = { __typename?: 'Mutation', updateSchema: string };

export type MeRolePermissionFragment = { __typename?: 'PermissionEntity', permissionResource: PermissionResource, accessLevel: AccessLevel };

export type MeRoleFragment = { __typename?: 'RoleEntity', uuid: string, name: string, permissions: Array<{ __typename?: 'PermissionEntity', permissionResource: PermissionResource, accessLevel: AccessLevel }> };

export type UserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRolesQuery = { __typename?: 'Query', userRoles: Array<{ __typename?: 'RoleEntity', uuid: string, name: string, permissions: Array<{ __typename?: 'PermissionEntity', permissionResource: PermissionResource, accessLevel: AccessLevel }> }> };

export type ValidateCrownChargesFromCsvMutationVariables = Exact<{
  validateCrownChargesInput: ValidateCrownChargesInput;
}>;


export type ValidateCrownChargesFromCsvMutation = { __typename?: 'Mutation', validateCrownChargesFromCSV: { __typename?: 'ValidateCrownChargesOutput', resultsUrl: string, csvResults: Array<Array<string>>, correctCrownIDs: Array<string>, wrongCrownIDs: Array<string> } };

export type ValidateCrownChargesFromPdfMutationVariables = Exact<{
  validateCrownChargesInput: ValidateCrownChargesInput;
}>;


export type ValidateCrownChargesFromPdfMutation = { __typename?: 'Mutation', validateCrownChargesFromPDF: { __typename?: 'ValidateCrownChargesOutput', resultsUrl: string, csvResults: Array<Array<string>>, correctCrownIDs: Array<string>, wrongCrownIDs: Array<string> } };

export type ApiKeyAdminConnectOrgsMutationVariables = Exact<{
  input: ApiKeyAdminConnectOrgsInput;
}>;


export type ApiKeyAdminConnectOrgsMutation = { __typename?: 'Mutation', apiKeyAdminConnectOrgs: { __typename?: 'ApiKeyAdminDetailEntity', apiKey: { __typename?: 'ApiKeyAdminEntity', uuid: string, name: string, apiKey: string, webhookUrl?: string | null, enableStaging: boolean, webhookAuthHeaderName?: string | null, webhookAuthHeaderValue?: string | null, payloadShapes: Array<WebhookPayloadShape>, eventTypes: Array<OutboundWebhookEventType>, idFormat: ApiUserIdFormat, customMapping: boolean, emitTerminalHandoffEvents: boolean, sendCompanyLocalTimestamps: boolean, webhookTimestampMode: WebhookTimestampMode, orgCount: number, createdAt: any, updatedAt: any }, linkedOrgs: Array<{ __typename?: 'ApiKeyAdminLinkedOrgEntity', organizationUuid: string, organizationDisplayName: string, companyUuid: string, companyName: string }> } };

export type ApiKeyAdminCreateMutationVariables = Exact<{
  input: ApiKeyAdminCreateInput;
}>;


export type ApiKeyAdminCreateMutation = { __typename?: 'Mutation', apiKeyAdminCreate: { __typename?: 'ApiKeyAdminEntity', uuid: string, name: string, apiKey: string, webhookUrl?: string | null, enableStaging: boolean, webhookAuthHeaderName?: string | null, webhookAuthHeaderValue?: string | null, payloadShapes: Array<WebhookPayloadShape>, eventTypes: Array<OutboundWebhookEventType>, idFormat: ApiUserIdFormat, customMapping: boolean, emitTerminalHandoffEvents: boolean, sendCompanyLocalTimestamps: boolean, webhookTimestampMode: WebhookTimestampMode, orgCount: number, createdAt: any, updatedAt: any } };

export type ApiKeyAdminDeleteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ApiKeyAdminDeleteMutation = { __typename?: 'Mutation', apiKeyAdminDelete: boolean };

export type ApiKeyAdminDisconnectOrgMutationVariables = Exact<{
  input: ApiKeyAdminDisconnectOrgInput;
}>;


export type ApiKeyAdminDisconnectOrgMutation = { __typename?: 'Mutation', apiKeyAdminDisconnectOrg: { __typename?: 'ApiKeyAdminDetailEntity', apiKey: { __typename?: 'ApiKeyAdminEntity', uuid: string, name: string, apiKey: string, webhookUrl?: string | null, enableStaging: boolean, webhookAuthHeaderName?: string | null, webhookAuthHeaderValue?: string | null, payloadShapes: Array<WebhookPayloadShape>, eventTypes: Array<OutboundWebhookEventType>, idFormat: ApiUserIdFormat, customMapping: boolean, emitTerminalHandoffEvents: boolean, sendCompanyLocalTimestamps: boolean, webhookTimestampMode: WebhookTimestampMode, orgCount: number, createdAt: any, updatedAt: any }, linkedOrgs: Array<{ __typename?: 'ApiKeyAdminLinkedOrgEntity', organizationUuid: string, organizationDisplayName: string, companyUuid: string, companyName: string }> } };

export type ApiKeyAdminEventTypeCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeyAdminEventTypeCatalogQuery = { __typename?: 'Query', apiKeyAdminEventTypeCatalog: Array<{ __typename?: 'ApiKeyAdminEventTypeCatalogShapeEntity', shape: WebhookPayloadShape, isStandard: boolean, eventTypes: Array<{ __typename?: 'ApiKeyAdminEventTypeCatalogEntryEntity', eventType: OutboundWebhookEventType, deprecated: boolean, requiresTerminalHandoffOptIn: boolean }> }> };

export type ApiKeyAdminExamplePayloadQueryVariables = Exact<{
  shape: WebhookPayloadShape;
  sendCompanyLocalTimestamps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ApiKeyAdminExamplePayloadQuery = { __typename?: 'Query', apiKeyAdminExamplePayload: string };

export type ApiKeyAdminExportCsvQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ApiKeyAdminExportCsvQuery = { __typename?: 'Query', apiKeyAdminExportCsv: string };

export type ApiKeyAdminGetQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ApiKeyAdminGetQuery = { __typename?: 'Query', apiKeyAdminGet: { __typename?: 'ApiKeyAdminDetailEntity', apiKey: { __typename?: 'ApiKeyAdminEntity', uuid: string, name: string, apiKey: string, webhookUrl?: string | null, enableStaging: boolean, webhookAuthHeaderName?: string | null, webhookAuthHeaderValue?: string | null, payloadShapes: Array<WebhookPayloadShape>, eventTypes: Array<OutboundWebhookEventType>, idFormat: ApiUserIdFormat, customMapping: boolean, emitTerminalHandoffEvents: boolean, sendCompanyLocalTimestamps: boolean, webhookTimestampMode: WebhookTimestampMode, orgCount: number, createdAt: any, updatedAt: any }, linkedOrgs: Array<{ __typename?: 'ApiKeyAdminLinkedOrgEntity', organizationUuid: string, organizationDisplayName: string, companyUuid: string, companyName: string }> } };

export type ApiKeyAdminImportCsvMutationVariables = Exact<{
  input: ApiKeyAdminImportCsvInput;
}>;


export type ApiKeyAdminImportCsvMutation = { __typename?: 'Mutation', apiKeyAdminImportCsv: { __typename?: 'ApiKeyAdminCsvImportReport', keyName: string, apiKey: string, keyOutcome: ApiKeyAdminCsvImportKeyOutcome, keyMessage?: string | null, orgsToLink: number, applied: boolean, orgRows: Array<{ __typename?: 'ApiKeyAdminCsvImportOrgRow', rowNumber: number, companyName: string, organizationDisplayName: string, outcome: ApiKeyAdminCsvImportOrgOutcome, message?: string | null }> } };

export type ApiKeyAdminListQueryVariables = Exact<{
  input: ApiKeyAdminListInput;
}>;


export type ApiKeyAdminListQuery = { __typename?: 'Query', apiKeyAdminList: { __typename?: 'ApiKeyAdminListResult', totalCount: number, apiKeys: Array<{ __typename?: 'ApiKeyAdminListItemEntity', uuid: string, name: string, webhookUrl?: string | null, enableStaging: boolean, webhookAuthHeaderName?: string | null, payloadShapes: Array<WebhookPayloadShape>, idFormat: ApiUserIdFormat, customMapping: boolean, emitTerminalHandoffEvents: boolean, orgCount: number, createdAt: any, updatedAt: any }> } };

export type ApiKeyAdminPreviewMappingQueryVariables = Exact<{
  input: ApiKeyAdminPreviewMappingInput;
}>;


export type ApiKeyAdminPreviewMappingQuery = { __typename?: 'Query', apiKeyAdminPreviewMapping: string };

export type ApiKeyAdminSearchOrganizationsQueryVariables = Exact<{
  input: ApiKeyAdminOrgSearchInput;
}>;


export type ApiKeyAdminSearchOrganizationsQuery = { __typename?: 'Query', apiKeyAdminSearchOrganizations: Array<{ __typename?: 'ApiKeyAdminOrgSearchResult', organizationUuid: string, organizationDisplayName: string, companyUuid: string, companyName: string }> };

export type ApiKeyAdminSetMappingTemplateMutationVariables = Exact<{
  input: ApiKeyAdminSetMappingTemplateInput;
}>;


export type ApiKeyAdminSetMappingTemplateMutation = { __typename?: 'Mutation', apiKeyAdminSetMappingTemplate: { __typename?: 'ApiKeyAdminWebhookShapeConfigEntity', webhookShape: WebhookPayloadShape, urlPath?: string | null, mappingTemplate?: string | null } };

export type ApiKeyAdminSetStatusMappingsMutationVariables = Exact<{
  input: ApiKeyAdminSetStatusMappingsInput;
}>;


export type ApiKeyAdminSetStatusMappingsMutation = { __typename?: 'Mutation', apiKeyAdminSetStatusMappings: Array<{ __typename?: 'ApiKeyAdminStatusMappingEntity', category: StatusMappingCategory, internalName: string, externalName: string }> };

export type ApiKeyAdminStatusMappingsQueryVariables = Exact<{
  apiKeyUuid: Scalars['String']['input'];
}>;


export type ApiKeyAdminStatusMappingsQuery = { __typename?: 'Query', apiKeyAdminStatusMappings: Array<{ __typename?: 'ApiKeyAdminStatusMappingEntity', category: StatusMappingCategory, internalName: string, externalName: string }> };

export type ApiKeyAdminUpdateMutationVariables = Exact<{
  input: ApiKeyAdminUpdateInput;
}>;


export type ApiKeyAdminUpdateMutation = { __typename?: 'Mutation', apiKeyAdminUpdate: { __typename?: 'ApiKeyAdminEntity', uuid: string, name: string, apiKey: string, webhookUrl?: string | null, enableStaging: boolean, webhookAuthHeaderName?: string | null, webhookAuthHeaderValue?: string | null, payloadShapes: Array<WebhookPayloadShape>, eventTypes: Array<OutboundWebhookEventType>, idFormat: ApiUserIdFormat, customMapping: boolean, emitTerminalHandoffEvents: boolean, sendCompanyLocalTimestamps: boolean, webhookTimestampMode: WebhookTimestampMode, orgCount: number, createdAt: any, updatedAt: any } };

export type ApiKeyAdminWebhookShapeConfigQueryVariables = Exact<{
  apiKeyUuid: Scalars['String']['input'];
  shape: WebhookPayloadShape;
}>;


export type ApiKeyAdminWebhookShapeConfigQuery = { __typename?: 'Query', apiKeyAdminWebhookShapeConfig?: { __typename?: 'ApiKeyAdminWebhookShapeConfigEntity', webhookShape: WebhookPayloadShape, urlPath?: string | null, mappingTemplate?: string | null } | null };

export type ApiKeyAdminFieldsFragment = { __typename?: 'ApiKeyAdminEntity', uuid: string, name: string, apiKey: string, webhookUrl?: string | null, enableStaging: boolean, webhookAuthHeaderName?: string | null, webhookAuthHeaderValue?: string | null, payloadShapes: Array<WebhookPayloadShape>, eventTypes: Array<OutboundWebhookEventType>, idFormat: ApiUserIdFormat, customMapping: boolean, emitTerminalHandoffEvents: boolean, sendCompanyLocalTimestamps: boolean, webhookTimestampMode: WebhookTimestampMode, orgCount: number, createdAt: any, updatedAt: any };

export type ApiKeyAdminListItemFieldsFragment = { __typename?: 'ApiKeyAdminListItemEntity', uuid: string, name: string, webhookUrl?: string | null, enableStaging: boolean, webhookAuthHeaderName?: string | null, payloadShapes: Array<WebhookPayloadShape>, idFormat: ApiUserIdFormat, customMapping: boolean, emitTerminalHandoffEvents: boolean, orgCount: number, createdAt: any, updatedAt: any };

export type ApiKeyAdminStatusMappingFieldsFragment = { __typename?: 'ApiKeyAdminStatusMappingEntity', category: StatusMappingCategory, internalName: string, externalName: string };

export type ApiKeyAdminLinkedOrgFieldsFragment = { __typename?: 'ApiKeyAdminLinkedOrgEntity', organizationUuid: string, organizationDisplayName: string, companyUuid: string, companyName: string };

export type ApiKeyAdminDetailFieldsFragment = { __typename?: 'ApiKeyAdminDetailEntity', apiKey: { __typename?: 'ApiKeyAdminEntity', uuid: string, name: string, apiKey: string, webhookUrl?: string | null, enableStaging: boolean, webhookAuthHeaderName?: string | null, webhookAuthHeaderValue?: string | null, payloadShapes: Array<WebhookPayloadShape>, eventTypes: Array<OutboundWebhookEventType>, idFormat: ApiUserIdFormat, customMapping: boolean, emitTerminalHandoffEvents: boolean, sendCompanyLocalTimestamps: boolean, webhookTimestampMode: WebhookTimestampMode, orgCount: number, createdAt: any, updatedAt: any }, linkedOrgs: Array<{ __typename?: 'ApiKeyAdminLinkedOrgEntity', organizationUuid: string, organizationDisplayName: string, companyUuid: string, companyName: string }> };

export type ApiKeyAdminCsvImportRowFieldsFragment = { __typename?: 'ApiKeyAdminCsvImportOrgRow', rowNumber: number, companyName: string, organizationDisplayName: string, outcome: ApiKeyAdminCsvImportOrgOutcome, message?: string | null };

export type ApiKeyAdminCsvImportReportFieldsFragment = { __typename?: 'ApiKeyAdminCsvImportReport', keyName: string, apiKey: string, keyOutcome: ApiKeyAdminCsvImportKeyOutcome, keyMessage?: string | null, orgsToLink: number, applied: boolean, orgRows: Array<{ __typename?: 'ApiKeyAdminCsvImportOrgRow', rowNumber: number, companyName: string, organizationDisplayName: string, outcome: ApiKeyAdminCsvImportOrgOutcome, message?: string | null }> };

export type DocumentationAdminCreateItemMutationVariables = Exact<{
  input: DocumentationItemCreateInput;
}>;


export type DocumentationAdminCreateItemMutation = { __typename?: 'Mutation', documentationAdminCreateItem: { __typename?: 'DocumentationItemEntity', uuid: string, topicUuid: string, title: string, slug: string, code?: string | null, status: DocumentationItemStatus, publishedAt?: any | null, sortOrder: number, htmlSizeBytes: number, updatedAt: any } };

export type DocumentationAdminCreateTopicMutationVariables = Exact<{
  input: DocumentationTopicCreateInput;
}>;


export type DocumentationAdminCreateTopicMutation = { __typename?: 'Mutation', documentationAdminCreateTopic: { __typename?: 'DocumentationTopicEntity', uuid: string, title: string, description?: string | null, sortOrder: number, items: Array<{ __typename?: 'DocumentationItemSummaryEntity', uuid: string, topicUuid: string, title: string, slug: string, code?: string | null, status: DocumentationItemStatus, publishedAt?: any | null, sortOrder: number, htmlSizeBytes: number, updatedAt: any }> } };

export type DocumentationAdminDeleteItemMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DocumentationAdminDeleteItemMutation = { __typename?: 'Mutation', documentationAdminDeleteItem: boolean };

export type DocumentationAdminDeleteTopicMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DocumentationAdminDeleteTopicMutation = { __typename?: 'Mutation', documentationAdminDeleteTopic: boolean };

export type DocumentationAdminItemSummaryFieldsFragment = { __typename?: 'DocumentationItemSummaryEntity', uuid: string, topicUuid: string, title: string, slug: string, code?: string | null, status: DocumentationItemStatus, publishedAt?: any | null, sortOrder: number, htmlSizeBytes: number, updatedAt: any };

export type DocumentationAdminItemFieldsFragment = { __typename?: 'DocumentationItemEntity', uuid: string, topicUuid: string, title: string, slug: string, code?: string | null, status: DocumentationItemStatus, publishedAt?: any | null, sortOrder: number, htmlSizeBytes: number, updatedAt: any };

export type DocumentationAdminItemQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DocumentationAdminItemQuery = { __typename?: 'Query', documentationAdminItem: { __typename?: 'DocumentationItemEntity', html: string, uuid: string, topicUuid: string, title: string, slug: string, code?: string | null, status: DocumentationItemStatus, publishedAt?: any | null, sortOrder: number, htmlSizeBytes: number, updatedAt: any } };

export type DocumentationAdminReorderMutationVariables = Exact<{
  input: DocumentationReorderInput;
}>;


export type DocumentationAdminReorderMutation = { __typename?: 'Mutation', documentationAdminReorder: boolean };

export type DocumentationAdminTopicFieldsFragment = { __typename?: 'DocumentationTopicEntity', uuid: string, title: string, description?: string | null, sortOrder: number, items: Array<{ __typename?: 'DocumentationItemSummaryEntity', uuid: string, topicUuid: string, title: string, slug: string, code?: string | null, status: DocumentationItemStatus, publishedAt?: any | null, sortOrder: number, htmlSizeBytes: number, updatedAt: any }> };

export type DocumentationAdminTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentationAdminTopicsQuery = { __typename?: 'Query', documentationAdminTopics: Array<{ __typename?: 'DocumentationTopicEntity', uuid: string, title: string, description?: string | null, sortOrder: number, items: Array<{ __typename?: 'DocumentationItemSummaryEntity', uuid: string, topicUuid: string, title: string, slug: string, code?: string | null, status: DocumentationItemStatus, publishedAt?: any | null, sortOrder: number, htmlSizeBytes: number, updatedAt: any }> }> };

export type DocumentationAdminUpdateItemMutationVariables = Exact<{
  input: DocumentationItemUpdateInput;
}>;


export type DocumentationAdminUpdateItemMutation = { __typename?: 'Mutation', documentationAdminUpdateItem: { __typename?: 'DocumentationItemEntity', uuid: string, topicUuid: string, title: string, slug: string, code?: string | null, status: DocumentationItemStatus, publishedAt?: any | null, sortOrder: number, htmlSizeBytes: number, updatedAt: any } };

export type DocumentationAdminUpdateTopicMutationVariables = Exact<{
  input: DocumentationTopicUpdateInput;
}>;


export type DocumentationAdminUpdateTopicMutation = { __typename?: 'Mutation', documentationAdminUpdateTopic: { __typename?: 'DocumentationTopicEntity', uuid: string, title: string, description?: string | null, sortOrder: number, items: Array<{ __typename?: 'DocumentationItemSummaryEntity', uuid: string, topicUuid: string, title: string, slug: string, code?: string | null, status: DocumentationItemStatus, publishedAt?: any | null, sortOrder: number, htmlSizeBytes: number, updatedAt: any }> } };

export type OrganizationMessageFieldsFragment = { __typename?: 'OrganizationMessageEntity', uuid: string, allCompanies: boolean, severity: OrganizationMessageSeverity, status: OrganizationMessageStatus, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, startsAt?: any | null, publishedAt?: any | null, expiresAt?: any | null, usesDefaultExpiry: boolean, resolvedAt?: any | null, withdrawnAt?: any | null, followsMessageUuid?: string | null, createdAt: any, companies: Array<{ __typename?: 'OrganizationMessageCompanyEntity', uuid: string, name: string }> };

export type OrganizationMessagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<OrganizationMessageView>;
}>;


export type OrganizationMessagesQuery = { __typename?: 'Query', organizationMessages: { __typename?: 'OrganizationMessageConnection', edges: Array<{ __typename?: 'OrganizationMessageEdge', node: { __typename?: 'OrganizationMessageEntity', uuid: string, allCompanies: boolean, severity: OrganizationMessageSeverity, status: OrganizationMessageStatus, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, startsAt?: any | null, publishedAt?: any | null, expiresAt?: any | null, usesDefaultExpiry: boolean, resolvedAt?: any | null, withdrawnAt?: any | null, followsMessageUuid?: string | null, createdAt: any, companies: Array<{ __typename?: 'OrganizationMessageCompanyEntity', uuid: string, name: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type OrganizationMessageDetailQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrganizationMessageDetailQuery = { __typename?: 'Query', organizationMessage: { __typename?: 'OrganizationMessageEntity', uuid: string, allCompanies: boolean, severity: OrganizationMessageSeverity, status: OrganizationMessageStatus, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, startsAt?: any | null, publishedAt?: any | null, expiresAt?: any | null, usesDefaultExpiry: boolean, resolvedAt?: any | null, withdrawnAt?: any | null, followsMessageUuid?: string | null, createdAt: any, companies: Array<{ __typename?: 'OrganizationMessageCompanyEntity', uuid: string, name: string }> }, organizationMessageHistory: Array<{ __typename?: 'OrganizationMessageEventEntity', action: OrganizationMessageEventAction, actorUserUuid: string, actorName?: string | null, createdAt: any }> };

export type OrganizationMessageStatsQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrganizationMessageStatsQuery = { __typename?: 'Query', organizationMessageStats: { __typename?: 'OrganizationMessageStatsEntity', asOf: any, companyCount: number, pendingCompanyCount: number, failedCompanyCount: number, deliveredCount: number, readCount: number, dismissedCount: number } };

export type OrganizationMessageReachQueryVariables = Exact<{
  audience: OrganizationMessageAudienceInput;
}>;


export type OrganizationMessageReachQuery = { __typename?: 'Query', organizationMessageReach: { __typename?: 'OrganizationMessageReachEntity', companyCount: number, userCount: number, bellEnabledCompanyCount: number } };

export type OrganizationMessageCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationMessageCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'CompanyEntity', uuid: string, name: string }> };

export type CreateOrganizationMessageMutationVariables = Exact<{
  input: CreateOrganizationMessageInput;
}>;


export type CreateOrganizationMessageMutation = { __typename?: 'Mutation', createOrganizationMessage: { __typename?: 'OrganizationMessageEntity', uuid: string, allCompanies: boolean, severity: OrganizationMessageSeverity, status: OrganizationMessageStatus, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, startsAt?: any | null, publishedAt?: any | null, expiresAt?: any | null, usesDefaultExpiry: boolean, resolvedAt?: any | null, withdrawnAt?: any | null, followsMessageUuid?: string | null, createdAt: any, companies: Array<{ __typename?: 'OrganizationMessageCompanyEntity', uuid: string, name: string }> } };

export type UpdateOrganizationMessageMutationVariables = Exact<{
  input: UpdateOrganizationMessageInput;
}>;


export type UpdateOrganizationMessageMutation = { __typename?: 'Mutation', updateOrganizationMessage: { __typename?: 'OrganizationMessageEntity', uuid: string, allCompanies: boolean, severity: OrganizationMessageSeverity, status: OrganizationMessageStatus, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, startsAt?: any | null, publishedAt?: any | null, expiresAt?: any | null, usesDefaultExpiry: boolean, resolvedAt?: any | null, withdrawnAt?: any | null, followsMessageUuid?: string | null, createdAt: any, companies: Array<{ __typename?: 'OrganizationMessageCompanyEntity', uuid: string, name: string }> } };

export type PublishOrganizationMessageMutationVariables = Exact<{
  input: PublishOrganizationMessageInput;
}>;


export type PublishOrganizationMessageMutation = { __typename?: 'Mutation', publishOrganizationMessage: { __typename?: 'OrganizationMessageEntity', uuid: string, allCompanies: boolean, severity: OrganizationMessageSeverity, status: OrganizationMessageStatus, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, startsAt?: any | null, publishedAt?: any | null, expiresAt?: any | null, usesDefaultExpiry: boolean, resolvedAt?: any | null, withdrawnAt?: any | null, followsMessageUuid?: string | null, createdAt: any, companies: Array<{ __typename?: 'OrganizationMessageCompanyEntity', uuid: string, name: string }> } };

export type ScheduleOrganizationMessageMutationVariables = Exact<{
  input: ScheduleOrganizationMessageInput;
}>;


export type ScheduleOrganizationMessageMutation = { __typename?: 'Mutation', scheduleOrganizationMessage: { __typename?: 'OrganizationMessageEntity', uuid: string, allCompanies: boolean, severity: OrganizationMessageSeverity, status: OrganizationMessageStatus, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, startsAt?: any | null, publishedAt?: any | null, expiresAt?: any | null, usesDefaultExpiry: boolean, resolvedAt?: any | null, withdrawnAt?: any | null, followsMessageUuid?: string | null, createdAt: any, companies: Array<{ __typename?: 'OrganizationMessageCompanyEntity', uuid: string, name: string }> } };

export type RescheduleOrganizationMessageMutationVariables = Exact<{
  input: ScheduleOrganizationMessageInput;
}>;


export type RescheduleOrganizationMessageMutation = { __typename?: 'Mutation', rescheduleOrganizationMessage: { __typename?: 'OrganizationMessageEntity', uuid: string, allCompanies: boolean, severity: OrganizationMessageSeverity, status: OrganizationMessageStatus, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, startsAt?: any | null, publishedAt?: any | null, expiresAt?: any | null, usesDefaultExpiry: boolean, resolvedAt?: any | null, withdrawnAt?: any | null, followsMessageUuid?: string | null, createdAt: any, companies: Array<{ __typename?: 'OrganizationMessageCompanyEntity', uuid: string, name: string }> } };

export type ResolveOrganizationMessageMutationVariables = Exact<{
  input: ResolveOrganizationMessageInput;
}>;


export type ResolveOrganizationMessageMutation = { __typename?: 'Mutation', resolveOrganizationMessage: { __typename?: 'OrganizationMessageEntity', uuid: string, allCompanies: boolean, severity: OrganizationMessageSeverity, status: OrganizationMessageStatus, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, startsAt?: any | null, publishedAt?: any | null, expiresAt?: any | null, usesDefaultExpiry: boolean, resolvedAt?: any | null, withdrawnAt?: any | null, followsMessageUuid?: string | null, createdAt: any, companies: Array<{ __typename?: 'OrganizationMessageCompanyEntity', uuid: string, name: string }> } };

export type WithdrawOrganizationMessageMutationVariables = Exact<{
  input: OrganizationMessageUuidInput;
}>;


export type WithdrawOrganizationMessageMutation = { __typename?: 'Mutation', withdrawOrganizationMessage: { __typename?: 'OrganizationMessageEntity', uuid: string, allCompanies: boolean, severity: OrganizationMessageSeverity, status: OrganizationMessageStatus, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, startsAt?: any | null, publishedAt?: any | null, expiresAt?: any | null, usesDefaultExpiry: boolean, resolvedAt?: any | null, withdrawnAt?: any | null, followsMessageUuid?: string | null, createdAt: any, companies: Array<{ __typename?: 'OrganizationMessageCompanyEntity', uuid: string, name: string }> } };

export type OrganizationMessageCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationMessageCountsQuery = { __typename?: 'Query', organizationMessageCounts: { __typename?: 'OrganizationMessageCountsEntity', live: number, scheduled: number, drafts: number, ended: number } };

export type AdvanceOutboundBenchOrdersMutationVariables = Exact<{
  input: AdvanceOutboundBenchOrdersInput;
}>;


export type AdvanceOutboundBenchOrdersMutation = { __typename?: 'Mutation', advanceOutboundBenchOrders: { __typename?: 'BenchRunReportEntity', environment: string, production: boolean, integrationType: BenchIntegrationType, orders: Array<{ __typename?: 'BenchOrderReportEntity', orderUuid: string, orderName?: string | null, hawb?: string | null, companyName?: string | null, billingContactName?: string | null, refusals: Array<string>, steps: Array<{ __typename?: 'BenchPlannedStepEntity', kind: BenchStepKind, stopRole?: BenchStopRole | null, stopUuid?: string | null, manifestUuid?: string | null, state: BenchStepState, reason: string, expected214Statuses: Array<Edi214ShipmentStatus>, expects990: boolean, expects210: boolean, refusedInProduction: boolean, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }> }>, nextStep?: { __typename?: 'BenchPlannedStepEntity', kind: BenchStepKind, stopRole?: BenchStopRole | null, stopUuid?: string | null, manifestUuid?: string | null, state: BenchStepState, reason: string, expected214Statuses: Array<Edi214ShipmentStatus>, expects990: boolean, expects210: boolean, refusedInProduction: boolean, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }> } | null, lastResult?: { __typename?: 'BenchStepResultEntity', kind?: BenchStepKind | null, stopRole?: BenchStopRole | null, outcome: BenchStepOutcome, message: string, startedAt: any } | null, ediTransactions: Array<{ __typename?: 'BenchEdiTransactionEntity', uuid: string, createdAt: any, transactionSet: string, status: EdiTransactionStatus, message?: string | null, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null, receiverIsaId: string, tenediMessageId?: string | null, tenediRunIds: Array<string> }> }> } };

export type BenchStepFieldsFragment = { __typename?: 'BenchPlannedStepEntity', kind: BenchStepKind, stopRole?: BenchStopRole | null, stopUuid?: string | null, manifestUuid?: string | null, state: BenchStepState, reason: string, expected214Statuses: Array<Edi214ShipmentStatus>, expects990: boolean, expects210: boolean, refusedInProduction: boolean, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }> };

export type BenchOrderReportFieldsFragment = { __typename?: 'BenchOrderReportEntity', orderUuid: string, orderName?: string | null, hawb?: string | null, companyName?: string | null, billingContactName?: string | null, refusals: Array<string>, steps: Array<{ __typename?: 'BenchPlannedStepEntity', kind: BenchStepKind, stopRole?: BenchStopRole | null, stopUuid?: string | null, manifestUuid?: string | null, state: BenchStepState, reason: string, expected214Statuses: Array<Edi214ShipmentStatus>, expects990: boolean, expects210: boolean, refusedInProduction: boolean, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }> }>, nextStep?: { __typename?: 'BenchPlannedStepEntity', kind: BenchStepKind, stopRole?: BenchStopRole | null, stopUuid?: string | null, manifestUuid?: string | null, state: BenchStepState, reason: string, expected214Statuses: Array<Edi214ShipmentStatus>, expects990: boolean, expects210: boolean, refusedInProduction: boolean, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }> } | null, lastResult?: { __typename?: 'BenchStepResultEntity', kind?: BenchStepKind | null, stopRole?: BenchStopRole | null, outcome: BenchStepOutcome, message: string, startedAt: any } | null, ediTransactions: Array<{ __typename?: 'BenchEdiTransactionEntity', uuid: string, createdAt: any, transactionSet: string, status: EdiTransactionStatus, message?: string | null, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null, receiverIsaId: string, tenediMessageId?: string | null, tenediRunIds: Array<string> }> };

export type BenchEdiTransactionFieldsFragment = { __typename?: 'BenchEdiTransactionEntity', uuid: string, createdAt: any, transactionSet: string, status: EdiTransactionStatus, message?: string | null, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null, receiverIsaId: string, tenediMessageId?: string | null, tenediRunIds: Array<string> };

export type BenchRunReportFieldsFragment = { __typename?: 'BenchRunReportEntity', environment: string, production: boolean, integrationType: BenchIntegrationType, orders: Array<{ __typename?: 'BenchOrderReportEntity', orderUuid: string, orderName?: string | null, hawb?: string | null, companyName?: string | null, billingContactName?: string | null, refusals: Array<string>, steps: Array<{ __typename?: 'BenchPlannedStepEntity', kind: BenchStepKind, stopRole?: BenchStopRole | null, stopUuid?: string | null, manifestUuid?: string | null, state: BenchStepState, reason: string, expected214Statuses: Array<Edi214ShipmentStatus>, expects990: boolean, expects210: boolean, refusedInProduction: boolean, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }> }>, nextStep?: { __typename?: 'BenchPlannedStepEntity', kind: BenchStepKind, stopRole?: BenchStopRole | null, stopUuid?: string | null, manifestUuid?: string | null, state: BenchStepState, reason: string, expected214Statuses: Array<Edi214ShipmentStatus>, expects990: boolean, expects210: boolean, refusedInProduction: boolean, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }> } | null, lastResult?: { __typename?: 'BenchStepResultEntity', kind?: BenchStepKind | null, stopRole?: BenchStopRole | null, outcome: BenchStepOutcome, message: string, startedAt: any } | null, ediTransactions: Array<{ __typename?: 'BenchEdiTransactionEntity', uuid: string, createdAt: any, transactionSet: string, status: EdiTransactionStatus, message?: string | null, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null, receiverIsaId: string, tenediMessageId?: string | null, tenediRunIds: Array<string> }> }> };

export type CreateOutboundBenchOrdersMutationVariables = Exact<{
  input: CreateOutboundBenchOrdersInput;
}>;


export type CreateOutboundBenchOrdersMutation = { __typename?: 'Mutation', createOutboundBenchOrders: { __typename?: 'BenchCreatedOrdersEntity', failure?: string | null, laneSourceOrderName?: string | null, warning?: string | null, receivedServiceNames: Array<string>, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }>, orders: Array<{ __typename?: 'BenchOrderOptionEntity', uuid: string, name: string, hawb?: string | null, mawb?: string | null, status: OrderStatus, createdAt: any }> } };

export type FireOutboundBenchTransactionMutationVariables = Exact<{
  input: FireOutboundBenchTransactionInput;
}>;


export type FireOutboundBenchTransactionMutation = { __typename?: 'Mutation', fireOutboundBenchTransaction: { __typename?: 'BenchFireResultEntity', orderUuid: string, outcome: BenchStepOutcome, message: string, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }>, ediTransactions: Array<{ __typename?: 'BenchEdiTransactionEntity', uuid: string, createdAt: any, transactionSet: string, status: EdiTransactionStatus, message?: string | null, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null, receiverIsaId: string, tenediMessageId?: string | null, tenediRunIds: Array<string> }> } };

export type OutboundBenchCompanyUsersQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
}>;


export type OutboundBenchCompanyUsersQuery = { __typename?: 'Query', outboundBenchCompanyUsers: Array<{ __typename?: 'BenchCompanyUserOptionEntity', uuid: string, displayName: string, email?: string | null }> };

export type OutboundBenchDriversQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
}>;


export type OutboundBenchDriversQuery = { __typename?: 'Query', outboundBenchDrivers: Array<{ __typename?: 'BenchDriverOptionEntity', uuid: string, displayName: string }> };

export type OutboundBenchEdiPayloadQueryVariables = Exact<{
  ediTransactionUuid: Scalars['String']['input'];
}>;


export type OutboundBenchEdiPayloadQuery = { __typename?: 'Query', outboundBenchEdiPayload: { __typename?: 'BenchEdiPayloadEntity', uuid: string, storedPayload: string, sentPath?: string | null, sentBody?: string | null, deliveredThroughTenedi: boolean, note: string } };

export type OutboundBenchOrdersQueryVariables = Exact<{
  input: OutboundBenchOrderSearchInput;
}>;


export type OutboundBenchOrdersQuery = { __typename?: 'Query', outboundBenchOrders: Array<{ __typename?: 'BenchOrderOptionEntity', uuid: string, name: string, hawb?: string | null, mawb?: string | null, status: OrderStatus, createdAt: any }> };

export type OutboundBenchPartnershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type OutboundBenchPartnershipsQuery = { __typename?: 'Query', outboundBenchPartnerships: Array<{ __typename?: 'BenchPartnershipOptionEntity', uuid: string, companyUuid: string, companyName: string, contactUuid: string, contactName: string, receiverIsaId?: string | null, autoAcceptOrders: boolean, edi214ShipmentStatuses: Array<Edi214ShipmentStatus> }> };

export type OutboundBenchServiceLevelsQueryVariables = Exact<{
  partnershipUuid: Scalars['String']['input'];
}>;


export type OutboundBenchServiceLevelsQuery = { __typename?: 'Query', outboundBenchServiceLevels: Array<{ __typename?: 'BenchServiceLevelOptionEntity', code: string, serviceName: string }> };

export type PlanOutboundBenchRunQueryVariables = Exact<{
  input: PlanOutboundBenchRunInput;
}>;


export type PlanOutboundBenchRunQuery = { __typename?: 'Query', planOutboundBenchRun: { __typename?: 'BenchRunReportEntity', environment: string, production: boolean, integrationType: BenchIntegrationType, orders: Array<{ __typename?: 'BenchOrderReportEntity', orderUuid: string, orderName?: string | null, hawb?: string | null, companyName?: string | null, billingContactName?: string | null, refusals: Array<string>, steps: Array<{ __typename?: 'BenchPlannedStepEntity', kind: BenchStepKind, stopRole?: BenchStopRole | null, stopUuid?: string | null, manifestUuid?: string | null, state: BenchStepState, reason: string, expected214Statuses: Array<Edi214ShipmentStatus>, expects990: boolean, expects210: boolean, refusedInProduction: boolean, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }> }>, nextStep?: { __typename?: 'BenchPlannedStepEntity', kind: BenchStepKind, stopRole?: BenchStopRole | null, stopUuid?: string | null, manifestUuid?: string | null, state: BenchStepState, reason: string, expected214Statuses: Array<Edi214ShipmentStatus>, expects990: boolean, expects210: boolean, refusedInProduction: boolean, sideEffects: Array<{ __typename?: 'BenchSideEffectEntity', kind: BenchSideEffectKind, detail: string, suppressedBy?: string | null }> } | null, lastResult?: { __typename?: 'BenchStepResultEntity', kind?: BenchStepKind | null, stopRole?: BenchStopRole | null, outcome: BenchStepOutcome, message: string, startedAt: any } | null, ediTransactions: Array<{ __typename?: 'BenchEdiTransactionEntity', uuid: string, createdAt: any, transactionSet: string, status: EdiTransactionStatus, message?: string | null, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null, receiverIsaId: string, tenediMessageId?: string | null, tenediRunIds: Array<string> }> }> } };

export type SmsConsentAdminFieldsFragment = { __typename?: 'SmsConsentAdminEntity', uuid: string, maskedPhoneNumber: string, status: SmsConsentStatus, basis: SmsConsentBasis, createdAt: any, optedInAt?: any | null, revokedAt?: any | null, landline?: boolean | null, lineTypeCheckedAt?: any | null, consecutiveFailures: number, lastFailureCode?: number | null, lastFailureAt?: any | null, undeliverableUntil?: any | null, historyTruncated: boolean, events: Array<{ __typename?: 'SmsConsentAdminEventEntity', uuid: string, action: SmsConsentEventAction, occurredAt: any }> };

export type SmsConsentAdminListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SmsConsentAdminFilterInput>;
}>;


export type SmsConsentAdminListQuery = { __typename?: 'Query', smsConsentAdminList: { __typename?: 'SmsConsentAdminConnection', edges: Array<{ __typename?: 'SmsConsentAdminEdge', node: { __typename?: 'SmsConsentAdminEntity', uuid: string, maskedPhoneNumber: string, status: SmsConsentStatus, basis: SmsConsentBasis, createdAt: any, optedInAt?: any | null, revokedAt?: any | null, landline?: boolean | null, lineTypeCheckedAt?: any | null, consecutiveFailures: number, lastFailureCode?: number | null, lastFailureAt?: any | null, undeliverableUntil?: any | null, historyTruncated: boolean, events: Array<{ __typename?: 'SmsConsentAdminEventEntity', uuid: string, action: SmsConsentEventAction, occurredAt: any }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type SaveTenediPartnershipMutationVariables = Exact<{
  input: SaveTenediPartnershipInput;
}>;


export type SaveTenediPartnershipMutation = { __typename?: 'Mutation', saveTenediPartnership: { __typename?: 'TenediPartnershipSaveResultEntity', created: boolean, changes: Array<{ __typename?: 'TenediFieldChangeEntity', field: string, before?: string | null, after?: string | null }>, partnership: { __typename?: 'TenediPartnershipEntity', uuid: string, companyStandardCarrierAlphaCode?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination, send990InResponseTo204: boolean, send990InResponseTo211: boolean, autoAcceptOrders: boolean, edi214ShipmentStatuses: Array<Edi214ShipmentStatus>, canCreateMultipleStops: boolean, ignoreCancellations: boolean, allowEditingShipperBillOfLadingNumber: boolean, ignoreNonEdiOutbound: boolean, removeSpacesFrom214Bol: boolean, excludeZeroChargeInvoices: boolean, sendBackupDocs: boolean, alternateStediPartnerId?: string | null, enableStaging: boolean, useStediGenerateEdiFunction: boolean, stediPartnershipId?: string | null, stedi210MappingId?: string | null, stedi214MappingId?: string | null, stedi990MappingId?: string | null, stedi210TransactionSettingId?: string | null, stedi214TransactionSettingId?: string | null, stedi990TransactionSettingId?: string | null, updatedAt: any } } };

export type TenediConnectionCustomersQueryVariables = Exact<{
  input: TenediConnectionCustomersInput;
}>;


export type TenediConnectionCustomersQuery = { __typename?: 'Query', tenediConnectionCustomers: Array<{ __typename?: 'TenediConnectionCustomerOptionEntity', uuid: string, displayName: string, isActive: boolean, isaId?: string | null, partnershipCount: number }> };

export type TenediCarrierIdentityFieldsFragment = { __typename?: 'TenediCarrierIdentityEntity', uuid: string, name: string, isaId?: string | null, alternateIsaId?: string | null, secondAlternateIsaId?: string | null, thirdAlternateIsaId?: string | null, fourthAlternateIsaId?: string | null, standardCarrierAlphaCode?: string | null, alternateStandardCarrierAlphaCode?: string | null, secondAlternateScac?: string | null, thirdAlternateScac?: string | null, fourthAlternateScac?: string | null, stediPartnerId?: string | null, scacs: Array<string> };

export type TenediCustomerIdentityFieldsFragment = { __typename?: 'TenediCustomerIdentityEntity', uuid: string, displayName: string, isActive: boolean, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, standardCarrierAlphaCode?: string | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod };

export type TenediPartnershipFieldsFragment = { __typename?: 'TenediPartnershipEntity', uuid: string, companyStandardCarrierAlphaCode?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination, send990InResponseTo204: boolean, send990InResponseTo211: boolean, autoAcceptOrders: boolean, edi214ShipmentStatuses: Array<Edi214ShipmentStatus>, canCreateMultipleStops: boolean, ignoreCancellations: boolean, allowEditingShipperBillOfLadingNumber: boolean, ignoreNonEdiOutbound: boolean, removeSpacesFrom214Bol: boolean, excludeZeroChargeInvoices: boolean, sendBackupDocs: boolean, alternateStediPartnerId?: string | null, enableStaging: boolean, useStediGenerateEdiFunction: boolean, stediPartnershipId?: string | null, stedi210MappingId?: string | null, stedi214MappingId?: string | null, stedi990MappingId?: string | null, stedi210TransactionSettingId?: string | null, stedi214TransactionSettingId?: string | null, stedi990TransactionSettingId?: string | null, updatedAt: any };

export type TenediFieldChangeFieldsFragment = { __typename?: 'TenediFieldChangeEntity', field: string, before?: string | null, after?: string | null };

export type TenediConnectionQueryVariables = Exact<{
  input: TenediConnectionInput;
}>;


export type TenediConnectionQuery = { __typename?: 'Query', tenediConnection: { __typename?: 'TenediConnectionEntity', environment: string, production: boolean, ready: boolean, carrier: { __typename?: 'TenediCarrierIdentityEntity', uuid: string, name: string, isaId?: string | null, alternateIsaId?: string | null, secondAlternateIsaId?: string | null, thirdAlternateIsaId?: string | null, fourthAlternateIsaId?: string | null, standardCarrierAlphaCode?: string | null, alternateStandardCarrierAlphaCode?: string | null, secondAlternateScac?: string | null, thirdAlternateScac?: string | null, fourthAlternateScac?: string | null, stediPartnerId?: string | null, scacs: Array<string> }, customer: { __typename?: 'TenediCustomerIdentityEntity', uuid: string, displayName: string, isActive: boolean, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, standardCarrierAlphaCode?: string | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod }, partnerships: Array<{ __typename?: 'TenediPartnershipEntity', uuid: string, companyStandardCarrierAlphaCode?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination, send990InResponseTo204: boolean, send990InResponseTo211: boolean, autoAcceptOrders: boolean, edi214ShipmentStatuses: Array<Edi214ShipmentStatus>, canCreateMultipleStops: boolean, ignoreCancellations: boolean, allowEditingShipperBillOfLadingNumber: boolean, ignoreNonEdiOutbound: boolean, removeSpacesFrom214Bol: boolean, excludeZeroChargeInvoices: boolean, sendBackupDocs: boolean, alternateStediPartnerId?: string | null, enableStaging: boolean, useStediGenerateEdiFunction: boolean, stediPartnershipId?: string | null, stedi210MappingId?: string | null, stedi214MappingId?: string | null, stedi990MappingId?: string | null, stedi210TransactionSettingId?: string | null, stedi214TransactionSettingId?: string | null, stedi990TransactionSettingId?: string | null, updatedAt: any }>, readiness: Array<{ __typename?: 'TenediReadinessItemEntity', check: TenediReadinessCheck, status: TenediReadinessStatus, message: string, fixIn: TenediReadinessSection }> } };

export type UpdateTenediCarrierIdentityMutationVariables = Exact<{
  input: UpdateTenediCarrierIdentityInput;
}>;


export type UpdateTenediCarrierIdentityMutation = { __typename?: 'Mutation', updateTenediCarrierIdentity: { __typename?: 'TenediCarrierIdentitySaveResultEntity', changes: Array<{ __typename?: 'TenediFieldChangeEntity', field: string, before?: string | null, after?: string | null }>, carrier: { __typename?: 'TenediCarrierIdentityEntity', uuid: string, name: string, isaId?: string | null, alternateIsaId?: string | null, secondAlternateIsaId?: string | null, thirdAlternateIsaId?: string | null, fourthAlternateIsaId?: string | null, standardCarrierAlphaCode?: string | null, alternateStandardCarrierAlphaCode?: string | null, secondAlternateScac?: string | null, thirdAlternateScac?: string | null, fourthAlternateScac?: string | null, stediPartnerId?: string | null, scacs: Array<string> } } };

export type UpdateTenediCustomerIdentityMutationVariables = Exact<{
  input: UpdateTenediCustomerIdentityInput;
}>;


export type UpdateTenediCustomerIdentityMutation = { __typename?: 'Mutation', updateTenediCustomerIdentity: { __typename?: 'TenediCustomerIdentitySaveResultEntity', changes: Array<{ __typename?: 'TenediFieldChangeEntity', field: string, before?: string | null, after?: string | null }>, customer: { __typename?: 'TenediCustomerIdentityEntity', uuid: string, displayName: string, isActive: boolean, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, standardCarrierAlphaCode?: string | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod } } };

export type CreateTestApiOrderMutationVariables = Exact<{
  input: CreateTestApiOrderInput;
}>;


export type CreateTestApiOrderMutation = { __typename?: 'Mutation', createTestApiOrder: { __typename?: 'TestApiOrderResult', orderUuid?: string | null, orderName?: string | null, merged: boolean, mergedIntoOrderUuid?: string | null, mergedIntoOrderName?: string | null, message?: string | null, inboundApiRequestUuid: string } };

export type CreateTestEdiOrderMutationVariables = Exact<{
  input: CreateTestEdiOrderInput;
}>;


export type CreateTestEdiOrderMutation = { __typename?: 'Mutation', createTestEdiOrder: { __typename?: 'TestEdiOrderResult', ediTransactionId?: string | null, orderUuid?: string | null, orderName?: string | null, merged: boolean, mergedIntoOrderUuid?: string | null, mergedIntoOrderName?: string | null, message?: string | null, schemaWarning?: string | null } };

export type TestIntegrationOrderCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type TestIntegrationOrderCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'CompanyEntity', uuid: string, name: string }> };

export type TestIntegrationOrderContactsQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
}>;


export type TestIntegrationOrderContactsQuery = { __typename?: 'Query', companyContacts: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> };

export type UserSessionsAdminCompanyUsersQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
}>;


export type UserSessionsAdminCompanyUsersQuery = { __typename?: 'Query', userSessionsAdminCompanyUsers: { __typename?: 'UserSessionsAdminCompanyUsersResult', totalCount: number, hasMore: boolean, users: Array<{ __typename?: 'UserSessionsAdminUserEntity', uuid: string, email?: string | null, name?: string | null, isActive: boolean, canRevokeSessions: boolean }> } };

export type UserSessionsAdminRevokeSessionsMutationVariables = Exact<{
  input: RevokeCompanyUserSessionsInput;
}>;


export type UserSessionsAdminRevokeSessionsMutation = { __typename?: 'Mutation', userSessionsAdminRevokeSessions: { __typename?: 'RevokeCompanyUserSessionsResult', revokedCount: number, archivedCount: number, skippedNoEmailCount: number, failedCount: number, targetedUsers: Array<{ __typename?: 'UserSessionsAdminUserEntity', uuid: string, email?: string | null, name?: string | null, isActive: boolean, canRevokeSessions: boolean }> } };

export type UserSessionsAdminSearchCompaniesQueryVariables = Exact<{
  input: UserSessionsAdminCompanySearchInput;
}>;


export type UserSessionsAdminSearchCompaniesQuery = { __typename?: 'Query', userSessionsAdminSearchCompanies: Array<{ __typename?: 'UserSessionsAdminCompanyEntity', uuid: string, name: string, activeUserCount: number }> };

export type UserSessionsAdminUserFieldsFragment = { __typename?: 'UserSessionsAdminUserEntity', uuid: string, email?: string | null, name?: string | null, isActive: boolean, canRevokeSessions: boolean };

export const AddressFragmentDoc = gql`
    fragment Address on AddressEntity {
  uuid
  name
  line1
  line2
  city
  state
  zip
}
    `;
export const ApiLogEmailTransactionFragmentDoc = gql`
    fragment ApiLogEmailTransaction on EmailTransactionEntity {
  createdAt
  company {
    uuid
    name
    timeZone
  }
  contact {
    uuid
    displayName
  }
  document {
    uuid
    preSignedGetUrl
  }
  invoice {
    uuid
    name
  }
  emails
  emailResponse
  emailResponseStatus
}
    `;
export const ApiLogFragmentDoc = gql`
    fragment ApiLog on ApiLogEntity {
  uuid
  createdAt
  updatedAt
  responseStatus
  sourceIpAddress
  direction
  emailTransaction {
    ...ApiLogEmailTransaction
  }
}
    ${ApiLogEmailTransactionFragmentDoc}`;
export const CompanyContactFragmentDoc = gql`
    fragment CompanyContact on ContactEntity {
  displayName
  isActive
  shortCode
  type
  uuid
  contactReferenceNumber
  quickbooksMappingId
  quickbooksDesktopContactId
  quickbooksFileMappingFreightChargeName
  quickbooksFileMappingCustomerName
  quickbooksFileMappingFuelChargeName
  quickbooksFileMappingPickupChargeName
  freightChargeQuickbooksMappingId
  fuelChargeQuickbooksMappingId
  miscCustomChargeQuickbooksMappingId
  stediPartnerId
  billingCycleDuration
  services {
    uuid
    name
    markOrdersAsSpecial
    defaultAppointmentStartTime
    defaultAppointmentEndTime
  }
  ... on CustomerContactEntity {
    defaultUseTariff
    defaultInvoiceTransmissionMethod
    defaultInvoiceType
    defaultInvoiceDownloadDocuments
    defaultInvoiceDocumentsRequired
    stediPartnerId
    defaultDimFactor
    defaultFuelSurcharge
  }
}
    `;
export const ShallowContactFragmentDoc = gql`
    fragment ShallowContact on ContactEntity {
  displayName
  isActive
  shortCode
  uuid
  contactReferenceNumber
  quickbooksMappingId
  quickbooksDesktopContactId
  quickbooksFileMappingFreightChargeName
  quickbooksFileMappingCustomerName
  quickbooksFileMappingFuelChargeName
  quickbooksFileMappingPickupChargeName
  freightChargeQuickbooksMappingId
  fuelChargeQuickbooksMappingId
  miscCustomChargeQuickbooksMappingId
  stediPartnerId
  billingCycleDuration
  services {
    uuid
    name
    markOrdersAsSpecial
    defaultAppointmentStartTime
    defaultAppointmentEndTime
  }
  ... on CustomerContactEntity {
    defaultUseTariff
    defaultInvoiceTransmissionMethod
    defaultInvoiceType
    defaultInvoiceDownloadDocuments
    defaultInvoiceDocumentsRequired
    stediPartnerId
    defaultDimFactor
    defaultFuelSurcharge
    isPrepaidOnly
  }
}
    `;
export const FuelProfileFragmentDoc = gql`
    fragment FuelProfile on FuelProfileEntity {
  uuid
  name
}
    `;
export const ServiceFragmentDoc = gql`
    fragment Service on ServiceEntity {
  uuid
  name
  isActive
}
    `;
export const TariffZoneGroupFragmentDoc = gql`
    fragment TariffZoneGroup on TariffZoneGroupEntity {
  id
  name
}
    `;
export const VehicleTypeFragmentDoc = gql`
    fragment VehicleType on VehicleTypeEntity {
  uuid
  name
  status
}
    `;
export const EvalRunDocumentFieldsFragmentDoc = gql`
    fragment EvalRunDocumentFields on DocExtractionEvalRunDocumentEntity {
  evalRunId
  documentId
  companyUuid
  status
  errorKind
  errorDetail
  inputTokens
  outputTokens
  latencyMs
  costUsd
  extractedFields
  verdicts
  docScore
  runMeta
}
    `;
export const EvalRunFieldsFragmentDoc = gql`
    fragment EvalRunFields on DocExtractionEvalRunEntity {
  id
  evalSetId
  name
  status
  executionMode
  providerBatchId
  documentCount
  completedCount
  errorCount
  bundleHash
  actualInputTokens
  actualOutputTokens
  actualCostUsd
  cancelRequestedAt
  createdAt
  updatedAt
  config
  aggregates
  costEstimate
}
    `;
export const EvalSetFieldsFragmentDoc = gql`
    fragment EvalSetFields on DocExtractionEvalSetEntity {
  id
  name
  documentCount
  seed
  createdBy
  createdAt
  selectionConfig
  strataSummary
}
    `;
export const EdiTransactionFragmentFragmentDoc = gql`
    fragment EdiTransactionFragment on EdiTransactionEntity {
  uuid
  updatedAt
  status
  code
  message
  payload
  order {
    uuid
    name
    secondaryRefNumber
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
}
    `;
export const EdgeAnchorFragmentDoc = gql`
    fragment EdgeAnchor on EdgeAnchorEntity {
  uuid
  blockId
  edge
  left
  top
  height
  width
  text
}
    `;
export const FingerprintAnchorFragmentDoc = gql`
    fragment FingerprintAnchor on FingerprintAnchorEntity {
  blockId
  left
  top
  height
  width
  substring
  text
  required
}
    `;
export const MeCompanyConfigurationFragmentDoc = gql`
    fragment MeCompanyConfiguration on CompanyConfigurationEntity {
  uuid
  sameDayDispatchCellHeader
  sendSummaryEmailWithIncompleteRoutes
  startingInvoiceOrdinalNumber
  defaultFuelSurchargeBillingMethod
  defaultDimFactor
  defaultFuelSurcharge
  defaultFuelSettlementPercentageRate
  defaultRouteStartTime
  defaultRouteLoadTimeInMinutes
  defaultRouteUnloadTimeInMinutes
  defaultGenerateAppointmentDurationInMinutes
  defaultGenerateAppointmentEarlyCushionInMinutes
  enableConsolidatedOrders
  showChargesOnCustomerPortal
  textNextCustomerForAppointments
  invoicePdfLogoUrl
  reviewUrl
  showManuallyConfirmedByDefault
  allowDriverToSelectNextStop
  showHelpersColumnInDispatch
  showVehicleInDailyDispatch
  requireReviewForEdiOrderCreation
  autoApplyWaitTimeMinutes
  useJournalNumberForInvoice
  getDriverLocationDataFromMobile
  stampMobilePhotosWithTimeAndLocation
  mobilePollingIntervalInSeconds
  requireDriverToAcknowledgeRouteChange
  useDriverNumberForDispatch
  defaultToAccessorial
  enablePaymentMethod
  driversShouldMarkFreightAsLoaded
  allCapsInOrderPage
  orderNamingScheme
  companyOrdinalStart
  minDigitsInCompanyOrdinalOrderName
  restrictEditingOrderName
  showKilogramsAndCentimeters
  showDriverSettlementInBilling
  notificationsEnabled
  requireDimsToFinalizeCharges
  orderIdentifierForCoverSheet
  enableDigitalSignatureFlow
  requireDriverSignature
  useSeparateDigitalSignatureStep
  sendSignedPodEmailAfterLateSignature
  requireSignedPodToCompleteStop
  includeHyphensInInvoiceName
  includeINVInInvoiceName
  appointmentSchedulingSlotHours
  appointmentSchedulingLeadingBufferHours
  appointmentSchedulingCutoffDays
  appointmentChangeCutoffHours
  appointmentSelfRescheduleLimit
  requireOnHandBeforeSelfScheduling
  appointmentSchedulerModel
  createRecurringOrdersInAdvanceHours
  serviceLevelOptional
  addOrdersToOpenInvoices
  invoiceNotes
  defaultInvoiceDocumentsRequired
  autoMatchEodDocumentsToOrders
  requirePODPhotoAndName
  requirePODPhotoAndNameForPickups
  requirePODPhotoForPickups
  requireSigneeNameForPickups
  requirePODPhotoForDeliveries
  requireSigneeNameForDeliveries
  autoGroupStops
  requireDriverToConfirmStopCompletedAtTime
  packageWarehouseLocationsEnabled
  wmsEnabled
  wmsStorageOrdersEnabled
  wmsShortTermStorageEnabled
  wmsAutoMarkOnHand
  useHawbForLotLabelBarcode
  quoteContributionMarginalFromRatio
  quoteContributionProfitableFromRatio
  quoteAgentEnabled
  quoteAgentDefaultMode
  quoteAgentAutoSendMaxCents
  quoteAgentMinConfidence
  quoteAgentValidityHours
  quoteAgentDailyModelBudgetCents
  draftOrderCleanupDays
  draftOrderCleanupSources
  duplicateOrderMergeWindowHours
  defaultPalletLength
  defaultPalletWidth
  defaultPalletHeight
  lineHaulEnabled
  lineHaulBuildAheadDays
  lineHaulMobilePastWindowHours
  lineHaulMobileFutureWindowHours
  lineHaulPlanningEnabled
  driverComplianceExpiringSoonDays
  logisticsSectionEnabled
  fulfillmentTypeEnabled
  pointToPointTariffsEnabled
  recoveryTariffsEnabled
  showCompanyNameOnBillOfLadingDoc
  defaultStandardStopType
  orderLevelOsdEnabled
  markOnHandUponPickup
  showAccessorialsToDrivers
  pieceTransferableStatuses
  t2tDelegationEnabled
  t2tSyncEnabled
}
    `;
export const ImportedOrderTypeMappingFragmentDoc = gql`
    fragment ImportedOrderTypeMapping on ImportedOrderTypeMappingEntity {
  uuid
  moveType
  serviceLevel
  inboundStopType
  outboundStopType
  lineHaul
  defaultToInbound
  defaultToOutbound
}
    `;
export const MeCompanyFragmentDoc = gql`
    fragment MeCompany on CompanyEntity {
  uuid
  segment
  timeZone
  name
  configuration {
    ...MeCompanyConfiguration
  }
  orderImportConfiguration {
    uuid
    alwaysCreateDummyOrderCharge
    importedOrderTypeMappings {
      ...ImportedOrderTypeMapping
    }
  }
}
    ${MeCompanyConfigurationFragmentDoc}
${ImportedOrderTypeMappingFragmentDoc}`;
export const NotificationCutoverConfigFieldsFragmentDoc = gql`
    fragment NotificationCutoverConfigFields on NotificationCutoverConfigEntity {
  eventType
  mode
  fullEligible
  fullBlockedBy
  fullEligibleBecause
  requiredPartnerEvent
  shadowComparable
  engineOnlyChannels
  source
  metadata {
    description
    trigger
    emittedBy
    channels
    deliveryState
    deliveryStateReason
    engineTargets {
      target
      definition
      recipientKind
    }
    legacyTargets {
      target
      definition
      recipientKind
    }
    configuredIn {
      setting
      clickPath
    }
  }
}
    `;
export const PackageTableColumnFragmentDoc = gql`
    fragment PackageTableColumn on PackageTableColumnEntity {
  uuid
  columnIndex
  header
  packageField
  required
}
    `;
export const PieceBackfillRunFieldsFragmentDoc = gql`
    fragment PieceBackfillRunFields on PieceBackfillRunView {
  uuid
  companyUuid
  mode
  status
  packagesTotal
  packagesProcessed
  packagesSkipped
  piecesCreated
  piecesUpdated
  joinsCreated
  params
  report
  error
  requestedByEmail
  createdAt
  startedAt
  finishedAt
}
    `;
export const ExtractedFieldFragmentDoc = gql`
    fragment ExtractedField on ExtractedFieldEntity {
  field
  value
  uuid
}
    `;
export const FingerprintAnchorMatchFragmentDoc = gql`
    fragment FingerprintAnchorMatch on FingerprintAnchorMatchEntity {
  substring
  text
  uuid
}
    `;
export const TransformAnchorMatchFragmentDoc = gql`
    fragment TransformAnchorMatch on TransformAnchorMatchEntity {
  text
  uuid
}
    `;
export const SchemaRunFragmentDoc = gql`
    fragment SchemaRun on SchemaRunEntity {
  uuid
  bucket
  key
  extractedFields {
    ...ExtractedField
  }
  fingerprintAnchorMatches {
    ...FingerprintAnchorMatch
  }
  transformAnchorMatches {
    ...TransformAnchorMatch
  }
  schema {
    uuid
    name
  }
  schemaRunPages {
    bucket
    key
    extractedFields {
      ...ExtractedField
    }
    fingerprintAnchorMatches {
      ...FingerprintAnchorMatch
    }
    transformAnchorMatches {
      ...TransformAnchorMatch
    }
    page
    uuid
  }
  schemaRunTestStatus
  type
}
    ${ExtractedFieldFragmentDoc}
${FingerprintAnchorMatchFragmentDoc}
${TransformAnchorMatchFragmentDoc}`;
export const TerminalsFragmentDoc = gql`
    fragment Terminals on TerminalEntity {
  name
  code
  uuid
  isActive
  address {
    line1
    line2
    city
    state
    zip
    uuid
    name
  }
}
    `;
export const FindTestOrderFragmentDoc = gql`
    fragment FindTestOrder on TestOrderEntity {
  uuid
  totalCharge
  totalFreightCharge
  totalFuelCharge
  order {
    uuid
    customCharges {
      uuid
      name
      billingMethod
      accessorialTemplate {
        name
      }
    }
  }
  testOrderCustomCharges {
    uuid
    customCharge {
      uuid
      name
      billingMethod
      accessorialTemplate {
        name
      }
    }
    total
  }
}
    `;
export const TestOrderFragmentDoc = gql`
    fragment TestOrder on TestOrderEntity {
  uuid
  totalCharge
  totalFreightCharge
  totalFuelCharge
  order {
    uuid
    company {
      uuid
      name
    }
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
}
    `;
export const TransformAnchorFragmentDoc = gql`
    fragment TransformAnchor on TransformAnchorEntity {
  blockId
  left
  top
  height
  width
  text
}
    `;
export const MeRolePermissionFragmentDoc = gql`
    fragment MeRolePermission on PermissionEntity {
  permissionResource
  accessLevel
}
    `;
export const MeRoleFragmentDoc = gql`
    fragment MeRole on RoleEntity {
  uuid
  name
  permissions {
    ...MeRolePermission
  }
}
    ${MeRolePermissionFragmentDoc}`;
export const ApiKeyAdminListItemFieldsFragmentDoc = gql`
    fragment ApiKeyAdminListItemFields on ApiKeyAdminListItemEntity {
  uuid
  name
  webhookUrl
  enableStaging
  webhookAuthHeaderName
  payloadShapes
  idFormat
  customMapping
  emitTerminalHandoffEvents
  orgCount
  createdAt
  updatedAt
}
    `;
export const ApiKeyAdminStatusMappingFieldsFragmentDoc = gql`
    fragment ApiKeyAdminStatusMappingFields on ApiKeyAdminStatusMappingEntity {
  category
  internalName
  externalName
}
    `;
export const ApiKeyAdminFieldsFragmentDoc = gql`
    fragment ApiKeyAdminFields on ApiKeyAdminEntity {
  uuid
  name
  apiKey
  webhookUrl
  enableStaging
  webhookAuthHeaderName
  webhookAuthHeaderValue
  payloadShapes
  eventTypes
  idFormat
  customMapping
  emitTerminalHandoffEvents
  sendCompanyLocalTimestamps
  webhookTimestampMode
  orgCount
  createdAt
  updatedAt
}
    `;
export const ApiKeyAdminLinkedOrgFieldsFragmentDoc = gql`
    fragment ApiKeyAdminLinkedOrgFields on ApiKeyAdminLinkedOrgEntity {
  organizationUuid
  organizationDisplayName
  companyUuid
  companyName
}
    `;
export const ApiKeyAdminDetailFieldsFragmentDoc = gql`
    fragment ApiKeyAdminDetailFields on ApiKeyAdminDetailEntity {
  apiKey {
    ...ApiKeyAdminFields
  }
  linkedOrgs {
    ...ApiKeyAdminLinkedOrgFields
  }
}
    ${ApiKeyAdminFieldsFragmentDoc}
${ApiKeyAdminLinkedOrgFieldsFragmentDoc}`;
export const ApiKeyAdminCsvImportRowFieldsFragmentDoc = gql`
    fragment ApiKeyAdminCsvImportRowFields on ApiKeyAdminCsvImportOrgRow {
  rowNumber
  companyName
  organizationDisplayName
  outcome
  message
}
    `;
export const ApiKeyAdminCsvImportReportFieldsFragmentDoc = gql`
    fragment ApiKeyAdminCsvImportReportFields on ApiKeyAdminCsvImportReport {
  keyName
  apiKey
  keyOutcome
  keyMessage
  orgsToLink
  applied
  orgRows {
    ...ApiKeyAdminCsvImportRowFields
  }
}
    ${ApiKeyAdminCsvImportRowFieldsFragmentDoc}`;
export const DocumentationAdminItemFieldsFragmentDoc = gql`
    fragment DocumentationAdminItemFields on DocumentationItemEntity {
  uuid
  topicUuid
  title
  slug
  code
  status
  publishedAt
  sortOrder
  htmlSizeBytes
  updatedAt
}
    `;
export const DocumentationAdminItemSummaryFieldsFragmentDoc = gql`
    fragment DocumentationAdminItemSummaryFields on DocumentationItemSummaryEntity {
  uuid
  topicUuid
  title
  slug
  code
  status
  publishedAt
  sortOrder
  htmlSizeBytes
  updatedAt
}
    `;
export const DocumentationAdminTopicFieldsFragmentDoc = gql`
    fragment DocumentationAdminTopicFields on DocumentationTopicEntity {
  uuid
  title
  description
  sortOrder
  items {
    ...DocumentationAdminItemSummaryFields
  }
}
    ${DocumentationAdminItemSummaryFieldsFragmentDoc}`;
export const OrganizationMessageFieldsFragmentDoc = gql`
    fragment OrganizationMessageFields on OrganizationMessageEntity {
  uuid
  allCompanies
  companies {
    uuid
    name
  }
  severity
  status
  title
  body
  linkType
  linkTarget
  linkLabel
  startsAt
  publishedAt
  expiresAt
  usesDefaultExpiry
  resolvedAt
  withdrawnAt
  followsMessageUuid
  createdAt
}
    `;
export const BenchStepFieldsFragmentDoc = gql`
    fragment BenchStepFields on BenchPlannedStepEntity {
  kind
  stopRole
  stopUuid
  manifestUuid
  state
  reason
  expected214Statuses
  expects990
  expects210
  refusedInProduction
  sideEffects {
    kind
    detail
    suppressedBy
  }
}
    `;
export const BenchEdiTransactionFieldsFragmentDoc = gql`
    fragment BenchEdiTransactionFields on BenchEdiTransactionEntity {
  uuid
  createdAt
  transactionSet
  status
  message
  edi214ShipmentStatus
  edi990ActionCode
  receiverIsaId
  tenediMessageId
  tenediRunIds
}
    `;
export const BenchOrderReportFieldsFragmentDoc = gql`
    fragment BenchOrderReportFields on BenchOrderReportEntity {
  orderUuid
  orderName
  hawb
  companyName
  billingContactName
  refusals
  steps {
    ...BenchStepFields
  }
  nextStep {
    ...BenchStepFields
  }
  lastResult {
    kind
    stopRole
    outcome
    message
    startedAt
  }
  ediTransactions {
    ...BenchEdiTransactionFields
  }
}
    ${BenchStepFieldsFragmentDoc}
${BenchEdiTransactionFieldsFragmentDoc}`;
export const BenchRunReportFieldsFragmentDoc = gql`
    fragment BenchRunReportFields on BenchRunReportEntity {
  environment
  production
  integrationType
  orders {
    ...BenchOrderReportFields
  }
}
    ${BenchOrderReportFieldsFragmentDoc}`;
export const SmsConsentAdminFieldsFragmentDoc = gql`
    fragment SmsConsentAdminFields on SmsConsentAdminEntity {
  uuid
  maskedPhoneNumber
  status
  basis
  createdAt
  optedInAt
  revokedAt
  landline
  lineTypeCheckedAt
  consecutiveFailures
  lastFailureCode
  lastFailureAt
  undeliverableUntil
  historyTruncated
  events {
    uuid
    action
    occurredAt
  }
}
    `;
export const TenediCarrierIdentityFieldsFragmentDoc = gql`
    fragment TenediCarrierIdentityFields on TenediCarrierIdentityEntity {
  uuid
  name
  isaId
  alternateIsaId
  secondAlternateIsaId
  thirdAlternateIsaId
  fourthAlternateIsaId
  standardCarrierAlphaCode
  alternateStandardCarrierAlphaCode
  secondAlternateScac
  thirdAlternateScac
  fourthAlternateScac
  stediPartnerId
  scacs
}
    `;
export const TenediCustomerIdentityFieldsFragmentDoc = gql`
    fragment TenediCustomerIdentityFields on TenediCustomerIdentityEntity {
  uuid
  displayName
  isActive
  isaId
  ediApplicationId
  ediContactCode
  stediPartnerId
  standardCarrierAlphaCode
  defaultInvoiceTransmissionMethod
}
    `;
export const TenediPartnershipFieldsFragmentDoc = gql`
    fragment TenediPartnershipFields on TenediPartnershipEntity {
  uuid
  companyStandardCarrierAlphaCode
  ediOutboundPayloadDestination
  send990InResponseTo204
  send990InResponseTo211
  autoAcceptOrders
  edi214ShipmentStatuses
  canCreateMultipleStops
  ignoreCancellations
  allowEditingShipperBillOfLadingNumber
  ignoreNonEdiOutbound
  removeSpacesFrom214Bol
  excludeZeroChargeInvoices
  sendBackupDocs
  alternateStediPartnerId
  enableStaging
  useStediGenerateEdiFunction
  stediPartnershipId
  stedi210MappingId
  stedi214MappingId
  stedi990MappingId
  stedi210TransactionSettingId
  stedi214TransactionSettingId
  stedi990TransactionSettingId
  updatedAt
}
    `;
export const TenediFieldChangeFieldsFragmentDoc = gql`
    fragment TenediFieldChangeFields on TenediFieldChangeEntity {
  field
  before
  after
}
    `;
export const UserSessionsAdminUserFieldsFragmentDoc = gql`
    fragment UserSessionsAdminUserFields on UserSessionsAdminUserEntity {
  uuid
  email
  name
  isActive
  canRevokeSessions
}
    `;
export const CompanyAccountTypesDocument = gql`
    query CompanyAccountTypes {
  companies {
    uuid
    name
    accountType
  }
}
    `;

/**
 * __useCompanyAccountTypesQuery__
 *
 * To run a query within a React component, call `useCompanyAccountTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAccountTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAccountTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyAccountTypesQuery(baseOptions?: Apollo.QueryHookOptions<CompanyAccountTypesQuery, CompanyAccountTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAccountTypesQuery, CompanyAccountTypesQueryVariables>(CompanyAccountTypesDocument, options);
      }
export function useCompanyAccountTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAccountTypesQuery, CompanyAccountTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAccountTypesQuery, CompanyAccountTypesQueryVariables>(CompanyAccountTypesDocument, options);
        }
export function useCompanyAccountTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyAccountTypesQuery, CompanyAccountTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyAccountTypesQuery, CompanyAccountTypesQueryVariables>(CompanyAccountTypesDocument, options);
        }
export type CompanyAccountTypesQueryHookResult = ReturnType<typeof useCompanyAccountTypesQuery>;
export type CompanyAccountTypesLazyQueryHookResult = ReturnType<typeof useCompanyAccountTypesLazyQuery>;
export type CompanyAccountTypesSuspenseQueryHookResult = ReturnType<typeof useCompanyAccountTypesSuspenseQuery>;
export type CompanyAccountTypesQueryResult = Apollo.QueryResult<CompanyAccountTypesQuery, CompanyAccountTypesQueryVariables>;
export const SetCompanyAccountTypeDocument = gql`
    mutation SetCompanyAccountType($input: SetCompanyAccountTypeInput!) {
  setCompanyAccountType(input: $input) {
    uuid
    accountType
  }
}
    `;
export type SetCompanyAccountTypeMutationFn = Apollo.MutationFunction<SetCompanyAccountTypeMutation, SetCompanyAccountTypeMutationVariables>;

/**
 * __useSetCompanyAccountTypeMutation__
 *
 * To run a mutation, you first call `useSetCompanyAccountTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCompanyAccountTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCompanyAccountTypeMutation, { data, loading, error }] = useSetCompanyAccountTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCompanyAccountTypeMutation(baseOptions?: Apollo.MutationHookOptions<SetCompanyAccountTypeMutation, SetCompanyAccountTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCompanyAccountTypeMutation, SetCompanyAccountTypeMutationVariables>(SetCompanyAccountTypeDocument, options);
      }
export type SetCompanyAccountTypeMutationHookResult = ReturnType<typeof useSetCompanyAccountTypeMutation>;
export type SetCompanyAccountTypeMutationResult = Apollo.MutationResult<SetCompanyAccountTypeMutation>;
export type SetCompanyAccountTypeMutationOptions = Apollo.BaseMutationOptions<SetCompanyAccountTypeMutation, SetCompanyAccountTypeMutationVariables>;
export const ScannedOrderResultAdminDetailDocument = gql`
    query ScannedOrderResultAdminDetail($uuid: String!) {
  scannedOrderResultForAdmin(uuid: $uuid) {
    uuid
    createdAt
    status
    failureReason
    pageStart
    pageEnd
    preSignedGetUrl
    applyPlan {
      billingParty {
        mechanism
        contactUuid
        senderVerdict
      }
      service {
        mechanism
        serviceId
      }
      deadlineType {
        mechanism
        value
      }
      duplicate {
        isDuplicate
        duplicateOrderUuid
        wouldAdoptOrphanUuid
      }
    }
    extractionDetail {
      extractedFields
      usage
      exemplarMarker
      correlationId
      pipelineVersion
      taxonomyVersion
    }
    exemplars {
      documentId
      documentType
      source
      cosineSimilarity
      rank
      preSignedGetUrl
    }
    company {
      uuid
      name
    }
    scannedOrder {
      createdAt
      source
      documentIngestionPipeline
      ingestedOutlookEmailDetails {
        receivedAt
        subject
        fromAddress
      }
    }
    order {
      uuid
    }
  }
}
    `;

/**
 * __useScannedOrderResultAdminDetailQuery__
 *
 * To run a query within a React component, call `useScannedOrderResultAdminDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useScannedOrderResultAdminDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScannedOrderResultAdminDetailQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useScannedOrderResultAdminDetailQuery(baseOptions: Apollo.QueryHookOptions<ScannedOrderResultAdminDetailQuery, ScannedOrderResultAdminDetailQueryVariables> & ({ variables: ScannedOrderResultAdminDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScannedOrderResultAdminDetailQuery, ScannedOrderResultAdminDetailQueryVariables>(ScannedOrderResultAdminDetailDocument, options);
      }
export function useScannedOrderResultAdminDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScannedOrderResultAdminDetailQuery, ScannedOrderResultAdminDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScannedOrderResultAdminDetailQuery, ScannedOrderResultAdminDetailQueryVariables>(ScannedOrderResultAdminDetailDocument, options);
        }
export function useScannedOrderResultAdminDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScannedOrderResultAdminDetailQuery, ScannedOrderResultAdminDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScannedOrderResultAdminDetailQuery, ScannedOrderResultAdminDetailQueryVariables>(ScannedOrderResultAdminDetailDocument, options);
        }
export type ScannedOrderResultAdminDetailQueryHookResult = ReturnType<typeof useScannedOrderResultAdminDetailQuery>;
export type ScannedOrderResultAdminDetailLazyQueryHookResult = ReturnType<typeof useScannedOrderResultAdminDetailLazyQuery>;
export type ScannedOrderResultAdminDetailSuspenseQueryHookResult = ReturnType<typeof useScannedOrderResultAdminDetailSuspenseQuery>;
export type ScannedOrderResultAdminDetailQueryResult = Apollo.QueryResult<ScannedOrderResultAdminDetailQuery, ScannedOrderResultAdminDetailQueryVariables>;
export const ScannedOrderResultsForLogsDocument = gql`
    query scannedOrderResultsForLogs($args: GetScannedOrderResultsForAdminArgs!) {
  scannedOrderResultsForAdmin(args: $args) {
    edges {
      node {
        uuid
        createdAt
        schemaUuid
        status
        failureReason
        preSignedGetUrl
        company {
          name
        }
        scannedOrder {
          source
          documentIngestionPipeline
          ingestedOutlookEmailDetails {
            receivedAt
            subject
            fromAddress
          }
        }
        order {
          uuid
          billingPartyContact {
            displayName
          }
          standardOrderFields {
            shipperBillOfLadingNumber
          }
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

/**
 * __useScannedOrderResultsForLogsQuery__
 *
 * To run a query within a React component, call `useScannedOrderResultsForLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScannedOrderResultsForLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScannedOrderResultsForLogsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useScannedOrderResultsForLogsQuery(baseOptions: Apollo.QueryHookOptions<ScannedOrderResultsForLogsQuery, ScannedOrderResultsForLogsQueryVariables> & ({ variables: ScannedOrderResultsForLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScannedOrderResultsForLogsQuery, ScannedOrderResultsForLogsQueryVariables>(ScannedOrderResultsForLogsDocument, options);
      }
export function useScannedOrderResultsForLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScannedOrderResultsForLogsQuery, ScannedOrderResultsForLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScannedOrderResultsForLogsQuery, ScannedOrderResultsForLogsQueryVariables>(ScannedOrderResultsForLogsDocument, options);
        }
export function useScannedOrderResultsForLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScannedOrderResultsForLogsQuery, ScannedOrderResultsForLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScannedOrderResultsForLogsQuery, ScannedOrderResultsForLogsQueryVariables>(ScannedOrderResultsForLogsDocument, options);
        }
export type ScannedOrderResultsForLogsQueryHookResult = ReturnType<typeof useScannedOrderResultsForLogsQuery>;
export type ScannedOrderResultsForLogsLazyQueryHookResult = ReturnType<typeof useScannedOrderResultsForLogsLazyQuery>;
export type ScannedOrderResultsForLogsSuspenseQueryHookResult = ReturnType<typeof useScannedOrderResultsForLogsSuspenseQuery>;
export type ScannedOrderResultsForLogsQueryResult = Apollo.QueryResult<ScannedOrderResultsForLogsQuery, ScannedOrderResultsForLogsQueryVariables>;
export const CreateOutlookIntegrationDocument = gql`
    mutation createOutlookIntegration($outlookIntegrationCreateInput: OutlookIntegrationCreateInput!) {
  createOutlookIntegration(
    outlookIntegrationCreateInput: $outlookIntegrationCreateInput
  ) {
    uuid
  }
}
    `;
export type CreateOutlookIntegrationMutationFn = Apollo.MutationFunction<CreateOutlookIntegrationMutation, CreateOutlookIntegrationMutationVariables>;

/**
 * __useCreateOutlookIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateOutlookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOutlookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOutlookIntegrationMutation, { data, loading, error }] = useCreateOutlookIntegrationMutation({
 *   variables: {
 *      outlookIntegrationCreateInput: // value for 'outlookIntegrationCreateInput'
 *   },
 * });
 */
export function useCreateOutlookIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOutlookIntegrationMutation, CreateOutlookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOutlookIntegrationMutation, CreateOutlookIntegrationMutationVariables>(CreateOutlookIntegrationDocument, options);
      }
export type CreateOutlookIntegrationMutationHookResult = ReturnType<typeof useCreateOutlookIntegrationMutation>;
export type CreateOutlookIntegrationMutationResult = Apollo.MutationResult<CreateOutlookIntegrationMutation>;
export type CreateOutlookIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateOutlookIntegrationMutation, CreateOutlookIntegrationMutationVariables>;
export const OutlookIntegrationsForInternalDocument = gql`
    query outlookIntegrationsForInternal($getOutlookIntegrationsForInternalInput: GetOutlookIntegrationsForInternalInput!) {
  outlookIntegrationsForInternal(
    getOutlookIntegrationsForInternalInput: $getOutlookIntegrationsForInternalInput
  ) {
    uuid
    createdAt
    terminal {
      uuid
      name
    }
    company {
      uuid
      name
    }
    user {
      uuid
      name
    }
    entraTenantId
    entraUserId
    emailCreatedAtStartDate
    outboundEmailDomains
  }
}
    `;

/**
 * __useOutlookIntegrationsForInternalQuery__
 *
 * To run a query within a React component, call `useOutlookIntegrationsForInternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutlookIntegrationsForInternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutlookIntegrationsForInternalQuery({
 *   variables: {
 *      getOutlookIntegrationsForInternalInput: // value for 'getOutlookIntegrationsForInternalInput'
 *   },
 * });
 */
export function useOutlookIntegrationsForInternalQuery(baseOptions: Apollo.QueryHookOptions<OutlookIntegrationsForInternalQuery, OutlookIntegrationsForInternalQueryVariables> & ({ variables: OutlookIntegrationsForInternalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutlookIntegrationsForInternalQuery, OutlookIntegrationsForInternalQueryVariables>(OutlookIntegrationsForInternalDocument, options);
      }
export function useOutlookIntegrationsForInternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutlookIntegrationsForInternalQuery, OutlookIntegrationsForInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutlookIntegrationsForInternalQuery, OutlookIntegrationsForInternalQueryVariables>(OutlookIntegrationsForInternalDocument, options);
        }
export function useOutlookIntegrationsForInternalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutlookIntegrationsForInternalQuery, OutlookIntegrationsForInternalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutlookIntegrationsForInternalQuery, OutlookIntegrationsForInternalQueryVariables>(OutlookIntegrationsForInternalDocument, options);
        }
export type OutlookIntegrationsForInternalQueryHookResult = ReturnType<typeof useOutlookIntegrationsForInternalQuery>;
export type OutlookIntegrationsForInternalLazyQueryHookResult = ReturnType<typeof useOutlookIntegrationsForInternalLazyQuery>;
export type OutlookIntegrationsForInternalSuspenseQueryHookResult = ReturnType<typeof useOutlookIntegrationsForInternalSuspenseQuery>;
export type OutlookIntegrationsForInternalQueryResult = Apollo.QueryResult<OutlookIntegrationsForInternalQuery, OutlookIntegrationsForInternalQueryVariables>;
export const UpdateOutlookIntegrationDocument = gql`
    mutation updateOutlookIntegration($outlookIntegrationUpdateInput: OutlookIntegrationUpdateInput!) {
  updateOutlookIntegration(
    outlookIntegrationUpdateInput: $outlookIntegrationUpdateInput
  ) {
    uuid
  }
}
    `;
export type UpdateOutlookIntegrationMutationFn = Apollo.MutationFunction<UpdateOutlookIntegrationMutation, UpdateOutlookIntegrationMutationVariables>;

/**
 * __useUpdateOutlookIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateOutlookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOutlookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOutlookIntegrationMutation, { data, loading, error }] = useUpdateOutlookIntegrationMutation({
 *   variables: {
 *      outlookIntegrationUpdateInput: // value for 'outlookIntegrationUpdateInput'
 *   },
 * });
 */
export function useUpdateOutlookIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOutlookIntegrationMutation, UpdateOutlookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOutlookIntegrationMutation, UpdateOutlookIntegrationMutationVariables>(UpdateOutlookIntegrationDocument, options);
      }
export type UpdateOutlookIntegrationMutationHookResult = ReturnType<typeof useUpdateOutlookIntegrationMutation>;
export type UpdateOutlookIntegrationMutationResult = Apollo.MutationResult<UpdateOutlookIntegrationMutation>;
export type UpdateOutlookIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateOutlookIntegrationMutation, UpdateOutlookIntegrationMutationVariables>;
export const CompanyDocument = gql`
    query company($uuid: String!) {
  companyByUuid(uuid: $uuid) {
    id
    uuid
    name
    createdAt
    configuration {
      invoicePdfLogoUrl
    }
    defaultAddress {
      city
      state
    }
  }
}
    `;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables> & ({ variables: CompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export function useCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanySuspenseQueryHookResult = ReturnType<typeof useCompanySuspenseQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const DocScanVolumeByPipelineReportDocument = gql`
    query docScanVolumeByPipelineReport($docScanVolumeByPipelineInput: DocScanVolumeByPipelineInput!) {
  docScanVolumeByPipelineReport(
    docScanVolumeByPipelineInput: $docScanVolumeByPipelineInput
  ) {
    startDate
    endDate
    pipeline
    totalCount
  }
}
    `;

/**
 * __useDocScanVolumeByPipelineReportQuery__
 *
 * To run a query within a React component, call `useDocScanVolumeByPipelineReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocScanVolumeByPipelineReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocScanVolumeByPipelineReportQuery({
 *   variables: {
 *      docScanVolumeByPipelineInput: // value for 'docScanVolumeByPipelineInput'
 *   },
 * });
 */
export function useDocScanVolumeByPipelineReportQuery(baseOptions: Apollo.QueryHookOptions<DocScanVolumeByPipelineReportQuery, DocScanVolumeByPipelineReportQueryVariables> & ({ variables: DocScanVolumeByPipelineReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocScanVolumeByPipelineReportQuery, DocScanVolumeByPipelineReportQueryVariables>(DocScanVolumeByPipelineReportDocument, options);
      }
export function useDocScanVolumeByPipelineReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocScanVolumeByPipelineReportQuery, DocScanVolumeByPipelineReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocScanVolumeByPipelineReportQuery, DocScanVolumeByPipelineReportQueryVariables>(DocScanVolumeByPipelineReportDocument, options);
        }
export function useDocScanVolumeByPipelineReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocScanVolumeByPipelineReportQuery, DocScanVolumeByPipelineReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocScanVolumeByPipelineReportQuery, DocScanVolumeByPipelineReportQueryVariables>(DocScanVolumeByPipelineReportDocument, options);
        }
export type DocScanVolumeByPipelineReportQueryHookResult = ReturnType<typeof useDocScanVolumeByPipelineReportQuery>;
export type DocScanVolumeByPipelineReportLazyQueryHookResult = ReturnType<typeof useDocScanVolumeByPipelineReportLazyQuery>;
export type DocScanVolumeByPipelineReportSuspenseQueryHookResult = ReturnType<typeof useDocScanVolumeByPipelineReportSuspenseQuery>;
export type DocScanVolumeByPipelineReportQueryResult = Apollo.QueryResult<DocScanVolumeByPipelineReportQuery, DocScanVolumeByPipelineReportQueryVariables>;
export const OrderVolumeByCompanyReportDocument = gql`
    query orderVolumeByCompanyReport($orderVolumeByCompanyInput: OrderVolumeByCompanyInput!) {
  orderVolumeByCompanyReport(
    orderVolumeByCompanyInput: $orderVolumeByCompanyInput
  ) {
    companyUuid
    companyName
    sourceAmounts {
      source
      scannedOrderSource
      totalCount
    }
  }
}
    `;

/**
 * __useOrderVolumeByCompanyReportQuery__
 *
 * To run a query within a React component, call `useOrderVolumeByCompanyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderVolumeByCompanyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderVolumeByCompanyReportQuery({
 *   variables: {
 *      orderVolumeByCompanyInput: // value for 'orderVolumeByCompanyInput'
 *   },
 * });
 */
export function useOrderVolumeByCompanyReportQuery(baseOptions: Apollo.QueryHookOptions<OrderVolumeByCompanyReportQuery, OrderVolumeByCompanyReportQueryVariables> & ({ variables: OrderVolumeByCompanyReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderVolumeByCompanyReportQuery, OrderVolumeByCompanyReportQueryVariables>(OrderVolumeByCompanyReportDocument, options);
      }
export function useOrderVolumeByCompanyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderVolumeByCompanyReportQuery, OrderVolumeByCompanyReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderVolumeByCompanyReportQuery, OrderVolumeByCompanyReportQueryVariables>(OrderVolumeByCompanyReportDocument, options);
        }
export function useOrderVolumeByCompanyReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderVolumeByCompanyReportQuery, OrderVolumeByCompanyReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderVolumeByCompanyReportQuery, OrderVolumeByCompanyReportQueryVariables>(OrderVolumeByCompanyReportDocument, options);
        }
export type OrderVolumeByCompanyReportQueryHookResult = ReturnType<typeof useOrderVolumeByCompanyReportQuery>;
export type OrderVolumeByCompanyReportLazyQueryHookResult = ReturnType<typeof useOrderVolumeByCompanyReportLazyQuery>;
export type OrderVolumeByCompanyReportSuspenseQueryHookResult = ReturnType<typeof useOrderVolumeByCompanyReportSuspenseQuery>;
export type OrderVolumeByCompanyReportQueryResult = Apollo.QueryResult<OrderVolumeByCompanyReportQuery, OrderVolumeByCompanyReportQueryVariables>;
export const OrderVolumeByContactReportDocument = gql`
    query orderVolumeByContactReport($orderVolumeByContactInput: OrderVolumeByContactInput!) {
  orderVolumeByContactReport(
    orderVolumeByContactInput: $orderVolumeByContactInput
  ) {
    contactUuid
    contactName
    sourceAmounts {
      source
      scannedOrderSource
      totalCount
    }
  }
}
    `;

/**
 * __useOrderVolumeByContactReportQuery__
 *
 * To run a query within a React component, call `useOrderVolumeByContactReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderVolumeByContactReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderVolumeByContactReportQuery({
 *   variables: {
 *      orderVolumeByContactInput: // value for 'orderVolumeByContactInput'
 *   },
 * });
 */
export function useOrderVolumeByContactReportQuery(baseOptions: Apollo.QueryHookOptions<OrderVolumeByContactReportQuery, OrderVolumeByContactReportQueryVariables> & ({ variables: OrderVolumeByContactReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderVolumeByContactReportQuery, OrderVolumeByContactReportQueryVariables>(OrderVolumeByContactReportDocument, options);
      }
export function useOrderVolumeByContactReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderVolumeByContactReportQuery, OrderVolumeByContactReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderVolumeByContactReportQuery, OrderVolumeByContactReportQueryVariables>(OrderVolumeByContactReportDocument, options);
        }
export function useOrderVolumeByContactReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderVolumeByContactReportQuery, OrderVolumeByContactReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderVolumeByContactReportQuery, OrderVolumeByContactReportQueryVariables>(OrderVolumeByContactReportDocument, options);
        }
export type OrderVolumeByContactReportQueryHookResult = ReturnType<typeof useOrderVolumeByContactReportQuery>;
export type OrderVolumeByContactReportLazyQueryHookResult = ReturnType<typeof useOrderVolumeByContactReportLazyQuery>;
export type OrderVolumeByContactReportSuspenseQueryHookResult = ReturnType<typeof useOrderVolumeByContactReportSuspenseQuery>;
export type OrderVolumeByContactReportQueryResult = Apollo.QueryResult<OrderVolumeByContactReportQuery, OrderVolumeByContactReportQueryVariables>;
export const OrderVolumeByDateRangeReportDocument = gql`
    query orderVolumeByDateRangeReport($orderVolumeByDateRangeInput: OrderVolumeByDateRangeInput!) {
  orderVolumeByDateRangeReport(
    orderVolumeByDateRangeInput: $orderVolumeByDateRangeInput
  ) {
    startDate
    endDate
    sourceAmounts {
      source
      scannedOrderSource
      totalCount
    }
  }
}
    `;

/**
 * __useOrderVolumeByDateRangeReportQuery__
 *
 * To run a query within a React component, call `useOrderVolumeByDateRangeReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderVolumeByDateRangeReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderVolumeByDateRangeReportQuery({
 *   variables: {
 *      orderVolumeByDateRangeInput: // value for 'orderVolumeByDateRangeInput'
 *   },
 * });
 */
export function useOrderVolumeByDateRangeReportQuery(baseOptions: Apollo.QueryHookOptions<OrderVolumeByDateRangeReportQuery, OrderVolumeByDateRangeReportQueryVariables> & ({ variables: OrderVolumeByDateRangeReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderVolumeByDateRangeReportQuery, OrderVolumeByDateRangeReportQueryVariables>(OrderVolumeByDateRangeReportDocument, options);
      }
export function useOrderVolumeByDateRangeReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderVolumeByDateRangeReportQuery, OrderVolumeByDateRangeReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderVolumeByDateRangeReportQuery, OrderVolumeByDateRangeReportQueryVariables>(OrderVolumeByDateRangeReportDocument, options);
        }
export function useOrderVolumeByDateRangeReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderVolumeByDateRangeReportQuery, OrderVolumeByDateRangeReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderVolumeByDateRangeReportQuery, OrderVolumeByDateRangeReportQueryVariables>(OrderVolumeByDateRangeReportDocument, options);
        }
export type OrderVolumeByDateRangeReportQueryHookResult = ReturnType<typeof useOrderVolumeByDateRangeReportQuery>;
export type OrderVolumeByDateRangeReportLazyQueryHookResult = ReturnType<typeof useOrderVolumeByDateRangeReportLazyQuery>;
export type OrderVolumeByDateRangeReportSuspenseQueryHookResult = ReturnType<typeof useOrderVolumeByDateRangeReportSuspenseQuery>;
export type OrderVolumeByDateRangeReportQueryResult = Apollo.QueryResult<OrderVolumeByDateRangeReportQuery, OrderVolumeByDateRangeReportQueryVariables>;
export const OrderVolumeBySchemaReportDocument = gql`
    query orderVolumeBySchemaReport($orderVolumeBySchemaInput: OrderVolumeBySchemaInput!) {
  orderVolumeBySchemaReport(orderVolumeBySchemaInput: $orderVolumeBySchemaInput) {
    schemaUuid
    schemaName
    total
  }
}
    `;

/**
 * __useOrderVolumeBySchemaReportQuery__
 *
 * To run a query within a React component, call `useOrderVolumeBySchemaReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderVolumeBySchemaReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderVolumeBySchemaReportQuery({
 *   variables: {
 *      orderVolumeBySchemaInput: // value for 'orderVolumeBySchemaInput'
 *   },
 * });
 */
export function useOrderVolumeBySchemaReportQuery(baseOptions: Apollo.QueryHookOptions<OrderVolumeBySchemaReportQuery, OrderVolumeBySchemaReportQueryVariables> & ({ variables: OrderVolumeBySchemaReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderVolumeBySchemaReportQuery, OrderVolumeBySchemaReportQueryVariables>(OrderVolumeBySchemaReportDocument, options);
      }
export function useOrderVolumeBySchemaReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderVolumeBySchemaReportQuery, OrderVolumeBySchemaReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderVolumeBySchemaReportQuery, OrderVolumeBySchemaReportQueryVariables>(OrderVolumeBySchemaReportDocument, options);
        }
export function useOrderVolumeBySchemaReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderVolumeBySchemaReportQuery, OrderVolumeBySchemaReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderVolumeBySchemaReportQuery, OrderVolumeBySchemaReportQueryVariables>(OrderVolumeBySchemaReportDocument, options);
        }
export type OrderVolumeBySchemaReportQueryHookResult = ReturnType<typeof useOrderVolumeBySchemaReportQuery>;
export type OrderVolumeBySchemaReportLazyQueryHookResult = ReturnType<typeof useOrderVolumeBySchemaReportLazyQuery>;
export type OrderVolumeBySchemaReportSuspenseQueryHookResult = ReturnType<typeof useOrderVolumeBySchemaReportSuspenseQuery>;
export type OrderVolumeBySchemaReportQueryResult = Apollo.QueryResult<OrderVolumeBySchemaReportQuery, OrderVolumeBySchemaReportQueryVariables>;
export const OrderVolumeByUserReportDocument = gql`
    query orderVolumeByUserReport($orderVolumeByUserInput: OrderVolumeByUserInput!) {
  orderVolumeByUserReport(orderVolumeByUserInput: $orderVolumeByUserInput) {
    userUuid
    name
    userEmail
    userTerminalName
    sourceAmounts {
      source
      scannedOrderSource
      totalCount
    }
  }
}
    `;

/**
 * __useOrderVolumeByUserReportQuery__
 *
 * To run a query within a React component, call `useOrderVolumeByUserReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderVolumeByUserReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderVolumeByUserReportQuery({
 *   variables: {
 *      orderVolumeByUserInput: // value for 'orderVolumeByUserInput'
 *   },
 * });
 */
export function useOrderVolumeByUserReportQuery(baseOptions: Apollo.QueryHookOptions<OrderVolumeByUserReportQuery, OrderVolumeByUserReportQueryVariables> & ({ variables: OrderVolumeByUserReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderVolumeByUserReportQuery, OrderVolumeByUserReportQueryVariables>(OrderVolumeByUserReportDocument, options);
      }
export function useOrderVolumeByUserReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderVolumeByUserReportQuery, OrderVolumeByUserReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderVolumeByUserReportQuery, OrderVolumeByUserReportQueryVariables>(OrderVolumeByUserReportDocument, options);
        }
export function useOrderVolumeByUserReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderVolumeByUserReportQuery, OrderVolumeByUserReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderVolumeByUserReportQuery, OrderVolumeByUserReportQueryVariables>(OrderVolumeByUserReportDocument, options);
        }
export type OrderVolumeByUserReportQueryHookResult = ReturnType<typeof useOrderVolumeByUserReportQuery>;
export type OrderVolumeByUserReportLazyQueryHookResult = ReturnType<typeof useOrderVolumeByUserReportLazyQuery>;
export type OrderVolumeByUserReportSuspenseQueryHookResult = ReturnType<typeof useOrderVolumeByUserReportSuspenseQuery>;
export type OrderVolumeByUserReportQueryResult = Apollo.QueryResult<OrderVolumeByUserReportQuery, OrderVolumeByUserReportQueryVariables>;
export const AllScannedDocumentsDocument = gql`
    query allScannedDocuments {
  allScannedDocuments
}
    `;

/**
 * __useAllScannedDocumentsQuery__
 *
 * To run a query within a React component, call `useAllScannedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllScannedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllScannedDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllScannedDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<AllScannedDocumentsQuery, AllScannedDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllScannedDocumentsQuery, AllScannedDocumentsQueryVariables>(AllScannedDocumentsDocument, options);
      }
export function useAllScannedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllScannedDocumentsQuery, AllScannedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllScannedDocumentsQuery, AllScannedDocumentsQueryVariables>(AllScannedDocumentsDocument, options);
        }
export function useAllScannedDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllScannedDocumentsQuery, AllScannedDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllScannedDocumentsQuery, AllScannedDocumentsQueryVariables>(AllScannedDocumentsDocument, options);
        }
export type AllScannedDocumentsQueryHookResult = ReturnType<typeof useAllScannedDocumentsQuery>;
export type AllScannedDocumentsLazyQueryHookResult = ReturnType<typeof useAllScannedDocumentsLazyQuery>;
export type AllScannedDocumentsSuspenseQueryHookResult = ReturnType<typeof useAllScannedDocumentsSuspenseQuery>;
export type AllScannedDocumentsQueryResult = Apollo.QueryResult<AllScannedDocumentsQuery, AllScannedDocumentsQueryVariables>;
export const ApiLogsDocument = gql`
    query apiLogs($first: Int, $after: String, $last: Int, $before: String, $createdAtDateFilters: [DateFilter!], $sortByCreatedAtDateAsc: Boolean, $isFreightSnap: Boolean, $isInvoiceEmails: Boolean, $freightSnapTransactionStatus: FreightSnapTransactionStatus, $freightSnapFailureReason: FreightSnapFailureReason, $searchText: String) {
  apiLogs(
    first: $first
    after: $after
    last: $last
    before: $before
    createdAtDateFilters: $createdAtDateFilters
    sortByCreatedAtDateAsc: $sortByCreatedAtDateAsc
    isFreightSnap: $isFreightSnap
    isInvoiceEmails: $isInvoiceEmails
    freightSnapTransactionStatus: $freightSnapTransactionStatus
    freightSnapFailureReason: $freightSnapFailureReason
    searchText: $searchText
  ) {
    totalCount
    edges {
      node {
        ...ApiLog
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ApiLogFragmentDoc}`;

/**
 * __useApiLogsQuery__
 *
 * To run a query within a React component, call `useApiLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiLogsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      createdAtDateFilters: // value for 'createdAtDateFilters'
 *      sortByCreatedAtDateAsc: // value for 'sortByCreatedAtDateAsc'
 *      isFreightSnap: // value for 'isFreightSnap'
 *      isInvoiceEmails: // value for 'isInvoiceEmails'
 *      freightSnapTransactionStatus: // value for 'freightSnapTransactionStatus'
 *      freightSnapFailureReason: // value for 'freightSnapFailureReason'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useApiLogsQuery(baseOptions?: Apollo.QueryHookOptions<ApiLogsQuery, ApiLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiLogsQuery, ApiLogsQueryVariables>(ApiLogsDocument, options);
      }
export function useApiLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiLogsQuery, ApiLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiLogsQuery, ApiLogsQueryVariables>(ApiLogsDocument, options);
        }
export function useApiLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiLogsQuery, ApiLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiLogsQuery, ApiLogsQueryVariables>(ApiLogsDocument, options);
        }
export type ApiLogsQueryHookResult = ReturnType<typeof useApiLogsQuery>;
export type ApiLogsLazyQueryHookResult = ReturnType<typeof useApiLogsLazyQuery>;
export type ApiLogsSuspenseQueryHookResult = ReturnType<typeof useApiLogsSuspenseQuery>;
export type ApiLogsQueryResult = Apollo.QueryResult<ApiLogsQuery, ApiLogsQueryVariables>;
export const InvoiceEmailsApiLogsDocument = gql`
    query invoiceEmailsApiLogs($findInvoiceEmailsApiLogsInput: FindInvoiceEmailsApiLogsInput!) {
  invoiceEmailsApiLogs(
    findInvoiceEmailsApiLogsInput: $findInvoiceEmailsApiLogsInput
  ) {
    apiLogConnection {
      totalCount
      edges {
        node {
          ...ApiLog
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ApiLogFragmentDoc}`;

/**
 * __useInvoiceEmailsApiLogsQuery__
 *
 * To run a query within a React component, call `useInvoiceEmailsApiLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceEmailsApiLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceEmailsApiLogsQuery({
 *   variables: {
 *      findInvoiceEmailsApiLogsInput: // value for 'findInvoiceEmailsApiLogsInput'
 *   },
 * });
 */
export function useInvoiceEmailsApiLogsQuery(baseOptions: Apollo.QueryHookOptions<InvoiceEmailsApiLogsQuery, InvoiceEmailsApiLogsQueryVariables> & ({ variables: InvoiceEmailsApiLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceEmailsApiLogsQuery, InvoiceEmailsApiLogsQueryVariables>(InvoiceEmailsApiLogsDocument, options);
      }
export function useInvoiceEmailsApiLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceEmailsApiLogsQuery, InvoiceEmailsApiLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceEmailsApiLogsQuery, InvoiceEmailsApiLogsQueryVariables>(InvoiceEmailsApiLogsDocument, options);
        }
export function useInvoiceEmailsApiLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoiceEmailsApiLogsQuery, InvoiceEmailsApiLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceEmailsApiLogsQuery, InvoiceEmailsApiLogsQueryVariables>(InvoiceEmailsApiLogsDocument, options);
        }
export type InvoiceEmailsApiLogsQueryHookResult = ReturnType<typeof useInvoiceEmailsApiLogsQuery>;
export type InvoiceEmailsApiLogsLazyQueryHookResult = ReturnType<typeof useInvoiceEmailsApiLogsLazyQuery>;
export type InvoiceEmailsApiLogsSuspenseQueryHookResult = ReturnType<typeof useInvoiceEmailsApiLogsSuspenseQuery>;
export type InvoiceEmailsApiLogsQueryResult = Apollo.QueryResult<InvoiceEmailsApiLogsQuery, InvoiceEmailsApiLogsQueryVariables>;
export const CompaniesDocument = gql`
    query companies {
  companies {
    uuid
    name
  }
}
    `;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export function useCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesSuspenseQueryHookResult = ReturnType<typeof useCompaniesSuspenseQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const CompanyConfigurationByCompanyUuidDocument = gql`
    query companyConfigurationByCompanyUuid($uuid: String!) {
  companyConfigurationByCompanyUuid(uuid: $uuid) {
    ...MeCompanyConfiguration
  }
}
    ${MeCompanyConfigurationFragmentDoc}`;

/**
 * __useCompanyConfigurationByCompanyUuidQuery__
 *
 * To run a query within a React component, call `useCompanyConfigurationByCompanyUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyConfigurationByCompanyUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyConfigurationByCompanyUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCompanyConfigurationByCompanyUuidQuery(baseOptions: Apollo.QueryHookOptions<CompanyConfigurationByCompanyUuidQuery, CompanyConfigurationByCompanyUuidQueryVariables> & ({ variables: CompanyConfigurationByCompanyUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyConfigurationByCompanyUuidQuery, CompanyConfigurationByCompanyUuidQueryVariables>(CompanyConfigurationByCompanyUuidDocument, options);
      }
export function useCompanyConfigurationByCompanyUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyConfigurationByCompanyUuidQuery, CompanyConfigurationByCompanyUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyConfigurationByCompanyUuidQuery, CompanyConfigurationByCompanyUuidQueryVariables>(CompanyConfigurationByCompanyUuidDocument, options);
        }
export function useCompanyConfigurationByCompanyUuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyConfigurationByCompanyUuidQuery, CompanyConfigurationByCompanyUuidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyConfigurationByCompanyUuidQuery, CompanyConfigurationByCompanyUuidQueryVariables>(CompanyConfigurationByCompanyUuidDocument, options);
        }
export type CompanyConfigurationByCompanyUuidQueryHookResult = ReturnType<typeof useCompanyConfigurationByCompanyUuidQuery>;
export type CompanyConfigurationByCompanyUuidLazyQueryHookResult = ReturnType<typeof useCompanyConfigurationByCompanyUuidLazyQuery>;
export type CompanyConfigurationByCompanyUuidSuspenseQueryHookResult = ReturnType<typeof useCompanyConfigurationByCompanyUuidSuspenseQuery>;
export type CompanyConfigurationByCompanyUuidQueryResult = Apollo.QueryResult<CompanyConfigurationByCompanyUuidQuery, CompanyConfigurationByCompanyUuidQueryVariables>;
export const OffboardCompanyFromQuoteAgentDocument = gql`
    mutation offboardCompanyFromQuoteAgent($input: OffboardCompanyFromQuoteAgentInput!) {
  offboardCompanyFromQuoteAgent(input: $input) {
    companyUuid
    status
  }
}
    `;
export type OffboardCompanyFromQuoteAgentMutationFn = Apollo.MutationFunction<OffboardCompanyFromQuoteAgentMutation, OffboardCompanyFromQuoteAgentMutationVariables>;

/**
 * __useOffboardCompanyFromQuoteAgentMutation__
 *
 * To run a mutation, you first call `useOffboardCompanyFromQuoteAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOffboardCompanyFromQuoteAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offboardCompanyFromQuoteAgentMutation, { data, loading, error }] = useOffboardCompanyFromQuoteAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOffboardCompanyFromQuoteAgentMutation(baseOptions?: Apollo.MutationHookOptions<OffboardCompanyFromQuoteAgentMutation, OffboardCompanyFromQuoteAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OffboardCompanyFromQuoteAgentMutation, OffboardCompanyFromQuoteAgentMutationVariables>(OffboardCompanyFromQuoteAgentDocument, options);
      }
export type OffboardCompanyFromQuoteAgentMutationHookResult = ReturnType<typeof useOffboardCompanyFromQuoteAgentMutation>;
export type OffboardCompanyFromQuoteAgentMutationResult = Apollo.MutationResult<OffboardCompanyFromQuoteAgentMutation>;
export type OffboardCompanyFromQuoteAgentMutationOptions = Apollo.BaseMutationOptions<OffboardCompanyFromQuoteAgentMutation, OffboardCompanyFromQuoteAgentMutationVariables>;
export const SessionCompanyConfigurationDocument = gql`
    query sessionCompanyConfiguration {
  companyConfiguration {
    ...MeCompanyConfiguration
  }
}
    ${MeCompanyConfigurationFragmentDoc}`;

/**
 * __useSessionCompanyConfigurationQuery__
 *
 * To run a query within a React component, call `useSessionCompanyConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionCompanyConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionCompanyConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionCompanyConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<SessionCompanyConfigurationQuery, SessionCompanyConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionCompanyConfigurationQuery, SessionCompanyConfigurationQueryVariables>(SessionCompanyConfigurationDocument, options);
      }
export function useSessionCompanyConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionCompanyConfigurationQuery, SessionCompanyConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionCompanyConfigurationQuery, SessionCompanyConfigurationQueryVariables>(SessionCompanyConfigurationDocument, options);
        }
export function useSessionCompanyConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SessionCompanyConfigurationQuery, SessionCompanyConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SessionCompanyConfigurationQuery, SessionCompanyConfigurationQueryVariables>(SessionCompanyConfigurationDocument, options);
        }
export type SessionCompanyConfigurationQueryHookResult = ReturnType<typeof useSessionCompanyConfigurationQuery>;
export type SessionCompanyConfigurationLazyQueryHookResult = ReturnType<typeof useSessionCompanyConfigurationLazyQuery>;
export type SessionCompanyConfigurationSuspenseQueryHookResult = ReturnType<typeof useSessionCompanyConfigurationSuspenseQuery>;
export type SessionCompanyConfigurationQueryResult = Apollo.QueryResult<SessionCompanyConfigurationQuery, SessionCompanyConfigurationQueryVariables>;
export const UpdateCompanyConfigurationDocument = gql`
    mutation updateCompanyConfiguration($updateCompanyConfigurationInput: UpdateCompanyConfigurationInput!) {
  updateCompanyConfiguration(
    updateCompanyConfigurationInput: $updateCompanyConfigurationInput
  ) {
    ...MeCompanyConfiguration
  }
}
    ${MeCompanyConfigurationFragmentDoc}`;
export type UpdateCompanyConfigurationMutationFn = Apollo.MutationFunction<UpdateCompanyConfigurationMutation, UpdateCompanyConfigurationMutationVariables>;

/**
 * __useUpdateCompanyConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyConfigurationMutation, { data, loading, error }] = useUpdateCompanyConfigurationMutation({
 *   variables: {
 *      updateCompanyConfigurationInput: // value for 'updateCompanyConfigurationInput'
 *   },
 * });
 */
export function useUpdateCompanyConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyConfigurationMutation, UpdateCompanyConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyConfigurationMutation, UpdateCompanyConfigurationMutationVariables>(UpdateCompanyConfigurationDocument, options);
      }
export type UpdateCompanyConfigurationMutationHookResult = ReturnType<typeof useUpdateCompanyConfigurationMutation>;
export type UpdateCompanyConfigurationMutationResult = Apollo.MutationResult<UpdateCompanyConfigurationMutation>;
export type UpdateCompanyConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyConfigurationMutation, UpdateCompanyConfigurationMutationVariables>;
export const UpdateQuoteAgentStaffSettingsDocument = gql`
    mutation updateQuoteAgentStaffSettings($input: UpdateQuoteAgentStaffSettingsInput!) {
  updateQuoteAgentStaffSettings(input: $input) {
    ...MeCompanyConfiguration
  }
}
    ${MeCompanyConfigurationFragmentDoc}`;
export type UpdateQuoteAgentStaffSettingsMutationFn = Apollo.MutationFunction<UpdateQuoteAgentStaffSettingsMutation, UpdateQuoteAgentStaffSettingsMutationVariables>;

/**
 * __useUpdateQuoteAgentStaffSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteAgentStaffSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteAgentStaffSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteAgentStaffSettingsMutation, { data, loading, error }] = useUpdateQuoteAgentStaffSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteAgentStaffSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteAgentStaffSettingsMutation, UpdateQuoteAgentStaffSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteAgentStaffSettingsMutation, UpdateQuoteAgentStaffSettingsMutationVariables>(UpdateQuoteAgentStaffSettingsDocument, options);
      }
export type UpdateQuoteAgentStaffSettingsMutationHookResult = ReturnType<typeof useUpdateQuoteAgentStaffSettingsMutation>;
export type UpdateQuoteAgentStaffSettingsMutationResult = Apollo.MutationResult<UpdateQuoteAgentStaffSettingsMutation>;
export type UpdateQuoteAgentStaffSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteAgentStaffSettingsMutation, UpdateQuoteAgentStaffSettingsMutationVariables>;
export const ConfigMigrationCompaniesDocument = gql`
    query ConfigMigrationCompanies($env: MigrationEnv!) {
  configMigrationCompanies(env: $env) {
    uuid
    name
  }
}
    `;

/**
 * __useConfigMigrationCompaniesQuery__
 *
 * To run a query within a React component, call `useConfigMigrationCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigMigrationCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigMigrationCompaniesQuery({
 *   variables: {
 *      env: // value for 'env'
 *   },
 * });
 */
export function useConfigMigrationCompaniesQuery(baseOptions: Apollo.QueryHookOptions<ConfigMigrationCompaniesQuery, ConfigMigrationCompaniesQueryVariables> & ({ variables: ConfigMigrationCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigMigrationCompaniesQuery, ConfigMigrationCompaniesQueryVariables>(ConfigMigrationCompaniesDocument, options);
      }
export function useConfigMigrationCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigMigrationCompaniesQuery, ConfigMigrationCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigMigrationCompaniesQuery, ConfigMigrationCompaniesQueryVariables>(ConfigMigrationCompaniesDocument, options);
        }
export function useConfigMigrationCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigMigrationCompaniesQuery, ConfigMigrationCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigMigrationCompaniesQuery, ConfigMigrationCompaniesQueryVariables>(ConfigMigrationCompaniesDocument, options);
        }
export type ConfigMigrationCompaniesQueryHookResult = ReturnType<typeof useConfigMigrationCompaniesQuery>;
export type ConfigMigrationCompaniesLazyQueryHookResult = ReturnType<typeof useConfigMigrationCompaniesLazyQuery>;
export type ConfigMigrationCompaniesSuspenseQueryHookResult = ReturnType<typeof useConfigMigrationCompaniesSuspenseQuery>;
export type ConfigMigrationCompaniesQueryResult = Apollo.QueryResult<ConfigMigrationCompaniesQuery, ConfigMigrationCompaniesQueryVariables>;
export const ConfigMigrationFeatureGroupsDocument = gql`
    query ConfigMigrationFeatureGroups {
  configMigrationFeatureGroups
}
    `;

/**
 * __useConfigMigrationFeatureGroupsQuery__
 *
 * To run a query within a React component, call `useConfigMigrationFeatureGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigMigrationFeatureGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigMigrationFeatureGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfigMigrationFeatureGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ConfigMigrationFeatureGroupsQuery, ConfigMigrationFeatureGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigMigrationFeatureGroupsQuery, ConfigMigrationFeatureGroupsQueryVariables>(ConfigMigrationFeatureGroupsDocument, options);
      }
export function useConfigMigrationFeatureGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigMigrationFeatureGroupsQuery, ConfigMigrationFeatureGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigMigrationFeatureGroupsQuery, ConfigMigrationFeatureGroupsQueryVariables>(ConfigMigrationFeatureGroupsDocument, options);
        }
export function useConfigMigrationFeatureGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigMigrationFeatureGroupsQuery, ConfigMigrationFeatureGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigMigrationFeatureGroupsQuery, ConfigMigrationFeatureGroupsQueryVariables>(ConfigMigrationFeatureGroupsDocument, options);
        }
export type ConfigMigrationFeatureGroupsQueryHookResult = ReturnType<typeof useConfigMigrationFeatureGroupsQuery>;
export type ConfigMigrationFeatureGroupsLazyQueryHookResult = ReturnType<typeof useConfigMigrationFeatureGroupsLazyQuery>;
export type ConfigMigrationFeatureGroupsSuspenseQueryHookResult = ReturnType<typeof useConfigMigrationFeatureGroupsSuspenseQuery>;
export type ConfigMigrationFeatureGroupsQueryResult = Apollo.QueryResult<ConfigMigrationFeatureGroupsQuery, ConfigMigrationFeatureGroupsQueryVariables>;
export const ConfigMigrationStatusDocument = gql`
    query ConfigMigrationStatus($jobId: String!) {
  configMigrationStatus(jobId: $jobId) {
    jobId
    state
    report {
      source
      target
      companyUuid
      dryRun
      sourceBundleKey
      preImageBundleKey
      allMatch
      tables {
        tableName
        sourceCount
        targetCount
        matches
        insertedUuids
        updatedUuids
        skipReason
      }
    }
  }
}
    `;

/**
 * __useConfigMigrationStatusQuery__
 *
 * To run a query within a React component, call `useConfigMigrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigMigrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigMigrationStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useConfigMigrationStatusQuery(baseOptions: Apollo.QueryHookOptions<ConfigMigrationStatusQuery, ConfigMigrationStatusQueryVariables> & ({ variables: ConfigMigrationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigMigrationStatusQuery, ConfigMigrationStatusQueryVariables>(ConfigMigrationStatusDocument, options);
      }
export function useConfigMigrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigMigrationStatusQuery, ConfigMigrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigMigrationStatusQuery, ConfigMigrationStatusQueryVariables>(ConfigMigrationStatusDocument, options);
        }
export function useConfigMigrationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigMigrationStatusQuery, ConfigMigrationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigMigrationStatusQuery, ConfigMigrationStatusQueryVariables>(ConfigMigrationStatusDocument, options);
        }
export type ConfigMigrationStatusQueryHookResult = ReturnType<typeof useConfigMigrationStatusQuery>;
export type ConfigMigrationStatusLazyQueryHookResult = ReturnType<typeof useConfigMigrationStatusLazyQuery>;
export type ConfigMigrationStatusSuspenseQueryHookResult = ReturnType<typeof useConfigMigrationStatusSuspenseQuery>;
export type ConfigMigrationStatusQueryResult = Apollo.QueryResult<ConfigMigrationStatusQuery, ConfigMigrationStatusQueryVariables>;
export const CompanyContactsDocument = gql`
    query companyContacts($companyUuid: String!, $excludeNonActiveContacts: Boolean) {
  companyContacts(
    companyUuid: $companyUuid
    excludeNonActiveContacts: $excludeNonActiveContacts
  ) {
    ...CompanyContact
  }
}
    ${CompanyContactFragmentDoc}`;

/**
 * __useCompanyContactsQuery__
 *
 * To run a query within a React component, call `useCompanyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyContactsQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      excludeNonActiveContacts: // value for 'excludeNonActiveContacts'
 *   },
 * });
 */
export function useCompanyContactsQuery(baseOptions: Apollo.QueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables> & ({ variables: CompanyContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
      }
export function useCompanyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
        }
export function useCompanyContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
        }
export type CompanyContactsQueryHookResult = ReturnType<typeof useCompanyContactsQuery>;
export type CompanyContactsLazyQueryHookResult = ReturnType<typeof useCompanyContactsLazyQuery>;
export type CompanyContactsSuspenseQueryHookResult = ReturnType<typeof useCompanyContactsSuspenseQuery>;
export type CompanyContactsQueryResult = Apollo.QueryResult<CompanyContactsQuery, CompanyContactsQueryVariables>;
export const ContactDocument = gql`
    query contact($uuid: String!) {
  contact(uuid: $uuid) {
    displayName
  }
}
    `;

/**
 * __useContactQuery__
 *
 * To run a query within a React component, call `useContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useContactQuery(baseOptions: Apollo.QueryHookOptions<ContactQuery, ContactQueryVariables> & ({ variables: ContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
      }
export function useContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
export function useContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
export type ContactQueryHookResult = ReturnType<typeof useContactQuery>;
export type ContactLazyQueryHookResult = ReturnType<typeof useContactLazyQuery>;
export type ContactSuspenseQueryHookResult = ReturnType<typeof useContactSuspenseQuery>;
export type ContactQueryResult = Apollo.QueryResult<ContactQuery, ContactQueryVariables>;
export const ShallowContactsDocument = gql`
    query shallowContacts($companyUuid: String, $excludeNonActive: Boolean) {
  contacts(companyUuid: $companyUuid, excludeNonActive: $excludeNonActive) {
    ...ShallowContact
  }
}
    ${ShallowContactFragmentDoc}`;

/**
 * __useShallowContactsQuery__
 *
 * To run a query within a React component, call `useShallowContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShallowContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShallowContactsQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      excludeNonActive: // value for 'excludeNonActive'
 *   },
 * });
 */
export function useShallowContactsQuery(baseOptions?: Apollo.QueryHookOptions<ShallowContactsQuery, ShallowContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShallowContactsQuery, ShallowContactsQueryVariables>(ShallowContactsDocument, options);
      }
export function useShallowContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShallowContactsQuery, ShallowContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShallowContactsQuery, ShallowContactsQueryVariables>(ShallowContactsDocument, options);
        }
export function useShallowContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShallowContactsQuery, ShallowContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShallowContactsQuery, ShallowContactsQueryVariables>(ShallowContactsDocument, options);
        }
export type ShallowContactsQueryHookResult = ReturnType<typeof useShallowContactsQuery>;
export type ShallowContactsLazyQueryHookResult = ReturnType<typeof useShallowContactsLazyQuery>;
export type ShallowContactsSuspenseQueryHookResult = ReturnType<typeof useShallowContactsSuspenseQuery>;
export type ShallowContactsQueryResult = Apollo.QueryResult<ShallowContactsQuery, ShallowContactsQueryVariables>;
export const CreateSchemaTestSnapshotDocument = gql`
    mutation createSchemaTestSnapshot($createSchemaTestSnapshotInput: CreateSchemaTestSnapshotInput!) {
  createSchemaTestSnapshot(
    createSchemaTestSnapshotInput: $createSchemaTestSnapshotInput
  )
}
    `;
export type CreateSchemaTestSnapshotMutationFn = Apollo.MutationFunction<CreateSchemaTestSnapshotMutation, CreateSchemaTestSnapshotMutationVariables>;

/**
 * __useCreateSchemaTestSnapshotMutation__
 *
 * To run a mutation, you first call `useCreateSchemaTestSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchemaTestSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchemaTestSnapshotMutation, { data, loading, error }] = useCreateSchemaTestSnapshotMutation({
 *   variables: {
 *      createSchemaTestSnapshotInput: // value for 'createSchemaTestSnapshotInput'
 *   },
 * });
 */
export function useCreateSchemaTestSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchemaTestSnapshotMutation, CreateSchemaTestSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchemaTestSnapshotMutation, CreateSchemaTestSnapshotMutationVariables>(CreateSchemaTestSnapshotDocument, options);
      }
export type CreateSchemaTestSnapshotMutationHookResult = ReturnType<typeof useCreateSchemaTestSnapshotMutation>;
export type CreateSchemaTestSnapshotMutationResult = Apollo.MutationResult<CreateSchemaTestSnapshotMutation>;
export type CreateSchemaTestSnapshotMutationOptions = Apollo.BaseMutationOptions<CreateSchemaTestSnapshotMutation, CreateSchemaTestSnapshotMutationVariables>;
export const CreateSchemaDocument = gql`
    mutation createSchema($createSchemaInput: CreateSchemaInput!) {
  createSchema(createSchemaInput: $createSchemaInput)
}
    `;
export type CreateSchemaMutationFn = Apollo.MutationFunction<CreateSchemaMutation, CreateSchemaMutationVariables>;

/**
 * __useCreateSchemaMutation__
 *
 * To run a mutation, you first call `useCreateSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchemaMutation, { data, loading, error }] = useCreateSchemaMutation({
 *   variables: {
 *      createSchemaInput: // value for 'createSchemaInput'
 *   },
 * });
 */
export function useCreateSchemaMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchemaMutation, CreateSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchemaMutation, CreateSchemaMutationVariables>(CreateSchemaDocument, options);
      }
export type CreateSchemaMutationHookResult = ReturnType<typeof useCreateSchemaMutation>;
export type CreateSchemaMutationResult = Apollo.MutationResult<CreateSchemaMutation>;
export type CreateSchemaMutationOptions = Apollo.BaseMutationOptions<CreateSchemaMutation, CreateSchemaMutationVariables>;
export const ImportCrownAccessorialDocument = gql`
    mutation importCrownAccessorial($importCrownAccessorialInput: ImportCrownAccessorialInput!) {
  importCrownAccessorial(
    importCrownAccessorialInput: $importCrownAccessorialInput
  ) {
    success
    error
  }
}
    `;
export type ImportCrownAccessorialMutationFn = Apollo.MutationFunction<ImportCrownAccessorialMutation, ImportCrownAccessorialMutationVariables>;

/**
 * __useImportCrownAccessorialMutation__
 *
 * To run a mutation, you first call `useImportCrownAccessorialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCrownAccessorialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCrownAccessorialMutation, { data, loading, error }] = useImportCrownAccessorialMutation({
 *   variables: {
 *      importCrownAccessorialInput: // value for 'importCrownAccessorialInput'
 *   },
 * });
 */
export function useImportCrownAccessorialMutation(baseOptions?: Apollo.MutationHookOptions<ImportCrownAccessorialMutation, ImportCrownAccessorialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCrownAccessorialMutation, ImportCrownAccessorialMutationVariables>(ImportCrownAccessorialDocument, options);
      }
export type ImportCrownAccessorialMutationHookResult = ReturnType<typeof useImportCrownAccessorialMutation>;
export type ImportCrownAccessorialMutationResult = Apollo.MutationResult<ImportCrownAccessorialMutation>;
export type ImportCrownAccessorialMutationOptions = Apollo.BaseMutationOptions<ImportCrownAccessorialMutation, ImportCrownAccessorialMutationVariables>;
export const ImportCrownContactsV2Document = gql`
    mutation importCrownContactsV2($csvUrl: String!, $companyUuid: String!, $useNewImporter: Boolean!) {
  importCrownContactsV2(
    csvUrl: $csvUrl
    companyUuid: $companyUuid
    useNewImporter: $useNewImporter
  )
}
    `;
export type ImportCrownContactsV2MutationFn = Apollo.MutationFunction<ImportCrownContactsV2Mutation, ImportCrownContactsV2MutationVariables>;

/**
 * __useImportCrownContactsV2Mutation__
 *
 * To run a mutation, you first call `useImportCrownContactsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCrownContactsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCrownContactsV2Mutation, { data, loading, error }] = useImportCrownContactsV2Mutation({
 *   variables: {
 *      csvUrl: // value for 'csvUrl'
 *      companyUuid: // value for 'companyUuid'
 *      useNewImporter: // value for 'useNewImporter'
 *   },
 * });
 */
export function useImportCrownContactsV2Mutation(baseOptions?: Apollo.MutationHookOptions<ImportCrownContactsV2Mutation, ImportCrownContactsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCrownContactsV2Mutation, ImportCrownContactsV2MutationVariables>(ImportCrownContactsV2Document, options);
      }
export type ImportCrownContactsV2MutationHookResult = ReturnType<typeof useImportCrownContactsV2Mutation>;
export type ImportCrownContactsV2MutationResult = Apollo.MutationResult<ImportCrownContactsV2Mutation>;
export type ImportCrownContactsV2MutationOptions = Apollo.BaseMutationOptions<ImportCrownContactsV2Mutation, ImportCrownContactsV2MutationVariables>;
export const ImportCrownDriversDocument = gql`
    mutation importCrownDrivers($importCrownDriversInput: ImportCrownDriversInput!) {
  importCrownDrivers(importCrownDriversInput: $importCrownDriversInput) {
    success
    error
    successfulDriverPhoneNumbers
    failedDriverPhoneNumbers
  }
}
    `;
export type ImportCrownDriversMutationFn = Apollo.MutationFunction<ImportCrownDriversMutation, ImportCrownDriversMutationVariables>;

/**
 * __useImportCrownDriversMutation__
 *
 * To run a mutation, you first call `useImportCrownDriversMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCrownDriversMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCrownDriversMutation, { data, loading, error }] = useImportCrownDriversMutation({
 *   variables: {
 *      importCrownDriversInput: // value for 'importCrownDriversInput'
 *   },
 * });
 */
export function useImportCrownDriversMutation(baseOptions?: Apollo.MutationHookOptions<ImportCrownDriversMutation, ImportCrownDriversMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCrownDriversMutation, ImportCrownDriversMutationVariables>(ImportCrownDriversDocument, options);
      }
export type ImportCrownDriversMutationHookResult = ReturnType<typeof useImportCrownDriversMutation>;
export type ImportCrownDriversMutationResult = Apollo.MutationResult<ImportCrownDriversMutation>;
export type ImportCrownDriversMutationOptions = Apollo.BaseMutationOptions<ImportCrownDriversMutation, ImportCrownDriversMutationVariables>;
export const CreateImportedOrderTypeMappingDocument = gql`
    mutation createImportedOrderTypeMapping($importedOrderTypeMappingCreateInput: ImportedOrderTypeMappingCreateInput!) {
  createImportedOrderTypeMapping(
    importedOrderTypeMappingCreateInput: $importedOrderTypeMappingCreateInput
  ) {
    uuid
  }
}
    `;
export type CreateImportedOrderTypeMappingMutationFn = Apollo.MutationFunction<CreateImportedOrderTypeMappingMutation, CreateImportedOrderTypeMappingMutationVariables>;

/**
 * __useCreateImportedOrderTypeMappingMutation__
 *
 * To run a mutation, you first call `useCreateImportedOrderTypeMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportedOrderTypeMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportedOrderTypeMappingMutation, { data, loading, error }] = useCreateImportedOrderTypeMappingMutation({
 *   variables: {
 *      importedOrderTypeMappingCreateInput: // value for 'importedOrderTypeMappingCreateInput'
 *   },
 * });
 */
export function useCreateImportedOrderTypeMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreateImportedOrderTypeMappingMutation, CreateImportedOrderTypeMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImportedOrderTypeMappingMutation, CreateImportedOrderTypeMappingMutationVariables>(CreateImportedOrderTypeMappingDocument, options);
      }
export type CreateImportedOrderTypeMappingMutationHookResult = ReturnType<typeof useCreateImportedOrderTypeMappingMutation>;
export type CreateImportedOrderTypeMappingMutationResult = Apollo.MutationResult<CreateImportedOrderTypeMappingMutation>;
export type CreateImportedOrderTypeMappingMutationOptions = Apollo.BaseMutationOptions<CreateImportedOrderTypeMappingMutation, CreateImportedOrderTypeMappingMutationVariables>;
export const CreateOrderImportConfigurationDocument = gql`
    mutation createOrderImportConfiguration($orderImportConfigurationCreateInput: OrderImportConfigurationCreateInput!) {
  createOrderImportConfiguration(
    orderImportConfigurationCreateInput: $orderImportConfigurationCreateInput
  ) {
    uuid
  }
}
    `;
export type CreateOrderImportConfigurationMutationFn = Apollo.MutationFunction<CreateOrderImportConfigurationMutation, CreateOrderImportConfigurationMutationVariables>;

/**
 * __useCreateOrderImportConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateOrderImportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderImportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderImportConfigurationMutation, { data, loading, error }] = useCreateOrderImportConfigurationMutation({
 *   variables: {
 *      orderImportConfigurationCreateInput: // value for 'orderImportConfigurationCreateInput'
 *   },
 * });
 */
export function useCreateOrderImportConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderImportConfigurationMutation, CreateOrderImportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderImportConfigurationMutation, CreateOrderImportConfigurationMutationVariables>(CreateOrderImportConfigurationDocument, options);
      }
export type CreateOrderImportConfigurationMutationHookResult = ReturnType<typeof useCreateOrderImportConfigurationMutation>;
export type CreateOrderImportConfigurationMutationResult = Apollo.MutationResult<CreateOrderImportConfigurationMutation>;
export type CreateOrderImportConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateOrderImportConfigurationMutation, CreateOrderImportConfigurationMutationVariables>;
export const ImportCrownOrdersDocument = gql`
    mutation importCrownOrders($importCrownOrdersInput: ImportCrownOrdersInput!) {
  importCrownOrders(importCrownOrdersInput: $importCrownOrdersInput) {
    numberOfOrders
    importedCrownIDs
    skippedCrownIDs
    failedCrownIDs
  }
}
    `;
export type ImportCrownOrdersMutationFn = Apollo.MutationFunction<ImportCrownOrdersMutation, ImportCrownOrdersMutationVariables>;

/**
 * __useImportCrownOrdersMutation__
 *
 * To run a mutation, you first call `useImportCrownOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCrownOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCrownOrdersMutation, { data, loading, error }] = useImportCrownOrdersMutation({
 *   variables: {
 *      importCrownOrdersInput: // value for 'importCrownOrdersInput'
 *   },
 * });
 */
export function useImportCrownOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ImportCrownOrdersMutation, ImportCrownOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCrownOrdersMutation, ImportCrownOrdersMutationVariables>(ImportCrownOrdersDocument, options);
      }
export type ImportCrownOrdersMutationHookResult = ReturnType<typeof useImportCrownOrdersMutation>;
export type ImportCrownOrdersMutationResult = Apollo.MutationResult<ImportCrownOrdersMutation>;
export type ImportCrownOrdersMutationOptions = Apollo.BaseMutationOptions<ImportCrownOrdersMutation, ImportCrownOrdersMutationVariables>;
export const RemoveImportedOrderTypeMappingDocument = gql`
    mutation removeImportedOrderTypeMapping($uuid: String!) {
  removeImportedOrderTypeMapping(uuid: $uuid) {
    uuid
  }
}
    `;
export type RemoveImportedOrderTypeMappingMutationFn = Apollo.MutationFunction<RemoveImportedOrderTypeMappingMutation, RemoveImportedOrderTypeMappingMutationVariables>;

/**
 * __useRemoveImportedOrderTypeMappingMutation__
 *
 * To run a mutation, you first call `useRemoveImportedOrderTypeMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveImportedOrderTypeMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeImportedOrderTypeMappingMutation, { data, loading, error }] = useRemoveImportedOrderTypeMappingMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useRemoveImportedOrderTypeMappingMutation(baseOptions?: Apollo.MutationHookOptions<RemoveImportedOrderTypeMappingMutation, RemoveImportedOrderTypeMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveImportedOrderTypeMappingMutation, RemoveImportedOrderTypeMappingMutationVariables>(RemoveImportedOrderTypeMappingDocument, options);
      }
export type RemoveImportedOrderTypeMappingMutationHookResult = ReturnType<typeof useRemoveImportedOrderTypeMappingMutation>;
export type RemoveImportedOrderTypeMappingMutationResult = Apollo.MutationResult<RemoveImportedOrderTypeMappingMutation>;
export type RemoveImportedOrderTypeMappingMutationOptions = Apollo.BaseMutationOptions<RemoveImportedOrderTypeMappingMutation, RemoveImportedOrderTypeMappingMutationVariables>;
export const UpdateOrderImportConfigurationDocument = gql`
    mutation updateOrderImportConfiguration($orderImportConfigurationUpdateInput: OrderImportConfigurationUpdateInput!) {
  updateOrderImportConfiguration(
    orderImportConfigurationUpdateInput: $orderImportConfigurationUpdateInput
  ) {
    uuid
  }
}
    `;
export type UpdateOrderImportConfigurationMutationFn = Apollo.MutationFunction<UpdateOrderImportConfigurationMutation, UpdateOrderImportConfigurationMutationVariables>;

/**
 * __useUpdateOrderImportConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateOrderImportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderImportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderImportConfigurationMutation, { data, loading, error }] = useUpdateOrderImportConfigurationMutation({
 *   variables: {
 *      orderImportConfigurationUpdateInput: // value for 'orderImportConfigurationUpdateInput'
 *   },
 * });
 */
export function useUpdateOrderImportConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderImportConfigurationMutation, UpdateOrderImportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderImportConfigurationMutation, UpdateOrderImportConfigurationMutationVariables>(UpdateOrderImportConfigurationDocument, options);
      }
export type UpdateOrderImportConfigurationMutationHookResult = ReturnType<typeof useUpdateOrderImportConfigurationMutation>;
export type UpdateOrderImportConfigurationMutationResult = Apollo.MutationResult<UpdateOrderImportConfigurationMutation>;
export type UpdateOrderImportConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateOrderImportConfigurationMutation, UpdateOrderImportConfigurationMutationVariables>;
export const ContactServicesDocument = gql`
    query contactServices($uuid: String!) {
  contact(uuid: $uuid) {
    uuid
    services {
      uuid
      name
    }
    defaultService {
      uuid
      name
    }
  }
}
    `;

/**
 * __useContactServicesQuery__
 *
 * To run a query within a React component, call `useContactServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactServicesQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useContactServicesQuery(baseOptions: Apollo.QueryHookOptions<ContactServicesQuery, ContactServicesQueryVariables> & ({ variables: ContactServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactServicesQuery, ContactServicesQueryVariables>(ContactServicesDocument, options);
      }
export function useContactServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactServicesQuery, ContactServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactServicesQuery, ContactServicesQueryVariables>(ContactServicesDocument, options);
        }
export function useContactServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactServicesQuery, ContactServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactServicesQuery, ContactServicesQueryVariables>(ContactServicesDocument, options);
        }
export type ContactServicesQueryHookResult = ReturnType<typeof useContactServicesQuery>;
export type ContactServicesLazyQueryHookResult = ReturnType<typeof useContactServicesLazyQuery>;
export type ContactServicesSuspenseQueryHookResult = ReturnType<typeof useContactServicesSuspenseQuery>;
export type ContactServicesQueryResult = Apollo.QueryResult<ContactServicesQuery, ContactServicesQueryVariables>;
export const FuelProfilesDocument = gql`
    query fuelProfiles($contactUuid: String, $orderUuid: String, $excludeContactUuid: String, $type: FuelProfileType) {
  fuelProfiles(
    contactUuid: $contactUuid
    orderUuid: $orderUuid
    excludeContactUuid: $excludeContactUuid
    type: $type
  ) {
    ...FuelProfile
  }
}
    ${FuelProfileFragmentDoc}`;

/**
 * __useFuelProfilesQuery__
 *
 * To run a query within a React component, call `useFuelProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFuelProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFuelProfilesQuery({
 *   variables: {
 *      contactUuid: // value for 'contactUuid'
 *      orderUuid: // value for 'orderUuid'
 *      excludeContactUuid: // value for 'excludeContactUuid'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useFuelProfilesQuery(baseOptions?: Apollo.QueryHookOptions<FuelProfilesQuery, FuelProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FuelProfilesQuery, FuelProfilesQueryVariables>(FuelProfilesDocument, options);
      }
export function useFuelProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FuelProfilesQuery, FuelProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FuelProfilesQuery, FuelProfilesQueryVariables>(FuelProfilesDocument, options);
        }
export function useFuelProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FuelProfilesQuery, FuelProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FuelProfilesQuery, FuelProfilesQueryVariables>(FuelProfilesDocument, options);
        }
export type FuelProfilesQueryHookResult = ReturnType<typeof useFuelProfilesQuery>;
export type FuelProfilesLazyQueryHookResult = ReturnType<typeof useFuelProfilesLazyQuery>;
export type FuelProfilesSuspenseQueryHookResult = ReturnType<typeof useFuelProfilesSuspenseQuery>;
export type FuelProfilesQueryResult = Apollo.QueryResult<FuelProfilesQuery, FuelProfilesQueryVariables>;
export const ImportCrownTariffDocument = gql`
    mutation importCrownTariff($importCrownTariffInput: ImportCrownTariffInput!) {
  importCrownTariff(importCrownTariffInput: $importCrownTariffInput) {
    success
    error
    dryRun
    tariffsToCreate
    rangesToCreate
  }
}
    `;
export type ImportCrownTariffMutationFn = Apollo.MutationFunction<ImportCrownTariffMutation, ImportCrownTariffMutationVariables>;

/**
 * __useImportCrownTariffMutation__
 *
 * To run a mutation, you first call `useImportCrownTariffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCrownTariffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCrownTariffMutation, { data, loading, error }] = useImportCrownTariffMutation({
 *   variables: {
 *      importCrownTariffInput: // value for 'importCrownTariffInput'
 *   },
 * });
 */
export function useImportCrownTariffMutation(baseOptions?: Apollo.MutationHookOptions<ImportCrownTariffMutation, ImportCrownTariffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCrownTariffMutation, ImportCrownTariffMutationVariables>(ImportCrownTariffDocument, options);
      }
export type ImportCrownTariffMutationHookResult = ReturnType<typeof useImportCrownTariffMutation>;
export type ImportCrownTariffMutationResult = Apollo.MutationResult<ImportCrownTariffMutation>;
export type ImportCrownTariffMutationOptions = Apollo.BaseMutationOptions<ImportCrownTariffMutation, ImportCrownTariffMutationVariables>;
export const ServicesDocument = gql`
    query services {
  services {
    ...Service
  }
}
    ${ServiceFragmentDoc}`;

/**
 * __useServicesQuery__
 *
 * To run a query within a React component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useServicesQuery(baseOptions?: Apollo.QueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
      }
export function useServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export function useServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export type ServicesQueryHookResult = ReturnType<typeof useServicesQuery>;
export type ServicesLazyQueryHookResult = ReturnType<typeof useServicesLazyQuery>;
export type ServicesSuspenseQueryHookResult = ReturnType<typeof useServicesSuspenseQuery>;
export type ServicesQueryResult = Apollo.QueryResult<ServicesQuery, ServicesQueryVariables>;
export const TariffZoneGroupsDocument = gql`
    query tariffZoneGroups($findTariffZoneGroupsInput: FindTariffZoneGroupsInput!) {
  tariffZoneGroups(findTariffZoneGroupsInput: $findTariffZoneGroupsInput) {
    ...TariffZoneGroup
  }
}
    ${TariffZoneGroupFragmentDoc}`;

/**
 * __useTariffZoneGroupsQuery__
 *
 * To run a query within a React component, call `useTariffZoneGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTariffZoneGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTariffZoneGroupsQuery({
 *   variables: {
 *      findTariffZoneGroupsInput: // value for 'findTariffZoneGroupsInput'
 *   },
 * });
 */
export function useTariffZoneGroupsQuery(baseOptions: Apollo.QueryHookOptions<TariffZoneGroupsQuery, TariffZoneGroupsQueryVariables> & ({ variables: TariffZoneGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TariffZoneGroupsQuery, TariffZoneGroupsQueryVariables>(TariffZoneGroupsDocument, options);
      }
export function useTariffZoneGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TariffZoneGroupsQuery, TariffZoneGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TariffZoneGroupsQuery, TariffZoneGroupsQueryVariables>(TariffZoneGroupsDocument, options);
        }
export function useTariffZoneGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TariffZoneGroupsQuery, TariffZoneGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TariffZoneGroupsQuery, TariffZoneGroupsQueryVariables>(TariffZoneGroupsDocument, options);
        }
export type TariffZoneGroupsQueryHookResult = ReturnType<typeof useTariffZoneGroupsQuery>;
export type TariffZoneGroupsLazyQueryHookResult = ReturnType<typeof useTariffZoneGroupsLazyQuery>;
export type TariffZoneGroupsSuspenseQueryHookResult = ReturnType<typeof useTariffZoneGroupsSuspenseQuery>;
export type TariffZoneGroupsQueryResult = Apollo.QueryResult<TariffZoneGroupsQuery, TariffZoneGroupsQueryVariables>;
export const VehicleTypesDocument = gql`
    query vehicleTypes {
  vehicleTypes {
    ...VehicleType
  }
}
    ${VehicleTypeFragmentDoc}`;

/**
 * __useVehicleTypesQuery__
 *
 * To run a query within a React component, call `useVehicleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVehicleTypesQuery(baseOptions?: Apollo.QueryHookOptions<VehicleTypesQuery, VehicleTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleTypesQuery, VehicleTypesQueryVariables>(VehicleTypesDocument, options);
      }
export function useVehicleTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleTypesQuery, VehicleTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleTypesQuery, VehicleTypesQueryVariables>(VehicleTypesDocument, options);
        }
export function useVehicleTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VehicleTypesQuery, VehicleTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VehicleTypesQuery, VehicleTypesQueryVariables>(VehicleTypesDocument, options);
        }
export type VehicleTypesQueryHookResult = ReturnType<typeof useVehicleTypesQuery>;
export type VehicleTypesLazyQueryHookResult = ReturnType<typeof useVehicleTypesLazyQuery>;
export type VehicleTypesSuspenseQueryHookResult = ReturnType<typeof useVehicleTypesSuspenseQuery>;
export type VehicleTypesQueryResult = Apollo.QueryResult<VehicleTypesQuery, VehicleTypesQueryVariables>;
export const ImportCrownUsersDocument = gql`
    mutation importCrownUsers($importCrownUsersInput: ImportCrownUsersInput!) {
  importCrownUsers(importCrownUsersInput: $importCrownUsersInput) {
    success
    error
  }
}
    `;
export type ImportCrownUsersMutationFn = Apollo.MutationFunction<ImportCrownUsersMutation, ImportCrownUsersMutationVariables>;

/**
 * __useImportCrownUsersMutation__
 *
 * To run a mutation, you first call `useImportCrownUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCrownUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCrownUsersMutation, { data, loading, error }] = useImportCrownUsersMutation({
 *   variables: {
 *      importCrownUsersInput: // value for 'importCrownUsersInput'
 *   },
 * });
 */
export function useImportCrownUsersMutation(baseOptions?: Apollo.MutationHookOptions<ImportCrownUsersMutation, ImportCrownUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCrownUsersMutation, ImportCrownUsersMutationVariables>(ImportCrownUsersDocument, options);
      }
export type ImportCrownUsersMutationHookResult = ReturnType<typeof useImportCrownUsersMutation>;
export type ImportCrownUsersMutationResult = Apollo.MutationResult<ImportCrownUsersMutation>;
export type ImportCrownUsersMutationOptions = Apollo.BaseMutationOptions<ImportCrownUsersMutation, ImportCrownUsersMutationVariables>;
export const DeleteSchemaRunDocument = gql`
    mutation deleteSchemaRun($deleteSchemaRunInput: DeleteSchemaRunInput!) {
  deleteSchemaRun(deleteSchemaRunInput: $deleteSchemaRunInput)
}
    `;
export type DeleteSchemaRunMutationFn = Apollo.MutationFunction<DeleteSchemaRunMutation, DeleteSchemaRunMutationVariables>;

/**
 * __useDeleteSchemaRunMutation__
 *
 * To run a mutation, you first call `useDeleteSchemaRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchemaRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchemaRunMutation, { data, loading, error }] = useDeleteSchemaRunMutation({
 *   variables: {
 *      deleteSchemaRunInput: // value for 'deleteSchemaRunInput'
 *   },
 * });
 */
export function useDeleteSchemaRunMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchemaRunMutation, DeleteSchemaRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchemaRunMutation, DeleteSchemaRunMutationVariables>(DeleteSchemaRunDocument, options);
      }
export type DeleteSchemaRunMutationHookResult = ReturnType<typeof useDeleteSchemaRunMutation>;
export type DeleteSchemaRunMutationResult = Apollo.MutationResult<DeleteSchemaRunMutation>;
export type DeleteSchemaRunMutationOptions = Apollo.BaseMutationOptions<DeleteSchemaRunMutation, DeleteSchemaRunMutationVariables>;
export const DeleteSchemaDocument = gql`
    mutation deleteSchema($uuid: String!) {
  deleteSchema(uuid: $uuid)
}
    `;
export type DeleteSchemaMutationFn = Apollo.MutationFunction<DeleteSchemaMutation, DeleteSchemaMutationVariables>;

/**
 * __useDeleteSchemaMutation__
 *
 * To run a mutation, you first call `useDeleteSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchemaMutation, { data, loading, error }] = useDeleteSchemaMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteSchemaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchemaMutation, DeleteSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchemaMutation, DeleteSchemaMutationVariables>(DeleteSchemaDocument, options);
      }
export type DeleteSchemaMutationHookResult = ReturnType<typeof useDeleteSchemaMutation>;
export type DeleteSchemaMutationResult = Apollo.MutationResult<DeleteSchemaMutation>;
export type DeleteSchemaMutationOptions = Apollo.BaseMutationOptions<DeleteSchemaMutation, DeleteSchemaMutationVariables>;
export const CancelDocExtractionEvalRunDocument = gql`
    mutation cancelDocExtractionEvalRun($runId: String!) {
  cancelDocExtractionEvalRun(runId: $runId) {
    evalRunId
    cancelRequested
  }
}
    `;
export type CancelDocExtractionEvalRunMutationFn = Apollo.MutationFunction<CancelDocExtractionEvalRunMutation, CancelDocExtractionEvalRunMutationVariables>;

/**
 * __useCancelDocExtractionEvalRunMutation__
 *
 * To run a mutation, you first call `useCancelDocExtractionEvalRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDocExtractionEvalRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDocExtractionEvalRunMutation, { data, loading, error }] = useCancelDocExtractionEvalRunMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useCancelDocExtractionEvalRunMutation(baseOptions?: Apollo.MutationHookOptions<CancelDocExtractionEvalRunMutation, CancelDocExtractionEvalRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDocExtractionEvalRunMutation, CancelDocExtractionEvalRunMutationVariables>(CancelDocExtractionEvalRunDocument, options);
      }
export type CancelDocExtractionEvalRunMutationHookResult = ReturnType<typeof useCancelDocExtractionEvalRunMutation>;
export type CancelDocExtractionEvalRunMutationResult = Apollo.MutationResult<CancelDocExtractionEvalRunMutation>;
export type CancelDocExtractionEvalRunMutationOptions = Apollo.BaseMutationOptions<CancelDocExtractionEvalRunMutation, CancelDocExtractionEvalRunMutationVariables>;
export const CreateDocExtractionEvalRunDocument = gql`
    mutation createDocExtractionEvalRun($input: CreateDocExtractionEvalRunInput!) {
  createDocExtractionEvalRun(input: $input) {
    evalRunId
    documentCount
    bundleHash
  }
}
    `;
export type CreateDocExtractionEvalRunMutationFn = Apollo.MutationFunction<CreateDocExtractionEvalRunMutation, CreateDocExtractionEvalRunMutationVariables>;

/**
 * __useCreateDocExtractionEvalRunMutation__
 *
 * To run a mutation, you first call `useCreateDocExtractionEvalRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocExtractionEvalRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocExtractionEvalRunMutation, { data, loading, error }] = useCreateDocExtractionEvalRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocExtractionEvalRunMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocExtractionEvalRunMutation, CreateDocExtractionEvalRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocExtractionEvalRunMutation, CreateDocExtractionEvalRunMutationVariables>(CreateDocExtractionEvalRunDocument, options);
      }
export type CreateDocExtractionEvalRunMutationHookResult = ReturnType<typeof useCreateDocExtractionEvalRunMutation>;
export type CreateDocExtractionEvalRunMutationResult = Apollo.MutationResult<CreateDocExtractionEvalRunMutation>;
export type CreateDocExtractionEvalRunMutationOptions = Apollo.BaseMutationOptions<CreateDocExtractionEvalRunMutation, CreateDocExtractionEvalRunMutationVariables>;
export const CreateDocExtractionEvalSetDocument = gql`
    mutation createDocExtractionEvalSet($input: CreateDocExtractionEvalSetInput!) {
  createDocExtractionEvalSet(input: $input) {
    evalSetId
    documentCount
    strata
  }
}
    `;
export type CreateDocExtractionEvalSetMutationFn = Apollo.MutationFunction<CreateDocExtractionEvalSetMutation, CreateDocExtractionEvalSetMutationVariables>;

/**
 * __useCreateDocExtractionEvalSetMutation__
 *
 * To run a mutation, you first call `useCreateDocExtractionEvalSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocExtractionEvalSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocExtractionEvalSetMutation, { data, loading, error }] = useCreateDocExtractionEvalSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocExtractionEvalSetMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocExtractionEvalSetMutation, CreateDocExtractionEvalSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocExtractionEvalSetMutation, CreateDocExtractionEvalSetMutationVariables>(CreateDocExtractionEvalSetDocument, options);
      }
export type CreateDocExtractionEvalSetMutationHookResult = ReturnType<typeof useCreateDocExtractionEvalSetMutation>;
export type CreateDocExtractionEvalSetMutationResult = Apollo.MutationResult<CreateDocExtractionEvalSetMutation>;
export type CreateDocExtractionEvalSetMutationOptions = Apollo.BaseMutationOptions<CreateDocExtractionEvalSetMutation, CreateDocExtractionEvalSetMutationVariables>;
export const EstimateDocExtractionEvalRunDocument = gql`
    mutation estimateDocExtractionEvalRun($input: EstimateDocExtractionEvalRunInput!) {
  estimateDocExtractionEvalRun(input: $input) {
    inputTokens
    outputTokens
    totalTokens
    usd
    pricingSource
    tokenProfileSource
  }
}
    `;
export type EstimateDocExtractionEvalRunMutationFn = Apollo.MutationFunction<EstimateDocExtractionEvalRunMutation, EstimateDocExtractionEvalRunMutationVariables>;

/**
 * __useEstimateDocExtractionEvalRunMutation__
 *
 * To run a mutation, you first call `useEstimateDocExtractionEvalRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEstimateDocExtractionEvalRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [estimateDocExtractionEvalRunMutation, { data, loading, error }] = useEstimateDocExtractionEvalRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEstimateDocExtractionEvalRunMutation(baseOptions?: Apollo.MutationHookOptions<EstimateDocExtractionEvalRunMutation, EstimateDocExtractionEvalRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EstimateDocExtractionEvalRunMutation, EstimateDocExtractionEvalRunMutationVariables>(EstimateDocExtractionEvalRunDocument, options);
      }
export type EstimateDocExtractionEvalRunMutationHookResult = ReturnType<typeof useEstimateDocExtractionEvalRunMutation>;
export type EstimateDocExtractionEvalRunMutationResult = Apollo.MutationResult<EstimateDocExtractionEvalRunMutation>;
export type EstimateDocExtractionEvalRunMutationOptions = Apollo.BaseMutationOptions<EstimateDocExtractionEvalRunMutation, EstimateDocExtractionEvalRunMutationVariables>;
export const DocExtractionEvalDocumentWordBoxesDocument = gql`
    query docExtractionEvalDocumentWordBoxes($runId: String!, $documentId: String!) {
  docExtractionEvalDocumentWordBoxes(runId: $runId, documentId: $documentId) {
    pages {
      pageNumber
      textSource
      words {
        text
        confidence
        left
        top
        width
        height
      }
    }
  }
}
    `;

/**
 * __useDocExtractionEvalDocumentWordBoxesQuery__
 *
 * To run a query within a React component, call `useDocExtractionEvalDocumentWordBoxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocExtractionEvalDocumentWordBoxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocExtractionEvalDocumentWordBoxesQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocExtractionEvalDocumentWordBoxesQuery(baseOptions: Apollo.QueryHookOptions<DocExtractionEvalDocumentWordBoxesQuery, DocExtractionEvalDocumentWordBoxesQueryVariables> & ({ variables: DocExtractionEvalDocumentWordBoxesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocExtractionEvalDocumentWordBoxesQuery, DocExtractionEvalDocumentWordBoxesQueryVariables>(DocExtractionEvalDocumentWordBoxesDocument, options);
      }
export function useDocExtractionEvalDocumentWordBoxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocExtractionEvalDocumentWordBoxesQuery, DocExtractionEvalDocumentWordBoxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocExtractionEvalDocumentWordBoxesQuery, DocExtractionEvalDocumentWordBoxesQueryVariables>(DocExtractionEvalDocumentWordBoxesDocument, options);
        }
export function useDocExtractionEvalDocumentWordBoxesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocExtractionEvalDocumentWordBoxesQuery, DocExtractionEvalDocumentWordBoxesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocExtractionEvalDocumentWordBoxesQuery, DocExtractionEvalDocumentWordBoxesQueryVariables>(DocExtractionEvalDocumentWordBoxesDocument, options);
        }
export type DocExtractionEvalDocumentWordBoxesQueryHookResult = ReturnType<typeof useDocExtractionEvalDocumentWordBoxesQuery>;
export type DocExtractionEvalDocumentWordBoxesLazyQueryHookResult = ReturnType<typeof useDocExtractionEvalDocumentWordBoxesLazyQuery>;
export type DocExtractionEvalDocumentWordBoxesSuspenseQueryHookResult = ReturnType<typeof useDocExtractionEvalDocumentWordBoxesSuspenseQuery>;
export type DocExtractionEvalDocumentWordBoxesQueryResult = Apollo.QueryResult<DocExtractionEvalDocumentWordBoxesQuery, DocExtractionEvalDocumentWordBoxesQueryVariables>;
export const DocExtractionEvalRunDocumentsDocument = gql`
    query docExtractionEvalRunDocuments($runId: String!, $after: String, $limit: Int) {
  docExtractionEvalRunDocuments(runId: $runId, after: $after, limit: $limit) {
    documents {
      ...EvalRunDocumentFields
    }
    nextCursor
  }
}
    ${EvalRunDocumentFieldsFragmentDoc}`;

/**
 * __useDocExtractionEvalRunDocumentsQuery__
 *
 * To run a query within a React component, call `useDocExtractionEvalRunDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocExtractionEvalRunDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocExtractionEvalRunDocumentsQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDocExtractionEvalRunDocumentsQuery(baseOptions: Apollo.QueryHookOptions<DocExtractionEvalRunDocumentsQuery, DocExtractionEvalRunDocumentsQueryVariables> & ({ variables: DocExtractionEvalRunDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocExtractionEvalRunDocumentsQuery, DocExtractionEvalRunDocumentsQueryVariables>(DocExtractionEvalRunDocumentsDocument, options);
      }
export function useDocExtractionEvalRunDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocExtractionEvalRunDocumentsQuery, DocExtractionEvalRunDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocExtractionEvalRunDocumentsQuery, DocExtractionEvalRunDocumentsQueryVariables>(DocExtractionEvalRunDocumentsDocument, options);
        }
export function useDocExtractionEvalRunDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocExtractionEvalRunDocumentsQuery, DocExtractionEvalRunDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocExtractionEvalRunDocumentsQuery, DocExtractionEvalRunDocumentsQueryVariables>(DocExtractionEvalRunDocumentsDocument, options);
        }
export type DocExtractionEvalRunDocumentsQueryHookResult = ReturnType<typeof useDocExtractionEvalRunDocumentsQuery>;
export type DocExtractionEvalRunDocumentsLazyQueryHookResult = ReturnType<typeof useDocExtractionEvalRunDocumentsLazyQuery>;
export type DocExtractionEvalRunDocumentsSuspenseQueryHookResult = ReturnType<typeof useDocExtractionEvalRunDocumentsSuspenseQuery>;
export type DocExtractionEvalRunDocumentsQueryResult = Apollo.QueryResult<DocExtractionEvalRunDocumentsQuery, DocExtractionEvalRunDocumentsQueryVariables>;
export const DocExtractionEvalRunDocument = gql`
    query docExtractionEvalRun($id: String!) {
  docExtractionEvalRun(id: $id) {
    ...EvalRunFields
  }
}
    ${EvalRunFieldsFragmentDoc}`;

/**
 * __useDocExtractionEvalRunQuery__
 *
 * To run a query within a React component, call `useDocExtractionEvalRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocExtractionEvalRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocExtractionEvalRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocExtractionEvalRunQuery(baseOptions: Apollo.QueryHookOptions<DocExtractionEvalRunQuery, DocExtractionEvalRunQueryVariables> & ({ variables: DocExtractionEvalRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocExtractionEvalRunQuery, DocExtractionEvalRunQueryVariables>(DocExtractionEvalRunDocument, options);
      }
export function useDocExtractionEvalRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocExtractionEvalRunQuery, DocExtractionEvalRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocExtractionEvalRunQuery, DocExtractionEvalRunQueryVariables>(DocExtractionEvalRunDocument, options);
        }
export function useDocExtractionEvalRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocExtractionEvalRunQuery, DocExtractionEvalRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocExtractionEvalRunQuery, DocExtractionEvalRunQueryVariables>(DocExtractionEvalRunDocument, options);
        }
export type DocExtractionEvalRunQueryHookResult = ReturnType<typeof useDocExtractionEvalRunQuery>;
export type DocExtractionEvalRunLazyQueryHookResult = ReturnType<typeof useDocExtractionEvalRunLazyQuery>;
export type DocExtractionEvalRunSuspenseQueryHookResult = ReturnType<typeof useDocExtractionEvalRunSuspenseQuery>;
export type DocExtractionEvalRunQueryResult = Apollo.QueryResult<DocExtractionEvalRunQuery, DocExtractionEvalRunQueryVariables>;
export const DocExtractionEvalRunsDocument = gql`
    query docExtractionEvalRuns($evalSetId: String, $limit: Int) {
  docExtractionEvalRuns(evalSetId: $evalSetId, limit: $limit) {
    ...EvalRunFields
  }
}
    ${EvalRunFieldsFragmentDoc}`;

/**
 * __useDocExtractionEvalRunsQuery__
 *
 * To run a query within a React component, call `useDocExtractionEvalRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocExtractionEvalRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocExtractionEvalRunsQuery({
 *   variables: {
 *      evalSetId: // value for 'evalSetId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDocExtractionEvalRunsQuery(baseOptions?: Apollo.QueryHookOptions<DocExtractionEvalRunsQuery, DocExtractionEvalRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocExtractionEvalRunsQuery, DocExtractionEvalRunsQueryVariables>(DocExtractionEvalRunsDocument, options);
      }
export function useDocExtractionEvalRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocExtractionEvalRunsQuery, DocExtractionEvalRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocExtractionEvalRunsQuery, DocExtractionEvalRunsQueryVariables>(DocExtractionEvalRunsDocument, options);
        }
export function useDocExtractionEvalRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocExtractionEvalRunsQuery, DocExtractionEvalRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocExtractionEvalRunsQuery, DocExtractionEvalRunsQueryVariables>(DocExtractionEvalRunsDocument, options);
        }
export type DocExtractionEvalRunsQueryHookResult = ReturnType<typeof useDocExtractionEvalRunsQuery>;
export type DocExtractionEvalRunsLazyQueryHookResult = ReturnType<typeof useDocExtractionEvalRunsLazyQuery>;
export type DocExtractionEvalRunsSuspenseQueryHookResult = ReturnType<typeof useDocExtractionEvalRunsSuspenseQuery>;
export type DocExtractionEvalRunsQueryResult = Apollo.QueryResult<DocExtractionEvalRunsQuery, DocExtractionEvalRunsQueryVariables>;
export const DocExtractionEvalSetDocument = gql`
    query docExtractionEvalSet($id: String!) {
  docExtractionEvalSet(id: $id) {
    ...EvalSetFields
  }
}
    ${EvalSetFieldsFragmentDoc}`;

/**
 * __useDocExtractionEvalSetQuery__
 *
 * To run a query within a React component, call `useDocExtractionEvalSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocExtractionEvalSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocExtractionEvalSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocExtractionEvalSetQuery(baseOptions: Apollo.QueryHookOptions<DocExtractionEvalSetQuery, DocExtractionEvalSetQueryVariables> & ({ variables: DocExtractionEvalSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocExtractionEvalSetQuery, DocExtractionEvalSetQueryVariables>(DocExtractionEvalSetDocument, options);
      }
export function useDocExtractionEvalSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocExtractionEvalSetQuery, DocExtractionEvalSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocExtractionEvalSetQuery, DocExtractionEvalSetQueryVariables>(DocExtractionEvalSetDocument, options);
        }
export function useDocExtractionEvalSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocExtractionEvalSetQuery, DocExtractionEvalSetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocExtractionEvalSetQuery, DocExtractionEvalSetQueryVariables>(DocExtractionEvalSetDocument, options);
        }
export type DocExtractionEvalSetQueryHookResult = ReturnType<typeof useDocExtractionEvalSetQuery>;
export type DocExtractionEvalSetLazyQueryHookResult = ReturnType<typeof useDocExtractionEvalSetLazyQuery>;
export type DocExtractionEvalSetSuspenseQueryHookResult = ReturnType<typeof useDocExtractionEvalSetSuspenseQuery>;
export type DocExtractionEvalSetQueryResult = Apollo.QueryResult<DocExtractionEvalSetQuery, DocExtractionEvalSetQueryVariables>;
export const DocExtractionEvalSetsDocument = gql`
    query docExtractionEvalSets($limit: Int) {
  docExtractionEvalSets(limit: $limit) {
    ...EvalSetFields
  }
}
    ${EvalSetFieldsFragmentDoc}`;

/**
 * __useDocExtractionEvalSetsQuery__
 *
 * To run a query within a React component, call `useDocExtractionEvalSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocExtractionEvalSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocExtractionEvalSetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDocExtractionEvalSetsQuery(baseOptions?: Apollo.QueryHookOptions<DocExtractionEvalSetsQuery, DocExtractionEvalSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocExtractionEvalSetsQuery, DocExtractionEvalSetsQueryVariables>(DocExtractionEvalSetsDocument, options);
      }
export function useDocExtractionEvalSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocExtractionEvalSetsQuery, DocExtractionEvalSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocExtractionEvalSetsQuery, DocExtractionEvalSetsQueryVariables>(DocExtractionEvalSetsDocument, options);
        }
export function useDocExtractionEvalSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocExtractionEvalSetsQuery, DocExtractionEvalSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocExtractionEvalSetsQuery, DocExtractionEvalSetsQueryVariables>(DocExtractionEvalSetsDocument, options);
        }
export type DocExtractionEvalSetsQueryHookResult = ReturnType<typeof useDocExtractionEvalSetsQuery>;
export type DocExtractionEvalSetsLazyQueryHookResult = ReturnType<typeof useDocExtractionEvalSetsLazyQuery>;
export type DocExtractionEvalSetsSuspenseQueryHookResult = ReturnType<typeof useDocExtractionEvalSetsSuspenseQuery>;
export type DocExtractionEvalSetsQueryResult = Apollo.QueryResult<DocExtractionEvalSetsQuery, DocExtractionEvalSetsQueryVariables>;
export const PreviewDocExtractionEvalSetDocument = gql`
    mutation previewDocExtractionEvalSet($config: JSON!) {
  previewDocExtractionEvalSet(config: $config) {
    totalCandidates
    selectedCount
    strata
    sampleDocumentIds
    poolCutoffAt
  }
}
    `;
export type PreviewDocExtractionEvalSetMutationFn = Apollo.MutationFunction<PreviewDocExtractionEvalSetMutation, PreviewDocExtractionEvalSetMutationVariables>;

/**
 * __usePreviewDocExtractionEvalSetMutation__
 *
 * To run a mutation, you first call `usePreviewDocExtractionEvalSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewDocExtractionEvalSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewDocExtractionEvalSetMutation, { data, loading, error }] = usePreviewDocExtractionEvalSetMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function usePreviewDocExtractionEvalSetMutation(baseOptions?: Apollo.MutationHookOptions<PreviewDocExtractionEvalSetMutation, PreviewDocExtractionEvalSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewDocExtractionEvalSetMutation, PreviewDocExtractionEvalSetMutationVariables>(PreviewDocExtractionEvalSetDocument, options);
      }
export type PreviewDocExtractionEvalSetMutationHookResult = ReturnType<typeof usePreviewDocExtractionEvalSetMutation>;
export type PreviewDocExtractionEvalSetMutationResult = Apollo.MutationResult<PreviewDocExtractionEvalSetMutation>;
export type PreviewDocExtractionEvalSetMutationOptions = Apollo.BaseMutationOptions<PreviewDocExtractionEvalSetMutation, PreviewDocExtractionEvalSetMutationVariables>;
export const GeneratePreSignedPutUrlDocument = gql`
    mutation generatePreSignedPutUrl($filename: String!, $filetype: String!) {
  generatePreSignedPutUrl(fileName: $filename, fileType: $filetype)
}
    `;
export type GeneratePreSignedPutUrlMutationFn = Apollo.MutationFunction<GeneratePreSignedPutUrlMutation, GeneratePreSignedPutUrlMutationVariables>;

/**
 * __useGeneratePreSignedPutUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePreSignedPutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePreSignedPutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePreSignedPutUrlMutation, { data, loading, error }] = useGeneratePreSignedPutUrlMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *      filetype: // value for 'filetype'
 *   },
 * });
 */
export function useGeneratePreSignedPutUrlMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePreSignedPutUrlMutation, GeneratePreSignedPutUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePreSignedPutUrlMutation, GeneratePreSignedPutUrlMutationVariables>(GeneratePreSignedPutUrlDocument, options);
      }
export type GeneratePreSignedPutUrlMutationHookResult = ReturnType<typeof useGeneratePreSignedPutUrlMutation>;
export type GeneratePreSignedPutUrlMutationResult = Apollo.MutationResult<GeneratePreSignedPutUrlMutation>;
export type GeneratePreSignedPutUrlMutationOptions = Apollo.BaseMutationOptions<GeneratePreSignedPutUrlMutation, GeneratePreSignedPutUrlMutationVariables>;
export const EdiTransactionsByCompanyDocument = gql`
    query ediTransactionsByCompany($companyUuid: String!, $first: Int, $after: String, $last: Int, $before: String) {
  ediTransactionsByCompany(
    companyUuid: $companyUuid
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    edges {
      node {
        ...EdiTransactionFragment
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${EdiTransactionFragmentFragmentDoc}`;

/**
 * __useEdiTransactionsByCompanyQuery__
 *
 * To run a query within a React component, call `useEdiTransactionsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdiTransactionsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdiTransactionsByCompanyQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useEdiTransactionsByCompanyQuery(baseOptions: Apollo.QueryHookOptions<EdiTransactionsByCompanyQuery, EdiTransactionsByCompanyQueryVariables> & ({ variables: EdiTransactionsByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdiTransactionsByCompanyQuery, EdiTransactionsByCompanyQueryVariables>(EdiTransactionsByCompanyDocument, options);
      }
export function useEdiTransactionsByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdiTransactionsByCompanyQuery, EdiTransactionsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdiTransactionsByCompanyQuery, EdiTransactionsByCompanyQueryVariables>(EdiTransactionsByCompanyDocument, options);
        }
export function useEdiTransactionsByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdiTransactionsByCompanyQuery, EdiTransactionsByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdiTransactionsByCompanyQuery, EdiTransactionsByCompanyQueryVariables>(EdiTransactionsByCompanyDocument, options);
        }
export type EdiTransactionsByCompanyQueryHookResult = ReturnType<typeof useEdiTransactionsByCompanyQuery>;
export type EdiTransactionsByCompanyLazyQueryHookResult = ReturnType<typeof useEdiTransactionsByCompanyLazyQuery>;
export type EdiTransactionsByCompanySuspenseQueryHookResult = ReturnType<typeof useEdiTransactionsByCompanySuspenseQuery>;
export type EdiTransactionsByCompanyQueryResult = Apollo.QueryResult<EdiTransactionsByCompanyQuery, EdiTransactionsByCompanyQueryVariables>;
export const GetXyTransformDocument = gql`
    query getXYTransform($getXyTransformInput: GetXyTransformInput!) {
  getXYTransform(getXyTransformInput: $getXyTransformInput) {
    xMin
    yMin
    yTranslation
    xTranslation
    yScale
    xScale
    rotation
  }
}
    `;

/**
 * __useGetXyTransformQuery__
 *
 * To run a query within a React component, call `useGetXyTransformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetXyTransformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetXyTransformQuery({
 *   variables: {
 *      getXyTransformInput: // value for 'getXyTransformInput'
 *   },
 * });
 */
export function useGetXyTransformQuery(baseOptions: Apollo.QueryHookOptions<GetXyTransformQuery, GetXyTransformQueryVariables> & ({ variables: GetXyTransformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetXyTransformQuery, GetXyTransformQueryVariables>(GetXyTransformDocument, options);
      }
export function useGetXyTransformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetXyTransformQuery, GetXyTransformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetXyTransformQuery, GetXyTransformQueryVariables>(GetXyTransformDocument, options);
        }
export function useGetXyTransformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetXyTransformQuery, GetXyTransformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetXyTransformQuery, GetXyTransformQueryVariables>(GetXyTransformDocument, options);
        }
export type GetXyTransformQueryHookResult = ReturnType<typeof useGetXyTransformQuery>;
export type GetXyTransformLazyQueryHookResult = ReturnType<typeof useGetXyTransformLazyQuery>;
export type GetXyTransformSuspenseQueryHookResult = ReturnType<typeof useGetXyTransformSuspenseQuery>;
export type GetXyTransformQueryResult = Apollo.QueryResult<GetXyTransformQuery, GetXyTransformQueryVariables>;
export const ImportTestSnapshotDocument = gql`
    mutation importTestSnapshot($importTestSnapshotInput: ImportTestSnapshotInput!) {
  importTestSnapshot(importTestSnapshotInput: $importTestSnapshotInput)
}
    `;
export type ImportTestSnapshotMutationFn = Apollo.MutationFunction<ImportTestSnapshotMutation, ImportTestSnapshotMutationVariables>;

/**
 * __useImportTestSnapshotMutation__
 *
 * To run a mutation, you first call `useImportTestSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTestSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTestSnapshotMutation, { data, loading, error }] = useImportTestSnapshotMutation({
 *   variables: {
 *      importTestSnapshotInput: // value for 'importTestSnapshotInput'
 *   },
 * });
 */
export function useImportTestSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<ImportTestSnapshotMutation, ImportTestSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportTestSnapshotMutation, ImportTestSnapshotMutationVariables>(ImportTestSnapshotDocument, options);
      }
export type ImportTestSnapshotMutationHookResult = ReturnType<typeof useImportTestSnapshotMutation>;
export type ImportTestSnapshotMutationResult = Apollo.MutationResult<ImportTestSnapshotMutation>;
export type ImportTestSnapshotMutationOptions = Apollo.BaseMutationOptions<ImportTestSnapshotMutation, ImportTestSnapshotMutationVariables>;
export const AdhocPreviewBatchDocument = gql`
    query adhocPreviewBatch($id: String!) {
  adhocPreviewBatch(id: $id) {
    id
    status
    companyUuid
    memberCount
    aggregateInputTokens
    aggregateOutputTokens
    aggregateCostUsd
    members {
      position
      fileName
      adhocRunId
      dispatchError
      runStatus
      error
      applyPlan {
        billingParty {
          mechanism
          contactUuid
          senderVerdict
        }
        service {
          mechanism
          serviceId
        }
        deadlineType {
          mechanism
          value
        }
        duplicate {
          isDuplicate
          duplicateOrderUuid
          wouldAdoptOrphanUuid
        }
      }
    }
  }
}
    `;

/**
 * __useAdhocPreviewBatchQuery__
 *
 * To run a query within a React component, call `useAdhocPreviewBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdhocPreviewBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdhocPreviewBatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdhocPreviewBatchQuery(baseOptions: Apollo.QueryHookOptions<AdhocPreviewBatchQuery, AdhocPreviewBatchQueryVariables> & ({ variables: AdhocPreviewBatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdhocPreviewBatchQuery, AdhocPreviewBatchQueryVariables>(AdhocPreviewBatchDocument, options);
      }
export function useAdhocPreviewBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdhocPreviewBatchQuery, AdhocPreviewBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdhocPreviewBatchQuery, AdhocPreviewBatchQueryVariables>(AdhocPreviewBatchDocument, options);
        }
export function useAdhocPreviewBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdhocPreviewBatchQuery, AdhocPreviewBatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdhocPreviewBatchQuery, AdhocPreviewBatchQueryVariables>(AdhocPreviewBatchDocument, options);
        }
export type AdhocPreviewBatchQueryHookResult = ReturnType<typeof useAdhocPreviewBatchQuery>;
export type AdhocPreviewBatchLazyQueryHookResult = ReturnType<typeof useAdhocPreviewBatchLazyQuery>;
export type AdhocPreviewBatchSuspenseQueryHookResult = ReturnType<typeof useAdhocPreviewBatchSuspenseQuery>;
export type AdhocPreviewBatchQueryResult = Apollo.QueryResult<AdhocPreviewBatchQuery, AdhocPreviewBatchQueryVariables>;
export const AdhocPreviewResultDocument = gql`
    query adhocPreviewResult($id: String!) {
  adhocPreviewResult(id: $id) {
    runId
    status
    error
    companyUuid
    extractedFields
    usage
    exemplars {
      documentId
      documentType
      source
      cosineSimilarity
      fieldValues
    }
    applyPlan {
      billingParty {
        mechanism
        contactUuid
        senderVerdict
      }
      service {
        mechanism
        serviceId
      }
      deadlineType {
        mechanism
        value
      }
      duplicate {
        isDuplicate
        duplicateOrderUuid
        wouldAdoptOrphanUuid
      }
    }
  }
}
    `;

/**
 * __useAdhocPreviewResultQuery__
 *
 * To run a query within a React component, call `useAdhocPreviewResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdhocPreviewResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdhocPreviewResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdhocPreviewResultQuery(baseOptions: Apollo.QueryHookOptions<AdhocPreviewResultQuery, AdhocPreviewResultQueryVariables> & ({ variables: AdhocPreviewResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdhocPreviewResultQuery, AdhocPreviewResultQueryVariables>(AdhocPreviewResultDocument, options);
      }
export function useAdhocPreviewResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdhocPreviewResultQuery, AdhocPreviewResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdhocPreviewResultQuery, AdhocPreviewResultQueryVariables>(AdhocPreviewResultDocument, options);
        }
export function useAdhocPreviewResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdhocPreviewResultQuery, AdhocPreviewResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdhocPreviewResultQuery, AdhocPreviewResultQueryVariables>(AdhocPreviewResultDocument, options);
        }
export type AdhocPreviewResultQueryHookResult = ReturnType<typeof useAdhocPreviewResultQuery>;
export type AdhocPreviewResultLazyQueryHookResult = ReturnType<typeof useAdhocPreviewResultLazyQuery>;
export type AdhocPreviewResultSuspenseQueryHookResult = ReturnType<typeof useAdhocPreviewResultSuspenseQuery>;
export type AdhocPreviewResultQueryResult = Apollo.QueryResult<AdhocPreviewResultQuery, AdhocPreviewResultQueryVariables>;
export const AdhocPreviewWordBoxesDocument = gql`
    query adhocPreviewWordBoxes($id: String!) {
  adhocPreviewWordBoxes(id: $id) {
    pages {
      pageNumber
      textSource
      words {
        text
        confidence
        left
        top
        width
        height
      }
    }
  }
}
    `;

/**
 * __useAdhocPreviewWordBoxesQuery__
 *
 * To run a query within a React component, call `useAdhocPreviewWordBoxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdhocPreviewWordBoxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdhocPreviewWordBoxesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdhocPreviewWordBoxesQuery(baseOptions: Apollo.QueryHookOptions<AdhocPreviewWordBoxesQuery, AdhocPreviewWordBoxesQueryVariables> & ({ variables: AdhocPreviewWordBoxesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdhocPreviewWordBoxesQuery, AdhocPreviewWordBoxesQueryVariables>(AdhocPreviewWordBoxesDocument, options);
      }
export function useAdhocPreviewWordBoxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdhocPreviewWordBoxesQuery, AdhocPreviewWordBoxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdhocPreviewWordBoxesQuery, AdhocPreviewWordBoxesQueryVariables>(AdhocPreviewWordBoxesDocument, options);
        }
export function useAdhocPreviewWordBoxesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdhocPreviewWordBoxesQuery, AdhocPreviewWordBoxesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdhocPreviewWordBoxesQuery, AdhocPreviewWordBoxesQueryVariables>(AdhocPreviewWordBoxesDocument, options);
        }
export type AdhocPreviewWordBoxesQueryHookResult = ReturnType<typeof useAdhocPreviewWordBoxesQuery>;
export type AdhocPreviewWordBoxesLazyQueryHookResult = ReturnType<typeof useAdhocPreviewWordBoxesLazyQuery>;
export type AdhocPreviewWordBoxesSuspenseQueryHookResult = ReturnType<typeof useAdhocPreviewWordBoxesSuspenseQuery>;
export type AdhocPreviewWordBoxesQueryResult = Apollo.QueryResult<AdhocPreviewWordBoxesQuery, AdhocPreviewWordBoxesQueryVariables>;
export const CreateIngestionTestUploadDocument = gql`
    mutation createIngestionTestUpload($input: CreateIngestionTestUploadInput!) {
  createIngestionTestUpload(input: $input) {
    uploadId
    bucket
    key
    uploadUrl
  }
}
    `;
export type CreateIngestionTestUploadMutationFn = Apollo.MutationFunction<CreateIngestionTestUploadMutation, CreateIngestionTestUploadMutationVariables>;

/**
 * __useCreateIngestionTestUploadMutation__
 *
 * To run a mutation, you first call `useCreateIngestionTestUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIngestionTestUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIngestionTestUploadMutation, { data, loading, error }] = useCreateIngestionTestUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIngestionTestUploadMutation(baseOptions?: Apollo.MutationHookOptions<CreateIngestionTestUploadMutation, CreateIngestionTestUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIngestionTestUploadMutation, CreateIngestionTestUploadMutationVariables>(CreateIngestionTestUploadDocument, options);
      }
export type CreateIngestionTestUploadMutationHookResult = ReturnType<typeof useCreateIngestionTestUploadMutation>;
export type CreateIngestionTestUploadMutationResult = Apollo.MutationResult<CreateIngestionTestUploadMutation>;
export type CreateIngestionTestUploadMutationOptions = Apollo.BaseMutationOptions<CreateIngestionTestUploadMutation, CreateIngestionTestUploadMutationVariables>;
export const TriggerAdhocPreviewBatchDocument = gql`
    mutation triggerAdhocPreviewBatch($input: TriggerAdhocPreviewBatchInput!) {
  triggerAdhocPreviewBatch(input: $input) {
    id
    status
    memberCount
  }
}
    `;
export type TriggerAdhocPreviewBatchMutationFn = Apollo.MutationFunction<TriggerAdhocPreviewBatchMutation, TriggerAdhocPreviewBatchMutationVariables>;

/**
 * __useTriggerAdhocPreviewBatchMutation__
 *
 * To run a mutation, you first call `useTriggerAdhocPreviewBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerAdhocPreviewBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerAdhocPreviewBatchMutation, { data, loading, error }] = useTriggerAdhocPreviewBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerAdhocPreviewBatchMutation(baseOptions?: Apollo.MutationHookOptions<TriggerAdhocPreviewBatchMutation, TriggerAdhocPreviewBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerAdhocPreviewBatchMutation, TriggerAdhocPreviewBatchMutationVariables>(TriggerAdhocPreviewBatchDocument, options);
      }
export type TriggerAdhocPreviewBatchMutationHookResult = ReturnType<typeof useTriggerAdhocPreviewBatchMutation>;
export type TriggerAdhocPreviewBatchMutationResult = Apollo.MutationResult<TriggerAdhocPreviewBatchMutation>;
export type TriggerAdhocPreviewBatchMutationOptions = Apollo.BaseMutationOptions<TriggerAdhocPreviewBatchMutation, TriggerAdhocPreviewBatchMutationVariables>;
export const TriggerAdhocPreviewDocument = gql`
    mutation triggerAdhocPreview($input: TriggerAdhocPreviewInput!) {
  triggerAdhocPreview(input: $input) {
    runId
    status
  }
}
    `;
export type TriggerAdhocPreviewMutationFn = Apollo.MutationFunction<TriggerAdhocPreviewMutation, TriggerAdhocPreviewMutationVariables>;

/**
 * __useTriggerAdhocPreviewMutation__
 *
 * To run a mutation, you first call `useTriggerAdhocPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerAdhocPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerAdhocPreviewMutation, { data, loading, error }] = useTriggerAdhocPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerAdhocPreviewMutation(baseOptions?: Apollo.MutationHookOptions<TriggerAdhocPreviewMutation, TriggerAdhocPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerAdhocPreviewMutation, TriggerAdhocPreviewMutationVariables>(TriggerAdhocPreviewDocument, options);
      }
export type TriggerAdhocPreviewMutationHookResult = ReturnType<typeof useTriggerAdhocPreviewMutation>;
export type TriggerAdhocPreviewMutationResult = Apollo.MutationResult<TriggerAdhocPreviewMutation>;
export type TriggerAdhocPreviewMutationOptions = Apollo.BaseMutationOptions<TriggerAdhocPreviewMutation, TriggerAdhocPreviewMutationVariables>;
export const IngestionTestRunDocument = gql`
    query ingestionTestRun($id: String!) {
  ingestionTestRun(id: $id) {
    id
    mode
    state
    companyUuid
    actorEmail
    correlationId
    emailContext
    extractedFields
    applyPlan
    appliedResults {
      resultUuid
      status
      orderUuid
      duplicateOfOrderUuid
      applyPlan
      pageStart
      pageEnd
    }
    exemplarMarker
    usage
    error
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useIngestionTestRunQuery__
 *
 * To run a query within a React component, call `useIngestionTestRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngestionTestRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionTestRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIngestionTestRunQuery(baseOptions: Apollo.QueryHookOptions<IngestionTestRunQuery, IngestionTestRunQueryVariables> & ({ variables: IngestionTestRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IngestionTestRunQuery, IngestionTestRunQueryVariables>(IngestionTestRunDocument, options);
      }
export function useIngestionTestRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IngestionTestRunQuery, IngestionTestRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IngestionTestRunQuery, IngestionTestRunQueryVariables>(IngestionTestRunDocument, options);
        }
export function useIngestionTestRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IngestionTestRunQuery, IngestionTestRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IngestionTestRunQuery, IngestionTestRunQueryVariables>(IngestionTestRunDocument, options);
        }
export type IngestionTestRunQueryHookResult = ReturnType<typeof useIngestionTestRunQuery>;
export type IngestionTestRunLazyQueryHookResult = ReturnType<typeof useIngestionTestRunLazyQuery>;
export type IngestionTestRunSuspenseQueryHookResult = ReturnType<typeof useIngestionTestRunSuspenseQuery>;
export type IngestionTestRunQueryResult = Apollo.QueryResult<IngestionTestRunQuery, IngestionTestRunQueryVariables>;
export const TriggerIngestionTestRunDocument = gql`
    mutation triggerIngestionTestRun($input: TriggerIngestionTestRunInput!) {
  triggerIngestionTestRun(input: $input) {
    id
    mode
    state
    correlationId
    createdAt
    error
  }
}
    `;
export type TriggerIngestionTestRunMutationFn = Apollo.MutationFunction<TriggerIngestionTestRunMutation, TriggerIngestionTestRunMutationVariables>;

/**
 * __useTriggerIngestionTestRunMutation__
 *
 * To run a mutation, you first call `useTriggerIngestionTestRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerIngestionTestRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerIngestionTestRunMutation, { data, loading, error }] = useTriggerIngestionTestRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerIngestionTestRunMutation(baseOptions?: Apollo.MutationHookOptions<TriggerIngestionTestRunMutation, TriggerIngestionTestRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerIngestionTestRunMutation, TriggerIngestionTestRunMutationVariables>(TriggerIngestionTestRunDocument, options);
      }
export type TriggerIngestionTestRunMutationHookResult = ReturnType<typeof useTriggerIngestionTestRunMutation>;
export type TriggerIngestionTestRunMutationResult = Apollo.MutationResult<TriggerIngestionTestRunMutation>;
export type TriggerIngestionTestRunMutationOptions = Apollo.BaseMutationOptions<TriggerIngestionTestRunMutation, TriggerIngestionTestRunMutationVariables>;
export const LoginInternalDocument = gql`
    mutation loginInternal($loginInputData: LoginInput!) {
  loginInternal(loginInputData: $loginInputData) {
    status
    fullAccessUser {
      uuid
    }
  }
}
    `;
export type LoginInternalMutationFn = Apollo.MutationFunction<LoginInternalMutation, LoginInternalMutationVariables>;

/**
 * __useLoginInternalMutation__
 *
 * To run a mutation, you first call `useLoginInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginInternalMutation, { data, loading, error }] = useLoginInternalMutation({
 *   variables: {
 *      loginInputData: // value for 'loginInputData'
 *   },
 * });
 */
export function useLoginInternalMutation(baseOptions?: Apollo.MutationHookOptions<LoginInternalMutation, LoginInternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginInternalMutation, LoginInternalMutationVariables>(LoginInternalDocument, options);
      }
export type LoginInternalMutationHookResult = ReturnType<typeof useLoginInternalMutation>;
export type LoginInternalMutationResult = Apollo.MutationResult<LoginInternalMutation>;
export type LoginInternalMutationOptions = Apollo.BaseMutationOptions<LoginInternalMutation, LoginInternalMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MeDocument = gql`
    query me {
  me {
    email
    uuid
    company {
      ...MeCompany
    }
  }
}
    ${MeCompanyFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const NormalizeDocumentDocument = gql`
    mutation normalizeDocument($normalizeDocumentInput: NormalizeDocumentInput!) {
  normalizeDocument(normalizeDocumentInput: $normalizeDocumentInput)
}
    `;
export type NormalizeDocumentMutationFn = Apollo.MutationFunction<NormalizeDocumentMutation, NormalizeDocumentMutationVariables>;

/**
 * __useNormalizeDocumentMutation__
 *
 * To run a mutation, you first call `useNormalizeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNormalizeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [normalizeDocumentMutation, { data, loading, error }] = useNormalizeDocumentMutation({
 *   variables: {
 *      normalizeDocumentInput: // value for 'normalizeDocumentInput'
 *   },
 * });
 */
export function useNormalizeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<NormalizeDocumentMutation, NormalizeDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NormalizeDocumentMutation, NormalizeDocumentMutationVariables>(NormalizeDocumentDocument, options);
      }
export type NormalizeDocumentMutationHookResult = ReturnType<typeof useNormalizeDocumentMutation>;
export type NormalizeDocumentMutationResult = Apollo.MutationResult<NormalizeDocumentMutation>;
export type NormalizeDocumentMutationOptions = Apollo.BaseMutationOptions<NormalizeDocumentMutation, NormalizeDocumentMutationVariables>;
export const NotificationCutoverConfigsDocument = gql`
    query notificationCutoverConfigs {
  notificationCutoverConfigs {
    ...NotificationCutoverConfigFields
  }
}
    ${NotificationCutoverConfigFieldsFragmentDoc}`;

/**
 * __useNotificationCutoverConfigsQuery__
 *
 * To run a query within a React component, call `useNotificationCutoverConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCutoverConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCutoverConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationCutoverConfigsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationCutoverConfigsQuery, NotificationCutoverConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationCutoverConfigsQuery, NotificationCutoverConfigsQueryVariables>(NotificationCutoverConfigsDocument, options);
      }
export function useNotificationCutoverConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationCutoverConfigsQuery, NotificationCutoverConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationCutoverConfigsQuery, NotificationCutoverConfigsQueryVariables>(NotificationCutoverConfigsDocument, options);
        }
export function useNotificationCutoverConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationCutoverConfigsQuery, NotificationCutoverConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationCutoverConfigsQuery, NotificationCutoverConfigsQueryVariables>(NotificationCutoverConfigsDocument, options);
        }
export type NotificationCutoverConfigsQueryHookResult = ReturnType<typeof useNotificationCutoverConfigsQuery>;
export type NotificationCutoverConfigsLazyQueryHookResult = ReturnType<typeof useNotificationCutoverConfigsLazyQuery>;
export type NotificationCutoverConfigsSuspenseQueryHookResult = ReturnType<typeof useNotificationCutoverConfigsSuspenseQuery>;
export type NotificationCutoverConfigsQueryResult = Apollo.QueryResult<NotificationCutoverConfigsQuery, NotificationCutoverConfigsQueryVariables>;
export const SetNotificationCutoverModeDocument = gql`
    mutation setNotificationCutoverMode($input: SetNotificationCutoverModeInput!) {
  setNotificationCutoverMode(input: $input) {
    eventType
    mode
    fullEligible
  }
}
    `;
export type SetNotificationCutoverModeMutationFn = Apollo.MutationFunction<SetNotificationCutoverModeMutation, SetNotificationCutoverModeMutationVariables>;

/**
 * __useSetNotificationCutoverModeMutation__
 *
 * To run a mutation, you first call `useSetNotificationCutoverModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationCutoverModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationCutoverModeMutation, { data, loading, error }] = useSetNotificationCutoverModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetNotificationCutoverModeMutation(baseOptions?: Apollo.MutationHookOptions<SetNotificationCutoverModeMutation, SetNotificationCutoverModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNotificationCutoverModeMutation, SetNotificationCutoverModeMutationVariables>(SetNotificationCutoverModeDocument, options);
      }
export type SetNotificationCutoverModeMutationHookResult = ReturnType<typeof useSetNotificationCutoverModeMutation>;
export type SetNotificationCutoverModeMutationResult = Apollo.MutationResult<SetNotificationCutoverModeMutation>;
export type SetNotificationCutoverModeMutationOptions = Apollo.BaseMutationOptions<SetNotificationCutoverModeMutation, SetNotificationCutoverModeMutationVariables>;
export const NotificationShadowComparisonsDocument = gql`
    query notificationShadowComparisons($filter: NotificationShadowComparisonFilterInput) {
  notificationShadowComparisons(filter: $filter) {
    uuid
    eventType
    channel
    status
    sourceRef
    mismatchedFields
    companyUuid
    hasLegacyContent
    hasEngineContent
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNotificationShadowComparisonsQuery__
 *
 * To run a query within a React component, call `useNotificationShadowComparisonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationShadowComparisonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationShadowComparisonsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNotificationShadowComparisonsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationShadowComparisonsQuery, NotificationShadowComparisonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationShadowComparisonsQuery, NotificationShadowComparisonsQueryVariables>(NotificationShadowComparisonsDocument, options);
      }
export function useNotificationShadowComparisonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationShadowComparisonsQuery, NotificationShadowComparisonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationShadowComparisonsQuery, NotificationShadowComparisonsQueryVariables>(NotificationShadowComparisonsDocument, options);
        }
export function useNotificationShadowComparisonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationShadowComparisonsQuery, NotificationShadowComparisonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationShadowComparisonsQuery, NotificationShadowComparisonsQueryVariables>(NotificationShadowComparisonsDocument, options);
        }
export type NotificationShadowComparisonsQueryHookResult = ReturnType<typeof useNotificationShadowComparisonsQuery>;
export type NotificationShadowComparisonsLazyQueryHookResult = ReturnType<typeof useNotificationShadowComparisonsLazyQuery>;
export type NotificationShadowComparisonsSuspenseQueryHookResult = ReturnType<typeof useNotificationShadowComparisonsSuspenseQuery>;
export type NotificationShadowComparisonsQueryResult = Apollo.QueryResult<NotificationShadowComparisonsQuery, NotificationShadowComparisonsQueryVariables>;
export const NotificationShadowComparisonSummaryDocument = gql`
    query notificationShadowComparisonSummary($filter: NotificationShadowComparisonFilterInput) {
  notificationShadowComparisonSummary(filter: $filter) {
    status
    count
  }
}
    `;

/**
 * __useNotificationShadowComparisonSummaryQuery__
 *
 * To run a query within a React component, call `useNotificationShadowComparisonSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationShadowComparisonSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationShadowComparisonSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNotificationShadowComparisonSummaryQuery(baseOptions?: Apollo.QueryHookOptions<NotificationShadowComparisonSummaryQuery, NotificationShadowComparisonSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationShadowComparisonSummaryQuery, NotificationShadowComparisonSummaryQueryVariables>(NotificationShadowComparisonSummaryDocument, options);
      }
export function useNotificationShadowComparisonSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationShadowComparisonSummaryQuery, NotificationShadowComparisonSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationShadowComparisonSummaryQuery, NotificationShadowComparisonSummaryQueryVariables>(NotificationShadowComparisonSummaryDocument, options);
        }
export function useNotificationShadowComparisonSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationShadowComparisonSummaryQuery, NotificationShadowComparisonSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationShadowComparisonSummaryQuery, NotificationShadowComparisonSummaryQueryVariables>(NotificationShadowComparisonSummaryDocument, options);
        }
export type NotificationShadowComparisonSummaryQueryHookResult = ReturnType<typeof useNotificationShadowComparisonSummaryQuery>;
export type NotificationShadowComparisonSummaryLazyQueryHookResult = ReturnType<typeof useNotificationShadowComparisonSummaryLazyQuery>;
export type NotificationShadowComparisonSummarySuspenseQueryHookResult = ReturnType<typeof useNotificationShadowComparisonSummarySuspenseQuery>;
export type NotificationShadowComparisonSummaryQueryResult = Apollo.QueryResult<NotificationShadowComparisonSummaryQuery, NotificationShadowComparisonSummaryQueryVariables>;
export const OrderMirrorCaptureConfigDocument = gql`
    query OrderMirrorCaptureConfig {
  orderMirrorCaptureConfig {
    mode
    companies {
      companyUuid
      companyName
    }
  }
}
    `;

/**
 * __useOrderMirrorCaptureConfigQuery__
 *
 * To run a query within a React component, call `useOrderMirrorCaptureConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderMirrorCaptureConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderMirrorCaptureConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderMirrorCaptureConfigQuery(baseOptions?: Apollo.QueryHookOptions<OrderMirrorCaptureConfigQuery, OrderMirrorCaptureConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderMirrorCaptureConfigQuery, OrderMirrorCaptureConfigQueryVariables>(OrderMirrorCaptureConfigDocument, options);
      }
export function useOrderMirrorCaptureConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderMirrorCaptureConfigQuery, OrderMirrorCaptureConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderMirrorCaptureConfigQuery, OrderMirrorCaptureConfigQueryVariables>(OrderMirrorCaptureConfigDocument, options);
        }
export function useOrderMirrorCaptureConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderMirrorCaptureConfigQuery, OrderMirrorCaptureConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderMirrorCaptureConfigQuery, OrderMirrorCaptureConfigQueryVariables>(OrderMirrorCaptureConfigDocument, options);
        }
export type OrderMirrorCaptureConfigQueryHookResult = ReturnType<typeof useOrderMirrorCaptureConfigQuery>;
export type OrderMirrorCaptureConfigLazyQueryHookResult = ReturnType<typeof useOrderMirrorCaptureConfigLazyQuery>;
export type OrderMirrorCaptureConfigSuspenseQueryHookResult = ReturnType<typeof useOrderMirrorCaptureConfigSuspenseQuery>;
export type OrderMirrorCaptureConfigQueryResult = Apollo.QueryResult<OrderMirrorCaptureConfigQuery, OrderMirrorCaptureConfigQueryVariables>;
export const ClearOrderMirrorOutboxDocument = gql`
    mutation ClearOrderMirrorOutbox {
  clearOrderMirrorOutbox
}
    `;
export type ClearOrderMirrorOutboxMutationFn = Apollo.MutationFunction<ClearOrderMirrorOutboxMutation, ClearOrderMirrorOutboxMutationVariables>;

/**
 * __useClearOrderMirrorOutboxMutation__
 *
 * To run a mutation, you first call `useClearOrderMirrorOutboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearOrderMirrorOutboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearOrderMirrorOutboxMutation, { data, loading, error }] = useClearOrderMirrorOutboxMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearOrderMirrorOutboxMutation(baseOptions?: Apollo.MutationHookOptions<ClearOrderMirrorOutboxMutation, ClearOrderMirrorOutboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearOrderMirrorOutboxMutation, ClearOrderMirrorOutboxMutationVariables>(ClearOrderMirrorOutboxDocument, options);
      }
export type ClearOrderMirrorOutboxMutationHookResult = ReturnType<typeof useClearOrderMirrorOutboxMutation>;
export type ClearOrderMirrorOutboxMutationResult = Apollo.MutationResult<ClearOrderMirrorOutboxMutation>;
export type ClearOrderMirrorOutboxMutationOptions = Apollo.BaseMutationOptions<ClearOrderMirrorOutboxMutation, ClearOrderMirrorOutboxMutationVariables>;
export const CreateMirrorTargetDocument = gql`
    mutation CreateMirrorTarget($input: CreateMirrorTargetInput!) {
  createMirrorTarget(input: $input) {
    uuid
  }
}
    `;
export type CreateMirrorTargetMutationFn = Apollo.MutationFunction<CreateMirrorTargetMutation, CreateMirrorTargetMutationVariables>;

/**
 * __useCreateMirrorTargetMutation__
 *
 * To run a mutation, you first call `useCreateMirrorTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMirrorTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMirrorTargetMutation, { data, loading, error }] = useCreateMirrorTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMirrorTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreateMirrorTargetMutation, CreateMirrorTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMirrorTargetMutation, CreateMirrorTargetMutationVariables>(CreateMirrorTargetDocument, options);
      }
export type CreateMirrorTargetMutationHookResult = ReturnType<typeof useCreateMirrorTargetMutation>;
export type CreateMirrorTargetMutationResult = Apollo.MutationResult<CreateMirrorTargetMutation>;
export type CreateMirrorTargetMutationOptions = Apollo.BaseMutationOptions<CreateMirrorTargetMutation, CreateMirrorTargetMutationVariables>;
export const DeleteMirrorTargetDocument = gql`
    mutation DeleteMirrorTarget($uuid: String!) {
  deleteMirrorTarget(uuid: $uuid)
}
    `;
export type DeleteMirrorTargetMutationFn = Apollo.MutationFunction<DeleteMirrorTargetMutation, DeleteMirrorTargetMutationVariables>;

/**
 * __useDeleteMirrorTargetMutation__
 *
 * To run a mutation, you first call `useDeleteMirrorTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMirrorTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMirrorTargetMutation, { data, loading, error }] = useDeleteMirrorTargetMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteMirrorTargetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMirrorTargetMutation, DeleteMirrorTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMirrorTargetMutation, DeleteMirrorTargetMutationVariables>(DeleteMirrorTargetDocument, options);
      }
export type DeleteMirrorTargetMutationHookResult = ReturnType<typeof useDeleteMirrorTargetMutation>;
export type DeleteMirrorTargetMutationResult = Apollo.MutationResult<DeleteMirrorTargetMutation>;
export type DeleteMirrorTargetMutationOptions = Apollo.BaseMutationOptions<DeleteMirrorTargetMutation, DeleteMirrorTargetMutationVariables>;
export const MirrorAdminAllCompaniesDocument = gql`
    query MirrorAdminAllCompanies {
  companies {
    uuid
    name
  }
}
    `;

/**
 * __useMirrorAdminAllCompaniesQuery__
 *
 * To run a query within a React component, call `useMirrorAdminAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMirrorAdminAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMirrorAdminAllCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMirrorAdminAllCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<MirrorAdminAllCompaniesQuery, MirrorAdminAllCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MirrorAdminAllCompaniesQuery, MirrorAdminAllCompaniesQueryVariables>(MirrorAdminAllCompaniesDocument, options);
      }
export function useMirrorAdminAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MirrorAdminAllCompaniesQuery, MirrorAdminAllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MirrorAdminAllCompaniesQuery, MirrorAdminAllCompaniesQueryVariables>(MirrorAdminAllCompaniesDocument, options);
        }
export function useMirrorAdminAllCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MirrorAdminAllCompaniesQuery, MirrorAdminAllCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MirrorAdminAllCompaniesQuery, MirrorAdminAllCompaniesQueryVariables>(MirrorAdminAllCompaniesDocument, options);
        }
export type MirrorAdminAllCompaniesQueryHookResult = ReturnType<typeof useMirrorAdminAllCompaniesQuery>;
export type MirrorAdminAllCompaniesLazyQueryHookResult = ReturnType<typeof useMirrorAdminAllCompaniesLazyQuery>;
export type MirrorAdminAllCompaniesSuspenseQueryHookResult = ReturnType<typeof useMirrorAdminAllCompaniesSuspenseQuery>;
export type MirrorAdminAllCompaniesQueryResult = Apollo.QueryResult<MirrorAdminAllCompaniesQuery, MirrorAdminAllCompaniesQueryVariables>;
export const MirrorTargetCompaniesDocument = gql`
    query MirrorTargetCompanies($targetUuid: String!) {
  mirrorTargetCompanies(targetUuid: $targetUuid) {
    companyUuid
    companyName
    enabled
  }
}
    `;

/**
 * __useMirrorTargetCompaniesQuery__
 *
 * To run a query within a React component, call `useMirrorTargetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMirrorTargetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMirrorTargetCompaniesQuery({
 *   variables: {
 *      targetUuid: // value for 'targetUuid'
 *   },
 * });
 */
export function useMirrorTargetCompaniesQuery(baseOptions: Apollo.QueryHookOptions<MirrorTargetCompaniesQuery, MirrorTargetCompaniesQueryVariables> & ({ variables: MirrorTargetCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MirrorTargetCompaniesQuery, MirrorTargetCompaniesQueryVariables>(MirrorTargetCompaniesDocument, options);
      }
export function useMirrorTargetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MirrorTargetCompaniesQuery, MirrorTargetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MirrorTargetCompaniesQuery, MirrorTargetCompaniesQueryVariables>(MirrorTargetCompaniesDocument, options);
        }
export function useMirrorTargetCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MirrorTargetCompaniesQuery, MirrorTargetCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MirrorTargetCompaniesQuery, MirrorTargetCompaniesQueryVariables>(MirrorTargetCompaniesDocument, options);
        }
export type MirrorTargetCompaniesQueryHookResult = ReturnType<typeof useMirrorTargetCompaniesQuery>;
export type MirrorTargetCompaniesLazyQueryHookResult = ReturnType<typeof useMirrorTargetCompaniesLazyQuery>;
export type MirrorTargetCompaniesSuspenseQueryHookResult = ReturnType<typeof useMirrorTargetCompaniesSuspenseQuery>;
export type MirrorTargetCompaniesQueryResult = Apollo.QueryResult<MirrorTargetCompaniesQuery, MirrorTargetCompaniesQueryVariables>;
export const MirrorTargetsDocument = gql`
    query MirrorTargets {
  mirrorTargets {
    uuid
    name
    url
    enabled
    batchSize
    subscribesToAllCompanies
    mirroredCompanyCount
    createdAt
  }
}
    `;

/**
 * __useMirrorTargetsQuery__
 *
 * To run a query within a React component, call `useMirrorTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMirrorTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMirrorTargetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMirrorTargetsQuery(baseOptions?: Apollo.QueryHookOptions<MirrorTargetsQuery, MirrorTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MirrorTargetsQuery, MirrorTargetsQueryVariables>(MirrorTargetsDocument, options);
      }
export function useMirrorTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MirrorTargetsQuery, MirrorTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MirrorTargetsQuery, MirrorTargetsQueryVariables>(MirrorTargetsDocument, options);
        }
export function useMirrorTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MirrorTargetsQuery, MirrorTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MirrorTargetsQuery, MirrorTargetsQueryVariables>(MirrorTargetsDocument, options);
        }
export type MirrorTargetsQueryHookResult = ReturnType<typeof useMirrorTargetsQuery>;
export type MirrorTargetsLazyQueryHookResult = ReturnType<typeof useMirrorTargetsLazyQuery>;
export type MirrorTargetsSuspenseQueryHookResult = ReturnType<typeof useMirrorTargetsSuspenseQuery>;
export type MirrorTargetsQueryResult = Apollo.QueryResult<MirrorTargetsQuery, MirrorTargetsQueryVariables>;
export const OrderMirrorOutboxCountDocument = gql`
    query OrderMirrorOutboxCount {
  orderMirrorOutboxCount
}
    `;

/**
 * __useOrderMirrorOutboxCountQuery__
 *
 * To run a query within a React component, call `useOrderMirrorOutboxCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderMirrorOutboxCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderMirrorOutboxCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderMirrorOutboxCountQuery(baseOptions?: Apollo.QueryHookOptions<OrderMirrorOutboxCountQuery, OrderMirrorOutboxCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderMirrorOutboxCountQuery, OrderMirrorOutboxCountQueryVariables>(OrderMirrorOutboxCountDocument, options);
      }
export function useOrderMirrorOutboxCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderMirrorOutboxCountQuery, OrderMirrorOutboxCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderMirrorOutboxCountQuery, OrderMirrorOutboxCountQueryVariables>(OrderMirrorOutboxCountDocument, options);
        }
export function useOrderMirrorOutboxCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderMirrorOutboxCountQuery, OrderMirrorOutboxCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderMirrorOutboxCountQuery, OrderMirrorOutboxCountQueryVariables>(OrderMirrorOutboxCountDocument, options);
        }
export type OrderMirrorOutboxCountQueryHookResult = ReturnType<typeof useOrderMirrorOutboxCountQuery>;
export type OrderMirrorOutboxCountLazyQueryHookResult = ReturnType<typeof useOrderMirrorOutboxCountLazyQuery>;
export type OrderMirrorOutboxCountSuspenseQueryHookResult = ReturnType<typeof useOrderMirrorOutboxCountSuspenseQuery>;
export type OrderMirrorOutboxCountQueryResult = Apollo.QueryResult<OrderMirrorOutboxCountQuery, OrderMirrorOutboxCountQueryVariables>;
export const OrderMirrorSyncRequestsDocument = gql`
    query OrderMirrorSyncRequests {
  orderMirrorSyncRequests {
    uuid
    scope
    companyUuids
    fromDateTime
    toDateTime
    status
    matchedCount
    createdCount
    existedCount
    error
    createdAt
  }
}
    `;

/**
 * __useOrderMirrorSyncRequestsQuery__
 *
 * To run a query within a React component, call `useOrderMirrorSyncRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderMirrorSyncRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderMirrorSyncRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderMirrorSyncRequestsQuery(baseOptions?: Apollo.QueryHookOptions<OrderMirrorSyncRequestsQuery, OrderMirrorSyncRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderMirrorSyncRequestsQuery, OrderMirrorSyncRequestsQueryVariables>(OrderMirrorSyncRequestsDocument, options);
      }
export function useOrderMirrorSyncRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderMirrorSyncRequestsQuery, OrderMirrorSyncRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderMirrorSyncRequestsQuery, OrderMirrorSyncRequestsQueryVariables>(OrderMirrorSyncRequestsDocument, options);
        }
export function useOrderMirrorSyncRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderMirrorSyncRequestsQuery, OrderMirrorSyncRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderMirrorSyncRequestsQuery, OrderMirrorSyncRequestsQueryVariables>(OrderMirrorSyncRequestsDocument, options);
        }
export type OrderMirrorSyncRequestsQueryHookResult = ReturnType<typeof useOrderMirrorSyncRequestsQuery>;
export type OrderMirrorSyncRequestsLazyQueryHookResult = ReturnType<typeof useOrderMirrorSyncRequestsLazyQuery>;
export type OrderMirrorSyncRequestsSuspenseQueryHookResult = ReturnType<typeof useOrderMirrorSyncRequestsSuspenseQuery>;
export type OrderMirrorSyncRequestsQueryResult = Apollo.QueryResult<OrderMirrorSyncRequestsQuery, OrderMirrorSyncRequestsQueryVariables>;
export const OrderMirrorSyncableCompaniesDocument = gql`
    query OrderMirrorSyncableCompanies {
  orderMirrorSyncableCompanies {
    companyUuid
    name
  }
}
    `;

/**
 * __useOrderMirrorSyncableCompaniesQuery__
 *
 * To run a query within a React component, call `useOrderMirrorSyncableCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderMirrorSyncableCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderMirrorSyncableCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderMirrorSyncableCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<OrderMirrorSyncableCompaniesQuery, OrderMirrorSyncableCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderMirrorSyncableCompaniesQuery, OrderMirrorSyncableCompaniesQueryVariables>(OrderMirrorSyncableCompaniesDocument, options);
      }
export function useOrderMirrorSyncableCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderMirrorSyncableCompaniesQuery, OrderMirrorSyncableCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderMirrorSyncableCompaniesQuery, OrderMirrorSyncableCompaniesQueryVariables>(OrderMirrorSyncableCompaniesDocument, options);
        }
export function useOrderMirrorSyncableCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderMirrorSyncableCompaniesQuery, OrderMirrorSyncableCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderMirrorSyncableCompaniesQuery, OrderMirrorSyncableCompaniesQueryVariables>(OrderMirrorSyncableCompaniesDocument, options);
        }
export type OrderMirrorSyncableCompaniesQueryHookResult = ReturnType<typeof useOrderMirrorSyncableCompaniesQuery>;
export type OrderMirrorSyncableCompaniesLazyQueryHookResult = ReturnType<typeof useOrderMirrorSyncableCompaniesLazyQuery>;
export type OrderMirrorSyncableCompaniesSuspenseQueryHookResult = ReturnType<typeof useOrderMirrorSyncableCompaniesSuspenseQuery>;
export type OrderMirrorSyncableCompaniesQueryResult = Apollo.QueryResult<OrderMirrorSyncableCompaniesQuery, OrderMirrorSyncableCompaniesQueryVariables>;
export const RequestOrderMirrorSyncDocument = gql`
    mutation RequestOrderMirrorSync($input: RequestOrderMirrorSyncInput!) {
  requestOrderMirrorSync(input: $input) {
    requestUuid
  }
}
    `;
export type RequestOrderMirrorSyncMutationFn = Apollo.MutationFunction<RequestOrderMirrorSyncMutation, RequestOrderMirrorSyncMutationVariables>;

/**
 * __useRequestOrderMirrorSyncMutation__
 *
 * To run a mutation, you first call `useRequestOrderMirrorSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOrderMirrorSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOrderMirrorSyncMutation, { data, loading, error }] = useRequestOrderMirrorSyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestOrderMirrorSyncMutation(baseOptions?: Apollo.MutationHookOptions<RequestOrderMirrorSyncMutation, RequestOrderMirrorSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestOrderMirrorSyncMutation, RequestOrderMirrorSyncMutationVariables>(RequestOrderMirrorSyncDocument, options);
      }
export type RequestOrderMirrorSyncMutationHookResult = ReturnType<typeof useRequestOrderMirrorSyncMutation>;
export type RequestOrderMirrorSyncMutationResult = Apollo.MutationResult<RequestOrderMirrorSyncMutation>;
export type RequestOrderMirrorSyncMutationOptions = Apollo.BaseMutationOptions<RequestOrderMirrorSyncMutation, RequestOrderMirrorSyncMutationVariables>;
export const SetOrderMirrorCaptureConfigDocument = gql`
    mutation SetOrderMirrorCaptureConfig($input: SetOrderMirrorCaptureConfigInput!) {
  setOrderMirrorCaptureConfig(input: $input) {
    mode
    companies {
      companyUuid
      companyName
    }
  }
}
    `;
export type SetOrderMirrorCaptureConfigMutationFn = Apollo.MutationFunction<SetOrderMirrorCaptureConfigMutation, SetOrderMirrorCaptureConfigMutationVariables>;

/**
 * __useSetOrderMirrorCaptureConfigMutation__
 *
 * To run a mutation, you first call `useSetOrderMirrorCaptureConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrderMirrorCaptureConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrderMirrorCaptureConfigMutation, { data, loading, error }] = useSetOrderMirrorCaptureConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOrderMirrorCaptureConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetOrderMirrorCaptureConfigMutation, SetOrderMirrorCaptureConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrderMirrorCaptureConfigMutation, SetOrderMirrorCaptureConfigMutationVariables>(SetOrderMirrorCaptureConfigDocument, options);
      }
export type SetOrderMirrorCaptureConfigMutationHookResult = ReturnType<typeof useSetOrderMirrorCaptureConfigMutation>;
export type SetOrderMirrorCaptureConfigMutationResult = Apollo.MutationResult<SetOrderMirrorCaptureConfigMutation>;
export type SetOrderMirrorCaptureConfigMutationOptions = Apollo.BaseMutationOptions<SetOrderMirrorCaptureConfigMutation, SetOrderMirrorCaptureConfigMutationVariables>;
export const SetMirrorTargetCompaniesDocument = gql`
    mutation SetMirrorTargetCompanies($input: SetMirrorTargetCompaniesInput!) {
  setMirrorTargetCompanies(input: $input)
}
    `;
export type SetMirrorTargetCompaniesMutationFn = Apollo.MutationFunction<SetMirrorTargetCompaniesMutation, SetMirrorTargetCompaniesMutationVariables>;

/**
 * __useSetMirrorTargetCompaniesMutation__
 *
 * To run a mutation, you first call `useSetMirrorTargetCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMirrorTargetCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMirrorTargetCompaniesMutation, { data, loading, error }] = useSetMirrorTargetCompaniesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMirrorTargetCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<SetMirrorTargetCompaniesMutation, SetMirrorTargetCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMirrorTargetCompaniesMutation, SetMirrorTargetCompaniesMutationVariables>(SetMirrorTargetCompaniesDocument, options);
      }
export type SetMirrorTargetCompaniesMutationHookResult = ReturnType<typeof useSetMirrorTargetCompaniesMutation>;
export type SetMirrorTargetCompaniesMutationResult = Apollo.MutationResult<SetMirrorTargetCompaniesMutation>;
export type SetMirrorTargetCompaniesMutationOptions = Apollo.BaseMutationOptions<SetMirrorTargetCompaniesMutation, SetMirrorTargetCompaniesMutationVariables>;
export const UpdateMirrorTargetDocument = gql`
    mutation UpdateMirrorTarget($input: UpdateMirrorTargetInput!) {
  updateMirrorTarget(input: $input) {
    uuid
  }
}
    `;
export type UpdateMirrorTargetMutationFn = Apollo.MutationFunction<UpdateMirrorTargetMutation, UpdateMirrorTargetMutationVariables>;

/**
 * __useUpdateMirrorTargetMutation__
 *
 * To run a mutation, you first call `useUpdateMirrorTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMirrorTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMirrorTargetMutation, { data, loading, error }] = useUpdateMirrorTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMirrorTargetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMirrorTargetMutation, UpdateMirrorTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMirrorTargetMutation, UpdateMirrorTargetMutationVariables>(UpdateMirrorTargetDocument, options);
      }
export type UpdateMirrorTargetMutationHookResult = ReturnType<typeof useUpdateMirrorTargetMutation>;
export type UpdateMirrorTargetMutationResult = Apollo.MutationResult<UpdateMirrorTargetMutation>;
export type UpdateMirrorTargetMutationOptions = Apollo.BaseMutationOptions<UpdateMirrorTargetMutation, UpdateMirrorTargetMutationVariables>;
export const PieceBackfillRunDocument = gql`
    query pieceBackfillRun($uuid: String!) {
  pieceBackfillRun(uuid: $uuid) {
    ...PieceBackfillRunFields
  }
}
    ${PieceBackfillRunFieldsFragmentDoc}`;

/**
 * __usePieceBackfillRunQuery__
 *
 * To run a query within a React component, call `usePieceBackfillRunQuery` and pass it any options that fit your needs.
 * When your component renders, `usePieceBackfillRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePieceBackfillRunQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function usePieceBackfillRunQuery(baseOptions: Apollo.QueryHookOptions<PieceBackfillRunQuery, PieceBackfillRunQueryVariables> & ({ variables: PieceBackfillRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PieceBackfillRunQuery, PieceBackfillRunQueryVariables>(PieceBackfillRunDocument, options);
      }
export function usePieceBackfillRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PieceBackfillRunQuery, PieceBackfillRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PieceBackfillRunQuery, PieceBackfillRunQueryVariables>(PieceBackfillRunDocument, options);
        }
export function usePieceBackfillRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PieceBackfillRunQuery, PieceBackfillRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PieceBackfillRunQuery, PieceBackfillRunQueryVariables>(PieceBackfillRunDocument, options);
        }
export type PieceBackfillRunQueryHookResult = ReturnType<typeof usePieceBackfillRunQuery>;
export type PieceBackfillRunLazyQueryHookResult = ReturnType<typeof usePieceBackfillRunLazyQuery>;
export type PieceBackfillRunSuspenseQueryHookResult = ReturnType<typeof usePieceBackfillRunSuspenseQuery>;
export type PieceBackfillRunQueryResult = Apollo.QueryResult<PieceBackfillRunQuery, PieceBackfillRunQueryVariables>;
export const PieceBackfillRunsDocument = gql`
    query pieceBackfillRuns($input: PieceBackfillRunsInput!) {
  pieceBackfillRuns(input: $input) {
    ...PieceBackfillRunFields
  }
}
    ${PieceBackfillRunFieldsFragmentDoc}`;

/**
 * __usePieceBackfillRunsQuery__
 *
 * To run a query within a React component, call `usePieceBackfillRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePieceBackfillRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePieceBackfillRunsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePieceBackfillRunsQuery(baseOptions: Apollo.QueryHookOptions<PieceBackfillRunsQuery, PieceBackfillRunsQueryVariables> & ({ variables: PieceBackfillRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PieceBackfillRunsQuery, PieceBackfillRunsQueryVariables>(PieceBackfillRunsDocument, options);
      }
export function usePieceBackfillRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PieceBackfillRunsQuery, PieceBackfillRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PieceBackfillRunsQuery, PieceBackfillRunsQueryVariables>(PieceBackfillRunsDocument, options);
        }
export function usePieceBackfillRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PieceBackfillRunsQuery, PieceBackfillRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PieceBackfillRunsQuery, PieceBackfillRunsQueryVariables>(PieceBackfillRunsDocument, options);
        }
export type PieceBackfillRunsQueryHookResult = ReturnType<typeof usePieceBackfillRunsQuery>;
export type PieceBackfillRunsLazyQueryHookResult = ReturnType<typeof usePieceBackfillRunsLazyQuery>;
export type PieceBackfillRunsSuspenseQueryHookResult = ReturnType<typeof usePieceBackfillRunsSuspenseQuery>;
export type PieceBackfillRunsQueryResult = Apollo.QueryResult<PieceBackfillRunsQuery, PieceBackfillRunsQueryVariables>;
export const PieceBackfillSurveyDocument = gql`
    query pieceBackfillSurvey($input: PieceBackfillSurveyInput!) {
  pieceBackfillSurvey(input: $input) {
    companyUuid
    cutoffDate
    totalPackageCount
    totalPackageQuantity
    totalExistingPieceCount
    totalMissingPieceCount
    billingParties {
      contactUuid
      contactName
      packageCount
      totalPackageQuantity
      existingPieceCount
      missingPieceCount
    }
  }
}
    `;

/**
 * __usePieceBackfillSurveyQuery__
 *
 * To run a query within a React component, call `usePieceBackfillSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePieceBackfillSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePieceBackfillSurveyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePieceBackfillSurveyQuery(baseOptions: Apollo.QueryHookOptions<PieceBackfillSurveyQuery, PieceBackfillSurveyQueryVariables> & ({ variables: PieceBackfillSurveyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PieceBackfillSurveyQuery, PieceBackfillSurveyQueryVariables>(PieceBackfillSurveyDocument, options);
      }
export function usePieceBackfillSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PieceBackfillSurveyQuery, PieceBackfillSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PieceBackfillSurveyQuery, PieceBackfillSurveyQueryVariables>(PieceBackfillSurveyDocument, options);
        }
export function usePieceBackfillSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PieceBackfillSurveyQuery, PieceBackfillSurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PieceBackfillSurveyQuery, PieceBackfillSurveyQueryVariables>(PieceBackfillSurveyDocument, options);
        }
export type PieceBackfillSurveyQueryHookResult = ReturnType<typeof usePieceBackfillSurveyQuery>;
export type PieceBackfillSurveyLazyQueryHookResult = ReturnType<typeof usePieceBackfillSurveyLazyQuery>;
export type PieceBackfillSurveySuspenseQueryHookResult = ReturnType<typeof usePieceBackfillSurveySuspenseQuery>;
export type PieceBackfillSurveyQueryResult = Apollo.QueryResult<PieceBackfillSurveyQuery, PieceBackfillSurveyQueryVariables>;
export const StartPieceBackfillRunDocument = gql`
    mutation startPieceBackfillRun($input: StartPieceBackfillRunInput!) {
  startPieceBackfillRun(input: $input) {
    ...PieceBackfillRunFields
  }
}
    ${PieceBackfillRunFieldsFragmentDoc}`;
export type StartPieceBackfillRunMutationFn = Apollo.MutationFunction<StartPieceBackfillRunMutation, StartPieceBackfillRunMutationVariables>;

/**
 * __useStartPieceBackfillRunMutation__
 *
 * To run a mutation, you first call `useStartPieceBackfillRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPieceBackfillRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPieceBackfillRunMutation, { data, loading, error }] = useStartPieceBackfillRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartPieceBackfillRunMutation(baseOptions?: Apollo.MutationHookOptions<StartPieceBackfillRunMutation, StartPieceBackfillRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPieceBackfillRunMutation, StartPieceBackfillRunMutationVariables>(StartPieceBackfillRunDocument, options);
      }
export type StartPieceBackfillRunMutationHookResult = ReturnType<typeof useStartPieceBackfillRunMutation>;
export type StartPieceBackfillRunMutationResult = Apollo.MutationResult<StartPieceBackfillRunMutation>;
export type StartPieceBackfillRunMutationOptions = Apollo.BaseMutationOptions<StartPieceBackfillRunMutation, StartPieceBackfillRunMutationVariables>;
export const PrefillInspectionDocument = gql`
    query prefillInspection($companyUuid: String!, $senderAddress: String, $billingPartyContactUuid: String) {
  prefillInspection(
    companyUuid: $companyUuid
    senderAddress: $senderAddress
    billingPartyContactUuid: $billingPartyContactUuid
  ) {
    __typename
    ... on PrefillInspectionEntity {
      candidates {
        uuid
        displayName
      }
      senderBillingParty {
        verdict
        contactUuid
        support
        distinctParties
      }
      conditionalService {
        verdict
        serviceId
        support
        share
      }
    }
    ... on QueryErrorOutput {
      message
    }
  }
}
    `;

/**
 * __usePrefillInspectionQuery__
 *
 * To run a query within a React component, call `usePrefillInspectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrefillInspectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrefillInspectionQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      senderAddress: // value for 'senderAddress'
 *      billingPartyContactUuid: // value for 'billingPartyContactUuid'
 *   },
 * });
 */
export function usePrefillInspectionQuery(baseOptions: Apollo.QueryHookOptions<PrefillInspectionQuery, PrefillInspectionQueryVariables> & ({ variables: PrefillInspectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrefillInspectionQuery, PrefillInspectionQueryVariables>(PrefillInspectionDocument, options);
      }
export function usePrefillInspectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrefillInspectionQuery, PrefillInspectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrefillInspectionQuery, PrefillInspectionQueryVariables>(PrefillInspectionDocument, options);
        }
export function usePrefillInspectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrefillInspectionQuery, PrefillInspectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrefillInspectionQuery, PrefillInspectionQueryVariables>(PrefillInspectionDocument, options);
        }
export type PrefillInspectionQueryHookResult = ReturnType<typeof usePrefillInspectionQuery>;
export type PrefillInspectionLazyQueryHookResult = ReturnType<typeof usePrefillInspectionLazyQuery>;
export type PrefillInspectionSuspenseQueryHookResult = ReturnType<typeof usePrefillInspectionSuspenseQuery>;
export type PrefillInspectionQueryResult = Apollo.QueryResult<PrefillInspectionQuery, PrefillInspectionQueryVariables>;
export const ReanalyzePageDocument = gql`
    mutation reanalyzePage($reanalyzePageInput: ReanalyzePageInput!) {
  reanalyzePage(reanalyzePageInput: $reanalyzePageInput)
}
    `;
export type ReanalyzePageMutationFn = Apollo.MutationFunction<ReanalyzePageMutation, ReanalyzePageMutationVariables>;

/**
 * __useReanalyzePageMutation__
 *
 * To run a mutation, you first call `useReanalyzePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReanalyzePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reanalyzePageMutation, { data, loading, error }] = useReanalyzePageMutation({
 *   variables: {
 *      reanalyzePageInput: // value for 'reanalyzePageInput'
 *   },
 * });
 */
export function useReanalyzePageMutation(baseOptions?: Apollo.MutationHookOptions<ReanalyzePageMutation, ReanalyzePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReanalyzePageMutation, ReanalyzePageMutationVariables>(ReanalyzePageDocument, options);
      }
export type ReanalyzePageMutationHookResult = ReturnType<typeof useReanalyzePageMutation>;
export type ReanalyzePageMutationResult = Apollo.MutationResult<ReanalyzePageMutation>;
export type ReanalyzePageMutationOptions = Apollo.BaseMutationOptions<ReanalyzePageMutation, ReanalyzePageMutationVariables>;
export const ReanalyzeSchemaFileDocument = gql`
    mutation reanalyzeSchemaFile($reanalyzeSchemaFileInput: ReanalyzeSchemaFileInput!) {
  reanalyzeSchemaFile(reanalyzeSchemaFileInput: $reanalyzeSchemaFileInput)
}
    `;
export type ReanalyzeSchemaFileMutationFn = Apollo.MutationFunction<ReanalyzeSchemaFileMutation, ReanalyzeSchemaFileMutationVariables>;

/**
 * __useReanalyzeSchemaFileMutation__
 *
 * To run a mutation, you first call `useReanalyzeSchemaFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReanalyzeSchemaFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reanalyzeSchemaFileMutation, { data, loading, error }] = useReanalyzeSchemaFileMutation({
 *   variables: {
 *      reanalyzeSchemaFileInput: // value for 'reanalyzeSchemaFileInput'
 *   },
 * });
 */
export function useReanalyzeSchemaFileMutation(baseOptions?: Apollo.MutationHookOptions<ReanalyzeSchemaFileMutation, ReanalyzeSchemaFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReanalyzeSchemaFileMutation, ReanalyzeSchemaFileMutationVariables>(ReanalyzeSchemaFileDocument, options);
      }
export type ReanalyzeSchemaFileMutationHookResult = ReturnType<typeof useReanalyzeSchemaFileMutation>;
export type ReanalyzeSchemaFileMutationResult = Apollo.MutationResult<ReanalyzeSchemaFileMutation>;
export type ReanalyzeSchemaFileMutationOptions = Apollo.BaseMutationOptions<ReanalyzeSchemaFileMutation, ReanalyzeSchemaFileMutationVariables>;
export const RenderServicesDocument = gql`
    query renderServices {
  renderServices {
    id
    name
    branch
    updatedAt
    deploys {
      commitHash
      commitMessage
      finishedAt
    }
  }
}
    `;

/**
 * __useRenderServicesQuery__
 *
 * To run a query within a React component, call `useRenderServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRenderServicesQuery(baseOptions?: Apollo.QueryHookOptions<RenderServicesQuery, RenderServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenderServicesQuery, RenderServicesQueryVariables>(RenderServicesDocument, options);
      }
export function useRenderServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenderServicesQuery, RenderServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenderServicesQuery, RenderServicesQueryVariables>(RenderServicesDocument, options);
        }
export function useRenderServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenderServicesQuery, RenderServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenderServicesQuery, RenderServicesQueryVariables>(RenderServicesDocument, options);
        }
export type RenderServicesQueryHookResult = ReturnType<typeof useRenderServicesQuery>;
export type RenderServicesLazyQueryHookResult = ReturnType<typeof useRenderServicesLazyQuery>;
export type RenderServicesSuspenseQueryHookResult = ReturnType<typeof useRenderServicesSuspenseQuery>;
export type RenderServicesQueryResult = Apollo.QueryResult<RenderServicesQuery, RenderServicesQueryVariables>;
export const RetrySftpUploadsDocument = gql`
    mutation retrySftpUploads($retrySftpUploadsInput: RetrySftpUploadsInput!) {
  retrySftpUploads(retrySftpUploadsInput: $retrySftpUploadsInput) {
    sftpUpload {
      uuid
      status
      error
    }
  }
}
    `;
export type RetrySftpUploadsMutationFn = Apollo.MutationFunction<RetrySftpUploadsMutation, RetrySftpUploadsMutationVariables>;

/**
 * __useRetrySftpUploadsMutation__
 *
 * To run a mutation, you first call `useRetrySftpUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrySftpUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrySftpUploadsMutation, { data, loading, error }] = useRetrySftpUploadsMutation({
 *   variables: {
 *      retrySftpUploadsInput: // value for 'retrySftpUploadsInput'
 *   },
 * });
 */
export function useRetrySftpUploadsMutation(baseOptions?: Apollo.MutationHookOptions<RetrySftpUploadsMutation, RetrySftpUploadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrySftpUploadsMutation, RetrySftpUploadsMutationVariables>(RetrySftpUploadsDocument, options);
      }
export type RetrySftpUploadsMutationHookResult = ReturnType<typeof useRetrySftpUploadsMutation>;
export type RetrySftpUploadsMutationResult = Apollo.MutationResult<RetrySftpUploadsMutation>;
export type RetrySftpUploadsMutationOptions = Apollo.BaseMutationOptions<RetrySftpUploadsMutation, RetrySftpUploadsMutationVariables>;
export const RotateDocumentDocument = gql`
    mutation rotateDocument($rotateDocumentInput: RotateDocumentInput!) {
  rotateDocument(rotateDocumentInput: $rotateDocumentInput)
}
    `;
export type RotateDocumentMutationFn = Apollo.MutationFunction<RotateDocumentMutation, RotateDocumentMutationVariables>;

/**
 * __useRotateDocumentMutation__
 *
 * To run a mutation, you first call `useRotateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateDocumentMutation, { data, loading, error }] = useRotateDocumentMutation({
 *   variables: {
 *      rotateDocumentInput: // value for 'rotateDocumentInput'
 *   },
 * });
 */
export function useRotateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RotateDocumentMutation, RotateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RotateDocumentMutation, RotateDocumentMutationVariables>(RotateDocumentDocument, options);
      }
export type RotateDocumentMutationHookResult = ReturnType<typeof useRotateDocumentMutation>;
export type RotateDocumentMutationResult = Apollo.MutationResult<RotateDocumentMutation>;
export type RotateDocumentMutationOptions = Apollo.BaseMutationOptions<RotateDocumentMutation, RotateDocumentMutationVariables>;
export const CreateScannedOrdersFromAdminDocument = gql`
    mutation createScannedOrdersFromAdmin($createScannedOrdersFromAdminInput: CreateScannedOrdersFromAdminInput!) {
  createScannedOrdersFromAdmin(
    createScannedOrdersFromAdminInput: $createScannedOrdersFromAdminInput
  ) {
    scannedOrderEntity {
      uuid
    }
    error
  }
}
    `;
export type CreateScannedOrdersFromAdminMutationFn = Apollo.MutationFunction<CreateScannedOrdersFromAdminMutation, CreateScannedOrdersFromAdminMutationVariables>;

/**
 * __useCreateScannedOrdersFromAdminMutation__
 *
 * To run a mutation, you first call `useCreateScannedOrdersFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScannedOrdersFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScannedOrdersFromAdminMutation, { data, loading, error }] = useCreateScannedOrdersFromAdminMutation({
 *   variables: {
 *      createScannedOrdersFromAdminInput: // value for 'createScannedOrdersFromAdminInput'
 *   },
 * });
 */
export function useCreateScannedOrdersFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateScannedOrdersFromAdminMutation, CreateScannedOrdersFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScannedOrdersFromAdminMutation, CreateScannedOrdersFromAdminMutationVariables>(CreateScannedOrdersFromAdminDocument, options);
      }
export type CreateScannedOrdersFromAdminMutationHookResult = ReturnType<typeof useCreateScannedOrdersFromAdminMutation>;
export type CreateScannedOrdersFromAdminMutationResult = Apollo.MutationResult<CreateScannedOrdersFromAdminMutation>;
export type CreateScannedOrdersFromAdminMutationOptions = Apollo.BaseMutationOptions<CreateScannedOrdersFromAdminMutation, CreateScannedOrdersFromAdminMutationVariables>;
export const ScannedOrderResultsForAdminDocument = gql`
    query scannedOrderResultsForAdmin($args: GetScannedOrderResultsForAdminArgs!) {
  scannedOrderResultsForAdmin(args: $args) {
    edges {
      node {
        uuid
        createdAt
        filename
        status
        failureReason
        preSignedGetUrl
        order {
          uuid
          name
          billingPartyContact {
            uuid
            displayName
          }
          standardOrderFields {
            shipperBillOfLadingNumber
            masterAirwayBillOfLadingNumber
          }
          documents {
            preSignedGetUrl
          }
          shipments {
            standardShipmentFields {
              pickupOrDelivery
              deadlineDate
            }
            legs {
              endStop {
                serviceDate
                specialInstructions
                shipperAddress {
                  ...Address
                }
                shipperContactPerson {
                  firstName
                  lastName
                  phone
                }
                consigneeAddress {
                  ...Address
                }
                consigneeContactPerson {
                  firstName
                  lastName
                  phone
                }
              }
            }
          }
          packages {
            quantity
            weight
            width
            length
            height
            description
          }
        }
        scannedOrder {
          uuid
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${AddressFragmentDoc}`;

/**
 * __useScannedOrderResultsForAdminQuery__
 *
 * To run a query within a React component, call `useScannedOrderResultsForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useScannedOrderResultsForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScannedOrderResultsForAdminQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useScannedOrderResultsForAdminQuery(baseOptions: Apollo.QueryHookOptions<ScannedOrderResultsForAdminQuery, ScannedOrderResultsForAdminQueryVariables> & ({ variables: ScannedOrderResultsForAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScannedOrderResultsForAdminQuery, ScannedOrderResultsForAdminQueryVariables>(ScannedOrderResultsForAdminDocument, options);
      }
export function useScannedOrderResultsForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScannedOrderResultsForAdminQuery, ScannedOrderResultsForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScannedOrderResultsForAdminQuery, ScannedOrderResultsForAdminQueryVariables>(ScannedOrderResultsForAdminDocument, options);
        }
export function useScannedOrderResultsForAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScannedOrderResultsForAdminQuery, ScannedOrderResultsForAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScannedOrderResultsForAdminQuery, ScannedOrderResultsForAdminQueryVariables>(ScannedOrderResultsForAdminDocument, options);
        }
export type ScannedOrderResultsForAdminQueryHookResult = ReturnType<typeof useScannedOrderResultsForAdminQuery>;
export type ScannedOrderResultsForAdminLazyQueryHookResult = ReturnType<typeof useScannedOrderResultsForAdminLazyQuery>;
export type ScannedOrderResultsForAdminSuspenseQueryHookResult = ReturnType<typeof useScannedOrderResultsForAdminSuspenseQuery>;
export type ScannedOrderResultsForAdminQueryResult = Apollo.QueryResult<ScannedOrderResultsForAdminQuery, ScannedOrderResultsForAdminQueryVariables>;
export const StructuredExtractionRunByScannedOrderUuidDocument = gql`
    query structuredExtractionRunByScannedOrderUuid($uuid: String!) {
  structuredExtractionRunByScannedOrder(scannedOrderUuid: $uuid) {
    uuid
    scannedOrderUuid
    schemaUuid
    schemaName
    rawResult
  }
}
    `;

/**
 * __useStructuredExtractionRunByScannedOrderUuidQuery__
 *
 * To run a query within a React component, call `useStructuredExtractionRunByScannedOrderUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuredExtractionRunByScannedOrderUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuredExtractionRunByScannedOrderUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useStructuredExtractionRunByScannedOrderUuidQuery(baseOptions: Apollo.QueryHookOptions<StructuredExtractionRunByScannedOrderUuidQuery, StructuredExtractionRunByScannedOrderUuidQueryVariables> & ({ variables: StructuredExtractionRunByScannedOrderUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuredExtractionRunByScannedOrderUuidQuery, StructuredExtractionRunByScannedOrderUuidQueryVariables>(StructuredExtractionRunByScannedOrderUuidDocument, options);
      }
export function useStructuredExtractionRunByScannedOrderUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuredExtractionRunByScannedOrderUuidQuery, StructuredExtractionRunByScannedOrderUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuredExtractionRunByScannedOrderUuidQuery, StructuredExtractionRunByScannedOrderUuidQueryVariables>(StructuredExtractionRunByScannedOrderUuidDocument, options);
        }
export function useStructuredExtractionRunByScannedOrderUuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructuredExtractionRunByScannedOrderUuidQuery, StructuredExtractionRunByScannedOrderUuidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructuredExtractionRunByScannedOrderUuidQuery, StructuredExtractionRunByScannedOrderUuidQueryVariables>(StructuredExtractionRunByScannedOrderUuidDocument, options);
        }
export type StructuredExtractionRunByScannedOrderUuidQueryHookResult = ReturnType<typeof useStructuredExtractionRunByScannedOrderUuidQuery>;
export type StructuredExtractionRunByScannedOrderUuidLazyQueryHookResult = ReturnType<typeof useStructuredExtractionRunByScannedOrderUuidLazyQuery>;
export type StructuredExtractionRunByScannedOrderUuidSuspenseQueryHookResult = ReturnType<typeof useStructuredExtractionRunByScannedOrderUuidSuspenseQuery>;
export type StructuredExtractionRunByScannedOrderUuidQueryResult = Apollo.QueryResult<StructuredExtractionRunByScannedOrderUuidQuery, StructuredExtractionRunByScannedOrderUuidQueryVariables>;
export const StructuredExtractionSchemaOverrideDocument = gql`
    query structuredExtractionSchemaOverride($schemaUuid: String!) {
  getStructuredExtractionSchemaOverride(schemaUuid: $schemaUuid) {
    uuid
    schemaOverride
    schemaExclusions
    deadlineDateKeys
    specialInstructionsKeys
  }
}
    `;

/**
 * __useStructuredExtractionSchemaOverrideQuery__
 *
 * To run a query within a React component, call `useStructuredExtractionSchemaOverrideQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuredExtractionSchemaOverrideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuredExtractionSchemaOverrideQuery({
 *   variables: {
 *      schemaUuid: // value for 'schemaUuid'
 *   },
 * });
 */
export function useStructuredExtractionSchemaOverrideQuery(baseOptions: Apollo.QueryHookOptions<StructuredExtractionSchemaOverrideQuery, StructuredExtractionSchemaOverrideQueryVariables> & ({ variables: StructuredExtractionSchemaOverrideQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuredExtractionSchemaOverrideQuery, StructuredExtractionSchemaOverrideQueryVariables>(StructuredExtractionSchemaOverrideDocument, options);
      }
export function useStructuredExtractionSchemaOverrideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuredExtractionSchemaOverrideQuery, StructuredExtractionSchemaOverrideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuredExtractionSchemaOverrideQuery, StructuredExtractionSchemaOverrideQueryVariables>(StructuredExtractionSchemaOverrideDocument, options);
        }
export function useStructuredExtractionSchemaOverrideSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructuredExtractionSchemaOverrideQuery, StructuredExtractionSchemaOverrideQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructuredExtractionSchemaOverrideQuery, StructuredExtractionSchemaOverrideQueryVariables>(StructuredExtractionSchemaOverrideDocument, options);
        }
export type StructuredExtractionSchemaOverrideQueryHookResult = ReturnType<typeof useStructuredExtractionSchemaOverrideQuery>;
export type StructuredExtractionSchemaOverrideLazyQueryHookResult = ReturnType<typeof useStructuredExtractionSchemaOverrideLazyQuery>;
export type StructuredExtractionSchemaOverrideSuspenseQueryHookResult = ReturnType<typeof useStructuredExtractionSchemaOverrideSuspenseQuery>;
export type StructuredExtractionSchemaOverrideQueryResult = Apollo.QueryResult<StructuredExtractionSchemaOverrideQuery, StructuredExtractionSchemaOverrideQueryVariables>;
export const UpsertStructuredExtractionSchemaOverrideDocument = gql`
    mutation upsertStructuredExtractionSchemaOverride($upsertStructuredExtractionSchemaOverrideInput: StructuredExtractionSchemaOverrideInput!) {
  upsertStructuredExtractionSchemaOverride(
    upsertStructuredExtractionSchemaOverrideInput: $upsertStructuredExtractionSchemaOverrideInput
  ) {
    uuid
    schemaOverride
    schemaExclusions
  }
}
    `;
export type UpsertStructuredExtractionSchemaOverrideMutationFn = Apollo.MutationFunction<UpsertStructuredExtractionSchemaOverrideMutation, UpsertStructuredExtractionSchemaOverrideMutationVariables>;

/**
 * __useUpsertStructuredExtractionSchemaOverrideMutation__
 *
 * To run a mutation, you first call `useUpsertStructuredExtractionSchemaOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStructuredExtractionSchemaOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStructuredExtractionSchemaOverrideMutation, { data, loading, error }] = useUpsertStructuredExtractionSchemaOverrideMutation({
 *   variables: {
 *      upsertStructuredExtractionSchemaOverrideInput: // value for 'upsertStructuredExtractionSchemaOverrideInput'
 *   },
 * });
 */
export function useUpsertStructuredExtractionSchemaOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStructuredExtractionSchemaOverrideMutation, UpsertStructuredExtractionSchemaOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStructuredExtractionSchemaOverrideMutation, UpsertStructuredExtractionSchemaOverrideMutationVariables>(UpsertStructuredExtractionSchemaOverrideDocument, options);
      }
export type UpsertStructuredExtractionSchemaOverrideMutationHookResult = ReturnType<typeof useUpsertStructuredExtractionSchemaOverrideMutation>;
export type UpsertStructuredExtractionSchemaOverrideMutationResult = Apollo.MutationResult<UpsertStructuredExtractionSchemaOverrideMutation>;
export type UpsertStructuredExtractionSchemaOverrideMutationOptions = Apollo.BaseMutationOptions<UpsertStructuredExtractionSchemaOverrideMutation, UpsertStructuredExtractionSchemaOverrideMutationVariables>;
export const CreateSchemaCompanyMappingDocument = gql`
    mutation createSchemaCompanyMapping($createSchemaCompanyMappingInput: CreateSchemaCompanyMappingInput!) {
  createSchemaCompanyMapping(
    createSchemaCompanyMappingInput: $createSchemaCompanyMappingInput
  )
}
    `;
export type CreateSchemaCompanyMappingMutationFn = Apollo.MutationFunction<CreateSchemaCompanyMappingMutation, CreateSchemaCompanyMappingMutationVariables>;

/**
 * __useCreateSchemaCompanyMappingMutation__
 *
 * To run a mutation, you first call `useCreateSchemaCompanyMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchemaCompanyMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchemaCompanyMappingMutation, { data, loading, error }] = useCreateSchemaCompanyMappingMutation({
 *   variables: {
 *      createSchemaCompanyMappingInput: // value for 'createSchemaCompanyMappingInput'
 *   },
 * });
 */
export function useCreateSchemaCompanyMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchemaCompanyMappingMutation, CreateSchemaCompanyMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchemaCompanyMappingMutation, CreateSchemaCompanyMappingMutationVariables>(CreateSchemaCompanyMappingDocument, options);
      }
export type CreateSchemaCompanyMappingMutationHookResult = ReturnType<typeof useCreateSchemaCompanyMappingMutation>;
export type CreateSchemaCompanyMappingMutationResult = Apollo.MutationResult<CreateSchemaCompanyMappingMutation>;
export type CreateSchemaCompanyMappingMutationOptions = Apollo.BaseMutationOptions<CreateSchemaCompanyMappingMutation, CreateSchemaCompanyMappingMutationVariables>;
export const CreateSchemaDocumentDocument = gql`
    mutation createSchemaDocument($createSchemaDocumentInput: CreateSchemaDocumentInput!) {
  createSchemaDocument(createSchemaDocumentInput: $createSchemaDocumentInput) {
    uuid
  }
}
    `;
export type CreateSchemaDocumentMutationFn = Apollo.MutationFunction<CreateSchemaDocumentMutation, CreateSchemaDocumentMutationVariables>;

/**
 * __useCreateSchemaDocumentMutation__
 *
 * To run a mutation, you first call `useCreateSchemaDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchemaDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchemaDocumentMutation, { data, loading, error }] = useCreateSchemaDocumentMutation({
 *   variables: {
 *      createSchemaDocumentInput: // value for 'createSchemaDocumentInput'
 *   },
 * });
 */
export function useCreateSchemaDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchemaDocumentMutation, CreateSchemaDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchemaDocumentMutation, CreateSchemaDocumentMutationVariables>(CreateSchemaDocumentDocument, options);
      }
export type CreateSchemaDocumentMutationHookResult = ReturnType<typeof useCreateSchemaDocumentMutation>;
export type CreateSchemaDocumentMutationResult = Apollo.MutationResult<CreateSchemaDocumentMutation>;
export type CreateSchemaDocumentMutationOptions = Apollo.BaseMutationOptions<CreateSchemaDocumentMutation, CreateSchemaDocumentMutationVariables>;
export const DeleteSchemaCompanyMappingDocument = gql`
    mutation deleteSchemaCompanyMapping($id: String!) {
  deleteSchemaCompanyMapping(id: $id)
}
    `;
export type DeleteSchemaCompanyMappingMutationFn = Apollo.MutationFunction<DeleteSchemaCompanyMappingMutation, DeleteSchemaCompanyMappingMutationVariables>;

/**
 * __useDeleteSchemaCompanyMappingMutation__
 *
 * To run a mutation, you first call `useDeleteSchemaCompanyMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchemaCompanyMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchemaCompanyMappingMutation, { data, loading, error }] = useDeleteSchemaCompanyMappingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSchemaCompanyMappingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchemaCompanyMappingMutation, DeleteSchemaCompanyMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchemaCompanyMappingMutation, DeleteSchemaCompanyMappingMutationVariables>(DeleteSchemaCompanyMappingDocument, options);
      }
export type DeleteSchemaCompanyMappingMutationHookResult = ReturnType<typeof useDeleteSchemaCompanyMappingMutation>;
export type DeleteSchemaCompanyMappingMutationResult = Apollo.MutationResult<DeleteSchemaCompanyMappingMutation>;
export type DeleteSchemaCompanyMappingMutationOptions = Apollo.BaseMutationOptions<DeleteSchemaCompanyMappingMutation, DeleteSchemaCompanyMappingMutationVariables>;
export const DeleteSchemaDocumentDocument = gql`
    mutation deleteSchemaDocument($uuid: String!) {
  deleteSchemaDocument(uuid: $uuid)
}
    `;
export type DeleteSchemaDocumentMutationFn = Apollo.MutationFunction<DeleteSchemaDocumentMutation, DeleteSchemaDocumentMutationVariables>;

/**
 * __useDeleteSchemaDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteSchemaDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchemaDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchemaDocumentMutation, { data, loading, error }] = useDeleteSchemaDocumentMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteSchemaDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchemaDocumentMutation, DeleteSchemaDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchemaDocumentMutation, DeleteSchemaDocumentMutationVariables>(DeleteSchemaDocumentDocument, options);
      }
export type DeleteSchemaDocumentMutationHookResult = ReturnType<typeof useDeleteSchemaDocumentMutation>;
export type DeleteSchemaDocumentMutationResult = Apollo.MutationResult<DeleteSchemaDocumentMutation>;
export type DeleteSchemaDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteSchemaDocumentMutation, DeleteSchemaDocumentMutationVariables>;
export const GenerateScannedOrderPreSignedPutUrlsDocument = gql`
    query generateScannedOrderPreSignedPutUrls($preSignedUrlRequests: [PreSignedUrlRequestInput!]!) {
  generateScannedOrderPreSignedPutUrls(
    preSignedUrlRequests: $preSignedUrlRequests
  ) {
    url
    bucket
    key
    filename
    filetype
  }
}
    `;

/**
 * __useGenerateScannedOrderPreSignedPutUrlsQuery__
 *
 * To run a query within a React component, call `useGenerateScannedOrderPreSignedPutUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateScannedOrderPreSignedPutUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateScannedOrderPreSignedPutUrlsQuery({
 *   variables: {
 *      preSignedUrlRequests: // value for 'preSignedUrlRequests'
 *   },
 * });
 */
export function useGenerateScannedOrderPreSignedPutUrlsQuery(baseOptions: Apollo.QueryHookOptions<GenerateScannedOrderPreSignedPutUrlsQuery, GenerateScannedOrderPreSignedPutUrlsQueryVariables> & ({ variables: GenerateScannedOrderPreSignedPutUrlsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateScannedOrderPreSignedPutUrlsQuery, GenerateScannedOrderPreSignedPutUrlsQueryVariables>(GenerateScannedOrderPreSignedPutUrlsDocument, options);
      }
export function useGenerateScannedOrderPreSignedPutUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateScannedOrderPreSignedPutUrlsQuery, GenerateScannedOrderPreSignedPutUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateScannedOrderPreSignedPutUrlsQuery, GenerateScannedOrderPreSignedPutUrlsQueryVariables>(GenerateScannedOrderPreSignedPutUrlsDocument, options);
        }
export function useGenerateScannedOrderPreSignedPutUrlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateScannedOrderPreSignedPutUrlsQuery, GenerateScannedOrderPreSignedPutUrlsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateScannedOrderPreSignedPutUrlsQuery, GenerateScannedOrderPreSignedPutUrlsQueryVariables>(GenerateScannedOrderPreSignedPutUrlsDocument, options);
        }
export type GenerateScannedOrderPreSignedPutUrlsQueryHookResult = ReturnType<typeof useGenerateScannedOrderPreSignedPutUrlsQuery>;
export type GenerateScannedOrderPreSignedPutUrlsLazyQueryHookResult = ReturnType<typeof useGenerateScannedOrderPreSignedPutUrlsLazyQuery>;
export type GenerateScannedOrderPreSignedPutUrlsSuspenseQueryHookResult = ReturnType<typeof useGenerateScannedOrderPreSignedPutUrlsSuspenseQuery>;
export type GenerateScannedOrderPreSignedPutUrlsQueryResult = Apollo.QueryResult<GenerateScannedOrderPreSignedPutUrlsQuery, GenerateScannedOrderPreSignedPutUrlsQueryVariables>;
export const SchemaCompanyMappingsDocument = gql`
    query schemaCompanyMappings($schemaUuid: String!) {
  schemaCompanyMappings(schemaUuid: $schemaUuid) {
    id
    contactUuid
    companyUuid
    isActive
    terminalUuid
  }
}
    `;

/**
 * __useSchemaCompanyMappingsQuery__
 *
 * To run a query within a React component, call `useSchemaCompanyMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaCompanyMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaCompanyMappingsQuery({
 *   variables: {
 *      schemaUuid: // value for 'schemaUuid'
 *   },
 * });
 */
export function useSchemaCompanyMappingsQuery(baseOptions: Apollo.QueryHookOptions<SchemaCompanyMappingsQuery, SchemaCompanyMappingsQueryVariables> & ({ variables: SchemaCompanyMappingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaCompanyMappingsQuery, SchemaCompanyMappingsQueryVariables>(SchemaCompanyMappingsDocument, options);
      }
export function useSchemaCompanyMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaCompanyMappingsQuery, SchemaCompanyMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaCompanyMappingsQuery, SchemaCompanyMappingsQueryVariables>(SchemaCompanyMappingsDocument, options);
        }
export function useSchemaCompanyMappingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchemaCompanyMappingsQuery, SchemaCompanyMappingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaCompanyMappingsQuery, SchemaCompanyMappingsQueryVariables>(SchemaCompanyMappingsDocument, options);
        }
export type SchemaCompanyMappingsQueryHookResult = ReturnType<typeof useSchemaCompanyMappingsQuery>;
export type SchemaCompanyMappingsLazyQueryHookResult = ReturnType<typeof useSchemaCompanyMappingsLazyQuery>;
export type SchemaCompanyMappingsSuspenseQueryHookResult = ReturnType<typeof useSchemaCompanyMappingsSuspenseQuery>;
export type SchemaCompanyMappingsQueryResult = Apollo.QueryResult<SchemaCompanyMappingsQuery, SchemaCompanyMappingsQueryVariables>;
export const SchemaDocumentsBySchemaCompanyMappingDocument = gql`
    query schemaDocumentsBySchemaCompanyMapping($schemaCompanyMappingId: String!) {
  schemaDocumentsBySchemaCompanyMapping(
    schemaCompanyMappingId: $schemaCompanyMappingId
  ) {
    uuid
    bucket
    key
    preSignedGetUrl
    company {
      uuid
      name
    }
  }
}
    `;

/**
 * __useSchemaDocumentsBySchemaCompanyMappingQuery__
 *
 * To run a query within a React component, call `useSchemaDocumentsBySchemaCompanyMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaDocumentsBySchemaCompanyMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaDocumentsBySchemaCompanyMappingQuery({
 *   variables: {
 *      schemaCompanyMappingId: // value for 'schemaCompanyMappingId'
 *   },
 * });
 */
export function useSchemaDocumentsBySchemaCompanyMappingQuery(baseOptions: Apollo.QueryHookOptions<SchemaDocumentsBySchemaCompanyMappingQuery, SchemaDocumentsBySchemaCompanyMappingQueryVariables> & ({ variables: SchemaDocumentsBySchemaCompanyMappingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaDocumentsBySchemaCompanyMappingQuery, SchemaDocumentsBySchemaCompanyMappingQueryVariables>(SchemaDocumentsBySchemaCompanyMappingDocument, options);
      }
export function useSchemaDocumentsBySchemaCompanyMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaDocumentsBySchemaCompanyMappingQuery, SchemaDocumentsBySchemaCompanyMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaDocumentsBySchemaCompanyMappingQuery, SchemaDocumentsBySchemaCompanyMappingQueryVariables>(SchemaDocumentsBySchemaCompanyMappingDocument, options);
        }
export function useSchemaDocumentsBySchemaCompanyMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchemaDocumentsBySchemaCompanyMappingQuery, SchemaDocumentsBySchemaCompanyMappingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaDocumentsBySchemaCompanyMappingQuery, SchemaDocumentsBySchemaCompanyMappingQueryVariables>(SchemaDocumentsBySchemaCompanyMappingDocument, options);
        }
export type SchemaDocumentsBySchemaCompanyMappingQueryHookResult = ReturnType<typeof useSchemaDocumentsBySchemaCompanyMappingQuery>;
export type SchemaDocumentsBySchemaCompanyMappingLazyQueryHookResult = ReturnType<typeof useSchemaDocumentsBySchemaCompanyMappingLazyQuery>;
export type SchemaDocumentsBySchemaCompanyMappingSuspenseQueryHookResult = ReturnType<typeof useSchemaDocumentsBySchemaCompanyMappingSuspenseQuery>;
export type SchemaDocumentsBySchemaCompanyMappingQueryResult = Apollo.QueryResult<SchemaDocumentsBySchemaCompanyMappingQuery, SchemaDocumentsBySchemaCompanyMappingQueryVariables>;
export const SearchSchemasDocument = gql`
    query searchSchemas($companyUuid: String, $searchText: String, $isActive: Boolean) {
  searchSchemas(
    companyUuid: $companyUuid
    searchText: $searchText
    isActive: $isActive
  ) {
    uuid
    name
    createdAt
    updatedAt
    companyUuid
    isActive
    scannedDocumentType
    firstTestSchemaDocument {
      uuid
      preSignedGetUrl
      bucket
      key
      company {
        uuid
        name
      }
    }
    testDocumentCount
    companyMappingsCount
  }
}
    `;

/**
 * __useSearchSchemasQuery__
 *
 * To run a query within a React component, call `useSearchSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSchemasQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      searchText: // value for 'searchText'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useSearchSchemasQuery(baseOptions?: Apollo.QueryHookOptions<SearchSchemasQuery, SearchSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSchemasQuery, SearchSchemasQueryVariables>(SearchSchemasDocument, options);
      }
export function useSearchSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSchemasQuery, SearchSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSchemasQuery, SearchSchemasQueryVariables>(SearchSchemasDocument, options);
        }
export function useSearchSchemasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSchemasQuery, SearchSchemasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSchemasQuery, SearchSchemasQueryVariables>(SearchSchemasDocument, options);
        }
export type SearchSchemasQueryHookResult = ReturnType<typeof useSearchSchemasQuery>;
export type SearchSchemasLazyQueryHookResult = ReturnType<typeof useSearchSchemasLazyQuery>;
export type SearchSchemasSuspenseQueryHookResult = ReturnType<typeof useSearchSchemasSuspenseQuery>;
export type SearchSchemasQueryResult = Apollo.QueryResult<SearchSchemasQuery, SearchSchemasQueryVariables>;
export const UpdateSchemaCompanyMappingDocument = gql`
    mutation updateSchemaCompanyMapping($updateSchemaCompanyMappingInput: UpdateSchemaCompanyMappingInput!) {
  updateSchemaCompanyMapping(
    updateSchemaCompanyMappingInput: $updateSchemaCompanyMappingInput
  )
}
    `;
export type UpdateSchemaCompanyMappingMutationFn = Apollo.MutationFunction<UpdateSchemaCompanyMappingMutation, UpdateSchemaCompanyMappingMutationVariables>;

/**
 * __useUpdateSchemaCompanyMappingMutation__
 *
 * To run a mutation, you first call `useUpdateSchemaCompanyMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchemaCompanyMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchemaCompanyMappingMutation, { data, loading, error }] = useUpdateSchemaCompanyMappingMutation({
 *   variables: {
 *      updateSchemaCompanyMappingInput: // value for 'updateSchemaCompanyMappingInput'
 *   },
 * });
 */
export function useUpdateSchemaCompanyMappingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchemaCompanyMappingMutation, UpdateSchemaCompanyMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchemaCompanyMappingMutation, UpdateSchemaCompanyMappingMutationVariables>(UpdateSchemaCompanyMappingDocument, options);
      }
export type UpdateSchemaCompanyMappingMutationHookResult = ReturnType<typeof useUpdateSchemaCompanyMappingMutation>;
export type UpdateSchemaCompanyMappingMutationResult = Apollo.MutationResult<UpdateSchemaCompanyMappingMutation>;
export type UpdateSchemaCompanyMappingMutationOptions = Apollo.BaseMutationOptions<UpdateSchemaCompanyMappingMutation, UpdateSchemaCompanyMappingMutationVariables>;
export const VerifySchemaDocumentMatchesForCompanyDocument = gql`
    query verifySchemaDocumentMatchesForCompany($companyUuid: String!, $schemaDocumentUuid: String) {
  verifySchemaDocumentMatchesForCompany(
    companyUuid: $companyUuid
    schemaDocumentUuid: $schemaDocumentUuid
  )
}
    `;

/**
 * __useVerifySchemaDocumentMatchesForCompanyQuery__
 *
 * To run a query within a React component, call `useVerifySchemaDocumentMatchesForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifySchemaDocumentMatchesForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifySchemaDocumentMatchesForCompanyQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      schemaDocumentUuid: // value for 'schemaDocumentUuid'
 *   },
 * });
 */
export function useVerifySchemaDocumentMatchesForCompanyQuery(baseOptions: Apollo.QueryHookOptions<VerifySchemaDocumentMatchesForCompanyQuery, VerifySchemaDocumentMatchesForCompanyQueryVariables> & ({ variables: VerifySchemaDocumentMatchesForCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifySchemaDocumentMatchesForCompanyQuery, VerifySchemaDocumentMatchesForCompanyQueryVariables>(VerifySchemaDocumentMatchesForCompanyDocument, options);
      }
export function useVerifySchemaDocumentMatchesForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifySchemaDocumentMatchesForCompanyQuery, VerifySchemaDocumentMatchesForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifySchemaDocumentMatchesForCompanyQuery, VerifySchemaDocumentMatchesForCompanyQueryVariables>(VerifySchemaDocumentMatchesForCompanyDocument, options);
        }
export function useVerifySchemaDocumentMatchesForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerifySchemaDocumentMatchesForCompanyQuery, VerifySchemaDocumentMatchesForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerifySchemaDocumentMatchesForCompanyQuery, VerifySchemaDocumentMatchesForCompanyQueryVariables>(VerifySchemaDocumentMatchesForCompanyDocument, options);
        }
export type VerifySchemaDocumentMatchesForCompanyQueryHookResult = ReturnType<typeof useVerifySchemaDocumentMatchesForCompanyQuery>;
export type VerifySchemaDocumentMatchesForCompanyLazyQueryHookResult = ReturnType<typeof useVerifySchemaDocumentMatchesForCompanyLazyQuery>;
export type VerifySchemaDocumentMatchesForCompanySuspenseQueryHookResult = ReturnType<typeof useVerifySchemaDocumentMatchesForCompanySuspenseQuery>;
export type VerifySchemaDocumentMatchesForCompanyQueryResult = Apollo.QueryResult<VerifySchemaDocumentMatchesForCompanyQuery, VerifySchemaDocumentMatchesForCompanyQueryVariables>;
export const SchemaFilePutUrlDocument = gql`
    query schemaFilePutUrl($schemaFilePutUrlInput: SchemaFilePutUrlInput!) {
  schemaFilePutUrl(schemaFilePutUrlInput: $schemaFilePutUrlInput)
}
    `;

/**
 * __useSchemaFilePutUrlQuery__
 *
 * To run a query within a React component, call `useSchemaFilePutUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaFilePutUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaFilePutUrlQuery({
 *   variables: {
 *      schemaFilePutUrlInput: // value for 'schemaFilePutUrlInput'
 *   },
 * });
 */
export function useSchemaFilePutUrlQuery(baseOptions: Apollo.QueryHookOptions<SchemaFilePutUrlQuery, SchemaFilePutUrlQueryVariables> & ({ variables: SchemaFilePutUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaFilePutUrlQuery, SchemaFilePutUrlQueryVariables>(SchemaFilePutUrlDocument, options);
      }
export function useSchemaFilePutUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaFilePutUrlQuery, SchemaFilePutUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaFilePutUrlQuery, SchemaFilePutUrlQueryVariables>(SchemaFilePutUrlDocument, options);
        }
export function useSchemaFilePutUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchemaFilePutUrlQuery, SchemaFilePutUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaFilePutUrlQuery, SchemaFilePutUrlQueryVariables>(SchemaFilePutUrlDocument, options);
        }
export type SchemaFilePutUrlQueryHookResult = ReturnType<typeof useSchemaFilePutUrlQuery>;
export type SchemaFilePutUrlLazyQueryHookResult = ReturnType<typeof useSchemaFilePutUrlLazyQuery>;
export type SchemaFilePutUrlSuspenseQueryHookResult = ReturnType<typeof useSchemaFilePutUrlSuspenseQuery>;
export type SchemaFilePutUrlQueryResult = Apollo.QueryResult<SchemaFilePutUrlQuery, SchemaFilePutUrlQueryVariables>;
export const SchemaRunTestListDocument = gql`
    query schemaRunTestList($schemaRunTestListInput: SchemaRunTestListInput!) {
  schemaRunTestList(schemaRunTestListInput: $schemaRunTestListInput) {
    uuid
    schemaRunTestStatus
    schemaRuns {
      ...SchemaRun
      schemaRunTestSnapshot {
        ...SchemaRun
      }
    }
  }
}
    ${SchemaRunFragmentDoc}`;

/**
 * __useSchemaRunTestListQuery__
 *
 * To run a query within a React component, call `useSchemaRunTestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaRunTestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaRunTestListQuery({
 *   variables: {
 *      schemaRunTestListInput: // value for 'schemaRunTestListInput'
 *   },
 * });
 */
export function useSchemaRunTestListQuery(baseOptions: Apollo.QueryHookOptions<SchemaRunTestListQuery, SchemaRunTestListQueryVariables> & ({ variables: SchemaRunTestListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaRunTestListQuery, SchemaRunTestListQueryVariables>(SchemaRunTestListDocument, options);
      }
export function useSchemaRunTestListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaRunTestListQuery, SchemaRunTestListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaRunTestListQuery, SchemaRunTestListQueryVariables>(SchemaRunTestListDocument, options);
        }
export function useSchemaRunTestListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchemaRunTestListQuery, SchemaRunTestListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaRunTestListQuery, SchemaRunTestListQueryVariables>(SchemaRunTestListDocument, options);
        }
export type SchemaRunTestListQueryHookResult = ReturnType<typeof useSchemaRunTestListQuery>;
export type SchemaRunTestListLazyQueryHookResult = ReturnType<typeof useSchemaRunTestListLazyQuery>;
export type SchemaRunTestListSuspenseQueryHookResult = ReturnType<typeof useSchemaRunTestListSuspenseQuery>;
export type SchemaRunTestListQueryResult = Apollo.QueryResult<SchemaRunTestListQuery, SchemaRunTestListQueryVariables>;
export const SchemaRunTestSnapshotsDocument = gql`
    query schemaRunTestSnapshots {
  schemaRunTestSnapshots {
    ...SchemaRun
  }
}
    ${SchemaRunFragmentDoc}`;

/**
 * __useSchemaRunTestSnapshotsQuery__
 *
 * To run a query within a React component, call `useSchemaRunTestSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaRunTestSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaRunTestSnapshotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchemaRunTestSnapshotsQuery(baseOptions?: Apollo.QueryHookOptions<SchemaRunTestSnapshotsQuery, SchemaRunTestSnapshotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaRunTestSnapshotsQuery, SchemaRunTestSnapshotsQueryVariables>(SchemaRunTestSnapshotsDocument, options);
      }
export function useSchemaRunTestSnapshotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaRunTestSnapshotsQuery, SchemaRunTestSnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaRunTestSnapshotsQuery, SchemaRunTestSnapshotsQueryVariables>(SchemaRunTestSnapshotsDocument, options);
        }
export function useSchemaRunTestSnapshotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchemaRunTestSnapshotsQuery, SchemaRunTestSnapshotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaRunTestSnapshotsQuery, SchemaRunTestSnapshotsQueryVariables>(SchemaRunTestSnapshotsDocument, options);
        }
export type SchemaRunTestSnapshotsQueryHookResult = ReturnType<typeof useSchemaRunTestSnapshotsQuery>;
export type SchemaRunTestSnapshotsLazyQueryHookResult = ReturnType<typeof useSchemaRunTestSnapshotsLazyQuery>;
export type SchemaRunTestSnapshotsSuspenseQueryHookResult = ReturnType<typeof useSchemaRunTestSnapshotsSuspenseQuery>;
export type SchemaRunTestSnapshotsQueryResult = Apollo.QueryResult<SchemaRunTestSnapshotsQuery, SchemaRunTestSnapshotsQueryVariables>;
export const SchemaRunDocument = gql`
    query schemaRun($uuid: String!) {
  schemaRun(uuid: $uuid) {
    ...SchemaRun
  }
}
    ${SchemaRunFragmentDoc}`;

/**
 * __useSchemaRunQuery__
 *
 * To run a query within a React component, call `useSchemaRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaRunQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSchemaRunQuery(baseOptions: Apollo.QueryHookOptions<SchemaRunQuery, SchemaRunQueryVariables> & ({ variables: SchemaRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaRunQuery, SchemaRunQueryVariables>(SchemaRunDocument, options);
      }
export function useSchemaRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaRunQuery, SchemaRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaRunQuery, SchemaRunQueryVariables>(SchemaRunDocument, options);
        }
export function useSchemaRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchemaRunQuery, SchemaRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaRunQuery, SchemaRunQueryVariables>(SchemaRunDocument, options);
        }
export type SchemaRunQueryHookResult = ReturnType<typeof useSchemaRunQuery>;
export type SchemaRunLazyQueryHookResult = ReturnType<typeof useSchemaRunLazyQuery>;
export type SchemaRunSuspenseQueryHookResult = ReturnType<typeof useSchemaRunSuspenseQuery>;
export type SchemaRunQueryResult = Apollo.QueryResult<SchemaRunQuery, SchemaRunQueryVariables>;
export const SchemaTestFilePutUrlDocument = gql`
    query schemaTestFilePutUrl($schemaTestFilePutUrlInput: SchemaTestFilePutUrlInput!) {
  schemaTestFilePutUrl(schemaTestFilePutUrlInput: $schemaTestFilePutUrlInput)
}
    `;

/**
 * __useSchemaTestFilePutUrlQuery__
 *
 * To run a query within a React component, call `useSchemaTestFilePutUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaTestFilePutUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaTestFilePutUrlQuery({
 *   variables: {
 *      schemaTestFilePutUrlInput: // value for 'schemaTestFilePutUrlInput'
 *   },
 * });
 */
export function useSchemaTestFilePutUrlQuery(baseOptions: Apollo.QueryHookOptions<SchemaTestFilePutUrlQuery, SchemaTestFilePutUrlQueryVariables> & ({ variables: SchemaTestFilePutUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTestFilePutUrlQuery, SchemaTestFilePutUrlQueryVariables>(SchemaTestFilePutUrlDocument, options);
      }
export function useSchemaTestFilePutUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTestFilePutUrlQuery, SchemaTestFilePutUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTestFilePutUrlQuery, SchemaTestFilePutUrlQueryVariables>(SchemaTestFilePutUrlDocument, options);
        }
export function useSchemaTestFilePutUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchemaTestFilePutUrlQuery, SchemaTestFilePutUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaTestFilePutUrlQuery, SchemaTestFilePutUrlQueryVariables>(SchemaTestFilePutUrlDocument, options);
        }
export type SchemaTestFilePutUrlQueryHookResult = ReturnType<typeof useSchemaTestFilePutUrlQuery>;
export type SchemaTestFilePutUrlLazyQueryHookResult = ReturnType<typeof useSchemaTestFilePutUrlLazyQuery>;
export type SchemaTestFilePutUrlSuspenseQueryHookResult = ReturnType<typeof useSchemaTestFilePutUrlSuspenseQuery>;
export type SchemaTestFilePutUrlQueryResult = Apollo.QueryResult<SchemaTestFilePutUrlQuery, SchemaTestFilePutUrlQueryVariables>;
export const SchemasDocument = gql`
    query schemas {
  schemas {
    uuid
    companyUuid
    contactUuid
    isMultiPage
    isActive
    name
    originalFilename
    packageTables {
      uuid
      blockId
      headerRowIndex
      packageTableColumns {
        ...PackageTableColumn
      }
      title
    }
    scannedDocumentType
    textractType
    schemaFields {
      uuid
      left
      top
      height
      width
      concatenateX
      leftEdgeAnchor {
        ...EdgeAnchor
      }
      rightEdgeAnchor {
        ...EdgeAnchor
      }
      topEdgeAnchor {
        ...EdgeAnchor
      }
      bottomEdgeAnchor {
        ...EdgeAnchor
      }
      fieldExtractors {
        uuid
        type
        value
        mapping
      }
      fieldMatchers {
        uuid
        type
        value
      }
    }
    fingerprintAnchors {
      ...FingerprintAnchor
    }
    transformAnchors {
      ...TransformAnchor
    }
  }
}
    ${PackageTableColumnFragmentDoc}
${EdgeAnchorFragmentDoc}
${FingerprintAnchorFragmentDoc}
${TransformAnchorFragmentDoc}`;

/**
 * __useSchemasQuery__
 *
 * To run a query within a React component, call `useSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemasQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchemasQuery(baseOptions?: Apollo.QueryHookOptions<SchemasQuery, SchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemasQuery, SchemasQueryVariables>(SchemasDocument, options);
      }
export function useSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemasQuery, SchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemasQuery, SchemasQueryVariables>(SchemasDocument, options);
        }
export function useSchemasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchemasQuery, SchemasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemasQuery, SchemasQueryVariables>(SchemasDocument, options);
        }
export type SchemasQueryHookResult = ReturnType<typeof useSchemasQuery>;
export type SchemasLazyQueryHookResult = ReturnType<typeof useSchemasLazyQuery>;
export type SchemasSuspenseQueryHookResult = ReturnType<typeof useSchemasSuspenseQuery>;
export type SchemasQueryResult = Apollo.QueryResult<SchemasQuery, SchemasQueryVariables>;
export const SftpUploadsDocument = gql`
    query sftpUploads($companyUuid: String, $contactUuid: String, $status: SftpUploadStatus, $type: SftpUploadType, $first: Int, $after: String, $last: Int, $before: String) {
  sftpUploads(
    findSftpUploadsInput: {companyUuid: $companyUuid, contactUuid: $contactUuid, status: $status, type: $type, first: $first, after: $after, last: $last, before: $before}
  ) {
    edges {
      node {
        uuid
        company {
          name
        }
        contact {
          displayName
        }
        createdAt
        type
        order {
          uuid
          standardOrderFields {
            shipperBillOfLadingNumber
          }
        }
        status
        error
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useSftpUploadsQuery__
 *
 * To run a query within a React component, call `useSftpUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSftpUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSftpUploadsQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      contactUuid: // value for 'contactUuid'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useSftpUploadsQuery(baseOptions?: Apollo.QueryHookOptions<SftpUploadsQuery, SftpUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SftpUploadsQuery, SftpUploadsQueryVariables>(SftpUploadsDocument, options);
      }
export function useSftpUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SftpUploadsQuery, SftpUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SftpUploadsQuery, SftpUploadsQueryVariables>(SftpUploadsDocument, options);
        }
export function useSftpUploadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SftpUploadsQuery, SftpUploadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SftpUploadsQuery, SftpUploadsQueryVariables>(SftpUploadsDocument, options);
        }
export type SftpUploadsQueryHookResult = ReturnType<typeof useSftpUploadsQuery>;
export type SftpUploadsLazyQueryHookResult = ReturnType<typeof useSftpUploadsLazyQuery>;
export type SftpUploadsSuspenseQueryHookResult = ReturnType<typeof useSftpUploadsSuspenseQuery>;
export type SftpUploadsQueryResult = Apollo.QueryResult<SftpUploadsQuery, SftpUploadsQueryVariables>;
export const StartConfigMigrationDocument = gql`
    mutation StartConfigMigration($input: StartConfigMigrationInput!) {
  startConfigMigration(input: $input)
}
    `;
export type StartConfigMigrationMutationFn = Apollo.MutationFunction<StartConfigMigrationMutation, StartConfigMigrationMutationVariables>;

/**
 * __useStartConfigMigrationMutation__
 *
 * To run a mutation, you first call `useStartConfigMigrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartConfigMigrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startConfigMigrationMutation, { data, loading, error }] = useStartConfigMigrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartConfigMigrationMutation(baseOptions?: Apollo.MutationHookOptions<StartConfigMigrationMutation, StartConfigMigrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartConfigMigrationMutation, StartConfigMigrationMutationVariables>(StartConfigMigrationDocument, options);
      }
export type StartConfigMigrationMutationHookResult = ReturnType<typeof useStartConfigMigrationMutation>;
export type StartConfigMigrationMutationResult = Apollo.MutationResult<StartConfigMigrationMutation>;
export type StartConfigMigrationMutationOptions = Apollo.BaseMutationOptions<StartConfigMigrationMutation, StartConfigMigrationMutationVariables>;
export const TerminalsForInternalDocument = gql`
    query terminalsForInternal($getTerminalsInternalInput: GetTerminalsInternalInput!) {
  terminalsForInternal(getTerminalsInternalInput: $getTerminalsInternalInput) {
    ...Terminals
  }
}
    ${TerminalsFragmentDoc}`;

/**
 * __useTerminalsForInternalQuery__
 *
 * To run a query within a React component, call `useTerminalsForInternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerminalsForInternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerminalsForInternalQuery({
 *   variables: {
 *      getTerminalsInternalInput: // value for 'getTerminalsInternalInput'
 *   },
 * });
 */
export function useTerminalsForInternalQuery(baseOptions: Apollo.QueryHookOptions<TerminalsForInternalQuery, TerminalsForInternalQueryVariables> & ({ variables: TerminalsForInternalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TerminalsForInternalQuery, TerminalsForInternalQueryVariables>(TerminalsForInternalDocument, options);
      }
export function useTerminalsForInternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TerminalsForInternalQuery, TerminalsForInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TerminalsForInternalQuery, TerminalsForInternalQueryVariables>(TerminalsForInternalDocument, options);
        }
export function useTerminalsForInternalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TerminalsForInternalQuery, TerminalsForInternalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TerminalsForInternalQuery, TerminalsForInternalQueryVariables>(TerminalsForInternalDocument, options);
        }
export type TerminalsForInternalQueryHookResult = ReturnType<typeof useTerminalsForInternalQuery>;
export type TerminalsForInternalLazyQueryHookResult = ReturnType<typeof useTerminalsForInternalLazyQuery>;
export type TerminalsForInternalSuspenseQueryHookResult = ReturnType<typeof useTerminalsForInternalSuspenseQuery>;
export type TerminalsForInternalQueryResult = Apollo.QueryResult<TerminalsForInternalQuery, TerminalsForInternalQueryVariables>;
export const TerminalsDocument = gql`
    query terminals($getTerminalsInput: GetTerminalsInput) {
  terminals(getTerminalsInput: $getTerminalsInput) {
    ...Terminals
  }
}
    ${TerminalsFragmentDoc}`;

/**
 * __useTerminalsQuery__
 *
 * To run a query within a React component, call `useTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerminalsQuery({
 *   variables: {
 *      getTerminalsInput: // value for 'getTerminalsInput'
 *   },
 * });
 */
export function useTerminalsQuery(baseOptions?: Apollo.QueryHookOptions<TerminalsQuery, TerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TerminalsQuery, TerminalsQueryVariables>(TerminalsDocument, options);
      }
export function useTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TerminalsQuery, TerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TerminalsQuery, TerminalsQueryVariables>(TerminalsDocument, options);
        }
export function useTerminalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TerminalsQuery, TerminalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TerminalsQuery, TerminalsQueryVariables>(TerminalsDocument, options);
        }
export type TerminalsQueryHookResult = ReturnType<typeof useTerminalsQuery>;
export type TerminalsLazyQueryHookResult = ReturnType<typeof useTerminalsLazyQuery>;
export type TerminalsSuspenseQueryHookResult = ReturnType<typeof useTerminalsSuspenseQuery>;
export type TerminalsQueryResult = Apollo.QueryResult<TerminalsQuery, TerminalsQueryVariables>;
export const TestAllSnapshotsDocument = gql`
    mutation testAllSnapshots {
  testAllSnapshots
}
    `;
export type TestAllSnapshotsMutationFn = Apollo.MutationFunction<TestAllSnapshotsMutation, TestAllSnapshotsMutationVariables>;

/**
 * __useTestAllSnapshotsMutation__
 *
 * To run a mutation, you first call `useTestAllSnapshotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestAllSnapshotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testAllSnapshotsMutation, { data, loading, error }] = useTestAllSnapshotsMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestAllSnapshotsMutation(baseOptions?: Apollo.MutationHookOptions<TestAllSnapshotsMutation, TestAllSnapshotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestAllSnapshotsMutation, TestAllSnapshotsMutationVariables>(TestAllSnapshotsDocument, options);
      }
export type TestAllSnapshotsMutationHookResult = ReturnType<typeof useTestAllSnapshotsMutation>;
export type TestAllSnapshotsMutationResult = Apollo.MutationResult<TestAllSnapshotsMutation>;
export type TestAllSnapshotsMutationOptions = Apollo.BaseMutationOptions<TestAllSnapshotsMutation, TestAllSnapshotsMutationVariables>;
export const TestOneSnapshotDocument = gql`
    mutation testOneSnapshot($testOneSnapshotInput: TestOneSnapshotInput!) {
  testOneSnapshot(testOneSnapshotInput: $testOneSnapshotInput)
}
    `;
export type TestOneSnapshotMutationFn = Apollo.MutationFunction<TestOneSnapshotMutation, TestOneSnapshotMutationVariables>;

/**
 * __useTestOneSnapshotMutation__
 *
 * To run a mutation, you first call `useTestOneSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestOneSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testOneSnapshotMutation, { data, loading, error }] = useTestOneSnapshotMutation({
 *   variables: {
 *      testOneSnapshotInput: // value for 'testOneSnapshotInput'
 *   },
 * });
 */
export function useTestOneSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<TestOneSnapshotMutation, TestOneSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestOneSnapshotMutation, TestOneSnapshotMutationVariables>(TestOneSnapshotDocument, options);
      }
export type TestOneSnapshotMutationHookResult = ReturnType<typeof useTestOneSnapshotMutation>;
export type TestOneSnapshotMutationResult = Apollo.MutationResult<TestOneSnapshotMutation>;
export type TestOneSnapshotMutationOptions = Apollo.BaseMutationOptions<TestOneSnapshotMutation, TestOneSnapshotMutationVariables>;
export const CreateTestOrderCustomChargeDocument = gql`
    mutation createTestOrderCustomCharge($createTestOrderCustomChargeInput: CreateTestOrderCustomChargeInput!) {
  createTestOrderCustomCharge(
    createTestOrderCustomChargeInput: $createTestOrderCustomChargeInput
  ) {
    success
  }
}
    `;
export type CreateTestOrderCustomChargeMutationFn = Apollo.MutationFunction<CreateTestOrderCustomChargeMutation, CreateTestOrderCustomChargeMutationVariables>;

/**
 * __useCreateTestOrderCustomChargeMutation__
 *
 * To run a mutation, you first call `useCreateTestOrderCustomChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestOrderCustomChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestOrderCustomChargeMutation, { data, loading, error }] = useCreateTestOrderCustomChargeMutation({
 *   variables: {
 *      createTestOrderCustomChargeInput: // value for 'createTestOrderCustomChargeInput'
 *   },
 * });
 */
export function useCreateTestOrderCustomChargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestOrderCustomChargeMutation, CreateTestOrderCustomChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestOrderCustomChargeMutation, CreateTestOrderCustomChargeMutationVariables>(CreateTestOrderCustomChargeDocument, options);
      }
export type CreateTestOrderCustomChargeMutationHookResult = ReturnType<typeof useCreateTestOrderCustomChargeMutation>;
export type CreateTestOrderCustomChargeMutationResult = Apollo.MutationResult<CreateTestOrderCustomChargeMutation>;
export type CreateTestOrderCustomChargeMutationOptions = Apollo.BaseMutationOptions<CreateTestOrderCustomChargeMutation, CreateTestOrderCustomChargeMutationVariables>;
export const CreateTestOrderV2Document = gql`
    mutation createTestOrderV2($createTestOrderRequest: CreateTestOrderRequest!) {
  createTestOrderV2(createTestOrderRequest: $createTestOrderRequest) {
    success
  }
}
    `;
export type CreateTestOrderV2MutationFn = Apollo.MutationFunction<CreateTestOrderV2Mutation, CreateTestOrderV2MutationVariables>;

/**
 * __useCreateTestOrderV2Mutation__
 *
 * To run a mutation, you first call `useCreateTestOrderV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestOrderV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestOrderV2Mutation, { data, loading, error }] = useCreateTestOrderV2Mutation({
 *   variables: {
 *      createTestOrderRequest: // value for 'createTestOrderRequest'
 *   },
 * });
 */
export function useCreateTestOrderV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateTestOrderV2Mutation, CreateTestOrderV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestOrderV2Mutation, CreateTestOrderV2MutationVariables>(CreateTestOrderV2Document, options);
      }
export type CreateTestOrderV2MutationHookResult = ReturnType<typeof useCreateTestOrderV2Mutation>;
export type CreateTestOrderV2MutationResult = Apollo.MutationResult<CreateTestOrderV2Mutation>;
export type CreateTestOrderV2MutationOptions = Apollo.BaseMutationOptions<CreateTestOrderV2Mutation, CreateTestOrderV2MutationVariables>;
export const TestOrderDocument = gql`
    query testOrder($findTestOrderInput: FindTestOrderInput!) {
  testOrder(findTestOrderInput: $findTestOrderInput) {
    testOrder {
      ...FindTestOrder
    }
  }
}
    ${FindTestOrderFragmentDoc}`;

/**
 * __useTestOrderQuery__
 *
 * To run a query within a React component, call `useTestOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestOrderQuery({
 *   variables: {
 *      findTestOrderInput: // value for 'findTestOrderInput'
 *   },
 * });
 */
export function useTestOrderQuery(baseOptions: Apollo.QueryHookOptions<TestOrderQuery, TestOrderQueryVariables> & ({ variables: TestOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestOrderQuery, TestOrderQueryVariables>(TestOrderDocument, options);
      }
export function useTestOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestOrderQuery, TestOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestOrderQuery, TestOrderQueryVariables>(TestOrderDocument, options);
        }
export function useTestOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestOrderQuery, TestOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestOrderQuery, TestOrderQueryVariables>(TestOrderDocument, options);
        }
export type TestOrderQueryHookResult = ReturnType<typeof useTestOrderQuery>;
export type TestOrderLazyQueryHookResult = ReturnType<typeof useTestOrderLazyQuery>;
export type TestOrderSuspenseQueryHookResult = ReturnType<typeof useTestOrderSuspenseQuery>;
export type TestOrderQueryResult = Apollo.QueryResult<TestOrderQuery, TestOrderQueryVariables>;
export const TestOrdersDocument = gql`
    query testOrders {
  testOrders {
    testOrders {
      ...TestOrder
    }
  }
}
    ${TestOrderFragmentDoc}`;

/**
 * __useTestOrdersQuery__
 *
 * To run a query within a React component, call `useTestOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestOrdersQuery(baseOptions?: Apollo.QueryHookOptions<TestOrdersQuery, TestOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestOrdersQuery, TestOrdersQueryVariables>(TestOrdersDocument, options);
      }
export function useTestOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestOrdersQuery, TestOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestOrdersQuery, TestOrdersQueryVariables>(TestOrdersDocument, options);
        }
export function useTestOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestOrdersQuery, TestOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestOrdersQuery, TestOrdersQueryVariables>(TestOrdersDocument, options);
        }
export type TestOrdersQueryHookResult = ReturnType<typeof useTestOrdersQuery>;
export type TestOrdersLazyQueryHookResult = ReturnType<typeof useTestOrdersLazyQuery>;
export type TestOrdersSuspenseQueryHookResult = ReturnType<typeof useTestOrdersSuspenseQuery>;
export type TestOrdersQueryResult = Apollo.QueryResult<TestOrdersQuery, TestOrdersQueryVariables>;
export const UpdateTestOrderDocument = gql`
    mutation updateTestOrder($updateTestOrderInput: UpdateTestOrderInput!) {
  updateTestOrder(updateTestOrderInput: $updateTestOrderInput) {
    success
  }
}
    `;
export type UpdateTestOrderMutationFn = Apollo.MutationFunction<UpdateTestOrderMutation, UpdateTestOrderMutationVariables>;

/**
 * __useUpdateTestOrderMutation__
 *
 * To run a mutation, you first call `useUpdateTestOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestOrderMutation, { data, loading, error }] = useUpdateTestOrderMutation({
 *   variables: {
 *      updateTestOrderInput: // value for 'updateTestOrderInput'
 *   },
 * });
 */
export function useUpdateTestOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestOrderMutation, UpdateTestOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestOrderMutation, UpdateTestOrderMutationVariables>(UpdateTestOrderDocument, options);
      }
export type UpdateTestOrderMutationHookResult = ReturnType<typeof useUpdateTestOrderMutation>;
export type UpdateTestOrderMutationResult = Apollo.MutationResult<UpdateTestOrderMutation>;
export type UpdateTestOrderMutationOptions = Apollo.BaseMutationOptions<UpdateTestOrderMutation, UpdateTestOrderMutationVariables>;
export const TestSchemaDocument = gql`
    mutation testSchema($testSchemaInput: TestSchemaInput!) {
  testSchema(testSchemaInput: $testSchemaInput)
}
    `;
export type TestSchemaMutationFn = Apollo.MutationFunction<TestSchemaMutation, TestSchemaMutationVariables>;

/**
 * __useTestSchemaMutation__
 *
 * To run a mutation, you first call `useTestSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testSchemaMutation, { data, loading, error }] = useTestSchemaMutation({
 *   variables: {
 *      testSchemaInput: // value for 'testSchemaInput'
 *   },
 * });
 */
export function useTestSchemaMutation(baseOptions?: Apollo.MutationHookOptions<TestSchemaMutation, TestSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestSchemaMutation, TestSchemaMutationVariables>(TestSchemaDocument, options);
      }
export type TestSchemaMutationHookResult = ReturnType<typeof useTestSchemaMutation>;
export type TestSchemaMutationResult = Apollo.MutationResult<TestSchemaMutation>;
export type TestSchemaMutationOptions = Apollo.BaseMutationOptions<TestSchemaMutation, TestSchemaMutationVariables>;
export const TextractSchemaFileDocument = gql`
    mutation textractSchemaFile($textractSchemaFileInput: TextractSchemaFileInput!) {
  textractSchemaFile(textractSchemaFileInput: $textractSchemaFileInput)
}
    `;
export type TextractSchemaFileMutationFn = Apollo.MutationFunction<TextractSchemaFileMutation, TextractSchemaFileMutationVariables>;

/**
 * __useTextractSchemaFileMutation__
 *
 * To run a mutation, you first call `useTextractSchemaFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTextractSchemaFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [textractSchemaFileMutation, { data, loading, error }] = useTextractSchemaFileMutation({
 *   variables: {
 *      textractSchemaFileInput: // value for 'textractSchemaFileInput'
 *   },
 * });
 */
export function useTextractSchemaFileMutation(baseOptions?: Apollo.MutationHookOptions<TextractSchemaFileMutation, TextractSchemaFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TextractSchemaFileMutation, TextractSchemaFileMutationVariables>(TextractSchemaFileDocument, options);
      }
export type TextractSchemaFileMutationHookResult = ReturnType<typeof useTextractSchemaFileMutation>;
export type TextractSchemaFileMutationResult = Apollo.MutationResult<TextractSchemaFileMutation>;
export type TextractSchemaFileMutationOptions = Apollo.BaseMutationOptions<TextractSchemaFileMutation, TextractSchemaFileMutationVariables>;
export const TextractSchemaTestFileDocument = gql`
    mutation textractSchemaTestFile($textractSchemaTestFileInput: TextractSchemaTestFileInput!) {
  textractSchemaTestFile(
    textractSchemaTestFileInput: $textractSchemaTestFileInput
  )
}
    `;
export type TextractSchemaTestFileMutationFn = Apollo.MutationFunction<TextractSchemaTestFileMutation, TextractSchemaTestFileMutationVariables>;

/**
 * __useTextractSchemaTestFileMutation__
 *
 * To run a mutation, you first call `useTextractSchemaTestFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTextractSchemaTestFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [textractSchemaTestFileMutation, { data, loading, error }] = useTextractSchemaTestFileMutation({
 *   variables: {
 *      textractSchemaTestFileInput: // value for 'textractSchemaTestFileInput'
 *   },
 * });
 */
export function useTextractSchemaTestFileMutation(baseOptions?: Apollo.MutationHookOptions<TextractSchemaTestFileMutation, TextractSchemaTestFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TextractSchemaTestFileMutation, TextractSchemaTestFileMutationVariables>(TextractSchemaTestFileDocument, options);
      }
export type TextractSchemaTestFileMutationHookResult = ReturnType<typeof useTextractSchemaTestFileMutation>;
export type TextractSchemaTestFileMutationResult = Apollo.MutationResult<TextractSchemaTestFileMutation>;
export type TextractSchemaTestFileMutationOptions = Apollo.BaseMutationOptions<TextractSchemaTestFileMutation, TextractSchemaTestFileMutationVariables>;
export const UpdateSchemaDocument = gql`
    mutation updateSchema($updateSchemaInput: UpdateSchemaInput!) {
  updateSchema(updateSchemaInput: $updateSchemaInput)
}
    `;
export type UpdateSchemaMutationFn = Apollo.MutationFunction<UpdateSchemaMutation, UpdateSchemaMutationVariables>;

/**
 * __useUpdateSchemaMutation__
 *
 * To run a mutation, you first call `useUpdateSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchemaMutation, { data, loading, error }] = useUpdateSchemaMutation({
 *   variables: {
 *      updateSchemaInput: // value for 'updateSchemaInput'
 *   },
 * });
 */
export function useUpdateSchemaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchemaMutation, UpdateSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchemaMutation, UpdateSchemaMutationVariables>(UpdateSchemaDocument, options);
      }
export type UpdateSchemaMutationHookResult = ReturnType<typeof useUpdateSchemaMutation>;
export type UpdateSchemaMutationResult = Apollo.MutationResult<UpdateSchemaMutation>;
export type UpdateSchemaMutationOptions = Apollo.BaseMutationOptions<UpdateSchemaMutation, UpdateSchemaMutationVariables>;
export const UserRolesDocument = gql`
    query userRoles {
  userRoles {
    ...MeRole
  }
}
    ${MeRoleFragmentDoc}`;

/**
 * __useUserRolesQuery__
 *
 * To run a query within a React component, call `useUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
      }
export function useUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
export function useUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
export type UserRolesQueryHookResult = ReturnType<typeof useUserRolesQuery>;
export type UserRolesLazyQueryHookResult = ReturnType<typeof useUserRolesLazyQuery>;
export type UserRolesSuspenseQueryHookResult = ReturnType<typeof useUserRolesSuspenseQuery>;
export type UserRolesQueryResult = Apollo.QueryResult<UserRolesQuery, UserRolesQueryVariables>;
export const ValidateCrownChargesFromCsvDocument = gql`
    mutation validateCrownChargesFromCSV($validateCrownChargesInput: ValidateCrownChargesInput!) {
  validateCrownChargesFromCSV(
    validateCrownChargesInput: $validateCrownChargesInput
  ) {
    resultsUrl
    csvResults
    correctCrownIDs
    wrongCrownIDs
  }
}
    `;
export type ValidateCrownChargesFromCsvMutationFn = Apollo.MutationFunction<ValidateCrownChargesFromCsvMutation, ValidateCrownChargesFromCsvMutationVariables>;

/**
 * __useValidateCrownChargesFromCsvMutation__
 *
 * To run a mutation, you first call `useValidateCrownChargesFromCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCrownChargesFromCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCrownChargesFromCsvMutation, { data, loading, error }] = useValidateCrownChargesFromCsvMutation({
 *   variables: {
 *      validateCrownChargesInput: // value for 'validateCrownChargesInput'
 *   },
 * });
 */
export function useValidateCrownChargesFromCsvMutation(baseOptions?: Apollo.MutationHookOptions<ValidateCrownChargesFromCsvMutation, ValidateCrownChargesFromCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateCrownChargesFromCsvMutation, ValidateCrownChargesFromCsvMutationVariables>(ValidateCrownChargesFromCsvDocument, options);
      }
export type ValidateCrownChargesFromCsvMutationHookResult = ReturnType<typeof useValidateCrownChargesFromCsvMutation>;
export type ValidateCrownChargesFromCsvMutationResult = Apollo.MutationResult<ValidateCrownChargesFromCsvMutation>;
export type ValidateCrownChargesFromCsvMutationOptions = Apollo.BaseMutationOptions<ValidateCrownChargesFromCsvMutation, ValidateCrownChargesFromCsvMutationVariables>;
export const ValidateCrownChargesFromPdfDocument = gql`
    mutation validateCrownChargesFromPDF($validateCrownChargesInput: ValidateCrownChargesInput!) {
  validateCrownChargesFromPDF(
    validateCrownChargesInput: $validateCrownChargesInput
  ) {
    resultsUrl
    csvResults
    correctCrownIDs
    wrongCrownIDs
  }
}
    `;
export type ValidateCrownChargesFromPdfMutationFn = Apollo.MutationFunction<ValidateCrownChargesFromPdfMutation, ValidateCrownChargesFromPdfMutationVariables>;

/**
 * __useValidateCrownChargesFromPdfMutation__
 *
 * To run a mutation, you first call `useValidateCrownChargesFromPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCrownChargesFromPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCrownChargesFromPdfMutation, { data, loading, error }] = useValidateCrownChargesFromPdfMutation({
 *   variables: {
 *      validateCrownChargesInput: // value for 'validateCrownChargesInput'
 *   },
 * });
 */
export function useValidateCrownChargesFromPdfMutation(baseOptions?: Apollo.MutationHookOptions<ValidateCrownChargesFromPdfMutation, ValidateCrownChargesFromPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateCrownChargesFromPdfMutation, ValidateCrownChargesFromPdfMutationVariables>(ValidateCrownChargesFromPdfDocument, options);
      }
export type ValidateCrownChargesFromPdfMutationHookResult = ReturnType<typeof useValidateCrownChargesFromPdfMutation>;
export type ValidateCrownChargesFromPdfMutationResult = Apollo.MutationResult<ValidateCrownChargesFromPdfMutation>;
export type ValidateCrownChargesFromPdfMutationOptions = Apollo.BaseMutationOptions<ValidateCrownChargesFromPdfMutation, ValidateCrownChargesFromPdfMutationVariables>;
export const ApiKeyAdminConnectOrgsDocument = gql`
    mutation ApiKeyAdminConnectOrgs($input: ApiKeyAdminConnectOrgsInput!) {
  apiKeyAdminConnectOrgs(input: $input) {
    ...ApiKeyAdminDetailFields
  }
}
    ${ApiKeyAdminDetailFieldsFragmentDoc}`;
export type ApiKeyAdminConnectOrgsMutationFn = Apollo.MutationFunction<ApiKeyAdminConnectOrgsMutation, ApiKeyAdminConnectOrgsMutationVariables>;

/**
 * __useApiKeyAdminConnectOrgsMutation__
 *
 * To run a mutation, you first call `useApiKeyAdminConnectOrgsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminConnectOrgsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyAdminConnectOrgsMutation, { data, loading, error }] = useApiKeyAdminConnectOrgsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyAdminConnectOrgsMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeyAdminConnectOrgsMutation, ApiKeyAdminConnectOrgsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeyAdminConnectOrgsMutation, ApiKeyAdminConnectOrgsMutationVariables>(ApiKeyAdminConnectOrgsDocument, options);
      }
export type ApiKeyAdminConnectOrgsMutationHookResult = ReturnType<typeof useApiKeyAdminConnectOrgsMutation>;
export type ApiKeyAdminConnectOrgsMutationResult = Apollo.MutationResult<ApiKeyAdminConnectOrgsMutation>;
export type ApiKeyAdminConnectOrgsMutationOptions = Apollo.BaseMutationOptions<ApiKeyAdminConnectOrgsMutation, ApiKeyAdminConnectOrgsMutationVariables>;
export const ApiKeyAdminCreateDocument = gql`
    mutation ApiKeyAdminCreate($input: ApiKeyAdminCreateInput!) {
  apiKeyAdminCreate(input: $input) {
    ...ApiKeyAdminFields
  }
}
    ${ApiKeyAdminFieldsFragmentDoc}`;
export type ApiKeyAdminCreateMutationFn = Apollo.MutationFunction<ApiKeyAdminCreateMutation, ApiKeyAdminCreateMutationVariables>;

/**
 * __useApiKeyAdminCreateMutation__
 *
 * To run a mutation, you first call `useApiKeyAdminCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyAdminCreateMutation, { data, loading, error }] = useApiKeyAdminCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyAdminCreateMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeyAdminCreateMutation, ApiKeyAdminCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeyAdminCreateMutation, ApiKeyAdminCreateMutationVariables>(ApiKeyAdminCreateDocument, options);
      }
export type ApiKeyAdminCreateMutationHookResult = ReturnType<typeof useApiKeyAdminCreateMutation>;
export type ApiKeyAdminCreateMutationResult = Apollo.MutationResult<ApiKeyAdminCreateMutation>;
export type ApiKeyAdminCreateMutationOptions = Apollo.BaseMutationOptions<ApiKeyAdminCreateMutation, ApiKeyAdminCreateMutationVariables>;
export const ApiKeyAdminDeleteDocument = gql`
    mutation ApiKeyAdminDelete($uuid: String!) {
  apiKeyAdminDelete(uuid: $uuid)
}
    `;
export type ApiKeyAdminDeleteMutationFn = Apollo.MutationFunction<ApiKeyAdminDeleteMutation, ApiKeyAdminDeleteMutationVariables>;

/**
 * __useApiKeyAdminDeleteMutation__
 *
 * To run a mutation, you first call `useApiKeyAdminDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyAdminDeleteMutation, { data, loading, error }] = useApiKeyAdminDeleteMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useApiKeyAdminDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeyAdminDeleteMutation, ApiKeyAdminDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeyAdminDeleteMutation, ApiKeyAdminDeleteMutationVariables>(ApiKeyAdminDeleteDocument, options);
      }
export type ApiKeyAdminDeleteMutationHookResult = ReturnType<typeof useApiKeyAdminDeleteMutation>;
export type ApiKeyAdminDeleteMutationResult = Apollo.MutationResult<ApiKeyAdminDeleteMutation>;
export type ApiKeyAdminDeleteMutationOptions = Apollo.BaseMutationOptions<ApiKeyAdminDeleteMutation, ApiKeyAdminDeleteMutationVariables>;
export const ApiKeyAdminDisconnectOrgDocument = gql`
    mutation ApiKeyAdminDisconnectOrg($input: ApiKeyAdminDisconnectOrgInput!) {
  apiKeyAdminDisconnectOrg(input: $input) {
    ...ApiKeyAdminDetailFields
  }
}
    ${ApiKeyAdminDetailFieldsFragmentDoc}`;
export type ApiKeyAdminDisconnectOrgMutationFn = Apollo.MutationFunction<ApiKeyAdminDisconnectOrgMutation, ApiKeyAdminDisconnectOrgMutationVariables>;

/**
 * __useApiKeyAdminDisconnectOrgMutation__
 *
 * To run a mutation, you first call `useApiKeyAdminDisconnectOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminDisconnectOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyAdminDisconnectOrgMutation, { data, loading, error }] = useApiKeyAdminDisconnectOrgMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyAdminDisconnectOrgMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeyAdminDisconnectOrgMutation, ApiKeyAdminDisconnectOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeyAdminDisconnectOrgMutation, ApiKeyAdminDisconnectOrgMutationVariables>(ApiKeyAdminDisconnectOrgDocument, options);
      }
export type ApiKeyAdminDisconnectOrgMutationHookResult = ReturnType<typeof useApiKeyAdminDisconnectOrgMutation>;
export type ApiKeyAdminDisconnectOrgMutationResult = Apollo.MutationResult<ApiKeyAdminDisconnectOrgMutation>;
export type ApiKeyAdminDisconnectOrgMutationOptions = Apollo.BaseMutationOptions<ApiKeyAdminDisconnectOrgMutation, ApiKeyAdminDisconnectOrgMutationVariables>;
export const ApiKeyAdminEventTypeCatalogDocument = gql`
    query ApiKeyAdminEventTypeCatalog {
  apiKeyAdminEventTypeCatalog {
    shape
    isStandard
    eventTypes {
      eventType
      deprecated
      requiresTerminalHandoffOptIn
    }
  }
}
    `;

/**
 * __useApiKeyAdminEventTypeCatalogQuery__
 *
 * To run a query within a React component, call `useApiKeyAdminEventTypeCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminEventTypeCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyAdminEventTypeCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeyAdminEventTypeCatalogQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeyAdminEventTypeCatalogQuery, ApiKeyAdminEventTypeCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyAdminEventTypeCatalogQuery, ApiKeyAdminEventTypeCatalogQueryVariables>(ApiKeyAdminEventTypeCatalogDocument, options);
      }
export function useApiKeyAdminEventTypeCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyAdminEventTypeCatalogQuery, ApiKeyAdminEventTypeCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyAdminEventTypeCatalogQuery, ApiKeyAdminEventTypeCatalogQueryVariables>(ApiKeyAdminEventTypeCatalogDocument, options);
        }
export function useApiKeyAdminEventTypeCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeyAdminEventTypeCatalogQuery, ApiKeyAdminEventTypeCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyAdminEventTypeCatalogQuery, ApiKeyAdminEventTypeCatalogQueryVariables>(ApiKeyAdminEventTypeCatalogDocument, options);
        }
export type ApiKeyAdminEventTypeCatalogQueryHookResult = ReturnType<typeof useApiKeyAdminEventTypeCatalogQuery>;
export type ApiKeyAdminEventTypeCatalogLazyQueryHookResult = ReturnType<typeof useApiKeyAdminEventTypeCatalogLazyQuery>;
export type ApiKeyAdminEventTypeCatalogSuspenseQueryHookResult = ReturnType<typeof useApiKeyAdminEventTypeCatalogSuspenseQuery>;
export type ApiKeyAdminEventTypeCatalogQueryResult = Apollo.QueryResult<ApiKeyAdminEventTypeCatalogQuery, ApiKeyAdminEventTypeCatalogQueryVariables>;
export const ApiKeyAdminExamplePayloadDocument = gql`
    query ApiKeyAdminExamplePayload($shape: WebhookPayloadShape!, $sendCompanyLocalTimestamps: Boolean) {
  apiKeyAdminExamplePayload(
    shape: $shape
    sendCompanyLocalTimestamps: $sendCompanyLocalTimestamps
  )
}
    `;

/**
 * __useApiKeyAdminExamplePayloadQuery__
 *
 * To run a query within a React component, call `useApiKeyAdminExamplePayloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminExamplePayloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyAdminExamplePayloadQuery({
 *   variables: {
 *      shape: // value for 'shape'
 *      sendCompanyLocalTimestamps: // value for 'sendCompanyLocalTimestamps'
 *   },
 * });
 */
export function useApiKeyAdminExamplePayloadQuery(baseOptions: Apollo.QueryHookOptions<ApiKeyAdminExamplePayloadQuery, ApiKeyAdminExamplePayloadQueryVariables> & ({ variables: ApiKeyAdminExamplePayloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyAdminExamplePayloadQuery, ApiKeyAdminExamplePayloadQueryVariables>(ApiKeyAdminExamplePayloadDocument, options);
      }
export function useApiKeyAdminExamplePayloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyAdminExamplePayloadQuery, ApiKeyAdminExamplePayloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyAdminExamplePayloadQuery, ApiKeyAdminExamplePayloadQueryVariables>(ApiKeyAdminExamplePayloadDocument, options);
        }
export function useApiKeyAdminExamplePayloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeyAdminExamplePayloadQuery, ApiKeyAdminExamplePayloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyAdminExamplePayloadQuery, ApiKeyAdminExamplePayloadQueryVariables>(ApiKeyAdminExamplePayloadDocument, options);
        }
export type ApiKeyAdminExamplePayloadQueryHookResult = ReturnType<typeof useApiKeyAdminExamplePayloadQuery>;
export type ApiKeyAdminExamplePayloadLazyQueryHookResult = ReturnType<typeof useApiKeyAdminExamplePayloadLazyQuery>;
export type ApiKeyAdminExamplePayloadSuspenseQueryHookResult = ReturnType<typeof useApiKeyAdminExamplePayloadSuspenseQuery>;
export type ApiKeyAdminExamplePayloadQueryResult = Apollo.QueryResult<ApiKeyAdminExamplePayloadQuery, ApiKeyAdminExamplePayloadQueryVariables>;
export const ApiKeyAdminExportCsvDocument = gql`
    query ApiKeyAdminExportCsv($uuid: String!) {
  apiKeyAdminExportCsv(uuid: $uuid)
}
    `;

/**
 * __useApiKeyAdminExportCsvQuery__
 *
 * To run a query within a React component, call `useApiKeyAdminExportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminExportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyAdminExportCsvQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useApiKeyAdminExportCsvQuery(baseOptions: Apollo.QueryHookOptions<ApiKeyAdminExportCsvQuery, ApiKeyAdminExportCsvQueryVariables> & ({ variables: ApiKeyAdminExportCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyAdminExportCsvQuery, ApiKeyAdminExportCsvQueryVariables>(ApiKeyAdminExportCsvDocument, options);
      }
export function useApiKeyAdminExportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyAdminExportCsvQuery, ApiKeyAdminExportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyAdminExportCsvQuery, ApiKeyAdminExportCsvQueryVariables>(ApiKeyAdminExportCsvDocument, options);
        }
export function useApiKeyAdminExportCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeyAdminExportCsvQuery, ApiKeyAdminExportCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyAdminExportCsvQuery, ApiKeyAdminExportCsvQueryVariables>(ApiKeyAdminExportCsvDocument, options);
        }
export type ApiKeyAdminExportCsvQueryHookResult = ReturnType<typeof useApiKeyAdminExportCsvQuery>;
export type ApiKeyAdminExportCsvLazyQueryHookResult = ReturnType<typeof useApiKeyAdminExportCsvLazyQuery>;
export type ApiKeyAdminExportCsvSuspenseQueryHookResult = ReturnType<typeof useApiKeyAdminExportCsvSuspenseQuery>;
export type ApiKeyAdminExportCsvQueryResult = Apollo.QueryResult<ApiKeyAdminExportCsvQuery, ApiKeyAdminExportCsvQueryVariables>;
export const ApiKeyAdminGetDocument = gql`
    query ApiKeyAdminGet($uuid: String!) {
  apiKeyAdminGet(uuid: $uuid) {
    ...ApiKeyAdminDetailFields
  }
}
    ${ApiKeyAdminDetailFieldsFragmentDoc}`;

/**
 * __useApiKeyAdminGetQuery__
 *
 * To run a query within a React component, call `useApiKeyAdminGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyAdminGetQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useApiKeyAdminGetQuery(baseOptions: Apollo.QueryHookOptions<ApiKeyAdminGetQuery, ApiKeyAdminGetQueryVariables> & ({ variables: ApiKeyAdminGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyAdminGetQuery, ApiKeyAdminGetQueryVariables>(ApiKeyAdminGetDocument, options);
      }
export function useApiKeyAdminGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyAdminGetQuery, ApiKeyAdminGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyAdminGetQuery, ApiKeyAdminGetQueryVariables>(ApiKeyAdminGetDocument, options);
        }
export function useApiKeyAdminGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeyAdminGetQuery, ApiKeyAdminGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyAdminGetQuery, ApiKeyAdminGetQueryVariables>(ApiKeyAdminGetDocument, options);
        }
export type ApiKeyAdminGetQueryHookResult = ReturnType<typeof useApiKeyAdminGetQuery>;
export type ApiKeyAdminGetLazyQueryHookResult = ReturnType<typeof useApiKeyAdminGetLazyQuery>;
export type ApiKeyAdminGetSuspenseQueryHookResult = ReturnType<typeof useApiKeyAdminGetSuspenseQuery>;
export type ApiKeyAdminGetQueryResult = Apollo.QueryResult<ApiKeyAdminGetQuery, ApiKeyAdminGetQueryVariables>;
export const ApiKeyAdminImportCsvDocument = gql`
    mutation ApiKeyAdminImportCsv($input: ApiKeyAdminImportCsvInput!) {
  apiKeyAdminImportCsv(input: $input) {
    ...ApiKeyAdminCsvImportReportFields
  }
}
    ${ApiKeyAdminCsvImportReportFieldsFragmentDoc}`;
export type ApiKeyAdminImportCsvMutationFn = Apollo.MutationFunction<ApiKeyAdminImportCsvMutation, ApiKeyAdminImportCsvMutationVariables>;

/**
 * __useApiKeyAdminImportCsvMutation__
 *
 * To run a mutation, you first call `useApiKeyAdminImportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminImportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyAdminImportCsvMutation, { data, loading, error }] = useApiKeyAdminImportCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyAdminImportCsvMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeyAdminImportCsvMutation, ApiKeyAdminImportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeyAdminImportCsvMutation, ApiKeyAdminImportCsvMutationVariables>(ApiKeyAdminImportCsvDocument, options);
      }
export type ApiKeyAdminImportCsvMutationHookResult = ReturnType<typeof useApiKeyAdminImportCsvMutation>;
export type ApiKeyAdminImportCsvMutationResult = Apollo.MutationResult<ApiKeyAdminImportCsvMutation>;
export type ApiKeyAdminImportCsvMutationOptions = Apollo.BaseMutationOptions<ApiKeyAdminImportCsvMutation, ApiKeyAdminImportCsvMutationVariables>;
export const ApiKeyAdminListDocument = gql`
    query ApiKeyAdminList($input: ApiKeyAdminListInput!) {
  apiKeyAdminList(input: $input) {
    apiKeys {
      ...ApiKeyAdminListItemFields
    }
    totalCount
  }
}
    ${ApiKeyAdminListItemFieldsFragmentDoc}`;

/**
 * __useApiKeyAdminListQuery__
 *
 * To run a query within a React component, call `useApiKeyAdminListQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyAdminListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyAdminListQuery(baseOptions: Apollo.QueryHookOptions<ApiKeyAdminListQuery, ApiKeyAdminListQueryVariables> & ({ variables: ApiKeyAdminListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyAdminListQuery, ApiKeyAdminListQueryVariables>(ApiKeyAdminListDocument, options);
      }
export function useApiKeyAdminListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyAdminListQuery, ApiKeyAdminListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyAdminListQuery, ApiKeyAdminListQueryVariables>(ApiKeyAdminListDocument, options);
        }
export function useApiKeyAdminListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeyAdminListQuery, ApiKeyAdminListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyAdminListQuery, ApiKeyAdminListQueryVariables>(ApiKeyAdminListDocument, options);
        }
export type ApiKeyAdminListQueryHookResult = ReturnType<typeof useApiKeyAdminListQuery>;
export type ApiKeyAdminListLazyQueryHookResult = ReturnType<typeof useApiKeyAdminListLazyQuery>;
export type ApiKeyAdminListSuspenseQueryHookResult = ReturnType<typeof useApiKeyAdminListSuspenseQuery>;
export type ApiKeyAdminListQueryResult = Apollo.QueryResult<ApiKeyAdminListQuery, ApiKeyAdminListQueryVariables>;
export const ApiKeyAdminPreviewMappingDocument = gql`
    query ApiKeyAdminPreviewMapping($input: ApiKeyAdminPreviewMappingInput!) {
  apiKeyAdminPreviewMapping(input: $input)
}
    `;

/**
 * __useApiKeyAdminPreviewMappingQuery__
 *
 * To run a query within a React component, call `useApiKeyAdminPreviewMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminPreviewMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyAdminPreviewMappingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyAdminPreviewMappingQuery(baseOptions: Apollo.QueryHookOptions<ApiKeyAdminPreviewMappingQuery, ApiKeyAdminPreviewMappingQueryVariables> & ({ variables: ApiKeyAdminPreviewMappingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyAdminPreviewMappingQuery, ApiKeyAdminPreviewMappingQueryVariables>(ApiKeyAdminPreviewMappingDocument, options);
      }
export function useApiKeyAdminPreviewMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyAdminPreviewMappingQuery, ApiKeyAdminPreviewMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyAdminPreviewMappingQuery, ApiKeyAdminPreviewMappingQueryVariables>(ApiKeyAdminPreviewMappingDocument, options);
        }
export function useApiKeyAdminPreviewMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeyAdminPreviewMappingQuery, ApiKeyAdminPreviewMappingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyAdminPreviewMappingQuery, ApiKeyAdminPreviewMappingQueryVariables>(ApiKeyAdminPreviewMappingDocument, options);
        }
export type ApiKeyAdminPreviewMappingQueryHookResult = ReturnType<typeof useApiKeyAdminPreviewMappingQuery>;
export type ApiKeyAdminPreviewMappingLazyQueryHookResult = ReturnType<typeof useApiKeyAdminPreviewMappingLazyQuery>;
export type ApiKeyAdminPreviewMappingSuspenseQueryHookResult = ReturnType<typeof useApiKeyAdminPreviewMappingSuspenseQuery>;
export type ApiKeyAdminPreviewMappingQueryResult = Apollo.QueryResult<ApiKeyAdminPreviewMappingQuery, ApiKeyAdminPreviewMappingQueryVariables>;
export const ApiKeyAdminSearchOrganizationsDocument = gql`
    query ApiKeyAdminSearchOrganizations($input: ApiKeyAdminOrgSearchInput!) {
  apiKeyAdminSearchOrganizations(input: $input) {
    organizationUuid
    organizationDisplayName
    companyUuid
    companyName
  }
}
    `;

/**
 * __useApiKeyAdminSearchOrganizationsQuery__
 *
 * To run a query within a React component, call `useApiKeyAdminSearchOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminSearchOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyAdminSearchOrganizationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyAdminSearchOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<ApiKeyAdminSearchOrganizationsQuery, ApiKeyAdminSearchOrganizationsQueryVariables> & ({ variables: ApiKeyAdminSearchOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyAdminSearchOrganizationsQuery, ApiKeyAdminSearchOrganizationsQueryVariables>(ApiKeyAdminSearchOrganizationsDocument, options);
      }
export function useApiKeyAdminSearchOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyAdminSearchOrganizationsQuery, ApiKeyAdminSearchOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyAdminSearchOrganizationsQuery, ApiKeyAdminSearchOrganizationsQueryVariables>(ApiKeyAdminSearchOrganizationsDocument, options);
        }
export function useApiKeyAdminSearchOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeyAdminSearchOrganizationsQuery, ApiKeyAdminSearchOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyAdminSearchOrganizationsQuery, ApiKeyAdminSearchOrganizationsQueryVariables>(ApiKeyAdminSearchOrganizationsDocument, options);
        }
export type ApiKeyAdminSearchOrganizationsQueryHookResult = ReturnType<typeof useApiKeyAdminSearchOrganizationsQuery>;
export type ApiKeyAdminSearchOrganizationsLazyQueryHookResult = ReturnType<typeof useApiKeyAdminSearchOrganizationsLazyQuery>;
export type ApiKeyAdminSearchOrganizationsSuspenseQueryHookResult = ReturnType<typeof useApiKeyAdminSearchOrganizationsSuspenseQuery>;
export type ApiKeyAdminSearchOrganizationsQueryResult = Apollo.QueryResult<ApiKeyAdminSearchOrganizationsQuery, ApiKeyAdminSearchOrganizationsQueryVariables>;
export const ApiKeyAdminSetMappingTemplateDocument = gql`
    mutation ApiKeyAdminSetMappingTemplate($input: ApiKeyAdminSetMappingTemplateInput!) {
  apiKeyAdminSetMappingTemplate(input: $input) {
    webhookShape
    urlPath
    mappingTemplate
  }
}
    `;
export type ApiKeyAdminSetMappingTemplateMutationFn = Apollo.MutationFunction<ApiKeyAdminSetMappingTemplateMutation, ApiKeyAdminSetMappingTemplateMutationVariables>;

/**
 * __useApiKeyAdminSetMappingTemplateMutation__
 *
 * To run a mutation, you first call `useApiKeyAdminSetMappingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminSetMappingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyAdminSetMappingTemplateMutation, { data, loading, error }] = useApiKeyAdminSetMappingTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyAdminSetMappingTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeyAdminSetMappingTemplateMutation, ApiKeyAdminSetMappingTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeyAdminSetMappingTemplateMutation, ApiKeyAdminSetMappingTemplateMutationVariables>(ApiKeyAdminSetMappingTemplateDocument, options);
      }
export type ApiKeyAdminSetMappingTemplateMutationHookResult = ReturnType<typeof useApiKeyAdminSetMappingTemplateMutation>;
export type ApiKeyAdminSetMappingTemplateMutationResult = Apollo.MutationResult<ApiKeyAdminSetMappingTemplateMutation>;
export type ApiKeyAdminSetMappingTemplateMutationOptions = Apollo.BaseMutationOptions<ApiKeyAdminSetMappingTemplateMutation, ApiKeyAdminSetMappingTemplateMutationVariables>;
export const ApiKeyAdminSetStatusMappingsDocument = gql`
    mutation ApiKeyAdminSetStatusMappings($input: ApiKeyAdminSetStatusMappingsInput!) {
  apiKeyAdminSetStatusMappings(input: $input) {
    ...ApiKeyAdminStatusMappingFields
  }
}
    ${ApiKeyAdminStatusMappingFieldsFragmentDoc}`;
export type ApiKeyAdminSetStatusMappingsMutationFn = Apollo.MutationFunction<ApiKeyAdminSetStatusMappingsMutation, ApiKeyAdminSetStatusMappingsMutationVariables>;

/**
 * __useApiKeyAdminSetStatusMappingsMutation__
 *
 * To run a mutation, you first call `useApiKeyAdminSetStatusMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminSetStatusMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyAdminSetStatusMappingsMutation, { data, loading, error }] = useApiKeyAdminSetStatusMappingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyAdminSetStatusMappingsMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeyAdminSetStatusMappingsMutation, ApiKeyAdminSetStatusMappingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeyAdminSetStatusMappingsMutation, ApiKeyAdminSetStatusMappingsMutationVariables>(ApiKeyAdminSetStatusMappingsDocument, options);
      }
export type ApiKeyAdminSetStatusMappingsMutationHookResult = ReturnType<typeof useApiKeyAdminSetStatusMappingsMutation>;
export type ApiKeyAdminSetStatusMappingsMutationResult = Apollo.MutationResult<ApiKeyAdminSetStatusMappingsMutation>;
export type ApiKeyAdminSetStatusMappingsMutationOptions = Apollo.BaseMutationOptions<ApiKeyAdminSetStatusMappingsMutation, ApiKeyAdminSetStatusMappingsMutationVariables>;
export const ApiKeyAdminStatusMappingsDocument = gql`
    query ApiKeyAdminStatusMappings($apiKeyUuid: String!) {
  apiKeyAdminStatusMappings(apiKeyUuid: $apiKeyUuid) {
    ...ApiKeyAdminStatusMappingFields
  }
}
    ${ApiKeyAdminStatusMappingFieldsFragmentDoc}`;

/**
 * __useApiKeyAdminStatusMappingsQuery__
 *
 * To run a query within a React component, call `useApiKeyAdminStatusMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminStatusMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyAdminStatusMappingsQuery({
 *   variables: {
 *      apiKeyUuid: // value for 'apiKeyUuid'
 *   },
 * });
 */
export function useApiKeyAdminStatusMappingsQuery(baseOptions: Apollo.QueryHookOptions<ApiKeyAdminStatusMappingsQuery, ApiKeyAdminStatusMappingsQueryVariables> & ({ variables: ApiKeyAdminStatusMappingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyAdminStatusMappingsQuery, ApiKeyAdminStatusMappingsQueryVariables>(ApiKeyAdminStatusMappingsDocument, options);
      }
export function useApiKeyAdminStatusMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyAdminStatusMappingsQuery, ApiKeyAdminStatusMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyAdminStatusMappingsQuery, ApiKeyAdminStatusMappingsQueryVariables>(ApiKeyAdminStatusMappingsDocument, options);
        }
export function useApiKeyAdminStatusMappingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeyAdminStatusMappingsQuery, ApiKeyAdminStatusMappingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyAdminStatusMappingsQuery, ApiKeyAdminStatusMappingsQueryVariables>(ApiKeyAdminStatusMappingsDocument, options);
        }
export type ApiKeyAdminStatusMappingsQueryHookResult = ReturnType<typeof useApiKeyAdminStatusMappingsQuery>;
export type ApiKeyAdminStatusMappingsLazyQueryHookResult = ReturnType<typeof useApiKeyAdminStatusMappingsLazyQuery>;
export type ApiKeyAdminStatusMappingsSuspenseQueryHookResult = ReturnType<typeof useApiKeyAdminStatusMappingsSuspenseQuery>;
export type ApiKeyAdminStatusMappingsQueryResult = Apollo.QueryResult<ApiKeyAdminStatusMappingsQuery, ApiKeyAdminStatusMappingsQueryVariables>;
export const ApiKeyAdminUpdateDocument = gql`
    mutation ApiKeyAdminUpdate($input: ApiKeyAdminUpdateInput!) {
  apiKeyAdminUpdate(input: $input) {
    ...ApiKeyAdminFields
  }
}
    ${ApiKeyAdminFieldsFragmentDoc}`;
export type ApiKeyAdminUpdateMutationFn = Apollo.MutationFunction<ApiKeyAdminUpdateMutation, ApiKeyAdminUpdateMutationVariables>;

/**
 * __useApiKeyAdminUpdateMutation__
 *
 * To run a mutation, you first call `useApiKeyAdminUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyAdminUpdateMutation, { data, loading, error }] = useApiKeyAdminUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyAdminUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeyAdminUpdateMutation, ApiKeyAdminUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeyAdminUpdateMutation, ApiKeyAdminUpdateMutationVariables>(ApiKeyAdminUpdateDocument, options);
      }
export type ApiKeyAdminUpdateMutationHookResult = ReturnType<typeof useApiKeyAdminUpdateMutation>;
export type ApiKeyAdminUpdateMutationResult = Apollo.MutationResult<ApiKeyAdminUpdateMutation>;
export type ApiKeyAdminUpdateMutationOptions = Apollo.BaseMutationOptions<ApiKeyAdminUpdateMutation, ApiKeyAdminUpdateMutationVariables>;
export const ApiKeyAdminWebhookShapeConfigDocument = gql`
    query ApiKeyAdminWebhookShapeConfig($apiKeyUuid: String!, $shape: WebhookPayloadShape!) {
  apiKeyAdminWebhookShapeConfig(apiKeyUuid: $apiKeyUuid, shape: $shape) {
    webhookShape
    urlPath
    mappingTemplate
  }
}
    `;

/**
 * __useApiKeyAdminWebhookShapeConfigQuery__
 *
 * To run a query within a React component, call `useApiKeyAdminWebhookShapeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyAdminWebhookShapeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyAdminWebhookShapeConfigQuery({
 *   variables: {
 *      apiKeyUuid: // value for 'apiKeyUuid'
 *      shape: // value for 'shape'
 *   },
 * });
 */
export function useApiKeyAdminWebhookShapeConfigQuery(baseOptions: Apollo.QueryHookOptions<ApiKeyAdminWebhookShapeConfigQuery, ApiKeyAdminWebhookShapeConfigQueryVariables> & ({ variables: ApiKeyAdminWebhookShapeConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyAdminWebhookShapeConfigQuery, ApiKeyAdminWebhookShapeConfigQueryVariables>(ApiKeyAdminWebhookShapeConfigDocument, options);
      }
export function useApiKeyAdminWebhookShapeConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyAdminWebhookShapeConfigQuery, ApiKeyAdminWebhookShapeConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyAdminWebhookShapeConfigQuery, ApiKeyAdminWebhookShapeConfigQueryVariables>(ApiKeyAdminWebhookShapeConfigDocument, options);
        }
export function useApiKeyAdminWebhookShapeConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeyAdminWebhookShapeConfigQuery, ApiKeyAdminWebhookShapeConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyAdminWebhookShapeConfigQuery, ApiKeyAdminWebhookShapeConfigQueryVariables>(ApiKeyAdminWebhookShapeConfigDocument, options);
        }
export type ApiKeyAdminWebhookShapeConfigQueryHookResult = ReturnType<typeof useApiKeyAdminWebhookShapeConfigQuery>;
export type ApiKeyAdminWebhookShapeConfigLazyQueryHookResult = ReturnType<typeof useApiKeyAdminWebhookShapeConfigLazyQuery>;
export type ApiKeyAdminWebhookShapeConfigSuspenseQueryHookResult = ReturnType<typeof useApiKeyAdminWebhookShapeConfigSuspenseQuery>;
export type ApiKeyAdminWebhookShapeConfigQueryResult = Apollo.QueryResult<ApiKeyAdminWebhookShapeConfigQuery, ApiKeyAdminWebhookShapeConfigQueryVariables>;
export const DocumentationAdminCreateItemDocument = gql`
    mutation DocumentationAdminCreateItem($input: DocumentationItemCreateInput!) {
  documentationAdminCreateItem(input: $input) {
    ...DocumentationAdminItemFields
  }
}
    ${DocumentationAdminItemFieldsFragmentDoc}`;
export type DocumentationAdminCreateItemMutationFn = Apollo.MutationFunction<DocumentationAdminCreateItemMutation, DocumentationAdminCreateItemMutationVariables>;

/**
 * __useDocumentationAdminCreateItemMutation__
 *
 * To run a mutation, you first call `useDocumentationAdminCreateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationAdminCreateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationAdminCreateItemMutation, { data, loading, error }] = useDocumentationAdminCreateItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDocumentationAdminCreateItemMutation(baseOptions?: Apollo.MutationHookOptions<DocumentationAdminCreateItemMutation, DocumentationAdminCreateItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentationAdminCreateItemMutation, DocumentationAdminCreateItemMutationVariables>(DocumentationAdminCreateItemDocument, options);
      }
export type DocumentationAdminCreateItemMutationHookResult = ReturnType<typeof useDocumentationAdminCreateItemMutation>;
export type DocumentationAdminCreateItemMutationResult = Apollo.MutationResult<DocumentationAdminCreateItemMutation>;
export type DocumentationAdminCreateItemMutationOptions = Apollo.BaseMutationOptions<DocumentationAdminCreateItemMutation, DocumentationAdminCreateItemMutationVariables>;
export const DocumentationAdminCreateTopicDocument = gql`
    mutation DocumentationAdminCreateTopic($input: DocumentationTopicCreateInput!) {
  documentationAdminCreateTopic(input: $input) {
    ...DocumentationAdminTopicFields
  }
}
    ${DocumentationAdminTopicFieldsFragmentDoc}`;
export type DocumentationAdminCreateTopicMutationFn = Apollo.MutationFunction<DocumentationAdminCreateTopicMutation, DocumentationAdminCreateTopicMutationVariables>;

/**
 * __useDocumentationAdminCreateTopicMutation__
 *
 * To run a mutation, you first call `useDocumentationAdminCreateTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationAdminCreateTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationAdminCreateTopicMutation, { data, loading, error }] = useDocumentationAdminCreateTopicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDocumentationAdminCreateTopicMutation(baseOptions?: Apollo.MutationHookOptions<DocumentationAdminCreateTopicMutation, DocumentationAdminCreateTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentationAdminCreateTopicMutation, DocumentationAdminCreateTopicMutationVariables>(DocumentationAdminCreateTopicDocument, options);
      }
export type DocumentationAdminCreateTopicMutationHookResult = ReturnType<typeof useDocumentationAdminCreateTopicMutation>;
export type DocumentationAdminCreateTopicMutationResult = Apollo.MutationResult<DocumentationAdminCreateTopicMutation>;
export type DocumentationAdminCreateTopicMutationOptions = Apollo.BaseMutationOptions<DocumentationAdminCreateTopicMutation, DocumentationAdminCreateTopicMutationVariables>;
export const DocumentationAdminDeleteItemDocument = gql`
    mutation DocumentationAdminDeleteItem($uuid: String!) {
  documentationAdminDeleteItem(uuid: $uuid)
}
    `;
export type DocumentationAdminDeleteItemMutationFn = Apollo.MutationFunction<DocumentationAdminDeleteItemMutation, DocumentationAdminDeleteItemMutationVariables>;

/**
 * __useDocumentationAdminDeleteItemMutation__
 *
 * To run a mutation, you first call `useDocumentationAdminDeleteItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationAdminDeleteItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationAdminDeleteItemMutation, { data, loading, error }] = useDocumentationAdminDeleteItemMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDocumentationAdminDeleteItemMutation(baseOptions?: Apollo.MutationHookOptions<DocumentationAdminDeleteItemMutation, DocumentationAdminDeleteItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentationAdminDeleteItemMutation, DocumentationAdminDeleteItemMutationVariables>(DocumentationAdminDeleteItemDocument, options);
      }
export type DocumentationAdminDeleteItemMutationHookResult = ReturnType<typeof useDocumentationAdminDeleteItemMutation>;
export type DocumentationAdminDeleteItemMutationResult = Apollo.MutationResult<DocumentationAdminDeleteItemMutation>;
export type DocumentationAdminDeleteItemMutationOptions = Apollo.BaseMutationOptions<DocumentationAdminDeleteItemMutation, DocumentationAdminDeleteItemMutationVariables>;
export const DocumentationAdminDeleteTopicDocument = gql`
    mutation DocumentationAdminDeleteTopic($uuid: String!) {
  documentationAdminDeleteTopic(uuid: $uuid)
}
    `;
export type DocumentationAdminDeleteTopicMutationFn = Apollo.MutationFunction<DocumentationAdminDeleteTopicMutation, DocumentationAdminDeleteTopicMutationVariables>;

/**
 * __useDocumentationAdminDeleteTopicMutation__
 *
 * To run a mutation, you first call `useDocumentationAdminDeleteTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationAdminDeleteTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationAdminDeleteTopicMutation, { data, loading, error }] = useDocumentationAdminDeleteTopicMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDocumentationAdminDeleteTopicMutation(baseOptions?: Apollo.MutationHookOptions<DocumentationAdminDeleteTopicMutation, DocumentationAdminDeleteTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentationAdminDeleteTopicMutation, DocumentationAdminDeleteTopicMutationVariables>(DocumentationAdminDeleteTopicDocument, options);
      }
export type DocumentationAdminDeleteTopicMutationHookResult = ReturnType<typeof useDocumentationAdminDeleteTopicMutation>;
export type DocumentationAdminDeleteTopicMutationResult = Apollo.MutationResult<DocumentationAdminDeleteTopicMutation>;
export type DocumentationAdminDeleteTopicMutationOptions = Apollo.BaseMutationOptions<DocumentationAdminDeleteTopicMutation, DocumentationAdminDeleteTopicMutationVariables>;
export const DocumentationAdminItemDocument = gql`
    query DocumentationAdminItem($uuid: String!) {
  documentationAdminItem(uuid: $uuid) {
    ...DocumentationAdminItemFields
    html
  }
}
    ${DocumentationAdminItemFieldsFragmentDoc}`;

/**
 * __useDocumentationAdminItemQuery__
 *
 * To run a query within a React component, call `useDocumentationAdminItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentationAdminItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentationAdminItemQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDocumentationAdminItemQuery(baseOptions: Apollo.QueryHookOptions<DocumentationAdminItemQuery, DocumentationAdminItemQueryVariables> & ({ variables: DocumentationAdminItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentationAdminItemQuery, DocumentationAdminItemQueryVariables>(DocumentationAdminItemDocument, options);
      }
export function useDocumentationAdminItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentationAdminItemQuery, DocumentationAdminItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentationAdminItemQuery, DocumentationAdminItemQueryVariables>(DocumentationAdminItemDocument, options);
        }
export function useDocumentationAdminItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentationAdminItemQuery, DocumentationAdminItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentationAdminItemQuery, DocumentationAdminItemQueryVariables>(DocumentationAdminItemDocument, options);
        }
export type DocumentationAdminItemQueryHookResult = ReturnType<typeof useDocumentationAdminItemQuery>;
export type DocumentationAdminItemLazyQueryHookResult = ReturnType<typeof useDocumentationAdminItemLazyQuery>;
export type DocumentationAdminItemSuspenseQueryHookResult = ReturnType<typeof useDocumentationAdminItemSuspenseQuery>;
export type DocumentationAdminItemQueryResult = Apollo.QueryResult<DocumentationAdminItemQuery, DocumentationAdminItemQueryVariables>;
export const DocumentationAdminReorderDocument = gql`
    mutation DocumentationAdminReorder($input: DocumentationReorderInput!) {
  documentationAdminReorder(input: $input)
}
    `;
export type DocumentationAdminReorderMutationFn = Apollo.MutationFunction<DocumentationAdminReorderMutation, DocumentationAdminReorderMutationVariables>;

/**
 * __useDocumentationAdminReorderMutation__
 *
 * To run a mutation, you first call `useDocumentationAdminReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationAdminReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationAdminReorderMutation, { data, loading, error }] = useDocumentationAdminReorderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDocumentationAdminReorderMutation(baseOptions?: Apollo.MutationHookOptions<DocumentationAdminReorderMutation, DocumentationAdminReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentationAdminReorderMutation, DocumentationAdminReorderMutationVariables>(DocumentationAdminReorderDocument, options);
      }
export type DocumentationAdminReorderMutationHookResult = ReturnType<typeof useDocumentationAdminReorderMutation>;
export type DocumentationAdminReorderMutationResult = Apollo.MutationResult<DocumentationAdminReorderMutation>;
export type DocumentationAdminReorderMutationOptions = Apollo.BaseMutationOptions<DocumentationAdminReorderMutation, DocumentationAdminReorderMutationVariables>;
export const DocumentationAdminTopicsDocument = gql`
    query DocumentationAdminTopics {
  documentationAdminTopics {
    ...DocumentationAdminTopicFields
  }
}
    ${DocumentationAdminTopicFieldsFragmentDoc}`;

/**
 * __useDocumentationAdminTopicsQuery__
 *
 * To run a query within a React component, call `useDocumentationAdminTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentationAdminTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentationAdminTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentationAdminTopicsQuery(baseOptions?: Apollo.QueryHookOptions<DocumentationAdminTopicsQuery, DocumentationAdminTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentationAdminTopicsQuery, DocumentationAdminTopicsQueryVariables>(DocumentationAdminTopicsDocument, options);
      }
export function useDocumentationAdminTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentationAdminTopicsQuery, DocumentationAdminTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentationAdminTopicsQuery, DocumentationAdminTopicsQueryVariables>(DocumentationAdminTopicsDocument, options);
        }
export function useDocumentationAdminTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentationAdminTopicsQuery, DocumentationAdminTopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentationAdminTopicsQuery, DocumentationAdminTopicsQueryVariables>(DocumentationAdminTopicsDocument, options);
        }
export type DocumentationAdminTopicsQueryHookResult = ReturnType<typeof useDocumentationAdminTopicsQuery>;
export type DocumentationAdminTopicsLazyQueryHookResult = ReturnType<typeof useDocumentationAdminTopicsLazyQuery>;
export type DocumentationAdminTopicsSuspenseQueryHookResult = ReturnType<typeof useDocumentationAdminTopicsSuspenseQuery>;
export type DocumentationAdminTopicsQueryResult = Apollo.QueryResult<DocumentationAdminTopicsQuery, DocumentationAdminTopicsQueryVariables>;
export const DocumentationAdminUpdateItemDocument = gql`
    mutation DocumentationAdminUpdateItem($input: DocumentationItemUpdateInput!) {
  documentationAdminUpdateItem(input: $input) {
    ...DocumentationAdminItemFields
  }
}
    ${DocumentationAdminItemFieldsFragmentDoc}`;
export type DocumentationAdminUpdateItemMutationFn = Apollo.MutationFunction<DocumentationAdminUpdateItemMutation, DocumentationAdminUpdateItemMutationVariables>;

/**
 * __useDocumentationAdminUpdateItemMutation__
 *
 * To run a mutation, you first call `useDocumentationAdminUpdateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationAdminUpdateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationAdminUpdateItemMutation, { data, loading, error }] = useDocumentationAdminUpdateItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDocumentationAdminUpdateItemMutation(baseOptions?: Apollo.MutationHookOptions<DocumentationAdminUpdateItemMutation, DocumentationAdminUpdateItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentationAdminUpdateItemMutation, DocumentationAdminUpdateItemMutationVariables>(DocumentationAdminUpdateItemDocument, options);
      }
export type DocumentationAdminUpdateItemMutationHookResult = ReturnType<typeof useDocumentationAdminUpdateItemMutation>;
export type DocumentationAdminUpdateItemMutationResult = Apollo.MutationResult<DocumentationAdminUpdateItemMutation>;
export type DocumentationAdminUpdateItemMutationOptions = Apollo.BaseMutationOptions<DocumentationAdminUpdateItemMutation, DocumentationAdminUpdateItemMutationVariables>;
export const DocumentationAdminUpdateTopicDocument = gql`
    mutation DocumentationAdminUpdateTopic($input: DocumentationTopicUpdateInput!) {
  documentationAdminUpdateTopic(input: $input) {
    ...DocumentationAdminTopicFields
  }
}
    ${DocumentationAdminTopicFieldsFragmentDoc}`;
export type DocumentationAdminUpdateTopicMutationFn = Apollo.MutationFunction<DocumentationAdminUpdateTopicMutation, DocumentationAdminUpdateTopicMutationVariables>;

/**
 * __useDocumentationAdminUpdateTopicMutation__
 *
 * To run a mutation, you first call `useDocumentationAdminUpdateTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationAdminUpdateTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationAdminUpdateTopicMutation, { data, loading, error }] = useDocumentationAdminUpdateTopicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDocumentationAdminUpdateTopicMutation(baseOptions?: Apollo.MutationHookOptions<DocumentationAdminUpdateTopicMutation, DocumentationAdminUpdateTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentationAdminUpdateTopicMutation, DocumentationAdminUpdateTopicMutationVariables>(DocumentationAdminUpdateTopicDocument, options);
      }
export type DocumentationAdminUpdateTopicMutationHookResult = ReturnType<typeof useDocumentationAdminUpdateTopicMutation>;
export type DocumentationAdminUpdateTopicMutationResult = Apollo.MutationResult<DocumentationAdminUpdateTopicMutation>;
export type DocumentationAdminUpdateTopicMutationOptions = Apollo.BaseMutationOptions<DocumentationAdminUpdateTopicMutation, DocumentationAdminUpdateTopicMutationVariables>;
export const OrganizationMessagesDocument = gql`
    query OrganizationMessages($first: Int, $after: String, $view: OrganizationMessageView) {
  organizationMessages(first: $first, after: $after, view: $view) {
    edges {
      node {
        ...OrganizationMessageFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${OrganizationMessageFieldsFragmentDoc}`;

/**
 * __useOrganizationMessagesQuery__
 *
 * To run a query within a React component, call `useOrganizationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMessagesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      view: // value for 'view'
 *   },
 * });
 */
export function useOrganizationMessagesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>(OrganizationMessagesDocument, options);
      }
export function useOrganizationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>(OrganizationMessagesDocument, options);
        }
export function useOrganizationMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>(OrganizationMessagesDocument, options);
        }
export type OrganizationMessagesQueryHookResult = ReturnType<typeof useOrganizationMessagesQuery>;
export type OrganizationMessagesLazyQueryHookResult = ReturnType<typeof useOrganizationMessagesLazyQuery>;
export type OrganizationMessagesSuspenseQueryHookResult = ReturnType<typeof useOrganizationMessagesSuspenseQuery>;
export type OrganizationMessagesQueryResult = Apollo.QueryResult<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>;
export const OrganizationMessageDetailDocument = gql`
    query OrganizationMessageDetail($uuid: String!) {
  organizationMessage(uuid: $uuid) {
    ...OrganizationMessageFields
  }
  organizationMessageHistory(uuid: $uuid) {
    action
    actorUserUuid
    actorName
    createdAt
  }
}
    ${OrganizationMessageFieldsFragmentDoc}`;

/**
 * __useOrganizationMessageDetailQuery__
 *
 * To run a query within a React component, call `useOrganizationMessageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMessageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMessageDetailQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useOrganizationMessageDetailQuery(baseOptions: Apollo.QueryHookOptions<OrganizationMessageDetailQuery, OrganizationMessageDetailQueryVariables> & ({ variables: OrganizationMessageDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMessageDetailQuery, OrganizationMessageDetailQueryVariables>(OrganizationMessageDetailDocument, options);
      }
export function useOrganizationMessageDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMessageDetailQuery, OrganizationMessageDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMessageDetailQuery, OrganizationMessageDetailQueryVariables>(OrganizationMessageDetailDocument, options);
        }
export function useOrganizationMessageDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationMessageDetailQuery, OrganizationMessageDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationMessageDetailQuery, OrganizationMessageDetailQueryVariables>(OrganizationMessageDetailDocument, options);
        }
export type OrganizationMessageDetailQueryHookResult = ReturnType<typeof useOrganizationMessageDetailQuery>;
export type OrganizationMessageDetailLazyQueryHookResult = ReturnType<typeof useOrganizationMessageDetailLazyQuery>;
export type OrganizationMessageDetailSuspenseQueryHookResult = ReturnType<typeof useOrganizationMessageDetailSuspenseQuery>;
export type OrganizationMessageDetailQueryResult = Apollo.QueryResult<OrganizationMessageDetailQuery, OrganizationMessageDetailQueryVariables>;
export const OrganizationMessageStatsDocument = gql`
    query OrganizationMessageStats($uuid: String!) {
  organizationMessageStats(uuid: $uuid) {
    asOf
    companyCount
    pendingCompanyCount
    failedCompanyCount
    deliveredCount
    readCount
    dismissedCount
  }
}
    `;

/**
 * __useOrganizationMessageStatsQuery__
 *
 * To run a query within a React component, call `useOrganizationMessageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMessageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMessageStatsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useOrganizationMessageStatsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationMessageStatsQuery, OrganizationMessageStatsQueryVariables> & ({ variables: OrganizationMessageStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMessageStatsQuery, OrganizationMessageStatsQueryVariables>(OrganizationMessageStatsDocument, options);
      }
export function useOrganizationMessageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMessageStatsQuery, OrganizationMessageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMessageStatsQuery, OrganizationMessageStatsQueryVariables>(OrganizationMessageStatsDocument, options);
        }
export function useOrganizationMessageStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationMessageStatsQuery, OrganizationMessageStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationMessageStatsQuery, OrganizationMessageStatsQueryVariables>(OrganizationMessageStatsDocument, options);
        }
export type OrganizationMessageStatsQueryHookResult = ReturnType<typeof useOrganizationMessageStatsQuery>;
export type OrganizationMessageStatsLazyQueryHookResult = ReturnType<typeof useOrganizationMessageStatsLazyQuery>;
export type OrganizationMessageStatsSuspenseQueryHookResult = ReturnType<typeof useOrganizationMessageStatsSuspenseQuery>;
export type OrganizationMessageStatsQueryResult = Apollo.QueryResult<OrganizationMessageStatsQuery, OrganizationMessageStatsQueryVariables>;
export const OrganizationMessageReachDocument = gql`
    query OrganizationMessageReach($audience: OrganizationMessageAudienceInput!) {
  organizationMessageReach(audience: $audience) {
    companyCount
    userCount
    bellEnabledCompanyCount
  }
}
    `;

/**
 * __useOrganizationMessageReachQuery__
 *
 * To run a query within a React component, call `useOrganizationMessageReachQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMessageReachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMessageReachQuery({
 *   variables: {
 *      audience: // value for 'audience'
 *   },
 * });
 */
export function useOrganizationMessageReachQuery(baseOptions: Apollo.QueryHookOptions<OrganizationMessageReachQuery, OrganizationMessageReachQueryVariables> & ({ variables: OrganizationMessageReachQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMessageReachQuery, OrganizationMessageReachQueryVariables>(OrganizationMessageReachDocument, options);
      }
export function useOrganizationMessageReachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMessageReachQuery, OrganizationMessageReachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMessageReachQuery, OrganizationMessageReachQueryVariables>(OrganizationMessageReachDocument, options);
        }
export function useOrganizationMessageReachSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationMessageReachQuery, OrganizationMessageReachQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationMessageReachQuery, OrganizationMessageReachQueryVariables>(OrganizationMessageReachDocument, options);
        }
export type OrganizationMessageReachQueryHookResult = ReturnType<typeof useOrganizationMessageReachQuery>;
export type OrganizationMessageReachLazyQueryHookResult = ReturnType<typeof useOrganizationMessageReachLazyQuery>;
export type OrganizationMessageReachSuspenseQueryHookResult = ReturnType<typeof useOrganizationMessageReachSuspenseQuery>;
export type OrganizationMessageReachQueryResult = Apollo.QueryResult<OrganizationMessageReachQuery, OrganizationMessageReachQueryVariables>;
export const OrganizationMessageCompaniesDocument = gql`
    query OrganizationMessageCompanies {
  companies {
    uuid
    name
  }
}
    `;

/**
 * __useOrganizationMessageCompaniesQuery__
 *
 * To run a query within a React component, call `useOrganizationMessageCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMessageCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMessageCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationMessageCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationMessageCompaniesQuery, OrganizationMessageCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMessageCompaniesQuery, OrganizationMessageCompaniesQueryVariables>(OrganizationMessageCompaniesDocument, options);
      }
export function useOrganizationMessageCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMessageCompaniesQuery, OrganizationMessageCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMessageCompaniesQuery, OrganizationMessageCompaniesQueryVariables>(OrganizationMessageCompaniesDocument, options);
        }
export function useOrganizationMessageCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationMessageCompaniesQuery, OrganizationMessageCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationMessageCompaniesQuery, OrganizationMessageCompaniesQueryVariables>(OrganizationMessageCompaniesDocument, options);
        }
export type OrganizationMessageCompaniesQueryHookResult = ReturnType<typeof useOrganizationMessageCompaniesQuery>;
export type OrganizationMessageCompaniesLazyQueryHookResult = ReturnType<typeof useOrganizationMessageCompaniesLazyQuery>;
export type OrganizationMessageCompaniesSuspenseQueryHookResult = ReturnType<typeof useOrganizationMessageCompaniesSuspenseQuery>;
export type OrganizationMessageCompaniesQueryResult = Apollo.QueryResult<OrganizationMessageCompaniesQuery, OrganizationMessageCompaniesQueryVariables>;
export const CreateOrganizationMessageDocument = gql`
    mutation CreateOrganizationMessage($input: CreateOrganizationMessageInput!) {
  createOrganizationMessage(input: $input) {
    ...OrganizationMessageFields
  }
}
    ${OrganizationMessageFieldsFragmentDoc}`;
export type CreateOrganizationMessageMutationFn = Apollo.MutationFunction<CreateOrganizationMessageMutation, CreateOrganizationMessageMutationVariables>;

/**
 * __useCreateOrganizationMessageMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMessageMutation, { data, loading, error }] = useCreateOrganizationMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMessageMutation, CreateOrganizationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMessageMutation, CreateOrganizationMessageMutationVariables>(CreateOrganizationMessageDocument, options);
      }
export type CreateOrganizationMessageMutationHookResult = ReturnType<typeof useCreateOrganizationMessageMutation>;
export type CreateOrganizationMessageMutationResult = Apollo.MutationResult<CreateOrganizationMessageMutation>;
export type CreateOrganizationMessageMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMessageMutation, CreateOrganizationMessageMutationVariables>;
export const UpdateOrganizationMessageDocument = gql`
    mutation UpdateOrganizationMessage($input: UpdateOrganizationMessageInput!) {
  updateOrganizationMessage(input: $input) {
    ...OrganizationMessageFields
  }
}
    ${OrganizationMessageFieldsFragmentDoc}`;
export type UpdateOrganizationMessageMutationFn = Apollo.MutationFunction<UpdateOrganizationMessageMutation, UpdateOrganizationMessageMutationVariables>;

/**
 * __useUpdateOrganizationMessageMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMessageMutation, { data, loading, error }] = useUpdateOrganizationMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMessageMutation, UpdateOrganizationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMessageMutation, UpdateOrganizationMessageMutationVariables>(UpdateOrganizationMessageDocument, options);
      }
export type UpdateOrganizationMessageMutationHookResult = ReturnType<typeof useUpdateOrganizationMessageMutation>;
export type UpdateOrganizationMessageMutationResult = Apollo.MutationResult<UpdateOrganizationMessageMutation>;
export type UpdateOrganizationMessageMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMessageMutation, UpdateOrganizationMessageMutationVariables>;
export const PublishOrganizationMessageDocument = gql`
    mutation PublishOrganizationMessage($input: PublishOrganizationMessageInput!) {
  publishOrganizationMessage(input: $input) {
    ...OrganizationMessageFields
  }
}
    ${OrganizationMessageFieldsFragmentDoc}`;
export type PublishOrganizationMessageMutationFn = Apollo.MutationFunction<PublishOrganizationMessageMutation, PublishOrganizationMessageMutationVariables>;

/**
 * __usePublishOrganizationMessageMutation__
 *
 * To run a mutation, you first call `usePublishOrganizationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishOrganizationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishOrganizationMessageMutation, { data, loading, error }] = usePublishOrganizationMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishOrganizationMessageMutation(baseOptions?: Apollo.MutationHookOptions<PublishOrganizationMessageMutation, PublishOrganizationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishOrganizationMessageMutation, PublishOrganizationMessageMutationVariables>(PublishOrganizationMessageDocument, options);
      }
export type PublishOrganizationMessageMutationHookResult = ReturnType<typeof usePublishOrganizationMessageMutation>;
export type PublishOrganizationMessageMutationResult = Apollo.MutationResult<PublishOrganizationMessageMutation>;
export type PublishOrganizationMessageMutationOptions = Apollo.BaseMutationOptions<PublishOrganizationMessageMutation, PublishOrganizationMessageMutationVariables>;
export const ScheduleOrganizationMessageDocument = gql`
    mutation ScheduleOrganizationMessage($input: ScheduleOrganizationMessageInput!) {
  scheduleOrganizationMessage(input: $input) {
    ...OrganizationMessageFields
  }
}
    ${OrganizationMessageFieldsFragmentDoc}`;
export type ScheduleOrganizationMessageMutationFn = Apollo.MutationFunction<ScheduleOrganizationMessageMutation, ScheduleOrganizationMessageMutationVariables>;

/**
 * __useScheduleOrganizationMessageMutation__
 *
 * To run a mutation, you first call `useScheduleOrganizationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleOrganizationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleOrganizationMessageMutation, { data, loading, error }] = useScheduleOrganizationMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleOrganizationMessageMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleOrganizationMessageMutation, ScheduleOrganizationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleOrganizationMessageMutation, ScheduleOrganizationMessageMutationVariables>(ScheduleOrganizationMessageDocument, options);
      }
export type ScheduleOrganizationMessageMutationHookResult = ReturnType<typeof useScheduleOrganizationMessageMutation>;
export type ScheduleOrganizationMessageMutationResult = Apollo.MutationResult<ScheduleOrganizationMessageMutation>;
export type ScheduleOrganizationMessageMutationOptions = Apollo.BaseMutationOptions<ScheduleOrganizationMessageMutation, ScheduleOrganizationMessageMutationVariables>;
export const RescheduleOrganizationMessageDocument = gql`
    mutation RescheduleOrganizationMessage($input: ScheduleOrganizationMessageInput!) {
  rescheduleOrganizationMessage(input: $input) {
    ...OrganizationMessageFields
  }
}
    ${OrganizationMessageFieldsFragmentDoc}`;
export type RescheduleOrganizationMessageMutationFn = Apollo.MutationFunction<RescheduleOrganizationMessageMutation, RescheduleOrganizationMessageMutationVariables>;

/**
 * __useRescheduleOrganizationMessageMutation__
 *
 * To run a mutation, you first call `useRescheduleOrganizationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleOrganizationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleOrganizationMessageMutation, { data, loading, error }] = useRescheduleOrganizationMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleOrganizationMessageMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleOrganizationMessageMutation, RescheduleOrganizationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleOrganizationMessageMutation, RescheduleOrganizationMessageMutationVariables>(RescheduleOrganizationMessageDocument, options);
      }
export type RescheduleOrganizationMessageMutationHookResult = ReturnType<typeof useRescheduleOrganizationMessageMutation>;
export type RescheduleOrganizationMessageMutationResult = Apollo.MutationResult<RescheduleOrganizationMessageMutation>;
export type RescheduleOrganizationMessageMutationOptions = Apollo.BaseMutationOptions<RescheduleOrganizationMessageMutation, RescheduleOrganizationMessageMutationVariables>;
export const ResolveOrganizationMessageDocument = gql`
    mutation ResolveOrganizationMessage($input: ResolveOrganizationMessageInput!) {
  resolveOrganizationMessage(input: $input) {
    ...OrganizationMessageFields
  }
}
    ${OrganizationMessageFieldsFragmentDoc}`;
export type ResolveOrganizationMessageMutationFn = Apollo.MutationFunction<ResolveOrganizationMessageMutation, ResolveOrganizationMessageMutationVariables>;

/**
 * __useResolveOrganizationMessageMutation__
 *
 * To run a mutation, you first call `useResolveOrganizationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveOrganizationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveOrganizationMessageMutation, { data, loading, error }] = useResolveOrganizationMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveOrganizationMessageMutation(baseOptions?: Apollo.MutationHookOptions<ResolveOrganizationMessageMutation, ResolveOrganizationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveOrganizationMessageMutation, ResolveOrganizationMessageMutationVariables>(ResolveOrganizationMessageDocument, options);
      }
export type ResolveOrganizationMessageMutationHookResult = ReturnType<typeof useResolveOrganizationMessageMutation>;
export type ResolveOrganizationMessageMutationResult = Apollo.MutationResult<ResolveOrganizationMessageMutation>;
export type ResolveOrganizationMessageMutationOptions = Apollo.BaseMutationOptions<ResolveOrganizationMessageMutation, ResolveOrganizationMessageMutationVariables>;
export const WithdrawOrganizationMessageDocument = gql`
    mutation WithdrawOrganizationMessage($input: OrganizationMessageUuidInput!) {
  withdrawOrganizationMessage(input: $input) {
    ...OrganizationMessageFields
  }
}
    ${OrganizationMessageFieldsFragmentDoc}`;
export type WithdrawOrganizationMessageMutationFn = Apollo.MutationFunction<WithdrawOrganizationMessageMutation, WithdrawOrganizationMessageMutationVariables>;

/**
 * __useWithdrawOrganizationMessageMutation__
 *
 * To run a mutation, you first call `useWithdrawOrganizationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawOrganizationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawOrganizationMessageMutation, { data, loading, error }] = useWithdrawOrganizationMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWithdrawOrganizationMessageMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawOrganizationMessageMutation, WithdrawOrganizationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawOrganizationMessageMutation, WithdrawOrganizationMessageMutationVariables>(WithdrawOrganizationMessageDocument, options);
      }
export type WithdrawOrganizationMessageMutationHookResult = ReturnType<typeof useWithdrawOrganizationMessageMutation>;
export type WithdrawOrganizationMessageMutationResult = Apollo.MutationResult<WithdrawOrganizationMessageMutation>;
export type WithdrawOrganizationMessageMutationOptions = Apollo.BaseMutationOptions<WithdrawOrganizationMessageMutation, WithdrawOrganizationMessageMutationVariables>;
export const OrganizationMessageCountsDocument = gql`
    query OrganizationMessageCounts {
  organizationMessageCounts {
    live
    scheduled
    drafts
    ended
  }
}
    `;

/**
 * __useOrganizationMessageCountsQuery__
 *
 * To run a query within a React component, call `useOrganizationMessageCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMessageCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMessageCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationMessageCountsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationMessageCountsQuery, OrganizationMessageCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMessageCountsQuery, OrganizationMessageCountsQueryVariables>(OrganizationMessageCountsDocument, options);
      }
export function useOrganizationMessageCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMessageCountsQuery, OrganizationMessageCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMessageCountsQuery, OrganizationMessageCountsQueryVariables>(OrganizationMessageCountsDocument, options);
        }
export function useOrganizationMessageCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationMessageCountsQuery, OrganizationMessageCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationMessageCountsQuery, OrganizationMessageCountsQueryVariables>(OrganizationMessageCountsDocument, options);
        }
export type OrganizationMessageCountsQueryHookResult = ReturnType<typeof useOrganizationMessageCountsQuery>;
export type OrganizationMessageCountsLazyQueryHookResult = ReturnType<typeof useOrganizationMessageCountsLazyQuery>;
export type OrganizationMessageCountsSuspenseQueryHookResult = ReturnType<typeof useOrganizationMessageCountsSuspenseQuery>;
export type OrganizationMessageCountsQueryResult = Apollo.QueryResult<OrganizationMessageCountsQuery, OrganizationMessageCountsQueryVariables>;
export const AdvanceOutboundBenchOrdersDocument = gql`
    mutation AdvanceOutboundBenchOrders($input: AdvanceOutboundBenchOrdersInput!) {
  advanceOutboundBenchOrders(input: $input) {
    ...BenchRunReportFields
  }
}
    ${BenchRunReportFieldsFragmentDoc}`;
export type AdvanceOutboundBenchOrdersMutationFn = Apollo.MutationFunction<AdvanceOutboundBenchOrdersMutation, AdvanceOutboundBenchOrdersMutationVariables>;

/**
 * __useAdvanceOutboundBenchOrdersMutation__
 *
 * To run a mutation, you first call `useAdvanceOutboundBenchOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdvanceOutboundBenchOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [advanceOutboundBenchOrdersMutation, { data, loading, error }] = useAdvanceOutboundBenchOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdvanceOutboundBenchOrdersMutation(baseOptions?: Apollo.MutationHookOptions<AdvanceOutboundBenchOrdersMutation, AdvanceOutboundBenchOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdvanceOutboundBenchOrdersMutation, AdvanceOutboundBenchOrdersMutationVariables>(AdvanceOutboundBenchOrdersDocument, options);
      }
export type AdvanceOutboundBenchOrdersMutationHookResult = ReturnType<typeof useAdvanceOutboundBenchOrdersMutation>;
export type AdvanceOutboundBenchOrdersMutationResult = Apollo.MutationResult<AdvanceOutboundBenchOrdersMutation>;
export type AdvanceOutboundBenchOrdersMutationOptions = Apollo.BaseMutationOptions<AdvanceOutboundBenchOrdersMutation, AdvanceOutboundBenchOrdersMutationVariables>;
export const CreateOutboundBenchOrdersDocument = gql`
    mutation CreateOutboundBenchOrders($input: CreateOutboundBenchOrdersInput!) {
  createOutboundBenchOrders(input: $input) {
    failure
    laneSourceOrderName
    warning
    receivedServiceNames
    sideEffects {
      kind
      detail
      suppressedBy
    }
    orders {
      uuid
      name
      hawb
      mawb
      status
      createdAt
    }
  }
}
    `;
export type CreateOutboundBenchOrdersMutationFn = Apollo.MutationFunction<CreateOutboundBenchOrdersMutation, CreateOutboundBenchOrdersMutationVariables>;

/**
 * __useCreateOutboundBenchOrdersMutation__
 *
 * To run a mutation, you first call `useCreateOutboundBenchOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOutboundBenchOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOutboundBenchOrdersMutation, { data, loading, error }] = useCreateOutboundBenchOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOutboundBenchOrdersMutation(baseOptions?: Apollo.MutationHookOptions<CreateOutboundBenchOrdersMutation, CreateOutboundBenchOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOutboundBenchOrdersMutation, CreateOutboundBenchOrdersMutationVariables>(CreateOutboundBenchOrdersDocument, options);
      }
export type CreateOutboundBenchOrdersMutationHookResult = ReturnType<typeof useCreateOutboundBenchOrdersMutation>;
export type CreateOutboundBenchOrdersMutationResult = Apollo.MutationResult<CreateOutboundBenchOrdersMutation>;
export type CreateOutboundBenchOrdersMutationOptions = Apollo.BaseMutationOptions<CreateOutboundBenchOrdersMutation, CreateOutboundBenchOrdersMutationVariables>;
export const FireOutboundBenchTransactionDocument = gql`
    mutation FireOutboundBenchTransaction($input: FireOutboundBenchTransactionInput!) {
  fireOutboundBenchTransaction(input: $input) {
    orderUuid
    outcome
    message
    sideEffects {
      kind
      detail
      suppressedBy
    }
    ediTransactions {
      ...BenchEdiTransactionFields
    }
  }
}
    ${BenchEdiTransactionFieldsFragmentDoc}`;
export type FireOutboundBenchTransactionMutationFn = Apollo.MutationFunction<FireOutboundBenchTransactionMutation, FireOutboundBenchTransactionMutationVariables>;

/**
 * __useFireOutboundBenchTransactionMutation__
 *
 * To run a mutation, you first call `useFireOutboundBenchTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFireOutboundBenchTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fireOutboundBenchTransactionMutation, { data, loading, error }] = useFireOutboundBenchTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFireOutboundBenchTransactionMutation(baseOptions?: Apollo.MutationHookOptions<FireOutboundBenchTransactionMutation, FireOutboundBenchTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FireOutboundBenchTransactionMutation, FireOutboundBenchTransactionMutationVariables>(FireOutboundBenchTransactionDocument, options);
      }
export type FireOutboundBenchTransactionMutationHookResult = ReturnType<typeof useFireOutboundBenchTransactionMutation>;
export type FireOutboundBenchTransactionMutationResult = Apollo.MutationResult<FireOutboundBenchTransactionMutation>;
export type FireOutboundBenchTransactionMutationOptions = Apollo.BaseMutationOptions<FireOutboundBenchTransactionMutation, FireOutboundBenchTransactionMutationVariables>;
export const OutboundBenchCompanyUsersDocument = gql`
    query OutboundBenchCompanyUsers($companyUuid: String!) {
  outboundBenchCompanyUsers(companyUuid: $companyUuid) {
    uuid
    displayName
    email
  }
}
    `;

/**
 * __useOutboundBenchCompanyUsersQuery__
 *
 * To run a query within a React component, call `useOutboundBenchCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutboundBenchCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutboundBenchCompanyUsersQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useOutboundBenchCompanyUsersQuery(baseOptions: Apollo.QueryHookOptions<OutboundBenchCompanyUsersQuery, OutboundBenchCompanyUsersQueryVariables> & ({ variables: OutboundBenchCompanyUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutboundBenchCompanyUsersQuery, OutboundBenchCompanyUsersQueryVariables>(OutboundBenchCompanyUsersDocument, options);
      }
export function useOutboundBenchCompanyUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutboundBenchCompanyUsersQuery, OutboundBenchCompanyUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutboundBenchCompanyUsersQuery, OutboundBenchCompanyUsersQueryVariables>(OutboundBenchCompanyUsersDocument, options);
        }
export function useOutboundBenchCompanyUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutboundBenchCompanyUsersQuery, OutboundBenchCompanyUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutboundBenchCompanyUsersQuery, OutboundBenchCompanyUsersQueryVariables>(OutboundBenchCompanyUsersDocument, options);
        }
export type OutboundBenchCompanyUsersQueryHookResult = ReturnType<typeof useOutboundBenchCompanyUsersQuery>;
export type OutboundBenchCompanyUsersLazyQueryHookResult = ReturnType<typeof useOutboundBenchCompanyUsersLazyQuery>;
export type OutboundBenchCompanyUsersSuspenseQueryHookResult = ReturnType<typeof useOutboundBenchCompanyUsersSuspenseQuery>;
export type OutboundBenchCompanyUsersQueryResult = Apollo.QueryResult<OutboundBenchCompanyUsersQuery, OutboundBenchCompanyUsersQueryVariables>;
export const OutboundBenchDriversDocument = gql`
    query OutboundBenchDrivers($companyUuid: String!) {
  outboundBenchDrivers(companyUuid: $companyUuid) {
    uuid
    displayName
  }
}
    `;

/**
 * __useOutboundBenchDriversQuery__
 *
 * To run a query within a React component, call `useOutboundBenchDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutboundBenchDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutboundBenchDriversQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useOutboundBenchDriversQuery(baseOptions: Apollo.QueryHookOptions<OutboundBenchDriversQuery, OutboundBenchDriversQueryVariables> & ({ variables: OutboundBenchDriversQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutboundBenchDriversQuery, OutboundBenchDriversQueryVariables>(OutboundBenchDriversDocument, options);
      }
export function useOutboundBenchDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutboundBenchDriversQuery, OutboundBenchDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutboundBenchDriversQuery, OutboundBenchDriversQueryVariables>(OutboundBenchDriversDocument, options);
        }
export function useOutboundBenchDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutboundBenchDriversQuery, OutboundBenchDriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutboundBenchDriversQuery, OutboundBenchDriversQueryVariables>(OutboundBenchDriversDocument, options);
        }
export type OutboundBenchDriversQueryHookResult = ReturnType<typeof useOutboundBenchDriversQuery>;
export type OutboundBenchDriversLazyQueryHookResult = ReturnType<typeof useOutboundBenchDriversLazyQuery>;
export type OutboundBenchDriversSuspenseQueryHookResult = ReturnType<typeof useOutboundBenchDriversSuspenseQuery>;
export type OutboundBenchDriversQueryResult = Apollo.QueryResult<OutboundBenchDriversQuery, OutboundBenchDriversQueryVariables>;
export const OutboundBenchEdiPayloadDocument = gql`
    query OutboundBenchEdiPayload($ediTransactionUuid: String!) {
  outboundBenchEdiPayload(ediTransactionUuid: $ediTransactionUuid) {
    uuid
    storedPayload
    sentPath
    sentBody
    deliveredThroughTenedi
    note
  }
}
    `;

/**
 * __useOutboundBenchEdiPayloadQuery__
 *
 * To run a query within a React component, call `useOutboundBenchEdiPayloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutboundBenchEdiPayloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutboundBenchEdiPayloadQuery({
 *   variables: {
 *      ediTransactionUuid: // value for 'ediTransactionUuid'
 *   },
 * });
 */
export function useOutboundBenchEdiPayloadQuery(baseOptions: Apollo.QueryHookOptions<OutboundBenchEdiPayloadQuery, OutboundBenchEdiPayloadQueryVariables> & ({ variables: OutboundBenchEdiPayloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutboundBenchEdiPayloadQuery, OutboundBenchEdiPayloadQueryVariables>(OutboundBenchEdiPayloadDocument, options);
      }
export function useOutboundBenchEdiPayloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutboundBenchEdiPayloadQuery, OutboundBenchEdiPayloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutboundBenchEdiPayloadQuery, OutboundBenchEdiPayloadQueryVariables>(OutboundBenchEdiPayloadDocument, options);
        }
export function useOutboundBenchEdiPayloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutboundBenchEdiPayloadQuery, OutboundBenchEdiPayloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutboundBenchEdiPayloadQuery, OutboundBenchEdiPayloadQueryVariables>(OutboundBenchEdiPayloadDocument, options);
        }
export type OutboundBenchEdiPayloadQueryHookResult = ReturnType<typeof useOutboundBenchEdiPayloadQuery>;
export type OutboundBenchEdiPayloadLazyQueryHookResult = ReturnType<typeof useOutboundBenchEdiPayloadLazyQuery>;
export type OutboundBenchEdiPayloadSuspenseQueryHookResult = ReturnType<typeof useOutboundBenchEdiPayloadSuspenseQuery>;
export type OutboundBenchEdiPayloadQueryResult = Apollo.QueryResult<OutboundBenchEdiPayloadQuery, OutboundBenchEdiPayloadQueryVariables>;
export const OutboundBenchOrdersDocument = gql`
    query OutboundBenchOrders($input: OutboundBenchOrderSearchInput!) {
  outboundBenchOrders(input: $input) {
    uuid
    name
    hawb
    mawb
    status
    createdAt
  }
}
    `;

/**
 * __useOutboundBenchOrdersQuery__
 *
 * To run a query within a React component, call `useOutboundBenchOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutboundBenchOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutboundBenchOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOutboundBenchOrdersQuery(baseOptions: Apollo.QueryHookOptions<OutboundBenchOrdersQuery, OutboundBenchOrdersQueryVariables> & ({ variables: OutboundBenchOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutboundBenchOrdersQuery, OutboundBenchOrdersQueryVariables>(OutboundBenchOrdersDocument, options);
      }
export function useOutboundBenchOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutboundBenchOrdersQuery, OutboundBenchOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutboundBenchOrdersQuery, OutboundBenchOrdersQueryVariables>(OutboundBenchOrdersDocument, options);
        }
export function useOutboundBenchOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutboundBenchOrdersQuery, OutboundBenchOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutboundBenchOrdersQuery, OutboundBenchOrdersQueryVariables>(OutboundBenchOrdersDocument, options);
        }
export type OutboundBenchOrdersQueryHookResult = ReturnType<typeof useOutboundBenchOrdersQuery>;
export type OutboundBenchOrdersLazyQueryHookResult = ReturnType<typeof useOutboundBenchOrdersLazyQuery>;
export type OutboundBenchOrdersSuspenseQueryHookResult = ReturnType<typeof useOutboundBenchOrdersSuspenseQuery>;
export type OutboundBenchOrdersQueryResult = Apollo.QueryResult<OutboundBenchOrdersQuery, OutboundBenchOrdersQueryVariables>;
export const OutboundBenchPartnershipsDocument = gql`
    query OutboundBenchPartnerships {
  outboundBenchPartnerships {
    uuid
    companyUuid
    companyName
    contactUuid
    contactName
    receiverIsaId
    autoAcceptOrders
    edi214ShipmentStatuses
  }
}
    `;

/**
 * __useOutboundBenchPartnershipsQuery__
 *
 * To run a query within a React component, call `useOutboundBenchPartnershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutboundBenchPartnershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutboundBenchPartnershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOutboundBenchPartnershipsQuery(baseOptions?: Apollo.QueryHookOptions<OutboundBenchPartnershipsQuery, OutboundBenchPartnershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutboundBenchPartnershipsQuery, OutboundBenchPartnershipsQueryVariables>(OutboundBenchPartnershipsDocument, options);
      }
export function useOutboundBenchPartnershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutboundBenchPartnershipsQuery, OutboundBenchPartnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutboundBenchPartnershipsQuery, OutboundBenchPartnershipsQueryVariables>(OutboundBenchPartnershipsDocument, options);
        }
export function useOutboundBenchPartnershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutboundBenchPartnershipsQuery, OutboundBenchPartnershipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutboundBenchPartnershipsQuery, OutboundBenchPartnershipsQueryVariables>(OutboundBenchPartnershipsDocument, options);
        }
export type OutboundBenchPartnershipsQueryHookResult = ReturnType<typeof useOutboundBenchPartnershipsQuery>;
export type OutboundBenchPartnershipsLazyQueryHookResult = ReturnType<typeof useOutboundBenchPartnershipsLazyQuery>;
export type OutboundBenchPartnershipsSuspenseQueryHookResult = ReturnType<typeof useOutboundBenchPartnershipsSuspenseQuery>;
export type OutboundBenchPartnershipsQueryResult = Apollo.QueryResult<OutboundBenchPartnershipsQuery, OutboundBenchPartnershipsQueryVariables>;
export const OutboundBenchServiceLevelsDocument = gql`
    query OutboundBenchServiceLevels($partnershipUuid: String!) {
  outboundBenchServiceLevels(partnershipUuid: $partnershipUuid) {
    code
    serviceName
  }
}
    `;

/**
 * __useOutboundBenchServiceLevelsQuery__
 *
 * To run a query within a React component, call `useOutboundBenchServiceLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutboundBenchServiceLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutboundBenchServiceLevelsQuery({
 *   variables: {
 *      partnershipUuid: // value for 'partnershipUuid'
 *   },
 * });
 */
export function useOutboundBenchServiceLevelsQuery(baseOptions: Apollo.QueryHookOptions<OutboundBenchServiceLevelsQuery, OutboundBenchServiceLevelsQueryVariables> & ({ variables: OutboundBenchServiceLevelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutboundBenchServiceLevelsQuery, OutboundBenchServiceLevelsQueryVariables>(OutboundBenchServiceLevelsDocument, options);
      }
export function useOutboundBenchServiceLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutboundBenchServiceLevelsQuery, OutboundBenchServiceLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutboundBenchServiceLevelsQuery, OutboundBenchServiceLevelsQueryVariables>(OutboundBenchServiceLevelsDocument, options);
        }
export function useOutboundBenchServiceLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutboundBenchServiceLevelsQuery, OutboundBenchServiceLevelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutboundBenchServiceLevelsQuery, OutboundBenchServiceLevelsQueryVariables>(OutboundBenchServiceLevelsDocument, options);
        }
export type OutboundBenchServiceLevelsQueryHookResult = ReturnType<typeof useOutboundBenchServiceLevelsQuery>;
export type OutboundBenchServiceLevelsLazyQueryHookResult = ReturnType<typeof useOutboundBenchServiceLevelsLazyQuery>;
export type OutboundBenchServiceLevelsSuspenseQueryHookResult = ReturnType<typeof useOutboundBenchServiceLevelsSuspenseQuery>;
export type OutboundBenchServiceLevelsQueryResult = Apollo.QueryResult<OutboundBenchServiceLevelsQuery, OutboundBenchServiceLevelsQueryVariables>;
export const PlanOutboundBenchRunDocument = gql`
    query PlanOutboundBenchRun($input: PlanOutboundBenchRunInput!) {
  planOutboundBenchRun(input: $input) {
    ...BenchRunReportFields
  }
}
    ${BenchRunReportFieldsFragmentDoc}`;

/**
 * __usePlanOutboundBenchRunQuery__
 *
 * To run a query within a React component, call `usePlanOutboundBenchRunQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanOutboundBenchRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanOutboundBenchRunQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlanOutboundBenchRunQuery(baseOptions: Apollo.QueryHookOptions<PlanOutboundBenchRunQuery, PlanOutboundBenchRunQueryVariables> & ({ variables: PlanOutboundBenchRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanOutboundBenchRunQuery, PlanOutboundBenchRunQueryVariables>(PlanOutboundBenchRunDocument, options);
      }
export function usePlanOutboundBenchRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanOutboundBenchRunQuery, PlanOutboundBenchRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanOutboundBenchRunQuery, PlanOutboundBenchRunQueryVariables>(PlanOutboundBenchRunDocument, options);
        }
export function usePlanOutboundBenchRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanOutboundBenchRunQuery, PlanOutboundBenchRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanOutboundBenchRunQuery, PlanOutboundBenchRunQueryVariables>(PlanOutboundBenchRunDocument, options);
        }
export type PlanOutboundBenchRunQueryHookResult = ReturnType<typeof usePlanOutboundBenchRunQuery>;
export type PlanOutboundBenchRunLazyQueryHookResult = ReturnType<typeof usePlanOutboundBenchRunLazyQuery>;
export type PlanOutboundBenchRunSuspenseQueryHookResult = ReturnType<typeof usePlanOutboundBenchRunSuspenseQuery>;
export type PlanOutboundBenchRunQueryResult = Apollo.QueryResult<PlanOutboundBenchRunQuery, PlanOutboundBenchRunQueryVariables>;
export const SmsConsentAdminListDocument = gql`
    query SmsConsentAdminList($first: Int, $after: String, $filter: SmsConsentAdminFilterInput) {
  smsConsentAdminList(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        ...SmsConsentAdminFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${SmsConsentAdminFieldsFragmentDoc}`;

/**
 * __useSmsConsentAdminListQuery__
 *
 * To run a query within a React component, call `useSmsConsentAdminListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsConsentAdminListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsConsentAdminListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSmsConsentAdminListQuery(baseOptions?: Apollo.QueryHookOptions<SmsConsentAdminListQuery, SmsConsentAdminListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmsConsentAdminListQuery, SmsConsentAdminListQueryVariables>(SmsConsentAdminListDocument, options);
      }
export function useSmsConsentAdminListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsConsentAdminListQuery, SmsConsentAdminListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmsConsentAdminListQuery, SmsConsentAdminListQueryVariables>(SmsConsentAdminListDocument, options);
        }
export function useSmsConsentAdminListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmsConsentAdminListQuery, SmsConsentAdminListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmsConsentAdminListQuery, SmsConsentAdminListQueryVariables>(SmsConsentAdminListDocument, options);
        }
export type SmsConsentAdminListQueryHookResult = ReturnType<typeof useSmsConsentAdminListQuery>;
export type SmsConsentAdminListLazyQueryHookResult = ReturnType<typeof useSmsConsentAdminListLazyQuery>;
export type SmsConsentAdminListSuspenseQueryHookResult = ReturnType<typeof useSmsConsentAdminListSuspenseQuery>;
export type SmsConsentAdminListQueryResult = Apollo.QueryResult<SmsConsentAdminListQuery, SmsConsentAdminListQueryVariables>;
export const SaveTenediPartnershipDocument = gql`
    mutation SaveTenediPartnership($input: SaveTenediPartnershipInput!) {
  saveTenediPartnership(input: $input) {
    created
    changes {
      ...TenediFieldChangeFields
    }
    partnership {
      ...TenediPartnershipFields
    }
  }
}
    ${TenediFieldChangeFieldsFragmentDoc}
${TenediPartnershipFieldsFragmentDoc}`;
export type SaveTenediPartnershipMutationFn = Apollo.MutationFunction<SaveTenediPartnershipMutation, SaveTenediPartnershipMutationVariables>;

/**
 * __useSaveTenediPartnershipMutation__
 *
 * To run a mutation, you first call `useSaveTenediPartnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTenediPartnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTenediPartnershipMutation, { data, loading, error }] = useSaveTenediPartnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTenediPartnershipMutation(baseOptions?: Apollo.MutationHookOptions<SaveTenediPartnershipMutation, SaveTenediPartnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTenediPartnershipMutation, SaveTenediPartnershipMutationVariables>(SaveTenediPartnershipDocument, options);
      }
export type SaveTenediPartnershipMutationHookResult = ReturnType<typeof useSaveTenediPartnershipMutation>;
export type SaveTenediPartnershipMutationResult = Apollo.MutationResult<SaveTenediPartnershipMutation>;
export type SaveTenediPartnershipMutationOptions = Apollo.BaseMutationOptions<SaveTenediPartnershipMutation, SaveTenediPartnershipMutationVariables>;
export const TenediConnectionCustomersDocument = gql`
    query TenediConnectionCustomers($input: TenediConnectionCustomersInput!) {
  tenediConnectionCustomers(input: $input) {
    uuid
    displayName
    isActive
    isaId
    partnershipCount
  }
}
    `;

/**
 * __useTenediConnectionCustomersQuery__
 *
 * To run a query within a React component, call `useTenediConnectionCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenediConnectionCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenediConnectionCustomersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTenediConnectionCustomersQuery(baseOptions: Apollo.QueryHookOptions<TenediConnectionCustomersQuery, TenediConnectionCustomersQueryVariables> & ({ variables: TenediConnectionCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenediConnectionCustomersQuery, TenediConnectionCustomersQueryVariables>(TenediConnectionCustomersDocument, options);
      }
export function useTenediConnectionCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenediConnectionCustomersQuery, TenediConnectionCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenediConnectionCustomersQuery, TenediConnectionCustomersQueryVariables>(TenediConnectionCustomersDocument, options);
        }
export function useTenediConnectionCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TenediConnectionCustomersQuery, TenediConnectionCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenediConnectionCustomersQuery, TenediConnectionCustomersQueryVariables>(TenediConnectionCustomersDocument, options);
        }
export type TenediConnectionCustomersQueryHookResult = ReturnType<typeof useTenediConnectionCustomersQuery>;
export type TenediConnectionCustomersLazyQueryHookResult = ReturnType<typeof useTenediConnectionCustomersLazyQuery>;
export type TenediConnectionCustomersSuspenseQueryHookResult = ReturnType<typeof useTenediConnectionCustomersSuspenseQuery>;
export type TenediConnectionCustomersQueryResult = Apollo.QueryResult<TenediConnectionCustomersQuery, TenediConnectionCustomersQueryVariables>;
export const TenediConnectionDocument = gql`
    query TenediConnection($input: TenediConnectionInput!) {
  tenediConnection(input: $input) {
    environment
    production
    ready
    carrier {
      ...TenediCarrierIdentityFields
    }
    customer {
      ...TenediCustomerIdentityFields
    }
    partnerships {
      ...TenediPartnershipFields
    }
    readiness {
      check
      status
      message
      fixIn
    }
  }
}
    ${TenediCarrierIdentityFieldsFragmentDoc}
${TenediCustomerIdentityFieldsFragmentDoc}
${TenediPartnershipFieldsFragmentDoc}`;

/**
 * __useTenediConnectionQuery__
 *
 * To run a query within a React component, call `useTenediConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenediConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenediConnectionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTenediConnectionQuery(baseOptions: Apollo.QueryHookOptions<TenediConnectionQuery, TenediConnectionQueryVariables> & ({ variables: TenediConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenediConnectionQuery, TenediConnectionQueryVariables>(TenediConnectionDocument, options);
      }
export function useTenediConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenediConnectionQuery, TenediConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenediConnectionQuery, TenediConnectionQueryVariables>(TenediConnectionDocument, options);
        }
export function useTenediConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TenediConnectionQuery, TenediConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenediConnectionQuery, TenediConnectionQueryVariables>(TenediConnectionDocument, options);
        }
export type TenediConnectionQueryHookResult = ReturnType<typeof useTenediConnectionQuery>;
export type TenediConnectionLazyQueryHookResult = ReturnType<typeof useTenediConnectionLazyQuery>;
export type TenediConnectionSuspenseQueryHookResult = ReturnType<typeof useTenediConnectionSuspenseQuery>;
export type TenediConnectionQueryResult = Apollo.QueryResult<TenediConnectionQuery, TenediConnectionQueryVariables>;
export const UpdateTenediCarrierIdentityDocument = gql`
    mutation UpdateTenediCarrierIdentity($input: UpdateTenediCarrierIdentityInput!) {
  updateTenediCarrierIdentity(input: $input) {
    changes {
      ...TenediFieldChangeFields
    }
    carrier {
      ...TenediCarrierIdentityFields
    }
  }
}
    ${TenediFieldChangeFieldsFragmentDoc}
${TenediCarrierIdentityFieldsFragmentDoc}`;
export type UpdateTenediCarrierIdentityMutationFn = Apollo.MutationFunction<UpdateTenediCarrierIdentityMutation, UpdateTenediCarrierIdentityMutationVariables>;

/**
 * __useUpdateTenediCarrierIdentityMutation__
 *
 * To run a mutation, you first call `useUpdateTenediCarrierIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenediCarrierIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenediCarrierIdentityMutation, { data, loading, error }] = useUpdateTenediCarrierIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenediCarrierIdentityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenediCarrierIdentityMutation, UpdateTenediCarrierIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenediCarrierIdentityMutation, UpdateTenediCarrierIdentityMutationVariables>(UpdateTenediCarrierIdentityDocument, options);
      }
export type UpdateTenediCarrierIdentityMutationHookResult = ReturnType<typeof useUpdateTenediCarrierIdentityMutation>;
export type UpdateTenediCarrierIdentityMutationResult = Apollo.MutationResult<UpdateTenediCarrierIdentityMutation>;
export type UpdateTenediCarrierIdentityMutationOptions = Apollo.BaseMutationOptions<UpdateTenediCarrierIdentityMutation, UpdateTenediCarrierIdentityMutationVariables>;
export const UpdateTenediCustomerIdentityDocument = gql`
    mutation UpdateTenediCustomerIdentity($input: UpdateTenediCustomerIdentityInput!) {
  updateTenediCustomerIdentity(input: $input) {
    changes {
      ...TenediFieldChangeFields
    }
    customer {
      ...TenediCustomerIdentityFields
    }
  }
}
    ${TenediFieldChangeFieldsFragmentDoc}
${TenediCustomerIdentityFieldsFragmentDoc}`;
export type UpdateTenediCustomerIdentityMutationFn = Apollo.MutationFunction<UpdateTenediCustomerIdentityMutation, UpdateTenediCustomerIdentityMutationVariables>;

/**
 * __useUpdateTenediCustomerIdentityMutation__
 *
 * To run a mutation, you first call `useUpdateTenediCustomerIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenediCustomerIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenediCustomerIdentityMutation, { data, loading, error }] = useUpdateTenediCustomerIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenediCustomerIdentityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenediCustomerIdentityMutation, UpdateTenediCustomerIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenediCustomerIdentityMutation, UpdateTenediCustomerIdentityMutationVariables>(UpdateTenediCustomerIdentityDocument, options);
      }
export type UpdateTenediCustomerIdentityMutationHookResult = ReturnType<typeof useUpdateTenediCustomerIdentityMutation>;
export type UpdateTenediCustomerIdentityMutationResult = Apollo.MutationResult<UpdateTenediCustomerIdentityMutation>;
export type UpdateTenediCustomerIdentityMutationOptions = Apollo.BaseMutationOptions<UpdateTenediCustomerIdentityMutation, UpdateTenediCustomerIdentityMutationVariables>;
export const CreateTestApiOrderDocument = gql`
    mutation CreateTestApiOrder($input: CreateTestApiOrderInput!) {
  createTestApiOrder(input: $input) {
    orderUuid
    orderName
    merged
    mergedIntoOrderUuid
    mergedIntoOrderName
    message
    inboundApiRequestUuid
  }
}
    `;
export type CreateTestApiOrderMutationFn = Apollo.MutationFunction<CreateTestApiOrderMutation, CreateTestApiOrderMutationVariables>;

/**
 * __useCreateTestApiOrderMutation__
 *
 * To run a mutation, you first call `useCreateTestApiOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestApiOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestApiOrderMutation, { data, loading, error }] = useCreateTestApiOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestApiOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestApiOrderMutation, CreateTestApiOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestApiOrderMutation, CreateTestApiOrderMutationVariables>(CreateTestApiOrderDocument, options);
      }
export type CreateTestApiOrderMutationHookResult = ReturnType<typeof useCreateTestApiOrderMutation>;
export type CreateTestApiOrderMutationResult = Apollo.MutationResult<CreateTestApiOrderMutation>;
export type CreateTestApiOrderMutationOptions = Apollo.BaseMutationOptions<CreateTestApiOrderMutation, CreateTestApiOrderMutationVariables>;
export const CreateTestEdiOrderDocument = gql`
    mutation CreateTestEdiOrder($input: CreateTestEdiOrderInput!) {
  createTestEdiOrder(input: $input) {
    ediTransactionId
    orderUuid
    orderName
    merged
    mergedIntoOrderUuid
    mergedIntoOrderName
    message
    schemaWarning
  }
}
    `;
export type CreateTestEdiOrderMutationFn = Apollo.MutationFunction<CreateTestEdiOrderMutation, CreateTestEdiOrderMutationVariables>;

/**
 * __useCreateTestEdiOrderMutation__
 *
 * To run a mutation, you first call `useCreateTestEdiOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestEdiOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestEdiOrderMutation, { data, loading, error }] = useCreateTestEdiOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestEdiOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestEdiOrderMutation, CreateTestEdiOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestEdiOrderMutation, CreateTestEdiOrderMutationVariables>(CreateTestEdiOrderDocument, options);
      }
export type CreateTestEdiOrderMutationHookResult = ReturnType<typeof useCreateTestEdiOrderMutation>;
export type CreateTestEdiOrderMutationResult = Apollo.MutationResult<CreateTestEdiOrderMutation>;
export type CreateTestEdiOrderMutationOptions = Apollo.BaseMutationOptions<CreateTestEdiOrderMutation, CreateTestEdiOrderMutationVariables>;
export const TestIntegrationOrderCompaniesDocument = gql`
    query TestIntegrationOrderCompanies {
  companies {
    uuid
    name
  }
}
    `;

/**
 * __useTestIntegrationOrderCompaniesQuery__
 *
 * To run a query within a React component, call `useTestIntegrationOrderCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestIntegrationOrderCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestIntegrationOrderCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestIntegrationOrderCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<TestIntegrationOrderCompaniesQuery, TestIntegrationOrderCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestIntegrationOrderCompaniesQuery, TestIntegrationOrderCompaniesQueryVariables>(TestIntegrationOrderCompaniesDocument, options);
      }
export function useTestIntegrationOrderCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestIntegrationOrderCompaniesQuery, TestIntegrationOrderCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestIntegrationOrderCompaniesQuery, TestIntegrationOrderCompaniesQueryVariables>(TestIntegrationOrderCompaniesDocument, options);
        }
export function useTestIntegrationOrderCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestIntegrationOrderCompaniesQuery, TestIntegrationOrderCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestIntegrationOrderCompaniesQuery, TestIntegrationOrderCompaniesQueryVariables>(TestIntegrationOrderCompaniesDocument, options);
        }
export type TestIntegrationOrderCompaniesQueryHookResult = ReturnType<typeof useTestIntegrationOrderCompaniesQuery>;
export type TestIntegrationOrderCompaniesLazyQueryHookResult = ReturnType<typeof useTestIntegrationOrderCompaniesLazyQuery>;
export type TestIntegrationOrderCompaniesSuspenseQueryHookResult = ReturnType<typeof useTestIntegrationOrderCompaniesSuspenseQuery>;
export type TestIntegrationOrderCompaniesQueryResult = Apollo.QueryResult<TestIntegrationOrderCompaniesQuery, TestIntegrationOrderCompaniesQueryVariables>;
export const TestIntegrationOrderContactsDocument = gql`
    query TestIntegrationOrderContacts($companyUuid: String!) {
  companyContacts(companyUuid: $companyUuid, excludeNonActiveContacts: true) {
    uuid
    displayName
    services {
      uuid
      name
    }
  }
}
    `;

/**
 * __useTestIntegrationOrderContactsQuery__
 *
 * To run a query within a React component, call `useTestIntegrationOrderContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestIntegrationOrderContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestIntegrationOrderContactsQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useTestIntegrationOrderContactsQuery(baseOptions: Apollo.QueryHookOptions<TestIntegrationOrderContactsQuery, TestIntegrationOrderContactsQueryVariables> & ({ variables: TestIntegrationOrderContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestIntegrationOrderContactsQuery, TestIntegrationOrderContactsQueryVariables>(TestIntegrationOrderContactsDocument, options);
      }
export function useTestIntegrationOrderContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestIntegrationOrderContactsQuery, TestIntegrationOrderContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestIntegrationOrderContactsQuery, TestIntegrationOrderContactsQueryVariables>(TestIntegrationOrderContactsDocument, options);
        }
export function useTestIntegrationOrderContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestIntegrationOrderContactsQuery, TestIntegrationOrderContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestIntegrationOrderContactsQuery, TestIntegrationOrderContactsQueryVariables>(TestIntegrationOrderContactsDocument, options);
        }
export type TestIntegrationOrderContactsQueryHookResult = ReturnType<typeof useTestIntegrationOrderContactsQuery>;
export type TestIntegrationOrderContactsLazyQueryHookResult = ReturnType<typeof useTestIntegrationOrderContactsLazyQuery>;
export type TestIntegrationOrderContactsSuspenseQueryHookResult = ReturnType<typeof useTestIntegrationOrderContactsSuspenseQuery>;
export type TestIntegrationOrderContactsQueryResult = Apollo.QueryResult<TestIntegrationOrderContactsQuery, TestIntegrationOrderContactsQueryVariables>;
export const UserSessionsAdminCompanyUsersDocument = gql`
    query UserSessionsAdminCompanyUsers($companyUuid: String!) {
  userSessionsAdminCompanyUsers(companyUuid: $companyUuid) {
    totalCount
    hasMore
    users {
      ...UserSessionsAdminUserFields
    }
  }
}
    ${UserSessionsAdminUserFieldsFragmentDoc}`;

/**
 * __useUserSessionsAdminCompanyUsersQuery__
 *
 * To run a query within a React component, call `useUserSessionsAdminCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSessionsAdminCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSessionsAdminCompanyUsersQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useUserSessionsAdminCompanyUsersQuery(baseOptions: Apollo.QueryHookOptions<UserSessionsAdminCompanyUsersQuery, UserSessionsAdminCompanyUsersQueryVariables> & ({ variables: UserSessionsAdminCompanyUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSessionsAdminCompanyUsersQuery, UserSessionsAdminCompanyUsersQueryVariables>(UserSessionsAdminCompanyUsersDocument, options);
      }
export function useUserSessionsAdminCompanyUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSessionsAdminCompanyUsersQuery, UserSessionsAdminCompanyUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSessionsAdminCompanyUsersQuery, UserSessionsAdminCompanyUsersQueryVariables>(UserSessionsAdminCompanyUsersDocument, options);
        }
export function useUserSessionsAdminCompanyUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserSessionsAdminCompanyUsersQuery, UserSessionsAdminCompanyUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSessionsAdminCompanyUsersQuery, UserSessionsAdminCompanyUsersQueryVariables>(UserSessionsAdminCompanyUsersDocument, options);
        }
export type UserSessionsAdminCompanyUsersQueryHookResult = ReturnType<typeof useUserSessionsAdminCompanyUsersQuery>;
export type UserSessionsAdminCompanyUsersLazyQueryHookResult = ReturnType<typeof useUserSessionsAdminCompanyUsersLazyQuery>;
export type UserSessionsAdminCompanyUsersSuspenseQueryHookResult = ReturnType<typeof useUserSessionsAdminCompanyUsersSuspenseQuery>;
export type UserSessionsAdminCompanyUsersQueryResult = Apollo.QueryResult<UserSessionsAdminCompanyUsersQuery, UserSessionsAdminCompanyUsersQueryVariables>;
export const UserSessionsAdminRevokeSessionsDocument = gql`
    mutation UserSessionsAdminRevokeSessions($input: RevokeCompanyUserSessionsInput!) {
  userSessionsAdminRevokeSessions(input: $input) {
    revokedCount
    archivedCount
    skippedNoEmailCount
    failedCount
    targetedUsers {
      ...UserSessionsAdminUserFields
    }
  }
}
    ${UserSessionsAdminUserFieldsFragmentDoc}`;
export type UserSessionsAdminRevokeSessionsMutationFn = Apollo.MutationFunction<UserSessionsAdminRevokeSessionsMutation, UserSessionsAdminRevokeSessionsMutationVariables>;

/**
 * __useUserSessionsAdminRevokeSessionsMutation__
 *
 * To run a mutation, you first call `useUserSessionsAdminRevokeSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSessionsAdminRevokeSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSessionsAdminRevokeSessionsMutation, { data, loading, error }] = useUserSessionsAdminRevokeSessionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSessionsAdminRevokeSessionsMutation(baseOptions?: Apollo.MutationHookOptions<UserSessionsAdminRevokeSessionsMutation, UserSessionsAdminRevokeSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSessionsAdminRevokeSessionsMutation, UserSessionsAdminRevokeSessionsMutationVariables>(UserSessionsAdminRevokeSessionsDocument, options);
      }
export type UserSessionsAdminRevokeSessionsMutationHookResult = ReturnType<typeof useUserSessionsAdminRevokeSessionsMutation>;
export type UserSessionsAdminRevokeSessionsMutationResult = Apollo.MutationResult<UserSessionsAdminRevokeSessionsMutation>;
export type UserSessionsAdminRevokeSessionsMutationOptions = Apollo.BaseMutationOptions<UserSessionsAdminRevokeSessionsMutation, UserSessionsAdminRevokeSessionsMutationVariables>;
export const UserSessionsAdminSearchCompaniesDocument = gql`
    query UserSessionsAdminSearchCompanies($input: UserSessionsAdminCompanySearchInput!) {
  userSessionsAdminSearchCompanies(input: $input) {
    uuid
    name
    activeUserCount
  }
}
    `;

/**
 * __useUserSessionsAdminSearchCompaniesQuery__
 *
 * To run a query within a React component, call `useUserSessionsAdminSearchCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSessionsAdminSearchCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSessionsAdminSearchCompaniesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSessionsAdminSearchCompaniesQuery(baseOptions: Apollo.QueryHookOptions<UserSessionsAdminSearchCompaniesQuery, UserSessionsAdminSearchCompaniesQueryVariables> & ({ variables: UserSessionsAdminSearchCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSessionsAdminSearchCompaniesQuery, UserSessionsAdminSearchCompaniesQueryVariables>(UserSessionsAdminSearchCompaniesDocument, options);
      }
export function useUserSessionsAdminSearchCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSessionsAdminSearchCompaniesQuery, UserSessionsAdminSearchCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSessionsAdminSearchCompaniesQuery, UserSessionsAdminSearchCompaniesQueryVariables>(UserSessionsAdminSearchCompaniesDocument, options);
        }
export function useUserSessionsAdminSearchCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserSessionsAdminSearchCompaniesQuery, UserSessionsAdminSearchCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSessionsAdminSearchCompaniesQuery, UserSessionsAdminSearchCompaniesQueryVariables>(UserSessionsAdminSearchCompaniesDocument, options);
        }
export type UserSessionsAdminSearchCompaniesQueryHookResult = ReturnType<typeof useUserSessionsAdminSearchCompaniesQuery>;
export type UserSessionsAdminSearchCompaniesLazyQueryHookResult = ReturnType<typeof useUserSessionsAdminSearchCompaniesLazyQuery>;
export type UserSessionsAdminSearchCompaniesSuspenseQueryHookResult = ReturnType<typeof useUserSessionsAdminSearchCompaniesSuspenseQuery>;
export type UserSessionsAdminSearchCompaniesQueryResult = Apollo.QueryResult<UserSessionsAdminSearchCompaniesQuery, UserSessionsAdminSearchCompaniesQueryVariables>;